/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "app/plugins/adene-simulador-wrapper/build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1681);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(175);


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "css", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyframes", function() { return keyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectGlobal", function() { return injectGlobal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThemeProvider", function() { return ThemeProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withTheme", function() { return wrapWithTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ServerStyleSheet", function() { return ServerStyleSheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StyleSheetManager", function() { return StyleSheetManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_plain_object__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_plain_object___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_plain_object__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis__ = __webpack_require__(1620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_stylis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);






/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate$2(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

var hyphenate_1 = hyphenate$2;

var hyphenate = hyphenate_1;

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

var hyphenateStyleName_1 = hyphenateStyleName;

//      
var objToCss = function objToCss(obj, prevKey) {
  var css = Object.keys(obj).filter(function (key) {
    var chunk = obj[key];
    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
  }).map(function (key) {
    if (__WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(obj[key])) return objToCss(obj[key], key);
    return hyphenateStyleName_1(key) + ': ' + obj[key] + ';';
  }).join(' ');
  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};

var flatten = function flatten(chunks, executionContext) {
  return chunks.reduce(function (ruleSet, chunk) {
    /* Remove falsey values */
    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
      return ruleSet;
    }
    /* Flatten ruleSet */
    if (Array.isArray(chunk)) {
      return [].concat(ruleSet, flatten(chunk, executionContext));
    }

    /* Handle other components */
    if (chunk.hasOwnProperty('styledComponentId')) {
      // $FlowFixMe not sure how to make this pass
      return [].concat(ruleSet, ['.' + chunk.styledComponentId]);
    }

    /* Either execute or defer the function */
    if (typeof chunk === 'function') {
      return executionContext ? ruleSet.concat.apply(ruleSet, flatten([chunk(executionContext)], executionContext)) : ruleSet.concat(chunk);
    }

    /* Handle objects */
    return ruleSet.concat(
    // $FlowFixMe have to add %checks somehow to isPlainObject
    __WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(chunk) ? objToCss(chunk) : chunk.toString());
  }, []);
};

//      
var stylis = new __WEBPACK_IMPORTED_MODULE_1_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: true
});

var stringifyRules = function stringifyRules(rules, selector, prefix) {
  var flatCSS = rules.join('').replace(/^\s*\/\/.*$/gm, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  return stylis(prefix || !selector ? '' : selector, cssStr);
};

//      
var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
var charsLength = chars.length;

/* Some high number, usually 9-digit base-10. Map it to base-😎 */
var generateAlphabeticName = function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = chars[x % charsLength] + name;
  }

  return chars[x % charsLength] + name;
};

//      


var interleave = (function (strings, interpolations) {
  return interpolations.reduce(function (array, interp, i) {
    return array.concat(interp, strings[i + 1]);
  }, [strings[0]]);
});

//      
var css = (function (strings) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  return flatten(interleave(strings, interpolations));
});

//      
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s+(\S+)\s+\*\//gm;

var extractCompsFromCSS = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

//      
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
                                     return  true ? __webpack_require__.nc : null;
});

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

//      
/* eslint-disable no-underscore-dangle */
/*
 * Browser Style Sheet with Rehydration
 *
 * <style data-styled-components="x y z"
 *        data-styled-components-is-local="true">
 *   /· sc-component-id: a ·/
 *   .sc-a { ... }
 *   .x { ... }
 *   /· sc-component-id: b ·/
 *   .sc-b { ... }
 *   .y { ... }
 *   .z { ... }
 * </style>
 *
 * Note: replace · with * in the above snippet.
 * */
var COMPONENTS_PER_TAG = 40;

var BrowserTag = function () {
  function BrowserTag(el, isLocal) {
    var existingSource = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    classCallCheck(this, BrowserTag);

    this.el = el;
    this.isLocal = isLocal;
    this.ready = false;

    var extractedComps = extractCompsFromCSS(existingSource);

    this.size = extractedComps.length;
    this.components = extractedComps.reduce(function (acc, obj) {
      acc[obj.componentId] = obj; // eslint-disable-line no-param-reassign
      return acc;
    }, {});
  }

  BrowserTag.prototype.isFull = function isFull() {
    return this.size >= COMPONENTS_PER_TAG;
  };

  BrowserTag.prototype.addComponent = function addComponent(componentId) {
    if (!this.ready) this.replaceElement();
    if (false) {
      throw new Error('Trying to add Component \'' + componentId + '\' twice!');
    }

    var comp = { componentId: componentId, textNode: document.createTextNode('') };
    this.el.appendChild(comp.textNode);

    this.size += 1;
    this.components[componentId] = comp;
  };

  BrowserTag.prototype.inject = function inject(componentId, css, name) {
    if (!this.ready) this.replaceElement();
    var comp = this.components[componentId];

    if (false) {
      throw new Error('Must add a new component before you can inject css into it');
    }
    if (comp.textNode.data === '') {
      comp.textNode.appendData('\n/* sc-component-id: ' + componentId + ' */\n');
    }

    comp.textNode.appendData(css);
    if (name) {
      var existingNames = this.el.getAttribute(SC_ATTR);
      this.el.setAttribute(SC_ATTR, existingNames ? existingNames + ' ' + name : name);
    }

    var nonce = getNonce();

    if (nonce) {
      this.el.setAttribute('nonce', nonce);
    }
  };

  BrowserTag.prototype.toHTML = function toHTML() {
    return this.el.outerHTML;
  };

  BrowserTag.prototype.toReactElement = function toReactElement() {
    throw new Error("BrowserTag doesn't implement toReactElement!");
  };

  BrowserTag.prototype.clone = function clone() {
    throw new Error('BrowserTag cannot be cloned!');
  };

  /* Because we care about source order, before we can inject anything we need to
   * create a text node for each component and replace the existing CSS. */


  BrowserTag.prototype.replaceElement = function replaceElement() {
    var _this = this;

    this.ready = true;
    // We have nothing to inject. Use the current el.
    if (this.size === 0) return;

    // Build up our replacement style tag
    var newEl = this.el.cloneNode();
    newEl.appendChild(document.createTextNode('\n'));

    Object.keys(this.components).forEach(function (key) {
      var comp = _this.components[key];

      // eslint-disable-next-line no-param-reassign
      comp.textNode = document.createTextNode(comp.cssFromDOM);
      newEl.appendChild(comp.textNode);
    });

    if (!this.el.parentNode) {
      throw new Error("Trying to replace an element that wasn't mounted!");
    }

    // The ol' switcheroo
    this.el.parentNode.replaceChild(newEl, this.el);
    this.el = newEl;
  };

  return BrowserTag;
}();

/* Factory function to separate DOM operations from logical ones*/


var BrowserStyleSheet = {
  create: function create() {
    var tags = [];
    var names = {};

    /* Construct existing state from DOM */
    var nodes = document.querySelectorAll('[' + SC_ATTR + ']');
    var nodesLength = nodes.length;

    for (var i = 0; i < nodesLength; i += 1) {
      var el = nodes[i];

      tags.push(new BrowserTag(el, el.getAttribute(LOCAL_ATTR) === 'true', el.innerHTML));

      var attr = el.getAttribute(SC_ATTR);
      if (attr) {
        attr.trim().split(/\s+/).forEach(function (name) {
          names[name] = true;
        });
      }
    }

    /* Factory for making more tags */
    var tagConstructor = function tagConstructor(isLocal) {
      var el = document.createElement('style');
      el.type = 'text/css';
      el.setAttribute(SC_ATTR, '');
      el.setAttribute(LOCAL_ATTR, isLocal ? 'true' : 'false');
      if (!document.head) throw new Error('Missing document <head>');
      document.head.appendChild(el);
      return new BrowserTag(el, isLocal);
    };

    return new StyleSheet(tagConstructor, tags, names);
  }
};

//      
var SC_ATTR = 'data-styled-components';
var LOCAL_ATTR = 'data-styled-components-is-local';
var CONTEXT_KEY = '__styled-components-stylesheet__';

/* eslint-disable flowtype/object-type-delimiter */

/* eslint-enable flowtype/object-type-delimiter */

var instance = null;
// eslint-disable-next-line no-use-before-define
var clones = [];

var StyleSheet = function () {
  function StyleSheet(tagConstructor) {
    var tags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var names = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, StyleSheet);
    this.hashes = {};
    this.deferredInjections = {};
    this.stylesCacheable = typeof document !== 'undefined';

    this.tagConstructor = tagConstructor;
    this.tags = tags;
    this.names = names;
    this.constructComponentTagMap();
  }

  // helper for `ComponentStyle` to know when it cache static styles.
  // staticly styled-component can not safely cache styles on the server
  // without all `ComponentStyle` instances saving a reference to the
  // the styleSheet instance they last rendered with,
  // or listening to creation / reset events. otherwise you might create
  // a component with one stylesheet and render it another api response
  // with another, losing styles on from your server-side render.


  StyleSheet.prototype.constructComponentTagMap = function constructComponentTagMap() {
    var _this = this;

    this.componentTags = {};

    this.tags.forEach(function (tag) {
      Object.keys(tag.components).forEach(function (componentId) {
        _this.componentTags[componentId] = tag;
      });
    });
  };

  /* Best level of caching—get the name from the hash straight away. */


  StyleSheet.prototype.getName = function getName(hash) {
    return this.hashes[hash.toString()];
  };

  /* Second level of caching—if the name is already in the dom, don't
   * inject anything and record the hash for getName next time. */


  StyleSheet.prototype.alreadyInjected = function alreadyInjected(hash, name) {
    if (!this.names[name]) return false;

    this.hashes[hash.toString()] = name;
    return true;
  };

  /* Third type of caching—don't inject components' componentId twice. */


  StyleSheet.prototype.hasInjectedComponent = function hasInjectedComponent(componentId) {
    return !!this.componentTags[componentId];
  };

  StyleSheet.prototype.deferredInject = function deferredInject(componentId, isLocal, css) {
    if (this === instance) {
      clones.forEach(function (clone) {
        clone.deferredInject(componentId, isLocal, css);
      });
    }

    this.getOrCreateTag(componentId, isLocal);
    this.deferredInjections[componentId] = css;
  };

  StyleSheet.prototype.inject = function inject(componentId, isLocal, css, hash, name) {
    if (this === instance) {
      clones.forEach(function (clone) {
        clone.inject(componentId, isLocal, css);
      });
    }

    var tag = this.getOrCreateTag(componentId, isLocal);

    var deferredInjection = this.deferredInjections[componentId];
    if (deferredInjection) {
      tag.inject(componentId, deferredInjection);
      delete this.deferredInjections[componentId];
    }

    tag.inject(componentId, css, name);

    if (hash && name) {
      this.hashes[hash.toString()] = name;
    }
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    return this.tags.map(function (tag, i) {
      return tag.toReactElement('sc-' + i);
    });
  };

  StyleSheet.prototype.getOrCreateTag = function getOrCreateTag(componentId, isLocal) {
    var existingTag = this.componentTags[componentId];
    if (existingTag) {
      return existingTag;
    }

    var lastTag = this.tags[this.tags.length - 1];
    var componentTag = !lastTag || lastTag.isFull() || lastTag.isLocal !== isLocal ? this.createNewTag(isLocal) : lastTag;
    this.componentTags[componentId] = componentTag;
    componentTag.addComponent(componentId);
    return componentTag;
  };

  StyleSheet.prototype.createNewTag = function createNewTag(isLocal) {
    var newTag = this.tagConstructor(isLocal);
    this.tags.push(newTag);
    return newTag;
  };

  StyleSheet.reset = function reset(isServer) {
    instance = StyleSheet.create(isServer);
  };

  /* We can make isServer totally implicit once Jest 20 drops and we
   * can change environment on a per-test basis. */


  StyleSheet.create = function create() {
    var isServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : typeof document === 'undefined';

    return (isServer ? ServerStyleSheet : BrowserStyleSheet).create();
  };

  StyleSheet.clone = function clone(oldSheet) {
    var newSheet = new StyleSheet(oldSheet.tagConstructor, oldSheet.tags.map(function (tag) {
      return tag.clone();
    }), _extends({}, oldSheet.names));

    newSheet.hashes = _extends({}, oldSheet.hashes);
    newSheet.deferredInjections = _extends({}, oldSheet.deferredInjections);
    clones.push(newSheet);

    return newSheet;
  };

  createClass(StyleSheet, null, [{
    key: 'instance',
    get: function get$$1() {
      return instance || (instance = StyleSheet.create());
    }
  }]);
  return StyleSheet;
}();

var _StyleSheetManager$ch;

//      
var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager() {
    classCallCheck(this, StyleSheetManager);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  StyleSheetManager.prototype.getChildContext = function getChildContext() {
    var _ref;

    return _ref = {}, _ref[CONTEXT_KEY] = this.props.sheet, _ref;
  };

  StyleSheetManager.prototype.render = function render() {
    /* eslint-disable react/prop-types */
    // Flow v0.43.1 will report an error accessing the `children` property,
    // but v0.47.0 will not. It is necessary to use a type cast instead of
    // a "fixme" comment to satisfy both Flow versions.
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(this.props.children);
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(ServerStyleSheet)]).isRequired, _StyleSheetManager$ch);

StyleSheetManager.propTypes = {
  sheet: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(ServerStyleSheet)]).isRequired
};

//      
/* eslint-disable no-underscore-dangle */
var ServerTag = function () {
  function ServerTag(isLocal) {
    classCallCheck(this, ServerTag);

    this.isLocal = isLocal;
    this.components = {};
    this.size = 0;
    this.names = [];
  }

  ServerTag.prototype.isFull = function isFull() {
    return false;
  };

  ServerTag.prototype.addComponent = function addComponent(componentId) {
    if (false) {
      throw new Error('Trying to add Component \'' + componentId + '\' twice!');
    }
    this.components[componentId] = { componentId: componentId, css: '' };
    this.size += 1;
  };

  ServerTag.prototype.concatenateCSS = function concatenateCSS() {
    var _this = this;

    return Object.keys(this.components).reduce(function (styles, k) {
      return styles + _this.components[k].css;
    }, '');
  };

  ServerTag.prototype.inject = function inject(componentId, css, name) {
    var comp = this.components[componentId];

    if (false) {
      throw new Error('Must add a new component before you can inject css into it');
    }
    if (comp.css === '') comp.css = '/* sc-component-id: ' + componentId + ' */\n';

    comp.css += css.replace(/\n*$/, '\n');

    if (name) this.names.push(name);
  };

  ServerTag.prototype.toHTML = function toHTML() {
    var attrs = ['type="text/css"', SC_ATTR + '="' + this.names.join(' ') + '"', LOCAL_ATTR + '="' + (this.isLocal ? 'true' : 'false') + '"'];

    var nonce = getNonce();

    if (nonce) {
      attrs.push('nonce="' + nonce + '"');
    }

    return '<style ' + attrs.join(' ') + '>' + this.concatenateCSS() + '</style>';
  };

  ServerTag.prototype.toReactElement = function toReactElement(key) {
    var _attrs;

    var attrs = (_attrs = {}, _attrs[SC_ATTR] = this.names.join(' '), _attrs[LOCAL_ATTR] = this.isLocal.toString(), _attrs);

    var nonce = getNonce();

    if (nonce) {
      attrs.nonce = nonce;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('style', _extends({
      key: key,
      type: 'text/css'
    }, attrs, {
      dangerouslySetInnerHTML: { __html: this.concatenateCSS() }
    }));
  };

  ServerTag.prototype.clone = function clone() {
    var _this2 = this;

    var copy = new ServerTag(this.isLocal);
    copy.names = [].concat(this.names);
    copy.size = this.size;
    copy.components = Object.keys(this.components).reduce(function (acc, key) {
      acc[key] = _extends({}, _this2.components[key]); // eslint-disable-line no-param-reassign
      return acc;
    }, {});

    return copy;
  };

  return ServerTag;
}();

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    this.instance = StyleSheet.clone(StyleSheet.instance);
  }

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.closed) {
      throw new Error("Can't collect styles once you've called getStyleTags!");
    }
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    if (!this.closed) {
      clones.splice(clones.indexOf(this.instance), 1);
      this.closed = true;
    }

    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    if (!this.closed) {
      clones.splice(clones.indexOf(this.instance), 1);
      this.closed = true;
    }

    return this.instance.toReactElements();
  };

  ServerStyleSheet.create = function create() {
    return new StyleSheet(function (isLocal) {
      return new ServerTag(isLocal);
    });
  };

  return ServerStyleSheet;
}();

//      

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

//      
/* eslint-disable max-len */
/**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 **/
/*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan
*/
/* eslint-enable max-len */

var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|(?:attribute|glyph)Nam|playsInlin|(?:formE|e)ncTyp|(?:writing|input|edge)Mod|(?:xlinkTy|itemSco|keyTy|slo)p|(?:amplitu|mo)d|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ntrol|ord)s|o(?:lor(?:Interpolation)?|ntent)|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|o(?:ntextMenu|ls)|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|(?:rossOrigi|olSpa)n|apHeight|lip(?:Path)?|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|autoFocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|formActio|zoomAndPa|onFocusI|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveA(?:spectRatio|lpha)|ointsAt[X-Z]|anose1)|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:gradientT|patternT|t)ransform|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:strokeMiterlimi|(?:specularConsta|repeatCou|fontVaria)n|(?:(?:specularE|e)xpon|renderingInt|asc)en|d(?:iffuseConsta|esce)n|(?:fontSizeAdju|lengthAdju|manife)s|baselineShif|vectorEffec|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|a(?:utoCorrec|bou)|markerStar|onFocusOu|in(?:tercep|lis)|restar|forma|heigh|lis)t|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|m(?:arkerMi|etho)|preloa|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:allowFullScre|hidd)en|strokeDasharray|systemLanguage|(?:strokeLineca|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|(?:pointerEve|keyPoi)nts|unicodeRange|(?:(?:allowReord|placehold|frameBord|paintOrd|post|ord)e|repeatDu|d(?:efe|u))r|mathematical|(?:vI|i)deographic|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|vAlphabetic|mediaGroup|spellCheck|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|(?:xmlnsXl|valueL)ink|a(?:rabicForm|l(?:phabetic|t)|sync)|pathLength|(?:text|m(?:in|ax))Length|innerHTML|xlinkShow|(?:xlinkHr|glyphR)ef|r(?:e(?:quired|sult|f))?|o(?:verflow|pen)|(?:tabInde|(?:sand|b)bo|viewBo)x|(?:(?:href|xml|src)La|kerni)ng|f(?:o(?:ntSize|rm)|il(?:ter|l))|autoPlay|unicode|p(?:attern|oints)|t(?:arget[XY]|o)|i(?:temRef|n2|s)|divisor|d(?:efault|ata|ir)?|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|(?:width|size)s|(?:stri|la)ng|prefix|itemID|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|s)|t(?:arget|ype)|typeof|width|value|x(?:mlns)?|label|m(?:edia|a(?:sk|x)|in)|size|href|k(?:ey)?|end|low|x[12]|i[dn]|y[12]|g[12]|by|f[xy]|[yz])$/;

/* From DOMProperty */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));

var validAttr = (function (name) {
  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
});

//      


function isTag(target) /* : %checks */{
  return typeof target === 'string';
}

//      


function isStyledComponent(target) /* : %checks */{
  return typeof target === 'function' && typeof target.styledComponentId === 'string';
}

//      

/* eslint-disable no-undef */
function getComponentName(target) {
  return target.displayName || target.name || 'Component';
}

//      


var determineTheme = (function (props, fallbackTheme, defaultProps) {
  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types */
  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
  /* eslint-enable */

  return theme;
});

//      
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

//      
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */

var createBroadcast = function createBroadcast(initialState) {
  var listeners = {};
  var id = 0;
  var state = initialState;

  function publish(nextState) {
    state = nextState;

    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in listeners) {
      var listener = listeners[key];
      if (listener === undefined) {
        // eslint-disable-next-line no-continue
        continue;
      }

      listener(state);
    }
  }

  function subscribe(listener) {
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    listener(state);
    return currentId;
  }

  function unsubscribe(unsubID) {
    listeners[unsubID] = undefined;
  }

  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
};

//      
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb();
    }
  };
});

var _ThemeProvider$childC;
var _ThemeProvider$contex;

//      
/* globals React$Element */
// NOTE: DO NOT CHANGE, changing this is a semver major change!
var CHANNEL = '__styled-components__';
var CHANNEL_NEXT = CHANNEL + 'next__';

var CONTEXT_CHANNEL_SHAPE = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
  getTheme: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  subscribe: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  unsubscribe: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
});

var warnChannelDeprecated = void 0;
if (false) {
  warnChannelDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.error('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
  });
}

var isFunction = function isFunction(test) {
  return typeof test === 'function';
};

/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.unsubscribeToOuterId = -1;

    _this.getTheme = _this.getTheme.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
    // with the outer theme
    var outerContext = this.context[CHANNEL_NEXT];
    if (outerContext !== undefined) {
      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
        _this2.outerTheme = theme;
      });
    }
    this.broadcast = createBroadcast(this.getTheme());
  };

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    var _this3 = this,
        _babelHelpers$extends;

    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
      getTheme: this.getTheme,
      subscribe: this.broadcast.subscribe,
      unsubscribe: this.broadcast.unsubscribe
    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
      if (false) {
        warnChannelDeprecated();
      }

      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
      return function () {
        return _this3.broadcast.unsubscribe(unsubscribeId);
      };
    }, _babelHelpers$extends));
  };

  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.theme !== nextProps.theme) {
      this.broadcast.publish(this.getTheme(nextProps.theme));
    }
  };

  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeToOuterId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    }
  };

  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation


  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
    var theme = passedTheme || this.props.theme;
    if (isFunction(theme)) {
      var mergedTheme = theme(this.outerTheme);
      if (false) {
        throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
      }
      return mergedTheme;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(theme)) {
      throw new Error('[ThemeProvider] Please make your theme prop a plain object');
    }
    return _extends({}, this.outerTheme, theme);
  };

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(this.props.children);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

ThemeProvider.childContextTypes = (_ThemeProvider$childC = {}, _ThemeProvider$childC[CHANNEL] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, _ThemeProvider$childC[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$childC);
ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);

//      

// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var STATIC_EXECUTION_CONTEXT = {};

var _StyledComponent = (function (ComponentStyle, constructWithOptions) {
  var identifiers = {};

  /* We depend on components having unique IDs */
  var generateId = function generateId(_displayName, parentComponentId) {
    var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

    var componentId = void 0;

    /**
     * only fall back to hashing the component injection order if
     * a proper displayName isn't provided by the babel plugin
     */
    if (!_displayName) {
      var nr = (identifiers[displayName] || 0) + 1;
      identifiers[displayName] = nr;

      componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);
    } else {
      componentId = displayName + '-' + ComponentStyle.generateName(displayName);
    }

    return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
  };

  var BaseStyledComponent = function (_Component) {
    inherits(BaseStyledComponent, _Component);

    function BaseStyledComponent() {
      var _temp, _this, _ret;

      classCallCheck(this, BaseStyledComponent);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
        theme: null,
        generatedClassName: ''
      }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
      var attrs = this.constructor.attrs;

      var context = _extends({}, props, { theme: theme });
      if (attrs === undefined) {
        return context;
      }

      this.attrs = Object.keys(attrs).reduce(function (acc, key) {
        var attr = attrs[key];
        // eslint-disable-next-line no-param-reassign
        acc[key] = typeof attr === 'function' ? attr(context) : attr;
        return acc;
      }, {});

      return _extends({}, context, this.attrs);
    };

    BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
      var _constructor = this.constructor,
          attrs = _constructor.attrs,
          componentStyle = _constructor.componentStyle,
          warnTooManyClasses = _constructor.warnTooManyClasses;

      var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.instance;

      // staticaly styled-components don't need to build an execution context object,
      // and shouldn't be increasing the number of class names
      if (componentStyle.isStatic && attrs === undefined) {
        return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
      } else {
        var executionContext = this.buildExecutionContext(theme, props);
        var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);

        if (false) {
          warnTooManyClasses(className);
        }

        return className;
      }
    };

    BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var componentStyle = this.constructor.componentStyle;

      var styledContext = this.context[CHANNEL_NEXT];

      // If this is a staticaly-styled component, we don't need to the theme
      // to generate or build styles.
      if (componentStyle.isStatic) {
        var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
        this.setState({ generatedClassName: generatedClassName });
        // If there is a theme in the context, subscribe to the event emitter. This
        // is necessary due to pure components blocking context updates, this circumvents
        // that by updating when an event is emitted
      } else if (styledContext !== undefined) {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          // This will be called once immediately
          var theme = determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);
          var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);

          _this2.setState({ theme: theme, generatedClassName: generatedClassName });
        });
      } else {
        // eslint-disable-next-line react/prop-types
        var theme = this.props.theme || {};
        var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
        this.setState({ theme: theme, generatedClassName: _generatedClassName });
      }
    };

    BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      // If this is a staticaly-styled component, we don't need to listen to
      // props changes to update styles
      var componentStyle = this.constructor.componentStyle;

      if (componentStyle.isStatic) {
        return;
      }

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, _this3.constructor.defaultProps);
        var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);

        return { theme: theme, generatedClassName: generatedClassName };
      });
    };

    BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      this.unsubscribeFromContext();
    };

    BaseStyledComponent.prototype.render = function render() {
      var _this4 = this;

      // eslint-disable-next-line react/prop-types
      var innerRef = this.props.innerRef;
      var generatedClassName = this.state.generatedClassName;
      var _constructor2 = this.constructor,
          styledComponentId = _constructor2.styledComponentId,
          target = _constructor2.target;


      var isTargetTag = isTag(target);

      var className = [
      // eslint-disable-next-line react/prop-types
      this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');

      var baseProps = _extends({}, this.attrs, {
        className: className
      });

      if (isStyledComponent(target)) {
        baseProps.innerRef = innerRef;
      } else {
        baseProps.ref = innerRef;
      }

      var propsForElement = Object.keys(this.props).reduce(function (acc, propName) {
        // Don't pass through non HTML tags through to HTML elements
        // always omit innerRef
        if (propName !== 'innerRef' && propName !== 'className' && (!isTargetTag || validAttr(propName))) {
          // eslint-disable-next-line no-param-reassign
          acc[propName] = _this4.props[propName];
        }

        return acc;
      }, baseProps);

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(target, propsForElement);
    };

    return BaseStyledComponent;
  }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

  var createStyledComponent = function createStyledComponent(target, options, rules) {
    var _StyledComponent$cont;

    var _options$displayName = options.displayName,
        displayName = _options$displayName === undefined ? isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')' : _options$displayName,
        _options$componentId = options.componentId,
        componentId = _options$componentId === undefined ? generateId(options.displayName, options.parentComponentId) : _options$componentId,
        _options$ParentCompon = options.ParentComponent,
        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
        extendingRules = options.rules,
        attrs = options.attrs;


    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : componentId;

    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);

    var StyledComponent = function (_ParentComponent) {
      inherits(StyledComponent, _ParentComponent);

      function StyledComponent() {
        classCallCheck(this, StyledComponent);
        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
      }

      StyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId,
            optionsToCopy = objectWithoutProperties(options, ['componentId']);


        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

        var newOptions = _extends({}, optionsToCopy, {
          componentId: newComponentId,
          ParentComponent: StyledComponent
        });

        return createStyledComponent(tag, newOptions, rules);
      };

      createClass(StyledComponent, null, [{
        key: 'extend',
        get: function get$$1() {
          var rulesFromOptions = options.rules,
              parentComponentId = options.componentId,
              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);


          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);

          var newOptions = _extends({}, optionsToCopy, {
            rules: newRules,
            parentComponentId: parentComponentId,
            ParentComponent: StyledComponent
          });

          return constructWithOptions(createStyledComponent, target, newOptions);
        }
      }]);
      return StyledComponent;
    }(ParentComponent);

    StyledComponent.contextTypes = (_StyledComponent$cont = {}, _StyledComponent$cont[CHANNEL] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, _StyledComponent$cont[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _StyledComponent$cont[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(ServerStyleSheet)]), _StyledComponent$cont);
    StyledComponent.displayName = displayName;
    StyledComponent.styledComponentId = styledComponentId;
    StyledComponent.attrs = attrs;
    StyledComponent.componentStyle = componentStyle;
    StyledComponent.target = target;


    if (false) {
      StyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
    }

    return StyledComponent;
  };

  return createStyledComponent;
});

// murmurhash2 via https://gist.github.com/raycmorgan/588423

function doHash(str, seed) {
  var m = 0x5bd1e995;
  var r = 24;
  var h = seed ^ str.length;
  var length = str.length;
  var currentIndex = 0;

  while (length >= 4) {
    var k = UInt32(str, currentIndex);

    k = Umul32(k, m);
    k ^= k >>> r;
    k = Umul32(k, m);

    h = Umul32(h, m);
    h ^= k;

    currentIndex += 4;
    length -= 4;
  }

  switch (length) {
    case 3:
      h ^= UInt16(str, currentIndex);
      h ^= str.charCodeAt(currentIndex + 2) << 16;
      h = Umul32(h, m);
      break;

    case 2:
      h ^= UInt16(str, currentIndex);
      h = Umul32(h, m);
      break;

    case 1:
      h ^= str.charCodeAt(currentIndex);
      h = Umul32(h, m);
      break;
  }

  h ^= h >>> 13;
  h = Umul32(h, m);
  h ^= h >>> 15;

  return h >>> 0;
}

function UInt32(str, pos) {
  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8) + (str.charCodeAt(pos++) << 16) + (str.charCodeAt(pos) << 24);
}

function UInt16(str, pos) {
  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8);
}

function Umul32(n, m) {
  n = n | 0;
  m = m | 0;
  var nlo = n & 0xffff;
  var nhi = n >>> 16;
  var res = nlo * m + ((nhi * m & 0xffff) << 16) | 0;
  return res;
}

//      
var isStaticRules = function isStaticRules(rules, attrs) {
  for (var i = 0; i < rules.length; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule)) {
      return false;
    } else if (typeof rule === 'function' && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled copmonent
      return false;
    }
  }

  if (attrs !== undefined) {
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in attrs) {
      var value = attrs[key];
      if (typeof value === 'function') {
        return false;
      }
    }
  }

  return true;
};

var isHRMEnabled = typeof module !== 'undefined' && module.hot && "production" !== 'production';

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */
var _ComponentStyle = (function (nameGenerator, flatten, stringifyRules) {
  var ComponentStyle = function () {
    function ComponentStyle(rules, attrs, componentId) {
      classCallCheck(this, ComponentStyle);

      this.rules = rules;
      this.isStatic = !isHRMEnabled && isStaticRules(rules, attrs);
      this.componentId = componentId;
      if (!StyleSheet.instance.hasInjectedComponent(this.componentId)) {
        var placeholder =  false ? '.' + componentId + ' {}' : '';
        StyleSheet.instance.deferredInject(componentId, true, placeholder);
      }
    }

    /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
      var isStatic = this.isStatic,
          lastClassName = this.lastClassName;

      if (isStatic && lastClassName !== undefined) {
        return lastClassName;
      }

      var flatCSS = flatten(this.rules, executionContext);
      var hash = doHash(this.componentId + flatCSS.join(''));

      var existingName = styleSheet.getName(hash);
      if (existingName !== undefined) {
        if (styleSheet.stylesCacheable) {
          this.lastClassName = existingName;
        }
        return existingName;
      }

      var name = nameGenerator(hash);
      if (styleSheet.stylesCacheable) {
        this.lastClassName = existingName;
      }
      if (styleSheet.alreadyInjected(hash, name)) {
        return name;
      }

      var css = '\n' + stringifyRules(flatCSS, '.' + name);
      // NOTE: this can only be set when we inject the class-name.
      // For some reason, presumably due to how css is stringifyRules behaves in
      // differently between client and server, styles break.
      styleSheet.inject(this.componentId, true, css, hash, name);
      return name;
    };

    ComponentStyle.generateName = function generateName(str) {
      return nameGenerator(doHash(str));
    };

    return ComponentStyle;
  }();

  return ComponentStyle;
});

//      
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

//      

var _styled = (function (styledComponent, constructWithOptions) {
  var styled = function styled(tag) {
    return constructWithOptions(styledComponent, tag);
  };

  // Shorthands for all valid HTML Elements
  domElements.forEach(function (domElement) {
    styled[domElement] = styled(domElement);
  });

  return styled;
});

//      
var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

var _keyframes = (function (nameGenerator, stringifyRules, css) {
  return function (strings) {
    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    var rules = css.apply(undefined, [strings].concat(interpolations));
    var hash = doHash(replaceWhitespace(JSON.stringify(rules)));

    var existingName = StyleSheet.instance.getName(hash);
    if (existingName) return existingName;

    var name = nameGenerator(hash);
    if (StyleSheet.instance.alreadyInjected(hash, name)) return name;

    var generatedCSS = stringifyRules(rules, name, '@keyframes');
    StyleSheet.instance.inject('sc-keyframes-' + name, true, generatedCSS, hash, name);
    return name;
  };
});

//      
var _injectGlobal = (function (stringifyRules, css) {
  var injectGlobal = function injectGlobal(strings) {
    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    var rules = css.apply(undefined, [strings].concat(interpolations));
    var hash = doHash(JSON.stringify(rules));

    var componentId = 'sc-global-' + hash;
    if (StyleSheet.instance.hasInjectedComponent(componentId)) return;

    StyleSheet.instance.inject(componentId, false, stringifyRules(rules));
  };

  return injectGlobal;
});

//      


var _constructWithOptions = (function (css) {
  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (false) {
      // $FlowInvalidInputTest
      throw new Error('Cannot create styled-component for component: ' + tag);
    }

    /* This is callable directly as a template function */
    var templateFunction = function templateFunction(strings) {
      for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        interpolations[_key - 1] = arguments[_key];
      }

      return componentConstructor(tag, options, css.apply(undefined, [strings].concat(interpolations)));
    };

    /* If config methods are called, wrap up a new template function and merge options */
    templateFunction.withConfig = function (config) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
    };
    templateFunction.attrs = function (attrs) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
        attrs: _extends({}, options.attrs || {}, attrs)
      }));
    };

    return templateFunction;
  };

  return constructWithOptions;
});

//      
/* globals ReactClass */

var wrapWithTheme = function wrapWithTheme(Component$$1) {
  var _WithTheme$contextTyp;

  var componentName = Component$$1.displayName || Component$$1.name || 'Component';

  var shouldSetInnerRef = isStyledComponent(Component$$1) ||
  // NOTE: We can't pass a ref to a stateless functional component
  typeof Component$$1 === 'function' && !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);

  var WithTheme = function (_React$Component) {
    inherits(WithTheme, _React$Component);

    function WithTheme() {
      var _temp, _this, _ret;

      classCallCheck(this, WithTheme);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {}, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping


    WithTheme.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var defaultProps = this.constructor.defaultProps;

      var styledContext = this.context[CHANNEL_NEXT];
      var themeProp = determineTheme(this.props, undefined, defaultProps);
      if (styledContext === undefined && themeProp === undefined && "production" !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
      } else if (styledContext === undefined && themeProp !== undefined) {
        this.setState({ theme: themeProp });
      } else {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          var theme = determineTheme(_this2.props, nextTheme, defaultProps);
          _this2.setState({ theme: theme });
        });
      }
    };

    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var defaultProps = this.constructor.defaultProps;

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, defaultProps);

        return { theme: theme };
      });
    };

    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    WithTheme.prototype.render = function render() {
      // eslint-disable-next-line react/prop-types
      var innerRef = this.props.innerRef;
      var theme = this.state.theme;


      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component$$1, _extends({
        theme: theme
      }, this.props, {
        innerRef: shouldSetInnerRef ? innerRef : undefined,
        ref: shouldSetInnerRef ? undefined : innerRef
      }));
    };

    return WithTheme;
  }(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

  WithTheme.displayName = 'WithTheme(' + componentName + ')';
  WithTheme.styledComponentId = 'withTheme';
  WithTheme.contextTypes = (_WithTheme$contextTyp = {}, _WithTheme$contextTyp[CHANNEL] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, _WithTheme$contextTyp[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _WithTheme$contextTyp);


  return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(WithTheme, Component$$1);
};

//      

/* Import singletons */
/* Import singleton constructors */
/* Import components */
/* Import Higher Order Components */
/* Instantiate singletons */
var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
var constructWithOptions = _constructWithOptions(css);
var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);

/* Instantiate exported singletons */
var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
var injectGlobal = _injectGlobal(stringifyRules, css);
var styled = _styled(StyledComponent, constructWithOptions);

/* harmony default export */ __webpack_exports__["default"] = (styled);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1678)(module)))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperties = __webpack_require__(946);

var _defineProperties2 = _interopRequireDefault(_defineProperties);

var _freeze = __webpack_require__(947);

var _freeze2 = _interopRequireDefault(_freeze);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (strings, raw) {
  return (0, _freeze2.default)((0, _defineProperties2.default)(strings, {
    raw: {
      value: (0, _freeze2.default)(raw)
    }
  }));
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(19);
var core = __webpack_require__(35);
var hide = __webpack_require__(64);
var redefine = __webpack_require__(57);
var ctx = __webpack_require__(79);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(948);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(945);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(305);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(305);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(459);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1432)();
}


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  animation-duration: ', ';\n  animation-timing-function: ', ';\n  animation-delay: ', ';\n  animation-iteration-count: ', ';\n  animation-direction: ', ';\n  animation-fill-mode: ', ';\n  animation-play-state:  ', ';\n  display: ', ';\n'], ['\n  animation-duration: ', ';\n  animation-timing-function: ', ';\n  animation-delay: ', ';\n  animation-iteration-count: ', ';\n  animation-direction: ', ';\n  animation-fill-mode: ', ';\n  animation-play-state:  ', ';\n  display: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BaseAnimation = _styledComponents2.default.div(_templateObject, function (props) {
  return props.duration;
}, function (props) {
  return props.timingFunction;
}, function (props) {
  return props.delay;
}, function (props) {
  return props.iterationCount;
}, function (props) {
  return props.direction;
}, function (props) {
  return props.fillMode;
}, function (props) {
  return props.playState;
}, function (props) {
  return props.display;
});

BaseAnimation.defaultProps = {
  duration: '1s',
  timingFunction: 'ease',
  delay: '0s',
  iterationCount: '1',
  direction: 'normal',
  fillMode: 'both',
  playState: 'running',
  display: 'block'
};

exports.default = BaseAnimation;

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return API_SIMULATION_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return API_SIMULATION_URL_V2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_BASE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return API_BASE_URL_V2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MEDIA_BASE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SENTRY_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return GOOGLE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ADESION_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PAGE_URL; });
/* unused harmony export SIMULATOR_TYPE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return tipsWidget; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return isAdvanced; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return isSimple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isEnterprise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return backgroundColors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ELECTRICITY_OFFER_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return GAS_OFFER_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return GAS_AND_ELECTRICITY_OFFER_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return BOOLEAN_CHOICES; });
// API url based on environment
var apiUrl=void 0;var apiUrlV2=void 0;var mediaUrl=void 0;var adesionUrl=void 0;var simulationUrl=void 0;var simulationUrlV2=void 0;var pageUrl=void 0;switch("production"){case'development':apiUrl='https://qa.poupaenergia.pt/d/api/v1';apiUrlV2='https://qa.poupaenergia.pt/d/api/v2';simulationUrl='https://qa.poupaenergia.pt/s/api/v1';simulationUrlV2='https://qa.poupaenergia.pt/s/api/v2';adesionUrl='https://qa.poupaenergia.pt/d/api/v1';mediaUrl='https://qa.poupaenergia.pt';pageUrl='https://qa.poupaenergia.pt';// apiUrl = `https://api.poupaenergia.pt/api/v1`
// apiUrlV2 = `https://api.poupaenergia.pt/api/v2`
// simulationUrl = `https://api.poupaenergia.pt/s/api/v1`
// adesionUrl = `https://api.poupaenergia.pt/api/v1`
// mediaUrl = `https://api.poupaenergia.pt`
// pageUrl = `https://poupaenergia.pt`
break;case'production':apiUrl='https://api.poupaenergia.pt/api/v1';apiUrlV2='https://api.poupaenergia.pt/api/v2';simulationUrl='https://api.poupaenergia.pt/s/api/v1';simulationUrlV2='https://api.poupaenergia.pt/s/api/v2';adesionUrl='https://api.poupaenergia.pt/api/v1';mediaUrl='https://api.poupaenergia.pt';pageUrl='https://poupaenergia.pt';break;case'qa':apiUrl='https://qa.poupaenergia.pt/d/api/v1';apiUrlV2='https://qa.poupaenergia.pt/d/api/v2';simulationUrl='https://qa.poupaenergia.pt/s/api/v1';simulationUrlV2='https://qa.poupaenergia.pt/s/api/v2';adesionUrl='https://qa.poupaenergia.pt/d/api/v1';mediaUrl='https://qa.poupaenergia.pt';pageUrl='https://qa.poupaenergia.pt';break;default:apiUrl='https://qa.poupaenergia.pt/d/api/v1';apiUrlV2='https://qa.poupaenergia.pt/d/api/v2';simulationUrl='https://qa.poupaenergia.pt/s/api/v1';simulationUrlV2='https://qa.poupaenergia.pt/s/api/v2';adesionUrl='https://qa.poupaenergia.pt/d/api/v1';mediaUrl='https://qa.poupaenergia.pt';pageUrl='https://qa.poupaenergia.pt';}var API_SIMULATION_URL=simulationUrl;var API_SIMULATION_URL_V2=simulationUrlV2;var API_BASE_URL=apiUrl;var API_BASE_URL_V2=apiUrlV2;var MEDIA_BASE_URL=mediaUrl;var SENTRY_URL='https://3ede0aa3ebbe493f847d75de623c477d@sentry2.ubiwhere.com/39';var GOOGLE_KEY='AIzaSyDgx1R-ss1J4w5hJNqd49Xxaxe-QP-lJIQ';var ADESION_URL=adesionUrl;var PAGE_URL=pageUrl;var SIMULATOR_TYPE=function(){var advanced=document.getElementById('adene-simulador-avancado');var simple=document.getElementById('adene-simulador-simples');var enterprise=document.getElementById('adene-simulador-empresarial');if(advanced)return'advanced';if(simple)return'simple';if(enterprise)return'enterprise';}();var tipsWidget=document.getElementById('sa-random-tips-widget');var isAdvanced=function(){var advanced=document.getElementById('adene-simulador-avancado');return!!advanced;}();var isSimple=function(){var simples=document.getElementById('adene-simulador-simples');return!!simples;}();var isEnterprise=function(){var enterprise=document.getElementById('adene-simulador-empresarial');return!!enterprise;}();var backgroundColors=function(){return{normalLeft:isEnterprise?'linear-gradient(270deg,#006756,#7ed068),linear-gradient(270deg,#006736,#93c13e)':'linear-gradient(270deg, #006736 0%, #93C13E 100%)',normalRight:isEnterprise?'linear-gradient(270deg,#7ed068,#006756),linear-gradient(270deg,#93c13e,#006736)':'linear-gradient(270deg, #93C13E 0%, #006736 100%)',overLeftLeft:isEnterprise?'linear-gradient(270deg,#006756 0%,#7ed068 90%),linear-gradient(270deg,#006736 0%,#93c13e 90%)':'linear-gradient(270deg, #006736 0%, #93C13E 90%)',overRightLeft:isEnterprise?'linear-gradient(270deg,#7ed068 0%,#006756 90%),linear-gradient(270deg,#93c13e 0%,#006736 90%)':'linear-gradient(270deg, #93C13E 0%, #006736 90%)',overLeftRight:isEnterprise?'linear-gradient(270deg,#006756 10%,#7ed068 100%),linear-gradient(270deg,#006736 10%,#93c13e 100%)':'linear-gradient(270deg, #006736 10%, #93C13E 100%)',overRightRight:isEnterprise?'linear-gradient(270deg,#7ed068 10%,#006756 100%),linear-gradient(270deg,#93c13e 10%,#006736 100%)':'linear-gradient(270deg, #93C13E 10%, #006736 100%)'};}();var ELECTRICITY_OFFER_TYPE='e';var GAS_OFFER_TYPE='g';var GAS_AND_ELECTRICITY_OFFER_TYPE='eg';var BOOLEAN_CHOICES=[{text:'SIM',value:true},{text:'NÃO',value:false}];

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return generateMediaUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return findOfferType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return mapObjectToarray; });
/* unused harmony export splitInto */
/* unused harmony export convertToUnderscore */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return csObjectToUnderscore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return csObjectFromUnderscore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return selectMapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return captureSentryException; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getDatesYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return sortByEnergyClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return currency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return pricesCurrency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return unitCurrency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return pickOrNot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return validNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return replaceDots; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return sendGevent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return searchToObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return roundToTwo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getResolvedWebsite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SIMPLE_WEBSITE_REGEX; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_mapValues__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_toArray__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_toArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_toArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_pick__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/**
 * Generates a url with the correct absolute address
 * @param {*} src
 */var generateMediaUrl=function generateMediaUrl(src){return''+__WEBPACK_IMPORTED_MODULE_1__config__["e" /* MEDIA_BASE_URL */]+src;};/**
 * Finds by id
 * @param {*} identifier
 * @param {*} offerTypes
 */var findOfferType=function findOfferType(identifier,offerTypes){return __WEBPACK_IMPORTED_MODULE_2_lodash_find___default()(offerTypes,function(_ref){var id=_ref.id;return id===identifier;});};/**
 * Converts an object to array
 * @param {*} object
 */var mapObjectToarray=function mapObjectToarray(object){return __WEBPACK_IMPORTED_MODULE_4_lodash_toArray___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_mapValues___default()(object,function(value,key){return{id:key,text:key,label:key,value:value};}));};/**
 * Splits array into separated array
 * @param {*} str
 * @param {*} len
 */var splitInto=function splitInto(str,len){var regex=new RegExp('.{'+len+'}|.{1,'+Number(len-1)+'}','g');return str.match(regex);};/**
 * Converts CamelCased string to underscored
 * @param {*} str
 */var convertToUnderscore=function convertToUnderscore(str){return str.replace(/([a-z])([A-Z])/g,'$1_$2').toLowerCase();};/**
 * Converts CamelCase Object to Underscore Object
 * @param {*} obj
 */var csObjectToUnderscore=function csObjectToUnderscore(obj){var newObj={};__WEBPACK_IMPORTED_MODULE_3_lodash_mapValues___default()(obj,function(value,key){var toUnder=convertToUnderscore(key);// if (isObject(value)){
//   value = csObjectToUnderscore(value)
// }
// if (isArray(value)) {
//   value = value.map((item) => {
//     if (isObject(item)) {
//       item = csObjectToUnderscore(item)
//     }
//     return item
//   })
// }
newObj[toUnder]=value;});return newObj;};/**
 *  Converts underscored string to CamelCased
 * @param {*} str
 */var convertToCamelCase=function convertToCamelCase(str){return str.replace(/_([a-z])/g,function(g){return g[1].toUpperCase();});};/**
 * Converts Underscore Object to CamelCase Object
 * @param {*} obj
 */var csObjectFromUnderscore=function csObjectFromUnderscore(obj){var newObj={};__WEBPACK_IMPORTED_MODULE_3_lodash_mapValues___default()(obj,function(value,key){var toUnder=convertToCamelCase(key);// if (isObject(value)){
//   value = convertToCamelCase(value)
// }
// if (isArray(value)) {
//   value = value.map((item) => {
//     if (isObject(item)) {
//       item = convertToCamelCase(item)
//     }
//     return item
//   })
// }
newObj[toUnder]=value;});return newObj;};/**
 * Simple Select mapper
 * @param {*} param0
 */var selectMapper=function selectMapper(_ref2){var id=_ref2.id,name=_ref2.name,item=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref2,['id','name']);return Object.assign({label:name,value:id},item);};/**
 * Captures an Exception to Sentry
 * @param {*} error
 */var captureSentryException=function captureSentryException(error){if(true){var Raven=__webpack_require__(601);Raven.captureException(error);// Raven.showReportDialog();}
}};/**
 * Gets the years string from two dates
 * @param {*} firstDate
 * @param {*} secondDate
 */var getDatesYear=function getDatesYear(firstDate,secondDate){var year1=__WEBPACK_IMPORTED_MODULE_7_moment___default()(firstDate);var year2=__WEBPACK_IMPORTED_MODULE_7_moment___default()(secondDate);var getYear=function getYear(m){return m.format('YYYY');};if(year1.isValid()&&year2.isValid()){return'('+getYear(year1)+'-'+getYear(year2)+')';}return year1.isValid()?'(> '+getYear(year1)+')':year2.isValid()?'(< '+getYear(year2)+')':'';};/**
 * Sorts energy classes alphabetically and by plus char number
 * @param {*} classes
 */var sortByEnergyClass=function sortByEnergyClass(classes){return classes.sort(function(a,b){var nameA=a.label.toUpperCase();var nameB=b.label.toUpperCase();if(nameA<nameB){return-1;}if(nameA>nameB){return 1;}return 0;}).sort(function(a,b){var plusA=a.label.substring(1,a.label.length);var plusB=b.label.substring(1,b.label.length);if(plusA>plusB){return-1;}if(plusA<plusB){return 1;}return 0;});};var currency=function currency(nr){return Number(nr).toFixed(2).replace('.',',');};var unitCurrency=function unitCurrency(nr){return Number(nr).toFixed(0).replace('.',',');};var pricesCurrency=function pricesCurrency(nr){return Number(nr).toFixed(4).replace('.',',');};var pickOrNot=function pickOrNot(values,toPick){var picked=__WEBPACK_IMPORTED_MODULE_5_lodash_pick___default()(values,toPick);return __WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty___default()(picked)?false:picked;};var validNumber=function validNumber(v){return Number(String(v).replace(',','.'));};var replaceDots=function replaceDots(v){return v&&String(v).replace('.',',');};var roundToTwo=function roundToTwo(num){return num&&Number(Math.round(num+'e2')+'e-2');};var sendGevent=function sendGevent(category,action,label){window.ga&&window.ga('send','event',category,action,label);};var getResolvedWebsite=function getResolvedWebsite(website){if(!website)return website;if(/(?!http:\/\/|https:\/\/)^\w/g.test(website))return'http://'+website;return website;};var searchToObject=function searchToObject(search){var pairs=search.substring(1).split('&');var obj={};var pair=void 0;var i=void 0;for(i in pairs){if(pairs[i]==='')continue;pair=pairs[i].split('=');obj[decodeURIComponent(pair[0])]=decodeURIComponent(pair[1]);}return obj;};var getCookie=function getCookie(name){var nameEQ=name+'=';var cookies=document.cookie.split(';');for(var i=0;i<cookies.length;i++){var cookie=cookies[i].trim();// Remove leading/trailing spaces
if(cookie.indexOf(nameEQ)===0){return cookie.substring(nameEQ.length,cookie.length);// Return the value of the cookie
}}return null;// Return null if the cookie is not found
};var SIMPLE_WEBSITE_REGEX=/(?:http(?:s)?:\/\/)?(?:(?:\.)?[\w-]+)*(?:\.[a-zA-Z-]+)+(?:\/[\w-]*)*(?:#[\w-]*)*(?:[.](?:html|php))*/g;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        var flags = null,
            parsedParts = false,
            isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            isNowValid =
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));
            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year',
    };

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1,
    };

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        if (!mom.isValid()) {
            return NaN;
        }

        var d = mom._d,
            isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }

    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;

        if (!mom.isValid() || isNaN(value)) {
            return;
        }

        d = mom._d;
        isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return void (isUTC
                    ? d.setUTCMilliseconds(value)
                    : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }

        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        void (isUTC
            ? d.setUTCFullYear(year, month, date)
            : d.setFullYear(year, month, date));
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // PARSING

    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        var month = value,
            date = mom.date();

        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        void (mom._isUTC
            ? mom._d.setUTCMonth(month, date)
            : mom._d.setMonth(month, date));
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            shortP,
            longP;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // PARSING

    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
              ? weekdays[m.day()]
              : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
              ? this._weekdaysShort[m.day()]
              : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
              ? this._weekdaysMin[m.day()]
              : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                      ? DATE
                      : a[HOUR] < 0 ||
                          a[HOUR] > 24 ||
                          (a[HOUR] === 24 &&
                              (a[MINUTE] !== 0 ||
                                  a[SECOND] !== 0 ||
                                  a[MILLISECOND] !== 0))
                        ? HOUR
                        : a[MINUTE] < 0 || a[MINUTE] > 59
                          ? MINUTE
                          : a[SECOND] < 0 || a[SECOND] > 59
                            ? SECOND
                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                              ? MILLISECOND
                              : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
              ? 'lastWeek'
              : diff < 0
                ? 'lastDay'
                : diff < 1
                  ? 'sameDay'
                  : diff < 2
                    ? 'nextDay'
                    : diff < 7
                      ? 'nextWeek'
                      : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            erasName,
            erasAbbr,
            erasNarrow,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);

            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday() + this.localeData()._week.dow,
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // PARSING

    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // PARSING

    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // PARSING

    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y'),
        valueOf$1 = asMilliseconds;

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.30.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(218)(module)))

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(70);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(941);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(459);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = {
  DISPLAY_FORMAT: 'L',
  ISO_FORMAT: 'YYYY-MM-DD',
  ISO_MONTH_FORMAT: 'YYYY-MM',

  START_DATE: 'startDate',
  END_DATE: 'endDate',

  HORIZONTAL_ORIENTATION: 'horizontal',
  VERTICAL_ORIENTATION: 'vertical',
  VERTICAL_SCROLLABLE: 'verticalScrollable',

  ICON_BEFORE_POSITION: 'before',
  ICON_AFTER_POSITION: 'after',

  ANCHOR_LEFT: 'left',
  ANCHOR_RIGHT: 'right',

  OPEN_DOWN: 'down',
  OPEN_UP: 'up',

  DAY_SIZE: 39,
  BLOCKED_MODIFIER: 'blocked',
  WEEKDAYS: [0, 1, 2, 3, 4, 5, 6],
};


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_io__ = __webpack_require__(178);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "take", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takem", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "put", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "all", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "race", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "call", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "apply", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cps", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fork", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "spawn", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "join", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cancel", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "select", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["o"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "actionChannel", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cancelled", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["p"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "flush", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["q"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getContext", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["r"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setContext", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["s"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takeEvery", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["t"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takeLatest", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["u"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["v"]; });


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connect = exports.keaSaga = exports.keaReducer = exports.createAction = exports.kea = undefined;

var _kea = __webpack_require__(1258);

Object.defineProperty(exports, 'kea', {
  enumerable: true,
  get: function get() {
    return _kea.kea;
  }
});

var _actions = __webpack_require__(253);

Object.defineProperty(exports, 'createAction', {
  enumerable: true,
  get: function get() {
    return _actions.createAction;
  }
});

var _store = __webpack_require__(254);

Object.defineProperty(exports, 'keaReducer', {
  enumerable: true,
  get: function get() {
    return _store.keaReducer;
  }
});
Object.defineProperty(exports, 'keaSaga', {
  enumerable: true,
  get: function get() {
    return _store.keaSaga;
  }
});
var connect = exports.connect = function connect(mapping) {
  return (0, _kea.kea)({ connect: mapping });
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(246)('wks');
var uid = __webpack_require__(120);
var Symbol = __webpack_require__(19).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(823);

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ic_brand_color_component_svg__ = __webpack_require__(1624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ic_brand_color_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ic_brand_color_component_svg__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  from {\n    transform: scale(1)\n  }\n  to {\n    transform: scale(1.04545)\n  }\n'],['\n  from {\n    transform: scale(1)\n  }\n  to {\n    transform: scale(1.04545)\n  }\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ','\n\n','\n\n  animation: ',' .5s linear infinite;\n'],['\n  ','\n\n','\n\n  animation: ',' .5s linear infinite;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()([''],['']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: ',';\n  ','\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  width: 100%;\n\n  ','\n'],['\n  height: ',';\n  ','\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  width: 100%;\n\n  ','\n']);// import Logo from './ic-brand-color.svg'
var Loading=function Loading(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Wrapper,props,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SpinnerSvg,props,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ic_brand_color_component_svg___default.a,null)),props.size!=='small'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Text,null));};var Scale=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styled_components__["keyframes"])(_templateObject);// const Spinner = styled.img`
//   ${({ size }) => size === 'small' && `
//   width: 25px;
//   height: 25px;
// `}
// ${({ size }) => size !== 'small' && `
//   width: 65px;
//   height: 65px;
//   margin-bottom: 20px;
// `}
//   animation: ${Scale} .5s linear infinite;
// `
var SpinnerSvg=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject2,function(_ref){var size=_ref.size;return size==='small'&&'\n  width: 25px;\n  height: 25px;\n';},function(_ref2){var size=_ref2.size;return size!=='small'&&'\n  width: 65px;\n  height: 65px;\n  margin-bottom: 20px;\n';},Scale);var Text=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject3);var Wrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject4,function(_ref3){var size=_ref3.size;return size!=='small'?'calc(100% - 60px)':'100%';},function(_ref4){var size=_ref4.size;return size!=='small'&&'min-height: 500px;';},function(_ref5){var noHeight=_ref5.noHeight;return noHeight&&'\n    height: initial!important;\n    min-height: initial!important;\n  ';});/* harmony default export */ __webpack_exports__["a"] = (Loading);

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(82);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(953);


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(22);

var DOMProperty = __webpack_require__(170);
var ReactDOMComponentFlags = __webpack_require__(630);

var invariant = __webpack_require__(12);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 34 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 35 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 37 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(18)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(17);
var IE8_DOM_DEFINE = __webpack_require__(488);
var toPrimitive = __webpack_require__(99);
var dP = Object.defineProperty;

exports.f = __webpack_require__(38) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonGradientV2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_config__ = __webpack_require__(10);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  height: 40px;\n  padding: 8px;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  align-self: stretch;\n\n  border: none;\n  background: ',';\n\n  cursor: pointer;\n\n  color: #fff;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n\n  > svg,\n  path {\n    fill: #fff;\n  }\n\n  &:hover {\n    background: linear-gradient(\n        0deg,\n        rgba(0, 0, 0, 0.2) 0%,\n        rgba(0, 0, 0, 0.2) 100%\n      ),\n      linear-gradient(270deg, #006736 -58.87%, #93c13e 100%);\n\n    ','\n  }\n\n  &:disabled {\n    background: #ececec;\n    cursor: default;\n    pointer-events: none;\n    color: #bababa;\n  }\n'],['\n  display: flex;\n  height: 40px;\n  padding: 8px;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  align-self: stretch;\n\n  border: none;\n  background: ',';\n\n  cursor: pointer;\n\n  color: #fff;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n\n  > svg,\n  path {\n    fill: #fff;\n  }\n\n  &:hover {\n    background: linear-gradient(\n        0deg,\n        rgba(0, 0, 0, 0.2) 0%,\n        rgba(0, 0, 0, 0.2) 100%\n      ),\n      linear-gradient(270deg, #006736 -58.87%, #93c13e 100%);\n\n    ','\n  }\n\n  &:disabled {\n    background: #ececec;\n    cursor: default;\n    pointer-events: none;\n    color: #bababa;\n  }\n']);var ButtonGradientV2=function(_Component){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ButtonGradientV2,_Component);function ButtonGradientV2(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,ButtonGradientV2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=ButtonGradientV2.__proto__||Object.getPrototypeOf(ButtonGradientV2)).call.apply(_ref,[this].concat(args))),_this),_this.handleClick=function(e){var _this$props=_this.props,onClick=_this$props.onClick,setModalTriggerHeight=_this$props.setModalTriggerHeight;onClick&&onClick(e);if(setModalTriggerHeight){setModalTriggerHeight(_this.buttonRef.getBoundingClientRect().top);}},_temp),__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ButtonGradientV2,[{key:'render',value:function render(){var _this2=this;var _props=this.props,icon=_props.icon,trailingIcon=_props.trailingIcon,children=_props.children,className=_props.className,danger=_props.danger,restProps=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props,['icon','trailingIcon','children','className','danger']);return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Wrapper,Object.assign({innerRef:function innerRef(ref){return _this2.buttonRef=ref;},danger:danger,bgColor:danger?'linear-gradient(270deg, #5A0000 -58.87%, #C00000 100%)':__WEBPACK_IMPORTED_MODULE_8_config__["c" /* backgroundColors */].normalLeft,className:className},restProps,{onClick:this.handleClick}),icon,children,trailingIcon);}}]);return ButtonGradientV2;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);var Wrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].button.attrs({ref:function ref(props){return props.buttonRef;}})(_templateObject,function(_ref2){var bgColor=_ref2.bgColor;return bgColor;},function(_ref3){var danger=_ref3.danger;return danger&&'\n      background: linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), linear-gradient(270deg, #5A0000 -58.87%, #C00000 100%);\n    ';});

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =  true ? __webpack_require__(730) : require('./build');

//# sourceMappingURL=index.js.map

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_mapValues__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_kea__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_kea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_kea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_querystring__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_querystring__);
/** Contants */var DEFAULT_VALUES={hide_additional:false,carCharging:{frequency:''}};var DEFAULT_SETTINGS={iframed:false,goToResults:false,electricCar:true};var OFFER_TYPES_ENDPOINT=__WEBPACK_IMPORTED_MODULE_6_config__["b" /* API_BASE_URL */]+'/public/offer-type/';var TRANSLATIONS_ENDPOINT=__WEBPACK_IMPORTED_MODULE_6_config__["b" /* API_BASE_URL */]+'/public/translations/';var ME_ENDPOINT=__WEBPACK_IMPORTED_MODULE_6_config__["b" /* API_BASE_URL */]+'/private/user-profile/me/';var SIMULATION_PROFILE_ENDPOINT=__WEBPACK_IMPORTED_MODULE_6_config__["b" /* API_BASE_URL */]+'/private/simulation-user-profile/';var TRANSLATIONS_LOCAL_KEY='local';var AUTH_TOKEN_KEY='tokenauth';var LOADING_COUNT=3;var SIMILATIONS_ENPOINT=__WEBPACK_IMPORTED_MODULE_6_config__["b" /* API_BASE_URL */]+'/public/simulation/{code}';var formatElectricityValues=function formatElectricityValues(_ref){var s=_ref.s,f=_ref.f,c=_ref.c,p=_ref.p,startDate=_ref.startDate,endDate=_ref.endDate;return{simples:s,svazio:f,cheias:c,ponta:p,startDate:startDate,endDate:endDate};};/* eslint-disable camelcase */var Logic=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_kea__["kea"])({path:function path(){return['scenes','app'];},actions:function actions(){return{getAppTranslations:function getAppTranslations(){return{};},getCurrentUser:function getCurrentUser(){return{};},setAppTranslations:function setAppTranslations(translations){return{translations:translations};},setValue:function setValue(selected,item){return{values:__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},item,selected.value)};},setValues:function setValues(selected){return selected;},setIsUserLoggedIn:function setIsUserLoggedIn(is){return{is:is};},setFinished:function setFinished(value){return{value:value};},setOfferTypes:function setOfferTypes(offerTypes){return{offerTypes:offerTypes};},fetchOfferTypes:function fetchOfferTypes(){return{};},fetchError:function fetchError(error){return{error:error};},setStarted:function setStarted(){return{};},setSettings:function setSettings(settings){return{settings:settings};},fetchProfile:function fetchProfile(id){return{id:id};},decreaseLoading:function decreaseLoading(){return{};},changeSimulationData:function changeSimulationData(){return{};}};},reducers:function reducers(_ref2){var _ref3;var actions=_ref2.actions;return{values:[DEFAULT_VALUES,__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,(_ref3={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3,actions.setValue,function(state,payload){return Object.assign({},state,payload.values);}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3,actions.setValues,function(state,payload){return Object.assign({},state,payload);}),_ref3)],offerTypes:[null,__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.setOfferTypes,function(_,payload){return payload.offerTypes;})],finished:[{},__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.setFinished,function(_,payload){return Object.assign({},_,payload.value);})],translations:[{},__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.setAppTranslations,function(state,payload){return payload.translations;})],userLoggedIn:[false,__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.setIsUserLoggedIn,function(_,payload){return payload.is;})],started:[false,__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.setStarted,function(){return true;})],settings:[DEFAULT_SETTINGS,__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.setSettings,function(state,payload){return Object.assign({},state,payload.settings);})],loading:[LOADING_COUNT,__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.decreaseLoading,function(state){return state-1;})],dataSimulationChanged:[false,__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.changeSimulationData,function(){return true;})]};},takeLatest:function takeLatest(_ref12){var _ref13;var actions=_ref12.actions,workers=_ref12.workers;return _ref13={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref13,actions.fetchOfferTypes,workers.fetchOfferTypes),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref13,actions.getAppTranslations,workers.getAppTranslations),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref13,actions.getCurrentUser,workers.getCurrentUser),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref13,actions.fetchProfile,workers.fetchProfile),_ref13;},start:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function start(){var _actions,fetchOfferTypes,setAppTranslations,getAppTranslations,getCurrentUser,setStarted,setSettings,decreaseLoading,setFinished,setValues,appStarted,localTranslations,parsedTranslations,params,queryString,urlParams,s,response,values,additional,notCameled;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function start$(_context){while(1){switch(_context.prev=_context.next){case 0:_actions=this.actions,fetchOfferTypes=_actions.fetchOfferTypes,setAppTranslations=_actions.setAppTranslations,getAppTranslations=_actions.getAppTranslations,getCurrentUser=_actions.getCurrentUser,setStarted=_actions.setStarted,setSettings=_actions.setSettings,decreaseLoading=_actions.decreaseLoading,setFinished=_actions.setFinished,setValues=_actions.setValues;_context.next=3;return this.get('started');case 3:appStarted=_context.sent;if(!appStarted){_context.next=6;break;}return _context.abrupt('return',false);case 6:_context.next=8;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(fetchOfferTypes());case 8:_context.next=10;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(getCurrentUser());case 10:// Check if user has translations in localStorage
// We need to do this because of performance issues
localTranslations=window.localStorage.getItem(TRANSLATIONS_LOCAL_KEY);if(!localTranslations){_context.next=15;break;}parsedTranslations=JSON.parse(localTranslations);_context.next=15;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setAppTranslations(parsedTranslations));case 15:// Check if there are any params in the first request
params=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_utils__["b" /* searchToObject */])(window.location.search);// Set iframe settings
if(!params.iframed){_context.next=20;break;}document.body.classList.add('iframed');_context.next=20;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setSettings({iframed:true}));case 20:if(params.profile){_context.next=49;break;}queryString=window.location.search;urlParams=new URLSearchParams(queryString);_context.prev=23;s=urlParams.get('code');if(!s){_context.next=43;break;}_context.next=28;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setSettings({isFromUrl:true,goToResults:true}));case 28:_context.next=30;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get,SIMILATIONS_ENPOINT.replace('{code}',s));case 30:response=_context.sent;values=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_utils__["c" /* csObjectFromUnderscore */])(response.data.simulation_history.api_input_data);if(values.gasConsumptionsRegistration){values.gasConsumptionsRegistration=values.gasConsumptionsRegistration.map(function(item){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_utils__["c" /* csObjectFromUnderscore */])(item);});}if(values.electricityConsumptionsRegistration){values.electricityConsumptionsRegistration=values.electricityConsumptionsRegistration.map(function(item){return formatElectricityValues(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_utils__["c" /* csObjectFromUnderscore */])(item));});}additional=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lodash__["pick"])(values.additionalData,['adults','children','district','elderly','equipments']);notCameled=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_utils__["a" /* csObjectToUnderscore */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lodash__["pick"])(values,['invoicingType','hasElectronicBilling','hasJointBilling','cicloHorario','cicloTarifa','electricityEntity','gasEntity','gasStage','potenciaContratada','municipality']));values=Object.assign({},values,additional,notCameled);values=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lodash__["omit"])(values,['invoicingType','hasElectronicBilling','hasJointBilling','cicloHorario','cicloTarifa','electricityEntity','gasEntity','gasStage']);values=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lodash__["omit"])(values,['simulationCode','equipment']);_context.next=41;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setValues(values));case 41:_context.next=43;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setFinished({profileFinished:true,habitationFinished:true,faturationFinished:true,consumeFinished:true}));case 43:_context.next=47;break;case 45:_context.prev=45;_context.t0=_context['catch'](23);case 47:_context.next=49;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(decreaseLoading());case 49:_context.next=51;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(getAppTranslations());case 51:_context.next=53;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setStarted(true));case 53:case'end':return _context.stop();}}},start,this,[[23,45]]);}),workers:{setValuesUrl:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function setValuesUrl(){var values,query,url;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setValuesUrl$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return this.get('values');case 2:values=_context2.sent;query=__WEBPACK_IMPORTED_MODULE_11_querystring___default.a.stringify(values);url='?s='+btoa(query);window.history.pushState('','',url+window.location.hash);case 6:case'end':return _context2.stop();}}},setValuesUrl,this);}),/**
     * Fetches offer type for the overall use in app
     */fetchOfferTypes:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchOfferTypes(){var _actions2,setOfferTypes,fetchError,decreaseLoading,response,results;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchOfferTypes$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_actions2=this.actions,setOfferTypes=_actions2.setOfferTypes,fetchError=_actions2.fetchError,decreaseLoading=_actions2.decreaseLoading;_context3.prev=1;_context3.next=4;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get,OFFER_TYPES_ENDPOINT,{limit:1000});case 4:response=_context3.sent;results=response.data.results;if(!results){_context3.next=11;break;}_context3.next=9;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setOfferTypes(results));case 9:_context3.next=11;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(decreaseLoading());case 11:_context3.next=17;break;case 13:_context3.prev=13;_context3.t0=_context3['catch'](1);_context3.next=17;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(fetchError(_context3.t0));case 17:case'end':return _context3.stop();}}},fetchOfferTypes,this,[[1,13]]);}),/**
     * Gets app translations
     */getAppTranslations:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function getAppTranslations(){var _actions3,setAppTranslations,setFatalError,request,results,translations,localTranslations;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getAppTranslations$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_actions3=this.actions,setAppTranslations=_actions3.setAppTranslations,setFatalError=_actions3.setFatalError;_context4.prev=1;_context4.next=4;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get,TRANSLATIONS_ENDPOINT);case 4:request=_context4.sent;results=request.data.results;// Convert translations to a simpler object
// This can be optimized #todo
translations={};__WEBPACK_IMPORTED_MODULE_5_lodash_mapValues___default()(results,function(item){return __WEBPACK_IMPORTED_MODULE_5_lodash_mapValues___default()(item.properties,function(prop){translations[prop.key]=prop.value;});});// Get local translations
// We don't want the user to see stuff changing when hes using the app
// Only update the storage on background and the next time he visits
// He will have the translations updated
localTranslations=window.localStorage.getItem(TRANSLATIONS_LOCAL_KEY);if(localTranslations){_context4.next=12;break;}_context4.next=12;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setAppTranslations(translations));case 12:// Set the new translations to localstorage
window.localStorage.setItem(TRANSLATIONS_LOCAL_KEY,JSON.stringify(translations));_context4.next=19;break;case 15:_context4.prev=15;_context4.t0=_context4['catch'](1);_context4.next=19;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setFatalError());case 19:case'end':return _context4.stop();}}},getAppTranslations,this,[[1,15]]);}),/**
     * Gets current user logged in
     */getCurrentUser:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function getCurrentUser(){var _actions4,setIsUserLoggedIn,decreaseLoading,_actions5,fetchProfile,setSettings,token,params,me;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getCurrentUser$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_actions4=this.actions,setIsUserLoggedIn=_actions4.setIsUserLoggedIn,decreaseLoading=_actions4.decreaseLoading;_actions5=this.actions,fetchProfile=_actions5.fetchProfile,setSettings=_actions5.setSettings;_context5.prev=2;token=window.localStorage.getItem(AUTH_TOKEN_KEY);params=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_utils__["b" /* searchToObject */])(window.location.search);if(token){_context5.next=14;break;}_context5.next=8;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setIsUserLoggedIn(false));case 8:_context5.next=10;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(decreaseLoading());case 10:if(!params.profile){_context5.next=13;break;}_context5.next=13;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(decreaseLoading());case 13:return _context5.abrupt('return');case 14:_context5.next=16;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get,ME_ENDPOINT,{headers:{Authorization:'JWT '+token}});case 16:me=_context5.sent;_context5.next=19;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setIsUserLoggedIn(me.data));case 19:__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common['Authorization']='JWT '+token;if(!params.profile){_context5.next=25;break;}_context5.next=23;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(fetchProfile(params.profile));case 23:_context5.next=25;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setSettings({isFromProfile:params.profile}));case 25:_context5.next=27;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(decreaseLoading());case 27:_context5.next=38;break;case 29:_context5.prev=29;_context5.t0=_context5['catch'](2);console.log(_context5.t0);_context5.next=34;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setIsUserLoggedIn(false));case 34:localStorage.removeItem(AUTH_TOKEN_KEY);delete __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common['Authorization'];_context5.next=38;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(decreaseLoading());case 38:case'end':return _context5.stop();}}},getCurrentUser,this,[[2,29]]);}),/**
     * Fetchs profile and sets it as the current values
     * @param {*} action
     */fetchProfile:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchProfile(action){var _actions6,setValues,fetchError,decreaseLoading,setFinished,setSettings,id,request,values,additional,notCameled;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchProfile$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_actions6=this.actions,setValues=_actions6.setValues,fetchError=_actions6.fetchError,decreaseLoading=_actions6.decreaseLoading,setFinished=_actions6.setFinished,setSettings=_actions6.setSettings;id=action.payload.id;_context6.prev=2;_context6.next=5;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get,''+SIMULATION_PROFILE_ENDPOINT+id+'/');case 5:request=_context6.sent;if(!request.data.simulation_history){_context6.next=9;break;}_context6.next=9;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setSettings({goToResults:true}));case 9:// Convert Api input to camelCase and apply it to the redux state
values=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_utils__["c" /* csObjectFromUnderscore */])(request.data.api_input_data);if(values.gasConsumptionsRegistration){values.gasConsumptionsRegistration=values.gasConsumptionsRegistration.map(function(item){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_utils__["c" /* csObjectFromUnderscore */])(item);});}if(values.electricityConsumptionsRegistration){values.electricityConsumptionsRegistration=values.electricityConsumptionsRegistration.map(function(item){return formatElectricityValues(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_utils__["c" /* csObjectFromUnderscore */])(item));});}additional=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lodash__["pick"])(values.additionalData,['adults','children','district','elderly','equipments']);notCameled=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_utils__["a" /* csObjectToUnderscore */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lodash__["pick"])(values,['invoicingType','hasElectronicBilling','hasJointBilling','cicloHorario','cicloTarifa','electricityEntity','gasEntity','gasStage','potenciaContratada','municipality']));values=Object.assign({},values,additional,notCameled);values=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lodash__["omit"])(values,['invoicingType','hasElectronicBilling','hasJointBilling','cicloHorario','cicloTarifa','electricityEntity','gasEntity','gasStage']);// Remove simulationCode so we can generate a new one
values=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lodash__["omit"])(values,['simulationCode','equipment']);_context6.next=19;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setValues(values));case 19:_context6.next=21;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setFinished({profileFinished:true,habitationFinished:true,faturationFinished:true,consumeFinished:true}));case 21:_context6.next=23;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(decreaseLoading());case 23:_context6.next=29;break;case 25:_context6.prev=25;_context6.t0=_context6['catch'](2);_context6.next=29;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(fetchError(_context6.t0));case 29:case'end':return _context6.stop();}}},fetchProfile,this,[[2,25]]);})},selectors:function selectors(_ref14){var _selectors=_ref14.selectors;return{/**
     * Selects the current offer type object based on id
     */offerType:[function(){return[_selectors.values,_selectors.offerTypes];},function(_ref15,offerTypes){var offerType=_ref15.offerType;return __WEBPACK_IMPORTED_MODULE_4_lodash_find___default()(offerTypes,function(_ref16){var id=_ref16.id;return id===offerType;});},__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any],iframed:[function(){return[_selectors.settings];},function(_ref17){var iframed=_ref17.iframed;return iframed;},__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any],electricCar:[function(){return[_selectors.settings];},function(_ref18){var electricCar=_ref18.electricCar;return electricCar;},__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any],goToResults:[function(){return[_selectors.settings];},function(_ref19){var goToResults=_ref19.goToResults;return goToResults;},__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any]};}});/* harmony default export */ __webpack_exports__["a"] = (Logic);

/***/ }),
/* 43 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonOutlineV2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_config__ = __webpack_require__(10);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 40px;\n  background: ',';\n  padding: 1px;\n  width: 100%;\n\n  ','\n'],['\n  height: 40px;\n  background: ',';\n  padding: 1px;\n  width: 100%;\n\n  ','\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  height: 100%;\n  width: 100%;\n  padding: 8px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  align-self: stretch;\n  outline: 0;\n  border: 0;\n  background: #fff;\n\n  color: var(--Gray, #3e3e3e);\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n\n  cursor: pointer;\n\n  > svg,\n  path {\n    fill: #3e3e3e;\n  }\n\n  &:hover {\n    background: #ececec;\n    color: #006736;\n\n    > svg,\n    path {\n      fill: #006736;\n    }\n  }\n\n  ','\n'],['\n  display: flex;\n  height: 100%;\n  width: 100%;\n  padding: 8px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  align-self: stretch;\n  outline: 0;\n  border: 0;\n  background: #fff;\n\n  color: var(--Gray, #3e3e3e);\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n\n  cursor: pointer;\n\n  > svg,\n  path {\n    fill: #3e3e3e;\n  }\n\n  &:hover {\n    background: #ececec;\n    color: #006736;\n\n    > svg,\n    path {\n      fill: #006736;\n    }\n  }\n\n  ','\n']);var ButtonOutlineV2=function(_Component){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ButtonOutlineV2,_Component);function ButtonOutlineV2(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,ButtonOutlineV2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=ButtonOutlineV2.__proto__||Object.getPrototypeOf(ButtonOutlineV2)).call.apply(_ref,[this].concat(args))),_this),_this.handleClick=function(e){var _this$props=_this.props,onClick=_this$props.onClick,setModalTriggerHeight=_this$props.setModalTriggerHeight;onClick&&onClick(e);if(setModalTriggerHeight){setModalTriggerHeight(_this.buttonRef.getBoundingClientRect().top);}},_temp),__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ButtonOutlineV2,[{key:'render',value:function render(){var _this2=this;var _props=this.props,icon=_props.icon,children=_props.children,className=_props.className,style=_props.style,disabled=_props.disabled,restProps=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props,['icon','children','className','style','disabled']);return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(BgWrapper,{innerRef:function innerRef(ref){return _this2.buttonRef=ref;},disabled:disabled,bgColor:__WEBPACK_IMPORTED_MODULE_8_config__["c" /* backgroundColors */].normalLeft,className:className,style:style},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Wrapper,Object.assign({disabled:disabled},restProps,{onClick:this.handleClick}),icon,children));}}]);return ButtonOutlineV2;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);var BgWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div.attrs({ref:function ref(props){return props.buttonRef;}})(_templateObject,function(_ref2){var bgColor=_ref2.bgColor;return bgColor;},function(_ref3){var disabled=_ref3.disabled;return disabled&&'\n    background: #BABABA;\n  ';});var Wrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].button(_templateObject2,function(_ref4){var disabled=_ref4.disabled;return disabled&&'\n    cursor: default;\n    pointer-events: none;\n    background: #ECECEC;\n    color: #BABABA;\n  ';});

/***/ }),
/* 45 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(90);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var calendarLabel = 'Calendar';
var closeDatePicker = 'Close';
var focusStartDate = 'Interact with the calendar and add the check-in date for your trip.';
var clearDate = 'Clear Date';
var clearDates = 'Clear Dates';
var jumpToPrevMonth = 'Move backward to switch to the previous month';
var jumpToNextMonth = 'Move forward to switch to the next month';
var keyboardShortcuts = 'Keyboard Shortcuts';
var showKeyboardShortcutsPanel = 'Open the keyboard shortcuts panel';
var hideKeyboardShortcutsPanel = 'Close the shortcuts panel';
var openThisPanel = 'Open this panel';
var enterKey = 'Enter key';
var leftArrowRightArrow = 'Right and left arrow keys';
var upArrowDownArrow = 'up and down arrow keys';
var pageUpPageDown = 'page up and page down keys';
var homeEnd = 'Home and end keys';
var escape = 'Escape key';
var questionMark = 'Question mark';
var selectFocusedDate = 'Select the date in focus';
var moveFocusByOneDay = 'Move backward (left) and forward (right) by one day';
var moveFocusByOneWeek = 'Move backward (up) and forward (down) by one week';
var moveFocusByOneMonth = 'Switch months';
var moveFocustoStartAndEndOfWeek = 'Go to the first or last day of a week';
var returnFocusToInput = 'Return to the date input field';
var keyboardNavigationInstructions = 'Press the down arrow key to interact with the calendar and\n  select a date. Press the question mark key to get the keyboard shortcuts for changing dates.';

// eslint-disable-next-line camelcase
var chooseAvailableStartDate = function chooseAvailableStartDate(_ref) {
  var date = _ref.date;
  return 'Choose ' + String(date) + ' as your check-in date. It\'s available.';
};

// eslint-disable-next-line camelcase
var chooseAvailableEndDate = function chooseAvailableEndDate(_ref2) {
  var date = _ref2.date;
  return 'Choose ' + String(date) + ' as your check-out date. It\'s available.';
};
var chooseAvailableDate = function chooseAvailableDate(_ref3) {
  var date = _ref3.date;
  return date;
};
var dateIsUnavailable = function dateIsUnavailable(_ref4) {
  var date = _ref4.date;
  return 'Not available. ' + String(date);
};

exports['default'] = {
  calendarLabel: calendarLabel,
  closeDatePicker: closeDatePicker,
  focusStartDate: focusStartDate,
  clearDate: clearDate,
  clearDates: clearDates,
  jumpToPrevMonth: jumpToPrevMonth,
  jumpToNextMonth: jumpToNextMonth,
  keyboardShortcuts: keyboardShortcuts,
  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
  openThisPanel: openThisPanel,
  enterKey: enterKey,
  leftArrowRightArrow: leftArrowRightArrow,
  upArrowDownArrow: upArrowDownArrow,
  pageUpPageDown: pageUpPageDown,
  homeEnd: homeEnd,
  escape: escape,
  questionMark: questionMark,
  selectFocusedDate: selectFocusedDate,
  moveFocusByOneDay: moveFocusByOneDay,
  moveFocusByOneWeek: moveFocusByOneWeek,
  moveFocusByOneMonth: moveFocusByOneMonth,
  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
  returnFocusToInput: returnFocusToInput,
  keyboardNavigationInstructions: keyboardNavigationInstructions,

  chooseAvailableStartDate: chooseAvailableStartDate,
  chooseAvailableEndDate: chooseAvailableEndDate,
  dateIsUnavailable: dateIsUnavailable
};
var DateRangePickerPhrases = exports.DateRangePickerPhrases = {
  calendarLabel: calendarLabel,
  closeDatePicker: closeDatePicker,
  clearDates: clearDates,
  focusStartDate: focusStartDate,
  jumpToPrevMonth: jumpToPrevMonth,
  jumpToNextMonth: jumpToNextMonth,
  keyboardShortcuts: keyboardShortcuts,
  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
  openThisPanel: openThisPanel,
  enterKey: enterKey,
  leftArrowRightArrow: leftArrowRightArrow,
  upArrowDownArrow: upArrowDownArrow,
  pageUpPageDown: pageUpPageDown,
  homeEnd: homeEnd,
  escape: escape,
  questionMark: questionMark,
  selectFocusedDate: selectFocusedDate,
  moveFocusByOneDay: moveFocusByOneDay,
  moveFocusByOneWeek: moveFocusByOneWeek,
  moveFocusByOneMonth: moveFocusByOneMonth,
  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
  returnFocusToInput: returnFocusToInput,
  keyboardNavigationInstructions: keyboardNavigationInstructions,
  chooseAvailableStartDate: chooseAvailableStartDate,
  chooseAvailableEndDate: chooseAvailableEndDate,
  dateIsUnavailable: dateIsUnavailable
};

var DateRangePickerInputPhrases = exports.DateRangePickerInputPhrases = {
  focusStartDate: focusStartDate,
  clearDates: clearDates,
  keyboardNavigationInstructions: keyboardNavigationInstructions
};

var SingleDatePickerPhrases = exports.SingleDatePickerPhrases = {
  calendarLabel: calendarLabel,
  closeDatePicker: closeDatePicker,
  clearDate: clearDate,
  jumpToPrevMonth: jumpToPrevMonth,
  jumpToNextMonth: jumpToNextMonth,
  keyboardShortcuts: keyboardShortcuts,
  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
  openThisPanel: openThisPanel,
  enterKey: enterKey,
  leftArrowRightArrow: leftArrowRightArrow,
  upArrowDownArrow: upArrowDownArrow,
  pageUpPageDown: pageUpPageDown,
  homeEnd: homeEnd,
  escape: escape,
  questionMark: questionMark,
  selectFocusedDate: selectFocusedDate,
  moveFocusByOneDay: moveFocusByOneDay,
  moveFocusByOneWeek: moveFocusByOneWeek,
  moveFocusByOneMonth: moveFocusByOneMonth,
  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
  returnFocusToInput: returnFocusToInput,
  keyboardNavigationInstructions: keyboardNavigationInstructions,
  chooseAvailableDate: chooseAvailableDate,
  dateIsUnavailable: dateIsUnavailable
};

var SingleDatePickerInputPhrases = exports.SingleDatePickerInputPhrases = {
  clearDate: clearDate,
  keyboardNavigationInstructions: keyboardNavigationInstructions
};

var DayPickerPhrases = exports.DayPickerPhrases = {
  calendarLabel: calendarLabel,
  jumpToPrevMonth: jumpToPrevMonth,
  jumpToNextMonth: jumpToNextMonth,
  keyboardShortcuts: keyboardShortcuts,
  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
  openThisPanel: openThisPanel,
  enterKey: enterKey,
  leftArrowRightArrow: leftArrowRightArrow,
  upArrowDownArrow: upArrowDownArrow,
  pageUpPageDown: pageUpPageDown,
  homeEnd: homeEnd,
  escape: escape,
  questionMark: questionMark,
  selectFocusedDate: selectFocusedDate,
  moveFocusByOneDay: moveFocusByOneDay,
  moveFocusByOneWeek: moveFocusByOneWeek,
  moveFocusByOneMonth: moveFocusByOneMonth,
  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
  returnFocusToInput: returnFocusToInput,
  chooseAvailableStartDate: chooseAvailableStartDate,
  chooseAvailableEndDate: chooseAvailableEndDate,
  chooseAvailableDate: chooseAvailableDate,
  dateIsUnavailable: dateIsUnavailable
};

var DayPickerKeyboardShortcutsPhrases = exports.DayPickerKeyboardShortcutsPhrases = {
  keyboardShortcuts: keyboardShortcuts,
  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
  openThisPanel: openThisPanel,
  enterKey: enterKey,
  leftArrowRightArrow: leftArrowRightArrow,
  upArrowDownArrow: upArrowDownArrow,
  pageUpPageDown: pageUpPageDown,
  homeEnd: homeEnd,
  escape: escape,
  questionMark: questionMark,
  selectFocusedDate: selectFocusedDate,
  moveFocusByOneDay: moveFocusByOneDay,
  moveFocusByOneWeek: moveFocusByOneWeek,
  moveFocusByOneMonth: moveFocusByOneMonth,
  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
  returnFocusToInput: returnFocusToInput
};

var DayPickerNavigationPhrases = exports.DayPickerNavigationPhrases = {
  jumpToPrevMonth: jumpToPrevMonth,
  jumpToNextMonth: jumpToNextMonth
};

var CalendarDayPhrases = exports.CalendarDayPhrases = {
  chooseAvailableDate: chooseAvailableDate,
  dateIsUnavailable: dateIsUnavailable
};

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Validations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Messages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_lang__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_lang___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_lang__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_mapValues__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isFunction__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNaN__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNaN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isNaN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* eslint-disable camelcase */var functions=Object.assign({},__WEBPACK_IMPORTED_MODULE_0_lodash_lang__,{greaterThanZero:function greaterThanZero(v){return v>0;},habitants:function habitants(adults,children,elderly){return!adults&&!children&&!elderly;},/**
   * Only passes to the next validation if this passes
   */hasSolarSystem:function hasSolarSystem(_ref){var _hasSolarSystem=_ref.hasSolarSystem;return _hasSolarSystem;},/**
   * Only passes to the next validation if this passes
   */hasCentralAirConditioning:function hasCentralAirConditioning(_ref2){var _hasCentralAirConditioning=_ref2.hasCentralAirConditioning;return _hasCentralAirConditioning;},isElectricity:function isElectricity(_ref3){var offerType=_ref3.offerType;return offerType===2;},isGas:function isGas(_ref4){var offerType=_ref4.offerType;return offerType===3;},hasJointBilling:function hasJointBilling(_ref5){var has_joint_billing=_ref5.has_joint_billing;return has_joint_billing;},doesNotHasConsumes:function doesNotHasConsumes(_ref6){var has_consumes=_ref6.has_consumes;return has_consumes===false;},// Consume validations
noDuplicateDates:function noDuplicateDates(values){var valid=true;var errors={};for(var index=0;index<values.length;index++){var element=Object.assign({},values[index]);element.startDate=element.startDate&&__WEBPACK_IMPORTED_MODULE_4_moment___default()(element.startDate);element.endDate=element.endDate&&__WEBPACK_IMPORTED_MODULE_4_moment___default()(element.endDate);// End date has to be greater than the start date
if(!element.startDate||!element.endDate||!element.startDate.isBefore(element.endDate)){valid=false;errors[index]='startDateVendDate';break;}else{// The end and start date have to be bigger than the other values added
if(values.length>1){for(var indexAll=0;indexAll<values.length;indexAll++){if(indexAll!==index){var second=values[indexAll];if(element.endDate.isBetween(second.startDate,second.endDate)){valid=false;errors[index]='datesMustBeBiggerThanTheOthers';break;}if(element.startDate.isBetween(second.startDate,second.endDate)){valid=false;errors[index]='datesMustBeBiggerThanTheOthers';break;}}}}}}return{flag:!valid,errors:errors};},// Consume validations
noDuplicateTimes:function noDuplicateTimes(values){var valid=true;var errors={};var index=0;for(var item in values){if(['factor','name','id'].indexOf(item)===-1){var itemName=item.split('_');if(itemName.length>1){if(itemName[1]==='start'){var nStartHour=itemName[0]+'_start_hours';var nEndHour=itemName[0]+'_end_hours';var startHour=values[nStartHour]&&values[nStartHour]!==''?__WEBPACK_IMPORTED_MODULE_4_moment___default()(values[nStartHour],'HH:mm:ss'):'';var endHour=values[nEndHour]&&values[nEndHour]!==''?__WEBPACK_IMPORTED_MODULE_4_moment___default()(values[nEndHour],'HH:mm:ss'):'';if(startHour!==''||endHour!==''){valid=false;errors[index]='startHourVendHour';break;}index++;}}}}return{flag:!valid,errors:errors};},valuesGreaterThanZero:function valuesGreaterThanZero(values){var valid=true;var errors={};var mapper=function mapper(value,key){if(key!=='startDate'&&key!=='endDate'&&key!=='startHour'&&key!=='endHour'){var nr=Number(String(value).replace(',','.'));if(__WEBPACK_IMPORTED_MODULE_3_lodash_isNaN___default()(nr)){valid=false;if(!errors[index]){errors[index]={};}errors[index][key]='isUndefined';}if(value&&(__WEBPACK_IMPORTED_MODULE_3_lodash_isNaN___default()(nr)||nr<0||nr>=100000)){valid=false;if(!errors[index]){errors[index]={};}errors[index][key]='greaterThanZero';}}};for(var index=0;index<values.length;index++){var element=values[index];__WEBPACK_IMPORTED_MODULE_1_lodash_mapValues___default()(element,mapper);}return{flag:!valid,errors:errors};}});functions.ignoreIf=functions;functions.not=functions;/* harmony default export */ __webpack_exports__["c"] = (functions);var Validations=__WEBPACK_IMPORTED_MODULE_1_lodash_mapValues___default()(functions,function(func,name){if(!__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(func)){return __WEBPACK_IMPORTED_MODULE_1_lodash_mapValues___default()(func,function(f,secondName){return name+'.'+secondName;});}return name;});var Messages={isUndefined:function isUndefined(name){return name+' \xE9 um campo obrigat\xF3rio.';},habitants:function habitants(name){return'O numero minimo de '+name+' \xE9 um.';},isNull:function isNull(name){return name+' \xE9 um campo obrigat\xF3rio.';},greaterThanZero:function greaterThanZero(name){return name+' \xE9 um campo entre 0 e 100000';},startDateVendDate:function startDateVendDate(name){return'A data do fim do consumo deveria ser superior \xE0 data de in\xEDcio';},startHourVendHour:function startHourVendHour(name){return'A hora de encerramento deveria ser superior \xE0 hora de abertura';},datesMustBeBiggerThanTheOthers:function datesMustBeBiggerThanTheOthers(name){return'A '+name+' j\xE1 existe inserida no alcance de outro registo.';},timesMustBeBiggerThanTheOthers:function timesMustBeBiggerThanTheOthers(name){return'A '+name+' j\xE1 existe inserida no alcance de outro registo.';}};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(316)('wks');
var uid = __webpack_require__(235);
var Symbol = __webpack_require__(45).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(123),
    getRawTag = __webpack_require__(1339),
    objectToString = __webpack_require__(1367);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(153),
    baseForOwn = __webpack_require__(363),
    baseIteratee = __webpack_require__(92);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(197),
    baseClone = __webpack_require__(198),
    baseUnset = __webpack_require__(545),
    castPath = __webpack_require__(154),
    copyObject = __webpack_require__(155),
    customOmitClone = __webpack_require__(1336),
    flatRest = __webpack_require__(552),
    getAllKeysIn = __webpack_require__(555);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1483);


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(45);
var core = __webpack_require__(34);
var ctx = __webpack_require__(139);
var hide = __webpack_require__(111);
var has = __webpack_require__(110);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(19);
var hide = __webpack_require__(64);
var has = __webpack_require__(63);
var SRC = __webpack_require__(120)('src');
var $toString = __webpack_require__(1029);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(35).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var fails = __webpack_require__(18);
var defined = __webpack_require__(90);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = getPhrasePropTypes;

var _object = __webpack_require__(267);

var _object2 = _interopRequireDefault(_object);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getPhrasePropTypes(defaultPhrases) {
  return Object.keys(defaultPhrases).reduce(function (phrases, key) {
    return (0, _object2['default'])({}, phrases, _defineProperty({}, key, _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func, _propTypes2['default'].node])));
  }, {});
}

/***/ }),
/* 60 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 61 */
/***/ (function(module, exports) {

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(432);
var isBuffer = __webpack_require__(1254);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object' && !isArray(obj)) {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(39);
var createDesc = __webpack_require__(118);
module.exports = __webpack_require__(38) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(193);
var defined = __webpack_require__(90);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(553);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sym; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return TASK; });
/* unused harmony export HELPER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return MATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SAGA_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SELF_CANCELLATION; });
/* unused harmony export konst */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return kTrue; });
/* unused harmony export kFalse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ident; });
/* harmony export (immutable) */ __webpack_exports__["b"] = check;
/* unused harmony export hasOwn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return is; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return object; });
/* harmony export (immutable) */ __webpack_exports__["k"] = remove;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return array; });
/* harmony export (immutable) */ __webpack_exports__["s"] = deferred;
/* harmony export (immutable) */ __webpack_exports__["t"] = arrayOfDeffered;
/* harmony export (immutable) */ __webpack_exports__["i"] = delay;
/* harmony export (immutable) */ __webpack_exports__["u"] = createMockTask;
/* unused harmony export autoInc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return uid; });
/* harmony export (immutable) */ __webpack_exports__["j"] = makeIterator;
/* harmony export (immutable) */ __webpack_exports__["w"] = log;
/* harmony export (immutable) */ __webpack_exports__["d"] = deprecate;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateIncentive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return internalErr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return createSetContextWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return wrapSagaDispatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return cloneableGenerator; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var sym = function sym(id) {
  return '@@redux-saga/' + id;
};

var TASK = sym('TASK');
var HELPER = sym('HELPER');
var MATCH = sym('MATCH');
var CANCEL = sym('CANCEL_PROMISE');
var SAGA_ACTION = sym('SAGA_ACTION');
var SELF_CANCELLATION = sym('SELF_CANCELLATION');
var konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue = konst(true);
var kFalse = konst(false);
var noop = function noop() {};
var ident = function ident(v) {
  return v;
};

function check(value, predicate, error) {
  if (!predicate(value)) {
    log('error', 'uncaught at check', error);
    throw new Error(error);
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(object, property) {
  return is.notUndef(object) && hasOwnProperty.call(object, property);
}

var is = {
  undef: function undef(v) {
    return v === null || v === undefined;
  },
  notUndef: function notUndef(v) {
    return v !== null && v !== undefined;
  },
  func: function func(f) {
    return typeof f === 'function';
  },
  number: function number(n) {
    return typeof n === 'number';
  },
  string: function string(s) {
    return typeof s === 'string';
  },
  array: Array.isArray,
  object: function object(obj) {
    return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
  },
  promise: function promise(p) {
    return p && is.func(p.then);
  },
  iterator: function iterator(it) {
    return it && is.func(it.next) && is.func(it.throw);
  },
  iterable: function iterable(it) {
    return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
  },
  task: function task(t) {
    return t && t[TASK];
  },
  observable: function observable(ob) {
    return ob && is.func(ob.subscribe);
  },
  buffer: function buffer(buf) {
    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
  },
  pattern: function pattern(pat) {
    return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
  },
  channel: function channel(ch) {
    return ch && is.func(ch.take) && is.func(ch.close);
  },
  helper: function helper(it) {
    return it && it[HELPER];
  },
  stringableFunc: function stringableFunc(f) {
    return is.func(f) && hasOwn(f, 'toString');
  }
};

var object = {
  assign: function assign(target, source) {
    for (var i in source) {
      if (hasOwn(source, i)) {
        target[i] = source[i];
      }
    }
  }
};

function remove(array, item) {
  var index = array.indexOf(item);
  if (index >= 0) {
    array.splice(index, 1);
  }
}

var array = {
  from: function from(obj) {
    var arr = Array(obj.length);
    for (var i in obj) {
      if (hasOwn(obj, i)) {
        arr[i] = obj[i];
      }
    }
    return arr;
  }
};

function deferred() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var def = _extends({}, props);
  var promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  def.promise = promise;
  return def;
}

function arrayOfDeffered(length) {
  var arr = [];
  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }
  return arr;
}

function delay(ms) {
  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var timeoutId = void 0;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(function () {
      return resolve(val);
    }, ms);
  });

  promise[CANCEL] = function () {
    return clearTimeout(timeoutId);
  };

  return promise;
}

function createMockTask() {
  var _ref;

  var running = true;
  var _result = void 0,
      _error = void 0;

  return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {
    return running;
  }, _ref.result = function result() {
    return _result;
  }, _ref.error = function error() {
    return _error;
  }, _ref.setRunning = function setRunning(b) {
    return running = b;
  }, _ref.setResult = function setResult(r) {
    return _result = r;
  }, _ref.setError = function setError(e) {
    return _error = e;
  }, _ref;
}

function autoInc() {
  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var kThrow = function kThrow(err) {
  throw err;
};
var kReturn = function kReturn(value) {
  return { value: value, done: true };
};
function makeIterator(next) {
  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var isHelper = arguments[3];

  var iterator = { name: name, next: next, throw: thro, return: kReturn };

  if (isHelper) {
    iterator[HELPER] = true;
  }
  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }
  return iterator;
}

/**
  Print error in a useful way whether in a browser environment
  (with expandable error stack traces), or in a node.js environment
  (text-only log output)
 **/
function log(level, message) {
  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  /*eslint-disable no-console*/
  if (typeof window === 'undefined') {
    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
  } else {
    console[level](message, error);
  }
}

function deprecate(fn, deprecationWarning) {
  return function () {
    if (false) log('warn', deprecationWarning);
    return fn.apply(undefined, arguments);
  };
}

var updateIncentive = function updateIncentive(deprecated, preferred) {
  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
};

var internalErr = function internalErr(err) {
  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
};

var createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
};

var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    return dispatch(Object.defineProperty(action, SAGA_ACTION, { value: true }));
  };
};

var cloneableGenerator = function cloneableGenerator(generatorFunc) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var history = [];
    var gen = generatorFunc.apply(undefined, args);
    return {
      next: function next(arg) {
        history.push(arg);
        return gen.next(arg);
      },
      clone: function clone() {
        var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
        history.forEach(function (arg) {
          return clonedGen.next(arg);
        });
        return clonedGen;
      },
      return: function _return(value) {
        return gen.return(value);
      },
      throw: function _throw(exception) {
        return gen.throw(exception);
      }
    };
  };
};

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Icon */
/* unused harmony export Wrapper */
/* unused harmony export DefaultSelector */
/* unused harmony export DefaultList */
/* unused harmony export DefaultListOpened */
/* unused harmony export Item */
/* unused harmony export Checkbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_find__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isEqual__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isArray__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_findIndex__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_map__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_remove__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_remove___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_remove__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_onclickoutside__ = __webpack_require__(275);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 35px;\n  height: 35px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 10px;\n'],['\n  width: 35px;\n  height: 35px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 10px;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: relative;\n'],['\n  position: relative;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding: 15px 16px;\n  font-size: 14px;\n  line-height: 18px;\n  font-weight: bold;\n  background-color: #ffffff;\n  color: #9c9c9c;\n  display: flex;\n  align-items: center;\n  background-position: right center;\n  background-repeat: no-repeat;\n  border: 1px solid #efefef;\n  cursor: pointer;\n  position: relative;\n\n  &::after {\n    content: \' \';\n    display: block;\n    background-image: url(',');\n    background-size: contain;\n    width: 12px;\n    height: 12px;\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n    background-repeat: no-repeat;\n    background-position: center;\n\n    ','\n  }\n\n  &.selected {\n    color: #3e3e3e;\n    font-weight: bold;\n  }\n\n  &[disabled] {\n    background-color: transparent;\n    border: 0;\n    color: #676767;\n    opacity: 0.5;\n    pointer-events: none;\n  }\n\n  &:focus {\n    border-color: #93c13e;\n  }\n\n  background-position: 16px center;\n  background-repeat: no-repeat;\n  background-size: 16.5px;\n\n  ','\n  ','\n'],['\n  padding: 15px 16px;\n  font-size: 14px;\n  line-height: 18px;\n  font-weight: bold;\n  background-color: #ffffff;\n  color: #9c9c9c;\n  display: flex;\n  align-items: center;\n  background-position: right center;\n  background-repeat: no-repeat;\n  border: 1px solid #efefef;\n  cursor: pointer;\n  position: relative;\n\n  &::after {\n    content: \' \';\n    display: block;\n    background-image: url(',');\n    background-size: contain;\n    width: 12px;\n    height: 12px;\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n    background-repeat: no-repeat;\n    background-position: center;\n\n    ','\n  }\n\n  &.selected {\n    color: #3e3e3e;\n    font-weight: bold;\n  }\n\n  &[disabled] {\n    background-color: transparent;\n    border: 0;\n    color: #676767;\n    opacity: 0.5;\n    pointer-events: none;\n  }\n\n  &:focus {\n    border-color: #93c13e;\n  }\n\n  background-position: 16px center;\n  background-repeat: no-repeat;\n  background-size: 16.5px;\n\n  ','\n  ','\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 0;\n  opacity: 0;\n  width: 100%;\n  max-height: 200px;\n  overflow: auto;\n  border: 1px solid #efefef;\n  border-top: 0;\n  border-radius: 0 2px 2px 0;\n  box-shadow: 0 0 0 1px #efefef;\n  transition: all 0.4s ease-in-out;\n  background: #fff;\n  position: absolute;\n  z-index: 99999;\n'],['\n  height: 0;\n  opacity: 0;\n  width: 100%;\n  max-height: 200px;\n  overflow: auto;\n  border: 1px solid #efefef;\n  border-top: 0;\n  border-radius: 0 2px 2px 0;\n  box-shadow: 0 0 0 1px #efefef;\n  transition: all 0.4s ease-in-out;\n  background: #fff;\n  position: absolute;\n  z-index: 99999;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: auto;\n  opacity: 1;\n  transition: all 0.4s ease-in-out;\n'],['\n  height: auto;\n  opacity: 1;\n  transition: all 0.4s ease-in-out;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding: 10px 15px;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  user-select: none;\n  font-size: 14px;\n  white-space: nowrap;\n\n  &:hover {\n    background-color: #efefef;\n  }\n'],['\n  padding: 10px 15px;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  user-select: none;\n  font-size: 14px;\n  white-space: nowrap;\n\n  &:hover {\n    background-color: #efefef;\n  }\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  border: 1px solid #bababa;\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 10px;\n\n  ','\n'],['\n  border: 1px solid #bababa;\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 10px;\n\n  ','\n']);/**
 * Select component
 */var Select=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Select,_Component);function Select(){__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,Select);var _this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(Select.__proto__||Object.getPrototypeOf(Select)).call(this));_this.state={listOpened:false,selected:null};_this.toggleList=_this.toggleList.bind(_this);_this.setSelectedFromProp=_this.setSelectedFromProp.bind(_this);return _this;}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Select,[{key:'handleClickOutside',value:function handleClickOutside(evt){if(this.state.listOpened){this.setState({listOpened:!this.state.listOpened});}}},{key:'setSelectedFromProp',value:function setSelectedFromProp(prop,first){var _this2=this;if(prop){var selected=void 0;if(__WEBPACK_IMPORTED_MODULE_9_lodash_isArray___default()(prop)){selected=__WEBPACK_IMPORTED_MODULE_11_lodash_map___default()(prop,function(propValue){return __WEBPACK_IMPORTED_MODULE_7_lodash_find___default()(_this2.props.items,function(_ref){var value=_ref.value;return value===propValue;});});}else{selected=__WEBPACK_IMPORTED_MODULE_7_lodash_find___default()(this.props.items,function(_ref2){var value=_ref2.value;return value===prop;});}if(selected){this.setState({selected:selected},function(){if(__WEBPACK_IMPORTED_MODULE_9_lodash_isArray___default()(selected)){_this2.props.onChange&&_this2.props.onChange(_this2.state.selected);}else{_this2.props.onChange&&_this2.props.onChange(Object.assign({},_this2.state.selected,{first:first}));}});}}}},{key:'componentWillMount',value:function componentWillMount(){this.setSelectedFromProp(this.props.selected,true);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.selected){var findItem=__WEBPACK_IMPORTED_MODULE_7_lodash_find___default()(this.props.items,function(_ref3){var value=_ref3.value;return value===nextProps.selected;});if(findItem){if(__WEBPACK_IMPORTED_MODULE_8_lodash_isEqual___default()(this.state.selected,findItem)){return false;}this.setSelectedFromProp(nextProps.selected);}}else{this.setState({selected:null});}}},{key:'toggleList',value:function toggleList(){this.setState({listOpened:!this.state.listOpened});}},{key:'selectItem',value:function selectItem(item){var _this3=this;this.setState({selected:item,listOpened:false},function(){_this3.props.onChange&&_this3.props.onChange(_this3.state.selected);});}},{key:'selectItems',value:function selectItems(item){var _this4=this;var items=this.state.selected||[];var found=__WEBPACK_IMPORTED_MODULE_10_lodash_findIndex___default()(items,function(i){return i.value===item.value;});if(this.props.removedSelectOnSelected){this.props.removedSelectOnSelected.forEach(function(v){return __WEBPACK_IMPORTED_MODULE_12_lodash_remove___default()(items,{value:v});});}if(this.props.excludeAllExceptOnSelect){var isExluder=this.props.excludeAllExceptOnSelect.find(function(it){return it===item.value;});if(isExluder){this.props.excludeAllExceptOnSelect.forEach(function(v){return __WEBPACK_IMPORTED_MODULE_12_lodash_remove___default()(items,function(item){return item.value!==v;});});}}if(found!==-1){items=items.filter(function(item,index){return index!==found;});}else{items.push(item);}this.setState({selected:items},function(){_this4.props.onChange&&_this4.props.onChange(_this4.state.selected);});}},{key:'render',value:function render(){var _this5=this;var _props=this.props,placeholder=_props.placeholder,render=_props.render,Selector=_props.Selector,List=_props.List,className=_props.className,items=_props.items;var SelectorText=placeholder;// Set default
if(!Selector){Selector=DefaultSelector;}if(!List){List=DefaultList;}if(this.state.listOpened){List=DefaultListOpened;}if(this.state.selected){if(this.state.selected.icon){SelectorText=__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span',null,typeof this.state.selected.icon==='string'?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Icon,{src:this.state.selected.icon,alt:this.state.selected.label}):this.state.selected.icon,this.state.selected.label);}else{SelectorText=this.state.selected.label;}}return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Wrapper,{className:className},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Selector,{onClick:!this.props.disabled&&this.toggleList,className:this.state.selected&&'selected',opened:this.state.listOpened,arrowIcon:this.props.arrowIcon,icon:this.props.icon,disabled:this.props.disabled},render?render(SelectorText,placeholder):SelectorText?SelectorText:placeholder),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(List,null,items&&items.map(function(item){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Item,{key:'item-'+item.value+item.label,onClick:function onClick(){return SelectorText?_this5.selectItem(item):_this5.selectItems(item);}},item.icon&&typeof item.icon==='string'?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Icon,{src:item.icon}):item.icon,item.value===(_this5.state.selected&&_this5.state.selected.value)?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',null,item.label,' ',__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span',{className:'itemSelected'},'\u2713')):item.label);})));}}]);return Select;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_react_onclickoutside__["a" /* default */])(Select));var Icon=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].img(_templateObject);var Wrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject2);var DefaultSelector=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject3,function(_ref4){var arrowIcon=_ref4.arrowIcon;return arrowIcon;},function(props){return props.opened&&'\n      transform: translateY(-50%)rotate(180deg);\n    ';},function(props){return props.icon?'background-image: url('+props.icon+');':'';},function(props){return props.icon?'padding-left: 40px':'';});var DefaultList=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject4);var DefaultListOpened=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(DefaultList)(_templateObject5);var Item=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject6);var Checkbox=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject7,function(props){return props.checked?'\n    &:after {\n      content: "\u2713";\n      color: #93C13E;\n      display: block;\n      width: 18px;\n      font-size: 18px;\n      text-align: center;\n      line-height: 18px;\n    }\n  ':'';});

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(18);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(1334),
    findIndex = __webpack_require__(93);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(541),
    getTag = __webpack_require__(126),
    isArguments = __webpack_require__(160),
    isArray = __webpack_require__(23),
    isArrayLike = __webpack_require__(83),
    isBuffer = __webpack_require__(161),
    isPrototype = __webpack_require__(261),
    isTypedArray = __webpack_require__(203);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColumnProps = exports.Col = exports.getRowProps = exports.Row = exports.Grid = undefined;

var _Row2 = __webpack_require__(1535);

Object.defineProperty(exports, 'getRowProps', {
  enumerable: true,
  get: function get() {
    return _Row2.getRowProps;
  }
});

var _Col2 = __webpack_require__(1533);

Object.defineProperty(exports, 'getColumnProps', {
  enumerable: true,
  get: function get() {
    return _Col2.getColumnProps;
  }
});

var _Grid2 = __webpack_require__(1534);

var _Grid3 = _interopRequireDefault(_Grid2);

var _Row3 = _interopRequireDefault(_Row2);

var _Col3 = _interopRequireDefault(_Col2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Grid = _Grid3.default;
exports.Row = _Row3.default;
exports.Col = _Col3.default;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(87);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(140)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(79);
var IObject = __webpack_require__(193);
var toObject = __webpack_require__(46);
var toLength = __webpack_require__(31);
var asc = __webpack_require__(484);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(77);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(194);
var createDesc = __webpack_require__(118);
var toIObject = __webpack_require__(65);
var toPrimitive = __webpack_require__(99);
var has = __webpack_require__(63);
var IE8_DOM_DEFINE = __webpack_require__(488);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(38) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(3);
var core = __webpack_require__(35);
var fails = __webpack_require__(18);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 82 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(101),
    isLength = __webpack_require__(264);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(22),
    _assign = __webpack_require__(21);

var CallbackQueue = __webpack_require__(628);
var PooledClass = __webpack_require__(129);
var ReactFeatureFlags = __webpack_require__(633);
var ReactReconciler = __webpack_require__(171);
var Transaction = __webpack_require__(272);

var invariant = __webpack_require__(12);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_config__ = __webpack_require__(10);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: relative;\n\n  > label {\n    color: #3e3e3e;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n    margin: 0;\n    text-transform: unset;\n\n    > b {\n      color: #c00000;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 18px;\n      margin: 0;\n    }\n  }\n'],['\n  position: relative;\n\n  > label {\n    color: #3e3e3e;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n    margin: 0;\n    text-transform: unset;\n\n    > b {\n      color: #c00000;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 18px;\n      margin: 0;\n    }\n  }\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background: #dedede;\n  height: 40px;\n  padding: 1px;\n  box-sizing: border-box;\n\n  &:focus-within {\n    background: ',';\n  }\n'],['\n  background: #dedede;\n  height: 40px;\n  padding: 1px;\n  box-sizing: border-box;\n\n  &:focus-within {\n    background: ',';\n  }\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  height: 100%;\n  padding-inline: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 4px;\n  flex: 1 0 0;\n\n  cursor: pointer;\n\n  ','\n\n  background-color: #fff;\n\n  &:hover {\n    background: #ececec;\n  }\n'],['\n  width: 100%;\n  height: 100%;\n  padding-inline: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 4px;\n  flex: 1 0 0;\n\n  cursor: pointer;\n\n  ','\n\n  background-color: #fff;\n\n  &:hover {\n    background: #ececec;\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #616161;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 25px;\n\n  background: transparent;\n  border: none;\n\n  field-sizing: content;\n  min-width: 10px;\n  padding: 0 !important;\n  width: unset !important;\n\n  ','\n\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  &:[type=number] {\n    -moz-appearance: textfield;\n  }\n'],['\n  color: #616161;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 25px;\n\n  background: transparent;\n  border: none;\n\n  field-sizing: content;\n  min-width: 10px;\n  padding: 0 !important;\n  width: unset !important;\n\n  ','\n\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  &:[type=number] {\n    -moz-appearance: textfield;\n  }\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #bababa;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  pointer-events: none;\n'],['\n  color: #bababa;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  pointer-events: none;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #c13e44;\n  font-size: 12px;\n  font-weight: 400;\n  ','\n  position: absolute;\n'],['\n  color: #c13e44;\n  font-size: 12px;\n  font-weight: 400;\n  ','\n  position: absolute;\n']);var InputV2=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InputV2,_Component);function InputV2(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,InputV2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=InputV2.__proto__||Object.getPrototypeOf(InputV2)).call.apply(_ref,[this].concat(args))),_this),_this.onChange=function(event,props){if(props.onlyNumbers){var re=/^[0-9\b]+$/;if(event.target.value&&!re.test(event.target.value)){return false;}}if(props.onlyDecimalNumbers){var _re=/(^[0-9]$)|(^[0-9](.|,)?$)|(^[0-9](.|,){1}[0-9]+$)/;if(event.target.value&&!_re.test(event.target.value)){return false;}}props.onChange(event.target.value);},_this.handleInputFocus=function(e){var input=e.target.querySelector('input');if(input){input.focus();var length=input.value.length;if(input.type==='number'){// Temporarily change type to text to set cursor position
input.type='text';setTimeout(function(){input.setSelectionRange(length,length);input.type='number';// Revert back to number
},0);}else{// For text inputs, directly set the cursor position
input.setSelectionRange(length,length);}}},_temp),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(InputV2,[{key:'render',value:function render(){var _this2=this;var props=this.props;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Label,{style:props.style},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('label',{style:props.labelStyle},props.label,props.required&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('b',null,' *')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputBg,{bgColor:__WEBPACK_IMPORTED_MODULE_8_config__["c" /* backgroundColors */].normalLeft},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputContent,{icon:Boolean(props.icon),onClick:this.handleInputFocus},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InnerInput,{id:props.id,valid:props.valid,value:props.value,type:props.type,required:props.required,autoComplete:'off',onChange:function onChange(e){_this2.onChange(e,props);},onBlur:function onBlur(e){return props.onBlur&&props.onBlur(props.validator);},placeholder:props.placeholder,maxLength:props.maxLength,className:props.className,fullWidth:!props.suffix}),props.suffix&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Suffix,null,props.suffix),props.icon)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Error,{valid:props.valid},props.errorMessage));}}]);return InputV2;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);InputV2.defaultProps={errorMessage:'',valid:true,placeholder:''};InputV2.propTypes={label:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,labelStyle:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,id:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,type:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,onChange:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,autoComplete:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,onBlur:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,value:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,valid:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,required:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,errorMessage:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,placeholder:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,validator:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,suffix:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,icon:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any};/* harmony default export */ __webpack_exports__["a"] = (InputV2);var Label=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject);var InputBg=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject2,function(_ref2){var bgColor=_ref2.bgColor;return bgColor;});var InputContent=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject3,function(_ref3){var icon=_ref3.icon;return icon&&'justify-content: space-between;';});var InnerInput=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].input(_templateObject4,function(_ref4){var fullWidth=_ref4.fullWidth;return fullWidth&&'flex: 1 0 0;';});var Suffix=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject5);var Error=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject6,function(props){return(props.valid===null||props.valid)&&'display: none;';});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_SubTitle__ = __webpack_require__(301);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  ','\n'],['\n  width: 100%;\n  ','\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  padding: ',';\n  text-align: center;\n  display: flex;\n  align-items: center;\n\n  &:nth-child(even) {\n    background-color: #f9f9f9;\n  }\n\n  &.invalid {\n    h3 {\n      color: indianred;\n    }\n  }\n'],['\n  width: 100%;\n  padding: ',';\n  text-align: center;\n  display: flex;\n  align-items: center;\n\n  &:nth-child(even) {\n    background-color: #f9f9f9;\n  }\n\n  &.invalid {\n    h3 {\n      color: indianred;\n    }\n  }\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-size: 32px;\n  font-weight: bold;\n  line-height: 32px;\n  color: #010101;\n  text-transform: uppercase;\n  text-align: center;\n  margin: 0;\n  margin-bottom: 8px;\n\n  @media screen and (max-width: 768px) {\n    font-size: 22px;\n    line-height: 22px;\n  }\n'],['\n  font-size: 32px;\n  font-weight: bold;\n  line-height: 32px;\n  color: #010101;\n  text-transform: uppercase;\n  text-align: center;\n  margin: 0;\n  margin-bottom: 8px;\n\n  @media screen and (max-width: 768px) {\n    font-size: 22px;\n    line-height: 22px;\n  }\n']);var Slot=function Slot(_ref){var children=_ref.children,slot=_ref.slot;var slottedChild=null;__WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.forEach(children,function(child){if(!__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(child))return;if(child.props['data-slot']===slot){slottedChild=__WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(child);}});return slottedChild;};var Section=function Section(_ref2){var style=_ref2.style,className=_ref2.className,id=_ref2.id,title=_ref2.title,subtitle=_ref2.subtitle,grey=_ref2.grey,children=_ref2.children,noContainer=_ref2.noContainer;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Wrapper,{style:style,className:className+' question',grey:grey,id:id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Container,{noContainer:noContainer},title&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Title,null,title),subtitle&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_SubTitle__["a" /* default */],{text:subtitle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Slot,{slot:'tip'},children)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.map(children,function(child,i){if(__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(child)&&child.props['data-slot'])return;return child;})));};/* harmony default export */ __webpack_exports__["a"] = (Section);var Container=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject,function(_ref3){var noContainer=_ref3.noContainer;return!noContainer&&'\n    max-width: 1200px;\n    margin: 0 auto;\n  ';});var Wrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject2,function(_ref4){var compact=_ref4.compact;return compact?'40px 0':'80px 0';});var Title=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].h2(_templateObject3);

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(75);
var IE8_DOM_DEFINE = __webpack_require__(464);
var toPrimitive = __webpack_require__(319);
var dP = Object.defineProperty;

exports.f = __webpack_require__(76) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 89 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 90 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(38)) {
  var LIBRARY = __webpack_require__(113);
  var global = __webpack_require__(19);
  var fails = __webpack_require__(18);
  var $export = __webpack_require__(3);
  var $typed = __webpack_require__(247);
  var $buffer = __webpack_require__(344);
  var ctx = __webpack_require__(79);
  var anInstance = __webpack_require__(143);
  var propertyDesc = __webpack_require__(118);
  var hide = __webpack_require__(64);
  var redefineAll = __webpack_require__(145);
  var toInteger = __webpack_require__(82);
  var toLength = __webpack_require__(31);
  var toIndex = __webpack_require__(507);
  var toAbsoluteIndex = __webpack_require__(119);
  var toPrimitive = __webpack_require__(99);
  var has = __webpack_require__(63);
  var classof = __webpack_require__(192);
  var isObject = __webpack_require__(20);
  var toObject = __webpack_require__(46);
  var isArrayIter = __webpack_require__(331);
  var create = __webpack_require__(114);
  var getPrototypeOf = __webpack_require__(116);
  var gOPN = __webpack_require__(115).f;
  var getIterFn = __webpack_require__(346);
  var uid = __webpack_require__(120);
  var wks = __webpack_require__(28);
  var createArrayMethod = __webpack_require__(78);
  var createArrayIncludes = __webpack_require__(237);
  var speciesConstructor = __webpack_require__(195);
  var ArrayIterators = __webpack_require__(347);
  var Iterators = __webpack_require__(144);
  var $iterDetect = __webpack_require__(243);
  var setSpecies = __webpack_require__(146);
  var arrayFill = __webpack_require__(324);
  var arrayCopyWithin = __webpack_require__(482);
  var $DP = __webpack_require__(39);
  var $GOPD = __webpack_require__(80);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(1304),
    baseMatchesProperty = __webpack_require__(1305),
    identity = __webpack_require__(201),
    isArray = __webpack_require__(23),
    property = __webpack_require__(1419);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(536),
    baseIteratee = __webpack_require__(92),
    toInteger = __webpack_require__(206);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(21);

var PooledClass = __webpack_require__(129);

var emptyFunction = __webpack_require__(70);
var warning = __webpack_require__(14);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}
/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ShadowBox__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Select__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Input__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Buttons__ = __webpack_require__(723);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__ShadowBox__["a"]; });
/* unused harmony reexport Select */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Input__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__Buttons__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__Buttons__["b"]; });







/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_mapValues__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_kea__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_kea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_kea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_querystring__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_querystring__);
/** Contants */var DEFAULT_VALUES={};var DEFAULT_SETTINGS={iframed:false,goToResults:false,electricCar:true};var OFFER_TYPES_ENDPOINT=__WEBPACK_IMPORTED_MODULE_6_config__["b" /* API_BASE_URL */]+'/public/offer-type/';var TRANSLATIONS_ENDPOINT=__WEBPACK_IMPORTED_MODULE_6_config__["b" /* API_BASE_URL */]+'/public/translations/';var ME_ENDPOINT=__WEBPACK_IMPORTED_MODULE_6_config__["b" /* API_BASE_URL */]+'/private/user-profile/me/';var TRANSLATIONS_LOCAL_KEY='local';var AUTH_TOKEN_KEY='tokenauth';var LOADING_COUNT=3;var SIMILATIONS_ENPOINT=__WEBPACK_IMPORTED_MODULE_6_config__["d" /* API_BASE_URL_V2 */]+'/public/simulation/{code}';/* eslint-disable camelcase */var Logic=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_kea__["kea"])({path:function path(){return['scenes','appV2'];},actions:function actions(){return{getAppTranslations:function getAppTranslations(){return{};},getCurrentUser:function getCurrentUser(){return{};},setAppTranslations:function setAppTranslations(translations){return{translations:translations};},setValue:function setValue(selected,item){return{values:__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},item,selected.value)};},setValues:function setValues(selected){return selected;},setIsUserLoggedIn:function setIsUserLoggedIn(is){return{is:is};},setFinished:function setFinished(value){return{value:value};},setOfferTypes:function setOfferTypes(offerTypes){return{offerTypes:offerTypes};},fetchOfferTypes:function fetchOfferTypes(){return{};},fetchError:function fetchError(error){return{error:error};},setStarted:function setStarted(){return{};},setSettings:function setSettings(settings){return{settings:settings};},decreaseLoading:function decreaseLoading(){return{};},changeSimulationData:function changeSimulationData(){return{};}};},reducers:function reducers(_ref){var _ref2;var actions=_ref.actions;return{values:[DEFAULT_VALUES,__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,(_ref2={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref2,actions.setValue,function(state,payload){return Object.assign({},state,payload.values);}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref2,actions.setValues,function(state,payload){return Object.assign({},state,payload);}),_ref2)],offerTypes:[null,__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.setOfferTypes,function(_,payload){return payload.offerTypes;})],finished:[{},__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.setFinished,function(_,payload){return Object.assign({},_,payload.value);})],translations:[{},__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.setAppTranslations,function(state,payload){return payload.translations;})],userLoggedIn:[false,__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.setIsUserLoggedIn,function(_,payload){return payload.is;})],started:[false,__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.setStarted,function(){return true;})],settings:[DEFAULT_SETTINGS,__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.setSettings,function(state,payload){return Object.assign({},state,payload.settings);})],loading:[LOADING_COUNT,__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.decreaseLoading,function(state){return state-1;})],dataSimulationChanged:[false,__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.changeSimulationData,function(){return true;})]};},takeLatest:function takeLatest(_ref11){var _ref12;var actions=_ref11.actions,workers=_ref11.workers;return _ref12={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref12,actions.fetchOfferTypes,workers.fetchOfferTypes),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref12,actions.getAppTranslations,workers.getAppTranslations),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref12,actions.getCurrentUser,workers.getCurrentUser),_ref12;},start:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function start(){var _actions,fetchOfferTypes,setAppTranslations,getAppTranslations,getCurrentUser,setStarted,setSettings,decreaseLoading,setFinished,setValues,appStarted,localTranslations,parsedTranslations,params,queryString,urlParams,s,response,values;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function start$(_context){while(1){switch(_context.prev=_context.next){case 0:_actions=this.actions,fetchOfferTypes=_actions.fetchOfferTypes,setAppTranslations=_actions.setAppTranslations,getAppTranslations=_actions.getAppTranslations,getCurrentUser=_actions.getCurrentUser,setStarted=_actions.setStarted,setSettings=_actions.setSettings,decreaseLoading=_actions.decreaseLoading,setFinished=_actions.setFinished,setValues=_actions.setValues;_context.next=3;return this.get('started');case 3:appStarted=_context.sent;if(!appStarted){_context.next=6;break;}return _context.abrupt('return',false);case 6:_context.next=8;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(fetchOfferTypes());case 8:_context.next=10;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(getCurrentUser());case 10:// Check if user has translations in localStorage
// We need to do this because of performance issues
localTranslations=window.localStorage.getItem(TRANSLATIONS_LOCAL_KEY);if(!localTranslations){_context.next=15;break;}parsedTranslations=JSON.parse(localTranslations);_context.next=15;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setAppTranslations(parsedTranslations));case 15:// Check if there are any params in the first request
params=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_utils__["b" /* searchToObject */])(window.location.search);// Set iframe settings
if(!params.iframed){_context.next=20;break;}document.body.classList.add('iframed');_context.next=20;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setSettings({iframed:true}));case 20:if(params.profile){_context.next=43;break;}queryString=window.location.search;urlParams=new URLSearchParams(queryString);_context.prev=23;s=urlParams.get('code');if(!s){_context.next=37;break;}_context.next=28;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setSettings({isFromUrl:true,goToResults:true}));case 28:_context.next=30;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get,SIMILATIONS_ENPOINT.replace('{code}',s));case 30:response=_context.sent;values=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_utils__["c" /* csObjectFromUnderscore */])(response.data.simulation_history.api_input_data);values=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lodash__["omit"])(values,['simulationCode']);_context.next=35;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setValues(values));case 35:_context.next=37;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setFinished({profileFinished:true}));case 37:_context.next=41;break;case 39:_context.prev=39;_context.t0=_context['catch'](23);case 41:_context.next=43;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(decreaseLoading());case 43:_context.next=45;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(getAppTranslations());case 45:_context.next=47;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setStarted(true));case 47:case'end':return _context.stop();}}},start,this,[[23,39]]);}),workers:{setValuesUrl:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function setValuesUrl(){var values,query,url;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setValuesUrl$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return this.get('values');case 2:values=_context2.sent;query=__WEBPACK_IMPORTED_MODULE_11_querystring___default.a.stringify(values);url='?s='+btoa(query);window.history.pushState('','',url+window.location.hash);case 6:case'end':return _context2.stop();}}},setValuesUrl,this);}),/**
     * Fetches offer type for the overall use in app
     */fetchOfferTypes:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchOfferTypes(){var _actions2,setOfferTypes,fetchError,decreaseLoading,response,results;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchOfferTypes$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_actions2=this.actions,setOfferTypes=_actions2.setOfferTypes,fetchError=_actions2.fetchError,decreaseLoading=_actions2.decreaseLoading;_context3.prev=1;_context3.next=4;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get,OFFER_TYPES_ENDPOINT,{limit:1000});case 4:response=_context3.sent;results=response.data.results;if(!results){_context3.next=11;break;}_context3.next=9;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setOfferTypes(results));case 9:_context3.next=11;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(decreaseLoading());case 11:_context3.next=17;break;case 13:_context3.prev=13;_context3.t0=_context3['catch'](1);_context3.next=17;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(fetchError(_context3.t0));case 17:case'end':return _context3.stop();}}},fetchOfferTypes,this,[[1,13]]);}),/**
     * Gets app translations
     */getAppTranslations:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function getAppTranslations(){var _actions3,setAppTranslations,setFatalError,request,results,translations,localTranslations;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getAppTranslations$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_actions3=this.actions,setAppTranslations=_actions3.setAppTranslations,setFatalError=_actions3.setFatalError;_context4.prev=1;_context4.next=4;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get,TRANSLATIONS_ENDPOINT);case 4:request=_context4.sent;results=request.data.results;// Convert translations to a simpler object
// This can be optimized #todo
translations={};__WEBPACK_IMPORTED_MODULE_5_lodash_mapValues___default()(results,function(item){return __WEBPACK_IMPORTED_MODULE_5_lodash_mapValues___default()(item.properties,function(prop){translations[prop.key]=prop.value;});});// Get local translations
// We don't want the user to see stuff changing when hes using the app
// Only update the storage on background and the next time he visits
// He will have the translations updated
localTranslations=window.localStorage.getItem(TRANSLATIONS_LOCAL_KEY);if(localTranslations){_context4.next=12;break;}_context4.next=12;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setAppTranslations(translations));case 12:// Set the new translations to localstorage
window.localStorage.setItem(TRANSLATIONS_LOCAL_KEY,JSON.stringify(translations));_context4.next=19;break;case 15:_context4.prev=15;_context4.t0=_context4['catch'](1);_context4.next=19;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setFatalError());case 19:case'end':return _context4.stop();}}},getAppTranslations,this,[[1,15]]);}),/**
     * Gets current user logged in
     */getCurrentUser:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function getCurrentUser(){var _actions4,setIsUserLoggedIn,decreaseLoading,setSettings,token,params,me;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getCurrentUser$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_actions4=this.actions,setIsUserLoggedIn=_actions4.setIsUserLoggedIn,decreaseLoading=_actions4.decreaseLoading;setSettings=this.actions.setSettings;_context5.prev=2;token=window.localStorage.getItem(AUTH_TOKEN_KEY);params=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_utils__["b" /* searchToObject */])(window.location.search);if(token){_context5.next=14;break;}_context5.next=8;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setIsUserLoggedIn(false));case 8:_context5.next=10;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(decreaseLoading());case 10:if(!params.profile){_context5.next=13;break;}_context5.next=13;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(decreaseLoading());case 13:return _context5.abrupt('return');case 14:_context5.next=16;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get,ME_ENDPOINT,{headers:{Authorization:'JWT '+token}});case 16:me=_context5.sent;_context5.next=19;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setIsUserLoggedIn(me.data));case 19:__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common['Authorization']='JWT '+token;if(!params.profile){_context5.next=23;break;}_context5.next=23;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setSettings({isFromProfile:params.profile}));case 23:_context5.next=25;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(decreaseLoading());case 25:_context5.next=35;break;case 27:_context5.prev=27;_context5.t0=_context5['catch'](2);_context5.next=31;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setIsUserLoggedIn(false));case 31:localStorage.removeItem(AUTH_TOKEN_KEY);delete __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common['Authorization'];_context5.next=35;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(decreaseLoading());case 35:case'end':return _context5.stop();}}},getCurrentUser,this,[[2,27]]);})},selectors:function selectors(_ref13){var _selectors=_ref13.selectors;return{/**
     * Selects the current offer type object based on id
     */offerType:[function(){return[_selectors.values,_selectors.offerTypes];},function(_ref14,offerTypes){var offerType=_ref14.offerType;return __WEBPACK_IMPORTED_MODULE_4_lodash_find___default()(offerTypes,function(_ref15){var id=_ref15.id;return id===offerType;});},__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any],iframed:[function(){return[_selectors.settings];},function(_ref16){var iframed=_ref16.iframed;return iframed;},__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any],electricCar:[function(){return[_selectors.settings];},function(_ref17){var electricCar=_ref17.electricCar;return electricCar;},__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any],goToResults:[function(){return[_selectors.settings];},function(_ref18){var goToResults=_ref18.goToResults;return goToResults;},__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any]};}});/* harmony default export */ __webpack_exports__["a"] = (Logic);

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(120)('meta');
var isObject = __webpack_require__(20);
var has = __webpack_require__(63);
var setDesc = __webpack_require__(39).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(18)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(20);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = exports.isAbsolutePath = undefined;

var _warning = __webpack_require__(151);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isAbsolutePath = exports.isAbsolutePath = function isAbsolutePath(path) {
  return typeof path === 'string' && path.charAt(0) === '/';
};

var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
  var _parsePath = parsePath(path);

  var pathname = _parsePath.pathname;
  var search = _parsePath.search;
  var hash = _parsePath.hash;


  return createPath({
    pathname: pathname,
    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
    hash: hash
  });
};

var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
  var _parsePath2 = parsePath(path);

  var pathname = _parsePath2.pathname;
  var search = _parsePath2.search;
  var hash = _parsePath2.hash;


  return createPath({
    pathname: pathname,
    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
      return prefix === '?' ? prefix : suffix;
    }),
    hash: hash
  });
};

var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
  var _parsePath3 = parsePath(path);

  var search = _parsePath3.search;

  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
  return match && match[1];
};

var extractPath = function extractPath(string) {
  var match = string.match(/^(https?:)?\/\/[^\/]*/);
  return match == null ? string : string.substring(match[0].length);
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  if (location == null || typeof location === 'string') return location;

  var basename = location.basename;
  var pathname = location.pathname;
  var search = location.search;
  var hash = location.hash;

  var path = (basename || '') + pathname;

  if (search && search !== '?') path += search;

  if (hash) path += hash;

  return path;
};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(51),
    isObject = __webpack_require__(43);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(533),
    baseKeys = __webpack_require__(541),
    isArrayLike = __webpack_require__(83);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var moment = __webpack_require__(13);
var momentValidationWrapper = __webpack_require__(1540);
var core = __webpack_require__(1539);

module.exports = {

  momentObj : core.createMomentChecker(
    'object',
    function(obj) {
      return typeof obj === 'object';
    },
    function isValid(value) {
      return momentValidationWrapper.isValidMoment(value);
    },
    'Moment'
  ),

  momentString : core.createMomentChecker(
    'string',
    function(str) {
      return typeof str === 'string';
    },
    function isValid(value) {
      return momentValidationWrapper.isValidMoment(moment(value));
    },
    'Moment'
  ),

  momentDurationObj : core.createMomentChecker(
    'object',
    function(obj) {
      return typeof obj === 'object';
    },
    function isValid(value) {
      return moment.isDuration(value);
    },
    'Duration'
  ),

};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.isReactChildren = isReactChildren;
exports.createRouteFromReactElement = createRouteFromReactElement;
exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
exports.createRoutes = createRoutes;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isValidChild(object) {
  return object == null || _react2.default.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  _react2.default.Children.forEach(children, function (element) {
    if (_react2.default.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;

var _warning = __webpack_require__(107);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
  var _parsePath = parsePath(path),
      pathname = _parsePath.pathname,
      search = _parsePath.search,
      hash = _parsePath.hash;

  return createPath({
    pathname: pathname,
    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
    hash: hash
  });
};

var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
  var _parsePath2 = parsePath(path),
      pathname = _parsePath2.pathname,
      search = _parsePath2.search,
      hash = _parsePath2.hash;

  return createPath({
    pathname: pathname,
    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
      return prefix === '?' ? prefix : suffix;
    }),
    hash: hash
  });
};

var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
  var _parsePath3 = parsePath(path),
      search = _parsePath3.search;

  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
  return match && match[1];
};

var extractPath = function extractPath(string) {
  var match = string.match(/^(https?:)?\/\/[^\/]*/);
  return match == null ? string : string.substring(match[0].length);
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  if (location == null || typeof location === 'string') return location;

  var basename = location.basename,
      pathname = location.pathname,
      search = location.search,
      hash = location.hash;

  var path = (basename || '') + pathname;

  if (search && search !== '?') path += search;

  if (hash) path += hash;

  return path;
};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(61);

var _interopRequireWildcard = __webpack_require__(182);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bpfrpt_proptype_VisibleCellRange = exports.bpfrpt_proptype_Alignment = exports.bpfrpt_proptype_OverscanIndicesGetter = exports.bpfrpt_proptype_OverscanIndices = exports.bpfrpt_proptype_OverscanIndicesGetterParams = exports.bpfrpt_proptype_RenderedSection = exports.bpfrpt_proptype_ScrollbarPresenceChange = exports.bpfrpt_proptype_Scroll = exports.bpfrpt_proptype_NoContentRenderer = exports.bpfrpt_proptype_CellSize = exports.bpfrpt_proptype_CellSizeGetter = exports.bpfrpt_proptype_CellRangeRenderer = exports.bpfrpt_proptype_CellRangeRendererParams = exports.bpfrpt_proptype_StyleCache = exports.bpfrpt_proptype_CellCache = exports.bpfrpt_proptype_CellRenderer = exports.bpfrpt_proptype_CellRendererParams = exports.bpfrpt_proptype_CellPosition = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _ScalingCellSizeAndPositionManager = _interopRequireDefault(__webpack_require__(412));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var bpfrpt_proptype_CellPosition =  true ? null : {
  "columnIndex": _propTypes["default"].number.isRequired,
  "rowIndex": _propTypes["default"].number.isRequired
};
exports.bpfrpt_proptype_CellPosition = bpfrpt_proptype_CellPosition;
var bpfrpt_proptype_CellRendererParams =  true ? null : {
  "columnIndex": _propTypes["default"].number.isRequired,
  "isScrolling": _propTypes["default"].bool.isRequired,
  "isVisible": _propTypes["default"].bool.isRequired,
  "key": _propTypes["default"].string.isRequired,
  "parent": _propTypes["default"].object.isRequired,
  "rowIndex": _propTypes["default"].number.isRequired,
  "style": _propTypes["default"].object.isRequired
};
exports.bpfrpt_proptype_CellRendererParams = bpfrpt_proptype_CellRendererParams;
var bpfrpt_proptype_CellRenderer =  true ? null : _propTypes["default"].func;
exports.bpfrpt_proptype_CellRenderer = bpfrpt_proptype_CellRenderer;
var bpfrpt_proptype_CellCache =  true ? null : _propTypes["default"].objectOf(_propTypes["default"].node.isRequired);
exports.bpfrpt_proptype_CellCache = bpfrpt_proptype_CellCache;
var bpfrpt_proptype_StyleCache =  true ? null : _propTypes["default"].objectOf(_propTypes["default"].object.isRequired);
exports.bpfrpt_proptype_StyleCache = bpfrpt_proptype_StyleCache;
var bpfrpt_proptype_CellRangeRendererParams =  true ? null : {
  "cellCache": _propTypes["default"].objectOf(_propTypes["default"].node.isRequired).isRequired,
  "cellRenderer": _propTypes["default"].func.isRequired,
  "columnSizeAndPositionManager": function columnSizeAndPositionManager() {
    return (typeof _ScalingCellSizeAndPositionManager["default"] === "function" ? _propTypes["default"].instanceOf(_ScalingCellSizeAndPositionManager["default"]).isRequired : _propTypes["default"].any.isRequired).apply(this, arguments);
  },
  "columnStartIndex": _propTypes["default"].number.isRequired,
  "columnStopIndex": _propTypes["default"].number.isRequired,
  "deferredMeasurementCache": _propTypes["default"].object,
  "horizontalOffsetAdjustment": _propTypes["default"].number.isRequired,
  "isScrolling": _propTypes["default"].bool.isRequired,
  "isScrollingOptOut": _propTypes["default"].bool.isRequired,
  "parent": _propTypes["default"].object.isRequired,
  "rowSizeAndPositionManager": function rowSizeAndPositionManager() {
    return (typeof _ScalingCellSizeAndPositionManager["default"] === "function" ? _propTypes["default"].instanceOf(_ScalingCellSizeAndPositionManager["default"]).isRequired : _propTypes["default"].any.isRequired).apply(this, arguments);
  },
  "rowStartIndex": _propTypes["default"].number.isRequired,
  "rowStopIndex": _propTypes["default"].number.isRequired,
  "scrollLeft": _propTypes["default"].number.isRequired,
  "scrollTop": _propTypes["default"].number.isRequired,
  "styleCache": _propTypes["default"].objectOf(_propTypes["default"].object.isRequired).isRequired,
  "verticalOffsetAdjustment": _propTypes["default"].number.isRequired,
  "visibleColumnIndices": _propTypes["default"].object.isRequired,
  "visibleRowIndices": _propTypes["default"].object.isRequired
};
exports.bpfrpt_proptype_CellRangeRendererParams = bpfrpt_proptype_CellRangeRendererParams;
var bpfrpt_proptype_CellRangeRenderer =  true ? null : _propTypes["default"].func;
exports.bpfrpt_proptype_CellRangeRenderer = bpfrpt_proptype_CellRangeRenderer;
var bpfrpt_proptype_CellSizeGetter =  true ? null : _propTypes["default"].func;
exports.bpfrpt_proptype_CellSizeGetter = bpfrpt_proptype_CellSizeGetter;
var bpfrpt_proptype_CellSize =  true ? null : _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].number]);
exports.bpfrpt_proptype_CellSize = bpfrpt_proptype_CellSize;
var bpfrpt_proptype_NoContentRenderer =  true ? null : _propTypes["default"].func;
exports.bpfrpt_proptype_NoContentRenderer = bpfrpt_proptype_NoContentRenderer;
var bpfrpt_proptype_Scroll =  true ? null : {
  "clientHeight": _propTypes["default"].number.isRequired,
  "clientWidth": _propTypes["default"].number.isRequired,
  "scrollHeight": _propTypes["default"].number.isRequired,
  "scrollLeft": _propTypes["default"].number.isRequired,
  "scrollTop": _propTypes["default"].number.isRequired,
  "scrollWidth": _propTypes["default"].number.isRequired
};
exports.bpfrpt_proptype_Scroll = bpfrpt_proptype_Scroll;
var bpfrpt_proptype_ScrollbarPresenceChange =  true ? null : {
  "horizontal": _propTypes["default"].bool.isRequired,
  "vertical": _propTypes["default"].bool.isRequired,
  "size": _propTypes["default"].number.isRequired
};
exports.bpfrpt_proptype_ScrollbarPresenceChange = bpfrpt_proptype_ScrollbarPresenceChange;
var bpfrpt_proptype_RenderedSection =  true ? null : {
  "columnOverscanStartIndex": _propTypes["default"].number.isRequired,
  "columnOverscanStopIndex": _propTypes["default"].number.isRequired,
  "columnStartIndex": _propTypes["default"].number.isRequired,
  "columnStopIndex": _propTypes["default"].number.isRequired,
  "rowOverscanStartIndex": _propTypes["default"].number.isRequired,
  "rowOverscanStopIndex": _propTypes["default"].number.isRequired,
  "rowStartIndex": _propTypes["default"].number.isRequired,
  "rowStopIndex": _propTypes["default"].number.isRequired
};
exports.bpfrpt_proptype_RenderedSection = bpfrpt_proptype_RenderedSection;
var bpfrpt_proptype_OverscanIndicesGetterParams =  true ? null : {
  // One of SCROLL_DIRECTION_HORIZONTAL or SCROLL_DIRECTION_VERTICAL
  "direction": _propTypes["default"].oneOf(["horizontal", "vertical"]).isRequired,
  // One of SCROLL_DIRECTION_BACKWARD or SCROLL_DIRECTION_FORWARD
  "scrollDirection": _propTypes["default"].oneOf([-1, 1]).isRequired,
  // Number of rows or columns in the current axis
  "cellCount": _propTypes["default"].number.isRequired,
  // Maximum number of cells to over-render in either direction
  "overscanCellsCount": _propTypes["default"].number.isRequired,
  // Begin of range of visible cells
  "startIndex": _propTypes["default"].number.isRequired,
  // End of range of visible cells
  "stopIndex": _propTypes["default"].number.isRequired
};
exports.bpfrpt_proptype_OverscanIndicesGetterParams = bpfrpt_proptype_OverscanIndicesGetterParams;
var bpfrpt_proptype_OverscanIndices =  true ? null : {
  "overscanStartIndex": _propTypes["default"].number.isRequired,
  "overscanStopIndex": _propTypes["default"].number.isRequired
};
exports.bpfrpt_proptype_OverscanIndices = bpfrpt_proptype_OverscanIndices;
var bpfrpt_proptype_OverscanIndicesGetter =  true ? null : _propTypes["default"].func;
exports.bpfrpt_proptype_OverscanIndicesGetter = bpfrpt_proptype_OverscanIndicesGetter;
var bpfrpt_proptype_Alignment =  true ? null : _propTypes["default"].oneOf(["auto", "end", "start", "center"]);
exports.bpfrpt_proptype_Alignment = bpfrpt_proptype_Alignment;
var bpfrpt_proptype_VisibleCellRange =  true ? null : {
  "start": _propTypes["default"].number,
  "stop": _propTypes["default"].number
};
exports.bpfrpt_proptype_VisibleCellRange = bpfrpt_proptype_VisibleCellRange;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_config__ = __webpack_require__(10);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 10px;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 8px;\n  align-self: stretch;\n  cursor: pointer;\n\n  ','\n'],['\n  display: flex;\n  padding: 10px;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 8px;\n  align-self: stretch;\n  cursor: pointer;\n\n  ','\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #3e3e3e;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n'],['\n  color: #3e3e3e;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  width: ',' !important;\n  height: ',' !important;\n  position: relative;\n  z-index: 1;\n  cursor: pointer;\n  margin: 0;\n  border: none !important;\n  -webkit-appearance: auto !important;\n\n  &::before {\n    content: \'\';\n    display: block;\n    position: absolute;\n    inset: 0;\n    border-radius: 999px;\n    border: 1px solid #ececec;\n    background: #f9f9f9;\n    z-index: 2;\n  }\n\n  &::after {\n    content: \'\';\n    display: block;\n    position: absolute;\n    width: ',';\n    height: ',';\n    top: ',';\n    left: ',';\n    border-radius: 999px;\n    background: #fff;\n    z-index: 3;\n    display: none;\n    box-sizing: unset;\n  }\n\n  &:checked {\n    &::before {\n      background: ',';\n      border: none;\n    }\n    &::after {\n      display: block;\n    }\n  }\n'],['\n  display: block;\n  width: ',' !important;\n  height: ',' !important;\n  position: relative;\n  z-index: 1;\n  cursor: pointer;\n  margin: 0;\n  border: none !important;\n  -webkit-appearance: auto !important;\n\n  &::before {\n    content: \'\';\n    display: block;\n    position: absolute;\n    inset: 0;\n    border-radius: 999px;\n    border: 1px solid #ececec;\n    background: #f9f9f9;\n    z-index: 2;\n  }\n\n  &::after {\n    content: \'\';\n    display: block;\n    position: absolute;\n    width: ',';\n    height: ',';\n    top: ',';\n    left: ',';\n    border-radius: 999px;\n    background: #fff;\n    z-index: 3;\n    display: none;\n    box-sizing: unset;\n  }\n\n  &:checked {\n    &::before {\n      background: ',';\n      border: none;\n    }\n    &::after {\n      display: block;\n    }\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  width: 20px;\n  height: 20px;\n  position: relative;\n  z-index: 1;\n  cursor: pointer;\n\n  &::before {\n    content: \'\';\n    display: block;\n    position: absolute;\n    inset: 0;\n    border: 1px solid #ececec;\n    background: #f9f9f9;\n    z-index: 2;\n  }\n\n  &::after {\n    content: \'\';\n    position: absolute;\n    display: none;\n    top: 2px;\n    left: 7px;\n    z-index: 3;\n    transform: rotate(45deg);\n    height: 10px;\n    width: 5px;\n    border-bottom: 2px solid #fff;\n    border-right: 2px solid #fff;\n    box-sizing: unset;\n  }\n\n  &:checked {\n    &::before {\n      content: \'\';\n      background: ',';\n      border: none;\n    }\n    &::after {\n      display: inline-block;\n    }\n  }\n'],['\n  display: block;\n  width: 20px;\n  height: 20px;\n  position: relative;\n  z-index: 1;\n  cursor: pointer;\n\n  &::before {\n    content: \'\';\n    display: block;\n    position: absolute;\n    inset: 0;\n    border: 1px solid #ececec;\n    background: #f9f9f9;\n    z-index: 2;\n  }\n\n  &::after {\n    content: \'\';\n    position: absolute;\n    display: none;\n    top: 2px;\n    left: 7px;\n    z-index: 3;\n    transform: rotate(45deg);\n    height: 10px;\n    width: 5px;\n    border-bottom: 2px solid #fff;\n    border-right: 2px solid #fff;\n    box-sizing: unset;\n  }\n\n  &:checked {\n    &::before {\n      content: \'\';\n      background: ',';\n      border: none;\n    }\n    &::after {\n      display: inline-block;\n    }\n  }\n']);var GhostRadioV2=function GhostRadioV2(_ref){var label=_ref.label,name=_ref.name,selected=_ref.selected,onClick=_ref.onClick,value=_ref.value,type=_ref.type,small=_ref.small,labelStyles=_ref.labelStyles,hasBorder=_ref.hasBorder,props=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref,['label','name','selected','onClick','value','type','small','labelStyles','hasBorder']);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Wrapper,{onClick:onClick,hasBorder:hasBorder,className:selected&&'selected'},type==='radio'?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Input,Object.assign({bgColor:__WEBPACK_IMPORTED_MODULE_4_config__["c" /* backgroundColors */].normalLeft,border:true,id:'opt-'+value+'-'+name,name:name,checked:selected,onChange:onClick,type:type,small:small},props)):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(InputCheck,Object.assign({bgColor:__WEBPACK_IMPORTED_MODULE_4_config__["c" /* backgroundColors */].normalLeft,border:true,id:'opt-'+value+'-'+name,name:name,checked:selected,type:type,small:small},props)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Title,{style:labelStyles},label));};/* harmony default export */ __webpack_exports__["a"] = (GhostRadioV2);var Wrapper=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject,function(_ref2){var hasBorder=_ref2.hasBorder;return hasBorder&&'\n    border-bottom: 1px solid #ECECEC;\n  ';});var Title=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].span(_templateObject2);var Input=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].input.attrs({type:'radio'})(_templateObject3,function(_ref3){var small=_ref3.small;return small?'16px':'20px';},function(_ref4){var small=_ref4.small;return small?'16px':'20px';},function(_ref5){var small=_ref5.small;return small?'8px':'10px';},function(_ref6){var small=_ref6.small;return small?'8px':'10px';},function(_ref7){var small=_ref7.small;return small?'4px':'5px';},function(_ref8){var small=_ref8.small;return small?'4px':'5px';},function(_ref9){var bgColor=_ref9.bgColor;return bgColor;});var InputCheck=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].input.attrs({type:'checkbox'})(_templateObject4,function(_ref10){var bgColor=_ref10.bgColor;return bgColor;});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_tooltip__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Svg_informacao_svg__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Svg_informacao_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_Svg_informacao_svg__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 22px;\n  position: absolute;\n  top: 4px;\n  margin-left: 8px;\n'],['\n  width: 22px;\n  position: absolute;\n  top: 4px;\n  margin-left: 8px;\n']);/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_rc_tooltip__["a" /* default */],{placement:'right',trigger:['hover'],overlay:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,props.text&&props.text.split('\n').map(function(item,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:index},item);}))},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Image,{src:__WEBPACK_IMPORTED_MODULE_4_components_Svg_informacao_svg___default.a,alt:'Informa\xE7\xE3o'}));});var Image=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].img(_templateObject);

/***/ }),
/* 110 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(88);
var createDesc = __webpack_require__(190);
module.exports = __webpack_require__(76) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(28)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(64)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(17);
var dPs = __webpack_require__(497);
var enumBugKeys = __webpack_require__(327);
var IE_PROTO = __webpack_require__(338)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(326)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(329).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(499);
var hiddenKeys = __webpack_require__(327).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(63);
var toObject = __webpack_require__(46);
var IE_PROTO = __webpack_require__(338)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(499);
var enumBugKeys = __webpack_require__(327);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(82);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 120 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(36);

var _invariant2 = _interopRequireDefault(_invariant);

var _PathUtils = __webpack_require__(100);

var _Actions = __webpack_require__(252);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQuery = exports.createQuery = function createQuery(props) {
  return _extends(Object.create(null), props);
};

var createLocation = exports.createLocation = function createLocation() {
  var input = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;

  var pathname = object.pathname || '/';
  var search = object.search || '';
  var hash = object.hash || '';
  var state = object.state;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
};

var isDate = function isDate(object) {
  return Object.prototype.toString.call(object) === '[object Date]';
};

var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
  if (a === b) return true;

  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (typeofA !== typeofB) return false;

  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;

  // Not the same object, but same type.
  if (typeofA === 'object') {
    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;

    if (!Array.isArray(a)) return Object.keys(a).every(function (key) {
      return statesAreEqual(a[key], b[key]);
    });

    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return statesAreEqual(item, b[index]);
    });
  }

  // All other serializable types (string, number, boolean)
  // should be strict equal.
  return false;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.key === b.key &&
  // a.action === b.action && // Different action !== location change.
  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(66);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 124 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(540),
    getValue = __webpack_require__(1340);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1273),
    Map = __webpack_require__(358),
    Promise = __webpack_require__(1275),
    Set = __webpack_require__(529),
    WeakMap = __webpack_require__(1276),
    baseGetTag = __webpack_require__(51),
    toSource = __webpack_require__(567);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(258);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _propTypes2['default'].oneOf(_constants.WEEKDAYS);

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(22);

var invariant = __webpack_require__(12);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_middleware__ = __webpack_require__(1606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_runSaga__ = __webpack_require__(679);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "runSaga", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_runSaga__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_channel__ = __webpack_require__(177);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "END", function() { return __WEBPACK_IMPORTED_MODULE_2__internal_channel__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "eventChannel", function() { return __WEBPACK_IMPORTED_MODULE_2__internal_channel__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "channel", function() { return __WEBPACK_IMPORTED_MODULE_2__internal_channel__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_buffers__ = __webpack_require__(279);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "buffers", function() { return __WEBPACK_IMPORTED_MODULE_3__internal_buffers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__ = __webpack_require__(680);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takeEvery", function() { return __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "takeLatest", function() { return __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_utils__ = __webpack_require__(67);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "delay", function() { return __WEBPACK_IMPORTED_MODULE_5__internal_utils__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CANCEL", function() { return __WEBPACK_IMPORTED_MODULE_5__internal_utils__["q"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__effects__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(1610);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "effects", function() { return __WEBPACK_IMPORTED_MODULE_6__effects__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "utils", function() { return __WEBPACK_IMPORTED_MODULE_7__utils__; });

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__internal_middleware__["a" /* default */]);












/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcArrowComponent (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"simuladores/icons/ic-arrow"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Simulador-Avancado---Desktop","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"simul_avancado_resultados_desktop","transform":"translate(-1272.000000, -974.000000)","fillRule":"nonzero","fill":"#BABABA"},React.createElement("g",{"id":"section-tarifarios","transform":"translate(0.000000, 544.000000)"},React.createElement("g",{"id":"content","transform":"translate(130.000000, 80.000000)"},React.createElement("g",{"transform":"translate(0.000000, 330.000000)","id":"order"},React.createElement("g",{"transform":"translate(858.000000, 0.000000)"},React.createElement("g",{"id":"content","transform":"translate(16.000000, 14.000000)"},React.createElement("path",{"d":"M270.219162,6.33680126 C269.668786,5.84757811 268.826024,5.89715232 268.336801,6.44752836 C267.847578,6.99790441 267.897152,7.84066607 268.447528,8.32988921 L273.114187,13.663213 C273.619367,14.1122623 274.38064,14.1122623 274.88582,13.663213 L279.552479,8.32988921 C280.102855,7.84066607 280.152429,6.99790441 279.663206,6.44752836 C279.173983,5.89715232 278.331221,5.84757811 277.780845,6.33680126 L274.000004,10.8827323 L270.219162,6.33680126 Z","id":"simuladores/icons/ic-arrow"}))))))))]);
}

IcArrowComponent.defaultProps = {"width":"12px","height":"8px","viewBox":"0 0 12 8","version":"1.1"};

module.exports = IcArrowComponent;

IcArrowComponent.default = IcArrowComponent;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(21);

var ReactCurrentOwner = __webpack_require__(423);

var warning = __webpack_require__(14);
var canDefineProperty = __webpack_require__(426);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(424);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FixedContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
var _templateObject=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_taggedTemplateLiteral___default()([''],['']);var Container=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div.attrs({className:'fixed-container'})(_templateObject);var FixedContainer=function(_Component){__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(FixedContainer,_Component);function FixedContainer(){__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this,FixedContainer);return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this,(FixedContainer.__proto__||Object.getPrototypeOf(FixedContainer)).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(FixedContainer,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Container,null,this.props.children);}}]);return FixedContainer;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display:block;\n  font-family: \'Nunito\', \'Helvetica Neue\', sans-serif;\n  text-transform: uppercase;\n  ','\n  ','\n  ','\n  ','\n  ','\n'],['\n  display:block;\n  font-family: \'Nunito\', \'Helvetica Neue\', sans-serif;\n  text-transform: uppercase;\n  ','\n  ','\n  ','\n  ','\n  ','\n']);var Label=function Label(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledLabel,props,props.children);};/* harmony default export */ __webpack_exports__["a"] = (Label);var StyledLabel=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].label(_templateObject,function(_ref){var color=_ref.color;return color?'color: '+color+';':'color: #010101;';},function(_ref2){var fontSize=_ref2.fontSize;return fontSize?'font-size: '+fontSize+';':'font-size: 12px;';},function(_ref3){var fontWeight=_ref3.fontWeight;return fontWeight?'font-weight: '+fontWeight+';':'font-weight: bold;';},function(_ref4){var lineHeight=_ref4.lineHeight;return lineHeight?'line-height: '+lineHeight+';':'line-height: 12px;';},function(_ref5){var align=_ref5.align;return align?'text-align: '+align+';':'text-align: center;';});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MobileModalV2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_ic_close_component_svg__ = __webpack_require__(1625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_ic_close_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_ic_close_component_svg__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background-color: #25272ca3;\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n'],['\n  background-color: #25272ca3;\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100dvw;\n  height: 100dvh;\n  background: #fff;\n\n  position: absolute;\n  top: 0;\n  max-height: 800px;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100dvw;\n  height: 100dvh;\n  background: #fff;\n\n  position: absolute;\n  top: 0;\n  max-height: 800px;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 12px 20px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  align-self: stretch;\n\n  ','\n\n  > .logo {\n    width: 30px;\n    height: 30px;\n    object-fit: contain;\n  }\n\n  h1 {\n    color: #010101;\n    font-family: Nunito;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 28px; /* 140% */\n    text-transform: uppercase;\n    margin: 0;\n    flex: 1 0 0;\n  }\n\n  span {\n    cursor: pointer;\n  }\n'],['\n  display: flex;\n  padding: 12px 20px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  align-self: stretch;\n\n  ','\n\n  > .logo {\n    width: 30px;\n    height: 30px;\n    object-fit: contain;\n  }\n\n  h1 {\n    color: #010101;\n    font-family: Nunito;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 28px; /* 140% */\n    text-transform: uppercase;\n    margin: 0;\n    flex: 1 0 0;\n  }\n\n  span {\n    cursor: pointer;\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 14px;\n  flex: 1 0 0;\n\n  ','\n'],['\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 14px;\n  flex: 1 0 0;\n\n  ','\n']);var MobileModalV2=function(_Component){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(MobileModalV2,_Component);function MobileModalV2(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,MobileModalV2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=MobileModalV2.__proto__||Object.getPrototypeOf(MobileModalV2)).call.apply(_ref,[this].concat(args))),_this),_this.sendModalHide=function(){var modalTriggerHeight=_this.props.modalTriggerHeight;window.parent.postMessage({type:'sendModalMobileHide',height:modalTriggerHeight},'*');},_this.sendModalOpen=function(){window.parent.postMessage({type:'sendModalMobileOpen',payload:true},'*');},_temp),__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(MobileModalV2,[{key:'componentDidMount',value:function componentDidMount(){this.sendModalOpen();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.sendModalHide();this.props.setModalTriggerHeight(null);}},{key:'render',value:function render(){var _props=this.props,title=_props.title,onClose=_props.onClose,children=_props.children,border=_props.border,logo=_props.logo,scrollable=_props.scrollable,restProps=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props,['title','onClose','children','border','logo','scrollable']);return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WrapperBg,{onMouseDown:onClose},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Wrapper,Object.assign({},restProps,{onMouseDown:function onMouseDown(e){return e.stopPropagation();}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TitleRow,{border:border},logo&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img',{className:'logo',src:logo,alt:title}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h1',null,title),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__images_ic_close_component_svg___default.a,{onClick:onClose}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Content,{scrollable:true},children)));}}]);return MobileModalV2;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);var WrapperBg=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject);var Wrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject2);var TitleRow=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject3,function(_ref2){var border=_ref2.border;return border&&'border-bottom: 1px solid #ECECEC;';});var Content=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject4,function(_ref3){var scrollable=_ref3.scrollable;return scrollable&&'\n    overflow: scroll;\n  ';});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TooltipV2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: relative;\n  width: fit-content;\n'],['\n  position: relative;\n  width: fit-content;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  cursor: pointer;\n'],['\n  cursor: pointer;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 8px;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  border-radius: 4px;\n  background: #1d1e22;\n  position: absolute;\n  box-sizing: border-box;\n  display: ',';\n  z-index: 10;\n\n  &::before {\n    content: \'\';\n    position: absolute;\n    width: 10px;\n    aspect-ratio: 1;\n    border-radius: 2px;\n    background-color: #1d1e22;\n\n    ','\n  }\n'],['\n  display: flex;\n  padding: 8px;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  border-radius: 4px;\n  background: #1d1e22;\n  position: absolute;\n  box-sizing: border-box;\n  display: ',';\n  z-index: 10;\n\n  &::before {\n    content: \'\';\n    position: absolute;\n    width: 10px;\n    aspect-ratio: 1;\n    border-radius: 2px;\n    background-color: #1d1e22;\n\n    ','\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 2px;\n  flex: 1 0 0;\n'],['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 2px;\n  flex: 1 0 0;\n']);var TooltipV2=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TooltipV2,_Component);function TooltipV2(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,TooltipV2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=TooltipV2.__proto__||Object.getPrototypeOf(TooltipV2)).call.apply(_ref,[this].concat(args))),_this),_this.state={showTooltip:false},_temp),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TooltipV2,[{key:'render',value:function render(){var _this2=this;var _props=this.props,className=_props.className,children=_props.children,content=_props.content,arrowLocation=_props.arrowLocation,style=_props.style,contentStyle=_props.contentStyle,dialogStyle=_props.dialogStyle;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Container,{className:className,style:style},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Toggle,{onMouseOver:function onMouseOver(){return _this2.setState({showTooltip:true});},onMouseOut:function onMouseOut(){return _this2.setState({showTooltip:false});}},children),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Dialog,{show:this.state.showTooltip,arrowLocation:arrowLocation,style:dialogStyle},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Content,{style:contentStyle},content)));}}]);return TooltipV2;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);var Container=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject);var Toggle=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject2);var Dialog=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject3,function(_ref2){var show=_ref2.show;return show?'flex':'none';},function(_ref3){var arrowLocation=_ref3.arrowLocation;return arrowLocation==='topLeft'&&'\n      top: -4px;\n      left: 5px;\n      transform: rotate(45deg);\n    ';});var Content=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject4);

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Form; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ubiwherenpm_adene_ui_components__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Loading__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Error__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_containers_Navbar__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_validations__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_mapValues__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_isFunction__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_first__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_first___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_first__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_last__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_isEmpty__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_isObject__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_isEqual__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash_isEqual__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-evenly;\n  align-items: stretch;\n  align-content: center;\n'],['\n  display: flex;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-evenly;\n  align-items: stretch;\n  align-content: center;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background: ',';\n  border: none;\n  font-size: 20px;\n  letter-spacing: 1px;\n  line-height: 20px;\n  padding-top: 30px;\n  padding-bottom: 30px;\n  color: #FFFFFF;\n  font-family: \'Nunito\', \'Helvetica Neue\', sans-serif;\n\n  font-weight: bold;\n  transition: all 0.3s ease-in-out;\n  border-radius: 0px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  order: 1;\n  flex-grow: 1;\n  flex-basis: 50%;\n\n  > strong {\n    margin: 0 10px;\n  }\n\n  > span {\n    margin: 0;\n    height: 12px;\n    width: 12px;\n    margin-top: -2px;\n    transition: all 0.2s ease-in-out;\n  }\n\n  &:first-child {\n    margin-right: 1px;\n  }\n\n  &:hover {\n    color: #FFFFFF;\n\n    ','\n    background: ',';\n\n    > span {\n      ','\n    }\n  }\n\n  @media screen and (max-width: 468px) {\n    font-size: 16px;\n  }\n'],['\n  background: ',';\n  border: none;\n  font-size: 20px;\n  letter-spacing: 1px;\n  line-height: 20px;\n  padding-top: 30px;\n  padding-bottom: 30px;\n  color: #FFFFFF;\n  font-family: \'Nunito\', \'Helvetica Neue\', sans-serif;\n\n  font-weight: bold;\n  transition: all 0.3s ease-in-out;\n  border-radius: 0px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  order: 1;\n  flex-grow: 1;\n  flex-basis: 50%;\n\n  > strong {\n    margin: 0 10px;\n  }\n\n  > span {\n    margin: 0;\n    height: 12px;\n    width: 12px;\n    margin-top: -2px;\n    transition: all 0.2s ease-in-out;\n  }\n\n  &:first-child {\n    margin-right: 1px;\n  }\n\n  &:hover {\n    color: #FFFFFF;\n\n    ','\n    background: ',';\n\n    > span {\n      ','\n    }\n  }\n\n  @media screen and (max-width: 468px) {\n    font-size: 16px;\n  }\n']);var Form=function(_Component){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Form,_Component);function Form(){__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,Form);return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(Form.__proto__||Object.getPrototypeOf(Form)).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Form,[{key:'isFormValid',/**
   * Validates form fields based on flowfields sent
   * by props
   */value:function isFormValid(){var _props=this.props,values=_props.values,fields=_props.fields;var invalid={};__WEBPACK_IMPORTED_MODULE_13_lodash_mapValues___default()(fields,function(validations,key){var multiple=key.indexOf(',')!==-1;var fields=[values[key]];// Multiple params validation
if(multiple){var valueNames=key.split(',');fields=valueNames.map(function(name){return values[name];});}var validatorNameInAsValues=false;var shouldDoTheRest=true;var firstValidation=__WEBPACK_IMPORTED_MODULE_15_lodash_first___default()(validations);__WEBPACK_IMPORTED_MODULE_13_lodash_mapValues___default()(values,function(value,key){if(firstValidation===key){validatorNameInAsValues=__WEBPACK_IMPORTED_MODULE_12_validations__["c" /* default */][firstValidation];}});// Only passs if value in Values
if(validatorNameInAsValues!==false){if(!validatorNameInAsValues(values)){shouldDoTheRest=false;}else{validations.shift();}}// Ignore all if validation matches
if(firstValidation&&firstValidation.indexOf('ignoreIf')!==-1){var validation=__WEBPACK_IMPORTED_MODULE_16_lodash_last___default()(firstValidation.split('.'));if(__WEBPACK_IMPORTED_MODULE_12_validations__["c" /* default */][validation](values)){shouldDoTheRest=false;}}if(shouldDoTheRest){for(var index=0;index<validations.length;index++){var _validation=validations[index];var validator=__WEBPACK_IMPORTED_MODULE_12_validations__["c" /* default */][_validation];if(__WEBPACK_IMPORTED_MODULE_14_lodash_isFunction___default()(validator)){var validationResult=validator.apply(undefined,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(fields).concat([values]));if(__WEBPACK_IMPORTED_MODULE_18_lodash_isObject___default()(validationResult)){if(validationResult.flag){invalid[key]=validationResult;break;}}else{if(validationResult){invalid[key]=_validation;break;}}}}}});return{valid:__WEBPACK_IMPORTED_MODULE_17_lodash_isEmpty___default()(invalid),invalid:invalid};}/**
   * Stuff to do on first mount
   */},{key:'componentDidMount',value:function componentDidMount(){}// // Scrols to top on component mount
// setTimeout(() => {
//   const element = document.getElementById('anchor')
//   if (element) {
//     element.scroll({ top: 0, behavior: 'smooth' })
//   }
// }, 100)
/**
   * Refresh invalids
   */},{key:'componentDidUpdate',value:function componentDidUpdate(){var currentInvalid=this.props.invalid;var setInvalid=this.actions.setInvalid;// Update invalids on changes
if(!__WEBPACK_IMPORTED_MODULE_17_lodash_isEmpty___default()(currentInvalid)){var _isFormValid=this.isFormValid(),valid=_isFormValid.valid,invalid=_isFormValid.invalid;if(!__WEBPACK_IMPORTED_MODULE_20_lodash_isEqual___default()(currentInvalid,invalid)){if(valid){setInvalid({});}else{setInvalid(invalid);}}}}/**
   * Renderes the navbar
   */},{key:'renderNavbar',value:function renderNavbar(){var router=this.props.router;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_containers_Navbar__["a" /* default */],{router:router,id:'navbar-simulator'});}/**
   * Renders the top info
   */},{key:'renderTop',value:function renderTop(){var _props2=this.props,loading=_props2.loading,error=_props2.error;if(loading){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Loading__["a" /* default */],null);}if(error){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Error__["a" /* default */],null);}}/**
   * Renders the buttons
   */},{key:'renderButtons',value:function renderButtons(){var _this2=this;var isLoading=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ButtonWrapper,{id:'buttons-simulator'},this.prev&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledButton,{bgNormalColor:__WEBPACK_IMPORTED_MODULE_19_config__["c" /* backgroundColors */].normalRight,bgOverColor:__WEBPACK_IMPORTED_MODULE_19_config__["c" /* backgroundColors */].overRightRight,arrowLeft:true,left:true,reverse:true,strokeColor:'#FFFFFF',onClick:function onClick(){return _this2.prev();}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong',null,this.prevText)),this.next&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledButton,{bgNormalColor:__WEBPACK_IMPORTED_MODULE_19_config__["c" /* backgroundColors */].normalLeft,bgOverColor:__WEBPACK_IMPORTED_MODULE_19_config__["c" /* backgroundColors */].overLeftLeft,arrowRight:true,disabled:isLoading,right:true,strokeColor:'#FFFFFF',onClick:function onClick(){if(!isLoading){_this2.next();}}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong',null,this.nextText)));}}]);return Form;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);var ButtonWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject);var StyledButton=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_8__ubiwherenpm_adene_ui_components__["c" /* SimpleArrowButton */])(_templateObject2,function(_ref){var bgNormalColor=_ref.bgNormalColor;return bgNormalColor;},function(_ref2){var right=_ref2.right,bgOverColor=_ref2.bgOverColor;return right?'padding-left: 30px;':'padding-right: 30px;';},function(_ref3){var bgOverColor=_ref3.bgOverColor;return bgOverColor;},function(_ref4){var right=_ref4.right;return right?'margin-right: -10px;':'margin-left: -10px;';});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectMapperClasse", function() { return selectMapperClasse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectFirstClass", function() { return selectFirstClass; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_kea__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_kea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_kea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_validations__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_containers_App_logic__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_pick__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_isEmpty__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_sortBy__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_first__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_first___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_first__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_isArray__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_isArray__);
/** Redux and Kea *//* eslint-disable camelcase */var EQUIPMENT_ENDPOINT=__WEBPACK_IMPORTED_MODULE_4_config__["b" /* API_BASE_URL */]+'/public/simulator/equipment/';var hiddenDivisionsPerOfferType=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({},__WEBPACK_IMPORTED_MODULE_4_config__["l" /* GAS_OFFER_TYPE */],['Garagem']);/**
 * Map simple object to select fcomponent
 * @param {*} param0
 */var selectMapper=function selectMapper(_ref){var id=_ref.id,name=_ref.name,value=_ref.value,item=__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_ref,['id','name','value']);return Object.assign({},item,{label:name,value:id!==undefined?id:value,id:value!==undefined?value:id});};/**
 * Map energy classes to select
 * @param {*} param0
 */var selectMapperClasse=function selectMapperClasse(_ref2){var classe_energetica=_ref2.classe_energetica,id=_ref2.id,item=__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_ref2,['classe_energetica','id']);return Object.assign({label:classe_energetica.name+' '+__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_utils__["l" /* getDatesYear */])(item.start_date,item.end_date),value:id},item,{classe_energetica:classe_energetica,id:id});};// Select the default class or the first if default doesnt exist
var selectDefault=function selectDefault(equipmentconsumption_set){var defaultClass=equipmentconsumption_set.find(function(item){return item.default===true;});return defaultClass||__WEBPACK_IMPORTED_MODULE_15_lodash_first___default()(equipmentconsumption_set);};/**
 * Selects the first classe in claeses
 * @param {*} param0
 */var selectFirstClass=function selectFirstClass(_ref3){var equipmentconsumption_set=_ref3.equipmentconsumption_set,item=__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_ref3,['equipmentconsumption_set']);return Object.assign({},item,{classes:equipmentconsumption_set&&equipmentconsumption_set.map(selectMapperClasse),selectedClass:selectDefault(equipmentconsumption_set)});};var fields={hasSolarSystem:[__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].isUndefined],hasSolarSystemYear:[__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].hasSolarSystem,__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].isUndefined],hasCentralAirConditioning:[__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].isUndefined],centralHeatingOfferType:[__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].hasCentralAirConditioning,__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].isUndefined],centralAirConditioningEquipment:[__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].hasCentralAirConditioning,__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].isUndefined],centralAirConditioningEnergyClass:[__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].hasCentralAirConditioning,__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].isUndefined],carCharging:[]};/* harmony default export */ __webpack_exports__["default"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_kea__["kea"])({path:function path(){return['scenes','habitation'];},actions:function actions(){return{fetchData:function fetchData(limit){return{limit:limit};},setData:function setData(data){return{data:data};},setInvalid:function setInvalid(invalid){return{invalid:invalid};},setDivision:function setDivision(division){return{division:division};},setCurrentTab:function setCurrentTab(index){return{index:index};},setCurrentEquipments:function setCurrentEquipments(equipments){return{equipments:equipments};},setSvg:function setSvg(svg){return{svg:svg};},closeStartModal:function closeStartModal(){return{};},setDataFetchError:function setDataFetchError(fetchDataError){return{fetchDataError:fetchDataError};}};},// VARIABLES
reducers:function reducers(_ref4){var _ref8,_ref12;var actions=_ref4.actions;return{data:[{},__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({},actions.setData,function(state,payload){return Object.assign({},payload.data);})],svg:[null,__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({},actions.setSvg,function(_,payload){return payload.svg;})],currentEquipments:[[],__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({},actions.setCurrentEquipments,function(_,payload){return[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(payload.equipments));})],loading:[true,__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,(_ref8={},__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref8,actions.fetchData,function(){return true;}),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref8,actions.setData,function(){return false;}),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref8,actions.setDataFetchError,function(){return false;}),_ref8)],fields:[fields,__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,{}],invalid:[[],__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.array,__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({},actions.setInvalid,function(_,payload){return[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(payload.invalid));})],currentDivision:[null,__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({},actions.setDivision,function(_,payload){return payload.division;})],currentTab:[0,__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({},actions.setCurrentTab,function(_,payload){return payload.index;})],error:[false,__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.array,(_ref12={},__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref12,actions.fetchData,function(){return false;}),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref12,actions.setData,function(){return false;}),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref12,actions.setDataFetchError,function(_,payload){return payload.fetchDataError;}),_ref12)],showStartModal:[true,__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({},actions.closeStartModal,function(){return false;})],dataChanged:[false,__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({},actions.setValues,function(state,payload){if(payload.municipality||payload.offerType||payload.adults||payload.children||payload.elderly||payload.constructionYear||payload.equipmentUtilizationProfile||payload.electricCar!==undefined||payload.electricCar!==null){return true;}else{return false;}})]};},takeLatest:function takeLatest(_ref15){var _ref16;var actions=_ref15.actions,workers=_ref15.workers;return _ref16={},__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref16,actions.fetchData,workers.fetchData),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref16,actions.setData,workers.fetchSvg),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref16,actions.setDivision,workers.fetchSvg),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref16,actions.setValues,workers.shouldRefreshData),_ref16;},start:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function start(){var _actions,fetchData,setDivision,data,error,dataChanged,_ref17,profileFinished;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function start$(_context){while(1){switch(_context.prev=_context.next){case 0:_actions=this.actions,fetchData=_actions.fetchData,setDivision=_actions.setDivision;_context.next=3;return this.get('data');case 3:data=_context.sent;_context.next=6;return this.get('error');case 6:error=_context.sent;_context.next=9;return this.get('dataChanged');case 9:dataChanged=_context.sent;_context.next=12;return __WEBPACK_IMPORTED_MODULE_11_containers_App_logic__["a" /* default */].get('finished');case 12:_ref17=_context.sent;profileFinished=_ref17.profileFinished;_context.next=16;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setDivision(null));case 16:if(this.props){_context.next=18;break;}return _context.abrupt('return');case 18:if(profileFinished){_context.next=22;break;}this.props.router.push('/');_context.next=25;break;case 22:if(!(__WEBPACK_IMPORTED_MODULE_13_lodash_isEmpty___default()(data)||error||dataChanged)){_context.next=25;break;}_context.next=25;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(fetchData(1));case 25:case'end':return _context.stop();}}},start,this);}),selectors:function selectors(_ref18){var _selectors=_ref18.selectors;return{divisions:[function(){return[_selectors.data];},function(_ref19){var divisions=_ref19.divisions;return divisions;},__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.any],currentOfferType:[function(){return[_selectors.data];},function(_ref20){var currentEquipmentOfferType=_ref20.currentEquipmentOfferType;return currentEquipmentOfferType;},__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.any],divisionsSvgs:[function(){return[_selectors.data];},function(_ref21){var divisionsSvgs=_ref21.divisionsSvgs;return divisionsSvgs;},__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.any],firstDivision:[function(){return[_selectors.data];},function(_ref22){var divisions=_ref22.divisions;return __WEBPACK_IMPORTED_MODULE_15_lodash_first___default()(divisions);},__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.any],currentDivision:[function(){return[_selectors.currentDivision];},function(division){return division;},__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.any]};},workers:{fetchData:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchData(action){var _actions2,setData,setValues,setDataFetchError,values,offerTypeObject,params,adults,children,elderly,response,data,offerTypes,solarSystemYears,centralHeating,houseDivisions,equipment,energyClasses,carChargingFrequencies,carChargingDurations,carChargingPowers,cleanData,suggestedEquipment,carObject,quantitiesLogic,quantities,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,division,_response,_data,cleanedSvg,duplicates,defaultValues;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchData$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_actions2=this.actions,setData=_actions2.setData,setValues=_actions2.setValues,setDataFetchError=_actions2.setDataFetchError;_context2.next=3;return __WEBPACK_IMPORTED_MODULE_11_containers_App_logic__["a" /* default */].get('values');case 3:values=_context2.sent;_context2.next=6;return __WEBPACK_IMPORTED_MODULE_11_containers_App_logic__["a" /* default */].get('offerType');case 6:offerTypeObject=_context2.sent;params=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_utils__["a" /* csObjectToUnderscore */])(__WEBPACK_IMPORTED_MODULE_12_lodash_pick___default()(values,['constructionYear','equipmentUtilizationType','equipmentUtilizationProfile','offerType']));adults=values.adults,children=values.children,elderly=values.elderly;params.habitants=adults+children+elderly||0;_context2.prev=10;_context2.next=13;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_10_axios___default.a.get,EQUIPMENT_ENDPOINT,{params:params});case 13:response=_context2.sent;data=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_utils__["c" /* csObjectFromUnderscore */])(response.data);offerTypes=data.offerTypes,solarSystemYears=data.solarSystemYears,centralHeating=data.centralHeating,houseDivisions=data.houseDivisions,equipment=data.equipment,energyClasses=data.energyClasses,carChargingFrequencies=data.carChargingFrequencies,carChargingDurations=data.carChargingDurations,carChargingPowers=data.carChargingPowers;cleanData={};suggestedEquipment=data.suggestedEquipment;carObject=equipment.find(function(el){return el.name==='Carro Eletrico'&&el['svg_key']==='el-carro';});if(carObject){suggestedEquipment.push(carObject);}cleanData.carChargingFrequencies=carChargingFrequencies.map(selectMapper);cleanData.carChargingDurations=carChargingDurations.map(selectMapper);cleanData.carChargingPowers=carChargingPowers.map(selectMapper);quantitiesLogic=function quantitiesLogic(item){var qtn=item.t1_factor_quantity;if(params.habitants>2){var nr=params.habitants-1;nr=nr>6?6:nr;// haha
qtn=item['t'+nr+'_factor_quantity'];}return qtn||1;};quantities=function quantities(item){return Object.assign({},item,{quantity:quantitiesLogic(item,params.habitants)});};cleanData.equipments=equipment.map(selectFirstClass).map(quantities);cleanData.divisions=__WEBPACK_IMPORTED_MODULE_14_lodash_sortBy___default()(houseDivisions.map(function(division){division.disabled=false;if(hiddenDivisionsPerOfferType[offerTypeObject.slug]){if(hiddenDivisionsPerOfferType[offerTypeObject.slug].indexOf(division.name)!==-1){division.disabled=true;}}return division;}),'order');// Fetch divisions svgs
cleanData.divisionsSvgs={};_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context2.prev=31;_iterator=cleanData.divisions[Symbol.iterator]();case 33:if(_iteratorNormalCompletion=(_step=_iterator.next()).done){_context2.next=44;break;}division=_step.value;_context2.next=37;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_10_axios___default.a.get,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_utils__["f" /* generateMediaUrl */])(division.svg_image));case 37:_response=_context2.sent;_data=_response.data;cleanedSvg=_data.replace('<?xml version="1.0" encoding="UTF-8"?>','');cleanData.divisionsSvgs[division.id]=cleanedSvg;case 41:_iteratorNormalCompletion=true;_context2.next=33;break;case 44:_context2.next=50;break;case 46:_context2.prev=46;_context2.t0=_context2['catch'](31);_didIteratorError=true;_iteratorError=_context2.t0;case 50:_context2.prev=50;_context2.prev=51;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 53:_context2.prev=53;if(!_didIteratorError){_context2.next=56;break;}throw _iteratorError;case 56:return _context2.finish(53);case 57:return _context2.finish(50);case 58:cleanData.offerTypes=__WEBPACK_IMPORTED_MODULE_14_lodash_sortBy___default()(offerTypes.map(selectMapper),'order');cleanData.solarSystemYears=__WEBPACK_IMPORTED_MODULE_14_lodash_sortBy___default()(solarSystemYears.map(selectMapper),'order');cleanData.centralHeatingEquipments=__WEBPACK_IMPORTED_MODULE_14_lodash_sortBy___default()(centralHeating.map(selectMapper).map(selectFirstClass).map(quantities),'order');cleanData.sugestedEquipment=__WEBPACK_IMPORTED_MODULE_14_lodash_sortBy___default()(suggestedEquipment.map(selectFirstClass).map(quantities),'order');// Duplicate equipments for each house division it belongs
// https://gitlab.ubiwhere.com/adene-poupa-energia/adenepe-portal-publico/issues/129
duplicates=[];cleanData.sugestedEquipment=cleanData.sugestedEquipment.map(function(equipment){if(__WEBPACK_IMPORTED_MODULE_16_lodash_isArray___default()(equipment.house_divisions)){equipment.house_divisions.map(function(division,index){if(index){// Ignore the first
// Create a clone so we dont change the current object
// Set the new house division to the clone
// Add element to array
var equipmentClone=Object.assign({},equipment);equipmentClone.house_divisions=division;duplicates.push(equipmentClone);}return division;});// Set array to the first element
equipment.house_divisions=equipment.house_divisions[0];}return equipment;});// Merge duplicates and singles
cleanData.sugestedEquipment=[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(cleanData.sugestedEquipment),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(duplicates));// Duplicate central equipments for each house division it belongs
// https://gitlab.ubiwhere.com/adene-poupa-energia/adenepe-portal-publico/issues/129
duplicates=[];cleanData.centralHeatingEquipments=cleanData.centralHeatingEquipments.map(function(equipment){if(__WEBPACK_IMPORTED_MODULE_16_lodash_isArray___default()(equipment.house_divisions)){equipment.house_divisions.map(function(division,index){if(index){// Ignore the first
// Create a clone so we dont change the current object
// Set the new house division to the clone
// Add element to array
var equipmentClone=Object.assign({},equipment);equipmentClone.house_divisions=division;duplicates.push(equipmentClone);}return division;});// Set array to the first element
equipment.house_divisions=equipment.house_divisions[0];}return equipment;});// Merge duplicates and singles
cleanData.centralHeatingEquipments=[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(cleanData.centralHeatingEquipments),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(duplicates));// Energy classes
cleanData.energyClasses=energyClasses.map(selectMapper).sort(function(a,b){var nameA=a.label.toUpperCase();var nameB=b.label.toUpperCase();if(nameA<nameB){return-1;}if(nameA>nameB){return 1;}return 0;}).sort(function(a,b){var plusA=a.label.substring(1,a.label.length);var plusB=b.label.substring(1,b.label.length);if(plusA>plusB){return-1;}if(plusA<plusB){return 1;}return 0;});// Used to check if we need to refetch data
cleanData.currentEquipmentOfferType=offerTypeObject;// Hide svg elements depending on offerType
if(offerTypeObject.value===3){cleanData.hiddenSvgItems=['el-arca','el-frigorifico','el-maquina-lavar-loica','el-forno','el-tvbox-router','el-televisao','el-microondas','el-maquina-lavar-roupa','el-maquina-secar-roupa','el-candeeiro-teto-cozinha','el-exaustor','el-ar-condicionado','el-candeeiro-pe','el-candeeiro-mesa','el-candeeiro-teto','el-candeeiro-pe','el-coluna','el-computador','el-carro'];}cleanData.defaultChargingDuration=carChargingDurations.find(function(c){return c.default;});cleanData.defaultChargingPower=carChargingPowers.find(function(c){return c.default;});cleanData.defaultChargingFrequency=carChargingFrequencies.find(function(c){return c.default;});if(offerTypeObject.slug===__WEBPACK_IMPORTED_MODULE_4_config__["m" /* ELECTRICITY_OFFER_TYPE */]){cleanData.hiddenSvgItems=[];}defaultValues={equipments:cleanData.sugestedEquipment,hasSolarSystem:false,hasCentralAirConditioning:false,solarSystemYear:1,carCharging:{frequency:cleanData.defaultChargingFrequency.id,duration:cleanData.defaultChargingDuration.value,power:cleanData.defaultChargingPower.value}};_context2.next=78;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setData(Object.assign({},cleanData)));case 78:_context2.next=80;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setValues(defaultValues));case 80:_context2.next=91;break;case 82:_context2.prev=82;_context2.t1=_context2['catch'](10);if(!(_context2.t1.response&&_context2.t1.response.status===404)){_context2.next=88;break;}if(this.props){this.props.router.push('/');}_context2.next=91;break;case 88:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_utils__["m" /* captureSentryException */])(_context2.t1);_context2.next=91;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setDataFetchError(_context2.t1));case 91:case'end':return _context2.stop();}}},fetchData,this,[[10,82],[31,46,50,58],[51,,53,57]]);}),// Request svg
fetchSvg:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchSvg(){var setSvg,currentDivision,response,data,cleanedSvg;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchSvg$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:setSvg=this.actions.setSvg;_context3.next=3;return this.get('currentDivision');case 3:currentDivision=_context3.sent;_context3.prev=4;_context3.next=7;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_10_axios___default.a.get,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_utils__["f" /* generateMediaUrl */])(currentDivision.svg_image));case 7:response=_context3.sent;data=response.data;cleanedSvg=data.replace('<?xml version="1.0" encoding="UTF-8"?>','');_context3.next=12;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setSvg(cleanedSvg));case 12:_context3.next=16;break;case 14:_context3.prev=14;_context3.t0=_context3['catch'](4);case 16:case'end':return _context3.stop();}}},fetchSvg,this,[[4,14]]);}),/**
     * If offer type changes force the equipments to reload
     * Should solve the issue in
     * https://gitlab.ubiwhere.com/adene-poupa-energia/adene-simulador-avancado/issues/69
     * @param {*} action
     */shouldRefreshData:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function shouldRefreshData(action){var _actions3,fetchData,setDivision,_ref23,profileFinished,payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function shouldRefreshData$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_actions3=this.actions,fetchData=_actions3.fetchData,setDivision=_actions3.setDivision;_context4.next=3;return __WEBPACK_IMPORTED_MODULE_11_containers_App_logic__["a" /* default */].get('finished');case 3:_ref23=_context4.sent;profileFinished=_ref23.profileFinished;payload=action.payload;if(!(profileFinished&&payload.offerType)){_context4.next=11;break;}_context4.next=9;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(fetchData(1));case 9:_context4.next=11;return setDivision(null);case 11:case'end':return _context4.stop();}}},shouldRefreshData,this);})},connect:{actions:[__WEBPACK_IMPORTED_MODULE_11_containers_App_logic__["a" /* default */],['setValue','setValues','setFinished']],props:[__WEBPACK_IMPORTED_MODULE_11_containers_App_logic__["a" /* default */],['values','settings','iframed']]}}));

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(230);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 140 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(465);
var defined = __webpack_require__(309);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(57);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(19);
var dP = __webpack_require__(39);
var DESCRIPTORS = __webpack_require__(38);
var SPECIES = __webpack_require__(28)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(39).f;
var has = __webpack_require__(63);
var TAG = __webpack_require__(28)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var defined = __webpack_require__(90);
var fails = __webpack_require__(18);
var spaces = __webpack_require__(342);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./type')} */
module.exports = TypeError;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var undefined;

var $Error = __webpack_require__(1186);
var $EvalError = __webpack_require__(1185);
var $RangeError = __webpack_require__(1187);
var $ReferenceError = __webpack_require__(1188);
var $SyntaxError = __webpack_require__(514);
var $TypeError = __webpack_require__(149);
var $URIError = __webpack_require__(1189);

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(1242)();
var hasProto = __webpack_require__(1241)();

var getProto = Object.getPrototypeOf || (
	hasProto
		? function (x) { return x.__proto__; } // eslint-disable-line no-proto
		: null
);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(351);
var hasOwn = __webpack_require__(1243);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 152 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = isTouchDevice;
function isTouchDevice() {
  return !!(typeof window !== 'undefined' && ('ontouchstart' in window || window.DocumentTouch && typeof document !== 'undefined' && document instanceof window.DocumentTouch)) || !!(typeof navigator !== 'undefined' && (navigator.maxTouchPoints || navigator.msMaxTouchPoints));
}
module.exports = exports['default'];

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(550);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(23),
    isKey = __webpack_require__(370),
    stringToPath = __webpack_require__(1379),
    toString = __webpack_require__(585);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(361),
    baseAssignValue = __webpack_require__(153);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(553);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(218)(module)))

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(162);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 158 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1395);


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1293),
    isObjectLike = __webpack_require__(37);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(66),
    stubFalse = __webpack_require__(581);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(218)(module)))

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(51),
    isObjectLike = __webpack_require__(37);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(1309),
    flatRest = __webpack_require__(552);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _propTypes2['default'].oneOf([_constants.OPEN_DOWN, _constants.OPEN_UP]);

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _propTypes2['default'].oneOf([_constants.HORIZONTAL_ORIENTATION, _constants.VERTICAL_ORIENTATION, _constants.VERTICAL_SCROLLABLE]);

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = isSameDay;

var _moment = __webpack_require__(13);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function isSameDay(a, b) {
  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
  // Compare least significant, most likely to change units first
  // Moment's isSame clones moment inputs and is a tad slow
  return a.date() === b.date() && a.month() === b.month() && a.year() === b.year();
}

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toISODateString;

var _moment = __webpack_require__(13);

var _moment2 = _interopRequireDefault(_moment);

var _toMomentObject = __webpack_require__(168);

var _toMomentObject2 = _interopRequireDefault(_toMomentObject);

var _constants = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function toISODateString(date, currentFormat) {
  var dateObj = _moment2['default'].isMoment(date) ? date : (0, _toMomentObject2['default'])(date, currentFormat);
  if (!dateObj) return null;

  return dateObj.format(_constants.ISO_FORMAT);
}

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toMomentObject;

var _moment = __webpack_require__(13);

var _moment2 = _interopRequireDefault(_moment);

var _constants = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function toMomentObject(dateString, customFormat) {
  var dateFormats = customFormat ? [customFormat, _constants.DISPLAY_FORMAT, _constants.ISO_FORMAT] : [_constants.DISPLAY_FORMAT, _constants.ISO_FORMAT];

  var date = (0, _moment2['default'])(dateString, dateFormats, true);
  return date.isValid() ? date.hour(12) : null;
}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = __webpack_require__(384);
var setInnerHTML = __webpack_require__(274);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(392);
var setTextContent = __webpack_require__(646);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(22);

var invariant = __webpack_require__(12);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactRef = __webpack_require__(1506);
var ReactInstrumentation = __webpack_require__(73);

var warning = __webpack_require__(14);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.compilePattern = compilePattern;
exports.matchPattern = matchPattern;
exports.getParamNames = getParamNames;
exports.getParams = getParams;
exports.formatPattern = formatPattern;

var _invariant = __webpack_require__(36);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern),
      regexpSource = _compilePattern2.regexpSource,
      paramNames = _compilePattern2.paramNames,
      tokens = _compilePattern2.tokens;

  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames,
      paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern),
      tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0,
      parenHistory = [];

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenHistory[parenCount] = '';
      parenCount += 1;
    } else if (token === ')') {
      var parenText = parenHistory.pop();
      parenCount -= 1;

      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;

      if (paramValue == null) {
        if (parenCount) {
          parenHistory[parenCount - 1] = '';

          var curTokenIdx = tokens.indexOf(token);
          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
          var nextParenIdx = -1;

          for (var _i = 0; _i < tokensSubset.length; _i++) {
            if (tokensSubset[_i] == ')') {
              nextParenIdx = _i;
              break;
            }
          }

          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;

          // jump to ending paren
          i = curTokenIdx + nextParenIdx - 1;
        }
      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
    } else {
      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
    }
  }

  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = routerWarning;
exports._resetWarned = _resetWarned;

var _warning = __webpack_require__(107);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(36);

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = __webpack_require__(107);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(105);

var _Actions = __webpack_require__(277);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQuery = exports.createQuery = function createQuery(props) {
  return _extends(Object.create(null), props);
};

var createLocation = exports.createLocation = function createLocation() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;

   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;

  var pathname = object.pathname || '/';
  var search = object.search || '';
  var hash = object.hash || '';
  var state = object.state;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
};

var isDate = function isDate(object) {
  return Object.prototype.toString.call(object) === '[object Date]';
};

var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
  if (a === b) return true;

  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (typeofA !== typeofB) return false;

  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;

  // Not the same object, but same type.
  if (typeofA === 'object') {
    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;

    if (!Array.isArray(a)) {
      var keysofA = Object.keys(a);
      var keysofB = Object.keys(b);
      return keysofA.length === keysofB.length && keysofA.every(function (key) {
        return statesAreEqual(a[key], b[key]);
      });
    }

    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return statesAreEqual(item, b[index]);
    });
  }

  // All other serializable types (string, number, boolean)
  // should be strict equal.
  return false;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.key === b.key &&
  // a.action === b.action && // Different action !== location change.
  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
};

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(21);

var ReactBaseClasses = __webpack_require__(673);
var ReactChildren = __webpack_require__(1596);
var ReactDOMFactories = __webpack_require__(1597);
var ReactElement = __webpack_require__(176);
var ReactPropTypes = __webpack_require__(1598);
var ReactVersion = __webpack_require__(1599);

var createReactClass = __webpack_require__(1600);
var onlyChild = __webpack_require__(1604);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(21);

var ReactCurrentOwner = __webpack_require__(95);

var warning = __webpack_require__(14);
var canDefineProperty = __webpack_require__(677);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(675);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isEnd; });
/* harmony export (immutable) */ __webpack_exports__["f"] = emitter;
/* unused harmony export INVALID_BUFFER */
/* unused harmony export UNDEFINED_INPUT_ERROR */
/* harmony export (immutable) */ __webpack_exports__["c"] = channel;
/* harmony export (immutable) */ __webpack_exports__["b"] = eventChannel;
/* harmony export (immutable) */ __webpack_exports__["d"] = stdChannel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffers__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler__ = __webpack_require__(681);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
var END = { type: CHANNEL_END_TYPE };
var isEnd = function isEnd(a) {
  return a && a.type === CHANNEL_END_TYPE;
};

function emitter() {
  var subscribers = [];

  function subscribe(sub) {
    subscribers.push(sub);
    return function () {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* remove */])(subscribers, sub);
    };
  }

  function emit(item) {
    var arr = subscribers.slice();
    for (var i = 0, len = arr.length; i < len; i++) {
      arr[i](item);
    }
  }

  return {
    subscribe: subscribe,
    emit: emit
  };
}

var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';

if (false) {
  UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
}

function channel() {
  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].fixed();

  var closed = false;
  var takers = [];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].buffer, INVALID_BUFFER);

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["l" /* internalErr */])('Cannot have a closed channel with pending takers');
    }
    if (takers.length && !buffer.isEmpty()) {
      throw __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["l" /* internalErr */])('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    checkForbiddenStates();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(input, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].notUndef, UNDEFINED_INPUT_ERROR);
    if (closed) {
      return;
    }
    if (!takers.length) {
      return buffer.put(input);
    }
    for (var i = 0; i < takers.length; i++) {
      var cb = takers[i];
      if (!cb[__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* MATCH */]] || cb[__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* MATCH */]](input)) {
        takers.splice(i, 1);
        return cb(input);
      }
    }
  }

  function take(cb) {
    checkForbiddenStates();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func, "channel.take's callback must be a function");

    if (closed && buffer.isEmpty()) {
      cb(END);
    } else if (!buffer.isEmpty()) {
      cb(buffer.take());
    } else {
      takers.push(cb);
      cb.cancel = function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* remove */])(takers, cb);
      };
    }
  }

  function flush(cb) {
    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func, "channel.flush' callback must be a function");
    if (closed && buffer.isEmpty()) {
      cb(END);
      return;
    }
    cb(buffer.flush());
  }

  function close() {
    checkForbiddenStates();
    if (!closed) {
      closed = true;
      if (takers.length) {
        var arr = takers;
        takers = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          arr[i](END);
        }
      }
    }
  }

  return {
    take: take,
    put: put,
    flush: flush,
    close: close,
    get __takers__() {
      return takers;
    },
    get __closed__() {
      return closed;
    }
  };
}

function eventChannel(subscribe) {
  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].none();
  var matcher = arguments[2];

  /**
    should be if(typeof matcher !== undefined) instead?
    see PR #273 for a background discussion
  **/
  if (arguments.length > 2) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func, 'Invalid match function passed to eventChannel');
  }

  var chan = channel(buffer);
  var close = function close() {
    if (!chan.__closed__) {
      if (unsubscribe) {
        unsubscribe();
      }
      chan.close();
    }
  };
  var unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      close();
      return;
    }
    if (matcher && !matcher(input)) {
      return;
    }
    chan.put(input);
  });
  if (chan.__closed__) {
    unsubscribe();
  }

  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func(unsubscribe)) {
    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: close
  };
}

function stdChannel(subscribe) {
  var chan = eventChannel(function (cb) {
    return subscribe(function (input) {
      if (input[__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* SAGA_ACTION */]]) {
        cb(input);
        return;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__scheduler__["a" /* asap */])(function () {
        return cb(input);
      });
    });
  });

  return _extends({}, chan, {
    take: function take(cb, matcher) {
      if (arguments.length > 1) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func, "channel.take's matcher argument must be a function");
        cb[__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* MATCH */]] = matcher;
      }
      chan.take(cb);
    }
  });
}

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = take;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return takem; });
/* harmony export (immutable) */ __webpack_exports__["a"] = put;
/* harmony export (immutable) */ __webpack_exports__["i"] = all;
/* harmony export (immutable) */ __webpack_exports__["j"] = race;
/* harmony export (immutable) */ __webpack_exports__["b"] = call;
/* harmony export (immutable) */ __webpack_exports__["k"] = apply;
/* harmony export (immutable) */ __webpack_exports__["l"] = cps;
/* harmony export (immutable) */ __webpack_exports__["e"] = fork;
/* harmony export (immutable) */ __webpack_exports__["m"] = spawn;
/* harmony export (immutable) */ __webpack_exports__["n"] = join;
/* harmony export (immutable) */ __webpack_exports__["f"] = cancel;
/* harmony export (immutable) */ __webpack_exports__["o"] = select;
/* harmony export (immutable) */ __webpack_exports__["c"] = actionChannel;
/* harmony export (immutable) */ __webpack_exports__["p"] = cancelled;
/* harmony export (immutable) */ __webpack_exports__["q"] = flush;
/* harmony export (immutable) */ __webpack_exports__["r"] = getContext;
/* harmony export (immutable) */ __webpack_exports__["s"] = setContext;
/* harmony export (immutable) */ __webpack_exports__["t"] = takeEvery;
/* harmony export (immutable) */ __webpack_exports__["u"] = takeLatest;
/* harmony export (immutable) */ __webpack_exports__["v"] = throttle;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return asEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sagaHelpers__ = __webpack_require__(680);



var IO = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* sym */])('IO');
var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';

var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';

var effect = function effect(type, payload) {
  var _ref;

  return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;
};

function take() {
  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

  if (arguments.length) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(arguments[0], __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].pattern(patternOrChannel)) {
    return effect(TAKE, { pattern: patternOrChannel });
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].channel(patternOrChannel)) {
    return effect(TAKE, { channel: patternOrChannel });
  }
  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
}

take.maybe = function () {
  var eff = take.apply(undefined, arguments);
  eff[TAKE].maybe = true;
  return eff;
};

var takem = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* deprecate */])(take.maybe, /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* updateIncentive */])('takem', 'take.maybe'));

function put(channel, action) {
  if (arguments.length > 1) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].notUndef, 'put(channel, action): argument channel is undefined');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(action, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].notUndef, 'put(channel, action): argument action is undefined');
  } else {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].notUndef, 'put(action): argument action is undefined');
    action = channel;
    channel = null;
  }
  return effect(PUT, { channel: channel, action: action });
}

put.resolve = function () {
  var eff = put.apply(undefined, arguments);
  eff[PUT].resolve = true;
  return eff;
};

put.sync = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* deprecate */])(put.resolve, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* updateIncentive */])('put.sync', 'put.resolve'));

function all(effects) {
  return effect(ALL, effects);
}

function race(effects) {
  return effect(RACE, effects);
}

function getFnCallDesc(meth, fn, args) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].notUndef, meth + ': argument fn is undefined');

  var context = null;
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].array(fn)) {
    var _fn = fn;
    context = _fn[0];
    fn = _fn[1];
  } else if (fn.fn) {
    var _fn2 = fn;
    context = _fn2.context;
    fn = _fn2.fn;
  }
  if (context && __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].string(fn) && __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func(context[fn])) {
    fn = context[fn];
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func, meth + ': argument ' + fn + ' is not a function');

  return { context: context, fn: fn, args: args };
}

function call(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return effect(CALL, getFnCallDesc('call', fn, args));
}

function apply(context, fn) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
}

function cps(fn) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return effect(CPS, getFnCallDesc('cps', fn, args));
}

function fork(fn) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return effect(FORK, getFnCallDesc('fork', fn, args));
}

function spawn(fn) {
  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  var eff = fork.apply(undefined, [fn].concat(args));
  eff[FORK].detached = true;
  return eff;
}

function join() {
  for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    tasks[_key5] = arguments[_key5];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return join(t);
    }));
  }
  var task = tasks[0];
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].notUndef, 'join(task): argument task is undefined');
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  return effect(JOIN, task);
}

function cancel() {
  for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    tasks[_key6] = arguments[_key6];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return cancel(t);
    }));
  }
  var task = tasks[0];
  if (tasks.length === 1) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].notUndef, 'cancel(task): argument task is undefined');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  }
  return effect(CANCEL, task || __WEBPACK_IMPORTED_MODULE_0__utils__["f" /* SELF_CANCELLATION */]);
}

function select(selector) {
  for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    args[_key7 - 1] = arguments[_key7];
  }

  if (arguments.length === 0) {
    selector = __WEBPACK_IMPORTED_MODULE_0__utils__["g" /* ident */];
  } else {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].notUndef, 'select(selector,[...]): argument selector is undefined');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func, 'select(selector,[...]): argument ' + selector + ' is not a function');
  }
  return effect(SELECT, { selector: selector, args: args });
}

/**
  channel(pattern, [buffer])    => creates an event channel for store actions
**/
function actionChannel(pattern, buffer) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(pattern, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
  if (arguments.length > 1) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
  }
  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
}

function cancelled() {
  return effect(CANCELLED, {});
}

function flush(channel) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].channel, 'flush(channel): argument ' + channel + ' is not valid channel');
  return effect(FLUSH, channel);
}

function getContext(prop) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(prop, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].string, 'getContext(prop): argument ' + prop + ' is not a string');
  return effect(GET_CONTEXT, prop);
}

function setContext(props) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].object, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])(null, props));
  return effect(SET_CONTEXT, props);
}

function takeEvery(patternOrChannel, worker) {
  for (var _len8 = arguments.length, args = Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
    args[_key8 - 2] = arguments[_key8];
  }

  return fork.apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["a" /* takeEveryHelper */], patternOrChannel, worker].concat(args));
}

function takeLatest(patternOrChannel, worker) {
  for (var _len9 = arguments.length, args = Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
    args[_key9 - 2] = arguments[_key9];
  }

  return fork.apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["b" /* takeLatestHelper */], patternOrChannel, worker].concat(args));
}

function throttle(ms, pattern, worker) {
  for (var _len10 = arguments.length, args = Array(_len10 > 3 ? _len10 - 3 : 0), _key10 = 3; _key10 < _len10; _key10++) {
    args[_key10 - 3] = arguments[_key10];
  }

  return fork.apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["c" /* throttleHelper */], ms, pattern, worker].concat(args));
}

var createAsEffectType = function createAsEffectType(type) {
  return function (effect) {
    return effect && effect[IO] && effect[type];
  };
};

var asEffect = {
  take: createAsEffectType(TAKE),
  put: createAsEffectType(PUT),
  all: createAsEffectType(ALL),
  race: createAsEffectType(RACE),
  call: createAsEffectType(CALL),
  cps: createAsEffectType(CPS),
  fork: createAsEffectType(FORK),
  join: createAsEffectType(JOIN),
  cancel: createAsEffectType(CANCEL),
  select: createAsEffectType(SELECT),
  actionChannel: createAsEffectType(ACTION_CHANNEL),
  cancelled: createAsEffectType(CANCELLED),
  flush: createAsEffectType(FLUSH),
  getContext: createAsEffectType(GET_CONTEXT),
  setContext: createAsEffectType(SET_CONTEXT)
};

/***/ }),
/* 179 */
/***/ (function(module, exports) {

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(420);
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(420);
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(220)["default"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BigModalV2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_ic_close_component_svg__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_ic_close_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_ic_close_component_svg__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background-color: #25272ca3;\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n'],['\n  background-color: #25272ca3;\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 24px 24px 16px 24px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  width: 700px;\n  height: 700px;\n\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%, 0%);\n  top: ','px;\n\n  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.4);\n  background: #fff;\n'],['\n  display: flex;\n  padding: 24px 24px 16px 24px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  width: 700px;\n  height: 700px;\n\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%, 0%);\n  top: ','px;\n\n  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.4);\n  background: #fff;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n\n  h1 {\n    color: #010101;\n    font-family: Nunito;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 28px; /* 140% */\n    text-transform: uppercase;\n    margin: 0;\n  }\n\n  span {\n    cursor: pointer;\n  }\n'],['\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n\n  h1 {\n    color: #010101;\n    font-family: Nunito;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 28px; /* 140% */\n    text-transform: uppercase;\n    margin: 0;\n  }\n\n  span {\n    cursor: pointer;\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex: 1 0 0;\n  width: 100%;\n'],['\n  display: flex;\n  flex: 1 0 0;\n  width: 100%;\n']);var BigModalV2=function(_Component){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(BigModalV2,_Component);function BigModalV2(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,BigModalV2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=BigModalV2.__proto__||Object.getPrototypeOf(BigModalV2)).call.apply(_ref,[this].concat(args))),_this),_this.state={modalTop:null},_this.calculateModalPosition=function(){if(_this.modalRef){var modalHeight=_this.modalRef.offsetHeight;var viewportHeight=window.innerHeight;var availableSpaceBelow=viewportHeight-_this.props.modalTriggerHeight;var topPosition=_this.props.modalTriggerHeight;if(availableSpaceBelow<modalHeight){var missingSpace=modalHeight-availableSpaceBelow;// Not enough space below, position above the button
topPosition=Math.max(0,_this.props.modalTriggerHeight-missingSpace);}_this.setState({modalTop:topPosition});}},_this.sendModalHide=function(){window.parent.postMessage({type:'sendModalHide',payload:true},'*');},_this.sendModalOpen=function(){window.parent.postMessage({type:'sendModalOpen',height:_this.props.modalTriggerHeight},'*');},_temp),__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(BigModalV2,[{key:'componentDidMount',value:function componentDidMount(){this.calculateModalPosition();this.sendModalOpen();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.sendModalHide();this.props.setModalTriggerHeight(null);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,title=_props.title,onClose=_props.onClose,children=_props.children,restProps=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props,['title','onClose','children']);var modalTop=this.state.modalTop;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WrapperBg,{onMouseDown:onClose},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Wrapper,Object.assign({scrollPosition:modalTop,innerRef:function innerRef(ref){return _this2.modalRef=ref;}},restProps,{onMouseDown:function onMouseDown(e){return e.stopPropagation();}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TitleRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h1',null,title),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__images_ic_close_component_svg___default.a,{onClick:onClose}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Content,null,children)));}}]);return BigModalV2;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);var WrapperBg=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject);var Wrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div.attrs({ref:function ref(props){return props.forwardedRef;}})(_templateObject2,function(_ref2){var scrollPosition=_ref2.scrollPosition;return scrollPosition;});var TitleRow=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject3);var Content=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject4);

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Button__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_PrimaryButton__ = __webpack_require__(185);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: ',';\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n'],['\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: ',';\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(1, 1, 1, 0.5);\n'],['\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(1, 1, 1, 0.5);\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background-image: linear-gradient(270deg, #006736 0%, #93c13e 100%);\n  display: flex;\n  align-items: center;\n  jsutify-content: center;\n'],['\n  background-image: linear-gradient(270deg, #006736 0%, #93c13e 100%);\n  display: flex;\n  align-items: center;\n  jsutify-content: center;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ','\n  background-color: #FFFFFF;\n  box-shadow: -2px 0 20px 0 rgba(0, 0, 0, 0.2);\n  position: relative;\n  top: 64px;\n  display: flex;\n\n  @media screen and (max-width: 768px) {\n    min-width: initial;\n    left: 0;\n    top: 0;\n\n    ',' {\n      display: none;\n    }\n  }\n'],['\n  ','\n  background-color: #FFFFFF;\n  box-shadow: -2px 0 20px 0 rgba(0, 0, 0, 0.2);\n  position: relative;\n  top: 64px;\n  display: flex;\n\n  @media screen and (max-width: 768px) {\n    min-width: initial;\n    left: 0;\n    top: 0;\n\n    ',' {\n      display: none;\n    }\n  }\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 32px;\n  padding-right: 55px;\n  justify-content: space-between;\n'],['\n  display: flex;\n  padding: 32px;\n  padding-right: 55px;\n  justify-content: space-between;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #010101;\n  font-family: Nunito;\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 28px;\n  margin: 0;\n  text-transform: uppercase;\n'],['\n  color: #010101;\n  font-family: Nunito;\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 28px;\n  margin: 0;\n  text-transform: uppercase;\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  border: 1px solid #bababa;\n  width: 24px;\n  height: 24px;\n  display: block;\n  text-align: center;\n  position: absolute;\n  cursor: pointer;\n  right: 32px;\n  top: 32px;\n  z-index: 33;\n\n  &:before {\n    content: \'\u2715\';\n    font-size: 20px;\n    line-height: 24px;\n    color: #bababa;\n    top: 0;\n    position: absolute;\n    left: 0;\n    width: 100%;\n  }\n'],['\n  border: 1px solid #bababa;\n  width: 24px;\n  height: 24px;\n  display: block;\n  text-align: center;\n  position: absolute;\n  cursor: pointer;\n  right: 32px;\n  top: 32px;\n  z-index: 33;\n\n  &:before {\n    content: \'\u2715\';\n    font-size: 20px;\n    line-height: 24px;\n    color: #bababa;\n    top: 0;\n    position: absolute;\n    left: 0;\n    width: 100%;\n  }\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ','\n'],['\n  ','\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 80px;\n  background-color: #efefef;\n  box-shadow: inset 0 1px 0 0 #dedede;\n  width: 100%;\n  padding: 16px;\n  text-align: right;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: flex-end;\n'],['\n  height: 80px;\n  background-color: #efefef;\n  box-shadow: inset 0 1px 0 0 #dedede;\n  width: 100%;\n  padding: 16px;\n  text-align: right;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: flex-end;\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 120px;\n  margin-right: 16px;\n'],['\n  width: 120px;\n  margin-right: 16px;\n']),_templateObject11=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 120px;\n'],['\n  width: 120px;\n']),_templateObject12=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  transition: opacity 0.3s ease-in;\n  opacity: 0;\n  z-index: 1111;\n  position: relative;\n\n  &.show {\n    opacity: 1;\n  }\n'],['\n  transition: opacity 0.3s ease-in;\n  opacity: 0;\n  z-index: 1111;\n  position: relative;\n\n  &.show {\n    opacity: 1;\n  }\n']),_templateObject13=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin-left: 36px;\n'],['\n  margin-left: 36px;\n']);var Modal=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Modal,_Component);function Modal(){__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,Modal);var _this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(Modal.__proto__||Object.getPrototypeOf(Modal)).call(this));_this.state={open:false};return _this;}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Modal,[{key:'componentWillMount',value:function componentWillMount(){document.body.style.overflow='hidden';}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.body.style.overflow='';}},{key:'render',value:function render(){var _this2=this;var _props=this.props,title=_props.title,subtitle=_props.subtitle,custom=_props.custom,buttons=_props.buttons,footer=_props.footer,iframed=_props.iframed,side=_props.side;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Container,{className:this.props.className,iframed:iframed},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Background,{onClick:this.props.closeOnBackground&&this.props.onClick}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(AnimateShow,{className:'show'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ModalCard,{width:this.props.width},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{style:{flex:1}},!custom&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CardHeader,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CardTitle,null,title,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Subtitle,null,subtitle))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Close,{onClick:function onClick(){return _this2.props.onClick(null);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CardBody,{custom:custom},this.props.children),buttons&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CardFooter,null,buttons.map(function(button){return button.primary?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(NextButton,{key:button.label,text:button.label,onClick:button.click}):__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CancelButton,{key:button.label,text:button.label,onClick:button.click,color:button.color});})),footer&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CardFooter,null,footer)),side&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(SideInfo,{style:{width:350}},side()))));}}]);return Modal;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);Modal.defaultProps={toggle:false};var Container=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject,function(_ref){var iframed=_ref.iframed;return iframed?'9999999':'1000';});var Background=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject2);var SideInfo=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject3);var ModalCard=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject4,function(_ref2){var _ref2$width=_ref2.width,width=_ref2$width===undefined?1020:_ref2$width;return'\n    max-width: '+width+'px;\n    min-width: '+width+'px;\n    left: calc(50% - '+width/2+'px);\n  ';},SideInfo);var CardHeader=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].header(_templateObject5);var CardTitle=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].h4(_templateObject6);var Close=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject7);var CardBody=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject8,function(_ref3){var custom=_ref3.custom;return!custom&&'\n    padding: 0 32px;\n  ';});var CardFooter=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].footer(_templateObject9);var CancelButton=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_7_components_Button__["a" /* default */])(_templateObject10);var NextButton=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_8_components_PrimaryButton__["a" /* default */])(_templateObject11);var AnimateShow=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject12);var Subtitle=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject13);/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: relative;\n'],['\n  position: relative;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background: linear-gradient(270deg, #006736 0%, #93c13e 100%);\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  z-index: 1;\n'],['\n  background: linear-gradient(270deg, #006736 0%, #93c13e 100%);\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  z-index: 1;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  text-transform: uppercase;\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 14px;\n  box-sizing: border-box;\n  padding: 17px;\n  width: 100%;\n  transition: all 0.1s ease-in-out;\n  height: 48px;\n  font-family: \'Nunito\';\n  color: #fff;\n  position: relative;\n  z-index: 2;\n\n  &:disabled {\n    background: none;\n    background-color: #ddd;\n    cursor: default;\n  }\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.15);\n  }\n'],['\n  text-transform: uppercase;\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 14px;\n  box-sizing: border-box;\n  padding: 17px;\n  width: 100%;\n  transition: all 0.1s ease-in-out;\n  height: 48px;\n  font-family: \'Nunito\';\n  color: #fff;\n  position: relative;\n  z-index: 2;\n\n  &:disabled {\n    background: none;\n    background-color: #ddd;\n    cursor: default;\n  }\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.15);\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: absolute;\n  width: 75%;\n  height: 8px;\n  top: 40px;\n  box-shadow: 0 2px 15px 0\n    rgba(0, 0, 0, ',');\n  left: 12.5%;\n  transition: all 0.2s ease;\n'],['\n  position: absolute;\n  width: 75%;\n  height: 8px;\n  top: 40px;\n  box-shadow: 0 2px 15px 0\n    rgba(0, 0, 0, ',');\n  left: 12.5%;\n  transition: all 0.2s ease;\n']);var PrimaryButton=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PrimaryButton,_Component);function PrimaryButton(){__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,PrimaryButton);var _this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(PrimaryButton.__proto__||Object.getPrototypeOf(PrimaryButton)).call(this));_this.state={hovered:false};return _this;}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(PrimaryButton,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Container,{className:this.props.className,style:this.props.style},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InnerButton,{onClick:this.props.onClick,onMouseEnter:function onMouseEnter(){return _this2.setState({hovered:true});},onMouseLeave:function onMouseLeave(){return _this2.setState({hovered:false});}},this.props.text),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Overlay,null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Shadow,{hover:this.state.hovered}));}}]);return PrimaryButton;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);var Container=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject);var Overlay=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject2);var InnerButton=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].button(_templateObject3);var Shadow=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject4,function(_ref){var hover=_ref.hover;return hover?'0.5':'0.3';});/* harmony default export */ __webpack_exports__["a"] = (PrimaryButton);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Icon */
/* unused harmony export Wrapper */
/* unused harmony export DefaultSelector */
/* unused harmony export DefaultList */
/* unused harmony export DefaultListOpened */
/* unused harmony export Item */
/* unused harmony export Checkbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_find__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isEqual__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isArray__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_findIndex__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_map__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_remove__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_remove___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_remove__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_onclickoutside__ = __webpack_require__(275);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 35px;\n  height: 35px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 10px;\n'],['\n  width: 35px;\n  height: 35px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 10px;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: relative;\n'],['\n  position: relative;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding: 15px 16px;\n  font-size: 14px;\n  line-height: 18px;\n  font-weight: bold;\n  background-color: #ffffff;\n  color: #9c9c9c;\n  display: flex;\n  align-items: center;\n  background-position: right center;\n  background-repeat: no-repeat;\n  border: 1px solid #efefef;\n  cursor: pointer;\n  position: relative;\n\n  &.selected {\n    color: #3e3e3e;\n    font-weight: bold;\n  }\n\n  &[disabled] {\n    background-color: transparent;\n    border: 0;\n    color: #676767;\n    opacity: 0.5;\n    pointer-events: none;\n  }\n\n  &:focus {\n    border-color: #93c13e;\n  }\n\n  background-position: 16px center;\n  background-repeat: no-repeat;\n  background-size: 16.5px;\n\n  ','\n  ','\n'],['\n  padding: 15px 16px;\n  font-size: 14px;\n  line-height: 18px;\n  font-weight: bold;\n  background-color: #ffffff;\n  color: #9c9c9c;\n  display: flex;\n  align-items: center;\n  background-position: right center;\n  background-repeat: no-repeat;\n  border: 1px solid #efefef;\n  cursor: pointer;\n  position: relative;\n\n  &.selected {\n    color: #3e3e3e;\n    font-weight: bold;\n  }\n\n  &[disabled] {\n    background-color: transparent;\n    border: 0;\n    color: #676767;\n    opacity: 0.5;\n    pointer-events: none;\n  }\n\n  &:focus {\n    border-color: #93c13e;\n  }\n\n  background-position: 16px center;\n  background-repeat: no-repeat;\n  background-size: 16.5px;\n\n  ','\n  ','\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  width: 12px;\n  height: 12px;\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n\n  > svg,\n  path {\n    fill: #616161;\n  }\n\n  ','\n'],['\n  display: block;\n  width: 12px;\n  height: 12px;\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n\n  > svg,\n  path {\n    fill: #616161;\n  }\n\n  ','\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 0;\n  opacity: 0;\n  width: 100%;\n  max-height: 200px;\n  overflow: auto;\n  border: 1px solid #efefef;\n  border-top: 0;\n  border-radius: 0 2px 2px 0;\n  box-shadow: 0 0 0 1px #efefef;\n  transition: all 0.4s ease-in-out;\n  background: #fff;\n  position: absolute;\n  z-index: 99999;\n'],['\n  height: 0;\n  opacity: 0;\n  width: 100%;\n  max-height: 200px;\n  overflow: auto;\n  border: 1px solid #efefef;\n  border-top: 0;\n  border-radius: 0 2px 2px 0;\n  box-shadow: 0 0 0 1px #efefef;\n  transition: all 0.4s ease-in-out;\n  background: #fff;\n  position: absolute;\n  z-index: 99999;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: auto;\n  opacity: 1;\n  transition: all 0.4s ease-in-out;\n'],['\n  height: auto;\n  opacity: 1;\n  transition: all 0.4s ease-in-out;\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding: 10px 15px;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  user-select: none;\n  font-size: 14px;\n  white-space: nowrap;\n\n  &:hover {\n    background-color: #efefef;\n  }\n'],['\n  padding: 10px 15px;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  user-select: none;\n  font-size: 14px;\n  white-space: nowrap;\n\n  &:hover {\n    background-color: #efefef;\n  }\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  border: 1px solid #bababa;\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 10px;\n\n  ','\n'],['\n  border: 1px solid #bababa;\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 10px;\n\n  ','\n']);/**
 * Select component
 */var Select=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Select,_Component);function Select(){__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,Select);var _this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(Select.__proto__||Object.getPrototypeOf(Select)).call(this));_this.state={listOpened:false,selected:null};_this.toggleList=_this.toggleList.bind(_this);_this.setSelectedFromProp=_this.setSelectedFromProp.bind(_this);return _this;}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Select,[{key:'handleClickOutside',value:function handleClickOutside(evt){if(this.state.listOpened){this.setState({listOpened:!this.state.listOpened});}}},{key:'setSelectedFromProp',value:function setSelectedFromProp(prop,first){var _this2=this;if(prop){var selected=void 0;if(__WEBPACK_IMPORTED_MODULE_9_lodash_isArray___default()(prop)){selected=__WEBPACK_IMPORTED_MODULE_11_lodash_map___default()(prop,function(propValue){return __WEBPACK_IMPORTED_MODULE_7_lodash_find___default()(_this2.props.items,function(_ref){var value=_ref.value;return value===propValue;});});}else{selected=__WEBPACK_IMPORTED_MODULE_7_lodash_find___default()(this.props.items,function(_ref2){var value=_ref2.value;return value===prop;});}if(selected){this.setState({selected:selected},function(){if(__WEBPACK_IMPORTED_MODULE_9_lodash_isArray___default()(selected)){_this2.props.onChange&&_this2.props.onChange(_this2.state.selected);}else{_this2.props.onChange&&_this2.props.onChange(Object.assign({},_this2.state.selected,{first:first}));}});}}}},{key:'componentWillMount',value:function componentWillMount(){this.setSelectedFromProp(this.props.selected,true);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.selected){var findItem=__WEBPACK_IMPORTED_MODULE_7_lodash_find___default()(this.props.items,function(_ref3){var value=_ref3.value;return value===nextProps.selected;});if(findItem){if(__WEBPACK_IMPORTED_MODULE_8_lodash_isEqual___default()(this.state.selected,findItem)){return false;}this.setSelectedFromProp(nextProps.selected);}}else{this.setState({selected:null});}}},{key:'toggleList',value:function toggleList(){this.setState({listOpened:!this.state.listOpened});}},{key:'selectItem',value:function selectItem(item){var _this3=this;this.setState({selected:item,listOpened:false},function(){_this3.props.onChange&&_this3.props.onChange(_this3.state.selected);});}},{key:'selectItems',value:function selectItems(item){var _this4=this;var items=this.state.selected||[];var found=__WEBPACK_IMPORTED_MODULE_10_lodash_findIndex___default()(items,function(i){return i.value===item.value;});if(this.props.removedSelectOnSelected){this.props.removedSelectOnSelected.forEach(function(v){return __WEBPACK_IMPORTED_MODULE_12_lodash_remove___default()(items,{value:v});});}if(this.props.excludeAllExceptOnSelect){var isExluder=this.props.excludeAllExceptOnSelect.find(function(it){return it===item.value;});if(isExluder){this.props.excludeAllExceptOnSelect.forEach(function(v){return __WEBPACK_IMPORTED_MODULE_12_lodash_remove___default()(items,function(item){return item.value!==v;});});}}if(found!==-1){items=items.filter(function(item,index){return index!==found;});}else{items.push(item);}this.setState({selected:items},function(){_this4.props.onChange&&_this4.props.onChange(_this4.state.selected);});}},{key:'render',value:function render(){var _this5=this;var _props=this.props,placeholder=_props.placeholder,render=_props.render,Selector=_props.Selector,List=_props.List,className=_props.className,items=_props.items,extraClick=_props.extraClick;var SelectorText=placeholder;// Set default
if(!Selector){Selector=DefaultSelector;}if(!List){List=DefaultList;}if(this.state.listOpened){List=DefaultListOpened;}if(this.state.selected){if(this.state.selected.icon){SelectorText=__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span',null,typeof this.state.selected.icon==='string'?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Icon,{src:this.state.selected.icon,alt:this.state.selected.label}):this.state.selected.icon,this.state.selected.label);}else{SelectorText=this.state.selected.label;}}return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Wrapper,{className:className},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Selector,{onClick:function onClick(){if(!_this5.props.disabled){_this5.toggleList();}if(extraClick){extraClick();}},className:this.state.selected&&'selected',icon:this.props.icon,disabled:this.props.disabled},render?render(SelectorText,placeholder):SelectorText?SelectorText:placeholder,this.props.arrowIcon&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(DropdownArrow,{opened:this.state.listOpened},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(this.props.arrowIcon,{width:12,height:12}))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(List,null,items&&items.map(function(item){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Item,{key:'item-'+item.value+item.label,onClick:function onClick(){return SelectorText?_this5.selectItem(item):_this5.selectItems(item);}},item.icon&&typeof item.icon==='string'?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Icon,{src:item.icon}):item.icon,item.value===(_this5.state.selected&&_this5.state.selected.value)?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',null,item.label,' ',__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span',{className:'itemSelected'},'\u2713')):item.label);})));}}]);return Select;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_react_onclickoutside__["a" /* default */])(Select));var Icon=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].img(_templateObject);var Wrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject2);var DefaultSelector=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject3,function(props){return props.icon?'background-image: url('+props.icon+');':'';},function(props){return props.icon?'padding-left: 40px':'';});var DropdownArrow=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject4,function(props){return props.opened&&'\n    transform: translateY(-50%)rotate(180deg);\n  ';});var DefaultList=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject5);var DefaultListOpened=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(DefaultList)(_templateObject6);var Item=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject7);var Checkbox=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject8,function(props){return props.checked?'\n    &:after {\n      content: "\u2713";\n      color: #93C13E;\n      display: block;\n      width: 18px;\n      font-size: 18px;\n      text-align: center;\n      line-height: 18px;\n    }\n  ':'';});

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(944);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 188 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(1004)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(468)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(89);
var TAG = __webpack_require__(28)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(89);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 194 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(17);
var aFunction = __webpack_require__(77);
var SPECIES = __webpack_require__(28)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/***/ }),
/* 197 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(256),
    arrayEach = __webpack_require__(532),
    assignValue = __webpack_require__(361),
    baseAssign = __webpack_require__(1285),
    baseAssignIn = __webpack_require__(1286),
    cloneBuffer = __webpack_require__(547),
    copyArray = __webpack_require__(366),
    copySymbols = __webpack_require__(1328),
    copySymbolsIn = __webpack_require__(1329),
    getAllKeys = __webpack_require__(554),
    getAllKeysIn = __webpack_require__(555),
    getTag = __webpack_require__(126),
    initCloneArray = __webpack_require__(1347),
    initCloneByTag = __webpack_require__(1348),
    initCloneObject = __webpack_require__(558),
    isArray = __webpack_require__(23),
    isBuffer = __webpack_require__(161),
    isMap = __webpack_require__(572),
    isObject = __webpack_require__(43),
    isSet = __webpack_require__(575),
    keys = __webpack_require__(102),
    keysIn = __webpack_require__(204);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(154),
    toKey = __webpack_require__(157);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 200 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 201 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(51),
    getPrototype = __webpack_require__(368),
    isObjectLike = __webpack_require__(37);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1301),
    baseUnary = __webpack_require__(124),
    nodeUtil = __webpack_require__(156);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(533),
    baseKeysIn = __webpack_require__(1302),
    isArrayLike = __webpack_require__(83);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(197),
    baseIteratee = __webpack_require__(92),
    baseMap = __webpack_require__(542),
    isArray = __webpack_require__(23);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(583);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule shallowCompare
 */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/**
 * Does a shallow comparison for props and state.
 * See ReactComponentWithPureRenderMixin
 * See also https://facebook.github.io/react/docs/shallow-compare.html
 */
function shallowCompare(instance, nextProps, nextState) {
  return (
    !shallowEqual(instance.props, nextProps) ||
    !shallowEqual(instance.state, nextState)
  );
}

module.exports = shallowCompare;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _propTypes2['default'].oneOf([_constants.ICON_BEFORE_POSITION, _constants.ICON_AFTER_POSITION]);

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = isAfterDay;

var _moment = __webpack_require__(13);

var _moment2 = _interopRequireDefault(_moment);

var _isBeforeDay = __webpack_require__(210);

var _isBeforeDay2 = _interopRequireDefault(_isBeforeDay);

var _isSameDay = __webpack_require__(166);

var _isSameDay2 = _interopRequireDefault(_isSameDay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function isAfterDay(a, b) {
  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
  return !(0, _isBeforeDay2['default'])(a, b) && !(0, _isSameDay2['default'])(a, b);
}

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = isBeforeDay;

var _moment = __webpack_require__(13);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function isBeforeDay(a, b) {
  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;

  var aYear = a.year();
  var aMonth = a.month();

  var bYear = b.year();
  var bMonth = b.month();

  var isSameYear = aYear === bYear;
  var isSameMonth = aMonth === bMonth;

  if (isSameYear && isSameMonth) return a.date() < b.date();
  if (isSameYear) return aMonth < bMonth;
  return aYear < bYear;
}

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = isInclusivelyAfterDay;

var _moment = __webpack_require__(13);

var _moment2 = _interopRequireDefault(_moment);

var _isBeforeDay = __webpack_require__(210);

var _isBeforeDay2 = _interopRequireDefault(_isBeforeDay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function isInclusivelyAfterDay(a, b) {
  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
  return !(0, _isBeforeDay2['default'])(a, b);
}

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(22);

var EventPluginRegistry = __webpack_require__(385);
var EventPluginUtils = __webpack_require__(386);
var ReactErrorUtils = __webpack_require__(390);

var accumulateInto = __webpack_require__(639);
var forEachAccumulated = __webpack_require__(640);
var invariant = __webpack_require__(12);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(212);
var EventPluginUtils = __webpack_require__(386);

var accumulateInto = __webpack_require__(639);
var forEachAccumulated = __webpack_require__(640);
var warning = __webpack_require__(14);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(94);

var getEventTarget = __webpack_require__(395);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
exports.falsy = falsy;

var _react = __webpack_require__(0);

var func = _react.PropTypes.func,
    object = _react.PropTypes.object,
    arrayOf = _react.PropTypes.arrayOf,
    oneOfType = _react.PropTypes.oneOfType,
    element = _react.PropTypes.element,
    shape = _react.PropTypes.shape,
    string = _react.PropTypes.string;
function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = exports.history = shape({
  listen: func.isRequired,
  push: func.isRequired,
  replace: func.isRequired,
  go: func.isRequired,
  goBack: func.isRequired,
  goForward: func.isRequired
});

var component = exports.component = oneOfType([func, string]);
var components = exports.components = oneOfType([component, object]);
var route = exports.route = oneOfType([object, element]);
var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 218 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 219 */
/***/ (function(module, exports) {

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 220 */
/***/ (function(module, exports) {

function _typeof(o) {
  "@babel/helpers - typeof";

  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_flexbox_grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_flexbox_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_flexbox_grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(10);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  margin: 14% 0px 12px 0px;\n'],['\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  margin: 14% 0px 12px 0px;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  font-weight: bold;\n  color: ',';\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 14px;\n  margin-bottom: 12px;\n'],['\n  display: block;\n  font-weight: bold;\n  color: ',';\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 14px;\n  margin-bottom: 12px;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n'],['\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin-right: 5px;\n'],['\n  margin-right: 5px;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 13px;\n  color: #676767;\n  margin-bottom: 10px;\n'],['\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 13px;\n  color: #676767;\n  margin-bottom: 10px;\n']);/* Aditional Services List
 * Created on Wed Aug 30 2017
 *
 * Copyright (c) 2017 Ubiwhere
 *
 * Authors:
 * - Hugo Fonseca <hfonseca@ubiwhere.com>
 */var BASE_URL=__WEBPACK_IMPORTED_MODULE_4__config__["e" /* MEDIA_BASE_URL */];var AditionalServices=function AditionalServices(_ref){var list=_ref.list,style=_ref.style;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Wrapper,{style:style},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Label,null,'Condi\xE7\xF5es adicionais'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(List,null,list&&list.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ListItem,{key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AditionalIcon,{src:''+BASE_URL+item.icon,alt:item.name}),item.name);}),!list.length&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ListItem,null,'Sem condi\xE7\xF5es adicionais.')));};/* harmony default export */ __webpack_exports__["a"] = (AditionalServices);var Wrapper=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3_react_flexbox_grid__["Col"])(_templateObject);var Label=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject2,function(props){return props.color||'#3E3E3E';});var List=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].ul(_templateObject3);var AditionalIcon=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].img(_templateObject4);var ListItem=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].li(_templateObject5);

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_outside_click_handler__ = __webpack_require__(1541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_outside_click_handler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_outside_click_handler__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n  position: relative;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n  position: relative;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  height: 32px;\n  padding: 12px 6px;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n\n  cursor: pointer;\n'],['\n  display: flex;\n  height: 32px;\n  padding: 12px 6px;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n\n  cursor: pointer;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  position: absolute;\n  top: 40px;\n  left: -100px;\n  z-index: 10;\n'],['\n  width: 100%;\n  position: absolute;\n  top: 40px;\n  left: -100px;\n  z-index: 10;\n']);var DropdownGhostV2=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DropdownGhostV2,_Component);function DropdownGhostV2(props){__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,DropdownGhostV2);// Initial state: dropdown is closed
var _this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(DropdownGhostV2.__proto__||Object.getPrototypeOf(DropdownGhostV2)).call(this,props));_this.toggleDropdown=function(){_this.setState(function(prevState){return{isOpen:!prevState.isOpen};});};_this.state={isOpen:false};return _this;}// Toggle the dropdown open/close state
__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DropdownGhostV2,[{key:'render',value:function render(){var _this2=this;var _props=this.props,titleArea=_props.titleArea,children=_props.children,className=_props.className,style=_props.style;var isOpen=this.state.isOpen;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_outside_click_handler___default.a,{useCapture:true,onOutsideClick:function onOutsideClick(){return _this2.setState({isOpen:false});}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Wrapper,{className:className,style:style},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ClickableArea,{onClick:this.toggleDropdown,onKeyDown:this.toggleDropdown,role:'combobox','aria-haspopup':true,tabIndex:0,'aria-labelledby':'dropdown-label','aria-expanded':isOpen,'aria-controls':'dropdown-content-id'},titleArea),isOpen&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Content,{id:'dropdown-content-id',role:'listbox','aria-labelledby':'dropdown-label'},children)));}}]);return DropdownGhostV2;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DropdownGhostV2);var Wrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject);var ClickableArea=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject2);var Content=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject3);

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_router__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  height: calc(100% - 60px);\n  min-height: 500px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n'],['\n  width: 100%;\n  height: calc(100% - 60px);\n  min-height: 500px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #676767;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n  text-align: center;\n  display: block;\n'],['\n  color: #676767;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n  text-align: center;\n  display: block;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #676767;\n  font-family: Nunito;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 28px;\n  text-align: center;\n'],['\n  color: #676767;\n  font-family: Nunito;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 28px;\n  text-align: center;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin: 10px;\n  background: none;\n  border: 1px solid #dedede;\n  outline: none;\n  padding: 10px;\n  text-decoration: none;\n  font-weight: bold;\n  color: #222;\n'],['\n  margin: 10px;\n  background: none;\n  border: 1px solid #dedede;\n  outline: none;\n  padding: 10px;\n  text-decoration: none;\n  font-weight: bold;\n  color: #222;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  color: #93c13e;\n  font-family: Nunito;\n  font-size: 72px;\n  font-weight: bold;\n  line-height: 72px;\n  text-align: center;\n'],['\n  display: block;\n  color: #93c13e;\n  font-family: Nunito;\n  font-size: 72px;\n  font-weight: bold;\n  line-height: 72px;\n  text-align: center;\n']);/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var status=_ref.status;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Status,null,status||'500'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Title,null,'OOPS, PARECE QUE A MANGUEIRA TORCEU'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Text,null,'Ocorreu um erro interno no servidor'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Goback,{to:'/'},'Voltar ao inicio'));});var Wrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject);var Text=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject2);var Title=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].h2(_templateObject3);var Goback=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3_react_router__["Link"])(_templateObject4);var Status=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject5);

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_ic_share_component_svg__ = __webpack_require__(1650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_ic_share_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_ic_share_component_svg__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  background: #fff;\n  border: none;\n  outline: none;\n  cursor: pointer;\n\n  color: #3e3e3e;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px; /* 142.857% */\n\n  &:hover {\n    text-decoration: underline;\n  }\n'],['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  background: #fff;\n  border: none;\n  outline: none;\n  cursor: pointer;\n\n  color: #3e3e3e;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px; /* 142.857% */\n\n  &:hover {\n    text-decoration: underline;\n  }\n']);var ShareButtonV2=function ShareButtonV2(_ref){var className=_ref.className,onClick=_ref.onClick,title=_ref.title,props=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref,['className','onClick','title']);var handleClick=function handleClick(){onClick&&onClick();};return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Wrapper,Object.assign({className:className,onClick:handleClick},props),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__images_ic_share_component_svg___default.a,null),title);};/* harmony default export */ __webpack_exports__["a"] = (ShareButtonV2);var Wrapper=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].button(_templateObject);

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_BigModalV2_images_ic_close_component_svg__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_BigModalV2_images_ic_close_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_BigModalV2_images_ic_close_component_svg__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background-color: #25272ca3;\n  position: absolute;\n  inset: 0;\n  z-index: 10000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n'],['\n  background-color: #25272ca3;\n  position: absolute;\n  inset: 0;\n  z-index: 10000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 24px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  width: 400px;\n  height: 400px;\n\n  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.4);\n  background: #fff;\n'],['\n  display: flex;\n  padding: 24px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  width: 400px;\n  height: 400px;\n\n  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.4);\n  background: #fff;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 0px 16px;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n  align-self: stretch;\n  flex-grow: 1;\n'],['\n  display: flex;\n  padding: 0px 16px;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n  align-self: stretch;\n  flex-grow: 1;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  align-self: stretch;\n\n  span {\n    cursor: pointer;\n  }\n'],['\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  align-self: stretch;\n\n  span {\n    cursor: pointer;\n  }\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  align-self: stretch;\n  color: #010101;\n  text-align: center;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 28px; /* 140% */\n  text-transform: uppercase;\n  margin: 0;\n'],['\n  align-self: stretch;\n  color: #010101;\n  text-align: center;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 28px; /* 140% */\n  text-transform: uppercase;\n  margin: 0;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex: 1 0 0;\n  width: 100%;\n'],['\n  display: flex;\n  flex: 1 0 0;\n  width: 100%;\n']);var SmallModalV2=function SmallModalV2(props){var title=props.title,description=props.description,icon=props.icon,onClose=props.onClose,children=props.children,restProps=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(props,['title','description','icon','onClose','children']);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(WrapperBg,{onMouseDown:onClose},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Wrapper,Object.assign({},restProps,{onMouseDown:function onMouseDown(e){return e.stopPropagation();}}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(CloseRow,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,' ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_BigModalV2_images_ic_close_component_svg___default.a,{onClick:onClose,className:'closeIcon'}),' ')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(StaticContent,null,icon,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Title,null,title),description),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Content,null,children)));};/* harmony default export */ __webpack_exports__["a"] = (SmallModalV2);var WrapperBg=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject);var Wrapper=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject2);var StaticContent=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject3);var CloseRow=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject4);var Title=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].h2(_templateObject5);var Content=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject6);

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Marginer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ','\n'],['\n  ','\n']);var Marginer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject,function(_ref){var _ref$top=_ref.top,top=_ref$top===undefined?0:_ref$top,_ref$right=_ref.right,right=_ref$right===undefined?0:_ref$right,_ref$bottom=_ref.bottom,bottom=_ref$bottom===undefined?0:_ref$bottom,_ref$left=_ref.left,left=_ref$left===undefined?0:_ref$left;return'\n    margin: '+top+'px '+right+'px '+bottom+'px '+left+'px;\n';});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectMapperClasse", function() { return selectMapperClasse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectFirstClass", function() { return selectFirstClass; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_kea__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_kea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_kea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_validations__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_containers_App_logic__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_pick__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_isEmpty__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_sortBy__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_first__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_first___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_first__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_isArray__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_isArray__);
/** Redux and Kea *//* eslint-disable camelcase */var EQUIPMENT_ENDPOINT=__WEBPACK_IMPORTED_MODULE_4_config__["b" /* API_BASE_URL */]+'/public/simulator/equipment/';/**
 * Map simple object to select component
 * @param {*} param0
 */var selectMapper=function selectMapper(_ref){var id=_ref.id,name=_ref.name,item=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties___default()(_ref,['id','name']);return Object.assign({label:name,value:id},item,{id:id,name:name});};/**
 * Map energy classes to select
 * @param {*} param0
 */var selectMapperClasse=function selectMapperClasse(_ref2){var classe_energetica=_ref2.classe_energetica,id=_ref2.id,item=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties___default()(_ref2,['classe_energetica','id']);return Object.assign({label:classe_energetica.name+' '+__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_utils__["l" /* getDatesYear */])(item.start_date,item.end_date),value:id},item,{classe_energetica:classe_energetica,id:id});};// Select the default class or the first if default doesnt exist
var selectDefault=function selectDefault(equipmentconsumption_set){var defaultClass=equipmentconsumption_set.find(function(item){return item.default===true;});return defaultClass||__WEBPACK_IMPORTED_MODULE_15_lodash_first___default()(equipmentconsumption_set);};/**
 * Class mapper
 * @param {*} param
 */var selectFirstClass=function selectFirstClass(_ref3){var equipmentconsumption_set=_ref3.equipmentconsumption_set,item=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties___default()(_ref3,['equipmentconsumption_set']);return Object.assign({},item,{classes:equipmentconsumption_set&&equipmentconsumption_set.map(selectMapperClasse),// Only one class? Select it if not use default
selectedClass:selectDefault(equipmentconsumption_set)});};var fields={hasSolarSystem:[__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].isUndefined],hasSolarSystemYear:[__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].hasSolarSystem,__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].isUndefined],hasCentralAirConditioning:[__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].isUndefined],centralHeatingOfferType:[__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].hasCentralAirConditioning,__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].isUndefined],centralAirConditioningEquipment:[__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].hasCentralAirConditioning,__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].isUndefined],centralAirConditioningEnergyClass:[__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].hasCentralAirConditioning,__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].isUndefined]};/* harmony default export */ __webpack_exports__["default"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_kea__["kea"])({path:function path(){return['scenes','habitation'];},actions:function actions(){return{fetchData:function fetchData(limit){return{limit:limit};},setData:function setData(data){return{data:data};},setInvalid:function setInvalid(invalid){return{invalid:invalid};},setDataFetchError:function setDataFetchError(fetchDataError){return{fetchDataError:fetchDataError};}};},reducers:function reducers(_ref4){var _ref6,_ref8;var actions=_ref4.actions;return{data:[{},__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.setData,function(state,payload){return Object.assign({},payload.data);})],loading:[true,__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,(_ref6={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref6,actions.fetchData,function(){return true;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref6,actions.setData,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref6,actions.setDataFetchError,function(){return false;}),_ref6)],fields:[fields,__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,{}],invalid:[[],__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.array,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.setInvalid,function(_,payload){return[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(payload.invalid));})],error:[false,__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.array,(_ref8={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref8,actions.fetchData,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref8,actions.setData,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref8,actions.setDataFetchError,function(_,payload){return payload.fetchDataError;}),_ref8)],dataChanged:[false,__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.setValues,function(_,payload){if(payload.municipality||payload.offerType||payload.adults||payload.children||payload.elderly||payload.constructionYear||payload.equipmentUtilizationProfile){return true;}else{return false;}})]};},takeLatest:function takeLatest(_ref10){var _ref11;var actions=_ref10.actions,workers=_ref10.workers;return _ref11={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref11,actions.fetchData,workers.fetchData),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref11,actions.setValues,workers.shouldRefreshData),_ref11;},start:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function start(){var fetchData,data,error,dataChanged,_ref12,profileFinished;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function start$(_context){while(1){switch(_context.prev=_context.next){case 0:fetchData=this.actions.fetchData;_context.next=3;return this.get('data');case 3:data=_context.sent;_context.next=6;return this.get('error');case 6:error=_context.sent;_context.next=9;return this.get('dataChanged');case 9:dataChanged=_context.sent;_context.next=12;return __WEBPACK_IMPORTED_MODULE_11_containers_App_logic__["a" /* default */].get('finished');case 12:_ref12=_context.sent;profileFinished=_ref12.profileFinished;if(this.props){_context.next=16;break;}return _context.abrupt('return');case 16:if(profileFinished){_context.next=20;break;}this.props.router.push('/');_context.next=23;break;case 20:if(!(__WEBPACK_IMPORTED_MODULE_13_lodash_isEmpty___default()(data)||error||dataChanged)){_context.next=23;break;}_context.next=23;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(fetchData(1));case 23:case'end':return _context.stop();}}},start,this);}),selectors:function selectors(_ref13){var _selectors=_ref13.selectors;return{divisions:[function(){return[_selectors.data];},function(_ref14){var divisions=_ref14.divisions;return divisions;},__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.any],firstDivision:[function(){return[_selectors.data];},function(_ref15){var divisions=_ref15.divisions;return __WEBPACK_IMPORTED_MODULE_15_lodash_first___default()(divisions);},__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.any]};},workers:{fetchData:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchData(action){var _actions,setData,setValues,setDataFetchError,values,settings,params,adults,children,elderly,response,data,offerTypes,solarSystemYears,centralHeating,houseDivisions,equipment,suggestedEquipment,energyClasses,carChargingDurations,carChargingFrequencies,carChargingPowers,cleanData,quantitiesLogic,quantities,duplicates,defaultValues;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchData$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_actions=this.actions,setData=_actions.setData,setValues=_actions.setValues,setDataFetchError=_actions.setDataFetchError;_context2.next=3;return __WEBPACK_IMPORTED_MODULE_11_containers_App_logic__["a" /* default */].get('values');case 3:values=_context2.sent;_context2.next=6;return __WEBPACK_IMPORTED_MODULE_11_containers_App_logic__["a" /* default */].get('settings');case 6:settings=_context2.sent;params=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_utils__["a" /* csObjectToUnderscore */])(__WEBPACK_IMPORTED_MODULE_12_lodash_pick___default()(values,['constructionYear','equipmentUtilizationType','equipmentUtilizationProfile','offerType']));adults=values.adults,children=values.children,elderly=values.elderly;params.habitants=adults+children+elderly||0;_context2.prev=10;_context2.next=13;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_10_axios___default.a.get,EQUIPMENT_ENDPOINT,{params:params});case 13:response=_context2.sent;data=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_utils__["c" /* csObjectFromUnderscore */])(response.data);offerTypes=data.offerTypes,solarSystemYears=data.solarSystemYears,centralHeating=data.centralHeating,houseDivisions=data.houseDivisions,equipment=data.equipment,suggestedEquipment=data.suggestedEquipment,energyClasses=data.energyClasses,carChargingDurations=data.carChargingDurations,carChargingFrequencies=data.carChargingFrequencies,carChargingPowers=data.carChargingPowers;cleanData={};cleanData.carChargingFrequencies=carChargingFrequencies.map(selectMapper);cleanData.carChargingDurations=carChargingDurations.map(selectMapper);cleanData.carChargingPowers=carChargingPowers.map(selectMapper);quantitiesLogic=function quantitiesLogic(item){var qtn=item.t1_factor_quantity;if(params.habitants>2){var nr=params.habitants-1;nr=nr>6?6:nr;// haha
qtn=item['t'+nr+'_factor_quantity'];}return qtn||1;};quantities=function quantities(item){return Object.assign({},item,{quantity:quantitiesLogic(item,params.habitants)});};cleanData.equipments=equipment.map(selectFirstClass).map(quantities);cleanData.divisions=__WEBPACK_IMPORTED_MODULE_14_lodash_sortBy___default()(houseDivisions,'order');cleanData.offerTypes=__WEBPACK_IMPORTED_MODULE_14_lodash_sortBy___default()(offerTypes.map(selectMapper),'order');cleanData.solarSystemYears=__WEBPACK_IMPORTED_MODULE_14_lodash_sortBy___default()(solarSystemYears.map(selectMapper),'order');cleanData.centralHeatingEquipments=__WEBPACK_IMPORTED_MODULE_14_lodash_sortBy___default()(centralHeating.map(selectFirstClass).map(quantities).map(selectMapper),'order');cleanData.sugestedEquipment=__WEBPACK_IMPORTED_MODULE_14_lodash_sortBy___default()(suggestedEquipment.map(selectFirstClass).map(quantities),'order');// Duplicate equipments for each house division it belongs
// https://gitlab.ubiwhere.com/adene-poupa-energia/adenepe-portal-publico/issues/129
duplicates=[];cleanData.sugestedEquipment=cleanData.sugestedEquipment.map(function(equipment){if(__WEBPACK_IMPORTED_MODULE_16_lodash_isArray___default()(equipment.house_divisions)){equipment.house_divisions.map(function(division,index){if(index){// Ignore the first
// Create a clone so we dont change the current object
// Set the new house division to the clone
// Add element to array
var equipmentClone=Object.assign({},equipment);equipmentClone.house_divisions=division;duplicates.push(equipmentClone);}return division;});// Set array to the first element
equipment.house_divisions=equipment.house_divisions[0];}return equipment;});// Merge duplicates and singles
cleanData.sugestedEquipment=[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(cleanData.sugestedEquipment),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(duplicates));// Duplicate central equipments for each house division it belongs
// https://gitlab.ubiwhere.com/adene-poupa-energia/adenepe-portal-publico/issues/129
duplicates=[];cleanData.centralHeatingEquipments=cleanData.centralHeatingEquipments.map(function(equipment){if(__WEBPACK_IMPORTED_MODULE_16_lodash_isArray___default()(equipment.house_divisions)){equipment.house_divisions.map(function(division,index){if(index){// Ignore the first
// Create a clone so we dont change the current object
// Set the new house division to the clone
// Add element to array
var equipmentClone=Object.assign({},equipment);equipmentClone.house_divisions=division;duplicates.push(equipmentClone);}return division;});// Set array to the first element
equipment.house_divisions=equipment.house_divisions[0];}return equipment;});// Merge duplicates and singles
cleanData.centralHeatingEquipments=[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(cleanData.centralHeatingEquipments),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(duplicates));cleanData.energyClasses=energyClasses.map(selectMapper).sort(function(a,b){var nameA=a.label.toUpperCase();var nameB=b.label.toUpperCase();if(nameA<nameB){return-1;}if(nameA>nameB){return 1;}return 0;}).sort(function(a,b){var plusA=a.label.substring(1,a.label.length);var plusB=b.label.substring(1,b.label.length);if(plusA>plusB){return-1;}if(plusA<plusB){return 1;}return 0;});cleanData.defaultChargingDuration=carChargingDurations.find(function(c){return c.default;});cleanData.defaultChargingPower=carChargingPowers.find(function(c){return c.default;});cleanData.defaultChargingFrequency=carChargingFrequencies.find(function(c){return c.default;});defaultValues={equipments:cleanData.sugestedEquipment,hasSolarSystem:false,hasCentralAirConditioning:false,centralHeatingOfferType:values.offerType,solarSystemYear:1};_context2.next=41;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setData(Object.assign({},cleanData)));case 41:if(settings.isFromProfile){_context2.next=44;break;}_context2.next=44;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setValues(defaultValues));case 44:_context2.next=55;break;case 46:_context2.prev=46;_context2.t0=_context2['catch'](10);if(!(_context2.t0.response.status===404)){_context2.next=52;break;}if(this.props){this.props.router.push('/');}_context2.next=55;break;case 52:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_utils__["m" /* captureSentryException */])(_context2.t0);_context2.next=55;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setDataFetchError(_context2.t0));case 55:case'end':return _context2.stop();}}},fetchData,this,[[10,46]]);}),/**
     * If offer type changes force the equipments to reload
     * Should solve the issue in
     * https://gitlab.ubiwhere.com/adene-poupa-energia/adene-simulador-avancado/issues/69
     * @param {*} action
     */shouldRefreshData:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function shouldRefreshData(action){var fetchData,_ref16,profileFinished,payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function shouldRefreshData$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:fetchData=this.actions.fetchData;_context3.next=3;return __WEBPACK_IMPORTED_MODULE_11_containers_App_logic__["a" /* default */].get('finished');case 3:_ref16=_context3.sent;profileFinished=_ref16.profileFinished;payload=action.payload;if(!(profileFinished&&payload.offerType)){_context3.next=9;break;}_context3.next=9;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(fetchData(1));case 9:case'end':return _context3.stop();}}},shouldRefreshData,this);})},connect:{actions:[__WEBPACK_IMPORTED_MODULE_11_containers_App_logic__["a" /* default */],['setValue','setValues','setFinished']],props:[__WEBPACK_IMPORTED_MODULE_11_containers_App_logic__["a" /* default */],['values','translations']]}}));

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVENT_HANDLERS_KEY = undefined;
exports.addEventListener = addEventListener;
exports.removeEventListener = removeEventListener;

var _normalizeEventOptions = __webpack_require__(960);

var _normalizeEventOptions2 = _interopRequireDefault(_normalizeEventOptions);

var _TargetEventHandlers = __webpack_require__(956);

var _TargetEventHandlers2 = _interopRequireDefault(_TargetEventHandlers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Export to make testing possible.
var EVENT_HANDLERS_KEY = exports.EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';

function addEventListener(target, eventName, listener, options) {
  if (!target[EVENT_HANDLERS_KEY]) {
    // eslint-disable-next-line no-param-reassign
    target[EVENT_HANDLERS_KEY] = new _TargetEventHandlers2['default'](target);
  }
  var normalizedEventOptions = (0, _normalizeEventOptions2['default'])(options);
  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
}

// Deprecated
function removeEventListener(unsubscribeFn) {
  unsubscribeFn();
}

/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(474);
var enumBugKeys = __webpack_require__(311);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 232 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(88).f;
var has = __webpack_require__(110);
var TAG = __webpack_require__(49)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(309);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 235 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1010);
var global = __webpack_require__(45);
var hide = __webpack_require__(111);
var Iterators = __webpack_require__(141);
var TO_STRING_TAG = __webpack_require__(49)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(65);
var toLength = __webpack_require__(31);
var toAbsoluteIndex = __webpack_require__(119);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(19);
var $export = __webpack_require__(3);
var redefine = __webpack_require__(57);
var redefineAll = __webpack_require__(145);
var meta = __webpack_require__(98);
var forOf = __webpack_require__(241);
var anInstance = __webpack_require__(143);
var isObject = __webpack_require__(20);
var fails = __webpack_require__(18);
var $iterDetect = __webpack_require__(243);
var setToStringTag = __webpack_require__(147);
var inheritIfRequired = __webpack_require__(330);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(510);
var redefine = __webpack_require__(57);
var hide = __webpack_require__(64);
var fails = __webpack_require__(18);
var defined = __webpack_require__(90);
var wks = __webpack_require__(28);
var regexpExec = __webpack_require__(336);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(17);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(79);
var call = __webpack_require__(491);
var isArrayIter = __webpack_require__(331);
var anObject = __webpack_require__(17);
var toLength = __webpack_require__(31);
var getIterFn = __webpack_require__(346);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(89);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(28)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 244 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(192);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(35);
var global = __webpack_require__(19);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(113) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(19);
var hide = __webpack_require__(64);
var uid = __webpack_require__(120);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(19);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(587);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var defineDataProperty = __webpack_require__(513);

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var supportsDescriptors = __webpack_require__(523)();

var defineProperty = function (object, name, value, predicate) {
	if (name in object) {
		if (predicate === true) {
			if (object[name] === value) {
				return;
			}
		} else if (!isFunction(predicate) || !predicate()) {
			return;
		}
	}

	if (supportsDescriptors) {
		defineDataProperty(object, name, value, true);
	} else {
		defineDataProperty(object, name, value);
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/arrow.ecaebf72.svg";

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Indicates that navigation was caused by a call to history.push.
 */
var PUSH = exports.PUSH = 'PUSH';

/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = exports.REPLACE = 'REPLACE';

/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = exports.POP = 'POP';

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.createActionTransforms = createActionTransforms;
exports.selectActionsFromLogic = selectActionsFromLogic;
exports.clearActionCache = clearActionCache;
exports.createAction = createAction;
exports.createActions = createActions;

var _store = __webpack_require__(254);

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function createActionTransforms() {
  var mapping = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (mapping.length % 2 === 1) {
    console.error('[KEA-LOGIC] uneven mapping given to selectActionsFromLogic:', mapping);
    console.trace();
    return;
  }

  var hash = {};
  var transforms = {};

  var _loop = function _loop(i) {
    var logic = mapping[i];
    var actionsArray = mapping[i + 1];

    if (logic._isKeaSingleton) {
      if (!logic._keaReducerConnected) {
        (0, _store.addReducer)(logic.path, logic.reducer, true);
        logic._keaReducerConnected = true;
      }
    }

    var actions = logic && logic.actions ? logic.actions : logic;

    actionsArray.forEach(function (query) {
      var from = query;
      var to = query;

      if (query.includes(' as ')) {
        var _query$split = query.split(' as ');

        var _query$split2 = _slicedToArray(_query$split, 2);

        from = _query$split2[0];
        to = _query$split2[1];
      }

      var matches = from.match(/^(.*)\((.*)\)$/);

      if (matches) {
        if (from === to) {
          to = matches[1];
        }
        from = matches[1];
        transforms[to] = matches[2].split(',').map(function (s) {
          return s.trim();
        });
      }

      if (typeof actions[from] === 'function') {
        hash[to] = actions[from];
      } else {
        console.error('[KEA-LOGIC] action "' + query + '" missing for logic:', logic);
        console.trace();
      }
    });
  };

  for (var i = 0; i < mapping.length; i += 2) {
    _loop(i);
  }

  return {
    actions: hash,
    transforms: transforms
  };
}

function selectActionsFromLogic() {
  var mapping = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return createActionTransforms(mapping).actions;
}

var alreadyCreated = {};

function clearActionCache() {
  alreadyCreated = {};
}

function createAction(type, payloadCreator) {
  if (alreadyCreated[type]) {
    console.error('[KEA-LOGIC] Already created action "' + type + '"');
  }

  var action = function action() {
    return {
      type: type,
      payload: typeof payloadCreator === 'function' ? payloadCreator.apply(undefined, arguments) : payloadCreator
    };
  };
  action.toString = function () {
    return type;
  };

  alreadyCreated[type] = true;

  return action;
}

var toSpaces = function toSpaces(key) {
  return key.replace(/(?:^|\.?)([A-Z])/g, function (x, y) {
    return ' ' + y.toLowerCase();
  }).replace(/^ /, '');
};

function createActions() {
  var mapping = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var path = arguments[1];

  var actions = {};

  var _ref = typeof path === 'string' ? path.split('.') : path,
      _ref2 = _toArray(_ref),
      scenes = _ref2[0],
      rest = _ref2.slice(1);

  var fullPath = scenes === 'scenes' ? rest.join('.') : scenes + (rest.length > 0 ? '.' + rest.join('.') : '');
  Object.keys(mapping).forEach(function (key) {
    var fullKey = toSpaces(key) + ' (' + fullPath + ')';
    actions[key] = createAction(fullKey, mapping[key]);
  });

  return actions;
}

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keaSaga = exports.NEW_SCENE = undefined;
exports.clearStore = clearStore;
exports.createRootSaga = createRootSaga;
exports.startSaga = startSaga;
exports.cancelSaga = cancelSaga;
exports.keaReducer = keaReducer;
exports.keaMiddlware = keaMiddlware;
exports.firstReducerRoot = firstReducerRoot;
exports.addReducer = addReducer;
exports.regenerateRootReducer = regenerateRootReducer;
exports.isSyncedWithStore = isSyncedWithStore;
exports.recursiveCreateReducer = recursiveCreateReducer;
exports.addKeaScene = addKeaScene;

var _effects = __webpack_require__(26);

var _reduxSaga = __webpack_require__(130);

var _redux = __webpack_require__(280);

var _marked = [componentSagaWatcher].map(regeneratorRuntime.mark);

var NEW_SCENE = exports.NEW_SCENE = '@@kea/NEW_SCENE';

// worker functions are loaded globally, reducers locally in store
var loadedWorkers = {};
var loadedScenes = {}; // all loaded scenes
var currentScene = null;
var defaultReducerRoot = null;

// all reducers that are created
var reducerTree = {};
var rootReducers = {};
var syncedWithStore = {};

function clearStore() {
  loadedWorkers = {};
  loadedScenes = {};
  currentScene = null;
  defaultReducerRoot = null;
  reducerTree = {};
  rootReducers = {};
  syncedWithStore = {};
}

function createRootSaga() {
  var appSagas = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  return regeneratorRuntime.mark(function _callee() {
    var runningSaga, ranAppSagas, _ref, payload, name, background;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            runningSaga = null;
            ranAppSagas = false;
            _context.next = 4;
            return (0, _effects.fork)(componentSagaWatcher);

          case 4:
            if (false) {
              _context.next = 28;
              break;
            }

            _context.next = 7;
            return (0, _effects.take)(NEW_SCENE);

          case 7:
            _ref = _context.sent;
            payload = _ref.payload;
            name = payload.name, background = payload.background;

            if (!(!ranAppSagas && appSagas)) {
              _context.next = 14;
              break;
            }

            _context.next = 13;
            return (0, _effects.call)(appSagas);

          case 13:
            ranAppSagas = true;

          case 14:
            if (!(!background && runningSaga)) {
              _context.next = 17;
              break;
            }

            _context.next = 17;
            return (0, _effects.cancel)(runningSaga);

          case 17:
            if (!loadedWorkers[name]) {
              _context.next = 26;
              break;
            }

            if (!background) {
              _context.next = 23;
              break;
            }

            _context.next = 21;
            return (0, _effects.fork)(loadedWorkers[name]);

          case 21:
            _context.next = 26;
            break;

          case 23:
            _context.next = 25;
            return (0, _effects.fork)(loadedWorkers[name]);

          case 25:
            runningSaga = _context.sent;

          case 26:
            _context.next = 4;
            break;

          case 28:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  });
}

var keaSaga = exports.keaSaga = createRootSaga();

var emitter = void 0;
var cancelCounter = 1;
var toCancel = {};

function createComponentChannel(socket) {
  return (0, _reduxSaga.eventChannel)(function (emit) {
    emitter = emit;
    return function () {};
  });
}

function componentSagaWatcher() {
  var channel, _ref2, _startSaga, _cancelSaga, saga, counter;

  return regeneratorRuntime.wrap(function componentSagaWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.call)(createComponentChannel);

        case 2:
          channel = _context2.sent;

        case 3:
          if (false) {
            _context2.next = 20;
            break;
          }

          _context2.next = 6;
          return (0, _effects.take)(channel);

        case 6:
          _ref2 = _context2.sent;
          _startSaga = _ref2.startSaga;
          _cancelSaga = _ref2.cancelSaga;
          saga = _ref2.saga;
          counter = _ref2.counter;

          if (!_startSaga) {
            _context2.next = 15;
            break;
          }

          _context2.next = 14;
          return (0, _effects.fork)(saga);

        case 14:
          toCancel[counter] = _context2.sent;

        case 15:
          if (!_cancelSaga) {
            _context2.next = 18;
            break;
          }

          _context2.next = 18;
          return (0, _effects.cancel)(toCancel[counter]);

        case 18:
          _context2.next = 3;
          break;

        case 20:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[0], this);
}

function startSaga(saga) {
  if (emitter) {
    cancelCounter += 1;
    emitter({ startSaga: true, saga: saga, counter: cancelCounter });
    return cancelCounter;
  }

  return null;
}

function cancelSaga(counter) {
  if (emitter) {
    emitter({ cancelSaga: true, counter: counter });
  }
}

function keaReducer() {
  var pathStart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'scenes';
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!reducerTree[pathStart]) {
    reducerTree[pathStart] = {};
    regenerateRootReducer(pathStart);
  }

  if (options && options.default) {
    defaultReducerRoot = pathStart;
  }

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    return rootReducers[pathStart] ? rootReducers[pathStart](state, action) : state;
  };
}

function keaMiddlware() {}

function firstReducerRoot() {
  return defaultReducerRoot || Object.keys(reducerTree)[0];
}

function addReducer(path, reducer) {
  var regenerate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var pathStart = path[0];

  if (typeof reducerTree[pathStart] === 'undefined') {
    console.error('[KEA-LOGIC] Path starting with "' + pathStart + '" is not connected to the reducer tree! Make sure to call keaReducer() before any calls to kea() take place!', path);
    return;
  }

  syncedWithStore[pathStart] = false;

  var pointer = reducerTree;

  for (var i = 0; i < path.length; i++) {
    var pathPart = path[i];

    // last part of the path, so [..., pathPart] = path
    if (i === path.length - 1) {
      // there's already something here!
      if (pointer[pathPart]) {
        // if it's a function, assume it's a reducer and replacing it is fine
        // otherwise give an error
        if (typeof pointer[pathPart] !== 'function') {
          console.error('[KEA-LOGIC] Can not add reducer to "' + path.join('.') + '". There is something in the way:', pointer[pathPart]);
          return;
        }
      }

      pointer[pathPart] = reducer;
    } else {
      if (!pointer[pathPart]) {
        pointer[pathPart] = {};
      }
      pointer = pointer[pathPart];
    }
  }

  if (regenerate) {
    regenerateRootReducer(pathStart);
  }
}

function regenerateRootReducer(pathStart) {
  var rootReducer = recursiveCreateReducer(reducerTree[pathStart]);

  rootReducers[pathStart] = function (state, action) {
    syncedWithStore[pathStart] = true;
    return rootReducer(state, action);
  };
}

function isSyncedWithStore() {
  var pathStart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (pathStart) {
    return syncedWithStore[pathStart];
  } else {
    return Object.values(syncedWithStore).filter(function (k) {
      return !k;
    }).length === 0;
  }
}

function recursiveCreateReducer(treeNode) {
  var children = {};
  Object.keys(treeNode).forEach(function (key) {
    if (typeof treeNode[key] === 'function') {
      children[key] = treeNode[key];
    } else {
      children[key] = recursiveCreateReducer(treeNode[key]);
    }
  });

  return Object.keys(children).length > 0 ? (0, _redux.combineReducers)(children) : function (state, action) {
    return state;
  };
}

// add reducers and sagas from the scene into the state
function addKeaScene(scene) {
  var background = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var store = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (!scene) {
    return;
  }

  var name = scene.name;


  if (currentScene === name) {
    return;
  }

  if (!loadedScenes[name]) {
    // store the scene and saga
    loadedWorkers[name] = scene.worker;
    loadedScenes[name] = scene;

    var rootReducersToRegenerate = {};

    // go through all loaded scenes and recreate the reducers
    // this is so because scenes can load logic from other scenes
    Object.keys(loadedScenes).forEach(function (key) {
      var logic = loadedScenes[key].logic;


      logic.forEach(function (logicClass) {
        var path = logicClass.path,
            reducer = logicClass.reducer;


        if (!path || !Array.isArray(path)) {
          console.error('[KEA-LOGIC] No path for logic in scene ' + name + '!', logicClass);
          return;
        }

        if (!reducer) {
          console.error('[KEA-LOGIC] No reducer in logic!', path, logicClass);
          console.trace();
          return;
        }

        addReducer(path, reducer, false);

        rootReducersToRegenerate[path[0]] = true;
      });
    });

    Object.keys(rootReducersToRegenerate).forEach(function (pathStart) {
      regenerateRootReducer(pathStart);
    });
  }

  if (store) {
    store.dispatch({
      type: NEW_SCENE,
      payload: {
        name: name,
        background: background
      }
    });
  }

  currentScene = name;
}

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1354),
    listCacheDelete = __webpack_require__(1355),
    listCacheGet = __webpack_require__(1356),
    listCacheHas = __webpack_require__(1357),
    listCacheSet = __webpack_require__(1358);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(255),
    stackClear = __webpack_require__(1372),
    stackDelete = __webpack_require__(1373),
    stackGet = __webpack_require__(1374),
    stackHas = __webpack_require__(1375),
    stackSet = __webpack_require__(1376);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(158);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1296),
    isObjectLike = __webpack_require__(37);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(266);

/**
 * Creates a function that performs a relational operation on two values.
 *
 * @private
 * @param {Function} operator The function to perform the operation.
 * @returns {Function} Returns the new relational operation function.
 */
function createRelationalOperation(operator) {
  return function(value, other) {
    if (!(typeof value == 'string' && typeof other == 'string')) {
      value = toNumber(value);
      other = toNumber(other);
    }
    return operator(value, other);
  };
}

module.exports = createRelationalOperation;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1350);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 261 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(125);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 263 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 264 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(92),
    basePullAt = __webpack_require__(1313);

/**
 * Removes all elements from `array` that `predicate` returns truthy for
 * and returns an array of the removed elements. The predicate is invoked
 * with three arguments: (value, index, array).
 *
 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
 * to pull elements from an array by value.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = [1, 2, 3, 4];
 * var evens = _.remove(array, function(n) {
 *   return n % 2 == 0;
 * });
 *
 * console.log(array);
 * // => [1, 3]
 *
 * console.log(evens);
 * // => [2, 4]
 */
function remove(array, predicate) {
  var result = [];
  if (!(array && array.length)) {
    return result;
  }
  var index = -1,
      indexes = [],
      length = array.length;

  predicate = baseIteratee(predicate, 3);
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result.push(value);
      indexes.push(index);
    }
  }
  basePullAt(array, indexes);
  return result;
}

module.exports = remove;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(1320),
    isObject = __webpack_require__(43),
    isSymbol = __webpack_require__(162);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defineProperties = __webpack_require__(249);
var callBind = __webpack_require__(307);

var implementation = __webpack_require__(589);
var getPolyfill = __webpack_require__(590);
var shim = __webpack_require__(1427);

var polyfill = callBind.apply(getPolyfill());
// eslint-disable-next-line no-unused-vars
var bound = function assign(target, source1) {
	return polyfill(Object, arguments);
};

defineProperties(bound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = bound;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 73);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = __webpack_require__(229);

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __webpack_require__(8);

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _consolidatedEvents = __webpack_require__(18);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

// import { forbidExtraProps } from 'airbnb-prop-types'; // TODO: add to propTypes; semver-major


var propTypes = {
  children: _propTypes2['default'].node,
  onOutsideClick: _propTypes2['default'].func
};

var defaultProps = {
  children: _react2['default'].createElement('span', null),
  onOutsideClick: function () {
    function onOutsideClick() {}

    return onOutsideClick;
  }()
};

var OutsideClickHandler = function (_React$Component) {
  _inherits(OutsideClickHandler, _React$Component);

  function OutsideClickHandler() {
    var _ref;

    _classCallCheck(this, OutsideClickHandler);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = OutsideClickHandler.__proto__ || Object.getPrototypeOf(OutsideClickHandler)).call.apply(_ref, [this].concat(args)));

    _this.onOutsideClick = _this.onOutsideClick.bind(_this);
    _this.setChildNodeRef = _this.setChildNodeRef.bind(_this);
    return _this;
  }

  _createClass(OutsideClickHandler, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        // `capture` flag is set to true so that a `stopPropagation` in the children
        // will not prevent all outside click handlers from firing - maja
        this.clickHandle = (0, _consolidatedEvents.addEventListener)(document, 'click', this.onOutsideClick, { capture: true });
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        if (this.clickHandle) {
          (0, _consolidatedEvents.removeEventListener)(this.clickHandle);
        }
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'onOutsideClick',
    value: function () {
      function onOutsideClick(e) {
        var onOutsideClick = this.props.onOutsideClick;
        var childNode = this.childNode;

        var isDescendantOfRoot = childNode && childNode.contains(e.target);
        if (!isDescendantOfRoot) {
          onOutsideClick(e);
        }
      }

      return onOutsideClick;
    }()
  }, {
    key: 'setChildNodeRef',
    value: function () {
      function setChildNodeRef(ref) {
        this.childNode = ref;
      }

      return setChildNodeRef;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement('div', { ref: this.setChildNodeRef }, this.props.children);
      }

      return render;
    }()
  }]);

  return OutsideClickHandler;
}(_react2['default'].Component);

exports['default'] = OutsideClickHandler;

OutsideClickHandler.propTypes = propTypes;
OutsideClickHandler.defaultProps = defaultProps;

/***/ })

/******/ });

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toISOMonthString;

var _moment = __webpack_require__(13);

var _moment2 = _interopRequireDefault(_moment);

var _toMomentObject = __webpack_require__(168);

var _toMomentObject2 = _interopRequireDefault(_toMomentObject);

var _constants = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function toISOMonthString(date, currentFormat) {
  var dateObj = _moment2['default'].isMoment(date) ? date : (0, _toMomentObject2['default'])(date, currentFormat);
  if (!dateObj) return null;

  return dateObj.format(_constants.ISO_MONTH_FORMAT);
}

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(21);

var EventPluginRegistry = __webpack_require__(385);
var ReactEventEmitterMixin = __webpack_require__(1498);
var ViewportMetrics = __webpack_require__(638);

var getVendorPrefixedEventName = __webpack_require__(1530);
var isEventSupported = __webpack_require__(396);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(215);
var ViewportMetrics = __webpack_require__(638);

var getEventModifierState = __webpack_require__(394);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(22);

var invariant = __webpack_require__(12);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(50);
var DOMNamespaces = __webpack_require__(384);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(392);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IGNORE_CLASS_NAME */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.
  // Also cover shadowRoot node by checking current.host


  while (current.parentNode || current.host) {
    // Only check normal node without shadowRoot
    if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode || current.host;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = {};
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions.passive = !instance.props.preventDefault;
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (config && typeof config.setClickOutsideRef === 'function') {
          return config.setClickOutsideRef()(instance);
        }

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;
          if (_this.initTimeStamp > event.timeStamp) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      _this.initTimeStamp = performance.now();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        }
      }

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    }
    /**
     * Remove all document's event listeners for this component
     */
    ;

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    }
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */
    ;

    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _this$props = this.props;
          _this$props.excludeScrollbar;
          var props = _objectWithoutPropertiesLoose(_this$props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, props);
    };

    return onClickOutside;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}/* harmony default export */ __webpack_exports__["a"] = (onClickOutsideHOC);

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;

var _RouteUtils = __webpack_require__(104);

Object.defineProperty(exports, 'createRoutes', {
  enumerable: true,
  get: function get() {
    return _RouteUtils.createRoutes;
  }
});

var _PropTypes = __webpack_require__(406);

Object.defineProperty(exports, 'locationShape', {
  enumerable: true,
  get: function get() {
    return _PropTypes.locationShape;
  }
});
Object.defineProperty(exports, 'routerShape', {
  enumerable: true,
  get: function get() {
    return _PropTypes.routerShape;
  }
});

var _PatternUtils = __webpack_require__(172);

Object.defineProperty(exports, 'formatPattern', {
  enumerable: true,
  get: function get() {
    return _PatternUtils.formatPattern;
  }
});

var _Router2 = __webpack_require__(1556);

var _Router3 = _interopRequireDefault(_Router2);

var _Link2 = __webpack_require__(658);

var _Link3 = _interopRequireDefault(_Link2);

var _IndexLink2 = __webpack_require__(1552);

var _IndexLink3 = _interopRequireDefault(_IndexLink2);

var _withRouter2 = __webpack_require__(1567);

var _withRouter3 = _interopRequireDefault(_withRouter2);

var _IndexRedirect2 = __webpack_require__(1553);

var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);

var _IndexRoute2 = __webpack_require__(1554);

var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);

var _Redirect2 = __webpack_require__(660);

var _Redirect3 = _interopRequireDefault(_Redirect2);

var _Route2 = __webpack_require__(1555);

var _Route3 = _interopRequireDefault(_Route2);

var _RouterContext2 = __webpack_require__(407);

var _RouterContext3 = _interopRequireDefault(_RouterContext2);

var _match2 = __webpack_require__(1565);

var _match3 = _interopRequireDefault(_match2);

var _useRouterHistory2 = __webpack_require__(665);

var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);

var _applyRouterMiddleware2 = __webpack_require__(1558);

var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);

var _browserHistory2 = __webpack_require__(1559);

var _browserHistory3 = _interopRequireDefault(_browserHistory2);

var _hashHistory2 = __webpack_require__(1563);

var _hashHistory3 = _interopRequireDefault(_hashHistory2);

var _createMemoryHistory2 = __webpack_require__(662);

var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Router = _Router3.default; /* components */

exports.Link = _Link3.default;
exports.IndexLink = _IndexLink3.default;
exports.withRouter = _withRouter3.default;

/* components (configuration) */

exports.IndexRedirect = _IndexRedirect3.default;
exports.IndexRoute = _IndexRoute3.default;
exports.Redirect = _Redirect3.default;
exports.Route = _Route3.default;

/* utils */

exports.RouterContext = _RouterContext3.default;
exports.match = _match3.default;
exports.useRouterHistory = _useRouterHistory3.default;
exports.applyRouterMiddleware = _applyRouterMiddleware3.default;

/* histories */

exports.browserHistory = _browserHistory3.default;
exports.hashHistory = _hashHistory3.default;
exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Indicates that navigation was caused by a call to history.push.
 */
var PUSH = exports.PUSH = 'PUSH';

/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = exports.REPLACE = 'REPLACE';

/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = exports.POP = 'POP';

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BUFFER_OVERFLOW */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buffers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(67);


var BUFFER_OVERFLOW = "Channel's Buffer overflow!";

var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;

var zeroBuffer = { isEmpty: __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* kTrue */], put: __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* noop */], take: __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* noop */] };

function ringBuffer() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var overflowAction = arguments[1];

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];
    while (length) {
      items.push(take());
    }
    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit = void 0;
        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);
          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;
          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;

            arr = flush();

            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;

            arr.length = doubledLimit;
            limit = doubledLimit;

            push(it);
            break;
          default:
          // DROP
        }
      }
    },
    take: take,
    flush: flush
  };
}

var buffers = {
  none: function none() {
    return zeroBuffer;
  },
  fixed: function fixed(limit) {
    return ringBuffer(limit, ON_OVERFLOW_THROW);
  },
  dropping: function dropping(limit) {
    return ringBuffer(limit, ON_OVERFLOW_DROP);
  },
  sliding: function sliding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
  },
  expanding: function expanding(initialSize) {
    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
  }
};

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _createStore = __webpack_require__(682);

var _createStore2 = _interopRequireDefault(_createStore);

var _utilsCombineReducers = __webpack_require__(1613);

var _utilsCombineReducers2 = _interopRequireDefault(_utilsCombineReducers);

var _utilsBindActionCreators = __webpack_require__(1612);

var _utilsBindActionCreators2 = _interopRequireDefault(_utilsBindActionCreators);

var _utilsApplyMiddleware = __webpack_require__(1611);

var _utilsApplyMiddleware2 = _interopRequireDefault(_utilsApplyMiddleware);

var _utilsCompose = __webpack_require__(683);

var _utilsCompose2 = _interopRequireDefault(_utilsCompose);

exports.createStore = _createStore2['default'];
exports.combineReducers = _utilsCombineReducers2['default'];
exports.bindActionCreators = _utilsBindActionCreators2['default'];
exports.applyMiddleware = _utilsApplyMiddleware2['default'];
exports.compose = _utilsCompose2['default'];

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcDiscountsComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-discounts"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M10.3336 2.34377L17.6667 9.69769C17.8093 9.84031 17.9104 9.99757 17.9736 10.1697C18.0405 10.3523 18.0729 10.5316 18.0729 10.7087C18.0729 10.8857 18.0406 11.0605 17.9745 11.2346C17.9118 11.3999 17.811 11.5545 17.6669 11.6985L11.7086 17.6569C11.5646 17.8008 11.4053 17.9064 11.23 17.9765C11.0489 18.049 10.872 18.0837 10.6979 18.0837C10.5237 18.0837 10.3468 18.049 10.1657 17.9765C9.99039 17.9064 9.8311 17.8008 9.68714 17.6569L2.33298 10.3027C2.20364 10.1734 2.10392 10.024 2.03304 9.85265C1.96249 9.68218 1.92703 9.50291 1.92703 9.31283V3.33366C1.92703 2.94216 2.06351 2.61323 2.34339 2.33335C2.62327 2.05347 2.9522 1.91699 3.3437 1.91699H9.32287C9.51014 1.91699 9.69164 1.95481 9.8693 2.0318C10.0502 2.1102 10.2042 2.21438 10.3336 2.34377ZM3.0937 9.39534L10.6976 17.0208L17.0095 10.7089L9.40579 3.08366H3.0937V9.39534ZM6.13567 6.12563C5.94003 6.32127 5.70871 6.41699 5.42703 6.41699C5.14536 6.41699 4.91403 6.32127 4.71839 6.12563C4.52275 5.92999 4.42703 5.69867 4.42703 5.41699C4.42703 5.13532 4.52275 4.90399 4.71839 4.70835C4.91403 4.51271 5.14536 4.41699 5.42703 4.41699C5.70871 4.41699 5.94003 4.51271 6.13567 4.70835C6.33131 4.90399 6.42703 5.13532 6.42703 5.41699C6.42703 5.69867 6.33131 5.92999 6.13567 6.12563Z","fill":"#3E3E3E"})));
}

IcDiscountsComponent.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IcDiscountsComponent;

IcDiscountsComponent.default = IcDiscountsComponent;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcEletricityGasComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-eletricity and gas"},React.createElement("path",{"id":"icons/ic-eletricidade-gas","fillRule":"evenodd","clipRule":"evenodd","d":"M4.88934 3.23628C4.95401 3.09574 5.09523 3.00586 5.25114 3.00586H9.65217C9.80039 3.00586 9.93637 3.0881 10.0052 3.21893C10.0734 3.34975 10.0622 3.50764 9.97692 3.6284L6.77734 8.12777H8.61746C8.70446 8.02579 8.79157 7.92369 8.87823 7.82309L8.88162 7.81915C9.21475 7.43173 9.55885 7.03154 9.87344 6.61584C10.5534 5.71707 10.9438 4.9127 11.1015 4.08438C11.1238 3.96813 11.1466 3.84355 11.1557 3.71689C11.1707 3.51285 11.5112 3.21025 11.709 3.21025C12.6115 3.21025 13.2842 3.95777 13.9202 4.6645C14.1355 4.90381 14.3467 5.13844 14.5611 5.33779C15.5591 6.26605 16.8074 7.54375 17.61 9.199C18.1704 10.3559 18.3959 11.3487 18.3186 12.3232C18.1456 14.5135 17.2122 16.0147 15.4651 16.9114C15.3585 16.9662 15.2564 16.994 15.1617 16.994C15.0397 16.994 14.9373 16.9481 14.8572 16.8576C14.7548 16.742 14.7146 16.6143 14.7408 16.4887C14.7716 16.3419 14.8894 16.2139 15.0725 16.1282C15.5833 15.8898 16.0181 15.5452 16.3649 15.1027C17.4877 13.6703 17.7376 12.0508 17.1077 10.289C16.7375 9.25313 16.1188 8.26831 15.1617 7.1898C14.3944 6.32469 13.4901 5.51476 12.3155 4.64133L12.2872 4.61982L12.2859 4.61882C12.2296 4.57535 12.1663 4.52647 12.0824 4.52647C11.9701 4.52647 11.8897 4.60663 11.8443 4.76522C11.4818 6.02383 10.6911 7.06383 9.89057 8.00007C9.78256 8.12604 8.25286 10.0624 8.25286 10.0624C8.23455 10.0915 8.21584 10.1202 8.19713 10.1489C8.16049 10.2052 8.12387 10.2614 8.09031 10.3202C7.30728 11.6992 7.21744 12.9513 7.81555 14.1474C8.40981 15.3352 9.41342 16.005 10.7977 16.1382C11.0784 16.1649 11.2595 16.3457 11.2486 16.5869C11.2385 16.8229 11.0588 16.9811 10.8019 16.9815C9.45781 16.9547 8.35598 16.3728 7.41949 15.2009C6.84026 14.4764 6.55187 13.5766 6.56166 12.5269C6.56341 12.3516 6.57704 12.1781 6.59661 12.0056L2.67134 16.6109C2.59339 16.7021 2.48153 16.7504 2.36722 16.7504C2.30045 16.7504 2.23229 16.7337 2.17041 16.6983C2.00402 16.6039 1.92921 16.4051 1.99248 16.2253L3.93188 10.7245H2.06449C1.92921 10.7245 1.80302 10.6565 1.72961 10.5433C1.65655 10.4306 1.64641 10.2883 1.70269 10.1661L4.88934 3.23628ZM8.88454 3.79497H5.50634L2.68289 9.93537H4.49225C4.62124 9.93537 4.74219 9.99714 4.81664 10.1019C4.8911 10.206 4.90998 10.34 4.86768 10.4604L3.45334 14.4712C3.45334 14.4712 7.86905 9.0491 7.97112 8.91689H6.00971C5.86115 8.91689 5.72516 8.83499 5.657 8.70382C5.58848 8.573 5.59932 8.41545 5.68496 8.29434L8.88454 3.79497ZM12.2085 7.73877C12.1722 7.51426 12.3096 7.38551 12.4316 7.3168C12.5085 7.27343 12.5843 7.25122 12.657 7.25122C12.7451 7.25122 12.8304 7.28419 12.9094 7.34908C13.8886 8.15137 14.5356 8.92729 14.9456 9.79066C15.7073 11.3939 15.5756 12.9172 14.5422 14.4472L14.5216 14.4781L14.5188 14.4825C14.5033 14.506 14.4877 14.5298 14.4702 14.5513C14.3654 14.6832 14.2217 14.7595 14.0773 14.7595C13.992 14.7595 13.9109 14.7335 13.8368 14.6832C13.6348 14.5461 13.5946 14.3178 13.7292 14.0728C13.7708 13.9965 13.8195 13.9242 13.8684 13.8516L13.8718 13.8465C13.9074 13.7935 13.9431 13.7404 13.9766 13.6855C14.7653 12.403 14.7377 11.0652 13.8945 9.7105C13.827 9.60154 13.7512 9.49674 13.6753 9.39298L13.5764 9.25557L13.309 9.32844C13.2663 9.90205 13.2275 10.4212 13.08 10.9282C12.9877 11.2478 12.8671 11.4841 12.7014 11.6732C12.4777 11.9279 12.19 12.0626 11.8702 12.0626C11.5552 12.0626 11.2315 11.9324 10.9347 11.6864L10.9336 11.6855C10.7774 11.5563 10.6989 11.4914 10.5974 11.4914C10.4345 11.4914 10.3849 11.635 10.3101 11.8523C10.0161 12.7045 10.2321 13.376 10.97 13.9035C11.1333 14.0208 11.3766 14.263 11.1724 14.5735C11.0955 14.6905 10.9795 14.7523 10.8368 14.7523C10.7204 14.7523 10.5932 14.7106 10.4684 14.6322C9.42495 13.9749 9.02225 12.6889 9.48927 11.5049C9.65007 11.0968 9.86296 10.7134 10.1216 10.3657C10.2391 10.2071 10.3859 10.1196 10.5341 10.1196C10.682 10.1196 10.8264 10.2074 10.9403 10.3664C11.1347 10.6356 11.3025 10.8279 11.4846 10.9896C11.5814 11.0753 11.6978 11.1638 11.8247 11.1638C12.0355 11.1638 12.1323 10.9341 12.1785 10.8241C12.3613 10.39 12.3746 9.93363 12.3725 9.50299C12.37 8.97032 12.3176 8.4099 12.2085 7.73877Z","fill":"#3E3E3E"})));
}

IcEletricityGasComponent.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IcEletricityGasComponent;

IcEletricityGasComponent.default = IcEletricityGasComponent;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcNetworkComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-network"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M12.6594 5.26668L12.6129 5.09378H7.36641L7.32072 5.26823C7.18837 5.77357 6.93989 6.20744 6.57351 6.57382C6.20713 6.94019 5.77326 7.18868 5.26792 7.32103L5.09347 7.36672V12.6132L5.26638 12.6597C5.89361 12.8286 6.40952 13.1644 6.81997 13.6715C7.22569 14.1726 7.42992 14.7625 7.42992 15.452C7.42992 16.2463 7.14985 16.9204 6.58325 17.487C6.01664 18.0536 5.34254 18.3336 4.5483 18.3336C3.75407 18.3336 3.07997 18.0536 2.51336 17.487C1.94676 16.9204 1.66669 16.2463 1.66669 15.452C1.66669 14.7625 1.87092 14.1726 2.27663 13.6715C2.68709 13.1644 3.203 12.8286 3.83023 12.6597L4.00313 12.6132V7.36799L3.83023 7.32144C3.203 7.15257 2.68709 6.81673 2.27663 6.3097C1.87028 5.80773 1.66669 5.22409 1.66669 4.54861C1.66669 3.75437 1.94676 3.08027 2.51336 2.51367C3.07997 1.94706 3.75407 1.66699 4.5483 1.66699C5.22379 1.66699 5.80743 1.87059 6.30939 2.27694C6.81642 2.68739 7.15226 3.2033 7.32113 3.83053L7.36768 4.00344H12.6129L12.6594 3.83053C12.8283 3.2033 13.1641 2.68739 13.6712 2.27694C14.1723 1.87122 14.7622 1.66699 15.4517 1.66699C16.246 1.66699 16.9201 1.94706 17.4867 2.51367C18.0533 3.08027 18.3333 3.75437 18.3333 4.54861C18.3333 5.34285 18.0533 6.01695 17.4867 6.58355C16.9201 7.15016 16.246 7.43023 15.4517 7.43023C14.7622 7.43023 14.1723 7.226 13.6712 6.82028C13.1641 6.40983 12.8283 5.89392 12.6594 5.26668ZM4.5483 17.2433C5.04072 17.2433 5.46722 17.0613 5.81532 16.7058C6.16076 16.353 6.33958 15.9318 6.33958 15.452C6.33958 14.9612 6.1621 14.5352 5.81359 14.1867C5.46509 13.8382 5.03911 13.6607 4.5483 13.6607C4.06853 13.6607 3.64729 13.8396 3.2945 14.185C2.93899 14.5331 2.75703 14.9596 2.75703 15.452C2.75703 15.9334 2.94036 16.3552 3.29275 16.7076C3.64514 17.06 4.06692 17.2433 4.5483 17.2433ZM4.5483 6.33988C5.03911 6.33988 5.46509 6.1624 5.81359 5.8139C6.1621 5.46539 6.33958 5.03942 6.33958 4.54861C6.33958 4.0578 6.1621 3.63182 5.81359 3.28332C5.46509 2.93482 5.03911 2.75733 4.5483 2.75733C4.06853 2.75733 3.64729 2.93615 3.2945 3.28159C2.93899 3.62969 2.75703 4.05619 2.75703 4.54861C2.75703 5.04103 2.93899 5.46753 3.2945 5.81563C3.64729 6.16106 4.06853 6.33988 4.5483 6.33988ZM15.4517 18.3336C14.6575 18.3336 13.9834 18.0536 13.4168 17.487C12.8502 16.9204 12.5701 16.2463 12.5701 15.452C12.5701 14.6578 12.8502 13.9837 13.4168 13.4171C13.9834 12.8505 14.6575 12.5704 15.4517 12.5704C16.246 12.5704 16.9201 12.8505 17.4867 13.4171C18.0533 13.9837 18.3333 14.6578 18.3333 15.452C18.3333 16.2463 18.0533 16.9204 17.4867 17.487C16.9201 18.0536 16.246 18.3336 15.4517 18.3336ZM15.4517 17.2433C15.9441 17.2433 16.3706 17.0613 16.7187 16.7058C17.0642 16.353 17.243 15.9318 17.243 15.452C17.243 14.9612 17.0655 14.5352 16.717 14.1867C16.3685 13.8382 15.9425 13.6607 15.4517 13.6607C14.9609 13.6607 14.5349 13.8382 14.1864 14.1867C13.8379 14.5352 13.6604 14.9612 13.6604 15.452C13.6604 15.9318 13.8393 16.353 14.1847 16.7058C14.5328 17.0613 14.9593 17.2433 15.4517 17.2433ZM15.4517 6.33988C15.9425 6.33988 16.3685 6.1624 16.717 5.8139C17.0655 5.46539 17.243 5.03942 17.243 4.54861C17.243 4.0578 17.0655 3.63182 16.717 3.28332C16.3685 2.93482 15.9425 2.75733 15.4517 2.75733C14.9609 2.75733 14.5349 2.93482 14.1864 3.28332C13.8379 3.63182 13.6604 4.0578 13.6604 4.54861C13.6604 5.03942 13.8379 5.46539 14.1864 5.8139C14.5349 6.1624 14.9609 6.33988 15.4517 6.33988Z","fill":"#3E3E3E"})));
}

IcNetworkComponent.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IcNetworkComponent;

IcNetworkComponent.default = IcNetworkComponent;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcResultComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-result"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M3.75 3.27051L5 2.02051L6.25 3.27051L7.5 2.02051L8.75 3.27051L10 2.02051L11.25 3.27051L12.5 2.02051L13.75 3.27051L15 2.02051L16.25 3.27051L17.25 2.27051V17.7301L16.25 16.7301L15 17.9801L13.75 16.7301L12.5 17.9801L11.25 16.7301L10 17.9801L8.75 16.7301L7.5 17.9801L6.25 16.7301L5 17.9801L3.75 16.7301L2.75 17.7301V2.27051L3.75 3.27051ZM3.91667 3.83362V16.167H16.0833V3.83362H3.91667ZM5.25 13.917V12.7503H14.75V13.917H5.25ZM5.25 10.5836V9.41695H14.75V10.5836H5.25ZM5.25 7.25029V6.08362H14.75V7.25029H5.25Z","fill":"#3E3E3E"})));
}

IcResultComponent.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IcResultComponent;

IcResultComponent.default = IcResultComponent;


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcSupportComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-support agent"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M8.97695 5.83332C8.97821 5.8284 8.97947 5.82348 8.98073 5.81856C9.01093 5.69993 9.03818 5.57986 9.06249 5.45833C9.12028 5.57391 9.18061 5.68706 9.24348 5.79778C9.25805 5.82343 9.27275 5.84896 9.28759 5.87435C9.83978 6.81923 10.5807 7.58333 11.5104 8.16667C12.5012 8.78834 13.5796 9.12619 14.7455 9.18023C14.7517 9.18052 14.758 9.1808 14.7642 9.18107C14.8424 9.18449 14.921 9.18663 15 9.1875C14.9865 9.10289 14.9713 9.01933 14.9543 8.93682C14.9406 8.87034 14.9257 8.80454 14.9097 8.73942C14.6582 7.71783 14.1224 6.86372 13.3021 6.17708C12.3646 5.39236 11.2778 5 10.0417 5C9.73296 5 9.43496 5.0232 9.14764 5.06961C9.14591 5.06989 9.14419 5.07017 9.14246 5.07045C9.05223 5.08512 8.96306 5.10208 8.87494 5.12132C8.8272 5.13175 8.77978 5.14285 8.73266 5.15462C7.82494 5.3814 7.03211 5.85764 6.35416 6.58333C5.42802 7.57469 4.97967 8.74981 5.0091 10.1087C5.00917 10.1119 5.00924 10.1151 5.00931 10.1184M2.74197 10.3779L2.81166 9.14675C2.91976 8.23555 3.18449 7.39377 3.6051 6.61931C4.02955 5.83778 4.56083 5.1589 5.19902 4.58117C5.83553 4.00496 6.56623 3.55552 7.39296 3.23289C8.21728 2.91121 9.08569 2.75 9.99999 2.75C10.9143 2.75 11.779 2.91121 12.596 3.23264C13.4166 3.55552 14.1483 4.00213 14.7926 4.57259C15.4365 5.14268 15.9667 5.81695 16.3837 6.59701C16.7981 7.37238 17.0666 8.21538 17.1884 9.12786L17.2589 10.35L17.393 10.4134C17.6117 10.5171 17.7784 10.6699 17.8986 10.876C18.0231 11.0894 18.0833 11.31 18.0833 11.5417V13.4583C18.0833 13.6899 18.0231 13.9106 17.8986 14.124C17.7784 14.3301 17.6117 14.4829 17.393 14.5866L17.25 14.6543V15.8333C17.25 16.2248 17.1135 16.5538 16.8336 16.8336C16.5538 17.1135 16.2248 17.25 15.8333 17.25H9.41666V16.0833H16.0833V9.91667C16.0833 8.22649 15.4918 6.78409 14.3122 5.60447C13.1326 4.42486 11.6902 3.83333 9.99999 3.83333C8.30981 3.83333 6.86741 4.42486 5.6878 5.60447C4.50818 6.78409 3.91666 8.22649 3.91666 9.91667V14.75H3.33332C2.94182 14.75 2.6129 14.6135 2.33302 14.3336C2.05314 14.0538 1.91666 13.7248 1.91666 13.3333V11.6667C1.91666 11.4188 1.97806 11.187 2.10283 10.9672C2.22602 10.7501 2.3985 10.5768 2.62525 10.4455L2.74197 10.3779ZM6.53684 6.754C7.18801 6.05697 7.94753 5.60279 8.82115 5.39027L8.81735 5.4093C8.60314 6.48034 8.15218 7.43208 7.4633 8.2681C6.8516 9.01045 6.11712 9.58598 5.25774 9.99612C5.25485 8.7467 5.68071 7.67042 6.53684 6.754ZM10.0417 5.25C9.77405 5.25 9.51523 5.26816 9.26508 5.3045L9.2861 5.34653C9.83536 6.44506 10.6202 7.31299 11.6433 7.9549C12.5802 8.54275 13.5967 8.8667 14.6967 8.92743C14.4719 7.89943 13.9546 7.04929 13.1416 6.36879C12.2496 5.62218 11.2198 5.25 10.0417 5.25ZM7.49999 11.4167C7.32684 11.4167 7.19354 11.3608 7.08302 11.2503C6.97249 11.1398 6.91666 11.0065 6.91666 10.8333C6.91666 10.6602 6.97249 10.5269 7.08302 10.4164C7.19354 10.3058 7.32684 10.25 7.49999 10.25C7.67314 10.25 7.80644 10.3058 7.91696 10.4164C8.02749 10.5269 8.08332 10.6602 8.08332 10.8333C8.08332 11.0065 8.02749 11.1398 7.91696 11.2503C7.80644 11.3608 7.67314 11.4167 7.49999 11.4167ZM12.5 11.4167C12.3268 11.4167 12.1935 11.3608 12.083 11.2503C11.9725 11.1398 11.9167 11.0065 11.9167 10.8333C11.9167 10.6602 11.9725 10.5269 12.083 10.4164C12.1935 10.3058 12.3268 10.25 12.5 10.25C12.6731 10.25 12.8064 10.3058 12.917 10.4164C13.0275 10.5269 13.0833 10.6602 13.0833 10.8333C13.0833 11.0065 13.0275 11.1398 12.917 11.2503C12.8064 11.3608 12.6731 11.4167 12.5 11.4167Z","fill":"#3E3E3E"})));
}

IcSupportComponent.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IcSupportComponent;

IcSupportComponent.default = IcSupportComponent;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcTaxesComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-taxes"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M15.5732 6.65141H11.6791V2.75733H6.53895V14.128H15.5732V6.65141ZM3.42368 17.2433H11.9907V18.3336H3.65733C3.29144 18.3336 2.98403 18.2061 2.72246 17.9445C2.4609 17.683 2.33334 17.3755 2.33334 17.0097V6.33988H3.42368V17.2433ZM9.82973 9.16338C9.6865 9.3066 9.51603 9.37726 9.30374 9.37726C9.09145 9.37726 8.92098 9.3066 8.77775 9.16338C8.63453 9.02015 8.56387 8.84968 8.56387 8.63739C8.56387 8.4251 8.63453 8.25463 8.77775 8.1114C8.92098 7.96817 9.09145 7.89752 9.30374 7.89752C9.51603 7.89752 9.6865 7.96817 9.82973 8.1114C9.97296 8.25463 10.0436 8.4251 10.0436 8.63739C10.0436 8.84968 9.97296 9.02015 9.82973 9.16338ZM13.4515 8.77368L12.6721 7.99429L8.66065 12.0058L9.44003 12.7852L13.4515 8.77368ZM13.3344 12.668C13.1912 12.8113 13.0207 12.8819 12.8084 12.8819C12.5961 12.8819 12.4257 12.8113 12.2824 12.668C12.1392 12.5248 12.0685 12.3543 12.0685 12.1421C12.0685 11.9298 12.1392 11.7593 12.2824 11.6161C12.4257 11.4728 12.5961 11.4022 12.8084 11.4022C13.0207 11.4022 13.1912 11.4728 13.3344 11.6161C13.4776 11.7593 13.5483 11.9298 13.5483 12.1421C13.5483 12.3543 13.4776 12.5248 13.3344 12.668ZM15.3396 15.2184H6.77259C6.4067 15.2184 6.09929 15.0908 5.83773 14.8293C5.57616 14.5677 5.44861 14.2603 5.44861 13.8944V2.99098C5.44861 2.62509 5.57616 2.31768 5.83773 2.05611C6.09929 1.79454 6.4067 1.66699 6.77259 1.66699H12.1275L16.6635 6.20302V13.8944C16.6635 14.2603 16.536 14.5677 16.2744 14.8293C16.0129 15.0908 15.7054 15.2184 15.3396 15.2184Z","fill":"#3E3E3E"})));
}

IcTaxesComponent.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IcTaxesComponent;

IcTaxesComponent.default = IcTaxesComponent;


/***/ }),
/* 288 */
/***/ (function(module, exports) {

function _getPrototypeOf(t) {
  return module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _getPrototypeOf(t);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(721);
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && setPrototypeOf(t, e);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(220)["default"];
var assertThisInitialized = __webpack_require__(219);
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return assertThisInitialized(t);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(62);
var normalizeHeaderName = __webpack_require__(837);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(428);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(428);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(376)))

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_config__ = __webpack_require__(10);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  text-transform: uppercase;\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 14px;\n  box-sizing: border-box;\n  padding: 17px;\n  width: 100%;\n  transition: all 0.2s ease;\n  height: 48px;\n  font-family: \'Nunito\';\n  color: #006736;\n  position: relative;\n  background-image: ',';\n  border-radius: 0px;\n  & > span {\n    position: relative;\n  }\n\n  &:active,\n  &:hover {\n    color: #fff;\n\n    &:before {\n      background-image: ',';\n    }\n  }\n\n  &:before {\n    background-color: ',';\n    height: calc(100% - 2px);\n    width: calc(100% - 2px);\n    position: absolute;\n    top: 1px;\n    left: 1px;\n    content: \'\';\n  }\n'],['\n  text-transform: uppercase;\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 14px;\n  box-sizing: border-box;\n  padding: 17px;\n  width: 100%;\n  transition: all 0.2s ease;\n  height: 48px;\n  font-family: \'Nunito\';\n  color: #006736;\n  position: relative;\n  background-image: ',';\n  border-radius: 0px;\n  & > span {\n    position: relative;\n  }\n\n  &:active,\n  &:hover {\n    color: #fff;\n\n    &:before {\n      background-image: ',';\n    }\n  }\n\n  &:before {\n    background-color: ',';\n    height: calc(100% - 2px);\n    width: calc(100% - 2px);\n    position: absolute;\n    top: 1px;\n    left: 1px;\n    content: \'\';\n  }\n']);var Button=function Button(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InnerButton,{onClick:props.onClick,className:props.className,bgColor:__WEBPACK_IMPORTED_MODULE_4_config__["c" /* backgroundColors */].normalRight},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,props.text),props.children);};Button.defaultProps={enable:true};Button.propTypes={text:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,color:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,onClick:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};var InnerButton=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].button(_templateObject,function(_ref){var bgColor=_ref.bgColor;return bgColor;},function(_ref2){var bgColor=_ref2.bgColor;return bgColor;},function(_ref3){var bg=_ref3.bg;return bg||'#EFEFEF';});/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonConfirm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ubiwherenpm_adene_ui_components__ = __webpack_require__(96);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n\n  margin: 0;\n\n  margin-left: 41px;\n\n  font-family: \'Nunito\', \'Helvetica Neue\', sans-serif;\n  text-transform: uppercase;\n  color: #010101;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 24px;\n  letter-spacing: 1px;\n\n  text-align: center;\n  padding: 28px 0px 28px 0px;\n\n  -webkit-transtion: none;\n  -moz-transition: none;\n  -ms-transition: none;\n  transition: none;\n\n  min-width: 80px;\n  display: inline-block;\n  background: transparent;\n\n  outline: none;\n  cursor: pointer;\n  border-radius: 0px;\n\n  &:hover {\n    color: #ffffff;\n    outline: none;\n    background: ',';\n  }\n\n  ','\n\n  &:focus {\n    ','\n    outline: none;\n  }\n\n  &:first-child {\n    margin-left: 0px;\n  }\n'],['\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n\n  margin: 0;\n\n  margin-left: 41px;\n\n  font-family: \'Nunito\', \'Helvetica Neue\', sans-serif;\n  text-transform: uppercase;\n  color: #010101;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 24px;\n  letter-spacing: 1px;\n\n  text-align: center;\n  padding: 28px 0px 28px 0px;\n\n  -webkit-transtion: none;\n  -moz-transition: none;\n  -ms-transition: none;\n  transition: none;\n\n  min-width: 80px;\n  display: inline-block;\n  background: transparent;\n\n  outline: none;\n  cursor: pointer;\n  border-radius: 0px;\n\n  &:hover {\n    color: #ffffff;\n    outline: none;\n    background: ',';\n  }\n\n  ','\n\n  &:focus {\n    ','\n    outline: none;\n  }\n\n  &:first-child {\n    margin-left: 0px;\n  }\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: auto;\n  display: inline-block;\n  margin-top: 32px;\n'],['\n  width: auto;\n  display: inline-block;\n  margin-top: 32px;\n']);var ButtonConfirm=function(_React$Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ButtonConfirm,_React$Component);function ButtonConfirm(props){__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,ButtonConfirm);var _this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(ButtonConfirm.__proto__||Object.getPrototypeOf(ButtonConfirm)).call(this,props));_this.handleClick=_this.handleClick.bind(_this);var item=props.value!==undefined&&props.value!==null?{value:props.value}:_this.getFirstSelectedItem();_this.state={selected:item.value};return _this;}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ButtonConfirm,[{key:'componentWillMount',value:function componentWillMount(){var item=this.props.value!==undefined&&this.props.value!==null?{value:this.props.value}:this.getFirstSelectedItem();if(this.props.onButtonClick){this.props.onButtonClick(Object.assign({},item,{first:true}));}}},{key:'getFirstSelectedItem',value:function getFirstSelectedItem(){this.props.items&&this.props.items.forEach(function(item){if(item.status)return item;});return this.props.items&&this.props.items[0];}},{key:'handleClick',value:function handleClick(e){if(this.props.onButtonClick){this.props.onButtonClick(Object.assign({},e));}this.setState({selected:e.value});}},{key:'render',value:function render(){var _this2=this;var items=this.props.items;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Container,null,items&&items.map(function(_ref){var value=_ref.value,text=_ref.text,status=_ref.status;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Button,{key:'buttonconfirm-'+value+text,onClick:function onClick(e){_this2.handleClick({value:value});},value:value,bgColor:__WEBPACK_IMPORTED_MODULE_7_config__["c" /* backgroundColors */].normalRight,status:_this2.state.selected===value},text);}));}}]);return ButtonConfirm;}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);var Button=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_8__ubiwherenpm_adene_ui_components__["b" /* SimpleButton */])(_templateObject,function(_ref2){var bgColor=_ref2.bgColor;return bgColor;},function(_ref3){var status=_ref3.status,bgColor=_ref3.bgColor;return status&&'\n    background: '+bgColor+';\n    color: #FFFFFF;\n    border: none;\n  ';},function(_ref4){var status=_ref4.status;return status&&'\n      color: #FFFFFF;\n    ';});var Container=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject2);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TITLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MERCHANT_IDENTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SUPPORT_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return BILLING_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CONTRACT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PAYMENT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ADDITIONAL_RESTRICTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COMERCIAL_CONDITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADDITIONAL_SERVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REFUNDS_ENTRIES; });
var TITLES={IDENTIFICATION:'Identificação',COMERCIAL_CONDITIONS:'Condições comerciais',ADDITIONAL_SERVICES:'Serviços adicionais (obrigatórios e opcionais)',REFUNDS:'Reembolsos'};var MERCHANT_IDENTIFICATION={designation:'Oferta Comercial',commercial_offer_modality:'Modalidade da oferta comercial',description:'Descrição da Oferta Comercial',market_segment_type:'Segmento da oferta',commercial_offer_website:'Endereço web da oferta comercial',website_standardized_contract_form:'Endereço web da ficha contratual padronizada',website_contract_conditions:'Endereço web das condições gerais do contrato',contacts:'Contrato Comercial Telefónico',email_contact:'Contrato Comercial Eletrónico',website_contact:'Contacto Comercial Eletrónico'};var SUPPORT_OPTIONS=[{slug:'w',text:'Por escrito'},{slug:'p',text:'Presencial'},{slug:'t',text:'Telefónico'},{slug:'e',text:'Eletrónico'}];var BILLING_TYPE={electronic_billing:'Electrónica',paper_billing:'Papel'};var CONTRACT_TYPE={email_contract_contact:'Electrónica',location_contract_contact:'Presencial',phone_contract_contact:'Telefone'};var PAYMENT_TYPE={direct_debit:'Débito direto em conta',atm_ctt:'Multibanco / Transferência bancária',shop_payment:'Loja / Agente autorizado'};var ADDITIONAL_RESTRICTIONS={partnerships:'Obriga a parcerias com outras instituições',equipments:'Destina-se a algum tipo de equipamento específico',consumers:'Destina-se a um grupo de consumidores específico',consumptions:'Obriga a consumos de energia mínimos/máximos'};var COMERCIAL_CONDITIONS={offer_type:'Tipo de fornecimento',contract_duration:'Duração do contrato (meses)',offer_start_date:'Data de início da oferta comercial',offer_validity:'Data de validade da oferta comercial',contract_type:'Contratação',billing_type:'Faturação',payment_type:'Métodos de Pagamento',direct_debit:'Débito direto em conta',atm_ctt:'Multibanco / Transferência bancária',shop_payment:'Loja / Agente autorizado',support_options:'Meios de Atendimento',payment_periodicity:'Modalidades de Faturação',has_loyalty:'Fidelização?',loyalty_clauses_description:'Descrição das cláusulas de fidelização, incluindo a penalização por rescisão antecipada',green_energy:'Energia elétrica com origem 100% renovável',has_additional_restrictions:'Restrições adicionais',additional_restrictions:'Restrições adicionais',offer_restrictions:'Detalhe as restrições anteriores e/ou outras aplicáveis.',price_function_of_access:'A tabela de preços é atualizada em função das tarifas de acesso às redes?',price_revision_conditions:'Outras políticas de atualização da tabela de preços',indexed_prices:'Preços indexados - existem mecanismos de revisão de preços inferiores a um ano?'};var ADDITIONAL_SERVICES={required_subscription_additional_services:'Obrigatoriedade de contratação de serviços adicionais?',additional_services_cost:'Custo dos serviços adicionais obrigatórios (€/ano) sem IVA',optional_services_description:'Descrição dos serviços adicionais opcionais relevantes'};var REFUNDS_ENTRIES={has_refunds:'A oferta tem reembolsos?',annual_refunds:'Reembolsos anuais',refunds_description:'Descrição de todos os reembolsos da oferta comercial'};

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config__ = __webpack_require__(10);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 48px;\n  border: ',';\n  flex-grow: 1;\n\n  &:hover,\n  &.selected {\n    border: none;\n    background: ',';\n    padding: 1px;\n  }\n\n  ','\n'],['\n  height: 48px;\n  border: ',';\n  flex-grow: 1;\n\n  &:hover,\n  &.selected {\n    border: none;\n    background: ',';\n    padding: 1px;\n  }\n\n  ','\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  height: 100%;\n  padding: 12px;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 6px;\n  min-width: 160px;\n  cursor: pointer;\n  background: #fff;\n\n  &.selected {\n    background: ',';\n  }\n'],['\n  display: flex;\n  height: 100%;\n  padding: 12px;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 6px;\n  min-width: 160px;\n  cursor: pointer;\n  background: #fff;\n\n  &.selected {\n    background: ',';\n  }\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 20px;\n  width: 20px;\n  margin: 0;\n\n  svg {\n    width: 20px !important;\n    height: 20px !important;\n  }\n'],['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 20px;\n  width: 20px;\n  margin: 0;\n\n  svg {\n    width: 20px !important;\n    height: 20px !important;\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #3e3e3e;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 18px; /* 128.571% */\n  text-transform: capitalize;\n'],['\n  color: #3e3e3e;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 18px; /* 128.571% */\n  text-transform: capitalize;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  width: 20px;\n  height: 20px;\n  position: relative;\n  z-index: 1;\n  cursor: pointer;\n\n  &::before {\n    content: \'\';\n    display: block;\n    position: absolute;\n    inset: 0;\n    border: 1px solid #ececec;\n    background: #f9f9f9;\n    z-index: 2;\n  }\n\n  &::after {\n    content: \'\';\n    position: absolute;\n    display: none;\n    top: 2px;\n    left: 7px;\n    z-index: 3;\n    transform: rotate(45deg);\n    height: 10px;\n    width: 5px;\n    border-bottom: 2px solid #fff;\n    border-right: 2px solid #fff;\n    box-sizing: content-box !important;\n  }\n\n  &:checked {\n    &::before {\n      background: ',';\n      border: none;\n    }\n    &::after {\n      display: inline-block;\n    }\n  }\n\n  &:disabled {\n    cursor: default;\n    pointer-events: none;\n  }\n'],['\n  display: block;\n  width: 20px;\n  height: 20px;\n  position: relative;\n  z-index: 1;\n  cursor: pointer;\n\n  &::before {\n    content: \'\';\n    display: block;\n    position: absolute;\n    inset: 0;\n    border: 1px solid #ececec;\n    background: #f9f9f9;\n    z-index: 2;\n  }\n\n  &::after {\n    content: \'\';\n    position: absolute;\n    display: none;\n    top: 2px;\n    left: 7px;\n    z-index: 3;\n    transform: rotate(45deg);\n    height: 10px;\n    width: 5px;\n    border-bottom: 2px solid #fff;\n    border-right: 2px solid #fff;\n    box-sizing: content-box !important;\n  }\n\n  &:checked {\n    &::before {\n      background: ',';\n      border: none;\n    }\n    &::after {\n      display: inline-block;\n    }\n  }\n\n  &:disabled {\n    cursor: default;\n    pointer-events: none;\n  }\n']);var InlineCheckV2=function InlineCheckV2(_ref){var icon=_ref.icon,name=_ref.name,selected=_ref.selected,onClick=_ref.onClick,style=_ref.style,value=_ref.value,noBackground=_ref.noBackground,disabled=_ref.disabled;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrapperBg,{disabled:disabled,bgColor:__WEBPACK_IMPORTED_MODULE_3_config__["c" /* backgroundColors */].normalLeft,noBackground:noBackground,style:style,className:selected&&'selected'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Wrapper,{onClick:onClick,noBackground:noBackground,className:selected&&'selected'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Input,{type:'checkbox',bgColor:__WEBPACK_IMPORTED_MODULE_3_config__["c" /* backgroundColors */].normalLeft,id:'opt-'+value+'-'+name,name:name,checked:selected,onSelect:onClick}),icon&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(CenteredBox,null,icon),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Title,null,name)));};/* harmony default export */ __webpack_exports__["a"] = (InlineCheckV2);var WrapperBg=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject,function(_ref2){var noBackground=_ref2.noBackground;return noBackground?'1px solid transparent':'1px solid #ECECEC';},function(_ref3){var bgColor=_ref3.bgColor,noBackground=_ref3.noBackground;return noBackground?'transparent':bgColor;},function(_ref4){var disabled=_ref4.disabled;return disabled&&'\n    pointer-events: none;\n    cursor: default;\n    opacity: 0.7;\n  ';});var Wrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject2,function(_ref5){var noBackground=_ref5.noBackground;return noBackground?'transparent':'linear-gradient(0deg, rgba(147, 193, 62, 0.10) 0%, rgba(147, 193, 62, 0.10) 100%), #FFF';});var CenteredBox=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject3);var Title=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject4);var Input=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].input.attrs({type:'checkbox'})(_templateObject5,function(_ref6){var bgColor=_ref6.bgColor;return bgColor;});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-size: 14px;\n  font-weight: bold;\n  text-align: left;\n  width: 100%;\n  display: block;\n  font-family: \'Nunito\';\n  color: #676767;\n  font-family: Nunito;\n  font-weight: 600;\n  line-height: 14px;\n'],['\n  font-size: 14px;\n  font-weight: bold;\n  text-align: left;\n  width: 100%;\n  display: block;\n  font-family: \'Nunito\';\n  color: #676767;\n  font-family: Nunito;\n  font-weight: 600;\n  line-height: 14px;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  border: 1px solid #dedede;\n  color: #3e3e3e;\n  background-color: transparent;\n  display: block;\n  width: 100%;\n  padding: 13px 12px;\n  position: relative;\n  transition: all 0.1s;\n  box-sizing: border-box;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 1px;\n  line-height: 14px;\n  margin-top: 8px;\n  height: 40px;\n\n  &:focus {\n    border-color: #93c13e;\n    outline: none;\n  }\n\n  &.valid {\n    border-color: #93c13e;\n  }\n\n  &.invalid {\n    border-color: indianred;\n  }\n\n  ','\n'],['\n  border: 1px solid #dedede;\n  color: #3e3e3e;\n  background-color: transparent;\n  display: block;\n  width: 100%;\n  padding: 13px 12px;\n  position: relative;\n  transition: all 0.1s;\n  box-sizing: border-box;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 1px;\n  line-height: 14px;\n  margin-top: 8px;\n  height: 40px;\n\n  &:focus {\n    border-color: #93c13e;\n    outline: none;\n  }\n\n  &.valid {\n    border-color: #93c13e;\n  }\n\n  &.invalid {\n    border-color: indianred;\n  }\n\n  ','\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #c13e44;\n  font-size: 12px;\n  font-weight: 400;\n  ','\n  position: absolute;\n'],['\n  color: #c13e44;\n  font-size: 12px;\n  font-weight: 400;\n  ','\n  position: absolute;\n']);var Label=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].label(_templateObject);var InnerInput=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].input(_templateObject2,function(props){return props.valid!==null&&!props.valid&&'border-color: #C13E44 !important;';});var Error=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].span(_templateObject3,function(props){return(props.valid===null||props.valid)&&'display: none;';});var _onChange=function _onChange(event,props){if(props.onlyNumbers){var re=/^[0-9\b]+$/;if(event.target.value&&!re.test(event.target.value)){return false;}}if(props.onlyDecimalNumbers){var _re=/(^[0-9]$)|(^[0-9](.|,)?$)|(^[0-9](.|,){1}[0-9]+$)/;if(event.target.value&&!_re.test(event.target.value)){return false;}}props.onChange(event.target.value);};var Input=function Input(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Label,null,props.label,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InnerInput,{valid:props.valid,value:props.value,type:props.type,autoComplete:'off',onChange:function onChange(e){return _onChange(e,props);},onBlur:function onBlur(e){return props.onBlur&&props.onBlur(props.validator);},placeholder:props.placeholder,maxLength:props.maxLength,className:props.className}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Error,{valid:props.valid},props.errorMessage));};Input.defaultProps={errorMessage:'',valid:true,placeholder:''};Input.propTypes={label:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,type:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,onChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,autoComplete:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,onBlur:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,value:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,valid:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,errorMessage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,placeholder:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,validator:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (Input);

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Form; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FormInputs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return InputsSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomInputsRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RadiosWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return InputWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return StyledSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return InputLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return WrapperSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Error; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_SelectV2__ = __webpack_require__(186);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-self: stretch;\n  flex-grow: 1;\n  width: 100%;\n  height: 100%;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-self: stretch;\n  flex-grow: 1;\n  width: 100%;\n  height: 100%;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 12px 16px 12px 16px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n  flex: 1 0 0;\n  overflow-y: auto;\n'],['\n  display: flex;\n  padding: 12px 16px 12px 16px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n  flex: 1 0 0;\n  overflow-y: auto;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 12px;\n  align-self: stretch;\n\n  > h4 {\n    color: #006736;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 20px;\n    margin: 0;\n    text-transform: none;\n  }\n\n  .rowsWrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n    align-self: stretch;\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 12px;\n  align-self: stretch;\n\n  > h4 {\n    color: #006736;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 20px;\n    margin: 0;\n    text-transform: none;\n  }\n\n  .rowsWrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n    align-self: stretch;\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  align-self: stretch;\n\n  ','\n\n  > label {\n    height: 25px;\n    align-self: stretch;\n    color: #3e3e3e;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n    margin: 0;\n    text-transform: unset;\n\n    b {\n      color: #f00;\n      font-style: normal;\n      font-weight: 400;\n    }\n  }\n'],['\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  align-self: stretch;\n\n  ','\n\n  > label {\n    height: 25px;\n    align-self: stretch;\n    color: #3e3e3e;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n    margin: 0;\n    text-transform: unset;\n\n    b {\n      color: #f00;\n      font-style: normal;\n      font-weight: 400;\n    }\n  }\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  gap: 16px;\n'],['\n  display: flex;\n  align-items: center;\n  gap: 16px;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  flex: 1 0 0;\n'],['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  flex: 1 0 0;\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n\n  > div:first-child {\n    height: 40px;\n  }\n\n  > div {\n    padding: 10px;\n    border: 1px solid #bababa;\n\n    color: #616161;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n  }\n'],['\n  width: 100%;\n\n  > div:first-child {\n    height: 40px;\n  }\n\n  > div {\n    padding: 10px;\n    border: 1px solid #bababa;\n\n    color: #616161;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n  }\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 25px;\n  align-self: stretch;\n  color: #3e3e3e;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  text-transform: unset;\n  margin: 0;\n'],['\n  height: 25px;\n  align-self: stretch;\n  color: #3e3e3e;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  text-transform: unset;\n  margin: 0;\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1 0 0;\n  width: 100%;\n\n  > label {\n    height: 25px;\n    align-self: stretch;\n    color: #3e3e3e;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n\n    b {\n      color: #f00;\n      font-style: normal;\n      font-weight: 400;\n    }\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1 0 0;\n  width: 100%;\n\n  > label {\n    height: 25px;\n    align-self: stretch;\n    color: #3e3e3e;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n\n    b {\n      color: #f00;\n      font-style: normal;\n      font-weight: 400;\n    }\n  }\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: inline-block;\n  font-size: 12px;\n  color: indianred;\n  text-align: left;\n'],['\n  display: inline-block;\n  font-size: 12px;\n  color: indianred;\n  text-align: left;\n']);var Form=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].form(_templateObject);var FormInputs=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2);var InputsSection=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject3);var CustomInputsRow=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject4,function(_ref){var column=_ref.column;return column&&'\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  ';});var RadiosWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject5);var InputWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject6);var StyledSelect=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2_components_SelectV2__["a" /* default */])(_templateObject7);var InputLabel=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].label(_templateObject8);var WrapperSelect=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject9);var Error=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject10);

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Form; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FormInputs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return InputsSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomInputsRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RadiosWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return InputWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return StyledSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return InputLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return WrapperSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Error; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_SelectV2__ = __webpack_require__(186);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-self: stretch;\n  flex-grow: 1;\n  width: 100%;\n  height: 100%;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-self: stretch;\n  flex-grow: 1;\n  width: 100%;\n  height: 100%;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 12px 16px 12px 16px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n  flex: 1 0 0;\n  overflow-y: auto;\n'],['\n  display: flex;\n  padding: 12px 16px 12px 16px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n  flex: 1 0 0;\n  overflow-y: auto;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 12px;\n  align-self: stretch;\n\n  > h4 {\n    color: #006736;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 20px;\n    margin: 0;\n    text-transform: none;\n  }\n\n  .rowsWrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n    gap: 16px;\n    align-self: stretch;\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 12px;\n  align-self: stretch;\n\n  > h4 {\n    color: #006736;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 20px;\n    margin: 0;\n    text-transform: none;\n  }\n\n  .rowsWrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n    gap: 16px;\n    align-self: stretch;\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  width: 100%;\n  align-self: stretch;\n\n  ','\n\n  > label {\n    height: 25px;\n    align-self: stretch;\n    color: #3e3e3e;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n    margin: 0;\n    text-transform: unset;\n\n    b {\n      color: #f00;\n      font-style: normal;\n      font-weight: 400;\n    }\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  width: 100%;\n  align-self: stretch;\n\n  ','\n\n  > label {\n    height: 25px;\n    align-self: stretch;\n    color: #3e3e3e;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n    margin: 0;\n    text-transform: unset;\n\n    b {\n      color: #f00;\n      font-style: normal;\n      font-weight: 400;\n    }\n  }\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  flex: 1 0 0;\n  width: 100%;\n'],['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  flex: 1 0 0;\n  width: 100%;\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n\n  > div:first-child {\n    height: 40px;\n  }\n\n  > div {\n    padding: 10px;\n    border: 1px solid #bababa;\n\n    color: #616161;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n  }\n'],['\n  width: 100%;\n\n  > div:first-child {\n    height: 40px;\n  }\n\n  > div {\n    padding: 10px;\n    border: 1px solid #bababa;\n\n    color: #616161;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n  }\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 25px;\n  align-self: stretch;\n  color: #3e3e3e;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  text-transform: unset;\n  margin: 0;\n'],['\n  height: 25px;\n  align-self: stretch;\n  color: #3e3e3e;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  text-transform: unset;\n  margin: 0;\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1 0 0;\n  width: 100%;\n\n  > label {\n    height: 25px;\n    align-self: stretch;\n    color: #3e3e3e;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n\n    b {\n      color: #f00;\n      font-style: normal;\n      font-weight: 400;\n    }\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1 0 0;\n  width: 100%;\n\n  > label {\n    height: 25px;\n    align-self: stretch;\n    color: #3e3e3e;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n\n    b {\n      color: #f00;\n      font-style: normal;\n      font-weight: 400;\n    }\n  }\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: inline-block;\n  font-size: 12px;\n  color: indianred;\n  text-align: left;\n'],['\n  display: inline-block;\n  font-size: 12px;\n  color: indianred;\n  text-align: left;\n']);var Form=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].form(_templateObject);var FormInputs=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2);var InputsSection=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject3);var CustomInputsRow=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject4,function(_ref){var column=_ref.column;return column&&'\n    gap: 8px;\n  ';});var RadiosWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject5);var InputWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject6);var StyledSelect=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2_components_SelectV2__["a" /* default */])(_templateObject7);var InputLabel=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].label(_templateObject8);var WrapperSelect=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject9);var Error=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject10);

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RadioGroup; });
/* unused harmony export Radio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Label__ = __webpack_require__(134);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  overflow: auto;\n  width: auto;\n  display: inline-block;\n  margin-top: 23px;\n'],['\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  overflow: auto;\n  width: auto;\n  display: inline-block;\n  margin-top: 23px;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  position: relative;\n  float: left;\n\n  @media (max-width: 980px) {\n    float: initial;\n  }\n\n  &:hover {\n    div {\n      background: ',';\n      &::before {\n        background: #ffffff;\n      }\n    }\n  }\n\n  &:before,\n  &:after {\n    content: \'\';\n    display: table;\n  }\n\n  &:after {\n    clear: both;\n  }\n\n  & + & {\n    margin-left: 32px;\n\n    @media (max-width: 980px) {\n      margin-left: 0;\n    }\n  }\n\n  zoom: 1;\n'],['\n  display: block;\n  position: relative;\n  float: left;\n\n  @media (max-width: 980px) {\n    float: initial;\n  }\n\n  &:hover {\n    div {\n      background: ',';\n      &::before {\n        background: #ffffff;\n      }\n    }\n  }\n\n  &:before,\n  &:after {\n    content: \'\';\n    display: table;\n  }\n\n  &:after {\n    clear: both;\n  }\n\n  & + & {\n    margin-left: 32px;\n\n    @media (max-width: 980px) {\n      margin-left: 0;\n    }\n  }\n\n  zoom: 1;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  visibility: hidden;\n  z-index: 6;\n\n  &:checked {\n    ~ div {\n      background: ',';\n      &::before {\n        background: #ffffff;\n      }\n    }\n  }\n'],['\n  display: block;\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  visibility: hidden;\n  z-index: 6;\n\n  &:checked {\n    ~ div {\n      background: ',';\n      &::before {\n        background: #ffffff;\n      }\n    }\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  border: 1px solid #9c9c9c;\n  background-color: #ffffff;\n  top: 8px;\n  left: 0px;\n  border-radius: 100%;\n  z-index: 5;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &::before {\n    display: block;\n    content: \'\';\n    border-radius: 100%;\n    height: 6px;\n    width: 6px;\n    background: #ffffff;\n  }\n'],['\n  display: block;\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  border: 1px solid #9c9c9c;\n  background-color: #ffffff;\n  top: 8px;\n  left: 0px;\n  border-radius: 100%;\n  z-index: 5;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &::before {\n    display: block;\n    content: \'\';\n    border-radius: 100%;\n    height: 6px;\n    width: 6px;\n    background: #ffffff;\n  }\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 12px;\n  text-align: center;\n  margin: 10px auto;\n  padding-left: 19px;\n  cursor: pointer;\n  z-index: 9;\n  @media (max-width: 768px) {\n    text-align: left;\n  }\n'],['\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 12px;\n  text-align: center;\n  margin: 10px auto;\n  padding-left: 19px;\n  cursor: pointer;\n  z-index: 9;\n  @media (max-width: 768px) {\n    text-align: left;\n  }\n']);var Radio=function Radio(_ref){var handleSelection=_ref.handleSelection,props=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_objectWithoutProperties___default()(_ref,['handleSelection']);return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Li,{onClick:function onClick(){return handleSelection();},bgColor:__WEBPACK_IMPORTED_MODULE_8_config__["c" /* backgroundColors */].normalLeft},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Input,{bgColor:__WEBPACK_IMPORTED_MODULE_8_config__["c" /* backgroundColors */].normalLeft,id:'opt-'+props.value+'-'+props.text,name:props.name,checked:props.selected,onChange:function onChange(e){handleSelection();}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledLabel,{'for':'opt-'+props.value+'-'+props.text},props.text),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Check,null));};var RadioGroup=function(_React$Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(RadioGroup,_React$Component);function RadioGroup(){__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,RadioGroup);return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(RadioGroup.__proto__||Object.getPrototypeOf(RadioGroup)).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(RadioGroup,[{key:'render',value:function render(){var _this2=this;var _props=this.props,items=_props.items,onSelectionChange=_props.onSelectionChange,value=_props.value;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Container,null,items&&items.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Radio,{key:'radiogroupitem-'+item.value+item.text,name:_this2.props.name,handleSelection:function handleSelection(){return onSelectionChange(item);},value:item.value,text:item.text,selected:item.value===value});}));}}]);return RadioGroup;}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);var Container=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].ul(_templateObject);var Li=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].li(_templateObject2,function(_ref2){var bgColor=_ref2.bgColor;return bgColor;});var Input=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].input.attrs({type:'radio'})(_templateObject3,function(_ref3){var bgColor=_ref3.bgColor;return bgColor;});var Check=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject4);var StyledLabel=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_9_components_Label__["a" /* default */])(_templateObject5);

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_kea__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_kea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_kea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_containers_AppV2_logic__ = __webpack_require__(97);
var PRICELIST_ENDPOINT=__WEBPACK_IMPORTED_MODULE_2_config__["b" /* API_BASE_URL */]+'/public/price-list/';var MARKET_SEGMENT_ENDPOINT=__WEBPACK_IMPORTED_MODULE_2_config__["b" /* API_BASE_URL */]+'/public/market-segment';/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_kea__["kea"])({connect:{props:[__WEBPACK_IMPORTED_MODULE_7_containers_AppV2_logic__["a" /* default */],['translations']]},actions:function actions(){return{fetchTariffInfo:function fetchTariffInfo(tariff){return{tariff:tariff};},resetTariffInfo:function resetTariffInfo(){return{};},setTariffInfo:function setTariffInfo(tariffInfo){return{tariffInfo:tariffInfo};},setFetchError:function setFetchError(message){return{message:message};},toggleCompareModal:function toggleCompareModal(open){return{open:open};},setCompareList:function setCompareList(list){return{list:list};}};},reducers:function reducers(_ref){var _ref2,_ref3;var actions=_ref.actions;return{tariffInfo:[null,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,(_ref2={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref2,actions.setTariffInfo,function(_,payload){return payload.tariffInfo;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref2,actions.resetTariffInfo,function(){return null;}),_ref2)],loading:[true,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,(_ref3={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3,actions.fetchTariffInfo,function(){return true;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3,actions.setTariffInfo,function(){return false;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3,actions.setFetchError,function(){return false;}),_ref3)],compareModal:[false,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.toggleCompareModal,function(_,payload){return payload.open;})],compareList:[[],__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.setCompareList,function(_,payload){return payload.list;})]};},takeLatest:function takeLatest(_ref6){var actions=_ref6.actions,workers=_ref6.workers;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.fetchTariffInfo,workers.fetchTariffInfo);},workers:{fetchTariffInfo:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchTariffInfo(action){var id,_actions,setTariffInfo,setFetchError,info,data,marketSegmentsList,marketSegmentsData,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,_id,singleMs;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchTariffInfo$(_context){while(1){switch(_context.prev=_context.next){case 0:id=action.payload.tariff.id;_actions=this.actions,setTariffInfo=_actions.setTariffInfo,setFetchError=_actions.setFetchError;if(!id){_context.next=48;break;}_context.prev=3;_context.next=6;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get,''+PRICELIST_ENDPOINT+id+'/');case 6:info=_context.sent;data=info.data;marketSegmentsList=data.pricelistadditionalinfo.market_segment_type||[];marketSegmentsData=[];_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context.prev=13;_iterator=marketSegmentsList[Symbol.iterator]();case 15:if(_iteratorNormalCompletion=(_step=_iterator.next()).done){_context.next=24;break;}_id=_step.value;_context.next=19;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get,MARKET_SEGMENT_ENDPOINT+'/'+_id+'/');case 19:singleMs=_context.sent;marketSegmentsData.push(singleMs.data);case 21:_iteratorNormalCompletion=true;_context.next=15;break;case 24:_context.next=30;break;case 26:_context.prev=26;_context.t0=_context['catch'](13);_didIteratorError=true;_iteratorError=_context.t0;case 30:_context.prev=30;_context.prev=31;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 33:_context.prev=33;if(!_didIteratorError){_context.next=36;break;}throw _iteratorError;case 36:return _context.finish(33);case 37:return _context.finish(30);case 38:data.priceListObject=action.payload.tariff;data.pricelistadditionalinfo.market_segment_type=marketSegmentsData.map(function(_ref8){var name=_ref8.name;return name;}).join(', ');_context.next=42;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setTariffInfo(data));case 42:_context.next=48;break;case 44:_context.prev=44;_context.t1=_context['catch'](3);_context.next=48;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setFetchError(_context.t1));case 48:case'end':return _context.stop();}}},fetchTariffInfo,this,[[3,44],[13,26,30,38],[31,,33,37]]);})}}));

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  line-height: 28px;\n  font-size: 16px;\n  letter-spacing: 1px;\n  color: #010101;\n  text-transform: uppercase;\n  font-weight: normal;\n  text-align: center;\n  margin: 0;\n  font-size: 100;\n  position: relative;\n\n  @media screen and (max-width: 768px) {\n    font-size: 14px;\n    line-height: 14px;\n    max-width: 70%;\n    text-align: center;\n    margin: 0 auto;\n  }\n\n  @media screen and (max-width: 468px) {\n    font-size: 10px;\n    line-height: 14px;\n  }\n'],['\n  line-height: 28px;\n  font-size: 16px;\n  letter-spacing: 1px;\n  color: #010101;\n  text-transform: uppercase;\n  font-weight: normal;\n  text-align: center;\n  margin: 0;\n  font-size: 100;\n  position: relative;\n\n  @media screen and (max-width: 768px) {\n    font-size: 14px;\n    line-height: 14px;\n    max-width: 70%;\n    text-align: center;\n    margin: 0 auto;\n  }\n\n  @media screen and (max-width: 468px) {\n    font-size: 10px;\n    line-height: 14px;\n  }\n']);var SubTitle=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SubTitle,_Component);function SubTitle(){__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,SubTitle);return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(SubTitle.__proto__||Object.getPrototypeOf(SubTitle)).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SubTitle,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(TextElement,{className:this.props.className},this.props.text,this.props.children);}}]);return SubTitle;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SubTitle);var TextElement=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].h3(_templateObject);

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_kea__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_kea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_kea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_omit__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isEmpty__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_mapValues__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_has__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_map__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_isArray__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_qs__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_containers_App_logic__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_config__ = __webpack_require__(10);
var LOCATIONS_ENDPOINT=__WEBPACK_IMPORTED_MODULE_15_config__["b" /* API_BASE_URL */]+'/public/municipality/';var DEFAULT_FILTERS={billing:['any'],no_contract_duration:'any'};var checkIfFiltersIsArray=function checkIfFiltersIsArray(selected){return __WEBPACK_IMPORTED_MODULE_12_lodash_isArray___default()(selected)?__WEBPACK_IMPORTED_MODULE_11_lodash_map___default()(selected,function(e){return e.value;}):selected.value;};var transformLocations=function transformLocations(municipalities){var format=[];municipalities.forEach(function(mun){var found=format.find(function(f){return f.value===mun.district.id;});found&&found.children.push({value:mun.id,label:mun.name});if(!found){format.push({label:mun.district.name,value:mun.district.id,children:[{label:mun.name,value:mun.id}]});}});return format;};var HandleExtras=function HandleExtras(filters,value,condition){var extraFilter=__WEBPACK_IMPORTED_MODULE_10_lodash_has___default()(filters,'extra');var valueOnFilter=false;var valIndex=void 0;if(extraFilter){valIndex=filters.extra.indexOf(value);valueOnFilter=valIndex>-1;}if(extraFilter){if(!valueOnFilter){if(!condition){filters.extra.push(value);}else{filters.extra.splice(valIndex,1);}}else{if(condition){filters.extra.splice(valIndex,1);}}}else{if(!condition){filters.extra=[value];}}};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_kea__["kea"])({actions:function actions(){return{setFilter:function setFilter(selected,item){return{filter:__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},item.fieldName,checkIfFiltersIsArray(selected))};},setFromUrl:function setFromUrl(filters){return{filters:filters};},triggerFilter:function triggerFilter(){return{};},removeFilters:function removeFilters(filters){return{filters:filters};},fetchLocations:function fetchLocations(page){return{page:page};},setLocations:function setLocations(locations){return{locations:locations};},setLocationsFetchError:function setLocationsFetchError(fetchLocationError){return{fetchLocationError:fetchLocationError};},setSetterFlag:function setSetterFlag(){return{};}};},reducers:function reducers(_ref){var _ref2,_ref4;var actions=_ref.actions;return{filters:[DEFAULT_FILTERS,__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,(_ref2={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref2,actions.setFilter,function(state,payload){return Object.assign({},state,payload.filter);}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref2,actions.removeFilters,function(state,payload){return __WEBPACK_IMPORTED_MODULE_7_lodash_omit___default()(state,payload.filters);}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref2,actions.setFromUrl,function(state,payload){return Object.assign({},state,payload.filters);}),_ref2)],locations:[[],__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.setLocations,function(state,payload){return[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(payload.locations));})],setterFromUrl:[false,__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,(_ref4={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref4,actions.setFromUrl,function(){return true;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref4,actions.setSetterFlag,function(){return true;}),_ref4)]};},takeLatest:function takeLatest(_ref5){var _ref6;var actions=_ref5.actions,workers=_ref5.workers;return _ref6={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref6,actions.setFilter,workers.setBrowserHistory),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref6,actions.fetchLocations,workers.fetchLocations),_ref6;},start:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function start(){var _actions,setFromUrl,fetchLocations,setSetterFlag,URLQuery,filtersfromQuery,_ref7,hide_additional;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function start$(_context){while(1){switch(_context.prev=_context.next){case 0:_actions=this.actions,setFromUrl=_actions.setFromUrl,fetchLocations=_actions.fetchLocations,setSetterFlag=_actions.setSetterFlag;_context.next=3;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(fetchLocations(1));case 3:/* eslint-enable camelcase */URLQuery=window.location.search.substring(1);filtersfromQuery=__WEBPACK_IMPORTED_MODULE_13_qs___default.a.parse(URLQuery,{strictNullHandling:true});// Parses number/bools fields correctly
filtersfromQuery=__WEBPACK_IMPORTED_MODULE_9_lodash_mapValues___default()(filtersfromQuery,function(filter){if(filter==='true'){return true;}var convertToNumber=Number(filter);// eslint-disable-next-line eqeqeq
return convertToNumber==filter?convertToNumber:filter;});// Hides additonal services
/* eslint-disable camelcase */_context.next=8;return __WEBPACK_IMPORTED_MODULE_14_containers_App_logic__["a" /* default */].get('values');case 8:_ref7=_context.sent;hide_additional=_ref7.hide_additional;HandleExtras(filtersfromQuery,'as',hide_additional);if(__WEBPACK_IMPORTED_MODULE_8_lodash_isEmpty___default()(filtersfromQuery)){_context.next=16;break;}_context.next=14;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setFromUrl(filtersfromQuery));case 14:_context.next=18;break;case 16:_context.next=18;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setSetterFlag());case 18:case'end':return _context.stop();}}},start,this);}),workers:{setBrowserHistory:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function setBrowserHistory(action){var filters,query,url;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setBrowserHistory$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return this.get('filters');case 2:filters=_context2.sent;query=__WEBPACK_IMPORTED_MODULE_13_qs___default.a.stringify(filters,{strictNullHandling:true});url='?'+query;window.history.pushState('','',url);case 6:case'end':return _context2.stop();}}},setBrowserHistory,this);}),fetchLocations:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchLocations(action){var page,_actions2,setLocations,setLocationsFetchError,params,locations,filteredLocations;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchLocations$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:page=action.payload.page;_actions2=this.actions,setLocations=_actions2.setLocations,setLocationsFetchError=_actions2.setLocationsFetchError;params={page:page,limit:1000};_context3.prev=3;_context3.next=6;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get,LOCATIONS_ENDPOINT,{params:params});case 6:locations=_context3.sent;filteredLocations=transformLocations(locations.data.results);_context3.next=10;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setLocations(filteredLocations));case 10:_context3.next=16;break;case 12:_context3.prev=12;_context3.t0=_context3['catch'](3);_context3.next=16;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setLocationsFetchError(_context3.t0));case 16:case'end':return _context3.stop();}}},fetchLocations,this,[[3,12]]);})}}));

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_kea__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_kea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_kea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isEmpty__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_mapValues__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_qs__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_containers_AppV2_logic__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils__ = __webpack_require__(11);
var ENTITIES_LIST_ENDPOINTS=__WEBPACK_IMPORTED_MODULE_12_config__["b" /* API_BASE_URL */]+'/public/entity/';var DEFAULT_FILTERS={// Tariff filters
price_list_time_cycle:'',// Billing filters
any_billing:false,electronic_billing:false,paper_billing:false,// Payment filters
any_payment:false,direct_debit:false,atm_ctt:false,// More filters
has_additional_restrictions:false,contract_duration:false,indexed_prices:false,is_regulated:false,has_refunds_nc:false,has_refunds:false,green_energy:false,entity_designation:[]// entity_designation: '',
};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_kea__["kea"])({actions:function actions(){return{setFilter:function setFilter(newFilters){return{filter:newFilters};},setFromUrl:function setFromUrl(filters){return{filters:filters};},triggerFilter:function triggerFilter(){return{};},resetFilters:function resetFilters(){return{};},setSetterFlag:function setSetterFlag(){return{};},fetchEntities:function fetchEntities(){return{};},setEntities:function setEntities(entities){return entities;},resetEntities:function resetEntities(){return{};},setSearchedEntities:function setSearchedEntities(entities){return entities;},setEntitiesError:function setEntitiesError(message){return{message:message};},searchEntity:function searchEntity(query,entitiesOptions){return{query:query,entitiesOptions:entitiesOptions};},setEntitiesLimit:function setEntitiesLimit(limit){return{limit:limit};},setEntitiesOffset:function setEntitiesOffset(offset){return{offset:offset};},setEntitiesCount:function setEntitiesCount(count){return{count:count};},setSearchQuery:function setSearchQuery(query){return{query:query};}};},reducers:function reducers(_ref){var _ref2,_ref3,_ref4,_ref5;var actions=_ref.actions;return{filters:[DEFAULT_FILTERS,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,(_ref2={},__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref2,actions.setFilter,function(state,payload){return Object.assign({},state,payload.filter);}),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref2,actions.setFromUrl,function(state,payload){return Object.assign({},state,payload.filters);}),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref2,actions.resetFilters,function(state){return Object.assign({code:state.code},DEFAULT_FILTERS);}),_ref2)],setterFromUrl:[false,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,(_ref3={},__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref3,actions.setFromUrl,function(){return true;}),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref3,actions.setSetterFlag,function(){return true;}),_ref3)],entitiesOptions:[[],__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,(_ref4={},__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref4,actions.setEntities,function(prevState,payload){var entitiesOptions=[].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(prevState));Object.values(payload).forEach(function(entity){if(entity.is_active){entitiesOptions.push({id:entity.id,label:entity.designation,fieldName:'entity_designation',value:false});}});return entitiesOptions;}),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref4,actions.resetEntities,function(){return[];}),_ref4)],searchedEntitiesOptions:[[],__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,(_ref5={},__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref5,actions.setSearchedEntities,function(_,payload){var entitiesOptions=[];Object.values(payload).forEach(function(entity){if(entity.is_active){entitiesOptions.push({id:entity.id,label:entity.designation,fieldName:'entity_designation',value:false});}});return entitiesOptions;}),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref5,actions.resetEntities,function(){return[];}),_ref5)],entitiesError:[null,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({},actions.setEntitiesError,function(state,payload){return payload.message;})],limit:[30,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({},actions.setEntitiesLimit,function(state,payload){return payload.limit;})],offset:[0,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({},actions.setEntitiesOffset,function(state,payload){return payload.offset;})],count:[0,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({},actions.setEntitiesCount,function(state,payload){return payload.count;})],searchQuery:['',__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({},actions.setSearchQuery,function(state,payload){return payload.query;})]};},takeLatest:function takeLatest(_ref11){var _ref12;var actions=_ref11.actions,workers=_ref11.workers;return _ref12={},__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref12,actions.setFilter,workers.setBrowserHistory),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref12,actions.resetFilters,workers.setBrowserHistory),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref12,actions.fetchEntities,workers.fetchEntities),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref12,actions.searchEntity,workers.searchEntity),_ref12;},start:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function start(){var _actions,setFromUrl,setSetterFlag,fetchEntities,URLQuery,filtersfromQuery;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function start$(_context){while(1){switch(_context.prev=_context.next){case 0:_actions=this.actions,setFromUrl=_actions.setFromUrl,setSetterFlag=_actions.setSetterFlag,fetchEntities=_actions.fetchEntities;/* eslint-enable camelcase */URLQuery=window.location.search.substring(1);filtersfromQuery=__WEBPACK_IMPORTED_MODULE_10_qs___default.a.parse(URLQuery,{strictNullHandling:true});// Parses number/bools fields correctly
filtersfromQuery=__WEBPACK_IMPORTED_MODULE_9_lodash_mapValues___default()(filtersfromQuery,function(filter,key){// Converter entities_design de string a array de números
if(key==='entity_designation'&&typeof filter==='string'){if(filter.includes(',')){return filter.split(',').map(function(item){return Number(item);});}// Si es un solo número como string
return[Number(filter)];}if(filter==='true'){return true;}var convertToNumber=Number(filter);// eslint-disable-next-line eqeqeq
return convertToNumber==filter?convertToNumber:filter;});_context.next=6;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(fetchEntities());case 6:if(__WEBPACK_IMPORTED_MODULE_8_lodash_isEmpty___default()(filtersfromQuery)){_context.next=11;break;}_context.next=9;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setFromUrl(filtersfromQuery));case 9:_context.next=13;break;case 11:_context.next=13;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setSetterFlag());case 13:case'end':return _context.stop();}}},start,this);}),workers:{setBrowserHistory:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function setBrowserHistory(action){var filters,trueFilters,query,url;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function setBrowserHistory$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return this.get('filters');case 2:filters=_context2.sent;trueFilters=Object.fromEntries(Object.entries(filters).filter(function(_ref13){var _ref14=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref13,2),_=_ref14[0],value=_ref14[1];if(!value)return false;if(Array.isArray(value)&&value.length===0)return false;return true;}).map(function(_ref15){var _ref16=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref15,2),key=_ref16[0],value=_ref16[1];if(key==='entity_designation'&&Array.isArray(value)){return[key,value.join(',')];}return[key,value];}));query=__WEBPACK_IMPORTED_MODULE_10_qs___default.a.stringify(trueFilters,{strictNullHandling:true});url='?'+query;window.history.pushState('','',url);case 7:case'end':return _context2.stop();}}},setBrowserHistory,this);}),fetchEntities:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function fetchEntities(){var limit,offset,rawValues,values,_actions2,setEntities,setEntitiesError,setEntitiesCount,response;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function fetchEntities$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return this.get('limit');case 2:limit=_context3.sent;_context3.next=5;return this.get('offset');case 5:offset=_context3.sent;_context3.next=8;return __WEBPACK_IMPORTED_MODULE_11_containers_AppV2_logic__["a" /* default */].get('values');case 8:rawValues=_context3.sent;values=Object.assign({},rawValues);_actions2=this.actions,setEntities=_actions2.setEntities,setEntitiesError=_actions2.setEntitiesError,setEntitiesCount=_actions2.setEntitiesCount;_context3.prev=11;_context3.next=14;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_5_axios___default.a.get,ENTITIES_LIST_ENDPOINTS,{params:{limit:limit,offset:offset,offer_types:values.offerType}});case 14:response=_context3.sent;_context3.next=17;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setEntities(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_utils__["c" /* csObjectFromUnderscore */])(response.data.results)));case 17:_context3.next=19;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setEntitiesCount(response.data.count));case 19:_context3.next=25;break;case 21:_context3.prev=21;_context3.t0=_context3['catch'](11);_context3.next=25;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setEntitiesError(_context3.t0));case 25:case'end':return _context3.stop();}}},fetchEntities,this,[[11,21]]);}),searchEntity:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function searchEntity(_ref17){var payload=_ref17.payload;var _actions3,setSearchedEntities,setEntitiesError,setSearchQuery,response;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function searchEntity$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_actions3=this.actions,setSearchedEntities=_actions3.setSearchedEntities,setEntitiesError=_actions3.setEntitiesError,setSearchQuery=_actions3.setSearchQuery;_context4.prev=1;_context4.next=4;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_5_axios___default.a.get,ENTITIES_LIST_ENDPOINTS,{params:{designation:payload.query}});case 4:response=_context4.sent;_context4.next=7;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setSearchQuery(payload.query));case 7:_context4.next=9;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setSearchedEntities(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_utils__["c" /* csObjectFromUnderscore */])(payload.query?response.data.results:[])));case 9:_context4.next=15;break;case 11:_context4.prev=11;_context4.t0=_context4['catch'](1);_context4.next=15;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setEntitiesError(_context4.t0));case 15:case'end':return _context4.stop();}}},searchEntity,this,[[1,11]]);})}}));

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_kea__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_kea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_kea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_saga__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_containers_AppV2_logic__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_containers_SimpleHabitation_logic__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_ResultsSectionV2_logic__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_containers_FiltersSectionV2_logic__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils__ = __webpack_require__(11);
/** Redux and Kea *//** Contants */var SIMULATOR_SUGESTIONS_ENDPOINT=__WEBPACK_IMPORTED_MODULE_3_config__["d" /* API_BASE_URL_V2 */]+'/public/simulator/simulation_price_list_suggestion/';var SIMULATOR_GET_SIMULATION=__WEBPACK_IMPORTED_MODULE_3_config__["d" /* API_BASE_URL_V2 */]+'/public/simulation/:code/';var SIMULATION_PROFILE_ENDPOINT=__WEBPACK_IMPORTED_MODULE_3_config__["b" /* API_BASE_URL */]+'/private/simulation-user-profile/';var ME_ENDPOINT=__WEBPACK_IMPORTED_MODULE_3_config__["b" /* API_BASE_URL */]+'/private/user-profile/me/';var AUTH_TOKEN_KEY='tokenauth';// Simulator url changes depending on the type of the simulator
var SIMULATOR_ENPOINT=__WEBPACK_IMPORTED_MODULE_3_config__["i" /* API_SIMULATION_URL_V2 */]+'/public/simulator/simple/';if(__WEBPACK_IMPORTED_MODULE_3_config__["k" /* isEnterprise */]){SIMULATOR_ENPOINT=__WEBPACK_IMPORTED_MODULE_3_config__["j" /* API_SIMULATION_URL */]+'/public/simulator/enterprise/';}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_kea__["kea"])({path:function path(){return['scenes','resultsV2'];},connect:{actions:[__WEBPACK_IMPORTED_MODULE_9_containers_AppV2_logic__["a" /* default */],['setValue','setValues','setFinished','setIsUserLoggedIn','iframed','changeSimulationData'],__WEBPACK_IMPORTED_MODULE_12_containers_FiltersSectionV2_logic__["a" /* default */],['triggerFilter','resetFilters','setFilter','setSearchQuery','resetEntities','setEntitiesCount','setEntitiesOffset'],__WEBPACK_IMPORTED_MODULE_11_components_ResultsSectionV2_logic__["a" /* default */],['setCompareList']],props:[__WEBPACK_IMPORTED_MODULE_9_containers_AppV2_logic__["a" /* default */],['values','translations','finished','settings'],__WEBPACK_IMPORTED_MODULE_10_containers_SimpleHabitation_logic__["default"],['currentEquipments'],__WEBPACK_IMPORTED_MODULE_12_containers_FiltersSectionV2_logic__["a" /* default */],['filters']]},actions:function actions(){return{makeSimulation:function makeSimulation(){return{};},setSimulationResults:function setSimulationResults(results){return{results:results};},setSimulationSugestions:function setSimulationSugestions(results){return Object.assign({},results);},changePage:function changePage(params){return{params:params};},setError:function setError(error){return Object.assign({},error);},saveProfile:function saveProfile(isNewFromUserWithProfiles){return{isNewFromUserWithProfiles:isNewFromUserWithProfiles};},setPrices:function setPrices(prices){return{prices:prices};},changePrices:function changePrices(type,field,value){return{type:type,field:field,value:value};},setUserProfile:function setUserProfile(profile){return{profile:profile};},openFiltering:function openFiltering(){return{};},closeFiltering:function closeFiltering(){return{};},filter:function filter(){return{};},order:function order(_order){return{order:_order};},fetchUserProfile:function fetchUserProfile(id,name){return{id:id,name:name};},setFetchError:function setFetchError(message){return{message:message};},reset:function reset(){return{};},getCurrentUser:function getCurrentUser(){return{};},setModalTriggerHeight:function setModalTriggerHeight(height){return{height:height};}};},reducers:function reducers(_ref){var _ref2,_ref5,_ref6,_ref7,_ref8,_ref9,_ref10,_ref11,_ref13;var actions=_ref.actions;return{simulation:[{},__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,(_ref2={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref2,actions.setSimulationResults,function(_,payload){return Object.assign({},payload);}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref2,actions.reset,function(){return{};}),_ref2)],modalTriggerHeight:[null,__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.setModalTriggerHeight,function(_,p){return p.height;})],ordering:['annual_billing',__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.order,function(_,p){return p.order;})],sugestions:[{},__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,(_ref5={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref5,actions.setSimulationSugestions,function(_,payload){return Object.assign({},payload);}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref5,actions.reset,function(){return{};}),_ref5)],currentPage:[1,__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,(_ref6={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref6,actions.makeSimulation,function(){return 1;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref6,actions.changePage,function(_,payload){return payload.params.currentPage;}),_ref6)],simulating:[true,__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,(_ref7={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.setSimulationResults,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.makeSimulation,function(){return true;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.setError,function(){return false;}),_ref7)],simulatingPatch:[false,__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,(_ref8={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref8,actions.setSimulationResults,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref8,actions.setError,function(){return false;}),_ref8)],loadingSugested:[true,__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,(_ref9={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref9,actions.makeSimulation,function(){return true;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref9,actions.setSimulationSugestions,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref9,actions.setError,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref9,actions.changePage,function(){return true;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref9,actions.filter,function(){return true;}),_ref9)],error:[false,__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,(_ref10={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref10,actions.setError,function(_,payload){return Object.assign({},payload.error);}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref10,actions.makeSimulation,function(){return false;}),_ref10)],filtering:[false,__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,(_ref11={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref11,actions.openFiltering,function(){return true;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref11,actions.closeFiltering,function(){return false;}),_ref11)],userProfile:[{},__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.setUserProfile,function(state,payload){return payload.profile;})],pricesForm:[{},__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,(_ref13={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref13,actions.setPrices,function(state,payload){return payload.prices;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref13,actions.changePrices,function(state,payload){var type=payload.type;// If no type: is a boolean toggle of field 'apply_refunds'
if(!type){return Object.assign({},state,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},payload.field,!state[payload.field]));}else{return Object.assign({},state,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},type,Object.assign({},state[type],__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},payload.field,payload.value))));}}),_ref13)]};},start:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function start(){var makeSimulation,_ref14,profileFinished;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function start$(_context){while(1){switch(_context.prev=_context.next){case 0:makeSimulation=this.actions.makeSimulation;_context.next=3;return __WEBPACK_IMPORTED_MODULE_9_containers_AppV2_logic__["a" /* default */].get('finished');case 3:_ref14=_context.sent;profileFinished=_ref14.profileFinished;if(profileFinished){_context.next=9;break;}this.props&&this.props.router&&this.props.router.push('/');_context.next=11;break;case 9:_context.next=11;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(makeSimulation());case 11:case'end':return _context.stop();}}},start,this);}),takeLatest:function takeLatest(_ref15){var _ref16;var actions=_ref15.actions,workers=_ref15.workers;return _ref16={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref16,actions.makeSimulation,workers.makeSimulation),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref16,actions.setSimulationResults,workers.fetchSugestions),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref16,actions.changePage,workers.fetchSugestions),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref16,actions.filter,workers.fetchSugestions),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref16,actions.order,workers.fetchSugestions),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref16,actions.triggerFilter,workers.triggerFiltering),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref16,actions.resetFilters,workers.triggerFiltering),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref16,actions.saveProfile,workers.saveProfile),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref16,actions.getCurrentUser,workers.getCurrentUser),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref16,actions.getCurrentUser,workers.getCurrentUser),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref16,actions.fetchUserProfile,workers.fetchUserProfile),_ref16;},workers:{makeSimulation:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function makeSimulation(){var _actions,setSimulationResults,setError,setFinished,setFilter,reset,source,rawValues,values,response,data,urlParams,url,simulationErrorCode,_rawValues,_values,getUrl,_response,_data,_urlParams,_url;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function makeSimulation$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_actions=this.actions,setSimulationResults=_actions.setSimulationResults,setError=_actions.setError,setFinished=_actions.setFinished,setFilter=_actions.setFilter,reset=_actions.reset;source=__WEBPACK_IMPORTED_MODULE_4_axios___default.a.CancelToken.source();// Create a cancel token
_context2.prev=2;_context2.next=5;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(reset());case 5:_context2.next=7;return __WEBPACK_IMPORTED_MODULE_9_containers_AppV2_logic__["a" /* default */].get('values');case 7:rawValues=_context2.sent;values=Object.assign({},rawValues);// Convert to undescore and omit uneeded values
values=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_utils__["a" /* csObjectToUnderscore */])(values);_context2.next=12;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_4_axios___default.a.post,SIMULATOR_ENPOINT,Object.assign({},values,{cancelToken:source.token}));case 12:response=_context2.sent;data=response.data;_context2.next=16;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setFinished({simulationFinished:true,simulationError:false}));case 16:_context2.next=18;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setFilter({code:data.code}));case 18:_context2.next=20;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setSimulationResults(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_utils__["c" /* csObjectFromUnderscore */])(data)));case 20:urlParams=new URLSearchParams(window.location.search);urlParams.set('code',data.code);url=urlParams.toString();window.history.pushState('','','?'+url+window.location.hash);// If is from a profile already loaded
// Save the profile and open the modal
_context2.next=26;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga__["delay"])(800);case 26:if(window.dataLayer){window.dataLayer.push({event:'optimize.activate.results'});}_context2.next=61;break;case 29:_context2.prev=29;_context2.t0=_context2['catch'](2);simulationErrorCode='error';if(!_context2.t0.response.data.simulation_code){_context2.next=56;break;}_context2.next=35;return __WEBPACK_IMPORTED_MODULE_9_containers_AppV2_logic__["a" /* default */].get('values');case 35:_rawValues=_context2.sent;_values=Object.assign({},_rawValues);if(!(_context2.t0.response.data.simulation_code[0]==='Object with code='+_values.simulationCode+' does not exist.')){_context2.next=56;break;}getUrl=SIMULATOR_GET_SIMULATION.replace(':code',_values.simulationCode);_context2.next=41;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get,getUrl);case 41:_response=_context2.sent;_data=_response.data;_context2.next=45;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setFinished({simulationFinished:true,simulationError:false}));case 45:_context2.next=47;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setFilter({code:_data.code}));case 47:_context2.next=49;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setSimulationResults(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_utils__["c" /* csObjectFromUnderscore */])(_data)));case 49:_urlParams=new URLSearchParams(window.location.search);_urlParams.set('code',_data.code);_url=_urlParams.toString();window.history.pushState('','','?'+_url+window.location.hash);// If is from a profile already loaded
// Save the profile and open the modal
_context2.next=55;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga__["delay"])(800);case 55:if(window.dataLayer){window.dataLayer.push({event:'optimize.activate.results'});}case 56:if(typeof _context2.t0.response.data.indexOf==='function'){if(_context2.t0.response.data.indexOf('Electric Price List is Empty')!==-1){simulationErrorCode='no_items';}else if(_context2.t0.response.data.indexOf('Gas Price List is Empty')!==-1){simulationErrorCode='no_items';}else if(_context2.t0.response.data.indexOf('Electronic Consumption Registration : Date Colisions, the start_date of an entry must be higher or equal to the previous end_date')!==-1){simulationErrorCode='electric_registration';}else if(_context2.t0.response.data.indexOf('Gas Consumption Registration : Date Colisions, the start_date of an entry must be higher or equal to the previous end_date')!==-1){simulationErrorCode='gas_registration';}else if(_context2.t0.response.status===504){simulationErrorCode='timeout';}}else if(_context2.t0.response.status===504){simulationErrorCode='timeout';}_context2.next=59;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setFinished({simulationFinished:true,simulationError:true,simulationErrorCode:simulationErrorCode}));case 59:_context2.next=61;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setError(_context2.t0));case 61:_context2.prev=61;_context2.next=64;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["cancelled"])();case 64:if(!_context2.sent){_context2.next=66;break;}source.cancel('Saga was cancelled.');case 66:return _context2.finish(61);case 67:case'end':return _context2.stop();}}},makeSimulation,this,[[2,29,61,67]]);}),fetchSugestions:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function fetchSugestions(action){var _actions2,setSimulationSugestions,setError,setCompareList,_ref17,results,code,ordering,filters,entitiesOptions,values,actionsParams,params,url,response,data;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function fetchSugestions$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_actions2=this.actions,setSimulationSugestions=_actions2.setSimulationSugestions,setError=_actions2.setError,setCompareList=_actions2.setCompareList;_context3.next=3;return this.get('simulation');case 3:_ref17=_context3.sent;results=_ref17.results;code=action.payload.results?action.payload.results.code:results.code;_context3.next=8;return this.get('ordering');case 8:ordering=_context3.sent;_context3.next=11;return __WEBPACK_IMPORTED_MODULE_12_containers_FiltersSectionV2_logic__["a" /* default */].get('filters');case 11:filters=_context3.sent;_context3.next=14;return __WEBPACK_IMPORTED_MODULE_12_containers_FiltersSectionV2_logic__["a" /* default */].get('entitiesOptions');case 14:entitiesOptions=_context3.sent;_context3.next=17;return __WEBPACK_IMPORTED_MODULE_9_containers_AppV2_logic__["a" /* default */].get('values');case 17:values=_context3.sent;actionsParams=action.payload.params?action.payload.params:{};params=Object.assign({limit:10,ordering:ordering,is_active:true},actionsParams);Object.entries(filters).forEach(function(_ref18){var _ref19=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref18,2),key=_ref19[0],value=_ref19[1];if(value&&key!=='any_billing'&&key!=='any_payment'&&key!=='price_list_time_cycle'&&key!=='entity_designation'){return params[key]=value;}else if(key==='price_list_time_cycle'&&value!=='all'){return params[key]=value;}else if(key==='entity_designation'&&value.length>0){var newEntityDesignation='';entitiesOptions.forEach(function(item){if(filters.entity_designation.includes(item.id)){if(!newEntityDesignation){newEntityDesignation=item.label;}else{newEntityDesignation=newEntityDesignation+','+item.label;}}});return params.entity_designation=newEntityDesignation;}});if(params.contract_duration){params.no_contract_duration=!params.contract_duration;delete params.contract_duration;}url=new URLSearchParams();Object.entries(filters).forEach(function(_ref20){var _ref21=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref20,2),key=_ref21[0],value=_ref21[1];if(value&&key!=='entity_designation'){url.set(key,value);}else if(value&&key==='entity_designation'){url.set(key,value.join(','));}});url.set('offer_type',values.offerType);url.set('potencia_contratada',values.potencia_contratada);url.set('ciclo_horario',values.ciclo_horario);url.set('code',code);if(values.gas_stage){url.set('price_step',values.gas_stage);url.set('municipality',values.municipality);}_context3.prev=29;_context3.next=32;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get,SIMULATOR_SUGESTIONS_ENDPOINT,{params:Object.assign({code:code},params)});case 32:response=_context3.sent;data=response.data;data.results=data.results.map(function(item){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_utils__["c" /* csObjectFromUnderscore */])(item);});data.results=data.results.map(function(item){var t=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_utils__["c" /* csObjectFromUnderscore */])(item.electricityPriceList||item.gasPriceList);url.set('id',t.id);return Object.assign({},item,{url:__WEBPACK_IMPORTED_MODULE_3_config__["g" /* PAGE_URL */]+'/tarifarios/?'+url.toString()});});_context3.next=38;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setSimulationSugestions(data));case 38:if(!(action.type!=='change page (resultsV2)')){_context3.next=41;break;}_context3.next=41;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setCompareList([]));case 41:_context3.next=43;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga__["delay"])(600);case 43:if(window.dataLayer){window.dataLayer.push({event:'optimize.activate.results'});}_context3.next=52;break;case 46:_context3.prev=46;_context3.t0=_context3['catch'](29);_context3.next=50;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setError(_context3.t0));case 50:_context3.next=52;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setSimulationSugestions([]));case 52:case'end':return _context3.stop();}}},fetchSugestions,this,[[29,46]]);}),/**
     * Triggers fetching when filtering
     * @param {Object} action Caller action
     */triggerFiltering:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function triggerFiltering(action){var filter;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function triggerFiltering$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:filter=this.actions.filter;_context4.next=3;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga__["delay"])(100);case 3:_context4.next=5;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(filter());case 5:case'end':return _context4.stop();}}},triggerFiltering,this);}),/**
     * Saves the simulation profile to the user account
     * Flow: https://projects.invisionapp.com/d/main#/console/11390927/270514272/preview
     */saveProfile:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function saveProfile(action){var setFetchError,userLoggedIn,simulation,isNewFromUserWithProfiles,modalDetails,requestProfiles,profiles,hasProfiles,nextHouseNumber,saveData,saveRequest,saved;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function saveProfile$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:setFetchError=this.actions.setFetchError;_context5.next=3;return __WEBPACK_IMPORTED_MODULE_9_containers_AppV2_logic__["a" /* default */].get('userLoggedIn');case 3:userLoggedIn=_context5.sent;_context5.next=6;return this.get('simulation');case 6:simulation=_context5.sent;isNewFromUserWithProfiles=action.payload.isNewFromUserWithProfiles;modalDetails={loggedIn:!!userLoggedIn,opened:true};_context5.prev=9;if(!userLoggedIn){_context5.next=32;break;}_context5.next=13;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get,SIMULATION_PROFILE_ENDPOINT);case 13:requestProfiles=_context5.sent;profiles=requestProfiles.data.results;hasProfiles=!!profiles.length;modalDetails.profiles=profiles;modalDetails.hasProfiles=hasProfiles;// If user does not have profiles do save
if(!(!hasProfiles||isNewFromUserWithProfiles)){_context5.next=29;break;}nextHouseNumber=profiles.length+1;saveData={name:(__WEBPACK_IMPORTED_MODULE_3_config__["k" /* isEnterprise */]?'Empresa':'Casa')+' '+nextHouseNumber,simulation_history:simulation.results.code};_context5.next=23;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_4_axios___default.a.post,SIMULATION_PROFILE_ENDPOINT,saveData);case 23:saveRequest=_context5.sent;saved=saveRequest.data;modalDetails.saved=saved;modalDetails.type='saved';_context5.next=30;break;case 29:modalDetails.type='update';case 30:_context5.next=33;break;case 32:modalDetails.type='notlogged';case 33:_context5.next=39;break;case 35:_context5.prev=35;_context5.t0=_context5['catch'](9);_context5.next=39;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setFetchError(_context5.t0));case 39:case'end':return _context5.stop();}}},saveProfile,this,[[9,35]]);}),/**
     * If is simulation on user profile, get user house
     */fetchUserProfile:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function fetchUserProfile(action){var setUserProfile,id,url,request;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function fetchUserProfile$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:setUserProfile=this.actions.setUserProfile;id=action.payload.id;url=''+SIMULATION_PROFILE_ENDPOINT+id+'/';_context6.prev=3;_context6.next=6;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get,url);case 6:request=_context6.sent;_context6.next=9;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setUserProfile(request.data));case 9:_context6.next=14;break;case 11:_context6.prev=11;_context6.t0=_context6['catch'](3);console.log(_context6.t0);case 14:case'end':return _context6.stop();}}},fetchUserProfile,this,[[3,11]]);}),/**
     * Gets current user logged in
     */getCurrentUser:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function getCurrentUser(){var _actions3,setIsUserLoggedIn,saveProfile,token,me;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function getCurrentUser$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_actions3=this.actions,setIsUserLoggedIn=_actions3.setIsUserLoggedIn,saveProfile=_actions3.saveProfile;_context7.prev=1;token=window.localStorage.getItem(AUTH_TOKEN_KEY);if(token){_context7.next=7;break;}_context7.next=6;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setIsUserLoggedIn(false));case 6:return _context7.abrupt('return');case 7:_context7.next=9;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get,ME_ENDPOINT,{headers:{Authorization:'JWT '+token}});case 9:me=_context7.sent;_context7.next=12;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setIsUserLoggedIn(me.data));case 12:__WEBPACK_IMPORTED_MODULE_4_axios___default.a.defaults.headers.common['Authorization']='JWT '+token;_context7.next=15;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(saveProfile());case 15:_context7.next=23;break;case 17:_context7.prev=17;_context7.t0=_context7['catch'](1);_context7.next=21;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setIsUserLoggedIn(false));case 21:window.localStorage.removeItem(AUTH_TOKEN_KEY);delete __WEBPACK_IMPORTED_MODULE_4_axios___default.a.defaults.headers.common['Authorization'];case 23:case'end':return _context7.stop();}}},getCurrentUser,this,[[1,17]]);})}}));

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(951);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(950);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(150);

var callBind = __webpack_require__(307);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(351);
var GetIntrinsic = __webpack_require__(150);
var setFunctionLength = __webpack_require__(1616);

var $TypeError = __webpack_require__(149);
var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $defineProperty = __webpack_require__(348);
var $max = GetIntrinsic('%Math.max%');

module.exports = function callBind(originalFunction) {
	if (typeof originalFunction !== 'function') {
		throw new $TypeError('a function is required');
	}
	var func = $reflectApply(bind, $call, arguments);
	return setFunctionLength(
		func,
		1 + $max(0, originalFunction.length - (arguments.length - 1)),
		true
	);
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(188);
var TAG = __webpack_require__(49)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 309 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(87);
var document = __webpack_require__(45).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 311 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(230);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(75);
var dPs = __webpack_require__(471);
var enumBugKeys = __webpack_require__(311);
var IE_PROTO = __webpack_require__(315)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(310)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(463).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 314 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(316)('keys');
var uid = __webpack_require__(235);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(34);
var global = __webpack_require__(45);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(189) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 317 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(317);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(87);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(45);
var core = __webpack_require__(34);
var LIBRARY = __webpack_require__(189);
var wksExt = __webpack_require__(321);
var defineProperty = __webpack_require__(88).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(49);


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(308);
var ITERATOR = __webpack_require__(49)('iterator');
var Iterators = __webpack_require__(141);
module.exports = __webpack_require__(34).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(339)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(46);
var toAbsoluteIndex = __webpack_require__(119);
var toLength = __webpack_require__(31);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(39);
var createDesc = __webpack_require__(118);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var document = __webpack_require__(19).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 327 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(28)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(19).document;
module.exports = document && document.documentElement;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var setPrototypeOf = __webpack_require__(337).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(144);
var ITERATOR = __webpack_require__(28)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(20);
var cof = __webpack_require__(89);
var MATCH = __webpack_require__(28)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(113);
var $export = __webpack_require__(3);
var redefine = __webpack_require__(57);
var hide = __webpack_require__(64);
var Iterators = __webpack_require__(144);
var $iterCreate = __webpack_require__(492);
var setToStringTag = __webpack_require__(147);
var getPrototypeOf = __webpack_require__(116);
var ITERATOR = __webpack_require__(28)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 334 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 335 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(240);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(20);
var anObject = __webpack_require__(17);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(79)(Function.call, __webpack_require__(80).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(246)('keys');
var uid = __webpack_require__(120);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(82);
var defined = __webpack_require__(90);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(332);
var defined = __webpack_require__(90);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(82);
var defined = __webpack_require__(90);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 342 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(79);
var invoke = __webpack_require__(489);
var html = __webpack_require__(329);
var cel = __webpack_require__(326);
var global = __webpack_require__(19);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(89)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(19);
var DESCRIPTORS = __webpack_require__(38);
var LIBRARY = __webpack_require__(113);
var $typed = __webpack_require__(247);
var hide = __webpack_require__(64);
var redefineAll = __webpack_require__(145);
var fails = __webpack_require__(18);
var anInstance = __webpack_require__(143);
var toInteger = __webpack_require__(82);
var toLength = __webpack_require__(31);
var toIndex = __webpack_require__(507);
var gOPN = __webpack_require__(115).f;
var dP = __webpack_require__(39).f;
var arrayFill = __webpack_require__(324);
var setToStringTag = __webpack_require__(147);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(28);


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(192);
var ITERATOR = __webpack_require__(28)('iterator');
var Iterators = __webpack_require__(144);
module.exports = __webpack_require__(35).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(112);
var step = __webpack_require__(493);
var Iterators = __webpack_require__(144);
var toIObject = __webpack_require__(65);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(333)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(150);

/** @type {import('.')} */
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true) || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/informacao.a1505958.svg";

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(1240);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;

var _LocationUtils = __webpack_require__(122);

var _DOMUtils = __webpack_require__(196);

var _DOMStateStorage = __webpack_require__(525);

var _PathUtils = __webpack_require__(100);

/* eslint-disable no-alert */


var PopStateEvent = 'popstate';

var _createLocation = function _createLocation(historyState) {
  var key = historyState && historyState.key;

  return (0, _LocationUtils.createLocation)({
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
  }, undefined, key);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  var historyState = void 0;
  try {
    historyState = window.history.state || {};
  } catch (error) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/mjackson/history/pull/289
    historyState = {};
  }

  return _createLocation(historyState);
};

var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
  return callback(window.confirm(message));
};

var startListener = exports.startListener = function startListener(listener) {
  var handlePopState = function handlePopState(event) {
    if (event.state !== undefined) // Ignore extraneous popstate events in WebKit
      listener(_createLocation(event.state));
  };

  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
  };
};

var updateLocation = function updateLocation(location, updateState) {
  var state = location.state;
  var key = location.key;


  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);

  updateState({ key: key }, (0, _PathUtils.createPath)(location));
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.pushState(state, null, path);
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.replaceState(state, null, path);
  });
};

var go = exports.go = function go(n) {
  if (n) window.history.go(n);
};

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AsyncUtils = __webpack_require__(1244);

var _PathUtils = __webpack_require__(100);

var _runTransitionHook = __webpack_require__(355);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _Actions = __webpack_require__(252);

var _LocationUtils = __webpack_require__(122);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var createHistory = function createHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
  var getCurrentLocation = options.getCurrentLocation;
  var getUserConfirmation = options.getUserConfirmation;
  var pushLocation = options.pushLocation;
  var replaceLocation = options.replaceLocation;
  var go = options.go;
  var keyLength = options.keyLength;


  var currentLocation = void 0;
  var pendingLocation = void 0;
  var beforeListeners = [];
  var listeners = [];
  var allKeys = [];

  var getCurrentIndex = function getCurrentIndex() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);

    if (currentLocation) return allKeys.indexOf(currentLocation.key);

    return -1;
  };

  var updateLocation = function updateLocation(nextLocation) {
    currentLocation = nextLocation;

    var currentIndex = getCurrentIndex();

    if (currentLocation.action === _Actions.PUSH) {
      allKeys = [].concat(_toConsumableArray(allKeys.slice(0, currentIndex + 1)), [currentLocation.key]);
    } else if (currentLocation.action === _Actions.REPLACE) {
      allKeys[currentIndex] = currentLocation.key;
    }

    listeners.forEach(function (listener) {
      return listener(currentLocation);
    });
  };

  var listenBefore = function listenBefore(listener) {
    beforeListeners.push(listener);

    return function () {
      return beforeListeners = beforeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var listen = function listen(listener) {
    listeners.push(listener);

    return function () {
      return listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
        return result != null ? done(result) : next();
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          return callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  };

  var transitionTo = function transitionTo(nextLocation) {
    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation

      pendingLocation = null;

      if (ok) {
        // Treat PUSH to same path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = (0, _PathUtils.createPath)(currentLocation);
          var nextPath = (0, _PathUtils.createPath)(nextLocation);

          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (nextLocation.action === _Actions.POP) {
          updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.PUSH) {
          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.REPLACE) {
          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
        }
      } else if (currentLocation && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(currentLocation.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
      }
    });
  };

  var push = function push(input) {
    return transitionTo(createLocation(input, _Actions.PUSH));
  };

  var replace = function replace(input) {
    return transitionTo(createLocation(input, _Actions.REPLACE));
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength || 6);
  };

  var createHref = function createHref(location) {
    return (0, _PathUtils.createPath)(location);
  };

  var createLocation = function createLocation(location, action) {
    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
    return (0, _LocationUtils.createLocation)(location, action, key);
  };

  return {
    getCurrentLocation: getCurrentLocation,
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: _PathUtils.createPath,
    createHref: createHref,
    createLocation: createLocation
  };
};

exports.default = createHistory;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _warning = __webpack_require__(151);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var runTransitionHook = function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
  }
};

exports.default = runTransitionHook;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pathSelector = pathSelector;
exports.safePathSelector = safePathSelector;
exports.createSelectors = createSelectors;

var _reselect = __webpack_require__(281);

// input: ['scenes', 'something', 'other'], state
// output: state.scenes.something.other
function pathSelector(path, state) {
  return [state].concat(path).reduce(function (v, a) {
    return v[a];
  });
}

function safePathSelector(path, state) {
  return [state].concat(path).reduce(function (v, a) {
    return (v || {})[a];
  });
}

// input: ['states', 'something', 'other'], ['key1', 'key2', 'key3'], { bla: 'asdf' }
// output: {
//   root: (state) => states.something.other,
//   key1: (state) => states.something.other.key1,
//   key2: (state) => states.something.other.key2,
//   key3: (state) => states.something.other.key3,
//   bla: 'asdf'
// }
function createSelectors(path, keys) {
  var additional = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var rootSelector = function rootSelector(state) {
    return pathSelector(path, state);
  };

  var selectors = {
    root: rootSelector
  };

  keys.forEach(function (key) {
    selectors[key] = (0, _reselect.createSelector)(rootSelector, function (state) {
      return state[key];
    });
  });

  return Object.assign(selectors, additional);
}

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(125),
    root = __webpack_require__(66);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1359),
    mapCacheDelete = __webpack_require__(1360),
    mapCacheGet = __webpack_require__(1361),
    mapCacheHas = __webpack_require__(1362),
    mapCacheSet = __webpack_require__(1363);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 360 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(153),
    eq = __webpack_require__(158);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(363),
    createBaseEach = __webpack_require__(1332);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(538),
    keys = __webpack_require__(102);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(256),
    baseIsEqual = __webpack_require__(258);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(531);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 366 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(560),
    keys = __webpack_require__(102);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(563);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(1279),
    stubArray = __webpack_require__(580);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(23),
    isSymbol = __webpack_require__(162);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(532),
    baseEach = __webpack_require__(362),
    castFunction = __webpack_require__(1322),
    isArray = __webpack_require__(23);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 372 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60), __webpack_require__(218)(module)))

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(123),
    copyArray = __webpack_require__(366),
    getTag = __webpack_require__(126),
    isArrayLike = __webpack_require__(83),
    isString = __webpack_require__(576),
    iteratorToArray = __webpack_require__(1353),
    mapToArray = __webpack_require__(561),
    setToArray = __webpack_require__(263),
    stringToArray = __webpack_require__(1378),
    values = __webpack_require__(1423);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Built-in value references. */
var symIterator = Symbol ? Symbol.iterator : undefined;

/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */
function toArray(value) {
  if (!value) {
    return [];
  }
  if (isArrayLike(value)) {
    return isString(value) ? stringToArray(value) : copyArray(value);
  }
  if (symIterator && value[symIterator]) {
    return iteratorToArray(value[symIterator]());
  }
  var tag = getTag(value),
      func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

  return func(value);
}

module.exports = toArray;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(92),
    baseUniq = __webpack_require__(544);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),
/* 376 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(1433);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var stringify = __webpack_require__(602);

var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined'
      ? global
      : typeof self !== 'undefined'
        ? self
        : {};

function isObject(what) {
  return typeof what === 'object' && what !== null;
}

// Yanked from https://git.io/vS8DV re-used under CC0
// with some tiny modifications
function isError(value) {
  switch (Object.prototype.toString.call(value)) {
    case '[object Error]':
      return true;
    case '[object Exception]':
      return true;
    case '[object DOMException]':
      return true;
    default:
      return value instanceof Error;
  }
}

function isErrorEvent(value) {
  return Object.prototype.toString.call(value) === '[object ErrorEvent]';
}

function isDOMError(value) {
  return Object.prototype.toString.call(value) === '[object DOMError]';
}

function isDOMException(value) {
  return Object.prototype.toString.call(value) === '[object DOMException]';
}

function isUndefined(what) {
  return what === void 0;
}

function isFunction(what) {
  return typeof what === 'function';
}

function isPlainObject(what) {
  return Object.prototype.toString.call(what) === '[object Object]';
}

function isString(what) {
  return Object.prototype.toString.call(what) === '[object String]';
}

function isArray(what) {
  return Object.prototype.toString.call(what) === '[object Array]';
}

function isEmptyObject(what) {
  if (!isPlainObject(what)) return false;

  for (var _ in what) {
    if (what.hasOwnProperty(_)) {
      return false;
    }
  }
  return true;
}

function supportsErrorEvent() {
  try {
    new ErrorEvent(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsDOMError() {
  try {
    new DOMError(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsDOMException() {
  try {
    new DOMException(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsFetch() {
  if (!('fetch' in _window)) return false;

  try {
    new Headers(); // eslint-disable-line no-new
    new Request(''); // eslint-disable-line no-new
    new Response(); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

// Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
// https://caniuse.com/#feat=referrer-policy
// It doesn't. And it throw exception instead of ignoring this parameter...
// REF: https://github.com/getsentry/raven-js/issues/1233
function supportsReferrerPolicy() {
  if (!supportsFetch()) return false;

  try {
    // eslint-disable-next-line no-new
    new Request('pickleRick', {
      referrerPolicy: 'origin'
    });
    return true;
  } catch (e) {
    return false;
  }
}

function supportsPromiseRejectionEvent() {
  return typeof PromiseRejectionEvent === 'function';
}

function wrappedCallback(callback) {
  function dataCallback(data, original) {
    var normalizedData = callback(data) || data;
    if (original) {
      return original(normalizedData) || normalizedData;
    }
    return normalizedData;
  }

  return dataCallback;
}

function each(obj, callback) {
  var i, j;

  if (isUndefined(obj.length)) {
    for (i in obj) {
      if (hasKey(obj, i)) {
        callback.call(null, i, obj[i]);
      }
    }
  } else {
    j = obj.length;
    if (j) {
      for (i = 0; i < j; i++) {
        callback.call(null, i, obj[i]);
      }
    }
  }
}

function objectMerge(obj1, obj2) {
  if (!obj2) {
    return obj1;
  }
  each(obj2, function(key, value) {
    obj1[key] = value;
  });
  return obj1;
}

/**
 * This function is only used for react-native.
 * react-native freezes object that have already been sent over the
 * js bridge. We need this function in order to check if the object is frozen.
 * So it's ok that objectFrozen returns false if Object.isFrozen is not
 * supported because it's not relevant for other "platforms". See related issue:
 * https://github.com/getsentry/react-native-sentry/issues/57
 */
function objectFrozen(obj) {
  if (!Object.isFrozen) {
    return false;
  }
  return Object.isFrozen(obj);
}

function truncate(str, max) {
  if (typeof max !== 'number') {
    throw new Error('2nd argument to `truncate` function should be a number');
  }
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : str.substr(0, max) + '\u2026';
}

/**
 * hasKey, a better form of hasOwnProperty
 * Example: hasKey(MainHostObject, property) === true/false
 *
 * @param {Object} host object to check property
 * @param {string} key to check
 */
function hasKey(object, key) {
  return Object.prototype.hasOwnProperty.call(object, key);
}

function joinRegExp(patterns) {
  // Combine an array of regular expressions and strings into one large regexp
  // Be mad.
  var sources = [],
    i = 0,
    len = patterns.length,
    pattern;

  for (; i < len; i++) {
    pattern = patterns[i];
    if (isString(pattern)) {
      // If it's a string, we need to escape it
      // Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
      sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'));
    } else if (pattern && pattern.source) {
      // If it's a regexp already, we want to extract the source
      sources.push(pattern.source);
    }
    // Intentionally skip other cases
  }
  return new RegExp(sources.join('|'), 'i');
}

function urlencode(o) {
  var pairs = [];
  each(o, function(key, value) {
    pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
  });
  return pairs.join('&');
}

// borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
// intentionally using regex and not <a/> href parsing trick because React Native and other
// environments where DOM might not be available
function parseUrl(url) {
  if (typeof url !== 'string') return {};
  var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  // coerce to undefined values to empty string so we don't get 'undefined'
  var query = match[6] || '';
  var fragment = match[8] || '';
  return {
    protocol: match[2],
    host: match[4],
    path: match[5],
    relative: match[5] + query + fragment // everything minus origin
  };
}
function uuid4() {
  var crypto = _window.crypto || _window.msCrypto;

  if (!isUndefined(crypto) && crypto.getRandomValues) {
    // Use window.crypto API if available
    // eslint-disable-next-line no-undef
    var arr = new Uint16Array(8);
    crypto.getRandomValues(arr);

    // set 4 in byte 7
    arr[3] = (arr[3] & 0xfff) | 0x4000;
    // set 2 most significant bits of byte 9 to '10'
    arr[4] = (arr[4] & 0x3fff) | 0x8000;

    var pad = function(num) {
      var v = num.toString(16);
      while (v.length < 4) {
        v = '0' + v;
      }
      return v;
    };

    return (
      pad(arr[0]) +
      pad(arr[1]) +
      pad(arr[2]) +
      pad(arr[3]) +
      pad(arr[4]) +
      pad(arr[5]) +
      pad(arr[6]) +
      pad(arr[7])
    );
  } else {
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @param elem
 * @returns {string}
 */
function htmlTreeAsString(elem) {
  /* eslint no-extra-parens:0*/
  var MAX_TRAVERSE_HEIGHT = 5,
    MAX_OUTPUT_LEN = 80,
    out = [],
    height = 0,
    len = 0,
    separator = ' > ',
    sepLength = separator.length,
    nextStr;

  while (elem && height++ < MAX_TRAVERSE_HEIGHT) {
    nextStr = htmlElementAsString(elem);
    // bail out if
    // - nextStr is the 'html' element
    // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
    //   (ignore this limit if we are on the first iteration)
    if (
      nextStr === 'html' ||
      (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)
    ) {
      break;
    }

    out.push(nextStr);

    len += nextStr.length;
    elem = elem.parentNode;
  }

  return out.reverse().join(separator);
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @param HTMLElement
 * @returns {string}
 */
function htmlElementAsString(elem) {
  var out = [],
    className,
    classes,
    key,
    attr,
    i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());
  if (elem.id) {
    out.push('#' + elem.id);
  }

  className = elem.className;
  if (className && isString(className)) {
    classes = className.split(/\s+/);
    for (i = 0; i < classes.length; i++) {
      out.push('.' + classes[i]);
    }
  }
  var attrWhitelist = ['type', 'name', 'title', 'alt'];
  for (i = 0; i < attrWhitelist.length; i++) {
    key = attrWhitelist[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push('[' + key + '="' + attr + '"]');
    }
  }
  return out.join('');
}

/**
 * Returns true if either a OR b is truthy, but not both
 */
function isOnlyOneTruthy(a, b) {
  return !!(!!a ^ !!b);
}

/**
 * Returns true if both parameters are undefined
 */
function isBothUndefined(a, b) {
  return isUndefined(a) && isUndefined(b);
}

/**
 * Returns true if the two input exception interfaces have the same content
 */
function isSameException(ex1, ex2) {
  if (isOnlyOneTruthy(ex1, ex2)) return false;

  ex1 = ex1.values[0];
  ex2 = ex2.values[0];

  if (ex1.type !== ex2.type || ex1.value !== ex2.value) return false;

  // in case both stacktraces are undefined, we can't decide so default to false
  if (isBothUndefined(ex1.stacktrace, ex2.stacktrace)) return false;

  return isSameStacktrace(ex1.stacktrace, ex2.stacktrace);
}

/**
 * Returns true if the two input stack trace interfaces have the same content
 */
function isSameStacktrace(stack1, stack2) {
  if (isOnlyOneTruthy(stack1, stack2)) return false;

  var frames1 = stack1.frames;
  var frames2 = stack2.frames;

  // Exit early if stacktrace is malformed
  if (frames1 === undefined || frames2 === undefined) return false;

  // Exit early if frame count differs
  if (frames1.length !== frames2.length) return false;

  // Iterate through every frame; bail out if anything differs
  var a, b;
  for (var i = 0; i < frames1.length; i++) {
    a = frames1[i];
    b = frames2[i];
    if (
      a.filename !== b.filename ||
      a.lineno !== b.lineno ||
      a.colno !== b.colno ||
      a['function'] !== b['function']
    )
      return false;
  }
  return true;
}

/**
 * Polyfill a method
 * @param obj object e.g. `document`
 * @param name method name present on object e.g. `addEventListener`
 * @param replacement replacement function
 * @param track {optional} record instrumentation to an array
 */
function fill(obj, name, replacement, track) {
  if (obj == null) return;
  var orig = obj[name];
  obj[name] = replacement(orig);
  obj[name].__raven__ = true;
  obj[name].__orig__ = orig;
  if (track) {
    track.push([obj, name, orig]);
  }
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns {string}
 */
function safeJoin(input, delimiter) {
  if (!isArray(input)) return '';

  var output = [];

  for (var i = 0; i < input.length; i++) {
    try {
      output.push(String(input[i]));
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

// Default Node.js REPL depth
var MAX_SERIALIZE_EXCEPTION_DEPTH = 3;
// 50kB, as 100kB is max payload size, so half sounds reasonable
var MAX_SERIALIZE_EXCEPTION_SIZE = 50 * 1024;
var MAX_SERIALIZE_KEYS_LENGTH = 40;

function utf8Length(value) {
  return ~-encodeURI(value).split(/%..|./).length;
}

function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}

function serializeValue(value) {
  if (typeof value === 'string') {
    var maxLength = 40;
    return truncate(value, maxLength);
  } else if (
    typeof value === 'number' ||
    typeof value === 'boolean' ||
    typeof value === 'undefined'
  ) {
    return value;
  }

  var type = Object.prototype.toString.call(value);

  // Node.js REPL notation
  if (type === '[object Object]') return '[Object]';
  if (type === '[object Array]') return '[Array]';
  if (type === '[object Function]')
    return value.name ? '[Function: ' + value.name + ']' : '[Function]';

  return value;
}

function serializeObject(value, depth) {
  if (depth === 0) return serializeValue(value);

  if (isPlainObject(value)) {
    return Object.keys(value).reduce(function(acc, key) {
      acc[key] = serializeObject(value[key], depth - 1);
      return acc;
    }, {});
  } else if (Array.isArray(value)) {
    return value.map(function(val) {
      return serializeObject(val, depth - 1);
    });
  }

  return serializeValue(value);
}

function serializeException(ex, depth, maxSize) {
  if (!isPlainObject(ex)) return ex;

  depth = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_DEPTH : depth;
  maxSize = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_SIZE : maxSize;

  var serialized = serializeObject(ex, depth);

  if (jsonSize(stringify(serialized)) > maxSize) {
    return serializeException(ex, depth - 1);
  }

  return serialized;
}

function serializeKeysForMessage(keys, maxLength) {
  if (typeof keys === 'number' || typeof keys === 'string') return keys.toString();
  if (!Array.isArray(keys)) return '';

  keys = keys.filter(function(key) {
    return typeof key === 'string';
  });
  if (keys.length === 0) return '[object has no keys]';

  maxLength = typeof maxLength !== 'number' ? MAX_SERIALIZE_KEYS_LENGTH : maxLength;
  if (keys[0].length >= maxLength) return keys[0];

  for (var usedKeys = keys.length; usedKeys > 0; usedKeys--) {
    var serialized = keys.slice(0, usedKeys).join(', ');
    if (serialized.length > maxLength) continue;
    if (usedKeys === keys.length) return serialized;
    return serialized + '\u2026';
  }

  return '';
}

function sanitize(input, sanitizeKeys) {
  if (!isArray(sanitizeKeys) || (isArray(sanitizeKeys) && sanitizeKeys.length === 0))
    return input;

  var sanitizeRegExp = joinRegExp(sanitizeKeys);
  var sanitizeMask = '********';
  var safeInput;

  try {
    safeInput = JSON.parse(stringify(input));
  } catch (o_O) {
    return input;
  }

  function sanitizeWorker(workerInput) {
    if (isArray(workerInput)) {
      return workerInput.map(function(val) {
        return sanitizeWorker(val);
      });
    }

    if (isPlainObject(workerInput)) {
      return Object.keys(workerInput).reduce(function(acc, k) {
        if (sanitizeRegExp.test(k)) {
          acc[k] = sanitizeMask;
        } else {
          acc[k] = sanitizeWorker(workerInput[k]);
        }
        return acc;
      }, {});
    }

    return workerInput;
  }

  return sanitizeWorker(safeInput);
}

module.exports = {
  isObject: isObject,
  isError: isError,
  isErrorEvent: isErrorEvent,
  isDOMError: isDOMError,
  isDOMException: isDOMException,
  isUndefined: isUndefined,
  isFunction: isFunction,
  isPlainObject: isPlainObject,
  isString: isString,
  isArray: isArray,
  isEmptyObject: isEmptyObject,
  supportsErrorEvent: supportsErrorEvent,
  supportsDOMError: supportsDOMError,
  supportsDOMException: supportsDOMException,
  supportsFetch: supportsFetch,
  supportsReferrerPolicy: supportsReferrerPolicy,
  supportsPromiseRejectionEvent: supportsPromiseRejectionEvent,
  wrappedCallback: wrappedCallback,
  each: each,
  objectMerge: objectMerge,
  truncate: truncate,
  objectFrozen: objectFrozen,
  hasKey: hasKey,
  joinRegExp: joinRegExp,
  urlencode: urlencode,
  uuid4: uuid4,
  htmlTreeAsString: htmlTreeAsString,
  htmlElementAsString: htmlElementAsString,
  isSameException: isSameException,
  isSameStacktrace: isSameStacktrace,
  parseUrl: parseUrl,
  fill: fill,
  safeJoin: safeJoin,
  serializeException: serializeException,
  serializeKeysForMessage: serializeKeysForMessage,
  sanitize: sanitize
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 68);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(41);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(25);

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(47);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(8);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(59);

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(55);

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(13);

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(165);

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(152);

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(128);

/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(207);

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(268);

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(381);

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(622);

/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(624);

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(582);

/***/ }),
/* 38 */,
/* 39 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(54);

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(1465);

/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(610);

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(1462);

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(1463);

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

exports.calculateDimension = calculateDimension;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAddonsShallowCompare = __webpack_require__(14);

var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);

var _reactDom = __webpack_require__(39);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _airbnbPropTypes = __webpack_require__(1);

var _moment = __webpack_require__(7);

var _moment2 = _interopRequireDefault(_moment);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _throttle = __webpack_require__(37);

var _throttle2 = _interopRequireDefault(_throttle);

var _isTouchDevice = __webpack_require__(9);

var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);

var _defaultPhrases = __webpack_require__(3);

var _getPhrasePropTypes = __webpack_require__(5);

var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);

var _OutsideClickHandler = __webpack_require__(17);

var _OutsideClickHandler2 = _interopRequireDefault(_OutsideClickHandler);

var _CalendarMonthGrid = __webpack_require__(53);

var _CalendarMonthGrid2 = _interopRequireDefault(_CalendarMonthGrid);

var _DayPickerNavigation = __webpack_require__(57);

var _DayPickerNavigation2 = _interopRequireDefault(_DayPickerNavigation);

var _DayPickerKeyboardShortcuts = __webpack_require__(56);

var _DayPickerKeyboardShortcuts2 = _interopRequireDefault(_DayPickerKeyboardShortcuts);

var _getTransformStyles = __webpack_require__(30);

var _getTransformStyles2 = _interopRequireDefault(_getTransformStyles);

var _getCalendarMonthWidth = __webpack_require__(28);

var _getCalendarMonthWidth2 = _interopRequireDefault(_getCalendarMonthWidth);

var _getActiveElement = __webpack_require__(46);

var _getActiveElement2 = _interopRequireDefault(_getActiveElement);

var _isDayVisible = __webpack_require__(21);

var _isDayVisible2 = _interopRequireDefault(_isDayVisible);

var _ScrollableOrientationShape = __webpack_require__(8);

var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);

var _DayOfWeekShape = __webpack_require__(12);

var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var MONTH_PADDING = 23;
var DAY_PICKER_PADDING = 9;
var PREV_TRANSITION = 'prev';
var NEXT_TRANSITION = 'next';

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
  // calendar presentation props
  enableOutsideDays: _propTypes2['default'].bool,
  numberOfMonths: _propTypes2['default'].number,
  orientation: _ScrollableOrientationShape2['default'],
  withPortal: _propTypes2['default'].bool,
  onOutsideClick: _propTypes2['default'].func,
  hidden: _propTypes2['default'].bool,
  initialVisibleMonth: _propTypes2['default'].func,
  firstDayOfWeek: _DayOfWeekShape2['default'],
  renderCalendarInfo: _propTypes2['default'].func,
  hideKeyboardShortcutsPanel: _propTypes2['default'].bool,
  daySize: _airbnbPropTypes.nonNegativeInteger,
  isRTL: _propTypes2['default'].bool,

  // navigation props
  navPrev: _propTypes2['default'].node,
  navNext: _propTypes2['default'].node,
  onPrevMonthClick: _propTypes2['default'].func,
  onNextMonthClick: _propTypes2['default'].func,
  onMultiplyScrollableMonths: _propTypes2['default'].func, // VERTICAL_SCROLLABLE daypickers only

  // month props
  renderMonth: _propTypes2['default'].func,

  // day props
  modifiers: _propTypes2['default'].object,
  renderDay: _propTypes2['default'].func,
  onDayClick: _propTypes2['default'].func,
  onDayMouseEnter: _propTypes2['default'].func,
  onDayMouseLeave: _propTypes2['default'].func,

  // accessibility props
  isFocused: _propTypes2['default'].bool,
  getFirstFocusableDay: _propTypes2['default'].func,
  onBlur: _propTypes2['default'].func,
  showKeyboardShortcuts: _propTypes2['default'].bool,

  // internationalization
  monthFormat: _propTypes2['default'].string,
  weekDayFormat: _propTypes2['default'].string,
  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DayPickerPhrases))
});

var defaultProps = exports.defaultProps = {
  // calendar presentation props
  enableOutsideDays: false,
  numberOfMonths: 2,
  orientation: _constants.HORIZONTAL_ORIENTATION,
  withPortal: false,
  onOutsideClick: function () {
    function onOutsideClick() {}

    return onOutsideClick;
  }(),

  hidden: false,
  initialVisibleMonth: function () {
    function initialVisibleMonth() {
      return (0, _moment2['default'])();
    }

    return initialVisibleMonth;
  }(),
  firstDayOfWeek: null,
  renderCalendarInfo: null,
  hideKeyboardShortcutsPanel: false,
  daySize: _constants.DAY_SIZE,
  isRTL: false,

  // navigation props
  navPrev: null,
  navNext: null,
  onPrevMonthClick: function () {
    function onPrevMonthClick() {}

    return onPrevMonthClick;
  }(),
  onNextMonthClick: function () {
    function onNextMonthClick() {}

    return onNextMonthClick;
  }(),
  onMultiplyScrollableMonths: function () {
    function onMultiplyScrollableMonths() {}

    return onMultiplyScrollableMonths;
  }(),

  // month props
  renderMonth: null,

  // day props
  modifiers: {},
  renderDay: null,
  onDayClick: function () {
    function onDayClick() {}

    return onDayClick;
  }(),
  onDayMouseEnter: function () {
    function onDayMouseEnter() {}

    return onDayMouseEnter;
  }(),
  onDayMouseLeave: function () {
    function onDayMouseLeave() {}

    return onDayMouseLeave;
  }(),

  // accessibility props
  isFocused: false,
  getFirstFocusableDay: null,
  onBlur: function () {
    function onBlur() {}

    return onBlur;
  }(),

  showKeyboardShortcuts: false,

  // internationalization
  monthFormat: 'MMMM YYYY',
  weekDayFormat: 'dd',
  phrases: _defaultPhrases.DayPickerPhrases
};

function applyTransformStyles(el, transform) {
  var opacity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  var transformStyles = (0, _getTransformStyles2['default'])(transform);
  transformStyles.opacity = opacity;

  Object.keys(transformStyles).forEach(function (styleKey) {
    // eslint-disable-next-line no-param-reassign
    el.style[styleKey] = transformStyles[styleKey];
  });
}

function calculateDimension(el, axis) {
  var borderBox = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var withMargin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (!el) {
    return 0;
  }

  var axisStart = axis === 'width' ? 'Left' : 'Top';
  var axisEnd = axis === 'width' ? 'Right' : 'Bottom';

  // Only read styles if we need to
  var style = !borderBox || withMargin ? window.getComputedStyle(el) : null;

  // Offset includes border and padding
  var offsetWidth = el.offsetWidth,
      offsetHeight = el.offsetHeight;

  var size = axis === 'width' ? offsetWidth : offsetHeight;

  // Get the inner size
  if (!borderBox) {
    size -= parseFloat(style['padding' + axisStart]) + parseFloat(style['padding' + axisEnd]) + parseFloat(style['border' + axisStart + 'Width']) + parseFloat(style['border' + axisEnd + 'Width']);
  }

  // Apply margin
  if (withMargin) {
    size += parseFloat(style['margin' + axisStart]) + parseFloat(style['margin' + axisEnd]);
  }

  return size;
}

function getMonthHeight(el) {
  var caption = el.querySelector('.js-CalendarMonth__caption');
  var grid = el.querySelector('.js-CalendarMonth__grid');

  // Need to separate out table children for FF
  // Add an additional +1 for the border
  return calculateDimension(caption, 'height', true, true) + calculateDimension(grid, 'height') + 1;
}

var DayPicker = function (_React$Component) {
  _inherits(DayPicker, _React$Component);

  function DayPicker(props) {
    _classCallCheck(this, DayPicker);

    var _this = _possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));

    var currentMonth = props.hidden ? (0, _moment2['default'])() : props.initialVisibleMonth();

    var focusedDate = currentMonth.clone().startOf('month');
    if (props.getFirstFocusableDay) {
      focusedDate = props.getFirstFocusableDay(currentMonth);
    }

    var translationValue = props.isRTL && _this.isHorizontal() ? -(0, _getCalendarMonthWidth2['default'])(props.daySize) : 0;

    _this.hasSetInitialVisibleMonth = !props.hidden;
    _this.state = {
      currentMonth: currentMonth,
      monthTransition: null,
      translationValue: translationValue,
      scrollableMonthMultiple: 1,
      calendarMonthWidth: (0, _getCalendarMonthWidth2['default'])(props.daySize),
      focusedDate: !props.hidden || props.isFocused ? focusedDate : null,
      nextFocusedDate: null,
      showKeyboardShortcuts: props.showKeyboardShortcuts,
      onKeyboardShortcutsPanelClose: function () {
        function onKeyboardShortcutsPanelClose() {}

        return onKeyboardShortcutsPanelClose;
      }(),

      isTouchDevice: (0, _isTouchDevice2['default'])(),
      withMouseInteractions: true
    };

    _this.onKeyDown = _this.onKeyDown.bind(_this);
    _this.onPrevMonthClick = _this.onPrevMonthClick.bind(_this);
    _this.onNextMonthClick = _this.onNextMonthClick.bind(_this);
    _this.setCalendarMonthGridRef = _this.setCalendarMonthGridRef.bind(_this);
    _this.multiplyScrollableMonths = _this.multiplyScrollableMonths.bind(_this);
    _this.updateStateAfterMonthTransition = _this.updateStateAfterMonthTransition.bind(_this);

    _this.openKeyboardShortcutsPanel = _this.openKeyboardShortcutsPanel.bind(_this);
    _this.closeKeyboardShortcutsPanel = _this.closeKeyboardShortcutsPanel.bind(_this);

    _this.setContainerRef = _this.setContainerRef.bind(_this);
    _this.setTransitionContainerRef = _this.setTransitionContainerRef.bind(_this);
    return _this;
  }

  _createClass(DayPicker, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        this.setState({ isTouchDevice: (0, _isTouchDevice2['default'])() });

        if (this.isHorizontal()) {
          this.adjustDayPickerHeight();
          this.initializeDayPickerWidth();
        }
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(nextProps) {
        var hidden = nextProps.hidden,
            isFocused = nextProps.isFocused,
            showKeyboardShortcuts = nextProps.showKeyboardShortcuts,
            onBlur = nextProps.onBlur;
        var currentMonth = this.state.currentMonth;

        if (!hidden) {
          if (!this.hasSetInitialVisibleMonth) {
            this.hasSetInitialVisibleMonth = true;
            this.setState({
              currentMonth: nextProps.initialVisibleMonth()
            });
          }

          if (!this.dayPickerWidth && this.isHorizontal()) {
            this.initializeDayPickerWidth();
            this.adjustDayPickerHeight();
          }
        }

        if (nextProps.daySize !== this.props.daySize) {
          this.setState({
            calendarMonthWidth: (0, _getCalendarMonthWidth2['default'])(nextProps.daySize)
          });
        }

        if (isFocused !== this.props.isFocused) {
          if (isFocused) {
            var focusedDate = this.getFocusedDay(currentMonth);

            var onKeyboardShortcutsPanelClose = this.state.onKeyboardShortcutsPanelClose;
            if (nextProps.showKeyboardShortcuts) {
              // the ? shortcut came from the input and we should return input there once it is close
              onKeyboardShortcutsPanelClose = onBlur;
            }

            this.setState({
              showKeyboardShortcuts: showKeyboardShortcuts,
              onKeyboardShortcutsPanelClose: onKeyboardShortcutsPanelClose,
              focusedDate: focusedDate,
              withMouseInteractions: false
            });
          } else {
            this.setState({ focusedDate: null });
          }
        }
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'shouldComponentUpdate',
    value: function () {
      function shouldComponentUpdate(nextProps, nextState) {
        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
      }

      return shouldComponentUpdate;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps, prevState) {
        var numberOfMonths = this.props.numberOfMonths;
        var _state = this.state,
            monthTransition = _state.monthTransition,
            currentMonth = _state.currentMonth,
            focusedDate = _state.focusedDate;

        if (monthTransition || !currentMonth.isSame(prevState.currentMonth) || numberOfMonths !== prevProps.numberOfMonths) {
          if (this.isHorizontal()) {
            this.adjustDayPickerHeight();
          }
        }

        if (!prevProps.isFocused && this.props.isFocused && !focusedDate || !prevProps.showKeyboardShortcuts && this.props.showKeyboardShortcuts) {
          this.container.focus();
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'onKeyDown',
    value: function () {
      function onKeyDown(e) {
        e.stopPropagation();

        this.setState({ withMouseInteractions: false });

        var onBlur = this.props.onBlur;
        var _state2 = this.state,
            focusedDate = _state2.focusedDate,
            showKeyboardShortcuts = _state2.showKeyboardShortcuts;

        if (!focusedDate) return;

        var newFocusedDate = focusedDate.clone();

        var didTransitionMonth = false;

        // focus might be anywhere when the keyboard shortcuts panel is opened so we want to
        // return it to wherever it was before when the panel was opened
        var activeElement = (0, _getActiveElement2['default'])();
        var onKeyboardShortcutsPanelClose = function () {
          function onKeyboardShortcutsPanelClose() {
            if (activeElement) activeElement.focus();
          }

          return onKeyboardShortcutsPanelClose;
        }();

        switch (e.key) {
          case 'ArrowUp':
            e.preventDefault();
            newFocusedDate.subtract(1, 'week');
            didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
            break;
          case 'ArrowLeft':
            e.preventDefault();
            newFocusedDate.subtract(1, 'day');
            didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
            break;
          case 'Home':
            e.preventDefault();
            newFocusedDate.startOf('week');
            didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
            break;
          case 'PageUp':
            e.preventDefault();
            newFocusedDate.subtract(1, 'month');
            didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
            break;

          case 'ArrowDown':
            e.preventDefault();
            newFocusedDate.add(1, 'week');
            didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
            break;
          case 'ArrowRight':
            e.preventDefault();
            newFocusedDate.add(1, 'day');
            didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
            break;
          case 'End':
            e.preventDefault();
            newFocusedDate.endOf('week');
            didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
            break;
          case 'PageDown':
            e.preventDefault();
            newFocusedDate.add(1, 'month');
            didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
            break;

          case '?':
            this.openKeyboardShortcutsPanel(onKeyboardShortcutsPanelClose);
            break;

          case 'Escape':
            if (showKeyboardShortcuts) {
              this.closeKeyboardShortcutsPanel();
            } else {
              onBlur();
            }
            break;

          default:
            break;
        }

        // If there was a month transition, do not update the focused date until the transition has
        // completed. Otherwise, attempting to focus on a DOM node may interrupt the CSS animation. If
        // didTransitionMonth is true, the focusedDate gets updated in #updateStateAfterMonthTransition
        if (!didTransitionMonth) {
          this.setState({
            focusedDate: newFocusedDate
          });
        }
      }

      return onKeyDown;
    }()
  }, {
    key: 'onPrevMonthClick',
    value: function () {
      function onPrevMonthClick(nextFocusedDate, e) {
        var isRTL = this.props.isRTL;

        if (e) e.preventDefault();

        var translationValue = this.isVertical() ? this.getMonthHeightByIndex(0) : this.dayPickerWidth;

        if (isRTL && this.isHorizontal()) {
          translationValue = -2 * this.dayPickerWidth;
        }

        // The first CalendarMonth is always positioned absolute at top: 0 or left: 0
        // so we need to transform it to the appropriate location before the animation.
        // This behavior is because we would otherwise need a double-render in order to
        // adjust the container position once we had the height the first calendar
        // (ie first draw all the calendar, then in a second render, use the first calendar's
        // height to position the container). Variable calendar heights, amirite? <3 Maja
        this.translateFirstDayPickerForAnimation(translationValue);

        this.setState({
          monthTransition: PREV_TRANSITION,
          translationValue: translationValue,
          focusedDate: null,
          nextFocusedDate: nextFocusedDate
        });
      }

      return onPrevMonthClick;
    }()
  }, {
    key: 'onNextMonthClick',
    value: function () {
      function onNextMonthClick(nextFocusedDate, e) {
        var isRTL = this.props.isRTL;

        if (e) e.preventDefault();

        var translationValue = this.isVertical() ? -this.getMonthHeightByIndex(1) : -this.dayPickerWidth;

        if (isRTL && this.isHorizontal()) {
          translationValue = 0;
        }

        this.setState({
          monthTransition: NEXT_TRANSITION,
          translationValue: translationValue,
          focusedDate: null,
          nextFocusedDate: nextFocusedDate
        });
      }

      return onNextMonthClick;
    }()
  }, {
    key: 'getFocusedDay',
    value: function () {
      function getFocusedDay(newMonth) {
        var _props = this.props,
            getFirstFocusableDay = _props.getFirstFocusableDay,
            numberOfMonths = _props.numberOfMonths;

        var focusedDate = void 0;
        if (getFirstFocusableDay) {
          focusedDate = getFirstFocusableDay(newMonth);
        }

        if (newMonth && (!focusedDate || !(0, _isDayVisible2['default'])(focusedDate, newMonth, numberOfMonths))) {
          focusedDate = newMonth.clone().startOf('month');
        }

        return focusedDate;
      }

      return getFocusedDay;
    }()
  }, {
    key: 'getMonthHeightByIndex',
    value: function () {
      function getMonthHeightByIndex(i) {
        return getMonthHeight(this.transitionContainer.querySelectorAll('.CalendarMonth')[i]);
      }

      return getMonthHeightByIndex;
    }()
  }, {
    key: 'setCalendarMonthGridRef',
    value: function () {
      function setCalendarMonthGridRef(ref) {
        this.calendarMonthGrid = ref;
      }

      return setCalendarMonthGridRef;
    }()
  }, {
    key: 'setContainerRef',
    value: function () {
      function setContainerRef(ref) {
        this.container = ref;
      }

      return setContainerRef;
    }()
  }, {
    key: 'setTransitionContainerRef',
    value: function () {
      function setTransitionContainerRef(ref) {
        this.transitionContainer = ref;
      }

      return setTransitionContainerRef;
    }()
  }, {
    key: 'maybeTransitionNextMonth',
    value: function () {
      function maybeTransitionNextMonth(newFocusedDate) {
        var numberOfMonths = this.props.numberOfMonths;
        var _state3 = this.state,
            currentMonth = _state3.currentMonth,
            focusedDate = _state3.focusedDate;

        var newFocusedDateMonth = newFocusedDate.month();
        var focusedDateMonth = focusedDate.month();
        var isNewFocusedDateVisible = (0, _isDayVisible2['default'])(newFocusedDate, currentMonth, numberOfMonths);
        if (newFocusedDateMonth !== focusedDateMonth && !isNewFocusedDateVisible) {
          this.onNextMonthClick(newFocusedDate);
          return true;
        }

        return false;
      }

      return maybeTransitionNextMonth;
    }()
  }, {
    key: 'maybeTransitionPrevMonth',
    value: function () {
      function maybeTransitionPrevMonth(newFocusedDate) {
        var numberOfMonths = this.props.numberOfMonths;
        var _state4 = this.state,
            currentMonth = _state4.currentMonth,
            focusedDate = _state4.focusedDate;

        var newFocusedDateMonth = newFocusedDate.month();
        var focusedDateMonth = focusedDate.month();
        var isNewFocusedDateVisible = (0, _isDayVisible2['default'])(newFocusedDate, currentMonth, numberOfMonths);
        if (newFocusedDateMonth !== focusedDateMonth && !isNewFocusedDateVisible) {
          this.onPrevMonthClick(newFocusedDate);
          return true;
        }

        return false;
      }

      return maybeTransitionPrevMonth;
    }()
  }, {
    key: 'multiplyScrollableMonths',
    value: function () {
      function multiplyScrollableMonths(e) {
        var onMultiplyScrollableMonths = this.props.onMultiplyScrollableMonths;

        if (e) e.preventDefault();

        if (onMultiplyScrollableMonths) onMultiplyScrollableMonths(e);

        this.setState({
          scrollableMonthMultiple: this.state.scrollableMonthMultiple + 1
        });
      }

      return multiplyScrollableMonths;
    }()
  }, {
    key: 'isHorizontal',
    value: function () {
      function isHorizontal() {
        return this.props.orientation === _constants.HORIZONTAL_ORIENTATION;
      }

      return isHorizontal;
    }()
  }, {
    key: 'isVertical',
    value: function () {
      function isVertical() {
        return this.props.orientation === _constants.VERTICAL_ORIENTATION || this.props.orientation === _constants.VERTICAL_SCROLLABLE;
      }

      return isVertical;
    }()
  }, {
    key: 'initializeDayPickerWidth',
    value: function () {
      function initializeDayPickerWidth() {
        if (this.calendarMonthGrid) {
          // eslint-disable-next-line react/no-find-dom-node
          var calendarMonthGridDOMNode = _reactDom2['default'].findDOMNode(this.calendarMonthGrid);
          if (calendarMonthGridDOMNode) {
            this.dayPickerWidth = calculateDimension(calendarMonthGridDOMNode.querySelector('.CalendarMonth'), 'width', true);
          }
        }
      }

      return initializeDayPickerWidth;
    }()
  }, {
    key: 'updateStateAfterMonthTransition',
    value: function () {
      function updateStateAfterMonthTransition() {
        var _props2 = this.props,
            onPrevMonthClick = _props2.onPrevMonthClick,
            onNextMonthClick = _props2.onNextMonthClick;
        var _state5 = this.state,
            currentMonth = _state5.currentMonth,
            monthTransition = _state5.monthTransition,
            focusedDate = _state5.focusedDate,
            nextFocusedDate = _state5.nextFocusedDate,
            withMouseInteractions = _state5.withMouseInteractions;

        if (!monthTransition) return;

        var newMonth = currentMonth.clone();
        if (monthTransition === PREV_TRANSITION) {
          if (onPrevMonthClick) onPrevMonthClick();
          newMonth.subtract(1, 'month');
        } else if (monthTransition === NEXT_TRANSITION) {
          if (onNextMonthClick) onNextMonthClick();
          newMonth.add(1, 'month');
        }

        var newFocusedDate = null;
        if (nextFocusedDate) {
          newFocusedDate = nextFocusedDate;
        } else if (!focusedDate && !withMouseInteractions) {
          newFocusedDate = this.getFocusedDay(newMonth);
        }

        if (this.calendarMonthGrid) {
          // eslint-disable-next-line react/no-find-dom-node
          var calendarMonthGridDOMNode = _reactDom2['default'].findDOMNode(this.calendarMonthGrid);
          if (calendarMonthGridDOMNode) {
            // clear the previous transforms
            applyTransformStyles(calendarMonthGridDOMNode.querySelector('.CalendarMonth'), 'none');
          }
        }

        this.setState({
          currentMonth: newMonth,
          monthTransition: null,
          translationValue: this.props.isRTL && this.isHorizontal() ? -this.dayPickerWidth : 0,
          nextFocusedDate: null,
          focusedDate: newFocusedDate
        }, function () {
          // we don't want to focus on the relevant calendar day after a month transition
          // if the user is navigating around using a mouse
          if (withMouseInteractions) {
            var activeElement = (0, _getActiveElement2['default'])();
            if (activeElement && activeElement !== document.body) {
              activeElement.blur();
            }
          }
        });
      }

      return updateStateAfterMonthTransition;
    }()
  }, {
    key: 'adjustDayPickerHeight',
    value: function () {
      function adjustDayPickerHeight() {
        var heights = [];

        Array.prototype.forEach.call(this.transitionContainer.querySelectorAll('.CalendarMonth'), function (el) {
          if (el.getAttribute('data-visible') === 'true') {
            heights.push(getMonthHeight(el));
          }
        });

        var newMonthHeight = Math.max.apply(Math, heights) + MONTH_PADDING;

        if (newMonthHeight !== calculateDimension(this.transitionContainer, 'height')) {
          this.monthHeight = newMonthHeight;
          this.transitionContainer.style.height = String(newMonthHeight) + 'px';
        }
      }

      return adjustDayPickerHeight;
    }()
  }, {
    key: 'translateFirstDayPickerForAnimation',
    value: function () {
      function translateFirstDayPickerForAnimation(translationValue) {
        var isRTL = this.props.isRTL;

        var convertedTranslationValue = -translationValue;
        if (isRTL && this.isHorizontal()) {
          var positiveTranslationValue = Math.abs(translationValue + this.dayPickerWidth);
          convertedTranslationValue = positiveTranslationValue;
        }
        var transformType = this.isVertical() ? 'translateY' : 'translateX';
        var transformValue = transformType + '(' + String(convertedTranslationValue) + 'px)';

        applyTransformStyles(this.transitionContainer.querySelector('.CalendarMonth'), transformValue, 1);
      }

      return translateFirstDayPickerForAnimation;
    }()
  }, {
    key: 'openKeyboardShortcutsPanel',
    value: function () {
      function openKeyboardShortcutsPanel(onCloseCallBack) {
        this.setState({
          showKeyboardShortcuts: true,
          onKeyboardShortcutsPanelClose: onCloseCallBack
        });
      }

      return openKeyboardShortcutsPanel;
    }()
  }, {
    key: 'closeKeyboardShortcutsPanel',
    value: function () {
      function closeKeyboardShortcutsPanel() {
        var onKeyboardShortcutsPanelClose = this.state.onKeyboardShortcutsPanelClose;

        if (onKeyboardShortcutsPanelClose) {
          onKeyboardShortcutsPanelClose();
        }

        this.setState({
          onKeyboardShortcutsPanelClose: null,
          showKeyboardShortcuts: false
        });
      }

      return closeKeyboardShortcutsPanel;
    }()
  }, {
    key: 'renderNavigation',
    value: function () {
      function renderNavigation() {
        var _this2 = this;

        var _props3 = this.props,
            navPrev = _props3.navPrev,
            navNext = _props3.navNext,
            orientation = _props3.orientation,
            phrases = _props3.phrases,
            isRTL = _props3.isRTL;

        var onNextMonthClick = void 0;
        if (orientation === _constants.VERTICAL_SCROLLABLE) {
          onNextMonthClick = this.multiplyScrollableMonths;
        } else {
          onNextMonthClick = function () {
            function onNextMonthClick(e) {
              _this2.onNextMonthClick(null, e);
            }

            return onNextMonthClick;
          }();
        }

        return _react2['default'].createElement(_DayPickerNavigation2['default'], {
          onPrevMonthClick: function () {
            function onPrevMonthClick(e) {
              _this2.onPrevMonthClick(null, e);
            }

            return onPrevMonthClick;
          }(),
          onNextMonthClick: onNextMonthClick,
          navPrev: navPrev,
          navNext: navNext,
          orientation: orientation,
          phrases: phrases,
          isRTL: isRTL
        });
      }

      return renderNavigation;
    }()
  }, {
    key: 'renderWeekHeader',
    value: function () {
      function renderWeekHeader(index) {
        var _props4 = this.props,
            daySize = _props4.daySize,
            orientation = _props4.orientation,
            weekDayFormat = _props4.weekDayFormat;
        var calendarMonthWidth = this.state.calendarMonthWidth;

        var verticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;
        var horizontalStyle = {
          left: index * calendarMonthWidth
        };
        var verticalStyle = {
          marginLeft: -calendarMonthWidth / 2
        };

        var style = {}; // no styles applied to the vertical-scrollable orientation
        if (this.isHorizontal()) {
          style = horizontalStyle;
        } else if (this.isVertical() && !verticalScrollable) {
          style = verticalStyle;
        }

        var firstDayOfWeek = this.props.firstDayOfWeek;

        if (firstDayOfWeek == null) {
          firstDayOfWeek = _moment2['default'].localeData().firstDayOfWeek();
        }

        var header = [];
        for (var i = 0; i < 7; i += 1) {
          header.push(_react2['default'].createElement('li', { key: i, style: { width: daySize } }, _react2['default'].createElement('small', null, (0, _moment2['default'])().day((i + firstDayOfWeek) % 7).format(weekDayFormat))));
        }

        return _react2['default'].createElement('div', {
          className: 'DayPicker__week-header',
          key: 'week-' + String(index),
          style: style
        }, _react2['default'].createElement('ul', null, header));
      }

      return renderWeekHeader;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this3 = this;

        var _state6 = this.state,
            calendarMonthWidth = _state6.calendarMonthWidth,
            currentMonth = _state6.currentMonth,
            monthTransition = _state6.monthTransition,
            translationValue = _state6.translationValue,
            scrollableMonthMultiple = _state6.scrollableMonthMultiple,
            focusedDate = _state6.focusedDate,
            showKeyboardShortcuts = _state6.showKeyboardShortcuts,
            isTouch = _state6.isTouchDevice;
        var _props5 = this.props,
            enableOutsideDays = _props5.enableOutsideDays,
            numberOfMonths = _props5.numberOfMonths,
            orientation = _props5.orientation,
            modifiers = _props5.modifiers,
            withPortal = _props5.withPortal,
            onDayClick = _props5.onDayClick,
            onDayMouseEnter = _props5.onDayMouseEnter,
            onDayMouseLeave = _props5.onDayMouseLeave,
            firstDayOfWeek = _props5.firstDayOfWeek,
            renderMonth = _props5.renderMonth,
            renderDay = _props5.renderDay,
            renderCalendarInfo = _props5.renderCalendarInfo,
            hideKeyboardShortcutsPanel = _props5.hideKeyboardShortcutsPanel,
            onOutsideClick = _props5.onOutsideClick,
            monthFormat = _props5.monthFormat,
            daySize = _props5.daySize,
            isFocused = _props5.isFocused,
            phrases = _props5.phrases;

        var numOfWeekHeaders = this.isVertical() ? 1 : numberOfMonths;
        var weekHeaders = [];
        for (var i = 0; i < numOfWeekHeaders; i += 1) {
          weekHeaders.push(this.renderWeekHeader(i));
        }

        var firstVisibleMonthIndex = 1;
        if (monthTransition === PREV_TRANSITION) {
          firstVisibleMonthIndex -= 1;
        } else if (monthTransition === NEXT_TRANSITION) {
          firstVisibleMonthIndex += 1;
        }

        var verticalScrollable = this.props.orientation === _constants.VERTICAL_SCROLLABLE;
        if (verticalScrollable) firstVisibleMonthIndex = 0;

        var dayPickerClassNames = (0, _classnames2['default'])('DayPicker', {
          'DayPicker--horizontal': this.isHorizontal(),
          'DayPicker--vertical': this.isVertical(),
          'DayPicker--vertical-scrollable': verticalScrollable,
          'DayPicker--portal': withPortal
        });

        var transitionContainerClasses = (0, _classnames2['default'])('transition-container', {
          'transition-container--horizontal': this.isHorizontal(),
          'transition-container--vertical': this.isVertical()
        });

        var horizontalWidth = calendarMonthWidth * numberOfMonths + 2 * DAY_PICKER_PADDING;

        // this is a kind of made-up value that generally looks good. we'll
        // probably want to let the user set this explicitly.
        var verticalHeight = 1.75 * calendarMonthWidth;

        var dayPickerStyle = {
          width: this.isHorizontal() && horizontalWidth,

          // These values are to center the datepicker (approximately) on the page
          marginLeft: this.isHorizontal() && withPortal && -horizontalWidth / 2,
          marginTop: this.isHorizontal() && withPortal && -calendarMonthWidth / 2
        };

        var transitionContainerStyle = {
          width: this.isHorizontal() && horizontalWidth,
          height: this.isVertical() && !verticalScrollable && !withPortal && verticalHeight
        };

        var isCalendarMonthGridAnimating = monthTransition !== null;
        var transformType = this.isVertical() ? 'translateY' : 'translateX';
        var transformValue = transformType + '(' + String(translationValue) + 'px)';

        var shouldFocusDate = !isCalendarMonthGridAnimating && isFocused;

        var keyboardShortcutButtonLocation = _DayPickerKeyboardShortcuts.BOTTOM_RIGHT;
        if (this.isVertical()) {
          keyboardShortcutButtonLocation = withPortal ? _DayPickerKeyboardShortcuts.TOP_LEFT : _DayPickerKeyboardShortcuts.TOP_RIGHT;
        }

        return _react2['default'].createElement('div', {
          className: dayPickerClassNames,
          style: dayPickerStyle,
          role: 'application',
          'aria-label': phrases.calendarLabel
        }, _react2['default'].createElement(_OutsideClickHandler2['default'], { onOutsideClick: onOutsideClick }, _react2['default'].createElement('div', {
          className: 'DayPicker__week-headers',
          'aria-hidden': 'true',
          role: 'presentation'
        }, weekHeaders), _react2['default'].createElement('div', { // eslint-disable-line jsx-a11y/no-noninteractive-element-interactions
          className: 'DayPicker__focus-region',
          ref: this.setContainerRef,
          onClick: function () {
            function onClick(e) {
              e.stopPropagation();
            }

            return onClick;
          }(),
          onKeyDown: (0, _throttle2['default'])(this.onKeyDown, 300),
          onMouseUp: function () {
            function onMouseUp() {
              _this3.setState({ withMouseInteractions: true });
            }

            return onMouseUp;
          }(),
          role: 'region',
          tabIndex: -1
        }, !verticalScrollable && this.renderNavigation(), _react2['default'].createElement('div', {
          className: transitionContainerClasses,
          ref: this.setTransitionContainerRef,
          style: transitionContainerStyle
        }, _react2['default'].createElement(_CalendarMonthGrid2['default'], {
          ref: this.setCalendarMonthGridRef,
          transformValue: transformValue,
          enableOutsideDays: enableOutsideDays,
          firstVisibleMonthIndex: firstVisibleMonthIndex,
          initialMonth: currentMonth,
          isAnimating: isCalendarMonthGridAnimating,
          modifiers: modifiers,
          orientation: orientation,
          numberOfMonths: numberOfMonths * scrollableMonthMultiple,
          onDayClick: onDayClick,
          onDayMouseEnter: onDayMouseEnter,
          onDayMouseLeave: onDayMouseLeave,
          renderMonth: renderMonth,
          renderDay: renderDay,
          onMonthTransitionEnd: this.updateStateAfterMonthTransition,
          monthFormat: monthFormat,
          daySize: daySize,
          firstDayOfWeek: firstDayOfWeek,
          isFocused: shouldFocusDate,
          focusedDate: focusedDate,
          phrases: phrases
        }), verticalScrollable && this.renderNavigation()), !isTouch && !hideKeyboardShortcutsPanel && _react2['default'].createElement(_DayPickerKeyboardShortcuts2['default'], {
          block: this.isVertical() && !withPortal,
          buttonLocation: keyboardShortcutButtonLocation,
          showKeyboardShortcutsPanel: showKeyboardShortcuts,
          openKeyboardShortcutsPanel: this.openKeyboardShortcutsPanel,
          closeKeyboardShortcutsPanel: this.closeKeyboardShortcutsPanel,
          phrases: phrases
        })), renderCalendarInfo && renderCalendarInfo()));
      }

      return render;
    }()
  }]);

  return DayPicker;
}(_react2['default'].Component);

exports['default'] = DayPicker;

DayPicker.propTypes = propTypes;
DayPicker.defaultProps = defaultProps;

/***/ })
/******/ ]);

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = isDayVisible;

var _isBeforeDay = __webpack_require__(210);

var _isBeforeDay2 = _interopRequireDefault(_isBeforeDay);

var _isAfterDay = __webpack_require__(209);

var _isAfterDay2 = _interopRequireDefault(_isAfterDay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function isDayVisible(day, month, numberOfMonths, enableOutsideDays) {
  var firstDayOfFirstMonth = month.clone().startOf('month');
  if (enableOutsideDays) firstDayOfFirstMonth = firstDayOfFirstMonth.startOf('week');
  if ((0, _isBeforeDay2['default'])(day, firstDayOfFirstMonth)) return false;

  var lastDayOfLastMonth = month.clone().add(numberOfMonths - 1, 'months').endOf('month');
  if (enableOutsideDays) lastDayOfLastMonth = lastDayOfLastMonth.endOf('week');
  return !(0, _isAfterDay2['default'])(day, lastDayOfLastMonth);
}

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toLocalizedDateString;

var _moment = __webpack_require__(13);

var _moment2 = _interopRequireDefault(_moment);

var _toMomentObject = __webpack_require__(168);

var _toMomentObject2 = _interopRequireDefault(_toMomentObject);

var _constants = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function toLocalizedDateString(date, currentFormat) {
  var dateObj = _moment2['default'].isMoment(date) ? date : (0, _toMomentObject2['default'])(date, currentFormat);
  if (!dateObj) return null;

  return dateObj.format(_constants.DISPLAY_FORMAT);
}

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMLazyTree = __webpack_require__(169);
var Danger = __webpack_require__(1475);
var ReactDOMComponentTree = __webpack_require__(33);
var ReactInstrumentation = __webpack_require__(73);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(392);
var setInnerHTML = __webpack_require__(274);
var setTextContent = __webpack_require__(646);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(22);

var invariant = __webpack_require__(12);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(22);

var ReactErrorUtils = __webpack_require__(390);

var invariant = __webpack_require__(12);
var warning = __webpack_require__(14);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(22);

var ReactPropTypesSecret = __webpack_require__(1504);
var propTypesFactory = __webpack_require__(377);

var React = __webpack_require__(175);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(12);
var warning = __webpack_require__(14);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(22);

var invariant = __webpack_require__(12);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = func.bind(null, a);
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(22);

var ReactCurrentOwner = __webpack_require__(95);
var ReactInstanceMap = __webpack_require__(214);
var ReactInstrumentation = __webpack_require__(73);
var ReactUpdates = __webpack_require__(84);

var invariant = __webpack_require__(12);
var warning = __webpack_require__(14);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(50);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(21);

var emptyFunction = __webpack_require__(70);
var warning = __webpack_require__(14);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getClass;

var _flexboxgrid = __webpack_require__(1191);

var _flexboxgrid2 = _interopRequireDefault(_flexboxgrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getClass(className) {
  return _flexboxgrid2.default && _flexboxgrid2.default[className] ? _flexboxgrid2.default[className] : className;
}

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createProps;
function createProps(propTypes, props, classNames) {
  var newProps = {};

  Object.keys(props).filter(function (key) {
    return key === 'children' || !propTypes[key];
  }).forEach(function (key) {
    return newProps[key] = props[key];
  });

  var className = classNames.filter(function (cn) {
    return cn;
  }).join(' ');
  return Object.assign({}, newProps, { className: className });
}

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(1543);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;

var _reducer = __webpack_require__(657);

Object.defineProperty(exports, 'LOCATION_CHANGE', {
  enumerable: true,
  get: function get() {
    return _reducer.LOCATION_CHANGE;
  }
});
Object.defineProperty(exports, 'routerReducer', {
  enumerable: true,
  get: function get() {
    return _reducer.routerReducer;
  }
});

var _actions = __webpack_require__(656);

Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
  enumerable: true,
  get: function get() {
    return _actions.CALL_HISTORY_METHOD;
  }
});
Object.defineProperty(exports, 'push', {
  enumerable: true,
  get: function get() {
    return _actions.push;
  }
});
Object.defineProperty(exports, 'replace', {
  enumerable: true,
  get: function get() {
    return _actions.replace;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _actions.go;
  }
});
Object.defineProperty(exports, 'goBack', {
  enumerable: true,
  get: function get() {
    return _actions.goBack;
  }
});
Object.defineProperty(exports, 'goForward', {
  enumerable: true,
  get: function get() {
    return _actions.goForward;
  }
});
Object.defineProperty(exports, 'routerActions', {
  enumerable: true,
  get: function get() {
    return _actions.routerActions;
  }
});

var _sync = __webpack_require__(1551);

var _sync2 = _interopRequireDefault(_sync);

var _middleware = __webpack_require__(1550);

var _middleware2 = _interopRequireDefault(_middleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.syncHistoryWithStore = _sync2['default'];
exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.loopAsync = loopAsync;
exports.mapAsync = mapAsync;
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ContextProvider = ContextProvider;
exports.ContextSubscriber = ContextSubscriber;

var _react = __webpack_require__(0);

// Works around issues with context updates failing to propagate.
// Caveat: the context value is expected to never change its identity.
// https://github.com/facebook/react/issues/2517
// https://github.com/reactjs/react-router/issues/470

var contextProviderShape = _react.PropTypes.shape({
  subscribe: _react.PropTypes.func.isRequired,
  eventIndex: _react.PropTypes.number.isRequired
});

function makeContextName(name) {
  return '@@contextSubscriber/' + name;
}

function ContextProvider(name) {
  var _childContextTypes, _ref2;

  var contextName = makeContextName(name);
  var listenersKey = contextName + '/listeners';
  var eventIndexKey = contextName + '/eventIndex';
  var subscribeKey = contextName + '/subscribe';

  return _ref2 = {
    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),

    getChildContext: function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextName] = {
        eventIndex: this[eventIndexKey],
        subscribe: this[subscribeKey]
      }, _ref;
    },
    componentWillMount: function componentWillMount() {
      this[listenersKey] = [];
      this[eventIndexKey] = 0;
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      this[eventIndexKey]++;
    },
    componentDidUpdate: function componentDidUpdate() {
      var _this = this;

      this[listenersKey].forEach(function (listener) {
        return listener(_this[eventIndexKey]);
      });
    }
  }, _ref2[subscribeKey] = function (listener) {
    var _this2 = this;

    // No need to immediately call listener here.
    this[listenersKey].push(listener);

    return function () {
      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
        return item !== listener;
      });
    };
  }, _ref2;
}

function ContextSubscriber(name) {
  var _contextTypes, _ref4;

  var contextName = makeContextName(name);
  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
  var handleContextUpdateKey = contextName + '/handleContextUpdate';
  var unsubscribeKey = contextName + '/unsubscribe';

  return _ref4 = {
    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),

    getInitialState: function getInitialState() {
      var _ref3;

      if (!this.context[contextName]) {
        return {};
      }

      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
    },
    componentDidMount: function componentDidMount() {
      if (!this.context[contextName]) {
        return;
      }

      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      var _setState;

      if (!this.context[contextName]) {
        return;
      }

      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
    },
    componentWillUnmount: function componentWillUnmount() {
      if (!this[unsubscribeKey]) {
        return;
      }

      this[unsubscribeKey]();
      this[unsubscribeKey] = null;
    }
  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
      var _setState2;

      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
    }
  }, _ref4;
}

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationShape = exports.routerShape = undefined;

var _react = __webpack_require__(0);

var func = _react.PropTypes.func,
    object = _react.PropTypes.object,
    shape = _react.PropTypes.shape,
    string = _react.PropTypes.string;
var routerShape = exports.routerShape = shape({
  push: func.isRequired,
  replace: func.isRequired,
  go: func.isRequired,
  goBack: func.isRequired,
  goForward: func.isRequired,
  setRouteLeaveHook: func.isRequired,
  isActive: func.isRequired
});

var locationShape = exports.locationShape = shape({
  pathname: string.isRequired,
  search: string.isRequired,
  state: object,
  action: string.isRequired,
  key: string
});

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _invariant = __webpack_require__(36);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _getRouteParams = __webpack_require__(1562);

var _getRouteParams2 = _interopRequireDefault(_getRouteParams);

var _ContextUtils = __webpack_require__(405);

var _RouteUtils = __webpack_require__(104);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _React$PropTypes = _react2.default.PropTypes,
    array = _React$PropTypes.array,
    func = _React$PropTypes.func,
    object = _React$PropTypes.object;

/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */

var RouterContext = _react2.default.createClass({
  displayName: 'RouterContext',


  mixins: [(0, _ContextUtils.ContextProvider)('router')],

  propTypes: {
    router: object.isRequired,
    location: object.isRequired,
    routes: array.isRequired,
    params: object.isRequired,
    components: array.isRequired,
    createElement: func.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: _react2.default.createElement
    };
  },


  childContextTypes: {
    router: object.isRequired
  },

  getChildContext: function getChildContext() {
    return {
      router: this.props.router
    };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        location = _props.location,
        routes = _props.routes,
        params = _props.params,
        components = _props.components,
        router = _props.router;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = (0, _getRouteParams2.default)(route, params);
        var props = {
          location: location,
          params: params,
          route: route,
          router: router,
          routeParams: routeParams,
          routes: routes
        };

        if ((0, _RouteUtils.isReactChildren)(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;

    return element;
  }
});

exports.default = RouterContext;
module.exports = exports['default'];

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;

var _LocationUtils = __webpack_require__(174);

var _DOMUtils = __webpack_require__(278);

var _DOMStateStorage = __webpack_require__(666);

var _PathUtils = __webpack_require__(105);

var _ExecutionEnvironment = __webpack_require__(409);

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();

var _createLocation = function _createLocation(historyState) {
  var key = historyState && historyState.key;

  return (0, _LocationUtils.createLocation)({
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
  }, undefined, key);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  var historyState = void 0;
  try {
    historyState = window.history.state || {};
  } catch (error) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    historyState = {};
  }

  return _createLocation(historyState);
};

var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

var startListener = exports.startListener = function startListener(listener) {
  var handlePopState = function handlePopState(event) {
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
      return;
    listener(_createLocation(event.state));
  };

  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
    return listener(getCurrentLocation());
  };

  if (needsHashchangeListener) {
    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
  }

  return function () {
    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

    if (needsHashchangeListener) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
    }
  };
};

var updateLocation = function updateLocation(location, updateState) {
  var state = location.state,
      key = location.key;


  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);

  updateState({ key: key }, (0, _PathUtils.createPath)(location));
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.pushState(state, null, path);
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.replaceState(state, null, path);
  });
};

var go = exports.go = function go(n) {
  if (n) window.history.go(n);
};

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AsyncUtils = __webpack_require__(1568);

var _PathUtils = __webpack_require__(105);

var _runTransitionHook = __webpack_require__(411);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _Actions = __webpack_require__(277);

var _LocationUtils = __webpack_require__(174);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createHistory = function createHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getCurrentLocation = options.getCurrentLocation,
      getUserConfirmation = options.getUserConfirmation,
      pushLocation = options.pushLocation,
      replaceLocation = options.replaceLocation,
      go = options.go,
      keyLength = options.keyLength;


  var currentLocation = void 0;
  var pendingLocation = void 0;
  var beforeListeners = [];
  var listeners = [];
  var allKeys = [];

  var getCurrentIndex = function getCurrentIndex() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);

    if (currentLocation) return allKeys.indexOf(currentLocation.key);

    return -1;
  };

  var updateLocation = function updateLocation(nextLocation) {
    var currentIndex = getCurrentIndex();

    currentLocation = nextLocation;

    if (currentLocation.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
    } else if (currentLocation.action === _Actions.REPLACE) {
      allKeys[currentIndex] = currentLocation.key;
    }

    listeners.forEach(function (listener) {
      return listener(currentLocation);
    });
  };

  var listenBefore = function listenBefore(listener) {
    beforeListeners.push(listener);

    return function () {
      return beforeListeners = beforeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var listen = function listen(listener) {
    listeners.push(listener);

    return function () {
      return listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
        return result != null ? done(result) : next();
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          return callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  };

  var transitionTo = function transitionTo(nextLocation) {
    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation

      pendingLocation = null;

      if (ok) {
        // Treat PUSH to same path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = (0, _PathUtils.createPath)(currentLocation);
          var nextPath = (0, _PathUtils.createPath)(nextLocation);

          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (nextLocation.action === _Actions.POP) {
          updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.PUSH) {
          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.REPLACE) {
          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
        }
      } else if (currentLocation && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(currentLocation.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
      }
    });
  };

  var push = function push(input) {
    return transitionTo(createLocation(input, _Actions.PUSH));
  };

  var replace = function replace(input) {
    return transitionTo(createLocation(input, _Actions.REPLACE));
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength || 6);
  };

  var createHref = function createHref(location) {
    return (0, _PathUtils.createPath)(location);
  };

  var createLocation = function createLocation(location, action) {
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
    return (0, _LocationUtils.createLocation)(location, action, key);
  };

  return {
    getCurrentLocation: getCurrentLocation,
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: _PathUtils.createPath,
    createHref: createHref,
    createLocation: createLocation
  };
};

exports.default = createHistory;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(107);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var runTransitionHook = function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
  }
};

exports.default = runTransitionHook;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(61);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(719));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(179));

var _createClass2 = _interopRequireDefault(__webpack_require__(180));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(181));

var _CellSizeAndPositionManager = _interopRequireDefault(__webpack_require__(1582));

var _maxElementSize = __webpack_require__(1584);

var _types = __webpack_require__(106);

/**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */
var ScalingCellSizeAndPositionManager =
/*#__PURE__*/
function () {
  function ScalingCellSizeAndPositionManager(_ref) {
    var _ref$maxScrollSize = _ref.maxScrollSize,
        maxScrollSize = _ref$maxScrollSize === void 0 ? (0, _maxElementSize.getMaxElementSize)() : _ref$maxScrollSize,
        params = (0, _objectWithoutProperties2["default"])(_ref, ["maxScrollSize"]);
    (0, _classCallCheck2["default"])(this, ScalingCellSizeAndPositionManager);
    (0, _defineProperty2["default"])(this, "_cellSizeAndPositionManager", void 0);
    (0, _defineProperty2["default"])(this, "_maxScrollSize", void 0);
    // Favor composition over inheritance to simplify IE10 support
    this._cellSizeAndPositionManager = new _CellSizeAndPositionManager["default"](params);
    this._maxScrollSize = maxScrollSize;
  }

  (0, _createClass2["default"])(ScalingCellSizeAndPositionManager, [{
    key: "areOffsetsAdjusted",
    value: function areOffsetsAdjusted() {
      return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
    }
  }, {
    key: "configure",
    value: function configure(params) {
      this._cellSizeAndPositionManager.configure(params);
    }
  }, {
    key: "getCellCount",
    value: function getCellCount() {
      return this._cellSizeAndPositionManager.getCellCount();
    }
  }, {
    key: "getEstimatedCellSize",
    value: function getEstimatedCellSize() {
      return this._cellSizeAndPositionManager.getEstimatedCellSize();
    }
  }, {
    key: "getLastMeasuredIndex",
    value: function getLastMeasuredIndex() {
      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
    }
    /**
     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
     * The offset passed to this function is scaled (safe) as well.
     */

  }, {
    key: "getOffsetAdjustment",
    value: function getOffsetAdjustment(_ref2) {
      var containerSize = _ref2.containerSize,
          offset = _ref2.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();

      var safeTotalSize = this.getTotalSize();

      var offsetPercentage = this._getOffsetPercentage({
        containerSize: containerSize,
        offset: offset,
        totalSize: safeTotalSize
      });

      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
    }
  }, {
    key: "getSizeAndPositionOfCell",
    value: function getSizeAndPositionOfCell(index) {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
    }
  }, {
    key: "getSizeAndPositionOfLastMeasuredCell",
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
    }
    /** See CellSizeAndPositionManager#getTotalSize */

  }, {
    key: "getTotalSize",
    value: function getTotalSize() {
      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
    }
    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */

  }, {
    key: "getUpdatedOffsetForIndex",
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === void 0 ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;
      currentOffset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: currentOffset
      });

      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
        align: align,
        containerSize: containerSize,
        currentOffset: currentOffset,
        targetIndex: targetIndex
      });

      return this._offsetToSafeOffset({
        containerSize: containerSize,
        offset: offset
      });
    }
    /** See CellSizeAndPositionManager#getVisibleCellRange */

  }, {
    key: "getVisibleCellRange",
    value: function getVisibleCellRange(_ref4) {
      var containerSize = _ref4.containerSize,
          offset = _ref4.offset;
      offset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: offset
      });
      return this._cellSizeAndPositionManager.getVisibleCellRange({
        containerSize: containerSize,
        offset: offset
      });
    }
  }, {
    key: "resetCell",
    value: function resetCell(index) {
      this._cellSizeAndPositionManager.resetCell(index);
    }
  }, {
    key: "_getOffsetPercentage",
    value: function _getOffsetPercentage(_ref5) {
      var containerSize = _ref5.containerSize,
          offset = _ref5.offset,
          totalSize = _ref5.totalSize;
      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
    }
  }, {
    key: "_offsetToSafeOffset",
    value: function _offsetToSafeOffset(_ref6) {
      var containerSize = _ref6.containerSize,
          offset = _ref6.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();

      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: totalSize
        });

        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
      }
    }
  }, {
    key: "_safeOffsetToOffset",
    value: function _safeOffsetToOffset(_ref7) {
      var containerSize = _ref7.containerSize,
          offset = _ref7.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();

      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: safeTotalSize
        });

        return Math.round(offsetPercentage * (totalSize - containerSize));
      }
    }
  }]);
  return ScalingCellSizeAndPositionManager;
}();

exports["default"] = ScalingCellSizeAndPositionManager;

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return qEnd; });
/* harmony export (immutable) */ __webpack_exports__["c"] = safeName;
/* harmony export (immutable) */ __webpack_exports__["a"] = fsmIterator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(67);


var done = { done: true, value: undefined };
var qEnd = {};

function safeName(patternOrChannel) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].channel(patternOrChannel)) {
    return 'channel';
  } else if (Array.isArray(patternOrChannel)) {
    return String(patternOrChannel.map(function (entry) {
      return String(entry);
    }));
  } else {
    return String(patternOrChannel);
  }
}

function fsmIterator(fsm, q0) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';

  var updateState = void 0,
      qNext = q0;

  function next(arg, error) {
    if (qNext === qEnd) {
      return done;
    }

    if (error) {
      qNext = qEnd;
      throw error;
    } else {
      updateState && updateState(arg);

      var _fsm$qNext = fsm[qNext](),
          q = _fsm$qNext[0],
          output = _fsm$qNext[1],
          _updateState = _fsm$qNext[2];

      qNext = q;
      updateState = _updateState;
      return qNext === qEnd ? done : output;
    }
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["j" /* makeIterator */])(next, function (error) {
    return next(null, error);
  }, name, true);
}

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcFacebookComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icons/ic-facebook"},React.createElement("g",{"id":"Vector"},[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.5583 1.49984H1.44173V16.4998H16.5583V1.49984ZM0.608398 0.666504V17.3332H17.3916V0.666504H0.608398Z","fill":"#3E3E3E","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.917 13.9998V9.49984H11.2928L11.5175 7.49984H9.917V6.52584C9.917 6.01084 9.93025 5.49984 10.6549 5.49984H11.3889V4.06984C11.3889 4.04834 10.7584 3.99984 10.1206 3.99984C8.78853 3.99984 7.95444 4.82834 7.95444 6.34984V7.49984H6.48252V9.49984H7.95444V13.9998H9.917Z","fill":"#3E3E3E","key":1})])));
}

IcFacebookComponent.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = IcFacebookComponent;

IcFacebookComponent.default = IcFacebookComponent;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcMailComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icons/ic-search"},[React.createElement("rect",{"id":"background","x":"1.34729","y":"1.1665","width":"15.7832","height":"15.6667","stroke":"#3E3E3E","key":0}),React.createElement("path",{"id":"Vector","d":"M4.5 4.5H13.5C13.7761 4.5 14 4.72386 14 5V13C14 13.2761 13.7761 13.5 13.5 13.5H4.5C4.22386 13.5 4 13.2761 4 13V5C4 4.72386 4.22386 4.5 4.5 4.5ZM13 6.61896L9.0359 10.169L5 6.60797V12.5H13V6.61896ZM5.25573 5.5L9.03095 8.831L12.7505 5.5H5.25573Z","fill":"#3E3E3E","key":1})]));
}

IcMailComponent.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = IcMailComponent;

IcMailComponent.default = IcMailComponent;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcSeeComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-see"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M17.0782 10.1038L17.1297 9.99993L17.0782 9.89604C16.4089 8.54393 15.4397 7.46725 14.1736 6.67005C12.9065 5.87224 11.5136 5.47306 10 5.47306C8.48652 5.47306 7.09358 5.87224 5.82648 6.67005C4.56034 7.46725 3.59122 8.54393 2.92186 9.89604L2.87043 9.99993L2.92186 10.1038C3.59122 11.4559 4.56034 12.5326 5.82648 13.3298C7.09358 14.1276 8.48652 14.5268 10 14.5268C11.5136 14.5268 12.9065 14.1276 14.1736 13.3298C15.4397 12.5326 16.4089 11.4559 17.0782 10.1038ZM12.3223 12.3222C11.6838 12.9607 10.9143 13.278 10 13.278C9.08582 13.278 8.31631 12.9607 7.67779 12.3222C7.03927 11.6837 6.72197 10.9142 6.72197 9.99993C6.72197 9.0857 7.03927 8.31619 7.67779 7.67767C8.31631 7.03915 9.08582 6.72185 10 6.72185C10.9143 6.72185 11.6838 7.03915 12.3223 7.67767C12.9608 8.31619 13.2781 9.0857 13.2781 9.99993C13.2781 10.9142 12.9608 11.6837 12.3223 12.3222ZM8.34178 11.6582C8.79595 12.1124 9.35328 12.3414 10 12.3414C10.6468 12.3414 11.2041 12.1124 11.6583 11.6582C12.1125 11.204 12.3415 10.6467 12.3415 9.99993C12.3415 9.35316 12.1125 8.79583 11.6583 8.34166C11.2041 7.8875 10.6468 7.65844 10 7.65844C9.35328 7.65844 8.79595 7.8875 8.34178 8.34166C7.88761 8.79583 7.65856 9.35316 7.65856 9.99993C7.65856 10.6467 7.88761 11.204 8.34178 11.6582ZM10 15.6195C8.14743 15.6195 6.46322 15.1033 4.94131 14.0697C3.44502 13.0534 2.35442 11.6987 1.66675 9.99993C2.35442 8.30117 3.44502 6.94641 4.94131 5.93018C6.46322 4.89655 8.14743 4.38037 10 4.38037C11.8527 4.38037 13.5369 4.89655 15.0588 5.93018C16.5551 6.94641 17.6457 8.30116 18.3333 9.99992C17.6457 11.6987 16.5551 13.0534 15.0588 14.0697C13.5369 15.1033 11.8527 15.6195 10 15.6195Z","fill":"#3E3E3E"})));
}

IcSeeComponent.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IcSeeComponent;

IcSeeComponent.default = IcSeeComponent;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcWhatsappComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icons/ic-search"},[React.createElement("rect",{"id":"background","x":"1.34729","y":"1.1665","width":"15.7832","height":"15.6667","stroke":"#3E3E3E","key":0}),React.createElement("path",{"id":"Vector","d":"M6.62631 12.2472L6.98868 12.4585C7.59405 12.8115 8.28206 13 9.00001 13C11.2092 13 13 11.2092 13 9C13 6.79086 11.2092 5 9.00001 5C6.79086 5 5 6.79086 5 9C5 9.71815 5.18861 10.4064 5.54184 11.0119L5.75303 11.3739L5.42628 12.5747L6.62631 12.2472ZM4.00209 14L4.67807 11.5157C4.24698 10.7768 4 9.91725 4 9C4 6.23857 6.23857 4 9.00001 4C11.7614 4 14 6.23857 14 9C14 11.7614 11.7614 14 9.00001 14C8.08306 14 7.22376 13.7532 6.48494 13.3223L4.00209 14ZM7.19567 6.65417C7.26261 6.64946 7.32977 6.64874 7.3968 6.65201C7.42388 6.65379 7.45083 6.65692 7.4778 6.66003C7.55743 6.66923 7.645 6.71773 7.67444 6.78447C7.8236 7.12268 7.96833 7.46282 8.10861 7.80481C8.13956 7.88031 8.12091 7.97817 8.06201 8.07285C8.03211 8.1214 7.98515 8.1895 7.93075 8.25915C7.8742 8.3315 7.7525 8.46455 7.7525 8.46455C7.7525 8.46455 7.7032 8.52365 7.72178 8.5972C7.72902 8.625 7.75211 8.6655 7.77305 8.69955C7.78464 8.7184 7.79541 8.73525 7.80239 8.7469C7.93035 8.96055 8.10236 9.17715 8.31246 9.3808C8.37266 9.43915 8.43106 9.4987 8.49386 9.554C8.72801 9.76045 8.99291 9.92915 9.279 10.0541L9.28155 10.0553C9.3238 10.0735 9.3455 10.0834 9.40735 10.1097C9.43855 10.1228 9.47045 10.1343 9.5032 10.1429C9.51505 10.146 9.5272 10.1477 9.5394 10.1486C9.62025 10.1535 9.667 10.1016 9.68695 10.0778C10.0487 9.6395 10.0818 9.6109 10.0843 9.6111V9.6119C10.1319 9.5618 10.2066 9.5444 10.2733 9.5485C10.3038 9.55035 10.3341 9.5562 10.3618 9.56885C10.6277 9.69015 11.0624 9.87935 11.0624 9.87935L11.3532 10.01C11.4019 10.0335 11.4463 10.0889 11.4485 10.1427C11.4498 10.1762 11.4534 10.2301 11.4414 10.3289C11.4258 10.4583 11.3864 10.614 11.3473 10.6957C11.3198 10.7529 11.2842 10.8037 11.2428 10.8467C11.1867 10.905 11.145 10.9404 11.0775 10.9907C11.0364 11.0213 11.0151 11.0357 11.0151 11.0357C10.9456 11.0795 10.9065 11.1014 10.8237 11.1454C10.695 11.214 10.5528 11.2534 10.4072 11.2609C10.3143 11.2656 10.2217 11.2724 10.129 11.2674C10.1249 11.2671 9.84485 11.2241 9.84485 11.2241C9.1339 11.0371 8.47641 10.6868 7.92468 10.201C7.81187 10.1017 7.70726 9.99425 7.60048 9.88795C7.15595 9.4454 6.81942 8.9682 6.61535 8.5168C6.51472 8.2942 6.451 8.0558 6.45 7.81049C6.44815 7.50703 6.5475 7.2116 6.73235 6.97093C6.76879 6.92349 6.80338 6.87427 6.86305 6.81793C6.92625 6.75826 6.96647 6.72622 7.00979 6.70406C7.06754 6.67451 7.13097 6.65871 7.19567 6.65417Z","fill":"#3E3E3E","key":1})]));
}

IcWhatsappComponent.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = IcWhatsappComponent;

IcWhatsappComponent.default = IcWhatsappComponent;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcXComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icons/ic-search"},[React.createElement("rect",{"id":"background","x":"1.1084","y":"1.1665","width":"15.7832","height":"15.6667","stroke":"#3E3E3E","key":0}),React.createElement("path",{"id":"Vector","d":"M12.0572 3.58301H13.7536L10.0474 7.81891L14.4074 13.583H10.9936L8.31973 10.0871L5.26026 13.583H3.56282L7.52693 9.05224L3.34436 3.58301H6.84487L9.26178 6.77839L12.0572 3.58301Z","fill":"#3E3E3E","key":1})]));
}

IcXComponent.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = IcXComponent;

IcXComponent.default = IcXComponent;


/***/ }),
/* 419 */
/***/ (function(module, exports) {

function _extends() {
  return module.exports = _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(220)["default"];
var toPrimitive = __webpack_require__(722);
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isArray = exports.isArray = function isArray(obj) {
  return Array.isArray(obj);
};

var buildState = exports.buildState = function buildState(props) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var state = {};
  Object.entries(props).forEach(function (prop) {
    var key = prop[0];
    var value = prop[1];

    if (key !== 'children') {
      state[key] = isArray(value) ? value[index] : value;
    }
  });

  state['index'] = index;
  return state;
};

var removeUnit = exports.removeUnit = function removeUnit(time) {
  return time.replace('s', '');
};

var convertToMs = exports.convertToMs = function convertToMs(time) {
  return time * 1000;
};

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(221),
    _assign = __webpack_require__(21);

var ReactNoopUpdateQueue = __webpack_require__(425);

var canDefineProperty = __webpack_require__(426);
var emptyObject = __webpack_require__(250);
var invariant = __webpack_require__(12);
var lowPriorityWarning = __webpack_require__(819);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(14);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(812);


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);
var settle = __webpack_require__(829);
var buildURL = __webpack_require__(832);
var parseHeaders = __webpack_require__(838);
var isURLSameOrigin = __webpack_require__(836);
var createError = __webpack_require__(431);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(831);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(834);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(828);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(10);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 10px 16px;\n  align-items: flex-start;\n  gap: 4px;\n  flex: 1 0 0;\n  border-bottom: 1px solid #ececec;\n'],['\n  display: flex;\n  padding: 10px 16px;\n  align-items: flex-start;\n  gap: 4px;\n  flex: 1 0 0;\n  border-bottom: 1px solid #ececec;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 1 0 0;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  color: #3e3e3e;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n'],['\n  flex: 1 0 0;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  color: #3e3e3e;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 2px;\n  flex: 1 0 0;\n\n  > span {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    align-self: stretch;\n    gap: 4px;\n  }\n\n  p {\n    color: #1d1e22;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    margin: 0;\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 2px;\n  flex: 1 0 0;\n\n  > span {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    align-self: stretch;\n    gap: 4px;\n  }\n\n  p {\n    color: #1d1e22;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    margin: 0;\n  }\n']);/* Aditional Services List
 * Created on Wed Aug 30 2017
 *
 * Copyright (c) 2017 Ubiwhere
 *
 * Authors:
 * - Hugo Fonseca <hfonseca@ubiwhere.com>
 */var AditionalServicesV2=function AditionalServicesV2(_ref){var list=_ref.list,style=_ref.style;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,{style:style},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Cell,null,'Condi\xE7\xF5es adicionais'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ListCell,null,list&&list.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:''+__WEBPACK_IMPORTED_MODULE_3__config__["e" /* MEDIA_BASE_URL */]+item.icon,alt:item.name}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,item.name));}),!list.length&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'-')));};/* harmony default export */ __webpack_exports__["a"] = (AditionalServicesV2);var Row=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].tr(_templateObject);var Cell=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].td(_templateObject2);var ListCell=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].td(_templateObject3);

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_config__ = __webpack_require__(10);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 40px;\n  max-width: 74px;\n  background: ',';\n  padding: 1px;\n  flex-grow: 1;\n  cursor: pointer;\n'],['\n  height: 40px;\n  max-width: 74px;\n  background: ',';\n  padding: 1px;\n  flex-grow: 1;\n  cursor: pointer;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  height: 100%;\n  padding: 8px;\n  flex: 1 0 0;\n  background: #fff;\n\n  &:hover {\n    background: #ececec;\n  }\n\n  &.selected {\n    background: transparent;\n\n    > p {\n      color: #fff;\n    }\n\n    svg,\n    path {\n      fill: #fff;\n    }\n  }\n'],['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  height: 100%;\n  padding: 8px;\n  flex: 1 0 0;\n  background: #fff;\n\n  &:hover {\n    background: #ececec;\n  }\n\n  &.selected {\n    background: transparent;\n\n    > p {\n      color: #fff;\n    }\n\n    svg,\n    path {\n      fill: #fff;\n    }\n  }\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  width: 20px !important;\n  height: 20px !important;\n  border: none !important;\n  position: relative;\n  z-index: 1;\n  cursor: pointer;\n  display: none;\n'],['\n  display: block;\n  width: 20px !important;\n  height: 20px !important;\n  border: none !important;\n  position: relative;\n  z-index: 1;\n  cursor: pointer;\n  display: none;\n']);var BoxRadioV2=function BoxRadioV2(_ref){var children=_ref.children,name=_ref.name,selected=_ref.selected,onClick=_ref.onClick,value=_ref.value,className=_ref.className,props=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref,['children','name','selected','onClick','value','className']);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(WrapperBg,Object.assign({bgColor:__WEBPACK_IMPORTED_MODULE_4_config__["c" /* backgroundColors */].normalLeft,className:className+' '+(selected&&'selected')},props),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Wrapper,{onClick:onClick,className:selected&&'selected',tabIndex:'1'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Input,{bgColor:__WEBPACK_IMPORTED_MODULE_4_config__["c" /* backgroundColors */].normalLeft,id:'opt-'+value+'-'+name,name:name,checked:selected,onChange:onClick}),children));};/* harmony default export */ __webpack_exports__["a"] = (BoxRadioV2);var WrapperBg=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject,function(_ref2){var bgColor=_ref2.bgColor;return bgColor;});var Wrapper=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject2);var Input=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].input.attrs({type:'radio'})(_templateObject3);

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config__ = __webpack_require__(10);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  text-align: center;\n  width: 150px;\n  cursor: pointer;\n\n  @media screen and (max-width: 768px) {\n    width: 100px;\n  }\n'],['\n  text-align: center;\n  width: 150px;\n  cursor: pointer;\n\n  @media screen and (max-width: 768px) {\n    width: 100px;\n  }\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  border: 1px solid #dedede;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  height: 80px;\n  width: 80px;\n  margin: 0 auto;\n  border-radius: 0px;\n\n  &:hover,\n  &.selected {\n    background: ',';\n\n    svg path {\n      fill: #fff;\n    }\n  }\n\n  @media screen and (max-width: 768px) {\n    width: 65px;\n    height: 65px;\n  }\n'],['\n  border: 1px solid #dedede;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  height: 80px;\n  width: 80px;\n  margin: 0 auto;\n  border-radius: 0px;\n\n  &:hover,\n  &.selected {\n    background: ',';\n\n    svg path {\n      fill: #fff;\n    }\n  }\n\n  @media screen and (max-width: 768px) {\n    width: 65px;\n    height: 65px;\n  }\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  text-transform: uppercase;\n  margin-top: 20px;\n  font-size: 12px;\n  line-height: 12px;\n  color: #010101;\n  font-weight: bold;\n  text-align: center;\n  font-family: \'Nunito\', \'Helvetica Neue\', sans-serif;\n\n  @media screen and (max-width: 768px) {\n    font-size: 10px;\n  }\n'],['\n  display: block;\n  text-transform: uppercase;\n  margin-top: 20px;\n  font-size: 12px;\n  line-height: 12px;\n  color: #010101;\n  font-weight: bold;\n  text-align: center;\n  font-family: \'Nunito\', \'Helvetica Neue\', sans-serif;\n\n  @media screen and (max-width: 768px) {\n    font-size: 10px;\n  }\n']);var Wrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject);var CenteredBox=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject2,function(_ref){var bgColor=_ref.bgColor;return bgColor;});var Title=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject3);var Button=function Button(_ref2){var icon=_ref2.icon,name=_ref2.name,selected=_ref2.selected,onClick=_ref2.onClick,className=_ref2.className;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Wrapper,{onClick:onClick,className:className},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(CenteredBox,{bgColor:__WEBPACK_IMPORTED_MODULE_3_config__["c" /* backgroundColors */].normalRight,className:selected&&'selected'},icon),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Title,null,name));};/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
var _templateObject=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #263238;\n  font-size: 14px;\n  display: flex;\n  cursor: pointer;\n  margin: 0;\n  width: auto;\n'],['\n  color: #263238;\n  font-size: 14px;\n  display: flex;\n  cursor: pointer;\n  margin: 0;\n  width: auto;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: none;\n'],['\n  display: none;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  border: 1px solid #bababa;\n  width: 16px;\n  height: 16px;\n  position: relative;\n  cursor: pointer;\n  display: inline-block;\n  margin-right: 5px;\n'],['\n  border: 1px solid #bababa;\n  width: 16px;\n  height: 16px;\n  position: relative;\n  cursor: pointer;\n  display: inline-block;\n  margin-right: 5px;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  border-bottom: 2px solid #93c13e;\n  border-left: 2px solid #93c13e;\n  width: 11px;\n  height: 5px;\n  transform: rotate(-45deg);\n  position: absolute;\n  top: 3px;\n  left: 2px;\n\n  ','\n'],['\n  border-bottom: 2px solid #93c13e;\n  border-left: 2px solid #93c13e;\n  width: 11px;\n  height: 5px;\n  transform: rotate(-45deg);\n  position: absolute;\n  top: 3px;\n  left: 2px;\n\n  ','\n']);var Label=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].label(_templateObject);var InnerCheck=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].input(_templateObject2);var FauxCheck=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject3);var Checkmark=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject4,function(_ref){var checked=_ref.checked;return!checked&&'display: none;';});var CheckInput=function(_Component){__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(CheckInput,_Component);function CheckInput(){__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this,CheckInput);return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this,(CheckInput.__proto__||Object.getPrototypeOf(CheckInput)).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CheckInput,[{key:'render',value:function render(){var props=this.props;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Label,props,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(FauxCheck,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Checkmark,{checked:props.value})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InnerCheck,Object.assign({type:'checkbox'},props)),props.label);}}]);return CheckInput;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);CheckInput.propTypes={onClick:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,label:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,onChange:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (CheckInput);

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Counter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_less_component_svg__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_less_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_less_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_more_component_svg__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_more_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_more_component_svg__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  border: 1px solid #DEDEDE;\n\n  position: relative;\n\n  opacity: 0.5;\n\n\n  ','\n\n  outline: none;\n  background: #FFF;\n\n  display:block;\n\n\n  float:left;\n\n  width: calc(50% - 4px);\n\n\n  margin-top: 8px;\n\n  &:before,\n  &:after {\n    content:"";\n    display:table;\n  }\n\n  &:after {\n    clear:both;\n  }\n\n  &:focus {\n    outline: none;\n\n  }\n  > * {\n    pointer-events: none;\n  }\n\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n\n\n\n\n  ','\n\n  ','\n\n  ','\n\n  ','\n'],['\n  border: 1px solid #DEDEDE;\n\n  position: relative;\n\n  opacity: 0.5;\n\n\n  ','\n\n  outline: none;\n  background: #FFF;\n\n  display:block;\n\n\n  float:left;\n\n  width: calc(50% - 4px);\n\n\n  margin-top: 8px;\n\n  &:before,\n  &:after {\n    content:"";\n    display:table;\n  }\n\n  &:after {\n    clear:both;\n  }\n\n  &:focus {\n    outline: none;\n\n  }\n  > * {\n    pointer-events: none;\n  }\n\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n\n\n\n\n  ','\n\n  ','\n\n  ','\n\n  ','\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  background: #FFF;\n  border: 1px solid #DEDEDE;\n  width: 118px;\n  min-height: 118px;\n\n  span {\n    display:block;\n    color: #010101;\n    font-family: Nunito;\n    font-size: 12px;\n    font-weight: bold;\n    line-height: 12px;\n    text-align: center;\n    text-transform: uppercase;\n  }\n  div {\n    svg {\n      width: 100%;\n    }\n  }\n\n  ','\n\n\n  ','\n\n  ','\n'],['\n  display: block;\n  background: #FFF;\n  border: 1px solid #DEDEDE;\n  width: 118px;\n  min-height: 118px;\n\n  span {\n    display:block;\n    color: #010101;\n    font-family: Nunito;\n    font-size: 12px;\n    font-weight: bold;\n    line-height: 12px;\n    text-align: center;\n    text-transform: uppercase;\n  }\n  div {\n    svg {\n      width: 100%;\n    }\n  }\n\n  ','\n\n\n  ','\n\n  ','\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: inline-block;\n\n  width: 120px;\n  min-height: 158px;\n\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n\n  vertical-align: top;\n'],['\n  display: inline-block;\n\n  width: 120px;\n  min-height: 158px;\n\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n\n  vertical-align: top;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #7c7c7c !important;\n  font-size: 9px !important;\n  margin: 0 !important;\n'],['\n  color: #7c7c7c !important;\n  font-size: 9px !important;\n  margin: 0 !important;\n']);var Counter=function(_React$Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Counter,_React$Component);function Counter(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,Counter);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=Counter.__proto__||Object.getPrototypeOf(Counter)).call.apply(_ref,[this].concat(args))),_this),_this.increment=function(val){var value=_this.props.value;_this.props.onChange&&_this.props.onChange({value:value+1});},_this.decrement=function(val){var value=_this.props.value;_this.props.onChange&&_this.props.onChange({value:value-1});},_temp),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Counter,[{key:'render',value:function render(){var _this2=this;var _props=this.props,type=_props.type,text=_props.text,disabled=_props.disabled,value=_props.value,children=_props.children,subLabel=_props.subLabel;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Image,{type:type},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',null,children),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span',null,value,'\xA0',text),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(SmallLabel,null,subLabel)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Button,{less:true,disabled:value===0,onClick:function onClick(){_this2.decrement(1);}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__images_less_component_svg___default.a,null)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Button,{plus:true,margin:true,onClick:function onClick(){_this2.increment(1);},disabled:disabled},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__images_more_component_svg___default.a,null)));}}]);return Counter;}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);var Button=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].button.attrs({type:'button'})(_templateObject,function(_ref2){var disabled=_ref2.disabled;return!disabled&&'\n    cursor: pointer;\n    opacity: 1.0;\n\n    &:hover {\n      opacity: 0.5;\n    }\n\n  ';},function(_ref3){var margin=_ref3.margin;return margin&&'margin-left: 30px;';},function(_ref4){var less=_ref4.less;return less&&'\n    svg {\n      margin-top: 16px;\n      margin-bottom: 13px;\n\n      width: 14px;\n      path {\n        fill: #93C13E;\n      }\n    }\n  ';},function(_ref5){var plus=_ref5.plus;return plus&&'\n    margin-left: 8px;\n    svg {\n\n      margin-top: 10px;\n      margin-bottom: 7px;\n\n      width: 14px;\n      height: 14px;\n\n      path {\n        fill: #93C13E;\n      }\n    }\n  ';},function(_ref6){var disabled=_ref6.disabled;return disabled&&'\n    svg {\n      rect {\n        fill: #DEDEDE;\n      }\n    }\n  ';});var Image=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject2,function(_ref7){var type=_ref7.type;return type==='adultos'?'\n    div {\n      margin-top: 26px;\n      margin-left: 40px;\n      margin-right: 40px;\n      width: 40px;\n      height: 40px;\n\n    }\n    span {\n      margin-top: 16px;\n    }\n  ':'';},function(_ref8){var type=_ref8.type;return type==='criancas'?'\n    div {\n      margin-top: 24px;\n      margin-left: 37px;\n      margin-right: 37px;\n\n      width: 46px;\n      height: 43px;\n    }\n    span {\n      margin-top: 15px;\n    }\n  ':'';},function(_ref9){var type=_ref9.type;return type==='idosos'?'\n    div {\n      margin-top: 22px;\n      margin-left: 40px;\n      margin-right: 40px;\n\n      width: 40px;\n      height: 48px;\n    }\n    span {\n      margin-top: 12px;\n    }\n  ':'';});var Container=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject3);var SmallLabel=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject4);

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return processIdentification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return processComercial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return processAdditionalServices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return processRefunds; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_portuguese_utils_formaters_formatToCurrency__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_portuguese_utils_formaters_formatToCurrency___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_portuguese_utils_formaters_formatToCurrency__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__information_entries__ = __webpack_require__(294);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  word-wrap: \'break-word\';\n  color: #93c13e;\n'],['\n  word-wrap: \'break-word\';\n  color: #93c13e;\n']);/* eslint-disable camelcase */var processIdentification=function processIdentification(_ref,_ref2){var designation=_ref.designation,description=_ref.description;var commercial_offer_website=_ref2.commercial_offer_website,website_standardized_contract_form=_ref2.website_standardized_contract_form,website_contract_conditions=_ref2.website_contract_conditions,contacts=_ref2.contacts,email_contact=_ref2.email_contact,website_contact=_ref2.website_contact;return{designation:designation,description:description,commercial_offer_website:commercial_offer_website,website_standardized_contract_form:website_standardized_contract_form,website_contract_conditions:website_contract_conditions,contacts:contacts,email_contact:email_contact,website_contact:website_contact};};var processComercial=function processComercial(_ref3,_ref4){var additional_services=_ref3.additional_services;var contract_duration=_ref4.contract_duration,offer_start_date=_ref4.offer_start_date,offer_validity=_ref4.offer_validity,email_contract_contact=_ref4.email_contract_contact,location_contract_contact=_ref4.location_contract_contact,phone_contract_contact=_ref4.phone_contract_contact,electronic_billing=_ref4.electronic_billing,green_energy=_ref4.green_energy,paper_billing=_ref4.paper_billing,direct_debit=_ref4.direct_debit,atm_ctt=_ref4.atm_ctt,shop_payment=_ref4.shop_payment,support_options=_ref4.support_options,payment_periodicity=_ref4.payment_periodicity,loyalty_clauses_description=_ref4.loyalty_clauses_description,has_additional_restrictions=_ref4.has_additional_restrictions,additional_restrictions=_ref4.additional_restrictions,offer_restrictions=_ref4.offer_restrictions,price_function_of_access=_ref4.price_function_of_access,price_revision_conditions=_ref4.price_revision_conditions,indexed_prices=_ref4.indexed_prices,website_contract_contact=_ref4.website_contract_contact;var newObj={contract_duration:contract_duration,offer_start_date:offer_start_date?__WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(offer_start_date)).format('DD/MM/YYYY'):'',offer_validity:offer_validity?__WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(offer_validity)).format('DD/MM/YYYY'):'',contract_type:[email_contract_contact||website_contract_contact?email_contract_contact?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Link,{href:'mailto:'+email_contract_contact,target:'_blank'},__WEBPACK_IMPORTED_MODULE_5__information_entries__["f" /* CONTRACT_TYPE */].email_contract_contact):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Link,{href:website_contract_contact,target:'_blank'},__WEBPACK_IMPORTED_MODULE_5__information_entries__["f" /* CONTRACT_TYPE */].email_contract_contact):'',location_contract_contact?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Link,{href:''+location_contract_contact,target:'_blank'},__WEBPACK_IMPORTED_MODULE_5__information_entries__["f" /* CONTRACT_TYPE */].location_contract_contact):'',phone_contract_contact?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Link,{href:'tel:'+phone_contract_contact,target:'_blank'},__WEBPACK_IMPORTED_MODULE_5__information_entries__["f" /* CONTRACT_TYPE */].phone_contract_contact,' (',phone_contract_contact,')'):''].filter(function(d){return d;}),billing_type:[electronic_billing?__WEBPACK_IMPORTED_MODULE_5__information_entries__["g" /* BILLING_TYPE */].electronic_billing:'',paper_billing?__WEBPACK_IMPORTED_MODULE_5__information_entries__["g" /* BILLING_TYPE */].paper_billing:''].filter(function(d){return d;}).join(', '),payment_type:[direct_debit?__WEBPACK_IMPORTED_MODULE_5__information_entries__["h" /* PAYMENT_TYPE */].direct_debit:'',atm_ctt?__WEBPACK_IMPORTED_MODULE_5__information_entries__["h" /* PAYMENT_TYPE */].atm_ctt:'',shop_payment?__WEBPACK_IMPORTED_MODULE_5__information_entries__["h" /* PAYMENT_TYPE */].shop_payment:''].filter(function(d){return d;}).join(', '),support_options:support_options&&support_options.map(function(so){return __WEBPACK_IMPORTED_MODULE_5__information_entries__["i" /* SUPPORT_OPTIONS */].find(function(sup){return sup.slug===so;}).text;}).join(', '),payment_periodicity:payment_periodicity,has_loyalty:!!additional_services.find(function(d){return d.id===3;}),loyalty_clauses_description:loyalty_clauses_description,green_energy:green_energy,has_additional_restrictions:has_additional_restrictions,additional_restrictions:additional_restrictions&&additional_restrictions.map(function(d){return __WEBPACK_IMPORTED_MODULE_5__information_entries__["j" /* ADDITIONAL_RESTRICTIONS */][d];}),offer_restrictions:offer_restrictions,price_function_of_access:price_function_of_access,price_revision_conditions:price_revision_conditions,indexed_prices:indexed_prices};if(!newObj.has_loyalty){delete newObj.loyalty_clauses_description;}if(!has_additional_restrictions){delete newObj.additional_restrictions;}else{delete newObj.has_additional_restrictions;}if(!indexed_prices){delete newObj.indexed_prices_description;}return newObj;};var processAdditionalServices=function processAdditionalServices(_ref5,_ref6){var additional_services=_ref5.additional_services;var additional_services_cost=_ref6.additional_services_cost,optional_services_description=_ref6.optional_services_description;var newObj={required_subscription_additional_services:!!additional_services.find(function(d){return d.id===5;}),additional_services_cost:additional_services_cost?''+__WEBPACK_IMPORTED_MODULE_4_portuguese_utils_formaters_formatToCurrency___default()(additional_services_cost,2):'',optional_services_description:optional_services_description};return newObj;};var processRefunds=function processRefunds(_ref7){var has_refunds=_ref7.has_refunds,annual_refunds=_ref7.annual_refunds,refunds_description=_ref7.refunds_description;if(!has_refunds){return{has_refunds:has_refunds};}var newObj={has_refunds:has_refunds,annual_refunds:annual_refunds?''+__WEBPACK_IMPORTED_MODULE_4_portuguese_utils_formaters_formatToCurrency___default()(annual_refunds,2):'',refunds_description:refunds_description};Object.keys(newObj).forEach(function(key){if(newObj[key]===''||newObj[key]===null){delete newObj[key];}});return newObj;};var Link=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].a(_templateObject);

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_kea__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_kea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_kea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_containers_AppV2_logic__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_containers_FiltersSectionV2_logic__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_containers_ResultsV2_logic__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_pick__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_mapKeys__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_mapKeys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_mapKeys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_omit__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_cloneDeep__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_cloneDeep__);
var PATCH_ENDPOINT=__WEBPACK_IMPORTED_MODULE_3_config__["i" /* API_SIMULATION_URL_V2 */]+'/public/simulation/:code/';var GET_FULL_TARIFF_ENDPOINT=__WEBPACK_IMPORTED_MODULE_3_config__["b" /* API_BASE_URL */]+'/public/price-list/:id/';var INVOICING_ENDPOINT=__WEBPACK_IMPORTED_MODULE_3_config__["j" /* API_SIMULATION_URL */]+'/public/simulator/invoicing/';var DEFAULT_VALUES={consumerProfile:'standard'};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_kea__["kea"])({connect:{props:[__WEBPACK_IMPORTED_MODULE_8_containers_AppV2_logic__["a" /* default */],['translations']],actions:[__WEBPACK_IMPORTED_MODULE_10_containers_ResultsV2_logic__["a" /* default */],['setSimulationResults'],__WEBPACK_IMPORTED_MODULE_9_containers_FiltersSectionV2_logic__["a" /* default */],['setFilter']]},actions:function actions(){return{editSimulation:function editSimulation(code){return{code:code};},resetForm:function resetForm(){return{};},setFormValues:function setFormValues(selected){return selected;},deleteFormValue:function deleteFormValue(key){return{key:key};},setEditError:function setEditError(message){return{message:message};},fetchOptions:function fetchOptions(){return{};},fetchOptionsError:function fetchOptionsError(error){return{error:error};},setOptions:function setOptions(options){return{options:options};},setPowerChoices:function setPowerChoices(options){return{options:options};},setTimeCycleChoices:function setTimeCycleChoices(options){return{options:options};},setGasStagesChoices:function setGasStagesChoices(options){return{options:options};},fetchFullEleTariff:function fetchFullEleTariff(id){return{id:id};},fetchFullEleTariffError:function fetchFullEleTariffError(error){return{error:error};},setFullEleTariff:function setFullEleTariff(tariff){return{tariff:tariff};},fetchFullGasTariff:function fetchFullGasTariff(id){return{id:id};},fetchFullGasTariffError:function fetchFullGasTariffError(error){return{error:error};},setFullGasTariff:function setFullGasTariff(tariff){return{tariff:tariff};}};},reducers:function reducers(_ref){var _ref2,_ref7,_ref8;var actions=_ref.actions;return{formValues:[DEFAULT_VALUES,__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,(_ref2={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref2,actions.setFormValues,function(state,payload){return Object.assign({},state,payload);}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref2,actions.resetForm,function(){return Object.assign({},DEFAULT_VALUES);}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref2,actions.deleteFormValue,function(state,payload){return __WEBPACK_IMPORTED_MODULE_14_lodash_omit___default()(state,payload.key);}),_ref2)],options:[{},__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.setOptions,function(_,payload){return Object.assign({},_,payload.options);})],powerChoices:[[],__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.setPowerChoices,function(_,payload){return[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(payload.options));})],timeCycleChoices:[[],__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.setTimeCycleChoices,function(_,payload){return[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(payload.options));})],gasStagesChoices:[[],__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.setGasStagesChoices,function(_,payload){return[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(payload.options));})],loading:[true,__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,(_ref7={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.editSimulation,function(){return true;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.setFormValues,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.resetForm,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.deleteFormValue,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.setEditError,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.fetchFullEleTariff,function(){return true;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.setFullEleTariff,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.fetchFullEleTariffError,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.fetchFullGasTariff,function(){return true;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.setFullGasTariff,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.fetchFullGasTariffError,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.fetchOptions,function(){return true;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.fetchFullTariff,function(){return true;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.setFullTariff,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.fetchFullTariffError,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.setOptions,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.setTimeCycleChoices,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.setPowerChoices,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.fetchOptionsError,function(){return false;}),_ref7)],error:[false,__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array,(_ref8={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref8,actions.fetchOptions,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref8,actions.setOptions,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref8,actions.setTimeCycleChoices,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref8,actions.setGasStagesChoices,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref8,actions.setPowerChoices,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref8,actions.fetchOptionsError,function(_,payload){return payload.error;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref8,actions.fetchFullEleTariffError,function(_,payload){return payload.error;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref8,actions.fetchFullGasTariffError,function(_,payload){return payload.error;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref8,actions.setEditError,function(_,payload){return payload.message;}),_ref8)],fullEleTariff:[{},__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.setFullEleTariff,function(_,payload){return Object.assign({},payload.tariff);})],fullGasTariff:[{},__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.setFullGasTariff,function(_,payload){return Object.assign({},payload.tariff);})]};},takeLatest:function takeLatest(_ref11){var _ref12;var actions=_ref11.actions,workers=_ref11.workers;return _ref12={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref12,actions.editSimulation,workers.editSimulation),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref12,actions.fetchOptions,workers.fetchSelectOptions),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref12,actions.fetchFullEleTariff,workers.fetchFullEleTariff),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref12,actions.fetchFullGasTariff,workers.fetchFullGasTariff),_ref12;},start:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function start(){var _actions,fetchOptions,fetchFullEleTariff,fetchFullGasTariff,_props,electricityPriceList,options,gasPriceList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function start$(_context){while(1){switch(_context.prev=_context.next){case 0:_actions=this.actions,fetchOptions=_actions.fetchOptions,fetchFullEleTariff=_actions.fetchFullEleTariff,fetchFullGasTariff=_actions.fetchFullGasTariff;_props=this.props,electricityPriceList=_props.electricityPriceList,options=_props.options,gasPriceList=_props.gasPriceList;if(!(Object.keys(options).length===0)){_context.next=5;break;}_context.next=5;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(fetchOptions());case 5:if(!(electricityPriceList&&electricityPriceList.id)){_context.next=8;break;}_context.next=8;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(fetchFullEleTariff(electricityPriceList.id));case 8:if(!(gasPriceList&&gasPriceList.id)){_context.next=11;break;}_context.next=11;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(fetchFullGasTariff(gasPriceList.id));case 11:case'end':return _context.stop();}}},start,this);}),workers:{editSimulation:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function editSimulation(action){var code,_actions2,setEditError,setSimulationResults,setFilter,_props2,onClose,formValues,electricityPriceList,gasPriceList,prices,form,url,queryParameters,urlCode,params,patch,data,urlParams,newUrl;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function editSimulation$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:code=action.payload.code;_actions2=this.actions,setEditError=_actions2.setEditError,setSimulationResults=_actions2.setSimulationResults,setFilter=_actions2.setFilter;_props2=this.props,onClose=_props2.onClose,formValues=_props2.formValues,electricityPriceList=_props2.electricityPriceList,gasPriceList=_props2.gasPriceList,prices=_props2.prices;form=__WEBPACK_IMPORTED_MODULE_15_lodash_cloneDeep___default()(formValues);delete form.electricityMonthlyBilling;delete form.gasMonthlyBilling;if(electricityPriceList){form.electricityPrices={cheia:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["j" /* validNumber */])(form.electricityCheia)||0,ponta:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["j" /* validNumber */])(form.electricityPonta)||0,super_vazio:prices.electricity.super_vazio,vazio:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["j" /* validNumber */])(form.electricityVazio)||0,termo_fixo:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["j" /* validNumber */])(form.electricityTermoFixo)||0};delete form.electricityCheia;delete form.electricityTermoFixo;delete form.electricityPonta;delete form.electricityVazio;}if(gasPriceList){form.gasPrices={termo_energia:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["j" /* validNumber */])(form.gasTermoEnergia),termo_fixo:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["j" /* validNumber */])(form.gasTermoFixo),stage:form.stage};form.gas_stage=form.stage;delete form.gasTermoEnergia;delete form.gasTermoFixo;delete form.stage;}if(form.consumerProfile==='custom'){delete form.consumerProfile;delete form.electricityAnnualBilling;delete form.gasAnnualBilling;if(electricityPriceList){form.electricityMonthlyConsumption={cheia:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["j" /* validNumber */])(form.electricityConsumeCheia)||0,ponta:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["j" /* validNumber */])(form.electricityConsumePonta)||0,vazio:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["j" /* validNumber */])(form.electricityConsumeVazio)||0,super_vazio:0};}}else{delete form.gasMonthlyConsumption;delete form.potenciaContratada;delete form.cicloHorario;}delete form.electricityConsumeCheia;delete form.electricityConsumePonta;delete form.electricityConsumeVazio;url=void 0;if(code){url=PATCH_ENDPOINT.replace(':code',code);}else{queryParameters=new URLSearchParams(window.location.search);urlCode=queryParameters.get('code');url=PATCH_ENDPOINT.replace(':code',urlCode);}_context2.prev=14;// Omit invalid
delete form.invalid;params=Object.assign({},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["a" /* csObjectToUnderscore */])(form));_context2.next=19;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_4_axios___default.a.patch,url,params);case 19:patch=_context2.sent;data=patch.data;_context2.next=23;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setFilter({code:data.code}));case 23:_context2.next=25;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setSimulationResults(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["c" /* csObjectFromUnderscore */])(data)));case 25:onClose&&onClose();urlParams=new URLSearchParams(window.location.search);urlParams.set('code',data.code);newUrl=urlParams.toString();window.history.pushState('','','?'+newUrl+window.location.hash);_context2.next=37;break;case 32:_context2.prev=32;_context2.t0=_context2['catch'](14);if(!(_context2.t0.response.data&&_context2.t0.response.status===400)){_context2.next=37;break;}_context2.next=37;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setEditError(_context2.t0.response.data));case 37:case'end':return _context2.stop();}}},editSimulation,this,[[14,32]]);}),fetchFullEleTariff:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchFullEleTariff(action){var id,_actions3,fetchFullEleTariffError,setFullEleTariff,url,tariff;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchFullEleTariff$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:id=action.payload.id;_actions3=this.actions,fetchFullEleTariffError=_actions3.fetchFullEleTariffError,setFullEleTariff=_actions3.setFullEleTariff;url=GET_FULL_TARIFF_ENDPOINT.replace(':id',id);_context3.prev=3;_context3.next=6;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get,url);case 6:tariff=_context3.sent;_context3.next=9;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setFullEleTariff(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["c" /* csObjectFromUnderscore */])(tariff.data)));case 9:_context3.next=15;break;case 11:_context3.prev=11;_context3.t0=_context3['catch'](3);_context3.next=15;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(fetchFullEleTariffError(_context3.t0));case 15:case'end':return _context3.stop();}}},fetchFullEleTariff,this,[[3,11]]);}),fetchFullGasTariff:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchFullGasTariff(action){var id,_actions4,fetchFullGasTariffError,setFullGasTariff,url,tariff;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchFullGasTariff$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:id=action.payload.id;_actions4=this.actions,fetchFullGasTariffError=_actions4.fetchFullGasTariffError,setFullGasTariff=_actions4.setFullGasTariff;url=GET_FULL_TARIFF_ENDPOINT.replace(':id',id);_context4.prev=3;_context4.next=6;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get,url);case 6:tariff=_context4.sent;_context4.next=9;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setFullGasTariff(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["c" /* csObjectFromUnderscore */])(tariff.data)));case 9:_context4.next=15;break;case 11:_context4.prev=11;_context4.t0=_context4['catch'](3);_context4.next=15;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(fetchFullGasTariffError(_context4.t0));case 15:case'end':return _context4.stop();}}},fetchFullGasTariff,this,[[3,11]]);}),fetchFullTariff:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchFullTariff(action){var id,_actions5,fetchFullTariffError,setFullTariff,url,tariff;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchFullTariff$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:id=action.payload.id;_actions5=this.actions,fetchFullTariffError=_actions5.fetchFullTariffError,setFullTariff=_actions5.setFullTariff;url=GET_FULL_TARIFF_ENDPOINT.replace(':id',id);_context5.prev=3;_context5.next=6;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get,url);case 6:tariff=_context5.sent;_context5.next=9;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setFullTariff(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["c" /* csObjectFromUnderscore */])(tariff.data)));case 9:_context5.next=15;break;case 11:_context5.prev=11;_context5.t0=_context5['catch'](3);_context5.next=15;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(fetchFullTariffError(_context5.t0));case 15:case'end':return _context5.stop();}}},fetchFullTariff,this,[[3,11]]);}),/**
     * Fetches the data needed to populate the selects in the form
     */fetchSelectOptions:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchSelectOptions(){var _actions6,setOptions,setTimeCycleChoices,setPowerChoices,fetchOptionsError,setGasStagesChoices,values,params,cleanData,response,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchSelectOptions$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_actions6=this.actions,setOptions=_actions6.setOptions,setTimeCycleChoices=_actions6.setTimeCycleChoices,setPowerChoices=_actions6.setPowerChoices,fetchOptionsError=_actions6.fetchOptionsError,setGasStagesChoices=_actions6.setGasStagesChoices;_context6.next=3;return __WEBPACK_IMPORTED_MODULE_8_containers_AppV2_logic__["a" /* default */].get('values');case 3:values=_context6.sent;// Needed params for the Invoicing endpoint
params=__WEBPACK_IMPORTED_MODULE_12_lodash_pick___default()(values,['offer_type','municipality']);// Clean response data for frontend use
cleanData=function cleanData(data){return{powerChoices:data.power_choices,timeCycleChoices:data.time_cycle_choices,gasStages:data.gas_stages};};_context6.prev=6;_context6.next=9;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get,INVOICING_ENDPOINT,{params:params});case 9:response=_context6.sent;data=cleanData(response.data);data.timeCycleChoices&&delete data.timeCycleChoices['tetra-horário'];// Replace . with , in powerchoices 😑
data.powerChoices=__WEBPACK_IMPORTED_MODULE_13_lodash_mapKeys___default()(data.powerChoices,function(value,key){return key.replace('.',',');});data.powerChoices=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["k" /* mapObjectToarray */])(data.powerChoices);data.timeCycleChoices=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["k" /* mapObjectToarray */])(data.timeCycleChoices);data.gasStages=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["k" /* mapObjectToarray */])(data.gasStages);_context6.next=18;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setOptions(data));case 18:_context6.next=20;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setTimeCycleChoices(data.timeCycleChoices));case 20:_context6.next=22;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setPowerChoices(data.powerChoices));case 22:_context6.next=24;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(setGasStagesChoices(data.gasStages));case 24:_context6.next=30;break;case 26:_context6.prev=26;_context6.t0=_context6['catch'](6);_context6.next=30;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["put"])(fetchOptionsError(_context6.t0));case 30:case'end':return _context6.stop();}}},fetchSelectOptions,this,[[6,26]]);})}}));

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_ic_eletricity_component_svg__ = __webpack_require__(1622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_ic_eletricity_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_ic_eletricity_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_ic_gas_component_svg__ = __webpack_require__(1623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_ic_gas_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_ic_gas_component_svg__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n  flex-grow: 1;\n  width: 100%;\n\n  @media screen and (min-width: 1000px) {\n    width: unset;\n    justify-content: flex-start;\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n  flex-grow: 1;\n  width: 100%;\n\n  @media screen and (min-width: 1000px) {\n    width: unset;\n    justify-content: flex-start;\n  }\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  height: 20px;\n  padding: 10px 0px;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n  align-self: stretch;\n\n  > h1 {\n    margin: 0;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 20px; /* 142.857% */\n    color: ',';\n    text-shadow: unset !important;\n  }\n'],['\n  display: flex;\n  height: 20px;\n  padding: 10px 0px;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n  align-self: stretch;\n\n  > h1 {\n    margin: 0;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 20px; /* 142.857% */\n    color: ',';\n    text-shadow: unset !important;\n  }\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-end;\n  gap: 2px;\n  align-self: stretch;\n  flex-grow: 1;\n  width: 100%;\n\n  ','\n\n  @media screen and (min-width: 1000px) {\n    flex-grow: unset;\n    align-items: flex-start;\n    width: unset;\n    border-bottom: unset;\n    padding-bottom: unset;\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-end;\n  gap: 2px;\n  align-self: stretch;\n  flex-grow: 1;\n  width: 100%;\n\n  ','\n\n  @media screen and (min-width: 1000px) {\n    flex-grow: unset;\n    align-items: flex-start;\n    width: unset;\n    border-bottom: unset;\n    padding-bottom: unset;\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n\n  p,\n  h3 {\n    margin: 0;\n    font-size: 14px;\n    font-style: normal;\n    line-height: 20px; /* 142.857% */\n    font-weight: 400;\n    text-transform: none;\n  }\n\n  p {\n    color: #676767;\n  }\n\n  h3 {\n    color: #1d1e22;\n    font-weight: 700;\n  }\n\n  span {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 4px;\n    min-width: 100px;\n  }\n\n  @media screen and (min-width: 1000px) {\n    align-self: stretch;\n    width: unset;\n\n    span {\n      justify-content: flex-start;\n    }\n  }\n'],['\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n\n  p,\n  h3 {\n    margin: 0;\n    font-size: 14px;\n    font-style: normal;\n    line-height: 20px; /* 142.857% */\n    font-weight: 400;\n    text-transform: none;\n  }\n\n  p {\n    color: #676767;\n  }\n\n  h3 {\n    color: #1d1e22;\n    font-weight: 700;\n  }\n\n  span {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 4px;\n    min-width: 100px;\n  }\n\n  @media screen and (min-width: 1000px) {\n    align-self: stretch;\n    width: unset;\n\n    span {\n      justify-content: flex-start;\n    }\n  }\n']);var EnergyDetailsV2=function EnergyDetailsV2(props){var electricityConsumption=props.electricityConsumption,gasConsumption=props.gasConsumption,prices=props.prices,energyType=props.energyType,priceListTimeCycle=props.priceListTimeCycle,calculatedHiredPowerFactor=props.calculatedHiredPowerFactor,gasStage=props.gasStage,_props$border=props.border,border=_props$border===undefined?true:_props$border,className=props.className,restProps=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(props,['electricityConsumption','gasConsumption','prices','energyType','priceListTimeCycle','calculatedHiredPowerFactor','gasStage','border','className']);var yearConsumption=Number(energyType==='electricity'?electricityConsumption:gasConsumption).toFixed(0);var energy=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils__["g" /* pricesCurrency */])(energyType==='electricity'?prices.electricity.cheia:prices.gas.termo_energia);var cheia=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils__["g" /* pricesCurrency */])(energyType==='electricity'?prices.electricity.cheia:0);var ponta=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils__["g" /* pricesCurrency */])(energyType==='electricity'?prices.electricity.ponta:0);var vazio=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils__["g" /* pricesCurrency */])(energyType==='electricity'?prices.electricity.vazio:0);var fixedTerm=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils__["g" /* pricesCurrency */])(energyType==='electricity'?prices.electricity.termo_fixo:prices.gas.termo_fixo);var _renderPotency=function _renderPotency(){return energyType==='electricity'&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Detail,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,'Pot\xEAncia'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h3',null,Math.round(calculatedHiredPowerFactor*1e2)/1e2),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,'kVA')));};var _renderTariff=function _renderTariff(){var timeCycleDeff=priceListTimeCycle==='s'?'Simples':priceListTimeCycle==='b'?'Bi-Horário':'Tri-Horário';return energyType==='electricity'&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Detail,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,'Tarif\xE1rio'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h3',null,timeCycleDeff)));};var _renderStage=function _renderStage(){return energyType!=='electricity'&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Detail,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,'Escal\xE3o'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h3',null,gasStage)));};return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Wrapper,Object.assign({className:className},restProps),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(TitleRow,{electricity:energyType==='electricity'},energyType==='electricity'?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__images_ic_eletricity_component_svg___default.a,null):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__images_ic_gas_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h1',null,' ',energyType==='electricity'?'Eletricidade':'Gás Natural',' ')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Details,{border:border},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Detail,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,'Consumo'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h3',null,yearConsumption?''+yearConsumption:'---'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,'kWh/ano'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Detail,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,energyType==='electricity'?'Termo Potência':'Termo Fixo'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h3',null,fixedTerm?''+fixedTerm:'---'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,'\u20AC/dia'))),energyType!=='electricity'?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Detail,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,'Energia'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h3',null,energy?''+energy:'---'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,'\u20AC/kWh'))):null,energyType==='electricity'&&priceListTimeCycle==='s'?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Detail,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,'Energia'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h3',null,cheia?''+cheia:'---'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,'\u20AC/kWh'))):null,energyType==='electricity'&&priceListTimeCycle!=='s'?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Detail,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,'Vazio'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h3',null,vazio?''+vazio:'---'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,'\u20AC/kWh'))):null,energyType==='electricity'&&priceListTimeCycle==='b'?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Detail,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,'Fora do Vazio'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h3',null,cheia?''+cheia:'---'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,'\u20AC/kWh'))):null,energyType==='electricity'&&priceListTimeCycle!=='b'&&priceListTimeCycle!=='s'?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Detail,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,'Ponta'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h3',null,ponta?''+ponta:'---'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,'\u20AC/kWh'))):null,energyType==='electricity'&&priceListTimeCycle!=='b'&&priceListTimeCycle!=='s'?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Detail,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,'Cheias'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h3',null,cheia?''+cheia:'---'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,'\u20AC/kWh'))):null,_renderPotency(),_renderTariff(),_renderStage()));};/* harmony default export */ __webpack_exports__["a"] = (EnergyDetailsV2);var Wrapper=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject);var TitleRow=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject2,function(_ref){var electricity=_ref.electricity;return electricity?'#FF8E2A':'#10C1EE';});var Details=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject3,function(_ref2){var border=_ref2.border;return border&&' \n    border-bottom: 1px solid #ECECEC;\n    padding-bottom: 8px;\n  ';});var Detail=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject4);

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_kea__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_kea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_kea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_containers_AppV2_logic__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_omit__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils__ = __webpack_require__(11);
var FEEDBACK_ENDPOINT=__WEBPACK_IMPORTED_MODULE_8_config__["d" /* API_BASE_URL_V2 */]+'/public/simulator/feedback/';var DEFAULT_VALUES={};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_kea__["kea"])({connect:{props:[__WEBPACK_IMPORTED_MODULE_6_containers_AppV2_logic__["a" /* default */],['translations']]},actions:function actions(){return{sendFeedback:function sendFeedback(code){return{code:code};},resetForm:function resetForm(){return{};},setFormValues:function setFormValues(selected){return selected;},deleteFormValue:function deleteFormValue(key){return{key:key};},setFeedbackError:function setFeedbackError(message){return{message:message};}};},reducers:function reducers(_ref){var _ref2,_ref3;var actions=_ref.actions;return{formValues:[DEFAULT_VALUES,__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,(_ref2={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref2,actions.setFormValues,function(state,payload){return Object.assign({},state,payload);}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref2,actions.resetForm,function(){return Object.assign({},DEFAULT_VALUES);}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref2,actions.deleteFormValue,function(state,payload){return __WEBPACK_IMPORTED_MODULE_7_lodash_omit___default()(state,payload.key);}),_ref2)],loading:[false,__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,(_ref3={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3,actions.sendFeedback,function(){return true;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3,actions.setFormValues,function(){return false;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3,actions.resetForm,function(){return false;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3,actions.deleteFormValue,function(){return false;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3,actions.setFeedbackError,function(){return false;}),_ref3)]};},takeLatest:function takeLatest(_ref4){var actions=_ref4.actions,workers=_ref4.workers;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.sendFeedback,workers.sendFeedback);},workers:{sendFeedback:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function sendFeedback(){var _actions,setFeedbackError,resetForm,_props,onClose,formValues,form;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function sendFeedback$(_context){while(1){switch(_context.prev=_context.next){case 0:_actions=this.actions,setFeedbackError=_actions.setFeedbackError,resetForm=_actions.resetForm;_props=this.props,onClose=_props.onClose,formValues=_props.formValues;form=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_utils__["a" /* csObjectToUnderscore */])(formValues);if(form.key){delete form.key;}_context.prev=4;_context.next=7;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post,FEEDBACK_ENDPOINT,Object.assign({},form));case 7:_context.next=9;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["put"])(resetForm());case 9:document.cookie='feedbackSubmitted=true; path=/; max-age='+365*24*60*60;onClose&&onClose();_context.next=17;break;case 13:_context.prev=13;_context.t0=_context['catch'](4);_context.next=17;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["put"])(setFeedbackError(_context.t0));case 17:case'end':return _context.stop();}}},sendFeedback,this,[[4,13]]);})}}));

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_kea__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_kea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_kea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_containers_AppV2_logic__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_containers_ResultsV2_logic__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_omit__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_mapValues__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_mapValues__);
var PATCH_ENDPOINT=__WEBPACK_IMPORTED_MODULE_2_config__["d" /* API_BASE_URL_V2 */]+'/public/simulation/:code/';var DISTRICTS_ENDPOINT=__WEBPACK_IMPORTED_MODULE_2_config__["b" /* API_BASE_URL */]+'/public/district/';var MUNICIPALITIES_ENDPOINT=__WEBPACK_IMPORTED_MODULE_2_config__["b" /* API_BASE_URL */]+'/public/municipality/';var SUBSCRIBE_PRICE_LIST_ENDPOINT=__WEBPACK_IMPORTED_MODULE_2_config__["h" /* ADESION_URL */]+'/public/subscribe-price-list/';var PERSONAL_VALUES={name:{value:'',valid:false},surName:{value:'',valid:false},nif:{value:'',valid:false},email:{value:'',valid:false},phone:{value:'',valid:false},contact:{value:'e',valid:true},contactTime:{value:'',valid:false}};var ADDRESS_VALUES={street:{value:'',valid:false},door:{value:'',valid:false},floor:{value:'',valid:false},district:{value:'',valid:false},municipality:{value:'',valid:false},billingAddress:{value:'e',valid:false},directDebit:{value:'d',valid:false},billingStreet:{value:'',valid:false},billingDoor:{value:'',valid:false},billingFloor:{value:'',valid:false},billingDistrict:{value:'',valid:false},billingMunicipality:{value:'',valid:false},electronicBilling:{value:'e',valid:false}};var DEFAULT_PROPS={personal:PERSONAL_VALUES,billing:ADDRESS_VALUES,electric:{currentEntityElectric:{value:'',valid:false,designation:'ee'},cpe:{value:'',valid:false},potency:{value:'',valid:false},tariff:{value:'',valid:false},cycle:{value:'',valid:false}},gas:{currentEntityGas:{value:'',valid:false,designation:'eg'},cui:{value:'',valid:false},tier:{value:'',valid:false}},confirm:{allowDataSharing:{value:false,valid:false}}};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_kea__["kea"])({connect:{props:[__WEBPACK_IMPORTED_MODULE_7_containers_AppV2_logic__["a" /* default */],['translations','values','userLoggedIn']],actions:[__WEBPACK_IMPORTED_MODULE_8_containers_ResultsV2_logic__["a" /* default */],['setSimulationResults','userProfile']]},actions:function actions(){return{joinTariff:function joinTariff(code){return{code:code};},submitForm:function submitForm(form,omit,callback){return{form:form,omit:omit,callback:callback};},setSubmitting:function setSubmitting(submitting){return{submitting:submitting};},setAdhesionResponse:function setAdhesionResponse(data){return{data:data};},setAdhesionError:function setAdhesionError(error){return{error:error};},setConfirmationError:function setConfirmationError(error){return{error:error};},resetForm:function resetForm(){return{};},setFormValues:function setFormValues(selected){return selected;},deleteFormValue:function deleteFormValue(key){return{key:key};},setEditError:function setEditError(message){return{message:message};},setInvalid:function setInvalid(invalid){return{invalid:invalid};},recheckValids:function recheckValids(){return{};},setFirstSet:function setFirstSet(firstSet){return{firstSet:firstSet};},setDistricts:function setDistricts(districts){return{districts:districts};},setMunicipalities:function setMunicipalities(municipalities){return{municipalities:municipalities};},setBillingMunicipalities:function setBillingMunicipalities(municipalities){return{municipalities:municipalities};},setError:function setError(error){return{error:error};},fetchDistricts:function fetchDistricts(){return{};},fetchMunicipalities:function fetchMunicipalities(id,type){return{id:id,type:type};}};},reducers:function reducers(_ref){var _ref2,_ref3,_ref5,_ref9,_ref10,_ref11,_ref12;var actions=_ref.actions;return{formValues:[DEFAULT_PROPS,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,(_ref2={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref2,actions.setFormValues,function(state,payload){return Object.assign({},state,payload);}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref2,actions.resetForm,function(){return Object.assign({},DEFAULT_PROPS);}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref2,actions.deleteFormValue,function(state,payload){return __WEBPACK_IMPORTED_MODULE_10_lodash_omit___default()(state,payload.key);}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref2,actions.recheckValids,function(_,payload){var current=Object.assign({},_);current=__WEBPACK_IMPORTED_MODULE_11_lodash_mapValues___default()(current,function(list1,key1){return __WEBPACK_IMPORTED_MODULE_11_lodash_mapValues___default()(list1,function(item,key){return Object.assign({},item,{valid:false});});});return current;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref2,actions.setInvalid,function(_,payload){var current=Object.assign({},_);var key=Object.keys(payload.invalid)[0];var list=payload.invalid[key];current=__WEBPACK_IMPORTED_MODULE_11_lodash_mapValues___default()(current,function(list1,key1){return __WEBPACK_IMPORTED_MODULE_11_lodash_mapValues___default()(list1,function(item,key){return Object.assign({},item,{valid:false});});});__WEBPACK_IMPORTED_MODULE_11_lodash_mapValues___default()(list,function(valid,valueKey){current[key][valueKey].valid=valid;});return current;}),_ref2)],loading:[false,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,(_ref3={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3,actions.joinTariff,function(){return true;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3,actions.setFormValues,function(){return false;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3,actions.resetForm,function(){return false;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3,actions.deleteFormValue,function(){return false;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3,actions.setEditError,function(){return false;}),_ref3)],submitting:[false,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.setSubmitting,function(_,payload){return payload.submitting;})],error:[false,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,(_ref5={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref5,actions.setError,function(state,payload){return payload.error;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref5,actions.setDistricts,function(){return false;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref5,actions.setMunicipalities,function(){return false;}),_ref5)],districts:[[],__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.setDistricts,function(_,payload){return payload.districts;})],municipalities:[[],__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.setMunicipalities,function(_,payload){return payload.municipalities;})],billingMunicipalities:[[],__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.setBillingMunicipalities,function(_,payload){return payload.municipalities;})],adhesionError:[null,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,(_ref9={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref9,actions.setAdhesionError,function(_,payload){return payload.error;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref9,actions.resetForm,function(){return null;}),_ref9)],adhesionResponse:[null,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,(_ref10={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref10,actions.setAdhesionResponse,function(state,payload){return payload.data;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref10,actions.resetForm,function(){return null;}),_ref10)],confirmationError:[false,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,(_ref11={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref11,actions.setConfirmationError,function(state,payload){return payload.error;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref11,actions.resetForm,function(){return false;}),_ref11)],firstSet:[true,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,(_ref12={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref12,actions.setFirstSet,function(_,payload){return payload.firstSet;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref12,actions.resetForm,function(){return true;}),_ref12)]};},takeLatest:function takeLatest(_ref13){var _ref14;var actions=_ref13.actions,workers=_ref13.workers;return _ref14={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref14,actions.joinTariff,workers.joinTariff),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref14,actions.submitForm,workers.submitForm),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref14,actions.fetchDistricts,workers.fetchDistricts),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref14,actions.fetchMunicipalities,workers.fetchMunicipalities),_ref14;},start:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function start(){var _actions,fetchDistricts,setFormValues,fetchMunicipalities,user,formData,name,hasSurName,surname,phone,fillForm;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function start$(_context){while(1){switch(_context.prev=_context.next){case 0:_actions=this.actions,fetchDistricts=_actions.fetchDistricts,setFormValues=_actions.setFormValues,fetchMunicipalities=_actions.fetchMunicipalities;_context.next=3;return __WEBPACK_IMPORTED_MODULE_7_containers_AppV2_logic__["a" /* default */].get('userLoggedIn');case 3:user=_context.sent;_context.next=6;return this.get('formValues');case 6:formData=_context.sent;if(!user){_context.next=19;break;}name=user.user.name.split(' ');hasSurName=name.length>=2;surname=hasSurName&&name[name.length-1]||'';phone=user.phone_number&&user.phone_number.replace('+351','')||'';fillForm={personal:Object.assign({},formData.personal,{name:{value:name[0],valid:false},surName:{value:surname,valid:false},nif:{value:user.tax_id,valid:false},email:{value:user.user.email||'',valid:false},phone:{value:phone,valid:false},contact:{value:'e',valid:false},contact_time:{value:'',valid:false}}),billing:Object.assign({},formData.billing,{street:{value:user.address,valid:false},municipality:{value:user.municipality,valid:false},district:{value:user.district,valid:false},billingStreet:{value:user.address,valid:false},billingMunicipality:{value:user.municipality,valid:false},billingDistrict:{value:user.district,valid:false}})};_context.next=15;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(fetchMunicipalities(user.district,'district'));case 15:_context.next=17;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(fetchMunicipalities(user.district,'billingDistrict'));case 17:_context.next=19;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setFormValues(fillForm));case 19:_context.next=21;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(fetchDistricts());case 21:case'end':return _context.stop();}}},start,this);}),workers:{joinTariff:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function joinTariff(action){var code,_actions2,setEditError,setSimulationResults,_props,onClose,formValues,form,url,params,patch;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function joinTariff$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:code=action.payload.code;_actions2=this.actions,setEditError=_actions2.setEditError,setSimulationResults=_actions2.setSimulationResults;_props=this.props,onClose=_props.onClose,formValues=_props.formValues;form=formValues;url=PATCH_ENDPOINT.replace(':code',code);_context2.prev=5;// Omit invalid
delete form.invalid;params=Object.assign({},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_utils__["a" /* csObjectToUnderscore */])(form));_context2.next=10;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_3_axios___default.a.patch,url,params);case 10:patch=_context2.sent;_context2.next=13;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setSimulationResults(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_utils__["c" /* csObjectFromUnderscore */])(patch.data)));case 13:onClose&&onClose();_context2.next=21;break;case 16:_context2.prev=16;_context2.t0=_context2['catch'](5);_context2.next=20;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setEditError(_context2.t0));case 20:console.log(_context2.t0);case 21:case'end':return _context2.stop();}}},joinTariff,this,[[5,16]]);}),submitForm:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function submitForm(_ref15){var payload=_ref15.payload;var _actions3,setAdhesionResponse,setAdhesionError,setConfirmationError,setSubmitting,userCPEandCUI,form,arrayBillings,result,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function submitForm$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_actions3=this.actions,setAdhesionResponse=_actions3.setAdhesionResponse,setAdhesionError=_actions3.setAdhesionError,setConfirmationError=_actions3.setConfirmationError,setSubmitting=_actions3.setSubmitting;_context3.next=3;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setSubmitting(true));case 3:_context3.next=5;return __WEBPACK_IMPORTED_MODULE_8_containers_ResultsV2_logic__["a" /* default */].get('userProfile');case 5:userCPEandCUI=_context3.sent;form={};Object.keys(payload.form).forEach(function(key){form[key]=payload.form[key];});arrayBillings=['billing_district','billing_door','billing_floor','billing_municipality','billing_street'];/** If billing_address is "e", thats means equal, billing values needs to be empty */if(form.billing_address==='e'){Object.keys(form).forEach(function(key){if(arrayBillings.find(function(value){return value===key;})){form[key]='';}});}/** If NIF is empty, send nif of user */if(!form.tax_id){if(this.props.formValues.personal&&this.props.formValues.personal.nif){form.tax_id=this.props.formValues.personal.nif.value;}}/** If User has CPE added, send to API */if(!form.cpe){if(userCPEandCUI&&userCPEandCUI.cpe){form.cpe=userCPEandCUI.cpe;}}/** If User has CUI added, send to API */if(!form.cui){if(userCPEandCUI&&userCPEandCUI.cui){form.cui=userCPEandCUI.cui;}}if(form.phone_number){form.phone_number='+351'+form.phone_number;}else{delete form.phone_number;}// Set form type
form.type='p';_context3.prev=15;if(form.time_cycle==='s'){form=__WEBPACK_IMPORTED_MODULE_10_lodash_omit___default()(form,['price_list_cycle']);}form.requires_cui_cpe=false;if(!payload.omit){// Enviar esta flag se for uma primeira adesao
form.test_repeated=true;}if(payload.omit&&payload.omit.omitRepeated){form.test_repeated=false;}_context3.next=22;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_3_axios___default.a.post,SUBSCRIBE_PRICE_LIST_ENDPOINT,form);case 22:result=_context3.sent;data=result.data;__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_utils__["e" /* sendGevent */])(this.props.isHome?'home':'simulador','Aderiu','Completou o processo de adesão');_context3.next=27;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setAdhesionResponse(data));case 27:if(!(payload.omit&&payload.omit.omitRepeated)){_context3.next=30;break;}_context3.next=30;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setConfirmationError(false));case 30:payload.callback&&payload.callback({successModal:true});_context3.next=44;break;case 33:_context3.prev=33;_context3.t0=_context3['catch'](15);if(!(_context3.t0.response.data&&_context3.t0.response.status===400&&_context3.t0.response.data.test_repeated&&!!_context3.t0.response.data.test_repeated.length)){_context3.next=40;break;}_context3.next=38;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setConfirmationError(true));case 38:_context3.next=44;break;case 40:if(_context3.t0.response.data&&_context3.t0.response.status===400&&_context3.t0.response.data.cui&&_context3.t0.response.data.cpe){_context3.t0.response.data.cuicpe='';delete _context3.t0.response.data.cui;delete _context3.t0.response.data.cpe;}if(_context3.t0.response.status!==400){_context3.t0.response.data='error';}_context3.next=44;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setAdhesionError(_context3.t0));case 44:_context3.prev=44;_context3.next=47;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setSubmitting(false));case 47:return _context3.finish(44);case 48:case'end':return _context3.stop();}}},submitForm,this,[[15,33,44,48]]);}),fetchMunicipalities:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchMunicipalities(_ref16){var payload=_ref16.payload;var _actions4,setMunicipalities,setBillingMunicipalities,setError,id,type,res,action;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchMunicipalities$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_actions4=this.actions,setMunicipalities=_actions4.setMunicipalities,setBillingMunicipalities=_actions4.setBillingMunicipalities,setError=_actions4.setError;id=payload.id,type=payload.type;_context4.prev=2;_context4.next=5;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get,MUNICIPALITIES_ENDPOINT,{params:{limit:100,district:id}});case 5:res=_context4.sent;action=type==='district'?setMunicipalities:setBillingMunicipalities;_context4.next=9;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(action(res.data.results.map(function(mun){return{label:mun.name,value:mun.id};})));case 9:_context4.next=15;break;case 11:_context4.prev=11;_context4.t0=_context4['catch'](2);_context4.next=15;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setError(_context4.t0));case 15:case'end':return _context4.stop();}}},fetchMunicipalities,this,[[2,11]]);}),fetchDistricts:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchDistricts(){var _actions5,setDistricts,setError,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchDistricts$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_actions5=this.actions,setDistricts=_actions5.setDistricts,setError=_actions5.setError;_context5.prev=1;_context5.next=4;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get,DISTRICTS_ENDPOINT,{params:{limit:100}});case 4:res=_context5.sent;_context5.next=7;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setDistricts(res.data.results.map(function(dis){return{label:dis.name,value:dis.id};})));case 7:_context5.next=13;break;case 9:_context5.prev=9;_context5.t0=_context5['catch'](1);_context5.next=13;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setError(_context5.t0));case 13:case'end':return _context5.stop();}}},fetchDistricts,this,[[1,9]]);})}}));

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hasBillingAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return required; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isNIF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return notEmptyEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return notEmptyPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isContactPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isChecked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return hasPaidServices; });
var isEmail=function isEmail(value,props){var emailRegex=/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;var result=true;var contact=props.contact;if(contact.value==='e'){if(!!props.email&&(!props.email.value||!emailRegex.test(props.email.value))){result=false;}}var message=result?'':'Forneça um email válido';return{result:result,message:message};};var isPhone=function isPhone(value,props){var result=true;if(!!props.phone&&(!props.phone.value||props.phone.value.length<9)){result=false;}var message=result?'':'Forneça um número válido';return{result:result,message:message};};var hasBillingAddress=function hasBillingAddress(values,props){return!!props&&!!props.billingAddress&&!!props.billingAddress.value&&props.billingAddress.value==='d';};var required=function required(value){var message='Campo de preenchimento obrigat\xF3rio';if(!value||value===undefined){return{result:false,message:message};}return{result:true,message:''};};var isNIF=function isNIF(value){var message='NIF inválido';if(value.length<9)return{result:false,message:message};var split=value.split('');var ident=split[0];if(ident==='0'&&ident==='3'&&ident==='4'&&ident==='7')return{result:false,message:message};var total=split.slice(0,split.length-1).map(function(sp){return parseInt(sp,10);}).reduce(function(sum,value,index,array){return sum+value*(array.length+1-index);},0);var divided=11-total%11;var control=divided>=10?0:divided;var valid=control===parseInt(split[split.length-1],10);return{result:valid,message:valid?'':message};};var notEmptyEmail=function notEmptyEmail(value,refValue){var emailRegex=/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;var result=!value?!!refValue:emailRegex.test(value);var message=result?'':'Forneça um email válido';return{result:result,message:message};};var notEmptyPhone=function notEmptyPhone(value,refValue){var result=!value?!!refValue:value.length===9;var message=result?'':'Forneça um telefone válido';return{result:result,message:message};};var isContactPhone=function isContactPhone(values,props){return!!props&&!!props.contact&&!!props.contact.value&&props.contact.value==='p';};var isChecked=function isChecked(value){var message='Para aderir \xE9 necessario aceitar os termos.';if(value===false){return{result:false,message:message};}return{result:true,message:''};};var hasPaidServices=function hasPaidServices(services){return services.some(function(srv){return srv.is_paid;});};

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_config__ = __webpack_require__(10);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 105px;\n  width: 105px;\n  border: 1px solid #ececec;\n  flex-grow: 1;\n  cursor: pointer;\n\n  &:hover,\n  &.selected {\n    border: none;\n    background: ',';\n    padding: 1px;\n  }\n'],['\n  height: 105px;\n  width: 105px;\n  border: 1px solid #ececec;\n  flex-grow: 1;\n  cursor: pointer;\n\n  &:hover,\n  &.selected {\n    border: none;\n    background: ',';\n    padding: 1px;\n  }\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 12px;\n  width: 100%;\n  height: 100%;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex: 1 0 0;\n  align-self: stretch;\n  background: #fff;\n\n  &.selected {\n    background: linear-gradient(\n        0deg,\n        rgba(147, 193, 62, 0.1) 0%,\n        rgba(147, 193, 62, 0.1) 100%\n      ),\n      #fff;\n  }\n'],['\n  display: flex;\n  padding: 12px;\n  width: 100%;\n  height: 100%;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex: 1 0 0;\n  align-self: stretch;\n  background: #fff;\n\n  &.selected {\n    background: linear-gradient(\n        0deg,\n        rgba(147, 193, 62, 0.1) 0%,\n        rgba(147, 193, 62, 0.1) 100%\n      ),\n      #fff;\n  }\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  align-self: stretch;\n'],['\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  align-self: stretch;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #3e3e3e;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 18px; /* 128.571% */\n'],['\n  color: #3e3e3e;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 18px; /* 128.571% */\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  width: 20px !important;\n  height: 20px !important;\n  border: none !important;\n  position: relative;\n  z-index: 1;\n  cursor: pointer;\n\n  &::before {\n    content: \'\';\n    display: block;\n    position: absolute;\n    inset: 0;\n    border-radius: 999px;\n    border: 1px solid #ececec;\n    background: #f9f9f9;\n    z-index: 2;\n  }\n\n  &::after {\n    content: \'\';\n    display: block;\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    top: 5px;\n    left: 5px;\n    border-radius: 999px;\n    background: #fff;\n    z-index: 3;\n    display: none;\n  }\n\n  &:checked {\n    &::before {\n      background: ',';\n      border: none;\n    }\n    &::after {\n      display: block;\n    }\n  }\n'],['\n  display: block;\n  width: 20px !important;\n  height: 20px !important;\n  border: none !important;\n  position: relative;\n  z-index: 1;\n  cursor: pointer;\n\n  &::before {\n    content: \'\';\n    display: block;\n    position: absolute;\n    inset: 0;\n    border-radius: 999px;\n    border: 1px solid #ececec;\n    background: #f9f9f9;\n    z-index: 2;\n  }\n\n  &::after {\n    content: \'\';\n    display: block;\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    top: 5px;\n    left: 5px;\n    border-radius: 999px;\n    background: #fff;\n    z-index: 3;\n    display: none;\n  }\n\n  &:checked {\n    &::before {\n      background: ',';\n      border: none;\n    }\n    &::after {\n      display: block;\n    }\n  }\n']);var LeftAlignRadioV2=function LeftAlignRadioV2(_ref){var icon=_ref.icon,name=_ref.name,selected=_ref.selected,onClick=_ref.onClick,value=_ref.value,className=_ref.className,props=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref,['icon','name','selected','onClick','value','className']);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(WrapperBg,Object.assign({bgColor:__WEBPACK_IMPORTED_MODULE_4_config__["c" /* backgroundColors */].normalLeft,className:className+' '+(selected&&'selected')},props),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Wrapper,{onClick:onClick,className:selected&&'selected'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(TopBox,null,icon,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Input,{bgColor:__WEBPACK_IMPORTED_MODULE_4_config__["c" /* backgroundColors */].normalLeft,id:'opt-'+value+'-'+name,name:name,checked:selected,onChange:onClick})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Title,null,name)));};/* harmony default export */ __webpack_exports__["a"] = (LeftAlignRadioV2);var WrapperBg=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject,function(_ref2){var bgColor=_ref2.bgColor;return bgColor;});var Wrapper=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject2);var TopBox=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject3);var Title=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].span(_templateObject4);var Input=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].input.attrs({type:'radio'})(_templateObject5,function(_ref3){var bgColor=_ref3.bgColor;return bgColor;});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Button__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_PrimaryButton__ = __webpack_require__(185);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n  width: 100%;\n  height: 100%;\n'],['\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n  width: 100%;\n  height: 100%;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(1, 1, 1, 0.5);\n'],['\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(1, 1, 1, 0.5);\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ','\n  background-color: #FFFFFF;\n  box-shadow: -2px 0 20px 0 rgba(0, 0, 0, 0.2);\n  position: absolute;\n  // top: 100px;\n  top: 50%;\n  transform: translateY(-50%);\n  text-align: left;\n\n  @media (max-width: 860px) {\n    max-width: 100%;\n    width: 90%;\n    position: fixed;\n    min-width: initial;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n  }\n'],['\n  ','\n  background-color: #FFFFFF;\n  box-shadow: -2px 0 20px 0 rgba(0, 0, 0, 0.2);\n  position: absolute;\n  // top: 100px;\n  top: 50%;\n  transform: translateY(-50%);\n  text-align: left;\n\n  @media (max-width: 860px) {\n    max-width: 100%;\n    width: 90%;\n    position: fixed;\n    min-width: initial;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 32px;\n  padding-right: 55px;\n  justify-content: space-between;\n\n  @media (max-width: 860px) {\n    padding: 16px;\n  }\n'],['\n  display: flex;\n  padding: 32px;\n  padding-right: 55px;\n  justify-content: space-between;\n\n  @media (max-width: 860px) {\n    padding: 16px;\n  }\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #010101;\n  font-family: Nunito;\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 28px;\n  margin: 0;\n  text-transform: uppercase;\n'],['\n  color: #010101;\n  font-family: Nunito;\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 28px;\n  margin: 0;\n  text-transform: uppercase;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  border: 1px solid #bababa;\n  width: 24px;\n  height: 24px;\n  display: block;\n  text-align: center;\n  position: absolute;\n  cursor: pointer;\n  right: 32px;\n  top: 32px;\n\n  &:before {\n    content: \'\u2715\';\n    font-size: 20px;\n    line-height: 24px;\n    color: #bababa;\n    top: 0;\n    position: absolute;\n    left: 0;\n    width: 100%;\n  }\n\n  @media (max-width: 860px) {\n    top: 16px;\n    right: 16px;\n  }\n'],['\n  border: 1px solid #bababa;\n  width: 24px;\n  height: 24px;\n  display: block;\n  text-align: center;\n  position: absolute;\n  cursor: pointer;\n  right: 32px;\n  top: 32px;\n\n  &:before {\n    content: \'\u2715\';\n    font-size: 20px;\n    line-height: 24px;\n    color: #bababa;\n    top: 0;\n    position: absolute;\n    left: 0;\n    width: 100%;\n  }\n\n  @media (max-width: 860px) {\n    top: 16px;\n    right: 16px;\n  }\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ','\n\n  @media (max-width: 860px) {\n    padding: 0 16px;\n  }\n'],['\n  ','\n\n  @media (max-width: 860px) {\n    padding: 0 16px;\n  }\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 80px;\n  background-color: #efefef;\n  box-shadow: inset 0 1px 0 0 #dedede;\n  width: 100%;\n  padding: 16px;\n  text-align: right;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: flex-end;\n'],['\n  height: 80px;\n  background-color: #efefef;\n  box-shadow: inset 0 1px 0 0 #dedede;\n  width: 100%;\n  padding: 16px;\n  text-align: right;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: flex-end;\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 120px;\n  margin-right: 16px;\n'],['\n  width: 120px;\n  margin-right: 16px;\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 120px;\n'],['\n  width: 120px;\n']),_templateObject11=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  transition: opacity 0.3s ease-in;\n  opacity: 0;\n\n  &.show {\n    opacity: 1;\n  }\n'],['\n  transition: opacity 0.3s ease-in;\n  opacity: 0;\n\n  &.show {\n    opacity: 1;\n  }\n']),_templateObject12=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin-left: 36px;\n'],['\n  margin-left: 36px;\n']);var Modal=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Modal,_Component);function Modal(){__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,Modal);var _this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(Modal.__proto__||Object.getPrototypeOf(Modal)).call(this));_this.state={open:false};return _this;}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Modal,[{key:'componentWillMount',value:function componentWillMount(){document.body.style.overflow='hidden';}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.body.style.overflow='';}},{key:'render',value:function render(){var _this2=this;var _props=this.props,title=_props.title,subtitle=_props.subtitle,custom=_props.custom,buttons=_props.buttons;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Container,{className:this.props.className},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Background,{onClick:this.props.closeOnBackground&&this.props.onClick}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(AnimateShow,{className:'show'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ModalCard,{width:this.props.width},!custom&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CardHeader,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CardTitle,null,title,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Subtitle,null,subtitle))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Close,{onClick:function onClick(){return _this2.props.onClick(null);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CardBody,{custom:custom},this.props.children),buttons&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CardFooter,null,buttons.map(function(button){return button.primary?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(NextButton,{key:button.label,text:button.label,onClick:button.click}):__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CancelButton,{key:button.label,text:button.label,onClick:button.click,color:button.color});})))));}}]);return Modal;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);Modal.defaultProps={toggle:false};var Container=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject);var Background=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject2);var ModalCard=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject3,function(_ref){var _ref$width=_ref.width,width=_ref$width===undefined?770:_ref$width;return'\n    max-width: '+width+'px;\n    min-width: '+width+'px;\n    left: calc(50% - '+width/2+'px);\n  ';});var CardHeader=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].header(_templateObject4);var CardTitle=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].h4(_templateObject5);var Close=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject6);var CardBody=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject7,function(_ref2){var custom=_ref2.custom;return!custom&&'\n    padding: 0 32px;\n  ';});var CardFooter=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].footer(_templateObject8);var CancelButton=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_7_components_Button__["a" /* default */])(_templateObject9);var NextButton=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_8_components_PrimaryButton__["a" /* default */])(_templateObject10);var AnimateShow=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject11);var Subtitle=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject12);/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GasItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EletricityItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ResultItem; });
/* unused harmony export FaturaCol */
/* unused harmony export SavedCol */
/* unused harmony export Numbery */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_flexbox_grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_flexbox_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_flexbox_grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ubiwherenpm_adene_ui_components__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_ResultHeader__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_ic_saber_mais_svg__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_ic_saber_mais_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_ic_saber_mais_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_AditionalServices__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_uniq__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_isEmpty__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_merge__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__PrimaryButton__ = __webpack_require__(185);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin: 0 !important;\n'],['\n  margin: 0 !important;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background: #fff;\n  min-height: 162px;\n  border: 1px solid #efefef;\n  margin: 0;\n  margin-bottom: 20px;\n  width: 100%;\n  position: relative;\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n\n  @media (max-width: 980px) {\n    display: flex !important;\n    flex-direction: column !important;\n  }\n'],['\n  background: #fff;\n  min-height: 162px;\n  border: 1px solid #efefef;\n  margin: 0;\n  margin-bottom: 20px;\n  width: 100%;\n  position: relative;\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n\n  @media (max-width: 980px) {\n    display: flex !important;\n    flex-direction: column !important;\n  }\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  flex: 1;\n  border-radius: 0px;\n  &.selected {\n  }\n'],['\n  width: 100%;\n  flex: 1;\n  border-radius: 0px;\n  &.selected {\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n\n  @media (max-width: 980px) {\n    position: initial;\n    max-width: none;\n    flex: 1;\n    flex-direction: row;\n  }\n'],['\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n\n  @media (max-width: 980px) {\n    position: initial;\n    max-width: none;\n    flex: 1;\n    flex-direction: row;\n  }\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding: 0 20px;\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  box-shadow: inset -1px 0 0 0 #efefef;\n  max-width: 150px;\n  background-color: #676767;\n\n  @media (max-width: 980px) {\n    max-width: none;\n  }\n'],['\n  padding: 0 20px;\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  box-shadow: inset -1px 0 0 0 #efefef;\n  max-width: 150px;\n  background-color: #676767;\n\n  @media (max-width: 980px) {\n    max-width: none;\n  }\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: row;\n'],['\n  display: flex;\n  flex-direction: row;\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: row;\n  padding: 0px 20px 0px 27px;\n'],['\n  display: flex;\n  flex-direction: row;\n  padding: 0px 20px 0px 27px;\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #676767;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 18px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  margin: 2px 0;\n'],['\n  color: #676767;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 18px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  margin: 2px 0;\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-weight: normal;\n'],['\n  font-weight: normal;\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()([''],['']),_templateObject11=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #676767;\n  font-size: 14px;\n  font-weight: 100;\n\n  margin-right: 10px;\n  display: inline-block;\n  vertical-align: middle;\n'],['\n  color: #676767;\n  font-size: 14px;\n  font-weight: 100;\n\n  margin-right: 10px;\n  display: inline-block;\n  vertical-align: middle;\n']),_templateObject12=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-size: 12px;\n  line-height: 12px;\n  color: #676767;\n  font-weight: bold;\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  margin: 2px 0;\n'],['\n  font-size: 12px;\n  line-height: 12px;\n  color: #676767;\n  font-weight: bold;\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  margin: 2px 0;\n']),_templateObject13=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin-right: 23px;\n'],['\n  margin-right: 23px;\n']),_templateObject14=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #676767;\n  font-size: 12px;\n  font-weight: 100;\n\n  margin-right: 10px;\n  display: inline-block;\n  vertical-align: middle;\n'],['\n  color: #676767;\n  font-size: 12px;\n  font-weight: 100;\n\n  margin-right: 10px;\n  display: inline-block;\n  vertical-align: middle;\n']),_templateObject15=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 0.25;\n  text-align: left;\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  margin-right: 30px;\n  justify-content: flex-start;\n  min-width: 165px;\n  margin-top: 5%;\n\n  @media (max-width: 980px) {\n    min-width: none;\n    min-height: 120px;\n  }\n'],['\n  flex: 0.25;\n  text-align: left;\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  margin-right: 30px;\n  justify-content: flex-start;\n  min-width: 165px;\n  margin-top: 5%;\n\n  @media (max-width: 980px) {\n    min-width: none;\n    min-height: 120px;\n  }\n']),_templateObject16=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 0.25;\n  text-align: left;\n  padding: 0 30px;\n  margin-right: 30px;\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  justify-content: flex-start;\n  min-width: 250px;\n  margin-top: 5%;\n\n  @media (max-width: 980px) {\n    min-width: none;\n    min-height: 120px;\n  }\n'],['\n  flex: 0.25;\n  text-align: left;\n  padding: 0 30px;\n  margin-right: 30px;\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  justify-content: flex-start;\n  min-width: 250px;\n  margin-top: 5%;\n\n  @media (max-width: 980px) {\n    min-width: none;\n    min-height: 120px;\n  }\n']),_templateObject17=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 14px;\n  margin: 10px 0px 12px 0px;\n  color: ',';\n\n  span {\n    color: #ccc;\n  }\n'],['\n  display: block;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 14px;\n  margin: 10px 0px 12px 0px;\n  color: ',';\n\n  span {\n    color: #ccc;\n  }\n']),_templateObject18=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  box-shadow: inset -1px 0 0 0 #efefef;\n  background: ',';\n  padding: 0 20px;\n  max-width: 150px;\n\n  ','\n\n  @media(max-width: 980px) {\n    min-width: 115px;\n  }\n'],['\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  box-shadow: inset -1px 0 0 0 #efefef;\n  background: ',';\n  padding: 0 20px;\n  max-width: 150px;\n\n  ','\n\n  @media(max-width: 980px) {\n    min-width: 115px;\n  }\n']),_templateObject19=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: white;\n  font-size: 18px;\n  line-height: 18px;\n  font-weight: bold;\n  margin: 10px 0;\n  margin-top: 0;\n'],['\n  color: white;\n  font-size: 18px;\n  line-height: 18px;\n  font-weight: bold;\n  margin: 10px 0;\n  margin-top: 0;\n']),_templateObject20=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-size: 13px;\n'],['\n  font-size: 13px;\n']),_templateObject21=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: relative;\n  width: 125%;\n  font-size: 20px;\n  font-weight: bold;\n  padding: 5px 0 5px 10px;\n  line-height: 22px;\n  margin: -10px 5px 1px -62px;\n  color: white;\n  background: ',';\n\n  ','\n\n  ::after {\n    content: \' \';\n    position: absolute;\n    width: 0;\n    height: 0;\n    left: 0px;\n    top: 100%;\n    border-width: 5px 16.5px;\n    border-style: solid;\n    border-color: #7f7f7f #7f7f7f transparent transparent;\n  }\n\n  ::before {\n    content: \' \';\n    position: absolute;\n    width: 0;\n    height: 0;\n    right: -2px;\n    top: 0px;\n    border-color: transparent #fff transparent transparent;\n  }\n\n  @media (max-width: 1280px) {\n    width: 100%;\n    margin: -10px 22px 1px -62px;\n\n    ::after {\n      border-width: 5px 13.5px;\n    }\n  }\n'],['\n  position: relative;\n  width: 125%;\n  font-size: 20px;\n  font-weight: bold;\n  padding: 5px 0 5px 10px;\n  line-height: 22px;\n  margin: -10px 5px 1px -62px;\n  color: white;\n  background: ',';\n\n  ','\n\n  ::after {\n    content: \' \';\n    position: absolute;\n    width: 0;\n    height: 0;\n    left: 0px;\n    top: 100%;\n    border-width: 5px 16.5px;\n    border-style: solid;\n    border-color: #7f7f7f #7f7f7f transparent transparent;\n  }\n\n  ::before {\n    content: \' \';\n    position: absolute;\n    width: 0;\n    height: 0;\n    right: -2px;\n    top: 0px;\n    border-color: transparent #fff transparent transparent;\n  }\n\n  @media (max-width: 1280px) {\n    width: 100%;\n    margin: -10px 22px 1px -62px;\n\n    ::after {\n      border-width: 5px 13.5px;\n    }\n  }\n']),_templateObject22=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-size: 16px;\n  margin: 0px !important;\n'],['\n  font-size: 16px;\n  margin: 0px !important;\n']),_templateObject23=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  font-size: 13px;\n  font-weight: bold;\n  line-height: 14px;\n  margin: 12px 0;\n  color: #ccc;\n  white-space: nowrap;\n'],['\n  display: block;\n  font-size: 13px;\n  font-weight: bold;\n  line-height: 14px;\n  margin: 12px 0;\n  color: #ccc;\n  white-space: nowrap;\n']),_templateObject24=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: row;\n\n  @media (max-width: 980px) {\n    margin-bottom: 5%;\n  }\n\n  @media (max-width: 850px) {\n    flex-direction: column;\n  }\n'],['\n  display: flex;\n  flex-direction: row;\n\n  @media (max-width: 980px) {\n    margin-bottom: 5%;\n  }\n\n  @media (max-width: 850px) {\n    flex-direction: column;\n  }\n']),_templateObject25=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  margin-left: 30px;\n\n  @media (max-width: 980px) {\n    min-width: 195px;\n    min-height: 120px;\n  }\n\n  @media (max-width: 850px) {\n    margin-top: -5% !important;\n  }\n'],['\n  display: flex;\n  margin-left: 30px;\n\n  @media (max-width: 980px) {\n    min-width: 195px;\n    min-height: 120px;\n  }\n\n  @media (max-width: 850px) {\n    margin-top: -5% !important;\n  }\n']);/* ResultItem Component
 * --------------------
 * Show the result box of a tariff
 * Created on Wed Aug 30 2017
 *
 * Copyright (c) 2017 Ubiwhere
 *
 * Authors:
 * - Hugo Fonseca <hfonseca@ubiwhere.com>
 */var GasItem=function GasItem(_ref){var prices=_ref.prices,className=_ref.className;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(GasRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(GasEntityCol,{className:className},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ResultLabel,{ga:true},'G\xE1s Natural'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Numberyx,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(NumberyLabel,null,'Termo Fixo'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Price,null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_utils__["g" /* pricesCurrency */])(prices.gas.termo_fixo)||'---',' ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Unit,null,'\u20AC/dia'))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Numberyx,{style:{marginTop:10}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(NumberyLabel,null,'Energia'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Price,null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_utils__["g" /* pricesCurrency */])(prices.gas.termo_energia)||'---',' ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Unit,null,'\u20AC/kWh')))));};var EletricityItem=function EletricityItem(_ref2){var prices=_ref2.prices,className=_ref2.className,priceListTimeCycle=_ref2.priceListTimeCycle;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(EletricityRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(EletricityEntityCol,{className:className},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ResultLabel,{el:true},'Eletricidade'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Numberyx,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(NumberyLabel,null,'Termo Pot\xEAncia'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Price,null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_utils__["g" /* pricesCurrency */])(prices.electricity.termo_fixo)||'---',' ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Unit,null,'\u20AC/dia'))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Numberyx,{style:{marginTop:10}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(NumberyLabel,null,'Energia'),priceListTimeCycle==='s'&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Price,null,''+(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_utils__["g" /* pricesCurrency */])(prices.electricity.cheia)||'---'),' ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Unit,null,'\u20AC/kWh'))),priceListTimeCycle==='b'&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(NumberyxSmall,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(NumberyLabelSmall,null,'Fora do Vazio'),' ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Price,null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_utils__["g" /* pricesCurrency */])(prices.electricity.cheia)||'---',' ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Unit,null,'\u20AC/kWh'))),priceListTimeCycle!=='s'&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(NumberyxSmall,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(NumberyLabelSmall,null,'Vazio'),' ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Price,null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_utils__["g" /* pricesCurrency */])(prices.electricity.vazio)||'---',' ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Unit,null,'\u20AC/kWh'))),priceListTimeCycle!=='b'&&priceListTimeCycle!=='s'&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(NumberyxSmall,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(NumberyLabelSmall,null,'Ponta'),' ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Price,null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_utils__["g" /* pricesCurrency */])(prices.electricity.ponta)||'---',' ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Unit,null,'\u20AC/kWh'))),priceListTimeCycle!=='b'&&priceListTimeCycle!=='s'&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(NumberyxSmall,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(NumberyLabelSmall,null,'Cheias'),' ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Price,null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_utils__["g" /* pricesCurrency */])(prices.electricity.cheia)||'---',' ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Unit,null,'\u20AC/kWh')))));};var ResultItem=function(_Component){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ResultItem,_Component);function ResultItem(){__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,ResultItem);return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(ResultItem.__proto__||Object.getPrototypeOf(ResultItem)).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ResultItem,[{key:'render',value:function render(){var _props=this.props,annualBilling=_props.annualBilling,bestAnnualBilling=_props.bestAnnualBilling,clickMore=_props.clickMore,clickAdhere=_props.clickAdhere,translations=_props.translations;var ADHERE_BUTTON=translations.ADHERE_BUTTON;var entity=void 0;var designation=void 0;var subscriptions=void 0;var medalText=void 0;var medalType=void 0;// Get values depending if electricity or gas
if(this.props.electricityPriceList){entity=this.props.electricityPriceList.entity;designation=this.props.electricityPriceList.designation;subscriptions=this.props.electricityPriceList.subscriptions;}if(this.props.gasPriceList){entity=this.props.gasPriceList.entity;designation=this.props.gasPriceList.designation;subscriptions=this.props.gasPriceList.subscriptions;}/** 
     * 
     * Ouro – mais de 50 adesões (inclusive)
      Prata – mais de 20 adesões (inclusive)
      Bronze – mais de 5 adesões (inclusive)
      "nenhuma medalha" – <5 adesões.
     */if(subscriptions.count>=50){medalText='+50 '+subscriptions.period;medalType='gold';}else if(subscriptions.count>=20){medalText='+20 '+subscriptions.period;medalType='silver';}else if(subscriptions.count>=5){medalText='+5 '+subscriptions.period;medalType='bronze';}// Calculate money saved
var moneySaved=bestAnnualBilling-annualBilling;// Set Logo absolute url
entity.absoluteLogoUrl=entity.hi_res_logo&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_utils__["f" /* generateMediaUrl */])(entity.hi_res_logo);// Merge Additional Services
var additionalServices=[];if(this.props.electricityPriceList){additionalServices=__WEBPACK_IMPORTED_MODULE_17_lodash_merge___default()(additionalServices,[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.props.electricityPriceList.additional_services)));}if(this.props.gasPriceList){additionalServices=__WEBPACK_IMPORTED_MODULE_17_lodash_merge___default()(additionalServices,[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.props.gasPriceList.additional_services)));}additionalServices=__WEBPACK_IMPORTED_MODULE_15_lodash_uniq___default()(additionalServices);// Info needed for KnowMore Modal
var moreInfoParams=Object.assign({},this.props,{moneySaved:moneySaved});moreInfoParams.priceListId=this.props.id;if(this.props.electricityPriceList){moreInfoParams.id=this.props.electricityPriceList.id;}else{if(this.props.gasPriceList){moreInfoParams.id=this.props.gasPriceList.id;}}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_ResultHeader__["a" /* default */],{designation:designation,timeCycle:this.props.priceListTimeCycle,absoluteLogoUrl:entity.absoluteLogoUrl,medalText:medalText,medalType:medalType,shareUrl:this.props.url}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Box,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(FaturaCol,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WhiteNumber,{isNegative:moneySaved<=0,bgColor:__WEBPACK_IMPORTED_MODULE_14_config__["c" /* backgroundColors */].normalLeft},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TieLabel,null,moneySaved<=0?'Gasta':'Poupa'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('br',null),' ',''+(moneySaved<=0?'+':'')+(moneySaved&&Math.abs(Math.round(moneySaved))),' ','\u20AC/ano'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TitleLabel,null,'Fatura de Energia *'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(NumberyAnnual,null,annualBilling&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_utils__["i" /* unitCurrency */])(annualBilling),' \u20AC/ano'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SmallNumber,null,annualBilling&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_utils__["i" /* unitCurrency */])(annualBilling/12),' \u20AC/m\xEAs')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Scrollable,null,this.props.electricityPriceList&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(EletricityItem,Object.assign({},this.props,{entity:false,electricityConsumption:false})),this.props.gasPriceList&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(GasItem,Object.assign({},this.props,{entity:false,gasConsumption:false})),additionalServices&&!__WEBPACK_IMPORTED_MODULE_16_lodash_isEmpty___default()(additionalServices)&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(AdditionalWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_AditionalServices__["a" /* default */],{list:additionalServices}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ButtonsList,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__PrimaryButton__["a" /* default */],{style:{marginBottom:20},text:ADHERE_BUTTON,onClick:function onClick(){return clickAdhere(moreInfoParams);}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Button,{onClick:function onClick(){return clickMore(moreInfoParams);},icon:__WEBPACK_IMPORTED_MODULE_11__images_ic_saber_mais_svg___default.a},'Saber Mais'))));}}]);return ResultItem;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);/* eslint-enable camelcase */var Wrapper=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_8_react_flexbox_grid__["Row"])(_templateObject);var Box=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_8_react_flexbox_grid__["Row"])(_templateObject2);var Button=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_9__ubiwherenpm_adene_ui_components__["b" /* SimpleButton */])(_templateObject3);var ButtonsList=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject4);var FaturaCol=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject5);var EletricityRow=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject6);var GasRow=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject7);var Numberyx=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject8);var Unit=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject9);var Price=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject10);var NumberyLabel=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject11);var NumberyxSmall=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject12);var TieLabel=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject13);var NumberyLabelSmall=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject14);var GasEntityCol=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject15);var EletricityEntityCol=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject16);var ResultLabel=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject17,function(_ref3){var el=_ref3.el;return el?'#FF8E2A':'#00BDED';});var SavedCol=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject18,function(_ref4){var bgColor=_ref4.bgColor;return bgColor;},function(_ref5){var isNegative=_ref5.isNegative;return isNegative&&'\n  background: linear-gradient(270deg,#3E3E3E,#9C9C9C);\n  ';});var Numbery=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject19);var SmallNumber=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(Numbery)(_templateObject20);var WhiteNumber=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(Numbery)(_templateObject21,function(_ref6){var bgColor=_ref6.bgColor;return bgColor;},function(_ref7){var isNegative=_ref7.isNegative;return isNegative&&'\n    background: linear-gradient(90deg, #C13E44 0%, #920F15 100%);\n  ';});var NumberyAnnual=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(Numbery)(_templateObject22);var TitleLabel=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject23);var Scrollable=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject24);var AdditionalWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject25);

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ic_brand_color_component_svg__ = __webpack_require__(1651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ic_brand_color_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ic_brand_color_component_svg__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  0% {\n    transform: perspective(400px) rotate3d(0, 1, 0, -360deg);\n    animation-timing-function: ease-out;\n  }\n  40% {\n    transform: perspective(400px) translate3d(0, 0, 80px) rotate3d(0, 1, 0, -190deg);\n    animation-timing-function: ease-out;\n  }\n  50% {\n    transform: perspective(400px) translate3d(0, 0, 80px) rotate3d(0, 1, 0, -170deg);\n    animation-timing-function: ease-in;\n  }\n  80% {\n    transform: perspective(400px) scale3d(.95, .95, .95);\n    animation-timing-function: ease-in;\n  }\n  100% {\n    transform: perspective(400px);\n    animation-timing-function: ease-in;\n  }\n'],['\n  0% {\n    transform: perspective(400px) rotate3d(0, 1, 0, -360deg);\n    animation-timing-function: ease-out;\n  }\n  40% {\n    transform: perspective(400px) translate3d(0, 0, 80px) rotate3d(0, 1, 0, -190deg);\n    animation-timing-function: ease-out;\n  }\n  50% {\n    transform: perspective(400px) translate3d(0, 0, 80px) rotate3d(0, 1, 0, -170deg);\n    animation-timing-function: ease-in;\n  }\n  80% {\n    transform: perspective(400px) scale3d(.95, .95, .95);\n    animation-timing-function: ease-in;\n  }\n  100% {\n    transform: perspective(400px);\n    animation-timing-function: ease-in;\n  }\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 65px;\n  height: 65px;\n  margin-bottom: 20px;\n  animation: ',' 2s linear infinite;\n  backface-visibility: visible;\n  animation-fill-mode: both;\n'],['\n  width: 65px;\n  height: 65px;\n  margin-bottom: 20px;\n  animation: ',' 2s linear infinite;\n  backface-visibility: visible;\n  animation-fill-mode: both;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: calc(100% - 60px);\n  min-height: 500px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n'],['\n  height: calc(100% - 60px);\n  min-height: 500px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  margin: 0 auto;\n  color: #ccc;\n'],['\n  display: block;\n  margin: 0 auto;\n  color: #ccc;\n']);// import Logo from './ic-brand-color.svg'
var Simulating=function Simulating(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SpinnerIcon,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ic_brand_color_component_svg___default.a,null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Text,null,'Estamos a avaliar o melhor tarif\xE1rio para si'));};var Scale=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styled_components__["keyframes"])(_templateObject);// const Spinner = styled.img`
//   width: 65px;
//   height: 65px;
//   margin-bottom: 20px;
//   animation: ${Scale} 2s linear infinite;
//   backface-visibility: visible;
//   animation-fill-mode: both;
// `
var SpinnerIcon=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject2,Scale);var Wrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject3);var Text=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject4);/* harmony default export */ __webpack_exports__["a"] = (Simulating);

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  height: 60px;\n  position: relative;\n'],['\n  width: 100%;\n  height: 60px;\n  position: relative;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  justify-content: space-around;\n  height: 100%;\n  align-items: center;\n'],['\n  display: flex;\n  justify-content: space-around;\n  height: 100%;\n  align-items: center;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 1;\n  color: #9c9c9c;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 14px;\n  text-align: center;\n  cursor: pointer;\n\n  ','\n\n  &.selected {\n    color: #3e3e3e;\n    font-weight: bold;\n  }\n'],['\n  flex: 1;\n  color: #9c9c9c;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 14px;\n  text-align: center;\n  cursor: pointer;\n\n  ','\n\n  &.selected {\n    color: #3e3e3e;\n    font-weight: bold;\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 5px;\n  width: 120px;\n  background: linear-gradient(270deg, #006736 0%, #93c13e 100%);\n  display: inline-block;\n  position: absolute;\n  bottom: 0;\n\n  transition: 0.3s ease-in-out;\n'],['\n  height: 5px;\n  width: 120px;\n  background: linear-gradient(270deg, #006736 0%, #93c13e 100%);\n  display: inline-block;\n  position: absolute;\n  bottom: 0;\n\n  transition: 0.3s ease-in-out;\n']);var Tabs=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tabs,_Component);function Tabs(){__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,Tabs);var _this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(Tabs.__proto__||Object.getPrototypeOf(Tabs)).call(this));_this.selectTab=function(selectedIndex){var selected=_this.tabRefs.find(function(tab){return tab.index===selectedIndex;});_this.slideRef.style.left=selected.ref.offsetLeft+'px';_this.slideRef.style.width=selected.ref.offsetWidth+'px';};_this.getSlide=function(ref){_this.slideRef=__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(ref);};_this.tabRefs=[];return _this;}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Tabs,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.currentIndex!==undefined){this.selectTab(nextProps.currentIndex);}}},{key:'componentDidMount',value:function componentDidMount(){var currentIndex=this.props.currentIndex;this.slideRef.style.left=this.tabRefs[currentIndex].ref.offsetLeft+'px';this.slideRef.style.width=this.tabRefs[currentIndex].ref.offsetWidth+'px';}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Flexer,null,this.props.tabs.map(function(tab,index){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Tab,{className:_this2.props.currentIndex===index&&'selected',key:tab,onClick:function onClick(){return _this2.props.onClick(index);},ref:function ref(_ref){return _this2.tabRefs.push({index:index,ref:__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(_ref)});},progress:_this2.props.hasProgress?index<_this2.props.currentIndex:false},tab);})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Slide,{ref:this.getSlide}));}}]);return Tabs;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);Tabs.propTypes={tabs:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string)};var Container=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject);var Flexer=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject2);var Tab=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject3,function(_ref2){var progress=_ref2.progress;return progress&&'\n    color: #3E3E3E;\n    font-weight: bold;\n  ';});var Slide=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject4);// const Underline = styled.span`
//   height: 1px;
//   width: 100%;
//   background: linear-gradient(270deg, #006736 0%, #93C13E 100%);
//   position: absolute;
//   bottom: 0;
//   left: 0;
// `
/* harmony default export */ __webpack_exports__["a"] = (Tabs);

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_portuguese_utils_formaters_formatToCurrency__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_portuguese_utils_formaters_formatToCurrency___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_portuguese_utils_formaters_formatToCurrency__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__information_entries__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Util__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Tabs__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_MonthlyInvoice__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils__ = __webpack_require__(11);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding-bottom: 32px;\n  max-height: calc(100vh - 300px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  min-height: calc(100vh - 500px);\n'],['\n  padding-bottom: 32px;\n  max-height: calc(100vh - 300px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  min-height: calc(100vh - 500px);\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding: 10px;\n'],['\n  padding: 10px;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #93c13e;\n  font-family: Nunito;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 16px;\n  margin: 0;\n'],['\n  color: #93c13e;\n  font-family: Nunito;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 16px;\n  margin: 0;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  margin-top: 16px;\n  border-bottom: 1px solid #efefef;\n  padding-bottom: 4px;\n\n  @media (max-width: 860px) {\n    flex-direction: column;\n  }\n'],['\n  display: flex;\n  margin-top: 16px;\n  border-bottom: 1px solid #efefef;\n  padding-bottom: 4px;\n\n  @media (max-width: 860px) {\n    flex-direction: column;\n  }\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #9c9c9c;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 14px;\n  min-width: 40%;\n  max-width: 40%;\n  margin-right: 8px;\n\n  @media (max-width: 860px) {\n    margin-bottom: 8px;\n  }\n'],['\n  color: #9c9c9c;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 14px;\n  min-width: 40%;\n  max-width: 40%;\n  margin-right: 8px;\n\n  @media (max-width: 860px) {\n    margin-bottom: 8px;\n  }\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #3e3e3e;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 14px;\n  white-space: pre-wrap;\n'],['\n  color: #3e3e3e;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 14px;\n  white-space: pre-wrap;\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  word-wrap: \'break-word\';\n  color: #93c13e;\n'],['\n  word-wrap: \'break-word\';\n  color: #93c13e;\n']);/* eslint-disable camelcase */// Modalidade da oferta comercial: commercial_offer_modality
var processIdentification=function processIdentification(_ref,_ref2,segments){var designation=_ref.designation,description=_ref.description;var market_segment_type=_ref2.market_segment_type,commercial_offer_website=_ref2.commercial_offer_website,website_standardized_contract_form=_ref2.website_standardized_contract_form,website_contract_conditions=_ref2.website_contract_conditions,contacts=_ref2.contacts,email_contact=_ref2.email_contact,website_contact=_ref2.website_contact;return{designation:designation,description:description,commercial_offer_website:commercial_offer_website,website_standardized_contract_form:website_standardized_contract_form,website_contract_conditions:website_contract_conditions,contacts:contacts,email_contact:email_contact,website_contact:website_contact};};var processComercial=function processComercial(_ref3,_ref4){var offer_type=_ref3.offer_type,additional_services=_ref3.additional_services;var contract_duration=_ref4.contract_duration,offer_start_date=_ref4.offer_start_date,offer_validity=_ref4.offer_validity,email_contract_contact=_ref4.email_contract_contact,location_contract_contact=_ref4.location_contract_contact,phone_contract_contact=_ref4.phone_contract_contact,electronic_billing=_ref4.electronic_billing,green_energy=_ref4.green_energy,paper_billing=_ref4.paper_billing,direct_debit=_ref4.direct_debit,atm_ctt=_ref4.atm_ctt,shop_payment=_ref4.shop_payment,support_options=_ref4.support_options,payment_periodicity=_ref4.payment_periodicity,loyalty_clauses_description=_ref4.loyalty_clauses_description,has_additional_restrictions=_ref4.has_additional_restrictions,additional_restrictions=_ref4.additional_restrictions,offer_restrictions=_ref4.offer_restrictions,discount_as_uploaded=_ref4.discount_as_uploaded,price_function_of_access=_ref4.price_function_of_access,price_revision_conditions=_ref4.price_revision_conditions,indexed_prices=_ref4.indexed_prices,indexed_prices_description=_ref4.indexed_prices_description,website_contract_contact=_ref4.website_contract_contact;var newObj={contract_duration:contract_duration,offer_start_date:offer_start_date?__WEBPACK_IMPORTED_MODULE_6_moment___default()(new Date(offer_start_date)).format('DD/MM/YYYY'):'',offer_validity:offer_validity?__WEBPACK_IMPORTED_MODULE_6_moment___default()(new Date(offer_validity)).format('DD/MM/YYYY'):'',contract_type:[email_contract_contact||website_contract_contact?email_contract_contact?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Link,{href:'mailto:'+email_contract_contact,target:'_blank'},__WEBPACK_IMPORTED_MODULE_9__information_entries__["a" /* CONTRACT_TYPE */].email_contract_contact):__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Link,{href:website_contract_contact,target:'_blank'},__WEBPACK_IMPORTED_MODULE_9__information_entries__["a" /* CONTRACT_TYPE */].email_contract_contact):'',location_contract_contact?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Link,{href:''+location_contract_contact,target:'_blank'},__WEBPACK_IMPORTED_MODULE_9__information_entries__["a" /* CONTRACT_TYPE */].location_contract_contact):'',phone_contract_contact?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Link,{href:'tel:'+phone_contract_contact,target:'_blank'},__WEBPACK_IMPORTED_MODULE_9__information_entries__["a" /* CONTRACT_TYPE */].phone_contract_contact,' (',phone_contract_contact,')'):''].filter(function(d){return d;}),billing_type:[electronic_billing?__WEBPACK_IMPORTED_MODULE_9__information_entries__["b" /* BILLING_TYPE */].electronic_billing:'',paper_billing?__WEBPACK_IMPORTED_MODULE_9__information_entries__["b" /* BILLING_TYPE */].paper_billing:''].filter(function(d){return d;}).join(', '),payment_type:[direct_debit?__WEBPACK_IMPORTED_MODULE_9__information_entries__["c" /* PAYMENT_TYPE */].direct_debit:'',atm_ctt?__WEBPACK_IMPORTED_MODULE_9__information_entries__["c" /* PAYMENT_TYPE */].atm_ctt:'',shop_payment?__WEBPACK_IMPORTED_MODULE_9__information_entries__["c" /* PAYMENT_TYPE */].shop_payment:''].filter(function(d){return d;}).join(', '),support_options:support_options&&support_options.map(function(so){return __WEBPACK_IMPORTED_MODULE_9__information_entries__["d" /* SUPPORT_OPTIONS */].find(function(sup){return sup.slug===so;}).text;}).join(', '),payment_periodicity:payment_periodicity,has_loyalty:!!additional_services.find(function(d){return d.id===3;}),loyalty_clauses_description:loyalty_clauses_description,green_energy:green_energy,has_additional_restrictions:has_additional_restrictions,additional_restrictions:additional_restrictions&&additional_restrictions.map(function(d){return __WEBPACK_IMPORTED_MODULE_9__information_entries__["e" /* ADDITIONAL_RESTRICTIONS */][d];}),offer_restrictions:offer_restrictions,discount_as_uploaded:discount_as_uploaded,price_function_of_access:price_function_of_access,price_revision_conditions:price_revision_conditions,indexed_prices:indexed_prices,indexed_prices_description:indexed_prices_description};if(!newObj.has_loyalty){delete newObj.loyalty_clauses_description;}if(!has_additional_restrictions){delete newObj.additional_restrictions;}else{delete newObj.has_additional_restrictions;}if(!indexed_prices){delete newObj.indexed_prices_description;}return newObj;};var entriesObject={electric:{currentEntityElectric:{value:'',valid:false,designation:'ee'},cpe:{value:'',valid:false},potency:{value:'',valid:false},cycle:{value:'',valid:false,designation:'CYCLE'}},gas:{currentEntityGas:{value:'',valid:false,designation:'eg'},cui:{value:'',valid:false},tier:{value:'',valid:false,designation:'TIER'}}};var processAdditionalServices=function processAdditionalServices(_ref5,_ref6){var additional_services_cost=_ref5.additional_services_cost,additional_services_cost_with_vat=_ref5.additional_services_cost_with_vat,additional_services_description=_ref5.additional_services_description,optional_services_description=_ref5.optional_services_description;var additional_services=_ref6.additional_services;var newObj={required_subscription_additional_services:!!additional_services.find(function(d){return d.id===5;}),additional_services_cost:additional_services_cost?''+__WEBPACK_IMPORTED_MODULE_8_portuguese_utils_formaters_formatToCurrency___default()(additional_services_cost,2):'',additional_services_cost_with_vat:additional_services_cost_with_vat?''+__WEBPACK_IMPORTED_MODULE_8_portuguese_utils_formaters_formatToCurrency___default()(additional_services_cost_with_vat,2):'',additional_services_description:additional_services_description,optional_services_description:optional_services_description};if(!newObj.required_subscription_additional_services){delete newObj.additional_services_cost_with_vat;delete newObj.additional_services_description;}return newObj;};var processRefunds=function processRefunds(_ref7){var has_refunds=_ref7.has_refunds,annual_refunds=_ref7.annual_refunds,electricity_refund_fixed_term=_ref7.electricity_refund_fixed_term,electricity_refund_energy_term=_ref7.electricity_refund_energy_term,electricity_refund_energy_function=_ref7.electricity_refund_energy_function,gas_refund_fixed_term=_ref7.gas_refund_fixed_term,gas_refund_energy_term=_ref7.gas_refund_energy_term,gas_refund_energy_function=_ref7.gas_refund_energy_function,refunds_description=_ref7.refunds_description;if(!has_refunds){return{has_refunds:has_refunds};}var newObj={has_refunds:has_refunds,annual_refunds:annual_refunds?''+__WEBPACK_IMPORTED_MODULE_8_portuguese_utils_formaters_formatToCurrency___default()(annual_refunds,2):'',electricity_refund_fixed_term:electricity_refund_fixed_term?__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_utils__["p" /* roundToTwo */])(electricity_refund_fixed_term*100)+'%':'',electricity_refund_energy_term:electricity_refund_energy_term?__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_utils__["p" /* roundToTwo */])(electricity_refund_energy_term*100)+'%':'',electricity_refund_energy_function:electricity_refund_energy_function?''+__WEBPACK_IMPORTED_MODULE_8_portuguese_utils_formaters_formatToCurrency___default()(electricity_refund_energy_function,4):'',gas_refund_fixed_term:gas_refund_fixed_term?__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_utils__["p" /* roundToTwo */])(gas_refund_fixed_term*100)+'%':'',gas_refund_energy_term:gas_refund_energy_term?__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_utils__["p" /* roundToTwo */])(gas_refund_energy_term*100)+'%':'',gas_refund_energy_function:gas_refund_energy_function?''+__WEBPACK_IMPORTED_MODULE_8_portuguese_utils_formaters_formatToCurrency___default()(gas_refund_energy_function,4):'',refunds_description:refunds_description};Object.keys(newObj).forEach(function(key){if(newObj[key]===''||newObj[key]===null){delete newObj[key];}});return newObj;};var typeOfVariable=function typeOfVariable(val){if(typeof val==='boolean'){return val?'Sim':'Não';}if(typeof val==='string'){if(__WEBPACK_IMPORTED_MODULE_14__utils__["q" /* SIMPLE_WEBSITE_REGEX */].test(val)){var urls=val.match(__WEBPACK_IMPORTED_MODULE_14__utils__["q" /* SIMPLE_WEBSITE_REGEX */]);var normalTexts=val.split(__WEBPACK_IMPORTED_MODULE_14__utils__["q" /* SIMPLE_WEBSITE_REGEX */]);return normalTexts.reduce(function(arr,value,i){var isEmail=/[\w-]+@$/.test(value);var url=urls.length>=i+1?urls[i]:'';if(value)arr.push(__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(EntryText,null,value,isEmail?url:''));if(!isEmail&&url)arr.push(__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Link,{href:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils__["r" /* getResolvedWebsite */])(urls[i]),target:'_blank'},urls[i]));return arr;},[]);}return val||'---';}if(Array.isArray(val)){return val.map(function(v){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span',null,v,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('br',null));});}return val;};var Entry=function Entry(props){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(EntryText,null,props.value===undefined||props.value===null?'---':typeOfVariable(props.value));};var renderIdentificationLabels=function renderIdentificationLabels(identification,entry){if(entry==='website_contact'||entry==='email_contact'){if(!identification['website_contact']&&!identification['email_contact']){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(InfoEntry,{key:'website_contact'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(EntryLabel,{xs:7},__WEBPACK_IMPORTED_MODULE_9__information_entries__["f" /* MERCHANT_IDENTIFICATION */]['website_contact']),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Entry,{value:identification['website_contact']}));}else{if(identification[entry]){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(InfoEntry,{key:entry},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(EntryLabel,{xs:7},__WEBPACK_IMPORTED_MODULE_9__information_entries__["f" /* MERCHANT_IDENTIFICATION */][entry]),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Entry,{value:identification[entry]}));}}}else{return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(InfoEntry,{key:entry},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(EntryLabel,{xs:7},__WEBPACK_IMPORTED_MODULE_9__information_entries__["f" /* MERCHANT_IDENTIFICATION */][entry]),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Entry,{value:identification[entry]}));}};var TariffDetails=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TariffDetails,_Component);function TariffDetails(){var _ref8;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,TariffDetails);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref8=TariffDetails.__proto__||Object.getPrototypeOf(TariffDetails)).call.apply(_ref8,[this].concat(args))),_this),_this.state={index:0},_temp),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TariffDetails,[{key:'render',value:function render(){var _this2=this;var _props=this.props,tariff=_props.tariff,priceListTimeCycle=_props.priceListTimeCycle,resultTariff=_props.resultTariff;if(priceListTimeCycle){entriesObject.electric.tariff={value:priceListTimeCycle,valid:true,designation:'TARIFF'};}var index=this.state.index;var tabs=['Detalhes','Fatura Mensal'];var pricelistadditionalinfo=void 0;if(tariff){pricelistadditionalinfo=tariff.pricelistadditionalinfo;}var tabChange=function tabChange(index){_this2.setState({index:index});return index;};var identification=processIdentification(tariff,pricelistadditionalinfo);var comercial=processComercial(tariff,pricelistadditionalinfo);var addServices=processAdditionalServices(pricelistadditionalinfo,tariff);var refunds=processRefunds(pricelistadditionalinfo);return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Tabs__["a" /* default */],{currentIndex:index,tabs:tabs,hasProgress:true,onClick:tabChange}),index===0&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',null,tariff&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Util__["a" /* Marginer */],{top:32},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Title,{className:'mt-3'},__WEBPACK_IMPORTED_MODULE_9__information_entries__["g" /* TITLES */].IDENTIFICATION)),Object.keys(identification).map(function(entry){return renderIdentificationLabels(identification,entry);}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Util__["a" /* Marginer */],{top:32},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Title,{className:'mt-3'},__WEBPACK_IMPORTED_MODULE_9__information_entries__["g" /* TITLES */].COMERCIAL_CONDITIONS)),Object.keys(comercial).map(function(entry){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(InfoEntry,{key:entry},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(EntryLabel,{xs:7},__WEBPACK_IMPORTED_MODULE_9__information_entries__["h" /* COMERCIAL_CONDITIONS */][entry]),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Entry,{value:comercial[entry]}));}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Util__["a" /* Marginer */],{top:32},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Title,{className:'mt-3'},__WEBPACK_IMPORTED_MODULE_9__information_entries__["g" /* TITLES */].ADDITIONAL_SERVICES)),Object.keys(addServices).map(function(entry){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(InfoEntry,{key:entry},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(EntryLabel,{xs:7},__WEBPACK_IMPORTED_MODULE_9__information_entries__["i" /* ADDITIONAL_SERVICES */][entry]),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Entry,{value:addServices[entry]}));}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Util__["a" /* Marginer */],{top:32},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Title,{className:'mt-3'},__WEBPACK_IMPORTED_MODULE_9__information_entries__["g" /* TITLES */].REFUNDS)),Object.keys(refunds).map(function(entry){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(InfoEntry,{key:entry},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(EntryLabel,{xs:7},__WEBPACK_IMPORTED_MODULE_9__information_entries__["j" /* REFUNDS_ENTRIES */][entry]),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Entry,{value:refunds[entry]}));}))),index===1&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(TariffWrapper,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_MonthlyInvoice__["a" /* default */],{tariff:resultTariff,tariffInfo:tariff,entries:entriesObject})));}}]);return TariffDetails;}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);var Container=__WEBPACK_IMPORTED_MODULE_5_styled_components__["default"].div(_templateObject);var TariffWrapper=__WEBPACK_IMPORTED_MODULE_5_styled_components__["default"].div(_templateObject2);var Title=__WEBPACK_IMPORTED_MODULE_5_styled_components__["default"].h6(_templateObject3);var InfoEntry=__WEBPACK_IMPORTED_MODULE_5_styled_components__["default"].div(_templateObject4);var EntryLabel=__WEBPACK_IMPORTED_MODULE_5_styled_components__["default"].span(_templateObject5);var EntryText=__WEBPACK_IMPORTED_MODULE_5_styled_components__["default"].span(_templateObject6);var Link=__WEBPACK_IMPORTED_MODULE_5_styled_components__["default"].a(_templateObject7);/* harmony default export */ __webpack_exports__["a"] = (TariffDetails);

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONTACT_HOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return POTENCY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TARIFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BILLING_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DIRECT_DEBIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ELETRONIC_BILLING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONTACTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CYCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TIER; });
var CONTACT_HOUR={name:'Em que período pretende ser contactado?',fieldName:'horario',values:[{label:'9h00 - 11h30',value:'9h00 - 11h30'},{label:'11h30 - 13h00',value:'11h30 - 13h00'},{label:'13h00 - 15h30',value:'13h00 - 15h30'},{label:'15h30 - 18h00',value:'15h30 - 18h00'},{label:'18h00 - 20h30',value:'18h00 - 20h30'}]};var POTENCY={name:'Potência',fieldName:'potencia_contratada',values:[{label:'1,15 kVA',value:1.15},{label:'2,3 kVA',value:2.3},{label:'3,45 kVA',value:3.45},{label:'4,6 kVA',value:4.6},{label:'5,75 kVA',value:5.75},{label:'6,9 kVA',value:6.9},{label:'10,35 kVA',value:10.35},{label:'13,8 kVA',value:13.8},{label:'17,25 kVA',value:17.25},{label:'20,7 kVA',value:20.7},{label:'27,6 kVA',value:27.6},{label:'34,5 kVA',value:34.5},{label:'41,4 kVA',value:41.4}]};var TARIFF={name:'Tarifa',fieldName:'ciclo_horario',values:[{label:'Simples',value:'s'},{label:'Bi-Horário',value:'b'},{label:'Tri-Horário',value:'t'}]};var BILLING_ADDRESS={name:'Morada da Faturação',fieldName:'billing_address',values:[{label:'Igual à morada de contrato',value:'e'},{label:'Diferente da morada do contrato',value:'d'}]};var DIRECT_DEBIT={name:'Débito direto',fieldName:'direct_debit',values:[{label:'Sim',value:'d'},{label:'Não',value:'false'}]};var ELETRONIC_BILLING={name:'Fatura eletrónica',fieldName:'eletronic_billing',values:[{label:'Sim',value:'e'},{label:'Não',value:'false'}]};var CONTACTS={name:'Meio de contacto preferêncial',fieldName:'preferential_contact',values:[{label:'Email',value:'e'},{label:'Chamada telefónica',value:'p'},{label:'SMS',value:'s'}]};var CYCLE={name:'Ciclo horário',fieldName:'ciclo',values:[{label:'Diário',value:'d'},{label:'Semanal',value:'w'}]};var TIER={name:'Escalão',fieldName:'price_step',values:[{label:'Escalão 1',value:1},{label:'Escalão 2',value:2},{label:'Escalão 3',value:3},{label:'Escalão 4',value:4}]};

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  max-width: 300px;\n  text-align: left;\n  align-items: center;\n'],['\n  display: flex;\n  max-width: 300px;\n  text-align: left;\n  align-items: center;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 20px;\n\n  width: 20px;\n'],['\n  height: 20px;\n\n  width: 20px;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: inline-block;\n  vertical-align: middle;\n  color: #676767;\n  font-size: 12px;\n  font-weight: 300;\n  line-height: 12px;\n  margin-left: 10px;\n'],['\n  display: inline-block;\n  vertical-align: middle;\n  color: #676767;\n  font-size: 12px;\n  font-weight: 300;\n  line-height: 12px;\n  margin-left: 10px;\n']);/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var text=_ref.text,icon=_ref.icon,className=_ref.className;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Wrapper,{className:className},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Icon,{src:icon,alt:text}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Text,null,text));});var Wrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject);var Icon=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].img(_templateObject2);var Text=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject3);

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UseType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Label__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Paragraph__ = __webpack_require__(877);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  justify-content: center;\n  flex-wrap: nowrap;\n  margin-top: 23px;\n  padding: 0 10px 3px;\n\n  @media screen and (max-width: 568px) {\n    flex-direction: column;\n    align-items: center;\n  }\n'],['\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  justify-content: center;\n  flex-wrap: nowrap;\n  margin-top: 23px;\n  padding: 0 10px 3px;\n\n  @media screen and (max-width: 568px) {\n    flex-direction: column;\n    align-items: center;\n  }\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  position: relative;\n\n  ','\n  ','\n  height: auto;\n  margin: 0;\n\n  & + & {\n    margin-left: 10px;\n  }\n\n  &:hover {\n    div.check {\n      background: ',';\n      &::before {\n        background: #ffffff;\n      }\n    }\n    div.box {\n      margin: 2px;\n\n      &:before {\n        top: -2px;\n        left: -2px;\n        right: -2px;\n        bottom: -2px;\n        background-image: ',';\n        z-index: -2;\n      }\n      &:after {\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        background: #ffffff;\n        z-index: -1;\n      }\n    }\n    div.checkwrapper {\n      &:before {\n        top: -2px;\n        left: -2px;\n        right: -2px;\n        bottom: -2px;\n        background: ',';\n        z-index: -2;\n      }\n      &:after {\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        background: #ffffff;\n        z-index: -1;\n      }\n    }\n  }\n\n  @media screen and (max-width: 1024px) {\n    margin-right: 0;\n    margin-bottom: 30px;\n  }\n\n  @media screen and (max-width: 568px) {\n    margin-left: 0 !important;\n  }\n'],['\n  display: block;\n  position: relative;\n\n  ','\n  ','\n  height: auto;\n  margin: 0;\n\n  & + & {\n    margin-left: 10px;\n  }\n\n  &:hover {\n    div.check {\n      background: ',';\n      &::before {\n        background: #ffffff;\n      }\n    }\n    div.box {\n      margin: 2px;\n\n      &:before {\n        top: -2px;\n        left: -2px;\n        right: -2px;\n        bottom: -2px;\n        background-image: ',';\n        z-index: -2;\n      }\n      &:after {\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        background: #ffffff;\n        z-index: -1;\n      }\n    }\n    div.checkwrapper {\n      &:before {\n        top: -2px;\n        left: -2px;\n        right: -2px;\n        bottom: -2px;\n        background: ',';\n        z-index: -2;\n      }\n      &:after {\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        background: #ffffff;\n        z-index: -1;\n      }\n    }\n  }\n\n  @media screen and (max-width: 1024px) {\n    margin-right: 0;\n    margin-bottom: 30px;\n  }\n\n  @media screen and (max-width: 568px) {\n    margin-left: 0 !important;\n  }\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: relative;\n  display: block;\n  cursor: pointer;\n  pointer-events: none;\n  margin-bottom: 26px;\n  z-index: 4;\n'],['\n  position: relative;\n  display: block;\n  cursor: pointer;\n  pointer-events: none;\n  margin-bottom: 26px;\n  z-index: 4;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin: 2px;\n  position: absolute;\n  z-index: 3;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 26px;\n\n  padding: 2px;\n  cursor: pointer;\n\n  &:before,\n  &:after {\n    content: \'\';\n    position: absolute;\n  }\n  ','\n'],['\n  margin: 2px;\n  position: absolute;\n  z-index: 3;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 26px;\n\n  padding: 2px;\n  cursor: pointer;\n\n  &:before,\n  &:after {\n    content: \'\';\n    position: absolute;\n  }\n  ','\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  position: absolute;\n  overflow: hidden;\n\n  width: 56px;\n  height: 28px;\n\n  bottom: 26px;\n  left: 50%;\n\n  margin-left: -28px;\n  z-index: 5;\n\n  cursor: pointer;\n'],['\n  display: block;\n  position: absolute;\n  overflow: hidden;\n\n  width: 56px;\n  height: 28px;\n\n  bottom: 26px;\n  left: 50%;\n\n  margin-left: -28px;\n  z-index: 5;\n\n  cursor: pointer;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  z-index: 5;\n\n  display: block;\n  position: absolute;\n  top: 2px;\n  left: 2px;\n\n  cursor: default;\n\n  width: 52px;\n  height: 52px;\n\n  &:before,\n  &:after {\n    content: \'\';\n    position: absolute;\n\n    border-top-left-radius: 100%;\n    border-top-right-radius: 100%;\n    border-bottom-right-radius: 0%;\n    border-bottom-left-radius: 0%;\n  }\n\n  ','\n'],['\n  z-index: 5;\n\n  display: block;\n  position: absolute;\n  top: 2px;\n  left: 2px;\n\n  cursor: default;\n\n  width: 52px;\n  height: 52px;\n\n  &:before,\n  &:after {\n    content: \'\';\n    position: absolute;\n\n    border-top-left-radius: 100%;\n    border-top-right-radius: 100%;\n    border-bottom-right-radius: 0%;\n    border-bottom-left-radius: 0%;\n  }\n\n  ','\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  position: absolute;\n\n  width: 14px;\n  height: 14px;\n  visibility: hidden;\n  z-index: 6;\n\n  &:checked {\n    ~ div.check {\n      background: ',';\n\n      &::before {\n        background: #ffffff;\n      }\n    }\n    ~ div.box {\n      margin: 2px;\n      &:before {\n        top: -2px;\n        left: -2px;\n        right: -2px;\n        bottom: -2px;\n        background-image: ',';\n        z-index: -2;\n      }\n      &:after {\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        background: #ffffff;\n        z-index: -1;\n      }\n    }\n    ~ div.checkwrapper {\n      &:before {\n        top: -2px;\n        left: -2px;\n        right: -2px;\n        bottom: -2px;\n        background: ',';\n        z-index: -2;\n      }\n      &:after {\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        background: #ffffff;\n        z-index: -1;\n      }\n    }\n  }\n'],['\n  display: block;\n  position: absolute;\n\n  width: 14px;\n  height: 14px;\n  visibility: hidden;\n  z-index: 6;\n\n  &:checked {\n    ~ div.check {\n      background: ',';\n\n      &::before {\n        background: #ffffff;\n      }\n    }\n    ~ div.box {\n      margin: 2px;\n      &:before {\n        top: -2px;\n        left: -2px;\n        right: -2px;\n        bottom: -2px;\n        background-image: ',';\n        z-index: -2;\n      }\n      &:after {\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        background: #ffffff;\n        z-index: -1;\n      }\n    }\n    ~ div.checkwrapper {\n      &:before {\n        top: -2px;\n        left: -2px;\n        right: -2px;\n        bottom: -2px;\n        background: ',';\n        z-index: -2;\n      }\n      &:after {\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        background: #ffffff;\n        z-index: -1;\n      }\n    }\n  }\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  position: absolute;\n  width: 37px;\n  height: 37px;\n  border: 1px solid #dedede;\n  bottom: 5px;\n  left: 50%;\n  border-radius: 100%;\n  margin-left: -19px;\n  z-index: 6;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  ','\n\n  &::before {\n    display: block;\n    content: \'\';\n    border-radius: 100%;\n    height: 21px;\n    width: 21px;\n    background: #ffffff;\n  }\n'],['\n  display: block;\n  position: absolute;\n  width: 37px;\n  height: 37px;\n  border: 1px solid #dedede;\n  bottom: 5px;\n  left: 50%;\n  border-radius: 100%;\n  margin-left: -19px;\n  z-index: 6;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  ','\n\n  &::before {\n    display: block;\n    content: \'\';\n    border-radius: 100%;\n    height: 21px;\n    width: 21px;\n    background: #ffffff;\n  }\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin: 35px 10px 0px 10px;\n  color: #010101;\n  font-size: 18px;\n  font-weight: bold;\n  line-height: 24px;\n  text-align: center;\n  text-transform: uppercase;\n'],['\n  margin: 35px 10px 0px 10px;\n  color: #010101;\n  font-size: 18px;\n  font-weight: bold;\n  line-height: 24px;\n  text-align: center;\n  text-transform: uppercase;\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin: 0px 10px 0px 10px;\n  color: #010101;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 24px;\n  text-align: center;\n  text-transform: uppercase;\n'],['\n  margin: 0px 10px 0px 10px;\n  color: #010101;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 24px;\n  text-align: center;\n  text-transform: uppercase;\n']),_templateObject11=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin: 12px 10px 0px 10px;\n  padding-bottom: 40px;\n  position: relative;\n  color: #010101;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 20px;\n  text-align: center;\n'],['\n  margin: 12px 10px 0px 10px;\n  padding-bottom: 40px;\n  position: relative;\n  color: #010101;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 20px;\n  text-align: center;\n']);var Item=function(_React$Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Item,_React$Component);function Item(){__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,Item);var _this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(Item.__proto__||Object.getPrototypeOf(Item)).call(this));_this.input=null;return _this;}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Item,[{key:'render',value:function render(){var _this2=this;var props=Object.assign({},this.props);return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Li,{id:props.name+'-'+props.value,onClick:props.handleSelection.bind(this,props),ref:function ref(c){_this2.input=c;},width:props.width,bgColor:__WEBPACK_IMPORTED_MODULE_7_config__["c" /* backgroundColors */].normalLeft,height:props.height},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Input,{id:props.name+'-'+props.value,name:props.name,checked:props.selected,bgColor:__WEBPACK_IMPORTED_MODULE_7_config__["c" /* backgroundColors */].normalLeft,onChange:props.handleSelection.bind(this,props)}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Box,{active:props.selected,bgColor:__WEBPACK_IMPORTED_MODULE_7_config__["c" /* backgroundColors */].normalLeft,className:'box'}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(TextWrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(StyledLabel,{'for':'f-option'},props.text),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(StyledLabelSecondary,{'for':'f-option'},props.subname?props.subname:' '),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(StyledParagraph,null,props.description)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CheckMask,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CheckWrapper,{bgColor:__WEBPACK_IMPORTED_MODULE_7_config__["c" /* backgroundColors */].normalLeft,className:'checkwrapper',active:props.selected})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Check,{className:'check',bgColor:__WEBPACK_IMPORTED_MODULE_7_config__["c" /* backgroundColors */].normalLeft}));}}]);return Item;}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);var UseType=function(_React$Component2){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(UseType,_React$Component2);function UseType(props){__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,UseType);var _this3=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(UseType.__proto__||Object.getPrototypeOf(UseType)).call(this,props));_this3.handleSelection=_this3.handleSelection.bind(_this3);_this3.itemsLoaded=0;_this3.maxHeight=266;_this3.state={itemHeight:_this3.maxHeight};return _this3;}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(UseType,[{key:'handleSelection',value:function handleSelection(e){if(this.props.onSelectionChange){this.props.onSelectionChange(Object.assign({},e));}}},{key:'render',value:function render(){var _this4=this;var items=this.props.items;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Container,null,items&&items.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Item,{componentLoaded:_this4.componentLoaded,key:'usetype-'+item.value+item.text,name:_this4.props.name,width:_this4.props.itemSize,handleSelection:_this4.handleSelection,value:item.value,text:item.text,subname:item.sub_name,description:item.description,height:_this4.state.itemHeight+'px',selected:item.value===_this4.props.value});}));}}]);return UseType;}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);var Container=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].ul(_templateObject);var Li=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].li(_templateObject2,function(_ref){var width=_ref.width;return width?'max-width: '+width+';':'max-width: 320px;';},function(_ref2){var height=_ref2.height;return height?'min-height: '+height+';':'min-height: 266px;';},function(_ref3){var bgColor=_ref3.bgColor;return bgColor;},function(_ref4){var bgColor=_ref4.bgColor;return bgColor;},function(_ref5){var bgColor=_ref5.bgColor;return bgColor;});var TextWrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject3);var Box=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject4,function(_ref6){var active=_ref6.active,bgColor=_ref6.bgColor;if(active){return'\n        &:before {\n          top: -2px;\n          left: -2px;\n          right: -2px;\n          bottom: -2px;\n          background-image: '+bgColor+';\n          z-index: -2;\n        }\n        &:after {\n          top: 0;\n          left: 0;\n          bottom: 0;\n          right: 0;\n          background: #FFFFFF;\n          z-index: -1;\n        }\n      ';}else{return'\n      &:before {\n        top: -1px;\n        left: -1px;\n        right: -1px;\n        bottom: -1px;\n        background: #DEDEDE;\n        z-index: -2;\n      }\n      &:after {\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        background: #FFFFFF;\n        z-index: -1;\n      }\n      ';}});var CheckMask=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject5);var CheckWrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject6,function(_ref7){var active=_ref7.active,bgColor=_ref7.bgColor;if(active){return'\n        &:before {\n          top: -2px;\n          left: -2px;\n          right: -2px;\n          bottom: -2px;\n          background: '+bgColor+';\n          z-index: -2;\n        }\n        &:after {\n          top: 0;\n          left: 0;\n          bottom: 0;\n          right: 0;\n          background: #F9F9F9;\n          z-index: -1;\n        }\n      ';}else{return'\n        &:before {\n          top: -1px;\n          left: -1px;\n          right: -1px;\n          bottom: -1px;\n          background: #DEDEDE;\n          z-index: -2;\n        }\n        &:after {\n          top: 0;\n          left: 0;\n          bottom: 0;\n          right: 0;\n          background: #F9F9F9;\n          z-index: -1;\n        }\n      ';}});var Input=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].input.attrs({type:'radio'})(_templateObject7,function(_ref8){var bgColor=_ref8.bgColor;return bgColor;},function(_ref9){var bgColor=_ref9.bgColor;return bgColor;},function(_ref10){var bgColor=_ref10.bgColor;return bgColor;});var Check=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject8,function(_ref11){var active=_ref11.active,bgColor=_ref11.bgColor;if(active){return'\n        background: '+bgColor+';\n      ';}else{return'\n        background-color: #FFFFFF;\n      ';}});var StyledLabel=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_8_components_Label__["a" /* default */])(_templateObject9);var StyledLabelSecondary=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_8_components_Label__["a" /* default */])(_templateObject10);var StyledParagraph=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_9_components_Paragraph__["a" /* default */])(_templateObject11);

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_kea__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_kea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_kea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_containers_App_logic__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_validations__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_omit__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_find__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_first__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_first___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_first__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_forEach__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_electricityplusgas_component_svg__ = __webpack_require__(1656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_electricityplusgas_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__images_electricityplusgas_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_electricity_component_svg__ = __webpack_require__(1655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_electricity_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__images_electricity_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_gas_component_svg__ = __webpack_require__(1657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_gas_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__images_gas_component_svg__);
var DISTRICTS_ENDPOINT=__WEBPACK_IMPORTED_MODULE_3_config__["b" /* API_BASE_URL */]+'/public/district/';var CITIES_ENDPOINT=__WEBPACK_IMPORTED_MODULE_3_config__["b" /* API_BASE_URL */]+'/public/municipality/';var ENTEPRISE_START=__WEBPACK_IMPORTED_MODULE_3_config__["b" /* API_BASE_URL */]+'/public/simulator/enterprise_start/';var fields={offerType:[__WEBPACK_IMPORTED_MODULE_10_validations__["a" /* Validations */].isUndefined],cae:[__WEBPACK_IMPORTED_MODULE_10_validations__["a" /* Validations */].isNull],work_hours:[__WEBPACK_IMPORTED_MODULE_10_validations__["a" /* Validations */].isNull],district:[__WEBPACK_IMPORTED_MODULE_10_validations__["a" /* Validations */].isUndefined],municipality:[__WEBPACK_IMPORTED_MODULE_10_validations__["a" /* Validations */].isUndefined]/* eslint-disable camelcase */};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_kea__["kea"])({path:function path(){return['scenes','company-profile'];},actions:function actions(){return{setDistricts:function setDistricts(districts){return{districts:districts};},setData:function setData(data){return{data:data};},setCities:function setCities(cities){return{cities:cities};},setCurrentLocation:function setCurrentLocation(currentLocation){return{currentLocation:currentLocation};},setInvalid:function setInvalid(invalid){return{invalid:invalid};},setCae:function setCae(cae){return{cae:cae};},removeCities:function removeCities(cities){return{cities:cities};},fetchDistricts:function fetchDistricts(limit){return{limit:limit};},fetchCities:function fetchCities(district){return{district:district};},fetchData:function fetchData(){return{};},changeLoading:function changeLoading(){return{};},setDataFetchError:function setDataFetchError(fetchDataError){return{fetchDataError:fetchDataError};},setDistrictsFetchError:function setDistrictsFetchError(fetchDistrictError){return{fetchDistrictError:fetchDistrictError};},setCitiesFetchError:function setCitiesFetchError(fetchCitiesError){return{fetchCitiesError:fetchCitiesError};}};},reducers:function reducers(_ref){var _ref4,_ref8;var actions=_ref.actions;return{currentLocalization:[null,__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.setCurrentLocation,function(state,payload){return payload.currentLocation;})],districts:[[],__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.setDistricts,function(state,payload){return[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(payload.districts));})],cities:[[],__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array,(_ref4={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref4,actions.setCities,function(state,payload){return[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(payload.cities));}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref4,actions.removeCities,function(state,payload){return __WEBPACK_IMPORTED_MODULE_11_lodash_omit___default()(state,payload.cities);}),_ref4)],data:[{},__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.setData,function(state,payload){return Object.assign({},payload.data);})],cae:[{},__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.setCae,function(state,payload){return payload.cae.cae;})],fields:[fields,__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,{}],invalid:[{},__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.setInvalid,function(_,payload){return payload.invalid;})],loading:[true,__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,(_ref8={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref8,actions.changeLoading,function(){return true;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref8,actions.fetchData,function(){return true;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref8,actions.fetchDistricts,function(){return true;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref8,actions.setDistricts,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref8,actions.setData,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref8,actions.setDataFetchError,function(){return false;}),_ref8)]};},selectors:function selectors(_ref9){var _selectors=_ref9.selectors;return{selectedCae:[function(){return[_selectors.data,_selectors.cae];},function(data,cae){return data&&data.caes&&data.caes.find(function(_ref10){var value=_ref10.value;return value===cae;});}]};},takeLatest:function takeLatest(_ref11){var _ref12;var actions=_ref11.actions,workers=_ref11.workers;return _ref12={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref12,actions.fetchDistricts,workers.fetchDistricts),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref12,actions.setDistricts,workers.setFromLocation),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref12,actions.setCities,workers.setMunicipalityFromLocation),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref12,actions.setCurrentLocation,workers.setFromLocation),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref12,actions.setDistrict,workers.fetchCities),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref12,actions.fetchCities,workers.fetchCities),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref12,actions.fetchData,workers.fetchData),_ref12;},start:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function start(){var _actions,fetchDistricts,fetchData,_ref13,simulationFinished,values;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function start$(_context){while(1){switch(_context.prev=_context.next){case 0:_actions=this.actions,fetchDistricts=_actions.fetchDistricts,fetchData=_actions.fetchData;_context.next=3;return __WEBPACK_IMPORTED_MODULE_9_containers_App_logic__["a" /* default */].get('finished');case 3:_ref13=_context.sent;simulationFinished=_ref13.simulationFinished;_context.next=7;return __WEBPACK_IMPORTED_MODULE_9_containers_App_logic__["a" /* default */].get('values');case 7:values=_context.sent;if(!(simulationFinished||!values.simulationCode)){_context.next=13;break;}_context.next=11;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(fetchDistricts(100));case 11:_context.next=13;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(fetchData());case 13:case'end':return _context.stop();}}},start,this);}),workers:{/**
     * Fetches the needed data
     * @param {*} action
     */fetchData:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchData(action){var _actions2,setData,setDataFetchError,setValues,_ref14,simulationFinished,settings,params,data,caes,enterpriseProfiles,offerTypes,simulationCode,defaultValues;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchData$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_actions2=this.actions,setData=_actions2.setData,setDataFetchError=_actions2.setDataFetchError,setValues=_actions2.setValues;_context2.next=3;return __WEBPACK_IMPORTED_MODULE_9_containers_App_logic__["a" /* default */].get('finished');case 3:_ref14=_context2.sent;simulationFinished=_ref14.simulationFinished;_context2.next=7;return __WEBPACK_IMPORTED_MODULE_9_containers_App_logic__["a" /* default */].get('settings');case 7:settings=_context2.sent;params={format:'json',type:__WEBPACK_IMPORTED_MODULE_3_config__["o" /* isSimple */]?'s':__WEBPACK_IMPORTED_MODULE_3_config__["p" /* isAdvanced */]?'a':'e'};_context2.prev=9;_context2.next=12;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_8_axios___default.a.post,ENTEPRISE_START,params);case 12:data=_context2.sent;caes=data.data&&data.data.caes.map(function(_ref15){var id=_ref15.id,name=_ref15.name,type=_ref15.type,code=_ref15.code;return{label:code+' - '+name,value:id,type:type};});enterpriseProfiles=data.data&&data.data.enterprise_profiles.sort(function(a,b){return a.order-b.order;}).map(function(_ref16){var id=_ref16.id,name=_ref16.name,description=_ref16.description;return{text:name,value:id,description:description};});offerTypes=data.data&&data.data.offer_types.sort(function(a,b){return a.order-b.order;}).map(function(_ref17){var id=_ref17.id,slug=_ref17.slug,name=_ref17.name;var icon=void 0;switch(slug){case'e':icon=__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__images_electricity_component_svg___default.a,null);break;case'g':icon=__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__images_gas_component_svg___default.a,null);break;case'eg':icon=__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__images_electricityplusgas_component_svg___default.a,null);break;default:icon=__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__images_electricity_component_svg___default.a,null);}return{text:(name+'').replace(' + ','<br />+<br />'),value:id,icon:icon,id:id,slug:slug};});// Set the default values after getting the data
simulationCode=data.data.simulation_code;defaultValues={};if(!simulationFinished&&!settings.isFromProfile){defaultValues={simulationCode:simulationCode,offerType:__WEBPACK_IMPORTED_MODULE_12_lodash_find___default()(offerTypes,function(_ref18){var slug=_ref18.slug;return slug==='eg';}).id,cae:null,enterprise_profile:__WEBPACK_IMPORTED_MODULE_13_lodash_first___default()(enterpriseProfiles).value};}else{// Reset simulation code
defaultValues={simulationCode:simulationCode};}_context2.next=21;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setValues(defaultValues));case 21:_context2.next=23;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setData({caes:caes,offerTypes:offerTypes,enterpriseProfiles:enterpriseProfiles}));case 23:_context2.next=29;break;case 25:_context2.prev=25;_context2.t0=_context2['catch'](9);_context2.next=29;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setDataFetchError(_context2.t0));case 29:case'end':return _context2.stop();}}},fetchData,this,[[9,25]]);}),/**
     * Fetchs all Districts
     * @param {*} action
     */fetchDistricts:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchDistricts(action){var limit,_actions3,setDistricts,setDistrictsFetchError,params,districts,filteredDistricts;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchDistricts$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:limit=action.payload.limit;_actions3=this.actions,setDistricts=_actions3.setDistricts,setDistrictsFetchError=_actions3.setDistrictsFetchError;params={limit:limit,format:'json'};_context3.prev=3;_context3.next=6;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_8_axios___default.a.get,DISTRICTS_ENDPOINT,{params:params});case 6:districts=_context3.sent;filteredDistricts=districts.data.results.map(function(_ref19){var id=_ref19.id,name=_ref19.name;return{label:name,value:id};});_context3.next=10;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setDistricts(filteredDistricts));case 10:_context3.next=16;break;case 12:_context3.prev=12;_context3.t0=_context3['catch'](3);_context3.next=16;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setDistrictsFetchError(_context3.t0));case 16:case'end':return _context3.stop();}}},fetchDistricts,this,[[3,12]]);}),/**
     * Fetches all municipalities from a district
     * @param {*} action
     */fetchCities:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchCities(action){var district,_actions4,setCities,setCitiesFetchError,params,cities,results;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchCities$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:district=action.payload.district;_actions4=this.actions,setCities=_actions4.setCities,setCitiesFetchError=_actions4.setCitiesFetchError;params={limit:1000,format:'json',district:district};_context4.prev=3;_context4.next=6;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_8_axios___default.a.get,CITIES_ENDPOINT,{params:params});case 6:cities=_context4.sent;results=cities.data.results;results=results.map(function(_ref20){var id=_ref20.id,name=_ref20.name,district=_ref20.district;return{value:id,label:name,district:district.id};});_context4.next=11;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setCities(results));case 11:_context4.next=17;break;case 13:_context4.prev=13;_context4.t0=_context4['catch'](3);_context4.next=17;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setCitiesFetchError(_context4.t0));case 17:case'end':return _context4.stop();}}},fetchCities,this,[[3,13]]);}),setFromLocation:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function setFromLocation(){var setValues,districts,currentLocation,distrito;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setFromLocation$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:setValues=this.actions.setValues;_context5.next=3;return this.get('districts');case 3:districts=_context5.sent;_context5.next=6;return this.get('currentLocalization');case 6:currentLocation=_context5.sent;if(!(currentLocation&&!!currentLocation.length)){_context5.next=13;break;}distrito=null;__WEBPACK_IMPORTED_MODULE_14_lodash_forEach___default()(currentLocation,function(_ref21){var long_name=_ref21.long_name;var find=districts&&districts.find(function(_ref22){var label=_ref22.label;return label.toLowerCase()===long_name.toLowerCase();});if(find){distrito=find;return false;}});if(!distrito){_context5.next=13;break;}_context5.next=13;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setValues({district:distrito.value}));case 13:case'end':return _context5.stop();}}},setFromLocation,this);}),setMunicipalityFromLocation:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function setMunicipalityFromLocation(){var setValues,cities,currentLocation,cidade;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setMunicipalityFromLocation$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:setValues=this.actions.setValues;_context6.next=3;return this.get('cities');case 3:cities=_context6.sent;_context6.next=6;return this.get('currentLocalization');case 6:currentLocation=_context6.sent;cidade=null;if(!(currentLocation&&!!currentLocation.length)){_context6.next=14;break;}// Search First for administrative area level 2 and 3
__WEBPACK_IMPORTED_MODULE_14_lodash_forEach___default()(currentLocation,function(location){var find=cities&&cities.find(function(_ref23){var label=_ref23.label;return label.toLowerCase()===location.long_name.toLowerCase()&&(location.types[0]==='administrative_area_level_2'||location.types[0]==='administrative_area_level_3');});if(find){cidade=find;return false;}});// If search is empty search by the name
if(!cidade){__WEBPACK_IMPORTED_MODULE_14_lodash_forEach___default()(currentLocation,function(location){var find=cities&&cities.find(function(_ref24){var label=_ref24.label;return label.toLowerCase()===location.long_name.toLowerCase();});if(find){cidade=find;return false;}});}if(!cidade){_context6.next=14;break;}_context6.next=14;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setValues({municipality:cidade.value}));case 14:case'end':return _context6.stop();}}},setMunicipalityFromLocation,this);})},connect:{actions:[__WEBPACK_IMPORTED_MODULE_9_containers_App_logic__["a" /* default */],['setValue','setValues','setFinished','iframed']],props:[__WEBPACK_IMPORTED_MODULE_9_containers_App_logic__["a" /* default */],['values','finished','translations']]}}));

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FiltersSectionV2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logic__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_DropdownV2__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_GhostRadioV2__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_InputV2__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_MobileModalV2__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_search_component_svg__ = __webpack_require__(1658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_search_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_search_component_svg__);
var _class;var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: flex-start;\n  width: 100%;\n'],['\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: flex-start;\n  width: 100%;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 14px;\n  flex: 1 0 0;\n  padding: 16px 20px;\n  overflow-y: auto;\n'],['\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 14px;\n  flex: 1 0 0;\n  padding: 16px 20px;\n  overflow-y: auto;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 56px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n\n  h3 {\n    color: #1d1e22;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n    letter-spacing: 1px;\n    margin: 0;\n    text-transform: none;\n  }\n'],['\n  height: 56px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n\n  h3 {\n    color: #1d1e22;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n    letter-spacing: 1px;\n    margin: 0;\n    text-transform: none;\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n'],['\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  border: none;\n  outline: none;\n  background: transparent;\n\n  cursor: pointer;\n\n  color: #006736;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n\n  &:hover {\n    text-decoration: underline;\n  }\n'],['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  border: none;\n  outline: none;\n  background: transparent;\n\n  cursor: pointer;\n\n  color: #006736;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n\n  &:hover {\n    text-decoration: underline;\n  }\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n'],['\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  overflow-y: auto;\n\n  ','\n'],['\n  width: 100%;\n  overflow-y: auto;\n\n  ','\n']);var FiltersSectionV2=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__logic__["a" /* default */])(_class=function(_Component){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(FiltersSectionV2,_Component);function FiltersSectionV2(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,FiltersSectionV2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=FiltersSectionV2.__proto__||Object.getPrototypeOf(FiltersSectionV2)).call.apply(_ref,[this].concat(args))),_this),_this.handleScroll=function(event){var _this$props=_this.props,limit=_this$props.limit,offset=_this$props.offset,count=_this$props.count;var _this$actions=_this.actions,setEntitiesOffset=_this$actions.setEntitiesOffset,fetchEntities=_this$actions.fetchEntities;var _event$target=event.target,scrollTop=_event$target.scrollTop,scrollHeight=_event$target.scrollHeight,clientHeight=_event$target.clientHeight;if(scrollTop+clientHeight>=scrollHeight){if(offset+limit<count){setEntitiesOffset(offset+limit);fetchEntities();}}},_this.findFilterSection=function(section){return __WEBPACK_IMPORTED_MODULE_9__data__["a" /* default */].find(function(_ref2){var filterSection=_ref2.filterSection;return filterSection===section;});},_this.setFilterAndCheckIfFinishFlow=function(value,item,section){var filters=_this.props.filters;var newFilters=Object.assign({},filters);var filterSection=_this.findFilterSection(section);if(filterSection.type==='radio'&&value&&section!=='tariff_type'){filterSection.filters.forEach(function(filter){if(filter.fieldName===item.fieldName){newFilters[filter.fieldName]=true;}else{newFilters[filter.fieldName]=false;}});}else if(section==='entities'){if(newFilters.entity_designation){var ids=newFilters.entity_designation;var itemIndex=ids.indexOf(item.id);if(itemIndex!==-1){// Remove the item if it already exists
ids.splice(itemIndex,1);newFilters.entity_designation=ids;}else{// Add the item if it doesn't exist
newFilters.entity_designation=[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(newFilters.entity_designation),[item.id]);}}else{newFilters.entity_designation=[item.id];}}else{newFilters[item.fieldName]=value;}_this.actions.setFilter(newFilters);_this.props.changePage({currentPage:1});// Wait for redux to finsh doing stuff
setTimeout(function(){_this.actions.triggerFilter();},0);},_this.renderFilters=function(){var _this$props2=_this.props,stateFilters=_this$props2.filters,searchedEntitiesOptions=_this$props2.searchedEntitiesOptions,entitiesOptions=_this$props2.entitiesOptions,isMobile=_this$props2.isMobile,searchQuery=_this$props2.searchQuery,simulation=_this$props2.simulation;var searchEntity=_this.actions.searchEntity;return __WEBPACK_IMPORTED_MODULE_9__data__["a" /* default */]&&__WEBPACK_IMPORTED_MODULE_9__data__["a" /* default */].map(function(_ref3){var name=_ref3.name,hidden=_ref3.hidden,type=_ref3.type,filters=_ref3.filters,filterSection=_ref3.filterSection,search=_ref3.search,fillFromApi=_ref3.fillFromApi;if(hidden){return null;}if(filterSection==='tariff_type'&&(!simulation.results||!simulation.results.electricityPriceList)){return null;}var transformedName=name;if(type==='checkbox'){var activeFilters=0;filters.forEach(function(filter){if(stateFilters[filter.fieldName]){activeFilters++;}});transformedName=activeFilters?name+' ('+activeFilters+')':name;}var filterOptions=filters;if(fillFromApi&&filterSection==='entities'){filterOptions=entitiesOptions;if(searchQuery){filterOptions=searchedEntitiesOptions;}}var searchBox=void 0;if(search&&filterSection==='entities'){searchBox=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_InputV2__["a" /* default */],{labelStyle:{display:'unset'},style:{flexGrow:'1'},type:'text',placeholder:'Pesquisar por comercializador',icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__images_search_component_svg___default.a,null),onChange:function onChange(val){return searchEntity(val);}});}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_DropdownV2__["a" /* default */],{style:isMobile?{width:'100%'}:{maxWidth:'270px'},isOpen:isMobile?true:type!=='radio',title:transformedName,key:'filter_section_'+filterSection},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{style:{width:'100%'}},searchBox,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ScrollerBox,{fixedHeight:filterSection==='entities',innerRef:function innerRef(ref){return _this.scrollerBoxRef=ref;}},filterOptions.map(function(item){var selected=stateFilters[item.fieldName];if(filterSection==='entities'){selected=stateFilters[item.fieldName].includes(item.id);}else if(filterSection==='tariff_type'){selected=stateFilters[item.fieldName]===item.value;}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_GhostRadioV2__["a" /* default */],{key:'input_'+type+'_'+item.fieldName+'_'+item.label,type:type,name:item.fieldName,hasBorder:true,label:item.label,selected:selected,style:{minWidth:'20px'},onClick:function onClick(){var value=filterSection==='tariff_type'?item.value:!stateFilters[item.fieldName];_this.setFilterAndCheckIfFinishFlow(value,item,filterSection);},value:item.value});}))));});},_this.renderContent=function(){var isMobile=_this.props.isMobile;var resetFilters=_this.actions.resetFilters;return isMobile?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_MobileModalV2__["a" /* default */],{onClose:_this.props.onClose,border:true,title:'Filtros',setModalTriggerHeight:_this.props.setModalTriggerHeight,modalTriggerHeight:_this.props.modalTriggerHeight},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(MobileWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(MobileReset,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ResetBtn,{onClick:resetFilters},'Limpar Filtros')),_this.renderFilters())):__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Wrapper,_this.props,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TitleRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h3',null,'Filtros'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ResetBtn,{onClick:resetFilters},'Limpar Filtros')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(FiltersWrapper,null,_this.renderFilters()));},_temp),__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(FiltersSectionV2,[{key:'componentDidMount',value:function componentDidMount(){this.scrollerBoxRef.addEventListener('scroll',this.handleScroll);}},{key:'componentWillUnmount',value:function componentWillUnmount(){var isMobile=this.props.isMobile;if(!isMobile){this.actions.resetEntities();this.actions.setSearchQuery('');this.actions.setEntitiesCount(0);this.actions.setEntitiesOffset(0);}this.scrollerBoxRef.removeEventListener('scroll',this.handleScroll);}/**
   * Finds the filter section
   *//**
   * Adds the new filter to the state
   *//**
   * Renders the filters boxes based on the json data
   */},{key:'render',/** Lonely boy */value:function render(){return this.renderContent();}}]);return FiltersSectionV2;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]))||_class;var Wrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject);var MobileWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject2);var TitleRow=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject3);var MobileReset=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject4);var ResetBtn=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].button(_templateObject5);var FiltersWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject6);var ScrollerBox=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div.attrs({ref:function ref(props){return props.forwardedRef;}})(_templateObject7,function(_ref4){var fixedHeight=_ref4.fixedHeight;return fixedHeight&&'\n    height: 500px;\n\n    &::-webkit-scrollbar {\n      background-color: #fff;\n    }\n\n    &::-webkit-scrollbar-button {\n      display: none;\n    }\n\n    &::-webkit-scrollbar-track {\n      background: #fff;\n      border-radius: 7px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background-color: #e1e1e1;\n      border-radius: 7px;\n      border: 3px solid #fff;\n    }\n\n  ';});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_kea__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_kea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_kea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_saga__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_containers_App_logic__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_containers_SimpleHabitation_logic__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_containers_Filters_logic__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_omit__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_pick__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utils__ = __webpack_require__(11);
/** Redux and Kea *//** Contants */var SIMULATOR_SUGESTIONS_ENDPOINT=__WEBPACK_IMPORTED_MODULE_3_config__["b" /* API_BASE_URL */]+'/public/simulator/simulation_price_list_suggestion/';var PRICELIST_ENDPOINT=__WEBPACK_IMPORTED_MODULE_3_config__["b" /* API_BASE_URL */]+'/public/price-list/';var UPDATE_PRICES_ENDPOINT=__WEBPACK_IMPORTED_MODULE_3_config__["j" /* API_SIMULATION_URL */]+'/public/simulation/:code/';var SIMULATION_PROFILE_ENDPOINT=__WEBPACK_IMPORTED_MODULE_3_config__["b" /* API_BASE_URL */]+'/private/simulation-user-profile/';var ME_ENDPOINT=__WEBPACK_IMPORTED_MODULE_3_config__["b" /* API_BASE_URL */]+'/private/user-profile/me/';var AUTH_TOKEN_KEY='tokenauth';// Simulator url changes depending on the type of the simulator
var SIMULATOR_ENPOINT=__WEBPACK_IMPORTED_MODULE_3_config__["j" /* API_SIMULATION_URL */]+'/public/simulator/advanced/';if(__WEBPACK_IMPORTED_MODULE_3_config__["o" /* isSimple */]){SIMULATOR_ENPOINT=__WEBPACK_IMPORTED_MODULE_3_config__["j" /* API_SIMULATION_URL */]+'/public/simulator/simple/';}if(__WEBPACK_IMPORTED_MODULE_3_config__["k" /* isEnterprise */]){SIMULATOR_ENPOINT=__WEBPACK_IMPORTED_MODULE_3_config__["j" /* API_SIMULATION_URL */]+'/public/simulator/enterprise/';}var BILLING_DICT={dd:'direct_debit',mb:'atm_ctt',fe:'electronic_billing',fp:'paper_billing',ce:'electronic_contract'};var EXTRA_DICT={ge:'green_energy',rg:'is_regulated',as:'no_additional_services',hr:'has_refunds',me:'has_eletric_mobility'// const DURATION_DICT = {
//   no: 'no_contract_duration',
//   m6: 'contract_duration_6_months',
//   m12: 'contract_duration_12_months',
//   m24: 'contract_duration_24_months'
// }
};var convertArray=function convertArray(filters,key,dict){var obj={};filters[key].forEach(function(val){if(val!=='any'){obj[dict[val]]=true;}});return obj;};var convertBilling=function convertBilling(filters){return convertArray(filters,'billing',BILLING_DICT);};var convertExtra=function convertExtra(filters){return convertArray(filters,'extra',EXTRA_DICT);};var formatEquipmentsForRequest=function formatEquipmentsForRequest(equipments){return equipments&&equipments.map(function(_ref){var id=_ref.id,quantity=_ref.quantity,selectedClass=_ref.selectedClass,house_divisions=_ref.house_divisions;return{equipment:id,equipment_profile_consumption:selectedClass.id,division:house_divisions,// this is the division ID (kitchen, room, ...) of the selected equipment
quantity:quantity};});};var formatElectricityTableItems=function formatElectricityTableItems(item){return{start_date:__WEBPACK_IMPORTED_MODULE_6_moment___default()(item.startDate).format('YYYY-MM-DD'),end_date:__WEBPACK_IMPORTED_MODULE_6_moment___default()(item.endDate).format('YYYY-MM-DD'),s:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_utils__["j" /* validNumber */])(item.simples),f:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_utils__["j" /* validNumber */])(item.svazio),c:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_utils__["j" /* validNumber */])(item.cheias),p:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_utils__["j" /* validNumber */])(item.ponta)};};var formatGasTableItems=function formatGasTableItems(_ref2){var startDate=_ref2.startDate,endDate=_ref2.endDate,consumption=_ref2.consumption;return{start_date:__WEBPACK_IMPORTED_MODULE_6_moment___default()(startDate).format('YYYY-MM-DD'),end_date:__WEBPACK_IMPORTED_MODULE_6_moment___default()(endDate).format('YYYY-MM-DD'),consumption:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_utils__["j" /* validNumber */])(consumption)};};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_kea__["kea"])({path:function path(){return['scenes','results'];},connect:{actions:[__WEBPACK_IMPORTED_MODULE_10_containers_App_logic__["a" /* default */],['setValue','setValues','setFinished','setIsUserLoggedIn','iframed','changeSimulationData'],__WEBPACK_IMPORTED_MODULE_12_containers_Filters_logic__["a" /* default */],['triggerFilter']],props:[__WEBPACK_IMPORTED_MODULE_10_containers_App_logic__["a" /* default */],['values','translations','finished','settings'],__WEBPACK_IMPORTED_MODULE_11_containers_SimpleHabitation_logic__["default"],['currentEquipments'],__WEBPACK_IMPORTED_MODULE_12_containers_Filters_logic__["a" /* default */],['filters']]},actions:function actions(){return{makeSimulation:function makeSimulation(){return{};},setSimulationResults:function setSimulationResults(results){return{results:results};},setSimulationSugestions:function setSimulationSugestions(results){return Object.assign({},results);},changePage:function changePage(params){return{params:params};},setError:function setError(error){return Object.assign({},error);},toggleEditPricesModal:function toggleEditPricesModal(modalPrices){return{modalPrices:modalPrices};},toggleSaveProfileModal:function toggleSaveProfileModal(modalDetails){return{modalDetails:modalDetails};},saveProfile:function saveProfile(isNewFromUserWithProfiles){return{isNewFromUserWithProfiles:isNewFromUserWithProfiles};},updateProfile:function updateProfile(id,name){return{id:id,name:name};},editPrices:function editPrices(){return{};},setPrices:function setPrices(prices){return{prices:prices};},changePrices:function changePrices(type,field,value){return{type:type,field:field,value:value};},updatePrices:function updatePrices(){return{};},resetPrices:function resetPrices(){return{};},setUserProfile:function setUserProfile(profile){return{profile:profile};},openFiltering:function openFiltering(){return{};},closeFiltering:function closeFiltering(){return{};},search:function search(str){return{str:str};},filter:function filter(){return{};},order:function order(_order){return{order:_order};},fetchUserProfile:function fetchUserProfile(id,name){return{id:id,name:name};},fetchTariffInfo:function fetchTariffInfo(tariff){return{tariff:tariff};},setTariffInfo:function setTariffInfo(tariffInfo){return{tariffInfo:tariffInfo};},setFetchError:function setFetchError(message){return{message:message};},setFilters:function setFilters(filters){return{filters:filters};},reset:function reset(){return{};},getCurrentUser:function getCurrentUser(){return{};}};},reducers:function reducers(_ref3){var _ref4,_ref7,_ref8,_ref9,_ref10,_ref11,_ref12,_ref13,_ref14,_ref19;var actions=_ref3.actions;return{simulation:[{},__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,(_ref4={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref4,actions.setSimulationResults,function(_,payload){return Object.assign({},payload);}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref4,actions.reset,function(){return{};}),_ref4)],search:[null,__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.search,function(_,payload){return payload.str;})],ordering:['asc',__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.order,function(_,p){return p.order.value;})],sugestions:[{},__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,(_ref7={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.setSimulationSugestions,function(_,payload){return Object.assign({},payload);}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.reset,function(){return{};}),_ref7)],currentPage:[1,__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,(_ref8={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref8,actions.makeSimulation,function(){return 1;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref8,actions.changePage,function(_,payload){return payload.params.currentPage;}),_ref8)],simulating:[true,__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,(_ref9={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref9,actions.setSimulationResults,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref9,actions.makeSimulation,function(){return true;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref9,actions.setError,function(){return false;}),_ref9)],simulatingPatch:[false,__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,(_ref10={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref10,actions.setSimulationResults,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref10,actions.updatePrices,function(){return true;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref10,actions.setError,function(){return false;}),_ref10)],loadingSugested:[true,__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,(_ref11={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref11,actions.makeSimulation,function(){return true;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref11,actions.setSimulationSugestions,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref11,actions.setError,function(){return false;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref11,actions.changePage,function(){return true;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref11,actions.filter,function(){return true;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref11,actions.search,function(){return true;}),_ref11)],error:[false,__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,(_ref12={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref12,actions.setError,function(_,payload){return Object.assign({},payload.error);}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref12,actions.makeSimulation,function(){return false;}),_ref12)],filtering:[false,__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,(_ref13={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref13,actions.openFiltering,function(){return true;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref13,actions.closeFiltering,function(){return false;}),_ref13)],tariffInfo:[null,__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,(_ref14={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref14,actions.setTariffInfo,function(_,payload){return payload.tariffInfo;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref14,actions.reset,function(){return null;}),_ref14)],showSaveProfileModal:[{opened:false},__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.toggleSaveProfileModal,function(state,payload){return Object.assign({},state,payload.modalDetails);})],showEditPricesModal:[{opened:false},__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.toggleEditPricesModal,function(state,payload){return Object.assign({},state,payload.modalPrices);})],startFilters:[null,__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.setFilters,function(state,payload){return payload.filters;})],userProfile:[{},__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.setUserProfile,function(state,payload){return payload.profile;})],pricesForm:[{},__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,(_ref19={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref19,actions.setPrices,function(state,payload){return payload.prices;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref19,actions.changePrices,function(state,payload){var type=payload.type;// If no type: is a boolean toggle of field 'apply_refunds'
if(!type){return Object.assign({},state,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},payload.field,!state[payload.field]));}else{return Object.assign({},state,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},type,Object.assign({},state[type],__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},payload.field,payload.value))));}}),_ref19)]};},start:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function start(){var makeSimulation,_ref20,profileFinished;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function start$(_context){while(1){switch(_context.prev=_context.next){case 0:makeSimulation=this.actions.makeSimulation;_context.next=3;return __WEBPACK_IMPORTED_MODULE_10_containers_App_logic__["a" /* default */].get('finished');case 3:_ref20=_context.sent;profileFinished=_ref20.profileFinished;if(profileFinished){_context.next=9;break;}this.props&&this.props.router&&this.props.router.push('/');_context.next=11;break;case 9:_context.next=11;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(makeSimulation());case 11:case'end':return _context.stop();}}},start,this);}),takeLatest:function takeLatest(_ref21){var _ref22;var actions=_ref21.actions,workers=_ref21.workers;return _ref22={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref22,actions.makeSimulation,workers.makeSimulation),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref22,actions.setSimulationResults,workers.fetchSugestions),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref22,actions.changePage,workers.fetchSugestions),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref22,actions.search,workers.fetchSugestions),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref22,actions.filter,workers.fetchSugestions),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref22,actions.order,workers.fetchSugestions),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref22,actions.triggerFilter,workers.triggerFiltering),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref22,actions.fetchTariffInfo,workers.fetchTariffInfo),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref22,actions.saveProfile,workers.saveProfile),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref22,actions.updateProfile,workers.updateProfile),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref22,actions.editPrices,workers.editPrices),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref22,actions.updatePrices,workers.updatePrices),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref22,actions.getCurrentUser,workers.getCurrentUser),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref22,actions.getCurrentUser,workers.getCurrentUser),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref22,actions.fetchUserProfile,workers.fetchUserProfile),_ref22;},workers:{fetchTariffInfo:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function fetchTariffInfo(action){var id,_actions,setTariffInfo,setFetchError,info;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function fetchTariffInfo$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:id=action.payload.tariff.id;_actions=this.actions,setTariffInfo=_actions.setTariffInfo,setFetchError=_actions.setFetchError;_context2.prev=2;_context2.next=5;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get,''+PRICELIST_ENDPOINT+id+'/');case 5:info=_context2.sent;info.data.priceListObject=action.payload.tariff;_context2.next=9;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setTariffInfo(info.data));case 9:_context2.next=15;break;case 11:_context2.prev=11;_context2.t0=_context2['catch'](2);_context2.next=15;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setFetchError(_context2.t0));case 15:case'end':return _context2.stop();}}},fetchTariffInfo,this,[[2,11]]);}),makeSimulation:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function makeSimulation(){var _actions2,setSimulationResults,setError,setFinished,reset,updateProfile,setFilters,currentEquipments,settings,rawValues,offerType,values,equipments,_values,adults,children,elderly,response,data,urlParams,url,simulationErrorCode;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function makeSimulation$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;_actions2=this.actions,setSimulationResults=_actions2.setSimulationResults,setError=_actions2.setError,setFinished=_actions2.setFinished,reset=_actions2.reset,updateProfile=_actions2.updateProfile,setFilters=_actions2.setFilters;_context3.next=4;return __WEBPACK_IMPORTED_MODULE_11_containers_SimpleHabitation_logic__["default"].get('currentEquipments');case 4:currentEquipments=_context3.sent;_context3.next=7;return __WEBPACK_IMPORTED_MODULE_10_containers_App_logic__["a" /* default */].get('settings');case 7:settings=_context3.sent;_context3.next=10;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(reset());case 10:_context3.next=12;return __WEBPACK_IMPORTED_MODULE_10_containers_App_logic__["a" /* default */].get('values');case 12:rawValues=_context3.sent;_context3.next=15;return __WEBPACK_IMPORTED_MODULE_10_containers_App_logic__["a" /* default */].get('offerType');case 15:offerType=_context3.sent;values=Object.assign({},rawValues);equipments=values.equipments;if(currentEquipments&&currentEquipments.length){equipments=[];currentEquipments.forEach(function(item){var filterItems=equipments.filter(function(e){return e.id===item.data.id&&e.house_divisions===item.data.house_divisions;});if(filterItems.length){var findIndex=equipments.indexOf(filterItems[0]);equipments[findIndex].quantity+=item.data.quantity;}else{equipments.push(Object.assign({},item.data));}});}// Sum habitants
_values=values,adults=_values.adults,children=_values.children,elderly=_values.elderly;values.habitants=adults+children+elderly||0;// Format table date to request
if(values.electricityConsumptionsRegistration){values.electricityConsumptionsRegistration=[].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(values.electricityConsumptionsRegistration)).map(formatElectricityTableItems);}if(values.gasConsumptionsRegistration){values.gasConsumptionsRegistration=[].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(values.gasConsumptionsRegistration)).map(formatGasTableItems);}values.additionalData=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_utils__["a" /* csObjectToUnderscore */])(__WEBPACK_IMPORTED_MODULE_14_lodash_pick___default()(values,['key','equipments','adults','children','elderly','district']));// Convert to undescore and omit uneeded values
values=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_utils__["a" /* csObjectToUnderscore */])(__WEBPACK_IMPORTED_MODULE_13_lodash_omit___default()(values,['key','equipments','adults','children','elderly','district','first','open']));// Omit entity field based in offer type
if(offerType.slug===__WEBPACK_IMPORTED_MODULE_3_config__["m" /* ELECTRICITY_OFFER_TYPE */]){values=__WEBPACK_IMPORTED_MODULE_13_lodash_omit___default()(values,['gas_entity','gas_stage','gas_consumptions_registration']);}if(offerType.slug===__WEBPACK_IMPORTED_MODULE_3_config__["l" /* GAS_OFFER_TYPE */]){values=__WEBPACK_IMPORTED_MODULE_13_lodash_omit___default()(values,['electricity_entity','electricity_consumptions_registration']);}if(__WEBPACK_IMPORTED_MODULE_3_config__["k" /* isEnterprise */]){values.work_hours=__WEBPACK_IMPORTED_MODULE_13_lodash_omit___default()(values.work_hours,['id','name']);}// Format equipments
values.equipment=formatEquipmentsForRequest(equipments);if(values.hide_additional){_context3.next=32;break;}_context3.next=32;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setFilters({extra:['as']}));case 32:_context3.prev=32;_context3.next=35;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_4_axios___default.a.post,SIMULATOR_ENPOINT,Object.assign({},values));case 35:response=_context3.sent;data=response.data;_context3.next=39;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setFinished({simulationFinished:true,simulationError:false}));case 39:_context3.next=41;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setSimulationResults(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_utils__["c" /* csObjectFromUnderscore */])(data)));case 41:urlParams=new URLSearchParams(window.location.search);urlParams.set('code',data.code);url=urlParams.toString();window.history.pushState('','','?'+url+window.location.hash);// If is from a profile already loaded
// Save the profile and open the modal
_context3.next=47;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_saga__["delay"])(800);case 47:if(!settings.isFromProfile){_context3.next=50;break;}_context3.next=50;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(updateProfile(settings.isFromProfile));case 50:if(window.dataLayer){window.dataLayer.push({event:'optimize.activate.results'});}_context3.next=62;break;case 53:_context3.prev=53;_context3.t0=_context3['catch'](32);console.log(_context3.t0);simulationErrorCode='error';if(typeof _context3.t0.response.data.indexOf==='function'){if(_context3.t0.response.data.indexOf('Electric Price List is Empty')!==-1){simulationErrorCode='electric';}else if(_context3.t0.response.data.indexOf('Gas Price List is Empty')!==-1){simulationErrorCode='gas';}else if(_context3.t0.response.data.indexOf('Electronic Consumption Registration : Date Colisions, the start_date of an entry must be higher or equal to the previous end_date')!==-1){simulationErrorCode='electric_registration';}else if(_context3.t0.response.data.indexOf('Gas Consumption Registration : Date Colisions, the start_date of an entry must be higher or equal to the previous end_date')!==-1){simulationErrorCode='gas_registration';}}_context3.next=60;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setFinished({simulationFinished:true,simulationError:true,simulationErrorCode:simulationErrorCode}));case 60:_context3.next=62;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setError(_context3.t0));case 62:_context3.next=66;break;case 64:_context3.prev=64;_context3.t1=_context3['catch'](0);case 66:case'end':return _context3.stop();}}},makeSimulation,this,[[0,64],[32,53]]);}),fetchSugestions:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function fetchSugestions(action){var _actions3,setSimulationSugestions,setError,_ref23,results,code,search,ordering,filters,values,actionsParams,order,params,url,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,v,_iteratorNormalCompletion2,_didIteratorError2,_iteratorError2,_iterator2,_step2,_v,response,data;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function fetchSugestions$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_actions3=this.actions,setSimulationSugestions=_actions3.setSimulationSugestions,setError=_actions3.setError;_context4.next=3;return this.get('simulation');case 3:_ref23=_context4.sent;results=_ref23.results;code=results.code;_context4.next=8;return this.get('search');case 8:search=_context4.sent;_context4.next=11;return this.get('ordering');case 11:ordering=_context4.sent;_context4.next=14;return __WEBPACK_IMPORTED_MODULE_12_containers_Filters_logic__["a" /* default */].get('filters');case 14:filters=_context4.sent;_context4.next=17;return __WEBPACK_IMPORTED_MODULE_10_containers_App_logic__["a" /* default */].get('values');case 17:values=_context4.sent;actionsParams=action.payload.params?action.payload.params:{};order='annual_billing';if(ordering!=='asc'){order='-annual_billing';}params=Object.assign({limit:10,ordering:order,is_active:true},actionsParams,filters);url=new URLSearchParams();url.set('offer_type',values.offerType);_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context4.prev=27;for(_iterator=filters.billing[Symbol.iterator]();!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){v=_step.value;url.append('billing[]',v);}_context4.next=35;break;case 31:_context4.prev=31;_context4.t0=_context4['catch'](27);_didIteratorError=true;_iteratorError=_context4.t0;case 35:_context4.prev=35;_context4.prev=36;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 38:_context4.prev=38;if(!_didIteratorError){_context4.next=41;break;}throw _iteratorError;case 41:return _context4.finish(38);case 42:return _context4.finish(35);case 43:_iteratorNormalCompletion2=true;_didIteratorError2=false;_iteratorError2=undefined;_context4.prev=46;for(_iterator2=filters.extra[Symbol.iterator]();!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){_v=_step2.value;url.append('extra[]',_v);}_context4.next=54;break;case 50:_context4.prev=50;_context4.t1=_context4['catch'](46);_didIteratorError2=true;_iteratorError2=_context4.t1;case 54:_context4.prev=54;_context4.prev=55;if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}case 57:_context4.prev=57;if(!_didIteratorError2){_context4.next=60;break;}throw _iteratorError2;case 60:return _context4.finish(57);case 61:return _context4.finish(54);case 62:url.set('no_contract_duration',filters.no_contract_duration);url.set('potencia_contratada',values.potencia_contratada);url.set('ciclo_horario',values.ciclo_horario);if(values.gas_stage){url.set('price_step',values.gas_stage);url.set('municipality',values.municipality);}if(search){params.entity_designation=search;}else{params=__WEBPACK_IMPORTED_MODULE_13_lodash_omit___default()(params,'entity_designation');}// Convert arrays to multi filters
if(params.billing){Object.assign(params,convertBilling(params));delete params.billing;}if(params.extra){Object.assign(params,convertExtra(params));delete params.extra;}// Caso o filtro: Sem Reembolsos esteja selecionado, o has_refunds não pode ir a true mas sim a false
// GET https://teste.poupaenergia.pt/d/api/v1/public/price-list/?has_refunds=false
if(params.has_refunds===true){params.has_refunds=false;}if(params.no_contract_duration){if(params.no_contract_duration==='any'){delete params.no_contract_duration;}}_context4.prev=71;_context4.next=74;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get,SIMULATOR_SUGESTIONS_ENDPOINT,{params:Object.assign({code:code},params)});case 74:response=_context4.sent;data=response.data;data.results=data.results.map(function(item){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_utils__["c" /* csObjectFromUnderscore */])(item);});data.results=data.results.map(function(item){var t=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_utils__["c" /* csObjectFromUnderscore */])(item.electricityPriceList||item.gasPriceList);url.set('id',t.id);return Object.assign({},item,{url:__WEBPACK_IMPORTED_MODULE_3_config__["g" /* PAGE_URL */]+'/tarifarios/?'+url.toString()});});_context4.next=80;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setSimulationSugestions(data));case 80:_context4.next=82;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_saga__["delay"])(600);case 82:if(window.dataLayer){window.dataLayer.push({event:'optimize.activate.results'});}_context4.next=91;break;case 85:_context4.prev=85;_context4.t2=_context4['catch'](71);_context4.next=89;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setError(_context4.t2));case 89:_context4.next=91;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setSimulationSugestions([]));case 91:case'end':return _context4.stop();}}},fetchSugestions,this,[[27,31,35,43],[36,,38,42],[46,50,54,62],[55,,57,61],[71,85]]);}),/**
     * Triggers fetching when filtering
     * @param {Object} action Caller action
     */triggerFiltering:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function triggerFiltering(action){var filter;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function triggerFiltering$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:filter=this.actions.filter;_context5.next=3;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_saga__["delay"])(100);case 3:_context5.next=5;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(filter());case 5:case'end':return _context5.stop();}}},triggerFiltering,this);}),/**
     * Saves the simulation profile to the user account
     * Flow: https://projects.invisionapp.com/d/main#/console/11390927/270514272/preview
     */saveProfile:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function saveProfile(action){var _actions4,toggleSaveProfileModal,setFetchError,userLoggedIn,simulation,isNewFromUserWithProfiles,modalDetails,requestProfiles,profiles,hasProfiles,nextHouseNumber,saveData,saveRequest,saved;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function saveProfile$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_actions4=this.actions,toggleSaveProfileModal=_actions4.toggleSaveProfileModal,setFetchError=_actions4.setFetchError;_context6.next=3;return __WEBPACK_IMPORTED_MODULE_10_containers_App_logic__["a" /* default */].get('userLoggedIn');case 3:userLoggedIn=_context6.sent;_context6.next=6;return this.get('simulation');case 6:simulation=_context6.sent;isNewFromUserWithProfiles=action.payload.isNewFromUserWithProfiles;modalDetails={loggedIn:!!userLoggedIn,opened:true};_context6.prev=9;if(!userLoggedIn){_context6.next=32;break;}_context6.next=13;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get,SIMULATION_PROFILE_ENDPOINT);case 13:requestProfiles=_context6.sent;profiles=requestProfiles.data.results;hasProfiles=!!profiles.length;modalDetails.profiles=profiles;modalDetails.hasProfiles=hasProfiles;// If user does not have profiles do save
if(!(!hasProfiles||isNewFromUserWithProfiles)){_context6.next=29;break;}nextHouseNumber=profiles.length+1;saveData={name:(__WEBPACK_IMPORTED_MODULE_3_config__["k" /* isEnterprise */]?'Empresa':'Casa')+' '+nextHouseNumber,simulation_history:simulation.results.code};_context6.next=23;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_4_axios___default.a.post,SIMULATION_PROFILE_ENDPOINT,saveData);case 23:saveRequest=_context6.sent;saved=saveRequest.data;modalDetails.saved=saved;modalDetails.type='saved';_context6.next=30;break;case 29:modalDetails.type='update';case 30:_context6.next=33;break;case 32:modalDetails.type='notlogged';case 33:_context6.next=35;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(toggleSaveProfileModal(modalDetails));case 35:_context6.next=41;break;case 37:_context6.prev=37;_context6.t0=_context6['catch'](9);_context6.next=41;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setFetchError(_context6.t0));case 41:case'end':return _context6.stop();}}},saveProfile,this,[[9,37]]);}),updateProfile:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function updateProfile(action){var _actions5,toggleSaveProfileModal,fetchUserProfile,id,name,simulation,url,request,saveRequest;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function updateProfile$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_actions5=this.actions,toggleSaveProfileModal=_actions5.toggleSaveProfileModal,fetchUserProfile=_actions5.fetchUserProfile;id=action.payload.id;name=action.payload.name;_context7.next=5;return this.get('simulation');case 5:simulation=_context7.sent;url=''+SIMULATION_PROFILE_ENDPOINT+id+'/';_context7.prev=7;request={simulation_history:simulation.results.code// If name exists update only the name
};if(name){request={name:name};}_context7.next=12;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_4_axios___default.a.patch,url,request);case 12:saveRequest=_context7.sent;_context7.next=15;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(toggleSaveProfileModal({opened:true,type:'updated',saved:saveRequest.data}));case 15:_context7.next=17;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(fetchUserProfile(id));case 17:_context7.next=21;break;case 19:_context7.prev=19;_context7.t0=_context7['catch'](7);case 21:case'end':return _context7.stop();}}},updateProfile,this,[[7,19]]);}),/**
     * If is simulation on user profile, get user house
     */fetchUserProfile:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function fetchUserProfile(action){var setUserProfile,id,url,request;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function fetchUserProfile$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:setUserProfile=this.actions.setUserProfile;id=action.payload.id;url=''+SIMULATION_PROFILE_ENDPOINT+id+'/';_context8.prev=3;_context8.next=6;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get,url);case 6:request=_context8.sent;_context8.next=9;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setUserProfile(request.data));case 9:_context8.next=14;break;case 11:_context8.prev=11;_context8.t0=_context8['catch'](3);console.log(_context8.t0);case 14:case'end':return _context8.stop();}}},fetchUserProfile,this,[[3,11]]);}),/**
     * Gets current user logged in
     */getCurrentUser:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function getCurrentUser(){var _actions6,setIsUserLoggedIn,saveProfile,token,me;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function getCurrentUser$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_actions6=this.actions,setIsUserLoggedIn=_actions6.setIsUserLoggedIn,saveProfile=_actions6.saveProfile;_context9.prev=1;token=window.localStorage.getItem(AUTH_TOKEN_KEY);if(token){_context9.next=7;break;}_context9.next=6;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setIsUserLoggedIn(false));case 6:return _context9.abrupt('return');case 7:_context9.next=9;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get,ME_ENDPOINT,{headers:{Authorization:'JWT '+token}});case 9:me=_context9.sent;_context9.next=12;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setIsUserLoggedIn(me.data));case 12:__WEBPACK_IMPORTED_MODULE_4_axios___default.a.defaults.headers.common['Authorization']='JWT '+token;_context9.next=15;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(saveProfile());case 15:_context9.next=23;break;case 17:_context9.prev=17;_context9.t0=_context9['catch'](1);_context9.next=21;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setIsUserLoggedIn(false));case 21:window.localStorage.removeItem(AUTH_TOKEN_KEY);delete __WEBPACK_IMPORTED_MODULE_4_axios___default.a.defaults.headers.common['Authorization'];case 23:case'end':return _context9.stop();}}},getCurrentUser,this,[[1,17]]);}),editPrices:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function editPrices(){var _actions7,setPrices,toggleEditPricesModal,simulationData,simulation,applyRefunds,pricesObject;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function editPrices$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_actions7=this.actions,setPrices=_actions7.setPrices,toggleEditPricesModal=_actions7.toggleEditPricesModal;_context10.next=3;return this.get('simulation');case 3:simulationData=_context10.sent;simulation=simulationData.results;applyRefunds=void 0;if(parseFloat(simulation.annualRefunds)!==0.0){applyRefunds=true;}else{applyRefunds=false;}pricesObject={};if(simulation){// IF simulation is dual
if(simulation.prices.electricity&&simulation.prices.gas){pricesObject={electricity_prices:Object.assign({},simulation.prices.electricity),gas_prices:Object.assign({},__WEBPACK_IMPORTED_MODULE_13_lodash_omit___default()(simulation.prices.gas,['distributor','escalao','stage'])),apply_refunds:applyRefunds,invalid:false};}// If simulation is just electricity
if(simulation.prices.electricity&&!simulation.prices.gas){pricesObject={electricity_prices:Object.assign({},simulation.prices.electricity),apply_refunds:applyRefunds,invalid:false};}// If simulation is just gas
if(!simulation.prices.electricity&&simulation.prices.gas){pricesObject={gas_prices:Object.assign({},__WEBPACK_IMPORTED_MODULE_13_lodash_omit___default()(simulation.prices.gas,['distributor','escalao','stage'])),apply_refunds:applyRefunds,invalid:false};}}_context10.next=11;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setPrices(pricesObject));case 11:_context10.next=13;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(toggleEditPricesModal({opened:true}));case 13:case'end':return _context10.stop();}}},editPrices,this);}),updatePrices:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function updatePrices(){var _actions8,setSimulationResults,toggleEditPricesModal,setError,form,simulationData,url,params,patch;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function updatePrices$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_actions8=this.actions,setSimulationResults=_actions8.setSimulationResults,toggleEditPricesModal=_actions8.toggleEditPricesModal,setError=_actions8.setError;_context11.next=3;return this.get('pricesForm');case 3:form=_context11.sent;_context11.next=6;return this.get('simulation');case 6:simulationData=_context11.sent;// Pass to a valid number to send to API
form.electricity_prices&&Object.keys(form.electricity_prices).forEach(function(key){form=Object.assign({},form,{electricity_prices:Object.assign({},form.electricity_prices,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},key,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_utils__["j" /* validNumber */])(form.electricity_prices[key])))});});form.gas_prices&&Object.keys(form.gas_prices).forEach(function(key){form=Object.assign({},form,{gas_prices:Object.assign({},form.gas_prices,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},key,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_utils__["j" /* validNumber */])(form.gas_prices[key])))});});url=UPDATE_PRICES_ENDPOINT.replace(':code',simulationData.results&&simulationData.results.code);_context11.prev=10;// Omit invalid
delete form.invalid;params=Object.assign({},form);_context11.next=15;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_4_axios___default.a.patch,url,params);case 15:patch=_context11.sent;_context11.next=18;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setSimulationResults(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_utils__["c" /* csObjectFromUnderscore */])(patch.data)));case 18:_context11.next=20;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(toggleEditPricesModal({opened:false}));case 20:_context11.next=27;break;case 22:_context11.prev=22;_context11.t0=_context11['catch'](10);_context11.next=26;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_saga_effects__["put"])(setError(_context11.t0));case 26:console.log(_context11.t0);case 27:case'end':return _context11.stop();}}},updatePrices,this,[[10,22]]);})}}));

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Tabs__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_TariffSubscribeForm__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Modal__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__logic__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_ic_aceitar_svg__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_ic_aceitar_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_ic_aceitar_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_ic_informacao_svg__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_ic_informacao_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_ic_informacao_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Loading__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__validations__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_mapValues__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_utils__ = __webpack_require__(11);
var _class;var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  > div:last-child {\n    height: 100%;\n\n    > div:first-child {\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      padding-bottom: 50px;\n    }\n  }\n'],['\n  > div:last-child {\n    height: 100%;\n\n    > div:first-child {\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      padding-bottom: 50px;\n    }\n  }\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  padding: 50px;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 87px;\n    height: 64px;\n    margin-bottom: 50px;\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  padding: 50px;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 87px;\n    height: 64px;\n    margin-bottom: 50px;\n  }\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #010101;\n  font-family: Nunito;\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 28px;\n  text-align: center;\n  margin-bottom: 16px;\n  text-transform: uppercase;\n'],['\n  color: #010101;\n  font-family: Nunito;\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 28px;\n  text-align: center;\n  margin-bottom: 16px;\n  text-transform: uppercase;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #010101;\n  font-family: Nunito;\n  font-size: 14px;\n  line-height: 20px;\n'],['\n  color: #010101;\n  font-family: Nunito;\n  font-size: 14px;\n  line-height: 20px;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #010101;\n  font-family: Nunito;\n  font-size: 19px;\n  line-height: 34px;\n  text-align: center;\n'],['\n  color: #010101;\n  font-family: Nunito;\n  font-size: 19px;\n  line-height: 34px;\n  text-align: center;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  overflow: auto;\n  padding-bottom: 100px;\n  height: initial;\n  bottom: 0;\n  text-align: initial;\n'],['\n  overflow: auto;\n  padding-bottom: 100px;\n  height: initial;\n  bottom: 0;\n  text-align: initial;\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding: 20px 0;\n'],['\n  padding: 20px 0;\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  font-weight: bold;\n  margin-bottom: 20px;\n  color: #8abb3f;\n'],['\n  display: block;\n  font-weight: bold;\n  margin-bottom: 20px;\n  color: #8abb3f;\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin-bottom: 10px;\n\n  ','\n'],['\n  margin-bottom: 10px;\n\n  ','\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 10px;\n  height: 10px;\n  background: linear-gradient(270deg, #006736 0%, #93c13e 100%);\n  display: inline-block;\n  border-radius: 50%;\n  margin-right: 10px;\n'],['\n  width: 10px;\n  height: 10px;\n  background: linear-gradient(270deg, #006736 0%, #93c13e 100%);\n  display: inline-block;\n  border-radius: 50%;\n  margin-right: 10px;\n']),_templateObject11=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 350px;\n'],['\n  height: 350px;\n']),_templateObject12=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  min-height: initial;\n'],['\n  min-height: initial;\n']),_templateObject13=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: relative;\n\n  .resp-sharing-button__link,\n  .resp-sharing-button__icon {\n    display: inline-block;\n  }\n\n  .resp-sharing-button__link {\n    text-decoration: none;\n    color: #fff;\n    margin: 0.5em;\n  }\n\n  .resp-sharing-button {\n    border-radius: 5px;\n    transition: 25ms ease-out;\n    padding: 0.5em 0.75em;\n    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;\n  }\n\n  .resp-sharing-button__icon svg {\n    width: 1em;\n    height: 1em;\n    margin-right: 0.4em;\n    vertical-align: top;\n  }\n\n  .resp-sharing-button--small svg {\n    margin: 0;\n    vertical-align: middle;\n  }\n\n  /* Non solid icons get a stroke */\n  .resp-sharing-button__icon {\n    stroke: #fff;\n    fill: none;\n  }\n\n  /* Solid icons get a fill */\n  .resp-sharing-button__icon--solid,\n  .resp-sharing-button__icon--solidcircle {\n    fill: #fff;\n    stroke: none;\n  }\n\n  .resp-sharing-button--twitter {\n    background-color: #55acee;\n  }\n\n  .resp-sharing-button--twitter:hover {\n    background-color: #2795e9;\n  }\n\n  .resp-sharing-button--pinterest {\n    background-color: #bd081c;\n  }\n\n  .resp-sharing-button--pinterest:hover {\n    background-color: #8c0615;\n  }\n\n  .resp-sharing-button--facebook {\n    background-color: #3b5998;\n  }\n\n  .resp-sharing-button--facebook:hover {\n    background-color: #2d4373;\n  }\n\n  .resp-sharing-button--tumblr {\n    background-color: #35465c;\n  }\n\n  .resp-sharing-button--tumblr:hover {\n    background-color: #222d3c;\n  }\n\n  .resp-sharing-button--reddit {\n    background-color: #5f99cf;\n  }\n\n  .resp-sharing-button--reddit:hover {\n    background-color: #3a80c1;\n  }\n\n  .resp-sharing-button--google {\n    background-color: #dd4b39;\n  }\n\n  .resp-sharing-button--google:hover {\n    background-color: #c23321;\n  }\n\n  .resp-sharing-button--linkedin {\n    background-color: #0077b5;\n  }\n\n  .resp-sharing-button--linkedin:hover {\n    background-color: #046293;\n  }\n\n  .resp-sharing-button--email {\n    background-color: #777;\n  }\n\n  .resp-sharing-button--email:hover {\n    background-color: #5e5e5e;\n  }\n\n  .resp-sharing-button--xing {\n    background-color: #1a7576;\n  }\n\n  .resp-sharing-button--xing:hover {\n    background-color: #114c4c;\n  }\n\n  .resp-sharing-button--whatsapp {\n    background-color: #25d366;\n  }\n\n  .resp-sharing-button--whatsapp:hover {\n    background-color: #1da851;\n  }\n\n  .resp-sharing-button--hackernews {\n    background-color: #ff6600;\n  }\n  .resp-sharing-button--hackernews:hover,\n  .resp-sharing-button--hackernews:focus {\n    background-color: #fb6200;\n  }\n\n  .resp-sharing-button--vk {\n    background-color: #507299;\n  }\n\n  .resp-sharing-button--vk:hover {\n    background-color: #43648c;\n  }\n\n  .resp-sharing-button--facebook {\n    background-color: #3b5998;\n    border-color: #3b5998;\n  }\n\n  .resp-sharing-button--facebook:hover,\n  .resp-sharing-button--facebook:active {\n    background-color: #2d4373;\n    border-color: #2d4373;\n  }\n\n  .resp-sharing-button--twitter {\n    background-color: #55acee;\n    border-color: #55acee;\n  }\n\n  .resp-sharing-button--twitter:hover,\n  .resp-sharing-button--twitter:active {\n    background-color: #2795e9;\n    border-color: #2795e9;\n  }\n\n  .resp-sharing-button--email {\n    background-color: #777777;\n    border-color: #777777;\n  }\n\n  .resp-sharing-button--email:hover,\n  .resp-sharing-button--email:active {\n    background-color: #5e5e5e;\n    border-color: #5e5e5e;\n  }\n\n  .resp-sharing-button--whatsapp {\n    background-color: #25d366;\n    border-color: #25d366;\n  }\n\n  .resp-sharing-button--whatsapp:hover,\n  .resp-sharing-button--whatsapp:active {\n    background-color: #1da851;\n    border-color: #1da851;\n  }\n\n  .sharebox-dialog {\n    display: none;\n    position: absolute;\n    left: 80px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  &:hover {\n    .sharebox-dialog {\n      display: block;\n    }\n\n    .sharebox-text {\n      opacity: 0;\n    }\n  }\n'],['\n  position: relative;\n\n  .resp-sharing-button__link,\n  .resp-sharing-button__icon {\n    display: inline-block;\n  }\n\n  .resp-sharing-button__link {\n    text-decoration: none;\n    color: #fff;\n    margin: 0.5em;\n  }\n\n  .resp-sharing-button {\n    border-radius: 5px;\n    transition: 25ms ease-out;\n    padding: 0.5em 0.75em;\n    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;\n  }\n\n  .resp-sharing-button__icon svg {\n    width: 1em;\n    height: 1em;\n    margin-right: 0.4em;\n    vertical-align: top;\n  }\n\n  .resp-sharing-button--small svg {\n    margin: 0;\n    vertical-align: middle;\n  }\n\n  /* Non solid icons get a stroke */\n  .resp-sharing-button__icon {\n    stroke: #fff;\n    fill: none;\n  }\n\n  /* Solid icons get a fill */\n  .resp-sharing-button__icon--solid,\n  .resp-sharing-button__icon--solidcircle {\n    fill: #fff;\n    stroke: none;\n  }\n\n  .resp-sharing-button--twitter {\n    background-color: #55acee;\n  }\n\n  .resp-sharing-button--twitter:hover {\n    background-color: #2795e9;\n  }\n\n  .resp-sharing-button--pinterest {\n    background-color: #bd081c;\n  }\n\n  .resp-sharing-button--pinterest:hover {\n    background-color: #8c0615;\n  }\n\n  .resp-sharing-button--facebook {\n    background-color: #3b5998;\n  }\n\n  .resp-sharing-button--facebook:hover {\n    background-color: #2d4373;\n  }\n\n  .resp-sharing-button--tumblr {\n    background-color: #35465c;\n  }\n\n  .resp-sharing-button--tumblr:hover {\n    background-color: #222d3c;\n  }\n\n  .resp-sharing-button--reddit {\n    background-color: #5f99cf;\n  }\n\n  .resp-sharing-button--reddit:hover {\n    background-color: #3a80c1;\n  }\n\n  .resp-sharing-button--google {\n    background-color: #dd4b39;\n  }\n\n  .resp-sharing-button--google:hover {\n    background-color: #c23321;\n  }\n\n  .resp-sharing-button--linkedin {\n    background-color: #0077b5;\n  }\n\n  .resp-sharing-button--linkedin:hover {\n    background-color: #046293;\n  }\n\n  .resp-sharing-button--email {\n    background-color: #777;\n  }\n\n  .resp-sharing-button--email:hover {\n    background-color: #5e5e5e;\n  }\n\n  .resp-sharing-button--xing {\n    background-color: #1a7576;\n  }\n\n  .resp-sharing-button--xing:hover {\n    background-color: #114c4c;\n  }\n\n  .resp-sharing-button--whatsapp {\n    background-color: #25d366;\n  }\n\n  .resp-sharing-button--whatsapp:hover {\n    background-color: #1da851;\n  }\n\n  .resp-sharing-button--hackernews {\n    background-color: #ff6600;\n  }\n  .resp-sharing-button--hackernews:hover,\n  .resp-sharing-button--hackernews:focus {\n    background-color: #fb6200;\n  }\n\n  .resp-sharing-button--vk {\n    background-color: #507299;\n  }\n\n  .resp-sharing-button--vk:hover {\n    background-color: #43648c;\n  }\n\n  .resp-sharing-button--facebook {\n    background-color: #3b5998;\n    border-color: #3b5998;\n  }\n\n  .resp-sharing-button--facebook:hover,\n  .resp-sharing-button--facebook:active {\n    background-color: #2d4373;\n    border-color: #2d4373;\n  }\n\n  .resp-sharing-button--twitter {\n    background-color: #55acee;\n    border-color: #55acee;\n  }\n\n  .resp-sharing-button--twitter:hover,\n  .resp-sharing-button--twitter:active {\n    background-color: #2795e9;\n    border-color: #2795e9;\n  }\n\n  .resp-sharing-button--email {\n    background-color: #777777;\n    border-color: #777777;\n  }\n\n  .resp-sharing-button--email:hover,\n  .resp-sharing-button--email:active {\n    background-color: #5e5e5e;\n    border-color: #5e5e5e;\n  }\n\n  .resp-sharing-button--whatsapp {\n    background-color: #25d366;\n    border-color: #25d366;\n  }\n\n  .resp-sharing-button--whatsapp:hover,\n  .resp-sharing-button--whatsapp:active {\n    background-color: #1da851;\n    border-color: #1da851;\n  }\n\n  .sharebox-dialog {\n    display: none;\n    position: absolute;\n    left: 80px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  &:hover {\n    .sharebox-dialog {\n      display: block;\n    }\n\n    .sharebox-text {\n      opacity: 0;\n    }\n  }\n']),_templateObject14=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);\n  background: #fff;\n  height: 60px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  .sharebox-icon {\n    width: 60px;\n    height: 60px;\n    background: linear-gradient(270deg, #006736 0%, #93c13e 100%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .sharebox-text {\n    padding: 0 24px;\n    flex: 1;\n    color: #010101;\n    font-family: Nunito;\n    font-size: 12px;\n    font-weight: bold;\n    letter-spacing: 0;\n    line-height: 16px;\n  }\n\n  .sharebox-carrot {\n    width: 60px;\n    height: 60px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n'],['\n  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);\n  background: #fff;\n  height: 60px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  .sharebox-icon {\n    width: 60px;\n    height: 60px;\n    background: linear-gradient(270deg, #006736 0%, #93c13e 100%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .sharebox-text {\n    padding: 0 24px;\n    flex: 1;\n    color: #010101;\n    font-family: Nunito;\n    font-size: 12px;\n    font-weight: bold;\n    letter-spacing: 0;\n    line-height: 16px;\n  }\n\n  .sharebox-carrot {\n    width: 60px;\n    height: 60px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n']);/* eslint-disable camelcase */var translateErrors={first_name:'Primeiro Nome',last_name:'Último Nome',tax_id:'NIF',email:'Email',phone_number:'Telefone / Telemóvel',company_phone_number:'Telefone / Telemóvel Contacto',company_name:'Nome da empresa',company_cae:'CAE da empresa',company_email:'Email empresa',legal_bi:'BI/CC do Representante legal',street:'Rua',door:'Nº da porta',floor:'Andar',postal_code:'Código postal',billing_address:'Morada de faturação',billing_street:'Rua de faturação',billing_door:'Nº da porta de faturação',billing_floor:'Andar de faturação',billing_postal_code:'Código postal de faturação',cpe:'CPE',cui:'CUI',cuicpe:['CUI','CPE']};var TariffSubscribeModal=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__logic__["a" /* default */])(_class=function(_Component){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(TariffSubscribeModal,_Component);function TariffSubscribeModal(){__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,TariffSubscribeModal);var _this=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(TariffSubscribeModal.__proto__||Object.getPrototypeOf(TariffSubscribeModal)).call(this));_this.isFormValid=function(validations){var key=Object.keys(validations)[0];var list=validations[key];var formBase=_this.props.formData[key];var invalid=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},key,{});__WEBPACK_IMPORTED_MODULE_16_lodash_mapValues___default()(list,function(funcs,valueKey){for(var index=0;index<funcs.length;index++){var func=funcs[index];var doFirst=true;if(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_lodash__["isArray"])(func)){func=func[0];doFirst=false;if(!func(formBase[valueKey].value,formBase)){break;}}if(doFirst){if(formBase[valueKey]){var _func=func(formBase[valueKey].value,formBase),result=_func.result,message=_func.message;if(!result){invalid[key][valueKey]=message;break;}}}}});if(_this.props.tariffInfo&&key==='personal'){var _this$props$tariffInf=_this.props.tariffInfo.entity,subscription_requires_email=_this$props$tariffInf.subscription_requires_email,subscription_requires_phone=_this$props$tariffInf.subscription_requires_phone;var emailKey='email';var phoneKey='phone';if(__WEBPACK_IMPORTED_MODULE_18_config__["k" /* isEnterprise */]){emailKey='companyEmail';phoneKey='companyPhoneNumber';}if(!subscription_requires_email&&!subscription_requires_phone){var phone=_this.props.formData.personal[phoneKey];var email=_this.props.formData.personal[emailKey];var emailVal=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__validations__["a" /* notEmptyEmail */])(email.value,phone.value);var phoneVal=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__validations__["b" /* notEmptyPhone */])(phone.value,email.value);if(!invalid.personal[phoneKey]&&!emailVal.result){invalid.personal[emailKey]=emailVal.message;}if(!invalid.personal[emailKey]&&!phoneVal.result){invalid.personal[phoneKey]=phoneVal.message;}}}return{valid:!Object.keys(invalid[key]).length,invalid:invalid};};_this.transformForm=function(form){if(!form){return false;}// mess
var personal=form.personal,billing=form.billing,electric=form.electric,gas=form.gas;var first_name=personal.name,last_name=personal.surname,tax_id=personal.nif,email=personal.email,phone_number=personal.phone,contact=personal.contact,companyName=personal.companyName,companyCae=personal.companyCae,companyPhoneNumber=personal.companyPhoneNumber,companyEmail=personal.companyEmail,legalBi=personal.legalBi;var street=billing.street,door=billing.door,floor=billing.floor,district=billing.district,municipality=billing.municipality,billingDoor=billing.billingDoor,billingFloor=billing.billingFloor,billingDistrict=billing.billingDistrict,billingMunicipality=billing.billingMunicipality,billingStreet=billing.billingStreet,directDebit=billing.directDebit,electronicBilling=billing.electronicBilling,billingAddress=billing.billingAddress;var cpe=electric.cpe,hired_power=electric.potency,time_cycle=electric.tariff,price_list_cycle=electric.cycle;var cui=gas.cui,price_step=gas.tier;var price_list=_this.props.tariffInfo.id;var gasFields={current_gas_entity:_this.props.tariffInfo.entity.id,cui:cui.value,price_step:price_step.value};var eletricityFields={current_electricity_entity:_this.props.tariffInfo.entity.id,hired_power:hired_power.value,cpe:cpe.value,time_cycle:time_cycle.value,price_list_cycle:price_list_cycle.value// Subscription source
};var subscription_source=void 0;if(__WEBPACK_IMPORTED_MODULE_18_config__["o" /* isSimple */]){subscription_source='simple_simulator';}if(_this.props.isHome){subscription_source='simple_simulator';}if(__WEBPACK_IMPORTED_MODULE_18_config__["p" /* isAdvanced */]){subscription_source='advanced_simulator';}if(__WEBPACK_IMPORTED_MODULE_18_config__["k" /* isEnterprise */]){subscription_source='enterprise_simulator';}var priceListId=_this.props.tariffInfo.priceListObject.priceListId;// Set the personal object to the correct one based on simulator
var personalObj={};var isEleContract=!!(_this.props.tariffInfo&&_this.props.tariffInfo.pricelistadditionalinfo.electronic_contract);if(__WEBPACK_IMPORTED_MODULE_18_config__["k" /* isEnterprise */]){personalObj={first_name:first_name.value,last_name:last_name.value,tax_id:tax_id.value,company_name:companyName.value,company_cae:companyCae.value,company_phone_number:companyPhoneNumber.value,company_email:companyEmail.value,legal_bi:legalBi.value,contact:contact.value,email:email.value,phone_number:phone_number.value};}else{personalObj={first_name:first_name.value,last_name:last_name.value,tax_id:tax_id.value,email:email.value,phone_number:phone_number.value,contact:contact.value};if(isEleContract){personalObj=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_lodash__["omit"])(personalObj,['tax_id','contact']);}}var obj=Object.assign({},personalObj,{street:street.value,door:door.value,floor:floor.value,billing_street:billingStreet.value,billing_door:billingDoor.value,billing_floor:billingFloor.value,billing_detail:''+(electronicBilling.value==='false'?'':electronicBilling.value)+(directDebit.value==='false'?'':directDebit.value),billing_address:billingAddress.value,billing_district:billingDistrict.value,billing_municipality:billingMunicipality.value,contract_summary:{},price_list:price_list,user:'',district:district.value,municipality:municipality.value,subscription_source:subscription_source,simulation_price_list:priceListId});if(_this.state.currentTariff.electricityPriceList){obj=Object.assign({},obj,eletricityFields);}if(_this.state.currentTariff.gasPriceList){obj=Object.assign({},obj,gasFields);}return obj;};_this.adhereActions=function(){var maxTabs=_this.state.tabs.length-1;var valid=true;var invalid=void 0;// if (this.state.currentTariff.electricityPriceList && this.state.currentTariff.gasPriceList) {
//   maxTabs = 4
// }
// if (isSimple) {
//   maxTabs = 2
// }
if(_this.state.index<=maxTabs){var validation=_this.isFormValid(_this.validations[_this.state.index]);valid=validation.valid;invalid=validation.invalid;}if(valid){_this.actions.recheckValids();if(_this.state.index<maxTabs){_this.tabChange(_this.state.index+1);}else{_this.actions.submitForm(_this.transformForm(_this.props.formData));}}else{_this.actions.setInvalid(invalid);}};_this.tabChange=function(index){var valid=true;var invalid=void 0;if(index>_this.state.index){var validation=_this.isFormValid(_this.validations[_this.state.index]);valid=validation.valid;invalid=validation.invalid;}if(valid){if(index===_this.state.tabs.length-1){_this.adhereButtons=[{label:'anterior',primary:false,click:function click(){return _this.state.index>0&&_this.tabChange(_this.state.index-1);},color:'#006736'},{label:'Aderir',primary:true,click:_this.adhereActions}];}else if(index===0){_this.adhereButtons=[{label:'seguinte',primary:true,click:_this.adhereActions}];}else{_this.adhereButtons=[{label:'anterior',primary:false,click:function click(){return _this.state.index>0&&_this.tabChange(_this.state.index-1);},color:'#006736'},{label:'seguinte',primary:true,click:_this.adhereActions}];}_this.setState({index:index});}else{_this.actions.setInvalid(invalid);}};_this.toggleModal=function(){var open=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;_this.setState({open:open},function(){return!_this.state.opened&&_this.actions.reset()&&_this.props.changeTariff(null);});};_this.toggleErrorModal=function(){_this.actions.setAdhesionError(null);};_this.hideDisclaimer=function(){_this.adhereButtons=[{label:'cancelar',primary:false,click:function click(){return _this.toggleModal();},color:'#006736'},{label:'seguinte',primary:true,click:_this.adhereActions}];_this.setState({showedDisclaimer:true});};_this.changeField=function(key,property,value){var section=Object.assign({},_this.props.formData[key]);var field=Object.assign({},section[property],{value:value});var data=Object.assign(_this.props.formData,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},key,Object.assign({},section,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},property,field))));if(property==='district'||property==='billingDistrict'){_this.actions.fetchMunicipalitiesTrigger(value,property);}_this.actions.setFormData(data);};_this.getPostal=function(_ref){var code=_ref.code,ext=_ref.ext,type=_ref.type;_this.actions.fetchPostalInfo(code,ext,type);};_this.state={index:0,currentTariff:null,open:false,errorOpened:true,showedDisclaimer:true,canSub:true};_this.adhereButtons=[{label:'cancelar',primary:false,click:function click(){return _this.toggleModal();},color:'#006736'},{label:'seguinte',primary:true,click:_this.adhereActions}];return _this;}__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(TariffSubscribeModal,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState({currentTariff:nextProps.tariff});if(nextProps.tariffInfo){var tariff=nextProps.tariff,_nextProps$values=nextProps.values,potencia_contratada=_nextProps$values.potencia_contratada,ciclo_tarifa=_nextProps$values.ciclo_tarifa,municipality=_nextProps$values.municipality,simulation=nextProps.simulation;var priceListTimeCycle=this.props.tariff.priceListTimeCycle;var _nextProps$tariffInfo=nextProps.tariffInfo.entity,subscription_requires_email=_nextProps$tariffInfo.subscription_requires_email,subscription_requires_phone=_nextProps$tariffInfo.subscription_requires_phone;var isEleContract=nextProps.tariffInfo.pricelistadditionalinfo.electronic_contract;isEleContract&&this.setState({tabs:['Dados Pessoais','Finalizar']});if(nextProps.firstSet&&isEleContract){if(tariff.suggested_electricity){if(potencia_contratada){this.changeField('electric','potency',potencia_contratada);}if(ciclo_tarifa){this.changeField('electric','cycle',ciclo_tarifa);}if(priceListTimeCycle){this.changeField('electric','tariff',priceListTimeCycle);}}if(simulation&&simulation.gasStage){this.changeField('gas','tier',simulation.gasStage);}if(municipality){this.changeField('billing','municipality',municipality);}var _detailsIndex=this.props.isHome?1:0;if(this.validations){delete this.validations[_detailsIndex].personal.nif;this.validations=this.validations.filter(function(val){return!Object.keys(val).find(function(k){return k==='billing'||k==='electric'||k==='gas';});});}this.actions.setFirstSet(false);}var detailsIndex=this.props.isHome?1:0;if(this.validations){var emailKey='email';var phoneKey='phone';var phone=this.validations[detailsIndex].personal[phoneKey];var email=this.validations[detailsIndex].personal[emailKey];if(subscription_requires_email&&!email.length){var _validations$detailsI;(_validations$detailsI=this.validations[detailsIndex].personal[emailKey]).push.apply(_validations$detailsI,[__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */],__WEBPACK_IMPORTED_MODULE_15__validations__["d" /* isEmail */]]);}if(subscription_requires_phone&&!phone.length){var _validations$detailsI2;(_validations$detailsI2=this.validations[detailsIndex].personal[phoneKey]).push.apply(_validations$detailsI2,[__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */],__WEBPACK_IMPORTED_MODULE_15__validations__["e" /* isPhone */]]);}}}}},{key:'componentWillMount',value:function componentWillMount(){var _this2=this;var _props=this.props,tariff=_props.tariff,_props$values=_props.values,potencia_contratada=_props$values.potencia_contratada,ciclo_tarifa=_props$values.ciclo_tarifa,cae=_props$values.cae,simulation=_props.simulation,tariffInfo=_props.tariffInfo,isHome=_props.isHome;var priceListTimeCycle=this.props.tariff.priceListTimeCycle;var gasOrEletricity=[];var eleSub=true;var gasSub=true;var isEleContract=!!tariffInfo&&tariffInfo.pricelistadditionalinfo.electronic_contract;if(tariff.electricityPriceList){var canSub=tariff.electricityPriceList.entity.can_subscribe;eleSub=canSub;}if(tariff.gasPriceList){var _canSub=tariff.gasPriceList.entity.can_subscribe;gasSub=_canSub;}if(!eleSub||!gasSub){this.adhereButtons=[{label:'Fechar',primary:true,click:function click(){return _this2.toggleModal();}}];this.setState({currentTariff:tariff,canSub:false,showedDisclaimer:true});}else{if(tariff.electricityPriceList){!isEleContract&&!__WEBPACK_IMPORTED_MODULE_18_config__["o" /* isSimple */]&&!isHome&&gasOrEletricity.push('Fornecimento Eletricidade');if(potencia_contratada){this.changeField('electric','potency',potencia_contratada);}if(ciclo_tarifa){this.changeField('electric','cycle',ciclo_tarifa);}if(priceListTimeCycle){this.changeField('electric','tariff',priceListTimeCycle);}}if(tariff.gasPriceList){!isEleContract&&!__WEBPACK_IMPORTED_MODULE_18_config__["o" /* isSimple */]&&!isHome&&gasOrEletricity.push('Fornecimento Gás Natural');if(simulation&&simulation.gasStage){this.changeField('gas','tier',simulation.gasStage);}}if(__WEBPACK_IMPORTED_MODULE_18_config__["k" /* isEnterprise */]){this.changeField('personal','companyCae',cae);}var billing=[];if(!isEleContract){billing.push('Morada');}var information=[];if(this.props.isHome){information.push('Informação geral');}var tabs=[].concat(information,[__WEBPACK_IMPORTED_MODULE_18_config__["k" /* isEnterprise */]?'Dados Empresariais':'Dados Pessoais'],billing,gasOrEletricity,['Finalizar']);var personalValidations={};if(__WEBPACK_IMPORTED_MODULE_18_config__["k" /* isEnterprise */]){personalValidations={name:[__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */]],surname:[__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */]],nif:[__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */],__WEBPACK_IMPORTED_MODULE_15__validations__["f" /* isNIF */]],email:[__WEBPACK_IMPORTED_MODULE_15__validations__["d" /* isEmail */]],phone:[__WEBPACK_IMPORTED_MODULE_15__validations__["e" /* isPhone */]],companyName:[__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */]],companyCae:[__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */]],companyPhoneNumber:[__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */]],companyEmail:[__WEBPACK_IMPORTED_MODULE_15__validations__["d" /* isEmail */]],legalBi:[__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */]],contact:[__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */]],contact_time:[[__WEBPACK_IMPORTED_MODULE_15__validations__["g" /* isContactPhone */]],__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */]]};}else{personalValidations={name:[__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */]],surname:[__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */]],nif:[__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */],__WEBPACK_IMPORTED_MODULE_15__validations__["f" /* isNIF */]],/*
           * these validations are added later now that
           * entities can control if email or phone are required
           */email:[],phone:[],contact:[__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */]],contact_time:[[__WEBPACK_IMPORTED_MODULE_15__validations__["g" /* isContactPhone */]],__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */]]};}if(isHome){this.validations=[{info:{}},{personal:personalValidations}];}else{this.validations=[{personal:personalValidations}];}if(!isEleContract){this.validations.push({billing:{postalCode:[__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */]],postalExtension:[__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */]],street:[__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */]],door:[__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */]],district:[__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */]],municipality:[__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */]],billingPostalCode:[[__WEBPACK_IMPORTED_MODULE_15__validations__["h" /* hasBillingAddress */]],__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */]],billingPostalExtension:[[__WEBPACK_IMPORTED_MODULE_15__validations__["h" /* hasBillingAddress */]],__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */]],billingStreet:[[__WEBPACK_IMPORTED_MODULE_15__validations__["h" /* hasBillingAddress */]],__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */]],billingDoor:[[__WEBPACK_IMPORTED_MODULE_15__validations__["h" /* hasBillingAddress */]],__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */]],billingDistrict:[[__WEBPACK_IMPORTED_MODULE_15__validations__["h" /* hasBillingAddress */]],__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */]],billingMunicipality:[[__WEBPACK_IMPORTED_MODULE_15__validations__["h" /* hasBillingAddress */]],__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */]]}});}if(isEleContract){var detailsIndex=this.props.isHome?1:0;delete this.validations[detailsIndex].personal.nif;}if(tariff.electricityPriceList&&!isEleContract&&!__WEBPACK_IMPORTED_MODULE_18_config__["o" /* isSimple */]&&!isHome){this.validations.push({electric:{cpe:[__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */],__WEBPACK_IMPORTED_MODULE_15__validations__["i" /* cepCui */]],potency:[__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */]],tariff:[__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */]],cycle:[__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */]]}});}if(tariff.gasPriceList&&!isEleContract&&!__WEBPACK_IMPORTED_MODULE_18_config__["o" /* isSimple */]&&!isHome){this.validations.push({gas:{cui:[__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */],__WEBPACK_IMPORTED_MODULE_15__validations__["i" /* cepCui */]],tier:[__WEBPACK_IMPORTED_MODULE_15__validations__["c" /* required */]]}});}this.validations.push({confirm:{allowDataSharing:[__WEBPACK_IMPORTED_MODULE_15__validations__["j" /* isChecked */]]}});this.setState({currentTariff:tariff,tabs:tabs});}if(this.props.isHome){this.changeField('electric','potency',parseFloat(this.props.tariff.calculatedHiredPowerFactor));this.changeField('gas','tier',parseFloat(this.props.tariff.gasStage));}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.setState({index:0,currentTariff:null});this.actions.setTariffInfo(null);}},{key:'errorsList',value:function errorsList(errors){return Object.keys(errors).map(function(key){var field=void 0;if(key==='cuicpe'){field=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{key:key},'Estes ',translateErrors[key][0],' e ',translateErrors[key][1],' aderiram a um tarif\xE1rio recentemente. Tem de aguardar 30 dias para efetuar uma nova ades\xE3o no Poupa Energia. Se tiver d\xFAvidas ligue-nos para o 211 160 500.');}else if(key==='cui'||key==='cpe'){field=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{key:key},'Este ',translateErrors[key],' aderiu a um tarif\xE1rio recentemente. Tem de aguardar 30 dias para efetuar uma nova ades\xE3o no Poupa Energia. Se tiver d\xFAvidas ligue-nos para o 211 160 500.');}else{field=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{key:key},'O campo ',translateErrors[key],' cont\xE9m erros.');}return field;});}},{key:'render',value:function render(){var _this3=this;if(this.props.adhesionResponse){this.adhereButtons=[{label:'fechar',primary:false,click:function click(){return _this3.toggleModal();},color:'#006736'}];}if(this.props.confirmationError){this.adhereButtons=[{label:'cancelar',primary:false,click:function click(){_this3.state.index>0&&_this3.tabChange(_this3.state.index);_this3.actions.setConfirmationError(false);},color:'#006736'},{label:'Aderir',primary:true,click:function click(){return _this3.actions.submitForm(_this3.transformForm(_this3.props.formData),{omitRepeated:true});}}];}var _props2=this.props,translations=_props2.translations,userProfile=_props2.userProfile;var _ref2=translations||{},SUCCESS_SUBSCRIPTION_EMAIL=_ref2.SUCCESS_SUBSCRIPTION_EMAIL,SUCCESS_SUBSCRIPTION_MERCHANT=_ref2.SUCCESS_SUBSCRIPTION_MERCHANT,CONFIRMATION_TIME_ERROR=_ref2.CONFIRMATION_TIME_ERROR,ESCLARECIMENTO_CUSTOS_ADICIONAIS=_ref2.ESCLARECIMENTO_CUSTOS_ADICIONAIS,ESCLARECIMENTO_CONTACTE=_ref2.ESCLARECIMENTO_CONTACTE,ESCLARECIMENTO_PONTO_4=_ref2.ESCLARECIMENTO_PONTO_4,ESCLARECIMENTO_PONTO_3=_ref2.ESCLARECIMENTO_PONTO_3,ESCLARECIMENTO_PONTO_2=_ref2.ESCLARECIMENTO_PONTO_2,ESCLARECIMENTO_PONTO_1=_ref2.ESCLARECIMENTO_PONTO_1,ESCLARECIMENTO_INDISPONIVEL=_ref2.ESCLARECIMENTO_INDISPONIVEL,COMO_FUNCIONA_TITLE=_ref2.COMO_FUNCIONA_TITLE,COMO_FUNCIONA_1=_ref2.COMO_FUNCIONA_1,COMO_FUNCIONA_2=_ref2.COMO_FUNCIONA_2,COMO_FUNCIONA_3=_ref2.COMO_FUNCIONA_3,SHARE_TEXT=_ref2.SHARE_TEXT;var designation=void 0;if(this.state.currentTariff&&this.state.currentTariff.c){designation=this.state.currentTariff.electricityPriceList.designation;}if(this.state.currentTariff&&this.state.currentTariff.gasPriceList){designation=this.state.currentTariff.gasPriceList.designation;}var shareText='';if(this.props.tariffInfo){shareText=SHARE_TEXT.replace('{TARIFARIO}',this.props.tariffInfo.designation);shareText=shareText.replace('{COMERCIALIZADOR}',this.props.tariffInfo.entity.designation);shareText=shareText.replace('{POUPANCA}',__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_utils__["i" /* unitCurrency */])(Number(Math.abs(this.props.tariff.annual_savings||this.props.tariff.annualSavings)).toFixed(0)));}return this.state.currentTariff&&this.state&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ScrollModal,{title:'ades\xE3o ao tarif\xE1rio:',subtitle:designation,toggle:this.state.open,onClick:this.toggleModal,custom:false,buttons:this.adhereButtons,closeOnBackground:false,side:function side(){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{style:{paddingLeft:40,paddingRight:40,color:'#fff'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_13__assets_ic_informacao_svg___default.a,style:{marginLeft:'auto',marginRight:'auto',display:'block'},alt:'Informações'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h2',{style:{textTransform:'uppercase',color:'#fff',marginTop:'15px'}},COMO_FUNCIONA_TITLE),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('ul',{style:{margin:0}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li',{style:{marginBottom:20}},COMO_FUNCIONA_1),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li',{style:{marginBottom:20}},COMO_FUNCIONA_2),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li',null,COMO_FUNCIONA_3)));}},!this.props.adhesionResponse&&!this.props.confirmationError&&this.state.showedDisclaimer&&this.state.canSub&&this.props.tariffInfo&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Tabs__["a" /* default */],{tabs:this.state.tabs,onClick:this.tabChange,hasProgress:true,currentIndex:this.state.index}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_TariffSubscribeForm__["a" /* default */],{isHome:this.props.isHome,userProfile:userProfile,postalInfo:this.props.postalInfo,getPostal:this.getPostal,municipality:this.props.municipality,index:this.state.index,tariff:this.props.tariff,fetchPostalInfo:this.actions.fetchPostalInfo,tariffInfo:this.props.tariffInfo,electricEntities:this.props.electricEntities,gasEntities:this.props.gasEntities,onChange:this.changeField,hasEletricity:this.props.tariff.electricityPriceList,hasGas:this.props.tariff.gasPriceList,numberOfTabs:this.state.tabs.length,formData:this.props.formData,filters:this.props.values,districts:this.props.districts,municipalities:this.props.municipalities,billingMunicipalities:this.props.billingMunicipalities,caes:this.props.data&&this.props.data.caes,loadingAddress:this.props.loadingAddress,addressNotFound:this.props.addressNotFound,isSimple:__WEBPACK_IMPORTED_MODULE_18_config__["o" /* isSimple */]||this.props.isHome})),this.props.adhesionResponse&&this.state.showedDisclaimer&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SuccessMessage,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img',{alt:'',src:__WEBPACK_IMPORTED_MODULE_12__assets_ic_aceitar_svg___default.a}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SuccessTitle,null,'Pr\xE9-ades\xE3o ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,this.props.adhesionResponse.code),' ','submetida com sucesso'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SuccessInfo,null,SUCCESS_SUBSCRIPTION_MERCHANT,!__WEBPACK_IMPORTED_MODULE_18_config__["k" /* isEnterprise */]&&this.props.formData.personal.email.value&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,SUCCESS_SUBSCRIPTION_EMAIL,' ',this.props.formData.personal.email.value),__WEBPACK_IMPORTED_MODULE_18_config__["k" /* isEnterprise */]&&this.props.formData.personal.companyEmail.value&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,SUCCESS_SUBSCRIPTION_EMAIL,' ',this.props.formData.personal.companyEmail.value)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ShareComponent,{style:{marginTop:'46px'},shareContent:shareText,shareUrl:'poupaenergia.pt',shareTitle:'Poupa Energia'})),this.props.confirmationError&&!this.props.adhesionResponse&&this.state.showedDisclaimer&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SuccessMessage,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ConfirmationError,null,CONFIRMATION_TIME_ERROR)),this.props.adhesionError&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ErrorModal,{title:'Aviso',toggle:this.state.errorOpened,onClick:this.toggleErrorModal,custom:false},this.props.adhesionError&&this.props.adhesionError.response.data&&!(typeof this.props.adhesionError.response.data==='string')&&this.errorsList(this.props.adhesionError.response.data),this.props.adhesionError&&this.props.adhesionError.response.data&&typeof this.props.adhesionError.response.data==='string'&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,'Ocorreu um erro')),!this.state.showedDisclaimer&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Disclaimer,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerTitle,null,'Esclarecimento'),this.props.tariffInfo&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__validations__["k" /* hasPaidServices */])(this.props.tariffInfo.additional_services)&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerText,{red:true},ESCLARECIMENTO_CUSTOS_ADICIONAIS),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerText,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ListBall,null),ESCLARECIMENTO_PONTO_1),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerText,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ListBall,null),ESCLARECIMENTO_PONTO_2),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerText,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ListBall,null),ESCLARECIMENTO_PONTO_3),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerText,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ListBall,null),ESCLARECIMENTO_PONTO_4),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerTitle,null,ESCLARECIMENTO_CONTACTE)),!this.state.canSub&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Disclaimer,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerTitle,null,'Esclarecimentos'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerText,null,ESCLARECIMENTO_INDISPONIVEL),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerTitle,null,ESCLARECIMENTO_CONTACTE)),!this.props.adhesionResponse&&this.state.showedDisclaimer&&this.state.canSub&&!this.props.tariffInfo&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Placeholder,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CenteredLoading,null)));}}]);return TariffSubscribeModal;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]))||_class;/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__logic__["a" /* default */])(TariffSubscribeModal));// {this.props.confirmationError &&
var ErrorModal=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_10_components_Modal__["a" /* default */])(_templateObject);var SuccessMessage=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject2);var SuccessTitle=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].h3(_templateObject3);var SuccessInfo=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject4);var ConfirmationError=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject5);var ScrollModal=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_10_components_Modal__["a" /* default */])(_templateObject6);var Disclaimer=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject7);var DisclaimerTitle=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject8);var DisclaimerText=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject9,function(_ref3){var red=_ref3.red;return red&&'\n  color: indianred;\n  ';});var ListBall=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject10);var Placeholder=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject11);var CenteredLoading=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_14_components_Loading__["a" /* default */])(_templateObject12);var ShareComponent=function ShareComponent(_ref4){var shareUrl=_ref4.shareUrl,shareContent=_ref4.shareContent,shareTitle=_ref4.shareTitle;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ShareBoxContainer,{style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ShareBox,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'sharebox-icon'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('svg',{width:24,height:26,viewBox:'0 0 24 26',xmlns:'http://www.w3.org/2000/svg'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('path',{d:'M19.333 23.44c-1.142 0-2.077-.918-2.077-2.04 0-.097.006-.186.024-.276a2.017 2.017 0 01.8-1.345 2.07 2.07 0 011.253-.42c1.143 0 2.078.918 2.078 2.041 0 1.122-.935 2.04-2.078 2.04m-14.666-8.4c-1.143 0-2.078-.918-2.078-2.04 0-1.123.935-2.04 2.078-2.04.47 0 .904.155 1.252.42.428.318.728.797.801 1.344.018.09.024.18.024.276 0 .096-.006.186-.024.276a2.016 2.016 0 01-.8 1.344 2.07 2.07 0 01-1.253.42M17.256 4.6c0-1.123.935-2.04 2.077-2.04 1.143 0 2.078.917 2.078 2.04 0 1.122-.935 2.04-2.078 2.04-.47 0-.904-.156-1.252-.42a2.016 2.016 0 01-.801-1.344 1.365 1.365 0 01-.024-.276m2.077 13.2a3.667 3.667 0 00-2.689 1.157l-8.482-4.859a3.624 3.624 0 000-2.196l8.482-4.86a3.666 3.666 0 002.69 1.158C21.355 8.2 23 6.586 23 4.6S21.356 1 19.333 1c-2.022 0-3.666 1.614-3.666 3.6 0 .384.06.75.17 1.098l-8.481 4.86A3.666 3.666 0 004.666 9.4C2.645 9.4 1 11.014 1 13c0 1.985 1.644 3.6 3.667 3.6a3.668 3.668 0 002.689-1.158l8.482 4.86c-.11.348-.171.714-.171 1.098 0 1.985 1.644 3.6 3.666 3.6C21.356 25 23 23.385 23 21.4c0-1.986-1.644-3.6-3.667-3.6',fill:'#FFF',fillRule:'nonzero',stroke:'#FFF',strokeWidth:0.6}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'sharebox-text'},'Partilhe a sua ades\xE3o e ajude os seus amigos a poupar!'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'sharebox-carrot'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('svg',{width:8,height:12,viewBox:'0 0 8 12',xmlns:'http://www.w3.org/2000/svg'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('path',{d:'M.337 9.78a1.333 1.333 0 001.993 1.772l5.333-4.666a1.333 1.333 0 000-1.772L2.33.448A1.333 1.333 0 00.337 2.219L4.883 6 .337 9.78z',fillRule:'nonzero',fill:'#010101',strokeWidth:0.2})))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'sharebox-dialog'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('a',{className:'resp-sharing-button__link',href:'https://facebook.com/sharer/sharer.php?u='+encodeURIComponent(shareUrl)+'&quote='+encodeURIComponent(shareContent),target:'_blank',rel:'noopener','aria-label':''},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'resp-sharing-button resp-sharing-button--facebook resp-sharing-button--small'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{'aria-hidden':'true',className:'resp-sharing-button__icon resp-sharing-button__icon--solidcircle'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',viewBox:'0 0 24 24'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('path',{d:'M12 0C5.38 0 0 5.38 0 12s5.38 12 12 12 12-5.38 12-12S18.62 0 12 0zm3.6 11.5h-2.1v7h-3v-7h-2v-2h2V8.34c0-1.1.35-2.82 2.65-2.82h2.35v2.3h-1.4c-.25 0-.6.13-.6.66V9.5h2.34l-.24 2z'}))))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('a',{className:'resp-sharing-button__link',href:'https://twitter.com/intent/tweet/?text='+encodeURIComponent(shareContent)+'&url='+encodeURIComponent(shareUrl),target:'_blank',rel:'noopener','aria-label':''},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'resp-sharing-button resp-sharing-button--twitter resp-sharing-button--small'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{'aria-hidden':'true',className:'resp-sharing-button__icon resp-sharing-button__icon--solidcircle'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',viewBox:'0 0 24 24'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('path',{d:'M12 0C5.38 0 0 5.38 0 12s5.38 12 12 12 12-5.38 12-12S18.62 0 12 0zm5.26 9.38v.34c0 3.48-2.64 7.5-7.48 7.5-1.48 0-2.87-.44-4.03-1.2 1.37.17 2.77-.2 3.9-1.08-1.16-.02-2.13-.78-2.46-1.83.38.1.8.07 1.17-.03-1.2-.24-2.1-1.3-2.1-2.58v-.05c.35.2.75.32 1.18.33-.7-.47-1.17-1.28-1.17-2.2 0-.47.13-.92.36-1.3C7.94 8.85 9.88 9.9 12.06 10c-.04-.2-.06-.4-.06-.6 0-1.46 1.18-2.63 2.63-2.63.76 0 1.44.3 1.92.82.6-.12 1.95-.27 1.95-.27-.35.53-.72 1.66-1.24 2.04z'}))))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('a',{className:'resp-sharing-button__link',href:'mailto:?subject='+encodeURIComponent(shareTitle)+'&body='+encodeURIComponent(shareContent+' '+shareUrl),target:'_self',rel:'noopener','aria-label':''},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'resp-sharing-button resp-sharing-button--email resp-sharing-button--small'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{'aria-hidden':'true',className:'resp-sharing-button__icon resp-sharing-button__icon--solidcircle'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',viewBox:'0 0 24 24'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('path',{d:'M12 0C5.38 0 0 5.38 0 12s5.38 12 12 12 12-5.38 12-12S18.62 0 12 0zm8 16c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v8z'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('path',{d:'M17.9 8.18c-.2-.2-.5-.24-.72-.07L12 12.38 6.82 8.1c-.22-.16-.53-.13-.7.08s-.15.53.06.7l3.62 2.97-3.57 2.23c-.23.14-.3.45-.15.7.1.14.25.22.42.22.1 0 .18-.02.27-.08l3.85-2.4 1.06.87c.1.04.2.1.32.1s.23-.06.32-.1l1.06-.9 3.86 2.4c.08.06.17.1.26.1.17 0 .33-.1.42-.25.15-.24.08-.55-.15-.7l-3.57-2.22 3.62-2.96c.2-.2.24-.5.07-.72z'}))))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('a',{className:'resp-sharing-button__link',href:'https://wa.me/?text='+encodeURIComponent(shareContent)+' '+encodeURIComponent(shareUrl),target:'_blank',rel:'noopener','aria-label':''},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'resp-sharing-button resp-sharing-button--whatsapp resp-sharing-button--small'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{'aria-hidden':'true',className:'resp-sharing-button__icon resp-sharing-button__icon--solidcircle'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',height:'24',width:'24',viewBox:'0 0 24 24'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('path',{d:'m12 0c-6.6 0-12 5.4-12 12s5.4 12 12 12 12-5.4 12-12-5.4-12-12-12zm0 3.8c2.2 0 4.2 0.9 5.7 2.4 1.6 1.5 2.4 3.6 2.5 5.7 0 4.5-3.6 8.1-8.1 8.1-1.4 0-2.7-0.4-3.9-1l-4.4 1.1 1.2-4.2c-0.8-1.2-1.1-2.6-1.1-4 0-4.5 3.6-8.1 8.1-8.1zm0.1 1.5c-3.7 0-6.7 3-6.7 6.7 0 1.3 0.3 2.5 1 3.6l0.1 0.3-0.7 2.4 2.5-0.7 0.3 0.099c1 0.7 2.2 1 3.4 1 3.7 0 6.8-3 6.9-6.6 0-1.8-0.7-3.5-2-4.8s-3-2-4.8-2zm-3 2.9h0.4c0.2 0 0.4-0.099 0.5 0.3s0.5 1.5 0.6 1.7 0.1 0.2 0 0.3-0.1 0.2-0.2 0.3l-0.3 0.3c-0.1 0.1-0.2 0.2-0.1 0.4 0.2 0.2 0.6 0.9 1.2 1.4 0.7 0.7 1.4 0.9 1.6 1 0.2 0 0.3 0.001 0.4-0.099s0.5-0.6 0.6-0.8c0.2-0.2 0.3-0.2 0.5-0.1l1.4 0.7c0.2 0.1 0.3 0.2 0.5 0.3 0 0.1 0.1 0.5-0.099 1s-1 0.9-1.4 1c-0.3 0-0.8 0.001-1.3-0.099-0.3-0.1-0.7-0.2-1.2-0.4-2.1-0.9-3.4-3-3.5-3.1s-0.8-1.1-0.8-2.1c0-1 0.5-1.5 0.7-1.7s0.4-0.3 0.5-0.3z'})))))));};var ShareBoxContainer=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject13);var ShareBox=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject14);

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isPhoneOrEmail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isContactPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return hasBillingAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return required; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return cepCui; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return hasPaidServices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isChecked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isNIF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return notEmptyEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return notEmptyPhone; });
var isPhoneOrEmail=function isPhoneOrEmail(value,props){var message='Forne\xE7a um n\xFAmero ou email correcto';var emailRegex=/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;if(props.phone&&props.phone.value&&props.phone.value.length<9){return{result:false,message:'Forne\xE7a um n\xFAmero v\xE1lido'};}if(props.email&&props.email.value&&!emailRegex.test(props.email.value)){return{result:false,message:'Forne\xE7a um email v\xE1lido'};}if(!props.email.value&&!props.phone.value){return{result:false,message:message};}return{result:true};};var isEmail=function isEmail(value,props){var emailRegex=/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;var result=true;var contact=props.contact;if(contact.value==='e'){if(!!props.email&&(!props.email.value||!emailRegex.test(props.email.value))){result=false;}}var message=result?'':'Forneça um email válido';return{result:result,message:message};};var isPhone=function isPhone(value,props){var result=true;if(!!props.phone&&(!props.phone.value||props.phone.value.length<9)){result=false;}var message=result?'':'Forneça um número válido';return{result:result,message:message};};var isContactPhone=function isContactPhone(values,props){return!!props&&!!props.contact&&!!props.contact.value&&props.contact.value==='p';};var hasBillingAddress=function hasBillingAddress(values,props){return!!props&&!!props.billingAddress&&!!props.billingAddress.value&&props.billingAddress.value==='d';};var required=function required(value){var message='Campo de preenchimento obrigat\xF3rio';if(!value||value===undefined){return{result:false,message:message};}return{result:true,message:''};};var cepCui=function cepCui(value){var message='Formato inv\xE1lido (PT + 16 algarismos + 2 letras)';var regex=/PT\d{16}[a-zA-Z]{2}/g;if(!value||!regex.test(value)){return{result:false,message:message};}return{result:true};};var hasPaidServices=function hasPaidServices(services){return services.some(function(srv){return srv.is_paid;});};var isChecked=function isChecked(value){var message='Para aderir \xE9 necessario aceitar os termos.';if(value===false){return{result:false,message:message};}return{result:true,message:''};};var isNIF=function isNIF(value){var message='NIF inválido';if(value.length<9)return{result:false,message:message};var split=value.split('');var ident=split[0];if(ident==='0'&&ident==='3'&&ident==='4'&&ident==='7')return{result:false,message:message};var total=split.slice(0,split.length-1).map(function(sp){return parseInt(sp,10);}).reduce(function(sum,value,index,array){return sum+value*(array.length+1-index);},0);var divided=11-total%11;var control=divided>=10?0:divided;var valid=control===parseInt(split[split.length-1],10);return{result:valid,message:valid?'':message};};var notEmptyEmail=function notEmptyEmail(value,refValue){var emailRegex=/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;var result=!value?!!refValue:emailRegex.test(value);var message=result?'':'Forneça um email válido';return{result:result,message:message};};var notEmptyPhone=function notEmptyPhone(value,refValue){var result=!value?!!refValue:value.length===9;var message=result?'':'Forneça um telefone válido';return{result:result,message:message};};

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_logrocket__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_logrocket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_logrocket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_kea__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_kea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_kea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__);
var reducers=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux__["combineReducers"])({scenes:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_kea__["keaReducer"])('scenes'),routing:__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["routerReducer"]});var sagaMiddleware=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_saga__["default"])();var composeEnhancers=window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__||__WEBPACK_IMPORTED_MODULE_1_redux__["compose"];var finalCreateStore=composeEnhancers(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux__["applyMiddleware"])(sagaMiddleware,__WEBPACK_IMPORTED_MODULE_0_logrocket___default.a.reduxMiddleware()))(__WEBPACK_IMPORTED_MODULE_1_redux__["createStore"]);var store=finalCreateStore(reducers);sagaMiddleware.run(__WEBPACK_IMPORTED_MODULE_3_kea__["keaSaga"]);/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(980), __esModule: true };

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(943);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(942);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["clsx"] = clsx;
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ __webpack_exports__["default"] = (clsx);

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(45).document;
module.exports = document && document.documentElement;


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(76) && !__webpack_require__(140)(function () {
  return Object.defineProperty(__webpack_require__(310)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(188);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(141);
var ITERATOR = __webpack_require__(49)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(75);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(189);
var $export = __webpack_require__(56);
var redefine = __webpack_require__(477);
var hide = __webpack_require__(111);
var Iterators = __webpack_require__(141);
var $iterCreate = __webpack_require__(994);
var setToStringTag = __webpack_require__(233);
var getPrototypeOf = __webpack_require__(999);
var ITERATOR = __webpack_require__(49)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(49)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(235)('meta');
var isObject = __webpack_require__(87);
var has = __webpack_require__(110);
var setDesc = __webpack_require__(88).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(140)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(88);
var anObject = __webpack_require__(75);
var getKeys = __webpack_require__(231);

module.exports = __webpack_require__(76) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(232);
var createDesc = __webpack_require__(190);
var toIObject = __webpack_require__(142);
var toPrimitive = __webpack_require__(319);
var has = __webpack_require__(110);
var IE8_DOM_DEFINE = __webpack_require__(464);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(76) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(474);
var hiddenKeys = __webpack_require__(311).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(110);
var toIObject = __webpack_require__(142);
var arrayIndexOf = __webpack_require__(988)(false);
var IE_PROTO = __webpack_require__(315)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 475 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(75);
var isObject = __webpack_require__(87);
var newPromiseCapability = __webpack_require__(312);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(111);


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(75);
var aFunction = __webpack_require__(230);
var SPECIES = __webpack_require__(49)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(139);
var invoke = __webpack_require__(992);
var html = __webpack_require__(463);
var cel = __webpack_require__(310);
var global = __webpack_require__(45);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(188)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 480 */
/***/ (function(module, exports) {



/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(89);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(46);
var toAbsoluteIndex = __webpack_require__(119);
var toLength = __webpack_require__(31);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(77);
var toObject = __webpack_require__(46);
var IObject = __webpack_require__(193);
var toLength = __webpack_require__(31);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1024);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(77);
var isObject = __webpack_require__(20);
var invoke = __webpack_require__(489);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(39).f;
var create = __webpack_require__(114);
var redefineAll = __webpack_require__(145);
var ctx = __webpack_require__(79);
var anInstance = __webpack_require__(143);
var forOf = __webpack_require__(241);
var $iterDefine = __webpack_require__(333);
var step = __webpack_require__(493);
var setSpecies = __webpack_require__(146);
var DESCRIPTORS = __webpack_require__(38);
var fastKey = __webpack_require__(98).fastKey;
var validate = __webpack_require__(121);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(145);
var getWeak = __webpack_require__(98).getWeak;
var anObject = __webpack_require__(17);
var isObject = __webpack_require__(20);
var anInstance = __webpack_require__(143);
var forOf = __webpack_require__(241);
var createArrayMethod = __webpack_require__(78);
var $has = __webpack_require__(63);
var validate = __webpack_require__(121);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(38) && !__webpack_require__(18)(function () {
  return Object.defineProperty(__webpack_require__(326)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 489 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(20);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(17);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(114);
var descriptor = __webpack_require__(118);
var setToStringTag = __webpack_require__(147);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(64)(IteratorPrototype, __webpack_require__(28)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 493 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 494 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(77);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(38);
var getKeys = __webpack_require__(117);
var gOPS = __webpack_require__(244);
var pIE = __webpack_require__(194);
var toObject = __webpack_require__(46);
var IObject = __webpack_require__(193);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(18)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(39);
var anObject = __webpack_require__(17);
var getKeys = __webpack_require__(117);

module.exports = __webpack_require__(38) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(65);
var gOPN = __webpack_require__(115).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(63);
var toIObject = __webpack_require__(65);
var arrayIndexOf = __webpack_require__(237)(false);
var IE_PROTO = __webpack_require__(338)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(38);
var getKeys = __webpack_require__(117);
var toIObject = __webpack_require__(65);
var isEnum = __webpack_require__(194).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(115);
var gOPS = __webpack_require__(244);
var anObject = __webpack_require__(17);
var Reflect = __webpack_require__(19).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(19).parseFloat;
var $trim = __webpack_require__(148).trim;

module.exports = 1 / $parseFloat(__webpack_require__(342) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(19).parseInt;
var $trim = __webpack_require__(148).trim;
var ws = __webpack_require__(342);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(17);
var isObject = __webpack_require__(20);
var newPromiseCapability = __webpack_require__(495);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 505 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(31);
var repeat = __webpack_require__(341);
var defined = __webpack_require__(90);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(82);
var toLength = __webpack_require__(31);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(19);
var core = __webpack_require__(35);
var LIBRARY = __webpack_require__(113);
var wksExt = __webpack_require__(345);
var defineProperty = __webpack_require__(39).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(113);
var global = __webpack_require__(19);
var ctx = __webpack_require__(79);
var classof = __webpack_require__(192);
var $export = __webpack_require__(3);
var isObject = __webpack_require__(20);
var aFunction = __webpack_require__(77);
var anInstance = __webpack_require__(143);
var forOf = __webpack_require__(241);
var speciesConstructor = __webpack_require__(195);
var task = __webpack_require__(343).set;
var microtask = __webpack_require__(1031)();
var newPromiseCapabilityModule = __webpack_require__(495);
var perform = __webpack_require__(1032);
var userAgent = __webpack_require__(248);
var promiseResolve = __webpack_require__(504);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(28)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(145)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(147)($Promise, PROMISE);
__webpack_require__(146)(PROMISE);
Wrapper = __webpack_require__(35)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(243)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(336);
__webpack_require__(3)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(38) && /./g.flags != 'g') __webpack_require__(39).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(240)
});


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(21);

// -- Inlined from fbjs --

var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function _invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var warning = function(){};

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

// /-- Inlined from fbjs --

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $defineProperty = __webpack_require__(348);

var $SyntaxError = __webpack_require__(514);
var $TypeError = __webpack_require__(149);

var gopd = __webpack_require__(522);

/** @type {import('.')} */
module.exports = function defineDataProperty(
	obj,
	property,
	value
) {
	if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
		throw new $TypeError('`obj` must be an object or a function`');
	}
	if (typeof property !== 'string' && typeof property !== 'symbol') {
		throw new $TypeError('`property` must be a string or a symbol`');
	}
	if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
		throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
		throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
		throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
		throw new $TypeError('`loose`, if provided, must be a boolean');
	}

	var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
	var nonWritable = arguments.length > 4 ? arguments[4] : null;
	var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
	var loose = arguments.length > 6 ? arguments[6] : false;

	/* @type {false | TypedPropertyDescriptor<unknown>} */
	var desc = !!gopd && gopd(obj, property);

	if ($defineProperty) {
		$defineProperty(obj, property, {
			configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
			enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
			value: value,
			writable: nonWritable === null && desc ? desc.writable : !nonWritable
		});
	} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
		// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
		obj[property] = value; // eslint-disable-line no-param-reassign
	} else {
		throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
	}
};


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./syntax')} */
module.exports = SyntaxError;


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(70);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ic-eletricidade.6539aa4e.svg";

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ic-gas.d9a65da4.svg";

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/order.ee4fec11.svg";

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/search.9b51ec00.svg";

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(150);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $defineProperty = __webpack_require__(348);

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	return !!$defineProperty;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!$defineProperty) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.readState = exports.saveState = undefined;

var _warning = __webpack_require__(151);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR']; /* eslint-disable no-empty */


var SecurityError = 'SecurityError';
var KeyPrefix = '@@History/';

var createKey = function createKey(key) {
  return KeyPrefix + key;
};

var saveState = exports.saveState = function saveState(key, state) {
  if (!window.sessionStorage) {
    // Session storage is not available or hidden.
    // sessionStorage is undefined in Internet Explorer when served via file protocol.
     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
    return;
  }

  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (error.name === SecurityError) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;

      return;
    }

    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;

      return;
    }

    throw error;
  }
};

var readState = exports.readState = function readState(key) {
  var json = void 0;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (error.name === SecurityError) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;

      return undefined;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return undefined;
};

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.locationsAreEqual = exports.Actions = exports.useQueries = exports.useBeforeUnload = exports.useBasename = exports.createMemoryHistory = exports.createHashHistory = exports.createHistory = undefined;

var _LocationUtils = __webpack_require__(122);

Object.defineProperty(exports, 'locationsAreEqual', {
  enumerable: true,
  get: function get() {
    return _LocationUtils.locationsAreEqual;
  }
});

var _createBrowserHistory = __webpack_require__(1247);

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

var _createHashHistory2 = __webpack_require__(1248);

var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);

var _createMemoryHistory2 = __webpack_require__(1249);

var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);

var _useBasename2 = __webpack_require__(1250);

var _useBasename3 = _interopRequireDefault(_useBasename2);

var _useBeforeUnload2 = __webpack_require__(1251);

var _useBeforeUnload3 = _interopRequireDefault(_useBeforeUnload2);

var _useQueries2 = __webpack_require__(1252);

var _useQueries3 = _interopRequireDefault(_useQueries2);

var _Actions2 = __webpack_require__(252);

var _Actions3 = _interopRequireDefault(_Actions2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.createHistory = _createBrowserHistory2.default;
exports.createHashHistory = _createHashHistory3.default;
exports.createMemoryHistory = _createMemoryHistory3.default;
exports.useBasename = _useBasename3.default;
exports.useBeforeUnload = _useBeforeUnload3.default;
exports.useQueries = _useQueries3.default;
exports.Actions = _Actions3.default;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createReducer = createReducer;
exports.createPersistentReducer = createPersistentReducer;
exports.combineReducerObjects = combineReducerObjects;
exports.convertReducerArrays = convertReducerArrays;

var _redux = __webpack_require__(280);

// storageAvailable('localStorage') == true or false
function storageAvailable(type) {
  try {
    var storage = window[type];
    var x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return false;
  }
}

var storageCache = {};

function warnIfUndefinedActionCreator(object, property) {
  if (false) {
    if (object.reducer.undefined !== undefined) {
      console.warn('A reducer with the property "' + property + '" is waiting for an action where its key is not defined.');
    }
  }

  return object;
}

// create reducer function from such an object { [action]: (state, payload) => state }
function createReducer(mapping, defaultValue) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultValue;
    var action = arguments[1];

    if (mapping[action.type]) {
      return mapping[action.type](state, action.payload, action.meta);
    } else {
      return state;
    }
  };
}

// create reducer function from such an object { [action]: (state, payload) => state }
// with the added benefit that it's stored in localStorage
function createPersistentReducer(actions, defaultValue, key) {
  if (storageAvailable('localStorage')) {
    var storage = window.localStorage;

    var value = storage[key] ? JSON.parse(storage[key]) : defaultValue;
    storageCache[key] = value;

    var reducer = createReducer(actions, value);

    return function (state, payload) {
      var result = reducer(state, payload);
      if (storageCache[key] !== result) {
        storageCache[key] = result;
        storage[key] = JSON.stringify(result);
      }
      return result;
    };
  } else {
    return createReducer(actions, defaultValue);
  }
}

// input: object with values: { value, type, reducer, ...options } or function(state, action) {}
// output: combined reducer function (state, action) {}
function combineReducerObjects(path, objects) {
  var reducers = {};

  Object.keys(objects).forEach(function (key) {
    var object = objects[key];
    if (typeof object.reducer === 'function') {
      reducers[key] = object.reducer;
    } else {
      reducers[key] = path && object.persist ? createPersistentReducer(object.reducer, object.value, path.join('.') + key) : createReducer(object.reducer, object.value);
    }
  });

  if (Object.keys(reducers).length > 0) {
    return (0, _redux.combineReducers)(reducers);
  } else {
    return function () {
      return {};
    };
  }
}

// input: object with values: [value, type, options, reducer]
// output: object with values: { value, type, reducer, ...options }
function convertReducerArrays(reducers) {
  if (!reducers) {
    return reducers;
  }

  var keys = Object.keys(reducers);
  for (var i = 0; i < keys.length; i++) {
    var s = reducers[keys[i]];
    if (Array.isArray(s)) {
      // s = [ value, type, options, reducer ]
      reducers[keys[i]] = warnIfUndefinedActionCreator(Object.assign({
        value: s[0],
        type: s[1], // proptype
        reducer: s[3] || s[2]
      }, s[3] ? s[2] : {}), keys[i]);
    }
  }

  return reducers;
}

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(1270);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(125),
    root = __webpack_require__(66);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(359),
    setCacheAdd = __webpack_require__(1369),
    setCacheHas = __webpack_require__(1370);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(66);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 532 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1318),
    isArguments = __webpack_require__(160),
    isArray = __webpack_require__(23),
    isBuffer = __webpack_require__(161),
    isIndex = __webpack_require__(200),
    isTypedArray = __webpack_require__(203);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(153),
    eq = __webpack_require__(158);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 535 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;


/***/ }),
/* 536 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(360),
    isFlattenable = __webpack_require__(1349);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(1333);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(360),
    isArray = __webpack_require__(23);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(101),
    isMasked = __webpack_require__(1352),
    isObject = __webpack_require__(43),
    toSource = __webpack_require__(567);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(261),
    nativeKeys = __webpack_require__(1365);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(362),
    isArrayLike = __webpack_require__(83);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(201),
    overRest = __webpack_require__(564),
    setToString = __webpack_require__(566);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(530),
    arrayIncludes = __webpack_require__(1280),
    arrayIncludesWith = __webpack_require__(1281),
    cacheHas = __webpack_require__(546),
    createSet = __webpack_require__(1335),
    setToArray = __webpack_require__(263);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(154),
    last = __webpack_require__(372),
    parent = __webpack_require__(1368),
    toKey = __webpack_require__(157);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 546 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(66);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(218)(module)))

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(365);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(66);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(125);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(530),
    arraySome = __webpack_require__(1282),
    cacheHas = __webpack_require__(546);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(1389),
    overRest = __webpack_require__(564),
    setToString = __webpack_require__(566);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(539),
    getSymbols = __webpack_require__(369),
    keys = __webpack_require__(102);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(539),
    getSymbolsIn = __webpack_require__(556),
    keysIn = __webpack_require__(204);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(360),
    getPrototype = __webpack_require__(368),
    getSymbols = __webpack_require__(369),
    stubArray = __webpack_require__(580);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(154),
    isArguments = __webpack_require__(160),
    isArray = __webpack_require__(23),
    isIndex = __webpack_require__(200),
    isLength = __webpack_require__(264),
    toKey = __webpack_require__(157);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(1288),
    getPrototype = __webpack_require__(368),
    isPrototype = __webpack_require__(261);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(158),
    isArrayLike = __webpack_require__(83),
    isIndex = __webpack_require__(200),
    isObject = __webpack_require__(43);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(43);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 561 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 562 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 563 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(1277);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 565 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(1315),
    shortOut = __webpack_require__(1371);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 567 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(198);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1291),
    hasPath = __webpack_require__(557);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(83),
    isObjectLike = __webpack_require__(37);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(206);

/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */
function isInteger(value) {
  return typeof value == 'number' && value == toInteger(value);
}

module.exports = isInteger;


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(1297),
    baseUnary = __webpack_require__(124),
    nodeUtil = __webpack_require__(156);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

var isNumber = __webpack_require__(574);

/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return isNumber(value) && value != +value;
}

module.exports = isNaN;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(51),
    isObjectLike = __webpack_require__(37);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(1300),
    baseUnary = __webpack_require__(124),
    nodeUtil = __webpack_require__(156);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(51),
    isArray = __webpack_require__(23),
    isObjectLike = __webpack_require__(37);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(153),
    baseForOwn = __webpack_require__(363),
    baseIteratee = __webpack_require__(92);

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

module.exports = mapKeys;


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(1306),
    createAssigner = __webpack_require__(1331);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(537),
    baseOrderBy = __webpack_require__(1308),
    baseRest = __webpack_require__(543),
    isIterateeCall = __webpack_require__(559);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),
/* 580 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 581 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(1388),
    isObject = __webpack_require__(43);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(266);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(155),
    keysIn = __webpack_require__(204);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1319);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(27);


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mapValues;
	function mapValues(obj, f) {
	  if (obj == null) {
	    return {};
	  }

	  var res = {};
	  Object.keys(obj).forEach(function (key) {
	    res[key] = f(obj[key]);
	  });
	  return res;
	}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setActive = setActive;
	exports.default = registerXHR;

	var _mapValues = __webpack_require__(1);

	var _mapValues2 = _interopRequireDefault(_mapValues);

	var _enhanceFunc = __webpack_require__(4);

	var _enhanceFunc2 = _interopRequireDefault(_enhanceFunc);

	var _protectFunc = __webpack_require__(6);

	var _protectFunc2 = _interopRequireDefault(_protectFunc);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var isActive = true;

	function setActive(shouldBeActive) {
	  isActive = shouldBeActive;
	}

	var currentXHRId = 0;
	function registerXHR(_ref) {
	  var addRequest = _ref.addRequest,
	      addResponse = _ref.addResponse;

	  var _XHR = XMLHttpRequest;
	  var xhrMap = new WeakMap();
	  var unsubFunctions = [];
	  // const LOGROCKET_XHR_LABEL = 'logrocket_xhr';
	  var LOGROCKET_XHR_LABEL = 'xhr-';

	  window._lrXMLHttpRequest = XMLHttpRequest;

	  // eslint-disable-next-line no-native-reassign
	  XMLHttpRequest = function XMLHttpRequest(mozAnon, mozSystem) {
	    var xhrObject = new _XHR(mozAnon, mozSystem);
	    if (!isActive) {
	      return xhrObject;
	    }

	    xhrMap.set(xhrObject, {
	      xhrId: ++currentXHRId,
	      headers: {}
	    });
	    // ..., 'open', (method, url, async, username, password) => {
	    unsubFunctions.push((0, _enhanceFunc2.default)(xhrObject, 'open', (0, _protectFunc2.default)(function (method, url) {
	      var currentXHR = xhrMap.get(xhrObject);
	      currentXHR.method = method;
	      currentXHR.url = url;
	    })));

	    unsubFunctions.push((0, _enhanceFunc2.default)(xhrObject, 'send', (0, _protectFunc2.default)(function (data) {
	      var currentXHR = xhrMap.get(xhrObject);
	      var request = {
	        url: currentXHR.url,
	        method: currentXHR.method.toUpperCase(),
	        headers: (0, _mapValues2.default)(currentXHR.headers, function (headerValues) {
	          return headerValues.join(', ');
	        }),
	        body: data
	      };
	      addRequest('' + LOGROCKET_XHR_LABEL + currentXHR.xhrId, request);
	    })));

	    unsubFunctions.push((0, _enhanceFunc2.default)(xhrObject, 'setRequestHeader', (0, _protectFunc2.default)(function (header, value) {
	      var currentXHR = xhrMap.get(xhrObject);
	      currentXHR.headers[header] = currentXHR.headers[header] || [];
	      currentXHR.headers[header].push(value);
	    })));

	    var xhrListeners = {
	      readystatechange: (0, _protectFunc2.default)(function () {
	        if (xhrObject.readyState === 4) {
	          var currentXHR = xhrMap.get(xhrObject);
	          var headerString = xhrObject.getAllResponseHeaders();

	          var headers = headerString.split(/[\r\n]+/).reduce(function (previous, current) {
	            var next = previous;
	            var headerParts = current.split(': ');
	            if (headerParts.length > 0) {
	              var key = headerParts.shift(); // first index of the array
	              var value = headerParts.join(': '); // rest of the array repaired
	              if (previous[key]) {
	                next[key] += ', ' + value;
	              } else {
	                next[key] = value;
	              }
	            }
	            return next;
	          }, {});

	          var body = void 0;

	          // IE 11 sometimes throws when trying to access a large responses:
	          // https://connect.microsoft.com/IE/Feedback/Details/1053110
	          try {
	            switch (xhrObject.responseType) {
	              case 'json':
	              case 'arraybuffer':
	              case 'blob':
	                {
	                  body = xhrObject.response;
	                  break;
	                }
	              case 'document':
	                {
	                  body = xhrObject.responseXML;
	                  break;
	                }
	              case 'text':
	              case '':
	                {
	                  body = xhrObject.responseText;
	                  break;
	                }
	              default:
	                {
	                  body = '';
	                }
	            }
	          } catch (err) {
	            body = 'LogRocket: Error accessing response.';
	          }

	          var response = {
	            url: currentXHR.url,
	            status: xhrObject.status,
	            headers: headers,
	            body: body
	          };

	          addResponse('' + LOGROCKET_XHR_LABEL + currentXHR.xhrId, response);
	        }
	      })
	      // // Unused Event Listeners
	      // loadstart: () => {},
	      // progress: () => {},
	      // abort: () => {},
	      // error: () => {},
	      // load: () => {},
	      // timeout: () => {},
	      // loadend: () => {},
	    };

	    Object.keys(xhrListeners).forEach(function (key) {
	      xhrObject.addEventListener(key, xhrListeners[key]);
	      unsubFunctions.push(function () {
	        xhrObject.removeEventListener(key, xhrListeners[key]);
	      });
	    });

	    return xhrObject;
	  };

	  // this allows "instanceof XMLHttpRequest" to work
	  XMLHttpRequest.prototype = _XHR.prototype;

	  // Persist the static variables.
	  ['UNSENT', 'OPENED', 'HEADERS_RECEIVED', 'LOADING', 'DONE'].forEach(function (variable) {
	    XMLHttpRequest[variable] = _XHR[variable];
	  });

	  return function () {
	    unsubFunctions.forEach(function (unsubFunction) {
	      unsubFunction();
	    });

	    // eslint-disable-next-line no-native-reassign
	    XMLHttpRequest = _XHR;
	  };
	}

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/* eslint-disable */

	'use strict';

	/*
	 TraceKit - Cross brower stack traces - github.com/occ/TraceKit

	 This was originally forked from github.com/occ/TraceKit, but has since been
	 largely re-written and is now maintained as part of raven-js.  Tests for
	 this are in test/vendor.

	 MIT license
	*/

	var TraceKit = {
	    collectWindowErrors: true,
	    debug: false
	};

	// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
	var _window = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	// global reference to slice
	var _slice = [].slice;
	var UNKNOWN_FUNCTION = '?';

	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
	var ERROR_TYPES_RE = /^(?:Uncaught (?:exception: )?)?((?:Eval|Internal|Range|Reference|Syntax|Type|URI)Error): ?(.*)$/;

	function getLocationHref() {
	    if (typeof document === 'undefined' || typeof document.location === 'undefined') return '';

	    return document.location.href;
	}

	/**
	 * TraceKit.report: cross-browser processing of unhandled exceptions
	 *
	 * Syntax:
	 *   TraceKit.report.subscribe(function(stackInfo) { ... })
	 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
	 *   TraceKit.report(exception)
	 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
	 *
	 * Supports:
	 *   - Firefox: full stack trace with line numbers, plus column number
	 *              on top frame; column number is not guaranteed
	 *   - Opera:   full stack trace with line and column numbers
	 *   - Chrome:  full stack trace with line and column numbers
	 *   - Safari:  line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *   - IE:      line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *
	 * In theory, TraceKit should work on all of the following versions:
	 *   - IE5.5+ (only 8.0 tested)
	 *   - Firefox 0.9+ (only 3.5+ tested)
	 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
	 *     Exceptions Have Stacktrace to be enabled in opera:config)
	 *   - Safari 3+ (only 4+ tested)
	 *   - Chrome 1+ (only 5+ tested)
	 *   - Konqueror 3.5+ (untested)
	 *
	 * Requires TraceKit.computeStackTrace.
	 *
	 * Tries to catch all unhandled exceptions and report them to the
	 * subscribed handlers. Please note that TraceKit.report will rethrow the
	 * exception. This is REQUIRED in order to get a useful stack trace in IE.
	 * If the exception does not reach the top of the browser, you will only
	 * get a stack trace from the point where TraceKit.report was called.
	 *
	 * Handlers receive a stackInfo object as described in the
	 * TraceKit.computeStackTrace docs.
	 */
	TraceKit.report = function reportModuleWrapper() {
	    var handlers = [],
	        lastArgs = null,
	        lastException = null,
	        lastExceptionStack = null;

	    /**
	     * Add a crash handler.
	     * @param {Function} handler
	     */
	    function subscribe(handler) {
	        installGlobalHandler();
	        handlers.push(handler);
	    }

	    /**
	     * Remove a crash handler.
	     * @param {Function} handler
	     */
	    function unsubscribe(handler) {
	        for (var i = handlers.length - 1; i >= 0; --i) {
	            if (handlers[i] === handler) {
	                handlers.splice(i, 1);
	            }
	        }
	    }

	    /**
	     * Remove all crash handlers.
	     */
	    function unsubscribeAll() {
	        uninstallGlobalHandler();
	        handlers = [];
	    }

	    /**
	     * Dispatch stack information to all handlers.
	     * @param {Object.<string, *>} stack
	     */
	    function notifyHandlers(stack, isWindowError) {
	        var exception = null;
	        if (isWindowError && !TraceKit.collectWindowErrors) {
	            return;
	        }
	        for (var i in handlers) {
	            if (handlers.hasOwnProperty(i)) {
	                try {
	                    handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
	                } catch (inner) {
	                    exception = inner;
	                }
	            }
	        }

	        if (exception) {
	            throw exception;
	        }
	    }

	    var _oldOnerrorHandler, _onErrorHandlerInstalled;

	    /**
	     * Ensures all global unhandled exceptions are recorded.
	     * Supported by Gecko and IE.
	     * @param {string} message Error message.
	     * @param {string} url URL of script that generated the exception.
	     * @param {(number|string)} lineNo The line number at which the error
	     * occurred.
	     * @param {?(number|string)} colNo The column number at which the error
	     * occurred.
	     * @param {?Error} ex The actual Error object.
	     */
	    function traceKitWindowOnError(message, url, lineNo, colNo, ex) {
	        var stack = null;

	        if (lastExceptionStack) {
	            TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
	            processLastException();
	        } else if (ex) {
	            // New chrome and blink send along a real error object
	            // Let's just report that like a normal error.
	            // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
	            stack = TraceKit.computeStackTrace(ex);
	            notifyHandlers(stack, true);
	        } else {
	            var location = {
	                'url': url,
	                'line': lineNo,
	                'column': colNo
	            };

	            var name = undefined;
	            var msg = message; // must be new var or will modify original `arguments`
	            var groups;
	            if ({}.toString.call(message) === '[object String]') {
	                var groups = message.match(ERROR_TYPES_RE);
	                if (groups) {
	                    name = groups[1];
	                    msg = groups[2];
	                }
	            }

	            location.func = UNKNOWN_FUNCTION;

	            stack = {
	                'name': name,
	                'message': msg,
	                'url': getLocationHref(),
	                'stack': [location]
	            };
	            notifyHandlers(stack, true);
	        }

	        if (_oldOnerrorHandler) {
	            return _oldOnerrorHandler.apply(this, arguments);
	        }

	        return false;
	    }

	    function installGlobalHandler() {
	        if (_onErrorHandlerInstalled) {
	            return;
	        }
	        _oldOnerrorHandler = _window.onerror;
	        _window.onerror = traceKitWindowOnError;
	        _onErrorHandlerInstalled = true;
	    }

	    function uninstallGlobalHandler() {
	        if (!_onErrorHandlerInstalled) {
	            return;
	        }
	        _window.onerror = _oldOnerrorHandler;
	        _onErrorHandlerInstalled = false;
	        _oldOnerrorHandler = undefined;
	    }

	    function processLastException() {
	        var _lastExceptionStack = lastExceptionStack,
	            _lastArgs = lastArgs;
	        lastArgs = null;
	        lastExceptionStack = null;
	        lastException = null;
	        notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
	    }

	    /**
	     * Reports an unhandled Error to TraceKit.
	     * @param {Error} ex
	     * @param {?boolean} rethrow If false, do not re-throw the exception.
	     * Only used for window.onerror to not cause an infinite loop of
	     * rethrowing.
	     */
	    function report(ex, rethrow) {
	        var args = _slice.call(arguments, 1);
	        if (lastExceptionStack) {
	            if (lastException === ex) {
	                return; // already caught by an inner catch block, ignore
	            } else {
	                processLastException();
	            }
	        }

	        var stack = TraceKit.computeStackTrace(ex);
	        lastExceptionStack = stack;
	        lastException = ex;
	        lastArgs = args;

	        // If the stack trace is incomplete, wait for 2 seconds for
	        // slow slow IE to see if onerror occurs or not before reporting
	        // this exception; otherwise, we will end up with an incomplete
	        // stack trace
	        setTimeout(function () {
	            if (lastException === ex) {
	                processLastException();
	            }
	        }, stack.incomplete ? 2000 : 0);

	        if (rethrow !== false) {
	            throw ex; // re-throw to propagate to the top level (and cause window.onerror)
	        }
	    }

	    report.subscribe = subscribe;
	    report.unsubscribe = unsubscribe;
	    report.uninstall = unsubscribeAll;
	    return report;
	}();

	/**
	 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
	 *
	 * Syntax:
	 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
	 * Returns:
	 *   s.name              - exception name
	 *   s.message           - exception message
	 *   s.stack[i].url      - JavaScript or HTML file URL
	 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
	 *   s.stack[i].args     - arguments passed to the function, if known
	 *   s.stack[i].line     - line number, if known
	 *   s.stack[i].column   - column number, if known
	 *
	 * Supports:
	 *   - Firefox:  full stack trace with line numbers and unreliable column
	 *               number on top frame
	 *   - Opera 10: full stack trace with line and column numbers
	 *   - Opera 9-: full stack trace with line numbers
	 *   - Chrome:   full stack trace with line and column numbers
	 *   - Safari:   line and column number for the topmost stacktrace element
	 *               only
	 *   - IE:       no line numbers whatsoever
	 *
	 * Tries to guess names of anonymous functions by looking for assignments
	 * in the source code. In IE and Safari, we have to guess source file names
	 * by searching for function bodies inside all page scripts. This will not
	 * work for scripts that are loaded cross-domain.
	 * Here be dragons: some function names may be guessed incorrectly, and
	 * duplicate functions may be mismatched.
	 *
	 * TraceKit.computeStackTrace should only be used for tracing purposes.
	 * Logging of unhandled exceptions should be done with TraceKit.report,
	 * which builds on top of TraceKit.computeStackTrace and provides better
	 * IE support by utilizing the window.onerror event to retrieve information
	 * about the top of the stack.
	 *
	 * Note: In IE and Safari, no stack trace is recorded on the Error object,
	 * so computeStackTrace instead walks its *own* chain of callers.
	 * This means that:
	 *  * in Safari, some methods may be missing from the stack trace;
	 *  * in IE, the topmost function in the stack trace will always be the
	 *    caller of computeStackTrace.
	 *
	 * This is okay for tracing (because you are likely to be calling
	 * computeStackTrace from the function you want to be the topmost element
	 * of the stack trace anyway), but not okay for logging unhandled
	 * exceptions (because your catch block will likely be far away from the
	 * inner function that actually caused the exception).
	 *
	 */
	TraceKit.computeStackTrace = function computeStackTraceWrapper() {
	    /**
	     * Escapes special characters, except for whitespace, in a string to be
	     * used inside a regular expression as a string literal.
	     * @param {string} text The string.
	     * @return {string} The escaped string literal.
	     */
	    function escapeRegExp(text) {
	        return text.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g, '\\$&');
	    }

	    /**
	     * Escapes special characters in a string to be used inside a regular
	     * expression as a string literal. Also ensures that HTML entities will
	     * be matched the same as their literal friends.
	     * @param {string} body The string.
	     * @return {string} The escaped string.
	     */
	    function escapeCodeAsRegExpForMatchingInsideHTML(body) {
	        return escapeRegExp(body).replace('<', '(?:<|&lt;)').replace('>', '(?:>|&gt;)').replace('&', '(?:&|&amp;)').replace('"', '(?:"|&quot;)').replace(/\s+/g, '\\s+');
	    }

	    // Contents of Exception in various browsers.
	    //
	    // SAFARI:
	    // ex.message = Can't find variable: qq
	    // ex.line = 59
	    // ex.sourceId = 580238192
	    // ex.sourceURL = http://...
	    // ex.expressionBeginOffset = 96
	    // ex.expressionCaretOffset = 98
	    // ex.expressionEndOffset = 98
	    // ex.name = ReferenceError
	    //
	    // FIREFOX:
	    // ex.message = qq is not defined
	    // ex.fileName = http://...
	    // ex.lineNumber = 59
	    // ex.columnNumber = 69
	    // ex.stack = ...stack trace... (see the example below)
	    // ex.name = ReferenceError
	    //
	    // CHROME:
	    // ex.message = qq is not defined
	    // ex.name = ReferenceError
	    // ex.type = not_defined
	    // ex.arguments = ['aa']
	    // ex.stack = ...stack trace...
	    //
	    // INTERNET EXPLORER:
	    // ex.message = ...
	    // ex.name = ReferenceError
	    //
	    // OPERA:
	    // ex.message = ...message... (see the example below)
	    // ex.name = ReferenceError
	    // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
	    // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'

	    /**
	     * Computes stack trace information from the stack property.
	     * Chrome and Gecko use this property.
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack trace information.
	     */
	    function computeStackTraceFromStackProp(ex) {
	        if (typeof ex.stack === 'undefined' || !ex.stack) return;

	        var chrome = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|<anonymous>).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
	            gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|resource|\[native).*?)(?::(\d+))?(?::(\d+))?\s*$/i,
	            winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
	            lines = ex.stack.split('\n'),
	            stack = [],
	            parts,
	            element,
	            reference = /^(.*) is undefined$/.exec(ex.message);

	        for (var i = 0, j = lines.length; i < j; ++i) {
	            if (parts = chrome.exec(lines[i])) {
	                var isNative = parts[2] && parts[2].indexOf('native') !== -1;
	                element = {
	                    'url': !isNative ? parts[2] : null,
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': isNative ? [parts[2]] : [],
	                    'line': parts[3] ? +parts[3] : null,
	                    'column': parts[4] ? +parts[4] : null
	                };
	            } else if (parts = winjs.exec(lines[i])) {
	                element = {
	                    'url': parts[2],
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': [],
	                    'line': +parts[3],
	                    'column': parts[4] ? +parts[4] : null
	                };
	            } else if (parts = gecko.exec(lines[i])) {
	                element = {
	                    'url': parts[3],
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': parts[2] ? parts[2].split(',') : [],
	                    'line': parts[4] ? +parts[4] : null,
	                    'column': parts[5] ? +parts[5] : null
	                };
	            } else {
	                continue;
	            }

	            if (!element.func && element.line) {
	                element.func = UNKNOWN_FUNCTION;
	            }

	            stack.push(element);
	        }

	        if (!stack.length) {
	            return null;
	        }

	        if (!stack[0].column && typeof ex.columnNumber !== 'undefined') {
	            // FireFox uses this awesome columnNumber property for its top frame
	            // Also note, Firefox's column number is 0-based and everything else expects 1-based,
	            // so adding 1
	            stack[0].column = ex.columnNumber + 1;
	        }

	        return {
	            'name': ex.name,
	            'message': ex.message,
	            'url': getLocationHref(),
	            'stack': stack
	        };
	    }

	    /**
	     * Adds information about the first frame to incomplete stack traces.
	     * Safari and IE require this to get complete data on the first frame.
	     * @param {Object.<string, *>} stackInfo Stack trace information from
	     * one of the compute* methods.
	     * @param {string} url The URL of the script that caused an error.
	     * @param {(number|string)} lineNo The line number of the script that
	     * caused an error.
	     * @param {string=} message The error generated by the browser, which
	     * hopefully contains the name of the object that caused the error.
	     * @return {boolean} Whether or not the stack information was
	     * augmented.
	     */
	    function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
	        var initial = {
	            'url': url,
	            'line': lineNo
	        };

	        if (initial.url && initial.line) {
	            stackInfo.incomplete = false;

	            if (!initial.func) {
	                initial.func = UNKNOWN_FUNCTION;
	            }

	            if (stackInfo.stack.length > 0) {
	                if (stackInfo.stack[0].url === initial.url) {
	                    if (stackInfo.stack[0].line === initial.line) {
	                        return false; // already in stack trace
	                    } else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
	                        stackInfo.stack[0].line = initial.line;
	                        return false;
	                    }
	                }
	            }

	            stackInfo.stack.unshift(initial);
	            stackInfo.partial = true;
	            return true;
	        } else {
	            stackInfo.incomplete = true;
	        }

	        return false;
	    }

	    /**
	     * Computes stack trace information by walking the arguments.caller
	     * chain at the time the exception occurred. This will cause earlier
	     * frames to be missed but is the only way to get any stack trace in
	     * Safari and IE. The top frame is restored by
	     * {@link augmentStackTraceWithInitialElement}.
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack trace information.
	     */
	    function computeStackTraceByWalkingCallerChain(ex, depth) {
	        var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
	            stack = [],
	            funcs = {},
	            recursion = false,
	            parts,
	            item,
	            source;

	        for (var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller) {
	            if (curr === computeStackTrace || curr === TraceKit.report) {
	                // console.log('skipping internal function');
	                continue;
	            }

	            item = {
	                'url': null,
	                'func': UNKNOWN_FUNCTION,
	                'line': null,
	                'column': null
	            };

	            if (curr.name) {
	                item.func = curr.name;
	            } else if (parts = functionName.exec(curr.toString())) {
	                item.func = parts[1];
	            }

	            if (typeof item.func === 'undefined') {
	                try {
	                    item.func = parts.input.substring(0, parts.input.indexOf('{'));
	                } catch (e) {}
	            }

	            if (funcs['' + curr]) {
	                recursion = true;
	            } else {
	                funcs['' + curr] = true;
	            }

	            stack.push(item);
	        }

	        if (depth) {
	            // console.log('depth is ' + depth);
	            // console.log('stack is ' + stack.length);
	            stack.splice(0, depth);
	        }

	        var result = {
	            'name': ex.name,
	            'message': ex.message,
	            'url': getLocationHref(),
	            'stack': stack
	        };
	        augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
	        return result;
	    }

	    /**
	     * Computes a stack trace for an exception.
	     * @param {Error} ex
	     * @param {(string|number)=} depth
	     */
	    function computeStackTrace(ex, depth) {
	        var stack = null;
	        depth = depth == null ? 0 : +depth;

	        try {
	            stack = computeStackTraceFromStackProp(ex);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (TraceKit.debug) {
	                throw e;
	            }
	        }

	        try {
	            stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (TraceKit.debug) {
	                throw e;
	            }
	        }

	        return {
	            'name': ex.name,
	            'message': ex.message,
	            'url': getLocationHref()
	        };
	    }

	    computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
	    computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;

	    return computeStackTrace;
	}();

	module.exports = TraceKit;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = enhanceFunc;
	/* eslint no-param-reassign: ["error", { "props": false }] */

	function enhanceFunc(obj, method, handler) {
	  var _this = this;

	  var original = obj[method];

	  obj[method] = function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    var res = void 0;
	    if (original) {
	      res = original.apply(obj, args);
	    }
	    handler.apply(_this, args);
	    return res;
	  };

	  return function () {
	    obj[method] = original;
	  };
	}

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var logError = console.error.bind ? console.error.bind(console) : function () {};

	exports.default = logError;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = protectFunc;

	var _sendTelemetryData = __webpack_require__(23);

	var _sendTelemetryData2 = _interopRequireDefault(_sendTelemetryData);

	var _logError = __webpack_require__(5);

	var _logError2 = _interopRequireDefault(_logError);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function protectFunc(f) {
	  var onFail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

	  return function () {
	    try {
	      f.apply(undefined, arguments);
	    } catch (err) {
	      if (typeof window !== 'undefined' && window._lrdebug) {
	        throw err;
	      }

	      var payload = onFail(err);
	      (0, _logError2.default)('LogRocket', err);
	      (0, _sendTelemetryData2.default)(err, payload);
	    }
	  };
	}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports=__webpack_require__(24);

/***/ }),
/* 8 */
[28, 9],
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _registerConsole = __webpack_require__(10);

	var _registerConsole2 = _interopRequireDefault(_registerConsole);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _registerConsole2.default;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	exports.default = registerConsole;

	var _enhanceFunc = __webpack_require__(4);

	var _enhanceFunc2 = _interopRequireDefault(_enhanceFunc);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function registerConsole(logger) {
	  var unsubFunctions = [];
	  var methods = ['log', 'warn', 'info', 'error', 'debug'];
	  methods.forEach(function (method) {
	    unsubFunctions.push((0, _enhanceFunc2.default)(console, method, function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }

	      logger.addEvent('lr.core.LogEvent', function () {
	        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	            _ref$isEnabled = _ref.isEnabled,
	            isEnabled = _ref$isEnabled === undefined ? true : _ref$isEnabled;

	        if ((typeof isEnabled === 'undefined' ? 'undefined' : _typeof(isEnabled)) === 'object' && isEnabled[method] === false || isEnabled === false) {
	          return null;
	        }

	        return {
	          logLevel: method.toUpperCase(),
	          args: args
	        };
	      });
	    }));
	  });

	  return function () {
	    unsubFunctions.forEach(function (unsubFunction) {
	      return unsubFunction();
	    });
	  };
	}

/***/ }),
/* 11 */
[28, 12],
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _registerExceptions = __webpack_require__(14);

	var _registerExceptions2 = _interopRequireDefault(_registerExceptions);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _registerExceptions2.default;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable */

	var _TraceKit = __webpack_require__(3);

	var _TraceKit2 = _interopRequireDefault(_TraceKit);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var objectPrototype = Object.prototype;

	function isUndefined(what) {
	  return what === void 0;
	}

	function isFunction(what) {
	  return typeof what === 'function';
	}

	function each(obj, callback) {
	  var i, j;

	  if (isUndefined(obj.length)) {
	    for (i in obj) {
	      if (hasKey(obj, i)) {
	        callback.call(null, i, obj[i]);
	      }
	    }
	  } else {
	    j = obj.length;
	    if (j) {
	      for (i = 0; i < j; i++) {
	        callback.call(null, i, obj[i]);
	      }
	    }
	  }
	}

	/**
	 * hasKey, a better form of hasOwnProperty
	 * Example: hasKey(MainHostObject, property) === true/false
	 *
	 * @param {Object} host object to check property
	 * @param {string} key to check
	 */
	function hasKey(object, key) {
	  return objectPrototype.hasOwnProperty.call(object, key);
	}

	/**
	 * Polyfill a method
	 * @param obj object e.g. `document`
	 * @param name method name present on object e.g. `addEventListener`
	 * @param replacement replacement function
	 * @param track {optional} record instrumentation to an array
	 */
	function fill(obj, name, replacement, track) {
	  var orig = obj[name];
	  obj[name] = replacement(orig);
	  if (track) {
	    track.push([obj, name, orig]);
	  }
	}

	// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/lr-js/pull/785)
	var _window = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	var _document = _window.document;

	var Handler = function () {
	  function Handler(_ref) {
	    var captureException = _ref.captureException;

	    _classCallCheck(this, Handler);

	    this._errorHandler = this._errorHandler.bind(this);

	    this._ignoreOnError = 0;
	    this._wrappedBuiltIns = [];
	    this.captureException = captureException;
	    _TraceKit2.default.report.subscribe(this._errorHandler);
	    this._instrumentTryCatch();
	  }

	  _createClass(Handler, [{
	    key: 'uninstall',
	    value: function uninstall() {
	      _TraceKit2.default.report.unsubscribe(this._errorHandler);

	      // restore any wrapped builtins
	      var builtin;
	      while (this._wrappedBuiltIns.length) {
	        builtin = this._wrappedBuiltIns.shift();

	        var obj = builtin[0],
	            name = builtin[1],
	            orig = builtin[2];

	        obj[name] = orig;
	      }
	    }
	  }, {
	    key: '_errorHandler',
	    value: function _errorHandler(report) {
	      if (!this._ignoreOnError) {
	        this.captureException(report);
	      }
	    }
	  }, {
	    key: '_ignoreNextOnError',
	    value: function _ignoreNextOnError() {
	      var _this = this;

	      this._ignoreOnError += 1;
	      setTimeout(function () {
	        // onerror should trigger before setTimeout
	        _this._ignoreOnError -= 1;
	      });
	    }

	    /*
	     * Wrap code within a context so Handler can capture errors
	     * reliably across domains that is executed immediately.
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The callback to be immediately executed within the context
	     * @param {array} args An array of arguments to be called with the callback [optional]
	     */

	  }, {
	    key: 'context',
	    value: function context(options, func, args) {
	      if (isFunction(options)) {
	        args = func || [];
	        func = options;
	        options = undefined;
	      }

	      return this.wrap(options, func).apply(this, args);
	    }
	  }, {
	    key: 'wrap',


	    /*
	     * Wrap code within a context and returns back a new function to be executed
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The function to be wrapped in a new context
	     * @param {function} func A function to call before the try/catch wrapper [optional, private]
	     * @return {function} The newly wrapped functions with a context
	     */
	    value: function wrap(options, func, _before) {
	      var self = this;
	      // 1 argument has been passed, and it's not a function
	      // so just return it
	      if (isUndefined(func) && !isFunction(options)) {
	        return options;
	      }

	      // options is optional
	      if (isFunction(options)) {
	        func = options;
	        options = undefined;
	      }

	      // At this point, we've passed along 2 arguments, and the second one
	      // is not a function either, so we'll just return the second argument.
	      if (!isFunction(func)) {
	        return func;
	      }

	      // We don't wanna wrap it twice!
	      try {
	        if (func.__lr__) {
	          return func;
	        }

	        // If this has already been wrapped in the past, return that
	        if (func.__lr_wrapper__) {
	          return func.__lr_wrapper__;
	        }
	      } catch (e) {
	        // Just accessing custom props in some Selenium environments
	        // can cause a "Permission denied" exception (see lr-js#495).
	        // Bail on wrapping and return the function as-is (defers to window.onerror).
	        return func;
	      }

	      function wrapped() {
	        var args = [],
	            i = arguments.length,
	            deep = !options || options && options.deep !== false;

	        if (_before && isFunction(_before)) {
	          _before.apply(this, arguments);
	        }

	        // Recursively wrap all of a function's arguments that are
	        // functions themselves.
	        while (i--) {
	          args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];
	        }try {
	          // Attempt to invoke user-land function
	          // NOTE: If you are a LogRocket user, and you are seeing this stack frame, it
	          //       means that LogRocket caught an error invoking your application code. This is
	          //       expected behavior and NOT indicative of a bug with LogRocket.
	          return func.apply(this, args);
	        } catch (e) {
	          self._ignoreNextOnError();
	          self.captureException(_TraceKit2.default.computeStackTrace(e), options);
	          throw e;
	        }
	      }

	      // copy over properties of the old function
	      for (var property in func) {
	        if (hasKey(func, property)) {
	          wrapped[property] = func[property];
	        }
	      }
	      wrapped.prototype = func.prototype;

	      func.__lr_wrapper__ = wrapped;
	      // Signal that this function has been wrapped already
	      // for both debugging and to prevent it to being wrapped twice
	      wrapped.__lr__ = true;
	      wrapped.__inner__ = func;

	      return wrapped;
	    }
	  }, {
	    key: '_instrumentTryCatch',


	    /**
	     * Install any queued plugins
	     */
	    value: function _instrumentTryCatch() {
	      var self = this;

	      var wrappedBuiltIns = self._wrappedBuiltIns;

	      function wrapTimeFn(orig) {
	        return function (fn, t) {
	          // preserve arity
	          // Make a copy of the arguments to prevent deoptimization
	          // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
	          var args = new Array(arguments.length);
	          for (var i = 0; i < args.length; ++i) {
	            args[i] = arguments[i];
	          }
	          var originalCallback = args[0];
	          if (isFunction(originalCallback)) {
	            args[0] = self.wrap(originalCallback);
	          }

	          // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
	          // also supports only two arguments and doesn't care what this is, so we
	          // can just call the original function directly.
	          if (orig.apply) {
	            return orig.apply(this, args);
	          } else {
	            return orig(args[0], args[1]);
	          }
	        };
	      }

	      function wrapEventTarget(global) {
	        var proto = _window[global] && _window[global].prototype;
	        if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
	          fill(proto, 'addEventListener', function (orig) {
	            return function (evtName, fn, capture, secure) {
	              // preserve arity
	              try {
	                if (fn && fn.handleEvent) {
	                  fn.handleEvent = self.wrap(fn.handleEvent);
	                }
	              } catch (err) {}
	              // can sometimes get 'Permission denied to access property "handle Event'


	              // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
	              // so that we don't have more than one wrapper function
	              var before;

	              return orig.call(this, evtName, self.wrap(fn, undefined, before), capture, secure);
	            };
	          }, wrappedBuiltIns);
	          fill(proto, 'removeEventListener', function (orig) {
	            return function (evt, fn, capture, secure) {
	              try {
	                fn = fn && (fn.__lr_wrapper__ ? fn.__lr_wrapper__ : fn);
	              } catch (e) {
	                // ignore, accessing __lr_wrapper__ will throw in some Selenium environments
	              }
	              return orig.call(this, evt, fn, capture, secure);
	            };
	          }, wrappedBuiltIns);
	        }
	      }

	      fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
	      fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
	      if (_window.requestAnimationFrame) {
	        fill(_window, 'requestAnimationFrame', function (orig) {
	          return function (cb) {
	            return orig(self.wrap(cb));
	          };
	        }, wrappedBuiltIns);
	      }

	      // event targets borrowed from bugsnag-js:
	      // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
	      var eventTargets = ['EventTarget', 'Window', 'Node', 'ApplicationCache', 'AudioTrackList', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'ModalWindow', 'Notification', 'SVGElementInstance', 'Screen', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'];
	      for (var i = 0; i < eventTargets.length; i++) {
	        wrapEventTarget(eventTargets[i]);
	      }

	      var $ = _window.jQuery || _window.$;
	      if ($ && $.fn && $.fn.ready) {
	        fill($.fn, 'ready', function (orig) {
	          return function (fn) {
	            return orig.call(this, self.wrap(fn));
	          };
	        }, wrappedBuiltIns);
	      }
	    }
	  }]);

	  return Handler;
	}();

	exports.default = Handler;
	;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = registerCore;

	var _raven = __webpack_require__(13);

	var _raven2 = _interopRequireDefault(_raven);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function stackTraceFromError(errorReport) {
	  function makeNotNull(val) {
	    return val === null ? undefined : val;
	  }

	  return errorReport.stack ? errorReport.stack.map(function (frame) {
	    return {
	      lineNumber: makeNotNull(frame.line),
	      columnNumber: makeNotNull(frame.column),
	      fileName: makeNotNull(frame.url),
	      functionName: makeNotNull(frame.func)
	    };
	  }) : undefined;
	}

	function registerCore(logger) {
	  var raven = new _raven2.default({
	    captureException: function captureException(errorReport) {
	      logger.addEvent('lr.core.Exception', function () {
	        return {
	          exceptionType: 'WINDOW',
	          errorType: errorReport.name,
	          message: errorReport.message,
	          browserUseragent: navigator.userAgent,
	          browserHref: window.location.href
	        };
	      }, { _stackTrace: stackTraceFromError(errorReport) });
	    }
	  });

	  var rejectionHandler = function rejectionHandler(evt) {
	    logger.addEvent('lr.core.Exception', function () {
	      return {
	        exceptionType: 'UNHANDLED_REJECTION',
	        message: evt.reason
	      };
	    });
	  };

	  window.addEventListener('unhandledrejection', rejectionHandler);

	  return function () {
	    window.removeEventListener('unhandledrejection', rejectionHandler);
	    raven.uninstall();
	  };
	}

/***/ }),
/* 15 */
[28, 17],
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _registerXHR = __webpack_require__(2);

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	var interceptors = [];

	function makeInterceptor(fetch, fetchId) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }

	  var reversedInterceptors = interceptors.reduce(function (array, interceptor) {
	    return [interceptor].concat(array);
	  }, []);
	  var promise = Promise.resolve(args);

	  // Register request interceptors
	  reversedInterceptors.forEach(function (_ref) {
	    var request = _ref.request,
	        requestError = _ref.requestError;

	    if (request || requestError) {
	      promise = promise.then(function (args) {
	        return request.apply(undefined, [fetchId].concat(_toConsumableArray(args)));
	      }, function (args) {
	        return requestError.apply(undefined, [fetchId].concat(_toConsumableArray(args)));
	      });
	    }
	  });

	  promise = promise.then(function (args) {
	    (0, _registerXHR.setActive)(false);

	    var res = void 0;
	    var err = void 0;
	    try {
	      res = fetch.apply(undefined, _toConsumableArray(args));
	    } catch (_err) {
	      err = _err;
	    }

	    (0, _registerXHR.setActive)(true);

	    if (err) {
	      throw err;
	    }
	    return res;
	  });

	  reversedInterceptors.forEach(function (_ref2) {
	    var response = _ref2.response,
	        responseError = _ref2.responseError;

	    if (response || responseError) {
	      promise = promise.then(function (res) {
	        return response(fetchId, res);
	      }, function (err) {
	        return responseError && responseError(fetchId, err);
	      });
	    }
	  });

	  return promise;
	}

	function attach(env) {
	  if (!env.fetch || !env.Promise) {
	    // Make sure fetch is avaibale in the given environment. If it's not, then
	    // default to using XHR intercept.
	    return;
	  }

	  var isPolyfill = env.fetch.polyfill;

	  // eslint-disable-next-line no-param-reassign
	  env.fetch = function (fetch) {
	    var fetchId = 0;

	    return function () {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }

	      return makeInterceptor.apply(undefined, [fetch, fetchId++].concat(args));
	    };
	  }(env.fetch);

	  // Forward the polyfill propery from fetch (set by github/whatwg-fetch).
	  if (isPolyfill) {
	    // eslint-disable-next-line no-param-reassign
	    env.fetch.polyfill = isPolyfill;
	  }
	}

	// TODO: React Native
	//   attach(global);

	var didAttach = false;

	exports.default = {
	  register: function register(interceptor) {
	    if (!didAttach) {
	      didAttach = true;
	      attach(window);
	    }

	    interceptors.push(interceptor);
	    return function () {
	      var index = interceptors.indexOf(interceptor);

	      if (index >= 0) {
	        interceptors.splice(index, 1);
	      }
	    };
	  },
	  clear: function clear() {
	    interceptors = [];
	  }
	};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	// import registerWebSocket from './registerWebSocket';


	exports.default = registerNetwork;

	var _registerFetch = __webpack_require__(18);

	var _registerFetch2 = _interopRequireDefault(_registerFetch);

	var _registerXHR = __webpack_require__(2);

	var _registerXHR2 = _interopRequireDefault(_registerXHR);

	var _protectFunc = __webpack_require__(6);

	var _protectFunc2 = _interopRequireDefault(_protectFunc);

	var _mapValues = __webpack_require__(1);

	var _mapValues2 = _interopRequireDefault(_mapValues);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function registerNetwork(logger) {
	  var ignoredNetwork = {};

	  // truncate if > 4MB in size
	  var truncate = function truncate(data) {
	    var limit = 1024 * 1000 * 4;
	    var str = data;

	    if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' && data != null) {
	      var proto = Object.getPrototypeOf(data);

	      if (proto === Object.prototype || proto === null) {
	        // plain object - jsonify for the size check
	        str = JSON.stringify(data);
	      }
	    }

	    if (str && str.length && str.length > limit && typeof str === 'string') {
	      var beginning = str.substring(0, 1000);
	      return beginning + ' ... LogRocket truncating to first 1000 characters.\n      Keep data under 4MB to prevent truncation. https://docs.logrocket.com/reference#network';
	    }

	    return data;
	  };

	  var addRequest = (0, _protectFunc2.default)(function (reqId, request) {
	    var method = request.method;
	    logger.addEvent('lr.network.RequestEvent', function () {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref$isEnabled = _ref.isEnabled,
	          isEnabled = _ref$isEnabled === undefined ? true : _ref$isEnabled,
	          _ref$requestSanitizer = _ref.requestSanitizer,
	          requestSanitizer = _ref$requestSanitizer === undefined ? function (f) {
	        return f;
	      } : _ref$requestSanitizer;

	      if (!isEnabled) {
	        return null;
	      }
	      var sanitized = null;
	      try {
	        // only try catch user defined functions
	        sanitized = requestSanitizer(request);
	      } catch (err) {
	        console.error(err);
	      }
	      if (sanitized) {
	        // Writing and then reading from an a tag turns a relative
	        // url into an absolute one.
	        var a = document.createElement('a');
	        a.href = sanitized.url;

	        return {
	          reqId: reqId, // default
	          url: a.href, // sanitized
	          headers: (0, _mapValues2.default)(sanitized.headers, function (headerValue) {
	            // sanitized
	            return '' + headerValue;
	          }),
	          body: truncate(sanitized.body), // sanitized
	          method: method, // default
	          referrer: sanitized.referrer || undefined, // sanitized
	          mode: sanitized.mode || undefined, // sanitized
	          credentials: sanitized.credentials || undefined // sanitized
	        };
	      }
	      ignoredNetwork[reqId] = true;
	      return null;
	    });
	  });

	  var addResponse = (0, _protectFunc2.default)(function (reqId, response) {
	    var status = response.status;
	    logger.addEvent('lr.network.ResponseEvent', function () {
	      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref2$isEnabled = _ref2.isEnabled,
	          isEnabled = _ref2$isEnabled === undefined ? true : _ref2$isEnabled,
	          _ref2$responseSanitiz = _ref2.responseSanitizer,
	          responseSanitizer = _ref2$responseSanitiz === undefined ? function (f) {
	        return f;
	      } : _ref2$responseSanitiz;

	      if (!isEnabled) {
	        return null;
	      } else if (ignoredNetwork[reqId]) {
	        delete ignoredNetwork[reqId];
	        return null;
	      }
	      var sanitized = null;

	      try {
	        // only try catch user defined functions
	        sanitized = responseSanitizer(response);
	      } catch (err) {
	        console.error(err);
	        // fall through to redacted log
	      }
	      if (sanitized) {
	        return {
	          reqId: reqId, // default
	          status: sanitized.status, // sanitized
	          headers: (0, _mapValues2.default)(sanitized.headers, function (headerValue) {
	            // sanitized
	            return '' + headerValue;
	          }),
	          body: truncate(sanitized.body) // sanitized
	        };
	      }
	      return {
	        reqId: reqId, // default
	        status: status, // default
	        headers: {}, // redacted
	        body: null // redacted
	      };
	    });
	  });

	  var unsubFetch = (0, _registerFetch2.default)({ addRequest: addRequest, addResponse: addResponse });
	  var unsubXHR = (0, _registerXHR2.default)({ addRequest: addRequest, addResponse: addResponse });
	  // const unsubWebSocket = registerWebSocket(logger);

	  return function () {
	    unsubFetch();
	    unsubXHR();
	    // unsubWebSocket();
	  };
	}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	exports.default = registerFetch;

	var _mapValues = __webpack_require__(1);

	var _mapValues2 = _interopRequireDefault(_mapValues);

	var _fetchIntercept = __webpack_require__(16);

	var _fetchIntercept2 = _interopRequireDefault(_fetchIntercept);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function makeObjectFromHeaders(headers) {
	  // If using real fetch, we must stringify the Headers object.
	  if (headers == null || typeof headers.forEach !== 'function') {
	    return headers;
	  }

	  var result = {};
	  headers.forEach(function (value, key) {
	    if (result[key]) {
	      result[key] = result[key] + ',' + value;
	    } else {
	      result[key] = '' + value;
	    }
	  });
	  return result;
	}

	// XHR specification is unclear of what types to allow in value so using toString method for now
	var stringifyHeaders = function stringifyHeaders(headers) {
	  return (0, _mapValues2.default)(makeObjectFromHeaders(headers), function (value) {
	    return '' + value;
	  });
	};

	function pluckFetchFields() {
	  var arg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	  return {
	    url: arg.url,
	    headers: stringifyHeaders(arg.headers),
	    body: arg.body,
	    method: arg.method && arg.method.toUpperCase(),
	    referrer: arg.referrer || undefined,
	    mode: arg.mode || undefined,
	    credentials: arg.credentials || undefined
	  };
	}

	function registerFetch(_ref) {
	  var addRequest = _ref.addRequest,
	      addResponse = _ref.addResponse;

	  var LOGROCKET_XHR_LABEL = 'fetch-';
	  var unregister = _fetchIntercept2.default.register({
	    request: function request(fetchId) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }

	      var p = void 0;

	      if (typeof Request !== 'undefined' && args[0] instanceof Request) {
	        p = args[0].clone().text().then(function (body) {
	          return _extends({}, pluckFetchFields(args[0]), {
	            body: body
	          });
	        });
	      } else {
	        p = Promise.resolve(_extends({}, pluckFetchFields(args[1]), {
	          url: '' + args[0]
	        }));
	      }

	      return p.then(function (req) {
	        addRequest('' + LOGROCKET_XHR_LABEL + fetchId, req);
	        return args;
	      });
	    },
	    requestError: function requestError(fetchId, error) {
	      return Promise.reject(error);
	    },
	    response: function response(fetchId, _response) {
	      var clonedResponse = _response.clone();

	      // TODO: enhance function on original response and future clones for:
	      // text(), json(), blob(), formdata(), arraybuffer()
	      return clonedResponse.text().then(function (data) {
	        var responseHash = {
	          url: _response.url,
	          status: _response.status,
	          headers: stringifyHeaders(_response.headers),
	          body: data
	        };
	        addResponse('' + LOGROCKET_XHR_LABEL + fetchId, responseHash);
	        return _response;
	      });
	    },
	    responseError: function responseError(fetchId, error) {
	      var response = {
	        url: undefined,
	        status: 0,
	        headers: {},
	        body: '' + error
	      };
	      addResponse('' + LOGROCKET_XHR_LABEL + fetchId, response);
	      return Promise.reject(error);
	    }
	  });

	  return unregister;
	}

/***/ }),
/* 19 */
[28, 22],
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	exports.default = createEnhancer;

	var _now = __webpack_require__(7);

	var _now2 = _interopRequireDefault(_now);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var storeIdCounter = 0;

	function createEnhancer(logger) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$stateSanitizer = _ref.stateSanitizer,
	      stateSanitizer = _ref$stateSanitizer === undefined ? function (f) {
	    return f;
	  } : _ref$stateSanitizer,
	      _ref$actionSanitizer = _ref.actionSanitizer,
	      actionSanitizer = _ref$actionSanitizer === undefined ? function (f) {
	    return f;
	  } : _ref$actionSanitizer;

	  // an enhancer is a function that returns a Store
	  return function (createStore) {
	    return function (reducer, initialState, enhancer) {
	      var store = createStore(reducer, initialState, enhancer);
	      var originalDispatch = store.dispatch;
	      var storeId = storeIdCounter++;
	      logger.addEvent('lr.redux.InitialState', function () {
	        var sanitizedState = void 0;
	        try {
	          // only try catch user defined functions
	          sanitizedState = stateSanitizer(store.getState());
	        } catch (err) {
	          console.error(err.toString());
	        }

	        return {
	          state: sanitizedState,
	          storeId: storeId
	        };
	      });

	      var dispatch = function dispatch(action) {
	        var start = (0, _now2.default)();

	        var err = void 0;
	        var res = void 0;
	        try {
	          res = originalDispatch(action);
	        } catch (_err) {
	          err = _err;
	        } finally {
	          var duration = (0, _now2.default)() - start;

	          logger.addEvent('lr.redux.ReduxAction', function () {
	            var sanitizedState = null;
	            var sanitizedAction = null;

	            try {
	              // only try catch user defined functions
	              sanitizedState = stateSanitizer(store.getState());
	              sanitizedAction = actionSanitizer(action);
	            } catch (err) {
	              console.error(err.toString());
	            }

	            if (sanitizedState && sanitizedAction) {
	              return {
	                storeId: storeId,
	                action: sanitizedAction,
	                duration: duration,
	                stateDelta: sanitizedState
	              };
	            }
	            return null;
	          });
	        }

	        if (err) {
	          throw err;
	        }

	        return res;
	      };

	      return _extends({}, store, {
	        dispatch: dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createMiddleware;

	var _now = __webpack_require__(7);

	var _now2 = _interopRequireDefault(_now);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var storeIdCounter = 0;

	function createMiddleware(logger) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$stateSanitizer = _ref.stateSanitizer,
	      stateSanitizer = _ref$stateSanitizer === undefined ? function (f) {
	    return f;
	  } : _ref$stateSanitizer,
	      _ref$actionSanitizer = _ref.actionSanitizer,
	      actionSanitizer = _ref$actionSanitizer === undefined ? function (f) {
	    return f;
	  } : _ref$actionSanitizer;

	  return function (store) {
	    var storeId = storeIdCounter++;
	    logger.addEvent('lr.redux.InitialState', function () {
	      var sanitizedState = void 0;
	      try {
	        // only try catch user defined functions
	        sanitizedState = stateSanitizer(store.getState());
	      } catch (err) {
	        console.error(err.toString());
	      }

	      return {
	        state: sanitizedState,
	        storeId: storeId
	      };
	    });

	    return function (next) {
	      return function (action) {
	        var start = (0, _now2.default)();

	        var err = void 0;
	        var res = void 0;
	        try {
	          res = next(action);
	        } catch (_err) {
	          err = _err;
	        } finally {
	          var duration = (0, _now2.default)() - start;

	          logger.addEvent('lr.redux.ReduxAction', function () {
	            var sanitizedState = null;
	            var sanitizedAction = null;

	            try {
	              // only try catch user defined functions
	              sanitizedState = stateSanitizer(store.getState());
	              sanitizedAction = actionSanitizer(action);
	            } catch (err) {
	              console.error(err.toString());
	            }

	            if (sanitizedState && sanitizedAction) {
	              return {
	                storeId: storeId,
	                action: sanitizedAction,
	                duration: duration,
	                stateDelta: sanitizedState
	              };
	            }
	            return null;
	          });
	        }

	        if (err) {
	          throw err;
	        }

	        return res;
	      };
	    };
	  };
	}

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createEnhancer = exports.createMiddleware = undefined;

	var _createEnhancer = __webpack_require__(20);

	var _createEnhancer2 = _interopRequireDefault(_createEnhancer);

	var _createMiddleware = __webpack_require__(21);

	var _createMiddleware2 = _interopRequireDefault(_createMiddleware);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.createMiddleware = _createMiddleware2.default;
	exports.createEnhancer = _createEnhancer2.default;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	exports.sendTelemetry = sendTelemetry;
	exports.default = sendErrorTelemetry;

	var _logError = __webpack_require__(5);

	var _logError2 = _interopRequireDefault(_logError);

	var _TraceKit = __webpack_require__(3);

	var _TraceKit2 = _interopRequireDefault(_TraceKit);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// eslint-disable-next-line no-undef
	var SCRIPT_VERSION =  true ? ("28a2300e44c6d18e594fb533c47cf5db2e96fd54") : '';

	function _sendToSentry(data) {
	  try {
	    var req = new XMLHttpRequest();
	    var message = data.message;

	    var url = (undefined) === 'prod' ? 'https://app.getsentry.com/api/199454/store/?sentry_version=7&sentry_client=http%2F3.8.0&sentry_key=03a8fb0031b441deaf96a466bbf39382' : 'https://app.getsentry.com/api/199453/store/?sentry_version=7&sentry_client=http%2F3.8.0&sentry_key=27d9a5c4e5444efc9eb176984006cb19';

	    req.open('POST', url);
	    req.send(JSON.stringify(_extends({
	      event_id: '',
	      message: message,
	      logger: 'javascript',
	      platform: 'javascript',
	      request: {
	        headers: {
	          'User-Agent': typeof navigator !== 'undefined' && navigator.userAgent
	        },
	        url: typeof location !== 'undefined' && location.href
	      },
	      release: 'sdk-' + SCRIPT_VERSION
	    }, data)));
	  } catch (err) {
	    (0, _logError2.default)('Failed to send', err);
	  }
	}

	function sendTelemetry(message, more) {
	  if (typeof window !== 'undefined' && window._lrdebug) {
	    return void (0, _logError2.default)(message);
	  }

	  _sendToSentry(_extends({
	    message: message
	  }, more));
	}

	function sendErrorTelemetry(err, payload) {
	  try {
	    var message = err.message;

	    var stringPayload = void 0;
	    try {
	      stringPayload = JSON.stringify(payload).slice(0, 1000);
	    } catch (err) {
	      try {
	        stringPayload = 'Could not stringify payload: ' + {}.toString(payload);
	      } catch (err) {/* nada */}
	    }

	    var stack = void 0;
	    try {
	      stack = _TraceKit2.default.computeStackTrace(err).stack.map(function (frame) {
	        return {
	          filename: frame.url,
	          lineno: frame.line,
	          colno: frame.column,
	          function: frame.func || '?'
	        };
	      });
	    } catch (err) {
	      /* nada */
	    }

	    _sendToSentry({
	      message: message,
	      extra: {
	        stringPayload: stringPayload
	      },
	      exception: {
	        values: [{
	          type: err.type,
	          value: message,
	          stacktrace: {
	            frames: stack
	          }
	        }]
	      }
	    });
	  } catch (err) {
	    (0, _logError2.default)('Failed to send', err);
	  }
	}

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	Object.defineProperty(exports,"__esModule",{value:true});var dateNow=Date.now.bind(Date);
	var loadTime=dateNow();exports.default=

	typeof performance!=='undefined'&&performance.now?
	performance.now.bind(performance):
	function(){return dateNow()-loadTime;};module.exports=exports['default'];

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MAX_QUEUE_SIZE = undefined;

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _logrocketNetwork = __webpack_require__(15);

	var _logrocketNetwork2 = _interopRequireDefault(_logrocketNetwork);

	var _logrocketExceptions = __webpack_require__(11);

	var _logrocketExceptions2 = _interopRequireDefault(_logrocketExceptions);

	var _logrocketConsole = __webpack_require__(8);

	var _logrocketConsole2 = _interopRequireDefault(_logrocketConsole);

	var _logrocketRedux = __webpack_require__(19);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var MAX_QUEUE_SIZE = exports.MAX_QUEUE_SIZE = 1000;

	var LogRocket = function () {
	  function LogRocket() {
	    var _this = this;

	    _classCallCheck(this, LogRocket);

	    this._buffer = [];

	    // TODO: tests for these exposed methods.
	    ['log', 'info', 'warn', 'error', 'debug'].forEach(function (method) {
	      _this[method] = function () {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }

	        _this.addEvent('lr.core.LogEvent', function () {
	          return {
	            logLevel: method.toUpperCase(),
	            args: args
	          };
	        }, { shouldCaptureStackTrace: true });
	      };
	    });

	    this._installed = [];
	  }

	  _createClass(LogRocket, [{
	    key: 'addEvent',
	    value: function addEvent(type, getMessage) {
	      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	      var time = Date.now();
	      this._run(function (logger) {
	        logger.addEvent(type, getMessage, _extends({}, opts, {
	          timeOverride: time
	        }));
	      });
	    }
	  }, {
	    key: 'onLogger',
	    value: function onLogger(logger) {
	      this._logger = logger;

	      while (this._buffer.length > 0) {
	        var f = this._buffer.shift();
	        f(this._logger);
	      }
	    }
	  }, {
	    key: '_run',
	    value: function _run(f) {
	      if (this._isDisabled) {
	        return;
	      }

	      if (this._logger) {
	        f(this._logger);
	      } else {
	        if (this._buffer.length >= MAX_QUEUE_SIZE) {
	          this._isDisabled = true;
	          console.warn('LogRocket: script did not load. Check that you have a valid network connection.');
	          this.uninstall();
	          return;
	        }

	        this._buffer.push(f.bind(this));
	      }
	    }
	  }, {
	    key: 'init',
	    value: function init(appID, opts) {
	      this._installed.push((0, _logrocketExceptions2.default)(this));
	      this._installed.push((0, _logrocketNetwork2.default)(this));
	      this._installed.push((0, _logrocketConsole2.default)(this));

	      this._run(function (logger) {
	        logger.init(appID, opts);
	      });
	    }
	  }, {
	    key: 'start',
	    value: function start() {
	      this._run(function (logger) {
	        logger.start();
	      });
	    }
	  }, {
	    key: 'uninstall',
	    value: function uninstall() {
	      this._installed.forEach(function (f) {
	        return f();
	      });
	      this._buffer = [];

	      this._run(function (logger) {
	        logger.uninstall();
	      });
	    }
	  }, {
	    key: 'identify',
	    value: function identify(id, opts) {
	      this._run(function (logger) {
	        logger.identify(id, opts);
	      });
	    }
	  }, {
	    key: 'startNewSession',
	    value: function startNewSession() {
	      this._run(function (logger) {
	        logger.startNewSession();
	      });
	    }
	  }, {
	    key: 'track',
	    value: function track(customEventName) {
	      this._run(function (logger) {
	        logger.track(customEventName);
	      });
	    }
	  }, {
	    key: 'getSessionURL',
	    value: function getSessionURL(cb) {
	      if (typeof cb !== 'function') {
	        throw new Error('LogRocket: must pass callback to getSessionURL()');
	      }

	      this._run(function (logger) {
	        if (logger.getSessionURL) {
	          logger.getSessionURL(cb);
	        } else {
	          cb(logger.recordingURL);
	        }
	      });
	    }
	  }, {
	    key: 'getVersion',
	    value: function getVersion(cb) {
	      this._run(function (logger) {
	        cb(logger.version);
	      });
	    }
	  }, {
	    key: 'startTransaction',
	    value: function startTransaction(transactionID) {
	      this.addEvent('lr.transaction.Start', function () {
	        return { id: transactionID };
	      });
	    }
	  }, {
	    key: 'endTransaction',
	    value: function endTransaction(transactionID) {
	      this.addEvent('lr.transaction.End', function () {
	        return { id: transactionID };
	      });
	    }
	  }, {
	    key: 'reduxEnhancer',
	    value: function reduxEnhancer() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	      return (0, _logrocketRedux.createEnhancer)(this, options);
	    }
	  }, {
	    key: 'reduxMiddleware',
	    value: function reduxMiddleware() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	      return (0, _logrocketRedux.createMiddleware)(this, options);
	    }
	  }, {
	    key: 'version',
	    get: function get() {
	      return this._logger && this._logger.version;
	    }
	  }, {
	    key: 'sessionURL',
	    get: function get() {
	      return this._logger && this._logger.recordingURL;
	    }
	  }, {
	    key: 'recordingURL',
	    get: function get() {
	      return this._logger && this._logger.recordingURL;
	    }
	  }, {
	    key: 'recordingID',
	    get: function get() {
	      return this._logger && this._logger.recordingID;
	    }
	  }, {
	    key: 'threadID',
	    get: function get() {
	      return this._logger && this._logger.threadID;
	    }
	  }, {
	    key: 'tabID',
	    get: function get() {
	      return this._logger && this._logger.tabID;
	    }
	  }]);

	  return LogRocket;
	}();

	exports.default = LogRocket;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = makeLogRocket;

	var _LogRocket = __webpack_require__(25);

	var _LogRocket2 = _interopRequireDefault(_LogRocket);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var REACT_NATIVE_NOTICE = 'LogRocket does not yet support React Native.';
	var makeNoopPolyfill = function makeNoopPolyfill() {
	  return {
	    init: function init() {},
	    uninstall: function uninstall() {},
	    log: function log() {},
	    info: function info() {},
	    warn: function warn() {},
	    error: function error() {},
	    debug: function debug() {},
	    addEvent: function addEvent() {},
	    identify: function identify() {},
	    start: function start() {},


	    get threadID() {
	      return null;
	    },
	    get recordingID() {
	      return null;
	    },
	    get recordingURL() {
	      return null;
	    },

	    reduxEnhancer: function reduxEnhancer() {
	      return function (store) {
	        return function () {
	          return store.apply(undefined, arguments);
	        };
	      };
	    },
	    reduxMiddleware: function reduxMiddleware() {
	      return function () {
	        return function (next) {
	          return function (action) {
	            return next(action);
	          };
	        };
	      };
	    },
	    track: function track() {},
	    getSessionURL: function getSessionURL() {},
	    getVersion: function getVersion() {},
	    startNewSession: function startNewSession() {},
	    onLogger: function onLogger() {},
	    setClock: function setClock() {}
	  };
	};

	function makeLogRocket() {
	  var getLogger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    throw new Error(REACT_NATIVE_NOTICE);
	  }

	  if (typeof window !== 'undefined') {
	    if (window._disableLogRocket) {
	      return makeNoopPolyfill();
	    }

	    if (window.MutationObserver) {
	      // Save window globals that we rely on.
	      window._lrMutationObserver = window.MutationObserver;

	      var instance = new _LogRocket2.default();
	      getLogger(instance);
	      return instance;
	    }
	  }

	  return makeNoopPolyfill();
	}
	module.exports = exports['default'];

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _makeLogRocket = __webpack_require__(26);

	var _makeLogRocket2 = _interopRequireDefault(_makeLogRocket);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var instance = (0, _makeLogRocket2.default)(function () {
	  var script = document.createElement('script');

	  if (window._lrAsyncScript) {
	    script.src = window._lrAsyncScript;
	  } else {
	    script.src = (undefined) === 'staging' ? 'https://cdn-staging.logrocket.com/logger.min.js' : 'https://cdn.logrocket.com/logger.min.js';
	  }

	  script.async = true;
	  document.head.appendChild(script);
	  script.onload = function () {
	    instance.onLogger(new window._LRLogger({
	      sdkVersion: ("0.5.6") // eslint-disable-line no-undef
	    }));
	  };
	  script.onerror = function () {
	    console.warn('LogRocket: script could not load. Check that you have a valid network connection.');
	    instance.uninstall();
	  };
	});

	exports.default = instance;
	module.exports = exports['default'];

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';

	module.exports = __webpack_require__(__webpack_module_template_argument_0__);

/***/ })
/******/ ])))
});
;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(588);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(1426);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// modified from https://github.com/es-shims/es6-shim
var objectKeys = __webpack_require__(587);
var hasSymbols = __webpack_require__(524)();
var callBound = __webpack_require__(306);
var toObject = Object;
var $push = callBound('Array.prototype.push');
var $propIsEnumerable = callBound('Object.prototype.propertyIsEnumerable');
var originalGetSymbols = hasSymbols ? Object.getOwnPropertySymbols : null;

// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
	if (target == null) { throw new TypeError('target must be an object'); }
	var to = toObject(target); // step 1
	if (arguments.length === 1) {
		return to; // step 2
	}
	for (var s = 1; s < arguments.length; ++s) {
		var from = toObject(arguments[s]); // step 3.a.i

		// step 3.a.ii:
		var keys = objectKeys(from);
		var getSymbols = hasSymbols && (Object.getOwnPropertySymbols || originalGetSymbols);
		if (getSymbols) {
			var syms = getSymbols(from);
			for (var j = 0; j < syms.length; ++j) {
				var key = syms[j];
				if ($propIsEnumerable(from, key)) {
					$push(keys, key);
				}
			}
		}

		// step 3.a.iii:
		for (var i = 0; i < keys.length; ++i) {
			var nextKey = keys[i];
			if ($propIsEnumerable(from, nextKey)) { // step 3.a.iii.2
				var propValue = from[nextKey]; // step 3.a.iii.2.a
				to[nextKey] = propValue; // step 3.a.iii.2.b
			}
		}
	}

	return to; // step 4
};


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(589);

var lacksProperEnumerationOrder = function () {
	if (!Object.assign) {
		return false;
	}
	/*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */
	var str = 'abcdefghijklmnopqrst';
	var letters = str.split('');
	var map = {};
	for (var i = 0; i < letters.length; ++i) {
		map[letters[i]] = letters[i];
	}
	var obj = Object.assign({}, map);
	var actual = '';
	for (var k in obj) {
		actual += k;
	}
	return str !== actual;
};

var assignHasPendingExceptions = function () {
	if (!Object.assign || !Object.preventExtensions) {
		return false;
	}
	/*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */
	var thrower = Object.preventExtensions({ 1: 2 });
	try {
		Object.assign(thrower, 'xy');
	} catch (e) {
		return thrower[1] === 'y';
	}
	return false;
};

module.exports = function getPolyfill() {
	if (!Object.assign) {
		return implementation;
	}
	if (lacksProperEnumerationOrder()) {
		return implementation;
	}
	if (assignHasPendingExceptions()) {
		return implementation;
	}
	return Object.assign;
};


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var RequireObjectCoercible = __webpack_require__(1190);
var callBound = __webpack_require__(306);

var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');
var $push = callBound('Array.prototype.push');

module.exports = function values(O) {
	var obj = RequireObjectCoercible(O);
	var vals = [];
	for (var key in obj) {
		if ($isEnumerable(obj, key)) { // checks own-ness as well
			$push(vals, obj[key]);
		}
	}
	return vals;
};


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(249);
var callBind = __webpack_require__(307);

var implementation = __webpack_require__(591);
var getPolyfill = __webpack_require__(593);
var shim = __webpack_require__(1428);

var polyfill = callBind(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(591);

module.exports = function getPolyfill() {
	return typeof Object.values === 'function' ? Object.values : implementation;
};


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = formatToCurrency;
/**
 * Helper function to convert a string with a float written with ','
 * for decimal places.
 * @param {string} number
 **/
function parseToEnglishFloat(number) {
  var parsed = parseFloat(number.replace(',', '.'));
  if (isNaN(parsed)) throw new Error('Parsed string is NaN');

  return parsed;
}

function getPaddedDecimal(number, decimals) {
  var splitted = number.toFixed(decimals).split('.');
  return splitted.length > 1 ? ',' + splitted[1] : '';
}

/**
 *
 * Formats number (integer, float or string) to currency
 * @param {number|string} number
 * @param {string|number} numDecimals
 * @param {boolean} ISO
 *
 **/
function formatToCurrency(number) {
  var numDecimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var ISO = arguments[2];

  if (['string', 'number'].indexOf(typeof number === 'undefined' ? 'undefined' : _typeof(number)) == -1) {
    throw new TypeError('Argument number must be of type number or string');
  }

  var numberToFormat = number;

  if (typeof number === 'string') {
    numberToFormat = parseToEnglishFloat(number);
  }

  var integer = Math.floor(numberToFormat).toString();
  var decimal = getPaddedDecimal(numberToFormat, numDecimals);

  var output = '' + addSeparators(integer) + decimal;
  var symbol = ISO ? 'EUR' : '€';

  return output + ' ' + symbol;
}

/**
  * Helper function
  * Returns a number with thousands separator
  + Example: 1000000 => 1.000.000
  * @param {string} number
**/

function addSeparators(number) {
  return number.split('').reverse().reduce(function (end, digit, index) {
    end.push(index && index % 3 === 0 ? digit + ' ' : digit);
    return end;
  }, []).reverse().join('');
}

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(822);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('not a function');
  }
  this._45 = 0;
  this._81 = 0;
  this._65 = null;
  this._54 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._10 = null;
Promise._97 = null;
Promise._61 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
};
function handle(self, deferred) {
  while (self._81 === 3) {
    self = self._65;
  }
  if (Promise._10) {
    Promise._10(self);
  }
  if (self._81 === 0) {
    if (self._45 === 0) {
      self._45 = 1;
      self._54 = deferred;
      return;
    }
    if (self._45 === 1) {
      self._45 = 2;
      self._54 = [self._54, deferred];
      return;
    }
    self._54.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._81 === 1) {
        resolve(deferred.promise, self._65);
      } else {
        reject(deferred.promise, self._65);
      }
      return;
    }
    var ret = tryCallOne(cb, self._65);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._81 = 3;
      self._65 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._81 = 1;
  self._65 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._81 = 2;
  self._65 = newValue;
  if (Promise._97) {
    Promise._97(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._45 === 1) {
    handle(self, self._54);
    self._54 = null;
  }
  if (self._45 === 2) {
    for (var i = 0; i < self._54.length; i++) {
      handle(self, self._54[i]);
    }
    self._54 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  })
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(1436);
var parse = __webpack_require__(1435);
var formats = __webpack_require__(378);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var formats = __webpack_require__(378);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var limit = 1024;

/* eslint operator-linebreak: [2, "before"] */

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var j = 0; j < string.length; j += limit) {
        var segment = string.length >= limit ? string.slice(j, j + limit) : string;
        var arr = [];

        for (var i = 0; i < segment.length; ++i) {
            var c = segment.charCodeAt(i);
            if (
                c === 0x2D // -
                || c === 0x2E // .
                || c === 0x5F // _
                || c === 0x7E // ~
                || (c >= 0x30 && c <= 0x39) // 0-9
                || (c >= 0x41 && c <= 0x5A) // a-z
                || (c >= 0x61 && c <= 0x7A) // A-Z
                || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }

            if (c < 0x80) {
                arr[arr.length] = hexTable[c];
                continue;
            }

            if (c < 0x800) {
                arr[arr.length] = hexTable[0xC0 | (c >> 6)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = hexTable[0xE0 | (c >> 12)]
                    + hexTable[0x80 | ((c >> 6) & 0x3F)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            i += 1;
            c = 0x10000 + (((c & 0x3FF) << 10) | (segment.charCodeAt(i) & 0x3FF));

            arr[arr.length] = hexTable[0xF0 | (c >> 18)]
                + hexTable[0x80 | ((c >> 12) & 0x3F)]
                + hexTable[0x80 | ((c >> 6) & 0x3F)]
                + hexTable[0x80 | (c & 0x3F)];
        }

        out += arr.join('');
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(1619);
var objectAssign = __webpack_require__(21);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(1437);
exports.encode = exports.stringify = __webpack_require__(1438);


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Enforces a single instance of the Raven client, and the
 * main entry point for Raven. If you are a consumer of the
 * Raven library, you SHOULD load this file (vs raven.js).
 **/

var RavenConstructor = __webpack_require__(1441);

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var _Raven = _window.Raven;

var Raven = new RavenConstructor();

/*
 * Allow multiple versions of Raven to be installed.
 * Strip Raven from the global context and returns the instance.
 *
 * @return {Raven}
 */
Raven.noConflict = function() {
  _window.Raven = _Raven;
  return Raven;
};

Raven.afterLoad();

module.exports = Raven;

/**
 * DISCLAIMER:
 *
 * Expose `Client` constructor for cases where user want to track multiple "sub-applications" in one larger app.
 * It's not meant to be used by a wide audience, so pleaaase make sure that you know what you're doing before using it.
 * Accidentally calling `install` multiple times, may result in an unexpected behavior that's very hard to debug.
 *
 * It's called `Client' to be in-line with Raven Node implementation.
 *
 * HOWTO:
 *
 * import Raven from 'raven-js';
 *
 * const someAppReporter = new Raven.Client();
 * const someOtherAppReporter = new Raven.Client();
 *
 * someAppReporter.config('__DSN__', {
 *   ...config goes here
 * });
 *
 * someOtherAppReporter.config('__OTHER_DSN__', {
 *   ...config goes here
 * });
 *
 * someAppReporter.captureMessage(...);
 * someAppReporter.captureException(...);
 * someAppReporter.captureBreadcrumb(...);
 *
 * someOtherAppReporter.captureMessage(...);
 * someOtherAppReporter.captureException(...);
 * someOtherAppReporter.captureBreadcrumb(...);
 *
 * It should "just work".
 */
module.exports.Client = RavenConstructor;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 602 */
/***/ (function(module, exports) {

/*
 json-stringify-safe
 Like JSON.stringify, but doesn't throw on circular references.

 Originally forked from https://github.com/isaacs/json-stringify-safe
 version 5.0.1 on 3/8/2017 and modified to handle Errors serialization
 and IE8 compatibility. Tests for this are in test/vendor.

 ISC license: https://github.com/isaacs/json-stringify-safe/blob/master/LICENSE
*/

exports = module.exports = stringify;
exports.getSerialize = serializer;

function indexOf(haystack, needle) {
  for (var i = 0; i < haystack.length; ++i) {
    if (haystack[i] === needle) return i;
  }
  return -1;
}

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
}

// https://github.com/ftlabs/js-abbreviate/blob/fa709e5f139e7770a71827b1893f22418097fbda/index.js#L95-L106
function stringifyError(value) {
  var err = {
    // These properties are implemented as magical getters and don't show up in for in
    stack: value.stack,
    message: value.message,
    name: value.name
  };

  for (var i in value) {
    if (Object.prototype.hasOwnProperty.call(value, i)) {
      err[i] = value[i];
    }
  }

  return err;
}

function serializer(replacer, cycleReplacer) {
  var stack = [];
  var keys = [];

  if (cycleReplacer == null) {
    cycleReplacer = function(key, value) {
      if (stack[0] === value) {
        return '[Circular ~]';
      }
      return '[Circular ~.' + keys.slice(0, indexOf(stack, value)).join('.') + ']';
    };
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = indexOf(stack, this);
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);

      if (~indexOf(stack, value)) {
        value = cycleReplacer.call(this, key, value);
      }
    } else {
      stack.push(value);
    }

    return replacer == null
      ? value instanceof Error ? stringifyError(value) : value
      : replacer.call(this, key, value);
  };
}


/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var LazyRenderBox = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LazyRenderBox, _Component);

  function LazyRenderBox() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return nextProps.hiddenClassName || nextProps.visible;
  };

  LazyRenderBox.prototype.render = function render() {
    var _props = this.props,
        hiddenClassName = _props.hiddenClassName,
        visible = _props.visible,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['hiddenClassName', 'visible']);

    if (hiddenClassName || __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.count(props.children) > 1) {
      if (!visible && hiddenClassName) {
        props.className += ' ' + hiddenClassName;
      }
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', props);
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(props.children);
  };

  return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

LazyRenderBox.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAlignFromPlacement;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAlignPopupClassName;
/* harmony export (immutable) */ __webpack_exports__["c"] = saveRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function isPointsEq(a1, a2, isAlignPoint) {
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }
  return a1[0] === a2[0] && a1[1] === a2[1];
}

function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, baseAlign, align);
}

function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  for (var placement in builtinPlacements) {
    if (builtinPlacements.hasOwnProperty(placement)) {
      if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
        return prefixCls + '-placement-' + placement;
      }
    }
  }
  return '';
}

function saveRef(name, component) {
  this[name] = component;
}

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListenerWrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);


function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates ? function run(e) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates(cb, e);
  } : cb;
  return __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default()(target, eventType, callback, option);
}

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
function contains(root, n) {
  var node = n;

  while (node) {
    if (node === root) {
      return true;
    }

    node = node.parentNode;
  }

  return false;
}

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 61);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __webpack_require__(41);

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = __webpack_require__(103);

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = __webpack_require__(207);

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __webpack_require__(25);

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __webpack_require__(47);

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __webpack_require__(8);

/***/ }),

/***/ 48:
/***/ (function(module, exports) {

module.exports = __webpack_require__(1467);

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __webpack_require__(59);

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = __webpack_require__(55);

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAddonsShallowCompare = __webpack_require__(14);

var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);

var _reactMomentProptypes = __webpack_require__(10);

var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);

var _airbnbPropTypes = __webpack_require__(1);

var _moment = __webpack_require__(7);

var _moment2 = _interopRequireDefault(_moment);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _defaultPhrases = __webpack_require__(3);

var _getPhrasePropTypes = __webpack_require__(5);

var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);

var _getPhrase = __webpack_require__(48);

var _getPhrase2 = _interopRequireDefault(_getPhrase);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
  day: _reactMomentProptypes2['default'].momentObj,
  daySize: _airbnbPropTypes.nonNegativeInteger,
  isOutsideDay: _propTypes2['default'].bool,
  modifiers: _propTypes2['default'].instanceOf(Set),
  isFocused: _propTypes2['default'].bool,
  tabIndex: _propTypes2['default'].oneOf([0, -1]),
  onDayClick: _propTypes2['default'].func,
  onDayMouseEnter: _propTypes2['default'].func,
  onDayMouseLeave: _propTypes2['default'].func,
  renderDay: _propTypes2['default'].func,

  // internationalization
  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.CalendarDayPhrases))
});

var defaultProps = {
  day: (0, _moment2['default'])(),
  daySize: _constants.DAY_SIZE,
  isOutsideDay: false,
  modifiers: new Set(),
  isFocused: false,
  tabIndex: -1,
  onDayClick: function () {
    function onDayClick() {}

    return onDayClick;
  }(),
  onDayMouseEnter: function () {
    function onDayMouseEnter() {}

    return onDayMouseEnter;
  }(),
  onDayMouseLeave: function () {
    function onDayMouseLeave() {}

    return onDayMouseLeave;
  }(),

  renderDay: null,

  // internationalization
  phrases: _defaultPhrases.CalendarDayPhrases
};

var CalendarDay = function (_React$Component) {
  _inherits(CalendarDay, _React$Component);

  function CalendarDay() {
    var _ref;

    _classCallCheck(this, CalendarDay);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = CalendarDay.__proto__ || Object.getPrototypeOf(CalendarDay)).call.apply(_ref, [this].concat(args)));

    _this.setButtonRef = _this.setButtonRef.bind(_this);
    return _this;
  }

  _createClass(CalendarDay, [{
    key: 'shouldComponentUpdate',
    value: function () {
      function shouldComponentUpdate(nextProps, nextState) {
        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
      }

      return shouldComponentUpdate;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps) {
        var _props = this.props,
            isFocused = _props.isFocused,
            tabIndex = _props.tabIndex;

        if (tabIndex === 0) {
          if (isFocused || tabIndex !== prevProps.tabIndex) {
            this.buttonRef.focus();
          }
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'onDayClick',
    value: function () {
      function onDayClick(day, e) {
        var onDayClick = this.props.onDayClick;

        onDayClick(day, e);
      }

      return onDayClick;
    }()
  }, {
    key: 'onDayMouseEnter',
    value: function () {
      function onDayMouseEnter(day, e) {
        var onDayMouseEnter = this.props.onDayMouseEnter;

        onDayMouseEnter(day, e);
      }

      return onDayMouseEnter;
    }()
  }, {
    key: 'onDayMouseLeave',
    value: function () {
      function onDayMouseLeave(day, e) {
        var onDayMouseLeave = this.props.onDayMouseLeave;

        onDayMouseLeave(day, e);
      }

      return onDayMouseLeave;
    }()
  }, {
    key: 'setButtonRef',
    value: function () {
      function setButtonRef(ref) {
        this.buttonRef = ref;
      }

      return setButtonRef;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props2 = this.props,
            day = _props2.day,
            daySize = _props2.daySize,
            isOutsideDay = _props2.isOutsideDay,
            modifiers = _props2.modifiers,
            renderDay = _props2.renderDay,
            tabIndex = _props2.tabIndex,
            _props2$phrases = _props2.phrases,
            chooseAvailableDate = _props2$phrases.chooseAvailableDate,
            dateIsUnavailable = _props2$phrases.dateIsUnavailable;

        if (!day) return _react2['default'].createElement('td', null);

        var className = (0, _classnames2['default'])('CalendarDay', {
          'CalendarDay--outside': isOutsideDay
        }, Array.from(modifiers, function (mod) {
          return 'CalendarDay--' + String(mod);
        }));

        var formattedDate = String(day.format('dddd')) + ', ' + String(day.format('LL'));

        var ariaLabel = (0, _getPhrase2['default'])(chooseAvailableDate, {
          date: formattedDate
        });

        if (_constants.BLOCKED_MODIFIER in modifiers && modifiers[_constants.BLOCKED_MODIFIER](day)) {
          ariaLabel = (0, _getPhrase2['default'])(dateIsUnavailable, { date: formattedDate });
        }

        var daySizeStyles = {
          width: daySize,
          height: daySize - 1
        };

        return _react2['default'].createElement('td', { className: className, style: daySizeStyles }, _react2['default'].createElement('button', {
          type: 'button',
          ref: this.setButtonRef,
          className: 'CalendarDay__button',
          'aria-label': ariaLabel,
          onMouseEnter: function () {
            function onMouseEnter(e) {
              _this2.onDayMouseEnter(day, e);
            }

            return onMouseEnter;
          }(),
          onMouseLeave: function () {
            function onMouseLeave(e) {
              _this2.onDayMouseLeave(day, e);
            }

            return onMouseLeave;
          }(),
          onMouseUp: function () {
            function onMouseUp(e) {
              e.currentTarget.blur();
            }

            return onMouseUp;
          }(),
          onClick: function () {
            function onClick(e) {
              _this2.onDayClick(day, e);
            }

            return onClick;
          }(),
          tabIndex: tabIndex
        }, renderDay ? renderDay(day) : day.format('D')));
      }

      return render;
    }()
  }]);

  return CalendarDay;
}(_react2['default'].Component);

exports['default'] = CalendarDay;

CalendarDay.propTypes = propTypes;
CalendarDay.defaultProps = defaultProps;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __webpack_require__(13);

/***/ })

/******/ });

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 62);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __webpack_require__(41);

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = __webpack_require__(103);

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = __webpack_require__(128);

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __webpack_require__(167);

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = __webpack_require__(207);

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __webpack_require__(25);

/***/ }),

/***/ 22:
/***/ (function(module, exports) {

module.exports = __webpack_require__(166);

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __webpack_require__(47);

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __webpack_require__(8);

/***/ }),

/***/ 47:
/***/ (function(module, exports) {

module.exports = __webpack_require__(1466);

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __webpack_require__(59);

/***/ }),

/***/ 51:
/***/ (function(module, exports) {

module.exports = __webpack_require__(608);

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = __webpack_require__(55);

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAddonsShallowCompare = __webpack_require__(14);

var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);

var _reactMomentProptypes = __webpack_require__(10);

var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);

var _airbnbPropTypes = __webpack_require__(1);

var _moment = __webpack_require__(7);

var _moment2 = _interopRequireDefault(_moment);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _defaultPhrases = __webpack_require__(3);

var _getPhrasePropTypes = __webpack_require__(5);

var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);

var _CalendarDay = __webpack_require__(51);

var _CalendarDay2 = _interopRequireDefault(_CalendarDay);

var _getCalendarMonthWeeks = __webpack_require__(47);

var _getCalendarMonthWeeks2 = _interopRequireDefault(_getCalendarMonthWeeks);

var _isSameDay = __webpack_require__(22);

var _isSameDay2 = _interopRequireDefault(_isSameDay);

var _toISODateString = __webpack_require__(13);

var _toISODateString2 = _interopRequireDefault(_toISODateString);

var _ScrollableOrientationShape = __webpack_require__(8);

var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);

var _DayOfWeekShape = __webpack_require__(12);

var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint react/no-array-index-key: 0 */

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
  month: _reactMomentProptypes2['default'].momentObj,
  isVisible: _propTypes2['default'].bool,
  enableOutsideDays: _propTypes2['default'].bool,
  modifiers: _propTypes2['default'].object,
  orientation: _ScrollableOrientationShape2['default'],
  daySize: _airbnbPropTypes.nonNegativeInteger,
  onDayClick: _propTypes2['default'].func,
  onDayMouseEnter: _propTypes2['default'].func,
  onDayMouseLeave: _propTypes2['default'].func,
  renderMonth: _propTypes2['default'].func,
  renderDay: _propTypes2['default'].func,
  firstDayOfWeek: _DayOfWeekShape2['default'],

  focusedDate: _reactMomentProptypes2['default'].momentObj, // indicates focusable day
  isFocused: _propTypes2['default'].bool, // indicates whether or not to move focus to focusable day

  // i18n
  monthFormat: _propTypes2['default'].string,
  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.CalendarDayPhrases))
});

var defaultProps = {
  month: (0, _moment2['default'])(),
  isVisible: true,
  enableOutsideDays: false,
  modifiers: {},
  orientation: _constants.HORIZONTAL_ORIENTATION,
  daySize: _constants.DAY_SIZE,
  onDayClick: function () {
    function onDayClick() {}

    return onDayClick;
  }(),
  onDayMouseEnter: function () {
    function onDayMouseEnter() {}

    return onDayMouseEnter;
  }(),
  onDayMouseLeave: function () {
    function onDayMouseLeave() {}

    return onDayMouseLeave;
  }(),

  renderMonth: null,
  renderDay: null,
  firstDayOfWeek: null,

  focusedDate: null,
  isFocused: false,

  // i18n
  monthFormat: 'MMMM YYYY', // english locale
  phrases: _defaultPhrases.CalendarDayPhrases
};

var CalendarMonth = function (_React$Component) {
  _inherits(CalendarMonth, _React$Component);

  function CalendarMonth(props) {
    _classCallCheck(this, CalendarMonth);

    var _this = _possibleConstructorReturn(this, (CalendarMonth.__proto__ || Object.getPrototypeOf(CalendarMonth)).call(this, props));

    _this.state = {
      weeks: (0, _getCalendarMonthWeeks2['default'])(props.month, props.enableOutsideDays, props.firstDayOfWeek == null ? _moment2['default'].localeData().firstDayOfWeek() : props.firstDayOfWeek)
    };
    return _this;
  }

  _createClass(CalendarMonth, [{
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(nextProps) {
        var month = nextProps.month,
            enableOutsideDays = nextProps.enableOutsideDays,
            firstDayOfWeek = nextProps.firstDayOfWeek;

        if (!month.isSame(this.props.month) || enableOutsideDays !== this.props.enableOutsideDays || firstDayOfWeek !== this.props.firstDayOfWeek) {
          this.setState({
            weeks: (0, _getCalendarMonthWeeks2['default'])(month, enableOutsideDays, firstDayOfWeek == null ? _moment2['default'].localeData().firstDayOfWeek() : firstDayOfWeek)
          });
        }
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'shouldComponentUpdate',
    value: function () {
      function shouldComponentUpdate(nextProps, nextState) {
        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
      }

      return shouldComponentUpdate;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            month = _props.month,
            monthFormat = _props.monthFormat,
            orientation = _props.orientation,
            isVisible = _props.isVisible,
            modifiers = _props.modifiers,
            onDayClick = _props.onDayClick,
            onDayMouseEnter = _props.onDayMouseEnter,
            onDayMouseLeave = _props.onDayMouseLeave,
            renderMonth = _props.renderMonth,
            renderDay = _props.renderDay,
            daySize = _props.daySize,
            focusedDate = _props.focusedDate,
            isFocused = _props.isFocused,
            phrases = _props.phrases;
        var weeks = this.state.weeks;

        var monthTitle = renderMonth ? renderMonth(month) : month.format(monthFormat);

        var calendarMonthClasses = (0, _classnames2['default'])('CalendarMonth', {
          'CalendarMonth--horizontal': orientation === _constants.HORIZONTAL_ORIENTATION,
          'CalendarMonth--vertical': orientation === _constants.VERTICAL_ORIENTATION,
          'CalendarMonth--vertical-scrollable': orientation === _constants.VERTICAL_SCROLLABLE
        });

        return _react2['default'].createElement('div', { className: calendarMonthClasses, 'data-visible': isVisible }, _react2['default'].createElement('div', {
          id: 'CalendarMonth__caption',
          className: 'CalendarMonth__caption js-CalendarMonth__caption'
        }, _react2['default'].createElement('strong', null, monthTitle)), _react2['default'].createElement('table', { role: 'presentation' }, _react2['default'].createElement('tbody', { className: 'js-CalendarMonth__grid' }, weeks.map(function (week, i) {
          return _react2['default'].createElement('tr', { key: i }, week.map(function (day, dayOfWeek) {
            return _react2['default'].createElement(_CalendarDay2['default'], {
              day: day,
              daySize: daySize,
              isOutsideDay: !day || day.month() !== month.month(),
              tabIndex: isVisible && (0, _isSameDay2['default'])(day, focusedDate) ? 0 : -1,
              isFocused: isFocused,
              key: dayOfWeek,
              onDayMouseEnter: onDayMouseEnter,
              onDayMouseLeave: onDayMouseLeave,
              onDayClick: onDayClick,
              renderDay: renderDay,
              phrases: phrases,
              modifiers: modifiers[(0, _toISODateString2['default'])(day)]
            });
          }));
        }))));
      }

      return render;
    }()
  }]);

  return CalendarMonth;
}(_react2['default'].Component);

exports['default'] = CalendarMonth;

CalendarMonth.propTypes = propTypes;
CalendarMonth.defaultProps = defaultProps;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __webpack_require__(13);

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = __webpack_require__(165);

/***/ })

/******/ });

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 63);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(41);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(25);

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(47);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(8);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(59);

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(55);

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(13);

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(165);

/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(103);

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(128);

/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(207);

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(229);

/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(209);

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(269);

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(267);

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(622);

/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(624);

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(1469);

/***/ }),
/* 51 */,
/* 52 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(609);

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _object = __webpack_require__(24);

var _object2 = _interopRequireDefault(_object);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAddonsShallowCompare = __webpack_require__(14);

var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);

var _reactMomentProptypes = __webpack_require__(10);

var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);

var _airbnbPropTypes = __webpack_require__(1);

var _moment = __webpack_require__(7);

var _moment2 = _interopRequireDefault(_moment);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _consolidatedEvents = __webpack_require__(18);

var _defaultPhrases = __webpack_require__(3);

var _getPhrasePropTypes = __webpack_require__(5);

var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);

var _CalendarMonth = __webpack_require__(52);

var _CalendarMonth2 = _interopRequireDefault(_CalendarMonth);

var _isTransitionEndSupported = __webpack_require__(50);

var _isTransitionEndSupported2 = _interopRequireDefault(_isTransitionEndSupported);

var _getTransformStyles = __webpack_require__(30);

var _getTransformStyles2 = _interopRequireDefault(_getTransformStyles);

var _getCalendarMonthWidth = __webpack_require__(28);

var _getCalendarMonthWidth2 = _interopRequireDefault(_getCalendarMonthWidth);

var _toISOMonthString = __webpack_require__(23);

var _toISOMonthString2 = _interopRequireDefault(_toISOMonthString);

var _isAfterDay = __webpack_require__(20);

var _isAfterDay2 = _interopRequireDefault(_isAfterDay);

var _ScrollableOrientationShape = __webpack_require__(8);

var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);

var _DayOfWeekShape = __webpack_require__(12);

var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
  enableOutsideDays: _propTypes2['default'].bool,
  firstVisibleMonthIndex: _propTypes2['default'].number,
  initialMonth: _reactMomentProptypes2['default'].momentObj,
  isAnimating: _propTypes2['default'].bool,
  numberOfMonths: _propTypes2['default'].number,
  modifiers: _propTypes2['default'].object,
  orientation: _ScrollableOrientationShape2['default'],
  onDayClick: _propTypes2['default'].func,
  onDayMouseEnter: _propTypes2['default'].func,
  onDayMouseLeave: _propTypes2['default'].func,
  onMonthTransitionEnd: _propTypes2['default'].func,
  renderMonth: _propTypes2['default'].func,
  renderDay: _propTypes2['default'].func,
  transformValue: _propTypes2['default'].string,
  daySize: _airbnbPropTypes.nonNegativeInteger,
  focusedDate: _reactMomentProptypes2['default'].momentObj, // indicates focusable day
  isFocused: _propTypes2['default'].bool, // indicates whether or not to move focus to focusable day
  firstDayOfWeek: _DayOfWeekShape2['default'],

  // i18n
  monthFormat: _propTypes2['default'].string,
  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.CalendarDayPhrases))
});

var defaultProps = {
  enableOutsideDays: false,
  firstVisibleMonthIndex: 0,
  initialMonth: (0, _moment2['default'])(),
  isAnimating: false,
  numberOfMonths: 1,
  modifiers: {},
  orientation: _constants.HORIZONTAL_ORIENTATION,
  onDayClick: function () {
    function onDayClick() {}

    return onDayClick;
  }(),
  onDayMouseEnter: function () {
    function onDayMouseEnter() {}

    return onDayMouseEnter;
  }(),
  onDayMouseLeave: function () {
    function onDayMouseLeave() {}

    return onDayMouseLeave;
  }(),
  onMonthTransitionEnd: function () {
    function onMonthTransitionEnd() {}

    return onMonthTransitionEnd;
  }(),

  renderMonth: null,
  renderDay: null,
  transformValue: 'none',
  daySize: _constants.DAY_SIZE,
  focusedDate: null,
  isFocused: false,
  firstDayOfWeek: null,

  // i18n
  monthFormat: 'MMMM YYYY', // english locale
  phrases: _defaultPhrases.CalendarDayPhrases
};

function getMonths(initialMonth, numberOfMonths, withoutTransitionMonths) {
  var month = initialMonth.clone();
  if (!withoutTransitionMonths) month = month.subtract(1, 'month');

  var months = [];
  for (var i = 0; i < (withoutTransitionMonths ? numberOfMonths : numberOfMonths + 2); i += 1) {
    months.push(month);
    month = month.clone().add(1, 'month');
  }

  return months;
}

var CalendarMonthGrid = function (_React$Component) {
  _inherits(CalendarMonthGrid, _React$Component);

  function CalendarMonthGrid(props) {
    _classCallCheck(this, CalendarMonthGrid);

    var _this = _possibleConstructorReturn(this, (CalendarMonthGrid.__proto__ || Object.getPrototypeOf(CalendarMonthGrid)).call(this, props));

    var withoutTransitionMonths = props.orientation === _constants.VERTICAL_SCROLLABLE;
    _this.state = {
      months: getMonths(props.initialMonth, props.numberOfMonths, withoutTransitionMonths)
    };

    _this.isTransitionEndSupported = (0, _isTransitionEndSupported2['default'])();
    _this.onTransitionEnd = _this.onTransitionEnd.bind(_this);
    _this.setContainerRef = _this.setContainerRef.bind(_this);
    return _this;
  }

  _createClass(CalendarMonthGrid, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        this.eventHandle = (0, _consolidatedEvents.addEventListener)(this.container, 'transitionend', this.onTransitionEnd);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(nextProps) {
        var initialMonth = nextProps.initialMonth,
            numberOfMonths = nextProps.numberOfMonths,
            orientation = nextProps.orientation;
        var months = this.state.months;

        var hasMonthChanged = !this.props.initialMonth.isSame(initialMonth, 'month');
        var hasNumberOfMonthsChanged = this.props.numberOfMonths !== numberOfMonths;
        var newMonths = months;

        if (hasMonthChanged && !hasNumberOfMonthsChanged) {
          if ((0, _isAfterDay2['default'])(initialMonth, this.props.initialMonth)) {
            newMonths = months.slice(1);
            newMonths.push(months[months.length - 1].clone().add(1, 'month'));
          } else {
            newMonths = months.slice(0, months.length - 1);
            newMonths.unshift(months[0].clone().subtract(1, 'month'));
          }
        }

        if (hasNumberOfMonthsChanged) {
          var withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
          newMonths = getMonths(initialMonth, numberOfMonths, withoutTransitionMonths);
        }

        this.setState({
          months: newMonths
        });
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'shouldComponentUpdate',
    value: function () {
      function shouldComponentUpdate(nextProps, nextState) {
        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
      }

      return shouldComponentUpdate;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate() {
        var _props = this.props,
            isAnimating = _props.isAnimating,
            onMonthTransitionEnd = _props.onMonthTransitionEnd;

        // For IE9, immediately call onMonthTransitionEnd instead of
        // waiting for the animation to complete

        if (!this.isTransitionEndSupported && isAnimating) {
          onMonthTransitionEnd();
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        (0, _consolidatedEvents.removeEventListener)(this.eventHandle);
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'onTransitionEnd',
    value: function () {
      function onTransitionEnd() {
        this.props.onMonthTransitionEnd();
      }

      return onTransitionEnd;
    }()
  }, {
    key: 'setContainerRef',
    value: function () {
      function setContainerRef(ref) {
        this.container = ref;
      }

      return setContainerRef;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props2 = this.props,
            enableOutsideDays = _props2.enableOutsideDays,
            firstVisibleMonthIndex = _props2.firstVisibleMonthIndex,
            isAnimating = _props2.isAnimating,
            modifiers = _props2.modifiers,
            numberOfMonths = _props2.numberOfMonths,
            monthFormat = _props2.monthFormat,
            orientation = _props2.orientation,
            transformValue = _props2.transformValue,
            daySize = _props2.daySize,
            onDayMouseEnter = _props2.onDayMouseEnter,
            onDayMouseLeave = _props2.onDayMouseLeave,
            onDayClick = _props2.onDayClick,
            renderMonth = _props2.renderMonth,
            renderDay = _props2.renderDay,
            onMonthTransitionEnd = _props2.onMonthTransitionEnd,
            firstDayOfWeek = _props2.firstDayOfWeek,
            focusedDate = _props2.focusedDate,
            isFocused = _props2.isFocused,
            phrases = _props2.phrases;
        var months = this.state.months;

        var isVertical = orientation === _constants.VERTICAL_ORIENTATION;
        var isVerticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;
        var isHorizontal = orientation === _constants.HORIZONTAL_ORIENTATION;

        var className = (0, _classnames2['default'])('CalendarMonthGrid', {
          'CalendarMonthGrid--horizontal': isHorizontal,
          'CalendarMonthGrid--vertical': isVertical,
          'CalendarMonthGrid--vertical-scrollable': isVerticalScrollable,
          'CalendarMonthGrid--animating': isAnimating
        });

        var calendarMonthWidth = (0, _getCalendarMonthWidth2['default'])(daySize);

        var width = isVertical || isVerticalScrollable ? calendarMonthWidth : (numberOfMonths + 2) * calendarMonthWidth;

        var style = (0, _object2['default'])({}, (0, _getTransformStyles2['default'])(transformValue), {
          width: width
        });

        return _react2['default'].createElement('div', {
          ref: this.setContainerRef,
          className: className,
          style: style,
          onTransitionEnd: onMonthTransitionEnd
        }, months.map(function (month, i) {
          var isVisible = i >= firstVisibleMonthIndex && i < firstVisibleMonthIndex + numberOfMonths;
          var monthString = (0, _toISOMonthString2['default'])(month);
          return _react2['default'].createElement(_CalendarMonth2['default'], {
            key: monthString,
            month: month,
            isVisible: isVisible,
            enableOutsideDays: enableOutsideDays,
            modifiers: modifiers[monthString],
            monthFormat: monthFormat,
            orientation: orientation,
            onDayMouseEnter: onDayMouseEnter,
            onDayMouseLeave: onDayMouseLeave,
            onDayClick: onDayClick,
            renderMonth: renderMonth,
            renderDay: renderDay,
            firstDayOfWeek: firstDayOfWeek,
            daySize: daySize,
            focusedDate: isVisible ? focusedDate : null,
            isFocused: isFocused,
            phrases: phrases
          });
        }));
      }

      return render;
    }()
  }]);

  return CalendarMonthGrid;
}(_react2['default'].Component);

exports['default'] = CalendarMonthGrid;

CalendarMonthGrid.propTypes = propTypes;
CalendarMonthGrid.defaultProps = defaultProps;

/***/ })
/******/ ]);

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 64);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __webpack_require__(41);

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = __webpack_require__(164);

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __webpack_require__(25);

/***/ }),

/***/ 37:
/***/ (function(module, exports) {

module.exports = __webpack_require__(582);

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __webpack_require__(8);

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = __webpack_require__(55);

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _airbnbPropTypes = __webpack_require__(1);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _throttle = __webpack_require__(37);

var _throttle2 = _interopRequireDefault(_throttle);

var _isTouchDevice = __webpack_require__(9);

var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);

var _OpenDirectionShape = __webpack_require__(15);

var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
  id: _propTypes2['default'].string.isRequired,
  placeholder: _propTypes2['default'].string, // also used as label
  displayValue: _propTypes2['default'].string,
  inputValue: _propTypes2['default'].string,
  screenReaderMessage: _propTypes2['default'].string,
  focused: _propTypes2['default'].bool,
  disabled: _propTypes2['default'].bool,
  required: _propTypes2['default'].bool,
  readOnly: _propTypes2['default'].bool,
  openDirection: _OpenDirectionShape2['default'],
  showCaret: _propTypes2['default'].bool,

  onChange: _propTypes2['default'].func,
  onFocus: _propTypes2['default'].func,
  onKeyDownShiftTab: _propTypes2['default'].func,
  onKeyDownTab: _propTypes2['default'].func,

  onKeyDownArrowDown: _propTypes2['default'].func,
  onKeyDownQuestionMark: _propTypes2['default'].func,

  // accessibility
  isFocused: _propTypes2['default'].bool // describes actual DOM focus
});

var defaultProps = {
  placeholder: 'Select Date',
  displayValue: '',
  inputValue: '',
  screenReaderMessage: '',
  focused: false,
  disabled: false,
  required: false,
  readOnly: null,
  openDirection: _constants.OPEN_DOWN,
  showCaret: false,

  onChange: function () {
    function onChange() {}

    return onChange;
  }(),
  onFocus: function () {
    function onFocus() {}

    return onFocus;
  }(),
  onKeyDownShiftTab: function () {
    function onKeyDownShiftTab() {}

    return onKeyDownShiftTab;
  }(),
  onKeyDownTab: function () {
    function onKeyDownTab() {}

    return onKeyDownTab;
  }(),
  onKeyDownArrowDown: function () {
    function onKeyDownArrowDown() {}

    return onKeyDownArrowDown;
  }(),
  onKeyDownQuestionMark: function () {
    function onKeyDownQuestionMark() {}

    return onKeyDownQuestionMark;
  }(),

  // accessibility
  isFocused: false
};

var DateInput = function (_React$Component) {
  _inherits(DateInput, _React$Component);

  function DateInput(props) {
    _classCallCheck(this, DateInput);

    var _this = _possibleConstructorReturn(this, (DateInput.__proto__ || Object.getPrototypeOf(DateInput)).call(this, props));

    _this.state = {
      dateString: '',
      isTouchDevice: false
    };

    _this.onChange = _this.onChange.bind(_this);
    _this.onKeyDown = _this.onKeyDown.bind(_this);
    _this.setInputRef = _this.setInputRef.bind(_this);
    return _this;
  }

  _createClass(DateInput, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        this.setState({ isTouchDevice: (0, _isTouchDevice2['default'])() });
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(nextProps) {
        if (!this.props.displayValue && nextProps.displayValue) {
          this.setState({
            dateString: ''
          });
        }
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps) {
        var _props = this.props,
            focused = _props.focused,
            isFocused = _props.isFocused;

        if (prevProps.focused === focused && prevProps.isFocused === isFocused) return;

        if (focused && isFocused) {
          this.inputRef.focus();
          this.inputRef.select();
        } else {
          this.inputRef.blur();
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'onChange',
    value: function () {
      function onChange(e) {
        var _props2 = this.props,
            onChange = _props2.onChange,
            onKeyDownQuestionMark = _props2.onKeyDownQuestionMark;

        var dateString = e.target.value;

        // In Safari, onKeyDown does not consistently fire ahead of onChange. As a result, we need to
        // special case the `?` key so that it always triggers the appropriate callback, instead of
        // modifying the input value
        if (dateString[dateString.length - 1] === '?') {
          onKeyDownQuestionMark(e);
        } else {
          this.setState({ dateString: dateString });
          onChange(dateString);
        }
      }

      return onChange;
    }()
  }, {
    key: 'onKeyDown',
    value: function () {
      function onKeyDown(e) {
        e.stopPropagation();

        var _props3 = this.props,
            onKeyDownShiftTab = _props3.onKeyDownShiftTab,
            onKeyDownTab = _props3.onKeyDownTab,
            onKeyDownArrowDown = _props3.onKeyDownArrowDown,
            onKeyDownQuestionMark = _props3.onKeyDownQuestionMark;
        var key = e.key;

        if (key === 'Tab') {
          if (e.shiftKey) {
            onKeyDownShiftTab(e);
          } else {
            onKeyDownTab(e);
          }
        } else if (key === 'ArrowDown') {
          onKeyDownArrowDown(e);
        } else if (key === '?') {
          e.preventDefault();
          onKeyDownQuestionMark(e);
        }
      }

      return onKeyDown;
    }()
  }, {
    key: 'setInputRef',
    value: function () {
      function setInputRef(ref) {
        this.inputRef = ref;
      }

      return setInputRef;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _state = this.state,
            dateString = _state.dateString,
            isTouch = _state.isTouchDevice;
        var _props4 = this.props,
            id = _props4.id,
            placeholder = _props4.placeholder,
            displayValue = _props4.displayValue,
            inputValue = _props4.inputValue,
            screenReaderMessage = _props4.screenReaderMessage,
            focused = _props4.focused,
            showCaret = _props4.showCaret,
            onFocus = _props4.onFocus,
            disabled = _props4.disabled,
            required = _props4.required,
            readOnly = _props4.readOnly,
            openDirection = _props4.openDirection;

        var displayText = displayValue || inputValue || dateString || placeholder || '';
        var value = inputValue || displayValue || dateString || '';
        var screenReaderMessageId = 'DateInput__screen-reader-message-' + String(id);

        return _react2['default'].createElement('div', {
          className: (0, _classnames2['default'])('DateInput', {
            'DateInput--with-caret': showCaret && focused,
            'DateInput--disabled': disabled,
            'DateInput--open-down': openDirection === _constants.OPEN_DOWN,
            'DateInput--open-up': openDirection === _constants.OPEN_UP
          })
        }, _react2['default'].createElement('input', {
          'aria-label': placeholder,
          className: 'DateInput__input needsclick',
          type: 'text',
          id: id,
          name: id,
          ref: this.setInputRef,
          value: value,
          onChange: this.onChange,
          onKeyDown: (0, _throttle2['default'])(this.onKeyDown, 300),
          onFocus: onFocus,
          placeholder: placeholder,
          autoComplete: 'off',
          disabled: disabled,
          readOnly: typeof readOnly === 'boolean' ? readOnly : isTouch,
          required: required,
          'aria-describedby': screenReaderMessage && screenReaderMessageId
        }), screenReaderMessage && _react2['default'].createElement('p', { id: screenReaderMessageId, className: 'screen-reader-only' }, screenReaderMessage), _react2['default'].createElement('div', {
          className: (0, _classnames2['default'])('DateInput__display-text', {
            'DateInput__display-text--has-input': !!value,
            'DateInput__display-text--focused': focused,
            'DateInput__display-text--disabled': disabled
          })
        }, displayText));
      }

      return render;
    }()
  }]);

  return DateInput;
}(_react2['default'].Component);

exports['default'] = DateInput;

DateInput.propTypes = propTypes;
DateInput.defaultProps = defaultProps;

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = __webpack_require__(152);

/***/ })

/******/ });

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 66);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __webpack_require__(41);

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function () {
      function render() {
        return _react2["default"].createElement(
          "svg",
          _extends({ viewBox: "0 0 12 12" }, this.props),
          _react2["default"].createElement("path", { fillRule: "evenodd", d: "M11.53.47a.75.75 0 0 0-1.061 0l-4.47 4.47L1.529.47A.75.75 0 1 0 .468 1.531l4.47 4.47-4.47 4.47a.75.75 0 1 0 1.061 1.061l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.061-1.061l-4.47-4.47 4.47-4.47a.75.75 0 0 0 0-1.061z" })
        );
      }

      return render;
    }()
  }]);

  return SVG;
}(_react2["default"].Component);

exports["default"] = SVG;

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = __webpack_require__(164);

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

module.exports = __webpack_require__(208);

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __webpack_require__(25);

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function () {
      function render() {
        return _react2["default"].createElement(
          "svg",
          _extends({ viewBox: "0 0 1000 1000" }, this.props),
          _react2["default"].createElement("path", { d: "M336.2 274.5l-210.1 210h805.4c13 0 23 10 23 23s-10 23-23 23H126.1l210.1 210.1c11 11 11 21 0 32-5 5-10 7-16 7s-11-2-16-7l-249.1-249c-11-11-11-21 0-32l249.1-249.1c21-21.1 53 10.9 32 32z" })
        );
      }

      return render;
    }()
  }]);

  return SVG;
}(_react2["default"].Component);

exports["default"] = SVG;

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function () {
      function render() {
        return _react2["default"].createElement(
          "svg",
          _extends({ viewBox: "0 0 1000 1000" }, this.props),
          _react2["default"].createElement("path", { d: "M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z" })
        );
      }

      return render;
    }()
  }]);

  return SVG;
}(_react2["default"].Component);

exports["default"] = SVG;

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function () {
      function render() {
        return _react2["default"].createElement(
          "svg",
          _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1393.1 1500" }, this.props),
          _react2["default"].createElement("path", { d: "M107.2 1392.9h241.1v-241.1H107.2v241.1zm294.7 0h267.9v-241.1H401.9v241.1zm-294.7-294.7h241.1V830.4H107.2v267.8zm294.7 0h267.9V830.4H401.9v267.8zM107.2 776.8h241.1V535.7H107.2v241.1zm616.2 616.1h267.9v-241.1H723.4v241.1zM401.9 776.8h267.9V535.7H401.9v241.1zm642.9 616.1H1286v-241.1h-241.1v241.1zm-321.4-294.7h267.9V830.4H723.4v267.8zM428.7 375V133.9c0-7.3-2.7-13.5-8-18.8-5.3-5.3-11.6-8-18.8-8h-53.6c-7.3 0-13.5 2.7-18.8 8-5.3 5.3-8 11.6-8 18.8V375c0 7.3 2.7 13.5 8 18.8 5.3 5.3 11.6 8 18.8 8h53.6c7.3 0 13.5-2.7 18.8-8 5.3-5.3 8-11.5 8-18.8zm616.1 723.2H1286V830.4h-241.1v267.8zM723.4 776.8h267.9V535.7H723.4v241.1zm321.4 0H1286V535.7h-241.1v241.1zm26.8-401.8V133.9c0-7.3-2.7-13.5-8-18.8-5.3-5.3-11.6-8-18.8-8h-53.6c-7.3 0-13.5 2.7-18.8 8-5.3 5.3-8 11.6-8 18.8V375c0 7.3 2.7 13.5 8 18.8 5.3 5.3 11.6 8 18.8 8h53.6c7.3 0 13.5-2.7 18.8-8 5.4-5.3 8-11.5 8-18.8zm321.5-53.6v1071.4c0 29-10.6 54.1-31.8 75.3-21.2 21.2-46.3 31.8-75.3 31.8H107.2c-29 0-54.1-10.6-75.3-31.8C10.6 1447 0 1421.9 0 1392.9V321.4c0-29 10.6-54.1 31.8-75.3s46.3-31.8 75.3-31.8h107.2v-80.4c0-36.8 13.1-68.4 39.3-94.6S311.4 0 348.3 0h53.6c36.8 0 68.4 13.1 94.6 39.3 26.2 26.2 39.3 57.8 39.3 94.6v80.4h321.5v-80.4c0-36.8 13.1-68.4 39.3-94.6C922.9 13.1 954.4 0 991.3 0h53.6c36.8 0 68.4 13.1 94.6 39.3s39.3 57.8 39.3 94.6v80.4H1286c29 0 54.1 10.6 75.3 31.8 21.2 21.2 31.8 46.3 31.8 75.3z" })
        );
      }

      return render;
    }()
  }]);

  return SVG;
}(_react2["default"].Component);

exports["default"] = SVG;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __webpack_require__(47);

/***/ }),

/***/ 35:
/***/ (function(module, exports) {

module.exports = __webpack_require__(611);

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __webpack_require__(8);

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __webpack_require__(59);

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = __webpack_require__(55);

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _airbnbPropTypes = __webpack_require__(1);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _defaultPhrases = __webpack_require__(3);

var _getPhrasePropTypes = __webpack_require__(5);

var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);

var _OpenDirectionShape = __webpack_require__(15);

var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);

var _DateInput = __webpack_require__(35);

var _DateInput2 = _interopRequireDefault(_DateInput);

var _IconPositionShape = __webpack_require__(19);

var _IconPositionShape2 = _interopRequireDefault(_IconPositionShape);

var _arrowRight = __webpack_require__(26);

var _arrowRight2 = _interopRequireDefault(_arrowRight);

var _arrowLeft = __webpack_require__(25);

var _arrowLeft2 = _interopRequireDefault(_arrowLeft);

var _close = __webpack_require__(11);

var _close2 = _interopRequireDefault(_close);

var _calendar = __webpack_require__(27);

var _calendar2 = _interopRequireDefault(_calendar);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
  startDateId: _propTypes2['default'].string,
  startDatePlaceholderText: _propTypes2['default'].string,
  screenReaderMessage: _propTypes2['default'].string,

  endDateId: _propTypes2['default'].string,
  endDatePlaceholderText: _propTypes2['default'].string,

  onStartDateFocus: _propTypes2['default'].func,
  onEndDateFocus: _propTypes2['default'].func,
  onStartDateChange: _propTypes2['default'].func,
  onEndDateChange: _propTypes2['default'].func,
  onStartDateShiftTab: _propTypes2['default'].func,
  onEndDateTab: _propTypes2['default'].func,
  onClearDates: _propTypes2['default'].func,
  onArrowDown: _propTypes2['default'].func,
  onQuestionMark: _propTypes2['default'].func,

  startDate: _propTypes2['default'].string,
  startDateValue: _propTypes2['default'].string,
  endDate: _propTypes2['default'].string,
  endDateValue: _propTypes2['default'].string,

  isStartDateFocused: _propTypes2['default'].bool,
  isEndDateFocused: _propTypes2['default'].bool,
  showClearDates: _propTypes2['default'].bool,
  disabled: _propTypes2['default'].bool,
  required: _propTypes2['default'].bool,
  readOnly: _propTypes2['default'].bool,
  openDirection: _OpenDirectionShape2['default'],
  showCaret: _propTypes2['default'].bool,
  showDefaultInputIcon: _propTypes2['default'].bool,
  inputIconPosition: _IconPositionShape2['default'],
  customInputIcon: _propTypes2['default'].node,
  customArrowIcon: _propTypes2['default'].node,
  customCloseIcon: _propTypes2['default'].node,

  // accessibility
  isFocused: _propTypes2['default'].bool, // describes actual DOM focus

  // i18n
  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DateRangePickerInputPhrases)),

  isRTL: _propTypes2['default'].bool
});

var defaultProps = {
  startDateId: _constants.START_DATE,
  endDateId: _constants.END_DATE,
  startDatePlaceholderText: 'Start Date',
  endDatePlaceholderText: 'End Date',
  screenReaderMessage: '',
  onStartDateFocus: function () {
    function onStartDateFocus() {}

    return onStartDateFocus;
  }(),
  onEndDateFocus: function () {
    function onEndDateFocus() {}

    return onEndDateFocus;
  }(),
  onStartDateChange: function () {
    function onStartDateChange() {}

    return onStartDateChange;
  }(),
  onEndDateChange: function () {
    function onEndDateChange() {}

    return onEndDateChange;
  }(),
  onStartDateShiftTab: function () {
    function onStartDateShiftTab() {}

    return onStartDateShiftTab;
  }(),
  onEndDateTab: function () {
    function onEndDateTab() {}

    return onEndDateTab;
  }(),
  onClearDates: function () {
    function onClearDates() {}

    return onClearDates;
  }(),
  onArrowDown: function () {
    function onArrowDown() {}

    return onArrowDown;
  }(),
  onQuestionMark: function () {
    function onQuestionMark() {}

    return onQuestionMark;
  }(),

  startDate: '',
  startDateValue: '',
  endDate: '',
  endDateValue: '',

  isStartDateFocused: false,
  isEndDateFocused: false,
  showClearDates: false,
  disabled: false,
  required: false,
  readOnly: false,
  openDirection: _constants.OPEN_DOWN,
  showCaret: false,
  showDefaultInputIcon: false,
  inputIconPosition: _constants.ICON_BEFORE_POSITION,
  customInputIcon: null,
  customArrowIcon: null,
  customCloseIcon: null,

  // accessibility
  isFocused: false,

  // i18n
  phrases: _defaultPhrases.DateRangePickerInputPhrases,

  isRTL: false
};

var DateRangePickerInput = function (_React$Component) {
  _inherits(DateRangePickerInput, _React$Component);

  function DateRangePickerInput(props) {
    _classCallCheck(this, DateRangePickerInput);

    var _this = _possibleConstructorReturn(this, (DateRangePickerInput.__proto__ || Object.getPrototypeOf(DateRangePickerInput)).call(this, props));

    _this.state = {
      isClearDatesHovered: false
    };

    _this.onClearDatesMouseEnter = _this.onClearDatesMouseEnter.bind(_this);
    _this.onClearDatesMouseLeave = _this.onClearDatesMouseLeave.bind(_this);
    return _this;
  }

  _createClass(DateRangePickerInput, [{
    key: 'onClearDatesMouseEnter',
    value: function () {
      function onClearDatesMouseEnter() {
        this.setState({
          isClearDatesHovered: true
        });
      }

      return onClearDatesMouseEnter;
    }()
  }, {
    key: 'onClearDatesMouseLeave',
    value: function () {
      function onClearDatesMouseLeave() {
        this.setState({
          isClearDatesHovered: false
        });
      }

      return onClearDatesMouseLeave;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var isClearDatesHovered = this.state.isClearDatesHovered;
        var _props = this.props,
            startDate = _props.startDate,
            startDateValue = _props.startDateValue,
            startDateId = _props.startDateId,
            startDatePlaceholderText = _props.startDatePlaceholderText,
            screenReaderMessage = _props.screenReaderMessage,
            isStartDateFocused = _props.isStartDateFocused,
            onStartDateChange = _props.onStartDateChange,
            onStartDateFocus = _props.onStartDateFocus,
            onStartDateShiftTab = _props.onStartDateShiftTab,
            endDate = _props.endDate,
            endDateValue = _props.endDateValue,
            endDateId = _props.endDateId,
            endDatePlaceholderText = _props.endDatePlaceholderText,
            isEndDateFocused = _props.isEndDateFocused,
            onEndDateChange = _props.onEndDateChange,
            onEndDateFocus = _props.onEndDateFocus,
            onEndDateTab = _props.onEndDateTab,
            onArrowDown = _props.onArrowDown,
            onQuestionMark = _props.onQuestionMark,
            onClearDates = _props.onClearDates,
            showClearDates = _props.showClearDates,
            disabled = _props.disabled,
            required = _props.required,
            readOnly = _props.readOnly,
            openDirection = _props.openDirection,
            showCaret = _props.showCaret,
            showDefaultInputIcon = _props.showDefaultInputIcon,
            inputIconPosition = _props.inputIconPosition,
            customInputIcon = _props.customInputIcon,
            customArrowIcon = _props.customArrowIcon,
            customCloseIcon = _props.customCloseIcon,
            isFocused = _props.isFocused,
            phrases = _props.phrases,
            isRTL = _props.isRTL;

        var calendarIcon = customInputIcon || _react2['default'].createElement(_calendar2['default'], null);
        var arrowIcon = customArrowIcon || (isRTL ? _react2['default'].createElement(_arrowLeft2['default'], null) : _react2['default'].createElement(_arrowRight2['default'], null));
        var closeIcon = customCloseIcon || _react2['default'].createElement(_close2['default'], null);
        var screenReaderText = screenReaderMessage || phrases.keyboardNavigationInstructions;
        var inputIcon = (showDefaultInputIcon || customInputIcon !== null) && _react2['default'].createElement('button', {
          type: 'button',
          className: 'DateRangePickerInput__calendar-icon',
          disabled: disabled,
          'aria-label': phrases.focusStartDate,
          onClick: onArrowDown
        }, calendarIcon);

        return _react2['default'].createElement('div', {
          className: (0, _classnames2['default'])('DateRangePickerInput', {
            'DateRangePickerInput--disabled': disabled,
            'DateRangePickerInput--rtl': isRTL
          })
        }, inputIconPosition === _constants.ICON_BEFORE_POSITION && inputIcon, _react2['default'].createElement(_DateInput2['default'], {
          id: startDateId,
          placeholder: startDatePlaceholderText,
          displayValue: startDate,
          inputValue: startDateValue,
          screenReaderMessage: screenReaderText,
          focused: isStartDateFocused,
          isFocused: isFocused,
          disabled: disabled,
          required: required,
          readOnly: readOnly,
          openDirection: openDirection,
          showCaret: showCaret,

          onChange: onStartDateChange,
          onFocus: onStartDateFocus,
          onKeyDownShiftTab: onStartDateShiftTab,
          onKeyDownArrowDown: onArrowDown,
          onKeyDownQuestionMark: onQuestionMark
        }), _react2['default'].createElement('div', {
          className: 'DateRangePickerInput__arrow',
          'aria-hidden': 'true',
          role: 'presentation'
        }, arrowIcon), _react2['default'].createElement(_DateInput2['default'], {
          id: endDateId,
          placeholder: endDatePlaceholderText,
          displayValue: endDate,
          inputValue: endDateValue,
          screenReaderMessage: screenReaderText,
          focused: isEndDateFocused,
          isFocused: isFocused,
          disabled: disabled,
          required: required,
          readOnly: readOnly,
          openDirection: openDirection,
          showCaret: showCaret,

          onChange: onEndDateChange,
          onFocus: onEndDateFocus,
          onKeyDownTab: onEndDateTab,
          onKeyDownArrowDown: onArrowDown,
          onKeyDownQuestionMark: onQuestionMark
        }), showClearDates && _react2['default'].createElement('button', {
          type: 'button',
          'aria-label': phrases.clearDates,
          className: (0, _classnames2['default'])('DateRangePickerInput__clear-dates', {
            'DateRangePickerInput__clear-dates--hide': !(startDate || endDate),
            'DateRangePickerInput__clear-dates--hover': isClearDatesHovered
          }),
          disabled: disabled,
          onMouseEnter: this.onClearDatesMouseEnter,
          onMouseLeave: this.onClearDatesMouseLeave,
          onClick: onClearDates
        }, _react2['default'].createElement('div', { className: 'DateRangePickerInput__close-icon' }, closeIcon)), inputIconPosition === _constants.ICON_AFTER_POSITION && inputIcon);
      }

      return render;
    }()
  }]);

  return DateRangePickerInput;
}(_react2['default'].Component);

exports['default'] = DateRangePickerInput;

DateRangePickerInput.propTypes = propTypes;
DateRangePickerInput.defaultProps = defaultProps;

/***/ })

/******/ });

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 67);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __webpack_require__(41);

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = __webpack_require__(103);

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __webpack_require__(167);

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = __webpack_require__(164);

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = __webpack_require__(211);

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

module.exports = __webpack_require__(208);

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __webpack_require__(25);

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __webpack_require__(47);

/***/ }),

/***/ 32:
/***/ (function(module, exports) {

module.exports = __webpack_require__(210);

/***/ }),

/***/ 33:
/***/ (function(module, exports) {

module.exports = __webpack_require__(382);

/***/ }),

/***/ 34:
/***/ (function(module, exports) {

module.exports = __webpack_require__(168);

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __webpack_require__(8);

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __webpack_require__(59);

/***/ }),

/***/ 54:
/***/ (function(module, exports) {

module.exports = __webpack_require__(612);

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(7);

var _moment2 = _interopRequireDefault(_moment);

var _reactMomentProptypes = __webpack_require__(10);

var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);

var _airbnbPropTypes = __webpack_require__(1);

var _OpenDirectionShape = __webpack_require__(15);

var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);

var _defaultPhrases = __webpack_require__(3);

var _getPhrasePropTypes = __webpack_require__(5);

var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);

var _DateRangePickerInput = __webpack_require__(54);

var _DateRangePickerInput2 = _interopRequireDefault(_DateRangePickerInput);

var _IconPositionShape = __webpack_require__(19);

var _IconPositionShape2 = _interopRequireDefault(_IconPositionShape);

var _toMomentObject = __webpack_require__(34);

var _toMomentObject2 = _interopRequireDefault(_toMomentObject);

var _toLocalizedDateString = __webpack_require__(33);

var _toLocalizedDateString2 = _interopRequireDefault(_toLocalizedDateString);

var _toISODateString = __webpack_require__(13);

var _toISODateString2 = _interopRequireDefault(_toISODateString);

var _isInclusivelyAfterDay = __webpack_require__(16);

var _isInclusivelyAfterDay2 = _interopRequireDefault(_isInclusivelyAfterDay);

var _isBeforeDay = __webpack_require__(32);

var _isBeforeDay2 = _interopRequireDefault(_isBeforeDay);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
  startDate: _reactMomentProptypes2['default'].momentObj,
  startDateId: _propTypes2['default'].string,
  startDatePlaceholderText: _propTypes2['default'].string,
  isStartDateFocused: _propTypes2['default'].bool,

  endDate: _reactMomentProptypes2['default'].momentObj,
  endDateId: _propTypes2['default'].string,
  endDatePlaceholderText: _propTypes2['default'].string,
  isEndDateFocused: _propTypes2['default'].bool,

  screenReaderMessage: _propTypes2['default'].string,
  showClearDates: _propTypes2['default'].bool,
  showCaret: _propTypes2['default'].bool,
  showDefaultInputIcon: _propTypes2['default'].bool,
  inputIconPosition: _IconPositionShape2['default'],
  disabled: _propTypes2['default'].bool,
  required: _propTypes2['default'].bool,
  readOnly: _propTypes2['default'].bool,
  openDirection: _OpenDirectionShape2['default'],

  keepOpenOnDateSelect: _propTypes2['default'].bool,
  reopenPickerOnClearDates: _propTypes2['default'].bool,
  withFullScreenPortal: _propTypes2['default'].bool,
  minimumNights: _airbnbPropTypes.nonNegativeInteger,
  isOutsideRange: _propTypes2['default'].func,
  displayFormat: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func]),

  onFocusChange: _propTypes2['default'].func,
  onClose: _propTypes2['default'].func,
  onDatesChange: _propTypes2['default'].func,
  onArrowDown: _propTypes2['default'].func,
  onQuestionMark: _propTypes2['default'].func,

  customInputIcon: _propTypes2['default'].node,
  customArrowIcon: _propTypes2['default'].node,
  customCloseIcon: _propTypes2['default'].node,

  // accessibility
  isFocused: _propTypes2['default'].bool,

  // i18n
  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DateRangePickerInputPhrases)),

  isRTL: _propTypes2['default'].bool
});

var defaultProps = {
  startDate: null,
  startDateId: _constants.START_DATE,
  startDatePlaceholderText: 'Start Date',
  isStartDateFocused: false,

  endDate: null,
  endDateId: _constants.END_DATE,
  endDatePlaceholderText: 'End Date',
  isEndDateFocused: false,

  screenReaderMessage: '',
  showClearDates: false,
  showCaret: false,
  showDefaultInputIcon: false,
  inputIconPosition: _constants.ICON_BEFORE_POSITION,
  disabled: false,
  required: false,
  readOnly: false,
  openDirection: _constants.OPEN_DOWN,

  keepOpenOnDateSelect: false,
  reopenPickerOnClearDates: false,
  withFullScreenPortal: false,
  minimumNights: 1,
  isOutsideRange: function () {
    function isOutsideRange(day) {
      return !(0, _isInclusivelyAfterDay2['default'])(day, (0, _moment2['default'])());
    }

    return isOutsideRange;
  }(),
  displayFormat: function () {
    function displayFormat() {
      return _moment2['default'].localeData().longDateFormat('L');
    }

    return displayFormat;
  }(),

  onFocusChange: function () {
    function onFocusChange() {}

    return onFocusChange;
  }(),
  onClose: function () {
    function onClose() {}

    return onClose;
  }(),
  onDatesChange: function () {
    function onDatesChange() {}

    return onDatesChange;
  }(),
  onArrowDown: function () {
    function onArrowDown() {}

    return onArrowDown;
  }(),
  onQuestionMark: function () {
    function onQuestionMark() {}

    return onQuestionMark;
  }(),

  customInputIcon: null,
  customArrowIcon: null,
  customCloseIcon: null,

  // accessibility
  isFocused: false,

  // i18n
  phrases: _defaultPhrases.DateRangePickerInputPhrases,

  isRTL: false
};

var DateRangePickerInputController = function (_React$Component) {
  _inherits(DateRangePickerInputController, _React$Component);

  function DateRangePickerInputController(props) {
    _classCallCheck(this, DateRangePickerInputController);

    var _this = _possibleConstructorReturn(this, (DateRangePickerInputController.__proto__ || Object.getPrototypeOf(DateRangePickerInputController)).call(this, props));

    _this.onClearFocus = _this.onClearFocus.bind(_this);
    _this.onStartDateChange = _this.onStartDateChange.bind(_this);
    _this.onStartDateFocus = _this.onStartDateFocus.bind(_this);
    _this.onEndDateChange = _this.onEndDateChange.bind(_this);
    _this.onEndDateFocus = _this.onEndDateFocus.bind(_this);
    _this.clearDates = _this.clearDates.bind(_this);
    return _this;
  }

  _createClass(DateRangePickerInputController, [{
    key: 'onClearFocus',
    value: function () {
      function onClearFocus() {
        var _props = this.props,
            onFocusChange = _props.onFocusChange,
            onClose = _props.onClose,
            startDate = _props.startDate,
            endDate = _props.endDate;

        onFocusChange(null);
        onClose({ startDate: startDate, endDate: endDate });
      }

      return onClearFocus;
    }()
  }, {
    key: 'onEndDateChange',
    value: function () {
      function onEndDateChange(endDateString) {
        var _props2 = this.props,
            startDate = _props2.startDate,
            isOutsideRange = _props2.isOutsideRange,
            minimumNights = _props2.minimumNights,
            keepOpenOnDateSelect = _props2.keepOpenOnDateSelect,
            onDatesChange = _props2.onDatesChange;

        var endDate = (0, _toMomentObject2['default'])(endDateString, this.getDisplayFormat());

        var isEndDateValid = endDate && !isOutsideRange(endDate) && !(startDate && (0, _isBeforeDay2['default'])(endDate, startDate.clone().add(minimumNights, 'days')));
        if (isEndDateValid) {
          onDatesChange({ startDate: startDate, endDate: endDate });
          if (!keepOpenOnDateSelect) this.onClearFocus();
        } else {
          onDatesChange({
            startDate: startDate,
            endDate: null
          });
        }
      }

      return onEndDateChange;
    }()
  }, {
    key: 'onEndDateFocus',
    value: function () {
      function onEndDateFocus() {
        var _props3 = this.props,
            startDate = _props3.startDate,
            onFocusChange = _props3.onFocusChange,
            withFullScreenPortal = _props3.withFullScreenPortal,
            disabled = _props3.disabled;

        if (!startDate && withFullScreenPortal && !disabled) {
          // When the datepicker is full screen, we never want to focus the end date first
          // because there's no indication that that is the case once the datepicker is open and it
          // might confuse the user
          onFocusChange(_constants.START_DATE);
        } else if (!disabled) {
          onFocusChange(_constants.END_DATE);
        }
      }

      return onEndDateFocus;
    }()
  }, {
    key: 'onStartDateChange',
    value: function () {
      function onStartDateChange(startDateString) {
        var startDate = (0, _toMomentObject2['default'])(startDateString, this.getDisplayFormat());

        var endDate = this.props.endDate;
        var _props4 = this.props,
            isOutsideRange = _props4.isOutsideRange,
            minimumNights = _props4.minimumNights,
            onDatesChange = _props4.onDatesChange,
            onFocusChange = _props4.onFocusChange;

        var isStartDateValid = startDate && !isOutsideRange(startDate);
        if (isStartDateValid) {
          if (startDate && (0, _isBeforeDay2['default'])(endDate, startDate.clone().add(minimumNights, 'days'))) {
            endDate = null;
          }

          onDatesChange({ startDate: startDate, endDate: endDate });
          onFocusChange(_constants.END_DATE);
        } else {
          onDatesChange({
            startDate: null,
            endDate: endDate
          });
        }
      }

      return onStartDateChange;
    }()
  }, {
    key: 'onStartDateFocus',
    value: function () {
      function onStartDateFocus() {
        if (!this.props.disabled) {
          this.props.onFocusChange(_constants.START_DATE);
        }
      }

      return onStartDateFocus;
    }()
  }, {
    key: 'getDisplayFormat',
    value: function () {
      function getDisplayFormat() {
        var displayFormat = this.props.displayFormat;

        return typeof displayFormat === 'string' ? displayFormat : displayFormat();
      }

      return getDisplayFormat;
    }()
  }, {
    key: 'getDateString',
    value: function () {
      function getDateString(date) {
        var displayFormat = this.getDisplayFormat();
        if (date && displayFormat) {
          return date && date.format(displayFormat);
        }
        return (0, _toLocalizedDateString2['default'])(date);
      }

      return getDateString;
    }()
  }, {
    key: 'clearDates',
    value: function () {
      function clearDates() {
        var _props5 = this.props,
            onDatesChange = _props5.onDatesChange,
            reopenPickerOnClearDates = _props5.reopenPickerOnClearDates,
            onFocusChange = _props5.onFocusChange;

        onDatesChange({ startDate: null, endDate: null });
        if (reopenPickerOnClearDates) {
          onFocusChange(_constants.START_DATE);
        }
      }

      return clearDates;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props6 = this.props,
            startDate = _props6.startDate,
            startDateId = _props6.startDateId,
            startDatePlaceholderText = _props6.startDatePlaceholderText,
            isStartDateFocused = _props6.isStartDateFocused,
            endDate = _props6.endDate,
            endDateId = _props6.endDateId,
            endDatePlaceholderText = _props6.endDatePlaceholderText,
            isEndDateFocused = _props6.isEndDateFocused,
            screenReaderMessage = _props6.screenReaderMessage,
            showClearDates = _props6.showClearDates,
            showCaret = _props6.showCaret,
            showDefaultInputIcon = _props6.showDefaultInputIcon,
            inputIconPosition = _props6.inputIconPosition,
            customInputIcon = _props6.customInputIcon,
            customArrowIcon = _props6.customArrowIcon,
            customCloseIcon = _props6.customCloseIcon,
            disabled = _props6.disabled,
            required = _props6.required,
            readOnly = _props6.readOnly,
            openDirection = _props6.openDirection,
            isFocused = _props6.isFocused,
            phrases = _props6.phrases,
            onArrowDown = _props6.onArrowDown,
            onQuestionMark = _props6.onQuestionMark,
            isRTL = _props6.isRTL;

        var startDateString = this.getDateString(startDate);
        var startDateValue = (0, _toISODateString2['default'])(startDate);
        var endDateString = this.getDateString(endDate);
        var endDateValue = (0, _toISODateString2['default'])(endDate);

        return _react2['default'].createElement(_DateRangePickerInput2['default'], {
          startDate: startDateString,
          startDateValue: startDateValue,
          startDateId: startDateId,
          startDatePlaceholderText: startDatePlaceholderText,
          isStartDateFocused: isStartDateFocused,
          endDate: endDateString,
          endDateValue: endDateValue,
          endDateId: endDateId,
          endDatePlaceholderText: endDatePlaceholderText,
          isEndDateFocused: isEndDateFocused,
          isFocused: isFocused,
          disabled: disabled,
          required: required,
          readOnly: readOnly,
          openDirection: openDirection,
          showCaret: showCaret,
          showDefaultInputIcon: showDefaultInputIcon,
          inputIconPosition: inputIconPosition,
          customInputIcon: customInputIcon,
          customArrowIcon: customArrowIcon,
          customCloseIcon: customCloseIcon,
          phrases: phrases,
          onStartDateChange: this.onStartDateChange,
          onStartDateFocus: this.onStartDateFocus,
          onStartDateShiftTab: this.onClearFocus,
          onEndDateChange: this.onEndDateChange,
          onEndDateFocus: this.onEndDateFocus,
          onEndDateTab: this.onClearFocus,
          showClearDates: showClearDates,
          onClearDates: this.clearDates,
          screenReaderMessage: screenReaderMessage,
          onArrowDown: onArrowDown,
          onQuestionMark: onQuestionMark,
          isRTL: isRTL
        });
      }

      return render;
    }()
  }]);

  return DateRangePickerInputController;
}(_react2['default'].Component);

exports['default'] = DateRangePickerInputController;

DateRangePickerInputController.propTypes = propTypes;
DateRangePickerInputController.defaultProps = defaultProps;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __webpack_require__(13);

/***/ })

/******/ });

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 71);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(41);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(25);

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(47);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(8);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(59);

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(13);

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(165);

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(152);

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(103);

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(128);

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(167);

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(211);

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(209);

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(381);

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(166);

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(269);

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(267);

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(625);

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(210);

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(380);

/***/ }),
/* 37 */,
/* 38 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(592);

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(619);

/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(626);

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _object3 = __webpack_require__(24);

var _object4 = _interopRequireDefault(_object3);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMomentProptypes = __webpack_require__(10);

var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);

var _airbnbPropTypes = __webpack_require__(1);

var _moment = __webpack_require__(7);

var _moment2 = _interopRequireDefault(_moment);

var _object = __webpack_require__(38);

var _object2 = _interopRequireDefault(_object);

var _isTouchDevice = __webpack_require__(9);

var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);

var _defaultPhrases = __webpack_require__(3);

var _getPhrasePropTypes = __webpack_require__(5);

var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);

var _isInclusivelyAfterDay = __webpack_require__(16);

var _isInclusivelyAfterDay2 = _interopRequireDefault(_isInclusivelyAfterDay);

var _isNextDay = __webpack_require__(49);

var _isNextDay2 = _interopRequireDefault(_isNextDay);

var _isSameDay = __webpack_require__(22);

var _isSameDay2 = _interopRequireDefault(_isSameDay);

var _isAfterDay = __webpack_require__(20);

var _isAfterDay2 = _interopRequireDefault(_isAfterDay);

var _isBeforeDay = __webpack_require__(32);

var _isBeforeDay2 = _interopRequireDefault(_isBeforeDay);

var _getVisibleDays = __webpack_require__(31);

var _getVisibleDays2 = _interopRequireDefault(_getVisibleDays);

var _isDayVisible = __webpack_require__(21);

var _isDayVisible2 = _interopRequireDefault(_isDayVisible);

var _toISODateString = __webpack_require__(13);

var _toISODateString2 = _interopRequireDefault(_toISODateString);

var _toISOMonthString = __webpack_require__(23);

var _toISOMonthString2 = _interopRequireDefault(_toISOMonthString);

var _FocusedInputShape = __webpack_require__(44);

var _FocusedInputShape2 = _interopRequireDefault(_FocusedInputShape);

var _ScrollableOrientationShape = __webpack_require__(8);

var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);

var _DayOfWeekShape = __webpack_require__(12);

var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);

var _constants = __webpack_require__(2);

var _DayPicker = __webpack_require__(36);

var _DayPicker2 = _interopRequireDefault(_DayPicker);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
  startDate: _reactMomentProptypes2['default'].momentObj,
  endDate: _reactMomentProptypes2['default'].momentObj,
  onDatesChange: _propTypes2['default'].func,

  focusedInput: _FocusedInputShape2['default'],
  onFocusChange: _propTypes2['default'].func,
  onClose: _propTypes2['default'].func,

  keepOpenOnDateSelect: _propTypes2['default'].bool,
  minimumNights: _propTypes2['default'].number,
  isOutsideRange: _propTypes2['default'].func,
  isDayBlocked: _propTypes2['default'].func,
  isDayHighlighted: _propTypes2['default'].func,

  // DayPicker props
  renderMonth: _propTypes2['default'].func,
  enableOutsideDays: _propTypes2['default'].bool,
  numberOfMonths: _propTypes2['default'].number,
  orientation: _ScrollableOrientationShape2['default'],
  withPortal: _propTypes2['default'].bool,
  initialVisibleMonth: _propTypes2['default'].func,
  hideKeyboardShortcutsPanel: _propTypes2['default'].bool,
  daySize: _airbnbPropTypes.nonNegativeInteger,

  navPrev: _propTypes2['default'].node,
  navNext: _propTypes2['default'].node,

  onPrevMonthClick: _propTypes2['default'].func,
  onNextMonthClick: _propTypes2['default'].func,
  onOutsideClick: _propTypes2['default'].func,
  renderDay: _propTypes2['default'].func,
  renderCalendarInfo: _propTypes2['default'].func,
  firstDayOfWeek: _DayOfWeekShape2['default'],

  // accessibility
  onBlur: _propTypes2['default'].func,
  isFocused: _propTypes2['default'].bool,
  showKeyboardShortcuts: _propTypes2['default'].bool,

  // i18n
  monthFormat: _propTypes2['default'].string,
  weekDayFormat: _propTypes2['default'].string,
  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DayPickerPhrases)),

  isRTL: _propTypes2['default'].bool
});

var defaultProps = {
  startDate: undefined, // TODO: use null
  endDate: undefined, // TODO: use null
  onDatesChange: function () {
    function onDatesChange() {}

    return onDatesChange;
  }(),

  focusedInput: null,
  onFocusChange: function () {
    function onFocusChange() {}

    return onFocusChange;
  }(),
  onClose: function () {
    function onClose() {}

    return onClose;
  }(),

  keepOpenOnDateSelect: false,
  minimumNights: 1,
  isOutsideRange: function () {
    function isOutsideRange() {}

    return isOutsideRange;
  }(),
  isDayBlocked: function () {
    function isDayBlocked() {}

    return isDayBlocked;
  }(),
  isDayHighlighted: function () {
    function isDayHighlighted() {}

    return isDayHighlighted;
  }(),

  // DayPicker props
  renderMonth: null,
  enableOutsideDays: false,
  numberOfMonths: 1,
  orientation: _constants.HORIZONTAL_ORIENTATION,
  withPortal: false,
  hideKeyboardShortcutsPanel: false,
  initialVisibleMonth: null,
  daySize: _constants.DAY_SIZE,

  navPrev: null,
  navNext: null,

  onPrevMonthClick: function () {
    function onPrevMonthClick() {}

    return onPrevMonthClick;
  }(),
  onNextMonthClick: function () {
    function onNextMonthClick() {}

    return onNextMonthClick;
  }(),
  onOutsideClick: function () {
    function onOutsideClick() {}

    return onOutsideClick;
  }(),

  renderDay: null,
  renderCalendarInfo: null,
  firstDayOfWeek: null,

  // accessibility
  onBlur: function () {
    function onBlur() {}

    return onBlur;
  }(),

  isFocused: false,
  showKeyboardShortcuts: false,

  // i18n
  monthFormat: 'MMMM YYYY',
  weekDayFormat: 'dd',
  phrases: _defaultPhrases.DayPickerPhrases,

  isRTL: false
};

var getChooseAvailableDatePhrase = function () {
  function getChooseAvailableDatePhrase(phrases, focusedInput) {
    if (focusedInput === _constants.START_DATE) {
      return phrases.chooseAvailableStartDate;
    } else if (focusedInput === _constants.END_DATE) {
      return phrases.chooseAvailableEndDate;
    }
    return phrases.chooseAvailableDate;
  }

  return getChooseAvailableDatePhrase;
}();

var DayPickerRangeController = function (_React$Component) {
  _inherits(DayPickerRangeController, _React$Component);

  function DayPickerRangeController(props) {
    _classCallCheck(this, DayPickerRangeController);

    var _this = _possibleConstructorReturn(this, (DayPickerRangeController.__proto__ || Object.getPrototypeOf(DayPickerRangeController)).call(this, props));

    _this.isTouchDevice = (0, _isTouchDevice2['default'])();
    _this.today = (0, _moment2['default'])();
    _this.modifiers = {
      today: function () {
        function today(day) {
          return _this.isToday(day);
        }

        return today;
      }(),
      blocked: function () {
        function blocked(day) {
          return _this.isBlocked(day);
        }

        return blocked;
      }(),
      'blocked-calendar': function () {
        function blockedCalendar(day) {
          return props.isDayBlocked(day);
        }

        return blockedCalendar;
      }(),
      'blocked-out-of-range': function () {
        function blockedOutOfRange(day) {
          return props.isOutsideRange(day);
        }

        return blockedOutOfRange;
      }(),
      'highlighted-calendar': function () {
        function highlightedCalendar(day) {
          return props.isDayHighlighted(day);
        }

        return highlightedCalendar;
      }(),
      valid: function () {
        function valid(day) {
          return !_this.isBlocked(day);
        }

        return valid;
      }(),
      'selected-start': function () {
        function selectedStart(day) {
          return _this.isStartDate(day);
        }

        return selectedStart;
      }(),
      'selected-end': function () {
        function selectedEnd(day) {
          return _this.isEndDate(day);
        }

        return selectedEnd;
      }(),
      'blocked-minimum-nights': function () {
        function blockedMinimumNights(day) {
          return _this.doesNotMeetMinimumNights(day);
        }

        return blockedMinimumNights;
      }(),
      'selected-span': function () {
        function selectedSpan(day) {
          return _this.isInSelectedSpan(day);
        }

        return selectedSpan;
      }(),
      'last-in-range': function () {
        function lastInRange(day) {
          return _this.isLastInRange(day);
        }

        return lastInRange;
      }(),
      hovered: function () {
        function hovered(day) {
          return _this.isHovered(day);
        }

        return hovered;
      }(),
      'hovered-span': function () {
        function hoveredSpan(day) {
          return _this.isInHoveredSpan(day);
        }

        return hoveredSpan;
      }(),
      'after-hovered-start': function () {
        function afterHoveredStart(day) {
          return _this.isDayAfterHoveredStartDate(day);
        }

        return afterHoveredStart;
      }()
    };

    var _this$getStateForNewM = _this.getStateForNewMonth(props),
        currentMonth = _this$getStateForNewM.currentMonth,
        visibleDays = _this$getStateForNewM.visibleDays;

    // initialize phrases
    // set the appropriate CalendarDay phrase based on focusedInput


    var chooseAvailableDate = getChooseAvailableDatePhrase(props.phrases, props.focusedInput);

    _this.state = {
      hoverDate: null,
      currentMonth: currentMonth,
      phrases: (0, _object4['default'])({}, props.phrases, {
        chooseAvailableDate: chooseAvailableDate
      }),
      visibleDays: visibleDays
    };

    _this.onDayClick = _this.onDayClick.bind(_this);
    _this.onDayMouseEnter = _this.onDayMouseEnter.bind(_this);
    _this.onDayMouseLeave = _this.onDayMouseLeave.bind(_this);
    _this.onPrevMonthClick = _this.onPrevMonthClick.bind(_this);
    _this.onNextMonthClick = _this.onNextMonthClick.bind(_this);
    _this.onMultiplyScrollableMonths = _this.onMultiplyScrollableMonths.bind(_this);
    _this.getFirstFocusableDay = _this.getFirstFocusableDay.bind(_this);
    _this.setDayPickerRef = _this.setDayPickerRef.bind(_this);
    return _this;
  }

  _createClass(DayPickerRangeController, [{
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(nextProps) {
        var _this2 = this;

        var startDate = nextProps.startDate,
            endDate = nextProps.endDate,
            focusedInput = nextProps.focusedInput,
            minimumNights = nextProps.minimumNights,
            isOutsideRange = nextProps.isOutsideRange,
            isDayBlocked = nextProps.isDayBlocked,
            isDayHighlighted = nextProps.isDayHighlighted,
            phrases = nextProps.phrases,
            initialVisibleMonth = nextProps.initialVisibleMonth,
            numberOfMonths = nextProps.numberOfMonths,
            enableOutsideDays = nextProps.enableOutsideDays;
        var visibleDays = this.state.visibleDays;

        var recomputeOutsideRange = false;
        var recomputeDayBlocked = false;
        var recomputeDayHighlighted = false;

        if (isOutsideRange !== this.props.isOutsideRange) {
          this.modifiers['blocked-out-of-range'] = function (day) {
            return isOutsideRange(day);
          };
          recomputeOutsideRange = true;
        }

        if (isDayBlocked !== this.props.isDayBlocked) {
          this.modifiers['blocked-calendar'] = function (day) {
            return isDayBlocked(day);
          };
          recomputeDayBlocked = true;
        }

        if (isDayHighlighted !== this.props.isDayHighlighted) {
          this.modifiers['highlighted-calendar'] = function (day) {
            return isDayHighlighted(day);
          };
          recomputeDayHighlighted = true;
        }

        var recomputePropModifiers = recomputeOutsideRange || recomputeDayBlocked || recomputeDayHighlighted;

        var didStartDateChange = startDate !== this.props.startDate;
        var didEndDateChange = endDate !== this.props.endDate;
        var didFocusChange = focusedInput !== this.props.focusedInput;

        if (numberOfMonths !== this.props.numberOfMonths || enableOutsideDays !== this.props.enableOutsideDays || initialVisibleMonth !== this.props.initialVisibleMonth && !this.props.focusedInput && didFocusChange) {
          var newMonthState = this.getStateForNewMonth(nextProps);
          var currentMonth = newMonthState.currentMonth;
          visibleDays = newMonthState.visibleDays;
          this.setState({
            currentMonth: currentMonth,
            visibleDays: visibleDays
          });
        }

        var modifiers = {};

        if (didStartDateChange) {
          modifiers = this.deleteModifier(modifiers, this.props.startDate, 'selected-start');
          modifiers = this.addModifier(modifiers, startDate, 'selected-start');
        }

        if (didEndDateChange) {
          modifiers = this.deleteModifier(modifiers, this.props.endDate, 'selected-end');
          modifiers = this.addModifier(modifiers, endDate, 'selected-end');
        }

        if (didStartDateChange || didEndDateChange) {
          if (this.props.startDate && this.props.endDate) {
            modifiers = this.deleteModifierFromRange(modifiers, this.props.startDate, this.props.endDate.clone().add(1, 'day'), 'selected-span');
          }

          if (startDate && endDate) {
            modifiers = this.deleteModifierFromRange(modifiers, startDate, endDate.clone().add(1, 'day'), 'hovered-span');

            modifiers = this.addModifierToRange(modifiers, startDate.clone().add(1, 'day'), endDate, 'selected-span');
          }
        }

        if (!this.isTouchDevice && didStartDateChange && startDate && !endDate) {
          var startSpan = startDate.clone().add(1, 'day');
          var endSpan = startDate.clone().add(minimumNights + 1, 'days');
          modifiers = this.addModifierToRange(modifiers, startSpan, endSpan, 'after-hovered-start');
        }

        if (minimumNights > 0 || minimumNights !== this.props.minimumNights) {
          if (didFocusChange || didStartDateChange) {
            var _startSpan = this.props.startDate ? this.props.startDate : this.today;
            modifiers = this.deleteModifierFromRange(modifiers, _startSpan, _startSpan.clone().add(minimumNights, 'days'), 'blocked-minimum-nights');
          }

          if (startDate && focusedInput === _constants.END_DATE) {
            modifiers = this.addModifierToRange(modifiers, startDate, startDate.clone().add(minimumNights, 'days'), 'blocked-minimum-nights');
          }
        }

        if (didFocusChange || recomputePropModifiers) {
          (0, _object2['default'])(visibleDays).forEach(function (days) {
            Object.keys(days).forEach(function (day) {
              var momentObj = (0, _moment2['default'])(day);

              if (_this2.isBlocked(momentObj)) {
                modifiers = _this2.addModifier(modifiers, momentObj, 'blocked');
              } else {
                modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked');
              }

              if (didFocusChange || recomputeOutsideRange) {
                if (isOutsideRange(momentObj)) {
                  modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-out-of-range');
                } else {
                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-out-of-range');
                }
              }

              if (didFocusChange || recomputeDayBlocked) {
                if (isDayBlocked(momentObj)) {
                  modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-calendar');
                } else {
                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-calendar');
                }
              }

              if (didFocusChange || recomputeDayHighlighted) {
                if (isDayHighlighted(momentObj)) {
                  modifiers = _this2.addModifier(modifiers, momentObj, 'highlighted-calendar');
                } else {
                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'highlighted-calendar');
                }
              }
            });
          });
        }

        var today = (0, _moment2['default'])();
        if (!(0, _isSameDay2['default'])(this.today, today)) {
          modifiers = this.deleteModifier(modifiers, this.today, 'today');
          modifiers = this.addModifier(modifiers, today, 'today');
          this.today = today;
        }

        if (Object.keys(modifiers).length > 0) {
          this.setState({
            visibleDays: (0, _object4['default'])({}, visibleDays, modifiers)
          });
        }

        if (didFocusChange || phrases !== this.props.phrases) {
          // set the appropriate CalendarDay phrase based on focusedInput
          var chooseAvailableDate = getChooseAvailableDatePhrase(phrases, focusedInput);

          this.setState({
            phrases: (0, _object4['default'])({}, phrases, {
              chooseAvailableDate: chooseAvailableDate
            })
          });
        }
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'onDayClick',
    value: function () {
      function onDayClick(day, e) {
        var _props = this.props,
            keepOpenOnDateSelect = _props.keepOpenOnDateSelect,
            minimumNights = _props.minimumNights,
            onBlur = _props.onBlur;

        if (e) e.preventDefault();
        if (this.isBlocked(day)) return;

        var _props2 = this.props,
            focusedInput = _props2.focusedInput,
            onFocusChange = _props2.onFocusChange,
            onClose = _props2.onClose;
        var _props3 = this.props,
            startDate = _props3.startDate,
            endDate = _props3.endDate;

        if (focusedInput === _constants.START_DATE) {
          onFocusChange(_constants.END_DATE);

          startDate = day;

          if ((0, _isInclusivelyAfterDay2['default'])(day, endDate)) {
            endDate = null;
          }
        } else if (focusedInput === _constants.END_DATE) {
          var firstAllowedEndDate = startDate && startDate.clone().add(minimumNights, 'days');

          if (!startDate) {
            endDate = day;
            onFocusChange(_constants.START_DATE);
          } else if ((0, _isInclusivelyAfterDay2['default'])(day, firstAllowedEndDate)) {
            endDate = day;
            if (!keepOpenOnDateSelect) {
              onFocusChange(null);
              onClose({ startDate: startDate, endDate: endDate });
            }
          } else {
            startDate = day;
            endDate = null;
          }
        }

        this.props.onDatesChange({ startDate: startDate, endDate: endDate });
        onBlur();
      }

      return onDayClick;
    }()
  }, {
    key: 'onDayMouseEnter',
    value: function () {
      function onDayMouseEnter(day) {
        if (this.isTouchDevice) return;
        var _props4 = this.props,
            startDate = _props4.startDate,
            endDate = _props4.endDate,
            focusedInput = _props4.focusedInput,
            minimumNights = _props4.minimumNights;
        var _state = this.state,
            hoverDate = _state.hoverDate,
            visibleDays = _state.visibleDays;

        if (focusedInput) {
          var modifiers = {};
          modifiers = this.deleteModifier(modifiers, hoverDate, 'hovered');
          modifiers = this.addModifier(modifiers, day, 'hovered');

          if (startDate && !endDate && focusedInput === _constants.END_DATE) {
            if ((0, _isAfterDay2['default'])(hoverDate, startDate)) {
              var endSpan = hoverDate.clone().add(1, 'day');
              modifiers = this.deleteModifierFromRange(modifiers, startDate, endSpan, 'hovered-span');
            }

            if (!this.isBlocked(day) && (0, _isAfterDay2['default'])(day, startDate)) {
              var _endSpan = day.clone().add(1, 'day');
              modifiers = this.addModifierToRange(modifiers, startDate, _endSpan, 'hovered-span');
            }
          }

          if (!startDate && endDate && focusedInput === _constants.START_DATE) {
            if ((0, _isBeforeDay2['default'])(hoverDate, endDate)) {
              modifiers = this.deleteModifierFromRange(modifiers, hoverDate, endDate, 'hovered-span');
            }

            if (!this.isBlocked(day) && (0, _isBeforeDay2['default'])(day, endDate)) {
              modifiers = this.addModifierToRange(modifiers, day, endDate, 'hovered-span');
            }
          }

          if (startDate) {
            var startSpan = startDate.clone().add(1, 'day');
            var _endSpan2 = startDate.clone().add(minimumNights + 1, 'days');
            modifiers = this.deleteModifierFromRange(modifiers, startSpan, _endSpan2, 'after-hovered-start');

            if ((0, _isSameDay2['default'])(day, startDate)) {
              var newStartSpan = startDate.clone().add(1, 'day');
              var newEndSpan = startDate.clone().add(minimumNights + 1, 'days');
              modifiers = this.addModifierToRange(modifiers, newStartSpan, newEndSpan, 'after-hovered-start');
            }
          }

          this.setState({
            hoverDate: day,
            visibleDays: (0, _object4['default'])({}, visibleDays, modifiers)
          });
        }
      }

      return onDayMouseEnter;
    }()
  }, {
    key: 'onDayMouseLeave',
    value: function () {
      function onDayMouseLeave(day) {
        var _props5 = this.props,
            startDate = _props5.startDate,
            endDate = _props5.endDate,
            minimumNights = _props5.minimumNights;
        var _state2 = this.state,
            hoverDate = _state2.hoverDate,
            visibleDays = _state2.visibleDays;

        if (this.isTouchDevice || !hoverDate) return;

        var modifiers = {};
        modifiers = this.deleteModifier(modifiers, hoverDate, 'hovered');

        if (startDate && !endDate && (0, _isAfterDay2['default'])(hoverDate, startDate)) {
          var endSpan = hoverDate.clone().add(1, 'day');
          modifiers = this.deleteModifierFromRange(modifiers, startDate, endSpan, 'hovered-span');
        }

        if (!startDate && endDate && (0, _isAfterDay2['default'])(endDate, hoverDate)) {
          modifiers = this.deleteModifierFromRange(modifiers, hoverDate, endDate, 'hovered-span');
        }

        if (startDate && (0, _isSameDay2['default'])(day, startDate)) {
          var startSpan = startDate.clone().add(1, 'day');
          var _endSpan3 = startDate.clone().add(minimumNights + 1, 'days');
          modifiers = this.deleteModifierFromRange(modifiers, startSpan, _endSpan3, 'after-hovered-start');
        }

        this.setState({
          hoverDate: null,
          visibleDays: (0, _object4['default'])({}, visibleDays, modifiers)
        });
      }

      return onDayMouseLeave;
    }()
  }, {
    key: 'onPrevMonthClick',
    value: function () {
      function onPrevMonthClick() {
        var _props6 = this.props,
            onPrevMonthClick = _props6.onPrevMonthClick,
            numberOfMonths = _props6.numberOfMonths,
            enableOutsideDays = _props6.enableOutsideDays;
        var _state3 = this.state,
            currentMonth = _state3.currentMonth,
            visibleDays = _state3.visibleDays;

        var newVisibleDays = {};
        Object.keys(visibleDays).sort().slice(0, numberOfMonths + 1).forEach(function (month) {
          newVisibleDays[month] = visibleDays[month];
        });

        var prevMonth = currentMonth.clone().subtract(2, 'months');
        var prevMonthVisibleDays = (0, _getVisibleDays2['default'])(prevMonth, 1, enableOutsideDays, true);

        var newCurrentMonth = currentMonth.clone().subtract(1, 'month');
        this.setState({
          currentMonth: newCurrentMonth,
          visibleDays: (0, _object4['default'])({}, newVisibleDays, this.getModifiers(prevMonthVisibleDays))
        });

        onPrevMonthClick(newCurrentMonth.clone());
      }

      return onPrevMonthClick;
    }()
  }, {
    key: 'onNextMonthClick',
    value: function () {
      function onNextMonthClick() {
        var _props7 = this.props,
            onNextMonthClick = _props7.onNextMonthClick,
            numberOfMonths = _props7.numberOfMonths,
            enableOutsideDays = _props7.enableOutsideDays;
        var _state4 = this.state,
            currentMonth = _state4.currentMonth,
            visibleDays = _state4.visibleDays;

        var newVisibleDays = {};
        Object.keys(visibleDays).sort().slice(1).forEach(function (month) {
          newVisibleDays[month] = visibleDays[month];
        });

        var nextMonth = currentMonth.clone().add(numberOfMonths + 1, 'month');
        var nextMonthVisibleDays = (0, _getVisibleDays2['default'])(nextMonth, 1, enableOutsideDays, true);

        var newCurrentMonth = currentMonth.clone().add(1, 'month');
        this.setState({
          currentMonth: newCurrentMonth,
          visibleDays: (0, _object4['default'])({}, newVisibleDays, this.getModifiers(nextMonthVisibleDays))
        });

        onNextMonthClick(newCurrentMonth.clone());
      }

      return onNextMonthClick;
    }()
  }, {
    key: 'onMultiplyScrollableMonths',
    value: function () {
      function onMultiplyScrollableMonths() {
        var _props8 = this.props,
            numberOfMonths = _props8.numberOfMonths,
            enableOutsideDays = _props8.enableOutsideDays;
        var _state5 = this.state,
            currentMonth = _state5.currentMonth,
            visibleDays = _state5.visibleDays;

        var numberOfVisibleMonths = Object.keys(visibleDays).length;
        var nextMonth = currentMonth.clone().add(numberOfVisibleMonths, 'month');
        var newVisibleDays = (0, _getVisibleDays2['default'])(nextMonth, numberOfMonths, enableOutsideDays, true);

        this.setState({
          visibleDays: (0, _object4['default'])({}, visibleDays, this.getModifiers(newVisibleDays))
        });
      }

      return onMultiplyScrollableMonths;
    }()
  }, {
    key: 'getFirstFocusableDay',
    value: function () {
      function getFirstFocusableDay(newMonth) {
        var _this3 = this;

        var _props9 = this.props,
            startDate = _props9.startDate,
            endDate = _props9.endDate,
            focusedInput = _props9.focusedInput,
            minimumNights = _props9.minimumNights,
            numberOfMonths = _props9.numberOfMonths;

        var focusedDate = newMonth.clone().startOf('month');
        if (focusedInput === _constants.START_DATE && startDate) {
          focusedDate = startDate.clone();
        } else if (focusedInput === _constants.END_DATE && !endDate && startDate) {
          focusedDate = startDate.clone().add(minimumNights, 'days');
        } else if (focusedInput === _constants.END_DATE && endDate) {
          focusedDate = endDate.clone();
        }

        if (this.isBlocked(focusedDate)) {
          var days = [];
          var lastVisibleDay = newMonth.clone().add(numberOfMonths - 1, 'months').endOf('month');
          var currentDay = focusedDate.clone();
          while (!(0, _isAfterDay2['default'])(currentDay, lastVisibleDay)) {
            currentDay = currentDay.clone().add(1, 'day');
            days.push(currentDay);
          }

          var viableDays = days.filter(function (day) {
            return !_this3.isBlocked(day);
          });

          if (viableDays.length > 0) focusedDate = viableDays[0];
        }

        return focusedDate;
      }

      return getFirstFocusableDay;
    }()
  }, {
    key: 'getModifiers',
    value: function () {
      function getModifiers(visibleDays) {
        var _this4 = this;

        var modifiers = {};
        Object.keys(visibleDays).forEach(function (month) {
          modifiers[month] = {};
          visibleDays[month].forEach(function (day) {
            modifiers[month][(0, _toISODateString2['default'])(day)] = _this4.getModifiersForDay(day);
          });
        });

        return modifiers;
      }

      return getModifiers;
    }()
  }, {
    key: 'getModifiersForDay',
    value: function () {
      function getModifiersForDay(day) {
        var _this5 = this;

        return new Set(Object.keys(this.modifiers).filter(function (modifier) {
          return _this5.modifiers[modifier](day);
        }));
      }

      return getModifiersForDay;
    }()
  }, {
    key: 'getStateForNewMonth',
    value: function () {
      function getStateForNewMonth(nextProps) {
        var _this6 = this;

        var initialVisibleMonth = nextProps.initialVisibleMonth,
            numberOfMonths = nextProps.numberOfMonths,
            enableOutsideDays = nextProps.enableOutsideDays,
            orientation = nextProps.orientation,
            startDate = nextProps.startDate;

        var initialVisibleMonthThunk = initialVisibleMonth || (startDate ? function () {
          return startDate;
        } : function () {
          return _this6.today;
        });
        var currentMonth = initialVisibleMonthThunk();
        var withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
        var visibleDays = this.getModifiers((0, _getVisibleDays2['default'])(currentMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths));
        return { currentMonth: currentMonth, visibleDays: visibleDays };
      }

      return getStateForNewMonth;
    }()
  }, {
    key: 'setDayPickerRef',
    value: function () {
      function setDayPickerRef(ref) {
        this.dayPicker = ref;
      }

      return setDayPickerRef;
    }()
  }, {
    key: 'addModifier',
    value: function () {
      function addModifier(updatedDays, day, modifier) {
        var _props10 = this.props,
            numberOfVisibleMonths = _props10.numberOfMonths,
            enableOutsideDays = _props10.enableOutsideDays,
            orientation = _props10.orientation;
        var _state6 = this.state,
            firstVisibleMonth = _state6.currentMonth,
            visibleDays = _state6.visibleDays;

        var currentMonth = firstVisibleMonth;
        var numberOfMonths = numberOfVisibleMonths;
        if (orientation !== _constants.VERTICAL_SCROLLABLE) {
          currentMonth = currentMonth.clone().subtract(1, 'month');
          numberOfMonths += 2;
        }
        if (!day || !(0, _isDayVisible2['default'])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
          return updatedDays;
        }

        var iso = (0, _toISODateString2['default'])(day);

        var updatedDaysAfterAddition = (0, _object4['default'])({}, updatedDays);
        if (enableOutsideDays) {
          var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
            return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
          });

          updatedDaysAfterAddition = monthsToUpdate.reduce(function (days, monthIso) {
            var month = updatedDays[monthIso] || visibleDays[monthIso];
            var modifiers = new Set(month[iso]);
            modifiers.add(modifier);
            return (0, _object4['default'])({}, days, _defineProperty({}, monthIso, (0, _object4['default'])({}, month, _defineProperty({}, iso, modifiers))));
          }, updatedDaysAfterAddition);
        } else {
          var monthIso = (0, _toISOMonthString2['default'])(day);
          var month = updatedDays[monthIso] || visibleDays[monthIso];

          var modifiers = new Set(month[iso]);
          modifiers.add(modifier);
          updatedDaysAfterAddition = (0, _object4['default'])({}, updatedDaysAfterAddition, _defineProperty({}, monthIso, (0, _object4['default'])({}, month, _defineProperty({}, iso, modifiers))));
        }

        return updatedDaysAfterAddition;
      }

      return addModifier;
    }()
  }, {
    key: 'addModifierToRange',
    value: function () {
      function addModifierToRange(updatedDays, start, end, modifier) {
        var days = updatedDays;

        var spanStart = start.clone();
        while ((0, _isBeforeDay2['default'])(spanStart, end)) {
          days = this.addModifier(days, spanStart, modifier);
          spanStart = spanStart.clone().add(1, 'day');
        }

        return days;
      }

      return addModifierToRange;
    }()
  }, {
    key: 'deleteModifier',
    value: function () {
      function deleteModifier(updatedDays, day, modifier) {
        var _props11 = this.props,
            numberOfVisibleMonths = _props11.numberOfMonths,
            enableOutsideDays = _props11.enableOutsideDays,
            orientation = _props11.orientation;
        var _state7 = this.state,
            firstVisibleMonth = _state7.currentMonth,
            visibleDays = _state7.visibleDays;

        var currentMonth = firstVisibleMonth;
        var numberOfMonths = numberOfVisibleMonths;
        if (orientation !== _constants.VERTICAL_SCROLLABLE) {
          currentMonth = currentMonth.clone().subtract(1, 'month');
          numberOfMonths += 2;
        }
        if (!day || !(0, _isDayVisible2['default'])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
          return updatedDays;
        }

        var iso = (0, _toISODateString2['default'])(day);

        var updatedDaysAfterDeletion = (0, _object4['default'])({}, updatedDays);
        if (enableOutsideDays) {
          var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
            return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
          });

          updatedDaysAfterDeletion = monthsToUpdate.reduce(function (days, monthIso) {
            var month = updatedDays[monthIso] || visibleDays[monthIso];
            var modifiers = new Set(month[iso]);
            modifiers['delete'](modifier);
            return (0, _object4['default'])({}, days, _defineProperty({}, monthIso, (0, _object4['default'])({}, month, _defineProperty({}, iso, modifiers))));
          }, updatedDaysAfterDeletion);
        } else {
          var monthIso = (0, _toISOMonthString2['default'])(day);
          var month = updatedDays[monthIso] || visibleDays[monthIso];

          var modifiers = new Set(month[iso]);
          modifiers['delete'](modifier);
          updatedDaysAfterDeletion = (0, _object4['default'])({}, updatedDaysAfterDeletion, _defineProperty({}, monthIso, (0, _object4['default'])({}, month, _defineProperty({}, iso, modifiers))));
        }

        return updatedDaysAfterDeletion;
      }

      return deleteModifier;
    }()
  }, {
    key: 'deleteModifierFromRange',
    value: function () {
      function deleteModifierFromRange(updatedDays, start, end, modifier) {
        var days = updatedDays;

        var spanStart = start.clone();
        while ((0, _isBeforeDay2['default'])(spanStart, end)) {
          days = this.deleteModifier(days, spanStart, modifier);
          spanStart = spanStart.clone().add(1, 'day');
        }

        return days;
      }

      return deleteModifierFromRange;
    }()
  }, {
    key: 'doesNotMeetMinimumNights',
    value: function () {
      function doesNotMeetMinimumNights(day) {
        var _props12 = this.props,
            startDate = _props12.startDate,
            isOutsideRange = _props12.isOutsideRange,
            focusedInput = _props12.focusedInput,
            minimumNights = _props12.minimumNights;

        if (focusedInput !== _constants.END_DATE) return false;

        if (startDate) {
          var dayDiff = day.diff(startDate.clone().startOf('day').hour(12), 'days');
          return dayDiff < minimumNights && dayDiff >= 0;
        }
        return isOutsideRange((0, _moment2['default'])(day).subtract(minimumNights, 'days'));
      }

      return doesNotMeetMinimumNights;
    }()
  }, {
    key: 'isDayAfterHoveredStartDate',
    value: function () {
      function isDayAfterHoveredStartDate(day) {
        var _props13 = this.props,
            startDate = _props13.startDate,
            endDate = _props13.endDate,
            minimumNights = _props13.minimumNights;

        var _ref = this.state || {},
            hoverDate = _ref.hoverDate;

        return !!startDate && !endDate && !this.isBlocked(day) && (0, _isNextDay2['default'])(hoverDate, day) && minimumNights > 0 && (0, _isSameDay2['default'])(hoverDate, startDate);
      }

      return isDayAfterHoveredStartDate;
    }()
  }, {
    key: 'isEndDate',
    value: function () {
      function isEndDate(day) {
        return (0, _isSameDay2['default'])(day, this.props.endDate);
      }

      return isEndDate;
    }()
  }, {
    key: 'isHovered',
    value: function () {
      function isHovered(day) {
        var _ref2 = this.state || {},
            hoverDate = _ref2.hoverDate;

        var focusedInput = this.props.focusedInput;

        return !!focusedInput && (0, _isSameDay2['default'])(day, hoverDate);
      }

      return isHovered;
    }()
  }, {
    key: 'isInHoveredSpan',
    value: function () {
      function isInHoveredSpan(day) {
        var _props14 = this.props,
            startDate = _props14.startDate,
            endDate = _props14.endDate;

        var _ref3 = this.state || {},
            hoverDate = _ref3.hoverDate;

        var isForwardRange = !!startDate && !endDate && (day.isBetween(startDate, hoverDate) || (0, _isSameDay2['default'])(hoverDate, day));
        var isBackwardRange = !!endDate && !startDate && (day.isBetween(hoverDate, endDate) || (0, _isSameDay2['default'])(hoverDate, day));

        var isValidDayHovered = hoverDate && !this.isBlocked(hoverDate);

        return (isForwardRange || isBackwardRange) && isValidDayHovered;
      }

      return isInHoveredSpan;
    }()
  }, {
    key: 'isInSelectedSpan',
    value: function () {
      function isInSelectedSpan(day) {
        var _props15 = this.props,
            startDate = _props15.startDate,
            endDate = _props15.endDate;

        return day.isBetween(startDate, endDate);
      }

      return isInSelectedSpan;
    }()
  }, {
    key: 'isLastInRange',
    value: function () {
      function isLastInRange(day) {
        return this.isInSelectedSpan(day) && (0, _isNextDay2['default'])(day, this.props.endDate);
      }

      return isLastInRange;
    }()
  }, {
    key: 'isStartDate',
    value: function () {
      function isStartDate(day) {
        return (0, _isSameDay2['default'])(day, this.props.startDate);
      }

      return isStartDate;
    }()
  }, {
    key: 'isBlocked',
    value: function () {
      function isBlocked(day) {
        var _props16 = this.props,
            isDayBlocked = _props16.isDayBlocked,
            isOutsideRange = _props16.isOutsideRange;

        return isDayBlocked(day) || isOutsideRange(day) || this.doesNotMeetMinimumNights(day);
      }

      return isBlocked;
    }()
  }, {
    key: 'isToday',
    value: function () {
      function isToday(day) {
        return (0, _isSameDay2['default'])(day, this.today);
      }

      return isToday;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props17 = this.props,
            numberOfMonths = _props17.numberOfMonths,
            orientation = _props17.orientation,
            monthFormat = _props17.monthFormat,
            renderMonth = _props17.renderMonth,
            navPrev = _props17.navPrev,
            navNext = _props17.navNext,
            onOutsideClick = _props17.onOutsideClick,
            withPortal = _props17.withPortal,
            enableOutsideDays = _props17.enableOutsideDays,
            firstDayOfWeek = _props17.firstDayOfWeek,
            hideKeyboardShortcutsPanel = _props17.hideKeyboardShortcutsPanel,
            daySize = _props17.daySize,
            focusedInput = _props17.focusedInput,
            renderDay = _props17.renderDay,
            renderCalendarInfo = _props17.renderCalendarInfo,
            onBlur = _props17.onBlur,
            isFocused = _props17.isFocused,
            showKeyboardShortcuts = _props17.showKeyboardShortcuts,
            isRTL = _props17.isRTL,
            weekDayFormat = _props17.weekDayFormat;
        var _state8 = this.state,
            currentMonth = _state8.currentMonth,
            phrases = _state8.phrases,
            visibleDays = _state8.visibleDays;

        return _react2['default'].createElement(_DayPicker2['default'], {
          ref: this.setDayPickerRef,
          orientation: orientation,
          enableOutsideDays: enableOutsideDays,
          modifiers: visibleDays,
          numberOfMonths: numberOfMonths,
          onDayClick: this.onDayClick,
          onDayMouseEnter: this.onDayMouseEnter,
          onDayMouseLeave: this.onDayMouseLeave,
          onPrevMonthClick: this.onPrevMonthClick,
          onNextMonthClick: this.onNextMonthClick,
          onMultiplyScrollableMonths: this.onMultiplyScrollableMonths,
          monthFormat: monthFormat,
          renderMonth: renderMonth,
          withPortal: withPortal,
          hidden: !focusedInput,
          initialVisibleMonth: function () {
            function initialVisibleMonth() {
              return currentMonth;
            }

            return initialVisibleMonth;
          }(),
          daySize: daySize,
          onOutsideClick: onOutsideClick,
          navPrev: navPrev,
          navNext: navNext,
          renderDay: renderDay,
          renderCalendarInfo: renderCalendarInfo,
          firstDayOfWeek: firstDayOfWeek,
          hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
          isFocused: isFocused,
          getFirstFocusableDay: this.getFirstFocusableDay,
          onBlur: onBlur,
          showKeyboardShortcuts: showKeyboardShortcuts,
          phrases: phrases,
          isRTL: isRTL,
          weekDayFormat: weekDayFormat
        });
      }

      return render;
    }()
  }]);

  return DayPickerRangeController;
}(_react2['default'].Component);

exports['default'] = DayPickerRangeController;

DayPickerRangeController.propTypes = propTypes;
DayPickerRangeController.defaultProps = defaultProps;

/***/ })
/******/ ]);

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 72);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(41);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(25);

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(47);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(8);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(59);

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(13);

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(165);

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(152);

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(103);

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(128);

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(167);

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(268);

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(209);

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(381);

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(166);

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(269);

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(267);

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(625);

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(380);

/***/ }),
/* 37 */,
/* 38 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(592);

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _object3 = __webpack_require__(24);

var _object4 = _interopRequireDefault(_object3);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMomentProptypes = __webpack_require__(10);

var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);

var _airbnbPropTypes = __webpack_require__(1);

var _moment = __webpack_require__(7);

var _moment2 = _interopRequireDefault(_moment);

var _object = __webpack_require__(38);

var _object2 = _interopRequireDefault(_object);

var _isTouchDevice = __webpack_require__(9);

var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);

var _defaultPhrases = __webpack_require__(3);

var _getPhrasePropTypes = __webpack_require__(5);

var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);

var _isSameDay = __webpack_require__(22);

var _isSameDay2 = _interopRequireDefault(_isSameDay);

var _isAfterDay = __webpack_require__(20);

var _isAfterDay2 = _interopRequireDefault(_isAfterDay);

var _getVisibleDays = __webpack_require__(31);

var _getVisibleDays2 = _interopRequireDefault(_getVisibleDays);

var _isDayVisible = __webpack_require__(21);

var _isDayVisible2 = _interopRequireDefault(_isDayVisible);

var _toISODateString = __webpack_require__(13);

var _toISODateString2 = _interopRequireDefault(_toISODateString);

var _toISOMonthString = __webpack_require__(23);

var _toISOMonthString2 = _interopRequireDefault(_toISOMonthString);

var _ScrollableOrientationShape = __webpack_require__(8);

var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);

var _DayOfWeekShape = __webpack_require__(12);

var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);

var _constants = __webpack_require__(2);

var _DayPicker = __webpack_require__(36);

var _DayPicker2 = _interopRequireDefault(_DayPicker);

var _OutsideClickHandler = __webpack_require__(17);

var _OutsideClickHandler2 = _interopRequireDefault(_OutsideClickHandler);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
  date: _reactMomentProptypes2['default'].momentObj,
  onDateChange: _propTypes2['default'].func,

  focused: _propTypes2['default'].bool,
  onFocusChange: _propTypes2['default'].func,
  onClose: _propTypes2['default'].func,

  keepOpenOnDateSelect: _propTypes2['default'].bool,
  isOutsideRange: _propTypes2['default'].func,
  isDayBlocked: _propTypes2['default'].func,
  isDayHighlighted: _propTypes2['default'].func,

  // DayPicker props
  renderMonth: _propTypes2['default'].func,
  enableOutsideDays: _propTypes2['default'].bool,
  numberOfMonths: _propTypes2['default'].number,
  orientation: _ScrollableOrientationShape2['default'],
  withPortal: _propTypes2['default'].bool,
  initialVisibleMonth: _propTypes2['default'].func,
  firstDayOfWeek: _DayOfWeekShape2['default'],
  hideKeyboardShortcutsPanel: _propTypes2['default'].bool,
  daySize: _airbnbPropTypes.nonNegativeInteger,

  navPrev: _propTypes2['default'].node,
  navNext: _propTypes2['default'].node,

  onPrevMonthClick: _propTypes2['default'].func,
  onNextMonthClick: _propTypes2['default'].func,
  onOutsideClick: _propTypes2['default'].func,
  renderDay: _propTypes2['default'].func,
  renderCalendarInfo: _propTypes2['default'].func,

  // accessibility
  onBlur: _propTypes2['default'].func,
  isFocused: _propTypes2['default'].bool,
  showKeyboardShortcuts: _propTypes2['default'].bool,

  // i18n
  monthFormat: _propTypes2['default'].string,
  weekDayFormat: _propTypes2['default'].string,
  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DayPickerPhrases)),

  isRTL: _propTypes2['default'].bool
});

var defaultProps = {
  date: undefined, // TODO: use null
  onDateChange: function () {
    function onDateChange() {}

    return onDateChange;
  }(),

  focused: false,
  onFocusChange: function () {
    function onFocusChange() {}

    return onFocusChange;
  }(),
  onClose: function () {
    function onClose() {}

    return onClose;
  }(),

  keepOpenOnDateSelect: false,
  isOutsideRange: function () {
    function isOutsideRange() {}

    return isOutsideRange;
  }(),
  isDayBlocked: function () {
    function isDayBlocked() {}

    return isDayBlocked;
  }(),
  isDayHighlighted: function () {
    function isDayHighlighted() {}

    return isDayHighlighted;
  }(),

  // DayPicker props
  renderMonth: null,
  enableOutsideDays: false,
  numberOfMonths: 1,
  orientation: _constants.HORIZONTAL_ORIENTATION,
  withPortal: false,
  hideKeyboardShortcutsPanel: false,
  initialVisibleMonth: null,
  firstDayOfWeek: null,
  daySize: _constants.DAY_SIZE,

  navPrev: null,
  navNext: null,

  onPrevMonthClick: function () {
    function onPrevMonthClick() {}

    return onPrevMonthClick;
  }(),
  onNextMonthClick: function () {
    function onNextMonthClick() {}

    return onNextMonthClick;
  }(),

  onOutsideClick: null,

  renderDay: null,
  renderCalendarInfo: null,

  // accessibility
  onBlur: function () {
    function onBlur() {}

    return onBlur;
  }(),

  isFocused: false,
  showKeyboardShortcuts: false,

  // i18n
  monthFormat: 'MMMM YYYY',
  weekDayFormat: 'dd',
  phrases: _defaultPhrases.DayPickerPhrases,

  isRTL: false
};

var DayPickerSingleDateController = function (_React$Component) {
  _inherits(DayPickerSingleDateController, _React$Component);

  function DayPickerSingleDateController(props) {
    _classCallCheck(this, DayPickerSingleDateController);

    var _this = _possibleConstructorReturn(this, (DayPickerSingleDateController.__proto__ || Object.getPrototypeOf(DayPickerSingleDateController)).call(this, props));

    _this.isTouchDevice = false;
    _this.today = (0, _moment2['default'])();

    _this.modifiers = {
      today: function () {
        function today(day) {
          return _this.isToday(day);
        }

        return today;
      }(),
      blocked: function () {
        function blocked(day) {
          return _this.isBlocked(day);
        }

        return blocked;
      }(),
      'blocked-calendar': function () {
        function blockedCalendar(day) {
          return props.isDayBlocked(day);
        }

        return blockedCalendar;
      }(),
      'blocked-out-of-range': function () {
        function blockedOutOfRange(day) {
          return props.isOutsideRange(day);
        }

        return blockedOutOfRange;
      }(),
      'highlighted-calendar': function () {
        function highlightedCalendar(day) {
          return props.isDayHighlighted(day);
        }

        return highlightedCalendar;
      }(),
      valid: function () {
        function valid(day) {
          return !_this.isBlocked(day);
        }

        return valid;
      }(),
      hovered: function () {
        function hovered(day) {
          return _this.isHovered(day);
        }

        return hovered;
      }(),
      selected: function () {
        function selected(day) {
          return _this.isSelected(day);
        }

        return selected;
      }()
    };

    var _this$getStateForNewM = _this.getStateForNewMonth(props),
        currentMonth = _this$getStateForNewM.currentMonth,
        visibleDays = _this$getStateForNewM.visibleDays;

    _this.state = {
      hoverDate: null,
      currentMonth: currentMonth,
      visibleDays: visibleDays
    };

    _this.onDayMouseEnter = _this.onDayMouseEnter.bind(_this);
    _this.onDayMouseLeave = _this.onDayMouseLeave.bind(_this);
    _this.onDayClick = _this.onDayClick.bind(_this);

    _this.onPrevMonthClick = _this.onPrevMonthClick.bind(_this);
    _this.onNextMonthClick = _this.onNextMonthClick.bind(_this);

    _this.getFirstFocusableDay = _this.getFirstFocusableDay.bind(_this);
    return _this;
  }

  _createClass(DayPickerSingleDateController, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        this.isTouchDevice = (0, _isTouchDevice2['default'])();
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(nextProps) {
        var _this2 = this;

        var date = nextProps.date,
            focused = nextProps.focused,
            isOutsideRange = nextProps.isOutsideRange,
            isDayBlocked = nextProps.isDayBlocked,
            isDayHighlighted = nextProps.isDayHighlighted,
            initialVisibleMonth = nextProps.initialVisibleMonth,
            numberOfMonths = nextProps.numberOfMonths,
            enableOutsideDays = nextProps.enableOutsideDays;
        var visibleDays = this.state.visibleDays;

        var recomputeOutsideRange = false;
        var recomputeDayBlocked = false;
        var recomputeDayHighlighted = false;

        if (isOutsideRange !== this.props.isOutsideRange) {
          this.modifiers['blocked-out-of-range'] = function (day) {
            return isOutsideRange(day);
          };
          recomputeOutsideRange = true;
        }

        if (isDayBlocked !== this.props.isDayBlocked) {
          this.modifiers['blocked-calendar'] = function (day) {
            return isDayBlocked(day);
          };
          recomputeDayBlocked = true;
        }

        if (isDayHighlighted !== this.props.isDayHighlighted) {
          this.modifiers['highlighted-calendar'] = function (day) {
            return isDayHighlighted(day);
          };
          recomputeDayHighlighted = true;
        }

        var recomputePropModifiers = recomputeOutsideRange || recomputeDayBlocked || recomputeDayHighlighted;

        if (numberOfMonths !== this.props.numberOfMonths || enableOutsideDays !== this.props.enableOutsideDays || initialVisibleMonth !== this.props.initialVisibleMonth && !this.props.focused && focused) {
          var newMonthState = this.getStateForNewMonth(nextProps);
          var currentMonth = newMonthState.currentMonth;
          visibleDays = newMonthState.visibleDays;
          this.setState({
            currentMonth: currentMonth,
            visibleDays: visibleDays
          });
        }

        var didDateChange = date !== this.props.date;
        var didFocusChange = focused !== this.props.focused;

        var modifiers = {};

        if (didDateChange) {
          modifiers = this.deleteModifier(modifiers, this.props.date, 'selected');
          modifiers = this.addModifier(modifiers, date, 'selected');
        }

        if (didFocusChange || recomputePropModifiers) {
          (0, _object2['default'])(visibleDays).forEach(function (days) {
            Object.keys(days).forEach(function (day) {
              var momentObj = (0, _moment2['default'])(day);
              if (_this2.isBlocked(momentObj)) {
                modifiers = _this2.addModifier(modifiers, momentObj, 'blocked');
              } else {
                modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked');
              }

              if (didFocusChange || recomputeOutsideRange) {
                if (isOutsideRange(momentObj)) {
                  modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-out-of-range');
                } else {
                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-out-of-range');
                }
              }

              if (didFocusChange || recomputeDayBlocked) {
                if (isDayBlocked(momentObj)) {
                  modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-calendar');
                } else {
                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-calendar');
                }
              }

              if (didFocusChange || recomputeDayHighlighted) {
                if (isDayHighlighted(momentObj)) {
                  modifiers = _this2.addModifier(modifiers, momentObj, 'highlighted-calendar');
                } else {
                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'highlighted-calendar');
                }
              }
            });
          });
        }

        var today = (0, _moment2['default'])();
        if (!(0, _isSameDay2['default'])(this.today, today)) {
          modifiers = this.deleteModifier(modifiers, this.today, 'today');
          modifiers = this.addModifier(modifiers, today, 'today');
          this.today = today;
        }

        if (Object.keys(modifiers).length > 0) {
          this.setState({
            visibleDays: (0, _object4['default'])({}, visibleDays, modifiers)
          });
        }
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'componentWillUpdate',
    value: function () {
      function componentWillUpdate() {
        this.today = (0, _moment2['default'])();
      }

      return componentWillUpdate;
    }()
  }, {
    key: 'onDayClick',
    value: function () {
      function onDayClick(day, e) {
        if (e) e.preventDefault();
        if (this.isBlocked(day)) return;
        var _props = this.props,
            onDateChange = _props.onDateChange,
            keepOpenOnDateSelect = _props.keepOpenOnDateSelect,
            onFocusChange = _props.onFocusChange,
            onClose = _props.onClose;

        onDateChange(day);
        if (!keepOpenOnDateSelect) {
          onFocusChange({ focused: null });
          onClose({ date: day });
        }
      }

      return onDayClick;
    }()
  }, {
    key: 'onDayMouseEnter',
    value: function () {
      function onDayMouseEnter(day) {
        if (this.isTouchDevice) return;
        var _state = this.state,
            hoverDate = _state.hoverDate,
            visibleDays = _state.visibleDays;

        var modifiers = this.deleteModifier({}, hoverDate, 'hovered');
        modifiers = this.addModifier(modifiers, day, 'hovered');

        this.setState({
          hoverDate: day,
          visibleDays: (0, _object4['default'])({}, visibleDays, modifiers)
        });
      }

      return onDayMouseEnter;
    }()
  }, {
    key: 'onDayMouseLeave',
    value: function () {
      function onDayMouseLeave() {
        var _state2 = this.state,
            hoverDate = _state2.hoverDate,
            visibleDays = _state2.visibleDays;

        if (this.isTouchDevice || !hoverDate) return;

        var modifiers = this.deleteModifier({}, hoverDate, 'hovered');

        this.setState({
          hoverDate: null,
          visibleDays: (0, _object4['default'])({}, visibleDays, modifiers)
        });
      }

      return onDayMouseLeave;
    }()
  }, {
    key: 'onPrevMonthClick',
    value: function () {
      function onPrevMonthClick() {
        var _props2 = this.props,
            onPrevMonthClick = _props2.onPrevMonthClick,
            numberOfMonths = _props2.numberOfMonths,
            enableOutsideDays = _props2.enableOutsideDays;
        var _state3 = this.state,
            currentMonth = _state3.currentMonth,
            visibleDays = _state3.visibleDays;

        var newVisibleDays = {};
        Object.keys(visibleDays).sort().slice(0, numberOfMonths + 1).forEach(function (month) {
          newVisibleDays[month] = visibleDays[month];
        });

        var prevMonth = currentMonth.clone().subtract(1, 'month');
        var prevMonthVisibleDays = (0, _getVisibleDays2['default'])(prevMonth, 1, enableOutsideDays);

        this.setState({
          currentMonth: prevMonth,
          visibleDays: (0, _object4['default'])({}, newVisibleDays, this.getModifiers(prevMonthVisibleDays))
        });

        onPrevMonthClick(prevMonth.clone());
      }

      return onPrevMonthClick;
    }()
  }, {
    key: 'onNextMonthClick',
    value: function () {
      function onNextMonthClick() {
        var _props3 = this.props,
            onNextMonthClick = _props3.onNextMonthClick,
            numberOfMonths = _props3.numberOfMonths,
            enableOutsideDays = _props3.enableOutsideDays;
        var _state4 = this.state,
            currentMonth = _state4.currentMonth,
            visibleDays = _state4.visibleDays;

        var newVisibleDays = {};
        Object.keys(visibleDays).sort().slice(1).forEach(function (month) {
          newVisibleDays[month] = visibleDays[month];
        });

        var nextMonth = currentMonth.clone().add(numberOfMonths, 'month');
        var nextMonthVisibleDays = (0, _getVisibleDays2['default'])(nextMonth, 1, enableOutsideDays);

        var newCurrentMonth = currentMonth.clone().add(1, 'month');
        this.setState({
          currentMonth: newCurrentMonth,
          visibleDays: (0, _object4['default'])({}, newVisibleDays, this.getModifiers(nextMonthVisibleDays))
        });

        onNextMonthClick(newCurrentMonth.clone());
      }

      return onNextMonthClick;
    }()
  }, {
    key: 'getFirstFocusableDay',
    value: function () {
      function getFirstFocusableDay(newMonth) {
        var _this3 = this;

        var _props4 = this.props,
            date = _props4.date,
            numberOfMonths = _props4.numberOfMonths;

        var focusedDate = newMonth.clone().startOf('month');
        if (date) {
          focusedDate = date.clone();
        }

        if (this.isBlocked(focusedDate)) {
          var days = [];
          var lastVisibleDay = newMonth.clone().add(numberOfMonths - 1, 'months').endOf('month');
          var currentDay = focusedDate.clone();
          while (!(0, _isAfterDay2['default'])(currentDay, lastVisibleDay)) {
            currentDay = currentDay.clone().add(1, 'day');
            days.push(currentDay);
          }

          var viableDays = days.filter(function (day) {
            return !_this3.isBlocked(day) && (0, _isAfterDay2['default'])(day, focusedDate);
          });
          if (viableDays.length > 0) focusedDate = viableDays[0];
        }

        return focusedDate;
      }

      return getFirstFocusableDay;
    }()
  }, {
    key: 'getModifiers',
    value: function () {
      function getModifiers(visibleDays) {
        var _this4 = this;

        var modifiers = {};
        Object.keys(visibleDays).forEach(function (month) {
          modifiers[month] = {};
          visibleDays[month].forEach(function (day) {
            modifiers[month][(0, _toISODateString2['default'])(day)] = _this4.getModifiersForDay(day);
          });
        });

        return modifiers;
      }

      return getModifiers;
    }()
  }, {
    key: 'getModifiersForDay',
    value: function () {
      function getModifiersForDay(day) {
        var _this5 = this;

        return new Set(Object.keys(this.modifiers).filter(function (modifier) {
          return _this5.modifiers[modifier](day);
        }));
      }

      return getModifiersForDay;
    }()
  }, {
    key: 'getStateForNewMonth',
    value: function () {
      function getStateForNewMonth(nextProps) {
        var _this6 = this;

        var initialVisibleMonth = nextProps.initialVisibleMonth,
            date = nextProps.date,
            numberOfMonths = nextProps.numberOfMonths,
            enableOutsideDays = nextProps.enableOutsideDays;

        var initialVisibleMonthThunk = initialVisibleMonth || (date ? function () {
          return date;
        } : function () {
          return _this6.today;
        });
        var currentMonth = initialVisibleMonthThunk();
        var visibleDays = this.getModifiers((0, _getVisibleDays2['default'])(currentMonth, numberOfMonths, enableOutsideDays));
        return { currentMonth: currentMonth, visibleDays: visibleDays };
      }

      return getStateForNewMonth;
    }()
  }, {
    key: 'addModifier',
    value: function () {
      function addModifier(updatedDays, day, modifier) {
        var _props5 = this.props,
            numberOfVisibleMonths = _props5.numberOfMonths,
            enableOutsideDays = _props5.enableOutsideDays,
            orientation = _props5.orientation;
        var _state5 = this.state,
            firstVisibleMonth = _state5.currentMonth,
            visibleDays = _state5.visibleDays;

        var currentMonth = firstVisibleMonth;
        var numberOfMonths = numberOfVisibleMonths;
        if (orientation !== _constants.VERTICAL_SCROLLABLE) {
          currentMonth = currentMonth.clone().subtract(1, 'month');
          numberOfMonths += 2;
        }
        if (!day || !(0, _isDayVisible2['default'])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
          return updatedDays;
        }

        var iso = (0, _toISODateString2['default'])(day);

        var updatedDaysAfterAddition = (0, _object4['default'])({}, updatedDays);
        if (enableOutsideDays) {
          var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
            return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
          });

          updatedDaysAfterAddition = monthsToUpdate.reduce(function (days, monthIso) {
            var month = updatedDays[monthIso] || visibleDays[monthIso];
            var modifiers = new Set(month[iso]);
            modifiers.add(modifier);
            return (0, _object4['default'])({}, days, _defineProperty({}, monthIso, (0, _object4['default'])({}, month, _defineProperty({}, iso, modifiers))));
          }, updatedDaysAfterAddition);
        } else {
          var monthIso = (0, _toISOMonthString2['default'])(day);
          var month = updatedDays[monthIso] || visibleDays[monthIso];

          var modifiers = new Set(month[iso]);
          modifiers.add(modifier);
          updatedDaysAfterAddition = (0, _object4['default'])({}, updatedDaysAfterAddition, _defineProperty({}, monthIso, (0, _object4['default'])({}, month, _defineProperty({}, iso, modifiers))));
        }

        return updatedDaysAfterAddition;
      }

      return addModifier;
    }()
  }, {
    key: 'deleteModifier',
    value: function () {
      function deleteModifier(updatedDays, day, modifier) {
        var _props6 = this.props,
            numberOfVisibleMonths = _props6.numberOfMonths,
            enableOutsideDays = _props6.enableOutsideDays,
            orientation = _props6.orientation;
        var _state6 = this.state,
            firstVisibleMonth = _state6.currentMonth,
            visibleDays = _state6.visibleDays;

        var currentMonth = firstVisibleMonth;
        var numberOfMonths = numberOfVisibleMonths;
        if (orientation !== _constants.VERTICAL_SCROLLABLE) {
          currentMonth = currentMonth.clone().subtract(1, 'month');
          numberOfMonths += 2;
        }
        if (!day || !(0, _isDayVisible2['default'])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
          return updatedDays;
        }

        var iso = (0, _toISODateString2['default'])(day);

        var updatedDaysAfterDeletion = (0, _object4['default'])({}, updatedDays);
        if (enableOutsideDays) {
          var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
            return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
          });

          updatedDaysAfterDeletion = monthsToUpdate.reduce(function (days, monthIso) {
            var month = updatedDays[monthIso] || visibleDays[monthIso];
            var modifiers = new Set(month[iso]);
            modifiers['delete'](modifier);
            return (0, _object4['default'])({}, days, _defineProperty({}, monthIso, (0, _object4['default'])({}, month, _defineProperty({}, iso, modifiers))));
          }, updatedDaysAfterDeletion);
        } else {
          var monthIso = (0, _toISOMonthString2['default'])(day);
          var month = updatedDays[monthIso] || visibleDays[monthIso];

          var modifiers = new Set(month[iso]);
          modifiers['delete'](modifier);
          updatedDaysAfterDeletion = (0, _object4['default'])({}, updatedDaysAfterDeletion, _defineProperty({}, monthIso, (0, _object4['default'])({}, month, _defineProperty({}, iso, modifiers))));
        }

        return updatedDaysAfterDeletion;
      }

      return deleteModifier;
    }()
  }, {
    key: 'isBlocked',
    value: function () {
      function isBlocked(day) {
        var _props7 = this.props,
            isDayBlocked = _props7.isDayBlocked,
            isOutsideRange = _props7.isOutsideRange;

        return isDayBlocked(day) || isOutsideRange(day);
      }

      return isBlocked;
    }()
  }, {
    key: 'isHovered',
    value: function () {
      function isHovered(day) {
        var _ref = this.state || {},
            hoverDate = _ref.hoverDate;

        return (0, _isSameDay2['default'])(day, hoverDate);
      }

      return isHovered;
    }()
  }, {
    key: 'isSelected',
    value: function () {
      function isSelected(day) {
        return (0, _isSameDay2['default'])(day, this.props.date);
      }

      return isSelected;
    }()
  }, {
    key: 'isToday',
    value: function () {
      function isToday(day) {
        return (0, _isSameDay2['default'])(day, this.today);
      }

      return isToday;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props8 = this.props,
            numberOfMonths = _props8.numberOfMonths,
            orientation = _props8.orientation,
            monthFormat = _props8.monthFormat,
            renderMonth = _props8.renderMonth,
            navPrev = _props8.navPrev,
            navNext = _props8.navNext,
            withPortal = _props8.withPortal,
            focused = _props8.focused,
            enableOutsideDays = _props8.enableOutsideDays,
            hideKeyboardShortcutsPanel = _props8.hideKeyboardShortcutsPanel,
            daySize = _props8.daySize,
            firstDayOfWeek = _props8.firstDayOfWeek,
            renderDay = _props8.renderDay,
            renderCalendarInfo = _props8.renderCalendarInfo,
            isFocused = _props8.isFocused,
            isRTL = _props8.isRTL,
            phrases = _props8.phrases,
            onOutsideClick = _props8.onOutsideClick,
            onBlur = _props8.onBlur,
            showKeyboardShortcuts = _props8.showKeyboardShortcuts,
            weekDayFormat = _props8.weekDayFormat;
        var _state7 = this.state,
            currentMonth = _state7.currentMonth,
            visibleDays = _state7.visibleDays;

        var dayPickerComponent = _react2['default'].createElement(_DayPicker2['default'], {
          orientation: orientation,
          enableOutsideDays: enableOutsideDays,
          modifiers: visibleDays,
          numberOfMonths: numberOfMonths,
          onDayClick: this.onDayClick,
          onDayMouseEnter: this.onDayMouseEnter,
          onDayMouseLeave: this.onDayMouseLeave,
          onPrevMonthClick: this.onPrevMonthClick,
          onNextMonthClick: this.onNextMonthClick,
          monthFormat: monthFormat,
          withPortal: withPortal,
          hidden: !focused,
          hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
          initialVisibleMonth: function () {
            function initialVisibleMonth() {
              return currentMonth;
            }

            return initialVisibleMonth;
          }(),
          firstDayOfWeek: firstDayOfWeek,
          navPrev: navPrev,
          navNext: navNext,
          renderMonth: renderMonth,
          renderDay: renderDay,
          renderCalendarInfo: renderCalendarInfo,
          isFocused: isFocused,
          getFirstFocusableDay: this.getFirstFocusableDay,
          onBlur: onBlur,
          phrases: phrases,
          daySize: daySize,
          isRTL: isRTL,
          showKeyboardShortcuts: showKeyboardShortcuts,
          weekDayFormat: weekDayFormat
        });

        if (onOutsideClick) {
          return _react2['default'].createElement(_OutsideClickHandler2['default'], {
            onOutsideClick: onOutsideClick
          }, dayPickerComponent);
        }

        return dayPickerComponent;
      }

      return render;
    }()
  }]);

  return DayPickerSingleDateController;
}(_react2['default'].Component);

exports['default'] = DayPickerSingleDateController;

DayPickerSingleDateController.propTypes = propTypes;
DayPickerSingleDateController.defaultProps = defaultProps;

/***/ })
/******/ ]);

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 75);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __webpack_require__(41);

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function () {
      function render() {
        return _react2["default"].createElement(
          "svg",
          _extends({ viewBox: "0 0 12 12" }, this.props),
          _react2["default"].createElement("path", { fillRule: "evenodd", d: "M11.53.47a.75.75 0 0 0-1.061 0l-4.47 4.47L1.529.47A.75.75 0 1 0 .468 1.531l4.47 4.47-4.47 4.47a.75.75 0 1 0 1.061 1.061l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.061-1.061l-4.47-4.47 4.47-4.47a.75.75 0 0 0 0-1.061z" })
        );
      }

      return render;
    }()
  }]);

  return SVG;
}(_react2["default"].Component);

exports["default"] = SVG;

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = __webpack_require__(164);

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

module.exports = __webpack_require__(208);

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __webpack_require__(25);

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function () {
      function render() {
        return _react2["default"].createElement(
          "svg",
          _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1393.1 1500" }, this.props),
          _react2["default"].createElement("path", { d: "M107.2 1392.9h241.1v-241.1H107.2v241.1zm294.7 0h267.9v-241.1H401.9v241.1zm-294.7-294.7h241.1V830.4H107.2v267.8zm294.7 0h267.9V830.4H401.9v267.8zM107.2 776.8h241.1V535.7H107.2v241.1zm616.2 616.1h267.9v-241.1H723.4v241.1zM401.9 776.8h267.9V535.7H401.9v241.1zm642.9 616.1H1286v-241.1h-241.1v241.1zm-321.4-294.7h267.9V830.4H723.4v267.8zM428.7 375V133.9c0-7.3-2.7-13.5-8-18.8-5.3-5.3-11.6-8-18.8-8h-53.6c-7.3 0-13.5 2.7-18.8 8-5.3 5.3-8 11.6-8 18.8V375c0 7.3 2.7 13.5 8 18.8 5.3 5.3 11.6 8 18.8 8h53.6c7.3 0 13.5-2.7 18.8-8 5.3-5.3 8-11.5 8-18.8zm616.1 723.2H1286V830.4h-241.1v267.8zM723.4 776.8h267.9V535.7H723.4v241.1zm321.4 0H1286V535.7h-241.1v241.1zm26.8-401.8V133.9c0-7.3-2.7-13.5-8-18.8-5.3-5.3-11.6-8-18.8-8h-53.6c-7.3 0-13.5 2.7-18.8 8-5.3 5.3-8 11.6-8 18.8V375c0 7.3 2.7 13.5 8 18.8 5.3 5.3 11.6 8 18.8 8h53.6c7.3 0 13.5-2.7 18.8-8 5.4-5.3 8-11.5 8-18.8zm321.5-53.6v1071.4c0 29-10.6 54.1-31.8 75.3-21.2 21.2-46.3 31.8-75.3 31.8H107.2c-29 0-54.1-10.6-75.3-31.8C10.6 1447 0 1421.9 0 1392.9V321.4c0-29 10.6-54.1 31.8-75.3s46.3-31.8 75.3-31.8h107.2v-80.4c0-36.8 13.1-68.4 39.3-94.6S311.4 0 348.3 0h53.6c36.8 0 68.4 13.1 94.6 39.3 26.2 26.2 39.3 57.8 39.3 94.6v80.4h321.5v-80.4c0-36.8 13.1-68.4 39.3-94.6C922.9 13.1 954.4 0 991.3 0h53.6c36.8 0 68.4 13.1 94.6 39.3s39.3 57.8 39.3 94.6v80.4H1286c29 0 54.1 10.6 75.3 31.8 21.2 21.2 31.8 46.3 31.8 75.3z" })
        );
      }

      return render;
    }()
  }]);

  return SVG;
}(_react2["default"].Component);

exports["default"] = SVG;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __webpack_require__(47);

/***/ }),

/***/ 35:
/***/ (function(module, exports) {

module.exports = __webpack_require__(611);

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __webpack_require__(8);

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __webpack_require__(59);

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = __webpack_require__(55);

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _airbnbPropTypes = __webpack_require__(1);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _defaultPhrases = __webpack_require__(3);

var _getPhrasePropTypes = __webpack_require__(5);

var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);

var _DateInput = __webpack_require__(35);

var _DateInput2 = _interopRequireDefault(_DateInput);

var _IconPositionShape = __webpack_require__(19);

var _IconPositionShape2 = _interopRequireDefault(_IconPositionShape);

var _close = __webpack_require__(11);

var _close2 = _interopRequireDefault(_close);

var _calendar = __webpack_require__(27);

var _calendar2 = _interopRequireDefault(_calendar);

var _OpenDirectionShape = __webpack_require__(15);

var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
  id: _propTypes2['default'].string.isRequired,
  placeholder: _propTypes2['default'].string, // also used as label
  displayValue: _propTypes2['default'].string,
  inputValue: _propTypes2['default'].string,
  screenReaderMessage: _propTypes2['default'].string,
  focused: _propTypes2['default'].bool,
  isFocused: _propTypes2['default'].bool, // describes actual DOM focus
  disabled: _propTypes2['default'].bool,
  required: _propTypes2['default'].bool,
  readOnly: _propTypes2['default'].bool,
  openDirection: _OpenDirectionShape2['default'],
  showCaret: _propTypes2['default'].bool,
  showClearDate: _propTypes2['default'].bool,
  customCloseIcon: _propTypes2['default'].node,
  showDefaultInputIcon: _propTypes2['default'].bool,
  inputIconPosition: _IconPositionShape2['default'],
  customInputIcon: _propTypes2['default'].node,
  isRTL: _propTypes2['default'].bool,
  onChange: _propTypes2['default'].func,
  onClearDate: _propTypes2['default'].func,
  onFocus: _propTypes2['default'].func,
  onKeyDownShiftTab: _propTypes2['default'].func,
  onKeyDownTab: _propTypes2['default'].func,
  onKeyDownArrowDown: _propTypes2['default'].func,

  // i18n
  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.SingleDatePickerInputPhrases))
});

var defaultProps = {
  placeholder: 'Select Date',
  displayValue: '',
  inputValue: '',
  screenReaderMessage: '',
  focused: false,
  isFocused: false,
  disabled: false,
  required: false,
  readOnly: false,
  openDirection: _constants.OPEN_DOWN,
  showCaret: false,
  showClearDate: false,
  showDefaultInputIcon: false,
  inputIconPosition: _constants.ICON_BEFORE_POSITION,
  customCloseIcon: null,
  customInputIcon: null,
  isRTL: false,

  onChange: function () {
    function onChange() {}

    return onChange;
  }(),
  onClearDate: function () {
    function onClearDate() {}

    return onClearDate;
  }(),
  onFocus: function () {
    function onFocus() {}

    return onFocus;
  }(),
  onKeyDownShiftTab: function () {
    function onKeyDownShiftTab() {}

    return onKeyDownShiftTab;
  }(),
  onKeyDownTab: function () {
    function onKeyDownTab() {}

    return onKeyDownTab;
  }(),
  onKeyDownArrowDown: function () {
    function onKeyDownArrowDown() {}

    return onKeyDownArrowDown;
  }(),

  // i18n
  phrases: _defaultPhrases.SingleDatePickerInputPhrases
};

var SingleDatePickerInput = function (_React$Component) {
  _inherits(SingleDatePickerInput, _React$Component);

  function SingleDatePickerInput(props) {
    _classCallCheck(this, SingleDatePickerInput);

    var _this = _possibleConstructorReturn(this, (SingleDatePickerInput.__proto__ || Object.getPrototypeOf(SingleDatePickerInput)).call(this, props));

    _this.state = {
      isClearDateHovered: false
    };

    _this.onClearDateMouseEnter = _this.onClearDateMouseEnter.bind(_this);
    _this.onClearDateMouseLeave = _this.onClearDateMouseLeave.bind(_this);
    return _this;
  }

  _createClass(SingleDatePickerInput, [{
    key: 'onClearDateMouseEnter',
    value: function () {
      function onClearDateMouseEnter() {
        this.setState({
          isClearDateHovered: true
        });
      }

      return onClearDateMouseEnter;
    }()
  }, {
    key: 'onClearDateMouseLeave',
    value: function () {
      function onClearDateMouseLeave() {
        this.setState({
          isClearDateHovered: false
        });
      }

      return onClearDateMouseLeave;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var isClearDateHovered = this.state.isClearDateHovered;
        var _props = this.props,
            id = _props.id,
            placeholder = _props.placeholder,
            displayValue = _props.displayValue,
            inputValue = _props.inputValue,
            focused = _props.focused,
            isFocused = _props.isFocused,
            disabled = _props.disabled,
            required = _props.required,
            readOnly = _props.readOnly,
            openDirection = _props.openDirection,
            showCaret = _props.showCaret,
            showClearDate = _props.showClearDate,
            showDefaultInputIcon = _props.showDefaultInputIcon,
            inputIconPosition = _props.inputIconPosition,
            phrases = _props.phrases,
            onClearDate = _props.onClearDate,
            onChange = _props.onChange,
            onFocus = _props.onFocus,
            onKeyDownShiftTab = _props.onKeyDownShiftTab,
            onKeyDownTab = _props.onKeyDownTab,
            onKeyDownArrowDown = _props.onKeyDownArrowDown,
            screenReaderMessage = _props.screenReaderMessage,
            customCloseIcon = _props.customCloseIcon,
            customInputIcon = _props.customInputIcon,
            isRTL = _props.isRTL;

        var calendarIcon = customInputIcon || _react2['default'].createElement(_calendar2['default'], null);
        var closeIcon = customCloseIcon || _react2['default'].createElement(_close2['default'], null);
        var screenReaderText = screenReaderMessage || phrases.keyboardNavigationInstructions;
        var inputIcon = (showDefaultInputIcon || customInputIcon !== null) && _react2['default'].createElement('button', {
          type: 'button',
          className: 'SingleDatePickerInput__calendar-icon',
          disabled: disabled,
          'aria-label': phrases.focusStartDate,
          onClick: onFocus
        }, calendarIcon);

        return _react2['default'].createElement('div', {
          className: (0, _classnames2['default'])('SingleDatePickerInput', {
            'SingleDatePickerInput--disabled': disabled,
            'SingleDatePickerInput--rtl': isRTL
          })
        }, inputIconPosition === _constants.ICON_BEFORE_POSITION && inputIcon, _react2['default'].createElement(_DateInput2['default'], {
          id: id,
          placeholder: placeholder // also used as label
          , displayValue: displayValue,
          inputValue: inputValue,
          screenReaderMessage: screenReaderText,
          focused: focused,
          isFocused: isFocused,
          disabled: disabled,
          required: required,
          readOnly: readOnly,
          openDirection: openDirection,
          showCaret: showCaret,
          onChange: onChange,
          onFocus: onFocus,
          onKeyDownShiftTab: onKeyDownShiftTab,
          onKeyDownTab: onKeyDownTab,
          onKeyDownArrowDown: onKeyDownArrowDown
        }), showClearDate && _react2['default'].createElement('button', {
          type: 'button',
          className: (0, _classnames2['default'])('SingleDatePickerInput__clear-date', {
            'SingleDatePickerInput__clear-date--hide': !displayValue,
            'SingleDatePickerInput__clear-date--hover': isClearDateHovered
          }),
          disabled: disabled,
          'aria-label': phrases.clearDate,
          onMouseEnter: this.onClearDateMouseEnter,
          onMouseLeave: this.onClearDateMouseLeave,
          onClick: onClearDate
        }, _react2['default'].createElement('div', { className: 'DateRangePickerInput__close' }, closeIcon)), inputIconPosition === _constants.ICON_AFTER_POSITION && inputIcon);
      }

      return render;
    }()
  }]);

  return SingleDatePickerInput;
}(_react2['default'].Component);

exports['default'] = SingleDatePickerInput;

SingleDatePickerInput.propTypes = propTypes;
SingleDatePickerInput.defaultProps = defaultProps;

/***/ })

/******/ });

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _propTypes2['default'].oneOf([_constants.ANCHOR_LEFT, _constants.ANCHOR_RIGHT]);

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMomentProptypes = __webpack_require__(103);

var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);

var _airbnbPropTypes = __webpack_require__(41);

var _defaultPhrases = __webpack_require__(47);

var _getPhrasePropTypes = __webpack_require__(59);

var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);

var _FocusedInputShape = __webpack_require__(619);

var _FocusedInputShape2 = _interopRequireDefault(_FocusedInputShape);

var _IconPositionShape = __webpack_require__(208);

var _IconPositionShape2 = _interopRequireDefault(_IconPositionShape);

var _OrientationShape = __webpack_require__(620);

var _OrientationShape2 = _interopRequireDefault(_OrientationShape);

var _AnchorDirectionShape = __webpack_require__(617);

var _AnchorDirectionShape2 = _interopRequireDefault(_AnchorDirectionShape);

var _OpenDirectionShape = __webpack_require__(164);

var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);

var _DayOfWeekShape = __webpack_require__(128);

var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  // required props for a functional interactive DateRangePicker
  startDate: _reactMomentProptypes2['default'].momentObj,
  endDate: _reactMomentProptypes2['default'].momentObj,
  onDatesChange: _propTypes2['default'].func.isRequired,

  focusedInput: _FocusedInputShape2['default'],
  onFocusChange: _propTypes2['default'].func.isRequired,

  onClose: _propTypes2['default'].func,

  // input related props
  startDateId: _propTypes2['default'].string.isRequired,
  startDatePlaceholderText: _propTypes2['default'].string,
  endDateId: _propTypes2['default'].string.isRequired,
  endDatePlaceholderText: _propTypes2['default'].string,
  disabled: _propTypes2['default'].bool,
  required: _propTypes2['default'].bool,
  readOnly: _propTypes2['default'].bool,
  screenReaderInputMessage: _propTypes2['default'].string,
  showClearDates: _propTypes2['default'].bool,
  showDefaultInputIcon: _propTypes2['default'].bool,
  inputIconPosition: _IconPositionShape2['default'],
  customInputIcon: _propTypes2['default'].node,
  customArrowIcon: _propTypes2['default'].node,
  customCloseIcon: _propTypes2['default'].node,

  // calendar presentation and interaction related props
  renderMonth: _propTypes2['default'].func,
  orientation: _OrientationShape2['default'],
  anchorDirection: _AnchorDirectionShape2['default'],
  openDirection: _OpenDirectionShape2['default'],
  horizontalMargin: _propTypes2['default'].number,
  withPortal: _propTypes2['default'].bool,
  withFullScreenPortal: _propTypes2['default'].bool,
  daySize: _airbnbPropTypes.nonNegativeInteger,
  isRTL: _propTypes2['default'].bool,
  firstDayOfWeek: _DayOfWeekShape2['default'],
  initialVisibleMonth: _propTypes2['default'].func,
  numberOfMonths: _propTypes2['default'].number,
  keepOpenOnDateSelect: _propTypes2['default'].bool,
  reopenPickerOnClearDates: _propTypes2['default'].bool,
  renderCalendarInfo: _propTypes2['default'].func,
  hideKeyboardShortcutsPanel: _propTypes2['default'].bool,

  // navigation related props
  navPrev: _propTypes2['default'].node,
  navNext: _propTypes2['default'].node,
  onPrevMonthClick: _propTypes2['default'].func,
  onNextMonthClick: _propTypes2['default'].func,

  // day presentation and interaction related props
  renderDay: _propTypes2['default'].func,
  minimumNights: _propTypes2['default'].number,
  enableOutsideDays: _propTypes2['default'].bool,
  isDayBlocked: _propTypes2['default'].func,
  isOutsideRange: _propTypes2['default'].func,
  isDayHighlighted: _propTypes2['default'].func,

  // internationalization props
  displayFormat: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func]),
  monthFormat: _propTypes2['default'].string,
  weekDayFormat: _propTypes2['default'].string,
  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DateRangePickerPhrases))
};

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _propTypes2['default'].oneOf([_constants.START_DATE, _constants.END_DATE]);

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _propTypes2['default'].oneOf([_constants.HORIZONTAL_ORIENTATION, _constants.VERTICAL_ORIENTATION]);

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMomentProptypes = __webpack_require__(103);

var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);

var _airbnbPropTypes = __webpack_require__(41);

var _defaultPhrases = __webpack_require__(47);

var _getPhrasePropTypes = __webpack_require__(59);

var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);

var _IconPositionShape = __webpack_require__(208);

var _IconPositionShape2 = _interopRequireDefault(_IconPositionShape);

var _OrientationShape = __webpack_require__(620);

var _OrientationShape2 = _interopRequireDefault(_OrientationShape);

var _AnchorDirectionShape = __webpack_require__(617);

var _AnchorDirectionShape2 = _interopRequireDefault(_AnchorDirectionShape);

var _OpenDirectionShape = __webpack_require__(164);

var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);

var _DayOfWeekShape = __webpack_require__(128);

var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  // required props for a functional interactive SingleDatePicker
  date: _reactMomentProptypes2['default'].momentObj,
  onDateChange: _propTypes2['default'].func.isRequired,

  focused: _propTypes2['default'].bool,
  onFocusChange: _propTypes2['default'].func.isRequired,

  // input related props
  id: _propTypes2['default'].string.isRequired,
  placeholder: _propTypes2['default'].string,
  disabled: _propTypes2['default'].bool,
  required: _propTypes2['default'].bool,
  readOnly: _propTypes2['default'].bool,
  screenReaderInputMessage: _propTypes2['default'].string,
  showClearDate: _propTypes2['default'].bool,
  customCloseIcon: _propTypes2['default'].node,
  showDefaultInputIcon: _propTypes2['default'].bool,
  inputIconPosition: _IconPositionShape2['default'],
  customInputIcon: _propTypes2['default'].node,

  // calendar presentation and interaction related props
  renderMonth: _propTypes2['default'].func,
  orientation: _OrientationShape2['default'],
  anchorDirection: _AnchorDirectionShape2['default'],
  openDirection: _OpenDirectionShape2['default'],
  horizontalMargin: _propTypes2['default'].number,
  withPortal: _propTypes2['default'].bool,
  withFullScreenPortal: _propTypes2['default'].bool,
  initialVisibleMonth: _propTypes2['default'].func,
  firstDayOfWeek: _DayOfWeekShape2['default'],
  numberOfMonths: _propTypes2['default'].number,
  keepOpenOnDateSelect: _propTypes2['default'].bool,
  reopenPickerOnClearDate: _propTypes2['default'].bool,
  renderCalendarInfo: _propTypes2['default'].func,
  hideKeyboardShortcutsPanel: _propTypes2['default'].bool,
  daySize: _airbnbPropTypes.nonNegativeInteger,
  isRTL: _propTypes2['default'].bool,

  // navigation related props
  navPrev: _propTypes2['default'].node,
  navNext: _propTypes2['default'].node,

  onPrevMonthClick: _propTypes2['default'].func,
  onNextMonthClick: _propTypes2['default'].func,
  onClose: _propTypes2['default'].func,

  // day presentation and interaction related props
  renderDay: _propTypes2['default'].func,
  enableOutsideDays: _propTypes2['default'].bool,
  isDayBlocked: _propTypes2['default'].func,
  isOutsideRange: _propTypes2['default'].func,
  isDayHighlighted: _propTypes2['default'].func,

  // internationalization props
  displayFormat: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func]),
  monthFormat: _propTypes2['default'].string,
  weekDayFormat: _propTypes2['default'].string,
  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.SingleDatePickerPhrases))
};

/***/ }),
/* 622 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getCalendarMonthWidth;
var CALENDAR_MONTH_PADDING = 9;

function getCalendarMonthWidth(daySize) {
  return 7 * (daySize + 1) + 2 * (CALENDAR_MONTH_PADDING + 1);
}

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = getResponsiveContainerStyles;

var _constants = __webpack_require__(25);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getResponsiveContainerStyles(anchorDirection, currentOffset, containerEdge, margin) {
  var windowWidth = typeof window !== 'undefined' ? window.innerWidth : 0;
  var calculatedOffset = anchorDirection === _constants.ANCHOR_LEFT ? windowWidth - containerEdge : containerEdge;
  var calculatedMargin = margin || 0;

  return _defineProperty({}, anchorDirection, Math.min(currentOffset + calculatedOffset - calculatedMargin, 0));
}

/***/ }),
/* 624 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getTransformStyles;
function getTransformStyles(transformValue) {
  return {
    transform: transformValue,
    msTransform: transformValue,
    MozTransform: transformValue,
    WebkitTransform: transformValue
  };
}

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = getVisibleDays;

var _moment = __webpack_require__(13);

var _moment2 = _interopRequireDefault(_moment);

var _toISOMonthString = __webpack_require__(269);

var _toISOMonthString2 = _interopRequireDefault(_toISOMonthString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getVisibleDays(month, numberOfMonths, enableOutsideDays, withoutTransitionMonths) {
  if (!_moment2['default'].isMoment(month)) return {};

  var visibleDaysByMonth = {};
  var currentMonth = withoutTransitionMonths ? month.clone() : month.clone().subtract(1, 'month');
  for (var i = 0; i < (withoutTransitionMonths ? numberOfMonths : numberOfMonths + 2); i += 1) {
    var visibleDays = [];

    // set utc offset to get correct dates in future (when timezone changes)
    var baseDate = currentMonth.clone();
    var firstOfMonth = baseDate.clone().startOf('month').hour(12);
    var lastOfMonth = baseDate.clone().endOf('month').hour(12);

    var currentDay = firstOfMonth.clone();

    // days belonging to the previous month
    if (enableOutsideDays) {
      for (var j = 0; j < currentDay.weekday(); j += 1) {
        var prevDay = currentDay.clone().subtract(j + 1, 'day');
        visibleDays.unshift(prevDay);
      }
    }

    while (currentDay < lastOfMonth) {
      visibleDays.push(currentDay.clone());
      currentDay.add(1, 'day');
    }

    if (enableOutsideDays) {
      // weekday() returns the index of the day of the week according to the locale
      // this means if the week starts on Monday, weekday() will return 0 for a Monday date, not 1
      if (currentDay.weekday() !== 0) {
        // days belonging to the next month
        for (var k = currentDay.weekday(), count = 0; k < 7; k += 1, count += 1) {
          var nextDay = currentDay.clone().add(count, 'day');
          visibleDays.push(nextDay);
        }
      }
    }

    visibleDaysByMonth[(0, _toISOMonthString2['default'])(currentMonth)] = visibleDays;
    currentMonth = currentMonth.clone().add(1, 'month');
  }

  return visibleDaysByMonth;
}

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = isNextDay;

var _moment = __webpack_require__(13);

var _moment2 = _interopRequireDefault(_moment);

var _isSameDay = __webpack_require__(166);

var _isSameDay2 = _interopRequireDefault(_isSameDay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function isNextDay(a, b) {
  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
  var nextDay = (0, _moment2['default'])(a).add(1, 'day');
  return (0, _isSameDay2['default'])(nextDay, b);
}

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(22);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(129);

var invariant = __webpack_require__(12);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(170);
var ReactDOMComponentTree = __webpack_require__(33);
var ReactInstrumentation = __webpack_require__(73);

var quoteAttributeValueForBrowser = __webpack_require__(1531);
var warning = __webpack_require__(14);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(21);

var LinkedValueUtils = __webpack_require__(388);
var ReactDOMComponentTree = __webpack_require__(33);
var ReactUpdates = __webpack_require__(84);

var warning = __webpack_require__(14);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(22);

var invariant = __webpack_require__(12);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMSelection = __webpack_require__(1491);

var containsNode = __webpack_require__(1202);
var focusNode = __webpack_require__(516);
var getActiveElement = __webpack_require__(517);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(22);

var DOMLazyTree = __webpack_require__(169);
var DOMProperty = __webpack_require__(170);
var React = __webpack_require__(175);
var ReactBrowserEventEmitter = __webpack_require__(270);
var ReactCurrentOwner = __webpack_require__(95);
var ReactDOMComponentTree = __webpack_require__(33);
var ReactDOMContainerInfo = __webpack_require__(1485);
var ReactDOMFeatureFlags = __webpack_require__(1487);
var ReactFeatureFlags = __webpack_require__(633);
var ReactInstanceMap = __webpack_require__(214);
var ReactInstrumentation = __webpack_require__(73);
var ReactMarkupChecksum = __webpack_require__(1501);
var ReactReconciler = __webpack_require__(171);
var ReactUpdateQueue = __webpack_require__(391);
var ReactUpdates = __webpack_require__(84);

var emptyObject = __webpack_require__(250);
var instantiateReactComponent = __webpack_require__(644);
var invariant = __webpack_require__(12);
var setInnerHTML = __webpack_require__(274);
var shouldUpdateReactComponent = __webpack_require__(397);
var warning = __webpack_require__(14);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(22);

var React = __webpack_require__(175);

var invariant = __webpack_require__(12);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(22);

var invariant = __webpack_require__(12);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactNodeTypes = __webpack_require__(637);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(50);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(33);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  delete inst._wrapperState.valueTracker;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(22),
    _assign = __webpack_require__(21);

var ReactCompositeComponent = __webpack_require__(1482);
var ReactEmptyComponent = __webpack_require__(632);
var ReactHostComponent = __webpack_require__(634);

var getNextDebugID = __webpack_require__(1602);
var invariant = __webpack_require__(12);
var warning = __webpack_require__(14);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(50);
var escapeTextContentForBrowser = __webpack_require__(273);
var setInnerHTML = __webpack_require__(274);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(22);

var ReactCurrentOwner = __webpack_require__(95);
var REACT_ELEMENT_TYPE = __webpack_require__(1497);

var getIteratorFn = __webpack_require__(1528);
var invariant = __webpack_require__(12);
var KeyEscapeUtils = __webpack_require__(387);
var warning = __webpack_require__(14);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewportSizeType = exports.ColumnSizeType = undefined;

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ColumnSizeType = exports.ColumnSizeType = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]);
var ViewportSizeType = exports.ViewportSizeType = _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg']);

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(54);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KEYCODES = {
  ESCAPE: 27
};

var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    _classCallCheck(this, Portal);

    var _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this));

    _this.state = { active: false };
    _this.handleWrapperClick = _this.handleWrapperClick.bind(_this);
    _this.closePortal = _this.closePortal.bind(_this);
    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
    _this.handleKeydown = _this.handleKeydown.bind(_this);
    _this.portal = null;
    _this.node = null;
    return _this;
  }

  _createClass(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.closeOnEsc) {
        document.addEventListener('keydown', this.handleKeydown);
      }

      if (this.props.closeOnOutsideClick) {
        document.addEventListener('mouseup', this.handleOutsideMouseClick);
        document.addEventListener('touchstart', this.handleOutsideMouseClick);
      }

      if (this.props.isOpened) {
        this.openPortal();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      // portal's 'is open' state is handled through the prop isOpened
      if (typeof newProps.isOpened !== 'undefined') {
        if (newProps.isOpened) {
          if (this.state.active) {
            this.renderPortal(newProps);
          } else {
            this.openPortal(newProps);
          }
        }
        if (!newProps.isOpened && this.state.active) {
          this.closePortal();
        }
      }

      // portal handles its own 'is open' state
      if (typeof newProps.isOpened === 'undefined' && this.state.active) {
        this.renderPortal(newProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeOnEsc) {
        document.removeEventListener('keydown', this.handleKeydown);
      }

      if (this.props.closeOnOutsideClick) {
        document.removeEventListener('mouseup', this.handleOutsideMouseClick);
        document.removeEventListener('touchstart', this.handleOutsideMouseClick);
      }

      this.closePortal(true);
    }
  }, {
    key: 'handleWrapperClick',
    value: function handleWrapperClick(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.state.active) {
        return;
      }
      this.openPortal();
    }
  }, {
    key: 'openPortal',
    value: function openPortal() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      this.setState({ active: true });
      this.renderPortal(props);
      this.props.onOpen(this.node);
    }
  }, {
    key: 'closePortal',
    value: function closePortal() {
      var _this2 = this;

      var isUnmounted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var resetPortalState = function resetPortalState(overrideIsUnmounted) {
        if (_this2.node) {
          _reactDom2.default.unmountComponentAtNode(_this2.node);
          document.body.removeChild(_this2.node);
        }
        _this2.portal = null;
        _this2.node = null;

        var finalIsUnmounted = overrideIsUnmounted === undefined ? isUnmounted : overrideIsUnmounted;

        if (finalIsUnmounted !== true) {
          _this2.setState({ active: false });
        }
      };

      if (this.state.active) {
        if (this.props.beforeClose) {
          this.props.beforeClose(this.node, resetPortalState);
        } else {
          resetPortalState();
        }

        this.props.onClose();
      }
    }
  }, {
    key: 'handleOutsideMouseClick',
    value: function handleOutsideMouseClick(e) {
      if (!this.state.active) {
        return;
      }

      var root = (0, _reactDom.findDOMNode)(this.portal);
      if (root.contains(e.target) || e.button && e.button !== 0) {
        return;
      }

      e.stopPropagation();
      this.closePortal();
    }
  }, {
    key: 'handleKeydown',
    value: function handleKeydown(e) {
      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
        this.closePortal();
      }
    }
  }, {
    key: 'renderPortal',
    value: function renderPortal(props) {
      if (!this.node) {
        this.node = document.createElement('div');
        document.body.appendChild(this.node);
      }

      var children = props.children;
      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
      if (typeof props.children.type === 'function') {
        children = _react2.default.cloneElement(props.children, { closePortal: this.closePortal });
      }

      this.portal = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, children, this.node, this.props.onUpdate);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.openByClickOn) {
        return _react2.default.cloneElement(this.props.openByClickOn, { onClick: this.handleWrapperClick });
      }
      return null;
    }
  }]);

  return Portal;
}(_react2.default.Component);

exports.default = Portal;


Portal.propTypes = {
  children: _propTypes2.default.element.isRequired,
  openByClickOn: _propTypes2.default.element,
  closeOnEsc: _propTypes2.default.bool,
  closeOnOutsideClick: _propTypes2.default.bool,
  isOpened: _propTypes2.default.bool,
  onOpen: _propTypes2.default.func,
  onClose: _propTypes2.default.func,
  beforeClose: _propTypes2.default.func,
  onUpdate: _propTypes2.default.func
};

Portal.defaultProps = {
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  onUpdate: function onUpdate() {}
};
module.exports = exports['default'];


/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_storeShape__ = __webpack_require__(654);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_storeShape__["a" /* default */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2_react__["PropTypes"].instanceOf(__WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */]), _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2_react__["PropTypes"].instanceOf(__WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */]), _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + WrappedComponent));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = _this.props[storeKey] || _this.context[storeKey];
        _this.parentSub = props[subscriptionKey] || context[subscriptionKey];

        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or ' + ('props of "' + displayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        // make sure `getState` is properly bound in order to avoid breaking
        // custom store implementations that rely on the store's context
        _this.getState = _this.store.getState.bind(_this.store);

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        return _ref2 = {}, _ref2[subscriptionKey] = this.subscription || this.parentSub, _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        // these are just to guard against extra memory leakage if a parent element doesn't
        // dereference this instance properly, such as an async callback that never finishes
        this.subscription = null;
        this.store = null;
        this.parentSub = null;
        this.selector.run = function () {};
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var dispatch = this.store.dispatch;
        var getState = this.getState;

        var sourceSelector = selectorFactory(dispatch, selectorFactoryOptions);

        // wrap the selector in an object that tracks its results between runs
        var selector = this.selector = {
          shouldComponentUpdate: true,
          props: sourceSelector(getState(), this.props),
          run: function runComponentSelector(props) {
            try {
              var nextProps = sourceSelector(getState(), props);
              if (selector.error || nextProps !== selector.props) {
                selector.shouldComponentUpdate = true;
                selector.props = nextProps;
                selector.error = null;
              }
            } catch (error) {
              selector.shouldComponentUpdate = true;
              selector.error = error;
            }
          }
        };
      };

      Connect.prototype.initSubscription = function initSubscription() {
        var _this2 = this;

        if (shouldHandleStateChanges) {
          (function () {
            var subscription = _this2.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](_this2.store, _this2.parentSub);
            var dummyState = {};

            subscription.onStateChange = function onStateChange() {
              this.selector.run(this.props);

              if (!this.selector.shouldComponentUpdate) {
                subscription.notifyNestedSubs();
              } else {
                this.componentDidUpdate = function componentDidUpdate() {
                  this.componentDidUpdate = undefined;
                  subscription.notifyNestedSubs();
                };

                this.setState(dummyState);
              }
            }.bind(_this2);
          })();
        }
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          if (this.subscription) this.subscription.tryUnsubscribe();
          this.initSubscription();
          if (shouldHandleStateChanges) this.subscription.trySubscribe();
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(655);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      // this.onStateChange is set by connectAdvanced.initSubscription()
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired
}));

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(402);



function verifyPlainObject(value, displayName, methodName) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = exports.push = updateLocation('push');
var replace = exports.replace = updateLocation('replace');
var go = exports.go = updateLocation('go');
var goBack = exports.goBack = updateLocation('goBack');
var goForward = exports.goForward = updateLocation('goForward');

var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.routerReducer = routerReducer;
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  locationBeforeTransitions: null
};

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */
function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { locationBeforeTransitions: payload });
  }

  return state;
}

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(36);

var _invariant2 = _interopRequireDefault(_invariant);

var _PropTypes = __webpack_require__(406);

var _ContextUtils = __webpack_require__(405);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _React$PropTypes = _react2.default.PropTypes,
    bool = _React$PropTypes.bool,
    object = _React$PropTypes.object,
    string = _React$PropTypes.string,
    func = _React$PropTypes.func,
    oneOfType = _React$PropTypes.oneOfType;


function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function resolveToLocation(to, router) {
  return typeof to === 'function' ? to(router.location) : to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 *
 * Links may pass along location state and/or query string parameters
 * in the state/query props, respectively.
 *
 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
 */
var Link = _react2.default.createClass({
  displayName: 'Link',


  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],

  contextTypes: {
    router: _PropTypes.routerShape
  },

  propTypes: {
    to: oneOfType([string, object, func]),
    query: object,
    hash: string,
    state: object,
    activeStyle: object,
    activeClassName: string,
    onlyActiveOnIndex: bool.isRequired,
    onClick: func,
    target: string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    var router = this.context.router;

    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    router.push(resolveToLocation(this.props.to, router));
  },
  render: function render() {
    var _props = this.props,
        to = _props.to,
        activeClassName = _props.activeClassName,
        activeStyle = _props.activeStyle,
        onlyActiveOnIndex = _props.onlyActiveOnIndex,
        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);

    // Ignore if rendered outside the context of router to simplify unit testing.


    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (to == null) {
        return _react2.default.createElement('a', props);
      }

      var toLocation = resolveToLocation(to, router);
      props.href = router.createHref(toLocation);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(toLocation, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
  }
});

exports.default = Link;
module.exports = exports['default'];

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isPromise = isPromise;
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(36);

var _invariant2 = _interopRequireDefault(_invariant);

var _RouteUtils = __webpack_require__(104);

var _PatternUtils = __webpack_require__(172);

var _InternalPropTypes = __webpack_require__(216);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _React$PropTypes = _react2.default.PropTypes,
    string = _React$PropTypes.string,
    object = _React$PropTypes.object;

/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */
/* eslint-disable react/require-render-return */

var Redirect = _react2.default.createClass({
  displayName: 'Redirect',


  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element) {
      var route = (0, _RouteUtils.createRouteFromReactElement)(element);

      if (route.from) route.path = route.from;

      route.onEnter = function (nextState, replace) {
        var location = nextState.location,
            params = nextState.params;


        var pathname = void 0;
        if (route.to.charAt(0) === '/') {
          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
        } else if (!route.to) {
          pathname = location.pathname;
        } else {
          var routeIndex = nextState.routes.indexOf(route);
          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
        }

        replace({
          pathname: pathname,
          query: route.query || location.query,
          state: route.state || location.state
        });
      };

      return route;
    },
    getRoutePattern: function getRoutePattern(routes, routeIndex) {
      var parentPattern = '';

      for (var i = routeIndex; i >= 0; i--) {
        var route = routes[i];
        var pattern = route.path || '';

        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

        if (pattern.indexOf('/') === 0) break;
      }

      return '/' + parentPattern;
    }
  },

  propTypes: {
    path: string,
    from: string, // Alias for path
    to: string.isRequired,
    query: object,
    state: object,
    onEnter: _InternalPropTypes.falsy,
    children: _InternalPropTypes.falsy
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
  }
});

exports.default = Redirect;
module.exports = exports['default'];

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.createRouterObject = createRouterObject;
exports.assignRouterState = assignRouterState;
function createRouterObject(history, transitionManager, state) {
  var router = _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });

  return assignRouterState(router, state);
}

function assignRouterState(router, _ref) {
  var location = _ref.location,
      params = _ref.params,
      routes = _ref.routes;

  router.location = location;
  router.params = params;
  router.routes = routes;

  return router;
}

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createMemoryHistory;

var _useQueries = __webpack_require__(668);

var _useQueries2 = _interopRequireDefault(_useQueries);

var _useBasename = __webpack_require__(667);

var _useBasename2 = _interopRequireDefault(_useBasename);

var _createMemoryHistory = __webpack_require__(1573);

var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createMemoryHistory(options) {
  // signatures and type checking differ between `useQueries` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = (0, _createMemoryHistory2.default)(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
  return history;
}
module.exports = exports['default'];

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (createHistory) {
  var history = void 0;
  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
  return history;
};

var _useRouterHistory = __webpack_require__(665);

var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

module.exports = exports['default'];

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createTransitionManager;

var _routerWarning = __webpack_require__(173);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _computeChangedRoutes2 = __webpack_require__(1560);

var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);

var _TransitionUtils = __webpack_require__(1557);

var _isActive2 = __webpack_require__(1564);

var _isActive3 = _interopRequireDefault(_isActive2);

var _getComponents = __webpack_require__(1561);

var _getComponents2 = _interopRequireDefault(_getComponents);

var _matchRoutes = __webpack_require__(1566);

var _matchRoutes2 = _interopRequireDefault(_matchRoutes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)
  function isActive(location, indexOnly) {
    location = history.createLocation(location);

    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
        leaveRoutes = _computeChangedRoutes.leaveRoutes,
        changeRoutes = _computeChangedRoutes.changeRoutes,
        enterRoutes = _computeChangedRoutes.enterRoutes;

    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      (0, _getComponents2.default)(nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.map(function (route) {
      return RouteHooks[getRouteID(route)];
    }).filter(function (hook) {
      return hook;
    });
  }

  function transitionHook(location, callback) {
    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
    var routeID = getRouteID(route, true);

    RouteHooks[routeID] = hook;

    if (thereWereNoRouteHooks) {
      // setup transition & beforeunload hooks
      unlistenBefore = history.listenBefore(transitionHook);

      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
    }

    return function () {
      removeListenBeforeHooksForRoute(route);
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    function historyListener(location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    }

    // TODO: Only use a single history listener. Otherwise we'll end up with
    // multiple concurrent calls to match.

    // Set up the history listener first in case the initial match redirects.
    var unsubscribe = history.listen(historyListener);

    if (state.location) {
      // Picking up on a matchContext.
      listener(null, state);
    } else {
      historyListener(history.getCurrentLocation());
    }

    return unsubscribe;
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}
module.exports = exports['default'];

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = useRouterHistory;

var _useQueries = __webpack_require__(668);

var _useQueries2 = _interopRequireDefault(_useQueries);

var _useBasename = __webpack_require__(667);

var _useBasename2 = _interopRequireDefault(_useBasename);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useRouterHistory(createHistory) {
  return function (options) {
    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
    return history;
  };
}
module.exports = exports['default'];

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.readState = exports.saveState = undefined;

var _warning = __webpack_require__(107);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuotaExceededErrors = {
  QuotaExceededError: true,
  QUOTA_EXCEEDED_ERR: true
};

var SecurityErrors = {
  SecurityError: true
};

var KeyPrefix = '@@History/';

var createKey = function createKey(key) {
  return KeyPrefix + key;
};

var saveState = exports.saveState = function saveState(key, state) {
  if (!window.sessionStorage) {
    // Session storage is not available or hidden.
    // sessionStorage is undefined in Internet Explorer when served via file protocol.
     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;

    return;
  }

  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;

      return;
    }

    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;

      return;
    }

    throw error;
  }
};

var readState = exports.readState = function readState(key) {
  var json = void 0;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;

      return undefined;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return undefined;
};

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _runTransitionHook = __webpack_require__(411);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(105);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useBasename = function useBasename(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var basename = options.basename;


    var addBasename = function addBasename(location) {
      if (!location) return location;

      if (basename && location.basename == null) {
        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    };

    var prependBasename = function prependBasename(location) {
      if (!basename) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var pname = object.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, object, {
        pathname: pathname
      });
    };

    // Override all read methods with basename-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return addBasename(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(addBasename(location));
      });
    };

    // Override all write methods with basename-aware versions.
    var push = function push(location) {
      return history.push(prependBasename(location));
    };

    var replace = function replace(location) {
      return history.replace(prependBasename(location));
    };

    var createPath = function createPath(location) {
      return history.createPath(prependBasename(location));
    };

    var createHref = function createHref(location) {
      return history.createHref(prependBasename(location));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useBasename;

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = __webpack_require__(599);

var _runTransitionHook = __webpack_require__(411);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _LocationUtils = __webpack_require__(174);

var _PathUtils = __webpack_require__(105);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStringifyQuery = function defaultStringifyQuery(query) {
  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
};

var defaultParseQueryString = _queryString.parse;

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
var useQueries = function useQueries(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var stringifyQuery = options.stringifyQuery,
        parseQueryString = options.parseQueryString;


    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    var decodeQuery = function decodeQuery(location) {
      if (!location) return location;

      if (location.query == null) location.query = parseQueryString(location.search.substring(1));

      return location;
    };

    var encodeQuery = function encodeQuery(location, query) {
      if (query == null) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var queryString = stringifyQuery(query);
      var search = queryString ? '?' + queryString : '';

      return _extends({}, object, {
        search: search
      });
    };

    // Override all read methods with query-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return decodeQuery(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(decodeQuery(location));
      });
    };

    // Override all write methods with query-aware versions.
    var push = function push(location) {
      return history.push(encodeQuery(location, location.query));
    };

    var replace = function replace(location) {
      return history.replace(encodeQuery(location, location.query));
    };

    var createPath = function createPath(location) {
      return history.createPath(encodeQuery(location, location.query));
    };

    var createHref = function createHref(location) {
      return history.createHref(encodeQuery(location, location.query));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));

      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);

      return decodeQuery(newLocation);
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useQueries;

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _VirtualizedSelect = __webpack_require__(1576);

var _VirtualizedSelect2 = _interopRequireDefault(_VirtualizedSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _VirtualizedSelect2.default;

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = defaultCellRangeRenderer;

var _types = __webpack_require__(106);

/**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */
function defaultCellRangeRenderer(_ref) {
  var cellCache = _ref.cellCache,
      cellRenderer = _ref.cellRenderer,
      columnSizeAndPositionManager = _ref.columnSizeAndPositionManager,
      columnStartIndex = _ref.columnStartIndex,
      columnStopIndex = _ref.columnStopIndex,
      deferredMeasurementCache = _ref.deferredMeasurementCache,
      horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment,
      isScrolling = _ref.isScrolling,
      isScrollingOptOut = _ref.isScrollingOptOut,
      parent = _ref.parent,
      rowSizeAndPositionManager = _ref.rowSizeAndPositionManager,
      rowStartIndex = _ref.rowStartIndex,
      rowStopIndex = _ref.rowStopIndex,
      styleCache = _ref.styleCache,
      verticalOffsetAdjustment = _ref.verticalOffsetAdjustment,
      visibleColumnIndices = _ref.visibleColumnIndices,
      visibleRowIndices = _ref.visibleRowIndices;
  var renderedCells = []; // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
  // User cannot scroll beyond these size limitations.
  // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
  // We should never cache styles for compressed offsets though as this can lead to bugs.
  // See issue #576 for more.

  var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();
  var canCacheStyle = !isScrolling && !areOffsetsAdjusted;

  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);

    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
      var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
      var key = "".concat(rowIndex, "-").concat(columnIndex);
      var style = void 0; // Cache style objects so shallow-compare doesn't re-render unnecessarily.

      if (canCacheStyle && styleCache[key]) {
        style = styleCache[key];
      } else {
        // In deferred mode, cells will be initially rendered before we know their size.
        // Don't interfere with CellMeasurer's measurements by setting an invalid size.
        if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) {
          // Position not-yet-measured cells at top/left 0,0,
          // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
          // Positioning them further to the right/bottom influences their measured size.
          style = {
            height: 'auto',
            left: 0,
            position: 'absolute',
            top: 0,
            width: 'auto'
          };
        } else {
          style = {
            height: rowDatum.size,
            left: columnDatum.offset + horizontalOffsetAdjustment,
            position: 'absolute',
            top: rowDatum.offset + verticalOffsetAdjustment,
            width: columnDatum.size
          };
          styleCache[key] = style;
        }
      }

      var cellRendererParams = {
        columnIndex: columnIndex,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent,
        rowIndex: rowIndex,
        style: style
      };
      var renderedCell = void 0; // Avoid re-creating cells while scrolling.
      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
      // If a scroll is in progress- cache and reuse cells.
      // This cache will be thrown away once scrolling completes.
      // However if we are scaling scroll positions and sizes, we should also avoid caching.
      // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
      // For more info refer to issue #395
      //
      // If isScrollingOptOut is specified, we always cache cells.
      // For more info refer to issue #1028

      if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
        if (!cellCache[key]) {
          cellCache[key] = cellRenderer(cellRendererParams);
        }

        renderedCell = cellCache[key]; // If the user is no longer scrolling, don't cache cells.
        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
      } else {
        renderedCell = cellRenderer(cellRendererParams);
      }

      if (renderedCell == null || renderedCell === false) {
        continue;
      }

      if (false) {
        warnAboutMissingStyle(parent, renderedCell);
      }

      renderedCells.push(renderedCell);
    }
  }

  return renderedCells;
}

function warnAboutMissingStyle(parent, renderedCell) {
  if (false) {
    if (renderedCell) {
      // If the direct child is a CellMeasurer, then we should check its child
      // See issue #611
      if (renderedCell.type && renderedCell.type.__internalCellMeasurerFlag) {
        renderedCell = renderedCell.props.children;
      }

      if (renderedCell && renderedCell.props && renderedCell.props.style === undefined && parent.__warnedAboutMissingStyle !== true) {
        parent.__warnedAboutMissingStyle = true;
        console.warn('Rendered cell should include style property for positioning.');
      }
    }
  }
}

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = defaultOverscanIndicesGetter;
exports.SCROLL_DIRECTION_VERTICAL = exports.SCROLL_DIRECTION_HORIZONTAL = exports.SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_BACKWARD = void 0;

var _types = __webpack_require__(106);

var SCROLL_DIRECTION_BACKWARD = -1;
exports.SCROLL_DIRECTION_BACKWARD = SCROLL_DIRECTION_BACKWARD;
var SCROLL_DIRECTION_FORWARD = 1;
exports.SCROLL_DIRECTION_FORWARD = SCROLL_DIRECTION_FORWARD;
var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
exports.SCROLL_DIRECTION_HORIZONTAL = SCROLL_DIRECTION_HORIZONTAL;
var SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

exports.SCROLL_DIRECTION_VERTICAL = SCROLL_DIRECTION_VERTICAL;

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
  }
}

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(61);

var _interopRequireWildcard = __webpack_require__(182);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bpfrpt_proptype_Scroll = exports.bpfrpt_proptype_RenderedRows = exports.bpfrpt_proptype_RowRenderer = exports.bpfrpt_proptype_RowRendererParams = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var bpfrpt_proptype_RowRendererParams =  true ? null : {
  "index": _propTypes["default"].number.isRequired,
  "isScrolling": _propTypes["default"].bool.isRequired,
  "isVisible": _propTypes["default"].bool.isRequired,
  "key": _propTypes["default"].string.isRequired,
  "parent": _propTypes["default"].object.isRequired,
  "style": _propTypes["default"].object.isRequired
};
exports.bpfrpt_proptype_RowRendererParams = bpfrpt_proptype_RowRendererParams;
var bpfrpt_proptype_RowRenderer =  true ? null : _propTypes["default"].func;
exports.bpfrpt_proptype_RowRenderer = bpfrpt_proptype_RowRenderer;
var bpfrpt_proptype_RenderedRows =  true ? null : {
  "overscanStartIndex": _propTypes["default"].number.isRequired,
  "overscanStopIndex": _propTypes["default"].number.isRequired,
  "startIndex": _propTypes["default"].number.isRequired,
  "stopIndex": _propTypes["default"].number.isRequired
};
exports.bpfrpt_proptype_RenderedRows = bpfrpt_proptype_RenderedRows;
var bpfrpt_proptype_Scroll =  true ? null : {
  "clientHeight": _propTypes["default"].number.isRequired,
  "scrollHeight": _propTypes["default"].number.isRequired,
  "scrollTop": _propTypes["default"].number.isRequired
};
exports.bpfrpt_proptype_Scroll = bpfrpt_proptype_Scroll;

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(217),
    _assign = __webpack_require__(21);

var ReactNoopUpdateQueue = __webpack_require__(676);

var canDefineProperty = __webpack_require__(677);
var emptyObject = __webpack_require__(250);
var invariant = __webpack_require__(12);
var lowPriorityWarning = __webpack_require__(1603);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(217);

var ReactCurrentOwner = __webpack_require__(95);

var invariant = __webpack_require__(12);
var warning = __webpack_require__(14);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var warning = __webpack_require__(14);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NOT_ITERATOR_ERROR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANNEL_END; });
/* unused harmony export TASK_CANCEL */
/* harmony export (immutable) */ __webpack_exports__["b"] = proc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__io__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__channel__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__buffers__ = __webpack_require__(279);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }







var NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';

var CHANNEL_END = {
  toString: function toString() {
    return '@@redux-saga/CHANNEL_END';
  }
};
var TASK_CANCEL = {
  toString: function toString() {
    return '@@redux-saga/TASK_CANCEL';
  }
};

var matchers = {
  wildcard: function wildcard() {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* kTrue */];
  },
  default: function _default(pattern) {
    return (typeof pattern === 'undefined' ? 'undefined' : _typeof(pattern)) === 'symbol' ? function (input) {
      return input.type === pattern;
    } : function (input) {
      return input.type === String(pattern);
    };
  },
  array: function array(patterns) {
    return function (input) {
      return patterns.some(function (p) {
        return matcher(p)(input);
      });
    };
  },
  predicate: function predicate(_predicate) {
    return function (input) {
      return _predicate(input);
    };
  }
};

function matcher(pattern) {
  // prettier-ignore
  return (pattern === '*' ? matchers.wildcard : __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].array(pattern) ? matchers.array : __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].stringableFunc(pattern) ? matchers.default : __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func(pattern) ? matchers.predicate : matchers.default)(pattern);
}

/**
  Used to track a parent task and its forks
  In the new fork model, forked tasks are attached by default to their parent
  We model this using the concept of Parent task && main Task
  main task is the main flow of the current Generator, the parent tasks is the
  aggregation of the main tasks + all its forked tasks.
  Thus the whole model represents an execution tree with multiple branches (vs the
  linear execution tree in sequential (non parallel) programming)

  A parent tasks has the following semantics
  - It completes if all its forks either complete or all cancelled
  - If it's cancelled, all forks are cancelled as well
  - It aborts if any uncaught error bubbles up from forks
  - If it completes, the return value is the one returned by the main task
**/
function forkQueue(name, mainTask, cb) {
  var tasks = [],
      result = void 0,
      completed = false;
  addTask(mainTask);

  function abort(err) {
    cancelAll();
    cb(err, true);
  }

  function addTask(task) {
    tasks.push(task);
    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* remove */])(tasks, task);
      task.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* noop */];
      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }
        if (!tasks.length) {
          completed = true;
          cb(result);
        }
      }
    };
    // task.cont.cancel = task.cancel
  }

  function cancelAll() {
    if (completed) {
      return;
    }
    completed = true;
    tasks.forEach(function (t) {
      t.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* noop */];
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: function getTasks() {
      return tasks;
    },
    taskNames: function taskNames() {
      return tasks.map(function (t) {
        return t.name;
      });
    }
  };
}

function createTaskIterator(_ref) {
  var context = _ref.context,
      fn = _ref.fn,
      args = _ref.args;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].iterator(fn)) {
    return fn;
  }

  // catch synchronous failures; see #152 and #441
  var result = void 0,
      error = void 0;
  try {
    result = fn.apply(context, args);
  } catch (err) {
    error = err;
  }

  // i.e. a generator function returns an iterator
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].iterator(result)) {
    return result;
  }

  // do not bubble up synchronous failures for detached forks
  // instead create a failed task. See #152 and #441
  return error ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["j" /* makeIterator */])(function () {
    throw error;
  }) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["j" /* makeIterator */])(function () {
    var pc = void 0;
    var eff = { done: false, value: result };
    var ret = function ret(value) {
      return { done: true, value: value };
    };
    return function (arg) {
      if (!pc) {
        pc = true;
        return eff;
      } else {
        return ret(arg);
      }
    };
  }());
}

var wrapHelper = function wrapHelper(helper) {
  return { fn: helper };
};

function proc(iterator) {
  var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* noop */];
  };
  var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* noop */];
  var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* noop */];
  var parentContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var parentEffectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'anonymous';
  var cont = arguments[8];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].iterator, NOT_ITERATOR_ERROR);

  var effectsString = '[...effects]';
  var runParallelEffect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* deprecate */])(runAllEffect, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* updateIncentive */])(effectsString, 'all(' + effectsString + ')'));

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;

  var log = logger || __WEBPACK_IMPORTED_MODULE_0__utils__["w" /* log */];
  var stdChannel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* stdChannel */])(subscribe);
  var taskContext = Object.create(parentContext);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/
  next.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* noop */];

  /**
    Creates a new task descriptor for this generator, We'll also create a main task
    to track the main flow (besides other forked tasks)
  **/
  var task = newTask(parentEffectId, name, iterator, cont);
  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
  var taskQueue = forkQueue(name, mainTask, end);

  /**
    cancellation of the main task. We'll simply resume the Generator with a Cancel
  **/
  function cancelMain() {
    if (mainTask.isRunning && !mainTask.isCancelled) {
      mainTask.isCancelled = true;
      next(TASK_CANCEL);
    }
  }

  /**
    This may be called by a parent generator to trigger/propagate cancellation
    cancel all pending tasks (including the main task), then end the current task.
     Cancellation propagates down to the whole execution tree holded by this Parent task
    It's also propagated to all joiners of this task and their execution tree/joiners
     Cancellation is noop for terminated/Cancelled tasks tasks
  **/
  function cancel() {
    /**
      We need to check both Running and Cancelled status
      Tasks can be Cancelled but still Running
    **/
    if (iterator._isRunning && !iterator._isCancelled) {
      iterator._isCancelled = true;
      taskQueue.cancelAll();
      /**
        Ending with a Never result will propagate the Cancellation to all joiners
      **/
      end(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/
  cont && (cont.cancel = cancel);

  // tracks the running status
  iterator._isRunning = true;

  // kicks up the generator
  next();

  // then return the task descriptor to the caller
  return task;

  /**
    This is the generator driver
    It's a recursive async/continuation function which calls itself
    until the generator terminates or throws
  **/
  function next(arg, isErr) {
    // Preventive measure. If we end up here, then there is really something wrong
    if (!mainTask.isRunning) {
      throw new Error('Trying to resume an already finished generator');
    }

    try {
      var result = void 0;
      if (isErr) {
        result = iterator.throw(arg);
      } else if (arg === TASK_CANCEL) {
        /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.isCancelled = true;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/
        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
      } else if (arg === CHANNEL_END) {
        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func(iterator.return) ? iterator.return() : { done: true };
      } else {
        result = iterator.next(arg);
      }

      if (!result.done) {
        runEffect(result.value, parentEffectId, '', next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        mainTask.isMainRunning = false;
        mainTask.cont && mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.isCancelled) {
        log('error', 'uncaught at ' + name, error.message);
      }
      mainTask.isMainRunning = false;
      mainTask.cont(error, true);
    }
  }

  function end(result, isErr) {
    iterator._isRunning = false;
    stdChannel.close();
    if (!isErr) {
      if (false) {
        log('info', name + ' has been cancelled', '');
      }
      iterator._result = result;
      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
    } else {
      if (result instanceof Error) {
        result.sagaStack = 'at ' + name + ' \n ' + (result.sagaStack || result.stack);
      }
      if (!task.cont) {
        log('error', 'uncaught', result.sagaStack || result.stack);
        if (result instanceof Error && onError) {
          onError(result);
        }
      }
      iterator._error = result;
      iterator._isAborted = true;
      iterator._deferredEnd && iterator._deferredEnd.reject(result);
    }
    task.cont && task.cont(result, isErr);
    task.joiners.forEach(function (j) {
      return j.cb(result, isErr);
    });
    task.joiners = null;
  }

  function runEffect(effect, parentEffectId) {
    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var cb = arguments[3];

    var effectId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["x" /* uid */])();
    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });

    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/
    var effectSettled = void 0;

    // Completion callback passed to the appropriate effect runner
    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* noop */]; // defensive measure
      if (sagaMonitor) {
        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
      }
      cb(res, isErr);
    }
    // tracks down the current cancel
    currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* noop */];

    // setup cancellation logic on the parent cb
    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      /**
        propagates cancel downward
        catch uncaught cancellations errors; since we can no longer call the completion
        callback, log errors raised during cancellations into the console
      **/
      try {
        currCb.cancel();
      } catch (err) {
        log('error', 'uncaught at ' + name, err.message);
      }
      currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* noop */]; // defensive measure

      sagaMonitor && sagaMonitor.effectCancelled(effectId);
    };

    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      for completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    var data = void 0;
    // prettier-ignore
    return (
      // Non declarative effect
      __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].promise(effect) ? resolvePromise(effect, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].iterator(effect) ? resolveIterator(effect, effectId, name, currCb)

      // declarative effects
      : __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].array(effect) ? runParallelEffect(effect, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].take(effect)) ? runTakeEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].put(effect)) ? runPutEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].all(effect)) ? runAllEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].race(effect)) ? runRaceEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].call(effect)) ? runCallEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].cps(effect)) ? runCPSEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].fork(effect)) ? runForkEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].join(effect)) ? runJoinEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].cancel(effect)) ? runCancelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].select(effect)) ? runSelectEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].actionChannel(effect)) ? runChannelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].flush(effect)) ? runFlushEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].cancelled(effect)) ? runCancelledEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].getContext(effect)) ? runGetContextEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].setContext(effect)) ? runSetContextEffect(data, currCb) : /* anything else returned as is */currCb(effect)
    );
  }

  function resolvePromise(promise, cb) {
    var cancelPromise = promise[__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* CANCEL */]];
    if (__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func(cancelPromise)) {
      cb.cancel = cancelPromise;
    } else if (__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func(promise.abort)) {
      cb.cancel = function () {
        return promise.abort();
      };
      // TODO: add support for the fetch API, whenever they get around to
      // adding cancel support
    }
    promise.then(cb, function (error) {
      return cb(error, true);
    });
  }

  function resolveIterator(iterator, effectId, name, cb) {
    proc(iterator, subscribe, dispatch, getState, taskContext, options, effectId, name, cb);
  }

  function runTakeEffect(_ref2, cb) {
    var channel = _ref2.channel,
        pattern = _ref2.pattern,
        maybe = _ref2.maybe;

    channel = channel || stdChannel;
    var takeCb = function takeCb(inp) {
      return inp instanceof Error ? cb(inp, true) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__channel__["e" /* isEnd */])(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
    };
    try {
      channel.take(takeCb, matcher(pattern));
    } catch (err) {
      return cb(err, true);
    }
    cb.cancel = takeCb.cancel;
  }

  function runPutEffect(_ref3, cb) {
    var channel = _ref3.channel,
        action = _ref3.action,
        resolve = _ref3.resolve;

    /**
      Schedule the put in case another saga is holding a lock.
      The put will be executed atomically. ie nested puts will execute after
      this put has terminated.
    **/
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__scheduler__["a" /* asap */])(function () {
      var result = void 0;
      try {
        result = (channel ? channel.put : dispatch)(action);
      } catch (error) {
        // If we have a channel or `put.resolve` was used then bubble up the error.
        if (channel || resolve) return cb(error, true);
        log('error', 'uncaught at ' + name, error.stack || error.message || error);
      }

      if (resolve && __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].promise(result)) {
        resolvePromise(result, cb);
      } else {
        return cb(result);
      }
    });
    // Put effects are non cancellables
  }

  function runCallEffect(_ref4, effectId, cb) {
    var context = _ref4.context,
        fn = _ref4.fn,
        args = _ref4.args;

    var result = void 0;
    // catch synchronous failures; see #152
    try {
      result = fn.apply(context, args);
    } catch (error) {
      return cb(error, true);
    }
    return __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].promise(result) ? resolvePromise(result, cb) : __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
  }

  function runCPSEffect(_ref5, cb) {
    var context = _ref5.context,
        fn = _ref5.fn,
        args = _ref5.args;

    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb

    // catch synchronous failures; see #152
    try {
      var cpsCb = function cpsCb(err, res) {
        return __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].undef(err) ? cb(res) : cb(err, true);
      };
      fn.apply(context, args.concat(cpsCb));
      if (cpsCb.cancel) {
        cb.cancel = function () {
          return cpsCb.cancel();
        };
      }
    } catch (error) {
      return cb(error, true);
    }
  }

  function runForkEffect(_ref6, effectId, cb) {
    var context = _ref6.context,
        fn = _ref6.fn,
        args = _ref6.args,
        detached = _ref6.detached;

    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });

    try {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__scheduler__["b" /* suspend */])();
      var _task = proc(taskIterator, subscribe, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* noop */]);

      if (detached) {
        cb(_task);
      } else {
        if (taskIterator._isRunning) {
          taskQueue.addTask(_task);
          cb(_task);
        } else if (taskIterator._error) {
          taskQueue.abort(taskIterator._error);
        } else {
          cb(_task);
        }
      }
    } finally {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__scheduler__["c" /* flush */])();
    }
    // Fork effects are non cancellables
  }

  function runJoinEffect(t, cb) {
    if (t.isRunning()) {
      var joiner = { task: task, cb: cb };
      cb.cancel = function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* remove */])(t.joiners, joiner);
      };
      t.joiners.push(joiner);
    } else {
      t.isAborted() ? cb(t.error(), true) : cb(t.result());
    }
  }

  function runCancelEffect(taskToCancel, cb) {
    if (taskToCancel === __WEBPACK_IMPORTED_MODULE_0__utils__["f" /* SELF_CANCELLATION */]) {
      taskToCancel = task;
    }
    if (taskToCancel.isRunning()) {
      taskToCancel.cancel();
    }
    cb();
    // cancel effects are non cancellables
  }

  function runAllEffect(effects, effectId, cb) {
    var keys = Object.keys(effects);

    if (!keys.length) {
      return cb(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].array(effects) ? [] : {});
    }

    var completedCount = 0;
    var completed = void 0;
    var results = {};
    var childCbs = {};

    function checkEffectEnd() {
      if (completedCount === keys.length) {
        completed = true;
        cb(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].array(effects) ? __WEBPACK_IMPORTED_MODULE_0__utils__["y" /* array */].from(_extends({}, results, { length: keys.length })) : results);
      }
    }

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }
        if (isErr || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__channel__["e" /* isEnd */])(res) || res === CHANNEL_END || res === TASK_CANCEL) {
          cb.cancel();
          cb(res, isErr);
        } else {
          results[key] = res;
          completedCount++;
          checkEffectEnd();
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };

    keys.forEach(function (key) {
      return runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runRaceEffect(effects, effectId, cb) {
    var completed = void 0;
    var keys = Object.keys(effects);
    var childCbs = {};

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }

        if (isErr) {
          // Race Auto cancellation
          cb.cancel();
          cb(res, true);
        } else if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__channel__["e" /* isEnd */])(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
          var _cb;

          cb.cancel();
          completed = true;
          cb((_cb = {}, _cb[key] = res, _cb));
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      // prevents unnecessary cancellation
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };
    keys.forEach(function (key) {
      if (completed) {
        return;
      }
      runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runSelectEffect(_ref7, cb) {
    var selector = _ref7.selector,
        args = _ref7.args;

    try {
      var state = selector.apply(undefined, [getState()].concat(args));
      cb(state);
    } catch (error) {
      cb(error, true);
    }
  }

  function runChannelEffect(_ref8, cb) {
    var pattern = _ref8.pattern,
        buffer = _ref8.buffer;

    var match = matcher(pattern);
    match.pattern = pattern;
    cb(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__channel__["b" /* eventChannel */])(subscribe, buffer || __WEBPACK_IMPORTED_MODULE_4__buffers__["a" /* buffers */].fixed(), match));
  }

  function runCancelledEffect(data, cb) {
    cb(!!mainTask.isCancelled);
  }

  function runFlushEffect(channel, cb) {
    channel.flush(cb);
  }

  function runGetContextEffect(prop, cb) {
    cb(taskContext[prop]);
  }

  function runSetContextEffect(props, cb) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["z" /* object */].assign(taskContext, props);
    cb();
  }

  function newTask(id, name, iterator, cont) {
    var _done, _ref9, _mutatorMap;

    iterator._deferredEnd = null;
    return _ref9 = {}, _ref9[__WEBPACK_IMPORTED_MODULE_0__utils__["r" /* TASK */]] = true, _ref9.id = id, _ref9.name = name, _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
      if (iterator._deferredEnd) {
        return iterator._deferredEnd.promise;
      } else {
        var def = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["s" /* deferred */])();
        iterator._deferredEnd = def;
        if (!iterator._isRunning) {
          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
        }
        return def.promise;
      }
    }, _ref9.cont = cont, _ref9.joiners = [], _ref9.cancel = cancel, _ref9.isRunning = function isRunning() {
      return iterator._isRunning;
    }, _ref9.isCancelled = function isCancelled() {
      return iterator._isCancelled;
    }, _ref9.isAborted = function isAborted() {
      return iterator._isAborted;
    }, _ref9.result = function result() {
      return iterator._result;
    }, _ref9.error = function error() {
      return iterator._error;
    }, _ref9.setContext = function setContext(props) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].object, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])('task', props));
      __WEBPACK_IMPORTED_MODULE_0__utils__["z" /* object */].assign(taskContext, props);
    }, _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
  }
}

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = runSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__proc__ = __webpack_require__(678);



var RUN_SAGA_SIGNATURE = 'runSaga(storeInterface, saga, ...args)';
var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ': saga argument must be a Generator function!';

function runSaga(storeInterface, saga) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var iterator = void 0;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].iterator(storeInterface)) {
    if (false) {
      log('warn', 'runSaga(iterator, storeInterface) has been deprecated in favor of ' + RUN_SAGA_SIGNATURE);
    }
    iterator = storeInterface;
    storeInterface = saga;
  } else {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(saga, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func, NON_GENERATOR_ERR);
    iterator = saga.apply(undefined, args);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].iterator, NON_GENERATOR_ERR);
  }

  var _storeInterface = storeInterface,
      subscribe = _storeInterface.subscribe,
      dispatch = _storeInterface.dispatch,
      getState = _storeInterface.getState,
      context = _storeInterface.context,
      sagaMonitor = _storeInterface.sagaMonitor,
      logger = _storeInterface.logger,
      onError = _storeInterface.onError;


  var effectId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["x" /* uid */])();

  if (sagaMonitor) {
    // monitors are expected to have a certain interface, let's fill-in any missing ones
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* noop */];
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* noop */];
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* noop */];
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* noop */];
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* noop */];

    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
  }

  var task = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__proc__["b" /* default */])(iterator, subscribe, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["A" /* wrapSagaDispatch */])(dispatch), getState, context, { sagaMonitor: sagaMonitor, logger: logger, onError: onError }, effectId, saga.name);

  if (sagaMonitor) {
    sagaMonitor.effectResolved(effectId, task);
  }

  return task;
}

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return takeEvery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return takeLatest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return throttle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__takeEvery__ = __webpack_require__(1607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__takeLatest__ = __webpack_require__(1608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__throttle__ = __webpack_require__(1609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(67);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__takeEvery__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__takeLatest__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__throttle__["a"]; });






var deprecationWarning = function deprecationWarning(helperName) {
  return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
};

var takeEvery = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_0__takeEvery__["a" /* default */], /*#__PURE__*/deprecationWarning('takeEvery'));
var takeLatest = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_1__takeLatest__["a" /* default */], /*#__PURE__*/deprecationWarning('takeLatest'));
var throttle = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_2__throttle__["a" /* default */], /*#__PURE__*/deprecationWarning('throttle'));



/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = asap;
/* harmony export (immutable) */ __webpack_exports__["b"] = suspend;
/* harmony export (immutable) */ __webpack_exports__["c"] = flush;
var queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/
var semaphore = 0;

/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/
function exec(task) {
  try {
    suspend();
    task();
  } finally {
    release();
  }
}

/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/
function asap(task) {
  queue.push(task);

  if (!semaphore) {
    suspend();
    flush();
  }
}

/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/
function suspend() {
  semaphore++;
}

/**
  Puts the scheduler in a `released` state.
**/
function release() {
  semaphore--;
}

/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/
function flush() {
  release();

  var task = void 0;
  while (!semaphore && (task = queue.shift()) !== undefined) {
    exec(task);
  }
}

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = createStore;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utilsIsPlainObject = __webpack_require__(684);

var _utilsIsPlainObject2 = _interopRequireDefault(_utilsIsPlainObject);

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'
};

exports.ActionTypes = ActionTypes;
/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [initialState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, initialState) {
  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = initialState;
  var listeners = [];
  var isDispatching = false;

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    listeners.push(listener);
    var isSubscribed = true;

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;
      var index = listeners.indexOf(listener);
      listeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!_utilsIsPlainObject2['default'](action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    listeners.slice().forEach(function (listener) {
      return listener();
    });
    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  };
}

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Composes single-argument functions from right to left.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing functions from right to
 * left. For example, compose(f, g, h) is identical to arg => f(g(h(arg))).
 */


exports.__esModule = true;
exports["default"] = compose;

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return function (arg) {
    return funcs.reduceRight(function (composed, f) {
      return f(composed);
    }, arg);
  };
}

module.exports = exports["default"];

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = isPlainObject;
var fnToString = function fnToString(fn) {
  return Function.prototype.toString.call(fn);
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */

function isPlainObject(obj) {
  if (!obj || typeof obj !== 'object') {
    return false;
  }

  var proto = typeof obj.constructor === 'function' ? Object.getPrototypeOf(obj) : Object.prototype;

  if (proto === null) {
    return true;
  }

  var constructor = proto.constructor;

  return typeof constructor === 'function' && constructor instanceof constructor && fnToString(constructor) === fnToString(Object);
}

module.exports = exports['default'];

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Applies a function to every key-value pair inside an object.
 *
 * @param {Object} obj The source object.
 * @param {Function} fn The mapper function that receives the value and the key.
 * @returns {Object} A new object that contains the mapped values for the keys.
 */


exports.__esModule = true;
exports["default"] = mapValues;

function mapValues(obj, fn) {
  return Object.keys(obj).reduce(function (result, key) {
    result[key] = fn(obj[key], key);
    return result;
  }, {});
}

module.exports = exports["default"];

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcCloseComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-close"},React.createElement("path",{"id":"Vector","d":"M17.8741 7.33366L16.6993 6.16699L12 10.8337L7.30071 6.16699L6.12589 7.33366L10.8252 12.0003L6.12589 16.667L7.30071 17.8337L12 13.167L16.6993 17.8337L17.8741 16.667L13.1748 12.0003L17.8741 7.33366Z","fill":"#3E3E3E"})));
}

IcCloseComponent.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IcCloseComponent;

IcCloseComponent.default = IcCloseComponent;


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcHouseComponent (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"House","key":0},[React.createElement("g",{"id":"Group","key":0},[React.createElement("g",{"id":"Group_2","key":0},[React.createElement("path",{"id":"Vector","d":"M11.6181 22.472C12.9084 22.5691 14.7327 15.7728 15.4403 10.8874C16.0213 6.87501 16.0038 3.08338 15.2749 2.94799C14.7169 2.84426 13.9472 4.92097 13.4835 4.77106C12.8622 4.57011 14.0869 0.791203 13.0185 0.112151C12.3602 -0.306206 10.909 0.501742 10.0415 1.6098C8.4762 3.60906 9.09021 6.22804 9.9729 12.5259C11.1039 20.5966 10.9541 22.4221 11.6181 22.472Z","fill":"url(#paint0_linear_1342_6911)","key":0}),React.createElement("g",{"id":"Vector_2","style":{"mixBlendMode":"soft-light"},"opacity":"0.3","key":1},React.createElement("path",{"d":"M12.6776 17.9864C13.3006 16.1542 14.0436 15.2562 13.8869 13.6327C13.7501 12.2146 13.1044 12.0825 12.9285 10.4294C12.7294 8.55709 13.5092 8.27053 13.2909 6.77025C12.9879 4.68718 11.3688 4.44281 11.1562 2.61739C11.0891 2.04054 11.1576 1.26288 11.6594 0.262695C11.0906 0.547455 10.4884 1.03842 10.041 1.6096C8.47571 3.60886 9.08972 6.22784 9.97242 12.5257C11.1035 20.5964 10.9537 22.4219 11.6178 22.4718C11.7187 22.4794 11.8229 22.4449 11.9296 22.3723C11.9695 20.5058 12.3148 19.0528 12.6775 17.9861L12.6776 17.9864Z","fill":"white"}))]),React.createElement("g",{"id":"Group_3","key":1},[React.createElement("path",{"id":"Vector_3","d":"M11.2621 25.3978C13.8534 19.9194 11.3096 14.2411 11.2187 11.078C11.0143 3.96137 9.41399 2.4864 8.6223 1.9581C7.56735 1.25387 5.84997 0.830261 4.91885 1.64913C3.17678 3.18136 4.95696 8.38585 4.04673 8.76646C3.57568 8.96339 3.02799 7.59934 2.27672 7.75161C1.24917 7.95975 0.785438 10.8122 0.703244 11.523C0.0675334 17.0176 8.84487 23.638 11.2623 25.3978H11.2621Z","fill":"url(#paint1_linear_1342_6911)","key":0}),React.createElement("g",{"id":"Vector_4","style":{"mixBlendMode":"soft-light"},"opacity":"0.5","key":1},React.createElement("path",{"d":"M8.69406 18.4992C7.86223 16.1383 7.29067 15.861 7.15843 14.1768C6.9147 11.0708 8.69745 9.96374 8.07653 7.60877C7.63382 5.92981 6.59501 5.98928 5.75517 3.92266C5.41338 3.08153 5.24777 2.24025 5.18457 1.45996C5.09044 1.51376 5.00119 1.57627 4.91845 1.64902C3.17639 3.18124 4.95657 8.38574 4.04634 8.76634C3.57528 8.96328 3.0276 7.59923 2.27633 7.75136C1.24891 7.9595 0.785045 10.8119 0.702852 11.5228C0.0671409 17.0173 8.06283 23.3045 10.4801 25.0644C10.5041 24.9622 9.8643 24.2511 9.88763 24.1496C9.66777 21.6734 9.15264 19.801 8.69406 18.4992Z","fill":"white"}))])]),React.createElement("g",{"id":"Group_4","key":1},[React.createElement("g",{"id":"Group_5","key":0},[React.createElement("path",{"id":"Vector_5","d":"M31.4508 30.5628V27.0443L2.62744 27.0039V30.4922L8.8854 32.0003L31.4508 30.5628Z","fill":"white","key":0}),React.createElement("path",{"id":"Vector_6","d":"M31.3867 18.991V19.4308L33.3062 19.4487L32.8815 18.9969L31.3867 18.991Z","fill":"#D8DEE8","key":1}),React.createElement("path",{"id":"Vector_7","d":"M8.82356 28.4454L2.62744 27.0862V19.0012L8.82356 19.0622V28.4454Z","fill":"url(#paint2_linear_1342_6911)","key":2}),React.createElement("path",{"id":"Vector_8","d":"M32.8816 18.9749L31.4512 19.0031V27.1283L17.0904 27.9642L11.1416 28.3105L8.82373 28.4453V19.0621L18.7942 16.1657L24.7378 10.3149L32.8815 18.9749H32.8816ZM28.8069 26.4136V18.3637L20.0537 18.3485V26.8719L28.8069 26.4136Z","fill":"url(#paint3_linear_1342_6911)","key":3}),React.createElement("g",{"id":"Group_6","opacity":"0.2","key":4},React.createElement("path",{"id":"Vector_9","d":"M33.0249 19.0062L24.9652 10.3944L24.7181 10.1304L24.473 10.3705L18.5641 16.1623L8.66769 19.0045L7.31055 19.3942V19.6074H8.8238V19.4696L18.7599 16.6155L24.7379 10.7654L32.4596 19.0062H33.0249Z","fill":"#D8DEE8"})),React.createElement("path",{"id":"Vector_10","d":"M24.7181 9.67993L24.9652 9.94381L33.1226 18.6512L33.3332 18.8756V19.4462L33.3062 19.4487L32.884 18.9993L24.7379 10.3149L18.7599 16.1651L8.90925 19.1428L7.31055 19.5951V18.9438L8.66769 18.5541L18.5641 15.7117L24.473 9.92002L24.7181 9.67993Z","fill":"white","key":5}),React.createElement("g",{"id":"Group_7","key":6},[React.createElement("path",{"id":"Vector_11","d":"M28.7181 18.4753V26.3059L20.1523 26.748V18.467L28.7181 18.4755V18.4753ZM28.2635 25.5596V18.9859L26.2048 18.9909V25.6552L28.2635 25.5595V25.5596ZM25.6456 25.6812V18.9923L23.514 18.9976V25.7803L25.6456 25.6813V25.6812ZM22.9346 25.8072V18.9989L20.7257 19.0043V25.9098L22.9346 25.8072Z","fill":"white","key":0}),React.createElement("path",{"id":"Vector_12","d":"M20.0146 26.896V18.3264L28.856 18.3351V26.4396L20.0146 26.896ZM20.2904 18.608V26.6005L28.5804 26.1726V18.6162L20.2904 18.608ZM20.588 26.0572V18.8644L23.0725 18.8583V25.9418L20.588 26.0572ZM20.8637 19.1449V25.7631L22.7969 25.6732V19.1402L20.8637 19.1449ZM23.3763 25.9276V18.8576L25.7835 18.8518V25.8159L23.3763 25.9278V25.9276ZM23.652 19.1381V25.6335L25.5079 25.5472V19.1335L23.652 19.1381ZM26.067 25.8026V18.851L28.4014 18.8453V25.6942L26.067 25.8026ZM26.3427 19.1315V25.5085L28.1256 25.4256V19.1272L26.3427 19.1316V19.1315Z","fill":"white","key":1})]),React.createElement("path",{"id":"Vector_13","d":"M24.7181 9.67993L24.473 9.92016L18.5641 15.7117L11.3984 16.0943L16.7882 11.0263L17.0131 10.8154L24.7181 9.67993Z","fill":"url(#paint4_linear_1342_6911)","key":7}),React.createElement("path",{"id":"Vector_14","d":"M13.4014 23.1952L16.4355 23.1553L16.4336 29.9992L13.4014 30.1748V23.1952Z","fill":"#F4F7FA","key":8}),React.createElement("path",{"id":"Vector_15","d":"M12.8413 29.8418V23.4416L16.2122 23.4006V29.5808L12.8413 29.8418Z","fill":"#93C13E","key":9}),React.createElement("path",{"id":"Vector_16","d":"M11.1416 30.3523V22.3808L17.0799 22.3196V29.9616L16.4335 29.9991V23.1692L13.4012 23.2163V30.2215L11.1416 30.3523Z","fill":"white","key":10}),React.createElement("path",{"id":"Vector_17","d":"M18.5639 15.7117L8.6673 18.5541L7.31016 18.9436L1.27734 18.8988L2.48787 18.5634L11.3983 16.0942L18.5639 15.7117Z","fill":"url(#paint5_linear_1342_6911)","key":11}),React.createElement("path",{"id":"Vector_18","d":"M7.31029 19.5951L1.27734 19.4593V18.8989L7.31029 18.9439V19.5951Z","fill":"white","key":12}),React.createElement("path",{"id":"Vector_19","d":"M28.224 19.0364V25.5116L26.2461 25.6029V19.0419L28.224 19.0364Z","fill":"url(#paint6_linear_1342_6911)","key":13}),React.createElement("path",{"id":"Vector_20","d":"M22.892 19.0508V25.7571L20.7695 25.855V19.0567L22.892 19.0508Z","fill":"url(#paint7_linear_1342_6911)","key":14}),React.createElement("path",{"id":"Vector_21","d":"M25.605 19.0437V25.6324L23.5566 25.7269V19.0494L25.605 19.0437Z","fill":"url(#paint8_linear_1342_6911)","key":15}),React.createElement("path",{"id":"Vector_22","d":"M11.1416 30.3453L17.0799 29.9194L18.4667 31.5028L11.1416 31.844V30.3453Z","fill":"#E8E8E8","key":16})]),React.createElement("path",{"id":"Vector_23","d":"M23.6673 10.3592C23.6673 10.4248 23.6152 10.4779 23.5509 10.4779C23.4867 10.4779 23.4346 10.4248 23.4346 10.3592V9.93189C23.4346 9.86634 23.4867 9.81323 23.5509 9.81323C23.6152 9.81323 23.6673 9.86634 23.6673 9.93189V10.3592Z","fill":"url(#paint9_linear_1342_6911)","key":1}),React.createElement("path",{"id":"Vector_24","d":"M21.3387 12.6859C21.3387 12.7515 21.2866 12.8046 21.2223 12.8046C21.158 12.8046 21.106 12.7515 21.106 12.6859V12.2586C21.106 12.193 21.158 12.1399 21.2223 12.1399C21.2866 12.1399 21.3387 12.193 21.3387 12.2586V12.6859Z","fill":"url(#paint10_linear_1342_6911)","key":2}),React.createElement("path",{"id":"Vector_25","d":"M15.4705 16.4696C15.4705 16.5176 15.4185 16.5565 15.3542 16.5565C15.2899 16.5565 15.2378 16.5176 15.2378 16.4696V16.1567C15.2378 16.1087 15.2899 16.0698 15.3542 16.0698C15.4185 16.0698 15.4705 16.1087 15.4705 16.1567V16.4696Z","fill":"url(#paint11_linear_1342_6911)","key":3}),React.createElement("path",{"id":"Vector_26","d":"M11.6053 17.577C11.6053 17.6426 11.5532 17.6957 11.4889 17.6957C11.4246 17.6957 11.3726 17.6426 11.3726 17.577V17.1497C11.3726 17.0841 11.4246 17.031 11.4889 17.031C11.5532 17.031 11.6053 17.0841 11.6053 17.1497V17.577Z","fill":"url(#paint12_linear_1342_6911)","key":4}),React.createElement("path",{"id":"Vector_27","d":"M18.7772 15.2977C18.7772 15.3633 18.7251 15.4164 18.6608 15.4164C18.5965 15.4164 18.5444 15.3633 18.5444 15.2977V14.8704C18.5444 14.8048 18.5965 14.7517 18.6608 14.7517C18.7251 14.7517 18.7772 14.8048 18.7772 14.8704V15.2977Z","fill":"url(#paint13_linear_1342_6911)","key":5}),React.createElement("path",{"id":"Vector_28","d":"M12.0243 15.7252C12.0243 15.7908 11.9722 15.8439 11.9079 15.8439C11.8436 15.8439 11.7915 15.7908 11.7915 15.7252V15.2979C11.7915 15.2323 11.8436 15.1792 11.9079 15.1792C11.9722 15.1792 12.0243 15.2323 12.0243 15.2979V15.7252Z","fill":"url(#paint14_linear_1342_6911)","key":6}),React.createElement("g",{"id":"Group_8","key":7},[React.createElement("path",{"id":"Vector_29","d":"M16.6144 16.0078L10.1416 16.0335C10.0544 16.0338 9.872 16.0638 9.74491 16.1002L1.42451 18.4265C1.32265 18.4557 1.2703 18.5074 1.32699 18.5744L6.55103 18.7807C6.67432 18.7856 6.79612 18.7713 6.9152 18.7387C8.24481 18.3745 16.5766 16.1377 16.5766 16.1377C16.7281 16.0978 16.7182 16.0074 16.6144 16.0078Z","fill":"url(#paint15_linear_1342_6911)","key":0}),React.createElement("path",{"id":"Vector_30","d":"M16.5755 16.009L9.90545 16.0345C9.81878 16.0348 9.64599 16.0646 9.51958 16.1009L1.42461 18.4265C1.32329 18.4557 1.29671 18.481 1.36506 18.4832L6.58367 18.6536C6.66342 18.6562 6.83229 18.6333 6.95069 18.602L16.4998 16.0803C16.6503 16.0404 16.6785 16.0086 16.5755 16.009Z","fill":"url(#paint16_linear_1342_6911)","key":1}),React.createElement("g",{"id":"Group_9","key":2},[React.createElement("g",{"id":"Group_10","key":0},[React.createElement("path",{"id":"Vector_31","d":"M10.2625 16.1974L9.3413 16.4585C9.2469 16.4852 9.12877 16.5067 9.06488 16.5065L8.45522 16.505C8.39255 16.5049 8.40815 16.4834 8.50038 16.457L9.40125 16.199C9.49593 16.1718 9.63319 16.1497 9.69788 16.1496L10.3279 16.1482C10.394 16.1481 10.3592 16.1702 10.2624 16.1976L10.2625 16.1974Z","fill":"url(#paint17_linear_1342_6911)","key":0}),React.createElement("path",{"id":"Vector_32","d":"M11.3323 16.1956L10.3854 16.4603C10.2885 16.4874 10.1432 16.5091 10.0776 16.509L9.45106 16.5074C9.38664 16.5073 9.42597 16.4856 9.52078 16.4588L10.4463 16.1971C10.5436 16.1696 10.6606 16.1473 10.7272 16.147L11.3749 16.1455C11.4427 16.1454 11.4317 16.1676 11.3322 16.1956H11.3323Z","fill":"url(#paint18_linear_1342_6911)","key":1}),React.createElement("path",{"id":"Vector_33","d":"M12.4516 16.1431L11.7856 16.1446C11.7173 16.1447 11.5739 16.1675 11.4742 16.1953L10.524 16.4606C10.4268 16.4877 10.4087 16.5098 10.4747 16.51L11.1186 16.5116C11.1858 16.5118 11.3128 16.4898 11.4122 16.4623L12.3844 16.1938C12.4864 16.1656 12.5212 16.1429 12.4516 16.1431Z","fill":"url(#paint19_linear_1342_6911)","key":2}),React.createElement("path",{"id":"Vector_34","d":"M13.5586 16.1404L12.8735 16.1419C12.8033 16.142 12.6812 16.1651 12.5787 16.1934L11.6017 16.4623C11.5019 16.4899 11.4586 16.5121 11.5266 16.5124L12.1886 16.5141C12.2578 16.5142 12.4135 16.4919 12.5156 16.4641L13.5156 16.1918C13.6206 16.1632 13.6302 16.1402 13.5586 16.1404Z","fill":"url(#paint20_linear_1342_6911)","key":3}),React.createElement("path",{"id":"Vector_35","d":"M14.6982 16.1377L13.9931 16.1394C13.9209 16.1395 13.7711 16.163 13.6657 16.1916L12.6619 16.4645C12.5594 16.4924 12.5383 16.5151 12.6082 16.5153L13.2892 16.5169C13.3604 16.5171 13.4965 16.4944 13.6014 16.4662L14.6293 16.19C14.7371 16.1609 14.7718 16.1376 14.6982 16.1377Z","fill":"url(#paint21_linear_1342_6911)","key":4}),React.createElement("path",{"id":"Vector_36","d":"M15.8711 16.1353L15.1451 16.1369C15.0707 16.1371 14.9435 16.1608 14.8351 16.1899L13.8021 16.4668C13.6966 16.495 13.649 16.5181 13.7209 16.5182L14.4217 16.52C14.4949 16.5201 14.6616 16.4972 14.7697 16.4686L15.8278 16.1882C15.9389 16.1588 15.947 16.1351 15.8711 16.1353Z","fill":"url(#paint22_linear_1342_6911)","key":5})]),React.createElement("g",{"id":"Group_11","key":1},[React.createElement("path",{"id":"Vector_37","d":"M8.77659 16.6164L7.88942 16.8689C7.79854 16.8946 7.68461 16.9157 7.62317 16.9151L7.03629 16.9105C6.97593 16.91 6.99112 16.8892 7.07996 16.8637L7.94787 16.6129C8.03902 16.5868 8.17113 16.5638 8.23352 16.564L8.83966 16.5659C8.90314 16.5662 8.86977 16.5898 8.77646 16.6162L8.77659 16.6164Z","fill":"url(#paint23_linear_1342_6911)","key":0}),React.createElement("path",{"id":"Vector_38","d":"M9.80507 16.6228L8.89375 16.8777C8.80044 16.9038 8.6606 16.9243 8.59753 16.9238L7.99478 16.9188C7.9328 16.9182 7.97064 16.8972 8.06205 16.8713L8.95343 16.6194C9.04716 16.5929 9.15973 16.5716 9.22375 16.5718L9.84644 16.5739C9.91168 16.5741 9.90096 16.596 9.80521 16.6228H9.80507Z","fill":"url(#paint24_linear_1342_6911)","key":1}),React.createElement("path",{"id":"Vector_39","d":"M10.8807 16.5774L10.2406 16.5752C10.175 16.5749 10.0371 16.5965 9.94117 16.6233L9.02659 16.8786C8.93314 16.9048 8.91551 16.9263 8.97899 16.9269L9.59815 16.932C9.66285 16.9326 9.78492 16.9115 9.88054 16.8851L10.8159 16.6269C10.9139 16.5998 10.9474 16.5777 10.8806 16.5774H10.8807Z","fill":"url(#paint25_linear_1342_6911)","key":2}),React.createElement("path",{"id":"Vector_40","d":"M11.9443 16.5808L11.2863 16.5786C11.2188 16.5783 11.1014 16.6003 11.0028 16.6274L10.063 16.8862C9.967 16.9126 9.92523 16.9343 9.9906 16.9349L10.6269 16.9401C10.6933 16.9407 10.8431 16.9197 10.9413 16.8928L11.9028 16.631C12.0037 16.6035 12.013 16.581 11.9443 16.5807V16.5808Z","fill":"url(#paint26_linear_1342_6911)","key":3}),React.createElement("path",{"id":"Vector_41","d":"M13.0386 16.5846L12.3618 16.5823C12.2923 16.582 12.1485 16.6043 12.0472 16.6318L11.0822 16.8941C10.9836 16.921 10.9633 16.9431 11.0304 16.9437L11.6845 16.949C11.7529 16.9496 11.8837 16.928 11.9846 16.9009L12.9722 16.6355C13.0759 16.6077 13.1092 16.5849 13.0386 16.5846Z","fill":"url(#paint27_linear_1342_6911)","key":4}),React.createElement("path",{"id":"Vector_42","d":"M14.1637 16.5883L13.4673 16.5859C13.396 16.5857 13.2738 16.6082 13.1696 16.6361L12.1771 16.9021C12.0756 16.9293 12.0299 16.9516 12.0988 16.9522L12.7715 16.9577C12.8419 16.9582 13.002 16.9367 13.1057 16.9091L14.1219 16.64C14.2285 16.6118 14.2364 16.5886 14.1637 16.5883Z","fill":"url(#paint28_linear_1342_6911)","key":5})]),React.createElement("g",{"id":"Group_12","key":2},[React.createElement("path",{"id":"Vector_43","d":"M7.3451 17.024L6.49007 17.2663C6.40245 17.2912 6.29272 17.3105 6.23359 17.3097L5.66827 17.3018C5.61008 17.301 5.62473 17.2805 5.71059 17.2559L6.54744 17.0162C6.63533 16.9911 6.76269 16.9711 6.82264 16.9717L7.40613 16.9769C7.46717 16.9775 7.43502 16.9985 7.3451 17.024Z","fill":"url(#paint29_linear_1342_6911)","key":0}),React.createElement("path",{"id":"Vector_44","d":"M8.33468 17.0336L7.45687 17.2791C7.36694 17.3042 7.23226 17.3236 7.1715 17.3228L6.59126 17.3148C6.53158 17.3139 6.5682 17.2935 6.65609 17.2686L7.51506 17.0257C7.60525 17.0003 7.71376 16.9799 7.77534 16.9805L8.37443 16.9859C8.43722 16.9864 8.42692 17.0077 8.33468 17.0336Z","fill":"url(#paint30_linear_1342_6911)","key":1}),React.createElement("path",{"id":"Vector_45","d":"M9.30749 17.0432L8.40689 17.2917C8.31466 17.3172 8.19734 17.3371 8.13508 17.3363L7.53925 17.328C7.47794 17.3271 7.49489 17.306 7.58523 17.2808L8.46616 17.0349C8.55866 17.009 8.69118 16.9887 8.75438 16.9893L9.36988 16.9948C9.43431 16.9954 9.40216 17.0169 9.30749 17.0431V17.0432Z","fill":"url(#paint31_linear_1342_6911)","key":2}),React.createElement("path",{"id":"Vector_46","d":"M10.3922 17.0041L9.75971 16.9983C9.69487 16.9977 9.58189 17.0186 9.48695 17.0448L8.58214 17.294C8.48964 17.3194 8.44949 17.3406 8.51229 17.3414L9.12427 17.35C9.18815 17.3508 9.33219 17.3311 9.42673 17.3052L10.352 17.0532C10.4491 17.0268 10.4582 17.0047 10.392 17.0041H10.3922Z","fill":"url(#paint32_linear_1342_6911)","key":3}),React.createElement("path",{"id":"Vector_47","d":"M11.4428 17.0138L10.7926 17.0078C10.7259 17.0073 10.5876 17.0282 10.4903 17.0547L9.56171 17.3071C9.46677 17.333 9.44724 17.3545 9.5118 17.3555L10.1406 17.3642C10.2064 17.3652 10.3321 17.3447 10.4292 17.3186L11.3791 17.0634C11.4787 17.0366 11.5109 17.0145 11.4429 17.0138H11.4428Z","fill":"url(#paint33_linear_1342_6911)","key":4}),React.createElement("path",{"id":"Vector_48","d":"M12.5239 17.0234L11.8552 17.0174C11.7866 17.0167 11.6693 17.0382 11.5692 17.0651L10.6147 17.3209C10.5172 17.3471 10.4731 17.3686 10.5395 17.3696L11.1859 17.3786C11.2534 17.3796 11.4072 17.3592 11.5071 17.3327L12.4837 17.0739C12.5863 17.0468 12.5937 17.024 12.5239 17.0234Z","fill":"url(#paint34_linear_1342_6911)","key":5})]),React.createElement("g",{"id":"Group_13","key":3},[React.createElement("path",{"id":"Vector_49","d":"M5.96533 17.4154L5.14082 17.6492C5.05632 17.6731 4.95053 17.6916 4.89343 17.6905L4.34859 17.6799C4.29257 17.6788 4.30668 17.6586 4.38955 17.6349L5.19697 17.4037C5.28174 17.3793 5.40449 17.3605 5.46227 17.3614L6.02433 17.3697C6.0832 17.3705 6.052 17.391 5.96547 17.4154H5.96533Z","fill":"url(#paint35_linear_1342_6911)","key":0}),React.createElement("path",{"id":"Vector_50","d":"M6.91823 17.43L6.07201 17.6666C5.98535 17.6908 5.85554 17.7092 5.79709 17.7081L5.23814 17.6972C5.18064 17.6961 5.2159 17.676 5.30081 17.6521L6.12912 17.4179C6.21606 17.3933 6.32063 17.374 6.3799 17.3748L6.95675 17.3834C7.0171 17.3842 7.00707 17.4052 6.91823 17.4301V17.43Z","fill":"url(#paint36_linear_1342_6911)","key":1}),React.createElement("path",{"id":"Vector_51","d":"M7.85441 17.4447L6.98676 17.6842C6.89792 17.7087 6.78494 17.7276 6.72486 17.7265L6.15113 17.7153C6.09213 17.7142 6.10854 17.6936 6.19548 17.6693L7.04454 17.4322C7.13379 17.4073 7.26128 17.388 7.32218 17.389L7.91449 17.3977C7.97648 17.3986 7.94542 17.4195 7.85427 17.4447H7.85441Z","fill":"url(#paint37_linear_1342_6911)","key":2}),React.createElement("path",{"id":"Vector_52","d":"M8.85899 17.4602L7.96802 17.7028C7.87674 17.7277 7.73839 17.7464 7.67681 17.7451L7.0879 17.7335C7.02727 17.7323 7.06606 17.7118 7.15531 17.6873L8.02688 17.4472C8.11843 17.4221 8.22681 17.4021 8.28947 17.4031L8.89778 17.4121C8.96153 17.4131 8.95258 17.4348 8.85899 17.4602Z","fill":"url(#paint38_linear_1342_6911)","key":3}),React.createElement("path",{"id":"Vector_53","d":"M9.84668 17.4752L8.93252 17.7208C8.83893 17.746 8.71822 17.7653 8.65488 17.7641L8.04995 17.7522C7.9877 17.751 8.00669 17.7298 8.09824 17.7049L8.99233 17.4619C9.08632 17.4363 9.21897 17.4165 9.28326 17.4175L9.90826 17.4268C9.97377 17.4277 9.94285 17.4493 9.84668 17.4752Z","fill":"url(#paint39_linear_1342_6911)","key":4}),React.createElement("path",{"id":"Vector_54","d":"M10.947 17.4422L10.3045 17.4327C10.2385 17.4317 10.1257 17.4522 10.0293 17.478L9.11076 17.7242C9.0169 17.7494 8.97445 17.7704 9.0382 17.7716L9.65967 17.7838C9.72463 17.785 9.87261 17.7658 9.96864 17.7404L10.9082 17.4914C11.0068 17.4653 11.0141 17.4432 10.947 17.4422Z","fill":"url(#paint40_linear_1342_6911)","key":5})]),React.createElement("g",{"id":"Group_14","key":4},[React.createElement("path",{"id":"Vector_55","d":"M4.6347 17.7923L3.83895 18.0177C3.75743 18.0408 3.6553 18.0585 3.60037 18.0571L3.07493 18.0438C3.02081 18.0424 3.03464 18.0227 3.11453 17.9998L3.89388 17.7766C3.97566 17.7531 4.09407 17.7353 4.14982 17.7364L4.69153 17.7474C4.74823 17.7485 4.71812 17.7685 4.63457 17.7923H4.6347Z","fill":"url(#paint41_linear_1342_6911)","key":0}),React.createElement("path",{"id":"Vector_56","d":"M5.55304 17.8115L4.73694 18.0396C4.65325 18.063 4.5282 18.0804 4.47177 18.0789L3.9329 18.0652C3.87743 18.0639 3.91161 18.0443 3.99353 18.0213L4.79268 17.7953C4.87664 17.7715 4.97741 17.7531 5.03451 17.7542L5.59034 17.7655C5.64852 17.7668 5.63876 17.7874 5.55304 17.8113V17.8115Z","fill":"url(#paint42_linear_1342_6911)","key":1}),React.createElement("path",{"id":"Vector_57","d":"M6.45446 17.831L5.61801 18.062C5.53229 18.0856 5.42338 18.1038 5.3656 18.1022L4.8129 18.0883C4.75607 18.0869 4.77194 18.0667 4.85589 18.0432L5.67471 17.8146C5.7607 17.7905 5.88358 17.7723 5.94231 17.7735L6.51265 17.7853C6.57232 17.7865 6.54235 17.807 6.45446 17.8312V17.831Z","fill":"url(#paint43_linear_1342_6911)","key":2}),React.createElement("path",{"id":"Vector_58","d":"M7.42159 17.8511L6.56303 18.0848C6.47501 18.1088 6.34182 18.1265 6.28241 18.1249L5.71519 18.1106C5.65687 18.109 5.69417 18.0891 5.7803 18.0655L6.62054 17.8341C6.70884 17.8098 6.81328 17.7908 6.8735 17.7921L7.45902 17.8041C7.52033 17.8053 7.51179 17.8265 7.42159 17.8511Z","fill":"url(#paint44_linear_1342_6911)","key":3}),React.createElement("path",{"id":"Vector_59","d":"M8.37207 17.8716L7.49154 18.1082C7.40134 18.1324 7.2851 18.1508 7.22407 18.1493L6.6418 18.1345C6.58198 18.1329 6.60016 18.1123 6.68845 18.0883L7.54999 17.8541C7.64046 17.8295 7.76836 17.8107 7.83008 17.8121L8.43134 17.8244C8.49427 17.8256 8.46457 17.8467 8.37207 17.8716Z","fill":"url(#paint45_linear_1342_6911)","key":4}),React.createElement("path",{"id":"Vector_60","d":"M9.39236 17.8931L8.48796 18.1326C8.48348 18.1339 8.4706 18.1348 8.46531 18.1359C8.3747 18.1587 8.25019 18.1751 8.19065 18.1737L7.59278 18.1585C7.53134 18.157 7.57216 18.1365 7.66277 18.1123L8.54736 17.8752C8.55577 17.873 8.55496 17.8707 8.56459 17.8685C8.65343 17.8469 8.75448 17.831 8.81225 17.8321L9.43006 17.8448C9.49476 17.8462 9.48744 17.8679 9.39236 17.8931Z","fill":"url(#paint46_linear_1342_6911)","key":5})]),React.createElement("g",{"id":"Group_15","key":5},[React.createElement("path",{"id":"Vector_61","d":"M3.35006 18.1564L2.5817 18.374C2.50289 18.3963 2.40429 18.4133 2.35126 18.4117L1.84426 18.3959C1.79204 18.3942 1.80547 18.3749 1.88265 18.3529L2.63554 18.1371C2.71462 18.1145 2.82882 18.0975 2.88267 18.099L3.40526 18.1127C3.45992 18.114 3.43089 18.1335 3.35019 18.1564H3.35006Z","fill":"url(#paint47_linear_1342_6911)","key":0}),React.createElement("path",{"id":"Vector_62","d":"M4.23557 18.1801L3.44781 18.4004C3.36711 18.423 3.24626 18.4394 3.19187 18.4378L2.67213 18.4216C2.61869 18.4199 2.65165 18.401 2.73072 18.3786L3.50234 18.1603C3.58331 18.1374 3.68056 18.1197 3.73576 18.1212L4.27165 18.1353C4.32766 18.1368 4.3183 18.157 4.23557 18.1801Z","fill":"url(#paint48_linear_1342_6911)","key":1}),React.createElement("path",{"id":"Vector_63","d":"M5.10453 18.2033L4.29751 18.4261C4.21477 18.4489 4.10979 18.4661 4.05405 18.4644L3.52115 18.4478C3.46635 18.4462 3.48168 18.4264 3.56279 18.4037L4.35312 18.1831C4.43613 18.1599 4.55467 18.1426 4.61123 18.1441L5.16081 18.1585C5.21832 18.16 5.18943 18.18 5.10466 18.2033H5.10453Z","fill":"url(#paint49_linear_1342_6911)","key":2}),React.createElement("path",{"id":"Vector_64","d":"M6.03653 18.2287L5.20862 18.4541C5.12372 18.4772 4.99527 18.4939 4.93804 18.4921L4.39144 18.4751C4.33515 18.4733 4.37123 18.454 4.45437 18.4311L5.26491 18.2079C5.35009 18.1844 5.45073 18.1663 5.50878 18.1678L6.07274 18.1826C6.13174 18.1841 6.12347 18.2049 6.03653 18.2287Z","fill":"url(#paint50_linear_1342_6911)","key":3}),React.createElement("path",{"id":"Vector_65","d":"M6.95125 18.2534L6.10259 18.4814C6.01565 18.5048 5.90362 18.5224 5.84489 18.5204L5.28405 18.503C5.22641 18.5012 5.24404 18.481 5.32908 18.4579L6.1597 18.2322C6.24691 18.2085 6.37006 18.1907 6.4296 18.1922L7.00849 18.2074C7.06911 18.209 7.04036 18.2296 6.95111 18.2535L6.95125 18.2534Z","fill":"url(#paint51_linear_1342_6911)","key":4}),React.createElement("path",{"id":"Vector_66","d":"M7.93332 18.2798L7.06201 18.5106C6.97276 18.5343 6.83591 18.5513 6.77569 18.5495L6.20006 18.5316C6.14093 18.5298 6.18026 18.5099 6.26761 18.4866L7.1202 18.2581C7.20971 18.234 7.31415 18.2155 7.37519 18.2171L7.96967 18.2328C8.03192 18.2344 8.02487 18.2557 7.93345 18.2801L7.93332 18.2798Z","fill":"url(#paint52_linear_1342_6911)","key":5})])]),React.createElement("path",{"id":"Vector_67","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M9.52127 16.4587L10.3585 16.2219C10.2925 16.2923 10.1436 16.3857 9.86537 16.5083L9.45155 16.5072C9.38713 16.5071 9.42646 16.4855 9.52127 16.4587Z","fill":"url(#paint53_linear_1342_6911)","key":3}),React.createElement("path",{"id":"Vector_68","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M9.71303 16.5688C9.499 16.6521 9.22516 16.7597 8.88038 16.8751C8.78706 16.9013 8.66092 16.923 8.59785 16.9224L7.99524 16.918C7.93325 16.9175 7.97123 16.8967 8.06251 16.8708L8.95389 16.6168C9.04761 16.5904 9.16019 16.567 9.22421 16.5671L9.71303 16.5688Z","fill":"url(#paint54_linear_1342_6911)","key":4}),React.createElement("path",{"id":"Vector_69","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M7.58509 17.2807L8.36701 17.0625C8.11826 17.1697 7.95727 17.2579 7.87874 17.3326L7.53925 17.3279C7.47794 17.3271 7.49476 17.3059 7.58509 17.2807Z","fill":"url(#paint55_linear_1342_6911)","key":5}),React.createElement("path",{"id":"Vector_70","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M7.82728 17.3959C7.81507 17.4179 7.82823 17.4389 7.80395 17.4582L6.98676 17.6837C6.89792 17.7082 6.78494 17.7272 6.72486 17.7261L6.15113 17.7149C6.09213 17.7137 6.10854 17.6931 6.19548 17.6688L7.04454 17.4318C7.13379 17.4069 7.26128 17.3875 7.32218 17.3885L7.82728 17.3959Z","fill":"url(#paint56_linear_1342_6911)","key":6}),React.createElement("path",{"id":"Vector_71","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M5.10453 18.2031L4.29751 18.4259C4.21477 18.4487 4.10979 18.4659 4.05405 18.4642L3.52115 18.4476C3.46635 18.4459 3.48168 18.4262 3.56279 18.4035L4.35312 18.1829C4.43613 18.1597 4.55467 18.1424 4.61123 18.1439L5.16081 18.1583C5.21832 18.1598 5.18943 18.1797 5.10466 18.2031H5.10453Z","fill":"url(#paint57_linear_1342_6911)","key":7}),React.createElement("path",{"id":"Vector_72","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M7.8383 17.499C7.87153 17.5653 7.95142 17.6189 8.09261 17.6686L7.96851 17.7023C7.87722 17.7272 7.73888 17.7459 7.6773 17.7446L7.08838 17.733C7.02776 17.7318 7.06655 17.7113 7.15579 17.6868L7.8383 17.499Z","fill":"url(#paint58_linear_1342_6911)","key":8}),React.createElement("path",{"id":"Vector_73","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M8.09824 17.7047L8.13744 17.6941C8.1982 17.7155 8.25707 17.7363 8.31254 17.7572L8.04995 17.752C7.9877 17.7508 8.00669 17.7296 8.09824 17.7047Z","fill":"url(#paint59_linear_1342_6911)","key":9}),React.createElement("path",{"id":"Vector_74","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M7.66277 18.112L8.54736 17.8749C8.55577 17.8727 8.55496 17.8704 8.56459 17.8682C8.67174 17.9398 8.67879 18.0225 8.46137 18.1356C8.37077 18.1585 8.25019 18.1749 8.19065 18.1734L7.59278 18.1582C7.53134 18.1567 7.57216 18.1362 7.66277 18.112Z","fill":"url(#paint60_linear_1342_6911)","key":10})]),React.createElement("g",{"id":"Group_16","key":8},[React.createElement("path",{"id":"Vector_75","d":"M23.9863 9.3382L17.5144 9.99983C17.4301 10.0084 17.2929 10.0724 17.2182 10.1419L11.2938 15.6357C11.2021 15.7207 11.2056 15.7875 11.2917 15.7852L17.9584 15.5946C18.0619 15.5917 18.2195 15.5134 18.309 15.4202L24.0378 9.45465C24.1096 9.37997 24.0861 9.32796 23.9866 9.3382H23.9863Z","fill":"url(#paint61_linear_1342_6911)","key":0}),React.createElement("path",{"id":"Vector_76","d":"M23.7173 9.36553L17.2859 10.0231C17.2021 10.0317 17.0736 10.0947 16.9986 10.1639L11.07 15.6425C10.9783 15.7273 10.9729 15.7943 11.0583 15.7918L17.6784 15.6024C17.7812 15.5995 17.9483 15.5213 18.038 15.4283L23.7769 9.48074C23.8488 9.40633 23.8161 9.35544 23.7172 9.36553H23.7173Z","fill":"url(#paint62_linear_1342_6911)","key":1}),React.createElement("g",{"id":"Group_17","key":2},[React.createElement("g",{"id":"Group_18","key":0},[React.createElement("path",{"id":"Vector_77","d":"M17.8617 10.2479L17.3117 10.7648C17.2541 10.8191 17.1646 10.8668 17.0998 10.8727L16.4809 10.9293C16.4172 10.9351 16.4045 10.8971 16.4623 10.8434L17.0143 10.3314C17.071 10.2789 17.176 10.2306 17.2395 10.2242L17.8563 10.1628C17.9209 10.1563 17.9182 10.1949 17.8617 10.2479Z","fill":"url(#paint63_linear_1342_6911)","key":0}),React.createElement("path",{"id":"Vector_78","d":"M18.9133 10.1445L18.3663 10.6675C18.3089 10.7224 18.1943 10.7731 18.1277 10.7791L17.4919 10.8372C17.4265 10.8432 17.4355 10.8026 17.4931 10.7483L18.0426 10.2304C18.099 10.1773 18.1819 10.1306 18.247 10.1241L18.8804 10.0611C18.9467 10.0544 18.9695 10.0908 18.9133 10.1445Z","fill":"url(#paint64_linear_1342_6911)","key":1}),React.createElement("path",{"id":"Vector_79","d":"M19.932 9.95584L19.2814 10.0207C19.2146 10.0273 19.1083 10.0769 19.0523 10.1305L18.5057 10.6544C18.4485 10.7093 18.4632 10.7482 18.5302 10.7421L19.1836 10.6825C19.2518 10.6762 19.3454 10.6269 19.4024 10.5716L19.9462 10.0424C20.002 9.9882 20 9.94906 19.932 9.95584Z","fill":"url(#paint65_linear_1342_6911)","key":2}),React.createElement("path",{"id":"Vector_80","d":"M21.0131 9.84824L20.3446 9.9149C20.2759 9.92168 20.193 9.96939 20.1374 10.0237L19.5941 10.554C19.5373 10.6094 19.529 10.6511 19.5979 10.6448L20.2695 10.5836C20.3398 10.5772 20.4598 10.5248 20.5164 10.4688L21.0566 9.93329C21.112 9.87853 21.0829 9.84132 21.0131 9.84824Z","fill":"url(#paint66_linear_1342_6911)","key":3}),React.createElement("path",{"id":"Vector_81","d":"M22.1242 9.73728L21.4369 9.80574C21.3664 9.81279 21.2592 9.86341 21.2039 9.91831L20.6642 10.4546C20.6077 10.5108 20.6246 10.5508 20.6954 10.5443L21.3861 10.4812C21.4582 10.4746 21.5557 10.4238 21.612 10.367L22.1483 9.82524C22.2032 9.76978 22.1961 9.73009 22.1242 9.73714V9.73728Z","fill":"url(#paint67_linear_1342_6911)","key":4}),React.createElement("path",{"id":"Vector_82","d":"M23.2662 9.62372L22.5594 9.69411C22.487 9.7013 22.4045 9.75012 22.3497 9.80572L21.8141 10.3487C21.758 10.4055 21.7508 10.4483 21.8236 10.4416L22.5342 10.3768C22.6085 10.37 22.7341 10.3159 22.7899 10.2585L23.3217 9.71002C23.3761 9.65387 23.3401 9.61639 23.2664 9.62372H23.2662Z","fill":"url(#paint68_linear_1342_6911)","key":5})]),React.createElement("g",{"id":"Group_19","key":1},[React.createElement("path",{"id":"Vector_83","d":"M16.9624 11.0928L16.3944 11.6267C16.3348 11.6827 16.2436 11.7315 16.1785 11.7368L15.5571 11.787C15.4932 11.7921 15.4818 11.7521 15.5415 11.6966L16.1115 11.1681C16.1699 11.1139 16.2767 11.0648 16.3404 11.0591L16.9597 11.0035C17.0245 10.9977 17.0205 11.0379 16.9623 11.0927L16.9624 11.0928Z","fill":"url(#paint69_linear_1342_6911)","key":0}),React.createElement("path",{"id":"Vector_84","d":"M18.0187 10.9996L17.4535 11.5401C17.3942 11.5968 17.2777 11.6482 17.2108 11.6536L16.5723 11.7052C16.5066 11.7105 16.5171 11.6681 16.5766 11.612L17.1441 11.077C17.2023 11.0221 17.2869 10.9746 17.3523 10.9686L17.9886 10.9115C18.0552 10.9055 18.0767 10.9443 18.0187 10.9996Z","fill":"url(#paint70_linear_1342_6911)","key":1}),React.createElement("path",{"id":"Vector_85","d":"M19.0455 10.8168L18.3916 10.8754C18.3245 10.8815 18.2165 10.9319 18.1586 10.9872L17.5937 11.5285C17.5345 11.5852 17.548 11.6263 17.6154 11.6207L18.2718 11.5676C18.3405 11.5621 18.4358 11.5117 18.4947 11.4545L19.0569 10.9076C19.1144 10.8516 19.1138 10.8106 19.0455 10.8168Z","fill":"url(#paint71_linear_1342_6911)","key":2}),React.createElement("path",{"id":"Vector_86","d":"M20.1317 10.719L19.4595 10.7793C19.3906 10.7856 19.306 10.8344 19.2485 10.8904L18.6868 11.4385C18.628 11.4959 18.6185 11.5394 18.6876 11.5338L19.3628 11.4791C19.4333 11.4735 19.5554 11.4202 19.614 11.3623L20.1727 10.8085C20.2299 10.7518 20.202 10.7127 20.1317 10.7189V10.719Z","fill":"url(#paint72_linear_1342_6911)","key":3}),React.createElement("path",{"id":"Vector_87","d":"M21.2492 10.6193L20.5579 10.6813C20.4869 10.6876 20.3779 10.7392 20.3207 10.7961L19.7624 11.3508C19.7039 11.4089 19.7195 11.4511 19.7909 11.4452L20.4854 11.3891C20.558 11.3833 20.6576 11.3313 20.7156 11.2725L21.2705 10.712C21.3273 10.6546 21.3214 10.6128 21.2491 10.6193H21.2492Z","fill":"url(#paint73_linear_1342_6911)","key":4}),React.createElement("path",{"id":"Vector_88","d":"M22.3984 10.5159L21.6871 10.5796C21.6141 10.5861 21.5299 10.6362 21.4732 10.6936L20.919 11.2554C20.861 11.3143 20.8523 11.359 20.9257 11.353L21.6406 11.2952C21.7153 11.2891 21.8431 11.2342 21.9009 11.1748L22.4514 10.6069C22.5077 10.5488 22.4728 10.509 22.3985 10.5156L22.3984 10.5159Z","fill":"url(#paint74_linear_1342_6911)","key":5})]),React.createElement("g",{"id":"Group_20","key":2},[React.createElement("path",{"id":"Vector_89","d":"M16.0338 11.9662L15.447 12.5179C15.3854 12.5757 15.2923 12.6256 15.2271 12.6302L14.6036 12.6738C14.5394 12.6782 14.5294 12.6362 14.5913 12.5789L15.18 12.0329C15.2404 11.9769 15.3489 11.9269 15.4129 11.922L16.0347 11.8727C16.0998 11.8676 16.0943 11.9098 16.0341 11.9664L16.0338 11.9662Z","fill":"url(#paint75_linear_1342_6911)","key":0}),React.createElement("path",{"id":"Vector_90","d":"M17.0941 11.8833L16.5098 12.442C16.4485 12.5007 16.3301 12.5529 16.2629 12.5575L15.6219 12.6023C15.556 12.6069 15.568 12.5626 15.6294 12.5047L16.2159 11.9518C16.2761 11.895 16.3624 11.8464 16.428 11.8411L17.067 11.7905C17.1338 11.7852 17.1541 11.8259 17.0941 11.8833Z","fill":"url(#paint76_linear_1342_6911)","key":1}),React.createElement("path",{"id":"Vector_91","d":"M18.1375 11.8021L17.5561 12.3677C17.495 12.4271 17.3981 12.4784 17.329 12.4832L16.6697 12.5293C16.6019 12.534 16.5898 12.4908 16.6511 12.432L17.235 11.8723C17.295 11.8149 17.4046 11.7638 17.4721 11.7585L18.129 11.7065C18.1978 11.7011 18.1971 11.744 18.1375 11.8021Z","fill":"url(#paint77_linear_1342_6911)","key":2}),React.createElement("path",{"id":"Vector_92","d":"M19.221 11.62L18.5455 11.6735C18.4761 11.6791 18.3898 11.729 18.3303 11.7871L17.7494 12.354C17.6885 12.4133 17.6775 12.4589 17.7471 12.4541L18.4256 12.4068C18.4965 12.4018 18.6206 12.3479 18.6811 12.2879L19.2592 11.7147C19.3183 11.6561 19.2917 11.6145 19.221 11.6201V11.62Z","fill":"url(#paint78_linear_1342_6911)","key":3}),React.createElement("path",{"id":"Vector_93","d":"M20.3443 11.5312L19.649 11.5863C19.5777 11.592 19.4668 11.6445 19.4076 11.7033L18.83 12.2774C18.7695 12.3375 18.7837 12.3819 18.8553 12.3769L19.5537 12.3283C19.6267 12.3231 19.7281 12.27 19.7883 12.2093L20.3629 11.629C20.4216 11.5697 20.417 11.5257 20.3443 11.5315V11.5312Z","fill":"url(#paint79_linear_1342_6911)","key":4}),React.createElement("path",{"id":"Vector_94","d":"M21.5007 11.4395L20.7851 11.4962C20.7117 11.502 20.6257 11.5532 20.567 11.6128L19.9933 12.1945C19.9332 12.2555 19.923 12.3022 19.9968 12.2971L20.7161 12.2469C20.7914 12.2417 20.9213 12.1859 20.981 12.1242L21.5512 11.5361C21.6095 11.4759 21.5757 11.4336 21.5009 11.4395H21.5007Z","fill":"url(#paint80_linear_1342_6911)","key":5})]),React.createElement("g",{"id":"Group_21","key":3},[React.createElement("path",{"id":"Vector_95","d":"M15.0736 12.8682L14.4668 13.4385C14.4032 13.4984 14.3083 13.5493 14.2428 13.553L13.6172 13.5894C13.5529 13.5931 13.5444 13.5487 13.6083 13.4895L14.2167 12.9253C14.2791 12.8673 14.3895 12.8167 14.4535 12.8123L15.0773 12.7698C15.1427 12.7654 15.1358 12.8095 15.0735 12.868L15.0736 12.8682Z","fill":"url(#paint81_linear_1342_6911)","key":0}),React.createElement("path",{"id":"Vector_96","d":"M16.1383 12.7973L15.5339 13.3753C15.4705 13.436 15.3502 13.489 15.2828 13.493L14.6393 13.5303C14.5733 13.5342 14.5865 13.4879 14.6503 13.4278L15.2567 12.8562C15.319 12.7976 15.407 12.7478 15.4729 12.7433L16.1143 12.6996C16.1815 12.695 16.2004 12.738 16.1385 12.7973H16.1383Z","fill":"url(#paint82_linear_1342_6911)","key":1}),React.createElement("path",{"id":"Vector_97","d":"M17.1856 12.7271L16.5838 13.3124C16.5206 13.3738 16.4217 13.4263 16.3524 13.4304L15.6902 13.4688C15.6221 13.4728 15.6115 13.4272 15.675 13.3665L16.2791 12.7875C16.3411 12.7282 16.4526 12.6762 16.5204 12.6715L17.1803 12.6266C17.2495 12.6219 17.2473 12.6669 17.1856 12.727V12.7271Z","fill":"url(#paint83_linear_1342_6911)","key":2}),React.createElement("path",{"id":"Vector_98","d":"M18.3126 12.6521L17.7141 13.2454C17.6513 13.3077 17.5253 13.3624 17.4539 13.3666L16.7724 13.4061C16.7024 13.4101 16.715 13.3626 16.7781 13.301L17.3793 12.7143C17.441 12.6542 17.5289 12.6032 17.5987 12.5983L18.2776 12.5521C18.3488 12.5473 18.3739 12.5914 18.3126 12.6521Z","fill":"url(#paint84_linear_1342_6911)","key":3}),React.createElement("path",{"id":"Vector_99","d":"M19.4227 12.5781L18.8276 13.1793C18.7651 13.2423 18.662 13.2966 18.5883 13.3008L17.8863 13.3416C17.8141 13.3458 17.8012 13.299 17.8642 13.2367L18.4623 12.6423C18.5236 12.5813 18.6365 12.5279 18.7082 12.523L19.4071 12.4755C19.4804 12.4705 19.4836 12.5165 19.4226 12.5782L19.4227 12.5781Z","fill":"url(#paint85_linear_1342_6911)","key":4}),React.createElement("path",{"id":"Vector_100","d":"M20.5704 12.3963L19.8506 12.4453C19.7768 12.4502 19.6888 12.5028 19.628 12.5645L19.0336 13.1671C18.9713 13.2303 18.9596 13.2792 19.0337 13.2749L19.757 13.2329C19.8327 13.2285 19.965 13.1718 20.0268 13.1079L20.6178 12.4982C20.6782 12.4359 20.6456 12.3909 20.5703 12.3962L20.5704 12.3963Z","fill":"url(#paint86_linear_1342_6911)","key":5})]),React.createElement("g",{"id":"Group_22","key":4},[React.createElement("path",{"id":"Vector_101","d":"M14.0815 13.801L13.4538 14.391C13.3879 14.4529 13.2912 14.5049 13.2254 14.508L12.5981 14.5366C12.5337 14.5395 12.5267 14.4928 12.5927 14.4315L13.2219 13.8482C13.2864 13.7883 13.3986 13.7367 13.4629 13.7331L14.0887 13.698C14.1542 13.6942 14.1458 13.7406 14.0814 13.8011L14.0815 13.801Z","fill":"url(#paint87_linear_1342_6911)","key":0}),React.createElement("path",{"id":"Vector_102","d":"M15.1498 13.7429L14.5242 14.341C14.4586 14.4038 14.3361 14.4578 14.2686 14.4608L13.623 14.4903C13.5566 14.4933 13.5717 14.4448 13.6376 14.3828L14.2649 13.7914C14.3292 13.7307 14.4191 13.6798 14.4853 13.6761L15.129 13.6399C15.1964 13.6361 15.2139 13.6816 15.1498 13.7429Z","fill":"url(#paint88_linear_1342_6911)","key":1}),React.createElement("path",{"id":"Vector_103","d":"M16.2016 13.685L15.5785 14.2912C15.5131 14.3548 15.4122 14.4084 15.3425 14.4116L14.6779 14.4419C14.6097 14.4451 14.6006 14.397 14.6663 14.334L15.2915 13.7348C15.3557 13.6734 15.4692 13.6204 15.5373 13.6165L16.1999 13.5793C16.2693 13.5755 16.2656 13.6227 16.2018 13.685H16.2016Z","fill":"url(#paint89_linear_1342_6911)","key":2}),React.createElement("path",{"id":"Vector_104","d":"M17.334 13.6227L16.7139 14.2375C16.6488 14.302 16.5206 14.3576 16.4489 14.361L15.7643 14.3922C15.6941 14.3954 15.7083 14.3456 15.7737 14.2817L16.3964 13.6742C16.4603 13.6119 16.5501 13.5595 16.6202 13.5556L17.3023 13.5173C17.3738 13.5133 17.3976 13.5598 17.3342 13.6229L17.334 13.6227Z","fill":"url(#paint90_linear_1342_6911)","key":3}),React.createElement("path",{"id":"Vector_105","d":"M18.4491 13.5619L17.8323 14.1851C17.7674 14.2505 17.6622 14.3059 17.5883 14.3092L16.8828 14.3415C16.8104 14.3448 16.799 14.2954 16.8641 14.2307L17.4838 13.6148C17.5473 13.5518 17.6622 13.4973 17.7343 13.4933L18.4369 13.4539C18.5106 13.4497 18.5123 13.4983 18.4491 13.562V13.5619Z","fill":"url(#paint91_linear_1342_6911)","key":4}),React.createElement("path",{"id":"Vector_106","d":"M19.6512 13.496L19.0383 14.1281C19.0352 14.1313 19.0219 14.1351 19.0178 14.1382C18.9526 14.2005 18.836 14.2522 18.7634 14.2555L18.0361 14.2887C17.9614 14.2922 17.9748 14.2409 18.0395 14.1752L18.6557 13.5505C18.6614 13.5447 18.6567 13.5398 18.6637 13.534C18.7279 13.4776 18.8153 13.4324 18.8829 13.4286L19.6068 13.388C19.6827 13.3837 19.7139 13.4313 19.6511 13.4961L19.6512 13.496Z","fill":"url(#paint92_linear_1342_6911)","key":5})]),React.createElement("g",{"id":"Group_23","key":5},[React.createElement("path",{"id":"Vector_107","d":"M13.0547 14.766L12.405 15.3766C12.3367 15.4408 12.238 15.494 12.1721 15.4961L11.5433 15.5164C11.4787 15.5185 11.4734 15.4693 11.5418 15.4059L12.1927 14.8023C12.2594 14.7403 12.3736 14.6879 12.4381 14.685L13.0656 14.6576C13.1314 14.6547 13.1213 14.7032 13.0547 14.7659V14.766Z","fill":"url(#paint93_linear_1342_6911)","key":0}),React.createElement("path",{"id":"Vector_108","d":"M14.1265 14.7208L13.4787 15.3402C13.4107 15.4052 13.2861 15.4601 13.2183 15.4623L12.5709 15.4832C12.5044 15.4854 12.5212 15.4347 12.5895 15.3703L13.2389 14.7582C13.3055 14.6954 13.3973 14.6433 13.4636 14.6404L14.1095 14.6122C14.1772 14.6093 14.1929 14.6573 14.1265 14.7208Z","fill":"url(#paint94_linear_1342_6911)","key":1}),React.createElement("path",{"id":"Vector_109","d":"M15.1823 14.6765L14.5366 15.3045C14.4688 15.3705 14.3659 15.4254 14.2959 15.4276L13.629 15.4492C13.5605 15.4514 13.5532 15.4006 13.6211 15.3355L14.2686 14.715C14.335 14.6513 14.4507 14.5974 14.5189 14.5944L15.1839 14.5653C15.2536 14.5623 15.2483 14.6121 15.1821 14.6764L15.1823 14.6765Z","fill":"url(#paint95_linear_1342_6911)","key":2}),React.createElement("path",{"id":"Vector_110","d":"M16.3192 14.6288L15.6763 15.2661C15.6088 15.333 15.4784 15.3896 15.4064 15.3919L14.7192 15.4142C14.6486 15.4164 14.6646 15.3643 14.7324 15.2982L15.3776 14.6686C15.4438 14.6041 15.5357 14.5504 15.6061 14.5474L16.291 14.5175C16.3627 14.5143 16.3853 14.5637 16.3193 14.6289L16.3192 14.6288Z","fill":"url(#paint96_linear_1342_6911)","key":3}),React.createElement("path",{"id":"Vector_111","d":"M17.44 14.5815L16.8003 15.2278C16.733 15.2957 16.6256 15.3524 16.5512 15.3548L15.8427 15.3777C15.77 15.3801 15.7602 15.3279 15.8278 15.2609L16.4703 14.6223C16.536 14.5569 16.6531 14.5014 16.7257 14.4983L17.4316 14.4674C17.5057 14.4642 17.5058 14.5153 17.4402 14.5815H17.44Z","fill":"url(#paint97_linear_1342_6911)","key":4}),React.createElement("path",{"id":"Vector_112","d":"M18.648 14.5307L18.0118 15.1868C17.945 15.2558 17.8083 15.3142 17.7316 15.3166L17.0007 15.3403C16.9257 15.3428 16.9408 15.2888 17.008 15.2208L17.6473 14.5727C17.7128 14.5063 17.8045 14.4512 17.8792 14.4478L18.607 14.4162C18.6834 14.4129 18.7131 14.4633 18.648 14.5305V14.5307Z","fill":"url(#paint98_linear_1342_6911)","key":5})])]),React.createElement("path",{"id":"Vector_113","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M17.4928 10.7476L17.9908 10.2781C18.0265 10.3984 18.0129 10.566 17.9115 10.7981L17.4914 10.8364C17.426 10.8423 17.435 10.8018 17.4926 10.7475L17.4928 10.7476Z","fill":"url(#paint99_linear_1342_6911)","key":3}),React.createElement("path",{"id":"Vector_114","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M17.8516 10.9238C17.7617 11.0963 17.6276 11.3003 17.4386 11.5412C17.3794 11.5979 17.2774 11.6481 17.2104 11.6535L16.5718 11.7051C16.5061 11.7103 16.5166 11.668 16.5761 11.6119L17.1436 11.0769C17.2018 11.022 17.2864 10.9744 17.3518 10.9685L17.8516 10.9238Z","fill":"url(#paint100_linear_1342_6911)","key":4}),React.createElement("path",{"id":"Vector_115","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M16.6506 12.4317L17.1703 11.9338C17.0624 12.162 17.0192 12.3485 17.0449 12.5028L16.6692 12.5291C16.6014 12.5338 16.5893 12.4906 16.6506 12.4319V12.4317Z","fill":"url(#paint101_linear_1342_6911)","key":5}),React.createElement("path",{"id":"Vector_116","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M17.251 12.8391C17.3898 12.9708 17.5624 13.0727 17.799 13.1609L17.7141 13.2452C17.6513 13.3074 17.5253 13.3622 17.4539 13.3663L16.7724 13.4059C16.7024 13.4099 16.715 13.3623 16.7781 13.3008L17.251 12.8391Z","fill":"url(#paint102_linear_1342_6911)","key":6}),React.createElement("path",{"id":"Vector_117","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M17.864 13.2364L17.8909 13.2097C17.9938 13.2482 18.0941 13.2855 18.1909 13.3237L17.8863 13.3414C17.8141 13.3455 17.8012 13.2988 17.8642 13.2364H17.864Z","fill":"url(#paint103_linear_1342_6911)","key":7}),React.createElement("path",{"id":"Vector_118","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M18.039 14.1751L18.6552 13.5504C18.6609 13.5446 18.6562 13.5397 18.6632 13.5339C18.9097 13.6779 19.0633 13.8595 19.0125 14.1384C18.9472 14.2007 18.8355 14.2521 18.7629 14.2554L18.0356 14.2886C17.9609 14.2921 17.9743 14.2408 18.039 14.1751Z","fill":"url(#paint104_linear_1342_6911)","key":8}),React.createElement("path",{"id":"Vector_119","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M18.6475 14.5307L18.0114 15.1868C17.9445 15.2558 17.8078 15.3142 17.7311 15.3166L17.0002 15.3403C16.9252 15.3428 16.9403 15.2888 17.0075 15.2208L17.6468 14.5727C17.7123 14.5063 17.804 14.4512 17.8787 14.4478L18.6065 14.4162C18.6829 14.4129 18.7126 14.4635 18.6475 14.5307Z","fill":"url(#paint105_linear_1342_6911)","key":9})])])]),React.createElement("defs",{"key":1},[React.createElement("linearGradient",{"id":"paint0_linear_1342_6911","x1":"12.4067","y1":"9.65176","x2":"1.1045","y2":"35.066","gradientUnits":"userSpaceOnUse","key":0},[React.createElement("stop",{"stopColor":"#006736","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint1_linear_1342_6911","x1":"6.81364","y1":"14.9153","x2":"2.94824","y2":"-8.15439","gradientUnits":"userSpaceOnUse","key":1},[React.createElement("stop",{"stopColor":"#93C13E","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#93C13E","key":1})]),React.createElement("linearGradient",{"id":"paint2_linear_1342_6911","x1":"-4.64139","y1":"22.355","x2":"12.3802","y2":"24.0558","gradientUnits":"userSpaceOnUse","key":2},[React.createElement("stop",{"stopColor":"#93C13E","key":0}),React.createElement("stop",{"offset":"1","stopColor":"white","key":1})]),React.createElement("linearGradient",{"id":"paint3_linear_1342_6911","x1":"-1.58975","y1":"20.6134","x2":"34.3717","y2":"18.4091","gradientUnits":"userSpaceOnUse","key":3},[React.createElement("stop",{"stopColor":"#C7DF9A","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#7BBE00","key":1})]),React.createElement("linearGradient",{"id":"paint4_linear_1342_6911","x1":"27.2626","y1":"8.93311","x2":"6.18018","y2":"18.2015","gradientUnits":"userSpaceOnUse","key":4},[React.createElement("stop",{"stopColor":"#05683C","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint5_linear_1342_6911","x1":"15.8763","y1":"15.1257","x2":"0.109045","y2":"20.6754","gradientUnits":"userSpaceOnUse","key":5},[React.createElement("stop",{"stopColor":"#05683C","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#F5F9F5","key":1})]),React.createElement("linearGradient",{"id":"paint6_linear_1342_6911","x1":"27.2351","y1":"17.4824","x2":"27.2351","y2":"31.6775","gradientUnits":"userSpaceOnUse","key":6},[React.createElement("stop",{"stopColor":"#93C13E","stopOpacity":"0.1","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint7_linear_1342_6911","x1":"21.8309","y1":"17.482","x2":"21.8309","y2":"31.6771","gradientUnits":"userSpaceOnUse","key":7},[React.createElement("stop",{"stopColor":"#93C13E","stopOpacity":"0.1","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint8_linear_1342_6911","x1":"24.5808","y1":"17.4824","x2":"24.5808","y2":"31.6775","gradientUnits":"userSpaceOnUse","key":8},[React.createElement("stop",{"stopColor":"#93C13E","stopOpacity":"0.1","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint9_linear_1342_6911","x1":"23.7418","y1":"10.0259","x2":"23.4113","y2":"10.225","gradientUnits":"userSpaceOnUse","key":9},[React.createElement("stop",{"stopColor":"#EBEFF2","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint10_linear_1342_6911","x1":"21.4132","y1":"12.3526","x2":"21.0827","y2":"12.5517","gradientUnits":"userSpaceOnUse","key":10},[React.createElement("stop",{"stopColor":"#EBEFF2","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint11_linear_1342_6911","x1":"15.5137","y1":"16.2131","x2":"15.2373","y2":"16.3797","gradientUnits":"userSpaceOnUse","key":11},[React.createElement("stop",{"stopColor":"#EBEFF2","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint12_linear_1342_6911","x1":"11.6799","y1":"17.2437","x2":"11.3494","y2":"17.4429","gradientUnits":"userSpaceOnUse","key":12},[React.createElement("stop",{"stopColor":"#EBEFF2","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint13_linear_1342_6911","x1":"18.8516","y1":"14.9644","x2":"18.5212","y2":"15.1635","gradientUnits":"userSpaceOnUse","key":13},[React.createElement("stop",{"stopColor":"#EBEFF2","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint14_linear_1342_6911","x1":"12.0987","y1":"15.3919","x2":"11.7682","y2":"15.591","gradientUnits":"userSpaceOnUse","key":14},[React.createElement("stop",{"stopColor":"#EBEFF2","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint15_linear_1342_6911","x1":"-1.88642","y1":"17.3947","x2":"13.5014","y2":"17.3947","gradientUnits":"userSpaceOnUse","key":15},[React.createElement("stop",{"stopColor":"#EBEFF2","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint16_linear_1342_6911","x1":"15.0192","y1":"13.465","x2":"4.56973","y2":"19.7617","gradientUnits":"userSpaceOnUse","key":16},[React.createElement("stop",{"stopColor":"#EBEFF2","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint17_linear_1342_6911","x1":"9.3687","y1":"15.5953","x2":"9.46093","y2":"18.6769","gradientUnits":"userSpaceOnUse","key":17},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint18_linear_1342_6911","x1":"10.3971","y1":"15.5738","x2":"10.4905","y2":"18.6958","gradientUnits":"userSpaceOnUse","key":18},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint19_linear_1342_6911","x1":"11.4395","y1":"15.5522","x2":"11.534","y2":"18.7156","gradientUnits":"userSpaceOnUse","key":19},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint20_linear_1342_6911","x1":"12.5262","y1":"15.5298","x2":"12.6221","y2":"18.7355","gradientUnits":"userSpaceOnUse","key":20},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint21_linear_1342_6911","x1":"13.6288","y1":"15.507","x2":"13.726","y2":"18.7564","gradientUnits":"userSpaceOnUse","key":21},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint22_linear_1342_6911","x1":"14.7793","y1":"15.4834","x2":"14.8779","y2":"18.7776","gradientUnits":"userSpaceOnUse","key":22},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint23_linear_1342_6911","x1":"7.90447","y1":"15.6331","x2":"7.99514","y2":"18.667","gradientUnits":"userSpaceOnUse","key":23},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint24_linear_1342_6911","x1":"8.89375","y1":"15.6282","x2":"8.98457","y2":"18.6666","gradientUnits":"userSpaceOnUse","key":24},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint25_linear_1342_6911","x1":"9.89573","y1":"15.6083","x2":"9.98767","y2":"18.6858","gradientUnits":"userSpaceOnUse","key":25},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint26_linear_1342_6911","x1":"10.94","y1":"15.5873","x2":"11.0331","y2":"18.705","gradientUnits":"userSpaceOnUse","key":26},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint27_linear_1342_6911","x1":"11.9992","y1":"15.5665","x2":"12.0936","y2":"18.7254","gradientUnits":"userSpaceOnUse","key":27},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint28_linear_1342_6911","x1":"13.1034","y1":"15.5444","x2":"13.199","y2":"18.7457","gradientUnits":"userSpaceOnUse","key":28},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint29_linear_1342_6911","x1":"6.49414","y1":"15.7039","x2":"6.58157","y2":"18.6266","gradientUnits":"userSpaceOnUse","key":29},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint30_linear_1342_6911","x1":"7.44602","y1":"15.6856","x2":"7.53443","y2":"18.6445","gradientUnits":"userSpaceOnUse","key":30},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint31_linear_1342_6911","x1":"8.41028","y1":"15.6675","x2":"8.49997","y2":"18.6636","gradientUnits":"userSpaceOnUse","key":31},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint32_linear_1342_6911","x1":"9.41438","y1":"15.6484","x2":"9.5052","y2":"18.6824","gradientUnits":"userSpaceOnUse","key":32},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint33_linear_1342_6911","x1":"10.4318","y1":"15.6294","x2":"10.5236","y2":"18.7024","gradientUnits":"userSpaceOnUse","key":33},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint34_linear_1342_6911","x1":"11.493","y1":"15.6093","x2":"11.586","y2":"18.7223","gradientUnits":"userSpaceOnUse","key":34},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint35_linear_1342_6911","x1":"5.13404","y1":"15.7636","x2":"5.21921","y2":"18.6126","gradientUnits":"userSpaceOnUse","key":35},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint36_linear_1342_6911","x1":"6.05086","y1":"15.7468","x2":"6.13702","y2":"18.6303","gradientUnits":"userSpaceOnUse","key":36},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint37_linear_1342_6911","x1":"6.97917","y1":"15.7306","x2":"7.06631","y2":"18.6492","gradientUnits":"userSpaceOnUse","key":37},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint38_linear_1342_6911","x1":"7.9451","y1":"15.7134","x2":"8.03337","y2":"18.668","gradientUnits":"userSpaceOnUse","key":38},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint39_linear_1342_6911","x1":"8.92384","y1":"15.6958","x2":"9.01324","y2":"18.6874","gradientUnits":"userSpaceOnUse","key":39},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint40_linear_1342_6911","x1":"9.94395","y1":"15.6778","x2":"10.0345","y2":"18.7071","gradientUnits":"userSpaceOnUse","key":40},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint41_linear_1342_6911","x1":"3.82199","y1":"15.8253","x2":"3.90505","y2":"18.6041","gradientUnits":"userSpaceOnUse","key":41},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint42_linear_1342_6911","x1":"4.70588","y1":"15.8101","x2":"4.78992","y2":"18.6215","gradientUnits":"userSpaceOnUse","key":42},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint43_linear_1342_6911","x1":"5.59984","y1":"15.7958","x2":"5.68487","y2":"18.6407","gradientUnits":"userSpaceOnUse","key":43},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint44_linear_1342_6911","x1":"6.53008","y1":"15.7799","x2":"6.61609","y2":"18.659","gradientUnits":"userSpaceOnUse","key":44},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint45_linear_1342_6911","x1":"7.47214","y1":"15.7647","x2":"7.55929","y2":"18.6788","gradientUnits":"userSpaceOnUse","key":45},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint46_linear_1342_6911","x1":"8.45296","y1":"15.7485","x2":"8.5411","y2":"18.6986","gradientUnits":"userSpaceOnUse","key":46},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint47_linear_1342_6911","x1":"2.55511","y1":"15.8895","x2":"2.6362","y2":"18.6013","gradientUnits":"userSpaceOnUse","key":47},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint48_linear_1342_6911","x1":"3.40739","y1":"15.8762","x2":"3.48932","y2":"18.6191","gradientUnits":"userSpaceOnUse","key":48},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint49_linear_1342_6911","x1":"4.26957","y1":"15.863","x2":"4.35249","y2":"18.6376","gradientUnits":"userSpaceOnUse","key":49},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint50_linear_1342_6911","x1":"5.16603","y1":"15.8494","x2":"5.24994","y2":"18.6566","gradientUnits":"userSpaceOnUse","key":50},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint51_linear_1342_6911","x1":"6.07316","y1":"15.8359","x2":"6.15805","y2":"18.6763","gradientUnits":"userSpaceOnUse","key":51},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint52_linear_1342_6911","x1":"7.01725","y1":"15.8215","x2":"7.10327","y2":"18.6961","gradientUnits":"userSpaceOnUse","key":52},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint53_linear_1342_6911","x1":"9.41995","y1":"16.3652","x2":"10.3585","y2":"16.3652","gradientUnits":"userSpaceOnUse","key":53},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint54_linear_1342_6911","x1":"7.96459","y1":"16.7447","x2":"9.71303","y2":"16.7447","gradientUnits":"userSpaceOnUse","key":54},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint55_linear_1342_6911","x1":"7.5029","y1":"17.1976","x2":"8.36701","y2":"17.1976","gradientUnits":"userSpaceOnUse","key":55},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint56_linear_1342_6911","x1":"6.11627","y1":"17.5573","x2":"7.82728","y2":"17.5573","gradientUnits":"userSpaceOnUse","key":56},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint57_linear_1342_6911","x1":"3.48873","y1":"18.304","x2":"5.19065","y2":"18.304","gradientUnits":"userSpaceOnUse","key":57},[React.createElement("stop",{"stopColor":"#AA80F9","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#6165D7","key":1})]),React.createElement("linearGradient",{"id":"paint58_linear_1342_6911","x1":"7.05895","y1":"17.622","x2":"8.09261","y2":"17.622","gradientUnits":"userSpaceOnUse","key":58},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint59_linear_1342_6911","x1":"8.0136","y1":"17.7256","x2":"8.31254","y2":"17.7256","gradientUnits":"userSpaceOnUse","key":59},[React.createElement("stop",{"stopColor":"#AA80F9","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#6165D7","key":1})]),React.createElement("linearGradient",{"id":"paint60_linear_1342_6911","x1":"7.56348","y1":"18.0207","x2":"8.63742","y2":"18.0207","gradientUnits":"userSpaceOnUse","key":60},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint61_linear_1342_6911","x1":"8.56118","y1":"12.561","x2":"21.4146","y2":"12.561","gradientUnits":"userSpaceOnUse","key":61},[React.createElement("stop",{"stopColor":"#EBEFF2","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint62_linear_1342_6911","x1":"23.5219","y1":"9.03832","x2":"13.1557","y2":"15.2848","gradientUnits":"userSpaceOnUse","key":62},[React.createElement("stop",{"stopColor":"white","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint63_linear_1342_6911","x1":"17.1198","y1":"8.97441","x2":"17.3174","y2":"15.5859","gradientUnits":"userSpaceOnUse","key":63},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint64_linear_1342_6911","x1":"18.149","y1":"8.83187","x2":"18.3493","y2":"15.5289","gradientUnits":"userSpaceOnUse","key":64},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint65_linear_1342_6911","x1":"19.1803","y1":"8.6857","x2":"19.3831","y2":"15.4706","gradientUnits":"userSpaceOnUse","key":65},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint66_linear_1342_6911","x1":"20.2678","y1":"8.53508","x2":"20.4732","y2":"15.4103","gradientUnits":"userSpaceOnUse","key":66},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint67_linear_1342_6911","x1":"21.3569","y1":"8.38083","x2":"21.5652","y2":"15.3488","gradientUnits":"userSpaceOnUse","key":67},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint68_linear_1342_6911","x1":"22.5069","y1":"8.22191","x2":"22.718","y2":"15.2851","gradientUnits":"userSpaceOnUse","key":68},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint69_linear_1342_6911","x1":"16.1842","y1":"8.93162","x2":"16.3861","y2":"15.6884","gradientUnits":"userSpaceOnUse","key":69},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint70_linear_1342_6911","x1":"17.2172","y1":"8.78624","x2":"17.4218","y2":"15.6325","gradientUnits":"userSpaceOnUse","key":70},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint71_linear_1342_6911","x1":"18.2532","y1":"8.63746","x2":"18.4607","y2":"15.5756","gradientUnits":"userSpaceOnUse","key":71},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0.5","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint72_linear_1342_6911","x1":"19.345","y1":"8.48316","x2":"19.5553","y2":"15.5159","gradientUnits":"userSpaceOnUse","key":72},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0.5","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint73_linear_1342_6911","x1":"20.44","y1":"8.32645","x2":"20.6532","y2":"15.4561","gradientUnits":"userSpaceOnUse","key":73},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"0.263695","stopColor":"#05683C","stopOpacity":"0.263695","key":1}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":2})]),React.createElement("linearGradient",{"id":"paint74_linear_1342_6911","x1":"21.5962","y1":"8.16355","x2":"21.8123","y2":"15.3929","gradientUnits":"userSpaceOnUse","key":74},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint75_linear_1342_6911","x1":"15.2179","y1":"8.87716","x2":"15.4243","y2":"15.7857","gradientUnits":"userSpaceOnUse","key":75},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint76_linear_1342_6911","x1":"16.2537","y1":"8.72813","x2":"16.4631","y2":"15.7303","gradientUnits":"userSpaceOnUse","key":76},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint77_linear_1342_6911","x1":"17.2947","y1":"8.57596","x2":"17.5069","y2":"15.6742","gradientUnits":"userSpaceOnUse","key":77},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint78_linear_1342_6911","x1":"18.3912","y1":"8.4185","x2":"18.6063","y2":"15.6157","gradientUnits":"userSpaceOnUse","key":78},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint79_linear_1342_6911","x1":"19.4914","y1":"8.25756","x2":"19.7097","y2":"15.5565","gradientUnits":"userSpaceOnUse","key":79},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint80_linear_1342_6911","x1":"20.6538","y1":"8.09087","x2":"20.8752","y2":"15.4942","gradientUnits":"userSpaceOnUse","key":80},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint81_linear_1342_6911","x1":"14.2185","y1":"8.80879","x2":"14.4297","y2":"15.8759","gradientUnits":"userSpaceOnUse","key":81},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint82_linear_1342_6911","x1":"15.2575","y1":"8.65622","x2":"15.4716","y2":"15.8214","gradientUnits":"userSpaceOnUse","key":82},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint83_linear_1342_6911","x1":"16.3018","y1":"8.49983","x2":"16.5191","y2":"15.7657","gradientUnits":"userSpaceOnUse","key":83},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint84_linear_1342_6911","x1":"17.4025","y1":"8.33854","x2":"17.6228","y2":"15.7081","gradientUnits":"userSpaceOnUse","key":84},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint85_linear_1342_6911","x1":"18.5086","y1":"8.17337","x2":"18.7321","y2":"15.6495","gradientUnits":"userSpaceOnUse","key":85},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint86_linear_1342_6911","x1":"19.6767","y1":"8.00225","x2":"19.9035","y2":"15.5881","gradientUnits":"userSpaceOnUse","key":86},[React.createElement("stop",{"stopColor":"#006736","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint87_linear_1342_6911","x1":"13.1854","y1":"8.72553","x2":"13.4016","y2":"15.9586","gradientUnits":"userSpaceOnUse","key":87},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint88_linear_1342_6911","x1":"14.2268","y1":"8.56924","x2":"14.4461","y2":"15.905","gradientUnits":"userSpaceOnUse","key":88},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint89_linear_1342_6911","x1":"15.2751","y1":"8.4083","x2":"15.4976","y2":"15.8498","gradientUnits":"userSpaceOnUse","key":89},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint90_linear_1342_6911","x1":"16.3798","y1":"8.24189","x2":"16.6056","y2":"15.7921","gradientUnits":"userSpaceOnUse","key":90},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint91_linear_1342_6911","x1":"17.4905","y1":"8.07193","x2":"17.7195","y2":"15.734","gradientUnits":"userSpaceOnUse","key":91},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0.5","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint92_linear_1342_6911","x1":"18.664","y1":"7.89567","x2":"18.8965","y2":"15.6731","gradientUnits":"userSpaceOnUse","key":92},[React.createElement("stop",{"stopColor":"#006736","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint93_linear_1342_6911","x1":"12.1157","y1":"8.62593","x2":"12.3371","y2":"16.0327","gradientUnits":"userSpaceOnUse","key":93},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint94_linear_1342_6911","x1":"13.1594","y1":"8.46407","x2":"13.384","y2":"15.9786","gradientUnits":"userSpaceOnUse","key":94},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint95_linear_1342_6911","x1":"14.2111","y1":"8.29854","x2":"14.439","y2":"15.9239","gradientUnits":"userSpaceOnUse","key":95},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint96_linear_1342_6911","x1":"15.3191","y1":"8.12719","x2":"15.5503","y2":"15.8669","gradientUnits":"userSpaceOnUse","key":96},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"0.728491","stopColor":"#006736","stopOpacity":"0.728491","key":1}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":2})]),React.createElement("linearGradient",{"id":"paint97_linear_1342_6911","x1":"16.4347","y1":"7.95129","x2":"16.6697","y2":"15.8087","gradientUnits":"userSpaceOnUse","key":97},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint98_linear_1342_6911","x1":"17.6127","y1":"7.76921","x2":"17.8511","y2":"15.7479","gradientUnits":"userSpaceOnUse","key":98},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint99_linear_1342_6911","x1":"17.446","y1":"10.5576","x2":"18.0087","y2":"10.5576","gradientUnits":"userSpaceOnUse","key":99},[React.createElement("stop",{"stopColor":"#006736","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint100_linear_1342_6911","x1":"16.5269","y1":"11.3148","x2":"17.8516","y2":"11.3148","gradientUnits":"userSpaceOnUse","key":100},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint101_linear_1342_6911","x1":"16.6109","y1":"12.2315","x2":"17.1703","y2":"12.2315","gradientUnits":"userSpaceOnUse","key":101},[React.createElement("stop",{"stopColor":"#006736","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint102_linear_1342_6911","x1":"16.7249","y1":"13.1226","x2":"17.799","y2":"13.1226","gradientUnits":"userSpaceOnUse","key":102},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0.5","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint103_linear_1342_6911","x1":"17.8238","y1":"13.2758","x2":"18.1909","y2":"13.2758","gradientUnits":"userSpaceOnUse","key":103},[React.createElement("stop",{"stopColor":"#AA80F9","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#6165D7","key":1})]),React.createElement("linearGradient",{"id":"paint104_linear_1342_6911","x1":"17.9848","y1":"13.9114","x2":"19.0221","y2":"13.9114","gradientUnits":"userSpaceOnUse","key":104},[React.createElement("stop",{"stopColor":"#AA80F9","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#6165D7","key":1})]),React.createElement("linearGradient",{"id":"paint105_linear_1342_6911","x1":"16.9503","y1":"14.8782","x2":"18.6833","y2":"14.8782","gradientUnits":"userSpaceOnUse","key":105},[React.createElement("stop",{"stopColor":"#AA80F9","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#AA80F9","key":1})])])]);
}

IcHouseComponent.defaultProps = {"width":"34","height":"32","viewBox":"0 0 34 32","fill":"none"};

module.exports = IcHouseComponent;

IcHouseComponent.default = IcHouseComponent;


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcInfo2Component (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.5918 9.74167V6.59167H7.40846V9.74167H6.5918ZM7.29201 4.95856C7.21464 5.03592 7.12134 5.07501 7.00013 5.07501C6.87892 5.07501 6.78562 5.03592 6.70825 4.95856C6.63088 4.88119 6.5918 4.78788 6.5918 4.66667C6.5918 4.54547 6.63088 4.45216 6.70825 4.37479C6.78562 4.29743 6.87892 4.25834 7.00013 4.25834C7.12134 4.25834 7.21464 4.29743 7.29201 4.37479C7.36938 4.45216 7.40846 4.54547 7.40846 4.66667C7.40846 4.78788 7.36938 4.88119 7.29201 4.95856ZM7.00013 12.6583C6.21596 12.6583 5.48133 12.5097 4.79446 12.2133C4.1042 11.9154 3.50551 11.5121 2.99679 11.0033C2.48807 10.4946 2.0847 9.89594 1.78685 9.20567C1.49046 8.51881 1.3418 7.78418 1.3418 7.00001C1.3418 6.21584 1.49046 5.48121 1.78685 4.79434C2.0847 4.10408 2.48807 3.50539 2.99679 2.99667C3.50551 2.48795 4.1042 2.08458 4.79446 1.78673C5.48133 1.49034 6.21596 1.34167 7.00013 1.34167C7.7843 1.34167 8.51893 1.49034 9.2058 1.78673C9.89606 2.08458 10.4948 2.48795 11.0035 2.99667C11.5122 3.50539 11.9156 4.10408 12.2134 4.79434C12.5098 5.48121 12.6585 6.21584 12.6585 7.00001C12.6585 7.78418 12.5098 8.51881 12.2134 9.20567C11.9156 9.89594 11.5122 10.4946 11.0035 11.0033C10.4948 11.5121 9.89606 11.9154 9.2058 12.2133C8.51893 12.5097 7.7843 12.6583 7.00013 12.6583ZM7.00013 11.8417C8.34834 11.8417 9.49662 11.3718 10.4343 10.4342C11.372 9.4965 11.8418 8.34822 11.8418 7.00001C11.8418 5.6518 11.372 4.50352 10.4343 3.56585C9.49662 2.62817 8.34834 2.15834 7.00013 2.15834C5.65192 2.15834 4.50364 2.62817 3.56597 3.56585C2.6283 4.50352 2.15846 5.6518 2.15846 7.00001C2.15846 8.34822 2.6283 9.4965 3.56597 10.4342C4.50364 11.3718 5.65192 11.8417 7.00013 11.8417Z","fill":"#3E3E3E"}));
}

IcInfo2Component.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = IcInfo2Component;

IcInfo2Component.default = IcInfo2Component;


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcWinnerComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-winner"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M17.048 7.6772L15.6909 6.34387L15.6909 6.34389L17.048 7.6772ZM7.25279 14.1398L4.20996 9.20108L8.42977 2.35815H16.9044L21.1242 9.20108L18.0814 14.1398V21.6419L12.6671 19.8372L7.25279 21.6419V14.1398ZM8.55755 16.0439V19.8307L12.6671 18.4694L16.7766 19.8307V16.0439H8.55755ZM16.1676 3.66292H9.1665L5.74295 9.20101L9.1665 14.7391H16.1676L19.5912 9.20101L16.1676 3.66292ZM11.6677 10.8164L9.64326 8.79194L8.71113 9.72407L11.6659 12.658L16.6224 7.67956L15.6934 6.76688L11.6677 10.8164Z","fill":"#006736"})));
}

IcWinnerComponent.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = IcWinnerComponent;

IcWinnerComponent.default = IcWinnerComponent;


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function LessComponent (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icons/ic-less"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Simulador-Simples---Desktop","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"simul_simples_etapa1-alt2_desktop","transform":"translate(-500.000000, -807.000000)","fill":"#93C13E"},React.createElement("g",{"id":"perguntas","transform":"translate(0.000000, 96.000000)"},React.createElement("g",{"id":"agregado","transform":"translate(0.000000, 388.000000)"},React.createElement("g",{"id":"content","transform":"translate(479.000000, 80.000000)"},React.createElement("g",{"id":"boxes","transform":"translate(0.000000, 100.000000)"},React.createElement("g",{"id":"option"},React.createElement("g",{"id":"btn","transform":"translate(0.000000, 128.000000)"},React.createElement("rect",{"id":"icons/ic-less","x":"21","y":"15","width":"14","height":"2"})))))))))]);
}

LessComponent.defaultProps = {"width":"14px","height":"2px","viewBox":"0 0 14 2","version":"1.1"};

module.exports = LessComponent;

LessComponent.default = LessComponent;


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function MoreComponent (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"faq/question/mobile","transform":"translate(-268.000000, -17.000000)","fill":"#D8D8D8"},React.createElement("g",{"id":"faq/question"},React.createElement("g",{"id":"content","transform":"translate(8.000000, 14.000000)"},React.createElement("path",{"d":"M268,9 L268,3 L266,3 L266,9 L260,9 L260,11 L266,11 L266,17 L268,17 L268,11 L274,11 L274,9 L268,9 Z","id":"icons/ic-more"})))))]);
}

MoreComponent.defaultProps = {"width":"14px","height":"14px","viewBox":"0 0 14 14","version":"1.1"};

module.exports = MoreComponent;

MoreComponent.default = MoreComponent;


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcCheckComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-check"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M7.16477 11.9785L14.0475 5.09874L14.7979 5.84945L7.16445 13.4796L3.20851 9.52193L3.95922 8.77154L7.16477 11.9785Z","fill":"#006736"})));
}

IcCheckComponent.defaultProps = {"width":"18","height":"19","viewBox":"0 0 18 19","fill":"none"};

module.exports = IcCheckComponent;

IcCheckComponent.default = IcCheckComponent;


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcDayComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-day"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M30.6721 7.92839L28.5601 5.81789L30.6718 7.92864L30.6721 7.92839ZM25.8601 28.4904L27.9602 26.3905L27.9601 26.3904L25.8601 28.4904ZM5.96147 7.94039L7.44096 6.4609L9.50166 8.51015L8.0112 9.99012L5.96147 7.94039ZM1.95007 17.4504H5.55007V19.5504H1.95007V17.4504ZM16.9501 2.52539H19.0501V6.05039H16.9501V2.52539ZM28.5602 6.45417L30.0356 7.9285L27.9872 9.97688L26.5129 8.5015L28.5602 6.45417ZM30.0228 29.0763L28.546 30.5531L26.4956 28.4913L27.961 27.0259L30.0228 29.0763ZM30.4501 17.4504H34.0501V19.5504H30.4501V17.4504ZM9.45007 18.5004C9.45007 13.7839 13.2836 9.95039 18.0001 9.95039C22.7165 9.95039 26.5501 13.7839 26.5501 18.5004C26.5501 23.2169 22.7165 27.0504 18.0001 27.0504C13.2836 27.0504 9.45007 23.2169 9.45007 18.5004ZM11.5501 18.5004C11.5501 22.0639 14.4365 24.9504 18.0001 24.9504C21.5636 24.9504 24.4501 22.0639 24.4501 18.5004C24.4501 14.9369 21.5636 12.0504 18.0001 12.0504C14.4365 12.0504 11.5501 14.9369 11.5501 18.5004ZM19.0501 34.4754V30.9504H16.9501V34.4754H19.0501ZM9.48956 28.4763L7.43919 30.5381L5.96058 29.0595L8.01096 26.9977L9.48956 28.4763Z","fill":"#3E3E3E"})));
}

IcDayComponent.defaultProps = {"width":"36","height":"37","viewBox":"0 0 36 37","fill":"none"};

module.exports = IcDayComponent;

IcDayComponent.default = IcDayComponent;


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcDependencyComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-dependency arrow"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M16.4525 11.0303C16.4513 11.0365 16.4499 11.0428 16.4486 11.0491L16.4525 11.0303ZM14.9528 5.48419V2.36133H15.9703V7.72273H10.6089V6.70522H14.4958L13.7391 5.76589C13.1665 5.0551 12.4785 4.48082 11.6782 4.04612C10.8536 3.59815 9.93853 3.37883 8.94569 3.37883C7.50947 3.37883 6.22974 3.83663 5.12979 4.74659C4.15886 5.54982 3.50226 6.5459 3.17048 7.72273H2.14191C2.46505 6.28587 3.18832 5.07562 4.31891 4.07633C5.61219 2.93323 7.14452 2.36133 8.94569 2.36133C9.93807 2.36133 10.859 2.55009 11.7146 2.92391C12.5806 3.30227 13.3281 3.81674 13.9621 4.46747L14.9528 5.48419ZM12.8702 14.0253C13.8411 13.222 14.4977 12.2259 14.8295 11.0491H15.8581C15.5349 12.486 14.8117 13.6962 13.6811 14.6955C12.3878 15.8386 10.8555 16.4105 9.05431 16.4105C8.06193 16.4105 7.14103 16.2218 6.2854 15.8479C5.41939 15.4696 4.67191 14.9551 4.03787 14.3044L3.04722 13.2877L3.04722 16.4105H2.02972V11.0491L7.39112 11.0491V12.0666H3.50422L4.2609 13.006C4.83348 13.7167 5.52152 14.291 6.32177 14.7257C7.14644 15.1737 8.06147 15.393 9.05431 15.393C10.4905 15.393 11.7703 14.9352 12.8702 14.0253Z","fill":"#BABABA"})));
}

IcDependencyComponent.defaultProps = {"width":"18","height":"19","viewBox":"0 0 18 19","fill":"none"};

module.exports = IcDependencyComponent;

IcDependencyComponent.default = IcDependencyComponent;


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcEletricityComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-eletricity"},React.createElement("path",{"id":"icons/ic-eletricidade","fillRule":"evenodd","clipRule":"evenodd","d":"M4.37866 9.64054C4.37866 9.57976 4.39178 9.51874 4.41835 9.46167L7.93668 1.8989C8.008 1.74595 8.16425 1.64746 8.33594 1.64746H13.1947C13.359 1.64746 13.509 1.73693 13.5848 1.87978C13.6177 1.9422 13.634 2.0102 13.634 2.07797C13.634 2.1653 13.6069 2.25225 13.5535 2.32639L10.0208 7.23693H12.5245C12.6954 7.23693 12.8509 7.33433 12.923 7.48693C12.9947 7.6388 12.9701 7.8181 12.8598 7.9458L5.48782 16.4949C5.40216 16.5948 5.27789 16.6475 5.15253 16.6475C5.07827 16.6475 5.0029 16.6294 4.93488 16.5905C4.7507 16.4873 4.66834 16.2705 4.7382 16.0746L6.87971 10.071H4.81761C4.66834 10.071 4.52938 9.99667 4.44849 9.87329C4.40219 9.80287 4.37866 9.72192 4.37866 9.64054ZM8.6183 2.50857L5.50069 9.21023H7.49809C7.64074 9.21023 7.77419 9.27733 7.85617 9.39133C7.93853 9.50533 7.95985 9.65143 7.91279 9.78274L6.35142 14.1597L11.5782 8.0984H9.1738C9.00983 8.0984 8.85947 8.00893 8.7841 7.86608C8.70837 7.72322 8.72087 7.55078 8.81498 7.41911L12.3477 2.50857H8.6183Z","fill":"#FF8E2A"})));
}

IcEletricityComponent.defaultProps = {"width":"18","height":"19","viewBox":"0 0 18 19","fill":"none"};

module.exports = IcEletricityComponent;

IcEletricityComponent.default = IcEletricityComponent;


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcGasComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-gas"},React.createElement("path",{"id":"icons/ic-gas","fillRule":"evenodd","clipRule":"evenodd","d":"M7.72475 2.0518C7.74156 1.82926 7.8249 1.64824 7.97931 1.5H8.46602C9.46639 2.21608 10.4983 2.95762 11.4181 3.81601C12.5004 4.82578 13.8544 6.21608 14.7242 8.01692C15.2491 9.10481 15.5033 10.0588 15.5089 10.9817V11.0469C15.5082 11.1707 15.5029 11.2942 15.4931 11.417C15.3054 13.8007 14.2928 15.4344 12.3982 16.4104C12.283 16.47 12.1723 16.5 12.0694 16.5C11.937 16.5 11.826 16.4501 11.7392 16.3514C11.6278 16.2258 11.5841 16.087 11.6128 15.9503C11.6461 15.7902 11.7739 15.651 11.9727 15.5576C12.5263 15.2991 12.998 14.9234 13.374 14.4421C14.5918 12.883 14.8629 11.1209 14.1797 9.20352C13.7778 8.07621 13.1072 7.00471 12.0694 5.83101C11.2374 4.88961 10.2567 4.0082 8.98283 3.05738L8.95237 3.03436L8.95058 3.03298C8.8894 2.98588 8.82053 2.93286 8.72968 2.93286C8.60818 2.93286 8.52099 3.01971 8.47162 3.19201C8.07875 4.56243 7.22124 5.69358 6.35288 6.71277C6.23914 6.84608 6.12408 6.97906 6.0093 7.11171L5.99958 7.12295C5.43059 7.77904 4.84234 8.45745 4.40081 9.23736C3.55135 10.7382 3.45401 12.1006 4.10248 13.4027C4.7471 14.695 5.83536 15.4236 7.33644 15.5687C7.64107 15.5977 7.8375 15.7944 7.82595 16.057C7.81474 16.3137 7.61971 16.486 7.34134 16.4864C5.88368 16.4574 4.68863 15.8237 3.6732 14.5488C3.04504 13.7602 2.73201 12.7815 2.74321 11.6392C2.75442 10.4271 3.14868 9.28514 3.94877 8.14737C4.34829 7.57883 4.80943 7.04029 5.25517 6.52023C5.61757 6.09714 5.99188 5.6601 6.33432 5.20631C7.07173 4.22829 7.49541 3.35316 7.66663 2.45187C7.69044 2.3249 7.7146 2.18957 7.72475 2.0518ZM8.86694 6.4285C8.82703 6.18434 8.97619 6.04412 9.10855 5.96913C9.19223 5.92204 9.27416 5.89798 9.35295 5.89798C9.44889 5.89798 9.54098 5.9339 9.62711 6.00436C10.6888 6.8774 11.3901 7.72148 11.8351 8.66114C12.6611 10.4058 12.5179 12.0637 11.3978 13.7288L11.3754 13.7623C11.3727 13.7664 11.3699 13.7705 11.3672 13.7746C11.3519 13.7976 11.3366 13.8205 11.3194 13.8422C11.2056 13.9855 11.0505 14.0682 10.8939 14.0682C10.8012 14.0682 10.7133 14.0403 10.6324 13.9855C10.4135 13.8362 10.3698 13.5879 10.5158 13.3214C10.5624 13.2363 10.6163 13.1554 10.6702 13.0748C10.7091 13.0169 10.7476 12.959 10.784 12.8997C11.6394 11.5038 11.6096 10.0487 10.6954 8.57429C10.6219 8.45535 10.5396 8.34165 10.4573 8.22829L10.3502 8.079L10.0602 8.15853C10.014 8.78252 9.97166 9.34723 9.81199 9.89937C9.71185 10.2468 9.58089 10.5045 9.40127 10.71C9.15862 10.9869 8.84699 11.1338 8.49964 11.1338C8.15825 11.1338 7.8074 10.9922 7.48526 10.7246C7.31531 10.5832 7.22959 10.5119 7.11936 10.5119C6.94284 10.5119 6.88915 10.6679 6.80814 10.9034L6.80773 10.9046C6.48909 11.8324 6.72334 12.5628 7.52343 13.1369C7.7006 13.2642 7.96426 13.5283 7.74297 13.8659C7.65999 13.9935 7.53428 14.0602 7.37917 14.0602C7.25276 14.0602 7.11481 14.0152 6.97965 13.9301C5.84797 13.2147 5.41134 11.815 5.918 10.5272C6.09238 10.0825 6.32312 9.66533 6.60324 9.28723C6.73105 9.11423 6.89001 9.01936 7.05073 9.01936C7.2111 9.01936 7.36761 9.11493 7.49156 9.28758C7.702 9.58057 7.88408 9.78985 8.08191 9.96599C8.18696 10.0595 8.31301 10.1554 8.45062 10.1554C8.67926 10.1554 8.78396 9.906 8.83403 9.78566C9.03221 9.31304 9.04692 8.81671 9.04447 8.34862C9.04202 7.76857 8.98529 7.15853 8.86694 6.4285Z","fill":"#10C1EE"})));
}

IcGasComponent.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = IcGasComponent;

IcGasComponent.default = IcGasComponent;


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcInfoComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-info"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M4.30005 21.4697C4.30005 12.0494 13.1166 4.1748 24 4.1748C34.885 4.1748 43.7001 11.9242 43.7001 21.4697C43.7001 25.0686 42.46 28.5454 39.9721 31.5309L39.8642 31.6603L43.5853 42.5668C43.6341 42.7697 43.6302 42.9598 43.573 43.1312C43.5172 43.2987 43.4048 43.4659 43.2077 43.6191C42.9954 43.725 42.8181 43.8076 42.5758 43.8247C42.5356 43.8004 42.4957 43.782 42.4592 43.7673C42.3912 43.74 42.3177 43.7194 42.2585 43.7028L42.2516 43.7008C42.1499 43.6723 42.0661 43.648 41.985 43.6078L30.8596 37.7254L30.7356 37.7691C28.6274 38.5132 26.2594 38.7647 24 38.7647C13.1151 38.7647 4.30005 31.0153 4.30005 21.4697ZM24 6.10652L23.996 6.10657C14.3815 6.23476 6.48482 13.0377 6.48482 21.4698C6.48482 29.8988 14.3785 36.8331 24 36.8331C26.3105 36.8331 28.4964 36.4483 30.5555 35.6768C30.8744 35.5721 31.2753 35.5835 31.5551 35.7701L31.567 35.778L40.7305 40.7017L37.7021 31.754C37.6205 31.5083 37.6859 31.2348 37.9087 30.8947C40.3551 28.1826 41.5152 24.9518 41.5152 21.4698C41.5152 13.0409 33.6216 6.10654 24 6.10652ZM23.0529 10.5611C23.3876 10.2821 23.7329 10.1559 24.0633 10.1559C24.3938 10.1559 24.7391 10.2821 25.0738 10.5611L25.0861 10.5713L25.0995 10.5802C25.3762 10.7647 25.5988 11.1643 25.5988 11.723C25.5988 12.0228 25.5681 12.2288 25.4965 12.396C25.4272 12.5575 25.3085 12.7085 25.0859 12.8754C24.6151 13.2285 24.2971 13.3217 24.0001 13.3217C23.5974 13.3217 23.2901 13.1254 22.9006 12.8658C22.6269 12.6833 22.4182 12.3013 22.5221 11.7818L22.5279 11.7527V11.723C22.5279 11.4232 22.5586 11.2171 22.6302 11.05C22.6995 10.8884 22.8185 10.7378 23.0411 10.5709L23.0529 10.5611ZM18.8569 18.7644V16.8328H25.0924V28.9847H29.0164V30.9163H22.781V18.7644H18.8569Z","fill":"white"})));
}

IcInfoComponent.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = IcInfoComponent;

IcInfoComponent.default = IcInfoComponent;


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcInfo2Component (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.5918 9.74167V6.59167H7.40846V9.74167H6.5918ZM7.29201 4.95856C7.21464 5.03592 7.12134 5.07501 7.00013 5.07501C6.87892 5.07501 6.78562 5.03592 6.70825 4.95856C6.63088 4.88119 6.5918 4.78788 6.5918 4.66667C6.5918 4.54547 6.63088 4.45216 6.70825 4.37479C6.78562 4.29743 6.87892 4.25834 7.00013 4.25834C7.12134 4.25834 7.21464 4.29743 7.29201 4.37479C7.36938 4.45216 7.40846 4.54547 7.40846 4.66667C7.40846 4.78788 7.36938 4.88119 7.29201 4.95856ZM7.00013 12.6583C6.21596 12.6583 5.48133 12.5097 4.79446 12.2133C4.1042 11.9154 3.50551 11.5121 2.99679 11.0033C2.48807 10.4946 2.0847 9.89594 1.78685 9.20567C1.49046 8.51881 1.3418 7.78418 1.3418 7.00001C1.3418 6.21584 1.49046 5.48121 1.78685 4.79434C2.0847 4.10408 2.48807 3.50539 2.99679 2.99667C3.50551 2.48795 4.1042 2.08458 4.79446 1.78673C5.48133 1.49034 6.21596 1.34167 7.00013 1.34167C7.7843 1.34167 8.51893 1.49034 9.2058 1.78673C9.89606 2.08458 10.4948 2.48795 11.0035 2.99667C11.5122 3.50539 11.9156 4.10408 12.2134 4.79434C12.5098 5.48121 12.6585 6.21584 12.6585 7.00001C12.6585 7.78418 12.5098 8.51881 12.2134 9.20567C11.9156 9.89594 11.5122 10.4946 11.0035 11.0033C10.4948 11.5121 9.89606 11.9154 9.2058 12.2133C8.51893 12.5097 7.7843 12.6583 7.00013 12.6583ZM7.00013 11.8417C8.34834 11.8417 9.49662 11.3718 10.4343 10.4342C11.372 9.4965 11.8418 8.34822 11.8418 7.00001C11.8418 5.6518 11.372 4.50352 10.4343 3.56585C9.49662 2.62817 8.34834 2.15834 7.00013 2.15834C5.65192 2.15834 4.50364 2.62817 3.56597 3.56585C2.6283 4.50352 2.15846 5.6518 2.15846 7.00001C2.15846 8.34822 2.6283 9.4965 3.56597 10.4342C4.50364 11.3718 5.65192 11.8417 7.00013 11.8417Z","fill":"#3E3E3E"}));
}

IcInfo2Component.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = IcInfo2Component;

IcInfo2Component.default = IcInfo2Component;


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcNightComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-night"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M18.2094 32.9884C16.1682 32.9884 14.2609 32.5999 12.4828 31.8258C10.6949 31.0474 9.14242 29.9975 7.82138 28.6764C6.50034 27.3554 5.45043 25.8029 4.67202 24.015C3.89787 22.2369 3.50943 20.3296 3.50943 18.2884C3.50943 14.7431 4.63538 11.6265 6.8925 8.92037C9.01254 6.37861 11.6723 4.74448 14.8859 4.01172C14.5577 6.32956 14.7343 8.6028 15.4167 10.8267C16.1637 13.2606 17.4526 15.393 19.2787 17.2191C21.1049 19.0452 23.2372 20.3342 25.6712 21.0811C27.8965 21.764 30.1712 21.9403 32.4906 21.6112C31.7793 24.8246 30.1505 27.4843 27.597 29.6047C24.878 31.8624 21.7548 32.9884 18.2094 32.9884ZM29.1398 24.4703L29.4768 23.8668L28.7886 23.8028C26.6884 23.6075 24.7006 23.0767 22.8228 22.211C20.947 21.3461 19.2657 20.1708 17.7776 18.6827C16.2891 17.1941 15.1071 15.5122 14.2296 13.6353C13.3526 11.7596 12.8287 9.77432 12.6579 7.67688L12.6012 6.97921L11.99 7.3205C9.99494 8.43463 8.42938 9.97363 7.30077 11.9325C6.17349 13.889 5.60943 16.0104 5.60943 18.2884C5.60943 21.7814 6.83713 24.765 9.28498 27.2128C11.7328 29.6607 14.7164 30.8884 18.2094 30.8884C20.4885 30.8884 22.6047 30.3175 24.5496 29.1765C26.4948 28.0354 28.0263 26.4642 29.1398 24.4703Z","fill":"#3E3E3E"})));
}

IcNightComponent.defaultProps = {"width":"36","height":"37","viewBox":"0 0 36 37","fill":"none"};

module.exports = IcNightComponent;

IcNightComponent.default = IcNightComponent;


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcResultComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-result"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M6.75 6.38672L9 4.13672L11.25 6.38672L13.5 4.13672L15.75 6.38672L18 4.13672L20.25 6.38672L22.5 4.13672L24.75 6.38672L27 4.13672L29.25 6.38672L31.05 4.58672V32.4139L29.25 30.6139L27 32.8639L24.75 30.6139L22.5 32.8639L20.25 30.6139L18 32.8639L15.75 30.6139L13.5 32.8639L11.25 30.6139L9 32.8639L6.75 30.6139L4.95 32.4139V4.58672L6.75 6.38672ZM7.05 7.40032V29.6003H28.95V7.40032H7.05ZM9.45 25.5503V23.4503H26.55V25.5503H9.45ZM9.45 19.5503V17.4503H26.55V19.5503H9.45ZM9.45 13.5503V11.4503H26.55V13.5503H9.45Z","fill":"#3E3E3E"})));
}

IcResultComponent.defaultProps = {"width":"36","height":"37","viewBox":"0 0 36 37","fill":"none"};

module.exports = IcResultComponent;

IcResultComponent.default = IcResultComponent;


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcCryComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic- cry"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M5.40901 13.0834L5.40885 13.125C5.40885 13.1111 5.4089 13.0972 5.40901 13.0834ZM14.9922 13.125L14.992 13.0834C14.9921 13.0972 14.9922 13.1111 14.9922 13.125ZM6.3635 7.664C6.3635 7.664 6.3635 7.664 6.36349 7.664L6.3635 7.664ZM9.40542 5.84184C9.41357 5.83207 9.42166 5.82228 9.42969 5.81246L9.40542 5.84184ZM9.39557 5.85361C9.35376 5.90336 9.31041 5.95253 9.26553 6.00113C9.22005 6.05038 9.17299 6.09903 9.12435 6.1471C9.22097 6.05162 9.31138 5.95379 9.39557 5.85361ZM10.9957 5.84195L10.9714 5.81246L11.9297 5.02085C11.9644 5.0625 12.0008 5.10371 12.0389 5.14449C12.0008 5.10369 11.9644 5.06246 11.9297 5.02079L10.9714 5.81246C10.9794 5.82231 10.9875 5.83214 10.9957 5.84195ZM6.40905 13.0833H5.65901C5.66856 11.8335 6.10817 10.7792 6.98146 9.9059C7.86445 9.02292 8.93251 8.58329 10.2005 8.58329C11.4685 8.58329 12.5366 9.02292 13.4196 9.9059C14.2929 10.7792 14.7325 11.8335 14.742 13.0833H13.992C13.9823 12.0498 13.6131 11.1632 12.8877 10.4378C12.1526 9.70264 11.2519 9.33329 10.2005 9.33329C9.14917 9.33329 8.24846 9.70264 7.51333 10.4378C6.78793 11.1632 6.4187 12.0498 6.40905 13.0833ZM7.79524 6.82457C7.2781 7.12007 6.79006 7.31515 6.33035 7.41541L6.22908 6.65587C6.6124 6.56189 7.01564 6.39312 7.43782 6.15527C7.86096 5.91688 8.21561 5.65446 8.49651 5.36584L9.07248 5.84165C8.74071 6.19844 8.31645 6.52673 7.79524 6.82457ZM12.9632 6.15527C13.3854 6.39312 13.7886 6.56189 14.172 6.65587L14.0707 7.41541C13.611 7.31515 13.1229 7.12007 12.6058 6.82457C12.0846 6.52673 11.6603 6.19844 11.3286 5.84165L11.9045 5.36584C12.1854 5.65446 12.5401 5.91688 12.9632 6.15527ZM10.2005 18.0833C9.08028 18.0833 8.03081 17.8709 7.04957 17.4475C6.06348 17.022 5.20821 16.4458 4.48146 15.719C3.75472 14.9923 3.17848 14.137 2.75298 13.1509C2.32957 12.1697 2.11719 11.1202 2.11719 9.99996C2.11719 8.87972 2.32957 7.83025 2.75298 6.84901C3.17848 5.86292 3.75472 5.00765 4.48146 4.2809C5.20821 3.55416 6.06348 2.97792 7.04957 2.55242C8.03081 2.12901 9.08028 1.91663 10.2005 1.91663C11.3208 1.91663 12.3702 2.12901 13.3515 2.55242C14.3376 2.97792 15.1928 3.55416 15.9196 4.2809C16.6463 5.00765 17.2226 5.86292 17.6481 6.84901C18.0715 7.83025 18.2839 8.87972 18.2839 9.99996C18.2839 11.1202 18.0715 12.1697 17.6481 13.1509C17.2226 14.137 16.6463 14.9923 15.9196 15.719C15.1928 16.4458 14.3376 17.022 13.3515 17.4475C12.3702 17.8709 11.3208 18.0833 10.2005 18.0833ZM10.2005 16.9166C12.1265 16.9166 13.7669 16.2454 15.1065 14.9059C16.446 13.5664 17.1172 11.926 17.1172 9.99996C17.1172 8.07395 16.446 6.43355 15.1065 5.09402C13.7669 3.75448 12.1265 3.08329 10.2005 3.08329C8.27451 3.08329 6.63411 3.75448 5.29458 5.09402C3.95505 6.43355 3.28385 8.07395 3.28385 9.99996C3.28385 11.926 3.95505 13.5664 5.29458 14.9059C6.63411 16.2454 8.27451 16.9166 10.2005 16.9166Z","fill":"#3E3E3E"})));
}

IcCryComponent.defaultProps = {"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none"};

module.exports = IcCryComponent;

IcCryComponent.default = IcCryComponent;


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcHappyComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-happy_"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M6.55011 11.4166C6.58266 11.4987 6.61708 11.5792 6.65335 11.6582L6.55011 11.4166ZM9.09176 8.56308L8.22083 7.69214L7.30417 8.56714L6.77866 8.04163L8.21468 6.60561L9.61527 8.03957L9.09176 8.56308ZM14.296 8.56714L13.3793 7.69214L12.5084 8.56308L11.9849 8.03957L13.3855 6.60561L14.8215 8.04163L14.296 8.56714ZM13.2305 13.3258C12.5018 13.8313 11.694 14.0833 10.8001 14.0833C9.90621 14.0833 9.09836 13.8313 8.36968 13.3258C7.74277 12.8909 7.26502 12.3389 6.93413 11.6666H14.666C14.3352 12.3389 13.8574 12.8909 13.2305 13.3258ZM10.8001 17.8333C9.67985 17.8333 8.63039 17.6209 7.64915 17.1975C6.66307 16.772 5.8078 16.1958 5.08106 15.469C4.35432 14.7423 3.77809 13.887 3.35259 12.9009C2.92918 11.9197 2.7168 10.8702 2.7168 9.74997C2.7168 8.62973 2.92918 7.58025 3.35259 6.59901C3.77809 5.61292 4.35432 4.75765 5.08106 4.03091C5.8078 3.30416 6.66307 2.72792 7.64915 2.30242C8.63039 1.87901 9.67985 1.66663 10.8001 1.66663C11.9203 1.66663 12.9698 1.87901 13.951 2.30242C14.9371 2.72792 15.7924 3.30416 16.5191 4.03091C17.2459 4.75765 17.8221 5.61292 18.2476 6.59901C18.671 7.58025 18.8834 8.62973 18.8834 9.74997C18.8834 10.8702 18.671 11.9197 18.2476 12.9009C17.8221 13.887 17.2459 14.7423 16.5191 15.469C15.7924 16.1958 14.9371 16.772 13.951 17.1975C12.9698 17.6209 11.9203 17.8333 10.8001 17.8333ZM10.8001 16.6666C12.7261 16.6666 14.3665 15.9955 15.706 14.6559C17.0455 13.3164 17.7167 11.676 17.7167 9.74997C17.7167 7.82395 17.0455 6.18355 15.706 4.84402C14.3665 3.50449 12.7261 2.83329 10.8001 2.83329C8.87408 2.83329 7.2337 3.50449 5.89417 4.84402C4.55465 6.18355 3.88346 7.82395 3.88346 9.74997C3.88346 11.676 4.55465 13.3164 5.89417 14.6559C7.2337 15.9955 8.87408 16.6666 10.8001 16.6666Z","fill":"#3E3E3E"})));
}

IcHappyComponent.defaultProps = {"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none"};

module.exports = IcHappyComponent;

IcHappyComponent.default = IcHappyComponent;


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcNeutralComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-neutral"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M10.0003 18.0833C5.53602 18.0833 1.91699 14.4642 1.91699 9.99996C1.91699 5.53566 5.53602 1.91663 10.0003 1.91663C14.4646 1.91663 18.0837 5.53566 18.0837 9.99996C18.0837 14.4642 14.4646 18.0833 10.0003 18.0833ZM10.0003 16.9166C13.8203 16.9166 16.917 13.8199 16.917 9.99996C16.917 6.17999 13.8203 3.08329 10.0003 3.08329C6.18035 3.08329 3.08366 6.17999 3.08366 9.99996C3.08366 13.8199 6.18035 16.9166 10.0003 16.9166ZM13.0837 13.0833V11.9166H6.91699V13.0833H13.0837ZM6.66699 8.91663C6.11471 8.91663 5.66699 8.46889 5.66699 7.91663C5.66699 7.36434 6.11471 6.91663 6.66699 6.91663C7.21928 6.91663 7.66699 7.36434 7.66699 7.91663C7.66699 8.46889 7.21928 8.91663 6.66699 8.91663ZM13.3337 8.91663C12.7814 8.91663 12.3337 8.46889 12.3337 7.91663C12.3337 7.36434 12.7814 6.91663 13.3337 6.91663C13.8859 6.91663 14.3337 7.36434 14.3337 7.91663C14.3337 8.46889 13.8859 8.91663 13.3337 8.91663Z","fill":"#3E3E3E"})));
}

IcNeutralComponent.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IcNeutralComponent;

IcNeutralComponent.default = IcNeutralComponent;


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcReviewComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-review"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M40.5996 33.0243H10.5443L7.39961 36.1006V7.82429H40.5996V33.0243ZM28.9415 27.6714L23.9996 24.6725L19.0577 27.6714L20.3662 22.0577L15.9752 18.2577L21.7612 17.7932L23.9996 12.4718L26.238 17.7932L32.024 18.2577L27.633 22.0577L28.9415 27.6714ZM11.7511 35.8243L4.59961 42.9758V8.42429C4.59961 7.48469 4.92716 6.69526 5.59887 6.02356C6.27058 5.35185 7.06 5.02429 7.99961 5.02429H39.9996C40.9392 5.02429 41.7286 5.35185 42.4003 6.02356C43.0721 6.69526 43.3996 7.48469 43.3996 8.42429V32.4243C43.3996 33.3639 43.0721 34.1533 42.4003 34.825C41.7286 35.4967 40.9392 35.8243 39.9996 35.8243H11.7511Z","fill":"white"})));
}

IcReviewComponent.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = IcReviewComponent;

IcReviewComponent.default = IcReviewComponent;


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcSadComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-sad"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M14.2262 8.62527C14.0306 8.82091 13.7993 8.91663 13.5176 8.91663C13.2359 8.91663 13.0046 8.82091 12.8089 8.62527C12.6133 8.42963 12.5176 8.1983 12.5176 7.91663C12.5176 7.63495 12.6133 7.40363 12.8089 7.20799C13.0046 7.01235 13.2359 6.91663 13.5176 6.91663C13.7993 6.91663 14.0306 7.01235 14.2262 7.20799C14.4219 7.40363 14.5176 7.63495 14.5176 7.91663C14.5176 8.1983 14.4219 8.42963 14.2262 8.62527ZM8.39289 8.62527C8.19725 8.82091 7.96592 8.91663 7.68425 8.91663C7.40257 8.91663 7.17124 8.82091 6.97561 8.62527C6.77997 8.42963 6.68425 8.1983 6.68425 7.91663C6.68425 7.63495 6.77997 7.40363 6.97561 7.20799C7.17124 7.01235 7.40257 6.91663 7.68425 6.91663C7.96592 6.91663 8.19725 7.01235 8.39289 7.20799C8.58852 7.40363 8.68425 7.63495 8.68425 7.91663C8.68425 8.1983 8.58852 8.42963 8.39289 8.62527ZM8.17049 12.2575C8.89918 11.752 9.70703 11.5 10.6009 11.5C11.4948 11.5 12.3026 11.752 13.0313 12.2575C13.6582 12.6923 14.136 13.2443 14.4669 13.9166H6.73493C7.06583 13.2443 7.54357 12.6923 8.17049 12.2575ZM10.6009 18.0833C9.48067 18.0833 8.4312 17.8709 7.44996 17.4475C6.46387 17.022 5.6086 16.4458 4.88186 15.719C4.15511 14.9923 3.57887 14.137 3.15337 13.1509C2.72996 12.1697 2.51758 11.1202 2.51758 9.99996C2.51758 8.87972 2.72996 7.83025 3.15337 6.84901C3.57887 5.86292 4.15511 5.00765 4.88186 4.2809C5.6086 3.55416 6.46387 2.97792 7.44996 2.55242C8.4312 2.12901 9.48067 1.91663 10.6009 1.91663C11.7212 1.91663 12.7706 2.12901 13.7519 2.55242C14.738 2.97792 15.5932 3.55416 16.32 4.2809C17.0467 5.00765 17.6229 5.86292 18.0485 6.84901C18.4719 7.83025 18.6842 8.87972 18.6842 9.99996C18.6842 11.1202 18.4719 12.1697 18.0485 13.1509C17.6229 14.137 17.0467 14.9923 16.32 15.719C15.5932 16.4458 14.738 17.022 13.7519 17.4475C12.7706 17.8709 11.7212 18.0833 10.6009 18.0833ZM10.6009 16.9166C12.5269 16.9166 14.1673 16.2454 15.5069 14.9059C16.8464 13.5664 17.5176 11.926 17.5176 9.99996C17.5176 8.07395 16.8464 6.43355 15.5069 5.09402C14.1673 3.75448 12.5269 3.08329 10.6009 3.08329C8.6749 3.08329 7.0345 3.75448 5.69497 5.09402C4.35544 6.43355 3.68424 8.07395 3.68424 9.99996C3.68424 11.926 4.35544 13.5664 5.69497 14.9059C7.0345 16.2454 8.6749 16.9166 10.6009 16.9166Z","fill":"#3E3E3E"})));
}

IcSadComponent.defaultProps = {"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none"};

module.exports = IcSadComponent;

IcSadComponent.default = IcSadComponent;


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcSmileComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-smile"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M6.3587 11.6666C6.39126 11.7487 6.42567 11.8292 6.46194 11.9082L6.3587 11.6666ZM14.234 8.62527C14.0383 8.82091 13.807 8.91663 13.5253 8.91663C13.2437 8.91663 13.0123 8.82091 12.8167 8.62527C12.6211 8.42963 12.5253 8.19831 12.5253 7.91663C12.5253 7.63496 12.6211 7.40363 12.8167 7.20799C13.0123 7.01235 13.2437 6.91663 13.5253 6.91663C13.807 6.91663 14.0383 7.01235 14.234 7.20799C14.4296 7.40363 14.5253 7.63496 14.5253 7.91663C14.5253 8.19831 14.4296 8.42963 14.234 8.62527ZM8.40067 8.62527C8.20503 8.82091 7.9737 8.91663 7.69203 8.91663C7.41036 8.91663 7.17903 8.82091 6.98339 8.62527C6.78776 8.42963 6.69204 8.19831 6.69204 7.91663C6.69204 7.63496 6.78776 7.40363 6.98339 7.20799C7.17903 7.01235 7.41036 6.91663 7.69203 6.91663C7.9737 6.91663 8.20503 7.01235 8.40067 7.20799C8.59631 7.40363 8.69203 7.63496 8.69203 7.91663C8.69203 8.19831 8.59631 8.42963 8.40067 8.62527ZM13.0391 13.5758C12.3104 14.0813 11.5026 14.3333 10.6087 14.3333C9.71481 14.3333 8.90695 14.0813 8.17827 13.5758C7.55136 13.1409 7.07362 12.5889 6.74272 11.9166H14.4746C14.1437 12.5889 13.666 13.1409 13.0391 13.5758ZM10.6087 18.0833C9.48845 18.0833 8.43898 17.8709 7.45775 17.4475C6.47166 17.022 5.61639 16.4458 4.88966 15.719C4.16292 14.9923 3.58668 14.137 3.16118 13.1509C2.73777 12.1697 2.52539 11.1202 2.52539 9.99997C2.52539 8.87973 2.73777 7.83025 3.16118 6.84901C3.58668 5.86292 4.16292 5.00765 4.88966 4.28091C5.61639 3.55416 6.47166 2.97792 7.45775 2.55242C8.43898 2.12901 9.48845 1.91663 10.6087 1.91663C11.7289 1.91663 12.7784 2.12901 13.7596 2.55242C14.7457 2.97792 15.601 3.55416 16.3277 4.28091C17.0545 5.00765 17.6307 5.86292 18.0562 6.84901C18.4796 7.83025 18.692 8.87973 18.692 9.99997C18.692 11.1202 18.4796 12.1697 18.0562 13.1509C17.6307 14.137 17.0545 14.9923 16.3277 15.719C15.601 16.4458 14.7457 17.022 13.7596 17.4475C12.7784 17.8709 11.7289 18.0833 10.6087 18.0833ZM10.6087 16.9166C12.5347 16.9166 14.1751 16.2455 15.5146 14.9059C16.8541 13.5664 17.5253 11.926 17.5253 9.99997C17.5253 8.07395 16.8541 6.43355 15.5146 5.09402C14.1751 3.75449 12.5347 3.08329 10.6087 3.08329C8.68268 3.08329 7.04229 3.75449 5.70276 5.09402C4.36324 6.43355 3.69205 8.07395 3.69205 9.99997C3.69205 11.926 4.36324 13.5664 5.70276 14.9059C7.04229 16.2455 8.68268 16.9166 10.6087 16.9166Z","fill":"#3E3E3E"})));
}

IcSmileComponent.defaultProps = {"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none"};

module.exports = IcSmileComponent;

IcSmileComponent.default = IcSmileComponent;


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcAlertComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-alert"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M26.3662 39.4667V26.8667H29.6329V39.4667H26.3662ZM29.1671 20.3342C28.8576 20.6437 28.4844 20.8 27.9995 20.8C27.5147 20.8 27.1415 20.6437 26.832 20.3342C26.5226 20.0248 26.3662 19.6515 26.3662 19.1667C26.3662 18.6819 26.5226 18.3086 26.832 17.9992C27.1415 17.6897 27.5147 17.5334 27.9995 17.5334C28.4844 17.5334 28.8576 17.6897 29.1671 17.9992C29.4765 18.3086 29.6329 18.6819 29.6329 19.1667C29.6329 19.6515 29.4765 20.0248 29.1671 20.3342ZM27.9995 51.1334C24.8629 51.1334 21.9243 50.5387 19.1769 49.3531C16.4158 48.1617 14.0211 46.5483 11.9862 44.5134C9.95131 42.4785 8.33784 40.0837 7.14643 37.3227C5.96088 34.5752 5.36621 31.6367 5.36621 28.5C5.36621 25.3634 5.96088 22.4248 7.14643 19.6774C8.33784 16.9163 9.95131 14.5216 11.9862 12.4867C14.0211 10.4518 16.4158 8.83833 19.1769 7.64692C21.9243 6.46136 24.8629 5.8667 27.9995 5.8667C31.1362 5.8667 34.0747 6.46136 36.8222 7.64692C39.5833 8.83833 41.978 10.4518 44.0129 12.4867C46.0478 14.5216 47.6612 16.9163 48.8527 19.6774C50.0382 22.4248 50.6329 25.3634 50.6329 28.5C50.6329 31.6367 50.0382 34.5752 48.8527 37.3227C47.6612 40.0837 46.0478 42.4785 44.0129 44.5134C41.978 46.5483 39.5833 48.1617 36.8222 49.3531C34.0747 50.5387 31.1362 51.1334 27.9995 51.1334ZM27.9995 47.8667C33.3924 47.8667 37.9855 45.9874 41.7362 42.2367C45.4869 38.486 47.3662 33.8929 47.3662 28.5C47.3662 23.1072 45.4869 18.5141 41.7362 14.7634C37.9855 11.0127 33.3924 9.13337 27.9995 9.13337C22.6067 9.13337 18.0136 11.0127 14.2629 14.7634C10.5122 18.5141 8.63288 23.1072 8.63288 28.5C8.63288 33.8929 10.5122 38.486 14.2629 42.2367C18.0136 45.9874 22.6067 47.8667 27.9995 47.8667Z","fill":"#CA0000"})));
}

IcAlertComponent.defaultProps = {"width":"56","height":"57","viewBox":"0 0 56 57","fill":"none"};

module.exports = IcAlertComponent;

IcAlertComponent.default = IcAlertComponent;


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcArrowComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-arrow forward"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M3.33333 9.66688V9.66689L13.4792 9.66688H3.33333ZM8.81251 16.0002L13.4792 11.3336L8.8125 16.0002L8.81251 16.0002ZM9.16763 15.9987L14.0827 11.0836H3.58333V9.91689H14.0827L9.16763 5.00179L9.99844 4.18555L16.3131 10.5002L9.99844 16.8149L9.16763 15.9987Z","fill":"#BABABA"})));
}

IcArrowComponent.defaultProps = {"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none"};

module.exports = IcArrowComponent;

IcArrowComponent.default = IcArrowComponent;


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcCheckSuccessComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-check"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M10.6 14.7243L7.75005 11.8743L6.77431 12.85L10.6 16.6757L17.2258 10.05L16.25 9.07425L10.6 14.7243ZM12 22.2C10.6558 22.2 9.39639 21.9451 8.21891 21.437C7.0356 20.9264 6.00927 20.2349 5.13718 19.3629C4.26509 18.4908 3.5736 17.4644 3.063 16.2811C2.55491 15.1036 2.30005 13.8443 2.30005 12.5C2.30005 11.1557 2.55491 9.89633 3.063 8.71885C3.5736 7.53554 4.26509 6.50921 5.13718 5.63712C6.00927 4.76503 7.0356 4.07354 8.21891 3.56294C9.39639 3.05484 10.6558 2.79999 12 2.79999C13.3443 2.79999 14.6037 3.05484 15.7812 3.56294C16.9645 4.07354 17.9908 4.76503 18.8629 5.63712C19.735 6.50921 20.4265 7.53554 20.9371 8.71885C21.4452 9.89633 21.7001 11.1557 21.7001 12.5C21.7001 13.8443 21.4452 15.1036 20.9371 16.2811C20.4265 17.4644 19.735 18.4908 18.8629 19.3629C17.9908 20.2349 16.9645 20.9264 15.7812 21.437C14.6037 21.9451 13.3443 22.2 12 22.2ZM12 20.8C14.3113 20.8 16.2797 19.9946 17.8872 18.3871C19.4946 16.7797 20.3001 14.8112 20.3001 12.5C20.3001 10.1888 19.4946 8.22029 17.8872 6.61286C16.2797 5.00542 14.3113 4.19999 12 4.19999C9.68883 4.19999 7.72036 5.00542 6.11292 6.61286C4.50548 8.22029 3.70005 10.1888 3.70005 12.5C3.70005 14.8112 4.50548 16.7797 6.11292 18.3871C7.72036 19.9946 9.68883 20.8 12 20.8Z","fill":"#3E3E3E"})));
}

IcCheckSuccessComponent.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"};

module.exports = IcCheckSuccessComponent;

IcCheckSuccessComponent.default = IcCheckSuccessComponent;


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcCheckComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-check"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M10.6 14.7243L7.75005 11.8743L6.77431 12.85L10.6 16.6757L17.2258 10.05L16.25 9.07425L10.6 14.7243ZM12 22.2C10.6558 22.2 9.39639 21.9451 8.21891 21.437C7.0356 20.9264 6.00927 20.2349 5.13718 19.3629C4.26509 18.4908 3.5736 17.4644 3.063 16.2811C2.55491 15.1036 2.30005 13.8443 2.30005 12.5C2.30005 11.1557 2.55491 9.89633 3.063 8.71885C3.5736 7.53554 4.26509 6.50921 5.13718 5.63712C6.00927 4.76503 7.0356 4.07354 8.21891 3.56294C9.39639 3.05484 10.6558 2.79999 12 2.79999C13.3443 2.79999 14.6037 3.05484 15.7812 3.56294C16.9645 4.07354 17.9908 4.76503 18.8629 5.63712C19.735 6.50921 20.4265 7.53554 20.9371 8.71885C21.4452 9.89633 21.7001 11.1557 21.7001 12.5C21.7001 13.8443 21.4452 15.1036 20.9371 16.2811C20.4265 17.4644 19.735 18.4908 18.8629 19.3629C17.9908 20.2349 16.9645 20.9264 15.7812 21.437C14.6037 21.9451 13.3443 22.2 12 22.2ZM12 20.8C14.3113 20.8 16.2797 19.9946 17.8872 18.3871C19.4946 16.7797 20.3001 14.8112 20.3001 12.5C20.3001 10.1888 19.4946 8.22029 17.8872 6.61286C16.2797 5.00542 14.3113 4.19999 12 4.19999C9.68883 4.19999 7.72036 5.00542 6.11292 6.61286C4.50548 8.22029 3.70005 10.1888 3.70005 12.5C3.70005 14.8112 4.50548 16.7797 6.11292 18.3871C7.72036 19.9946 9.68883 20.8 12 20.8Z","fill":"#3E3E3E"})));
}

IcCheckComponent.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"};

module.exports = IcCheckComponent;

IcCheckComponent.default = IcCheckComponent;


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcEditComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-edit"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M13.8567 7.68437L13.0726 6.92737L12.3156 6.14332L3.91667 14.5423V16.0833H5.45772L13.8567 7.68437ZM15.9217 5.24495L14.7551 4.07828L14.5783 4.25505L15.7449 5.42172L15.9217 5.24495ZM16.8441 6.34406L5.93811 17.25H2.75V14.062L13.6727 3.15999C13.8176 3.0279 13.9758 2.92713 14.1477 2.856C14.3181 2.78546 14.4974 2.75 14.6875 2.75C14.8776 2.75 15.0614 2.78548 15.2405 2.85712C15.4137 2.92641 15.563 3.0298 15.6906 3.16903L16.8471 4.34652L16.8519 4.35096C16.9897 4.47725 17.0883 4.62433 17.1507 4.7944C17.2176 4.97697 17.25 5.15623 17.25 5.33333C17.25 5.52624 17.217 5.70792 17.1517 5.88009C17.089 6.04539 16.9881 6.20002 16.8441 6.34406Z","fill":"white"})));
}

IcEditComponent.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IcEditComponent;

IcEditComponent.default = IcEditComponent;


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcAlertComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-alert"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M26.3662 39.4667V26.8667H29.6329V39.4667H26.3662ZM29.1671 20.3342C28.8576 20.6437 28.4844 20.8 27.9995 20.8C27.5147 20.8 27.1415 20.6437 26.832 20.3342C26.5226 20.0248 26.3662 19.6515 26.3662 19.1667C26.3662 18.6819 26.5226 18.3086 26.832 17.9992C27.1415 17.6897 27.5147 17.5334 27.9995 17.5334C28.4844 17.5334 28.8576 17.6897 29.1671 17.9992C29.4765 18.3086 29.6329 18.6819 29.6329 19.1667C29.6329 19.6515 29.4765 20.0248 29.1671 20.3342ZM27.9995 51.1334C24.8629 51.1334 21.9243 50.5387 19.1769 49.3531C16.4158 48.1617 14.0211 46.5483 11.9862 44.5134C9.95131 42.4785 8.33784 40.0837 7.14643 37.3227C5.96088 34.5752 5.36621 31.6367 5.36621 28.5C5.36621 25.3634 5.96088 22.4248 7.14643 19.6774C8.33784 16.9163 9.95131 14.5216 11.9862 12.4867C14.0211 10.4518 16.4158 8.83833 19.1769 7.64692C21.9243 6.46136 24.8629 5.8667 27.9995 5.8667C31.1362 5.8667 34.0747 6.46136 36.8222 7.64692C39.5833 8.83833 41.978 10.4518 44.0129 12.4867C46.0478 14.5216 47.6612 16.9163 48.8527 19.6774C50.0382 22.4248 50.6329 25.3634 50.6329 28.5C50.6329 31.6367 50.0382 34.5752 48.8527 37.3227C47.6612 40.0837 46.0478 42.4785 44.0129 44.5134C41.978 46.5483 39.5833 48.1617 36.8222 49.3531C34.0747 50.5387 31.1362 51.1334 27.9995 51.1334ZM27.9995 47.8667C33.3924 47.8667 37.9855 45.9874 41.7362 42.2367C45.4869 38.486 47.3662 33.8929 47.3662 28.5C47.3662 23.1072 45.4869 18.5141 41.7362 14.7634C37.9855 11.0127 33.3924 9.13337 27.9995 9.13337C22.6067 9.13337 18.0136 11.0127 14.2629 14.7634C10.5122 18.5141 8.63288 23.1072 8.63288 28.5C8.63288 33.8929 10.5122 38.486 14.2629 42.2367C18.0136 45.9874 22.6067 47.8667 27.9995 47.8667Z","fill":"#93C13E"})));
}

IcAlertComponent.defaultProps = {"width":"56","height":"57","viewBox":"0 0 56 57","fill":"none"};

module.exports = IcAlertComponent;

IcAlertComponent.default = IcAlertComponent;


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function AdultoComponent (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"simuladores/icons/ic-adulto"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2},React.createElement("linearGradient",{"x1":"158.87207%","y1":"50%","x2":"-2.22044605e-14%","y2":"50%","id":"linearGradient-1"},[React.createElement("stop",{"stopColor":"#006736","offset":"0%","key":0}),React.createElement("stop",{"stopColor":"#93C13E","offset":"100%","key":1})])),React.createElement("g",{"id":"Simulador-Avancado---Desktop","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"simul_avancado_etapa1_desktop","transform":"translate(-519.000000, -2328.000000)","fillRule":"nonzero","fill":"url(#linearGradient-1)"},React.createElement("g",{"id":"agregado","transform":"translate(0.000000, 2122.000000)"},React.createElement("g",{"id":"content","transform":"translate(479.000000, 80.000000)"},React.createElement("g",{"id":"boxes","transform":"translate(0.000000, 100.000000)"},React.createElement("g",{"id":"option"},React.createElement("g",{"id":"box"},React.createElement("g",{"id":"content","transform":"translate(26.000000, 26.000000)"},React.createElement("path",{"d":"M33.9,0 C22.9,0 14,8.9 14,19.9 C14,30.9 22.9,39.8 33.9,39.8 C44.9,39.8 53.8,30.9 53.8,19.9 C53.7,8.9 44.8,0 33.9,0 Z M33.9,37.3 C24.3,37.3 16.5,29.5 16.5,19.9 C16.5,10.3 24.3,2.5 33.9,2.5 C43.5,2.5 51.3,10.3 51.3,19.9 C51.3,29.5 43.5,37.3 33.9,37.3 Z M43.8,25.1 C43.2,24.7 42.5,24.9 42.1,25.4 C40.2,28.2 37.2,29.8 33.8,29.8 C30.4,29.8 27.4,28.1 25.5,25.4 C25.1,24.8 24.3,24.7 23.8,25.1 C23.2,25.5 23.1,26.3 23.5,26.8 C25.8,30.3 29.7,32.3 33.8,32.3 C38,32.3 41.8,30.2 44.1,26.8 C44.6,26.2 44.4,25.5 43.8,25.1 Z M27.7,18.7 C30.1,18.7 32,16.7 32,14.4 C32,12.1 30,10.1 27.7,10.1 C25.3,10.1 23.4,12.1 23.4,14.4 C23.4,16.7 25.3,18.7 27.7,18.7 Z M27.7,12.4 C28.7,12.4 29.6,13.2 29.6,14.3 C29.6,15.4 28.8,16.2 27.7,16.2 C26.6,16.2 25.8,15.4 25.8,14.3 C25.8,13.2 26.6,12.4 27.7,12.4 Z M40.1,10 C37.7,10 35.8,12 35.8,14.3 C35.8,16.6 37.8,18.6 40.1,18.6 C42.4,18.6 44.4,16.6 44.4,14.3 C44.4,12 42.5,10 40.1,10 Z M40.1,16.2 C39.1,16.2 38.2,15.4 38.2,14.3 C38.2,13.2 39,12.4 40.1,12.4 C41.1,12.4 42,13.2 42,14.3 C42,15.4 41.1,16.2 40.1,16.2 Z","id":"simuladores/icons/ic-adulto"})))))))))]);
}

AdultoComponent.defaultProps = {"width":"40px","height":"40px","viewBox":"0 0 40 40","version":"1.1"};

module.exports = AdultoComponent;

AdultoComponent.default = AdultoComponent;


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1615);

if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(1430).enable();
  window.Promise = __webpack_require__(1429);
}

// fetch() polyfill for making API calls.
__webpack_require__(1679);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(21);



window.NodeList.prototype.forEach = Array.prototype.forEach

window.Node.prototype.contains = function contains(node) {
	if (!(0 in arguments)) {
		throw new TypeError('1 argument is required')
	}

	while (node = node && node.parentNode){
		if (this === node) {
			return true
		}
  }

	return false
};

if (!("classList" in SVGElement.prototype)) {
  Object.defineProperty(SVGElement.prototype, "classList", {
    get: function () {
      return {
        contains: function (className) {
          return this.className && this.className.baseVal.split(" ").indexOf(className) !== -1;
        }
      };
    }
  });
}


/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_idempotent_babel_polyfill__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_idempotent_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_idempotent_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_smoothscroll_polyfill__ = __webpack_require__(1618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_smoothscroll_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_smoothscroll_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routes__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__routesV2__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_flexbox_grid_dist_react_flexbox_grid_css__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_flexbox_grid_dist_react_flexbox_grid_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_flexbox_grid_dist_react_flexbox_grid_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dates_lib_css_datepicker_css__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dates_lib_css_datepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dates_lib_css_datepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_datetime_css_react_datetime_css__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_datetime_css_react_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_datetime_css_react_datetime_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_tooltip_assets_bootstrap_css__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_tooltip_assets_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_rc_tooltip_assets_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_css__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__index_css__);
global._babelPolyfill=false;// Smoothscroll polyfill
__WEBPACK_IMPORTED_MODULE_4_smoothscroll_polyfill___default.a.polyfill();// Sentry
if(true){var sentryConfig={name:"production"};var Raven=__webpack_require__(601);var LogRocket=__webpack_require__(586);LogRocket.init('cau4dx/poupaenergia');Raven.setDataCallback(function(data){data.extra.sessionURL=LogRocket.sessionURL;return data;});Raven.config(__WEBPACK_IMPORTED_MODULE_3_config__["a" /* SENTRY_URL */],sentryConfig).install();}// Render elements
var advanced=document.getElementById('adene-simulador-avancado');var simple=document.getElementById('adene-simulador-simples');var enterprise=document.getElementById('adene-simulador-empresarial');var home=document.getElementById('adene-simulador-home');var feedback=document.getElementById('adene-simulador-feedback');var rating=document.getElementById('adene-simulador-rating');// Renders the advanced simulator
if(advanced){__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__routes__["a" /* AdvancedRoutes */],null),advanced);if(false){module.hot.accept('./routes',function(){var Next=require('./routes').AdvancedRoutes;ReactDOM.render(React.createElement(Next,null),advanced);});}}// Renders the simple simulator
if(simple){__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__routesV2__["a" /* SimpleRoutesV2 */],null),simple);if(false){module.hot.accept('./routesV2',function(){var Next=require('./routesV2').SimpleRoutesV2;ReactDOM.render(React.createElement(Next,null),simple);});}}// Renders the simple simulator
if(enterprise){__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__routes__["b" /* EnterpriseRoutes */],null),enterprise);if(false){module.hot.accept('./routes',function(){var Next=require('./routes').EnterpriseRoutes;ReactDOM.render(React.createElement(Next,null),enterprise);});}}if(home){__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__routes__["c" /* HomeRoutes */],null),home);if(false){module.hot.accept('./routes',function(){var Next=require('./routes').HomeRoutes;ReactDOM.render(React.createElement(Next,null),home);});}}// Renders the standalone feedback survey (embeddable micro-service)
if(feedback){__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__routesV2__["b" /* FeedbackRoutes */],null),feedback);if(false){module.hot.accept('./routesV2',function(){var Next=require('./routesV2').FeedbackRoutes;ReactDOM.render(React.createElement(Next,null),feedback);});}}// Renders the standalone adhesion rating survey (embeddable micro-service)
if(rating){__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__routesV2__["c" /* RatingRoutes */],null),rating);if(false){module.hot.accept('./routesV2',function(){var Next=require('./routesV2').RatingRoutes;ReactDOM.render(React.createElement(Next,null),rating);});}}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(60)))

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(717);

var _global = _interopRequireDefault(__webpack_require__(975));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (_global.default._babelPolyfill && typeof console !== "undefined" && console.warn) {
  console.warn("@babel/polyfill is loaded more than once on this page. This is probably not desirable/intended " + "and may have consequences if different versions of the polyfills are applied sequentially. " + "If you do need to load the polyfill more than once, use @babel/polyfill/noConflict " + "instead to bypass the warning.");
}

_global.default._babelPolyfill = true;

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(961);

__webpack_require__(963);

__webpack_require__(962);

__webpack_require__(969);

__webpack_require__(968);

__webpack_require__(971);

__webpack_require__(970);

__webpack_require__(972);

__webpack_require__(965);

__webpack_require__(966);

__webpack_require__(964);

__webpack_require__(967);

__webpack_require__(1181);

__webpack_require__(718);

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; };
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) });

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: true });
  defineProperty(
    GeneratorFunctionPrototype,
    "constructor",
    { value: GeneratorFunction, configurable: true }
  );
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    defineProperty(this, "_invoke", { value: enqueue });
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method;
    var method = delegate.iterator[methodName];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method, or a missing .next mehtod, always terminate the
      // yield* loop.
      context.delegate = null;

      // Note: ["return"] must be used for ES3 parsing compatibility.
      if (methodName === "throw" && delegate.iterator["return"]) {
        // If the delegate iterator has a return method, give it a
        // chance to clean up.
        context.method = "return";
        context.arg = undefined;
        maybeInvokeDelegate(delegate, context);

        if (context.method === "throw") {
          // If maybeInvokeDelegate(context) changed context.method from
          // "return" to "throw", let that override the TypeError below.
          return ContinueSentinel;
        }
      }
      if (methodName !== "return") {
        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a '" + methodName + "' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(val) {
    var object = Object(val);
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : {}
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(720);
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 720 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 721 */
/***/ (function(module, exports) {

function _setPrototypeOf(t, e) {
  return module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _setPrototypeOf(t, e);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(220)["default"];
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SimpleButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SimpleArrowButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  vertical-align: middle;\n  ', '\n\n  ', '\n'], ['\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  vertical-align: middle;\n  ', '\n\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  ', '\n  border-width: 0px 3px 3px 0px;\n  display: inline-block;\n  padding: 3px;\n  \n  ', '\n\n  ', '\n  \n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n'], ['\n  ', '\n  border-width: 0px 3px 3px 0px;\n  display: inline-block;\n  padding: 3px;\n  \n  ', '\n\n  ', '\n  \n  ', '\n\n  ', '\n\n  ', '\n\n  ', '\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  padding: 18px;\n  outline: none;\n\tborder: 1px solid #DEDEDE;\n  background-color: #EFEFEF;\n  color: #676767;\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 19px;\n  transition: all .2s ease-in-out;\n  cursor: pointer;\n  text-align: center;\n  text-transform: uppercase;\n\n  &[disabled] {\n    color: #676767;\n    opacity: 0.4;\n    pointer-events: none;\n  }\n\n  &:focus,\n  &:hover,\n  &.active {\n    color: #93C13E;\n  }\n'], ['\n  padding: 18px;\n  outline: none;\n\tborder: 1px solid #DEDEDE;\n  background-color: #EFEFEF;\n  color: #676767;\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 19px;\n  transition: all .2s ease-in-out;\n  cursor: pointer;\n  text-align: center;\n  text-transform: uppercase;\n\n  &[disabled] {\n    color: #676767;\n    opacity: 0.4;\n    pointer-events: none;\n  }\n\n  &:focus,\n  &:hover,\n  &.active {\n    color: #93C13E;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }




var Icon = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].img(_templateObject, function (_ref) {
  var left = _ref.left;
  return left && '\n    margin-right: 8px;\n  ';
}, function (_ref2) {
  var right = _ref2.right;
  return right && '\n    margin-left: 8px;\n  ';
});

var Arrow = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject2, function (_ref3) {
  var strokeColor = _ref3.strokeColor;
  return strokeColor ? 'border: solid ' + strokeColor + ';' : 'border: solid black;';
}, function (_ref4) {
  var arrowLeft = _ref4.arrowLeft;
  return arrowLeft && '\n    -webkit-transform: rotate(135deg);\n    transform: rotate(135deg);\n  ';
}, function (_ref5) {
  var arrowRight = _ref5.arrowRight;
  return arrowRight && '\n    -webkit-transform: rotate(-45deg);\n    transform: rotate(-45deg);\n  ';
}, function (_ref6) {
  var arrowUp = _ref6.arrowUp;
  return arrowUp && '\n    -webkit-transform: rotate(-135deg);\n    transform: rotate(-135deg);\n    margin-bottom: -2px;\n  ';
}, function (_ref7) {
  var arrowDown = _ref7.arrowDown;
  return arrowDown && '\n    margin-bottom: 2px;\n    -webkit-transform: rotate(45deg);\n    transform: rotate(45deg);\n  ';
}, function (_ref8) {
  var left = _ref8.left;
  return left && ' \n    margin-right: 8px;\n  ';
}, function (_ref9) {
  var right = _ref9.right;
  return right && '\n    margin-left: 8px;\n  ';
});

var Simple = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].button(_templateObject3);

var SimpleButton = function SimpleButton(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Simple,
    props,
    props.left && props.icon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, { src: props.icon, left: true }),
    !props.right && !props.left && props.icon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, { src: props.icon, left: true }),
    props.children,
    props.right && props.icon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, { src: props.icon, right: true })
  );
};

var SimpleArrowButton = function SimpleArrowButton(props) {
  var _props = _extends({}, props);
  var _arrowProps = void 0;

  if (!_props.left && !_props.right) {
    _props.left = true;
  }

  if (!_props.arrowUp && !_props.arrowDown && !_props.arrowLeft && !_props.arrowRight) {
    _props.arrowLeft = true;
  }

  _arrowProps = _extends({}, _props);
  delete _arrowProps.children;
  delete _arrowProps.className;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Simple,
    _props,
    (_props.left || !_props.right && !_props.left) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Arrow, _arrowProps),
    _props.children,
    _props.right && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Arrow, _arrowProps)
  );
};



/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject = _taggedTemplateLiteralLoose(['\n  padding: 15px 16px;\n  outline: none;\n  border: 1px solid #EFEFEF;\n  background-color: #FFFFFF;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 19px;\n  color: #BABABA;\n  transition: all .2s ease-in-out;\n  background-position: 16px center;\n  background-repeat: no-repeat;\n  background-size: 16.5px;\n\n  &[disabled] {\n    background-color: transparent;\n    border: 0;\n    color: #676767;\n    opacity: 0.5;\n  }\n\n  &:focus {\n    border-color: #93C13E;\n  }\n\n  ', '\n  ', '\n'], ['\n  padding: 15px 16px;\n  outline: none;\n  border: 1px solid #EFEFEF;\n  background-color: #FFFFFF;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 19px;\n  color: #BABABA;\n  transition: all .2s ease-in-out;\n  background-position: 16px center;\n  background-repeat: no-repeat;\n  background-size: 16.5px;\n\n  &[disabled] {\n    background-color: transparent;\n    border: 0;\n    color: #676767;\n    opacity: 0.5;\n  }\n\n  &:focus {\n    border-color: #93C13E;\n  }\n\n  ', '\n  ', '\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }




var Input = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].input(_templateObject, function (props) {
  return props.icon ? 'background-image: url(' + props.icon + ');' : '';
}, function (props) {
  return props.icon ? 'padding-left: 40px' : '';
});

/* harmony default export */ __webpack_exports__["a"] = (Input);

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Icon */
/* unused harmony export Wrapper */
/* unused harmony export DefaultSelector */
/* unused harmony export DefaultList */
/* unused harmony export DefaultListOpened */
/* unused harmony export Item */
/* unused harmony export Checkbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isEqual__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isArray__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_map__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_remove__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_remove___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_remove__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_onclickoutside__ = __webpack_require__(275);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 35px;\n  height: 35px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 10px;\n'], ['\n  width: 35px;\n  height: 35px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 10px;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  max-width: 200px;\n'], ['\n  position: relative;\n  max-width: 200px;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  padding: 15px 16px;\n  font-size: 14px;\n  line-height: 18px;\n  font-weight: bold;\n  background-color: #FFFFFF;\n  color: #9C9C9C;\n  display: flex;\n  align-items: center;\n  background-position: right center;\n  background-repeat: no-repeat;\n  border: 1px solid #EFEFEF;\n  cursor: pointer;\n  position: relative;\n\n  &::after {\n    content: " ";\n    display: block;\n    background-image: url(', ');\n    background-size: contain;\n    width: 12px;\n    height: 12px;\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n    background-repeat: no-repeat;\n    background-position: center;\n\n    ', '\n  }\n\n  &.selected {\n    color: #3E3E3E;\n    font-weight: bold;\n  }\n\n  &[disabled] {\n    background-color: transparent;\n    border: 0;\n    color: #676767;\n    opacity: 0.5;\n    pointer-events: none;\n  }\n\n  &:focus {\n    border-color: #93C13E;\n  }\n\n  background-position: 16px center;\n  background-repeat: no-repeat;\n  background-size: 16.5px;\n\n  ', '\n  ', '\n'], ['\n  padding: 15px 16px;\n  font-size: 14px;\n  line-height: 18px;\n  font-weight: bold;\n  background-color: #FFFFFF;\n  color: #9C9C9C;\n  display: flex;\n  align-items: center;\n  background-position: right center;\n  background-repeat: no-repeat;\n  border: 1px solid #EFEFEF;\n  cursor: pointer;\n  position: relative;\n\n  &::after {\n    content: " ";\n    display: block;\n    background-image: url(', ');\n    background-size: contain;\n    width: 12px;\n    height: 12px;\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n    background-repeat: no-repeat;\n    background-position: center;\n\n    ', '\n  }\n\n  &.selected {\n    color: #3E3E3E;\n    font-weight: bold;\n  }\n\n  &[disabled] {\n    background-color: transparent;\n    border: 0;\n    color: #676767;\n    opacity: 0.5;\n    pointer-events: none;\n  }\n\n  &:focus {\n    border-color: #93C13E;\n  }\n\n  background-position: 16px center;\n  background-repeat: no-repeat;\n  background-size: 16.5px;\n\n  ', '\n  ', '\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  height: 0;\n  opacity: 0;\n  min-width: 198px;\n  max-height: 200px;\n  overflow: auto;\n  border: 1px solid #EFEFEF;\n  border-top: 0;\n  border-radius: 0 2px 2px 0;\n  box-shadow: 0 0 0 1px #EFEFEF;\n  transition: all .4s ease-in-out;\n  background: #FFF;\n  position: fixed;\n  z-index: 55;\n'], ['\n  height: 0;\n  opacity: 0;\n  min-width: 198px;\n  max-height: 200px;\n  overflow: auto;\n  border: 1px solid #EFEFEF;\n  border-top: 0;\n  border-radius: 0 2px 2px 0;\n  box-shadow: 0 0 0 1px #EFEFEF;\n  transition: all .4s ease-in-out;\n  background: #FFF;\n  position: fixed;\n  z-index: 55;\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n  height: auto;\n  opacity: 1;\n  transition: all .4s ease-in-out;\n'], ['\n  height: auto;\n  opacity: 1;\n  transition: all .4s ease-in-out;\n']),
    _templateObject6 = _taggedTemplateLiteralLoose(['\n  padding: 10px 15px;\n  transition: all .2s ease;\n  cursor: pointer;\n  user-select: none;\n  font-size: 14px;\n  white-space: nowrap;\n\n  &:hover {\n    background-color: #EFEFEF;\n  }\n'], ['\n  padding: 10px 15px;\n  transition: all .2s ease;\n  cursor: pointer;\n  user-select: none;\n  font-size: 14px;\n  white-space: nowrap;\n\n  &:hover {\n    background-color: #EFEFEF;\n  }\n']),
    _templateObject7 = _taggedTemplateLiteralLoose(['\n  border: 1px solid #BABABA;\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 10px;\n\n\n  ', '\n'], ['\n  border: 1px solid #BABABA;\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 10px;\n\n\n  ', '\n']),
    _templateObject8 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  width: 100%;\n'], ['\n  position: absolute;\n  width: 100%;\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











/**
 * Select component
 */

var Select = function (_Component) {
  _inherits(Select, _Component);

  function Select() {
    _classCallCheck(this, Select);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.state = {
      listOpened: false,
      selected: null
    };

    _this.toggleList = _this.toggleList.bind(_this);
    _this.setSelectedFromProp = _this.setSelectedFromProp.bind(_this);
    return _this;
  }

  Select.prototype.handleClickOutside = function handleClickOutside(evt) {
    if (this.state.listOpened) {
      this.setState({ listOpened: !this.state.listOpened });
    }
  };

  Select.prototype.setSelectedFromProp = function setSelectedFromProp(prop, first) {
    var _this2 = this;

    if (prop) {
      var selected = void 0;
      if (__WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(prop)) {
        selected = __WEBPACK_IMPORTED_MODULE_6_lodash_map___default()(prop, function (propValue) {
          return __WEBPACK_IMPORTED_MODULE_2_lodash_find___default()(_this2.props.items, function (_ref) {
            var value = _ref.value;
            return value === propValue;
          });
        });
      } else {
        selected = __WEBPACK_IMPORTED_MODULE_2_lodash_find___default()(this.props.items, function (_ref2) {
          var value = _ref2.value;
          return value === prop;
        });
      }

      if (selected) {
        this.setState({ selected: selected }, function () {

          if (__WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(selected)) {
            _this2.props.onChange && _this2.props.onChange(_this2.state.selected);
          } else {
            _this2.props.onChange && _this2.props.onChange(_extends({}, _this2.state.selected, { first: first }));
          }
        });
      }
    }

    if (prop === null) {
      this.setState({ selected: null });
    }
  };

  Select.prototype.componentWillMount = function componentWillMount() {
    this.setSelectedFromProp(this.props.selected, true);
  };

  Select.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.selected) {
      var findItem = __WEBPACK_IMPORTED_MODULE_2_lodash_find___default()(this.props.items, function (_ref3) {
        var value = _ref3.value;
        return value === nextProps.selected;
      });
      if (findItem) {
        if (__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default()(this.state.selected, findItem)) {
          return false;
        }
      }
      return true;
    }

    this.setSelectedFromProp(null);
  };

  Select.prototype.toggleList = function toggleList() {
    this.setState({ listOpened: !this.state.listOpened });
  };

  Select.prototype.selectItem = function selectItem(item) {
    var _this3 = this;

    this.setState({ selected: item, listOpened: false }, function () {
      _this3.props.onChange && _this3.props.onChange(_this3.state.selected);
    });
  };

  Select.prototype.selectItems = function selectItems(item) {
    var _this4 = this;

    var items = this.state.selected || [];

    var found = __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex___default()(items, function (i) {
      return i.value === item.value;
    });

    if (this.props.removedSelectOnSelected) {
      this.props.removedSelectOnSelected.forEach(function (v) {
        return __WEBPACK_IMPORTED_MODULE_7_lodash_remove___default()(items, { value: v });
      });
    }

    if (this.props.excludeAllExceptOnSelect) {
      var isExluder = this.props.excludeAllExceptOnSelect.find(function (it) {
        return it === item.value;
      });
      if (isExluder) {
        this.props.excludeAllExceptOnSelect.forEach(function (v) {
          return __WEBPACK_IMPORTED_MODULE_7_lodash_remove___default()(items, function (item) {
            return item.value !== v;
          });
        });
      }
    }

    if (found !== -1) {
      items = items.filter(function (item, index) {
        return index !== found;
      });
    } else {
      items.push(item);
    }

    this.setState({ selected: items }, function () {
      _this4.props.onChange && _this4.props.onChange(_this4.state.selected);
    });
  };

  Select.prototype.render = function render() {
    var _this5 = this;

    var _props = this.props,
        placeholder = _props.placeholder,
        Selector = _props.Selector,
        List = _props.List,
        children = _props.children,
        className = _props.className,
        items = _props.items,
        checkboxed = _props.checkboxed;


    var SelectorText = placeholder;

    // Set default
    if (!Selector) {
      Selector = DefaultSelector;
    }

    if (!List) {
      List = DefaultList;
    }

    if (this.state.listOpened) {
      List = DefaultListOpened;
    }

    if (this.state.selected) {
      if (this.state.selected.icon) {
        SelectorText = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, { src: this.state.selected.icon, alt: this.state.selected.label }),
          this.state.selected.label
        );
      } else {
        SelectorText = this.state.selected.label;
      }
    }

    var isChecked = function isChecked(_ref4) {
      var value = _ref4.value;

      if (_this5.state.selected) {
        if (__WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(_this5.state.selected)) {
          return __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex___default()(_this5.state.selected, function (i) {
            return i.value === value;
          }) !== -1;
        }
      } else {
        return _this5.state.selected === value;
      }
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Wrapper,
      { className: className },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Selector,
        {
          onClick: !this.props.disabled && this.toggleList,
          className: this.state.selected && 'selected',
          opened: this.state.listOpened,
          arrowIcon: this.props.arrowIcon,
          icon: this.props.icon,
          disabled: this.props.disabled },
        !checkboxed ? SelectorText : placeholder
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Absolute,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          List,
          null,
          items && items.map(function (item) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              Item,
              { key: 'item-' + item.value + item.label, onClick: function onClick() {
                  return !checkboxed ? _this5.selectItem(item) : _this5.selectItems(item);
                } },
              item.icon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, { src: item.icon }),
              checkboxed ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Checkbox, { checked: isChecked(item) }) : '',
              item.label
            );
          })
        )
      )
    );
  };

  return Select;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_onclickoutside__["a" /* default */])(Select));

var Icon = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].img(_templateObject);

var Wrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2);

var DefaultSelector = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject3, function (_ref5) {
  var arrowIcon = _ref5.arrowIcon;
  return arrowIcon;
}, function (props) {
  return props.opened && '\n      transform: translateY(-50%)rotate(180deg);\n    ';
}, function (props) {
  return props.icon ? 'background-image: url(' + props.icon + ');' : '';
}, function (props) {
  return props.icon ? 'padding-left: 40px' : '';
});

var DefaultList = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject4);

var DefaultListOpened = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(DefaultList)(_templateObject5);

var Item = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject6);

var Checkbox = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject7, function (props) {
  return props.checked ? '\n    &:after {\n      content: "\u2713";\n      color: #93C13E;\n      display: block;\n      width: 18px;\n      font-size: 18px;\n      text-align: center;\n      line-height: 18px;\n    }\n  ' : '';
});

var Absolute = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject8);

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject = _taggedTemplateLiteralLoose(['\n  box-shadow: 0 0 6px 0 rgba(0,0,0,0.1);\n  background-color: #FFFFFF;\n'], ['\n  box-shadow: 0 0 6px 0 rgba(0,0,0,0.1);\n  background-color: #FFFFFF;\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }




var ShadowBox = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject);

/* harmony default export */ __webpack_exports__["a"] = (ShadowBox);

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * base event object for custom and dom event.
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, "__esModule", {
  value: true
});
function returnFalse() {
  return false;
}

function returnTrue() {
  return true;
}

function EventBaseObject() {
  this.timeStamp = Date.now();
  this.target = undefined;
  this.currentTarget = undefined;
}

EventBaseObject.prototype = {
  isEventObject: 1,

  constructor: EventBaseObject,

  isDefaultPrevented: returnFalse,

  isPropagationStopped: returnFalse,

  isImmediatePropagationStopped: returnFalse,

  preventDefault: function preventDefault() {
    this.isDefaultPrevented = returnTrue;
  },

  stopPropagation: function stopPropagation() {
    this.isPropagationStopped = returnTrue;
  },

  stopImmediatePropagation: function stopImmediatePropagation() {
    this.isImmediatePropagationStopped = returnTrue;
    // fixed 1.2
    // call stopPropagation implicitly
    this.stopPropagation();
  },

  halt: function halt(immediate) {
    if (immediate) {
      this.stopImmediatePropagation();
    } else {
      this.stopPropagation();
    }
    this.preventDefault();
  }
};

exports["default"] = EventBaseObject;
module.exports = exports["default"];

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * event object for dom
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventBaseObject = __webpack_require__(727);

var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);

var _objectAssign = __webpack_require__(21);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var TRUE = true;
var FALSE = false;
var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];

function isNullOrUndefined(w) {
  return w === null || w === undefined;
}

var eventNormalizers = [{
  reg: /^key/,
  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
  fix: function fix(event, nativeEvent) {
    if (isNullOrUndefined(event.which)) {
      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
    }

    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
    if (event.metaKey === undefined) {
      event.metaKey = event.ctrlKey;
    }
  }
}, {
  reg: /^touch/,
  props: ['touches', 'changedTouches', 'targetTouches']
}, {
  reg: /^hashchange$/,
  props: ['newURL', 'oldURL']
}, {
  reg: /^gesturechange$/i,
  props: ['rotation', 'scale']
}, {
  reg: /^(mousewheel|DOMMouseScroll)$/,
  props: [],
  fix: function fix(event, nativeEvent) {
    var deltaX = undefined;
    var deltaY = undefined;
    var delta = undefined;
    var wheelDelta = nativeEvent.wheelDelta;
    var axis = nativeEvent.axis;
    var wheelDeltaY = nativeEvent.wheelDeltaY;
    var wheelDeltaX = nativeEvent.wheelDeltaX;
    var detail = nativeEvent.detail;

    // ie/webkit
    if (wheelDelta) {
      delta = wheelDelta / 120;
    }

    // gecko
    if (detail) {
      // press control e.detail == 1 else e.detail == 3
      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
    }

    // Gecko
    if (axis !== undefined) {
      if (axis === event.HORIZONTAL_AXIS) {
        deltaY = 0;
        deltaX = 0 - delta;
      } else if (axis === event.VERTICAL_AXIS) {
        deltaX = 0;
        deltaY = delta;
      }
    }

    // Webkit
    if (wheelDeltaY !== undefined) {
      deltaY = wheelDeltaY / 120;
    }
    if (wheelDeltaX !== undefined) {
      deltaX = -1 * wheelDeltaX / 120;
    }

    // 默认 deltaY (ie)
    if (!deltaX && !deltaY) {
      deltaY = delta;
    }

    if (deltaX !== undefined) {
      /**
       * deltaX of mousewheel event
       * @property deltaX
       * @member Event.DomEvent.Object
       */
      event.deltaX = deltaX;
    }

    if (deltaY !== undefined) {
      /**
       * deltaY of mousewheel event
       * @property deltaY
       * @member Event.DomEvent.Object
       */
      event.deltaY = deltaY;
    }

    if (delta !== undefined) {
      /**
       * delta of mousewheel event
       * @property delta
       * @member Event.DomEvent.Object
       */
      event.delta = delta;
    }
  }
}, {
  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
  fix: function fix(event, nativeEvent) {
    var eventDoc = undefined;
    var doc = undefined;
    var body = undefined;
    var target = event.target;
    var button = nativeEvent.button;

    // Calculate pageX/Y if missing and clientX/Y available
    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
      eventDoc = target.ownerDocument || document;
      doc = eventDoc.documentElement;
      body = eventDoc.body;
      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
    }

    // which for click: 1 === left; 2 === middle; 3 === right
    // do not use button
    if (!event.which && button !== undefined) {
      if (button & 1) {
        event.which = 1;
      } else if (button & 2) {
        event.which = 3;
      } else if (button & 4) {
        event.which = 2;
      } else {
        event.which = 0;
      }
    }

    // add relatedTarget, if necessary
    if (!event.relatedTarget && event.fromElement) {
      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
    }

    return event;
  }
}];

function retTrue() {
  return TRUE;
}

function retFalse() {
  return FALSE;
}

function DomEventObject(nativeEvent) {
  var type = nativeEvent.type;

  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';

  _EventBaseObject2['default'].call(this);

  this.nativeEvent = nativeEvent;

  // in case dom event has been mark as default prevented by lower dom node
  var isDefaultPrevented = retFalse;
  if ('defaultPrevented' in nativeEvent) {
    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
  } else if ('getPreventDefault' in nativeEvent) {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
  } else if ('returnValue' in nativeEvent) {
    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
  }

  this.isDefaultPrevented = isDefaultPrevented;

  var fixFns = [];
  var fixFn = undefined;
  var l = undefined;
  var prop = undefined;
  var props = commonProps.concat();

  eventNormalizers.forEach(function (normalizer) {
    if (type.match(normalizer.reg)) {
      props = props.concat(normalizer.props);
      if (normalizer.fix) {
        fixFns.push(normalizer.fix);
      }
    }
  });

  l = props.length;

  // clone properties of the original event object
  while (l) {
    prop = props[--l];
    this[prop] = nativeEvent[prop];
  }

  // fix target property, if necessary
  if (!this.target && isNative) {
    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
  }

  // check if target is a text node (safari)
  if (this.target && this.target.nodeType === 3) {
    this.target = this.target.parentNode;
  }

  l = fixFns.length;

  while (l) {
    fixFn = fixFns[--l];
    fixFn(this, nativeEvent);
  }

  this.timeStamp = nativeEvent.timeStamp || Date.now();
}

var EventBaseObjectProto = _EventBaseObject2['default'].prototype;

(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
  constructor: DomEventObject,

  preventDefault: function preventDefault() {
    var e = this.nativeEvent;

    // if preventDefault exists run it on the original event
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      // otherwise set the returnValue property of the original event to FALSE (IE)
      e.returnValue = FALSE;
    }

    EventBaseObjectProto.preventDefault.call(this);
  },

  stopPropagation: function stopPropagation() {
    var e = this.nativeEvent;

    // if stopPropagation exists run it on the original event
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      // otherwise set the cancelBubble property of the original event to TRUE (IE)
      e.cancelBubble = TRUE;
    }

    EventBaseObjectProto.stopPropagation.call(this);
  }
});

exports['default'] = DomEventObject;
module.exports = exports['default'];

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = addEventListener;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventObject = __webpack_require__(728);

var _EventObject2 = _interopRequireDefault(_EventObject);

function addEventListener(target, eventType, callback, option) {
  function wrapCallback(e) {
    var ne = new _EventObject2['default'](e);
    callback.call(target, ne);
  }

  if (target.addEventListener) {
    var _ret = (function () {
      var useCapture = false;
      if (typeof option === 'object') {
        useCapture = option.capture || false;
      } else if (typeof option === 'boolean') {
        useCapture = option;
      }

      target.addEventListener(eventType, wrapCallback, option || false);

      return {
        v: {
          remove: function remove() {
            target.removeEventListener(eventType, wrapCallback, useCapture);
          }
        }
      };
    })();

    if (typeof _ret === 'object') return _ret.v;
  } else if (target.attachEvent) {
    target.attachEvent('on' + eventType, wrapCallback);
    return {
      remove: function remove() {
        target.detachEvent('on' + eventType, wrapCallback);
      }
    };
  }
}

module.exports = exports['default'];

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function noop() {
  return null;
}

noop.isRequired = noop;

function noopThunk() {
  return noop;
}

module.exports = {
  and: noopThunk,
  between: noopThunk,
  booleanSome: noopThunk,
  childrenHavePropXorChildren: noopThunk,
  childrenOf: noopThunk,
  childrenOfType: noopThunk,
  childrenSequenceOf: noopThunk,
  componentWithName: noopThunk,
  disallowedIf: noopThunk,
  elementType: noopThunk,
  empty: noopThunk,
  explicitNull: noopThunk,
  forbidExtraProps: Object,
  integer: noopThunk,
  keysOf: noopThunk,
  mutuallyExclusiveProps: noopThunk,
  mutuallyExclusiveTrueProps: noopThunk,
  nChildren: noopThunk,
  nonNegativeInteger: noop,
  nonNegativeNumber: noopThunk,
  numericString: noopThunk,
  object: noopThunk,
  or: noopThunk,
  predicate: noopThunk,
  range: noopThunk,
  ref: noopThunk,
  requiredBy: noopThunk,
  restrictedProp: noopThunk,
  sequenceOf: noopThunk,
  shape: noopThunk,
  stringEndsWith: noopThunk,
  stringStartsWith: noopThunk,
  uniqueArray: noopThunk,
  uniqueArrayOf: noopThunk,
  valuesOf: noopThunk,
  withShape: noopThunk
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(427);

var _react2 = _interopRequireDefault(_react);

var _Utils = __webpack_require__(421);

var Utils = _interopRequireWildcard(_Utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StackAnimates = function (_PureComponent) {
  _inherits(StackAnimates, _PureComponent);

  function StackAnimates(props) {
    _classCallCheck(this, StackAnimates);

    var _this = _possibleConstructorReturn(this, (StackAnimates.__proto__ || Object.getPrototypeOf(StackAnimates)).call(this, props));

    _this.state = Utils.buildState(props);
    return _this;
  }

  _createClass(StackAnimates, [{
    key: 'renderNextAnimate',
    value: function renderNextAnimate() {
      var _this2 = this;

      if (this.HaveMoreAnimations) {
        setTimeout(function () {
          _this2.setState(Utils.buildState(_this2.props, _this2.getNextIndex), function () {
            return _this2.renderNextAnimate();
          });
        }, this.getNextStartTime);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var Animation = this.state.Animation;


      return _react2.default.createElement(
        Animation,
        this.state,
        this.props.children
      );
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.renderNextAnimate();
    }
  }, {
    key: 'getNextIndex',
    get: function get() {
      return this.state.index + 1;
    }
  }, {
    key: 'getNextStartTime',
    get: function get() {
      var time = Utils.convertToMs(parseFloat(Utils.removeUnit(this.state.duration)));
      var delay = Utils.convertToMs(parseFloat(Utils.removeUnit(this.state.delay)));
      return time + delay;
    }
  }, {
    key: 'HaveMoreAnimations',
    get: function get() {
      return this.getNextIndex < this.props.Animation.length;
    }
  }]);

  return StackAnimates;
}(_react.PureComponent);

exports.default = StackAnimates;

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(427);

var _react2 = _interopRequireDefault(_react);

var _Utils = __webpack_require__(421);

var Utils = _interopRequireWildcard(_Utils);

var _StackAnimates = __webpack_require__(731);

var _StackAnimates2 = _interopRequireDefault(_StackAnimates);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Animate = function (_PureComponent) {
  _inherits(Animate, _PureComponent);

  function Animate() {
    _classCallCheck(this, Animate);

    return _possibleConstructorReturn(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).apply(this, arguments));
  }

  _createClass(Animate, [{
    key: 'render',
    value: function render() {
      var Animation = this.props.Animation;


      if (Utils.isArray(Animation)) {
        return _react2.default.createElement(_StackAnimates2.default, this.props);
      }

      return _react2.default.createElement(
        Animation,
        this.props,
        this.props.children
      );
    }
  }]);

  return Animate;
}(_react.PureComponent);

exports.default = Animate;

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from, 50%, to {\n     opacity: 1;\n   }\n\n   25%, 75% {\n     opacity: 0;\n   }\n'], ['\n  from, 50%, to {\n     opacity: 1;\n   }\n\n   25%, 75% {\n     opacity: 0;\n   }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var flashAnimation = (0, _styledComponents.keyframes)(_templateObject);

var Flash = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, flashAnimation);

exports.default = Flash;

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  0% {\n     transform: translateX(0);\n   }\n\n   6.5% {\n     transform: translateX(-6px) rotateY(-9deg);\n   }\n\n   18.5% {\n     transform: translateX(5px) rotateY(7deg);\n   }\n\n   31.5% {\n     transform: translateX(-3px) rotateY(-5deg);\n   }\n\n   43.5% {\n     transform: translateX(2px) rotateY(3deg);\n   }\n\n   50% {\n     transform: translateX(0);\n   }\n'], ['\n  0% {\n     transform: translateX(0);\n   }\n\n   6.5% {\n     transform: translateX(-6px) rotateY(-9deg);\n   }\n\n   18.5% {\n     transform: translateX(5px) rotateY(7deg);\n   }\n\n   31.5% {\n     transform: translateX(-3px) rotateY(-5deg);\n   }\n\n   43.5% {\n     transform: translateX(2px) rotateY(3deg);\n   }\n\n   50% {\n     transform: translateX(0);\n   }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n  animation-timing-function: ease-in-out;\n'], ['\n  animation-name: ', ';\n  animation-timing-function: ease-in-out;\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var HeadShakeAnimation = (0, _styledComponents.keyframes)(_templateObject);

var HeadShake = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, HeadShakeAnimation);

exports.default = HeadShake;

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from, 11.1%, to {\n     transform: none;\n   }\n\n   22.2% {\n     transform: skewX(-12.5deg) skewY(-12.5deg);\n   }\n\n   33.3% {\n     transform: skewX(6.25deg) skewY(6.25deg);\n   }\n\n   44.4% {\n     transform: skewX(-3.125deg) skewY(-3.125deg);\n   }\n\n   55.5% {\n     transform: skewX(1.5625deg) skewY(1.5625deg);\n   }\n\n   66.6% {\n     transform: skewX(-0.78125deg) skewY(-0.78125deg);\n   }\n\n   77.7% {\n     transform: skewX(0.390625deg) skewY(0.390625deg);\n   }\n\n   88.8% {\n     transform: skewX(-0.1953125deg) skewY(-0.1953125deg);\n   }\n'], ['\n  from, 11.1%, to {\n     transform: none;\n   }\n\n   22.2% {\n     transform: skewX(-12.5deg) skewY(-12.5deg);\n   }\n\n   33.3% {\n     transform: skewX(6.25deg) skewY(6.25deg);\n   }\n\n   44.4% {\n     transform: skewX(-3.125deg) skewY(-3.125deg);\n   }\n\n   55.5% {\n     transform: skewX(1.5625deg) skewY(1.5625deg);\n   }\n\n   66.6% {\n     transform: skewX(-0.78125deg) skewY(-0.78125deg);\n   }\n\n   77.7% {\n     transform: skewX(0.390625deg) skewY(0.390625deg);\n   }\n\n   88.8% {\n     transform: skewX(-0.1953125deg) skewY(-0.1953125deg);\n   }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n  transform-origin: center;\n'], ['\n  animation-name: ', ';\n  transform-origin: center;\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var jelloAnimation = (0, _styledComponents.keyframes)(_templateObject);

var Jello = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, jelloAnimation);

exports.default = Jello;

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n    transform: scale3d(1, 1, 1);\n  }\n\n  50% {\n    transform: scale3d(1.05, 1.05, 1.05);\n  }\n\n  to {\n    transform: scale3d(1, 1, 1);\n  }\n'], ['\n  from {\n    transform: scale3d(1, 1, 1);\n  }\n\n  50% {\n    transform: scale3d(1.05, 1.05, 1.05);\n  }\n\n  to {\n    transform: scale3d(1, 1, 1);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PulseAnimation = (0, _styledComponents.keyframes)(_templateObject);

var Pulse = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, PulseAnimation);

exports.default = Pulse;

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n      transform: scale3d(1, 1, 1);\n    }\n\n    30% {\n      transform: scale3d(1.25, 0.75, 1);\n    }\n\n    40% {\n      transform: scale3d(0.75, 1.25, 1);\n    }\n\n    50% {\n      transform: scale3d(1.15, 0.85, 1);\n    }\n\n    65% {\n      transform: scale3d(.95, 1.05, 1);\n    }\n\n    75% {\n      transform: scale3d(1.05, .95, 1);\n    }\n\n    to {\n      transform: scale3d(1, 1, 1);\n    }\n'], ['\n  from {\n      transform: scale3d(1, 1, 1);\n    }\n\n    30% {\n      transform: scale3d(1.25, 0.75, 1);\n    }\n\n    40% {\n      transform: scale3d(0.75, 1.25, 1);\n    }\n\n    50% {\n      transform: scale3d(1.15, 0.85, 1);\n    }\n\n    65% {\n      transform: scale3d(.95, 1.05, 1);\n    }\n\n    75% {\n      transform: scale3d(1.05, .95, 1);\n    }\n\n    to {\n      transform: scale3d(1, 1, 1);\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var RubberBandAnimation = (0, _styledComponents.keyframes)(_templateObject);

var RubberBand = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, RubberBandAnimation);

exports.default = RubberBand;

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from, to {\n   transform: translate3d(0, 0, 0);\n  }\n\n  10%, 30%, 50%, 70%, 90% {\n   transform: translate3d(-10px, 0, 0);\n  }\n\n  20%, 40%, 60%, 80% {\n   transform: translate3d(10px, 0, 0);\n  }\n'], ['\n  from, to {\n   transform: translate3d(0, 0, 0);\n  }\n\n  10%, 30%, 50%, 70%, 90% {\n   transform: translate3d(-10px, 0, 0);\n  }\n\n  20%, 40%, 60%, 80% {\n   transform: translate3d(10px, 0, 0);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ShakeAnimation = (0, _styledComponents.keyframes)(_templateObject);

var Shake = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, ShakeAnimation);

exports.default = Shake;

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  20% {\n    transform: rotate3d(0, 0, 1, 15deg);\n  }\n\n  40% {\n    transform: rotate3d(0, 0, 1, -10deg);\n  }\n\n  60% {\n    transform: rotate3d(0, 0, 1, 5deg);\n  }\n\n  80% {\n    transform: rotate3d(0, 0, 1, -5deg);\n  }\n\n  to {\n    transform: rotate3d(0, 0, 1, 0deg);\n  }\n'], ['\n  20% {\n    transform: rotate3d(0, 0, 1, 15deg);\n  }\n\n  40% {\n    transform: rotate3d(0, 0, 1, -10deg);\n  }\n\n  60% {\n    transform: rotate3d(0, 0, 1, 5deg);\n  }\n\n  80% {\n    transform: rotate3d(0, 0, 1, -5deg);\n  }\n\n  to {\n    transform: rotate3d(0, 0, 1, 0deg);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n  transform-origin: top center;\n'], ['\n  animation-name: ', ';\n  transform-origin: top center;\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SwingAnimation = (0, _styledComponents.keyframes)(_templateObject);

var Swing = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, SwingAnimation);

exports.default = Swing;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n    transform: scale3d(1, 1, 1);\n  }\n\n  10%, 20% {\n    transform: scale3d(.9, .9, .9) rotate3d(0, 0, 1, -3deg);\n  }\n\n  30%, 50%, 70%, 90% {\n    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);\n  }\n\n  40%, 60%, 80% {\n    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);\n  }\n\n  to {\n    transform: scale3d(1, 1, 1);\n  }\n'], ['\n  from {\n    transform: scale3d(1, 1, 1);\n  }\n\n  10%, 20% {\n    transform: scale3d(.9, .9, .9) rotate3d(0, 0, 1, -3deg);\n  }\n\n  30%, 50%, 70%, 90% {\n    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);\n  }\n\n  40%, 60%, 80% {\n    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);\n  }\n\n  to {\n    transform: scale3d(1, 1, 1);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TadaAnimation = (0, _styledComponents.keyframes)(_templateObject);

var Tada = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, TadaAnimation);

exports.default = Tada;

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n    transform: none;\n  }\n\n  15% {\n    transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);\n  }\n\n  30% {\n    transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);\n  }\n\n  45% {\n    transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);\n  }\n\n  60% {\n    transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);\n  }\n\n  75% {\n    transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);\n  }\n\n  to {\n    transform: none;\n  }\n'], ['\n  from {\n    transform: none;\n  }\n\n  15% {\n    transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);\n  }\n\n  30% {\n    transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);\n  }\n\n  45% {\n    transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);\n  }\n\n  60% {\n    transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);\n  }\n\n  75% {\n    transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);\n  }\n\n  to {\n    transform: none;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var WobbleAnimation = (0, _styledComponents.keyframes)(_templateObject);

var Wobble = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, WobbleAnimation);

exports.default = Wobble;

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from, 20%, 40%, 60%, 80%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n  }\n\n  0% {\n    opacity: 0;\n    transform: scale3d(.3, .3, .3);\n  }\n\n  20% {\n    transform: scale3d(1.1, 1.1, 1.1);\n  }\n\n  40% {\n    transform: scale3d(.9, .9, .9);\n  }\n\n  60% {\n    opacity: 1;\n    transform: scale3d(1.03, 1.03, 1.03);\n  }\n\n  80% {\n    transform: scale3d(.97, .97, .97);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale3d(1, 1, 1);\n  }\n'], ['\n  from, 20%, 40%, 60%, 80%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n  }\n\n  0% {\n    opacity: 0;\n    transform: scale3d(.3, .3, .3);\n  }\n\n  20% {\n    transform: scale3d(1.1, 1.1, 1.1);\n  }\n\n  40% {\n    transform: scale3d(.9, .9, .9);\n  }\n\n  60% {\n    opacity: 1;\n    transform: scale3d(1.03, 1.03, 1.03);\n  }\n\n  80% {\n    transform: scale3d(.97, .97, .97);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale3d(1, 1, 1);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var bounceInAnimation = (0, _styledComponents.keyframes)(_templateObject);

var BounceIn = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, bounceInAnimation);

exports.default = BounceIn;

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n  }\n\n  0% {\n    opacity: 0;\n    transform: translate3d(0, -3000px, 0);\n  }\n\n  60% {\n    opacity: 1;\n    transform: translate3d(0, 25px, 0);\n  }\n\n  75% {\n    transform: translate3d(0, -10px, 0);\n  }\n\n  90% {\n    transform: translate3d(0, 5px, 0);\n  }\n\n  to {\n    transform: none;\n  }\n'], ['\n  from, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n  }\n\n  0% {\n    opacity: 0;\n    transform: translate3d(0, -3000px, 0);\n  }\n\n  60% {\n    opacity: 1;\n    transform: translate3d(0, 25px, 0);\n  }\n\n  75% {\n    transform: translate3d(0, -10px, 0);\n  }\n\n  90% {\n    transform: translate3d(0, 5px, 0);\n  }\n\n  to {\n    transform: none;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var bounceInDownAnimation = (0, _styledComponents.keyframes)(_templateObject);

var BounceInDown = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, bounceInDownAnimation);

exports.default = BounceInDown;

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from, 60%, 75%, 90%, to {\n   animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n  }\n\n  0% {\n   opacity: 0;\n   transform: translate3d(-3000px, 0, 0);\n  }\n\n  60% {\n   opacity: 1;\n   transform: translate3d(25px, 0, 0);\n  }\n\n  75% {\n   transform: translate3d(-10px, 0, 0);\n  }\n\n  90% {\n   transform: translate3d(5px, 0, 0);\n  }\n\n  to {\n   transform: none;\n  }\n'], ['\n  from, 60%, 75%, 90%, to {\n   animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n  }\n\n  0% {\n   opacity: 0;\n   transform: translate3d(-3000px, 0, 0);\n  }\n\n  60% {\n   opacity: 1;\n   transform: translate3d(25px, 0, 0);\n  }\n\n  75% {\n   transform: translate3d(-10px, 0, 0);\n  }\n\n  90% {\n   transform: translate3d(5px, 0, 0);\n  }\n\n  to {\n   transform: none;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var bounceInLeftAnimation = (0, _styledComponents.keyframes)(_templateObject);

var BounceInLeft = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, bounceInLeftAnimation);

exports.default = BounceInLeft;

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from, 60%, 75%, 90%, to {\n     animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n   }\n\n   from {\n     opacity: 0;\n     transform: translate3d(3000px, 0, 0);\n   }\n\n   60% {\n     opacity: 1;\n     transform: translate3d(-25px, 0, 0);\n   }\n\n   75% {\n     transform: translate3d(10px, 0, 0);\n   }\n\n   90% {\n     transform: translate3d(-5px, 0, 0);\n   }\n\n   to {\n     transform: none;\n   }\n'], ['\n  from, 60%, 75%, 90%, to {\n     animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n   }\n\n   from {\n     opacity: 0;\n     transform: translate3d(3000px, 0, 0);\n   }\n\n   60% {\n     opacity: 1;\n     transform: translate3d(-25px, 0, 0);\n   }\n\n   75% {\n     transform: translate3d(10px, 0, 0);\n   }\n\n   90% {\n     transform: translate3d(-5px, 0, 0);\n   }\n\n   to {\n     transform: none;\n   }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var bounceInRightAnimation = (0, _styledComponents.keyframes)(_templateObject);

var BounceInRight = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, bounceInRightAnimation);

exports.default = BounceInRight;

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n  }\n\n  from {\n    opacity: 0;\n    transform: translate3d(0, 3000px, 0);\n  }\n\n  60% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n\n  75% {\n    transform: translate3d(0, 10px, 0);\n  }\n\n  90% {\n    transform: translate3d(0, -5px, 0);\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n'], ['\n  from, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n  }\n\n  from {\n    opacity: 0;\n    transform: translate3d(0, 3000px, 0);\n  }\n\n  60% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n\n  75% {\n    transform: translate3d(0, 10px, 0);\n  }\n\n  90% {\n    transform: translate3d(0, -5px, 0);\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var bounceInUpAnimation = (0, _styledComponents.keyframes)(_templateObject);

var BounceInUp = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, bounceInUpAnimation);

exports.default = BounceInUp;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  20% {\n   transform: scale3d(.9, .9, .9);\n  }\n\n  50%, 55% {\n   opacity: 1;\n   transform: scale3d(1.1, 1.1, 1.1);\n  }\n\n  to {\n   opacity: 0;\n   transform: scale3d(.3, .3, .3);\n  }\n'], ['\n  20% {\n   transform: scale3d(.9, .9, .9);\n  }\n\n  50%, 55% {\n   opacity: 1;\n   transform: scale3d(1.1, 1.1, 1.1);\n  }\n\n  to {\n   opacity: 0;\n   transform: scale3d(.3, .3, .3);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var bounceOutAnimation = (0, _styledComponents.keyframes)(_templateObject);

var BounceOut = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, bounceOutAnimation);

exports.default = BounceOut;

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  20% {\n    transform: translate3d(0, 10px, 0);\n  }\n\n  40%, 45% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0);\n  }\n'], ['\n  20% {\n    transform: translate3d(0, 10px, 0);\n  }\n\n  40%, 45% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var bounceOutDownAnimation = (0, _styledComponents.keyframes)(_templateObject);

var BounceOutDown = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, bounceOutDownAnimation);

exports.default = BounceOutDown;

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  20% {\n    opacity: 1;\n    transform: translate3d(20px, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0);\n  }\n'], ['\n  20% {\n    opacity: 1;\n    transform: translate3d(20px, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var bounceOutLeftAnimation = (0, _styledComponents.keyframes)(_templateObject);

var BounceOutLeft = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, bounceOutLeftAnimation);

exports.default = BounceOutLeft;

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  20% {\n    opacity: 1;\n    transform: translate3d(-20px, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(2000px, 0, 0);\n  }\n'], ['\n  20% {\n    opacity: 1;\n    transform: translate3d(-20px, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(2000px, 0, 0);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var bounceOutRightAnimation = (0, _styledComponents.keyframes)(_templateObject);

var BounceOutRight = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, bounceOutRightAnimation);

exports.default = BounceOutRight;

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  20% {\n    transform: translate3d(0, -10px, 0);\n  }\n\n  40%, 45% {\n    opacity: 1;\n    transform: translate3d(0, 20px, 0);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0);\n  }\n'], ['\n  20% {\n    transform: translate3d(0, -10px, 0);\n  }\n\n  40%, 45% {\n    opacity: 1;\n    transform: translate3d(0, 20px, 0);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var bounceOutUpAnimation = (0, _styledComponents.keyframes)(_templateObject);

var BounceOutUp = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, bounceOutUpAnimation);

exports.default = BounceOutUp;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from, 20%, 53%, 80%, to {\n   animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n   transform: translate3d(0,0,0);\n  }\n\n  40%, 43% {\n   animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);\n   transform: translate3d(0, -30px, 0);\n  }\n\n  70% {\n   animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);\n   transform: translate3d(0, -15px, 0);\n  }\n\n  90% {\n   transform: translate3d(0,-4px,0);\n  }\n'], ['\n  from, 20%, 53%, 80%, to {\n   animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n   transform: translate3d(0,0,0);\n  }\n\n  40%, 43% {\n   animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);\n   transform: translate3d(0, -30px, 0);\n  }\n\n  70% {\n   animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);\n   transform: translate3d(0, -15px, 0);\n  }\n\n  90% {\n   transform: translate3d(0,-4px,0);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var bounceAnimation = (0, _styledComponents.keyframes)(_templateObject);

var Bounce = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, bounceAnimation);

exports.default = Bounce;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  0% {\n    transform-origin: top left;\n    animation-timing-function: ease-in-out;\n  }\n\n  20%, 60% {\n    transform: rotate3d(0, 0, 1, 80deg);\n    transform-origin: top left;\n    animation-timing-function: ease-in-out;\n  }\n\n  40%, 80% {\n    transform: rotate3d(0, 0, 1, 60deg);\n    transform-origin: top left;\n    animation-timing-function: ease-in-out;\n    opacity: 1;\n  }\n\n  to {\n    transform: translate3d(0, 700px, 0);\n    opacity: 0;\n  }\n'], ['\n  0% {\n    transform-origin: top left;\n    animation-timing-function: ease-in-out;\n  }\n\n  20%, 60% {\n    transform: rotate3d(0, 0, 1, 80deg);\n    transform-origin: top left;\n    animation-timing-function: ease-in-out;\n  }\n\n  40%, 80% {\n    transform: rotate3d(0, 0, 1, 60deg);\n    transform-origin: top left;\n    animation-timing-function: ease-in-out;\n    opacity: 1;\n  }\n\n  to {\n    transform: translate3d(0, 700px, 0);\n    opacity: 0;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var HingeAnimation = (0, _styledComponents.keyframes)(_templateObject);

var Hinge = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, HingeAnimation);

exports.default = Hinge;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n      opacity: 0;\n      transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);\n    }\n\n    to {\n      opacity: 1;\n      transform: none;\n    }\n'], ['\n  from {\n      opacity: 0;\n      transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);\n    }\n\n    to {\n      opacity: 1;\n      transform: none;\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var RollInAnimation = (0, _styledComponents.keyframes)(_templateObject);

var RollIn = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, RollInAnimation);

exports.default = RollIn;

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg);\n  }\n'], ['\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var RollOutAnimation = (0, _styledComponents.keyframes)(_templateObject);

var RollOut = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, RollOutAnimation);

exports.default = RollOut;

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n'], ['\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FadeInAnimation = (0, _styledComponents.keyframes)(_templateObject);

var FadeIn = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, FadeInAnimation);

exports.default = FadeIn;

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n     opacity: 0;\n     transform: translate3d(0, -100%, 0);\n   }\n\n   to {\n     opacity: 1;\n     transform: none;\n   }\n'], ['\n  from {\n     opacity: 0;\n     transform: translate3d(0, -100%, 0);\n   }\n\n   to {\n     opacity: 1;\n     transform: none;\n   }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FadeInDownAnimation = (0, _styledComponents.keyframes)(_templateObject);

var FadeInDown = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, FadeInDownAnimation);

exports.default = FadeInDown;

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: none;\n  }\n'], ['\n  from {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: none;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FadeInDownBigAnimation = (0, _styledComponents.keyframes)(_templateObject);

var FadeInDownBig = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, FadeInDownBigAnimation);

exports.default = FadeInDownBig;

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n    opacity: 0;\n    transform: translate3d(-100%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: none;\n  }\n'], ['\n  from {\n    opacity: 0;\n    transform: translate3d(-100%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: none;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FadeInLeftAnimation = (0, _styledComponents.keyframes)(_templateObject);

var FadeInLeft = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, FadeInLeftAnimation);

exports.default = FadeInLeft;

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: none;\n  }\n'], ['\n  from {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: none;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FadeInLeftBigAnimation = (0, _styledComponents.keyframes)(_templateObject);

var FadeInLeftBig = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, FadeInLeftBigAnimation);

exports.default = FadeInLeftBig;

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n     opacity: 0;\n     transform: translate3d(100%, 0, 0);\n   }\n\n   to {\n     opacity: 1;\n     transform: none;\n   }\n'], ['\n  from {\n     opacity: 0;\n     transform: translate3d(100%, 0, 0);\n   }\n\n   to {\n     opacity: 1;\n     transform: none;\n   }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FadeInRightAnimation = (0, _styledComponents.keyframes)(_templateObject);

var FadeInRight = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, FadeInRightAnimation);

exports.default = FadeInRight;

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n   opacity: 0;\n   transform: translate3d(2000px, 0, 0);\n  }\n\n  to {\n   opacity: 1;\n   transform: none;\n  }\n'], ['\n  from {\n   opacity: 0;\n   transform: translate3d(2000px, 0, 0);\n  }\n\n  to {\n   opacity: 1;\n   transform: none;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FadeInRightBigAnimation = (0, _styledComponents.keyframes)(_templateObject);

var FadeInRightBig = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, FadeInRightBigAnimation);

exports.default = FadeInRightBig;

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n   opacity: 0;\n   transform: translate3d(0, 100%, 0);\n  }\n\n  to {\n   opacity: 1;\n   transform: none;\n  }\n'], ['\n  from {\n   opacity: 0;\n   transform: translate3d(0, 100%, 0);\n  }\n\n  to {\n   opacity: 1;\n   transform: none;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FadeInUpAnimation = (0, _styledComponents.keyframes)(_templateObject);

var FadeInUp = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, FadeInUpAnimation);

exports.default = FadeInUp;

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: none;\n  }\n'], ['\n  from {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: none;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FadeInUpBigAnimation = (0, _styledComponents.keyframes)(_templateObject);

var FadeInUpBig = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, FadeInUpBigAnimation);

exports.default = FadeInUpBig;

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n'], ['\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FadeOutAnimation = (0, _styledComponents.keyframes)(_templateObject);

var FadeOut = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, FadeOutAnimation);

exports.default = FadeOut;

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n     opacity: 1;\n   }\n\n   to {\n     opacity: 0;\n     transform: translate3d(0, 100%, 0);\n   }\n'], ['\n  from {\n     opacity: 1;\n   }\n\n   to {\n     opacity: 0;\n     transform: translate3d(0, 100%, 0);\n   }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FadeOutDownAnimation = (0, _styledComponents.keyframes)(_templateObject);

var FadeOutDown = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, FadeOutDownAnimation);

exports.default = FadeOutDown;

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n   opacity: 1;\n  }\n\n  to {\n   opacity: 0;\n   transform: translate3d(0, 2000px, 0);\n  }\n'], ['\n  from {\n   opacity: 1;\n  }\n\n  to {\n   opacity: 0;\n   transform: translate3d(0, 2000px, 0);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FadeOutDownBigAnimation = (0, _styledComponents.keyframes)(_templateObject);

var FadeOutDownBig = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, FadeOutDownBigAnimation);

exports.default = FadeOutDownBig;

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(-100%, 0, 0);\n  }\n'], ['\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(-100%, 0, 0);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FadeOutLeftAnimation = (0, _styledComponents.keyframes)(_templateObject);

var FadeOutLeft = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, FadeOutLeftAnimation);

exports.default = FadeOutLeft;

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0);\n  }\n'], ['\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FadeOutLeftBigAnimation = (0, _styledComponents.keyframes)(_templateObject);

var FadeOutLeftBig = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, FadeOutLeftBigAnimation);

exports.default = FadeOutLeftBig;

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(100%, 0, 0);\n  }\n'], ['\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(100%, 0, 0);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FadeOutRightAnimation = (0, _styledComponents.keyframes)(_templateObject);

var FadeOutRight = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, FadeOutRightAnimation);

exports.default = FadeOutRight;

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n   opacity: 1;\n  }\n\n  to {\n   opacity: 0;\n   transform: translate3d(2000px, 0, 0);\n  }\n'], ['\n  from {\n   opacity: 1;\n  }\n\n  to {\n   opacity: 0;\n   transform: translate3d(2000px, 0, 0);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FadeOutRightBigAnimation = (0, _styledComponents.keyframes)(_templateObject);

var FadeOutRightBig = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, FadeOutRightBigAnimation);

exports.default = FadeOutRightBig;

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n     opacity: 1;\n   }\n\n   to {\n     opacity: 0;\n     transform: translate3d(0, -100%, 0);\n   }\n'], ['\n  from {\n     opacity: 1;\n   }\n\n   to {\n     opacity: 0;\n     transform: translate3d(0, -100%, 0);\n   }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FadeOutUpAnimation = (0, _styledComponents.keyframes)(_templateObject);

var FadeOutUp = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, FadeOutUpAnimation);

exports.default = FadeOutUp;

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0);\n  }\n'], ['\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FadeOutUpBigAnimation = (0, _styledComponents.keyframes)(_templateObject);

var FadeOutUpBig = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, FadeOutUpBigAnimation);

exports.default = FadeOutUpBig;

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n      transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n      animation-timing-function: ease-in;\n      opacity: 0;\n    }\n\n    40% {\n      transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n      animation-timing-function: ease-in;\n    }\n\n    60% {\n      transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\n      opacity: 1;\n    }\n\n    80% {\n      transform: perspective(400px) rotate3d(1, 0, 0, -5deg);\n    }\n\n    to {\n      transform: perspective(400px);\n    }\n'], ['\n  from {\n      transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n      animation-timing-function: ease-in;\n      opacity: 0;\n    }\n\n    40% {\n      transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n      animation-timing-function: ease-in;\n    }\n\n    60% {\n      transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\n      opacity: 1;\n    }\n\n    80% {\n      transform: perspective(400px) rotate3d(1, 0, 0, -5deg);\n    }\n\n    to {\n      transform: perspective(400px);\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n  backface-visibility: visible !important;\n'], ['\n  animation-name: ', ';\n  backface-visibility: visible !important;\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FlipInXAnimation = (0, _styledComponents.keyframes)(_templateObject);

var FlipInX = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, FlipInXAnimation);

exports.default = FlipInX;

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n      transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n      animation-timing-function: ease-in;\n      opacity: 0;\n    }\n\n    40% {\n      transform: perspective(400px) rotate3d(0, 1, 0, -20deg);\n      animation-timing-function: ease-in;\n    }\n\n    60% {\n      transform: perspective(400px) rotate3d(0, 1, 0, 10deg);\n      opacity: 1;\n    }\n\n    80% {\n      transform: perspective(400px) rotate3d(0, 1, 0, -5deg);\n    }\n\n    to {\n      transform: perspective(400px);\n    }\n'], ['\n  from {\n      transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n      animation-timing-function: ease-in;\n      opacity: 0;\n    }\n\n    40% {\n      transform: perspective(400px) rotate3d(0, 1, 0, -20deg);\n      animation-timing-function: ease-in;\n    }\n\n    60% {\n      transform: perspective(400px) rotate3d(0, 1, 0, 10deg);\n      opacity: 1;\n    }\n\n    80% {\n      transform: perspective(400px) rotate3d(0, 1, 0, -5deg);\n    }\n\n    to {\n      transform: perspective(400px);\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n  backface-visibility: visible !important;\n'], ['\n  animation-name: ', ';\n  backface-visibility: visible !important;\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FlipInYAnimation = (0, _styledComponents.keyframes)(_templateObject);

var FlipInY = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, FlipInYAnimation);

exports.default = FlipInY;

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n    transform: perspective(400px);\n  }\n\n  30% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n    opacity: 1;\n  }\n\n  to {\n    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n    opacity: 0;\n  }\n'], ['\n  from {\n    transform: perspective(400px);\n  }\n\n  30% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n    opacity: 1;\n  }\n\n  to {\n    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n    opacity: 0;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n  backface-visibility: visible !important;\n'], ['\n  animation-name: ', ';\n  backface-visibility: visible !important;\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FlipOutXAnimation = (0, _styledComponents.keyframes)(_templateObject);

var FlipOutX = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, FlipOutXAnimation);

exports.default = FlipOutX;

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n    transform: perspective(400px);\n  }\n\n  30% {\n    transform: perspective(400px) rotate3d(0, 1, 0, -15deg);\n    opacity: 1;\n  }\n\n  to {\n    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n    opacity: 0;\n  }\n'], ['\n  from {\n    transform: perspective(400px);\n  }\n\n  30% {\n    transform: perspective(400px) rotate3d(0, 1, 0, -15deg);\n    opacity: 1;\n  }\n\n  to {\n    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n    opacity: 0;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n  backface-visibility: visible !important;\n'], ['\n  animation-name: ', ';\n  backface-visibility: visible !important;\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FlipOutYAnimation = (0, _styledComponents.keyframes)(_templateObject);

var FlipOutY = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, FlipOutYAnimation);

exports.default = FlipOutY;

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n    transform: perspective(400px) rotate3d(0, 1, 0, -360deg);\n    animation-timing-function: ease-out;\n  }\n\n  40% {\n    transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);\n    animation-timing-function: ease-out;\n  }\n\n  50% {\n    transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);\n    animation-timing-function: ease-in;\n  }\n\n  80% {\n    transform: perspective(400px) scale3d(.95, .95, .95);\n    animation-timing-function: ease-in;\n  }\n\n  to {\n    transform: perspective(400px);\n    animation-timing-function: ease-in;\n  }\n'], ['\n  from {\n    transform: perspective(400px) rotate3d(0, 1, 0, -360deg);\n    animation-timing-function: ease-out;\n  }\n\n  40% {\n    transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);\n    animation-timing-function: ease-out;\n  }\n\n  50% {\n    transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);\n    animation-timing-function: ease-in;\n  }\n\n  80% {\n    transform: perspective(400px) scale3d(.95, .95, .95);\n    animation-timing-function: ease-in;\n  }\n\n  to {\n    transform: perspective(400px);\n    animation-timing-function: ease-in;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n  backface-visibility: visible;\n'], ['\n  animation-name: ', ';\n  backface-visibility: visible;\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FlipAnimation = (0, _styledComponents.keyframes)(_templateObject);

var Flip = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, FlipAnimation);

exports.default = Flip;

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n    transform: translate3d(100%, 0, 0) skewX(-30deg);\n    opacity: 0;\n  }\n\n  60% {\n    transform: skewX(20deg);\n    opacity: 1;\n  }\n\n  80% {\n    transform: skewX(-5deg);\n    opacity: 1;\n  }\n\n  to {\n    transform: none;\n    opacity: 1;\n  }\n'], ['\n  from {\n    transform: translate3d(100%, 0, 0) skewX(-30deg);\n    opacity: 0;\n  }\n\n  60% {\n    transform: skewX(20deg);\n    opacity: 1;\n  }\n\n  80% {\n    transform: skewX(-5deg);\n    opacity: 1;\n  }\n\n  to {\n    transform: none;\n    opacity: 1;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n  animation-timing-function: ease-out;\n'], ['\n  animation-name: ', ';\n  animation-timing-function: ease-out;\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var LightSpeedInAnimation = (0, _styledComponents.keyframes)(_templateObject);

var LightSpeedIn = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, LightSpeedInAnimation);

exports.default = LightSpeedIn;

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n     opacity: 1;\n   }\n\n   to {\n     transform: translate3d(100%, 0, 0) skewX(30deg);\n     opacity: 0;\n   }\n'], ['\n  from {\n     opacity: 1;\n   }\n\n   to {\n     transform: translate3d(100%, 0, 0) skewX(30deg);\n     opacity: 0;\n   }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n  animation-timing-function: ease-in;\n'], ['\n  animation-name: ', ';\n  animation-timing-function: ease-in;\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var LightSpeedOutAnimation = (0, _styledComponents.keyframes)(_templateObject);

var LightSpeedOut = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, LightSpeedOutAnimation);

exports.default = LightSpeedOut;

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n    transform-origin: center;\n    transform: rotate3d(0, 0, 1, -200deg);\n    opacity: 0;\n  }\n\n  to {\n    transform-origin: center;\n    transform: none;\n    opacity: 1;\n  }\n'], ['\n  from {\n    transform-origin: center;\n    transform: rotate3d(0, 0, 1, -200deg);\n    opacity: 0;\n  }\n\n  to {\n    transform-origin: center;\n    transform: none;\n    opacity: 1;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var RotateInAnimation = (0, _styledComponents.keyframes)(_templateObject);

var RotateIn = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, RotateInAnimation);

exports.default = RotateIn;

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n      transform-origin: left bottom;\n      transform: rotate3d(0, 0, 1, -45deg);\n      opacity: 0;\n    }\n\n    to {\n      transform-origin: left bottom;\n      transform: none;\n      opacity: 1;\n    }\n'], ['\n  from {\n      transform-origin: left bottom;\n      transform: rotate3d(0, 0, 1, -45deg);\n      opacity: 0;\n    }\n\n    to {\n      transform-origin: left bottom;\n      transform: none;\n      opacity: 1;\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var RotateInDownLeftAnimation = (0, _styledComponents.keyframes)(_templateObject);

var RotateInDownLeft = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, RotateInDownLeftAnimation);

exports.default = RotateInDownLeft;

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n     transform-origin: right bottom;\n     transform: rotate3d(0, 0, 1, 45deg);\n     opacity: 0;\n   }\n\n   to {\n     transform-origin: right bottom;\n     transform: none;\n     opacity: 1;\n   }\n'], ['\n  from {\n     transform-origin: right bottom;\n     transform: rotate3d(0, 0, 1, 45deg);\n     opacity: 0;\n   }\n\n   to {\n     transform-origin: right bottom;\n     transform: none;\n     opacity: 1;\n   }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var RotateInDownRightAnimation = (0, _styledComponents.keyframes)(_templateObject);

var RotateInDownRight = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, RotateInDownRightAnimation);

exports.default = RotateInDownRight;

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n      transform-origin: left bottom;\n      transform: rotate3d(0, 0, 1, 45deg);\n      opacity: 0;\n    }\n\n    to {\n      transform-origin: left bottom;\n      transform: none;\n      opacity: 1;\n    }\n'], ['\n  from {\n      transform-origin: left bottom;\n      transform: rotate3d(0, 0, 1, 45deg);\n      opacity: 0;\n    }\n\n    to {\n      transform-origin: left bottom;\n      transform: none;\n      opacity: 1;\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var RotateInUpLeftAnimation = (0, _styledComponents.keyframes)(_templateObject);

var RotateInUpLeft = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, RotateInUpLeftAnimation);

exports.default = RotateInUpLeft;

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n    transform-origin: right bottom;\n    transform: rotate3d(0, 0, 1, -90deg);\n    opacity: 0;\n  }\n\n  to {\n    transform-origin: right bottom;\n    transform: none;\n    opacity: 1;\n  }\n'], ['\n  from {\n    transform-origin: right bottom;\n    transform: rotate3d(0, 0, 1, -90deg);\n    opacity: 0;\n  }\n\n  to {\n    transform-origin: right bottom;\n    transform: none;\n    opacity: 1;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var RotateInUpRightAnimation = (0, _styledComponents.keyframes)(_templateObject);

var RotateInUpRight = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, RotateInUpRightAnimation);

exports.default = RotateInUpRight;

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n      transform-origin: center;\n      opacity: 1;\n    }\n\n    to {\n      transform-origin: center;\n      transform: rotate3d(0, 0, 1, 200deg);\n      opacity: 0;\n    }\n'], ['\n  from {\n      transform-origin: center;\n      opacity: 1;\n    }\n\n    to {\n      transform-origin: center;\n      transform: rotate3d(0, 0, 1, 200deg);\n      opacity: 0;\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var RotateOutAnimation = (0, _styledComponents.keyframes)(_templateObject);

var RotateOut = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, RotateOutAnimation);

exports.default = RotateOut;

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n     transform-origin: left bottom;\n     opacity: 1;\n   }\n\n   to {\n     transform-origin: left bottom;\n     transform: rotate3d(0, 0, 1, 45deg);\n     opacity: 0;\n   }\n'], ['\n  from {\n     transform-origin: left bottom;\n     opacity: 1;\n   }\n\n   to {\n     transform-origin: left bottom;\n     transform: rotate3d(0, 0, 1, 45deg);\n     opacity: 0;\n   }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var RotateOutDownLeftAnimation = (0, _styledComponents.keyframes)(_templateObject);

var RotateOutDownLeft = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, RotateOutDownLeftAnimation);

exports.default = RotateOutDownLeft;

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n      transform-origin: right bottom;\n      opacity: 1;\n    }\n\n    to {\n      transform-origin: right bottom;\n      transform: rotate3d(0, 0, 1, -45deg);\n      opacity: 0;\n    }\n'], ['\n  from {\n      transform-origin: right bottom;\n      opacity: 1;\n    }\n\n    to {\n      transform-origin: right bottom;\n      transform: rotate3d(0, 0, 1, -45deg);\n      opacity: 0;\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var RotateOutDownRightAnimation = (0, _styledComponents.keyframes)(_templateObject);

var RotateOutDownRight = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, RotateOutDownRightAnimation);

exports.default = RotateOutDownRight;

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n    transform-origin: left bottom;\n    opacity: 1;\n  }\n\n  to {\n    transform-origin: left bottom;\n    transform: rotate3d(0, 0, 1, -45deg);\n    opacity: 0;\n  }\n'], ['\n  from {\n    transform-origin: left bottom;\n    opacity: 1;\n  }\n\n  to {\n    transform-origin: left bottom;\n    transform: rotate3d(0, 0, 1, -45deg);\n    opacity: 0;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var RotateOutUpLeftAnimation = (0, _styledComponents.keyframes)(_templateObject);

var RotateOutUpLeft = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, RotateOutUpLeftAnimation);

exports.default = RotateOutUpLeft;

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n      transform-origin: right bottom;\n      opacity: 1;\n    }\n\n    to {\n      transform-origin: right bottom;\n      transform: rotate3d(0, 0, 1, 90deg);\n      opacity: 0;\n    }\n'], ['\n  from {\n      transform-origin: right bottom;\n      opacity: 1;\n    }\n\n    to {\n      transform-origin: right bottom;\n      transform: rotate3d(0, 0, 1, 90deg);\n      opacity: 0;\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var RotateOutUpRightAnimation = (0, _styledComponents.keyframes)(_templateObject);

var RotateOutUpRight = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, RotateOutUpRightAnimation);

exports.default = RotateOutUpRight;

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n      transform: translate3d(0, -100%, 0);\n      visibility: visible;\n    }\n\n    to {\n      transform: translate3d(0, 0, 0);\n    }\n'], ['\n  from {\n      transform: translate3d(0, -100%, 0);\n      visibility: visible;\n    }\n\n    to {\n      transform: translate3d(0, 0, 0);\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SlideInDownAnimation = (0, _styledComponents.keyframes)(_templateObject);

var SlideInDown = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, SlideInDownAnimation);

exports.default = SlideInDown;

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n      transform: translate3d(-100%, 0, 0);\n      visibility: visible;\n    }\n\n    to {\n      transform: translate3d(0, 0, 0);\n    }\n'], ['\n  from {\n      transform: translate3d(-100%, 0, 0);\n      visibility: visible;\n    }\n\n    to {\n      transform: translate3d(0, 0, 0);\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SlideInLeftAnimation = (0, _styledComponents.keyframes)(_templateObject);

var SlideInLeft = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, SlideInLeftAnimation);

exports.default = SlideInLeft;

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n      transform: translate3d(100%, 0, 0);\n      visibility: visible;\n    }\n\n    to {\n      transform: translate3d(0, 0, 0);\n    }\n'], ['\n  from {\n      transform: translate3d(100%, 0, 0);\n      visibility: visible;\n    }\n\n    to {\n      transform: translate3d(0, 0, 0);\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SlideInRightAnimation = (0, _styledComponents.keyframes)(_templateObject);

var SlideInRight = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, SlideInRightAnimation);

exports.default = SlideInRight;

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n     transform: translate3d(0, 100%, 0);\n     visibility: visible;\n   }\n\n   to {\n     transform: translate3d(0, 0, 0);\n   }\n'], ['\n  from {\n     transform: translate3d(0, 100%, 0);\n     visibility: visible;\n   }\n\n   to {\n     transform: translate3d(0, 0, 0);\n   }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SlideInUpAnimation = (0, _styledComponents.keyframes)(_templateObject);

var SlideInUp = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, SlideInUpAnimation);

exports.default = SlideInUp;

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    visibility: hidden;\n    transform: translate3d(0, 100%, 0);\n  }\n'], ['\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    visibility: hidden;\n    transform: translate3d(0, 100%, 0);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SlideOutDownAnimation = (0, _styledComponents.keyframes)(_templateObject);

var SlideOutDown = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, SlideOutDownAnimation);

exports.default = SlideOutDown;

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n      transform: translate3d(0, 0, 0);\n    }\n\n    to {\n      visibility: hidden;\n      transform: translate3d(-100%, 0, 0);\n    }\n'], ['\n  from {\n      transform: translate3d(0, 0, 0);\n    }\n\n    to {\n      visibility: hidden;\n      transform: translate3d(-100%, 0, 0);\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SlideOutLeftAnimation = (0, _styledComponents.keyframes)(_templateObject);

var SlideOutLeft = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, SlideOutLeftAnimation);

exports.default = SlideOutLeft;

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n      transform: translate3d(0, 0, 0);\n    }\n\n    to {\n      visibility: hidden;\n      transform: translate3d(100%, 0, 0);\n    }\n'], ['\n  from {\n      transform: translate3d(0, 0, 0);\n    }\n\n    to {\n      visibility: hidden;\n      transform: translate3d(100%, 0, 0);\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SlideOutRightAnimation = (0, _styledComponents.keyframes)(_templateObject);

var SlideOutRight = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, SlideOutRightAnimation);

exports.default = SlideOutRight;

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n      transform: translate3d(0, 0, 0);\n    }\n\n    to {\n      visibility: hidden;\n      transform: translate3d(0, -100%, 0);\n    }\n'], ['\n  from {\n      transform: translate3d(0, 0, 0);\n    }\n\n    to {\n      visibility: hidden;\n      transform: translate3d(0, -100%, 0);\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SlideOutUpAnimation = (0, _styledComponents.keyframes)(_templateObject);

var SlideOutUp = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, SlideOutUpAnimation);

exports.default = SlideOutUp;

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n     opacity: 0;\n     transform: scale3d(.3, .3, .3);\n   }\n\n   50% {\n     opacity: 1;\n   }\n'], ['\n  from {\n     opacity: 0;\n     transform: scale3d(.3, .3, .3);\n   }\n\n   50% {\n     opacity: 1;\n   }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ZoomInAnimation = (0, _styledComponents.keyframes)(_templateObject);

var ZoomIn = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, ZoomInAnimation);

exports.default = ZoomIn;

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n     opacity: 0;\n     transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);\n     animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);\n   }\n\n   60% {\n     opacity: 1;\n     transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);\n     animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);\n   }\n'], ['\n  from {\n     opacity: 0;\n     transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);\n     animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);\n   }\n\n   60% {\n     opacity: 1;\n     transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);\n     animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);\n   }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ZoomInDownAnimation = (0, _styledComponents.keyframes)(_templateObject);

var ZoomInDown = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, ZoomInDownAnimation);

exports.default = ZoomInDown;

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n      opacity: 0;\n      transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);\n      animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);\n    }\n\n    60% {\n      opacity: 1;\n      transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);\n      animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);\n    }\n'], ['\n  from {\n      opacity: 0;\n      transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);\n      animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);\n    }\n\n    60% {\n      opacity: 1;\n      transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);\n      animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ZoomInLeftAnimation = (0, _styledComponents.keyframes)(_templateObject);

var ZoomInLeft = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, ZoomInLeftAnimation);

exports.default = ZoomInLeft;

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n      opacity: 0;\n      transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);\n      animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);\n    }\n\n    60% {\n      opacity: 1;\n      transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);\n      animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);\n    }\n'], ['\n  from {\n      opacity: 0;\n      transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);\n      animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);\n    }\n\n    60% {\n      opacity: 1;\n      transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);\n      animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ZoomInRightAnimation = (0, _styledComponents.keyframes)(_templateObject);

var ZoomInRight = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, ZoomInRightAnimation);

exports.default = ZoomInRight;

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n      opacity: 0;\n      transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);\n      animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);\n    }\n\n    60% {\n      opacity: 1;\n      transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);\n      animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);\n    }\n'], ['\n  from {\n      opacity: 0;\n      transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);\n      animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);\n    }\n\n    60% {\n      opacity: 1;\n      transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);\n      animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ZoomInUpAnimation = (0, _styledComponents.keyframes)(_templateObject);

var ZoomInUp = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, ZoomInUpAnimation);

exports.default = ZoomInUp;

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n   opacity: 1;\n  }\n\n  50% {\n   opacity: 0;\n   transform: scale3d(.3, .3, .3);\n  }\n\n  to {\n   opacity: 0;\n  }\n'], ['\n  from {\n   opacity: 1;\n  }\n\n  50% {\n   opacity: 0;\n   transform: scale3d(.3, .3, .3);\n  }\n\n  to {\n   opacity: 0;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ZoomOutAnimation = (0, _styledComponents.keyframes)(_templateObject);

var ZoomOut = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, ZoomOutAnimation);

exports.default = ZoomOut;

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  40% {\n      opacity: 1;\n      transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);\n      animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);\n    }\n\n    to {\n      opacity: 0;\n      transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);\n      transform-origin: center bottom;\n      animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);\n    }\n'], ['\n  40% {\n      opacity: 1;\n      transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);\n      animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);\n    }\n\n    to {\n      opacity: 0;\n      transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);\n      transform-origin: center bottom;\n      animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ZoomOutDownAnimation = (0, _styledComponents.keyframes)(_templateObject);

var ZoomOutDown = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, ZoomOutDownAnimation);

exports.default = ZoomOutDown;

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  40% {\n      opacity: 1;\n      transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0);\n    }\n\n    to {\n      opacity: 0;\n      transform: scale(.1) translate3d(-2000px, 0, 0);\n      transform-origin: left center;\n    }\n'], ['\n  40% {\n      opacity: 1;\n      transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0);\n    }\n\n    to {\n      opacity: 0;\n      transform: scale(.1) translate3d(-2000px, 0, 0);\n      transform-origin: left center;\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ZoomOutLeftAnimation = (0, _styledComponents.keyframes)(_templateObject);

var ZoomOutLeft = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, ZoomOutLeftAnimation);

exports.default = ZoomOutLeft;

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  40% {\n      opacity: 1;\n      transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0);\n    }\n\n    to {\n      opacity: 0;\n      transform: scale(.1) translate3d(2000px, 0, 0);\n      transform-origin: right center;\n    }\n'], ['\n  40% {\n      opacity: 1;\n      transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0);\n    }\n\n    to {\n      opacity: 0;\n      transform: scale(.1) translate3d(2000px, 0, 0);\n      transform-origin: right center;\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ZoomOutRightAnimation = (0, _styledComponents.keyframes)(_templateObject);

var ZoomOutRight = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, ZoomOutRightAnimation);

exports.default = ZoomOutRight;

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  40% {\n      opacity: 1;\n      transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);\n      animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);\n    }\n\n    to {\n      opacity: 0;\n      transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);\n      transform-origin: center bottom;\n      animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);\n    }\n'], ['\n  40% {\n      opacity: 1;\n      transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);\n      animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);\n    }\n\n    to {\n      opacity: 0;\n      transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);\n      transform-origin: center bottom;\n      animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ZoomOutUpAnimation = (0, _styledComponents.keyframes)(_templateObject);

var ZoomOutUp = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, ZoomOutUpAnimation);

exports.default = ZoomOutUp;

;

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseAnimation = exports.ZoomOutUp = exports.ZoomOutRight = exports.ZoomOutLeft = exports.ZoomOutDown = exports.ZoomOut = exports.ZoomInUp = exports.ZoomInRight = exports.ZoomInLeft = exports.ZoomInDown = exports.ZoomIn = exports.RollOut = exports.RollIn = exports.Hinge = exports.SlideOutUp = exports.SlideOutRight = exports.SlideOutLeft = exports.SlideOutDown = exports.SlideInUp = exports.SlideInRight = exports.SlideInLeft = exports.SlideInDown = exports.RotateOutUpRight = exports.RotateOutUpLeft = exports.RotateOutDownRight = exports.RotateOutDownLeft = exports.RotateOut = exports.RotateInUpRight = exports.RotateInUpLeft = exports.RotateInDownRight = exports.RotateInDownLeft = exports.RotateIn = exports.LightSpeedOut = exports.LightSpeedIn = exports.FlipOutY = exports.FlipOutX = exports.FlipInY = exports.FlipInX = exports.Flip = exports.FadeOutUpBig = exports.FadeOutUp = exports.FadeOutRightBig = exports.FadeOutRight = exports.FadeOutLeftBig = exports.FadeOutLeft = exports.FadeOutDownBig = exports.FadeOutDown = exports.FadeOut = exports.FadeInUpBig = exports.FadeInUp = exports.FadeInRightBig = exports.FadeInRight = exports.FadeInLeftBig = exports.FadeInLeft = exports.FadeInDownBig = exports.FadeInDown = exports.FadeIn = exports.BounceOutUp = exports.BounceOutRight = exports.BounceOutLeft = exports.BounceOutDown = exports.BounceOut = exports.BounceInRight = exports.BounceInLeft = exports.BounceInDown = exports.BounceInUp = exports.BounceIn = exports.Wobble = exports.Tada = exports.Swing = exports.Shake = exports.RubberBand = exports.Pulse = exports.Jello = exports.HeadShake = exports.Flash = exports.Bounce = undefined;

var _BaseAnimation = __webpack_require__(9);

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

var _Flash = __webpack_require__(733);

var _Flash2 = _interopRequireDefault(_Flash);

var _HeadShake = __webpack_require__(734);

var _HeadShake2 = _interopRequireDefault(_HeadShake);

var _Jello = __webpack_require__(735);

var _Jello2 = _interopRequireDefault(_Jello);

var _Pulse = __webpack_require__(736);

var _Pulse2 = _interopRequireDefault(_Pulse);

var _RubberBand = __webpack_require__(737);

var _RubberBand2 = _interopRequireDefault(_RubberBand);

var _Shake = __webpack_require__(738);

var _Shake2 = _interopRequireDefault(_Shake);

var _Swing = __webpack_require__(739);

var _Swing2 = _interopRequireDefault(_Swing);

var _Tada = __webpack_require__(740);

var _Tada2 = _interopRequireDefault(_Tada);

var _Wobble = __webpack_require__(741);

var _Wobble2 = _interopRequireDefault(_Wobble);

var _Bounce = __webpack_require__(752);

var _Bounce2 = _interopRequireDefault(_Bounce);

var _In = __webpack_require__(742);

var _In2 = _interopRequireDefault(_In);

var _InUp = __webpack_require__(746);

var _InUp2 = _interopRequireDefault(_InUp);

var _InDown = __webpack_require__(743);

var _InDown2 = _interopRequireDefault(_InDown);

var _InLeft = __webpack_require__(744);

var _InLeft2 = _interopRequireDefault(_InLeft);

var _InRight = __webpack_require__(745);

var _InRight2 = _interopRequireDefault(_InRight);

var _Out = __webpack_require__(747);

var _Out2 = _interopRequireDefault(_Out);

var _OutDown = __webpack_require__(748);

var _OutDown2 = _interopRequireDefault(_OutDown);

var _OutLeft = __webpack_require__(749);

var _OutLeft2 = _interopRequireDefault(_OutLeft);

var _OutRight = __webpack_require__(750);

var _OutRight2 = _interopRequireDefault(_OutRight);

var _OutUp = __webpack_require__(751);

var _OutUp2 = _interopRequireDefault(_OutUp);

var _In3 = __webpack_require__(756);

var _In4 = _interopRequireDefault(_In3);

var _InDown3 = __webpack_require__(757);

var _InDown4 = _interopRequireDefault(_InDown3);

var _InDownBig = __webpack_require__(758);

var _InDownBig2 = _interopRequireDefault(_InDownBig);

var _InLeft3 = __webpack_require__(759);

var _InLeft4 = _interopRequireDefault(_InLeft3);

var _InLeftBig = __webpack_require__(760);

var _InLeftBig2 = _interopRequireDefault(_InLeftBig);

var _InRight3 = __webpack_require__(761);

var _InRight4 = _interopRequireDefault(_InRight3);

var _InRightBig = __webpack_require__(762);

var _InRightBig2 = _interopRequireDefault(_InRightBig);

var _InUp3 = __webpack_require__(763);

var _InUp4 = _interopRequireDefault(_InUp3);

var _InUpBig = __webpack_require__(764);

var _InUpBig2 = _interopRequireDefault(_InUpBig);

var _Out3 = __webpack_require__(765);

var _Out4 = _interopRequireDefault(_Out3);

var _OutDown3 = __webpack_require__(766);

var _OutDown4 = _interopRequireDefault(_OutDown3);

var _OutDownBig = __webpack_require__(767);

var _OutDownBig2 = _interopRequireDefault(_OutDownBig);

var _OutLeft3 = __webpack_require__(768);

var _OutLeft4 = _interopRequireDefault(_OutLeft3);

var _OutLeftBig = __webpack_require__(769);

var _OutLeftBig2 = _interopRequireDefault(_OutLeftBig);

var _OutRight3 = __webpack_require__(770);

var _OutRight4 = _interopRequireDefault(_OutRight3);

var _OutRightBig = __webpack_require__(771);

var _OutRightBig2 = _interopRequireDefault(_OutRightBig);

var _OutUp3 = __webpack_require__(772);

var _OutUp4 = _interopRequireDefault(_OutUp3);

var _OutUpBig = __webpack_require__(773);

var _OutUpBig2 = _interopRequireDefault(_OutUpBig);

var _Flip = __webpack_require__(778);

var _Flip2 = _interopRequireDefault(_Flip);

var _InX = __webpack_require__(774);

var _InX2 = _interopRequireDefault(_InX);

var _InY = __webpack_require__(775);

var _InY2 = _interopRequireDefault(_InY);

var _OutX = __webpack_require__(776);

var _OutX2 = _interopRequireDefault(_OutX);

var _OutY = __webpack_require__(777);

var _OutY2 = _interopRequireDefault(_OutY);

var _In5 = __webpack_require__(779);

var _In6 = _interopRequireDefault(_In5);

var _Out5 = __webpack_require__(780);

var _Out6 = _interopRequireDefault(_Out5);

var _In7 = __webpack_require__(781);

var _In8 = _interopRequireDefault(_In7);

var _InDownLeft = __webpack_require__(782);

var _InDownLeft2 = _interopRequireDefault(_InDownLeft);

var _InDownRight = __webpack_require__(783);

var _InDownRight2 = _interopRequireDefault(_InDownRight);

var _InUpLeft = __webpack_require__(784);

var _InUpLeft2 = _interopRequireDefault(_InUpLeft);

var _InUpRight = __webpack_require__(785);

var _InUpRight2 = _interopRequireDefault(_InUpRight);

var _Out7 = __webpack_require__(786);

var _Out8 = _interopRequireDefault(_Out7);

var _OutDownLeft = __webpack_require__(787);

var _OutDownLeft2 = _interopRequireDefault(_OutDownLeft);

var _OutDownRight = __webpack_require__(788);

var _OutDownRight2 = _interopRequireDefault(_OutDownRight);

var _OutUpLeft = __webpack_require__(789);

var _OutUpLeft2 = _interopRequireDefault(_OutUpLeft);

var _OutUpRight = __webpack_require__(790);

var _OutUpRight2 = _interopRequireDefault(_OutUpRight);

var _InDown5 = __webpack_require__(791);

var _InDown6 = _interopRequireDefault(_InDown5);

var _InLeft5 = __webpack_require__(792);

var _InLeft6 = _interopRequireDefault(_InLeft5);

var _InRight5 = __webpack_require__(793);

var _InRight6 = _interopRequireDefault(_InRight5);

var _InUp5 = __webpack_require__(794);

var _InUp6 = _interopRequireDefault(_InUp5);

var _OutDown5 = __webpack_require__(795);

var _OutDown6 = _interopRequireDefault(_OutDown5);

var _OutLeft5 = __webpack_require__(796);

var _OutLeft6 = _interopRequireDefault(_OutLeft5);

var _OutRight5 = __webpack_require__(797);

var _OutRight6 = _interopRequireDefault(_OutRight5);

var _OutUp5 = __webpack_require__(798);

var _OutUp6 = _interopRequireDefault(_OutUp5);

var _Hinge = __webpack_require__(753);

var _Hinge2 = _interopRequireDefault(_Hinge);

var _RollIn = __webpack_require__(754);

var _RollIn2 = _interopRequireDefault(_RollIn);

var _RollOut = __webpack_require__(755);

var _RollOut2 = _interopRequireDefault(_RollOut);

var _In9 = __webpack_require__(799);

var _In10 = _interopRequireDefault(_In9);

var _InDown7 = __webpack_require__(800);

var _InDown8 = _interopRequireDefault(_InDown7);

var _InLeft7 = __webpack_require__(801);

var _InLeft8 = _interopRequireDefault(_InLeft7);

var _InRight7 = __webpack_require__(802);

var _InRight8 = _interopRequireDefault(_InRight7);

var _InUp7 = __webpack_require__(803);

var _InUp8 = _interopRequireDefault(_InUp7);

var _Out9 = __webpack_require__(804);

var _Out10 = _interopRequireDefault(_Out9);

var _OutDown7 = __webpack_require__(805);

var _OutDown8 = _interopRequireDefault(_OutDown7);

var _OutLeft7 = __webpack_require__(806);

var _OutLeft8 = _interopRequireDefault(_OutLeft7);

var _OutRight7 = __webpack_require__(807);

var _OutRight8 = _interopRequireDefault(_OutRight7);

var _OutUp7 = __webpack_require__(808);

var _OutUp8 = _interopRequireDefault(_OutUp7);

var _Animate = __webpack_require__(732);

var _Animate2 = _interopRequireDefault(_Animate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Bounce = _Bounce2.default;
exports.Flash = _Flash2.default;
exports.HeadShake = _HeadShake2.default;
exports.Jello = _Jello2.default;
exports.Pulse = _Pulse2.default;
exports.RubberBand = _RubberBand2.default;
exports.Shake = _Shake2.default;
exports.Swing = _Swing2.default;
exports.Tada = _Tada2.default;
exports.Wobble = _Wobble2.default;
exports.BounceIn = _In2.default;
exports.BounceInUp = _InUp2.default;
exports.BounceInDown = _InDown2.default;
exports.BounceInLeft = _InLeft2.default;
exports.BounceInRight = _InRight2.default;
exports.BounceOut = _Out2.default;
exports.BounceOutDown = _OutDown2.default;
exports.BounceOutLeft = _OutLeft2.default;
exports.BounceOutRight = _OutRight2.default;
exports.BounceOutUp = _OutUp2.default;
exports.FadeIn = _In4.default;
exports.FadeInDown = _InDown4.default;
exports.FadeInDownBig = _InDownBig2.default;
exports.FadeInLeft = _InLeft4.default;
exports.FadeInLeftBig = _InLeftBig2.default;
exports.FadeInRight = _InRight4.default;
exports.FadeInRightBig = _InRightBig2.default;
exports.FadeInUp = _InUp4.default;
exports.FadeInUpBig = _InUpBig2.default;
exports.FadeOut = _Out4.default;
exports.FadeOutDown = _OutDown4.default;
exports.FadeOutDownBig = _OutDownBig2.default;
exports.FadeOutLeft = _OutLeft4.default;
exports.FadeOutLeftBig = _OutLeftBig2.default;
exports.FadeOutRight = _OutRight4.default;
exports.FadeOutRightBig = _OutRightBig2.default;
exports.FadeOutUp = _OutUp4.default;
exports.FadeOutUpBig = _OutUpBig2.default;
exports.Flip = _Flip2.default;
exports.FlipInX = _InX2.default;
exports.FlipInY = _InY2.default;
exports.FlipOutX = _OutX2.default;
exports.FlipOutY = _OutY2.default;
exports.LightSpeedIn = _In6.default;
exports.LightSpeedOut = _Out6.default;
exports.RotateIn = _In8.default;
exports.RotateInDownLeft = _InDownLeft2.default;
exports.RotateInDownRight = _InDownRight2.default;
exports.RotateInUpLeft = _InUpLeft2.default;
exports.RotateInUpRight = _InUpRight2.default;
exports.RotateOut = _Out8.default;
exports.RotateOutDownLeft = _OutDownLeft2.default;
exports.RotateOutDownRight = _OutDownRight2.default;
exports.RotateOutUpLeft = _OutUpLeft2.default;
exports.RotateOutUpRight = _OutUpRight2.default;
exports.SlideInDown = _InDown6.default;
exports.SlideInLeft = _InLeft6.default;
exports.SlideInRight = _InRight6.default;
exports.SlideInUp = _InUp6.default;
exports.SlideOutDown = _OutDown6.default;
exports.SlideOutLeft = _OutLeft6.default;
exports.SlideOutRight = _OutRight6.default;
exports.SlideOutUp = _OutUp6.default;
exports.Hinge = _Hinge2.default;
exports.RollIn = _RollIn2.default;
exports.RollOut = _RollOut2.default;
exports.ZoomIn = _In10.default;
exports.ZoomInDown = _InDown8.default;
exports.ZoomInLeft = _InLeft8.default;
exports.ZoomInRight = _InRight8.default;
exports.ZoomInUp = _InUp8.default;
exports.ZoomOut = _Out10.default;
exports.ZoomOutDown = _OutDown8.default;
exports.ZoomOutLeft = _OutLeft8.default;
exports.ZoomOutRight = _OutRight8.default;
exports.ZoomOutUp = _OutUp8.default;
exports.BaseAnimation = _BaseAnimation2.default;
exports.default = _Animate2.default;

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(221);

var invariant = __webpack_require__(12);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(21);

var ReactBaseClasses = __webpack_require__(422);
var ReactChildren = __webpack_require__(813);
var ReactDOMFactories = __webpack_require__(814);
var ReactElement = __webpack_require__(132);
var ReactPropTypes = __webpack_require__(815);
var ReactVersion = __webpack_require__(816);

var createReactClass = __webpack_require__(817);
var onlyChild = __webpack_require__(820);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(811);
var ReactElement = __webpack_require__(132);

var emptyFunction = __webpack_require__(70);
var traverseAllChildren = __webpack_require__(821);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(132);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(132),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(377);

module.exports = factory(isValidElement);

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.7.0';


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(422),
    Component = _require.Component;

var _require2 = __webpack_require__(132),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(425);
var factory = __webpack_require__(512);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(221);

var ReactElement = __webpack_require__(132);

var invariant = __webpack_require__(12);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(221);

var ReactCurrentOwner = __webpack_require__(423);
var REACT_ELEMENT_TYPE = __webpack_require__(424);

var getIteratorFn = __webpack_require__(818);
var invariant = __webpack_require__(12);
var KeyEscapeUtils = __webpack_require__(810);
var warning = __webpack_require__(14);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);
var bind = __webpack_require__(432);
var Axios = __webpack_require__(825);
var defaults = __webpack_require__(291);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(429);
axios.CancelToken = __webpack_require__(824);
axios.isCancel = __webpack_require__(430);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(839);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(429);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(291);
var utils = __webpack_require__(62);
var InterceptorManager = __webpack_require__(826);
var dispatchRequest = __webpack_require__(827);
var isAbsoluteURL = __webpack_require__(835);
var combineURLs = __webpack_require__(833);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);
var transformData = __webpack_require__(830);
var isCancel = __webpack_require__(430);
var defaults = __webpack_require__(291);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(431);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonCompareMobileV2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  outline: none;\n  border: none;\n  background-color: transparent;\n\n  cursor: pointer;\n\n  color: #006736;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px; /* 142.857% */\n\n  &:disabled {\n    color: #bababa;\n    cursor: default;\n  }\n'],['\n  outline: none;\n  border: none;\n  background-color: transparent;\n\n  cursor: pointer;\n\n  color: #006736;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px; /* 142.857% */\n\n  &:disabled {\n    color: #bababa;\n    cursor: default;\n  }\n']);var ButtonCompareMobileV2=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ButtonCompareMobileV2,_Component);function ButtonCompareMobileV2(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,ButtonCompareMobileV2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=ButtonCompareMobileV2.__proto__||Object.getPrototypeOf(ButtonCompareMobileV2)).call.apply(_ref,[this].concat(args))),_this),_this.handleClick=function(e){var _this$props=_this.props,onClick=_this$props.onClick,setModalTriggerHeight=_this$props.setModalTriggerHeight;onClick&&onClick(e);if(setModalTriggerHeight){setModalTriggerHeight(_this.buttonRef.getBoundingClientRect().top);}},_temp),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ButtonCompareMobileV2,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CompareButton,Object.assign({innerRef:function innerRef(ref){return _this2.buttonRef=ref;}},this.props,{onClick:this.handleClick}),'Comparar');}}]);return ButtonCompareMobileV2;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);var CompareButton=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].button.attrs({ref:function ref(props){return props.buttonRef;}})(_templateObject);

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonFiltersMobileV2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  cursor: pointer;\n  width: 20px;\n  height: 20px;\n'],['\n  cursor: pointer;\n  width: 20px;\n  height: 20px;\n']);var ButtonFiltersMobileV2=function(_Component){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ButtonFiltersMobileV2,_Component);function ButtonFiltersMobileV2(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,ButtonFiltersMobileV2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=ButtonFiltersMobileV2.__proto__||Object.getPrototypeOf(ButtonFiltersMobileV2)).call.apply(_ref,[this].concat(args))),_this),_this.handleClick=function(e){var _this$props=_this.props,onClick=_this$props.onClick,setModalTriggerHeight=_this$props.setModalTriggerHeight;onClick&&onClick(e);if(setModalTriggerHeight){setModalTriggerHeight(_this.buttonRef.getBoundingClientRect().top);}},_temp),__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ButtonFiltersMobileV2,[{key:'render',value:function render(){var _this2=this;var _props=this.props,children=_props.children,restProps=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props,['children']);return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Wrapper,Object.assign({},restProps,{innerRef:function innerRef(ref){return _this2.buttonRef=ref;},className:'iconWrapper',onClick:this.handleClick}),children);}}]);return ButtonFiltersMobileV2;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);var Wrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div.attrs({ref:function ref(props){return props.buttonRef;}})(_templateObject);

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompareModalV2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ButtonOutlineV2__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ButtonGradientV2__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__BigModalV2__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DetailsModalV2_images_ic_network_component_svg__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DetailsModalV2_images_ic_network_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__DetailsModalV2_images_ic_network_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__DetailsModalV2_images_ic_eletricity_gas_component_svg__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__DetailsModalV2_images_ic_eletricity_gas_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__DetailsModalV2_images_ic_eletricity_gas_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DetailsModalV2_images_ic_support_component_svg__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DetailsModalV2_images_ic_support_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__DetailsModalV2_images_ic_support_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DetailsModalV2_images_ic_discounts_component_svg__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DetailsModalV2_images_ic_discounts_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__DetailsModalV2_images_ic_discounts_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__DetailsModalV2_images_ic_taxes_component_svg__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__DetailsModalV2_images_ic_taxes_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__DetailsModalV2_images_ic_taxes_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DetailsModalV2_images_ic_result_component_svg__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DetailsModalV2_images_ic_result_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__DetailsModalV2_images_ic_result_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_ic_house_component_svg__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_ic_house_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__images_ic_house_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_ic_info2_component_svg__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_ic_info2_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__images_ic_info2_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_ic_winner_component_svg__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_ic_winner_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__images_ic_winner_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__TooltipV2__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_utils__ = __webpack_require__(11);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #fff;\n  font-family: Nunito;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 150% */\n  min-width: 250px;\n  margin: 0;\n'],['\n  color: #fff;\n  font-family: Nunito;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 150% */\n  min-width: 250px;\n  margin: 0;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #ececec;\n  flex: 1 0 0;\n  width: 100%;\n  border-spacing: 0;\n  align-self: stretch;\n\n  > tbody {\n    overflow-y: auto;\n    width: 100%;\n    flex: 1 0 0;\n    align-self: stretch;\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #ececec;\n  flex: 1 0 0;\n  width: 100%;\n  border-spacing: 0;\n  align-self: stretch;\n\n  > tbody {\n    overflow-y: auto;\n    width: 100%;\n    flex: 1 0 0;\n    align-self: stretch;\n  }\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex: 1 0 0;\n\n  border-bottom: ',';\n'],['\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex: 1 0 0;\n\n  border-bottom: ',';\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  gap: 4px;\n'],['\n  display: flex;\n  align-items: center;\n  gap: 4px;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 10px 16px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 2px;\n  flex: 1 0 0;\n  align-self: stretch;\n\n  ','\n'],['\n  display: flex;\n  padding: 10px 16px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 2px;\n  flex: 1 0 0;\n  align-self: stretch;\n\n  ','\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #1D1E22;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; \n  margin: 0;\n\n  > b {\n    color: #1D1E22;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 20px; /* 142.857% */\n  }\n\n  ','\n\n  ','\n\n  ','\n\n   ','\n\n  ','\n'],['\n  color: #1D1E22;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; \n  margin: 0;\n\n  > b {\n    color: #1D1E22;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 20px; /* 142.857% */\n  }\n\n  ','\n\n  ','\n\n  ','\n\n   ','\n\n  ','\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  align-content: center;\n  padding: 10px 16px;\n  align-self: stretch;\n  flex-wrap: wrap;\n  flex: 1 0 0;\n  gap: 4px;\n\n  ','\n'],['\n  display: flex;\n  align-items: center;\n  align-content: center;\n  padding: 10px 16px;\n  align-self: stretch;\n  flex-wrap: wrap;\n  flex: 1 0 0;\n  gap: 4px;\n\n  ','\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n  gap: 4px;\n'],['\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n  gap: 4px;\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 12px 16px;\n  align-items: center;\n  gap: 4px;\n  flex: 1 0 0;\n  align-self: stretch;\n\n  > img {\n    width: 60px;\n    height: 30px;\n    object-fit: contain;\n  }\n\n\n  ','\n\n  ','\n\n  ','\n'],['\n  display: flex;\n  padding: 12px 16px;\n  align-items: center;\n  gap: 4px;\n  flex: 1 0 0;\n  align-self: stretch;\n\n  > img {\n    width: 60px;\n    height: 30px;\n    object-fit: contain;\n  }\n\n\n  ','\n\n  ','\n\n  ','\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #006736;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 18px; /* 150% */\n  margin: 0;\n  text-transform: uppercase;\n'],['\n  color: #006736;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 18px; /* 150% */\n  margin: 0;\n  text-transform: uppercase;\n']),_templateObject11=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 8px 16px;\n  flex: 1 0 0;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n'],['\n  display: flex;\n  padding: 8px 16px;\n  flex: 1 0 0;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n']),_templateObject12=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  height: 72px;\n  padding: 16px;\n  align-items: center;\n  gap: 4px;\n  flex: 1 0 0;\n'],['\n  display: flex;\n  height: 72px;\n  padding: 16px;\n  align-items: center;\n  gap: 4px;\n  flex: 1 0 0;\n']);var TABLE_KEYS=['medal','logo','designation','electricity','gas','additional_services','potency','tariff','cycle','stage','billing','network_access','energy','other_services','refunds_discounts','taxes','annual_billing'];var CompareModalV2=function(_Component){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CompareModalV2,_Component);function CompareModalV2(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,CompareModalV2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=CompareModalV2.__proto__||Object.getPrototypeOf(CompareModalV2)).call.apply(_ref,[this].concat(args))),_this),_this.generateCellKey=function(key,id){return'compare_cell_row_'+key+'_item_'+id;},_this.renderElectricityCell=function(key,item,cheapId){var timeCycle=item.priceListTimeCycle;var elePrices=item.prices.electricity;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ListCell,{key:_this.generateCellKey(key,item.id),cheap:item.id===cheapId},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(PriceDetails,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},'Termo Pot\xEAncia'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["g" /* pricesCurrency */])(elePrices.termo_fixo)||'---'),' \u20AC/dia')),timeCycle==='s'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(PriceDetails,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},'Energia'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["g" /* pricesCurrency */])(elePrices.cheia)||'---'),' \u20AC/kWh')):null,timeCycle!=='s'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(PriceDetails,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},'Vazio'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["g" /* pricesCurrency */])(elePrices.vazio)||'---'),' \u20AC/kWh')):null,timeCycle==='b'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(PriceDetails,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},'Fora do Vazio'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["g" /* pricesCurrency */])(elePrices.cheia)||'---'),' \u20AC/kWh')):null,timeCycle!=='s'&&timeCycle!=='b'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(PriceDetails,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},'Ponta'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["g" /* pricesCurrency */])(elePrices.ponta)||'---'),' \u20AC/kWh')):null,timeCycle!=='s'&&timeCycle!=='b'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(PriceDetails,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},'Cheias'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["g" /* pricesCurrency */])(elePrices.cheia)||'---'),' \u20AC/kWh')):null);},_this.renderRow=function(key,updatedList){var mostCheap=updatedList.reduce(function(prev,curr){return Number(prev.annualBilling)<Number(curr.annualBilling)?prev:curr;});var hasElectricity=Boolean(updatedList[0].electricityPriceList);var hasGas=Boolean(updatedList[0].gasPriceList);var empty=false;var cells=[];if(key==='medal'){empty=true;cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,null));updatedList.forEach(function(item){return cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id,center:true},item.id===mostCheap.id&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__images_ic_winner_component_svg___default.a,null),item.id===mostCheap.id&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(MedalText,null,'Mais Econ\xF3mico')));});}else if(key==='logo'){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,null));updatedList.forEach(function(item,index){var energyPriceList=hasElectricity?item.electricityPriceList:item.gasPriceList;cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id,center:true},index===0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__images_ic_house_component_svg___default.a,null),index>0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img',{src:''+__WEBPACK_IMPORTED_MODULE_8_config__["e" /* MEDIA_BASE_URL */]+energyPriceList.entity.hi_res_logo,alt:energyPriceList.designation})));});}else if(key==='designation'){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{defaultText:true},'Tarif\xE1rio')));updatedList.forEach(function(item,index){var energyPriceList=hasElectricity?item.electricityPriceList:item.gasPriceList;cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,null,index===0?'O meu tarifário':energyPriceList.designation)));});}else if(key==='electricity'){if(hasElectricity){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{defaultText:true},'Eletricidade')));updatedList.forEach(function(item){cells.push(_this.renderElectricityCell(key,item,mostCheap.id));});}else{empty=true;}}else if(key==='gas'){if(hasGas){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{defaultText:true},'G\xE1s Natural')));updatedList.forEach(function(item){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ListCell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(PriceDetails,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},'Termo Fixo'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["g" /* pricesCurrency */])(item.prices.gas.termo_fixo)||'---'),' ','\u20AC/dia')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(PriceDetails,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},'Energia'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["g" /* pricesCurrency */])(item.prices.gas.termo_energia)||'---'),' ','\u20AC/kWh'))));});}else{empty=true;}}else if(key==='additional_services'){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{defaultText:true},'Condi\xE7\xF5es Adicionais')));updatedList.forEach(function(item){var additionalServices=hasElectricity?item.electricityPriceList.additional_services:item.gasPriceList.additional_services;if(!additionalServices.length){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,null,'-')));}else{cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ServicesCell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id},additionalServices.map(function(service){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,null,service.name);})));}});}else if(key==='potency'){if(hasElectricity){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{defaultText:true},'Pot\xEAncia')));updatedList.forEach(function(item){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["h" /* currency */])(item.calculatedHiredPowerFactor)),' kVA')));});}else{empty=true;}}else if(key==='tariff'){if(hasElectricity){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{defaultText:true},'Tarifa')));updatedList.forEach(function(item){var timeCycle=item.priceListTimeCycle;var text=timeCycle==='s'?'Simples':timeCycle==='b'?'Bi-Horário':timeCycle==='t'?'Tri-Horário':'-';cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{bold:true},text)));});}else{empty=true;}}else if(key==='cycle'){if(hasElectricity){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{defaultText:true},'Ciclo Hor\xE1rio')));updatedList.forEach(function(item){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{bold:true},'Di\xE1rio')));});}else{empty=true;}}else if(key==='stage'){if(hasGas){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{defaultText:true},'Escal\xE3o')));updatedList.forEach(function(item){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{bold:true},item.prices.gas.stage)));});}else{empty=true;}}else if(key==='billing'){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{title:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{title:true},'Fatura\xE7\xE3o')));updatedList.forEach(function(item){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id}));});}else if(key==='network_access'){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(IconCell,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__DetailsModalV2_images_ic_network_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true,tooltip:true},'Pot\xEAncia',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__TooltipV2__["a" /* default */],{style:{height:'16px'},contentStyle:{maxWidth:'180px'},content:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TooltipText,null,'Inclui Tarifa de Acesso \xE0s Redes.'),arrowLocation:'topLeft'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__images_ic_info2_component_svg___default.a,{width:'16px',height:'16px'})))));updatedList.forEach(function(item){var eleAnnualFixedTerm=hasElectricity?Number(item.electricityFixedTerm):0;var gasAnnualFixedTerm=hasGas?Number(item.gasFixedTerm):0;var monthlyNetworkAccess=eleAnnualFixedTerm+gasAnnualFixedTerm;cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,monthlyNetworkAccess.toFixed(2).replace('.',',')),' \u20AC')));});}else if(key==='energy'){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(IconCell,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__DetailsModalV2_images_ic_eletricity_gas_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true,tooltip:true},'Energia',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__TooltipV2__["a" /* default */],{style:{height:'16px'},contentStyle:{maxWidth:'180px'},content:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TooltipText,null,'Inclui Tarifa de Acesso \xE0s Redes.'),arrowLocation:'topLeft'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__images_ic_info2_component_svg___default.a,{width:'16px',height:'16px'})))));updatedList.forEach(function(item){var eleAnnualEnergy=hasElectricity?Number(item.electricityEnergy):0;var gasAnnualEnergy=hasGas?Number(item.gasEnergy):0;var monthlyEnergy=eleAnnualEnergy+gasAnnualEnergy;cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,monthlyEnergy.toFixed(2).replace('.',',')),' \u20AC')));});}else if(key==='other_services'){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(IconCell,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__DetailsModalV2_images_ic_support_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},'Outros Servi\xE7os')));updatedList.forEach(function(item){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,'0'),' \u20AC')));});}else if(key==='refunds_discounts'){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(IconCell,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__DetailsModalV2_images_ic_discounts_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},'Reembolsos/Descontos')));updatedList.forEach(function(item){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["h" /* currency */])(item.annualRefunds)),' \u20AC')));});}else if(key==='taxes'){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(IconCell,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__DetailsModalV2_images_ic_taxes_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},'Taxas e Impostos')));updatedList.forEach(function(item){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["h" /* currency */])(item.annualTaxes)),' \u20AC')));});}else if(key==='annual_billing'){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(IconCell,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__DetailsModalV2_images_ic_result_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},'Valor Anual')));updatedList.forEach(function(item){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["h" /* currency */])(item.annualBilling)),' \u20AC')));});}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,{key:'compare_row_'+key,empty:empty},cells);},_this.renderBtnsRow=function(updatedList){var mostCheap=updatedList.reduce(function(prev,curr){return Number(prev.annualBilling)<Number(curr.annualBilling)?prev:curr;});var cells=[];updatedList.forEach(function(item,index){if(index===0){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(BtnCell,null));}else{var moreInfoParams=Object.assign({},_this.props,{priceListId:item.id});if(item.electricityPriceList){moreInfoParams.id=item.electricityPriceList.id;}else if(item.gasPriceList){moreInfoParams.id=item.gasPriceList.id;}var BtnComponent=item.id===mostCheap.id?__WEBPACK_IMPORTED_MODULE_10__ButtonGradientV2__["a" /* default */]:__WEBPACK_IMPORTED_MODULE_9__ButtonOutlineV2__["a" /* default */];cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(BtnCell,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(BtnComponent,{onClick:function onClick(){return _this.props.onJoin(moreInfoParams);}},'Aderir ao Tarif\xE1rio')));}});return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(BtnsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(BtnCell,null),cells);},_this.renderTable=function(){var _this$props=_this.props,compareList=_this$props.compareList,simulation=_this$props.simulation;var updatedList=[simulation.results].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(compareList));return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Table,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('tbody',null,TABLE_KEYS.map(function(key){return _this.renderRow(key,updatedList);})),_this.renderBtnsRow(updatedList));},_temp),__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CompareModalV2,[{key:'render',value:function render(){var onClose=this.props.onClose;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__BigModalV2__["a" /* default */],{modalTriggerHeight:this.props.modalTriggerHeight,setModalTriggerHeight:this.props.setModalTriggerHeight,title:'Comparar Resultados',onClose:onClose,style:{width:'950px'}},this.renderTable());}}]);return CompareModalV2;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);var TooltipText=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].p(_templateObject);var Table=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].table(_templateObject2);var Row=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].tr(_templateObject3,function(_ref2){var empty=_ref2.empty;return!empty&&'1px solid #ECECEC';});var BtnsRow=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].tr(_templateObject4);var ListCell=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].td(_templateObject5,function(_ref3){var cheap=_ref3.cheap;return cheap&&'\n    background: linear-gradient(0deg, rgba(147, 193, 62, 0.05) 0%, rgba(147, 193, 62, 0.05) 100%), #FFF;\n  ';});var Detail=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].p(_templateObject6,function(_ref4){var defaultText=_ref4.defaultText;return defaultText&&'\n    color: #676767;\n    font-weight: 600;\n  ';},function(_ref5){var title=_ref5.title;return title&&'\n    color: #006736;\n    font-weight: 700;\n  ';},function(_ref6){var lighter=_ref6.lighter;return lighter&&'\n    color: #3E3E3E;\n  ';},function(_ref7){var bold=_ref7.bold;return bold&&'\n    font-weight: 700;\n  ';},function(_ref8){var tooltip=_ref8.tooltip;return tooltip&&'\n    display: flex;\n    align-items: center;\n    gap: 4px;\n  ';});var ServicesCell=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].td(_templateObject7,function(_ref9){var cheap=_ref9.cheap;return cheap&&'\n    background: linear-gradient(0deg, rgba(147, 193, 62, 0.05) 0%, rgba(147, 193, 62, 0.05) 100%), #FFF;\n  ';});var PriceDetails=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject8);var Cell=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].td(_templateObject9,function(_ref10){var title=_ref10.title;return title&&'\n    padding: 10px 16px;\n  ';},function(_ref11){var cheap=_ref11.cheap;return cheap&&'\n    background: linear-gradient(0deg, rgba(147, 193, 62, 0.05) 0%, rgba(147, 193, 62, 0.05) 100%), #FFF;\n  ';},function(_ref12){var center=_ref12.center;return center&&'\n    justify-content: center;\n  ';});var MedalText=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].h4(_templateObject10);var IconCell=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].td(_templateObject11);var BtnCell=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].td(_templateObject12);

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompareModalMobileV2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ButtonOutlineV2__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ButtonGradientV2__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MobileModalV2__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DetailsModalV2_images_ic_network_component_svg__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DetailsModalV2_images_ic_network_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__DetailsModalV2_images_ic_network_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__DetailsModalV2_images_ic_eletricity_gas_component_svg__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__DetailsModalV2_images_ic_eletricity_gas_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__DetailsModalV2_images_ic_eletricity_gas_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DetailsModalV2_images_ic_support_component_svg__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DetailsModalV2_images_ic_support_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__DetailsModalV2_images_ic_support_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DetailsModalV2_images_ic_discounts_component_svg__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DetailsModalV2_images_ic_discounts_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__DetailsModalV2_images_ic_discounts_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__DetailsModalV2_images_ic_taxes_component_svg__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__DetailsModalV2_images_ic_taxes_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__DetailsModalV2_images_ic_taxes_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DetailsModalV2_images_ic_result_component_svg__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DetailsModalV2_images_ic_result_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__DetailsModalV2_images_ic_result_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_ic_house_component_svg__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_ic_house_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__images_ic_house_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_ic_info2_component_svg__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_ic_info2_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__images_ic_info2_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_ic_winner_component_svg__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_ic_winner_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__images_ic_winner_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__TooltipV2__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_utils__ = __webpack_require__(11);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #fff;\n  font-family: Nunito;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 150% */\n  min-width: 250px;\n  margin: 0;\n'],['\n  color: #fff;\n  font-family: Nunito;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 150% */\n  min-width: 250px;\n  margin: 0;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  overflow: auto;\n  position: relative;\n  width: 1000px;\n'],['\n  overflow: auto;\n  position: relative;\n  width: 1000px;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  border: 1px solid #ececec;\n  width: 100%;\n  border-spacing: 0;\n  table-layout: fixed;\n\n  > tbody {\n    overflow: scroll;\n  }\n'],['\n  border: 1px solid #ececec;\n  width: 100%;\n  border-spacing: 0;\n  table-layout: fixed;\n\n  > tbody {\n    overflow: scroll;\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  border-bottom: 1px solid #ececec;\n'],['\n  border-bottom: 1px solid #ececec;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: sticky;\n  background: #fff;\n  bottom: 0;\n  z-index: 10;\n'],['\n  position: sticky;\n  background: #fff;\n  bottom: 0;\n  z-index: 10;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding: 10px 16px;\n  min-width: 200px;\n\n  ','\n'],['\n  padding: 10px 16px;\n  min-width: 200px;\n\n  ','\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #1D1E22;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; \n  margin: 0;\n\n  > b {\n    color: #1D1E22;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 20px; /* 142.857% */\n  }\n\n  ','\n\n  ','\n\n  ','\n\n   ','\n\n    ','\n'],['\n  color: #1D1E22;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; \n  margin: 0;\n\n  > b {\n    color: #1D1E22;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 20px; /* 142.857% */\n  }\n\n  ','\n\n  ','\n\n  ','\n\n   ','\n\n    ','\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n  gap: 4px;\n'],['\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n  gap: 4px;\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding: 12px 16px;\n  min-width: 200px;\n\n  > img {\n    width: 60px;\n    height: 30px;\n    object-fit: contain;\n  }\n\n  &.absolute {\n    position: sticky;\n    left: 0;\n    min-width: 130px;\n    border-right: 1px solid #ECECEC;\n  }\n\n\n  ','\n\n  ','\n\n  ','\n'],['\n  padding: 12px 16px;\n  min-width: 200px;\n\n  > img {\n    width: 60px;\n    height: 30px;\n    object-fit: contain;\n  }\n\n  &.absolute {\n    position: sticky;\n    left: 0;\n    min-width: 130px;\n    border-right: 1px solid #ECECEC;\n  }\n\n\n  ','\n\n  ','\n\n  ','\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #006736;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 18px; /* 150% */\n  margin: 0;\n  text-transform: uppercase;\n'],['\n  color: #006736;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 18px; /* 150% */\n  margin: 0;\n  text-transform: uppercase;\n']),_templateObject11=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding: 8px 16px;\n  min-width: 200px;\n\n  &.absolute {\n    position: sticky;\n    left: 0;\n    min-width: 130px;\n    border-right: 1px solid #ececec;\n  }\n\n  > span {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 8px;\n  }\n'],['\n  padding: 8px 16px;\n  min-width: 200px;\n\n  &.absolute {\n    position: sticky;\n    left: 0;\n    min-width: 130px;\n    border-right: 1px solid #ececec;\n  }\n\n  > span {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 8px;\n  }\n']),_templateObject12=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 72px;\n  padding: 16px;\n  min-width: 200px;\n\n  &.absolute {\n    position: sticky;\n    left: 0;\n    min-width: 130px;\n    border-right: 1px solid #ececec;\n  }\n'],['\n  height: 72px;\n  padding: 16px;\n  min-width: 200px;\n\n  &.absolute {\n    position: sticky;\n    left: 0;\n    min-width: 130px;\n    border-right: 1px solid #ececec;\n  }\n']);var TABLE_KEYS=['medal','logo','designation','electricity','gas','additional_services','potency','tariff','cycle','stage','billing','network_access','energy','other_services','refunds_discounts','taxes','annual_billing'];var CompareModalMobileV2=function(_Component){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CompareModalMobileV2,_Component);function CompareModalMobileV2(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,CompareModalMobileV2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=CompareModalMobileV2.__proto__||Object.getPrototypeOf(CompareModalMobileV2)).call.apply(_ref,[this].concat(args))),_this),_this.generateCellKey=function(key,id){return'compare_cell_row_'+key+'_item_'+id;},_this.renderElectricityCell=function(key,item,cheapId){var timeCycle=item.priceListTimeCycle;var elePrices=item.prices.electricity;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ListCell,{key:_this.generateCellKey(key,item.id),cheap:item.id===cheapId},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(PriceDetails,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},'Termo Pot\xEAncia'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["g" /* pricesCurrency */])(elePrices.termo_fixo)||'---'),' \u20AC/dia')),timeCycle==='s'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(PriceDetails,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},'Energia'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["g" /* pricesCurrency */])(elePrices.cheia)||'---'),' \u20AC/kWh')):null,timeCycle!=='s'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(PriceDetails,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},'Vazio'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["g" /* pricesCurrency */])(elePrices.vazio)||'---'),' \u20AC/kWh')):null,timeCycle==='b'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(PriceDetails,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},'Fora do Vazio'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["g" /* pricesCurrency */])(elePrices.cheia)||'---'),' \u20AC/kWh')):null,timeCycle!=='s'&&timeCycle!=='b'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(PriceDetails,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},'Ponta'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["g" /* pricesCurrency */])(elePrices.ponta)||'---'),' \u20AC/kWh')):null,timeCycle!=='s'&&timeCycle!=='b'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(PriceDetails,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},'Cheias'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["g" /* pricesCurrency */])(elePrices.cheia)||'---'),' \u20AC/kWh')):null);},_this.renderRow=function(key,updatedList){var mostCheap=updatedList.reduce(function(prev,curr){return Number(prev.annualBilling)<Number(curr.annualBilling)?prev:curr;});var hasElectricity=Boolean(updatedList[0].electricityPriceList);var hasGas=Boolean(updatedList[0].gasPriceList);var empty=false;var cells=[];if(key==='medal'){empty=true;cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{className:'absolute'}));updatedList.forEach(function(item){return cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id,center:true},item.id===mostCheap.id&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__images_ic_winner_component_svg___default.a,null),item.id===mostCheap.id&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(MedalText,null,'Mais Econ\xF3mico')));});}else if(key==='logo'){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{className:'absolute'}));updatedList.forEach(function(item,index){var energyPriceList=hasElectricity?item.electricityPriceList:item.gasPriceList;cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id,center:true},index===0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__images_ic_house_component_svg___default.a,null),index>0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img',{src:''+__WEBPACK_IMPORTED_MODULE_8_config__["e" /* MEDIA_BASE_URL */]+energyPriceList.entity.hi_res_logo,alt:energyPriceList.designation})));});}else if(key==='designation'){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{className:'absolute'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{defaultText:true},'Tarif\xE1rio')));updatedList.forEach(function(item,index){var energyPriceList=hasElectricity?item.electricityPriceList:item.gasPriceList;cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,null,index===0?'O meu tarifário':energyPriceList.designation)));});}else if(key==='electricity'){if(hasElectricity){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{className:'absolute'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{defaultText:true},'Eletricidade')));updatedList.forEach(function(item){cells.push(_this.renderElectricityCell(key,item,mostCheap.id));});}else{empty=true;}}else if(key==='gas'){if(hasGas){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{className:'absolute'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{defaultText:true},'G\xE1s Natural')));updatedList.forEach(function(item){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ListCell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(PriceDetails,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},'Termo Fixo'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["g" /* pricesCurrency */])(item.prices.gas.termo_fixo)||'---'),' ','\u20AC/dia')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(PriceDetails,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},'Energia'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["g" /* pricesCurrency */])(item.prices.gas.termo_energia)||'---'),' ','\u20AC/kWh'))));});}else{empty=true;}}else if(key==='additional_services'){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{className:'absolute'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{defaultText:true},'Condi\xE7\xF5es Adicionais')));updatedList.forEach(function(item){var additionalServices=hasElectricity?item.electricityPriceList.additional_services:item.gasPriceList.additional_services;if(!additionalServices.length){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,null,'-')));}else{cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ServicesCell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id},additionalServices.map(function(service){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,null,service.name);})));}});}else if(key==='potency'){if(hasElectricity){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{className:'absolute'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{defaultText:true},'Pot\xEAncia')));updatedList.forEach(function(item){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["h" /* currency */])(item.calculatedHiredPowerFactor)),' kVA')));});}else{empty=true;}}else if(key==='tariff'){if(hasElectricity){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{className:'absolute'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{defaultText:true},'Tarifa')));updatedList.forEach(function(item){var timeCycle=item.priceListTimeCycle;var text=timeCycle==='s'?'Simples':timeCycle==='b'?'Bi-Horário':timeCycle==='t'?'Tri-Horário':'-';cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{bold:true},text)));});}else{empty=true;}}else if(key==='cycle'){if(hasElectricity){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{className:'absolute'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{defaultText:true},'Ciclo Hor\xE1rio')));updatedList.forEach(function(item){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{bold:true},'Di\xE1rio')));});}else{empty=true;}}else if(key==='stage'){if(hasGas){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{className:'absolute'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{defaultText:true},'Escal\xE3o')));updatedList.forEach(function(item){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{bold:true},item.prices.gas.stage)));});}else{empty=true;}}else if(key==='billing'){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{title:true,className:'absolute'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{title:true},'Fatura\xE7\xE3o')));updatedList.forEach(function(item){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id}));});}else if(key==='network_access'){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(IconCell,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__DetailsModalV2_images_ic_network_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true,tooltip:true},'Pot\xEAncia',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__TooltipV2__["a" /* default */],{style:{height:'16px'},contentStyle:{maxWidth:'180px'},content:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TooltipText,null,'Inclui Tarifa de Acesso \xE0s Redes.'),arrowLocation:'topLeft'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__images_ic_info2_component_svg___default.a,{width:'16px',height:'16px'}))))));updatedList.forEach(function(item){var eleAnnualFixedTerm=hasElectricity?Number(item.electricityFixedTerm):0;var gasAnnualFixedTerm=hasGas?Number(item.gasFixedTerm):0;var monthlyNetworkAccess=eleAnnualFixedTerm+gasAnnualFixedTerm;cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,monthlyNetworkAccess.toFixed(2).replace('.',',')),' \u20AC')));});}else if(key==='energy'){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(IconCell,{className:'absolute'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__DetailsModalV2_images_ic_eletricity_gas_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true,tooltip:true},'Energia',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__TooltipV2__["a" /* default */],{contentStyle:{maxWidth:'180px'},style:{height:'16px'},content:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TooltipText,null,'Inclui Tarifa de Acesso \xE0s Redes.'),arrowLocation:'topLeft'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__images_ic_info2_component_svg___default.a,{width:'16px',height:'16px'}))))));updatedList.forEach(function(item){var eleAnnualEnergy=hasElectricity?Number(item.electricityEnergy):0;var gasAnnualEnergy=hasGas?Number(item.gasEnergy):0;var monthlyEnergy=eleAnnualEnergy+gasAnnualEnergy;cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,monthlyEnergy.toFixed(2).replace('.',',')),' \u20AC')));});}else if(key==='other_services'){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(IconCell,{className:'absolute'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__DetailsModalV2_images_ic_support_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},'Outros Servi\xE7os'))));updatedList.forEach(function(item){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,'0'),' \u20AC')));});}else if(key==='refunds_discounts'){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(IconCell,{className:'absolute'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__DetailsModalV2_images_ic_discounts_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},'Reembolsos/Descontos'))));updatedList.forEach(function(item){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["h" /* currency */])(item.annualRefunds)),' \u20AC')));});}else if(key==='taxes'){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(IconCell,{className:'absolute'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__DetailsModalV2_images_ic_taxes_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},'Taxas e Impostos'))));updatedList.forEach(function(item){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["h" /* currency */])(item.annualTaxes)),' \u20AC')));});}else if(key==='annual_billing'){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(IconCell,{className:'absolute'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__DetailsModalV2_images_ic_result_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,{lighter:true},'Valor Anual'))));updatedList.forEach(function(item){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Cell,{key:_this.generateCellKey(key,item.id),cheap:item.id===mostCheap.id},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["h" /* currency */])(item.annualBilling)),' \u20AC')));});}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,{key:'compare_row_'+key,empty:empty},cells);},_this.renderBtnsRow=function(updatedList){var mostCheap=updatedList.reduce(function(prev,curr){return Number(prev.annualBilling)<Number(curr.annualBilling)?prev:curr;});var cells=[];updatedList.forEach(function(item,index){if(index===0){cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(BtnCell,null));}else{var moreInfoParams=Object.assign({},_this.props,{priceListId:item.id});if(item.electricityPriceList){moreInfoParams.id=item.electricityPriceList.id;}else if(item.gasPriceList){moreInfoParams.id=item.gasPriceList.id;}var BtnComponent=item.id===mostCheap.id?__WEBPACK_IMPORTED_MODULE_10__ButtonGradientV2__["a" /* default */]:__WEBPACK_IMPORTED_MODULE_9__ButtonOutlineV2__["a" /* default */];cells.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(BtnCell,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(BtnComponent,{onClick:function onClick(){return _this.props.onJoin(moreInfoParams);}},'Aderir ao Tarif\xE1rio')));}});return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(BtnsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(BtnCell,{className:'absolute'}),cells);},_this.renderTable=function(){var _this$props=_this.props,compareList=_this$props.compareList,simulation=_this$props.simulation;var updatedList=[simulation.results].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(compareList));return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TableWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Table,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('tbody',null,TABLE_KEYS.map(function(key){return _this.renderRow(key,updatedList);}),_this.renderBtnsRow(updatedList))));},_temp),__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CompareModalMobileV2,[{key:'render',value:function render(){var onClose=this.props.onClose;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__MobileModalV2__["a" /* default */],{setModalTriggerHeight:this.props.setModalTriggerHeight,modalTriggerHeight:this.props.modalTriggerHeight,title:'Comparar Resultados',onClose:onClose,scrollable:true},this.renderTable());}}]);return CompareModalMobileV2;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);var TooltipText=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].p(_templateObject);var TableWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject2);var Table=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].table(_templateObject3);var Row=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].tr(_templateObject4);var BtnsRow=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].tr(_templateObject5);var ListCell=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].td(_templateObject6,function(_ref2){var cheap=_ref2.cheap;return cheap&&'\n    background: linear-gradient(0deg, rgba(147, 193, 62, 0.05) 0%, rgba(147, 193, 62, 0.05) 100%), #FFF;\n  ';});var Detail=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].p(_templateObject7,function(_ref3){var defaultText=_ref3.defaultText;return defaultText&&'\n    color: #676767;\n    font-weight: 600;\n  ';},function(_ref4){var title=_ref4.title;return title&&'\n    color: #006736;\n    font-weight: 700;\n  ';},function(_ref5){var lighter=_ref5.lighter;return lighter&&'\n    color: #3E3E3E;\n  ';},function(_ref6){var bold=_ref6.bold;return bold&&'\n    font-weight: 700;\n  ';},function(_ref7){var tooltip=_ref7.tooltip;return tooltip&&'\n    display: flex;\n    align-items: center;\n    gap: 4px;\n  ';});var ServicesCell=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].td(_templateObject6,function(_ref8){var cheap=_ref8.cheap;return cheap&&'\n    background: linear-gradient(0deg, rgba(147, 193, 62, 0.05) 0%, rgba(147, 193, 62, 0.05) 100%), #FFF;\n  ';});var PriceDetails=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject8);var Cell=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].td(_templateObject9,function(_ref9){var title=_ref9.title;return title&&'\n    padding: 10px 16px;\n  ';},function(_ref10){var cheap=_ref10.cheap;return cheap&&'\n    background: linear-gradient(0deg, rgba(147, 193, 62, 0.05) 0%, rgba(147, 193, 62, 0.05) 100%), #FFF;\n  ';},function(_ref11){var center=_ref11.center;return center&&'\n    justify-content: center;\n  ';});var MedalText=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].h4(_templateObject10);var IconCell=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].td(_templateObject11);var BtnCell=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].td(_templateObject12);

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_locale_pt_js__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_locale_pt_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment_locale_pt_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_omit__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__calendar_svg__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__calendar_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__calendar_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dates__ = __webpack_require__(1460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dates__);
__WEBPACK_IMPORTED_MODULE_5_moment___default.a.locale('pt');var Icon=function Icon(){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__calendar_svg___default.a,alt:'Date'});};var defaultProps={disabled:false,required:false,screenReaderInputMessage:'',showClearDate:false,showDefaultInputIcon:false,// calendar presentation and interaction related props
orientation:__WEBPACK_IMPORTED_MODULE_9_react_dates__["HORIZONTAL_ORIENTATION"],anchorDirection:__WEBPACK_IMPORTED_MODULE_9_react_dates__["ANCHOR_LEFT"],horizontalMargin:0,withPortal:false,withFullScreenPortal:false,initialVisibleMonth:null,numberOfMonths:1,keepOpenOnDateSelect:false,reopenPickerOnClearDate:false,isRTL:false,// navigation related props
navPrev:null,navNext:null,onPrevMonthClick:function onPrevMonthClick(){},onNextMonthClick:function onNextMonthClick(){},// day presentation and interaction related props
renderDay:null,enableOutsideDays:true,isDayBlocked:function isDayBlocked(){return false;},isOutsideRange:function isOutsideRange(day){return false;},isDayHighlighted:function isDayHighlighted(){},// internationalization props
displayFormat:'DD/MM/YYYY',renderMonth:function renderMonth(month){month.locale('pt');return month.format('MMMM YYYY');},phrases:__WEBPACK_IMPORTED_MODULE_9_react_dates__["SingleDatePickerPhrases"],customInputIcon:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Icon,null)};var SingleDatePickerWrapper=function(_React$Component){__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SingleDatePickerWrapper,_React$Component);function SingleDatePickerWrapper(props){__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this,SingleDatePickerWrapper);var _this=__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this,(SingleDatePickerWrapper.__proto__||Object.getPrototypeOf(SingleDatePickerWrapper)).call(this,props));_this.state={focused:props.autoFocus,date:props.value};_this.onDateChange=_this.onDateChange.bind(_this);_this.onFocusChange=_this.onFocusChange.bind(_this);return _this;}__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(SingleDatePickerWrapper,[{key:'onDateChange',value:function onDateChange(date){this.setState({date:date});this.props.onChange&&this.props.onChange({date:date});}},{key:'onFocusChange',value:function onFocusChange(_ref){var focused=_ref.focused;this.setState({focused:focused});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(props){if(props.value!==this.state.date){this.setState({date:props.value});}}},{key:'render',value:function render(){var _state=this.state,focused=_state.focused,date=_state.date;__WEBPACK_IMPORTED_MODULE_5_moment___default.a.locale('pt');// autoFocus and initialDate are helper props for the example wrapper but are not
// props on the SingleDatePicker itself and thus, have to be omitted.
var props=__WEBPACK_IMPORTED_MODULE_7_lodash_omit___default()(this.props,['autoFocus','initialDate','value','onChange']);props=Object.assign({},defaultProps,props);return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_dates__["SingleDatePicker"],Object.assign({},props,{date:date,focused:focused,onDateChange:this.onDateChange,onFocusChange:this.onFocusChange}));}}]);return SingleDatePickerWrapper;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (SingleDatePickerWrapper);

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DetailsModalV2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ButtonOutlineV2__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ButtonGradientV2__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__BigModalV2__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_ic_network_component_svg__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_ic_network_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_ic_network_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_ic_eletricity_gas_component_svg__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_ic_eletricity_gas_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_ic_eletricity_gas_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_ic_support_component_svg__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_ic_support_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__images_ic_support_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_ic_discounts_component_svg__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_ic_discounts_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_ic_discounts_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_ic_taxes_component_svg__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_ic_taxes_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__images_ic_taxes_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_ic_result_component_svg__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_ic_result_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__images_ic_result_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_ic_check_component_svg__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_ic_check_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__images_ic_check_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_Loading__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__information_entries__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__processor__ = __webpack_require__(438);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #3e3e3e;\n  font-family: Nunito;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 150% */\n  max-width: unset;\n  padding-left: 16px;\n'],['\n  color: #3e3e3e;\n  font-family: Nunito;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 150% */\n  max-width: unset;\n  padding-left: 16px;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  flex: 1 0 0;\n'],['\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  flex: 1 0 0;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1 0 0;\n  align-self: stretch;\n\n  border: 1px solid #ececec;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1 0 0;\n  align-self: stretch;\n\n  border: 1px solid #ececec;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #1d1e22;\n  word-break: break-all;\n\n  &:visited {\n    color: #676767;\n  }\n'],['\n  color: #1d1e22;\n  word-break: break-all;\n\n  &:visited {\n    color: #676767;\n  }\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n'],['\n  width: 100%;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  flex: 1 0 0;\n  align-self: stretch;\n  overflow-y: auto;\n'],['\n  width: 100%;\n  flex: 1 0 0;\n  align-self: stretch;\n  overflow-y: auto;\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  display: flex;\n  align-items: center;\n'],['\n  width: 100%;\n  display: flex;\n  align-items: center;\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 10px 16px;\n  align-items: center;\n  gap: 4px;\n  flex: 1 0 0;\n  border-bottom: 1px solid #ececec;\n'],['\n  display: flex;\n  padding: 10px 16px;\n  align-items: center;\n  gap: 4px;\n  flex: 1 0 0;\n  border-bottom: 1px solid #ececec;\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 10px 16px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 6px;\n  flex: 1 0 0;\n  align-self: stretch;\n\n  > .content {\n    display: flex;\n    align-items: center;\n    align-content: center;\n    gap: 4px 12px;\n    align-self: stretch;\n    flex-wrap: wrap;\n\n    span {\n      display: flex;\n      padding: 4px 0px;\n      justify-content: center;\n      align-items: center;\n      gap: 4px;\n\n      color: #006736;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n    }\n  }\n'],['\n  display: flex;\n  padding: 10px 16px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 6px;\n  flex: 1 0 0;\n  align-self: stretch;\n\n  > .content {\n    display: flex;\n    align-items: center;\n    align-content: center;\n    gap: 4px 12px;\n    align-self: stretch;\n    flex-wrap: wrap;\n\n    span {\n      display: flex;\n      padding: 4px 0px;\n      justify-content: center;\n      align-items: center;\n      gap: 4px;\n\n      color: #006736;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n    }\n  }\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #006736;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 20px;\n'],['\n  color: #006736;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 20px;\n']),_templateObject11=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 1 0 0;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-wrap: wrap;\n  width: 50%;\n\n  color: ',';\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: ',';\n  line-height: 20px;\n\n  ','\n\n  > span {\n    color: #3e3e3e;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n  }\n'],['\n  flex: 1 0 0;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-wrap: wrap;\n  width: 50%;\n\n  color: ',';\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: ',';\n  line-height: 20px;\n\n  ','\n\n  > span {\n    color: #3e3e3e;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n  }\n']),_templateObject12=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 1 0 0;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  color: #3e3e3e;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: ',';\n  line-height: 20px;\n'],['\n  flex: 1 0 0;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  color: #3e3e3e;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: ',';\n  line-height: 20px;\n']),_templateObject13=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 12px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex: 1 0 0;\n  align-self: stretch;\n  cursor: pointer;\n\n  background: ',';\n\n  color: ',';\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n\n  ','\n'],['\n  display: flex;\n  padding: 12px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex: 1 0 0;\n  align-self: stretch;\n  cursor: pointer;\n\n  background: ',';\n\n  color: ',';\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n\n  ','\n']),_templateObject14=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 12px;\n  align-self: stretch;\n'],['\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 12px;\n  align-self: stretch;\n']);var DetailsModalV2=function(_Component){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(DetailsModalV2,_Component);function DetailsModalV2(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,DetailsModalV2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=DetailsModalV2.__proto__||Object.getPrototypeOf(DetailsModalV2)).call.apply(_ref,[this].concat(args))),_this),_this.state={tab:'general'},_this.toggleTab=function(value){_this.setState({tab:value});},_this.renderRow=function(field,name){var isPrice=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var suffix=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'';var fallback=arguments.length>4&&arguments[4]!==undefined?arguments[4]:'';var suffixElement=suffix?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,suffix):null;return field?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{light:true},name),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{suffix:suffix},isPrice?__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_utils__["g" /* pricesCurrency */])(field):field,' ',suffixElement)):fallback?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{light:true},name),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,null,fallback)):null;},_this.renderIdentificationLabels=function(identification,entry){var value=identification[entry]?identification[entry]:'-';if(entry==='website_contact'){value=identification.website_contact?identification.website_contact:identification.email_contact?identification.email_contact:'---';}else if(entry==='email_contact'){return null;}var content=value;if(entry==='commercial_offer_website'||entry==='website_standardized_contract_form'||entry==='website_contract_conditions'||entry==='website_contact'&&identification.website_contact){content=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Link,{href:value,target:'_blank',rel:'noopener noreferrer'},value);}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,{key:'identification_entry_'+entry},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{light:true},__WEBPACK_IMPORTED_MODULE_20__information_entries__["a" /* MERCHANT_IDENTIFICATION */][entry]),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,null,content));},_this.renderGeneralLabels=function(identification,entry,LABELS){var value=identification[entry]?identification[entry]===true?'Sim':identification[entry]:identification[entry]===false?'Não':'-';return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,{key:'general_entry_'+entry},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{light:true},LABELS[entry]),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,null,value));},_this.renderGeneralTable=function(){var tariff=_this.props.tariff.result;var timeCycle=tariff.priceListTimeCycle;var tariffInfo=_this.props.tariffInfo;return _this.state.tab==='general'&&tariff?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TableBody,null,tariff.electricityPriceList&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TitleCell,null,'Eletricidade')),tariff.electricityPriceList?_this.renderRow(tariff.prices.electricity.termo_fixo,'Termo Potência*',true,'€/Dia'):null,tariff.electricityPriceList&&timeCycle==='s'?_this.renderRow(tariff.prices.electricity.cheia,'Energia*',true,'€/kWh'):null,tariff.electricityPriceList&&timeCycle!=='s'?_this.renderRow(tariff.prices.electricity.vazio,'Vazio*',true,'€/kWh'):null,tariff.electricityPriceList&&timeCycle==='b'?_this.renderRow(tariff.prices.electricity.cheia,'Fora do Vazio*',true,'€/kWh'):null,tariff.electricityPriceList&&timeCycle!=='s'&&timeCycle!=='b'?_this.renderRow(tariff.prices.electricity.ponta,'Ponta*',true,'€/kWh'):null,tariff.electricityPriceList&&timeCycle!=='s'&&timeCycle!=='b'?_this.renderRow(tariff.prices.electricity.cheia,'Cheias*',true,'€/kWh'):null,tariff.electricityPriceList&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{light:true},'Tarif\xE1rio'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{suffix:true},timeCycle==='s'?'Simples':timeCycle==='b'?'Bi-Horário':'Tri-Horário')),tariff.gasPriceList&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TitleCell,null,'G\xE1s Natural')),tariff.gasPriceList&&_this.renderRow(tariff.prices.gas.termo_fixo,'Termo Fixo*',true,'€/Dia'),tariff.gasPriceList&&_this.renderRow(tariff.prices.gas.termo_energia,'Energia*',true,'€/kWh'),tariff.gasPriceList&&_this.renderRow(tariff.gasStage,'Escalão',false),tariffInfo.additional_services.length?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TitleCell,null,'Ofertas Comerciais')):null,tariffInfo.additional_services.length?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(AdditionalServicesRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'content'},tariffInfo.additional_services.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{key:'additional_service_'+index+'_'+item},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__images_ic_check_component_svg___default.a,null),item.name);}))):null):null;},_this.renderInvoicingTable=function(){var tariff=_this.props.tariff.result;var suffix=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,'\u20AC');var eleAnnualFixedTerm=tariff.electricityFixedTerm?Number(tariff.electricityFixedTerm):0;var gasAnnualFixedTerm=tariff.gasFixedTerm?Number(tariff.gasFixedTerm):0;var monthlyNetworkAccess=(eleAnnualFixedTerm+gasAnnualFixedTerm)/12;var eleAnnualEnergy=tariff.electricityEnergy?Number(tariff.electricityEnergy):0;var gasAnnualEnergy=tariff.gasEnergy?Number(tariff.gasEnergy):0;var monthlyEnergy=(eleAnnualEnergy+gasAnnualEnergy)/12;return _this.state.tab==='invoicing'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TableBody,null,tariff.electricityPriceList&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TitleCell,null,'Eletricidade')),tariff.electricityPriceList&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InvoiceCell,{light:true},'Termo Pot\xEAncia*'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{suffix:true},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_utils__["h" /* currency */])(tariff.electricityFixedTerm/12),suffix)),tariff.electricityPriceList&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InvoiceCell,{light:true},'Custo de Energia*'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{suffix:true},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_utils__["h" /* currency */])(tariff.electricityEnergy/12),suffix)),tariff.gasPriceList&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TitleCell,null,'G\xE1s Natural')),tariff.gasPriceList&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InvoiceCell,{light:true},'Termo Fixo*'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{suffix:true},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_utils__["h" /* currency */])(tariff.gasFixedTerm/12),suffix)),tariff.gasPriceList&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InvoiceCell,{light:true},'Custo de Energia*'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{suffix:true},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_utils__["h" /* currency */])(tariff.gasEnergy/12),suffix)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TitleCell,null,'Detalhes')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InvoiceCell,{light:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__images_ic_network_component_svg___default.a,null),'Pot\xEAncia'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{suffix:true},monthlyNetworkAccess.toFixed(2).replace('.',','),suffix)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InvoiceCell,{light:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__images_ic_eletricity_gas_component_svg___default.a,null),'Energia'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{suffix:true},monthlyEnergy.toFixed(2).replace('.',','),suffix)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InvoiceCell,{light:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__images_ic_support_component_svg___default.a,null),' Outros Servi\xE7os'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{suffix:true},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_utils__["h" /* currency */])(tariff.additionalServicesCost/12),suffix)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InvoiceCell,{light:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__images_ic_discounts_component_svg___default.a,null),' Reembolsos/Descontos'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{suffix:true},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_utils__["h" /* currency */])(tariff.annualRefunds/12),suffix)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InvoiceCell,{light:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__images_ic_taxes_component_svg___default.a,null),' Taxas e Impostos'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{suffix:true},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_utils__["h" /* currency */])(tariff.annualTaxes/12),suffix)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InvoiceCell,{light:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__images_ic_result_component_svg___default.a,null),' Valor Mensal'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{suffix:true},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_utils__["h" /* currency */])(tariff.annualBilling/12),suffix))):null;},_this.renderMoreInfoTable=function(){var tariffInfo=_this.props.tariffInfo;var additionalInfo=tariffInfo.pricelistadditionalinfo;var identification=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__processor__["a" /* processIdentification */])(tariffInfo,additionalInfo);var comercial=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__processor__["b" /* processComercial */])(tariffInfo,additionalInfo);var additionalServices=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__processor__["c" /* processAdditionalServices */])(tariffInfo,additionalInfo);var refunds=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__processor__["d" /* processRefunds */])(additionalInfo);return _this.state.tab==='moreInfo'&&tariffInfo?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TableBody,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TitleCell,null,__WEBPACK_IMPORTED_MODULE_20__information_entries__["b" /* TITLES */].IDENTIFICATION)),Object.keys(identification).map(function(entry){return _this.renderIdentificationLabels(identification,entry);}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TitleCell,null,__WEBPACK_IMPORTED_MODULE_20__information_entries__["b" /* TITLES */].COMERCIAL_CONDITIONS)),Object.keys(comercial).map(function(entry){return _this.renderGeneralLabels(comercial,entry,__WEBPACK_IMPORTED_MODULE_20__information_entries__["c" /* COMERCIAL_CONDITIONS */]);}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TitleCell,null,__WEBPACK_IMPORTED_MODULE_20__information_entries__["b" /* TITLES */].ADDITIONAL_SERVICES)),Object.keys(additionalServices).map(function(entry){return _this.renderGeneralLabels(additionalServices,entry,__WEBPACK_IMPORTED_MODULE_20__information_entries__["d" /* ADDITIONAL_SERVICES */]);}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TitleCell,null,__WEBPACK_IMPORTED_MODULE_20__information_entries__["b" /* TITLES */].REFUNDS)),Object.keys(refunds).map(function(entry){return _this.renderGeneralLabels(refunds,entry,__WEBPACK_IMPORTED_MODULE_20__information_entries__["e" /* REFUNDS_ENTRIES */]);})):null;},_this.renderWarningText=function(){var tab=_this.state.tab;return tab==='general'||tab==='invoicing'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WarningText,null,'* Os pre\xE7os inluem a tarifa de acesso \xE0s redes.'):null;},_this.renderBtns=function(){var _this$props=_this.props,hasBtns=_this$props.hasBtns,onClose=_this$props.onClose,tariff=_this$props.tariff,onJoin=_this$props.onJoin;return hasBtns?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ButtonsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ButtonOutlineV2__["a" /* default */],{style:{width:'115px'},onClick:onClose},'Cancelar'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ButtonGradientV2__["a" /* default */],{style:{width:'115px'},onClick:function onClick(){return onJoin(tariff);}},'Aderir')):null;},_temp),__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(DetailsModalV2,[{key:'render',value:function render(){var _this2=this;var _props=this.props,title=_props.title,onClose=_props.onClose,tariffInfo=_props.tariffInfo,loading=_props.loading,restProps=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props,['title','onClose','tariffInfo','loading']);var tab=this.state.tab;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__BigModalV2__["a" /* default */],{modalTriggerHeight:this.props.modalTriggerHeight,setModalTriggerHeight:this.props.setModalTriggerHeight,style:{width:'750px'},title:'Detalhes do tarif\xE1rio',onClose:onClose},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Wrapper,restProps,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Content,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TableHeader,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TopRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ToggleButton,{active:tab==='general',onClick:function onClick(){return _this2.toggleTab('general');}},'Pre\xE7os e Condi\xE7\xF5es'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ToggleButton,{active:tab==='invoicing',onClick:function onClick(){return _this2.toggleTab('invoicing');}},'Fatura Mensal Estimada'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ToggleButton,{active:tab==='moreInfo',onClick:function onClick(){return _this2.toggleTab('moreInfo');}},'Informa\xE7\xE3o Geral'))),!tariffInfo&&loading&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Loading__["a" /* default */],null),tariffInfo&&this.renderGeneralTable(),this.renderInvoicingTable(),tariffInfo&&this.renderMoreInfoTable(),this.renderWarningText()),this.renderBtns()));}}]);return DetailsModalV2;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);var WarningText=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].p(_templateObject);var Wrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject2);var Content=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].table(_templateObject3);var Link=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].a(_templateObject4);var TableHeader=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].thead(_templateObject5);var TableBody=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].tbody(_templateObject6);var TopRow=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].tr(_templateObject7);var Row=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].tr(_templateObject8);var AdditionalServicesRow=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].tr(_templateObject9);var TitleCell=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].td(_templateObject10);var ContentCell=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].td(_templateObject11,function(_ref2){var light=_ref2.light;return light?'#676767':'#1D1E22';},function(_ref3){var light=_ref3.light;return light?'600':'400';},function(_ref4){var suffix=_ref4.suffix;return suffix&&'\n    font-weight: 700;\n  ';});var InvoiceCell=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].td(_templateObject12,function(_ref5){var light=_ref5.light;return light?'400':'600';});var ToggleButton=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].th(_templateObject13,function(_ref6){var active=_ref6.active;return active?'#fff':'#EFEFEF';},function(_ref7){var active=_ref7.active;return active?'#1D1E22':'#3E3E3E';},function(_ref8){var active=_ref8.active;return active&&'\n    border-bottom: 2px solid #006736;\n  ';});var ButtonsRow=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject14);

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DetailsModalMobileV2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ButtonOutlineV2__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ButtonGradientV2__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MobileModalV2__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_ic_network_component_svg__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_ic_network_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_ic_network_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_ic_eletricity_gas_component_svg__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_ic_eletricity_gas_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_ic_eletricity_gas_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_ic_support_component_svg__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_ic_support_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__images_ic_support_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_ic_discounts_component_svg__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_ic_discounts_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_ic_discounts_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_ic_taxes_component_svg__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_ic_taxes_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__images_ic_taxes_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_ic_result_component_svg__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_ic_result_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__images_ic_result_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_ic_check_component_svg__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_ic_check_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__images_ic_check_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_Loading__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__information_entries__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__processor__ = __webpack_require__(438);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #3e3e3e;\n  font-family: Nunito;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 150% */\n  max-width: unset;\n  padding-left: 16px;\n'],['\n  color: #3e3e3e;\n  font-family: Nunito;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 150% */\n  max-width: unset;\n  padding-left: 16px;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 12px;\n  padding: 20px;\n  align-self: stretch;\n\n  > div:first-child,\n  > button {\n    width: 100%;\n  }\n\n  @media screen and (min-width: 600px) {\n    > div:first-child,\n    > button {\n      width: 115px;\n    }\n  }\n'],['\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 12px;\n  padding: 20px;\n  align-self: stretch;\n\n  > div:first-child,\n  > button {\n    width: 100%;\n  }\n\n  @media screen and (min-width: 600px) {\n    > div:first-child,\n    > button {\n      width: 115px;\n    }\n  }\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  flex: 1 0 0;\n  width: 100%;\n'],['\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  flex: 1 0 0;\n  width: 100%;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #1d1e22;\n  word-break: break-all;\n\n  &:visited {\n    color: #676767;\n  }\n'],['\n  color: #1d1e22;\n  word-break: break-all;\n\n  &:visited {\n    color: #676767;\n  }\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1 0 0;\n  align-self: stretch;\n\n  border: 1px solid #ececec;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1 0 0;\n  align-self: stretch;\n\n  border: 1px solid #ececec;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n'],['\n  width: 100%;\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  flex: 1 0 0;\n  align-self: stretch;\n  overflow-y: auto;\n'],['\n  width: 100%;\n  flex: 1 0 0;\n  align-self: stretch;\n  overflow-y: auto;\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  display: flex;\n  align-items: center;\n  overflow-x: auto;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n'],['\n  width: 100%;\n  display: flex;\n  align-items: center;\n  overflow-x: auto;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 10px 16px;\n  align-items: center;\n  gap: 6px;\n  flex: 1 0 0;\n  border-bottom: 1px solid #ececec;\n'],['\n  display: flex;\n  padding: 10px 16px;\n  align-items: center;\n  gap: 6px;\n  flex: 1 0 0;\n  border-bottom: 1px solid #ececec;\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 10px 16px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 6px;\n  flex: 1 0 0;\n  align-self: stretch;\n\n  > .content {\n    display: flex;\n    align-items: center;\n    align-content: center;\n    gap: 4px 12px;\n    align-self: stretch;\n    flex-wrap: wrap;\n\n    span {\n      display: flex;\n      padding: 4px 0px;\n      justify-content: center;\n      align-items: center;\n      gap: 4px;\n\n      color: #006736;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n    }\n  }\n'],['\n  display: flex;\n  padding: 10px 16px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 6px;\n  flex: 1 0 0;\n  align-self: stretch;\n\n  > .content {\n    display: flex;\n    align-items: center;\n    align-content: center;\n    gap: 4px 12px;\n    align-self: stretch;\n    flex-wrap: wrap;\n\n    span {\n      display: flex;\n      padding: 4px 0px;\n      justify-content: center;\n      align-items: center;\n      gap: 4px;\n\n      color: #006736;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n    }\n  }\n']),_templateObject11=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #006736;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 20px;\n'],['\n  color: #006736;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 20px;\n']),_templateObject12=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 1 0 0;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-wrap: wrap;\n  width: 50%;\n  word-break: break-all;\n\n  color: ',';\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: ',';\n  line-height: 20px;\n\n  ','\n\n  > span {\n    color: #3e3e3e;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n  }\n'],['\n  flex: 1 0 0;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-wrap: wrap;\n  width: 50%;\n  word-break: break-all;\n\n  color: ',';\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: ',';\n  line-height: 20px;\n\n  ','\n\n  > span {\n    color: #3e3e3e;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n  }\n']),_templateObject13=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 1 0 0;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  word-break: break-all;\n\n  color: #3e3e3e;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: ',';\n  line-height: 20px;\n'],['\n  flex: 1 0 0;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  word-break: break-all;\n\n  color: #3e3e3e;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: ',';\n  line-height: 20px;\n']),_templateObject14=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 12px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex: 1 0 0;\n  align-self: stretch;\n  cursor: pointer;\n  min-width: 150px;\n\n  background: ',';\n\n  color: ',';\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n\n  ','\n'],['\n  display: flex;\n  padding: 12px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex: 1 0 0;\n  align-self: stretch;\n  cursor: pointer;\n  min-width: 150px;\n\n  background: ',';\n\n  color: ',';\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n\n  ','\n']);var DetailsModalMobileV2=function(_Component){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(DetailsModalMobileV2,_Component);function DetailsModalMobileV2(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,DetailsModalMobileV2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=DetailsModalMobileV2.__proto__||Object.getPrototypeOf(DetailsModalMobileV2)).call.apply(_ref,[this].concat(args))),_this),_this.state={tab:'general'},_this.toggleTab=function(value){_this.setState({tab:value});},_this.renderRow=function(field,name){var isPrice=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var suffix=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'';var fallback=arguments.length>4&&arguments[4]!==undefined?arguments[4]:'';var suffixElement=suffix?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,suffix):null;return field?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{light:true},name),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{suffix:suffix},isPrice?__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_utils__["g" /* pricesCurrency */])(field):field,' ',suffixElement)):fallback?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{light:true},name),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,null,fallback)):null;},_this.renderIdentificationLabels=function(identification,entry){var value=identification[entry]?identification[entry]:'-';if(entry==='website_contact'){value=identification.website_contact?identification.website_contact:identification.email_contact?identification.email_contact:'---';}else if(entry==='email_contact'){return null;}var content=value;if(entry==='commercial_offer_website'||entry==='website_standardized_contract_form'||entry==='website_contract_conditions'||entry==='website_contact'&&identification.website_contact){content=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Link,{href:value,target:'_blank',rel:'noopener noreferrer'},value);}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,{key:'identification_entry_'+entry},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{light:true},__WEBPACK_IMPORTED_MODULE_20__information_entries__["a" /* MERCHANT_IDENTIFICATION */][entry]),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,null,content));},_this.renderGeneralLabels=function(identification,entry,LABELS){var value=identification[entry]?identification[entry]===true?'Sim':identification[entry]:identification[entry]===false?'Não':'-';return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,{key:'general_entry_'+entry},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{light:true},LABELS[entry]),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,null,value));},_this.renderGeneralTable=function(){var tariff=_this.props.tariff.result;var timeCycle=tariff.priceListTimeCycle;var tariffInfo=_this.props.tariffInfo;return _this.state.tab==='general'&&tariff?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TableBody,null,tariff.electricityPriceList&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TitleCell,null,'Eletricidade')),tariff.electricityPriceList?_this.renderRow(tariff.prices.electricity.termo_fixo,'Termo Potência*',true,'€/Dia'):null,tariff.electricityPriceList&&timeCycle==='s'?_this.renderRow(tariff.prices.electricity.cheia,'Energia*',true,'€/kWh'):null,tariff.electricityPriceList&&timeCycle!=='s'?_this.renderRow(tariff.prices.electricity.vazio,'Vazio*',true,'€/kWh'):null,tariff.electricityPriceList&&timeCycle==='b'?_this.renderRow(tariff.prices.electricity.cheia,'Fora do Vazio*',true,'€/kWh'):null,tariff.electricityPriceList&&timeCycle!=='s'&&timeCycle!=='b'?_this.renderRow(tariff.prices.electricity.ponta,'Ponta*',true,'€/kWh'):null,tariff.electricityPriceList&&timeCycle!=='s'&&timeCycle!=='b'?_this.renderRow(tariff.prices.electricity.cheia,'Cheias*',true,'€/kWh'):null,tariff.electricityPriceList&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{light:true},'Tarif\xE1rio'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{suffix:true},timeCycle==='s'?'Simples':timeCycle==='b'?'Bi-Horário':'Tri-Horário')),tariff.gasPriceList&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TitleCell,null,'G\xE1s Natural')),tariff.gasPriceList&&_this.renderRow(tariff.prices.gas.termo_fixo,'Termo Fixo*',true,'€/Dia'),tariff.gasPriceList&&_this.renderRow(tariff.prices.gas.termo_energia,'Energia*',true,'€/kWh'),tariff.gasPriceList&&_this.renderRow(tariff.gasStage,'Escalão',false),tariffInfo.additional_services.length?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TitleCell,null,'Ofertas Comerciais')):null,tariffInfo.additional_services.length?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(AdditionalServicesRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'content'},tariffInfo.additional_services.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{key:'additional_service_'+index+'_'+item},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__images_ic_check_component_svg___default.a,null),item.name);}))):null):null;},_this.renderInvoicingTable=function(){var tariff=_this.props.tariff.result;var suffix=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,'\u20AC');var eleAnnualFixedTerm=tariff.electricityFixedTerm?Number(tariff.electricityFixedTerm):0;var gasAnnualFixedTerm=tariff.gasFixedTerm?Number(tariff.gasFixedTerm):0;var monthlyNetworkAccess=(eleAnnualFixedTerm+gasAnnualFixedTerm)/12;var eleAnnualEnergy=tariff.electricityEnergy?Number(tariff.electricityEnergy):0;var gasAnnualEnergy=tariff.gasEnergy?Number(tariff.gasEnergy):0;var monthlyEnergy=(eleAnnualEnergy+gasAnnualEnergy)/12;return _this.state.tab==='invoicing'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TableBody,null,tariff.electricityPriceList&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TitleCell,null,'Eletricidade')),tariff.electricityPriceList&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InvoiceCell,{light:true},'Termo Pot\xEAncia*'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{suffix:true},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_utils__["h" /* currency */])(tariff.electricityFixedTerm/12),suffix)),tariff.electricityPriceList&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InvoiceCell,{light:true},'Custo de Energia*'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{suffix:true},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_utils__["h" /* currency */])(tariff.electricityEnergy/12),suffix)),tariff.electricityPriceList&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{light:true},'Tarif\xE1rio'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{suffix:true},tariff.priceListTimeCycle==='s'?'Simples':tariff.priceListTimeCycle==='b'?'Bi-Horário':'Tri-Horário')),tariff.gasPriceList&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TitleCell,null,'G\xE1s Natural')),tariff.gasPriceList&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InvoiceCell,{light:true},'Termo Fixo*'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{suffix:true},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_utils__["h" /* currency */])(tariff.gasFixedTerm/12),suffix)),tariff.gasPriceList&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InvoiceCell,{light:true},'Custo de Energia*'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{suffix:true},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_utils__["h" /* currency */])(tariff.gasEnergy/12),suffix)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TitleCell,null,'Detalhes')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InvoiceCell,{light:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__images_ic_network_component_svg___default.a,null),'Pot\xEAncia'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{suffix:true},monthlyNetworkAccess.toFixed(2).replace('.',','),suffix)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InvoiceCell,{light:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__images_ic_eletricity_gas_component_svg___default.a,null),'Energia'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{suffix:true},monthlyEnergy.toFixed(2).replace('.',','),suffix)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InvoiceCell,{light:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__images_ic_support_component_svg___default.a,null),' Outros Servi\xE7os'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{suffix:true},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_utils__["h" /* currency */])(tariff.additionalServicesCost/12),suffix)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InvoiceCell,{light:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__images_ic_discounts_component_svg___default.a,null),' Reembolsos/Descontos'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{suffix:true},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_utils__["h" /* currency */])(tariff.annualRefunds/12),suffix)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InvoiceCell,{light:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__images_ic_taxes_component_svg___default.a,null),' Taxas e Impostos'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{suffix:true},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_utils__["h" /* currency */])(tariff.annualTaxes/12),suffix)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InvoiceCell,{light:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__images_ic_result_component_svg___default.a,null),' Valor Mensal'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContentCell,{suffix:true},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_utils__["h" /* currency */])(tariff.annualBilling/12),suffix))):null;},_this.renderMoreInfoTable=function(){var tariffInfo=_this.props.tariffInfo;var additionalInfo=tariffInfo.pricelistadditionalinfo;var identification=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__processor__["a" /* processIdentification */])(tariffInfo,additionalInfo);var comercial=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__processor__["b" /* processComercial */])(tariffInfo,additionalInfo);var additionalServices=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__processor__["c" /* processAdditionalServices */])(tariffInfo,additionalInfo);var refunds=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__processor__["d" /* processRefunds */])(additionalInfo);return _this.state.tab==='moreInfo'&&tariffInfo?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TableBody,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TitleCell,null,__WEBPACK_IMPORTED_MODULE_20__information_entries__["b" /* TITLES */].IDENTIFICATION)),Object.keys(identification).map(function(entry){return _this.renderIdentificationLabels(identification,entry);}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TitleCell,null,__WEBPACK_IMPORTED_MODULE_20__information_entries__["b" /* TITLES */].COMERCIAL_CONDITIONS)),Object.keys(comercial).map(function(entry){return _this.renderGeneralLabels(comercial,entry,__WEBPACK_IMPORTED_MODULE_20__information_entries__["c" /* COMERCIAL_CONDITIONS */]);}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TitleCell,null,__WEBPACK_IMPORTED_MODULE_20__information_entries__["b" /* TITLES */].ADDITIONAL_SERVICES)),Object.keys(additionalServices).map(function(entry){return _this.renderGeneralLabels(additionalServices,entry,__WEBPACK_IMPORTED_MODULE_20__information_entries__["d" /* ADDITIONAL_SERVICES */]);}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TitleCell,null,__WEBPACK_IMPORTED_MODULE_20__information_entries__["b" /* TITLES */].REFUNDS)),Object.keys(refunds).map(function(entry){return _this.renderGeneralLabels(refunds,entry,__WEBPACK_IMPORTED_MODULE_20__information_entries__["e" /* REFUNDS_ENTRIES */]);})):null;},_this.renderWarningText=function(){var tab=_this.state.tab;return tab==='general'||tab==='invoicing'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WarningText,null,'* Os pre\xE7os inluem a tarifa de acesso \xE0s redes.'):null;},_this.renderBtns=function(){var _this$props=_this.props,hasBtns=_this$props.hasBtns,onClose=_this$props.onClose,tariff=_this$props.tariff,onJoin=_this$props.onJoin;return hasBtns?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ButtonsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ButtonOutlineV2__["a" /* default */],{onClick:onClose},'Cancelar'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ButtonGradientV2__["a" /* default */],{onClick:function onClick(){return onJoin(tariff);}},'Aderir')):null;},_temp),__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(DetailsModalMobileV2,[{key:'render',value:function render(){var _this2=this;var _props=this.props,title=_props.title,onClose=_props.onClose,tariffInfo=_props.tariffInfo,tariff=_props.tariff,loading=_props.loading,restProps=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props,['title','onClose','tariffInfo','tariff','loading']);var tab=this.state.tab;var logo=tariff.result.electricityPriceList?tariff.result.electricityPriceList.entity.hi_res_logo:tariff.result.gasPriceList?tariff.result.gasPriceList.entity.hi_res_logo:null;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__MobileModalV2__["a" /* default */],{setModalTriggerHeight:this.props.setModalTriggerHeight,modalTriggerHeight:this.props.modalTriggerHeight,title:'Detalhes do tarif\xE1rio',logo:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_utils__["f" /* generateMediaUrl */])(logo),onClose:onClose},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Wrapper,restProps,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Content,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TableHeader,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TopRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ToggleButton,{active:tab==='general',onClick:function onClick(){return _this2.toggleTab('general');}},'Informa\xE7\xE3o Geral'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ToggleButton,{active:tab==='invoicing',onClick:function onClick(){return _this2.toggleTab('invoicing');}},'Fatura Mensal Estimada'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ToggleButton,{active:tab==='moreInfo',onClick:function onClick(){return _this2.toggleTab('moreInfo');}},'Mais informa\xE7\xF5es'))),!tariffInfo&&loading&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Loading__["a" /* default */],null),tariffInfo&&this.renderGeneralTable(),this.renderInvoicingTable(),tariffInfo&&this.renderMoreInfoTable(),this.renderWarningText()),this.renderBtns()));}}]);return DetailsModalMobileV2;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);var WarningText=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].p(_templateObject);var ButtonsRow=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject2);var Wrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject3);var Link=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].a(_templateObject4);var Content=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].table(_templateObject5);var TableHeader=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].thead(_templateObject6);var TableBody=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].tbody(_templateObject7);var TopRow=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].tr(_templateObject8);var Row=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].tr(_templateObject9);var AdditionalServicesRow=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].tr(_templateObject10);var TitleCell=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].td(_templateObject11);var ContentCell=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].td(_templateObject12,function(_ref2){var light=_ref2.light;return light?'#676767':'#1D1E22';},function(_ref3){var light=_ref3.light;return light?'600':'400';},function(_ref4){var suffix=_ref4.suffix;return suffix&&'\n    font-weight: 700;\n  ';});var InvoiceCell=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].td(_templateObject13,function(_ref5){var light=_ref5.light;return light?'400':'600';});var ToggleButton=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].th(_templateObject14,function(_ref6){var active=_ref6.active;return active?'#fff':'#EFEFEF';},function(_ref7){var active=_ref7.active;return active?'#1D1E22':'#3E3E3E';},function(_ref8){var active=_ref8.active;return active&&'\n    border-bottom: 2px solid #006736;\n  ';});

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_grayscale_svg__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_grayscale_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_grayscale_svg__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display:inline-block;\n  width: 60px;\n  position: relative;\n  background-color: #FFFFFF;\n\n  flex: 1 1 auto;\n  color: #676767;\n  opacity: 0.6;\n\n  ','\n\n  margin-left: 10px;\n  margin-right: 10px;\n\n  &:first-child {\n    margin-left: 0px;\n  }\n\n  &:last-child {\n    margin-right: 0px;\n  }\n\n  transition: opacity 0.2s ease-in, color 0.2s ease-in;\n  text-align:center;\n\n  &:hover {\n    > img {\n      -webkit-filter: grayscale(100%);\n      filter: grayscale(100%);\n      filter: gray;\n      filter: url("','#greyscale");\n    }\n    > span {\n      color: #3E3E3E;\n    }\n    opacity: 1.0;\n  }\n'],['\n  display:inline-block;\n  width: 60px;\n  position: relative;\n  background-color: #FFFFFF;\n\n  flex: 1 1 auto;\n  color: #676767;\n  opacity: 0.6;\n\n  ','\n\n  margin-left: 10px;\n  margin-right: 10px;\n\n  &:first-child {\n    margin-left: 0px;\n  }\n\n  &:last-child {\n    margin-right: 0px;\n  }\n\n  transition: opacity 0.2s ease-in, color 0.2s ease-in;\n  text-align:center;\n\n  &:hover {\n    > img {\n      -webkit-filter: grayscale(100%);\n      filter: grayscale(100%);\n      filter: gray;\n      filter: url("','#greyscale");\n    }\n    > span {\n      color: #3E3E3E;\n    }\n    opacity: 1.0;\n  }\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  transition: filter 0.2s ease-in;\n  width: 35px;\n  height: 35px;\n  margin: 0 auto;\n\n  ','\n'],['\n  display: block;\n  transition: filter 0.2s ease-in;\n  width: 35px;\n  height: 35px;\n  margin: 0 auto;\n\n  ','\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  -webkit-transition: color 0.2s ease-in;\n  -moz-transition: color 0.2s ease-in;\n  -ms-transition: color 0.2s ease-in;\n  -o-transition: color 0.2s ease-in;\n  transition: color 0.2s ease-in;\n\n  color: #676767;\n\n  ','\n  display: inline-block;\n\n  font-family: Nunito;\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 12px;\n  text-align: center;\n'],['\n  -webkit-transition: color 0.2s ease-in;\n  -moz-transition: color 0.2s ease-in;\n  -ms-transition: color 0.2s ease-in;\n  -o-transition: color 0.2s ease-in;\n  transition: color 0.2s ease-in;\n\n  color: #676767;\n\n  ','\n  display: inline-block;\n\n  font-family: Nunito;\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 12px;\n  text-align: center;\n']);var DivisionNavbarItem=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DivisionNavbarItem,_Component);function DivisionNavbarItem(){__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,DivisionNavbarItem);return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(DivisionNavbarItem.__proto__||Object.getPrototypeOf(DivisionNavbarItem)).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DivisionNavbarItem,[{key:'componentDidMount',value:function componentDidMount(){this.props.onComponentLoaded&&this.props.onComponentLoaded();}},{key:'render',value:function render(){var _props=this.props,className=_props.className,icon=_props.icon,title=_props.title,selected=_props.selected,onClick=_props.onClick;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Container,{className:className,onClick:onClick,selected:selected},icon&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Image,{src:__WEBPACK_IMPORTED_MODULE_7_config__["e" /* MEDIA_BASE_URL */]+icon,alt:title,selected:selected,gray:__WEBPACK_IMPORTED_MODULE_8__images_grayscale_svg___default.a}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Title,{selected:selected},title));}}]);return DivisionNavbarItem;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DivisionNavbarItem);var Container=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject,function(_ref){var selected=_ref.selected;return selected&&'\n    opacity: 1.0;\n  ';},function(_ref2){var gray=_ref2.gray;return gray;});var Image=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].img(_templateObject2,function(_ref3){var selected=_ref3.selected;return selected&&'\n    -webkit-filter: grayscale(100%);\n    filter: grayscale(100%);\n    filter: gray;\n    filter: url("'+function(_ref4){var gray=_ref4.gray;return gray;}+'#greyscale");\n  ';});var Title=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject3,function(_ref5){var selected=_ref5.selected;return selected&&'\n    color: #3E3E3E;\n  ';});

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_ic_arrow_component_svg__ = __webpack_require__(1621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_ic_arrow_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_ic_arrow_component_svg__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  height: 32px;\n  padding: 12px 6px;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n\n  cursor: pointer;\n\n  h3 {\n    color: #3e3e3e;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 20px;\n    text-transform: none;\n    text-align: left;\n    margin: 0;\n  }\n\n  &:hover {\n    background-color: #fcfcfc;\n  }\n\n  &:focus {\n    border: 1px solid #5c5c5c;\n  }\n'],['\n  display: flex;\n  height: 32px;\n  padding: 12px 6px;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n\n  cursor: pointer;\n\n  h3 {\n    color: #3e3e3e;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 20px;\n    text-transform: none;\n    text-align: left;\n    margin: 0;\n  }\n\n  &:hover {\n    background-color: #fcfcfc;\n  }\n\n  &:focus {\n    border: 1px solid #5c5c5c;\n  }\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 24px;\n  height: 24px;\n  transition: transform 0.1s ease-in;\n\n  ','\n'],['\n  width: 24px;\n  height: 24px;\n  transition: transform 0.1s ease-in;\n\n  ','\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n'],['\n  width: 100%;\n']);var DropdownV2=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DropdownV2,_Component);function DropdownV2(props){__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,DropdownV2);// Initial state: dropdown is closed
var _this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(DropdownV2.__proto__||Object.getPrototypeOf(DropdownV2)).call(this,props));_this.toggleDropdown=function(){_this.setState(function(prevState){return{isOpen:!prevState.isOpen};});};_this.state={isOpen:props.isOpen||false};return _this;}// Toggle the dropdown open/close state
__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DropdownV2,[{key:'render',value:function render(){var _props=this.props,title=_props.title,children=_props.children,style=_props.style;var isOpen=this.state.isOpen;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Wrapper,{style:style},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ClickableArea,{onClick:this.toggleDropdown,onKeyDown:this.toggleDropdown,role:'combobox','aria-haspopup':true,tabIndex:0,'aria-labelledby':'dropdown-label','aria-expanded':isOpen,'aria-controls':'dropdown-content-id'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('h3',null,title),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Arrow,{isOpen:isOpen},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__images_ic_arrow_component_svg___default.a,null))),isOpen&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Content,{id:'dropdown-content-id',role:'listbox','aria-labelledby':'dropdown-label'},children));}}]);return DropdownV2;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DropdownV2);var Wrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject);var ClickableArea=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject2);var Arrow=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject3,function(_ref){var isOpen=_ref.isOpen;return!isOpen&&'\n    transform: rotate(180deg);\n  ';});var Content=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject4);

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Icon */
/* unused harmony export Wrapper */
/* unused harmony export DefaultSelector */
/* unused harmony export DefaultList */
/* unused harmony export DefaultListOpened */
/* unused harmony export Item */
/* unused harmony export Checkbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_find__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isEqual__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isArray__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_findIndex__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_map__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_remove__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_remove___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_remove__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_onclickoutside__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_ic_arrow_more_svg__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_ic_arrow_more_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_ic_arrow_more_svg__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 35px;\n  height: 35px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 10px;\n'],['\n  width: 35px;\n  height: 35px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 10px;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: relative;\n  max-width: 200px;\n'],['\n  position: relative;\n  max-width: 200px;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding: 15px 16px;\n  font-size: 14px;\n  line-height: 18px;\n  font-weight: bold;\n  background-color: #ffffff;\n  color: #9c9c9c;\n  display: flex;\n  align-items: center;\n  background-position: right center;\n  background-repeat: no-repeat;\n  border: 1px solid #efefef;\n  cursor: pointer;\n  position: relative;\n\n  &::after {\n    content: \' \';\n    display: block;\n    background-image: url(',');\n    background-size: contain;\n    width: 12px;\n    height: 12px;\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n    background-repeat: no-repeat;\n    background-position: center;\n\n    ','\n  }\n\n  &.selected {\n    color: #3e3e3e;\n    font-weight: bold;\n  }\n\n  &[disabled] {\n    background-color: transparent;\n    border: 0;\n    color: #676767;\n    opacity: 0.5;\n    pointer-events: none;\n  }\n\n  &:focus {\n    border-color: #93c13e;\n  }\n\n  background-position: 16px center;\n  background-repeat: no-repeat;\n  background-size: 16.5px;\n\n  ','\n  ','\n'],['\n  padding: 15px 16px;\n  font-size: 14px;\n  line-height: 18px;\n  font-weight: bold;\n  background-color: #ffffff;\n  color: #9c9c9c;\n  display: flex;\n  align-items: center;\n  background-position: right center;\n  background-repeat: no-repeat;\n  border: 1px solid #efefef;\n  cursor: pointer;\n  position: relative;\n\n  &::after {\n    content: \' \';\n    display: block;\n    background-image: url(',');\n    background-size: contain;\n    width: 12px;\n    height: 12px;\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n    background-repeat: no-repeat;\n    background-position: center;\n\n    ','\n  }\n\n  &.selected {\n    color: #3e3e3e;\n    font-weight: bold;\n  }\n\n  &[disabled] {\n    background-color: transparent;\n    border: 0;\n    color: #676767;\n    opacity: 0.5;\n    pointer-events: none;\n  }\n\n  &:focus {\n    border-color: #93c13e;\n  }\n\n  background-position: 16px center;\n  background-repeat: no-repeat;\n  background-size: 16.5px;\n\n  ','\n  ','\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 0;\n  opacity: 0;\n  width: 100%;\n  max-height: 200px;\n  overflow: auto;\n  border: 1px solid #efefef;\n  border-top: 0;\n  border-radius: 0 2px 2px 0;\n  box-shadow: 0 0 0 1px #efefef;\n  transition: all 0.4s ease-in-out;\n  background: #fff;\n  position: absolute;\n  z-index: 55;\n'],['\n  height: 0;\n  opacity: 0;\n  width: 100%;\n  max-height: 200px;\n  overflow: auto;\n  border: 1px solid #efefef;\n  border-top: 0;\n  border-radius: 0 2px 2px 0;\n  box-shadow: 0 0 0 1px #efefef;\n  transition: all 0.4s ease-in-out;\n  background: #fff;\n  position: absolute;\n  z-index: 55;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: auto;\n  opacity: 1;\n  transition: all 0.4s ease-in-out;\n'],['\n  height: auto;\n  opacity: 1;\n  transition: all 0.4s ease-in-out;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  left: 100%;\n  height: auto;\n  opacity: 1;\n'],['\n  left: 100%;\n  height: auto;\n  opacity: 1;\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding: 10px 15px;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  user-select: none;\n  font-size: 14px;\n  position: relative;\n\n  &:hover {\n    background-color: #efefef;\n  }\n'],['\n  padding: 10px 15px;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  user-select: none;\n  font-size: 14px;\n  position: relative;\n\n  &:hover {\n    background-color: #efefef;\n  }\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  border: 1px solid #bababa;\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 10px;\n\n  ','\n'],['\n  border: 1px solid #bababa;\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 10px;\n\n  ','\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: relative;\n  background: url(',') no-repeat;\n  background-size: contain;\n  width: 10px;\n  height: 10px;\n  position: absolute;\n  right: 15px;\n  top: 15px;\n'],['\n  position: relative;\n  background: url(',') no-repeat;\n  background-size: contain;\n  width: 10px;\n  height: 10px;\n  position: absolute;\n  right: 15px;\n  top: 15px;\n']);/**
 * Select component
 */var DualSelect=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DualSelect,_Component);function DualSelect(){__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,DualSelect);var _this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(DualSelect.__proto__||Object.getPrototypeOf(DualSelect)).call(this));_this.state={listOpened:false,secondaryOpened:false,selected:null,currentItem:null};_this.toggleList=_this.toggleList.bind(_this);_this.setSelectedFromProp=_this.setSelectedFromProp.bind(_this);return _this;}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DualSelect,[{key:'handleClickOutside',value:function handleClickOutside(evt){if(this.state.listOpened){this.setState({listOpened:!this.state.listOpened,secondaryOpened:!this.state.secondaryOpened});}}},{key:'setSelectedFromProp',value:function setSelectedFromProp(prop,first,items){var _this2=this;if(prop){var selected=void 0;if(__WEBPACK_IMPORTED_MODULE_10_lodash_isArray___default()(prop)){selected=__WEBPACK_IMPORTED_MODULE_12_lodash_map___default()(prop,function(propValue){return __WEBPACK_IMPORTED_MODULE_8_lodash_find___default()(_this2.props.items,function(_ref){var value=_ref.value;return value===propValue;});});}else{items&&items.forEach(function(item){return item.children.forEach(function(child){if(child.value===prop)selected=child;});});}if(selected){this.setState({selected:selected},function(){if(__WEBPACK_IMPORTED_MODULE_10_lodash_isArray___default()(selected)){_this2.props.onChange&&_this2.props.onChange(_this2.state.selected);}else{_this2.props.onChange&&_this2.props.onChange(Object.assign({},_this2.state.selected,{first:first}));}});}}}},{key:'componentWillMount',value:function componentWillMount(){this.setSelectedFromProp(this.props.selected,true);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.selected&&nextProps.items.length>0){var found=void 0;nextProps.items.forEach(function(item){return item.children.forEach(function(child){if(child.value===nextProps.selected)found=child;});});if(found){if(__WEBPACK_IMPORTED_MODULE_9_lodash_isEqual___default()(this.state.selected,found)){return false;}this.setSelectedFromProp(nextProps.selected,false,nextProps.items);}}}},{key:'toggleList',value:function toggleList(){this.setState({listOpened:!this.state.listOpened});}},{key:'toggleSecondaryList',value:function toggleSecondaryList(item){this.setState({secondaryOpened:true,currentItem:item});}},{key:'selectItem',value:function selectItem(item){var _this3=this;this.setState({selected:item,listOpened:false,secondaryOpened:false},function(){_this3.props.onChange&&_this3.props.onChange(_this3.state.selected);});}},{key:'selectItems',value:function selectItems(item){var _this4=this;var items=this.state.selected||[];var found=__WEBPACK_IMPORTED_MODULE_11_lodash_findIndex___default()(items,function(i){return i.value===item.value;});if(this.props.removedSelectOnSelected&&!this.removedFirst){this.props.removedSelectOnSelected.forEach(function(v){return __WEBPACK_IMPORTED_MODULE_13_lodash_remove___default()(items,{value:v});});this.removedFirst=true;}if(found!==-1){items=items.filter(function(item,index){return index!==found;});}else{items.push(item);}this.setState({selected:items},function(){_this4.props.onChange&&_this4.props.onChange(_this4.state.selected);});}},{key:'renderSecondary',value:function renderSecondary(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(SecondaryList,null,this.state.currentItem&&this.state.currentItem.children.map(function(item){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Item,{key:'item-'+item.value+item.label,onClick:function onClick(){return _this5.selectItem(item);}},item.label);}));}},{key:'render',value:function render(){var _this6=this;var _props=this.props,placeholder=_props.placeholder,Selector=_props.Selector,List=_props.List,className=_props.className,items=_props.items,checkboxed=_props.checkboxed;var SelectorText=placeholder;// Set default
if(!Selector){Selector=DefaultSelector;}if(!List){List=DefaultList;}if(this.state.listOpened){List=DefaultListOpened;}if(this.state.selected){if(this.state.selected.icon){SelectorText=__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Icon,{src:this.state.selected.icon,alt:this.state.selected.label}),this.state.selected.label);}else{SelectorText=this.state.selected.label;}}var isChecked=function isChecked(_ref2){var value=_ref2.value;if(_this6.state.selected){if(__WEBPACK_IMPORTED_MODULE_10_lodash_isArray___default()(_this6.state.selected)){return __WEBPACK_IMPORTED_MODULE_11_lodash_findIndex___default()(_this6.state.selected,function(i){return i.value===value;})!==-1;}}else{return _this6.state.selected===value;}};return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Wrapper,{className:className},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Selector,{onClick:!this.props.disabled&&this.toggleList,className:this.state.selected&&'selected',opened:this.state.listOpened,arrowIcon:this.props.arrowIcon,icon:this.props.icon,disabled:this.props.disabled},!checkboxed?SelectorText:placeholder),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(List,null,items&&items.map(function(item){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Item,{key:'item-'+item.value+item.label,onClick:function onClick(){return _this6.toggleSecondaryList(item);}},item.icon&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Icon,{src:item.icon}),checkboxed?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Checkbox,{checked:isChecked(item)}):'',item.label,_this6.state.currentItem===item&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(OpenIcon,null));})),this.state.secondaryOpened&&this.renderSecondary());}}]);return DualSelect;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);DualSelect.propTypes={icon:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,arrowIcon:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,disabled:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,placeholder:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,items:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object),checkboxed:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,onChange:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,removedSelectOnSelected:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),List:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,Selector:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,selected:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_react_onclickoutside__["a" /* default */])(DualSelect));var Icon=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].img(_templateObject);var Wrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject2);var DefaultSelector=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject3,function(_ref3){var arrowIcon=_ref3.arrowIcon;return arrowIcon;},function(props){return props.opened&&'\n      transform: translateY(-50%)rotate(180deg);\n    ';},function(props){return props.icon?'background-image: url('+props.icon+');':'';},function(props){return props.icon?'padding-left: 40px':'';});var DefaultList=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject4);var DefaultListOpened=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(DefaultList)(_templateObject5);var SecondaryList=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(DefaultList)(_templateObject6);var Item=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject7);var Checkbox=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject8,function(props){return props.checked?'\n    &:after {\n      content: "\u2713";\n      color: #93C13E;\n      display: block;\n      width: 14px;\n      font-size: 10px;\n      text-align: center;\n      line-height: 18px;\n    }\n  ':'';});var OpenIcon=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject9,__WEBPACK_IMPORTED_MODULE_15__assets_ic_arrow_more_svg___default.a);

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditDataModalV2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logic__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_ic_day_component_svg__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_ic_day_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_ic_day_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_ic_night_component_svg__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_ic_night_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_ic_night_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_ic_result_component_svg__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_ic_result_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_ic_result_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_ic_eletricity_component_svg__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_ic_eletricity_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_ic_eletricity_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_ic_gas_component_svg__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_ic_gas_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__images_ic_gas_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_ic_dependency_component_svg__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_ic_dependency_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_ic_dependency_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_ic_info2_component_svg__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_ic_info2_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__images_ic_info2_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_containers_ProfileV2_images_ic_arrow_component_svg__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_containers_ProfileV2_images_ic_arrow_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_containers_ProfileV2_images_ic_arrow_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_Loading__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ButtonOutlineV2__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ButtonGradientV2__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__LeftAlignRadioV2__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_SelectV2__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__TooltipV2__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__BigModalV2__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__InputV2__ = __webpack_require__(85);
var _class;var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #fff;\n  font-family: Nunito;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 150% */\n  min-width: 250px;\n  margin: 0;\n'],['\n  color: #fff;\n  font-family: Nunito;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 150% */\n  min-width: 250px;\n  margin: 0;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  flex: 1 0 0;\n'],['\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  flex: 1 0 0;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 700px;\n'],['\n  width: 700px;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-grow: 1;\n  align-self: stretch;\n  border: 1px solid #ececec;\n'],['\n  display: flex;\n  flex-grow: 1;\n  align-self: stretch;\n  border: 1px solid #ececec;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-self: stretch;\n  width: 100%;\n  height: 100%;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-self: stretch;\n  width: 100%;\n  height: 100%;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 12px 16px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 8px;\n  align-self: stretch;\n  border-bottom: 1px solid #ececec;\n\n  h4 {\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 1;\n    overflow: hidden;\n    color: #1d1e22;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    text-overflow: ellipsis;\n    font-family: Nunito;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 20px;\n    margin: 0;\n    text-transform: none;\n  }\n\n  > .inputs {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    align-self: stretch;\n  }\n'],['\n  display: flex;\n  padding: 12px 16px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 8px;\n  align-self: stretch;\n  border-bottom: 1px solid #ececec;\n\n  h4 {\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 1;\n    overflow: hidden;\n    color: #1d1e22;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    text-overflow: ellipsis;\n    font-family: Nunito;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 20px;\n    margin: 0;\n    text-transform: none;\n  }\n\n  > .inputs {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    align-self: stretch;\n  }\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 12px 0px;\n  align-items: flex-start;\n  flex: 1 0 0;\n  align-self: stretch;\n  overflow-y: auto;\n'],['\n  display: flex;\n  padding: 12px 0px;\n  align-items: flex-start;\n  flex: 1 0 0;\n  align-self: stretch;\n  overflow-y: auto;\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 0 16px;\n  align-items: flex-start;\n\n  > p {\n    color: #3e3e3e;\n    font-family: Nunito;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 18px; /* 150% */\n    max-width: unset;\n    margin-bottom: 6px;\n  }\n'],['\n  display: flex;\n  padding: 0 16px;\n  align-items: flex-start;\n\n  > p {\n    color: #3e3e3e;\n    font-family: Nunito;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 18px; /* 150% */\n    max-width: unset;\n    margin-bottom: 6px;\n  }\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  padding: 0px 16px;\n  align-items: flex-start;\n  gap: 12px;\n  flex: 1 0 0;\n\n  .section {\n    display: flex;\n    width: 100;\n    flex-direction: column;\n    gap: 12px;\n    width: 100%;\n\n    .titleRow {\n      display: flex;\n      align-items: center;\n      gap: 4px;\n      align-self: stretch;\n\n      > h5 {\n        color: #ff8e2a;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: 20px;\n        margin: 0;\n      }\n    }\n\n    .titleRow.gas > h5 {\n      color: #10c1ee;\n    }\n  }\n\n  > .titleRow {\n    display: flex;\n    padding: 10px 0px;\n    align-items: center;\n    gap: 4px;\n    align-self: stretch;\n\n    > svg {\n      width: 18px;\n      height: 18px;\n    }\n\n    > h5 {\n      color: #3e3e3e;\n      font-feature-settings: \'liga\' off, \'clig\' off;\n      font-family: Nunito;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 700;\n      margin: 0;\n    }\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  padding: 0px 16px;\n  align-items: flex-start;\n  gap: 12px;\n  flex: 1 0 0;\n\n  .section {\n    display: flex;\n    width: 100;\n    flex-direction: column;\n    gap: 12px;\n    width: 100%;\n\n    .titleRow {\n      display: flex;\n      align-items: center;\n      gap: 4px;\n      align-self: stretch;\n\n      > h5 {\n        color: #ff8e2a;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: 20px;\n        margin: 0;\n      }\n    }\n\n    .titleRow.gas > h5 {\n      color: #10c1ee;\n    }\n  }\n\n  > .titleRow {\n    display: flex;\n    padding: 10px 0px;\n    align-items: center;\n    gap: 4px;\n    align-self: stretch;\n\n    > svg {\n      width: 18px;\n      height: 18px;\n    }\n\n    > h5 {\n      color: #3e3e3e;\n      font-feature-settings: \'liga\' off, \'clig\' off;\n      font-family: Nunito;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 700;\n      margin: 0;\n    }\n  }\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 0px 16px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  flex: 1 0 0;\n  align-self: stretch;\n\n  .section {\n    display: flex;\n    width: 100;\n    flex-direction: column;\n    gap: 12px;\n    width: 100%;\n  }\n\n  .titleRow {\n    display: flex;\n    padding: 10px 0px;\n    align-items: center;\n    gap: 4px;\n    align-self: stretch;\n\n    > h5 {\n      color: #ff8e2a;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 20px;\n      margin: 0;\n    }\n  }\n\n  .titleRow.gas > h5 {\n    color: #10c1ee;\n  }\n'],['\n  display: flex;\n  padding: 0px 16px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  flex: 1 0 0;\n  align-self: stretch;\n\n  .section {\n    display: flex;\n    width: 100;\n    flex-direction: column;\n    gap: 12px;\n    width: 100%;\n  }\n\n  .titleRow {\n    display: flex;\n    padding: 10px 0px;\n    align-items: center;\n    gap: 4px;\n    align-self: stretch;\n\n    > h5 {\n      color: #ff8e2a;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 20px;\n      margin: 0;\n    }\n  }\n\n  .titleRow.gas > h5 {\n    color: #10c1ee;\n  }\n']),_templateObject11=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n']),_templateObject12=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  gap: 12px;\n\n  h4 {\n    align-self: stretch;\n    color: #1d1e22;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    margin: 0;\n    text-transform: unset !important;\n    display: flex;\n    gap: 4px;\n    align-items: center;\n    justify-content: flex-start;\n    z-index: 10;\n  }\n'],['\n  gap: 12px;\n\n  h4 {\n    align-self: stretch;\n    color: #1d1e22;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    margin: 0;\n    text-transform: unset !important;\n    display: flex;\n    gap: 4px;\n    align-items: center;\n    justify-content: flex-start;\n    z-index: 10;\n  }\n']),_templateObject13=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: flex-start;\n  gap: 18px;\n  align-self: stretch;\n'],['\n  display: flex;\n  align-items: flex-start;\n  gap: 18px;\n  align-self: stretch;\n']),_templateObject14=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  z-index: 100;\n\n  > div:first-child {\n    height: 40px;\n  }\n\n  > div {\n    padding: 10px;\n    border: 1px solid #bababa;\n\n    color: #616161;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n  }\n'],['\n  width: 100%;\n  z-index: 100;\n\n  > div:first-child {\n    height: 40px;\n  }\n\n  > div {\n    padding: 10px;\n    border: 1px solid #bababa;\n\n    color: #616161;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n  }\n']),_templateObject15=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 25px;\n  align-self: stretch;\n  color: #3e3e3e;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  text-transform: unset !important;\n  margin-bottom: unset !important;\n'],['\n  height: 25px;\n  align-self: stretch;\n  color: #3e3e3e;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  text-transform: unset !important;\n  margin-bottom: unset !important;\n']),_templateObject16=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1 0 0;\n  width: 100%;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1 0 0;\n  width: 100%;\n']),_templateObject17=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  align-self: stretch;\n\n  > .icon {\n    display: flex;\n    width: 20px;\n    padding: 12px 0px;\n    flex-direction: column;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 10px;\n  }\n'],['\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  align-self: stretch;\n\n  > .icon {\n    display: flex;\n    width: 20px;\n    padding: 12px 0px;\n    flex-direction: column;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 10px;\n  }\n']),_templateObject18=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 16px;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  align-self: stretch;\n  border-top: 1px solid #ececec;\n'],['\n  display: flex;\n  padding: 16px;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  align-self: stretch;\n  border-top: 1px solid #ececec;\n']);var EditDataModalV2=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__logic__["a" /* default */])(_class=function(_Component){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(EditDataModalV2,_Component);function EditDataModalV2(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,EditDataModalV2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=EditDataModalV2.__proto__||Object.getPrototypeOf(EditDataModalV2)).call.apply(_ref,[this].concat(args))),_this),_this.state={changedGasTermoEnergia:false,changedGasTermoFixo:false,changedElectricityCheia:false,changedElectricityPonta:false,changedElectricityVazio:false,changedElectricityTermoPotencia:false},_this.handleScroll=function(event){if(_this.scrollerBoxRef){setTimeout(function(){_this.scrollerBoxRef.scrollTop=_this.scrollerBoxRef.scrollHeight;},100);}},_this.updatePowerChoiceOptions=function(timeCycle){var _this$props=_this.props,options=_this$props.options,fullEleTariff=_this$props.fullEleTariff;var setPowerChoices=_this.actions.setPowerChoices;var electricitySet=fullEleTariff.electricitySet;if(electricitySet&&options){var filteredSets=electricitySet.filter(function(_ref2){var ciclo_horario=_ref2.ciclo_horario;return ciclo_horario===timeCycle;});var filteredPowerChoiceOptions=[];filteredSets.forEach(function(set){var option=options.powerChoices.find(function(option){return option.value===set.potencia_contratada;});if(option){filteredPowerChoiceOptions.push(option);}});filteredPowerChoiceOptions.sort(function(a,b){return a.value-b.value;});setPowerChoices(filteredPowerChoiceOptions);}},_this.changeTimeCycle=function(timeCycle){var _this$props2=_this.props,electricityConsumptionCheia=_this$props2.electricityConsumptionCheia,electricityConsumptionVazio=_this$props2.electricityConsumptionVazio,electricityConsumptionPonta=_this$props2.electricityConsumptionPonta,electricityConsumptionSuperVazio=_this$props2.electricityConsumptionSuperVazio,fullEleTariff=_this$props2.fullEleTariff,formValues=_this$props2.formValues;var setFormValues=_this.actions.setFormValues;var electricitySet=fullEleTariff.electricitySet;//* Update power choice options to only show the sets from the chosen time cycle
_this.updatePowerChoiceOptions(timeCycle);//* Check if the new time cycle has a set with the same power choice if not change to the first
var filteredSets=electricitySet.filter(function(_ref3){var ciclo_horario=_ref3.ciclo_horario;return ciclo_horario===timeCycle;});var newPowerChoice=formValues.potenciaContratada;if(!filteredSets.find(function(_ref4){var potencia_contratada=_ref4.potencia_contratada;return potencia_contratada===newPowerChoice;})){newPowerChoice=filteredSets[0].potencia_contratada;}//* Get the correct set
var correctSet=electricitySet.find(function(_ref5){var potencia_contratada=_ref5.potencia_contratada,ciclo_horario=_ref5.ciclo_horario;return potencia_contratada===newPowerChoice&&ciclo_horario===timeCycle;});if(electricityConsumptionCheia&&electricityConsumptionVazio&&electricityConsumptionPonta){var newValues=Object.assign({},!_this.state.changedElectricityPonta&&{electricityPonta:correctSet.ponta},!_this.state.changedElectricityCheia&&{electricityCheia:correctSet.cheias},!_this.state.changedElectricityVazio&&{electricityVazio:correctSet.vazio_normal},!_this.state.changedElectricityTermoPotencia&&{electricityTermoFixo:correctSet.potencia_contratada_preco},{cicloHorario:timeCycle,potenciaContratada:newPowerChoice});if(timeCycle==='s'){var fullCheiaConsumption=Number(electricityConsumptionCheia)+Number(electricityConsumptionVazio)+Number(electricityConsumptionPonta)+Number(electricityConsumptionSuperVazio);setFormValues(Object.assign({},newValues,{electricityConsumeCheia:_this.roundNumber(fullCheiaConsumption.toFixed(2)/12)}));}else if(timeCycle==='b'){var fullVazioConsumption=Number(electricityConsumptionSuperVazio)+Number(electricityConsumptionVazio);var fullCheiaPontaConsumption=Number(electricityConsumptionCheia)+Number(electricityConsumptionPonta);setFormValues(Object.assign({},newValues,{electricityConsumeCheia:_this.roundNumber(fullCheiaPontaConsumption.toFixed(2)/12),electricityConsumeVazio:_this.roundNumber(fullVazioConsumption.toFixed(2)/12)}));}else{var _fullVazioConsumption=Number(electricityConsumptionSuperVazio)+Number(electricityConsumptionVazio);setFormValues(Object.assign({},newValues,{electricityConsumeCheia:_this.roundNumber(electricityConsumptionCheia/12),electricityConsumeVazio:_this.roundNumber(_fullVazioConsumption.toFixed(2)/12),electricityConsumePonta:_this.roundNumber(electricityConsumptionPonta/12)}));}}},_this.changeGasStage=function(stage){var fullGasTariff=_this.props.fullGasTariff;var setFormValues=_this.actions.setFormValues;var _this$state=_this.state,changedGasTermoEnergia=_this$state.changedGasTermoEnergia,changedGasTermoFixo=_this$state.changedGasTermoFixo;var gasSet=fullGasTariff.gasSet;var set=gasSet.length>0?gasSet[0]:[];var updatedFormValues=Object.assign({stage:stage},set&&!changedGasTermoEnergia&&{gasTermoEnergia:set['termo_energia_escalao_'+stage]},set&&!changedGasTermoFixo&&{gasTermoFixo:set['termo_fixo_escalao_'+stage]});setFormValues(updatedFormValues);},_this.roundNumber=function(num){if(!num)return;return Number(num).toFixed(2);},_this.roundNumberTo4=function(num){if(!num)return;return Number(num).toFixed(4);},_this.handleKeyDown=function(e){var editSimulation=_this.actions.editSimulation;e.stopPropagation();if(e.key==='Enter'){editSimulation();}},_this.closeModal=function(){var onClose=_this.props.onClose;onClose();},_this.disableSubmitButton=function(){var _this$props3=_this.props,formValues=_this$props3.formValues,electricityPriceList=_this$props3.electricityPriceList,gasPriceList=_this$props3.gasPriceList;var isCustomProfile=formValues.consumerProfile==='custom';if(!isCustomProfile){if(electricityPriceList&&!formValues.electricityAnnualBilling||gasPriceList&&!formValues.gasAnnualBilling){return true;}}else if(isCustomProfile){var customElectricityCondition=['potenciaContratada','cicloHorario','electricityConsumeCheia'];if(formValues.cicloHorario==='s'){customElectricityCondition=[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(customElectricityCondition),['electricityCheia','electricityTermoFixo']).some(function(field){return!formValues[field];});}else if(formValues.cicloHorario==='b'){customElectricityCondition=[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(customElectricityCondition),['electricityConsumeVazio','electricityCheia','electricityVazio','electricityTermoFixo']).some(function(field){return!formValues[field];});}else if(formValues.cicloHorario==='t'){customElectricityCondition=[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(customElectricityCondition),['electricityConsumeVazio','electricityConsumePonta','electricityCheia','electricityPonta','electricityVazio','electricityTermoFixo']).some(function(field){return!formValues[field];});}var customGasCondition=['gasMonthlyConsumption','gasTermoEnergia','gasTermoFixo'].some(function(field){return!formValues[field];});if(electricityPriceList&&gasPriceList){return customElectricityCondition||customGasCondition;}if(electricityPriceList){return customElectricityCondition;}if(gasPriceList){return customGasCondition;}}return false;},_this.renderStandardNightInputs=function(){var _this$props4=_this.props,formValues=_this$props4.formValues,electricityPriceList=_this$props4.electricityPriceList,gasPriceList=_this$props4.gasPriceList;var setFormValues=_this.actions.setFormValues;return formValues.consumerProfile!=='custom'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StandardNight,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'titleRow'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__images_ic_result_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h5',null,'Fatura de Energia Estimada com Impostos e IVA')),electricityPriceList&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'titleRow'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__images_ic_eletricity_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h5',null,'Eletricidade')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__InputV2__["a" /* default */],{style:{flexGrow:'1'},required:true,label:'Custo Mensal',type:'number',placeholder:'0',suffix:'\u20AC',value:Number(formValues.electricityMonthlyBilling),onChange:function onChange(val){return setFormValues({electricityMonthlyBilling:_this.roundNumber(val),electricityAnnualBilling:_this.roundNumber(val*12)});}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__images_ic_dependency_component_svg___default.a,null)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__InputV2__["a" /* default */],{style:{flexGrow:'1'},label:'Custo Anual',required:true,type:'number',suffix:'\u20AC',placeholder:'0',value:Number(formValues.electricityAnnualBilling),onChange:function onChange(val){return setFormValues({electricityMonthlyBilling:_this.roundNumber(val/12),electricityAnnualBilling:_this.roundNumber(val)});}}))),gasPriceList&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'titleRow gas'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__images_ic_gas_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h5',null,'G\xE1s Natural')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__InputV2__["a" /* default */],{style:{flexGrow:'1'},required:true,label:'Custo Mensal',type:'number',placeholder:'0',suffix:'\u20AC',value:Number(formValues.gasMonthlyBilling),onChange:function onChange(val){return setFormValues({gasMonthlyBilling:_this.roundNumber(val),gasAnnualBilling:_this.roundNumber(val*12)});}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__images_ic_dependency_component_svg___default.a,null)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__InputV2__["a" /* default */],{style:{flexGrow:'1'},label:'Custo Anual',required:true,type:'number',suffix:'\u20AC',placeholder:'0',value:Number(formValues.gasAnnualBilling),onChange:function onChange(val){return setFormValues({gasMonthlyBilling:_this.roundNumber(val/12),gasAnnualBilling:_this.roundNumber(val)});}})))):null;},_this.renderSimpleTimeCycleElectricityInputs=function(){var formValues=_this.props.formValues;var setFormValues=_this.actions.setFormValues;return formValues.cicloHorario==='s'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(EnergyInputs,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputsGroup,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4',null,'Consumo Mensal'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomInputsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__InputV2__["a" /* default */],{style:{flex:'1 0 0'},required:true,label:'Energia',type:'number',placeholder:'0',suffix:'kWh',value:Number(formValues.electricityConsumeCheia),onChange:function onChange(val){return setFormValues({electricityConsumeCheia:_this.roundNumber(val)});}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{style:{flex:'1 0 0'}}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputsGroup,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4',null,'Pre\xE7os (sem IVA)',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__TooltipV2__["a" /* default */],{style:{height:'16px'},content:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TooltipText,null,'Pre\xE7os com a taxa de acesso \xE0 rede (sem IVA)',' '),arrowLocation:'topLeft'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__images_ic_info2_component_svg___default.a,{width:'16px',height:'16px'}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomInputsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__InputV2__["a" /* default */],{style:{flex:'1 0 0'},required:true,label:'Energia',type:'number',placeholder:'0',suffix:'\u20AC/kWh',value:Number(formValues.electricityCheia),onChange:function onChange(val){_this.setState({changedElectricityCheia:true});setFormValues({electricityCheia:_this.roundNumberTo4(val)});}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__InputV2__["a" /* default */],{style:{flex:'1 0 0'},required:true,label:'Termo Pot\xEAncia',type:'number',placeholder:'0',suffix:'\u20AC/Dia',value:Number(formValues.electricityTermoFixo),onChange:function onChange(val){_this.setState({changedElectricityTermoPotencia:true});setFormValues({electricityTermoFixo:_this.roundNumberTo4(val)});}})))):null;},_this.renderBiTimeCycleElectricityInputs=function(){var formValues=_this.props.formValues;var setFormValues=_this.actions.setFormValues;return formValues.cicloHorario==='b'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(EnergyInputs,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputsGroup,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4',null,'Consumo Mensal'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomInputsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__InputV2__["a" /* default */],{style:{flex:'1 0 0'},required:true,label:'Fora do Vazio',type:'number',placeholder:'0',suffix:'kWh',value:Number(formValues.electricityConsumeCheia),onChange:function onChange(val){return setFormValues({electricityConsumeCheia:_this.roundNumber(val)});}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__InputV2__["a" /* default */],{style:{flex:'1 0 0'},required:true,label:'Vazio',type:'number',placeholder:'0',suffix:'kWh',value:Number(formValues.electricityConsumeVazio),onChange:function onChange(val){return setFormValues({electricityConsumeVazio:_this.roundNumber(val)});}}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputsGroup,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4',null,'Pre\xE7os (sem IVA)',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__TooltipV2__["a" /* default */],{style:{height:'16px'},content:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TooltipText,null,'Pre\xE7os com a taxa de acesso \xE0 rede (sem IVA)',' '),arrowLocation:'topLeft'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__images_ic_info2_component_svg___default.a,{width:'16px',height:'16px'}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomInputsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__InputV2__["a" /* default */],{style:{flex:'1 0 0'},required:true,label:'Fora do Vazio',type:'number',placeholder:'0',suffix:'\u20AC/kWh',value:Number(formValues.electricityCheia),onChange:function onChange(val){_this.setState({changedElectricityCheia:true});setFormValues({electricityCheia:_this.roundNumberTo4(val)});}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__InputV2__["a" /* default */],{style:{flex:'1 0 0'},required:true,label:'Vazio',type:'number',placeholder:'0',suffix:'\u20AC/kWh',value:Number(formValues.electricityVazio),onChange:function onChange(val){_this.setState({changedElectricityVazio:true});setFormValues({electricityVazio:_this.roundNumberTo4(val)});}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomInputsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__InputV2__["a" /* default */],{style:{flex:'1 0 0'},required:true,label:'Termo Fixo',type:'number',placeholder:'0',suffix:'\u20AC/Dia',value:Number(formValues.electricityTermoFixo),onChange:function onChange(val){_this.setState({changedElectricityTermoPotencia:true});setFormValues({electricityTermoFixo:_this.roundNumberTo4(val)});}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{style:{flex:'1 0 0'}})))):null;},_this.renderTriTimeCycleElectricityInputs=function(){var formValues=_this.props.formValues;var setFormValues=_this.actions.setFormValues;return formValues.cicloHorario==='t'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(EnergyInputs,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputsGroup,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4',null,'Consumo Mensal'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomInputsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__InputV2__["a" /* default */],{style:{flex:'1 0 0'},required:true,label:'Ponta',type:'number',placeholder:'0',suffix:'kWh',value:Number(formValues.electricityConsumePonta),onChange:function onChange(val){return setFormValues({electricityConsumePonta:_this.roundNumber(val)});}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__InputV2__["a" /* default */],{style:{flex:'1 0 0'},required:true,label:'Cheias',type:'number',placeholder:'0',suffix:'kWh',value:Number(formValues.electricityConsumeCheia),onChange:function onChange(val){return setFormValues({electricityConsumeCheia:_this.roundNumber(val)});}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomInputsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__InputV2__["a" /* default */],{style:{flex:'1 0 0'},required:true,label:'Vazio',type:'number',placeholder:'0',suffix:'kWh',value:Number(formValues.electricityConsumeVazio),onChange:function onChange(val){return setFormValues({electricityConsumeVazio:_this.roundNumber(val)});}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{style:{flex:'1 0 0'}}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputsGroup,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4',null,'Pre\xE7os (sem IVA)',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__TooltipV2__["a" /* default */],{style:{height:'16px'},content:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TooltipText,null,'Pre\xE7os com a taxa de acesso \xE0 rede (sem IVA)',' '),arrowLocation:'topLeft'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__images_ic_info2_component_svg___default.a,{width:'16px',height:'16px'}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomInputsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__InputV2__["a" /* default */],{style:{flex:'1 0 0'},required:true,label:'Ponta',type:'number',placeholder:'0',suffix:'\u20AC/kWh',value:Number(formValues.electricityPonta),onChange:function onChange(val){_this.setState({changedElectricityPonta:true});setFormValues({electricityPonta:_this.roundNumberTo4(val)});}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__InputV2__["a" /* default */],{style:{flex:'1 0 0'},required:true,label:'Cheias',type:'number',placeholder:'0',suffix:'\u20AC/KWh',value:Number(formValues.electricityCheia),onChange:function onChange(val){_this.setState({changedElectricityCheia:true});setFormValues({electricityCheia:_this.roundNumberTo4(val)});}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomInputsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__InputV2__["a" /* default */],{style:{flex:'1 0 0'},required:true,label:'Vazio',type:'number',placeholder:'0',suffix:'\u20AC/kWh',value:Number(formValues.electricityVazio),onChange:function onChange(val){_this.setState({changedElectricityVazio:true});setFormValues({electricityVazio:_this.roundNumberTo4(val)});}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__InputV2__["a" /* default */],{style:{flex:'1 0 0'},required:true,label:'Termo Fixo',type:'number',placeholder:'0',suffix:'\u20AC/Dia',value:Number(formValues.electricityTermoFixo),onChange:function onChange(val){_this.setState({changedElectricityTermoPotencia:true});setFormValues({electricityTermoFixo:_this.roundNumberTo4(val)});}})))):null;},_this.renderCustomInputs=function(){var _this$props5=_this.props,formValues=_this$props5.formValues,powerChoices=_this$props5.powerChoices,timeCycleChoices=_this$props5.timeCycleChoices,gasStagesChoices=_this$props5.gasStagesChoices,electricityPriceList=_this$props5.electricityPriceList,gasPriceList=_this$props5.gasPriceList,fullEleTariff=_this$props5.fullEleTariff;var setFormValues=_this.actions.setFormValues;var electricitySet=fullEleTariff.electricitySet;return formValues.consumerProfile==='custom'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomContent,null,electricityPriceList&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'titleRow'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__images_ic_eletricity_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h5',null,'Eletricidade')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(EnergyInputs,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomInputsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WrapperSelect,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputLabel,null,'Pot\xEAncia contratada'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledSelect,{items:powerChoices,onChange:function onChange(_ref6){var value=_ref6.value;if(value!==formValues.potenciaContratada){var correctSet=electricitySet.find(function(_ref7){var potencia_contratada=_ref7.potencia_contratada,ciclo_horario=_ref7.ciclo_horario;return potencia_contratada===value&&ciclo_horario===formValues.cicloHorario;});setFormValues(Object.assign({potenciaContratada:value},!_this.state.changedElectricityPonta&&{electricityPonta:correctSet.ponta},!_this.state.changedElectricityCheia&&{electricityCheia:correctSet.cheias},!_this.state.changedElectricityVazio&&{electricityVazio:correctSet.vazio_normal},!_this.state.changedElectricityTermoPotencia&&{electricityTermoFixo:correctSet.potencia_contratada_preco}));}},selected:formValues.potenciaContratada,arrowIcon:__WEBPACK_IMPORTED_MODULE_16_containers_ProfileV2_images_ic_arrow_component_svg___default.a})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WrapperSelect,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputLabel,null,'Tarif\xE1rio'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledSelect,{items:timeCycleChoices,onChange:function onChange(_ref8){var value=_ref8.value;if(value!==formValues.cicloHorario){_this.changeTimeCycle(value);}},selected:formValues.cicloHorario,arrowIcon:__WEBPACK_IMPORTED_MODULE_16_containers_ProfileV2_images_ic_arrow_component_svg___default.a}))),_this.renderSimpleTimeCycleElectricityInputs(),_this.renderBiTimeCycleElectricityInputs(),_this.renderTriTimeCycleElectricityInputs())),gasPriceList&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'titleRow gas'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__images_ic_gas_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h5',null,'G\xE1s Natural')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(EnergyInputs,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputsGroup,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4',null,'Consumo Mensal'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomInputsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WrapperSelect,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputLabel,null,'Escal\xE3o'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledSelect,{items:gasStagesChoices,onChange:function onChange(_ref9){var value=_ref9.value;if(value!==formValues.stage){_this.changeGasStage(value);}},extraClick:function extraClick(event){_this.handleScroll(event);},selected:formValues.stage,arrowIcon:__WEBPACK_IMPORTED_MODULE_16_containers_ProfileV2_images_ic_arrow_component_svg___default.a})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__InputV2__["a" /* default */],{style:{flex:'1 0 0',display:'flex',flexDirection:'column',gap:'4px'},required:true,label:'Energia',type:'number',placeholder:'0',suffix:'kWh',value:Number(formValues.gasMonthlyConsumption),onChange:function onChange(val){return setFormValues({gasMonthlyConsumption:_this.roundNumber(val)});}}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputsGroup,{style:{marginBottom:'30px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4',null,'Pre\xE7os (sem IVA)',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__TooltipV2__["a" /* default */],{style:{height:'16px'},content:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TooltipText,null,'Pre\xE7os com a taxa de acesso \xE0 rede (sem IVA)',' '),arrowLocation:'topLeft'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__images_ic_info2_component_svg___default.a,{width:'16px',height:'16px'}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomInputsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__InputV2__["a" /* default */],{style:{flex:'1 0 0'},required:true,label:'Energia',type:'number',placeholder:'0',suffix:'\u20AC/kWh',value:Number(formValues.gasTermoEnergia),onChange:function onChange(val){_this.setState({changedGasTermoEnergia:true});setFormValues({gasTermoEnergia:_this.roundNumberTo4(val)});},onTouchEnd:function onTouchEnd(e){return console.log('Touch');}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__InputV2__["a" /* default */],{style:{flex:'1 0 0'},required:true,label:'Termo Fixo',type:'number',placeholder:'0',suffix:'\u20AC/Dia',value:Number(formValues.gasTermoFixo),onChange:function onChange(val){_this.setState({changedGasTermoFixo:true});setFormValues({gasTermoFixo:_this.roundNumberTo4(val)});}})))))):null;},_this.renderWarningText=function(){var formValues=_this.props.formValues;return formValues.consumerProfile!=='custom'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TextSection,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p',null,'Os c\xE1lculos apresentados assentam nos pre\xE7os de energia do mercado regulado. Se quiser de acordo com o pre\xE7o de energia da sua fatura, escolha o separador "Tenho os dados da minha fatura"')):null;},_this.renderForm=function(){var _this$props6=_this.props,loading=_this$props6.loading,formValues=_this$props6.formValues,simulationCode=_this$props6.simulationCode;var _this$actions=_this.actions,setFormValues=_this$actions.setFormValues,editSimulation=_this$actions.editSimulation;return!loading?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Form,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(UtilizationSection,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4',null,'Perfil de Utiliza\xE7\xE3o'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'inputs'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__LeftAlignRadioV2__["a" /* default */],{onClick:function onClick(){setFormValues({consumerProfile:'standard'});},icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__images_ic_day_component_svg___default.a,null),name:'Maioritariamente Diurno',selected:formValues.consumerProfile==='standard'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__LeftAlignRadioV2__["a" /* default */],{onClick:function onClick(){setFormValues({consumerProfile:'night'});},icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__images_ic_night_component_svg___default.a,null),name:'Maioritariamente Noturno',selected:formValues.consumerProfile==='night'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__LeftAlignRadioV2__["a" /* default */],{onClick:function onClick(){_this.updatePowerChoiceOptions(formValues.cicloHorario||'s');setFormValues({consumerProfile:'custom',potenciaContratada:formValues.potenciaContratada||3.45,cicloHorario:formValues.cicloHorario||'s'});},icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__images_ic_result_component_svg___default.a,null),name:'Tenho os dados da minha fatura',selected:formValues.consumerProfile==='custom'}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InvoiceSection,{innerRef:function innerRef(ref){return _this.scrollerBoxRef=ref;}},_this.renderStandardNightInputs(),_this.renderCustomInputs()),_this.renderWarningText(),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(BtnsWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ButtonOutlineV2__["a" /* default */],{style:{width:'140px '},onClick:function onClick(){return _this.closeModal();}},'Cancelar'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__ButtonGradientV2__["a" /* default */],{style:{width:'140px '},onClick:function onClick(e){e.preventDefault();editSimulation(simulationCode);},disabled:_this.disableSubmitButton()},'Atualizar dados'))):null;},_temp),__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(EditDataModalV2,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,electricityPriceList=_props.electricityPriceList,gasPriceList=_props.gasPriceList,prices=_props.prices,electricityAnnualBilling=_props.electricityAnnualBilling,gasAnnualBilling=_props.gasAnnualBilling,electricityConsumptionCheia=_props.electricityConsumptionCheia,electricityConsumptionVazio=_props.electricityConsumptionVazio,electricityConsumptionPonta=_props.electricityConsumptionPonta,electricityConsumptionSuperVazio=_props.electricityConsumptionSuperVazio,gasConsumption=_props.gasConsumption,priceListTimeCycle=_props.priceListTimeCycle,gasStage=_props.gasStage;var setFormValues=this.actions.setFormValues;if(electricityPriceList){setFormValues({electricityPonta:prices.electricity.ponta,electricityCheia:prices.electricity.cheia,electricityVazio:prices.electricity.vazio,electricityTermoFixo:prices.electricity.termo_fixo,electricityAnnualBilling:electricityAnnualBilling||0,electricityMonthlyBilling:electricityAnnualBilling?this.roundNumber(electricityAnnualBilling/12):0});if(electricityConsumptionCheia&&electricityConsumptionVazio&&electricityConsumptionPonta){if(priceListTimeCycle==='s'){var fullCheiaConsumption=Number(electricityConsumptionCheia)+Number(electricityConsumptionVazio)+Number(electricityConsumptionPonta)+Number(electricityConsumptionSuperVazio);setFormValues({electricityConsumeCheia:this.roundNumber(fullCheiaConsumption.toFixed(2)/12)});}else if(priceListTimeCycle==='b'){var fullVazioConsumption=Number(electricityConsumptionSuperVazio)+Number(electricityConsumptionVazio);var fullCheiaPontaConsumption=Number(electricityConsumptionCheia)+Number(electricityConsumptionPonta);setFormValues({electricityConsumeCheia:this.roundNumber(fullCheiaPontaConsumption.toFixed(2)/12),electricityConsumeVazio:this.roundNumber(fullVazioConsumption.toFixed(2)/12)});}else{var _fullVazioConsumption2=Number(electricityConsumptionSuperVazio)+Number(electricityConsumptionVazio);setFormValues({electricityConsumeCheia:this.roundNumber(electricityConsumptionCheia/12),electricityConsumeVazio:this.roundNumber(_fullVazioConsumption2.toFixed(2)/12),electricityConsumePonta:this.roundNumber(electricityConsumptionPonta/12)});}}}if(gasPriceList){setFormValues({gasTermoEnergia:prices.gas.termo_energia,gasTermoFixo:prices.gas.termo_fixo,gasAnnualBilling:gasAnnualBilling||0,gasMonthlyBilling:gasAnnualBilling?this.roundNumber(gasAnnualBilling/12):0,gasMonthlyConsumption:gasConsumption?this.roundNumber(gasConsumption/12):0,stage:gasStage?gasStage:1});}}},{key:'renderLoading',value:function renderLoading(){var loading=this.props.loading;return loading?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_Loading__["a" /* default */],null):null;}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ModalWrapper,{modalTriggerHeight:this.props.modalTriggerHeight,setModalTriggerHeight:this.props.setModalTriggerHeight,title:'Ajustar Valores',onClose:function onClose(){return _this2.closeModal();},onKeyDown:this.handleKeyDown,tabIndex:-1},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Wrapper,this.props,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(FormWrapper,null,this.renderLoading(),this.renderForm())));}}]);return EditDataModalV2;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]))||_class;var TooltipText=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].h6(_templateObject);var Wrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject2);var ModalWrapper=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_23__BigModalV2__["a" /* default */])(_templateObject3);var FormWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject4);var Form=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].form(_templateObject5);var UtilizationSection=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject6);var InvoiceSection=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div.attrs({ref:function ref(props){return props.forwardedRef;}})(_templateObject7);var TextSection=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject8);var StandardNight=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject9);var CustomContent=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject10);var EnergyInputs=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject11);var InputsGroup=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(EnergyInputs)(_templateObject12);var CustomInputsRow=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject13);var StyledSelect=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_21_components_SelectV2__["a" /* default */])(_templateObject14);var InputLabel=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].label(_templateObject15);var WrapperSelect=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject16);var InputsRow=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject17);var BtnsWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject18);

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditDataModalMobileV2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logic__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_ic_day_component_svg__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_ic_day_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_ic_day_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_ic_night_component_svg__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_ic_night_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_ic_night_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_ic_result_component_svg__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_ic_result_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_ic_result_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_ic_eletricity_component_svg__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_ic_eletricity_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_ic_eletricity_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_ic_gas_component_svg__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_ic_gas_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__images_ic_gas_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_ic_dependency_component_svg__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_ic_dependency_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_ic_dependency_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_containers_ProfileV2_images_ic_arrow_component_svg__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_containers_ProfileV2_images_ic_arrow_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_containers_ProfileV2_images_ic_arrow_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_ic_info2_component_svg__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_ic_info2_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__images_ic_info2_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_Loading__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ButtonOutlineV2__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ButtonGradientV2__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_SelectV2__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__MobileModalV2__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__InputV2__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__TooltipV2__ = __webpack_require__(136);
var _class;var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-self: stretch;\n  width: 100%;\n  height: 100%;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-self: stretch;\n  width: 100%;\n  height: 100%;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #fff;\n  font-family: Nunito;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 150% */\n  min-width: 250px;\n  margin: 0;\n'],['\n  color: #fff;\n  font-family: Nunito;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 150% */\n  min-width: 250px;\n  margin: 0;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 0 16px;\n  align-items: flex-start;\n\n  > p {\n    color: #3e3e3e;\n    font-family: Nunito;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 18px; /* 150% */\n    max-width: unset;\n    margin-bottom: 6px;\n  }\n'],['\n  display: flex;\n  padding: 0 16px;\n  align-items: flex-start;\n\n  > p {\n    color: #3e3e3e;\n    font-family: Nunito;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 18px; /* 150% */\n    max-width: unset;\n    margin-bottom: 6px;\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 2px 20px 20px 20px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 8px;\n  align-self: stretch;\n  border-bottom: 1px solid #ececec;\n\n  h4 {\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 1;\n    overflow: hidden;\n    color: #1d1e22;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    text-overflow: ellipsis;\n    font-family: Nunito;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 20px;\n    margin: 0;\n    text-transform: none;\n  }\n\n  > .inputs {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    align-self: stretch;\n  }\n'],['\n  display: flex;\n  padding: 2px 20px 20px 20px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 8px;\n  align-self: stretch;\n  border-bottom: 1px solid #ececec;\n\n  h4 {\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 1;\n    overflow: hidden;\n    color: #1d1e22;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    text-overflow: ellipsis;\n    font-family: Nunito;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 20px;\n    margin: 0;\n    text-transform: none;\n  }\n\n  > .inputs {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    align-self: stretch;\n  }\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 20px;\n  height: 20px;\n\n  > svg {\n    width: 100%;\n    height: 100%;\n    fill: #3e3e3e;\n\n    > path {\n      fill: #3e3e3e;\n    }\n  }\n'],['\n  width: 20px;\n  height: 20px;\n\n  > svg {\n    width: 100%;\n    height: 100%;\n    fill: #3e3e3e;\n\n    > path {\n      fill: #3e3e3e;\n    }\n  }\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 16px 20px;\n  align-items: flex-start;\n  flex: 1 0 0;\n  align-self: stretch;\n\n  overflow-y: auto;\n'],['\n  display: flex;\n  padding: 16px 20px;\n  align-items: flex-start;\n  flex: 1 0 0;\n  align-self: stretch;\n\n  overflow-y: auto;\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  flex: 1 0 0;\n\n  .section {\n    display: flex;\n    width: 100;\n    flex-direction: column;\n    gap: 12px;\n    width: 100%;\n\n    .titleRow {\n      display: flex;\n      align-items: center;\n      gap: 4px;\n      align-self: stretch;\n\n      > h5 {\n        color: #ff8e2a;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: 20px;\n        margin: 0;\n      }\n    }\n\n    .titleRow.gas > h5 {\n      color: #10c1ee;\n    }\n  }\n\n  > .titleRow {\n    display: flex;\n    padding: 10px 0px;\n    align-items: center;\n    gap: 4px;\n    align-self: stretch;\n\n    > svg {\n      width: 18px;\n      height: 18px;\n    }\n\n    > h5 {\n      color: #3e3e3e;\n      font-feature-settings: \'liga\' off, \'clig\' off;\n      font-family: Nunito;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 700;\n      margin: 0;\n    }\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  flex: 1 0 0;\n\n  .section {\n    display: flex;\n    width: 100;\n    flex-direction: column;\n    gap: 12px;\n    width: 100%;\n\n    .titleRow {\n      display: flex;\n      align-items: center;\n      gap: 4px;\n      align-self: stretch;\n\n      > h5 {\n        color: #ff8e2a;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: 20px;\n        margin: 0;\n      }\n    }\n\n    .titleRow.gas > h5 {\n      color: #10c1ee;\n    }\n  }\n\n  > .titleRow {\n    display: flex;\n    padding: 10px 0px;\n    align-items: center;\n    gap: 4px;\n    align-self: stretch;\n\n    > svg {\n      width: 18px;\n      height: 18px;\n    }\n\n    > h5 {\n      color: #3e3e3e;\n      font-feature-settings: \'liga\' off, \'clig\' off;\n      font-family: Nunito;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 700;\n      margin: 0;\n    }\n  }\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  flex: 1 0 0;\n  align-self: stretch;\n\n  .section {\n    display: flex;\n    width: 100;\n    flex-direction: column;\n    gap: 12px;\n    width: 100%;\n  }\n\n  .titleRow {\n    display: flex;\n    padding: 10px 0px;\n    align-items: center;\n    gap: 4px;\n    align-self: stretch;\n\n    > h5 {\n      color: #ff8e2a;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 20px;\n      margin: 0;\n    }\n  }\n\n  .titleRow.gas > h5 {\n    color: #10c1ee;\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  flex: 1 0 0;\n  align-self: stretch;\n\n  .section {\n    display: flex;\n    width: 100;\n    flex-direction: column;\n    gap: 12px;\n    width: 100%;\n  }\n\n  .titleRow {\n    display: flex;\n    padding: 10px 0px;\n    align-items: center;\n    gap: 4px;\n    align-self: stretch;\n\n    > h5 {\n      color: #ff8e2a;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 20px;\n      margin: 0;\n    }\n  }\n\n  .titleRow.gas > h5 {\n    color: #10c1ee;\n  }\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  gap: 12px;\n\n  h4 {\n    align-self: stretch;\n    color: #1d1e22;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    margin: 0;\n    text-transform: unset !important;\n    display: flex;\n    gap: 4px;\n    align-items: center;\n    justify-content: flex-start;\n  }\n'],['\n  gap: 12px;\n\n  h4 {\n    align-self: stretch;\n    color: #1d1e22;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    margin: 0;\n    text-transform: unset !important;\n    display: flex;\n    gap: 4px;\n    align-items: center;\n    justify-content: flex-start;\n  }\n']),_templateObject11=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 18px;\n  align-self: stretch;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 18px;\n  align-self: stretch;\n']),_templateObject12=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n\n  > div:first-child {\n    height: 40px;\n  }\n\n  > div {\n    padding: 10px;\n    border: 1px solid #bababa;\n\n    color: #3e3e3e;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n\n    > span {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      font-weight: 400;\n    }\n  }\n\n  > div:last-child {\n    > div {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n    }\n  }\n'],['\n  width: 100%;\n\n  > div:first-child {\n    height: 40px;\n  }\n\n  > div {\n    padding: 10px;\n    border: 1px solid #bababa;\n\n    color: #3e3e3e;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n\n    > span {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      font-weight: 400;\n    }\n  }\n\n  > div:last-child {\n    > div {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n    }\n  }\n']),_templateObject13=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 25px;\n  align-self: stretch;\n  color: #3e3e3e;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  text-transform: unset !important;\n'],['\n  height: 25px;\n  align-self: stretch;\n  color: #3e3e3e;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  text-transform: unset !important;\n']),_templateObject14=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1 0 0;\n  width: 100%;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1 0 0;\n  width: 100%;\n']),_templateObject15=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-self: stretch;\n  row-gap: 12px;\n\n  .iconInput {\n    width: 100%;\n    display: flex;\n    align-items: flex-end;\n    gap: 8px;\n\n    > .icon {\n      display: flex;\n      width: 20px;\n      padding: 12px 0px;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n\n  @media screen and (min-width: 600px) {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-end;\n\n    .iconInput {\n      gap: 0px;\n    }\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-self: stretch;\n  row-gap: 12px;\n\n  .iconInput {\n    width: 100%;\n    display: flex;\n    align-items: flex-end;\n    gap: 8px;\n\n    > .icon {\n      display: flex;\n      width: 20px;\n      padding: 12px 0px;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n\n  @media screen and (min-width: 600px) {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-end;\n\n    .iconInput {\n      gap: 0px;\n    }\n  }\n']),_templateObject16=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 16px;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  align-self: stretch;\n  border-top: 1px solid #ececec;\n\n  > div:first-child {\n    width: 100%;\n  }\n\n  > button {\n    width: 100%;\n  }\n\n  @media screen and (min-width: 600px) {\n    > div:first-child {\n      width: 140px;\n    }\n\n    > button {\n      width: 140px;\n    }\n  }\n'],['\n  display: flex;\n  padding: 16px;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  align-self: stretch;\n  border-top: 1px solid #ececec;\n\n  > div:first-child {\n    width: 100%;\n  }\n\n  > button {\n    width: 100%;\n  }\n\n  @media screen and (min-width: 600px) {\n    > div:first-child {\n      width: 140px;\n    }\n\n    > button {\n      width: 140px;\n    }\n  }\n']);var EditDataModalMobileV2=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__logic__["a" /* default */])(_class=function(_Component){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(EditDataModalMobileV2,_Component);function EditDataModalMobileV2(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,EditDataModalMobileV2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=EditDataModalMobileV2.__proto__||Object.getPrototypeOf(EditDataModalMobileV2)).call.apply(_ref,[this].concat(args))),_this),_this.state={utilizationProfile:[{label:'Maioritariamente Diurno',value:'standard',icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(IconWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__images_ic_day_component_svg___default.a,null))},{label:'Maioritariamente Noturno',value:'night',icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(IconWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__images_ic_night_component_svg___default.a,null))},{label:'Tenho os dados da minha fatura',value:'custom',icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(IconWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__images_ic_result_component_svg___default.a,null))}],changedGasTermoEnergia:false,changedGasTermoFixo:false,changedElectricityCheia:false,changedElectricityPonta:false,changedElectricityVazio:false,changedElectricityTermoPotencia:false},_this.updatePowerChoiceOptions=function(timeCycle){var _this$props=_this.props,options=_this$props.options,fullEleTariff=_this$props.fullEleTariff;var setPowerChoices=_this.actions.setPowerChoices;var electricitySet=fullEleTariff.electricitySet;if(electricitySet&&options){var filteredSets=electricitySet.filter(function(_ref2){var ciclo_horario=_ref2.ciclo_horario;return ciclo_horario===timeCycle;});var filteredPowerChoiceOptions=[];filteredSets.forEach(function(set){var option=options.powerChoices.find(function(option){return option.value===set.potencia_contratada;});if(option){filteredPowerChoiceOptions.push(option);}});filteredPowerChoiceOptions.sort(function(a,b){return a.value-b.value;});setPowerChoices(filteredPowerChoiceOptions);}},_this.changeTimeCycle=function(timeCycle){var _this$props2=_this.props,electricityConsumptionCheia=_this$props2.electricityConsumptionCheia,electricityConsumptionVazio=_this$props2.electricityConsumptionVazio,electricityConsumptionPonta=_this$props2.electricityConsumptionPonta,electricityConsumptionSuperVazio=_this$props2.electricityConsumptionSuperVazio,fullEleTariff=_this$props2.fullEleTariff,formValues=_this$props2.formValues;var setFormValues=_this.actions.setFormValues;var electricitySet=fullEleTariff.electricitySet;//* Update power choice options to only show the sets from the chosen time cycle
_this.updatePowerChoiceOptions(timeCycle);//* Check if the new time cycle has a set with the same power choice if not change to the first
var filteredSets=electricitySet.filter(function(_ref3){var ciclo_horario=_ref3.ciclo_horario;return ciclo_horario===timeCycle;});var newPowerChoice=formValues.potenciaContratada;if(!filteredSets.find(function(_ref4){var potencia_contratada=_ref4.potencia_contratada;return potencia_contratada===newPowerChoice;})){newPowerChoice=filteredSets[0].potencia_contratada;}//* Get the correct set
var correctSet=electricitySet.find(function(_ref5){var potencia_contratada=_ref5.potencia_contratada,ciclo_horario=_ref5.ciclo_horario;return potencia_contratada===newPowerChoice&&ciclo_horario===timeCycle;});if(electricityConsumptionCheia&&electricityConsumptionVazio&&electricityConsumptionPonta){var newValues=Object.assign({},!_this.state.changedElectricityPonta&&{electricityPonta:correctSet.ponta},!_this.state.changedElectricityCheia&&{electricityCheia:correctSet.cheias},!_this.state.changedElectricityVazio&&{electricityVazio:correctSet.vazio_normal},!_this.state.changedElectricityTermoPotencia&&{electricityTermoFixo:correctSet.potencia_contratada_preco},{cicloHorario:timeCycle,potenciaContratada:newPowerChoice});if(timeCycle==='s'){var fullCheiaConsumption=Number(electricityConsumptionCheia)+Number(electricityConsumptionVazio)+Number(electricityConsumptionPonta)+Number(electricityConsumptionSuperVazio);setFormValues(Object.assign({},newValues,{electricityConsumeCheia:_this.roundNumber(fullCheiaConsumption.toFixed(2)/12)}));}else if(timeCycle==='b'){var fullVazioConsumption=Number(electricityConsumptionSuperVazio)+Number(electricityConsumptionVazio);var fullCheiaPontaConsumption=Number(electricityConsumptionCheia)+Number(electricityConsumptionPonta);setFormValues(Object.assign({},newValues,{electricityConsumeCheia:_this.roundNumber(fullCheiaPontaConsumption.toFixed(2)/12),electricityConsumeVazio:_this.roundNumber(fullVazioConsumption.toFixed(2)/12)}));}else{var _fullVazioConsumption=Number(electricityConsumptionSuperVazio)+Number(electricityConsumptionVazio);setFormValues(Object.assign({},newValues,{electricityConsumeCheia:_this.roundNumber(electricityConsumptionCheia/12),electricityConsumeVazio:_this.roundNumber(_fullVazioConsumption.toFixed(2)/12),electricityConsumePonta:_this.roundNumber(electricityConsumptionPonta/12)}));}}},_this.changeGasStage=function(stage){var fullGasTariff=_this.props.fullGasTariff;var setFormValues=_this.actions.setFormValues;var _this$state=_this.state,changedGasTermoEnergia=_this$state.changedGasTermoEnergia,changedGasTermoFixo=_this$state.changedGasTermoFixo;var gasSet=fullGasTariff.gasSet;var set=gasSet.length>0?gasSet[0]:[];var updatedFormValues=Object.assign({stage:stage},set&&!changedGasTermoEnergia&&{gasTermoEnergia:set['termo_energia_escalao_'+stage]},set&&!changedGasTermoFixo&&{gasTermoFixo:set['termo_fixo_escalao_'+stage]});setFormValues(updatedFormValues);},_this.roundNumber=function(num){if(!num)return;return Number(num).toFixed(2);},_this.roundNumberTo4=function(num){if(!num)return;return Number(num).toFixed(4);},_this.closeModal=function(){var onClose=_this.props.onClose;onClose();},_this.handleKeyDown=function(e){var editSimulation=_this.actions.editSimulation;e.stopPropagation();if(e.key==='Enter'){editSimulation();}},_this.disableSubmitButton=function(){var _this$props3=_this.props,formValues=_this$props3.formValues,electricityPriceList=_this$props3.electricityPriceList,gasPriceList=_this$props3.gasPriceList;var isCustomProfile=formValues.consumerProfile==='custom';if(!isCustomProfile){if(electricityPriceList&&!formValues.electricityAnnualBilling||gasPriceList&&!formValues.gasAnnualBilling){return true;}}else if(isCustomProfile){var customElectricityCondition=['potenciaContratada','cicloHorario','electricityConsumeCheia'];if(formValues.cicloHorario==='s'){customElectricityCondition=[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(customElectricityCondition),['electricityCheia','electricityTermoFixo']).some(function(field){return!formValues[field];});}else if(formValues.cicloHorario==='b'){customElectricityCondition=[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(customElectricityCondition),['electricityConsumeVazio','electricityCheia','electricityVazio','electricityTermoFixo']).some(function(field){return!formValues[field];});}else if(formValues.cicloHorario==='t'){customElectricityCondition=[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(customElectricityCondition),['electricityConsumeVazio','electricityConsumePonta','electricityCheia','electricityPonta','electricityVazio','electricityTermoFixo']).some(function(field){return!formValues[field];});}var customGasCondition=['gasMonthlyConsumption','gasTermoEnergia','gasTermoFixo'].some(function(field){return!formValues[field];});if(electricityPriceList&&gasPriceList){return customElectricityCondition||customGasCondition;}if(electricityPriceList){return customElectricityCondition;}if(gasPriceList){return customGasCondition;}}return false;},_this.renderStandardNightInputs=function(){var _this$props4=_this.props,formValues=_this$props4.formValues,electricityPriceList=_this$props4.electricityPriceList,gasPriceList=_this$props4.gasPriceList;var setFormValues=_this.actions.setFormValues;return formValues.consumerProfile!=='custom'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StandardNight,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'titleRow'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__images_ic_result_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h5',null,'Fatura de Energia Estimada com Impostos e IVA')),electricityPriceList&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'titleRow'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__images_ic_eletricity_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h5',null,'Eletricidade')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'iconInput'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__InputV2__["a" /* default */],{style:{flexGrow:'1'},required:true,label:'Custo Mensal',type:'number',placeholder:'0',suffix:'\u20AC',value:Number(formValues.electricityMonthlyBilling),onChange:function onChange(val){return setFormValues({electricityMonthlyBilling:_this.roundNumber(val),electricityAnnualBilling:_this.roundNumber(val*12)});}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__images_ic_dependency_component_svg___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__InputV2__["a" /* default */],{style:{width:'100%'},label:'Custo Anual',required:true,type:'number',suffix:'\u20AC',placeholder:'0',value:Number(formValues.electricityAnnualBilling),onChange:function onChange(val){return setFormValues({electricityMonthlyBilling:_this.roundNumber(val/12),electricityAnnualBilling:_this.roundNumber(val)});}}))),gasPriceList&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'titleRow gas'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__images_ic_gas_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h5',null,'G\xE1s Natural')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'iconInput'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__InputV2__["a" /* default */],{style:{flexGrow:'1'},required:true,label:'Custo Mensal',type:'number',placeholder:'0',suffix:'\u20AC',value:Number(formValues.gasMonthlyBilling),onChange:function onChange(val){return setFormValues({gasMonthlyBilling:_this.roundNumber(val),gasAnnualBilling:_this.roundNumber(val*12)});}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'icon'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__images_ic_dependency_component_svg___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__InputV2__["a" /* default */],{style:{width:'100%'},label:'Custo Anual',required:true,type:'number',suffix:'\u20AC',placeholder:'0',value:Number(formValues.gasAnnualBilling),onChange:function onChange(val){return setFormValues({gasMonthlyBilling:_this.roundNumber(val/12),gasAnnualBilling:_this.roundNumber(val)});}})))):null;},_this.renderSimpleTimeCycleElectricityInputs=function(){var formValues=_this.props.formValues;var setFormValues=_this.actions.setFormValues;return formValues.cicloHorario==='s'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(EnergyInputs,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputsGroup,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4',null,'Consumo Mensal'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomInputsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__InputV2__["a" /* default */],{style:{width:'100%'},required:true,label:'Energia',type:'number',placeholder:'0',suffix:'kWh',value:Number(formValues.electricityConsumeCheia),onChange:function onChange(val){return setFormValues({electricityConsumeCheia:_this.roundNumber(val)});}}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputsGroup,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4',null,'Pre\xE7os (sem IVA)',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__TooltipV2__["a" /* default */],{style:{height:'16px'},content:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TooltipText,null,'Pre\xE7os com a taxa de acesso \xE0 rede (sem IVA)',' '),arrowLocation:'topLeft'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__images_ic_info2_component_svg___default.a,{width:'16px',height:'16px'}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomInputsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__InputV2__["a" /* default */],{style:{width:'100%'},required:true,label:'Energia',type:'number',placeholder:'0',suffix:'\u20AC/kWh',value:Number(formValues.electricityCheia),onChange:function onChange(val){_this.setState({changedElectricityCheia:true});setFormValues({electricityCheia:_this.roundNumberTo4(val)});}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__InputV2__["a" /* default */],{style:{width:'100%'},required:true,label:'Termo Pot\xEAncia',type:'number',placeholder:'0',suffix:'\u20AC/Dia',value:Number(formValues.electricityTermoFixo),onChange:function onChange(val){_this.setState({changedElectricityTermoPotencia:true});setFormValues({electricityTermoFixo:_this.roundNumberTo4(val)});}})))):null;},_this.renderBiTimeCycleElectricityInputs=function(){var formValues=_this.props.formValues;var setFormValues=_this.actions.setFormValues;return formValues.cicloHorario==='b'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(EnergyInputs,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputsGroup,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4',null,'Consumo Mensal'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomInputsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__InputV2__["a" /* default */],{style:{width:'100%'},required:true,label:'Fora do Vazio',type:'number',placeholder:'0',suffix:'kWh',value:Number(formValues.electricityConsumeCheia),onChange:function onChange(val){return setFormValues({electricityConsumeCheia:_this.roundNumber(val)});}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__InputV2__["a" /* default */],{style:{width:'100%'},required:true,label:'Vazio',type:'number',placeholder:'0',suffix:'kWh',value:Number(formValues.electricityConsumeVazio),onChange:function onChange(val){return setFormValues({electricityConsumeVazio:_this.roundNumber(val)});}}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputsGroup,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4',null,'Pre\xE7os (sem IVA)',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__TooltipV2__["a" /* default */],{style:{height:'16px'},content:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TooltipText,null,'Pre\xE7os com a taxa de acesso \xE0 rede (sem IVA)',' '),arrowLocation:'topLeft'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__images_ic_info2_component_svg___default.a,{width:'16px',height:'16px'}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomInputsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__InputV2__["a" /* default */],{style:{width:'100%'},required:true,label:'Fora do Vazio',type:'number',placeholder:'0',suffix:'\u20AC/kWh',value:Number(formValues.electricityCheia),onChange:function onChange(val){_this.setState({changedElectricityCheia:true});setFormValues({electricityCheia:_this.roundNumberTo4(val)});}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__InputV2__["a" /* default */],{style:{width:'100%'},required:true,label:'Vazio',type:'number',placeholder:'0',suffix:'\u20AC/Dia',value:Number(formValues.electricityVazio),onChange:function onChange(val){_this.setState({changedElectricityVazio:true});setFormValues({electricityVazio:_this.roundNumberTo4(val)});}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomInputsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__InputV2__["a" /* default */],{style:{width:'100%'},required:true,label:'Termo Fixo',type:'number',placeholder:'0',suffix:'\u20AC/kWh',value:Number(formValues.electricityTermoFixo),onChange:function onChange(val){_this.setState({changedElectricityTermoPotencia:true});setFormValues({electricityTermoFixo:_this.roundNumberTo4(val)});}})))):null;},_this.renderTriTimeCycleElectricityInputs=function(){var formValues=_this.props.formValues;var setFormValues=_this.actions.setFormValues;return formValues.cicloHorario==='t'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(EnergyInputs,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputsGroup,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4',null,'Consumo Mensal'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomInputsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__InputV2__["a" /* default */],{style:{width:'100%'},required:true,label:'Ponta',type:'number',placeholder:'0',suffix:'kWh',value:Number(formValues.electricityConsumePonta),onChange:function onChange(val){return setFormValues({electricityConsumePonta:_this.roundNumber(val)});}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__InputV2__["a" /* default */],{style:{width:'100%'},required:true,label:'Cheias',type:'number',placeholder:'0',suffix:'kWh',value:Number(formValues.electricityConsumeCheia),onChange:function onChange(val){return setFormValues({electricityConsumeCheia:_this.roundNumber(val)});}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomInputsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__InputV2__["a" /* default */],{style:{width:'100%'},required:true,label:'Vazio',type:'number',placeholder:'0',suffix:'kWh',value:Number(formValues.electricityConsumeVazio),onChange:function onChange(val){return setFormValues({electricityConsumeVazio:_this.roundNumber(val)});}}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputsGroup,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4',null,'Pre\xE7os (sem IVA)',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__TooltipV2__["a" /* default */],{style:{height:'16px'},content:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TooltipText,null,'Pre\xE7os com a taxa de acesso \xE0 rede (sem IVA)',' '),arrowLocation:'topLeft'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__images_ic_info2_component_svg___default.a,{width:'16px',height:'16px'}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomInputsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__InputV2__["a" /* default */],{style:{width:'100%'},required:true,label:'Ponta',type:'number',placeholder:'0',suffix:'\u20AC/kWh',value:Number(formValues.electricityPonta),onChange:function onChange(val){_this.setState({changedElectricityPonta:true});setFormValues({electricityPonta:_this.roundNumberTo4(val)});}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__InputV2__["a" /* default */],{style:{width:'100%'},required:true,label:'Cheias',type:'number',placeholder:'0',suffix:'\u20AC/Dia',value:Number(formValues.electricityCheia),onChange:function onChange(val){_this.setState({changedElectricityCheia:true});setFormValues({electricityCheia:_this.roundNumberTo4(val)});}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomInputsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__InputV2__["a" /* default */],{style:{width:'100%'},required:true,label:'Vazio',type:'number',placeholder:'0',suffix:'\u20AC/kWh',value:Number(formValues.electricityVazio),onChange:function onChange(val){_this.setState({changedElectricityVazio:true});setFormValues({electricityVazio:_this.roundNumberTo4(val)});}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__InputV2__["a" /* default */],{style:{width:'100%'},required:true,label:'Termo Fixo',type:'number',placeholder:'0',suffix:'\u20AC/kWh',value:Number(formValues.electricityTermoFixo),onChange:function onChange(val){_this.setState({changedElectricityTermoPotencia:true});setFormValues({electricityTermoFixo:_this.roundNumberTo4(val)});}})))):null;},_this.renderCustomInputs=function(){var _this$props5=_this.props,formValues=_this$props5.formValues,powerChoices=_this$props5.powerChoices,timeCycleChoices=_this$props5.timeCycleChoices,gasStagesChoices=_this$props5.gasStagesChoices,electricityPriceList=_this$props5.electricityPriceList,gasPriceList=_this$props5.gasPriceList,fullEleTariff=_this$props5.fullEleTariff;var setFormValues=_this.actions.setFormValues;var electricitySet=fullEleTariff.electricitySet;return formValues.consumerProfile==='custom'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomContent,null,electricityPriceList&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'titleRow'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__images_ic_eletricity_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h5',null,'Eletricidade')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(EnergyInputs,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomInputsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WrapperSelect,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputLabel,null,'Pot\xEAncia contratada'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledSelect,{items:powerChoices,onChange:function onChange(_ref6){var value=_ref6.value;if(value!==formValues.potenciaContratada){var correctSet=electricitySet.find(function(_ref7){var potencia_contratada=_ref7.potencia_contratada,ciclo_horario=_ref7.ciclo_horario;return potencia_contratada===value&&ciclo_horario===formValues.cicloHorario;});setFormValues(Object.assign({potenciaContratada:value},!_this.state.changedElectricityPonta&&{electricityPonta:correctSet.ponta},!_this.state.changedElectricityCheia&&{electricityCheia:correctSet.cheias},!_this.state.changedElectricityVazio&&{electricityVazio:correctSet.vazio_normal},!_this.state.changedElectricityTermoPotencia&&{electricityTermoFixo:correctSet.potencia_contratada_preco}));}},selected:formValues.potenciaContratada,arrowIcon:__WEBPACK_IMPORTED_MODULE_15_containers_ProfileV2_images_ic_arrow_component_svg___default.a})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WrapperSelect,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputLabel,null,'Tarif\xE1rio'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledSelect,{items:timeCycleChoices,onChange:function onChange(_ref8){var value=_ref8.value;if(value!==formValues.cicloHorario){_this.changeTimeCycle(value);}},selected:formValues.cicloHorario,arrowIcon:__WEBPACK_IMPORTED_MODULE_15_containers_ProfileV2_images_ic_arrow_component_svg___default.a}))),_this.renderSimpleTimeCycleElectricityInputs(),_this.renderBiTimeCycleElectricityInputs(),_this.renderTriTimeCycleElectricityInputs())),gasPriceList&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'titleRow gas'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__images_ic_gas_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h5',null,'G\xE1s Natural')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(EnergyInputs,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputsGroup,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4',null,'Consumo Mensal'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomInputsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WrapperSelect,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputLabel,null,'Escal\xE3o'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledSelect,{items:gasStagesChoices,onChange:function onChange(_ref9){var value=_ref9.value;if(value!==formValues.stage){_this.changeGasStage(value);}},selected:formValues.stage,arrowIcon:__WEBPACK_IMPORTED_MODULE_15_containers_ProfileV2_images_ic_arrow_component_svg___default.a})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__InputV2__["a" /* default */],{style:{width:'100%'},required:true,label:'Energia',type:'number',placeholder:'0',suffix:'kWh',value:Number(formValues.gasMonthlyConsumption),onChange:function onChange(val){return setFormValues({gasMonthlyConsumption:_this.roundNumber(val)});}}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputsGroup,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4',null,'Pre\xE7os (sem IVA)',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__TooltipV2__["a" /* default */],{style:{height:'16px'},content:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TooltipText,null,'Pre\xE7os com a taxa de acesso \xE0 rede (sem IVA)',' '),arrowLocation:'topLeft'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__images_ic_info2_component_svg___default.a,{width:'16px',height:'16px'}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomInputsRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__InputV2__["a" /* default */],{style:{width:'100%'},required:true,label:'Energia',type:'number',placeholder:'0',suffix:'\u20AC/kWh',value:Number(formValues.gasTermoEnergia),onChange:function onChange(val){_this.setState({changedGasTermoEnergia:true});setFormValues({gasTermoEnergia:_this.roundNumberTo4(val)});}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__InputV2__["a" /* default */],{style:{width:'100%'},required:true,label:'Termo Fixo',type:'number',placeholder:'0',suffix:'\u20AC/Dia',value:Number(formValues.gasTermoFixo),onChange:function onChange(val){_this.setState({changedGasTermoFixo:true});setFormValues({gasTermoFixo:_this.roundNumberTo4(val)});}})))))):null;},_this.renderWarningText=function(){var formValues=_this.props.formValues;return formValues.consumerProfile!=='custom'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TextSection,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p',null,'Os c\xE1lculos apresentados assentam nos pre\xE7os de energia do mercado regulado. Se quiser de acordo com o pre\xE7o de energia da sua fatura, escolha o separador "Tenho os dados da minha fatura"')):null;},_this.renderForm=function(){var _this$props6=_this.props,loading=_this$props6.loading,formValues=_this$props6.formValues,simulationCode=_this$props6.simulationCode;var _this$actions=_this.actions,setFormValues=_this$actions.setFormValues,editSimulation=_this$actions.editSimulation;return!loading?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Form,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(UtilizationSection,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledSelect,{items:_this.state.utilizationProfile.map(function(item){return item;}),onChange:function onChange(_ref10){var value=_ref10.value;if(value==='standard'||value==='night'){setFormValues({consumerProfile:value});}else{_this.updatePowerChoiceOptions(formValues.cicloHorario||'s');setFormValues({consumerProfile:'custom',potenciaContratada:formValues.potenciaContratada||3.45,cicloHorario:formValues.cicloHorario||'s'});}},selected:formValues.consumerProfile,arrowIcon:__WEBPACK_IMPORTED_MODULE_15_containers_ProfileV2_images_ic_arrow_component_svg___default.a})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InvoiceSection,null,_this.renderStandardNightInputs(),_this.renderCustomInputs()),_this.renderWarningText(),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(BtnsWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ButtonOutlineV2__["a" /* default */],{onClick:function onClick(){return _this.closeModal();}},'Cancelar'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__ButtonGradientV2__["a" /* default */],{onClick:function onClick(e){e.preventDefault();editSimulation(simulationCode);},disabled:_this.disableSubmitButton()},'Atualizar dados'))):null;},_temp),__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(EditDataModalMobileV2,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,electricityPriceList=_props.electricityPriceList,gasPriceList=_props.gasPriceList,prices=_props.prices,electricityAnnualBilling=_props.electricityAnnualBilling,gasAnnualBilling=_props.gasAnnualBilling,electricityConsumptionCheia=_props.electricityConsumptionCheia,electricityConsumptionVazio=_props.electricityConsumptionVazio,electricityConsumptionPonta=_props.electricityConsumptionPonta,electricityConsumptionSuperVazio=_props.electricityConsumptionSuperVazio,gasConsumption=_props.gasConsumption,priceListTimeCycle=_props.priceListTimeCycle,gasStage=_props.gasStage;var setFormValues=this.actions.setFormValues;if(electricityPriceList){setFormValues({electricityPonta:prices.electricity.ponta,electricityCheia:prices.electricity.cheia,electricityVazio:prices.electricity.vazio,electricityTermoFixo:prices.electricity.termo_fixo,electricityAnnualBilling:electricityAnnualBilling||0,electricityMonthlyBilling:electricityAnnualBilling?this.roundNumber(electricityAnnualBilling/12):0});if(electricityConsumptionCheia&&electricityConsumptionVazio&&electricityConsumptionPonta){if(priceListTimeCycle==='s'){var fullCheiaConsumption=Number(electricityConsumptionCheia)+Number(electricityConsumptionVazio)+Number(electricityConsumptionPonta)+Number(electricityConsumptionSuperVazio);setFormValues({electricityConsumeCheia:this.roundNumber(fullCheiaConsumption.toFixed(2)/12)});}else if(priceListTimeCycle==='b'){var fullVazioConsumption=Number(electricityConsumptionSuperVazio)+Number(electricityConsumptionVazio);var fullCheiaPontaConsumption=Number(electricityConsumptionCheia)+Number(electricityConsumptionPonta);setFormValues({electricityConsumeCheia:this.roundNumber(fullCheiaPontaConsumption.toFixed(2)/12),electricityConsumeVazio:this.roundNumber(fullVazioConsumption.toFixed(2)/12)});}else{var _fullVazioConsumption2=Number(electricityConsumptionSuperVazio)+Number(electricityConsumptionVazio);setFormValues({electricityConsumeCheia:this.roundNumber(electricityConsumptionCheia/12),electricityConsumeVazio:this.roundNumber(_fullVazioConsumption2.toFixed(2)/12),electricityConsumePonta:this.roundNumber(electricityConsumptionPonta/12)});}}}if(gasPriceList){setFormValues({gasTermoEnergia:prices.gas.termo_energia,gasTermoFixo:prices.gas.termo_fixo,gasAnnualBilling:gasAnnualBilling||0,gasMonthlyBilling:gasAnnualBilling?this.roundNumber(gasAnnualBilling/12):0,gasMonthlyConsumption:gasConsumption?this.roundNumber(gasConsumption/12):0,stage:gasStage?gasStage:1});}}},{key:'renderLoading',value:function renderLoading(){var loading=this.props.loading;return loading?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_Loading__["a" /* default */],null):null;}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__MobileModalV2__["a" /* default */],{setModalTriggerHeight:this.props.setModalTriggerHeight,modalTriggerHeight:this.props.modalTriggerHeight,title:'Ajustar Valores',onClose:function onClose(){return _this2.closeModal();},onKeyDown:this.handleKeyDown,tabIndex:-1},this.renderLoading(),this.renderForm());}}]);return EditDataModalMobileV2;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]))||_class;var Form=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].form(_templateObject);var TooltipText=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].h6(_templateObject2);var TextSection=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject3);var UtilizationSection=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject4);var IconWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject5);var InvoiceSection=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject6);var StandardNight=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject7);var CustomContent=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject8);var EnergyInputs=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject9);var InputsGroup=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(EnergyInputs)(_templateObject10);var CustomInputsRow=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject11);var StyledSelect=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_20_components_SelectV2__["a" /* default */])(_templateObject12);var InputLabel=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].label(_templateObject13);var WrapperSelect=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject14);var InputsRow=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject15);var BtnsWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject16);

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditPricesModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Modal__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Input__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CheckInput__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Svg_ic_gas_svg__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Svg_ic_gas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_Svg_ic_gas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Svg_ic_eletricidade_svg__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Svg_ic_eletricidade_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_Svg_ic_eletricidade_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils__ = __webpack_require__(11);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding: 20px;\n  width: 100%;\n'],['\n  padding: 20px;\n  width: 100%;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: row;\n'],['\n  display: flex;\n  flex-direction: row;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  margin-bottom: 5px;\n'],['\n  width: 100%;\n  margin-bottom: 5px;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #676767;\n  font-family: Nunito;\n  font-size: 14px;\n  line-height: 18px;\n'],['\n  color: #676767;\n  font-family: Nunito;\n  font-size: 14px;\n  line-height: 18px;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  width: 50%;\n  padding: ',';\n  ','\n\n  ','\n'],['\n  display: flex;\n  flex-direction: column;\n  width: 50%;\n  padding: ',';\n  ','\n\n  ','\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ','\n'],['\n  ','\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  color: #3e3e3e;\n  font-family: Nunito;\n  font-size: 17px;\n  font-weight: bold;\n  line-height: 14px;\n  margin-bottom: 20px;\n'],['\n  display: block;\n  color: #3e3e3e;\n  font-family: Nunito;\n  font-size: 17px;\n  font-weight: bold;\n  line-height: 14px;\n  margin-bottom: 20px;\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  max-width: 4%;\n  position: relative;\n  top: 5px;\n  margin-right: 5px;\n'],['\n  max-width: 4%;\n  position: relative;\n  top: 5px;\n  margin-right: 5px;\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  max-width: 5%;\n  margin-right: 5px;\n'],['\n  max-width: 5%;\n  margin-right: 5px;\n']);var EditPricesModal=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(EditPricesModal,_Component);function EditPricesModal(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,EditPricesModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=EditPricesModal.__proto__||Object.getPrototypeOf(EditPricesModal)).call.apply(_ref,[this].concat(args))),_this),_this.onUpdate=function(){var _this$props=_this.props,form=_this$props.form,updatePrices=_this$props.updatePrices;if(!form.invalid){updatePrices();}},_this.renderButtons=[{label:'cancelar',primary:false,click:function click(){return _this.props.toogler({opened:false});}},{label:'guardar',primary:true,click:function click(){return _this.onUpdate();}}],_this.isValid=function(obj,field){var form=_this.props.form;if(!obj[field]){form.invalid=true;return false;}else{form.invalid=false;}},_this.renderErrorMessage=function(value){if(!value){return'Campo de preenchimento obrigat\xF3rio';}},_temp),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(EditPricesModal,[{key:'render',value:function render(){var _props=this.props,toogler=_props.toogler,form=_props.form,_onChange=_props.onChange,electricityPriceList=_props.electricityPriceList,gasPriceList=_props.gasPriceList,timeCycle=_props.timeCycle;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Modal__["a" /* default */],{title:'Ajustar Pre\xE7os do meu tarif\xE1rio',toogler:true,buttons:this.renderButtons,onClick:function onClick(){return toogler({opened:false});}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Row,null,electricityPriceList&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Col,{eletricty:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Title,{style:{color:'#FF8E2A'}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(EletricityIcon,{src:__WEBPACK_IMPORTED_MODULE_11_components_Svg_ic_eletricidade_svg___default.a}),'Eletricidade'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputBox,{first:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputForm,{onlyDecimalNumbers:true,label:'Termo Pot\xEAncia (\u20AC/dia)',maxLength:6,valid:this.isValid(form.electricity_prices,'termo_fixo'),errorMessage:this.renderErrorMessage(form.electricity_prices&&form.electricity_prices.termo_fixo),value:form.electricity_prices&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_utils__["o" /* replaceDots */])(form.electricity_prices.termo_fixo),onChange:function onChange(e){return _onChange('electricity_prices','termo_fixo',e);}})),timeCycle==='s'&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputBox,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputForm,{onlyDecimalNumbers:true,label:'Energia (\u20AC/kWh)',maxLength:6,valid:this.isValid(form.electricity_prices,'cheia'),errorMessage:this.renderErrorMessage(form.electricity_prices&&form.electricity_prices.cheia),value:form.electricity_prices&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_utils__["o" /* replaceDots */])(form.electricity_prices.cheia),onChange:function onChange(e){return _onChange('electricity_prices','cheia',e);}})),timeCycle!=='s'&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputBox,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputForm,{onlyDecimalNumbers:true,label:'Energia - '+(timeCycle==='b'?'Fora do Vazio':'Cheias')+' (\u20AC/kWh)',maxLength:6,valid:this.isValid(form.electricity_prices,'cheia'),errorMessage:this.renderErrorMessage(form.electricity_prices&&form.electricity_prices.cheia),value:form.electricity_prices&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_utils__["o" /* replaceDots */])(form.electricity_prices.cheia),onChange:function onChange(e){return _onChange('electricity_prices','cheia',e);}})),timeCycle!=='s'&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputBox,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputForm,{onlyDecimalNumbers:true,label:'Energia - Vazio (\u20AC/kWh)',maxLength:6,valid:this.isValid(form.electricity_prices,'vazio'),errorMessage:this.renderErrorMessage(form.electricity_prices,'vazio'),value:form.electricity_prices&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_utils__["o" /* replaceDots */])(form.electricity_prices.vazio),onChange:function onChange(e){return _onChange('electricity_prices','vazio',e);}})),timeCycle!=='b'&&timeCycle!=='s'&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputBox,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputForm,{label:'Energia - Ponta (\u20AC/kWh)',onlyDecimalNumbers:true,maxLength:6,valid:this.isValid(form.electricity_prices,'ponta'),errorMessage:this.renderErrorMessage(form.electricity_prices&&form.electricity_prices.ponta),value:form.electricity_prices&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_utils__["o" /* replaceDots */])(form.electricity_prices.ponta),onChange:function onChange(e){return _onChange('electricity_prices','ponta',e);}}))),gasPriceList&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Col,{hasEletricity:electricityPriceList,eletricty:false},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Title,{style:{color:'#00BDED'}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(GasIcon,{src:__WEBPACK_IMPORTED_MODULE_10_components_Svg_ic_gas_svg___default.a}),'G\xE1s Natural'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputBox,{first:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputForm,{label:'Termo Fixo (\u20AC/dia)',onlyDecimalNumbers:true,maxLength:6,valid:this.isValid(form.gas_prices,'termo_fixo'),errorMessage:this.renderErrorMessage(form.gas_prices&&form.gas_prices.termo_fixo),value:form.gas_prices&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_utils__["o" /* replaceDots */])(form.gas_prices.termo_fixo),onChange:function onChange(e){return _onChange('gas_prices','termo_fixo',e);}})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputBox,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputForm,{label:'Energia (\u20AC/kWh)',onlyDecimalNumbers:true,maxLength:6,valid:this.isValid(form.gas_prices,'termo_energia'),errorMessage:this.renderErrorMessage(form.gas_prices&&form.gas_prices.termo_energia),value:form.gas_prices&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_utils__["o" /* replaceDots */])(form.gas_prices.termo_energia),onChange:function onChange(e){return _onChange('gas_prices','termo_energia',e);}})))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputBox,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CheckForm,{label:'Manter os mesmos descontos aplicados ao tarif\xE1rio?',value:form.apply_refunds,onClick:function onClick(){return _onChange('','apply_refunds','');}}))));}}]);return EditPricesModal;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);var Wrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject);var Row=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject2);var InputForm=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_8__Input__["a" /* default */])(_templateObject3);var CheckForm=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_9__CheckInput__["a" /* default */])(_templateObject4);var Col=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject5,function(_ref2){var eletricty=_ref2.eletricty;return eletricty?' 0 20px 0 0 ':'0 0 0 20px';},function(_ref3){var hasEletricity=_ref3.hasEletricity;return!hasEletricity&&'\n        padding-left: 0px !important;\n    ';},function(_ref4){var eletricty=_ref4.eletricty;return eletricty&&'\n        border-right: 1px solid #F9F9F9;\n    ';});var InputBox=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject6,function(_ref5){var first=_ref5.first;return!first&&'\n        margin-top: 20px;\n    ';});var Title=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject7);var EletricityIcon=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].img(_templateObject8);var GasIcon=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].img(_templateObject9);

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin: 0;\n  padding: 0;\n  display: inline-block;\n  text-align: center;\n  .group:before,\n  .group:after {\n    content: \'\';\n    display: table;\n  }\n  .group:after {\n    clear: both;\n  }\n  .group {\n    zoom: 1; /* For IE 6/7 (trigger hasLayout) */\n  }\n'],['\n  margin: 0;\n  padding: 0;\n  display: inline-block;\n  text-align: center;\n  .group:before,\n  .group:after {\n    content: \'\';\n    display: table;\n  }\n  .group:after {\n    clear: both;\n  }\n  .group {\n    zoom: 1; /* For IE 6/7 (trigger hasLayout) */\n  }\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin-right: 15px;\n  max-width: 40px;\n  max-height: 40px;\n  display: inline-block;\n  vertical-align: middle;\n'],['\n  margin-right: 15px;\n  max-width: 40px;\n  max-height: 40px;\n  display: inline-block;\n  vertical-align: middle;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-family: Nunito;\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 40px;\n  display: inline-block;\n  vertical-align: middle;\n  max-width: 300px;\n'],['\n  font-family: Nunito;\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 40px;\n  display: inline-block;\n  vertical-align: middle;\n  max-width: 300px;\n']);var EquipmentHeader=function EquipmentHeader(_ref){var className=_ref.className,icon=_ref.icon,title=_ref.title;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Header,{className:className},icon&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Image,{className:'group',src:icon,alt:title}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Title,{className:'group'},title));};/* harmony default export */ __webpack_exports__["a"] = (EquipmentHeader);var Header=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject);var Image=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].img(_templateObject2);var Title=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject3);

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ic_remove_svg__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ic_remove_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ic_remove_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ic_edit_svg__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ic_edit_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ic_edit_svg__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  border: 1px solid #ccc;\n  padding: 10px;\n  margin-top: 5px;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n'],['\n  border: 1px solid #ccc;\n  padding: 10px;\n  margin-top: 5px;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 0.5;\n  align-items: center;\n  display: flex;\n'],['\n  flex: 0.5;\n  align-items: center;\n  display: flex;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 0.5;\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n'],['\n  flex: 0.5;\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin-right: 10px;\n  width: 35px;\n  height: 35px;\n'],['\n  margin-right: 10px;\n  width: 35px;\n  height: 35px;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-weight: bold;\n  font-size: 14px;\n'],['\n  font-weight: bold;\n  font-size: 14px;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()([''],['']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-weight: bold;\n  margin-right: 5px;\n'],['\n  font-weight: bold;\n  margin-right: 5px;\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 20px;\n  height: 20px;\n  background: none;\n  outline: none;\n  background-image: url(',');\n  background-size: contain;\n  border: 0;\n  background-repeat: no-repeat;\n  cursor: pointer;\n'],['\n  width: 20px;\n  height: 20px;\n  background: none;\n  outline: none;\n  background-image: url(',');\n  background-size: contain;\n  border: 0;\n  background-repeat: no-repeat;\n  cursor: pointer;\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 20px;\n  height: 20px;\n  background: none;\n  outline: none;\n  background-image: url(',');\n  background-size: contain;\n  border: 0;\n  background-repeat: no-repeat;\n  margin-right: 10px;\n  cursor: pointer;\n'],['\n  width: 20px;\n  height: 20px;\n  background: none;\n  outline: none;\n  background-image: url(',');\n  background-size: contain;\n  border: 0;\n  background-repeat: no-repeat;\n  margin-right: 10px;\n  cursor: pointer;\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin-left: auto;\n'],['\n  margin-left: auto;\n']);/* eslint-disable camelcase */var Equipment=function Equipment(_ref){var name=_ref.name,classes=_ref.classes,equipment_icon=_ref.equipment_icon,selectedClass=_ref.selectedClass,onRemove=_ref.onRemove,onEdit=_ref.onEdit,_ref$showEnergyClass=_ref.showEnergyClass,showEnergyClass=_ref$showEnergyClass===undefined?true:_ref$showEnergyClass;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Left,null,equipment_icon&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Icon,{src:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils__["f" /* generateMediaUrl */])(equipment_icon.icon),alt:name}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Name,null,name)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Right,null,showEnergyClass&&selectedClass&&classes&&classes.length>1&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Classe,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Label,null,selectedClass.classe_energetica.name)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Actions,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Edit,{onClick:function onClick(){return onEdit();}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Remove,{onClick:function onClick(){return onRemove();}}))));};/* eslint-enable camelcase *//* harmony default export */ __webpack_exports__["a"] = (Equipment);var Wrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].li(_templateObject);var Left=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject2);var Right=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject3);var Icon=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].img(_templateObject4);var Name=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject5);var Classe=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject6);var Label=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject7);var Remove=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].button(_templateObject8,__WEBPACK_IMPORTED_MODULE_4__ic_remove_svg___default.a);var Edit=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].button(_templateObject9,__WEBPACK_IMPORTED_MODULE_5__ic_edit_svg___default.a);var Actions=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject10);

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Toggle__ = __webpack_require__(899);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid #efefef;\n  padding: 10px;\n'],['\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid #efefef;\n  padding: 10px;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #010101;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 16px;\n'],['\n  color: #010101;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 16px;\n']);/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var equipment=_ref.equipment,selected=_ref.selected,onToggle=_ref.onToggle;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(EquipmentWrapper,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Name,null,equipment.name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Toggle__["a" /* default */],{selected:selected,onClick:function onClick(){return onToggle();}}));});var EquipmentWrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject);var Name=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject2);

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FeedbackContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FeedbackModalV2_logic__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Loading__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ButtonOutlineV2__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ButtonGradientV2__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__BoxRadioV2__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FeedbackModalV2_images_ic_review_component_svg__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FeedbackModalV2_images_ic_review_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__FeedbackModalV2_images_ic_review_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__FeedbackModalV2_images_ic_cry_component_svg__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__FeedbackModalV2_images_ic_cry_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__FeedbackModalV2_images_ic_cry_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__FeedbackModalV2_images_ic_smile_component_svg__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__FeedbackModalV2_images_ic_smile_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__FeedbackModalV2_images_ic_smile_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__FeedbackModalV2_images_ic_sad_component_svg__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__FeedbackModalV2_images_ic_sad_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__FeedbackModalV2_images_ic_sad_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__FeedbackModalV2_images_ic_neutral_component_svg__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__FeedbackModalV2_images_ic_neutral_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__FeedbackModalV2_images_ic_neutral_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__FeedbackModalV2_images_ic_happy_component_svg__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__FeedbackModalV2_images_ic_happy_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__FeedbackModalV2_images_ic_happy_component_svg__);
var _class;var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: stretch;\n  gap: 16px;\n  width: 100%;\n  height: 100%;\n'],['\n  display: flex;\n  align-items: stretch;\n  gap: 16px;\n  width: 100%;\n  height: 100%;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-grow: 1;\n  align-self: stretch;\n  border: 1px solid #ececec;\n'],['\n  display: flex;\n  flex-grow: 1;\n  align-self: stretch;\n  border: 1px solid #ececec;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-self: stretch;\n  width: 100%;\n  height: 100%;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-self: stretch;\n  width: 100%;\n  height: 100%;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  flex: 1 0 0;\n  padding: 12px 16px;\n  width: 100%;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  flex: 1 0 0;\n  padding: 12px 16px;\n  width: 100%;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  display: flex;\n  padding: 10px;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 10px;\n  align-self: stretch;\n  border: 1px solid #ececec;\n\n  overflow: hidden;\n  color: #3e3e3e;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n\n  &::placeholder {\n    color: #616161;\n  }\n'],['\n  width: 100%;\n  display: flex;\n  padding: 10px;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 10px;\n  align-self: stretch;\n  border: 1px solid #ececec;\n\n  overflow: hidden;\n  color: #3e3e3e;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n\n  &::placeholder {\n    color: #616161;\n  }\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #3e3e3e;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px; /* 142.857% */\n  margin: 0;\n  width: unset;\n'],['\n  color: #3e3e3e;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px; /* 142.857% */\n  margin: 0;\n  width: unset;\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  align-self: stretch;\n  flex-wrap: wrap;\n\n  @media (min-width: 1000px) {\n    flex-wrap: nowrap;\n  }\n'],['\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  align-self: stretch;\n  flex-wrap: wrap;\n\n  @media (min-width: 1000px) {\n    flex-wrap: nowrap;\n  }\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 12px;\n  align-self: stretch;\n'],['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 12px;\n  align-self: stretch;\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  align-self: stretch;\n'],['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  align-self: stretch;\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ',';\n  font-size: 14px;\n  font-style: normal;\n  font-family: Nunito;\n  font-weight: 700;\n  line-height: 20px;\n  margin: 0;\n  text-transform: unset;\n  text-align: left;\n  letter-spacing: unset;\n'],['\n  ',';\n  font-size: 14px;\n  font-style: normal;\n  font-family: Nunito;\n  font-weight: 700;\n  line-height: 20px;\n  margin: 0;\n  text-transform: unset;\n  text-align: left;\n  letter-spacing: unset;\n']),_templateObject11=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #3e3e3e;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  margin: 0;\n'],['\n  color: #3e3e3e;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  margin: 0;\n']),_templateObject12=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  width: 310px;\n  padding: 24px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n  background: linear-gradient(270deg, #006736 -58.87%, #93c13e 100%);\n'],['\n  display: flex;\n  width: 310px;\n  padding: 24px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n  background: linear-gradient(270deg, #006736 -58.87%, #93c13e 100%);\n']),_templateObject13=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  align-self: stretch;\n  color: #fff;\n  font-family: Nunito;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 32px; /* 133.333% */\n  text-transform: uppercase;\n  margin: 0;\n'],['\n  align-self: stretch;\n  color: #fff;\n  font-family: Nunito;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 32px; /* 133.333% */\n  text-transform: uppercase;\n  margin: 0;\n']),_templateObject14=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #fff;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  margin: 0;\n'],['\n  color: #fff;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  margin: 0;\n']),_templateObject15=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 16px;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  align-self: stretch;\n  border-top: 1px solid #ececec;\n'],['\n  display: flex;\n  padding: 16px;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  align-self: stretch;\n  border-top: 1px solid #ececec;\n']);/**
 * Conteúdo do inquérito de satisfação SEM a moldura de modal.
 *
 * É o mesmo conteúdo interno da FeedbackModalV2 (formulário + painel verde),
 * mas sem overlay/posicionamento/botão de fechar, para poder ser colocado
 * dentro de uma modal do projeto pai (ou de qualquer outro contentor).
 *
 * A FeedbackModalV2 mantém-se intacta para uso dentro desta aplicação.
 *
 * Props:
 *  - width: número (largura do viewport). >= 1000 mostra o painel lateral.
 *  - onClose: callback opcional chamado após submeter com sucesso (e, se
 *    showCancel estiver ativo, também ao cancelar).
 *  - showCancel: bool (default false). Mostra o botão "Cancelar". Faz sentido
 *    dentro de uma modal desta app; num iframe/micro-serviço normalmente não.
 */var FeedbackContent=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__FeedbackModalV2_logic__["a" /* default */])(_class=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FeedbackContent,_Component);function FeedbackContent(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,FeedbackContent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=FeedbackContent.__proto__||Object.getPrototypeOf(FeedbackContent)).call.apply(_ref,[this].concat(args))),_this),_this.handleCancel=function(){var onClose=_this.props.onClose;var resetForm=_this.actions.resetForm;resetForm();onClose&&onClose();},_this.disableSubmitButton=function(){return false;},_this.renderForm=function(){var _this$props=_this.props,loading=_this$props.loading,formValues=_this$props.formValues;var _this$actions=_this.actions,setFormValues=_this$actions.setFormValues,sendFeedback=_this$actions.sendFeedback;return!loading?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Form,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Content,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputSection,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(TextsWrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Title,null,'Est\xE1 satisfeito com a informa\xE7\xE3o disponibilizada?'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Description,null,'Sendo 1 (nada satisfeito) e 5 (muito satisfeito)')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(RadioWrappers,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__BoxRadioV2__["a" /* default */],{onClick:function onClick(){return setFormValues({rating:1});},name:'Feedback1',selected:formValues.rating===1},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__FeedbackModalV2_images_ic_cry_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(RadioText,null,'1')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__BoxRadioV2__["a" /* default */],{onClick:function onClick(){return setFormValues({rating:2});},name:'Feedback2',selected:formValues.rating===2},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__FeedbackModalV2_images_ic_sad_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(RadioText,null,'2')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__BoxRadioV2__["a" /* default */],{onClick:function onClick(){return setFormValues({rating:3});},name:'Feedback3',selected:formValues.rating===3},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__FeedbackModalV2_images_ic_neutral_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(RadioText,null,'3')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__BoxRadioV2__["a" /* default */],{onClick:function onClick(){return setFormValues({rating:4});},name:'Feedback4',selected:formValues.rating===4},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__FeedbackModalV2_images_ic_smile_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(RadioText,null,'4')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__BoxRadioV2__["a" /* default */],{onClick:function onClick(){return setFormValues({rating:5});},name:'Feedback5',selected:formValues.rating===5},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__FeedbackModalV2_images_ic_happy_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(RadioText,null,'5')))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputSection,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(TextsWrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Title,{lighter:true},'Recomendaria o Poupa Energia a um familiar ou amigo?')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(RadioWrappers,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__BoxRadioV2__["a" /* default */],{onClick:function onClick(){return setFormValues({recommendation:'yes'});},name:'recommendation _yes',selected:formValues.recommendation==='yes'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(RadioText,null,'Sim')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__BoxRadioV2__["a" /* default */],{onClick:function onClick(){return setFormValues({recommendation:'no'});},name:'recommendation _no',selected:formValues.recommendation==='no'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(RadioText,null,'N\xE3o')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__BoxRadioV2__["a" /* default */],{onClick:function onClick(){return setFormValues({recommendation:'maybe'});},name:'recommendation_maybe',selected:formValues.recommendation==='maybe'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(RadioText,null,'Talvez')))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputSection,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(TextsWrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Title,{lighter:true},'Por favor, deixe-nos algum coment\xE1rio adicional ou sugest\xE3o de melhoria')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(TextArea,{id:'txtArea',rows:'5',name:'observations',value:formValues.observations,onChange:function onChange(e){return setFormValues({observations:e.target.value});},placeholder:'Escreva um coment\xE1rio e ajude-nos a melhorar.'}))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(BtnsWrapper,null,_this.props.showCancel&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ButtonOutlineV2__["a" /* default */],{style:{width:'140px '},onClick:function onClick(){return _this.handleCancel();}},'Cancelar'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ButtonGradientV2__["a" /* default */],{style:{width:'140px '},onClick:function onClick(e){e.preventDefault();sendFeedback();},disabled:_this.disableSubmitButton()},'Submeter'))):null;},_temp),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(FeedbackContent,[{key:'renderLoading',value:function renderLoading(){var loading=this.props.loading;return loading?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Loading__["a" /* default */],null):null;}},{key:'render',value:function render(){var width=this.props.width;return width>=1000?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(FormWrapper,null,this.renderLoading(),this.renderForm()),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Advice,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__FeedbackModalV2_images_ic_review_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(AdviceTitle,null,'Partilhe a sua opini\xE3o'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(AdviceText,null,'A sua opini\xE3o \xE9 importante para n\xF3s. Deixe-nos o seu feedback e ajude-nos a melhorar.'))):__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(FormWrapper,null,this.renderLoading(),this.renderForm());}}]);return FeedbackContent;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]))||_class;var Wrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject);var FormWrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject2);var Form=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].form(_templateObject3);var Content=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject4);var TextArea=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].textarea(_templateObject5);var RadioText=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].p(_templateObject6);var RadioWrappers=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject7);var InputSection=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject8);var TextsWrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject9);var Title=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].h3(_templateObject10,function(_ref2){var lighter=_ref2.lighter;return lighter?'#3E3E3E':'#1D1E22';});var Description=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].p(_templateObject11);var Advice=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject12);var AdviceTitle=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].h1(_templateObject13);var AdviceText=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].p(_templateObject14);var BtnsWrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject15);

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FeedbackModalV2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__logic__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Loading__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ButtonOutlineV2__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ButtonGradientV2__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__BigModalV2__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__MobileModalV2__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__BoxRadioV2__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_ic_review_component_svg__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_ic_review_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_ic_review_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_ic_cry_component_svg__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_ic_cry_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__images_ic_cry_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_ic_smile_component_svg__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_ic_smile_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__images_ic_smile_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_ic_sad_component_svg__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_ic_sad_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__images_ic_sad_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_ic_neutral_component_svg__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_ic_neutral_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__images_ic_neutral_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_ic_happy_component_svg__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_ic_happy_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__images_ic_happy_component_svg__);
var _class;var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  flex: 1 0 0;\n'],['\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  flex: 1 0 0;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 800px;\n  height: 560px;\n'],['\n  width: 800px;\n  height: 560px;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-grow: 1;\n  align-self: stretch;\n  border: 1px solid #ececec;\n'],['\n  display: flex;\n  flex-grow: 1;\n  align-self: stretch;\n  border: 1px solid #ececec;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-self: stretch;\n  width: 100%;\n  height: 100%;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-self: stretch;\n  width: 100%;\n  height: 100%;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  flex: 1 0 0;\n  padding: 12px 16px;\n  width: 100%;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  flex: 1 0 0;\n  padding: 12px 16px;\n  width: 100%;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  display: flex;\n  padding: 10px;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 10px;\n  align-self: stretch;\n  border: 1px solid #ececec;\n\n  overflow: hidden;\n  color: #3e3e3e;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n\n  &::placeholder {\n    color: #616161;\n  }\n'],['\n  width: 100%;\n  display: flex;\n  padding: 10px;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 10px;\n  align-self: stretch;\n  border: 1px solid #ececec;\n\n  overflow: hidden;\n  color: #3e3e3e;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n\n  &::placeholder {\n    color: #616161;\n  }\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #3e3e3e;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px; /* 142.857% */\n  margin: 0;\n  width: unset;\n'],['\n  color: #3e3e3e;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px; /* 142.857% */\n  margin: 0;\n  width: unset;\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  align-self: stretch;\n  flex-wrap: wrap;\n\n  @media (min-width: 1000px) {\n    flex-wrap: nowrap;\n  }\n'],['\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  align-self: stretch;\n  flex-wrap: wrap;\n\n  @media (min-width: 1000px) {\n    flex-wrap: nowrap;\n  }\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 12px;\n  align-self: stretch;\n'],['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 12px;\n  align-self: stretch;\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  align-self: stretch;\n'],['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  align-self: stretch;\n']),_templateObject11=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ',';\n  font-size: 14px;\n  font-style: normal;\n  font-family: Nunito;\n  font-weight: 700;\n  line-height: 20px;\n  margin: 0;\n  text-transform: unset;\n  text-align: left;\n  letter-spacing: unset;\n'],['\n  ',';\n  font-size: 14px;\n  font-style: normal;\n  font-family: Nunito;\n  font-weight: 700;\n  line-height: 20px;\n  margin: 0;\n  text-transform: unset;\n  text-align: left;\n  letter-spacing: unset;\n']),_templateObject12=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #3e3e3e;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  margin: 0;\n'],['\n  color: #3e3e3e;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  margin: 0;\n']),_templateObject13=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  width: 310px;\n  padding: 24px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n  background: linear-gradient(270deg, #006736 -58.87%, #93c13e 100%);\n'],['\n  display: flex;\n  width: 310px;\n  padding: 24px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n  background: linear-gradient(270deg, #006736 -58.87%, #93c13e 100%);\n']),_templateObject14=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  align-self: stretch;\n  color: #fff;\n  font-family: Nunito;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 32px; /* 133.333% */\n  text-transform: uppercase;\n  margin: 0;\n'],['\n  align-self: stretch;\n  color: #fff;\n  font-family: Nunito;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 32px; /* 133.333% */\n  text-transform: uppercase;\n  margin: 0;\n']),_templateObject15=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #fff;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  margin: 0;\n'],['\n  color: #fff;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  margin: 0;\n']),_templateObject16=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 16px;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  align-self: stretch;\n  border-top: 1px solid #ececec;\n'],['\n  display: flex;\n  padding: 16px;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  align-self: stretch;\n  border-top: 1px solid #ececec;\n']);var FeedbackModalV2=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__logic__["a" /* default */])(_class=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FeedbackModalV2,_Component);function FeedbackModalV2(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,FeedbackModalV2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=FeedbackModalV2.__proto__||Object.getPrototypeOf(FeedbackModalV2)).call.apply(_ref,[this].concat(args))),_this),_this.closeModal=function(){var onClose=_this.props.onClose;var resetForm=_this.actions.resetForm;resetForm();onClose();},_this.disableSubmitButton=function(){return false;},_this.renderForm=function(){var _this$props=_this.props,loading=_this$props.loading,formValues=_this$props.formValues;var _this$actions=_this.actions,setFormValues=_this$actions.setFormValues,sendFeedback=_this$actions.sendFeedback;return!loading?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Form,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Content,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputSection,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(TextsWrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Title,null,'Est\xE1 satisfeito com a informa\xE7\xE3o disponibilizada?'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Description,null,'Sendo 1 (nada satisfeito) e 5 (muito satisfeito)')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(RadioWrappers,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__BoxRadioV2__["a" /* default */],{onClick:function onClick(){return setFormValues({rating:1});},name:'Feedback1',selected:formValues.rating===1},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__images_ic_cry_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(RadioText,null,'1')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__BoxRadioV2__["a" /* default */],{onClick:function onClick(){return setFormValues({rating:2});},name:'Feedback2',selected:formValues.rating===2},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__images_ic_sad_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(RadioText,null,'2')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__BoxRadioV2__["a" /* default */],{onClick:function onClick(){return setFormValues({rating:3});},name:'Feedback3',selected:formValues.rating===3},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__images_ic_neutral_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(RadioText,null,'3')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__BoxRadioV2__["a" /* default */],{onClick:function onClick(){return setFormValues({rating:4});},name:'Feedback4',selected:formValues.rating===4},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__images_ic_smile_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(RadioText,null,'4')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__BoxRadioV2__["a" /* default */],{onClick:function onClick(){return setFormValues({rating:5});},name:'Feedback5',selected:formValues.rating===5},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__images_ic_happy_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(RadioText,null,'5')))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputSection,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(TextsWrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Title,{lighter:true},'Recomendaria o Poupa Energia a um familiar ou amigo?')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(RadioWrappers,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__BoxRadioV2__["a" /* default */],{onClick:function onClick(){return setFormValues({recommendation:'yes'});},name:'recommendation _yes',selected:formValues.recommendation==='yes'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(RadioText,null,'Sim')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__BoxRadioV2__["a" /* default */],{onClick:function onClick(){return setFormValues({recommendation:'no'});},name:'recommendation _no',selected:formValues.recommendation==='no'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(RadioText,null,'N\xE3o')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__BoxRadioV2__["a" /* default */],{onClick:function onClick(){return setFormValues({recommendation:'maybe'});},name:'recommendation_maybe',selected:formValues.recommendation==='maybe'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(RadioText,null,'Talvez')))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputSection,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(TextsWrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Title,{lighter:true},'Por favor, deixe-nos algum coment\xE1rio adicional ou sugest\xE3o de melhoria')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(TextArea,{id:'txtArea',rows:'5',name:'observations',value:formValues.observations,onChange:function onChange(e){return setFormValues({observations:e.target.value});},placeholder:'Escreva um coment\xE1rio e ajude-nos a melhorar.'}))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(BtnsWrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ButtonOutlineV2__["a" /* default */],{style:{width:'140px '},onClick:function onClick(){return _this.closeModal();}},'Cancelar'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ButtonGradientV2__["a" /* default */],{style:{width:'140px '},onClick:function onClick(e){e.preventDefault();sendFeedback();},disabled:_this.disableSubmitButton()},'Submeter'))):null;},_temp),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(FeedbackModalV2,[{key:'renderLoading',value:function renderLoading(){var loading=this.props.loading;return loading?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Loading__["a" /* default */],null):null;}},{key:'render',value:function render(){var _this2=this;var width=this.props.width;return width>=1000?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ModalWrapper,{setModalTriggerHeight:this.props.setModalTriggerHeight,modalTriggerHeight:this.props.modalTriggerHeight,onClose:function onClose(){return _this2.closeModal();}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Wrapper,this.props,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(FormWrapper,null,this.renderLoading(),this.renderForm()),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Advice,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__images_ic_review_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(AdviceTitle,null,'Partilhe a sua opini\xE3o'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(AdviceText,null,'A sua opini\xE3o \xE9 importante para n\xF3s. Deixe-nos o seu feedback e ajude-nos a melhorar.')))):__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__MobileModalV2__["a" /* default */],{onClose:function onClose(){return _this2.closeModal();}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(FormWrapper,null,this.renderLoading(),this.renderForm()));}}]);return FeedbackModalV2;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]))||_class;var Wrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject);var ModalWrapper=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_11__BigModalV2__["a" /* default */])(_templateObject2);var FormWrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject3);var Form=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].form(_templateObject4);var Content=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject5);var TextArea=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].textarea(_templateObject6);var RadioText=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].p(_templateObject7);var RadioWrappers=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject8);var InputSection=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject9);var TextsWrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject10);var Title=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].h3(_templateObject11,function(_ref2){var lighter=_ref2.lighter;return lighter?'#3E3E3E':'#1D1E22';});var Description=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].p(_templateObject12);var Advice=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject13);var AdviceTitle=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].h1(_templateObject14);var AdviceText=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].p(_templateObject15);var BtnsWrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject16);

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config__ = __webpack_require__(10);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 48px;\n  border: 1px solid #ececec;\n  flex-grow: 1;\n\n  &:hover,\n  &.selected {\n    border: none;\n    background: ',';\n    padding: 1px;\n  }\n'],['\n  height: 48px;\n  border: 1px solid #ececec;\n  flex-grow: 1;\n\n  &:hover,\n  &.selected {\n    border: none;\n    background: ',';\n    padding: 1px;\n  }\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  height: 100%;\n  padding: 12px;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 6px;\n  min-width: 160px;\n  cursor: pointer;\n  background: #fff;\n\n  &.selected {\n    background: linear-gradient(\n        0deg,\n        rgba(147, 193, 62, 0.1) 0%,\n        rgba(147, 193, 62, 0.1) 100%\n      ),\n      #fff;\n  }\n'],['\n  display: flex;\n  height: 100%;\n  padding: 12px;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 6px;\n  min-width: 160px;\n  cursor: pointer;\n  background: #fff;\n\n  &.selected {\n    background: linear-gradient(\n        0deg,\n        rgba(147, 193, 62, 0.1) 0%,\n        rgba(147, 193, 62, 0.1) 100%\n      ),\n      #fff;\n  }\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 20px;\n  width: 20px;\n  margin: 0;\n\n  svg {\n    width: 20px !important;\n    height: 20px !important;\n  }\n'],['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 20px;\n  width: 20px;\n  margin: 0;\n\n  svg {\n    width: 20px !important;\n    height: 20px !important;\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #3e3e3e;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 18px; /* 128.571% */\n  text-transform: capitalize;\n'],['\n  color: #3e3e3e;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 18px; /* 128.571% */\n  text-transform: capitalize;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  width: 20px !important;\n  height: 20px !important;\n  border: none !important;\n  position: relative;\n  z-index: 1;\n  cursor: pointer;\n\n  &::before {\n    content: \'\';\n    display: block;\n    position: absolute;\n    inset: 0;\n    border-radius: 999px;\n    border: 1px solid #ececec;\n    background: #f9f9f9;\n    z-index: 2;\n  }\n\n  &::after {\n    content: \'\';\n    display: block;\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    top: 5px;\n    left: 5px;\n    border-radius: 999px;\n    background: #fff;\n    z-index: 3;\n    display: none;\n  }\n\n  &:checked {\n    &::before {\n      background: ',';\n      border: none;\n    }\n    &::after {\n      display: block;\n    }\n  }\n'],['\n  display: block;\n  width: 20px !important;\n  height: 20px !important;\n  border: none !important;\n  position: relative;\n  z-index: 1;\n  cursor: pointer;\n\n  &::before {\n    content: \'\';\n    display: block;\n    position: absolute;\n    inset: 0;\n    border-radius: 999px;\n    border: 1px solid #ececec;\n    background: #f9f9f9;\n    z-index: 2;\n  }\n\n  &::after {\n    content: \'\';\n    display: block;\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    top: 5px;\n    left: 5px;\n    border-radius: 999px;\n    background: #fff;\n    z-index: 3;\n    display: none;\n  }\n\n  &:checked {\n    &::before {\n      background: ',';\n      border: none;\n    }\n    &::after {\n      display: block;\n    }\n  }\n']);var InlineRadioV2=function InlineRadioV2(_ref){var icon=_ref.icon,name=_ref.name,selected=_ref.selected,onClick=_ref.onClick,style=_ref.style,value=_ref.value;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrapperBg,{bgColor:__WEBPACK_IMPORTED_MODULE_3_config__["c" /* backgroundColors */].normalLeft,style:style,className:selected&&'selected'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Wrapper,{onClick:onClick,className:selected&&'selected'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Input,{bgColor:__WEBPACK_IMPORTED_MODULE_3_config__["c" /* backgroundColors */].normalLeft,id:'opt-'+value+'-'+name,name:name,checked:selected,onChange:onClick}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(CenteredBox,null,icon),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Title,null,name)));};/* harmony default export */ __webpack_exports__["a"] = (InlineRadioV2);var WrapperBg=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject,function(_ref2){var bgColor=_ref2.bgColor;return bgColor;});var Wrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject2);var CenteredBox=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject3);var Title=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject4);var Input=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].input.attrs({type:'radio'})(_templateObject5,function(_ref3){var bgColor=_ref3.bgColor;return bgColor;});

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_InputV2__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_GhostRadioV2__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_ProfileV2_images_ic_arrow_component_svg__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_ProfileV2_images_ic_arrow_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_containers_ProfileV2_images_ic_arrow_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(297);
var AddressForm=function AddressForm(props){var changeField=props.changeField,loading=props.loading,tab=props.tab,renderBtns=props.renderBtns,billingAddress=props.billingAddress,directDebit=props.directDebit,street=props.street,door=props.door,floor=props.floor,district=props.district,municipality=props.municipality,billingStreet=props.billingStreet,billingDoor=props.billingDoor,billingFloor=props.billingFloor,billingDistrict=props.billingDistrict,billingMunicipality=props.billingMunicipality,electronicBilling=props.electronicBilling,districts=props.districts,municipalities=props.municipalities,billingMunicipalities=props.billingMunicipalities;var _renderAddressInputs=function _renderAddressInputs(type){var streetField=type==='contract'?street:billingStreet;var doorField=type==='contract'?door:billingDoor;var floorField=type==='contract'?floor:billingFloor;var districtField=type==='contract'?district:billingDistrict;var municipalityField=type==='contract'?municipality:billingMunicipality;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rowsWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* CustomInputsRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* InputWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_InputV2__["a" /* default */],{style:{width:'100%'},required:true,label:'Morada',type:'text',value:streetField.value,onChange:function onChange(val){return changeField('billing',type==='contract'?'street':'billingStreet',val);},valid:!Boolean(streetField.valid),errorMessage:streetField.valid}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* CustomInputsRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* InputWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_InputV2__["a" /* default */],{style:{width:'100%'},required:true,label:'Porta',type:'text',value:doorField.value,onChange:function onChange(val){return changeField('billing',type==='contract'?'door':'billingDoor',val);},valid:!Boolean(doorField.valid),errorMessage:doorField.valid})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* InputWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_InputV2__["a" /* default */],{style:{width:'100%'},required:true,label:'Andar',type:'text',value:floorField.value,onChange:function onChange(val){return changeField('billing',type==='contract'?'floor':'billingFloor',val);},valid:!Boolean(floorField.valid),errorMessage:floorField.valid}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* CustomInputsRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* WrapperSelect */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* InputLabel */],null,'Distrito'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["e" /* StyledSelect */],{items:districts,placeholder:'Distrito',onChange:function onChange(_ref){var value=_ref.value;return changeField('billing',type==='contract'?'district':'billingDistrict',value);},selected:districtField.value,arrowIcon:__WEBPACK_IMPORTED_MODULE_3_containers_ProfileV2_images_ic_arrow_component_svg___default.a}),Boolean(districtField.valid)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["f" /* Error */],null,districtField.valid)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* WrapperSelect */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* InputLabel */],null,'Concelho'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["e" /* StyledSelect */],{items:type==='contract'?municipalities:billingMunicipalities,placeholder:'Concelho',onChange:function onChange(_ref2){var value=_ref2.value;return changeField('billing',type==='contract'?'municipality':'billingMunicipality',value);},selected:municipalityField.value,arrowIcon:__WEBPACK_IMPORTED_MODULE_3_containers_ProfileV2_images_ic_arrow_component_svg___default.a}),Boolean(municipalityField.valid)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["f" /* Error */],null,municipalityField.valid))));};return!loading&&tab==='address'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["g" /* Form */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["h" /* FormInputs */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["i" /* InputsSection */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Morada de Contrato'),_renderAddressInputs('contract')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["i" /* InputsSection */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Morada de Fatura\xE7\xE3o'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rowsWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* CustomInputsRow */],{column:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Morada de fatura\xE7\xE3o',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,' *')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["j" /* RadiosWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_GhostRadioV2__["a" /* default */],{small:true,type:'radio',name:'contract_address_same',label:'Igual \xE0 morada de contrato',selected:billingAddress.value==='e',onClick:function onClick(){return changeField('billing','billingAddress','e');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_GhostRadioV2__["a" /* default */],{small:true,type:'radio',name:'contract_address_different',label:'Diferente da morada de contrato',selected:billingAddress.value==='d',onClick:function onClick(){return changeField('billing','billingAddress','d');}}))),billingAddress.value==='d'&&_renderAddressInputs('billing'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* CustomInputsRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* WrapperSelect */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'D\xE9bito direto',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,' *')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["j" /* RadiosWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_GhostRadioV2__["a" /* default */],{small:true,type:'radio',label:'Sim',selected:directDebit.value==='d',onClick:function onClick(){return changeField('billing','directDebit','d');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_GhostRadioV2__["a" /* default */],{small:true,type:'radio',label:'N\xE3o',selected:!directDebit.value,onClick:function onClick(){return changeField('billing','directDebit',false);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* WrapperSelect */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Fatura eletr\xF3nica',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,' *')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["j" /* RadiosWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_GhostRadioV2__["a" /* default */],{small:true,type:'radio',label:'Sim',selected:electronicBilling.value==='e',onClick:function onClick(){return changeField('billing','electronicBilling','e');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_GhostRadioV2__["a" /* default */],{small:true,type:'radio',label:'N\xE3o',selected:!electronicBilling.value,onClick:function onClick(){return changeField('billing','electronicBilling',false);}}))))))),renderBtns());};/* harmony default export */ __webpack_exports__["a"] = (AddressForm);

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_InputV2__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_GhostRadioV2__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_ProfileV2_images_ic_arrow_component_svg__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_ProfileV2_images_ic_arrow_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_containers_ProfileV2_images_ic_arrow_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(297);
var PersonalForm=function PersonalForm(props){var name=props.name,surName=props.surName,email=props.email,phone=props.phone,nif=props.nif,contact=props.contact,contactTime=props.contactTime,changeField=props.changeField,loading=props.loading,tab=props.tab,renderBtns=props.renderBtns;var contactValues=[{label:'9h00 - 11h30',value:'9h00 - 11h30'},{label:'11h30 - 13h00',value:'11h30 - 13h00'},{label:'13h00 - 15h30',value:'13h00 - 15h30'},{label:'15h30 - 18h00',value:'15h30 - 18h00'},{label:'18h00 - 20h30',value:'18h00 - 20h30'}];return!loading&&tab==='personal'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["g" /* Form */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["h" /* FormInputs */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["i" /* InputsSection */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Dados Pessoais'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rowsWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* CustomInputsRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* InputWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_InputV2__["a" /* default */],{id:'name_input',style:{width:'100%'},required:true,label:'Nome',type:'text',placeholder:'Escreva o seu nome',value:name.value,onChange:function onChange(val){return changeField('personal','name',val);},valid:!Boolean(name.valid),errorMessage:name.valid})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* InputWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_InputV2__["a" /* default */],{id:'surName_input',style:{width:'100%'},required:true,label:'Apelido',type:'text',placeholder:'Escreva o seu apelido',value:surName.value,onChange:function onChange(val){return changeField('personal','surName',val);},valid:!Boolean(surName.valid),errorMessage:surName.valid}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* CustomInputsRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* InputWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_InputV2__["a" /* default */],{id:'nif_input',style:{width:'100%'},required:true,label:'NIF',type:'number',placeholder:'Ex: 000 000 000',value:nif.value,onChange:function onChange(val){return changeField('personal','nif',val);},valid:!Boolean(nif.valid),errorMessage:nif.valid})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* InputWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'100%'}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["i" /* InputsSection */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Contatos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rowsWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* CustomInputsRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* InputWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_InputV2__["a" /* default */],{id:'email_input',style:{width:'100%'},required:true,label:'Email',type:'email',placeholder:'Escreva o seu email',value:email.value,onChange:function onChange(val){return changeField('personal','email',val);},valid:!Boolean(email.valid),errorMessage:email.valid})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* InputWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_InputV2__["a" /* default */],{id:'phone_input',style:{width:'100%'},required:true,label:'Contato',placeholder:'Ex: 900 000 000',value:phone.value,valid:!Boolean(phone.valid),errorMessage:phone.valid,onChange:function onChange(val){var value=val;var sanitized=value.replace(/[^\d+]/g,'');var plusCount=(sanitized.match(/\+/g)||[]).length;if(plusCount>1){value='+'+sanitized.replace(/\+/g,'');}else if(plusCount===1&&sanitized.indexOf('+')!==0){value='+'+sanitized.replace(/\+/g,'');}else{value=sanitized;}changeField('personal','phone',value);},pattern:'[\\+0-9]*',inputMode:'tel',type:'text'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* CustomInputsRow */],{column:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Meio de contato prefer\xEAncial',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,' *')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["j" /* RadiosWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_GhostRadioV2__["a" /* default */],{small:true,type:'radio',name:'email',label:'Email',selected:contact.value==='e',onClick:function onClick(){changeField('personal','contact','e');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_GhostRadioV2__["a" /* default */],{small:true,type:'radio',name:'phone',label:'Chamada telef\xF3nica',selected:contact.value==='p',onClick:function onClick(){changeField('personal','contact','p');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_GhostRadioV2__["a" /* default */],{small:true,type:'radio',name:'sms',label:'SMS',selected:contact.value==='s',onClick:function onClick(){changeField('personal','contact','s');}}))),contact.value==='p'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* CustomInputsRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* WrapperSelect */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* InputLabel */],null,'Em que per\xEDodo pretende ser contactado?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["e" /* StyledSelect */],{items:contactValues,placeholder:'Selecionar o ciclo horário...',onChange:function onChange(_ref){var value=_ref.value;return changeField('personal','contactTime',value);},selected:contactTime.value,arrowIcon:__WEBPACK_IMPORTED_MODULE_3_containers_ProfileV2_images_ic_arrow_component_svg___default.a}),Boolean(contactTime.valid)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["f" /* Error */],null,contactTime.valid)))))),renderBtns());};/* harmony default export */ __webpack_exports__["a"] = (PersonalForm);

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_AditionalServicesV2__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_GhostRadioV2__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_ic_check_component_svg__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_ic_check_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_ic_check_component_svg__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n  height: 100%;\n  align-self: stretch;\n  flex-grow: 1;\n\n  > .tableWrapper {\n    overflow-y: auto;\n    display: flex;\n    align-self: stretch;\n    flex: 1 0 0;\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n  height: 100%;\n  align-self: stretch;\n  flex-grow: 1;\n\n  > .tableWrapper {\n    overflow-y: auto;\n    display: flex;\n    align-self: stretch;\n    flex: 1 0 0;\n  }\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  border-spacing: 0;\n'],['\n  width: 100%;\n  border-spacing: 0;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: ',';\n  align-items: ',';\n  gap: 4px;\n  flex: 1 0 0;\n  border-bottom: 1px solid #ececec;\n\n  ','\n'],['\n  display: flex;\n  padding: ',';\n  align-items: ',';\n  gap: 4px;\n  flex: 1 0 0;\n  border-bottom: 1px solid #ececec;\n\n  ','\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 4px;\n  align-self: stretch;\n  padding: 10px 16px;\n\n  > .item {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  > .item svg {\n    width: 18px;\n    height: 18px;\n\n    path {\n      fill: #006736;\n    }\n  }\n\n  > .item p {\n    flex: 1 0 0;\n    color: #3e3e3e;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    margin: 0;\n  }\n\n  .item.bold p {\n    font-weight: 700;\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 4px;\n  align-self: stretch;\n  padding: 10px 16px;\n\n  > .item {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  > .item svg {\n    width: 18px;\n    height: 18px;\n\n    path {\n      fill: #006736;\n    }\n  }\n\n  > .item p {\n    flex: 1 0 0;\n    color: #3e3e3e;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    margin: 0;\n  }\n\n  .item.bold p {\n    font-weight: 700;\n  }\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #1d1e22;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  margin: 0;\n\n  > a {\n    color: #1d1e22;\n    text-decoration-line: underline;\n  }\n'],['\n  color: #1d1e22;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  margin: 0;\n\n  > a {\n    color: #1d1e22;\n    text-decoration-line: underline;\n  }\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #006736;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 20px;\n'],['\n  color: #006736;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 20px;\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 1 0 0;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  color: #3e3e3e;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: ',';\n  line-height: 20px;\n\n  > img {\n    width: 50px;\n    height: 26px;\n    object-fit: contain;\n  }\n'],['\n  flex: 1 0 0;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  color: #3e3e3e;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: ',';\n  line-height: 20px;\n\n  > img {\n    width: 50px;\n    height: 26px;\n    object-fit: contain;\n  }\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 2px;\n  flex: 1 0 0;\n\n  > span {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    align-self: stretch;\n  }\n\n  > span p {\n    color: #1d1e22;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    margin: 0;\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 2px;\n  flex: 1 0 0;\n\n  > span {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    align-self: stretch;\n  }\n\n  > span p {\n    color: #1d1e22;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    margin: 0;\n  }\n']);var Revision=function Revision(props){var loading=props.loading,tab=props.tab,currentTariff=props.currentTariff,tariffInfo=props.tariffInfo,electricityPriceList=props.electricityPriceList,prices=props.prices,gasPriceList=props.gasPriceList,renderBtns=props.renderBtns,formValues=props.formValues,changeField=props.changeField,allowDataSharing=props.allowDataSharing,districts=props.districts,municipalities=props.municipalities,billingMunicipalities=props.billingMunicipalities;var gasStage=currentTariff.result.gasStage;var timeCycle=currentTariff.result.priceListTimeCycle;var calculatedHiredPowerFactor=currentTariff.result.calculatedHiredPowerFactor;var _renderRow=function _renderRow(field,name){var isImg=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var suffix=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'';var fieldToUse=field;if(isImg){fieldToUse=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_utils__["f" /* generateMediaUrl */])(field),alt:name});}return field?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,{hasImg:isImg},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InvoiceCell,{light:true},name),isImg?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InvoiceCell,null,fieldToUse):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InvoiceCell,null,fieldToUse+' '+suffix)):null;};var _renderDistrictRow=function _renderDistrictRow(field,name){if(field){var fieldLabel=districts.find(function(_ref){var value=_ref.value;return value===field;}).label;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InvoiceCell,{light:true},name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InvoiceCell,null,fieldLabel));}return null;};var _renderMunicipalitiesRow=function _renderMunicipalitiesRow(field,name,billing){if(field){var correctMunicipalities=billing?billingMunicipalities:municipalities;var fieldLabel=correctMunicipalities.find(function(_ref2){var value=_ref2.value;return value===field;}).label;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InvoiceCell,{light:true},name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InvoiceCell,null,fieldLabel));}return null;};var _renderSpan=function _renderSpan(label,value,suffix){return value&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,label),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,value),' ',suffix));};var _renderElectricityRow=function _renderElectricityRow(){return electricityPriceList&&prices.electricity&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,{isEnergy:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InvoiceCell,{light:true},'Eletricidade'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(EnergyCell,null,_renderSpan('Termo Potência',prices.electricity.termo_fixo,'€/Dia'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Energia'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null)),_renderSpan('Fora do Vazio',prices.electricity.cheia,'€/kWh'),_renderSpan('Vazio',prices.electricity.vazio,'€/kWh')));};var _renderGasRow=function _renderGasRow(){return gasPriceList&&prices.gas&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,{isEnergy:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InvoiceCell,{light:true},'G\xE1s Natural'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(EnergyCell,null,_renderSpan('Energia',prices.gas.termo_energia,'€/kWh'),_renderSpan('Termo Fixo',prices.gas.termo_fixo,'€/Dia')));};var isEleContract=tariffInfo.pricelistadditionalinfo.electronic_contract;var timeCycleValue=timeCycle==='s'?'Simples':timeCycle==='b'?'Bi-Horário':timeCycle==='t'?'Tri-Horário':null;var contactValue=formValues.personal.contact.value;var contactMethod=contactValue==='email'?'E-mail':contactValue==='phone'?'Chamada telefónica':'SMS';var debitDirection=formValues.billing.directDebit.value?'Sim':'Não';var billingAddressValue=formValues.billing.billingAddress.value==='d';var billingAddress=billingAddressValue?'Diferente da morada do contrato':'Igual à morada de contrato';return!loading&&tab==='revision'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tableWrapper'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Table,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TitleCell,null,'Resumo do Tarif\xE1rio')),tariffInfo&&_renderRow(tariffInfo.entity.hi_res_logo,'Fornecedor',true),tariffInfo&&_renderRow(tariffInfo.designation,'Tarifário'),_renderElectricityRow(),_renderGasRow(),tariffInfo&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_AditionalServicesV2__["a" /* default */],{list:tariffInfo.additional_services}),currentTariff&&currentTariff.result.electricityPriceList&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TitleCell,null,'Eletricidade')),currentTariff&&currentTariff.result.electricityPriceList?_renderRow(currentTariff.result.prices.electricity.termo_fixo,'Termo Potência',false,'€/Dia'):null,currentTariff&&currentTariff.result.electricityPriceList&&timeCycle==='s'?_renderRow(currentTariff.result.prices.electricity.cheia,'Energia',false,'€/kWh'):null,currentTariff&&currentTariff.result.electricityPriceList&&timeCycle!=='s'?_renderRow(currentTariff.result.prices.electricity.vazio,'Vazio',false,'€/kWh'):null,currentTariff&&currentTariff.result.electricityPriceList&&timeCycle==='b'?_renderRow(currentTariff.result.prices.electricity.cheia,'Fora do Vazio',false,'€/kWh'):null,currentTariff&&currentTariff.result.electricityPriceList&&timeCycle!=='s'&&timeCycle!=='b'?_renderRow(currentTariff.result.prices.electricity.ponta,'Ponta',false,'€/kWh'):null,currentTariff&&currentTariff.result.electricityPriceList&&timeCycle!=='s'&&timeCycle!=='b'?_renderRow(currentTariff.result.prices.electricity.cheia,'Cheias',false,'€/kWh'):null,currentTariff&&currentTariff.result.electricityPriceList&&calculatedHiredPowerFactor?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InvoiceCell,{light:true},'Pot\xEAncia'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InvoiceCell,null,Math.round(calculatedHiredPowerFactor*1e2)/1e2,' kVa')):null,currentTariff&&currentTariff.result.electricityPriceList?_renderRow(timeCycleValue,'Tarifa'):null,currentTariff&&currentTariff.result.electricityPriceList?_renderRow('Diário','Ciclo Horário'):null,currentTariff&&currentTariff.result.gasPriceList&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TitleCell,null,'G\xE1s Natural')),gasStage&&currentTariff.result.gasPriceList?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InvoiceCell,{light:true},'Escal\xE3o'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InvoiceCell,null,'Escal\xE3o ',gasStage)):null,currentTariff.result.gasPriceList&&_renderRow(currentTariff.result.prices.gas.termo_fixo,'Termo Fixo',false,'€/Dia'),currentTariff.result.gasPriceList&&_renderRow(currentTariff.result.prices.gas.termo_energia,'Energia',false,'€/kWh'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TitleCell,null,'Dados de ades\xE3o ao tarif\xE1rio')),_renderRow(formValues.personal.name.value,'Primeiro nome'),_renderRow(formValues.personal.surName.value,'Apelido'),_renderRow(formValues.personal.nif.value,'NIF'),_renderRow(formValues.personal.phone.value,'Telefone/Telemóvel'),_renderRow(contactMethod,'Meio de contato preferencial'),_renderRow(debitDirection,'Débito direto'),_renderRow('Sim','Fatura eletrónica'),_renderRow(billingAddress,'Morada de faturação'),!isEleContract&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TitleCell,null,formValues.billing.billingAddress.value==='e'?'Morada de Contrato e Faturação':'Morada de Contrato')),!isEleContract&&_renderRow(formValues.billing.street.value,'Rua'),!isEleContract&&_renderRow(formValues.billing.door.value,'Nº da Porta'),!isEleContract&&_renderRow(formValues.billing.floor.value,'Andar'),!isEleContract&&_renderDistrictRow(formValues.billing.district.value,'Distrito'),!isEleContract&&_renderMunicipalitiesRow(formValues.billing.municipality.value,'Concelho'),!isEleContract&&billingAddressValue&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TitleCell,null,'Morada de Fatura\xE7\xE3o')),!isEleContract&&billingAddressValue&&_renderRow(formValues.billing.billingStreet.value,'Rua'),!isEleContract&&billingAddressValue&&_renderRow(formValues.billing.billingDoor.value,'Nº da Porta'),!isEleContract&&billingAddressValue&&_renderRow(formValues.billing.billingFloor.value,'Andar'),!isEleContract&&billingAddressValue&&_renderDistrictRow(formValues.billing.billingDistrict.value,'Distrito'),!isEleContract&&billingAddressValue&&_renderMunicipalitiesRow(formValues.billing.billingMunicipality.value,'Concelho',true),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TitleCell,null,'Outras Informa\xE7\xF5es')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ListRow,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__images_ic_check_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,' ','Os valores apresentados baseiam-se nos dados introduzidos e representam uma estimativa da sua fatura de energia nos pr\xF3ximos 12 meses e da poupan\xE7a expect\xE1vel face ao seu tarif\xE1rio atual.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__images_ic_check_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,' ','Estes valores t\xEAm em considera\xE7\xE3o as condi\xE7\xF5es de consumo de eletricidade e/ou g\xE1s natural inseridos e que se assumem corretos e atuais.',' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__images_ic_check_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,' ','O presente pedido de ades\xE3o n\xE3o constitui uma proposta contratual, sendo esta uma responsabilidade do comercializador, que entrar\xE1 em contacto consigo.',' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__images_ic_check_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,' ','O OLMC n\xE3o pode ser responsabilizado por eventuais diferen\xE7as no valor de fatura\xE7\xE3o e/ou consumos de eletricidade e g\xE1s natural que venham a ocorrer durante este per\xEDodo,. nem por eventuais diverg\xEAncias entre as partes que possam decorrer do contrato celebrado na sequ\xEAncia de informa\xE7\xE3o disponibilizada pelo portal Poupa Energia.',' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'item bold'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,' Em caso de d\xFAvida contacte-nos atrav\xE9s do 211 160 500 '))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,{noPadding:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_GhostRadioV2__["a" /* default */],{type:'checkbox',name:'allow_data_sharing',labelStyles:{flex:'1'},label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TermsLink,null,'Concordo com os',' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{target:'_blank',href:__WEBPACK_IMPORTED_MODULE_6_config__["g" /* PAGE_URL */]+'/termos-e-condicoes/'},'termos e condi\xE7\xF5es'),' ','e autorizo o envio desta informa\xE7\xE3o para o comercializador.'),selected:allowDataSharing.value,onClick:function onClick(){return changeField('confirm','allowDataSharing',!allowDataSharing.value);}}))))),renderBtns());};/* harmony default export */ __webpack_exports__["a"] = (Revision);var Wrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject);var Table=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].table(_templateObject2);var Row=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].tr(_templateObject3,function(_ref3){var hasImg=_ref3.hasImg;return hasImg?'8px 16px':'10px 16px';},function(_ref4){var isEnergy=_ref4.isEnergy;return isEnergy?'flex-start':'center';},function(_ref5){var noPadding=_ref5.noPadding;return noPadding&&'\n    padding: 0;\n  ';});var ListRow=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].tr(_templateObject4);var TermsLink=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].p(_templateObject5);var TitleCell=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].td(_templateObject6);var InvoiceCell=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].td(_templateObject7,function(_ref6){var light=_ref6.light;return light?'400':'600';});var EnergyCell=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].td(_templateObject8);

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_InputV2__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(297);
var SimplePersonalForm=function SimplePersonalForm(props){var name=props.name,surName=props.surName,email=props.email,phone=props.phone,changeField=props.changeField,loading=props.loading,tab=props.tab,renderBtns=props.renderBtns;return!loading&&tab==='simple_personal'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["g" /* Form */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["h" /* FormInputs */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["i" /* InputsSection */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Dados Pessoais'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rowsWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* CustomInputsRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* InputWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_InputV2__["a" /* default */],{id:'name_input',style:{width:'100%'},required:true,label:'Nome',type:'text',placeholder:'Escreva o seu nome',value:name.value,onChange:function onChange(val){return changeField('personal','name',val);},valid:!Boolean(name.valid),errorMessage:name.valid})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* InputWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_InputV2__["a" /* default */],{id:'surName_input',style:{width:'100%'},required:true,label:'Apelido',type:'text',placeholder:'Escreva o seu apelido',value:surName.value,onChange:function onChange(val){return changeField('personal','surName',val);},valid:!Boolean(surName.valid),errorMessage:surName.valid}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["i" /* InputsSection */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Contatos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rowsWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* CustomInputsRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* InputWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_InputV2__["a" /* default */],{id:'email_input',style:{width:'100%'},required:true,label:'Email',type:'email',placeholder:'Escreva o seu email',value:email.value,onChange:function onChange(val){return changeField('personal','email',val);},valid:!Boolean(email.valid),errorMessage:email.valid})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* InputWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_InputV2__["a" /* default */],{id:'phone_input',style:{width:'100%'},required:true,label:'Contato',placeholder:'Ex: 900 000 000',value:phone.value,valid:!Boolean(phone.valid),errorMessage:phone.valid,onChange:function onChange(val){var value=val;var sanitized=value.replace(/[^\d+]/g,'');var plusCount=(sanitized.match(/\+/g)||[]).length;if(plusCount>1){value='+'+sanitized.replace(/\+/g,'');}else if(plusCount===1&&sanitized.indexOf('+')!==0){value='+'+sanitized.replace(/\+/g,'');}else{value=sanitized;}changeField('personal','phone',value);},pattern:'[\\+0-9]*',inputMode:'tel',type:'text'})))))),renderBtns());};/* harmony default export */ __webpack_exports__["a"] = (SimplePersonalForm);

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JoinTariffModalV2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_mapValues__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isArray__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_omit__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__logic__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_EditDataModalV2_images_ic_info_component_svg__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_EditDataModalV2_images_ic_info_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_EditDataModalV2_images_ic_info_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_ic_arrow_component_svg__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_ic_arrow_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__images_ic_arrow_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_ic_check_success_component_svg__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_ic_check_success_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_ic_check_success_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_ic_alert_component_svg__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_ic_alert_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__images_ic_alert_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_Loading__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ButtonOutlineV2__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ButtonGradientV2__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__BigModalV2__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__SmallModalV2__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_personalForm__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_simplePersonalForm__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_addressForm__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_revision__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__validations__ = __webpack_require__(443);
var _class;var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  flex: 1 0 0;\n'],['\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  flex: 1 0 0;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 90%;\n\n  @media (min-width: 1200px) {\n    width: 900px;\n  }\n'],['\n  width: 90%;\n\n  @media (min-width: 1200px) {\n    width: 900px;\n  }\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  padding: 50px;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 87px;\n    height: 64px;\n    margin-bottom: 50px;\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  padding: 50px;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 87px;\n    height: 64px;\n    margin-bottom: 50px;\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #010101;\n  font-family: Nunito;\n  font-size: 19px;\n  line-height: 34px;\n  text-align: center;\n'],['\n  color: #010101;\n  font-family: Nunito;\n  font-size: 19px;\n  line-height: 34px;\n  text-align: center;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n'],['\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1 0 0;\n  align-self: stretch;\n\n  border: 1px solid #ececec;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1 0 0;\n  align-self: stretch;\n\n  border: 1px solid #ececec;\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n'],['\n  width: 100%;\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  display: flex;\n  align-items: center;\n'],['\n  width: 100%;\n  display: flex;\n  align-items: center;\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 12px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex: 1 0 0;\n  align-self: stretch;\n  cursor: pointer;\n\n  background: ',';\n\n  color: ',';\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n\n  ','\n\n  ','\n'],['\n  display: flex;\n  padding: 12px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex: 1 0 0;\n  align-self: stretch;\n  cursor: pointer;\n\n  background: ',';\n\n  color: ',';\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n\n  ','\n\n  ','\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-grow: 1;\n  align-self: stretch;\n'],['\n  display: flex;\n  flex-grow: 1;\n  align-self: stretch;\n']),_templateObject11=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 16px;\n  align-items: center;\n  justify-content: ',';\n  gap: 12px;\n  align-self: stretch;\n  border-top: 1px solid #ececec;\n\n  ','\n'],['\n  display: flex;\n  padding: 16px;\n  align-items: center;\n  justify-content: ',';\n  gap: 12px;\n  align-self: stretch;\n  border-top: 1px solid #ececec;\n\n  ','\n']),_templateObject12=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding: 20px 0;\n'],['\n  padding: 20px 0;\n']),_templateObject13=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  font-weight: bold;\n  margin-bottom: 20px;\n  color: #8abb3f;\n'],['\n  display: block;\n  font-weight: bold;\n  margin-bottom: 20px;\n  color: #8abb3f;\n']),_templateObject14=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin-bottom: 10px;\n\n  ','\n'],['\n  margin-bottom: 10px;\n\n  ','\n']),_templateObject15=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 10px;\n  height: 10px;\n  background: linear-gradient(270deg, #006736 0%, #93c13e 100%);\n  display: inline-block;\n  border-radius: 50%;\n  margin-right: 10px;\n'],['\n  width: 10px;\n  height: 10px;\n  background: linear-gradient(270deg, #006736 0%, #93c13e 100%);\n  display: inline-block;\n  border-radius: 50%;\n  margin-right: 10px;\n']),_templateObject16=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  width: 310px;\n  padding: 24px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n  background: linear-gradient(270deg, #006736 -58.87%, #93c13e 100%);\n'],['\n  display: flex;\n  width: 310px;\n  padding: 24px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n  background: linear-gradient(270deg, #006736 -58.87%, #93c13e 100%);\n']),_templateObject17=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  align-self: stretch;\n  color: #fff;\n  font-family: Nunito;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 32px; /* 133.333% */\n  text-transform: uppercase;\n  margin: 0;\n'],['\n  align-self: stretch;\n  color: #fff;\n  font-family: Nunito;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 32px; /* 133.333% */\n  text-transform: uppercase;\n  margin: 0;\n']),_templateObject18=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #fff;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  margin: 0;\n'],['\n  color: #fff;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  margin: 0;\n']),_templateObject19=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  align-self: stretch;\n  color: #3e3e3e;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n  margin: 0;\n\n  > b {\n    color: #010101;\n    font-weight: 700;\n  }\n'],['\n  align-self: stretch;\n  color: #3e3e3e;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n  margin: 0;\n\n  > b {\n    color: #010101;\n    font-weight: 700;\n  }\n']),_templateObject20=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n'],['\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n']);var translateErrors={first_name:'Primeiro Nome',last_name:'Último Nome',tax_id:'NIF',email:'Email',phone_number:'Telefone / Telemóvel',company_phone_number:'Telefone / Telemóvel Contacto',company_name:'Nome da empresa',company_cae:'CAE da empresa',company_email:'Email empresa',legal_bi:'BI/CC do Representante legal',street:'Rua',door:'Nº da porta',floor:'Andar',postal_code:'Código postal',billing_address:'Morada de faturação',billing_street:'Rua de faturação',billing_door:'Nº da porta de faturação',billing_floor:'Andar de faturação',billing_postal_code:'Código postal de faturação',cpe:'CPE',cui:'CUI',cuicpe:['CUI','CPE']};var JoinTariffModalV2=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__logic__["a" /* default */])(_class=function(_Component){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(JoinTariffModalV2,_Component);function JoinTariffModalV2(){__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,JoinTariffModalV2);var _this=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(JoinTariffModalV2.__proto__||Object.getPrototypeOf(JoinTariffModalV2)).call(this));_this.isFormValid=function(validations){var key=Object.keys(validations)[0];var list=validations[key];var formBase=_this.props.formValues[key];var invalid=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},key,{});__WEBPACK_IMPORTED_MODULE_8_lodash_mapValues___default()(list,function(funcs,valueKey){for(var index=0;index<funcs.length;index++){var func=funcs[index];var doFirst=true;if(__WEBPACK_IMPORTED_MODULE_9_lodash_isArray___default()(func)){func=func[0];doFirst=false;if(!func(formBase[valueKey].value,formBase)){break;}}if(doFirst){if(formBase[valueKey]){var _func=func(formBase[valueKey].value,formBase),result=_func.result,message=_func.message;if(!result){invalid[key][valueKey]=message;break;}}}}});if(_this.props.tariffInfo&&key==='personal'){var _this$props$tariffInf=_this.props.tariffInfo.entity,subscription_requires_email=_this$props$tariffInf.subscription_requires_email,subscription_requires_phone=_this$props$tariffInf.subscription_requires_phone;var emailKey='email';var phoneKey='phone';if(!subscription_requires_email&&!subscription_requires_phone){var phone=_this.props.formData.personal[phoneKey];var email=_this.props.formData.personal[emailKey];var emailVal=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__validations__["a" /* notEmptyEmail */])(email.value,phone.value);var phoneVal=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__validations__["b" /* notEmptyPhone */])(phone.value,email.value);if(!invalid.personal[phoneKey]&&!emailVal.result){invalid.personal[emailKey]=emailVal.message;}if(!invalid.personal[emailKey]&&!phoneVal.result){invalid.personal[phoneKey]=phoneVal.message;}}}return{valid:!Object.keys(invalid[key]).length,invalid:invalid};};_this.toggleTab=function(value){var _this$state=_this.state,currentTab=_this$state.currentTab,validations=_this$state.validations;var valid=true;var invalid=void 0;if(currentTab==='personal'||currentTab==='simple_personal'){var validation=_this.isFormValid(validations[0]);valid=validation.valid;invalid=validation.invalid;}else if(currentTab==='address'&&value==='revision'){var _validation=_this.isFormValid(validations[1]);valid=_validation.valid;invalid=_validation.invalid;}if(valid){_this.setState({currentTab:value});}else{_this.actions.setInvalid(invalid);}};_this.transformForm=function(form){if(!form){return false;}var personal=form.personal,billing=form.billing,electric=form.electric,gas=form.gas;var first_name=personal.name,last_name=personal.surName,tax_id=personal.nif,email=personal.email,phone_number=personal.phone,contact=personal.contact,contactTime=personal.contactTime;var street=billing.street,door=billing.door,floor=billing.floor,district=billing.district,municipality=billing.municipality,billingDoor=billing.billingDoor,billingFloor=billing.billingFloor,billingDistrict=billing.billingDistrict,billingMunicipality=billing.billingMunicipality,billingStreet=billing.billingStreet,directDebit=billing.directDebit,electronicBilling=billing.electronicBilling,billingAddress=billing.billingAddress;var cpe=electric.cpe,hired_power=electric.potency,price_list_cycle=electric.cycle,time_cycle=electric.tariff;var cui=gas.cui,price_step=gas.tier;var _this$props$tariffInf2=_this.props.tariffInfo,price_list=_this$props$tariffInf2.id,entity=_this$props$tariffInf2.entity,priceListObject=_this$props$tariffInf2.priceListObject,pricelistadditionalinfo=_this$props$tariffInf2.pricelistadditionalinfo;var gasFields=Object.assign({current_gas_entity:entity.id,cui:cui.value},price_step.value&&{price_step:price_step.value});var eletricityFields=Object.assign({current_electricity_entity:entity.id,cpe:cpe.value,price_list_cycle:price_list_cycle.value},hired_power.value&&{hired_power:hired_power.value},time_cycle.value&&{time_cycle:time_cycle.value});// Subscription source
var subscription_source='simple_simulator';var priceListId=priceListObject.priceListId;// Set the personal object to the correct one based on simulator
var personalObj={first_name:first_name.value,last_name:last_name.value,tax_id:tax_id.value,email:email.value,phone_number:phone_number.value,contact:contact.value,contact_time:contactTime.value};var isEleContract=!!(_this.props.tariffInfo&&pricelistadditionalinfo.electronic_contract);if(isEleContract){personalObj=__WEBPACK_IMPORTED_MODULE_10_lodash_omit___default()(personalObj,['tax_id','contact']);}var obj=Object.assign({},personalObj,{street:street.value,door:door.value,floor:floor.value,billing_street:billingStreet.value,billing_door:billingDoor.value,billing_floor:billingFloor.value,billing_detail:''+(electronicBilling.value==='false'?'':electronicBilling.value)+(directDebit.value==='false'?'':directDebit.value),billing_address:billingAddress.value,billing_district:billingDistrict.value,billing_municipality:billingMunicipality.value,contract_summary:{},price_list:price_list,user:'',district:district.value,municipality:municipality.value,subscription_source:subscription_source,simulation_price_list:priceListId});if(_this.state.currentTariff.result.electricityPriceList){obj=Object.assign({},obj,eletricityFields);}if(_this.state.currentTariff.result.gasPriceList){obj=Object.assign({},obj,gasFields);}return obj;};_this.renderBtns=function(){var _this$state2=_this.state,currentTab=_this$state2.currentTab,validations=_this$state2.validations,isEleContract=_this$state2.isEleContract;var _this$props=_this.props,formValues=_this$props.formValues,confirmationError=_this$props.confirmationError;var _this$actions=_this.actions,submitForm=_this$actions.submitForm,setConfirmationError=_this$actions.setConfirmationError;var outlineBtnText=currentTab==='personal'?'Cancelar':'Voltar atrás';var gradientBtnText=currentTab==='revision'?'Aderir':'Seguinte';var handleOutlineClick=function handleOutlineClick(e){if(e){e.preventDefault();}if(confirmationError){setConfirmationError(false);_this.setState({cancelModal:true});return;}if(currentTab==='personal'||currentTab==='simple_personal'){_this.setState({cancelModal:true});}else if(currentTab==='address'){_this.toggleTab('personal');}else if(currentTab==='revision'&&isEleContract){_this.toggleTab('simple_personal');}else{_this.toggleTab('address');}};var handleGradientClick=function handleGradientClick(e){e.preventDefault();if(confirmationError){_this.actions.submitForm(_this.transformForm(_this.props.formData),{omitRepeated:true},_this.setState({successModal:true}));return;}if(currentTab==='personal'||currentTab==='simple_personal'){var validation=_this.isFormValid(validations[0]);if(validation.valid){_this.toggleTab(currentTab==='personal'?'address':'revision');}else{_this.actions.setInvalid(validation.invalid);}}else if(currentTab==='address'){var _validation2=_this.isFormValid(validations[1]);if(_validation2.valid){_this.toggleTab('revision');}else{_this.actions.setInvalid(_validation2.invalid);}}else{var personalValid=_this.isFormValid(validations[0]);var billingValid=_this.isFormValid(validations[1]);var revisionValid=formValues.confirm.allowDataSharing.value;if(personalValid.valid&&billingValid.valid&&revisionValid){submitForm(_this.transformForm(formValues),{},_this.setState({successModal:true}));}}};return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(BtnsWrapper,{tab:currentTab},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ButtonOutlineV2__["a" /* default */],{style:{width:'140px '},onClick:function onClick(e){return handleOutlineClick(e);}},outlineBtnText),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ButtonGradientV2__["a" /* default */],{style:{width:'140px '},onClick:function onClick(e){return handleGradientClick(e);},trailingIcon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__images_ic_arrow_component_svg___default.a,null),disabled:_this.disableSubmitButton()},gradientBtnText));};_this.closeModal=function(){var changeTariff=_this.props.changeTariff;var resetForm=_this.actions.resetForm;resetForm();changeTariff(null);};_this.toggleModal=function(){var open=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;_this.setState({open:open},function(){return!_this.state.opened&&_this.actions.reset()&&_this.props.changeTariff(null);});};_this.toggleErrorModal=function(){_this.actions.setAdhesionError(null);};_this.changeField=function(key,property,value){var section=Object.assign({},_this.props.formValues[key]);var field=Object.assign({},section[property],{value:value});var data=Object.assign(_this.props.formValues,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},key,Object.assign({},section,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},property,field))));if(property==='district'||property==='billingDistrict'){_this.actions.fetchMunicipalities(value,property);}_this.actions.setFormValues(data);};_this.keepOnPersonalTab=function(){var validations=_this.state.validations;var validation=_this.isFormValid(validations[0]);if(validation.valid){return false;}else{return true;}};_this.keepOnAddressTab=function(){var validations=_this.state.validations;var validation=_this.isFormValid(validations[1]);if(validation.valid){return false;}else{return true;}};_this.disableSubmitButton=function(){var currentTab=_this.state.currentTab;var formValues=_this.props.formValues;if(currentTab==='personal'||currentTab==='simple_personal'){return _this.keepOnPersonalTab();}else if(currentTab==='address'){return _this.keepOnAddressTab();}else if(currentTab==='revision'){return!formValues.confirm.allowDataSharing.value;}return false;};_this.renderSmallModal=function(type){var adhesionResponse=_this.props.adhesionResponse;var condition=type==='success'?adhesionResponse&&_this.state.successModal:_this.state.cancelModal;var icon=type==='success'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__images_ic_check_success_component_svg___default.a,null):__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__images_ic_alert_component_svg___default.a,null);var title=type==='success'?'Pré-adesão submetida com sucesso':'sair da página ?';var description=type==='success'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Description,null,'O comercializador recebeu os seus dados e ir\xE1 entrar em contacto consigo no prazo m\xE1ximo de 48h. Envi\xE1mos uma confirma\xE7\xE3o do processo para o seu email:\xA0',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,_this.props.formValues.personal.email.value)):__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Description,null,'Se optar por sair agora, todos os dados que j\xE1 preencheu ser\xE3o perdidos e n\xE3o poder\xE3o ser recuperados. Para evitar ter que reiniciar o processo, recomendamos que termine o preenchimento.');var btnsContent=type==='success'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ButtonGradientV2__["a" /* default */],{style:{width:'100% '},onClick:function onClick(){_this.setState({successModal:false});_this.closeModal();}},'Ok'):__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SmallModalBtnsWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ButtonOutlineV2__["a" /* default */],{onClick:function onClick(){_this.setState({cancelModal:false});}},'Cancelar'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ButtonGradientV2__["a" /* default */],{danger:true,style:{flexGrow:'1'},onClick:function onClick(){_this.setState({cancelModal:false});_this.closeModal();}},'Sair'));var handleClose=type==='success'?function(){_this.setState({successModal:false});if(adhesionResponse){_this.closeModal();}}:function(){return _this.setState({cancelModal:false});};return condition&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__SmallModalV2__["a" /* default */],{title:title,description:description,icon:icon,onClose:handleClose},btnsContent);};_this.renderTab=function(tab){var _this$props2=_this.props,adhesionResponse=_this$props2.adhesionResponse,confirmationError=_this$props2.confirmationError,tariffInfo=_this$props2.tariffInfo,submitting=_this$props2.submitting;var _this$state3=_this.state,showedDisclaimer=_this$state3.showedDisclaimer,canSub=_this$state3.canSub;return!adhesionResponse&&!confirmationError&&showedDisclaimer&&canSub&&tariffInfo&&!submitting?tab:null;};_this.state={tabs:[],currentTab:'',isEleContract:false,currentTariff:null,open:false,errorOpened:true,showedDisclaimer:true,canSub:true,validations:[]};_this.adhereButtons=[{label:'cancelar',primary:false,click:function click(){return _this.toggleModal();},color:'#006736'},{label:'seguinte',primary:true,click:_this.adhereActions}];return _this;}__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(JoinTariffModalV2,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState({currentTariff:nextProps.tariff});if(nextProps.tariffInfo){var tariff=nextProps.tariff,_nextProps$values=nextProps.values,potencia_contratada=_nextProps$values.potencia_contratada,ciclo_tarifa=_nextProps$values.ciclo_tarifa,municipality=_nextProps$values.municipality,simulation=nextProps.simulation;var priceListTimeCycle=this.props.tariff.priceListTimeCycle;var isEleContract=nextProps.tariffInfo.pricelistadditionalinfo.electronic_contract;isEleContract&&this.setState({tabs:['simple_personal','revision']});if(nextProps.firstSet){if(tariff.suggested_electricity){if(potencia_contratada){this.changeField('electric','potency',potencia_contratada);}if(ciclo_tarifa){this.changeField('electric','cycle',ciclo_tarifa);}if(priceListTimeCycle){this.changeField('electric','tariff',priceListTimeCycle);}}if(simulation&&simulation.gasStage){this.changeField('gas','tier',simulation.gasStage);}if(municipality){this.changeField('billing','municipality',municipality);}this.actions.setFirstSet(false);}}}},{key:'componentWillMount',value:function componentWillMount(){var _this2=this;var _props=this.props,tariff=_props.tariff,ciclo_tarifa=_props.values.ciclo_tarifa,tariffInfo=_props.tariffInfo;var _tariffInfo$entity=tariffInfo.entity,subscription_requires_email=_tariffInfo$entity.subscription_requires_email,subscription_requires_phone=_tariffInfo$entity.subscription_requires_phone;var _props$tariff$result=this.props.tariff.result,priceListTimeCycle=_props$tariff$result.priceListTimeCycle,calculatedHiredPowerFactor=_props$tariff$result.calculatedHiredPowerFactor,gasStage=_props$tariff$result.gasStage;var eleSub=true;var gasSub=true;var isEleContract=!!tariffInfo&&tariffInfo.pricelistadditionalinfo.electronic_contract;this.setState({isEleContract:isEleContract});if(tariff.result.electricityPriceList){var canSub=tariff.result.electricityPriceList.entity.can_subscribe;eleSub=canSub;}if(tariff.result.gasPriceList){var _canSub=tariff.result.gasPriceList.entity.can_subscribe;gasSub=_canSub;}if(!eleSub||!gasSub){this.adhereButtons=[{label:'Fechar',primary:true,click:function click(){return _this2.toggleModal();}}];this.setState({currentTariff:tariff,canSub:false,showedDisclaimer:true});}else{if(tariff.result.electricityPriceList){if(calculatedHiredPowerFactor){var hiredPower=Number(calculatedHiredPowerFactor);this.changeField('electric','potency',hiredPower);}if(ciclo_tarifa){this.changeField('electric','cycle',ciclo_tarifa);}if(priceListTimeCycle){this.changeField('electric','tariff',priceListTimeCycle);}}if(tariff.result.gasPriceList){if(gasStage){this.changeField('gas','tier',gasStage);}}var personal=[];if(isEleContract){personal.push('simple_personal');this.setState({currentTab:'simple_personal'});}else{personal.push('personal');this.setState({currentTab:'personal'});}var billing=[];if(!isEleContract){billing.push('address');}var tabs=[].concat(personal,billing,['revision']);var validations=[];var personalValidations={name:[__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */]],surName:[__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */]],nif:[__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */],__WEBPACK_IMPORTED_MODULE_25__validations__["d" /* isNIF */]],/*
         * these validations are added later now that
         * entities can control if email or phone are required
         */email:[],phone:[],contact:[__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */]],contactTime:[[__WEBPACK_IMPORTED_MODULE_25__validations__["e" /* isContactPhone */]],__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */]]};validations=[{personal:personalValidations}];if(!isEleContract){validations.push({billing:{street:[__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */]],door:[__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */]],district:[__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */]],municipality:[__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */]],billingStreet:[[__WEBPACK_IMPORTED_MODULE_25__validations__["f" /* hasBillingAddress */]],__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */]],billingDoor:[[__WEBPACK_IMPORTED_MODULE_25__validations__["f" /* hasBillingAddress */]],__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */]],billingDistrict:[[__WEBPACK_IMPORTED_MODULE_25__validations__["f" /* hasBillingAddress */]],__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */]],billingMunicipality:[[__WEBPACK_IMPORTED_MODULE_25__validations__["f" /* hasBillingAddress */]],__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */]]}});}if(isEleContract){delete validations[0].personal.nif;}var phone=validations[0].personal.phone;var email=validations[0].personal.email;if(subscription_requires_email&&!email.length){var _validations$0$person;(_validations$0$person=validations[0].personal.email).push.apply(_validations$0$person,[__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */],__WEBPACK_IMPORTED_MODULE_25__validations__["g" /* isEmail */]]);}if(subscription_requires_phone&&!phone.length){var _validations$0$person2;(_validations$0$person2=validations[0].personal.phone).push.apply(_validations$0$person2,[__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */],__WEBPACK_IMPORTED_MODULE_25__validations__["h" /* isPhone */]]);}validations.push({confirm:{allowDataSharing:[__WEBPACK_IMPORTED_MODULE_25__validations__["i" /* isChecked */]]}});this.setState({currentTariff:tariff,tabs:tabs,validations:validations});}if(this.props.isHome){this.changeField('electric','potency',parseFloat(this.props.tariff.calculatedHiredPowerFactor));this.changeField('gas','tier',parseFloat(this.props.tariff.gasStage));}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.setState({currentTariff:null,tabs:[],currentTab:''});}},{key:'errorsList',value:function errorsList(errors){return Object.keys(errors).map(function(key){var field=void 0;if(key==='cuicpe'){field=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{key:key},'Estes ',translateErrors[key][0],' e ',translateErrors[key][1],' aderiram a um tarif\xE1rio recentemente. Tem de aguardar 30 dias para efetuar uma nova ades\xE3o no Poupa Energia. Se tiver d\xFAvidas ligue-nos para o 211 160 500.');}else if(key==='cui'||key==='cpe'){field=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{key:key},'Este ',translateErrors[key],' aderiu a um tarif\xE1rio recentemente. Tem de aguardar 30 dias para efetuar uma nova ades\xE3o no Poupa Energia. Se tiver d\xFAvidas ligue-nos para o 211 160 500.');}else{field=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{key:key},'O campo ',translateErrors[key],' cont\xE9m erros.');}return field;});}},{key:'renderLoading',value:function renderLoading(){var _props2=this.props,loading=_props2.loading,submitting=_props2.submitting;return loading||submitting?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Loading__["a" /* default */],null):null;}},{key:'render',value:function render(){var _this3=this;var _state=this.state,tabs=_state.tabs,currentTab=_state.currentTab,isEleContract=_state.isEleContract;var _props3=this.props,formValues=_props3.formValues,loading=_props3.loading,districts=_props3.districts,municipalities=_props3.municipalities,billingMunicipalities=_props3.billingMunicipalities,electricityPriceList=_props3.electricityPriceList,gasPriceList=_props3.gasPriceList,prices=_props3.prices,tariffInfo=_props3.tariffInfo,calculatedHiredPowerFactor=_props3.calculatedHiredPowerFactor,priceListTimeCycle=_props3.priceListTimeCycle,gasStage=_props3.gasStage,translations=_props3.translations;var _ref=translations||{},ESCLARECIMENTO_CUSTOS_ADICIONAIS=_ref.ESCLARECIMENTO_CUSTOS_ADICIONAIS,ESCLARECIMENTO_CONTACTE=_ref.ESCLARECIMENTO_CONTACTE,ESCLARECIMENTO_PONTO_4=_ref.ESCLARECIMENTO_PONTO_4,ESCLARECIMENTO_PONTO_3=_ref.ESCLARECIMENTO_PONTO_3,ESCLARECIMENTO_PONTO_2=_ref.ESCLARECIMENTO_PONTO_2,ESCLARECIMENTO_PONTO_1=_ref.ESCLARECIMENTO_PONTO_1,ESCLARECIMENTO_INDISPONIVEL=_ref.ESCLARECIMENTO_INDISPONIVEL;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ModalWrapper,{modalTriggerHeight:this.props.modalTriggerHeight,setModalTriggerHeight:this.props.setModalTriggerHeight,title:'Aderir ao Tarif\xE1rio',onClose:function onClose(){return _this3.setState({cancelModal:true});}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Wrapper,this.props,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Content,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TableHeader,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TopRow,null,tabs.map(function(tab,index){var suffix=index+1+'.';var text=tab==='revision'?'Resumo':tab==='address'?'Morada':'Dados Pessoais';var disableTab=false;if(tab==='address'){disableTab=_this3.keepOnPersonalTab();}else if(tab==='revision'&&isEleContract){disableTab=_this3.keepOnPersonalTab();}else if(tab==='revision'&&!isEleContract){disableTab=_this3.keepOnAddressTab();}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ToggleButton,{key:'tab_'+tab,active:currentTab===tab,onClick:function onClick(){return _this3.toggleTab(tab);},disabled:disableTab},suffix,' ',text);}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(FormWrapper,null,this.renderLoading(),this.renderTab(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_personalForm__["a" /* default */],{name:formValues.personal.name,surName:formValues.personal.surName,email:formValues.personal.email,phone:formValues.personal.phone,nif:formValues.personal.nif,contact:formValues.personal.contact,contactTime:formValues.personal.contactTime,changeField:this.changeField,loading:loading,tab:currentTab,renderBtns:this.renderBtns})),this.renderTab(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_simplePersonalForm__["a" /* default */],{name:formValues.personal.name,surName:formValues.personal.surName,email:formValues.personal.email,phone:formValues.personal.phone,changeField:this.changeField,loading:loading,tab:currentTab,renderBtns:this.renderBtns})),this.renderTab(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_addressForm__["a" /* default */],{billingAddress:formValues.billing.billingAddress,directDebit:formValues.billing.directDebit,street:formValues.billing.street,door:formValues.billing.door,floor:formValues.billing.floor,district:formValues.billing.district,municipality:formValues.billing.municipality,billingStreet:formValues.billing.billingStreet,billingDoor:formValues.billing.billingDoor,billingFloor:formValues.billing.billingFloor,billingDistrict:formValues.billing.billingDistrict,billingMunicipality:formValues.billing.billingMunicipality,electronicBilling:formValues.billing.electronicBilling,districts:districts,municipalities:municipalities,billingMunicipalities:billingMunicipalities,changeField:this.changeField,loading:loading,tab:currentTab,renderBtns:this.renderBtns})),this.renderTab(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__components_revision__["a" /* default */],{currentTariff:this.state.currentTariff,loading:loading,tab:currentTab,electricityPriceList:electricityPriceList,gasPriceList:gasPriceList,prices:prices,tariffInfo:tariffInfo,calculatedHiredPowerFactor:calculatedHiredPowerFactor,timeCycle:priceListTimeCycle,gasStage:gasStage,formValues:formValues,renderBtns:this.renderBtns,changeField:this.changeField,allowDataSharing:formValues.confirm.allowDataSharing,districts:districts,municipalities:municipalities,billingMunicipalities:billingMunicipalities})),this.props.confirmationError&&!this.props.adhesionResponse&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SuccessMessage,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ConfirmationError,null,this.props.translations.CONFIRMATION_TIME_ERROR)),this.props.adhesionError&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__SmallModalV2__["a" /* default */],{icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__images_ic_alert_component_svg___default.a,null),title:'Aviso',onClose:function onClose(){return _this3.actions.setAdhesionError(null);}},this.props.adhesionError&&this.props.adhesionError.response.data&&!(typeof this.props.adhesionError.response.data==='string')&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ApiErrors,null,this.errorsList(this.props.adhesionError.response.data)),this.props.adhesionError&&this.props.adhesionError.response.data&&typeof this.props.adhesionError.response.data==='string'&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,'Ocorreu um erro, por favor tente novamente')),!this.state.showedDisclaimer&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Disclaimer,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerTitle,null,'Esclarecimento'),this.props.tariffInfo&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__validations__["j" /* hasPaidServices */])(this.props.tariffInfo.additional_services)&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerText,{red:true},ESCLARECIMENTO_CUSTOS_ADICIONAIS),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerText,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ListBall,null),ESCLARECIMENTO_PONTO_1),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerText,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ListBall,null),ESCLARECIMENTO_PONTO_2),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerText,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ListBall,null),ESCLARECIMENTO_PONTO_3),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerText,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ListBall,null),ESCLARECIMENTO_PONTO_4),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerTitle,null,ESCLARECIMENTO_CONTACTE)),!this.state.canSub&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Disclaimer,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerTitle,null,'Esclarecimentos'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerText,null,ESCLARECIMENTO_INDISPONIVEL),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerTitle,null,ESCLARECIMENTO_CONTACTE)))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Advice,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_EditDataModalV2_images_ic_info_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(AdviceTitle,null,'Como Funciona ?'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(AdviceText,null,'Complete o seu pedido de ades\xE3o e n\xF3s tratamos do resto!'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(AdviceText,null,'Iremos contactar o novo comercializador e enviar-lhe todos os dados necess\xE1rios'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(AdviceText,null,'O novo comercializador ir\xE1 contact\xE1-lo para confirmar o seu pedido de ades\xE3o'))),this.renderSmallModal('success'),this.renderSmallModal('cancel'));}}]);return JoinTariffModalV2;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]))||_class;var Wrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject);var ModalWrapper=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_19__BigModalV2__["a" /* default */])(_templateObject2);var SuccessMessage=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject3);var ConfirmationError=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject4);var ApiErrors=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject5);var Content=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject6);var TableHeader=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject7);var TopRow=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject8);var ToggleButton=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject9,function(_ref2){var active=_ref2.active;return active?'#fff':'#EFEFEF';},function(_ref3){var active=_ref3.active;return active?'#1D1E22':'#3E3E3E';},function(_ref4){var active=_ref4.active;return active&&'\n    border-bottom: 2px solid #006736;\n  ';},function(_ref5){var disabled=_ref5.disabled;return disabled&&'\n    cursor: default;\n  ';});var FormWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject10);var BtnsWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject11,function(_ref6){var tab=_ref6.tab;return tab==='personal'?'flex-end':'space-between';},function(_ref7){var tab=_ref7.tab;return tab!=='personal'&&'\n    width: 100%;  \n  ';});var Disclaimer=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject12);var DisclaimerTitle=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject13);var DisclaimerText=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject14,function(_ref8){var red=_ref8.red;return red&&'\n  color: indianred;\n  ';});var ListBall=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject15);var Advice=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject16);var AdviceTitle=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].h1(_templateObject17);var AdviceText=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].p(_templateObject18);var Description=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].p(_templateObject19);var SmallModalBtnsWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject20);

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JoinTariffModalMobileV2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_mapValues__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isArray__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_omit__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__logic__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_EditDataModalV2_images_ic_info_component_svg__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_EditDataModalV2_images_ic_info_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_EditDataModalV2_images_ic_info_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_ic_arrow_component_svg__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_ic_arrow_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__images_ic_arrow_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_ic_check_success_component_svg__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_ic_check_success_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_ic_check_success_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_ic_alert_component_svg__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_ic_alert_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__images_ic_alert_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_Loading__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ButtonOutlineV2__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ButtonGradientV2__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__MobileModalV2__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__SmallModalV2__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__mobileComponents_personalForm__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__mobileComponents_simplePersonalForm__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__mobileComponents_addressForm__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__mobileComponents_revision__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__validations__ = __webpack_require__(443);
var _class;var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background: linear-gradient(270deg, #006736 -58.87%, #93c13e 100%);\n\n  .closeIcon {\n    fill: #fff;\n    path {\n      fill: #fff;\n    }\n  }\n'],['\n  background: linear-gradient(270deg, #006736 -58.87%, #93c13e 100%);\n\n  .closeIcon {\n    fill: #fff;\n    path {\n      fill: #fff;\n    }\n  }\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n\n  > svg {\n    width: 48px;\n    height: 48px;\n  }\n\n  > h3,\n  p {\n    color: #fff;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 28px; /* 140% */\n    margin: 0;\n  }\n\n  > h3 {\n    text-transform: uppercase;\n  }\n\n  > p {\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 24px; /* 150% */\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n\n  > svg {\n    width: 48px;\n    height: 48px;\n  }\n\n  > h3,\n  p {\n    color: #fff;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 28px; /* 140% */\n    margin: 0;\n  }\n\n  > h3 {\n    text-transform: uppercase;\n  }\n\n  > p {\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 24px; /* 150% */\n  }\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  padding: 50px;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 87px;\n    height: 64px;\n    margin-bottom: 50px;\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  padding: 50px;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 87px;\n    height: 64px;\n    margin-bottom: 50px;\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #010101;\n  font-family: Nunito;\n  font-size: 19px;\n  line-height: 34px;\n  text-align: center;\n'],['\n  color: #010101;\n  font-family: Nunito;\n  font-size: 19px;\n  line-height: 34px;\n  text-align: center;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n'],['\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1 0 0;\n  align-self: stretch;\n  width: 100%;\n\n  border: 1px solid #ececec;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1 0 0;\n  align-self: stretch;\n  width: 100%;\n\n  border: 1px solid #ececec;\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n'],['\n  width: 100%;\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  display: flex;\n  align-items: center;\n  overflow-x: auto;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n'],['\n  width: 100%;\n  display: flex;\n  align-items: center;\n  overflow-x: auto;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 12px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex: 1 0 0;\n  align-self: stretch;\n  cursor: pointer;\n  min-width: 150px;\n\n  background: ',';\n\n  color: ',';\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n\n  ','\n\n  ','\n'],['\n  display: flex;\n  padding: 12px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex: 1 0 0;\n  align-self: stretch;\n  cursor: pointer;\n  min-width: 150px;\n\n  background: ',';\n\n  color: ',';\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n\n  ','\n\n  ','\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-grow: 1;\n  align-self: stretch;\n'],['\n  display: flex;\n  flex-grow: 1;\n  align-self: stretch;\n']),_templateObject11=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n\n  ','\n\n  .advice {\n    display: flex;\n    padding: 8px 20px;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 16px;\n    align-self: stretch;\n    background: var(\n      --Gradient,\n      linear-gradient(270deg, #006736 -58.87%, #93c13e 100%)\n    );\n\n    > h4 {\n      color: #fff;\n      font-size: 18px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 32px; /* 177.778% */\n      text-transform: uppercase;\n      margin: 0;\n    }\n  }\n\n  .btns {\n    display: flex;\n    padding: 16px;\n    align-items: center;\n    gap: 12px;\n    align-self: stretch;\n\n    > div:first-child,\n    > button {\n      width: 100%;\n    }\n  }\n\n  @media screen and (min-width: 600px) {\n    .btns {\n      justify-content: flex-end;\n\n      > div:first-child,\n      > button {\n        width: 140px;\n      }\n    }\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n\n  ','\n\n  .advice {\n    display: flex;\n    padding: 8px 20px;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 16px;\n    align-self: stretch;\n    background: var(\n      --Gradient,\n      linear-gradient(270deg, #006736 -58.87%, #93c13e 100%)\n    );\n\n    > h4 {\n      color: #fff;\n      font-size: 18px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 32px; /* 177.778% */\n      text-transform: uppercase;\n      margin: 0;\n    }\n  }\n\n  .btns {\n    display: flex;\n    padding: 16px;\n    align-items: center;\n    gap: 12px;\n    align-self: stretch;\n\n    > div:first-child,\n    > button {\n      width: 100%;\n    }\n  }\n\n  @media screen and (min-width: 600px) {\n    .btns {\n      justify-content: flex-end;\n\n      > div:first-child,\n      > button {\n        width: 140px;\n      }\n    }\n  }\n']),_templateObject12=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding: 20px 0;\n'],['\n  padding: 20px 0;\n']),_templateObject13=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  font-weight: bold;\n  margin-bottom: 20px;\n  color: #8abb3f;\n'],['\n  display: block;\n  font-weight: bold;\n  margin-bottom: 20px;\n  color: #8abb3f;\n']),_templateObject14=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin-bottom: 10px;\n\n  ','\n'],['\n  margin-bottom: 10px;\n\n  ','\n']),_templateObject15=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 10px;\n  height: 10px;\n  background: linear-gradient(270deg, #006736 0%, #93c13e 100%);\n  display: inline-block;\n  border-radius: 50%;\n  margin-right: 10px;\n'],['\n  width: 10px;\n  height: 10px;\n  background: linear-gradient(270deg, #006736 0%, #93c13e 100%);\n  display: inline-block;\n  border-radius: 50%;\n  margin-right: 10px;\n']),_templateObject16=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  align-self: stretch;\n  color: #3e3e3e;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n  margin: 0;\n\n  > b {\n    color: #010101;\n    font-weight: 700;\n  }\n'],['\n  align-self: stretch;\n  color: #3e3e3e;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n  margin: 0;\n\n  > b {\n    color: #010101;\n    font-weight: 700;\n  }\n']),_templateObject17=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n'],['\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n']);var translateErrors={first_name:'Primeiro Nome',last_name:'Último Nome',tax_id:'NIF',email:'Email',phone_number:'Telefone / Telemóvel',company_phone_number:'Telefone / Telemóvel Contacto',company_name:'Nome da empresa',company_cae:'CAE da empresa',company_email:'Email empresa',legal_bi:'BI/CC do Representante legal',street:'Rua',door:'Nº da porta',floor:'Andar',postal_code:'Código postal',billing_address:'Morada de faturação',billing_street:'Rua de faturação',billing_door:'Nº da porta de faturação',billing_floor:'Andar de faturação',billing_postal_code:'Código postal de faturação',cpe:'CPE',cui:'CUI',cuicpe:['CUI','CPE']};var JoinTariffModalMobileV2=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__logic__["a" /* default */])(_class=function(_Component){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(JoinTariffModalMobileV2,_Component);function JoinTariffModalMobileV2(){__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,JoinTariffModalMobileV2);var _this=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(JoinTariffModalMobileV2.__proto__||Object.getPrototypeOf(JoinTariffModalMobileV2)).call(this));_this.isFormValid=function(validations){var key=Object.keys(validations)[0];var list=validations[key];var formBase=_this.props.formValues[key];var invalid=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},key,{});__WEBPACK_IMPORTED_MODULE_8_lodash_mapValues___default()(list,function(funcs,valueKey){for(var index=0;index<funcs.length;index++){var func=funcs[index];var doFirst=true;if(__WEBPACK_IMPORTED_MODULE_9_lodash_isArray___default()(func)){func=func[0];doFirst=false;if(!func(formBase[valueKey].value,formBase)){break;}}if(doFirst){if(formBase[valueKey]){var _func=func(formBase[valueKey].value,formBase),result=_func.result,message=_func.message;if(!result){invalid[key][valueKey]=message;break;}}}}});if(_this.props.tariffInfo&&key==='personal'){var _this$props$tariffInf=_this.props.tariffInfo.entity,subscription_requires_email=_this$props$tariffInf.subscription_requires_email,subscription_requires_phone=_this$props$tariffInf.subscription_requires_phone;var emailKey='email';var phoneKey='phone';if(!subscription_requires_email&&!subscription_requires_phone){var phone=_this.props.formData.personal[phoneKey];var email=_this.props.formData.personal[emailKey];var emailVal=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__validations__["a" /* notEmptyEmail */])(email.value,phone.value);var phoneVal=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__validations__["b" /* notEmptyPhone */])(phone.value,email.value);if(!invalid.personal[phoneKey]&&!emailVal.result){invalid.personal[emailKey]=emailVal.message;}if(!invalid.personal[emailKey]&&!phoneVal.result){invalid.personal[phoneKey]=phoneVal.message;}}}return{valid:!Object.keys(invalid[key]).length,invalid:invalid};};_this.toggleTab=function(value){var _this$state=_this.state,currentTab=_this$state.currentTab,validations=_this$state.validations;var valid=true;var invalid=void 0;if(currentTab==='personal'||currentTab==='simple_personal'){var validation=_this.isFormValid(validations[0]);valid=validation.valid;invalid=validation.invalid;}else if(currentTab==='address'&&value==='revision'){var _validation=_this.isFormValid(validations[1]);valid=_validation.valid;invalid=_validation.invalid;}if(valid){_this.setState({currentTab:value});}else{_this.actions.setInvalid(invalid);}};_this.transformForm=function(form){if(!form){return false;}var personal=form.personal,billing=form.billing,electric=form.electric,gas=form.gas;var first_name=personal.name,last_name=personal.surName,tax_id=personal.nif,email=personal.email,phone_number=personal.phone,contact=personal.contact,contactTime=personal.contactTime;var street=billing.street,door=billing.door,floor=billing.floor,district=billing.district,municipality=billing.municipality,billingDoor=billing.billingDoor,billingFloor=billing.billingFloor,billingDistrict=billing.billingDistrict,billingMunicipality=billing.billingMunicipality,billingStreet=billing.billingStreet,directDebit=billing.directDebit,electronicBilling=billing.electronicBilling,billingAddress=billing.billingAddress;var cpe=electric.cpe,hired_power=electric.potency,time_cycle=electric.tariff,price_list_cycle=electric.cycle;var cui=gas.cui,price_step=gas.tier;var _this$props$tariffInf2=_this.props.tariffInfo,price_list=_this$props$tariffInf2.id,entity=_this$props$tariffInf2.entity,priceListObject=_this$props$tariffInf2.priceListObject,pricelistadditionalinfo=_this$props$tariffInf2.pricelistadditionalinfo;var gasFields=Object.assign({current_gas_entity:entity.id,cui:cui.value},price_step.value&&{price_step:price_step.value});var eletricityFields=Object.assign({current_electricity_entity:entity.id,cpe:cpe.value,price_list_cycle:price_list_cycle.value},hired_power.value&&{hired_power:hired_power.value},time_cycle.value&&{time_cycle:time_cycle.value});// Subscription source
var subscription_source='simple_simulator';var priceListId=priceListObject.priceListId;// Set the personal object to the correct one based on simulator
var personalObj={first_name:first_name.value,last_name:last_name.value,tax_id:tax_id.value,email:email.value,phone_number:phone_number.value,contact:contact.value,contact_time:contactTime.value};var isEleContract=!!(_this.props.tariffInfo&&pricelistadditionalinfo.electronic_contract);if(isEleContract){personalObj=__WEBPACK_IMPORTED_MODULE_10_lodash_omit___default()(personalObj,['tax_id','contact']);}var obj=Object.assign({},personalObj,{street:street.value,door:door.value,floor:floor.value,billing_street:billingStreet.value,billing_door:billingDoor.value,billing_floor:billingFloor.value,billing_detail:''+(electronicBilling.value==='false'?'':electronicBilling.value)+(directDebit.value==='false'?'':directDebit.value),billing_address:billingAddress.value,billing_district:billingDistrict.value,billing_municipality:billingMunicipality.value,contract_summary:{},price_list:price_list,user:'',district:district.value,municipality:municipality.value,subscription_source:subscription_source,simulation_price_list:priceListId});if(_this.state.currentTariff.result.electricityPriceList){obj=Object.assign({},obj,eletricityFields);}if(_this.state.currentTariff.result.gasPriceList){obj=Object.assign({},obj,gasFields);}return obj;};_this.renderBtns=function(){var _this$state2=_this.state,currentTab=_this$state2.currentTab,validations=_this$state2.validations,isEleContract=_this$state2.isEleContract;var _this$props=_this.props,formValues=_this$props.formValues,confirmationError=_this$props.confirmationError;var _this$actions=_this.actions,submitForm=_this$actions.submitForm,setConfirmationError=_this$actions.setConfirmationError;var outlineBtnText=currentTab==='personal'?'Cancelar':'Voltar atrás';var gradientBtnText=currentTab==='revision'?'Aderir':'Seguinte';var handleOutlineClick=function handleOutlineClick(e){e.preventDefault();if(confirmationError){setConfirmationError(false);_this.setState({cancelModal:true});return;}if(currentTab==='personal'||currentTab==='simple_personal'){_this.setState({cancelModal:true});}else if(currentTab==='address'){_this.toggleTab('personal');}else if(currentTab==='revision'&&isEleContract){_this.toggleTab('simple_personal');}else{_this.toggleTab('address');}};var handleGradientClick=function handleGradientClick(e){e.preventDefault();if(confirmationError){_this.actions.submitForm(_this.transformForm(_this.props.formData),{omitRepeated:true},_this.setState({successModal:true}));return;}if(currentTab==='personal'||currentTab==='simple_personal'){var validation=_this.isFormValid(validations[0]);if(validation.valid){_this.toggleTab(currentTab==='personal'?'address':'revision');}else{_this.actions.setInvalid(validation.invalid);}}else if(currentTab==='address'){var _validation2=_this.isFormValid(validations[1]);if(_validation2.valid){_this.toggleTab('revision');}else{_this.actions.setInvalid(_validation2.invalid);}}else{var personalValid=_this.isFormValid(validations[0]);var billingValid=_this.isFormValid(validations[1]);var revisionValid=formValues.confirm.allowDataSharing.value;if(personalValid.valid&&billingValid.valid&&revisionValid){submitForm(_this.transformForm(formValues),{},_this.setState({successModal:true}));}}};return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(BtnsWrapper,{tab:currentTab},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'advice',onClick:function onClick(){return _this.setState({infoModal:true});}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_EditDataModalV2_images_ic_info_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h4',null,'Como Funciona?')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'btns'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ButtonOutlineV2__["a" /* default */],{onClick:function onClick(e){return handleOutlineClick(e);}},outlineBtnText),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ButtonGradientV2__["a" /* default */],{onClick:function onClick(e){return handleGradientClick(e);},trailingIcon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__images_ic_arrow_component_svg___default.a,null),disabled:_this.disableSubmitButton()},gradientBtnText)));};_this.closeModal=function(){var changeTariff=_this.props.changeTariff;var resetForm=_this.actions.resetForm;resetForm();changeTariff(null);};_this.toggleModal=function(){var open=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;_this.setState({open:open},function(){return!_this.state.opened&&_this.actions.reset()&&_this.props.changeTariff(null);});};_this.toggleErrorModal=function(){_this.actions.setAdhesionError(null);};_this.changeField=function(key,property,value){var section=Object.assign({},_this.props.formValues[key]);var field=Object.assign({},section[property],{value:value});var data=Object.assign(_this.props.formValues,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},key,Object.assign({},section,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},property,field))));if(property==='district'||property==='billingDistrict'){_this.actions.fetchMunicipalities(value,property);}_this.actions.setFormValues(data);};_this.keepOnPersonalTab=function(){var validations=_this.state.validations;var validation=_this.isFormValid(validations[0]);if(validation.valid){return false;}else{return true;}};_this.keepOnAddressTab=function(){var validations=_this.state.validations;var validation=_this.isFormValid(validations[1]);if(validation.valid){return false;}else{return true;}};_this.disableSubmitButton=function(){var currentTab=_this.state.currentTab;var formValues=_this.props.formValues;if(currentTab==='personal'||currentTab==='simple_personal'){return _this.keepOnPersonalTab();}else if(currentTab==='address'){return _this.keepOnAddressTab();}else if(currentTab==='revision'){return!formValues.confirm.allowDataSharing.value;}return false;};_this.renderSmallModal=function(type){var adhesionResponse=_this.props.adhesionResponse;var condition=type==='success'?adhesionResponse&&_this.state.successModal:_this.state.cancelModal;var icon=type==='success'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__images_ic_check_success_component_svg___default.a,null):__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__images_ic_alert_component_svg___default.a,null);var title=type==='success'?'Pré-adesão submetida com sucesso':'sair da página ?';var description=type==='success'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Description,null,'O comercializador recebeu os seus dados e ir\xE1 entrar em contacto consigo no prazo m\xE1ximo de 48h. Envi\xE1mos uma confirma\xE7\xE3o do processo para o seu email:\xA0',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,_this.props.formValues.personal.email.value)):__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Description,null,'Se optar por sair agora, todos os dados que j\xE1 preencheu ser\xE3o perdidos e n\xE3o poder\xE3o ser recuperados. Para evitar ter que reiniciar o processo, recomendamos que termine o preenchimento.');var btnsContent=type==='success'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ButtonGradientV2__["a" /* default */],{style:{width:'100% '},onClick:function onClick(){_this.setState({successModal:false});_this.closeModal();}},'Ok'):__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SmallModalBtnsWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ButtonOutlineV2__["a" /* default */],{onClick:function onClick(){_this.setState({cancelModal:false});}},'Cancelar'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ButtonGradientV2__["a" /* default */],{danger:true,style:{flexGrow:'1'},onClick:function onClick(){_this.setState({cancelModal:false});_this.closeModal();}},'Sair'));var handleClose=type==='success'?function(){_this.setState({successModal:false});if(adhesionResponse){_this.closeModal();}}:function(){return _this.setState({cancelModal:false});};return condition&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__SmallModalV2__["a" /* default */],{title:title,description:description,icon:icon,onClose:handleClose},btnsContent);};_this.renderInfoModal=function(){return _this.state.infoModal?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InfoModal,{onClose:function onClose(){return _this.setState({infoModal:false});}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InfoModalWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_EditDataModalV2_images_ic_info_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h3',null,'Como Funciona?'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p',null,'Complete o seu pedido de ades\xE3o e n\xF3s tratamos do resto!'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p',null,'Iremos contactar o novo comercializador e enviar-lhe todos os dados necess\xE1rios'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p',null,'O novo comercializador ir\xE1 contact\xE1-lo para confirmar o seu pedido de ades\xE3o'))):null;};_this.renderTab=function(tab){var _this$props2=_this.props,adhesionResponse=_this$props2.adhesionResponse,confirmationError=_this$props2.confirmationError,tariffInfo=_this$props2.tariffInfo,submitting=_this$props2.submitting;var _this$state3=_this.state,showedDisclaimer=_this$state3.showedDisclaimer,canSub=_this$state3.canSub;return!adhesionResponse&&!confirmationError&&showedDisclaimer&&canSub&&tariffInfo&&!submitting?tab:null;};_this.state={tabs:[],currentTab:'',isEleContract:false,currentTariff:null,open:false,errorOpened:true,showedDisclaimer:true,canSub:true,infoModal:false,validations:[]};_this.adhereButtons=[{label:'cancelar',primary:false,click:function click(){return _this.toggleModal();},color:'#006736'},{label:'seguinte',primary:true,click:_this.adhereActions}];return _this;}__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(JoinTariffModalMobileV2,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState({currentTariff:nextProps.tariff});if(nextProps.tariffInfo){var tariff=nextProps.tariff,_nextProps$values=nextProps.values,potencia_contratada=_nextProps$values.potencia_contratada,ciclo_tarifa=_nextProps$values.ciclo_tarifa,municipality=_nextProps$values.municipality,simulation=nextProps.simulation;var priceListTimeCycle=this.props.tariff.priceListTimeCycle;var isEleContract=nextProps.tariffInfo.pricelistadditionalinfo.electronic_contract;isEleContract&&this.setState({tabs:['simple_personal','revision']});if(nextProps.firstSet){if(tariff.suggested_electricity){if(potencia_contratada){this.changeField('electric','potency',potencia_contratada);}if(ciclo_tarifa){this.changeField('electric','cycle',ciclo_tarifa);}if(priceListTimeCycle){this.changeField('electric','tariff',priceListTimeCycle);}}if(simulation&&simulation.gasStage){this.changeField('gas','tier',simulation.gasStage);}if(municipality){this.changeField('billing','municipality',municipality);}this.actions.setFirstSet(false);}}}},{key:'componentWillMount',value:function componentWillMount(){var _this2=this;var _props=this.props,tariff=_props.tariff,ciclo_tarifa=_props.values.ciclo_tarifa,tariffInfo=_props.tariffInfo;var _tariffInfo$entity=tariffInfo.entity,subscription_requires_email=_tariffInfo$entity.subscription_requires_email,subscription_requires_phone=_tariffInfo$entity.subscription_requires_phone;var _props$tariff$result=this.props.tariff.result,priceListTimeCycle=_props$tariff$result.priceListTimeCycle,calculatedHiredPowerFactor=_props$tariff$result.calculatedHiredPowerFactor,gasStage=_props$tariff$result.gasStage;var eleSub=true;var gasSub=true;var isEleContract=!!tariffInfo&&tariffInfo.pricelistadditionalinfo.electronic_contract;this.setState({isEleContract:isEleContract});if(tariff.result.electricityPriceList){var canSub=tariff.electricityPriceList.entity.can_subscribe;eleSub=canSub;}if(tariff.result.gasPriceList){var _canSub=tariff.gasPriceList.entity.can_subscribe;gasSub=_canSub;}if(!eleSub||!gasSub){this.adhereButtons=[{label:'Fechar',primary:true,click:function click(){return _this2.toggleModal();}}];this.setState({currentTariff:tariff,canSub:false,showedDisclaimer:true});}else{if(tariff.result.electricityPriceList){if(calculatedHiredPowerFactor){var hiredPower=Number(calculatedHiredPowerFactor);this.changeField('electric','potency',hiredPower);}if(ciclo_tarifa){this.changeField('electric','cycle',ciclo_tarifa);}if(priceListTimeCycle){this.changeField('electric','tariff',priceListTimeCycle);}}if(tariff.result.gasPriceList){if(gasStage){this.changeField('gas','tier',gasStage);}}var personal=[];if(isEleContract){personal.push('simple_personal');this.setState({currentTab:'simple_personal'});}else{personal.push('personal');this.setState({currentTab:'personal'});}var billing=[];if(!isEleContract){billing.push('address');}var tabs=[].concat(personal,billing,['revision']);var validations=[];var personalValidations={name:[__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */]],surName:[__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */]],nif:[__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */],__WEBPACK_IMPORTED_MODULE_25__validations__["d" /* isNIF */]],/*
         * these validations are added later now that
         * entities can control if email or phone are required
         */email:[],phone:[],contact:[__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */]],contactTime:[[__WEBPACK_IMPORTED_MODULE_25__validations__["e" /* isContactPhone */]],__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */]]};validations=[{personal:personalValidations}];if(!isEleContract){validations.push({billing:{street:[__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */]],door:[__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */]],district:[__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */]],municipality:[__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */]],billingStreet:[[__WEBPACK_IMPORTED_MODULE_25__validations__["f" /* hasBillingAddress */]],__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */]],billingDoor:[[__WEBPACK_IMPORTED_MODULE_25__validations__["f" /* hasBillingAddress */]],__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */]],billingDistrict:[[__WEBPACK_IMPORTED_MODULE_25__validations__["f" /* hasBillingAddress */]],__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */]],billingMunicipality:[[__WEBPACK_IMPORTED_MODULE_25__validations__["f" /* hasBillingAddress */]],__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */]]}});}if(isEleContract){delete validations[0].personal.nif;}var phone=validations[0].personal.phone;var email=validations[0].personal.email;if(subscription_requires_email&&!email.length){var _validations$0$person;(_validations$0$person=validations[0].personal.email).push.apply(_validations$0$person,[__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */],__WEBPACK_IMPORTED_MODULE_25__validations__["g" /* isEmail */]]);}if(subscription_requires_phone&&!phone.length){var _validations$0$person2;(_validations$0$person2=validations[0].personal.phone).push.apply(_validations$0$person2,[__WEBPACK_IMPORTED_MODULE_25__validations__["c" /* required */],__WEBPACK_IMPORTED_MODULE_25__validations__["h" /* isPhone */]]);}validations.push({confirm:{allowDataSharing:[__WEBPACK_IMPORTED_MODULE_25__validations__["i" /* isChecked */]]}});this.setState({currentTariff:tariff,tabs:tabs,validations:validations});}if(this.props.isHome){this.changeField('electric','potency',parseFloat(this.props.tariff.calculatedHiredPowerFactor));this.changeField('gas','tier',parseFloat(this.props.tariff.gasStage));}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.setState({currentTariff:null,tabs:[],currentTab:''});}},{key:'errorsList',value:function errorsList(errors){return Object.keys(errors).map(function(key){var field=void 0;if(key==='cuicpe'){field=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{key:key},'Estes ',translateErrors[key][0],' e ',translateErrors[key][1],' aderiram a um tarif\xE1rio recentemente. Tem de aguardar 30 dias para efetuar uma nova ades\xE3o no Poupa Energia. Se tiver d\xFAvidas ligue-nos para o 211 160 500.');}else if(key==='cui'||key==='cpe'){field=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{key:key},'Este ',translateErrors[key],' aderiu a um tarif\xE1rio recentemente. Tem de aguardar 30 dias para efetuar uma nova ades\xE3o no Poupa Energia. Se tiver d\xFAvidas ligue-nos para o 211 160 500.');}else{field=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{key:key},'O campo ',translateErrors[key],' cont\xE9m erros.');}return field;});}},{key:'renderLoading',value:function renderLoading(){var _props2=this.props,loading=_props2.loading,submitting=_props2.submitting;return loading||submitting?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Loading__["a" /* default */],null):null;}},{key:'render',value:function render(){var _this3=this;var _state=this.state,tabs=_state.tabs,currentTab=_state.currentTab,isEleContract=_state.isEleContract;var _props3=this.props,formValues=_props3.formValues,loading=_props3.loading,districts=_props3.districts,municipalities=_props3.municipalities,billingMunicipalities=_props3.billingMunicipalities,electricityPriceList=_props3.electricityPriceList,gasPriceList=_props3.gasPriceList,prices=_props3.prices,tariffInfo=_props3.tariffInfo,calculatedHiredPowerFactor=_props3.calculatedHiredPowerFactor,priceListTimeCycle=_props3.priceListTimeCycle,gasStage=_props3.gasStage,translations=_props3.translations;var _ref=translations||{},ESCLARECIMENTO_CUSTOS_ADICIONAIS=_ref.ESCLARECIMENTO_CUSTOS_ADICIONAIS,ESCLARECIMENTO_CONTACTE=_ref.ESCLARECIMENTO_CONTACTE,ESCLARECIMENTO_PONTO_4=_ref.ESCLARECIMENTO_PONTO_4,ESCLARECIMENTO_PONTO_3=_ref.ESCLARECIMENTO_PONTO_3,ESCLARECIMENTO_PONTO_2=_ref.ESCLARECIMENTO_PONTO_2,ESCLARECIMENTO_PONTO_1=_ref.ESCLARECIMENTO_PONTO_1,ESCLARECIMENTO_INDISPONIVEL=_ref.ESCLARECIMENTO_INDISPONIVEL;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__MobileModalV2__["a" /* default */],{setModalTriggerHeight:this.props.setModalTriggerHeight,modalTriggerHeight:this.props.modalTriggerHeight,title:'Aderir ao Tarif\xE1rio',onClose:function onClose(){return _this3.setState({cancelModal:true});}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Content,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TableHeader,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TopRow,null,tabs.map(function(tab,index){var suffix=index+1+'.';var text=tab==='revision'?'Resumo':tab==='address'?'Morada':'Dados Pessoais';var disableTab=false;if(tab==='address'){disableTab=_this3.keepOnPersonalTab();}else if(tab==='revision'&&isEleContract){disableTab=_this3.keepOnPersonalTab();}else if(tab==='revision'&&!isEleContract){disableTab=_this3.keepOnAddressTab();}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ToggleButton,{key:'tab_'+tab,active:currentTab===tab,onClick:function onClick(){return _this3.toggleTab(tab);},disabled:disableTab},suffix,' ',text);}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(FormWrapper,null,this.renderLoading(),this.renderTab(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__mobileComponents_personalForm__["a" /* default */],{name:formValues.personal.name,surName:formValues.personal.surName,email:formValues.personal.email,phone:formValues.personal.phone,nif:formValues.personal.nif,contact:formValues.personal.contact,contactTime:formValues.personal.contactTime,changeField:this.changeField,loading:loading,tab:currentTab,renderBtns:this.renderBtns})),this.renderTab(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__mobileComponents_simplePersonalForm__["a" /* default */],{name:formValues.personal.name,surName:formValues.personal.surName,email:formValues.personal.email,phone:formValues.personal.phone,changeField:this.changeField,loading:loading,tab:currentTab,renderBtns:this.renderBtns})),this.renderTab(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__mobileComponents_addressForm__["a" /* default */],{billingAddress:formValues.billing.billingAddress,directDebit:formValues.billing.directDebit,street:formValues.billing.street,door:formValues.billing.door,floor:formValues.billing.floor,district:formValues.billing.district,municipality:formValues.billing.municipality,billingStreet:formValues.billing.billingStreet,billingDoor:formValues.billing.billingDoor,billingFloor:formValues.billing.billingFloor,billingDistrict:formValues.billing.billingDistrict,billingMunicipality:formValues.billing.billingMunicipality,electronicBilling:formValues.billing.electronicBilling,districts:districts,municipalities:municipalities,billingMunicipalities:billingMunicipalities,changeField:this.changeField,loading:loading,tab:currentTab,renderBtns:this.renderBtns})),this.renderTab(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__mobileComponents_revision__["a" /* default */],{currentTariff:this.state.currentTariff,loading:loading,tab:currentTab,electricityPriceList:electricityPriceList,gasPriceList:gasPriceList,prices:prices,tariffInfo:tariffInfo,calculatedHiredPowerFactor:calculatedHiredPowerFactor,timeCycle:priceListTimeCycle,gasStage:gasStage,formValues:formValues,renderBtns:this.renderBtns,changeField:this.changeField,allowDataSharing:formValues.confirm.allowDataSharing,districts:districts,municipalities:municipalities,billingMunicipalities:billingMunicipalities})),this.props.confirmationError&&!this.props.adhesionResponse&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SuccessMessage,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ConfirmationError,null,this.props.translations.CONFIRMATION_TIME_ERROR)),this.props.adhesionError&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__SmallModalV2__["a" /* default */],{icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__images_ic_alert_component_svg___default.a,null),title:'Aviso',onClose:function onClose(){return _this3.actions.setAdhesionError(null);}},this.props.adhesionError&&this.props.adhesionError.response.data&&!(typeof this.props.adhesionError.response.data==='string')&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ApiErrors,null,this.errorsList(this.props.adhesionError.response.data)),this.props.adhesionError&&this.props.adhesionError.response.data&&typeof this.props.adhesionError.response.data==='string'&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,'Ocorreu um erro, por favor tente novamente')),!this.state.showedDisclaimer&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Disclaimer,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerTitle,null,'Esclarecimento'),this.props.tariffInfo&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__validations__["j" /* hasPaidServices */])(this.props.tariffInfo.additional_services)&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerText,{red:true},ESCLARECIMENTO_CUSTOS_ADICIONAIS),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerText,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ListBall,null),ESCLARECIMENTO_PONTO_1),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerText,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ListBall,null),ESCLARECIMENTO_PONTO_2),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerText,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ListBall,null),ESCLARECIMENTO_PONTO_3),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerText,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ListBall,null),ESCLARECIMENTO_PONTO_4),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerTitle,null,ESCLARECIMENTO_CONTACTE)),!this.state.canSub&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Disclaimer,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerTitle,null,'Esclarecimentos'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerText,null,ESCLARECIMENTO_INDISPONIVEL),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerTitle,null,ESCLARECIMENTO_CONTACTE)))),this.renderSmallModal('success'),this.renderSmallModal('cancel'),this.renderInfoModal());}}]);return JoinTariffModalMobileV2;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]))||_class;var InfoModal=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_20__SmallModalV2__["a" /* default */])(_templateObject);var InfoModalWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject2);var SuccessMessage=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject3);var ConfirmationError=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject4);var ApiErrors=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject5);var Content=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject6);var TableHeader=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject7);var TopRow=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject8);var ToggleButton=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject9,function(_ref2){var active=_ref2.active;return active?'#fff':'#EFEFEF';},function(_ref3){var active=_ref3.active;return active?'#1D1E22':'#3E3E3E';},function(_ref4){var active=_ref4.active;return active&&'\n    border-bottom: 2px solid #006736;\n  ';},function(_ref5){var disabled=_ref5.disabled;return disabled&&'\n    cursor: default;\n  ';});var FormWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject10);var BtnsWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject11,function(_ref6){var tab=_ref6.tab;return tab!=='personal'&&'\n    width: 100%;  \n  ';});var Disclaimer=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject12);var DisclaimerTitle=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject13);var DisclaimerText=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject14,function(_ref7){var red=_ref7.red;return red&&'\n  color: indianred;\n  ';});var ListBall=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject15);var Description=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].p(_templateObject16);var SmallModalBtnsWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject17);

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_InputV2__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_GhostRadioV2__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_ProfileV2_images_ic_arrow_component_svg__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_ProfileV2_images_ic_arrow_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_containers_ProfileV2_images_ic_arrow_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(298);
var AddressForm=function AddressForm(props){var changeField=props.changeField,loading=props.loading,tab=props.tab,renderBtns=props.renderBtns,billingAddress=props.billingAddress,directDebit=props.directDebit,street=props.street,door=props.door,floor=props.floor,district=props.district,municipality=props.municipality,billingStreet=props.billingStreet,billingDoor=props.billingDoor,billingFloor=props.billingFloor,billingDistrict=props.billingDistrict,billingMunicipality=props.billingMunicipality,electronicBilling=props.electronicBilling,districts=props.districts,municipalities=props.municipalities,billingMunicipalities=props.billingMunicipalities;var _renderAddressInputs=function _renderAddressInputs(type){var streetField=type==='contract'?street:billingStreet;var doorField=type==='contract'?door:billingDoor;var floorField=type==='contract'?floor:billingFloor;var districtField=type==='contract'?district:billingDistrict;var municipalityField=type==='contract'?municipality:billingMunicipality;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rowsWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* CustomInputsRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* InputWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_InputV2__["a" /* default */],{style:{width:'100%'},required:true,label:'Morada',type:'text',value:streetField.value,onChange:function onChange(val){return changeField('billing',type==='contract'?'street':'billingStreet',val);},valid:!Boolean(streetField.valid),errorMessage:streetField.valid}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* CustomInputsRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* InputWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_InputV2__["a" /* default */],{style:{width:'100%'},required:true,label:'Porta',type:'text',value:doorField.value,onChange:function onChange(val){return changeField('billing',type==='contract'?'door':'billingDoor',val);},valid:!Boolean(doorField.valid),errorMessage:doorField.valid})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* InputWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_InputV2__["a" /* default */],{style:{width:'100%'},required:true,label:'Andar',type:'text',value:floorField.value,onChange:function onChange(val){return changeField('billing',type==='contract'?'floor':'billingFloor',val);},valid:!Boolean(floorField.valid),errorMessage:floorField.valid}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* CustomInputsRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* WrapperSelect */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* InputLabel */],null,'Distrito'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["e" /* StyledSelect */],{items:districts,placeholder:'Distrito',onChange:function onChange(_ref){var value=_ref.value;return changeField('billing',type==='contract'?'district':'billingDistrict',value);},selected:districtField.value,arrowIcon:__WEBPACK_IMPORTED_MODULE_3_containers_ProfileV2_images_ic_arrow_component_svg___default.a}),Boolean(districtField.valid)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["f" /* Error */],null,districtField.valid)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* WrapperSelect */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* InputLabel */],null,'Concelho'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["e" /* StyledSelect */],{items:type==='contract'?municipalities:billingMunicipalities,placeholder:'Concelho',onChange:function onChange(_ref2){var value=_ref2.value;return changeField('billing',type==='contract'?'municipality':'billingMunicipality',value);},selected:municipalityField.value,arrowIcon:__WEBPACK_IMPORTED_MODULE_3_containers_ProfileV2_images_ic_arrow_component_svg___default.a}),Boolean(municipalityField.valid)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["f" /* Error */],null,municipalityField.valid))));};return!loading&&tab==='address'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["g" /* Form */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["h" /* FormInputs */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["i" /* InputsSection */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Morada de Contrato'),_renderAddressInputs('contract')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["i" /* InputsSection */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Morada de Fatura\xE7\xE3o'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rowsWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* CustomInputsRow */],{column:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Morada de fatura\xE7\xE3o',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,' *')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["j" /* RadiosWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_GhostRadioV2__["a" /* default */],{small:true,type:'radio',name:'contract_address_same',label:'Igual \xE0 morada de contrato',selected:billingAddress.value==='e',onClick:function onClick(){return changeField('billing','billingAddress','e');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_GhostRadioV2__["a" /* default */],{small:true,type:'radio',name:'contract_address_different',label:'Diferente da morada de contrato',selected:billingAddress.value==='d',onClick:function onClick(){return changeField('billing','billingAddress','d');}}))),billingAddress.value==='d'&&_renderAddressInputs('billing'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* CustomInputsRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* WrapperSelect */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'D\xE9bito direto',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,' *')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["j" /* RadiosWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_GhostRadioV2__["a" /* default */],{small:true,type:'radio',label:'Sim',selected:directDebit.value==='d',onClick:function onClick(){return changeField('billing','directDebit','d');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_GhostRadioV2__["a" /* default */],{small:true,type:'radio',label:'N\xE3o',selected:!directDebit.value,onClick:function onClick(){return changeField('billing','directDebit',false);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* WrapperSelect */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Fatura eletr\xF3nica',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,' *')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["j" /* RadiosWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_GhostRadioV2__["a" /* default */],{small:true,type:'radio',label:'Sim',selected:electronicBilling.value==='e',onClick:function onClick(){return changeField('billing','electronicBilling','e');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_GhostRadioV2__["a" /* default */],{small:true,type:'radio',label:'N\xE3o',selected:!electronicBilling.value,onClick:function onClick(){return changeField('billing','electronicBilling',false);}}))))))),renderBtns());};/* harmony default export */ __webpack_exports__["a"] = (AddressForm);

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_InputV2__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_GhostRadioV2__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_ProfileV2_images_ic_arrow_component_svg__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_ProfileV2_images_ic_arrow_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_containers_ProfileV2_images_ic_arrow_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(298);
var PersonalForm=function PersonalForm(props){var name=props.name,surName=props.surName,email=props.email,phone=props.phone,nif=props.nif,contact=props.contact,contactTime=props.contactTime,changeField=props.changeField,loading=props.loading,tab=props.tab,renderBtns=props.renderBtns;var contactValues=[{label:'9h00 - 11h30',value:'9h00 - 11h30'},{label:'11h30 - 13h00',value:'11h30 - 13h00'},{label:'13h00 - 15h30',value:'13h00 - 15h30'},{label:'15h30 - 18h00',value:'15h30 - 18h00'},{label:'18h00 - 20h30',value:'18h00 - 20h30'}];return!loading&&tab==='personal'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["g" /* Form */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["h" /* FormInputs */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["i" /* InputsSection */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Dados Pessoais'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rowsWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* CustomInputsRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* InputWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_InputV2__["a" /* default */],{id:'name_input',style:{width:'100%'},required:true,label:'Nome',type:'text',placeholder:'Escreva o seu nome',value:name.value,onChange:function onChange(val){return changeField('personal','name',val);},valid:!Boolean(name.valid),errorMessage:name.valid})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* InputWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_InputV2__["a" /* default */],{id:'surName_input',style:{width:'100%'},required:true,label:'Apelido',type:'text',placeholder:'Escreva o seu apelido',value:surName.value,onChange:function onChange(val){return changeField('personal','surName',val);},valid:!Boolean(surName.valid),errorMessage:surName.valid}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* CustomInputsRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* InputWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_InputV2__["a" /* default */],{id:'nif_input',style:{width:'100%'},required:true,label:'NIF',type:'number',placeholder:'Ex: 000 000 000',value:nif.value,onChange:function onChange(val){return changeField('personal','nif',val);},valid:!Boolean(nif.valid),errorMessage:nif.valid}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["i" /* InputsSection */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Contatos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rowsWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* CustomInputsRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* InputWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_InputV2__["a" /* default */],{id:'email_input',style:{width:'100%'},required:true,label:'Email',type:'email',placeholder:'Escreva o seu email',value:email.value,onChange:function onChange(val){return changeField('personal','email',val);},valid:!Boolean(email.valid),errorMessage:email.valid})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* InputWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_InputV2__["a" /* default */],{id:'phone_input',style:{width:'100%'},required:true,label:'Contato',placeholder:'Ex: 900 000 000',value:phone.value,valid:!Boolean(phone.valid),errorMessage:phone.valid,onChange:function onChange(val){var value=val;var sanitized=value.replace(/[^\d+]/g,'');var plusCount=(sanitized.match(/\+/g)||[]).length;if(plusCount>1){value='+'+sanitized.replace(/\+/g,'');}else if(plusCount===1&&sanitized.indexOf('+')!==0){value='+'+sanitized.replace(/\+/g,'');}else{value=sanitized;}changeField('personal','phone',value);},pattern:'[\\+0-9]*',inputMode:'tel',type:'text'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* CustomInputsRow */],{column:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Meio de contato prefer\xEAncial',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,' *')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["j" /* RadiosWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_GhostRadioV2__["a" /* default */],{small:true,type:'radio',name:'email',label:'Email',selected:contact.value==='e',onClick:function onClick(){changeField('personal','contact','e');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_GhostRadioV2__["a" /* default */],{small:true,type:'radio',name:'phone',label:'Chamada telef\xF3nica',selected:contact.value==='p',onClick:function onClick(){changeField('personal','contact','p');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_GhostRadioV2__["a" /* default */],{small:true,type:'radio',name:'sms',label:'SMS',selected:contact.value==='s',onClick:function onClick(){changeField('personal','contact','s');}}))),contact.value==='p'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* CustomInputsRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* WrapperSelect */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* InputLabel */],null,'Em que per\xEDodo pretende ser contactado?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["e" /* StyledSelect */],{items:contactValues,placeholder:'Selecionar o ciclo horário...',onChange:function onChange(_ref){var value=_ref.value;return changeField('personal','contactTime',value);},selected:contactTime.value,arrowIcon:__WEBPACK_IMPORTED_MODULE_3_containers_ProfileV2_images_ic_arrow_component_svg___default.a}),Boolean(contactTime.valid)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["f" /* Error */],null,contactTime.valid)))))),renderBtns());};/* harmony default export */ __webpack_exports__["a"] = (PersonalForm);

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_AditionalServicesV2__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_GhostRadioV2__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_ic_check_component_svg__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_ic_check_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_ic_check_component_svg__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n  height: 100%;\n  align-self: stretch;\n  flex-grow: 1;\n\n  > .tableWrapper {\n    overflow-y: auto;\n    display: flex;\n    align-self: stretch;\n    flex: 1 0 0;\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n  height: 100%;\n  align-self: stretch;\n  flex-grow: 1;\n\n  > .tableWrapper {\n    overflow-y: auto;\n    display: flex;\n    align-self: stretch;\n    flex: 1 0 0;\n  }\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  border-spacing: 0;\n'],['\n  width: 100%;\n  border-spacing: 0;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: ',';\n  align-items: ',';\n  gap: 4px;\n  flex: 1 0 0;\n  border-bottom: 1px solid #ececec;\n\n  ','\n'],['\n  display: flex;\n  padding: ',';\n  align-items: ',';\n  gap: 4px;\n  flex: 1 0 0;\n  border-bottom: 1px solid #ececec;\n\n  ','\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 4px;\n  align-self: stretch;\n  padding: 10px 16px;\n\n  > .item {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  > .item svg {\n    width: 18px;\n    height: 18px;\n\n    path {\n      fill: #006736;\n    }\n  }\n\n  > .item p {\n    flex: 1 0 0;\n    color: #3e3e3e;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    margin: 0;\n  }\n\n  .item.bold p {\n    font-weight: 700;\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 4px;\n  align-self: stretch;\n  padding: 10px 16px;\n\n  > .item {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  > .item svg {\n    width: 18px;\n    height: 18px;\n\n    path {\n      fill: #006736;\n    }\n  }\n\n  > .item p {\n    flex: 1 0 0;\n    color: #3e3e3e;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    margin: 0;\n  }\n\n  .item.bold p {\n    font-weight: 700;\n  }\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #1d1e22;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  margin: 0;\n\n  > a {\n    color: #1d1e22;\n    text-decoration-line: underline;\n  }\n'],['\n  color: #1d1e22;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  margin: 0;\n\n  > a {\n    color: #1d1e22;\n    text-decoration-line: underline;\n  }\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #006736;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 20px;\n'],['\n  color: #006736;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 20px;\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 1 0 0;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  color: #3e3e3e;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: ',';\n  line-height: 20px;\n\n  > img {\n    width: 50px;\n    height: 26px;\n    object-fit: contain;\n  }\n'],['\n  flex: 1 0 0;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  color: #3e3e3e;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: ',';\n  line-height: 20px;\n\n  > img {\n    width: 50px;\n    height: 26px;\n    object-fit: contain;\n  }\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 2px;\n  flex: 1 0 0;\n\n  > span {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    align-self: stretch;\n  }\n\n  > span p {\n    color: #1d1e22;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    margin: 0;\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 2px;\n  flex: 1 0 0;\n\n  > span {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    align-self: stretch;\n  }\n\n  > span p {\n    color: #1d1e22;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    margin: 0;\n  }\n']);var Revision=function Revision(props){var loading=props.loading,tab=props.tab,currentTariff=props.currentTariff,tariffInfo=props.tariffInfo,electricityPriceList=props.electricityPriceList,prices=props.prices,gasPriceList=props.gasPriceList,renderBtns=props.renderBtns,formValues=props.formValues,changeField=props.changeField,allowDataSharing=props.allowDataSharing,districts=props.districts,municipalities=props.municipalities,billingMunicipalities=props.billingMunicipalities;var gasStage=currentTariff.result.gasStage;var timeCycle=currentTariff.result.priceListTimeCycle;var calculatedHiredPowerFactor=currentTariff.result.calculatedHiredPowerFactor;var _renderRow=function _renderRow(field,name){var isImg=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var suffix=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'';var fieldToUse=field;if(isImg){fieldToUse=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_utils__["f" /* generateMediaUrl */])(field),alt:name});}return field?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,{hasImg:isImg},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InvoiceCell,{light:true},name),isImg?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InvoiceCell,null,fieldToUse):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InvoiceCell,null,fieldToUse+' '+suffix)):null;};var _renderDistrictRow=function _renderDistrictRow(field,name){if(field){var fieldLabel=districts.find(function(_ref){var value=_ref.value;return value===field;}).label;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InvoiceCell,{light:true},name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InvoiceCell,null,fieldLabel));}return null;};var _renderMunicipalitiesRow=function _renderMunicipalitiesRow(field,name,billing){if(field){var correctMunicipalities=billing?billingMunicipalities:municipalities;var fieldLabel=correctMunicipalities.find(function(_ref2){var value=_ref2.value;return value===field;}).label;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InvoiceCell,{light:true},name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InvoiceCell,null,fieldLabel));}return null;};var _renderSpan=function _renderSpan(label,value,suffix){return value&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,label),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,value),' ',suffix));};var _renderElectricityRow=function _renderElectricityRow(){return electricityPriceList&&prices.electricity&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,{isEnergy:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InvoiceCell,{light:true},'Eletricidade'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(EnergyCell,null,_renderSpan('Termo Potência',prices.electricity.termo_fixo,'€/Dia'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Energia'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null)),_renderSpan('Fora do Vazio',prices.electricity.cheia,'€/kWh'),_renderSpan('Vazio',prices.electricity.vazio,'€/kWh')));};var _renderGasRow=function _renderGasRow(){return gasPriceList&&prices.gas&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,{isEnergy:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InvoiceCell,{light:true},'G\xE1s Natural'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(EnergyCell,null,_renderSpan('Energia',prices.gas.termo_energia,'€/kWh'),_renderSpan('Termo Fixo',prices.gas.termo_fixo,'€/Dia')));};var isEleContract=tariffInfo.pricelistadditionalinfo.electronic_contract;var timeCycleValue=timeCycle==='s'?'Simples':timeCycle==='b'?'Bi-Horário':timeCycle==='t'?'Tri-Horário':null;var contactValue=formValues.personal.contact.value;var contactMethod=contactValue==='email'?'E-mail':contactValue==='phone'?'Chamada telefónica':'SMS';var debitDirection=formValues.billing.directDebit.value?'Sim':'Não';var billingAddressValue=formValues.billing.billingAddress.value==='d';var billingAddress=billingAddressValue?'Diferente da morada do contrato':'Igual à morada de contrato';return!loading&&tab==='revision'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tableWrapper'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Table,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TitleCell,null,'Resumo do Tarif\xE1rio')),tariffInfo&&_renderRow(tariffInfo.entity.hi_res_logo,'Fornecedor',true),tariffInfo&&_renderRow(tariffInfo.designation,'Tarifário'),_renderElectricityRow(),_renderGasRow(),tariffInfo&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_AditionalServicesV2__["a" /* default */],{list:tariffInfo.additional_services}),currentTariff&&currentTariff.result.electricityPriceList&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TitleCell,null,'Eletricidade')),currentTariff&&currentTariff.result.electricityPriceList?_renderRow(currentTariff.result.prices.electricity.termo_fixo,'Termo Potência',false,'€/Dia'):null,currentTariff&&currentTariff.result.electricityPriceList&&timeCycle==='s'?_renderRow(currentTariff.result.prices.electricity.cheia,'Energia',false,'€/kWh'):null,currentTariff&&currentTariff.result.electricityPriceList&&timeCycle!=='s'?_renderRow(currentTariff.result.prices.electricity.vazio,'Vazio',false,'€/kWh'):null,currentTariff&&currentTariff.result.electricityPriceList&&timeCycle==='b'?_renderRow(currentTariff.result.prices.electricity.cheia,'Fora do Vazio',false,'€/kWh'):null,currentTariff&&currentTariff.result.electricityPriceList&&timeCycle!=='s'&&timeCycle!=='b'?_renderRow(currentTariff.result.prices.electricity.ponta,'Ponta',false,'€/kWh'):null,currentTariff&&currentTariff.result.electricityPriceList&&timeCycle!=='s'&&timeCycle!=='b'?_renderRow(currentTariff.result.prices.electricity.cheia,'Cheias',false,'€/kWh'):null,currentTariff&&currentTariff.result.electricityPriceList&&calculatedHiredPowerFactor?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InvoiceCell,{light:true},'Pot\xEAncia'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InvoiceCell,null,Math.round(calculatedHiredPowerFactor*1e2)/1e2,' kVa')):null,currentTariff&&currentTariff.result.electricityPriceList?_renderRow(timeCycleValue,'Tarifa'):null,currentTariff&&currentTariff.result.electricityPriceList?_renderRow('Diário','Ciclo Horário'):null,currentTariff&&currentTariff.result.gasPriceList&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TitleCell,null,'G\xE1s Natural')),gasStage&&currentTariff.result.gasPriceList?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InvoiceCell,{light:true},'Escal\xE3o'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InvoiceCell,null,'Escal\xE3o ',gasStage)):null,currentTariff.result.gasPriceList&&_renderRow(currentTariff.result.prices.gas.termo_fixo,'Termo Fixo',false,'€/Dia'),currentTariff.result.gasPriceList&&_renderRow(currentTariff.result.prices.gas.termo_energia,'Energia',false,'€/kWh'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TitleCell,null,'Dados de ades\xE3o ao tarif\xE1rio')),_renderRow(formValues.personal.name.value,'Primeiro nome'),_renderRow(formValues.personal.surName.value,'Apelido'),_renderRow(formValues.personal.nif.value,'NIF'),_renderRow(formValues.personal.phone.value,'Telefone/Telemóvel'),_renderRow(contactMethod,'Meio de contato preferencial'),_renderRow(debitDirection,'Débito direto'),_renderRow('Sim','Fatura eletrónica'),_renderRow(billingAddress,'Morada de faturação'),!isEleContract&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TitleCell,null,formValues.billing.billingAddress.value==='e'?'Morada de Contrato e Faturação':'Morada de Contrato')),!isEleContract&&_renderRow(formValues.billing.street.value,'Rua'),!isEleContract&&_renderRow(formValues.billing.door.value,'Nº da Porta'),!isEleContract&&_renderRow(formValues.billing.floor.value,'Andar'),!isEleContract&&_renderDistrictRow(formValues.billing.district.value,'Distrito'),!isEleContract&&_renderMunicipalitiesRow(formValues.billing.municipality.value,'Concelho'),!isEleContract&&billingAddressValue&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TitleCell,null,'Morada De Fatura\xE7\xE3o')),!isEleContract&&billingAddressValue&&_renderRow(formValues.billing.billingStreet.value,'Rua'),!isEleContract&&billingAddressValue&&_renderRow(formValues.billing.billingDoor.value,'Nº da Porta'),!isEleContract&&billingAddressValue&&_renderRow(formValues.billing.billingFloor.value,'Andar'),!isEleContract&&billingAddressValue&&_renderDistrictRow(formValues.billing.billingDistrict.value,'Distrito'),!isEleContract&&billingAddressValue&&_renderMunicipalitiesRow(formValues.billing.billingMunicipality.value,'Concelho',true),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TitleCell,null,'Outras Informa\xE7\xF5es')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ListRow,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__images_ic_check_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,' ','Os valores apresentados baseiam-se nos dados introduzidos e representam uma estimativa da sua fatura de energia nos pr\xF3ximos 12 meses e da poupan\xE7a expect\xE1vel face ao seu tarif\xE1rio atual.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__images_ic_check_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,' ','Estes valores t\xEAm em considera\xE7\xE3o as condi\xE7\xF5es de consumo de eletricidade e/ou g\xE1s natural inseridos e que se assumem corretos e atuais.',' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__images_ic_check_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,' ','O presente pedido de ades\xE3o n\xE3o constitui uma proposta contratual, sendo esta uma responsabilidade do comercializador, que entrar\xE1 em contacto consigo.',' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__images_ic_check_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,' ','O OLMC n\xE3o pode ser responsabilizado por eventuais diferen\xE7as no valor de fatura\xE7\xE3o e/ou consumos de eletricidade e g\xE1s natural que venham a ocorrer durante este per\xEDodo,. nem por eventuais diverg\xEAncias entre as partes que possam decorrer do contrato celebrado na sequ\xEAncia de informa\xE7\xE3o disponibilizada pelo portal Poupa Energia.',' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'item bold'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,' Em caso de d\xFAvida contacte-nos atrav\xE9s do 211 160 500 '))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Row,{noPadding:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_GhostRadioV2__["a" /* default */],{type:'checkbox',name:'allow_data_sharing',labelStyles:{flex:'1'},label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TermsLink,null,'Concordo com os',' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{target:'_blank',href:__WEBPACK_IMPORTED_MODULE_6_config__["g" /* PAGE_URL */]+'/termos-e-condicoes/'},'termos e condi\xE7\xF5es'),' ','e autorizo o envio desta informa\xE7\xE3o para o comercializador.'),selected:allowDataSharing.value,onClick:function onClick(){return changeField('confirm','allowDataSharing',!allowDataSharing.value);}}))))),renderBtns());};/* harmony default export */ __webpack_exports__["a"] = (Revision);var Wrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject);var Table=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].table(_templateObject2);var Row=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].tr(_templateObject3,function(_ref3){var hasImg=_ref3.hasImg;return hasImg?'8px 16px':'10px 16px';},function(_ref4){var isEnergy=_ref4.isEnergy;return isEnergy?'flex-start':'center';},function(_ref5){var noPadding=_ref5.noPadding;return noPadding&&'\n    padding: 0;\n  ';});var ListRow=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].tr(_templateObject4);var TermsLink=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].p(_templateObject5);var TitleCell=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].td(_templateObject6);var InvoiceCell=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].td(_templateObject7,function(_ref6){var light=_ref6.light;return light?'400':'600';});var EnergyCell=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].td(_templateObject8);

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_InputV2__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(298);
var SimplePersonalForm=function SimplePersonalForm(props){var name=props.name,surName=props.surName,email=props.email,phone=props.phone,changeField=props.changeField,loading=props.loading,tab=props.tab,renderBtns=props.renderBtns;return!loading&&tab==='simple_personal'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["g" /* Form */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["h" /* FormInputs */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["i" /* InputsSection */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Dados Pessoais'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rowsWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* CustomInputsRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* InputWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_InputV2__["a" /* default */],{id:'name_input',style:{width:'100%'},required:true,label:'Nome',type:'text',placeholder:'Escreva o seu nome',value:name.value,onChange:function onChange(val){return changeField('personal','name',val);},valid:!Boolean(name.valid),errorMessage:name.valid})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* InputWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_InputV2__["a" /* default */],{id:'surName_input',style:{width:'100%'},required:true,label:'Apelido',type:'text',placeholder:'Escreva o seu apelido',value:surName.value,onChange:function onChange(val){return changeField('personal','surName',val);},valid:!Boolean(surName.valid),errorMessage:surName.valid}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["i" /* InputsSection */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Contatos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rowsWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* CustomInputsRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* InputWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_InputV2__["a" /* default */],{id:'email_input',style:{width:'100%'},required:true,label:'Email',type:'email',placeholder:'Escreva o seu email',value:email.value,onChange:function onChange(val){return changeField('personal','email',val);},valid:!Boolean(email.valid),errorMessage:email.valid})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* InputWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_InputV2__["a" /* default */],{id:'phone_input',style:{width:'100%'},required:true,label:'Contato',placeholder:'Ex: 900 000 000',value:phone.value,valid:!Boolean(phone.valid),errorMessage:phone.valid,onChange:function onChange(val){var value=val;var sanitized=value.replace(/[^\d+]/g,'');var plusCount=(sanitized.match(/\+/g)||[]).length;if(plusCount>1){value='+'+sanitized.replace(/\+/g,'');}else if(plusCount===1&&sanitized.indexOf('+')!==0){value='+'+sanitized.replace(/\+/g,'');}else{value=sanitized;}changeField('personal','phone',value);},pattern:'[\\+0-9]*',inputMode:'tel',type:'text'})))))),renderBtns());};/* harmony default export */ __webpack_exports__["a"] = (SimplePersonalForm);

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_config__ = __webpack_require__(10);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 130px;\n  width: 110px;\n  border: 1px solid #ececec;\n  flex-grow: 1;\n  cursor: pointer;\n\n  &:hover,\n  &.selected {\n    border: none;\n    background: ',';\n    padding: 1px;\n  }\n\n  ','\n'],['\n  height: 130px;\n  width: 110px;\n  border: 1px solid #ececec;\n  flex-grow: 1;\n  cursor: pointer;\n\n  &:hover,\n  &.selected {\n    border: none;\n    background: ',';\n    padding: 1px;\n  }\n\n  ','\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 12px;\n  width: 100%;\n  height: 100%;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex: 1 0 0;\n  align-self: stretch;\n  background: #fff;\n\n  &.selected {\n    background: linear-gradient(\n        0deg,\n        rgba(147, 193, 62, 0.1) 0%,\n        rgba(147, 193, 62, 0.1) 100%\n      ),\n      #fff;\n  }\n'],['\n  display: flex;\n  padding: 12px;\n  width: 100%;\n  height: 100%;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex: 1 0 0;\n  align-self: stretch;\n  background: #fff;\n\n  &.selected {\n    background: linear-gradient(\n        0deg,\n        rgba(147, 193, 62, 0.1) 0%,\n        rgba(147, 193, 62, 0.1) 100%\n      ),\n      #fff;\n  }\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  align-self: stretch;\n'],['\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  align-self: stretch;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #3e3e3e;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 18px; /* 128.571% */\n'],['\n  color: #3e3e3e;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 18px; /* 128.571% */\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  width: 20px;\n  height: 20px;\n  position: relative;\n  z-index: 1;\n  cursor: pointer;\n\n  &::before {\n    content: \'\';\n    display: block;\n    position: absolute;\n    inset: 0;\n    border: 1px solid #ececec;\n    background: #f9f9f9;\n    z-index: 2;\n  }\n\n  &::after {\n    content: \'\';\n    position: absolute;\n    display: none;\n    top: 2px;\n    left: 7px;\n    z-index: 3;\n    transform: rotate(45deg);\n    height: 10px;\n    width: 5px;\n    border-bottom: 2px solid #fff;\n    border-right: 2px solid #fff;\n    box-sizing: content-box !important;\n  }\n\n  &:checked {\n    &::before {\n      content: \'\';\n      background: ',';\n      border: none;\n    }\n    &::after {\n      display: inline-block;\n    }\n  }\n'],['\n  display: block;\n  width: 20px;\n  height: 20px;\n  position: relative;\n  z-index: 1;\n  cursor: pointer;\n\n  &::before {\n    content: \'\';\n    display: block;\n    position: absolute;\n    inset: 0;\n    border: 1px solid #ececec;\n    background: #f9f9f9;\n    z-index: 2;\n  }\n\n  &::after {\n    content: \'\';\n    position: absolute;\n    display: none;\n    top: 2px;\n    left: 7px;\n    z-index: 3;\n    transform: rotate(45deg);\n    height: 10px;\n    width: 5px;\n    border-bottom: 2px solid #fff;\n    border-right: 2px solid #fff;\n    box-sizing: content-box !important;\n  }\n\n  &:checked {\n    &::before {\n      content: \'\';\n      background: ',';\n      border: none;\n    }\n    &::after {\n      display: inline-block;\n    }\n  }\n']);var LeftAlignCheckV2=function LeftAlignCheckV2(_ref){var icon=_ref.icon,name=_ref.name,selected=_ref.selected,onClick=_ref.onClick,value=_ref.value,className=_ref.className,disabled=_ref.disabled,props=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref,['icon','name','selected','onClick','value','className','disabled']);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(WrapperBg,Object.assign({bgColor:__WEBPACK_IMPORTED_MODULE_4_config__["c" /* backgroundColors */].normalLeft,className:className+' '+(selected&&'selected'),disabled:disabled},props),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Wrapper,{onClick:onClick,className:selected&&'selected'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(TopBox,null,icon,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Input,{type:'checkbox',bgColor:__WEBPACK_IMPORTED_MODULE_4_config__["c" /* backgroundColors */].normalLeft,id:'opt-'+value+'-'+name,name:name,checked:selected,onChange:onClick})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Title,null,name)));};/* harmony default export */ __webpack_exports__["a"] = (LeftAlignCheckV2);var WrapperBg=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject,function(_ref2){var bgColor=_ref2.bgColor;return bgColor;},function(_ref3){var disabled=_ref3.disabled;return disabled&&'\n    pointer-events: none;\n    cursor: default;\n    opacity: 0.7;\n  ';});var Wrapper=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject2);var TopBox=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject3);var Title=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].span(_templateObject4);var Input=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].input.attrs({type:'radio'})(_templateObject5,function(_ref4){var bgColor=_ref4.bgColor;return bgColor;});

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_flexbox_grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_flexbox_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_flexbox_grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_AditionalServices__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Util__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Svg_ic_gas_svg__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Svg_ic_gas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_Svg_ic_gas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Svg_ic_eletricidade_svg__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Svg_ic_eletricidade_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_Svg_ic_eletricidade_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Svg_ic_contrato_faturacao_svg__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Svg_ic_contrato_faturacao_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_Svg_ic_contrato_faturacao_svg__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  color: #3e3e3e;\n  font-family: Nunito;\n  font-size: 17px;\n  font-weight: bold;\n  line-height: 14px;\n'],['\n  display: block;\n  color: #3e3e3e;\n  font-family: Nunito;\n  font-size: 17px;\n  font-weight: bold;\n  line-height: 14px;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  color: #3e3e3e;\n  font-family: Nunito;\n  font-size: 20px;\n  font-weight: bold;\n  margin-bottom: 5px;\n'],['\n  display: block;\n  color: #3e3e3e;\n  font-family: Nunito;\n  font-size: 20px;\n  font-weight: bold;\n  margin-bottom: 5px;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  max-width: 5%;\n  margin-right: 5px;\n'],['\n  max-width: 5%;\n  margin-right: 5px;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  max-width: 5%;\n  margin-right: 6px;\n'],['\n  max-width: 5%;\n  margin-right: 6px;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  max-height: 80%;\n  max-width: 80%;\n  display: block;\n'],['\n  max-height: 80%;\n  max-width: 80%;\n  display: block;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #9c9c9c;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 14px;\n'],['\n  color: #9c9c9c;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 14px;\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-weight: normal;\n'],['\n  font-weight: normal;\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #676767;\n  font-family: Nunito;\n  font-size: 18px;\n  font-weight: bold;\n  line-height: 18px;\n'],['\n  color: #676767;\n  font-family: Nunito;\n  font-size: 18px;\n  font-weight: bold;\n  line-height: 18px;\n']);var MonthlyInvoice=function MonthlyInvoice(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Util__["a" /* Marginer */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Util__["a" /* Marginer */],{top:'12',right:'0',bottom:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Entity,{src:props.tariffInfo.entity&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils__["f" /* generateMediaUrl */])(props.tariffInfo.entity.hi_res_logo),alt:props.tariffInfo.entity&&props.tariffInfo.entity.designation})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(BigTitle,null,'Fatura Mensal'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Value,null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils__["h" /* currency */])(props.tariff&&props.tariff.annualBilling/12),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Unit,null,'\u20AC')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Util__["a" /* Marginer */],{top:'37',right:'0',bottom:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_flexbox_grid__["Row"],null,props.tariff.electricityPriceList&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Title,{style:{color:'#FF8E2A',marginBottom:10}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(EletricityIcon,{src:__WEBPACK_IMPORTED_MODULE_8_components_Svg_ic_eletricidade_svg___default.a}),'Eletricidade'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Label,null,'Termo Pot\xEAncia'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Value,null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils__["h" /* currency */])(props.tariff.electricityFixedTerm/12),'\u20AC')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Label,null,'Energia'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Value,null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils__["h" /* currency */])(props.tariff.electricityEnergy/12),'\u20AC')))),props.tariff.gasPriceList&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Title,{style:{color:'#00BDED',marginBottom:10,marginTop:5}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(GasIcon,{src:__WEBPACK_IMPORTED_MODULE_7_components_Svg_ic_gas_svg___default.a}),'G\xE1s Natural'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Label,null,'Termo Fixo'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Value,null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils__["h" /* currency */])(props.tariff.gasFixedTerm/12),'\u20AC')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Label,null,'Energia'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Value,null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils__["h" /* currency */])(props.tariff.gasEnergy/12),'\u20AC')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Util__["a" /* Marginer */],{top:'48',right:'0',left:'0',bottom:'0'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Title,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(OrderIcon,{src:__WEBPACK_IMPORTED_MODULE_9_components_Svg_ic_contrato_faturacao_svg___default.a}),'Impostos'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Util__["a" /* Marginer */],{top:'12',right:'0',bottom:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Label,null,'Total'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Value,null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils__["h" /* currency */])(props.tariff.annualTaxes/12),'\u20AC')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_flexbox_grid__["Col"],{xs:6,style:{marginTop:-25}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_AditionalServices__["a" /* default */],{style:{margin:0},list:props.tariffInfo.additional_services}))))));};var Title=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject);var BigTitle=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject2);var GasIcon=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].img(_templateObject3);var EletricityIcon=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].img(_templateObject3);var OrderIcon=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].img(_templateObject4);var Entity=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].img(_templateObject5);var Label=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject6);var Unit=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject7);var Value=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject8);/* harmony default export */ __webpack_exports__["a"] = (MonthlyInvoice);

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MyTarifMobileSectionV2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_ic_result_component_svg__ = __webpack_require__(1631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_ic_result_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_ic_result_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_ic_house_component_svg__ = __webpack_require__(1628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_ic_house_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_ic_house_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_ic_see_component_svg__ = __webpack_require__(1632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_ic_see_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_ic_see_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_ic_edit_component_svg__ = __webpack_require__(1626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_ic_edit_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_ic_edit_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_ic_whatsapp_component_svg__ = __webpack_require__(1633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_ic_whatsapp_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__images_ic_whatsapp_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_ic_facebook_component_svg__ = __webpack_require__(1627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_ic_facebook_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_ic_facebook_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_ic_x_component_svg__ = __webpack_require__(1634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_ic_x_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__images_ic_x_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_ic_mail_component_svg__ = __webpack_require__(1630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_ic_mail_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__images_ic_mail_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_ic_info_component_svg__ = __webpack_require__(1629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_ic_info_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__images_ic_info_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ShareButtonV2__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__TooltipV2__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ButtonOutlineV2__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ButtonGradientV2__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__EnergyDetailsV2__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__DropdownGhostV2__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__EditDataModalV2_mobile__ = __webpack_require__(851);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #fff;\n  font-family: Nunito;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 150% */\n  min-width: 160px;\n  margin: 0;\n'],['\n  color: #fff;\n  font-family: Nunito;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 150% */\n  min-width: 160px;\n  margin: 0;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-self: stretch;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-self: stretch;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  height: 50px;\n  padding-inline: 20px;\n  align-items: center;\n  gap: 4px;\n  align-self: stretch;\n  border-bottom: 1px solid #ececec;\n\n  h1 {\n    padding: 12px 0px;\n    flex: 1 0 0;\n    margin: 0;\n    align-self: stretch;\n    color: #1d1e22;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n  }\n\n  @media screen and (min-width: 800px) {\n    padding-inline: 100px;\n  }\n'],['\n  display: flex;\n  height: 50px;\n  padding-inline: 20px;\n  align-items: center;\n  gap: 4px;\n  align-self: stretch;\n  border-bottom: 1px solid #ececec;\n\n  h1 {\n    padding: 12px 0px;\n    flex: 1 0 0;\n    margin: 0;\n    align-self: stretch;\n    color: #1d1e22;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n  }\n\n  @media screen and (min-width: 800px) {\n    padding-inline: 100px;\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 8px 20px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  align-self: stretch;\n  background: linear-gradient(\n      0deg,\n      rgba(147, 193, 62, 0.2) 0%,\n      rgba(147, 193, 62, 0.2) 100%\n    ),\n    #fff;\n  border-bottom: 1px solid #ececec;\n  flex-wrap: wrap;\n\n  > .code {\n    display: flex;\n    padding: 2px 8px;\n    justify-content: center;\n    align-items: center;\n    gap: 4px;\n\n    p {\n      color: #006736;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 20px; /* 150% */\n      margin: 0;\n    }\n\n    p:last-child {\n      font-weight: 700;\n    }\n  }\n\n  @media screen and (min-width: 800px) {\n    padding-inline: 100px;\n  }\n'],['\n  display: flex;\n  padding: 8px 20px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  align-self: stretch;\n  background: linear-gradient(\n      0deg,\n      rgba(147, 193, 62, 0.2) 0%,\n      rgba(147, 193, 62, 0.2) 100%\n    ),\n    #fff;\n  border-bottom: 1px solid #ececec;\n  flex-wrap: wrap;\n\n  > .code {\n    display: flex;\n    padding: 2px 8px;\n    justify-content: center;\n    align-items: center;\n    gap: 4px;\n\n    p {\n      color: #006736;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 20px; /* 150% */\n      margin: 0;\n    }\n\n    p:last-child {\n      font-weight: 700;\n    }\n  }\n\n  @media screen and (min-width: 800px) {\n    padding-inline: 100px;\n  }\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  > svg {\n    width: 36px;\n    height: 36px;\n  }\n'],['\n  > svg {\n    width: 36px;\n    height: 36px;\n  }\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n  align-self: stretch;\n'],['\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n  align-self: stretch;\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 16px 20px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n\n  @media screen and (min-width: 800px) {\n    padding-inline: 100px;\n  }\n'],['\n  display: flex;\n  padding: 16px 20px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n\n  @media screen and (min-width: 800px) {\n    padding-inline: 100px;\n  }\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  align-self: stretch;\n  justify-content: space-between;\n  width: 100%;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #ececec;\n\n  > .title {\n    display: flex;\n    height: 20px;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 4px;\n    align-self: stretch;\n    width: 100%;\n\n    p {\n      color: #3e3e3e;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 20px; /* 142.857% */\n      margin: 0;\n    }\n\n    > div {\n      height: 19px;\n    }\n  }\n\n  > .values {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    gap: 4px;\n    flex: 1 0 0;\n    width: 100%;\n\n    > span {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      align-self: stretch;\n\n      h5 {\n        color: #676767;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 20px;\n        margin: 0;\n      }\n\n      p {\n        color: #1d1e22;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: 20px; /* 142.857% */\n        margin: 0;\n      }\n    }\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  align-self: stretch;\n  justify-content: space-between;\n  width: 100%;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #ececec;\n\n  > .title {\n    display: flex;\n    height: 20px;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 4px;\n    align-self: stretch;\n    width: 100%;\n\n    p {\n      color: #3e3e3e;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 20px; /* 142.857% */\n      margin: 0;\n    }\n\n    > div {\n      height: 19px;\n    }\n  }\n\n  > .values {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    gap: 4px;\n    flex: 1 0 0;\n    width: 100%;\n\n    > span {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      align-self: stretch;\n\n      h5 {\n        color: #676767;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 20px;\n        margin: 0;\n      }\n\n      p {\n        color: #1d1e22;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: 20px; /* 142.857% */\n        margin: 0;\n      }\n    }\n  }\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column-reverse;\n  padding: 16px 20px;\n  align-items: center;\n  gap: 12px;\n  align-self: stretch;\n  border-top: 1px solid #ececec;\n\n  @media screen and (min-width: 500px) {\n    flex-direction: row;\n  }\n\n  @media screen and (min-width: 800px) {\n    padding-inline: 100px;\n  }\n'],['\n  display: flex;\n  flex-direction: column-reverse;\n  padding: 16px 20px;\n  align-items: center;\n  gap: 12px;\n  align-self: stretch;\n  border-top: 1px solid #ececec;\n\n  @media screen and (min-width: 500px) {\n    flex-direction: row;\n  }\n\n  @media screen and (min-width: 800px) {\n    padding-inline: 100px;\n  }\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-self: stretch;\n  gap: 10px;\n  height: 40px;\n  padding: 10px;\n  border-bottom: ',';\n  background: #fff;\n  text-decoration: none;\n\n  cursor: pointer;\n\n  p {\n    flex: 1 0 0;\n    color: var(--Gray, #3e3e3e);\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n  }\n'],['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-self: stretch;\n  gap: 10px;\n  height: 40px;\n  padding: 10px;\n  border-bottom: ',';\n  background: #fff;\n  text-decoration: none;\n\n  cursor: pointer;\n\n  p {\n    flex: 1 0 0;\n    color: var(--Gray, #3e3e3e);\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n  }\n']);var MyTarifMobileSectionV2=function(_Component){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(MyTarifMobileSectionV2,_Component);function MyTarifMobileSectionV2(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,MyTarifMobileSectionV2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=MyTarifMobileSectionV2.__proto__||Object.getPrototypeOf(MyTarifMobileSectionV2)).call.apply(_ref,[this].concat(args))),_this),_this.state={shareUrl:''+window.location.origin+window.location.pathname+'?code='+_this.props.simulationCode,shareContent:'Veja a minha simulação em'},_temp),__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(MyTarifMobileSectionV2,[{key:'renderDataModal',value:function renderDataModal(){var _props=this.props,dataModal=_props.dataModal,toggleDataModal=_props.toggleDataModal;return dataModal?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__EditDataModalV2_mobile__["a" /* default */],Object.assign({},this.props,{onClose:toggleDataModal,setModalTriggerHeight:this.props.setModalTriggerHeight,modalTriggerHeight:this.props.modalTriggerHeight})):null;}},{key:'renderContent',value:function renderContent(hasSimulation,content){var aditionalCondition=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;return hasSimulation&&aditionalCondition?content:null;}/** Lonely boy */},{key:'render',value:function render(){var _props2=this.props,hasSimulation=_props2.hasSimulation,annualBilling=_props2.annualBilling,electricityPriceList=_props2.electricityPriceList,electricityConsumption=_props2.electricityConsumption,gasPriceList=_props2.gasPriceList,gasConsumption=_props2.gasConsumption,simulationCode=_props2.simulationCode,prices=_props2.prices,code=_props2.code,router=_props2.router,className=_props2.className,toggleDataModal=_props2.toggleDataModal,restProps=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2,['hasSimulation','annualBilling','electricityPriceList','electricityConsumption','gasPriceList','gasConsumption','simulationCode','prices','code','router','className','toggleDataModal']);return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Wrapper,Object.assign({className:className},restProps),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(HeaderRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h1',null,'O meu Tarif\xE1rio'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ShareWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__DropdownGhostV2__["a" /* default */],{titleArea:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ShareButtonV2__["a" /* default */],null)},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{style:{width:'186px',border:'1px solid #ECECEC'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ShareBtn,{href:'https://wa.me/?text='+encodeURIComponent(this.state.shareContent)+' '+encodeURIComponent(''+window.location.origin+window.location.pathname+'?code='+this.props.simulationCode),target:'_blank',rel:'noopener','aria-label':''},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__images_ic_whatsapp_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p',null,'Whatsapp')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ShareBtn,{href:'https://facebook.com/sharer/sharer.php?u='+encodeURIComponent(''+window.location.origin+window.location.pathname+'?code='+this.props.simulationCode)+'&quote='+encodeURIComponent(this.state.shareContent),target:'_blank',rel:'noopener','aria-label':''},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__images_ic_facebook_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p',null,'Facebook')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ShareBtn,{href:'https://twitter.com/intent/tweet/?text='+encodeURIComponent(this.state.shareContent)+'&url='+encodeURIComponent(''+window.location.origin+window.location.pathname+'?code='+this.props.simulationCode),target:'_blank',rel:'noopener','aria-label':''},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__images_ic_x_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p',null,'X')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ShareBtn,{noBorder:true,href:'mailto:?subject='+encodeURIComponent('Simulação')+'&body='+encodeURIComponent(this.state.shareContent+' '+window.location.origin+window.location.pathname+'?code='+this.props.simulationCode),target:'_blank',rel:'noopener','aria-label':''},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__images_ic_mail_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p',null,'Mail')))))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SimulationCodeRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(VectorWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__images_ic_house_component_svg___default.a,null)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'code'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p',null,'simula\xE7\xE3o'),this.renderContent(hasSimulation,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p',null,'#',code)))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DetailsContent,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'title'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__images_ic_result_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p',null,'Fatura'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__TooltipV2__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TooltipText,null,'Valores aproximados m\xE9dios'),arrowLocation:'topLeft'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__images_ic_info_component_svg___default.a,null))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'values'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h5',null,'Custo Anual'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p',null,annualBilling&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_utils__["i" /* unitCurrency */])(annualBilling),'\u20AC')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h5',null,'Custo Mensal'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p',null,annualBilling&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_utils__["i" /* unitCurrency */])(annualBilling/12),'\u20AC')))),this.renderContent(hasSimulation,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__EnergyDetailsV2__["a" /* default */],Object.assign({energyType:'electricity'},this.props)),electricityPriceList),this.renderContent(hasSimulation,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__EnergyDetailsV2__["a" /* default */],Object.assign({border:false,energyType:'gas'},this.props)),gasPriceList)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(BtnsWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__ButtonOutlineV2__["a" /* default */],{onClick:function onClick(){return window.open('https://www.poupaenergia.pt/fatura-energia/','_blank','noopener,noreferrer');},icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__images_ic_see_component_svg___default.a,null)},'Como Ler a Fatura'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__TooltipV2__["a" /* default */],{style:{width:'100%'},contentStyle:{minWidth:'200px'},dialogStyle:{marginTop:'10px'},content:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TooltipText,null,'Clique para atualizar os valores da sua simula\xE7\xE3o com a possibilidade de inserir os dados da sua fatura.'),arrowLocation:'topLeft'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ButtonGradientV2__["a" /* default */],{setModalTriggerHeight:this.props.setModalTriggerHeight,onClick:toggleDataModal,icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__images_ic_edit_component_svg___default.a,null)},'Ajustar Valores'))),this.renderDataModal());}}]);return MyTarifMobileSectionV2;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);var TooltipText=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].h6(_templateObject);var Wrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject2);var HeaderRow=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject3);var SimulationCodeRow=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject4);var VectorWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject5);var ShareWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject6);var DetailsContent=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject7);var Detail=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject8);var BtnsWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject9);var ShareBtn=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].a(_templateObject10,function(_ref2){var noBorder=_ref2.noBorder;return noBorder?'none':'1px solid #ECECEC';});

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MyTarifSectionV2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_ic_arrow_back_component_svg__ = __webpack_require__(1639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_ic_arrow_back_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_ic_arrow_back_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_ic_result_component_svg__ = __webpack_require__(1641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_ic_result_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_ic_result_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_home_illustration_component_svg__ = __webpack_require__(1638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_home_illustration_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_home_illustration_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_ic_see_component_svg__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_ic_see_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_ic_see_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_ic_edit_component_svg__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_ic_edit_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__images_ic_edit_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_ic_whatsapp_component_svg__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_ic_whatsapp_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_ic_whatsapp_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_ic_facebook_component_svg__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_ic_facebook_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__images_ic_facebook_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_ic_x_component_svg__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_ic_x_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__images_ic_x_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_ic_mail_component_svg__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_ic_mail_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__images_ic_mail_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_car_line_component_svg__ = __webpack_require__(1635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_car_line_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__images_car_line_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_energy_line_component_svg__ = __webpack_require__(1636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_energy_line_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__images_energy_line_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_gas_line_component_svg__ = __webpack_require__(1637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_gas_line_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__images_gas_line_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__images_ic_info_component_svg__ = __webpack_require__(1640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__images_ic_info_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__images_ic_info_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ShareButtonV2__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ButtonOutlineV2__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ButtonGradientV2__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__EnergyDetailsV2__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__DropdownGhostV2__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__TooltipV2__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__EditDataModalV2__ = __webpack_require__(850);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #fff;\n  font-family: Nunito;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 150% */\n  min-width: 160px;\n  margin: 0;\n'],['\n  color: #fff;\n  font-family: Nunito;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 150% */\n  min-width: 160px;\n  margin: 0;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 1 0 0;\n  position: relative;\n'],['\n  flex: 1 0 0;\n  position: relative;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: absolute;\n  top: 17%;\n  left: 9%;\n'],['\n  position: absolute;\n  top: 17%;\n  left: 9%;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: absolute;\n  right: 14%;\n  top: 30%;\n'],['\n  position: absolute;\n  right: 14%;\n  top: 30%;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: absolute;\n  top: 0;\n  right: 27%;\n'],['\n  position: absolute;\n  top: 0;\n  right: 27%;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 24px 20px;\n  flex-direction: column;\n  align-items: flex-start;\n  background: #fff;\n  max-width: 1200px;\n  margin-inline: auto;\n\n  @media screen and (min-width: 1300px) {\n    padding-inline: 0px;\n  }\n'],['\n  display: flex;\n  padding: 24px 20px;\n  flex-direction: column;\n  align-items: flex-start;\n  background: #fff;\n  max-width: 1200px;\n  margin-inline: auto;\n\n  @media screen and (min-width: 1300px) {\n    padding-inline: 0px;\n  }\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  display: flex;\n  padding: 12px 16px;\n  align-items: center;\n  justify-content: space-between;\n'],['\n  width: 100%;\n  display: flex;\n  padding: 12px 16px;\n  align-items: center;\n  justify-content: space-between;\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1 0 0;\n  align-self: stretch;\n\n  svg {\n    cursor: pointer;\n  }\n\n  h1 {\n    color: #1d1e22;\n    font-family: Nunito;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px; /* 133.333% */\n    margin: 0;\n  }\n\n  span {\n    display: flex;\n    padding: 2px 8px;\n    justify-content: center;\n    align-items: center;\n    gap: 4px;\n    background: linear-gradient(\n        0deg,\n        rgba(147, 193, 62, 0.1) 0%,\n        rgba(147, 193, 62, 0.1) 100%\n      ),\n      #fff;\n\n    p {\n      color: #006736;\n      font-feature-settings: \'liga\' off, \'clig\' off;\n      font-family: Nunito;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 18px; /* 150% */\n      margin: 0;\n    }\n\n    p:last-child {\n      font-weight: 700;\n    }\n  }\n'],['\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1 0 0;\n  align-self: stretch;\n\n  svg {\n    cursor: pointer;\n  }\n\n  h1 {\n    color: #1d1e22;\n    font-family: Nunito;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px; /* 133.333% */\n    margin: 0;\n  }\n\n  span {\n    display: flex;\n    padding: 2px 8px;\n    justify-content: center;\n    align-items: center;\n    gap: 4px;\n    background: linear-gradient(\n        0deg,\n        rgba(147, 193, 62, 0.1) 0%,\n        rgba(147, 193, 62, 0.1) 100%\n      ),\n      #fff;\n\n    p {\n      color: #006736;\n      font-feature-settings: \'liga\' off, \'clig\' off;\n      font-family: Nunito;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 18px; /* 150% */\n      margin: 0;\n    }\n\n    p:last-child {\n      font-weight: 700;\n    }\n  }\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n  align-self: stretch;\n'],['\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n  align-self: stretch;\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 16px 16px 0px 16px;\n  align-items: flex-start;\n  gap: 24px;\n  flex: 1 0 0;\n  align-self: stretch;\n'],['\n  display: flex;\n  padding: 16px 16px 0px 16px;\n  align-items: flex-start;\n  gap: 24px;\n  flex: 1 0 0;\n  align-self: stretch;\n']),_templateObject11=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  gap: 16px;\n'],['\n  display: flex;\n  align-items: center;\n  gap: 16px;\n']),_templateObject12=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 12px 16px 12px 0px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 4px;\n  align-self: stretch;\n  border-right: 1px solid #ececec;\n\n  > span:first-child {\n    display: flex;\n    height: 20px;\n    align-items: center;\n    gap: 4px;\n    align-self: stretch;\n\n    p {\n      color: #3e3e3e;\n      font-feature-settings: \'liga\' off, \'clig\' off;\n      font-family: Nunito;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 20px;\n      margin: 0;\n\n      b {\n        font-weight: 400;\n      }\n    }\n\n    > div {\n      height: 19px;\n    }\n  }\n'],['\n  display: flex;\n  padding: 12px 16px 12px 0px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 4px;\n  align-self: stretch;\n  border-right: 1px solid #ececec;\n\n  > span:first-child {\n    display: flex;\n    height: 20px;\n    align-items: center;\n    gap: 4px;\n    align-self: stretch;\n\n    p {\n      color: #3e3e3e;\n      font-feature-settings: \'liga\' off, \'clig\' off;\n      font-family: Nunito;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 20px;\n      margin: 0;\n\n      b {\n        font-weight: 400;\n      }\n    }\n\n    > div {\n      height: 19px;\n    }\n  }\n']),_templateObject13=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 2px;\n  align-self: stretch;\n'],['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 2px;\n  align-self: stretch;\n']),_templateObject14=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n  gap: 10px;\n\n  p,\n  h3 {\n    margin: 0;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 14px;\n    font-style: normal;\n    line-height: 20px; /* 142.857% */\n    font-weight: 400;\n  }\n\n  p {\n    color: #676767;\n  }\n\n  h3 {\n    color: #1d1e22;\n    font-weight: 700;\n  }\n'],['\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n  gap: 10px;\n\n  p,\n  h3 {\n    margin: 0;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 14px;\n    font-style: normal;\n    line-height: 20px; /* 142.857% */\n    font-weight: 400;\n  }\n\n  p {\n    color: #676767;\n  }\n\n  h3 {\n    color: #1d1e22;\n    font-weight: 700;\n  }\n']),_templateObject15=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 12px;\n  height: 100%;\n  flex-grow: 1;\n  max-width: 220px;\n  margin-left: auto;\n'],['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 12px;\n  height: 100%;\n  flex-grow: 1;\n  max-width: 220px;\n  margin-left: auto;\n']),_templateObject16=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-self: stretch;\n  gap: 10px;\n  height: 40px;\n  padding: 10px;\n  border-bottom: ',';\n  background: #fff;\n  text-decoration: none;\n\n  cursor: pointer;\n\n  p {\n    flex: 1 0 0;\n    color: var(--Gray, #3e3e3e);\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n  }\n'],['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-self: stretch;\n  gap: 10px;\n  height: 40px;\n  padding: 10px;\n  border-bottom: ',';\n  background: #fff;\n  text-decoration: none;\n\n  cursor: pointer;\n\n  p {\n    flex: 1 0 0;\n    color: var(--Gray, #3e3e3e);\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n  }\n']);var MyTarifSectionV2=function(_Component){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(MyTarifSectionV2,_Component);function MyTarifSectionV2(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,MyTarifSectionV2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=MyTarifSectionV2.__proto__||Object.getPrototypeOf(MyTarifSectionV2)).call.apply(_ref,[this].concat(args))),_this),_this.state={shareUrl:''+window.location.origin+window.location.pathname+'?code='+_this.props.code,shareContent:'Veja a minha simulação em'},_this.handleChangeSimulationData=function(){var _this$props=_this.props,router=_this$props.router,changeSimulationData=_this$props.changeSimulationData,resetFilters=_this$props.resetFilters,setSearchQuery=_this$props.setSearchQuery;resetFilters();setSearchQuery('');changeSimulationData();router.push('/');},_temp),__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(MyTarifSectionV2,[{key:'renderDataModal',value:function renderDataModal(){var _props=this.props,dataModal=_props.dataModal,toggleDataModal=_props.toggleDataModal;return dataModal?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__EditDataModalV2__["a" /* default */],Object.assign({},this.props,{onClose:toggleDataModal,modalTriggerHeight:this.props.modalTriggerHeight,setModalTriggerHeight:this.props.setModalTriggerHeight})):null;}},{key:'renderContent',value:function renderContent(hasSimulation,content){var aditionalCondition=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;return hasSimulation&&aditionalCondition?content:null;}},{key:'render',value:function render(){var _props2=this.props,hasSimulation=_props2.hasSimulation,annualBilling=_props2.annualBilling,electricityPriceList=_props2.electricityPriceList,electricityConsumption=_props2.electricityConsumption,gasPriceList=_props2.gasPriceList,gasConsumption=_props2.gasConsumption,simulationCode=_props2.simulationCode,prices=_props2.prices,code=_props2.code,className=_props2.className,toggleDataModal=_props2.toggleDataModal,simulationValues=_props2.simulationValues,restProps=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2,['hasSimulation','annualBilling','electricityPriceList','electricityConsumption','gasPriceList','gasConsumption','simulationCode','prices','code','className','toggleDataModal','simulationValues']);return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Wrapper,Object.assign({className:className},restProps),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TitleRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TitleLeft,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__images_ic_arrow_back_component_svg___default.a,{onClick:this.handleChangeSimulationData}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h1',null,'O meu Tarif\xE1rio'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p',null,'simula\xE7\xE3o'),this.renderContent(hasSimulation,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p',null,code)))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ShareWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__DropdownGhostV2__["a" /* default */],{titleArea:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__ShareButtonV2__["a" /* default */],{title:'Partilhar'})},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{style:{width:'186px',border:'1px solid #ECECEC'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ShareBtn,{href:'https://wa.me/?text='+encodeURIComponent(this.state.shareContent)+' '+encodeURIComponent(''+window.location.origin+window.location.pathname+'?code='+this.props.code),target:'_blank',rel:'noopener','aria-label':''},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__images_ic_whatsapp_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p',null,'Whatsapp')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ShareBtn,{href:'https://facebook.com/sharer/sharer.php?u='+encodeURIComponent(''+window.location.origin+window.location.pathname+'?code='+this.props.code)+'&quote='+encodeURIComponent(this.state.shareContent),target:'_blank',rel:'noopener','aria-label':''},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__images_ic_facebook_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p',null,'Facebook')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ShareBtn,{href:'https://twitter.com/intent/tweet/?text='+encodeURIComponent(this.state.shareContent)+'&url='+encodeURIComponent(''+window.location.origin+window.location.pathname+'?code='+this.props.code),target:'_blank',rel:'noopener','aria-label':''},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__images_ic_x_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p',null,'X')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ShareBtn,{noBorder:true,href:'mailto:?subject='+encodeURIComponent('Simulação')+'&body='+encodeURIComponent(this.state.shareContent+' '+window.location.origin+window.location.pathname+'?code='+this.props.code),target:'_blank',rel:'noopener','aria-label':''},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__images_ic_mail_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p',null,'Mail')))))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Content,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InvoiceSection,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(VectorWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__images_home_illustration_component_svg___default.a,null),simulationValues.hasElectricCar?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(VectorCarLine,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__images_car_line_component_svg___default.a,null)):null,simulationValues.hasNaturalGasHeating?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(VectorGasLine,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__images_gas_line_component_svg___default.a,null)):null,simulationValues.hasSolarSystem?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(VectorEnergyLine,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__images_energy_line_component_svg___default.a,null)):null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InvoiceDetails,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__images_ic_result_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p',null,'Fatura'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__TooltipV2__["a" /* default */],{content:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TooltipText,null,'Valores aproximados m\xE9dios'),arrowLocation:'topLeft'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__images_ic_info_component_svg___default.a,{width:14,height:14}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Details,null,this.renderContent(hasSimulation,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p',null,'Custo Mensal'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h3',null,annualBilling&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_utils__["i" /* unitCurrency */])(annualBilling/12),'\u20AC'))),this.renderContent(hasSimulation,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Detail,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p',null,'Custo Anual'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h3',null,annualBilling&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_utils__["i" /* unitCurrency */])(annualBilling),'\u20AC')))))),this.renderContent(hasSimulation,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__EnergyDetailsV2__["a" /* default */],Object.assign({energyType:'electricity'},this.props)),electricityPriceList),this.renderContent(hasSimulation,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__EnergyDetailsV2__["a" /* default */],Object.assign({energyType:'gas'},this.props)),gasPriceList),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(BtnsWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__ButtonOutlineV2__["a" /* default */],{onClick:function onClick(){window.open('https://www.poupaenergia.pt/fatura-energia/','_blank','noopener,noreferrer');},icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__images_ic_see_component_svg___default.a,null)},'Como ler a fatura'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__TooltipV2__["a" /* default */],{style:{width:'100%'},contentStyle:{minWidth:'220px'},dialogStyle:{marginTop:'10px'},content:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TooltipText,null,'Clique para atualizar os valores da sua simula\xE7\xE3o com a possibilidade de inserir os dados da sua fatura.'),arrowLocation:'topLeft'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__ButtonGradientV2__["a" /* default */],{setModalTriggerHeight:this.props.setModalTriggerHeight,onClick:toggleDataModal,icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__images_ic_edit_component_svg___default.a,null)},'Ajustar Valores')))),this.renderDataModal());}}]);return MyTarifSectionV2;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);var TooltipText=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].h6(_templateObject);var VectorWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject2);var VectorCarLine=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject3);var VectorGasLine=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject4);var VectorEnergyLine=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject5);var Wrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject6);var TitleRow=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject7);var TitleLeft=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject8);var ShareWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject9);var Content=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject10);var InvoiceSection=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject11);var InvoiceDetails=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject12);var Details=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject13);var Detail=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject14);var BtnsWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject15);var ShareBtn=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].a(_templateObject16,function(_ref2){var noBorder=_ref2.noBorder;return noBorder?'none':'1px solid #ECECEC';});

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ic_search_svg__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ic_search_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ic_search_svg__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  padding: 20vh 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'],['\n  width: 100%;\n  padding: 20vh 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 40px;\n  height: 40px;\n  margin-right: 10px;\n'],['\n  width: 40px;\n  height: 40px;\n  margin-right: 10px;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #bababa;\n  font-size: 20px;\n  line-height: 28px;\n'],['\n  color: #bababa;\n  font-size: 20px;\n  line-height: 28px;\n']);var NoResults=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NoResults,_Component);function NoResults(){__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,NoResults);return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(NoResults.__proto__||Object.getPrototypeOf(NoResults)).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(NoResults,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Img,{src:__WEBPACK_IMPORTED_MODULE_7__ic_search_svg___default.a,alt:'Selecione os filtros..'}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Text,null,'N\xE3o foram encontrados tarif\xE1rios para a sua pesquisa'));}}]);return NoResults;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NoResults);var Wrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject);var Img=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].img(_templateObject2);var Text=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].p(_templateObject3);

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ic_search_component_svg__ = __webpack_require__(1642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ic_search_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ic_search_component_svg__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 32px;\n  gap: 16px;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 32px;\n  gap: 16px;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  overflow: hidden;\n  color: #1d1e22;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  text-overflow: ellipsis;\n  font-family: Nunito;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px; /* 133.333% */\n  letter-spacing: 1px;\n  margin: 0;\n  text-transform: unset;\n'],['\n  overflow: hidden;\n  color: #1d1e22;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  text-overflow: ellipsis;\n  font-family: Nunito;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px; /* 133.333% */\n  letter-spacing: 1px;\n  margin: 0;\n  text-transform: unset;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  overflow: hidden;\n  color: #3e3e3e;\n  text-align: center;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  text-overflow: ellipsis;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n  margin: 0;\n'],['\n  overflow: hidden;\n  color: #3e3e3e;\n  text-align: center;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  text-overflow: ellipsis;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n  margin: 0;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  align-self: stretch;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  align-self: stretch;\n']);var NoResultsV2=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NoResultsV2,_Component);function NoResultsV2(){__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,NoResultsV2);return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(NoResultsV2.__proto__||Object.getPrototypeOf(NoResultsV2)).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(NoResultsV2,[{key:'render',value:function render(){var _props=this.props,children=_props.children,title=_props.title,text=_props.text;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ic_search_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Content,null,title&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Title,null,'Sem Resultados Dispon\xEDveis.'),text&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Text,null,'Por favor, tente alterar os dados do seu tarif\xE1rio de forma a visualizar resultados.'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Text,null,'Se precisar de ajuda contacte-nos atrav\xE9s do ',__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('b',null,'211 160 500.'))),children));}}]);return NoResultsV2;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NoResultsV2);var Wrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject);var Title=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].h3(_templateObject2);var Text=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].p(_templateObject3);var Content=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject4);

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ic_navigation_left_svg__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ic_navigation_left_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ic_navigation_left_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ic_navigation_right_svg__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ic_navigation_right_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ic_navigation_right_svg__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);\n  background: white;\n  border-radius: 2px 0 0 2px;\n  height: 55px;\n  display: inline-block;\n  margin: 0 auto;\n  display: inline-flex;\n  justify-content: center;\n\n  @media (max-width: 860px) {\n    height: 48px;\n    width: 100%;\n  }\n'],['\n  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);\n  background: white;\n  border-radius: 2px 0 0 2px;\n  height: 55px;\n  display: inline-block;\n  margin: 0 auto;\n  display: inline-flex;\n  justify-content: center;\n\n  @media (max-width: 860px) {\n    height: 48px;\n    width: 100%;\n  }\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 55px;\n  height: 100%;\n  text-align: center;\n  line-height: 55px;\n  color: #9c9c9c;\n  text-decoration: none;\n  display: inline-block;\n  vertical-align: top;\n  outline: none;\n  cursor: pointer;\n\n  ','\n\n  &.current {\n    color: #93c13e;\n    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);\n  }\n\n  @media (max-width: 860px) {\n    width: 48px;\n    line-height: 48px;\n  }\n'],['\n  width: 55px;\n  height: 100%;\n  text-align: center;\n  line-height: 55px;\n  color: #9c9c9c;\n  text-decoration: none;\n  display: inline-block;\n  vertical-align: top;\n  outline: none;\n  cursor: pointer;\n\n  ','\n\n  &.current {\n    color: #93c13e;\n    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);\n  }\n\n  @media (max-width: 860px) {\n    width: 48px;\n    line-height: 48px;\n  }\n']);var Paginator=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Paginator,_Component);function Paginator(){__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,Paginator);var _this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(Paginator.__proto__||Object.getPrototypeOf(Paginator)).call(this));_this.state={currentPage:1,limit:10,offset:0};return _this;}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Paginator,[{key:'componentWillMount',value:function componentWillMount(){this.setState({currentPage:this.props.currentPage});}},{key:'setPage',value:function setPage(page){var _this2=this;this.setState({currentPage:page,offset:(page-1)*this.state.limit},function(){_this2.props.pageChange(_this2.state);});}},{key:'render',value:function render(){var _this3=this;var count=this.props.count;var nextPage=function nextPage(){var next=_this3.state.currentPage+1;if(next<=_this3.maxPages){_this3.setPage(next);}};var prevPage=function prevPage(){var prev=_this3.state.currentPage-1;if(prev>0){_this3.setPage(prev);}};this.maxPages=Math.ceil(count/this.state.limit);return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Page,{isIcon:__WEBPACK_IMPORTED_MODULE_8__ic_navigation_left_svg___default.a,onClick:function onClick(){return prevPage();}}),this.state.currentPage-2>1&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Page,{onClick:function onClick(e){return _this3.setPage(1);}},'1'),this.state.currentPage-2>1&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Page,null,'...'),this.state.currentPage>1&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Page,{onClick:function onClick(e){return _this3.setPage(_this3.state.currentPage-1);}},this.state.currentPage-1),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Page,{className:'current',onClick:function onClick(e){return _this3.setPage(_this3.state.currentPage);}},this.state.currentPage),this.state.currentPage+1<=this.maxPages&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Page,{onClick:function onClick(e){return _this3.setPage(_this3.state.currentPage+1);}},this.state.currentPage+1),this.state.currentPage+2<this.maxPages&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Page,null,'...'),this.state.currentPage+2<this.maxPages&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Page,{onClick:function onClick(e){return _this3.setPage(_this3.maxPages);}},this.maxPages),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Page,{isIcon:__WEBPACK_IMPORTED_MODULE_9__ic_navigation_right_svg___default.a,onClick:function onClick(){return nextPage();}}));}}]);return Paginator;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);Paginator.propTypes={pageChange:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,count:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number};var Container=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject);var Page=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject2,function(_ref){var isIcon=_ref.isIcon;return isIcon&&'\n   background: url('+isIcon+') no-repeat;\n   background-position: center;\n ';});/* harmony default export */ __webpack_exports__["a"] = (Paginator);

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ic_left_component_svg__ = __webpack_require__(1643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ic_left_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ic_left_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ic_right_component_svg__ = __webpack_require__(1644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ic_right_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ic_right_component_svg__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  border-radius: 2px 0 0 2px;\n  height: 55px;\n  display: inline-block;\n  margin: 0 auto;\n  display: inline-flex;\n  justify-content: center;\n\n  @media (max-width: 860px) {\n    height: 48px;\n    width: 100%;\n  }\n'],['\n  border-radius: 2px 0 0 2px;\n  height: 55px;\n  display: inline-block;\n  margin: 0 auto;\n  display: inline-flex;\n  justify-content: center;\n\n  @media (max-width: 860px) {\n    height: 48px;\n    width: 100%;\n  }\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 55px;\n  height: 100%;\n  text-align: center;\n\n  cursor: pointer;\n\n  color: #9c9c9c;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n\n  &.current {\n    color: #006736;\n  }\n\n  @media (max-width: 860px) {\n    width: 48px;\n    line-height: 48px;\n  }\n'],['\n  width: 55px;\n  height: 100%;\n  text-align: center;\n\n  cursor: pointer;\n\n  color: #9c9c9c;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n\n  &.current {\n    color: #006736;\n  }\n\n  @media (max-width: 860px) {\n    width: 48px;\n    line-height: 48px;\n  }\n']);var Paginator=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Paginator,_Component);function Paginator(){__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,Paginator);var _this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(Paginator.__proto__||Object.getPrototypeOf(Paginator)).call(this));_this.state={currentPage:1,limit:10,offset:0};return _this;}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Paginator,[{key:'componentWillMount',value:function componentWillMount(){this.setState({currentPage:this.props.currentPage});}},{key:'setPage',value:function setPage(page){var _this2=this;this.setState({currentPage:page,offset:(page-1)*this.state.limit},function(){_this2.props.pageChange(_this2.state);});}},{key:'render',value:function render(){var _this3=this;var count=this.props.count;var nextPage=function nextPage(){var next=_this3.state.currentPage+1;if(next<=_this3.maxPages){_this3.setPage(next);}};var prevPage=function prevPage(){var prev=_this3.state.currentPage-1;if(prev>0){_this3.setPage(prev);}};this.maxPages=Math.ceil(count/this.state.limit);return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Page,{onClick:function onClick(){return prevPage();}},' ',__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ic_left_component_svg___default.a,null),' '),this.state.currentPage-2>1&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Page,{onClick:function onClick(e){return _this3.setPage(1);}},'1'),this.state.currentPage-2>1&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Page,null,'...'),this.state.currentPage>1&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Page,{onClick:function onClick(e){return _this3.setPage(_this3.state.currentPage-1);}},this.state.currentPage-1),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Page,{className:'current',onClick:function onClick(e){return _this3.setPage(_this3.state.currentPage);}},this.state.currentPage),this.state.currentPage+1<=this.maxPages&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Page,{onClick:function onClick(e){return _this3.setPage(_this3.state.currentPage+1);}},this.state.currentPage+1),this.state.currentPage+2<this.maxPages&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Page,null,'...'),this.state.currentPage+2<this.maxPages&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Page,{onClick:function onClick(e){return _this3.setPage(_this3.maxPages);}},this.maxPages),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Page,{onClick:function onClick(){return nextPage();}},' ',__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ic_right_component_svg___default.a,null),' '));}}]);return Paginator;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);Paginator.propTypes={pageChange:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,count:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number};var Container=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject);var Page=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject2);/* harmony default export */ __webpack_exports__["a"] = (Paginator);

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display:block;\n  font-family: \'Nunito\', \'Helvetica Neue\', sans-serif;\n  text-transform: none;\n  ','\n  ','\n  ','\n  ','\n  ','\n'],['\n  display:block;\n  font-family: \'Nunito\', \'Helvetica Neue\', sans-serif;\n  text-transform: none;\n  ','\n  ','\n  ','\n  ','\n  ','\n']);var Paragraph=function Paragraph(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledParagraph,props,props.children);};/* harmony default export */ __webpack_exports__["a"] = (Paragraph);var StyledParagraph=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].p(_templateObject,function(_ref){var color=_ref.color;return color?'color: '+color+';':'color: #010101;';},function(_ref2){var fontSize=_ref2.fontSize;return fontSize?'font-size: '+fontSize+';':'font-size: 12px;';},function(_ref3){var fontWeight=_ref3.fontWeight;return fontWeight?'font-weight: '+fontWeight+';':'font-weight: bold;';},function(_ref4){var lineHeight=_ref4.lineHeight;return lineHeight?'line-height: '+lineHeight+';':'line-height: 12px;';},function(_ref5){var align=_ref5.align;return align?'text-align: '+align+';':'text-align: center;';});

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Svg_logo_component_svg__ = __webpack_require__(1652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Svg_logo_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_Svg_logo_component_svg__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin: 0 auto;\n  display: block;\n  border: 0;\n  background: none;\n  margin-top: 30px;\n  max-width: 85px;\n  outline: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  &:hover {\n    transform: scale(1.04535);\n  }\n'],['\n  margin: 0 auto;\n  display: block;\n  border: 0;\n  background: none;\n  margin-top: 30px;\n  max-width: 85px;\n  outline: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  &:hover {\n    transform: scale(1.04535);\n  }\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #3e3e3e;\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: bold;\n  text-align: center;\n  display: block;\n  margin: 10px 0;\n  text-transform: uppercase;\n'],['\n  color: #3e3e3e;\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: bold;\n  text-align: center;\n  display: block;\n  margin: 10px 0;\n  text-transform: uppercase;\n']);var PlusButton=function PlusButton(_ref){var text=_ref.text,_onClick=_ref.onClick;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Wrapper,{onClick:function onClick(){return _onClick();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Svg_logo_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Span,null,text));};/* harmony default export */ __webpack_exports__["a"] = (PlusButton);var Wrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].button(_templateObject);var Span=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject2);

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Loading__ = __webpack_require__(30);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: inline-block;\n  width: 100%;\n'],['\n  display: inline-block;\n  width: 100%;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  text-align: left;\n  color: #676767;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 14px;\n'],['\n  display: block;\n  text-align: left;\n  color: #676767;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 14px;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin-top: 8px;\n  display: flex;\n'],['\n  margin-top: 8px;\n  display: flex;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  border: 1px solid #dedede;\n  background-color: #ffffff;\n  padding: 13px 12px;\n  box-sizing: border-box;\n  height: 40px;\n  color: #3e3e3e;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 14px;\n  margin-right: 8px;\n  outline: none;\n\n  &:focus {\n    border-color: #93c13e;\n  }\n'],['\n  border: 1px solid #dedede;\n  background-color: #ffffff;\n  padding: 13px 12px;\n  box-sizing: border-box;\n  height: 40px;\n  color: #3e3e3e;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 14px;\n  margin-right: 8px;\n  outline: none;\n\n  &:focus {\n    border-color: #93c13e;\n  }\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background-color: #676767;\n  border: none;\n  height: 40px;\n  color: #ffffff;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 14px;\n  padding: 0 16px;\n  cursor: pointer;\n'],['\n  background-color: #676767;\n  border: none;\n  height: 40px;\n  color: #ffffff;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 14px;\n  padding: 0 16px;\n  cursor: pointer;\n']);var PostalInput=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PostalInput,_Component);function PostalInput(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,PostalInput);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=PostalInput.__proto__||Object.getPrototypeOf(PostalInput)).call.apply(_ref,[this].concat(args))),_this),_this.state={ext:'',code:'',focus:''},_this.changeCode=function(code){_this.setState({code:code},function(){_this.props.changeCode&&_this.props.changeCode(code);});},_this.changeExt=function(ext){_this.setState({ext:ext},function(){_this.props.changeCode&&_this.props.changeExt(ext);});},_this.search=function(){_this.props.onClick&&_this.props.onClick(_this.state);},_temp),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(PostalInput,[{key:'render',value:function render(){var _this2=this;var onChangeCode=function onChangeCode(event){var re=/^[0-9\b]+$/;if(event.target.value&&!re.test(event.target.value)){return false;}if(event.target.value.length===4){_this2.secondRef&&_this2.secondRef.focus();}_this2.changeCode(event.target.value);};var onChangeExt=function onChangeExt(event){var re=/^[0-9\b]+$/;if(event.target.value&&!re.test(event.target.value)){return false;}if(event.target.value.length===3){_this2.buttonRef&&_this2.buttonRef.focus();}if(!event.target.value.length){_this2.postalRef&&_this2.postalRef.focus();}_this2.changeExt(event.target.value);};return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Label,null,'C\xF3digo postal'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputContainer,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Input,{innerRef:function innerRef(ref){_this2.postalRef=ref;},type:'text',style:{maxWidth:'64px'},value:this.props.code,onChange:function onChange(e){return onChangeCode(e);},maxLength:4,autoComplete:'off'}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Input,{type:'text',innerRef:function innerRef(ref){_this2.secondRef=ref;},style:{maxWidth:'55px'},value:this.props.ext,onChange:function onChange(e){return onChangeExt(e);},maxLength:3,autoComplete:'off'}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Button,{innerRef:function innerRef(ref){_this2.buttonRef=ref;},onClick:this.search},this.props.loading&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Loading__["a" /* default */],{size:'small'}),!this.props.loading&&'Pesquisar morada')));}}]);return PostalInput;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);var Container=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject);var Label=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject2);var InputContainer=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject3);var Input=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].input(_templateObject4);var Button=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].button(_templateObject5);/* harmony default export */ __webpack_exports__["a"] = (PostalInput);

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RatingContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_StarRating__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_ButtonGradientV2__ = __webpack_require__(40);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  width: 100%;\n  padding: 16px;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  width: 100%;\n  padding: 16px;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #1d1e22;\n  font-family: Nunito;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 24px;\n  margin: 0;\n  text-align: left;\n  text-transform: unset;\n  letter-spacing: unset;\n'],['\n  color: #1d1e22;\n  font-family: Nunito;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 24px;\n  margin: 0;\n  text-align: left;\n  text-transform: unset;\n  letter-spacing: unset;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #1d1e22;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 20px;\n'],['\n  color: #1d1e22;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 20px;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n'],['\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #3e3e3e;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n'],['\n  color: #3e3e3e;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  padding: 10px;\n  align-self: stretch;\n  border: 1px solid #ececec;\n\n  color: #3e3e3e;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  resize: vertical;\n\n  &::placeholder {\n    color: #616161;\n  }\n'],['\n  width: 100%;\n  padding: 10px;\n  align-self: stretch;\n  border: 1px solid #ececec;\n\n  color: #3e3e3e;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  resize: vertical;\n\n  &::placeholder {\n    color: #616161;\n  }\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #3e3e3e;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  cursor: pointer;\n'],['\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #3e3e3e;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  cursor: pointer;\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #c00000;\n  font-family: Nunito;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 18px;\n'],['\n  color: #c00000;\n  font-family: Nunito;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 18px;\n']);var RATING_ENDPOINT=__WEBPACK_IMPORTED_MODULE_9_config__["b" /* API_BASE_URL */]+'/public/subscribe-price-list/feedback/';/**
 * Conteúdo do inquérito de avaliação da adesão (rating).
 *
 * Réplica em React do rating.php + main.js (jQuery) do WordPress antigo, para
 * poder ser servido isolado e embebido num iframe do projeto pai.
 *
 * O token e o subscription chegam por props (lidos do URL pelo RatingStandalone)
 * e vão no payload do POST — sem eles não é possível submeter.
 *
 * Props:
 *  - subscription: string (obrigatório para submeter).
 *  - token: string (obrigatório para submeter).
 *  - onSuccess: callback chamado após o POST ter sucesso.
 */var RatingContent=function(_Component){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(RatingContent,_Component);function RatingContent(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,RatingContent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=RatingContent.__proto__||Object.getPrototypeOf(RatingContent)).call.apply(_ref,[this].concat(args))),_this),_this.state={rating_1:0,rating_2:0,rating_3:0,observations:'',authorize:false,loading:false,error:''},_this.setRating=function(key,value){var _this$setState;return _this.setState((_this$setState={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_this$setState,key,value),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_this$setState,'error',''),_this$setState));},_this.validate=function(){var _this$state=_this.state,rating_1=_this$state.rating_1,rating_2=_this$state.rating_2,rating_3=_this$state.rating_3;if(!rating_1||!rating_2||!rating_3){return'Avalie por favor todas as questões.';}return'';},_this.handleSubmit=function(e){e.preventDefault();var _this$props=_this.props,subscription=_this$props.subscription,token=_this$props.token,onSuccess=_this$props.onSuccess;var _this$state2=_this.state,rating_1=_this$state2.rating_1,rating_2=_this$state2.rating_2,rating_3=_this$state2.rating_3,observations=_this$state2.observations,authorize=_this$state2.authorize;var error=_this.validate();if(error){_this.setState({error:error});return;}_this.setState({loading:true,error:''});__WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(RATING_ENDPOINT,{subscription:subscription,feedback_token:token,rating_1:rating_1,rating_2:rating_2,rating_3:rating_3,observations:observations,authorize:authorize}).then(function(){_this.setState({loading:false});onSuccess&&onSuccess();}).catch(function(err){// A API devolve validações em `non_field_errors` (ex.: quando a
// avaliação já foi submetida antes -> "Avaliação já efetuada").
// Mostramos essa mensagem; para qualquer outro erro, uma genérica.
var data=err&&err.response&&err.response.data;var apiMessage=data&&data.non_field_errors&&data.non_field_errors[0];_this.setState({loading:false,error:apiMessage||'Ocorreu um erro tente novamente mais tarde.'});});},_temp),__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}// As 3 avaliações são obrigatórias (comentário e checkbox são opcionais),
// tal como validava o main.js antigo.
__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(RatingContent,[{key:'render',value:function render(){var _this2=this;var _state=this.state,rating_1=_state.rating_1,rating_2=_state.rating_2,rating_3=_state.rating_3,observations=_state.observations,authorize=_state.authorize,loading=_state.loading,error=_state.error;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Form,{onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Title,null,'Avalie o seu pedido de ades\xE3o'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(FixedLabel,null,'Como correu a sua ades\xE3o?'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Question,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_StarRating__["a" /* default */],{name:'rating_1',value:rating_1,onChange:function onChange(v){return _this2.setRating('rating_1',v);}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StarLabel,null,'Tempo de resposta')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Question,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_StarRating__["a" /* default */],{name:'rating_2',value:rating_2,onChange:function onChange(v){return _this2.setRating('rating_2',v);}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StarLabel,null,'Qualidade do atendimento')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Question,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_StarRating__["a" /* default */],{name:'rating_3',value:rating_3,onChange:function onChange(v){return _this2.setRating('rating_3',v);}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StarLabel,null,'Formaliza\xE7\xE3o do contrato')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(FixedLabel,null,'Coment\xE1rio'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TextArea,{rows:'4',value:observations,onChange:function onChange(e){return _this2.setState({observations:e.target.value});},placeholder:'Escreva um coment\xE1rio e ajude-nos a melhorar.'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CheckboxLabel,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('input',{type:'checkbox',checked:authorize,onChange:function onChange(e){return _this2.setState({authorize:e.target.checked});}}),'Autorizo que o meu coment\xE1rio seja divulgado'),error?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ErrorText,null,error):null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_ButtonGradientV2__["a" /* default */],{style:{width:'140px'},type:'submit',disabled:loading},'Submeter'));}}]);return RatingContent;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);var Form=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].form(_templateObject);var Title=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].h3(_templateObject2);var FixedLabel=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].label(_templateObject3);var Question=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject4);var StarLabel=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].span(_templateObject5);var TextArea=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].textarea(_templateObject6);var CheckboxLabel=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].label(_templateObject7);var ErrorText=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].span(_templateObject8);

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = RatingFooter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logo_poupa_energia_footer_png__ = __webpack_require__(1675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logo_poupa_energia_footer_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__logo_poupa_energia_footer_png__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  background: #1e1e1e;\n  color: #cfcfcf;\n'],['\n  width: 100%;\n  background: #1e1e1e;\n  color: #cfcfcf;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  flex-wrap: wrap;\n'],['\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  flex-wrap: wrap;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 40px;\n  width: auto;\n  display: block;\n'],['\n  height: 40px;\n  width: auto;\n  display: block;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: wrap;\n'],['\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: wrap;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #cfcfcf;\n  text-decoration: none;\n\n  &:hover {\n    color: #fff;\n  }\n'],['\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #cfcfcf;\n  text-decoration: none;\n\n  &:hover {\n    color: #fff;\n  }\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border: 1px solid #6b6b6b;\n\n  svg path {\n    fill: currentColor;\n  }\n'],['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border: 1px solid #6b6b6b;\n\n  svg path {\n    fill: currentColor;\n  }\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 400;\n'],['\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 400;\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  border-top: 1px solid #333;\n  padding: 12px 24px;\n  font-family: Nunito;\n  font-size: 13px;\n  color: #9a9a9a;\n  text-align: center;\n  width: 100%;\n'],['\n  border-top: 1px solid #333;\n  padding: 12px 24px;\n  font-family: Nunito;\n  font-size: 13px;\n  color: #9a9a9a;\n  text-align: center;\n  width: 100%;\n']);/**
 * Rodapé da página de avaliação (versão super resumida do footer do portal).
 *
 * Ao contrário do footer.html completo (dezenas de links), aqui só temos:
 *  - o logo Poupa Energia à esquerda;
 *  - os links/ícones das redes sociais à direita;
 *  - uma barra inferior com "© ADENE {ano}".
 */var SOCIALS=[{label:'Facebook',href:'https://www.facebook.com/agenciaparaaenergia',icon:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M13.5 21v-8h2.7l.4-3.1h-3.1V7.9c0-.9.25-1.5 1.55-1.5h1.65V3.6c-.3-.04-1.3-.13-2.45-.13-2.42 0-4.08 1.48-4.08 4.2v2.34H7.5V13h2.67v8h3.33z'})},{label:'Instagram',href:'https://www.instagram.com/adene.pt/',icon:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M12 7.2A4.8 4.8 0 1 0 12 16.8 4.8 4.8 0 0 0 12 7.2zm0 7.9a3.1 3.1 0 1 1 0-6.2 3.1 3.1 0 0 1 0 6.2zm4.9-8.1a1.1 1.1 0 1 1-2.2 0 1.1 1.1 0 0 1 2.2 0zM20 6.9c-.05-1.5-.4-2.85-1.5-3.94C17.4 1.86 16.06 1.5 14.56 1.45c-1.55-.09-6.2-.09-7.74 0C5.33 1.5 3.99 1.85 2.9 2.95 1.8 4.04 1.45 5.39 1.4 6.89c-.09 1.55-.09 6.2 0 7.75.05 1.5.4 2.84 1.5 3.94 1.09 1.1 2.43 1.45 3.93 1.5 1.55.09 6.19.09 7.74 0 1.5-.05 2.84-.4 3.94-1.5 1.1-1.1 1.45-2.44 1.5-3.94.09-1.55.09-6.19 0-7.74zm-2.03 9.4a3.14 3.14 0 0 1-1.77 1.77c-1.22.49-4.13.37-5.48.37-1.36 0-4.27.11-5.49-.37a3.14 3.14 0 0 1-1.77-1.77c-.48-1.22-.37-4.13-.37-5.49 0-1.35-.11-4.26.37-5.48A3.14 3.14 0 0 1 6.51 3.53c1.22-.48 4.13-.37 5.49-.37 1.35 0 4.26-.11 5.48.37a3.14 3.14 0 0 1 1.77 1.77c.49 1.22.37 4.13.37 5.48 0 1.36.12 4.27-.37 5.49z'})},{label:'Linkedin',href:'https://linkedin.com/company/adene',icon:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M6.94 5a1.94 1.94 0 1 1-3.88 0 1.94 1.94 0 0 1 3.88 0zM7 8.48H3V21h4V8.48zm6.32 0H9.34V21h3.94v-6.57c0-3.66 4.77-3.96 4.77 0V21H22v-7.93c0-6.17-7.06-5.94-8.72-2.91l.04-1.68z'})},{label:'Youtube',href:'https://www.youtube.com/c/ADENEAg%C3%AAnciaparaaEnergia',icon:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M23 12s0-3.2-.41-4.73a2.46 2.46 0 0 0-1.73-1.74C19.32 5.1 12 5.1 12 5.1s-7.32 0-8.86.42c-.85.23-1.51.9-1.73 1.75C1 8.8 1 12 1 12s0 3.2.41 4.73c.22.85.88 1.51 1.73 1.74 1.54.43 8.86.43 8.86.43s7.32 0 8.86-.42a2.46 2.46 0 0 0 1.73-1.75C23 15.2 23 12 23 12zM9.75 15.02V8.98L14.75 12l-5 3.02z'})}];function RatingFooter(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Footer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Bar,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'https://poupaenergia.pt/',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Logo,{src:__WEBPACK_IMPORTED_MODULE_3__logo_poupa_energia_footer_png___default.a,alt:'Logo Poupa Energia'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Socials,null,SOCIALS.map(function(s){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Social,{key:s.label,href:s.href,target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(IconBox,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{width:'16',height:'16',viewBox:'0 0 24 24'},s.icon)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SocialLabel,null,s.label));}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Copyright,null,'\xA9 ADENE 2026'));}var Footer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].footer(_templateObject);var Bar=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject2);var Logo=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].img(_templateObject3);var Socials=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject4);var Social=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].a(_templateObject5);var IconBox=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject6);var SocialLabel=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject7);var Copyright=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject8);

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = RatingHeader;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logo_poupa_energia_png__ = __webpack_require__(1677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logo_poupa_energia_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__logo_poupa_energia_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logo_adene_png__ = __webpack_require__(1676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logo_adene_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__logo_adene_png__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  background: #fff;\n  border-bottom: 1px solid #ececec;\n'],['\n  width: 100%;\n  background: #fff;\n  border-bottom: 1px solid #ececec;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 16px 24px;\n  display: flex;\n  align-items: center;\n  gap: 40px;\n'],['\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 16px 24px;\n  display: flex;\n  align-items: center;\n  gap: 40px;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 44px;\n  width: auto;\n  display: block;\n'],['\n  height: 44px;\n  width: auto;\n  display: block;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 40px;\n  width: auto;\n  display: block;\n'],['\n  height: 40px;\n  width: auto;\n  display: block;\n']);/**
 * Cabeçalho da página de avaliação (versão simplificada do header do portal).
 *
 * Réplica do header.html mas SEM a "Área Reservada / Entrar": o objetivo é que
 * o utilizador preencha o inquérito, não que saia para a área reservada.
 * Mantém apenas os logos (Poupa Energia + ADENE) à esquerda.
 */function RatingHeader(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Header,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Inner,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'https://poupaenergia.pt/',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PoupaLogo,{src:__WEBPACK_IMPORTED_MODULE_3__logo_poupa_energia_png___default.a,alt:'Logo do Poupa Energia'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'https://www.adene.pt/',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AdeneLogo,{src:__WEBPACK_IMPORTED_MODULE_4__logo_adene_png___default.a,alt:'Logo da ADENE Ag\xEAncia para a Energia'}))));}var Header=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].header(_templateObject);var Inner=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject2);var PoupaLogo=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].img(_templateObject3);var AdeneLogo=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].img(_templateObject4);

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_medals_medal_bronze_v2_svg__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_medals_medal_bronze_v2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_medals_medal_bronze_v2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_medals_medal_gold_v2_svg__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_medals_medal_gold_v2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_medals_medal_gold_v2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_medals_medal_silver_v2_svg__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_medals_medal_silver_v2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_medals_medal_silver_v2_svg__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  outline: none;\n  border: 1px solid #dedede;\n  background-color: #efefef;\n  color: #676767;\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 19px;\n  -webkit-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n  text-transform: uppercase;\n  height: 100%;\n  padding: 0px 14px;\n\n  @media screen and (max-width: 768px) {\n    position: relative;\n    padding: 14px;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .resp-sharing-button__link,\n  .resp-sharing-button__icon {\n    display: inline-block;\n  }\n\n  .resp-sharing-button__link {\n    text-decoration: none;\n    color: #fff;\n    margin: 2px;\n  }\n\n  .resp-sharing-button {\n    border-radius: 5px;\n    transition: 25ms ease-out;\n    padding: 0.5em 0.75em;\n    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;\n  }\n\n  .resp-sharing-button__icon svg {\n    width: 1em;\n    height: 1em;\n    margin-right: 0.4em;\n    vertical-align: top;\n  }\n\n  .resp-sharing-button--small svg {\n    margin: 0;\n    vertical-align: middle;\n  }\n\n  /* Non solid icons get a stroke */\n  .resp-sharing-button__icon {\n    stroke: #fff;\n    fill: none;\n  }\n\n  /* Solid icons get a fill */\n  .resp-sharing-button__icon--solid,\n  .resp-sharing-button__icon--solidcircle {\n    fill: #fff;\n    stroke: none;\n  }\n\n  .resp-sharing-button--twitter {\n    background-color: #55acee;\n  }\n\n  .resp-sharing-button--twitter:hover {\n    background-color: #2795e9;\n  }\n\n  .resp-sharing-button--pinterest {\n    background-color: #bd081c;\n  }\n\n  .resp-sharing-button--pinterest:hover {\n    background-color: #8c0615;\n  }\n\n  .resp-sharing-button--facebook {\n    background-color: #3b5998;\n  }\n\n  .resp-sharing-button--facebook:hover {\n    background-color: #2d4373;\n  }\n\n  .resp-sharing-button--tumblr {\n    background-color: #35465c;\n  }\n\n  .resp-sharing-button--tumblr:hover {\n    background-color: #222d3c;\n  }\n\n  .resp-sharing-button--reddit {\n    background-color: #5f99cf;\n  }\n\n  .resp-sharing-button--reddit:hover {\n    background-color: #3a80c1;\n  }\n\n  .resp-sharing-button--google {\n    background-color: #dd4b39;\n  }\n\n  .resp-sharing-button--google:hover {\n    background-color: #c23321;\n  }\n\n  .resp-sharing-button--linkedin {\n    background-color: #0077b5;\n  }\n\n  .resp-sharing-button--linkedin:hover {\n    background-color: #046293;\n  }\n\n  .resp-sharing-button--email {\n    background-color: #777;\n  }\n\n  .resp-sharing-button--email:hover {\n    background-color: #5e5e5e;\n  }\n\n  .resp-sharing-button--xing {\n    background-color: #1a7576;\n  }\n\n  .resp-sharing-button--xing:hover {\n    background-color: #114c4c;\n  }\n\n  .resp-sharing-button--whatsapp {\n    background-color: #25d366;\n  }\n\n  .resp-sharing-button--whatsapp:hover {\n    background-color: #1da851;\n  }\n\n  .resp-sharing-button--hackernews {\n    background-color: #ff6600;\n  }\n  .resp-sharing-button--hackernews:hover,\n  .resp-sharing-button--hackernews:focus {\n    background-color: #fb6200;\n  }\n\n  .resp-sharing-button--vk {\n    background-color: #507299;\n  }\n\n  .resp-sharing-button--vk:hover {\n    background-color: #43648c;\n  }\n\n  .resp-sharing-button--facebook {\n    background-color: #3b5998;\n    border-color: #3b5998;\n  }\n\n  .resp-sharing-button--facebook:hover,\n  .resp-sharing-button--facebook:active {\n    background-color: #2d4373;\n    border-color: #2d4373;\n  }\n\n  .resp-sharing-button--twitter {\n    background-color: #55acee;\n    border-color: #55acee;\n  }\n\n  .resp-sharing-button--twitter:hover,\n  .resp-sharing-button--twitter:active {\n    background-color: #2795e9;\n    border-color: #2795e9;\n  }\n\n  .resp-sharing-button--email {\n    background-color: #777777;\n    border-color: #777777;\n  }\n\n  .resp-sharing-button--email:hover,\n  .resp-sharing-button--email:active {\n    background-color: #5e5e5e;\n    border-color: #5e5e5e;\n  }\n\n  .resp-sharing-button--whatsapp {\n    background-color: #25d366;\n    border-color: #25d366;\n  }\n\n  .resp-sharing-button--whatsapp:hover,\n  .resp-sharing-button--whatsapp:active {\n    background-color: #1da851;\n    border-color: #1da851;\n  }\n\n  .sharebox-dialog {\n    display: none;\n    padding-left: 8px;\n\n    @media screen and (max-width: 768px) {\n      display: flex;\n    }\n  }\n\n  &:hover {\n    .sharebox-dialog {\n      display: flex;\n    }\n\n    .sharebox-text {\n      opacity: 0;\n    }\n  }\n'],['\n  display: flex;\n  align-items: center;\n  outline: none;\n  border: 1px solid #dedede;\n  background-color: #efefef;\n  color: #676767;\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 19px;\n  -webkit-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n  text-transform: uppercase;\n  height: 100%;\n  padding: 0px 14px;\n\n  @media screen and (max-width: 768px) {\n    position: relative;\n    padding: 14px;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .resp-sharing-button__link,\n  .resp-sharing-button__icon {\n    display: inline-block;\n  }\n\n  .resp-sharing-button__link {\n    text-decoration: none;\n    color: #fff;\n    margin: 2px;\n  }\n\n  .resp-sharing-button {\n    border-radius: 5px;\n    transition: 25ms ease-out;\n    padding: 0.5em 0.75em;\n    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;\n  }\n\n  .resp-sharing-button__icon svg {\n    width: 1em;\n    height: 1em;\n    margin-right: 0.4em;\n    vertical-align: top;\n  }\n\n  .resp-sharing-button--small svg {\n    margin: 0;\n    vertical-align: middle;\n  }\n\n  /* Non solid icons get a stroke */\n  .resp-sharing-button__icon {\n    stroke: #fff;\n    fill: none;\n  }\n\n  /* Solid icons get a fill */\n  .resp-sharing-button__icon--solid,\n  .resp-sharing-button__icon--solidcircle {\n    fill: #fff;\n    stroke: none;\n  }\n\n  .resp-sharing-button--twitter {\n    background-color: #55acee;\n  }\n\n  .resp-sharing-button--twitter:hover {\n    background-color: #2795e9;\n  }\n\n  .resp-sharing-button--pinterest {\n    background-color: #bd081c;\n  }\n\n  .resp-sharing-button--pinterest:hover {\n    background-color: #8c0615;\n  }\n\n  .resp-sharing-button--facebook {\n    background-color: #3b5998;\n  }\n\n  .resp-sharing-button--facebook:hover {\n    background-color: #2d4373;\n  }\n\n  .resp-sharing-button--tumblr {\n    background-color: #35465c;\n  }\n\n  .resp-sharing-button--tumblr:hover {\n    background-color: #222d3c;\n  }\n\n  .resp-sharing-button--reddit {\n    background-color: #5f99cf;\n  }\n\n  .resp-sharing-button--reddit:hover {\n    background-color: #3a80c1;\n  }\n\n  .resp-sharing-button--google {\n    background-color: #dd4b39;\n  }\n\n  .resp-sharing-button--google:hover {\n    background-color: #c23321;\n  }\n\n  .resp-sharing-button--linkedin {\n    background-color: #0077b5;\n  }\n\n  .resp-sharing-button--linkedin:hover {\n    background-color: #046293;\n  }\n\n  .resp-sharing-button--email {\n    background-color: #777;\n  }\n\n  .resp-sharing-button--email:hover {\n    background-color: #5e5e5e;\n  }\n\n  .resp-sharing-button--xing {\n    background-color: #1a7576;\n  }\n\n  .resp-sharing-button--xing:hover {\n    background-color: #114c4c;\n  }\n\n  .resp-sharing-button--whatsapp {\n    background-color: #25d366;\n  }\n\n  .resp-sharing-button--whatsapp:hover {\n    background-color: #1da851;\n  }\n\n  .resp-sharing-button--hackernews {\n    background-color: #ff6600;\n  }\n  .resp-sharing-button--hackernews:hover,\n  .resp-sharing-button--hackernews:focus {\n    background-color: #fb6200;\n  }\n\n  .resp-sharing-button--vk {\n    background-color: #507299;\n  }\n\n  .resp-sharing-button--vk:hover {\n    background-color: #43648c;\n  }\n\n  .resp-sharing-button--facebook {\n    background-color: #3b5998;\n    border-color: #3b5998;\n  }\n\n  .resp-sharing-button--facebook:hover,\n  .resp-sharing-button--facebook:active {\n    background-color: #2d4373;\n    border-color: #2d4373;\n  }\n\n  .resp-sharing-button--twitter {\n    background-color: #55acee;\n    border-color: #55acee;\n  }\n\n  .resp-sharing-button--twitter:hover,\n  .resp-sharing-button--twitter:active {\n    background-color: #2795e9;\n    border-color: #2795e9;\n  }\n\n  .resp-sharing-button--email {\n    background-color: #777777;\n    border-color: #777777;\n  }\n\n  .resp-sharing-button--email:hover,\n  .resp-sharing-button--email:active {\n    background-color: #5e5e5e;\n    border-color: #5e5e5e;\n  }\n\n  .resp-sharing-button--whatsapp {\n    background-color: #25d366;\n    border-color: #25d366;\n  }\n\n  .resp-sharing-button--whatsapp:hover,\n  .resp-sharing-button--whatsapp:active {\n    background-color: #1da851;\n    border-color: #1da851;\n  }\n\n  .sharebox-dialog {\n    display: none;\n    padding-left: 8px;\n\n    @media screen and (max-width: 768px) {\n      display: flex;\n    }\n  }\n\n  &:hover {\n    .sharebox-dialog {\n      display: flex;\n    }\n\n    .sharebox-text {\n      opacity: 0;\n    }\n  }\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  cursor: pointer;\n\n  .sharebox-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .sharebox-text {\n    padding: 0 24px;\n    flex: 1;\n    color: #010101;\n    font-family: Nunito;\n    font-size: 12px;\n    font-weight: bold;\n    letter-spacing: 0;\n    line-height: 16px;\n  }\n\n  .sharebox-carrot {\n    width: 60px;\n    height: 60px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n'],['\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  cursor: pointer;\n\n  .sharebox-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .sharebox-text {\n    padding: 0 24px;\n    flex: 1;\n    color: #010101;\n    font-family: Nunito;\n    font-size: 12px;\n    font-weight: bold;\n    letter-spacing: 0;\n    line-height: 16px;\n  }\n\n  .sharebox-carrot {\n    width: 60px;\n    height: 60px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n'],['\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-weight: bold;\n  color: #93c13e;\n  font-size: 14px;\n  text-align: left;\n  display: block;\n'],['\n  font-weight: bold;\n  color: #93c13e;\n  font-size: 14px;\n  text-align: left;\n  display: block;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 22px;\n  height: auto;\n'],['\n  width: 22px;\n  height: auto;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background-color: rgba(255, 255, 255, 0.6);\n  border: 1px solid #efefef;\n  border-bottom: 0;\n  min-height: 57px;\n  display: flex;\n  min-width: 200px;\n  align-items: center;\n\n  @media screen and (max-width: 768px) {\n    height: auto;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  }\n'],['\n  background-color: rgba(255, 255, 255, 0.6);\n  border: 1px solid #efefef;\n  border-bottom: 0;\n  min-height: 57px;\n  display: flex;\n  min-width: 200px;\n  align-items: center;\n\n  @media screen and (max-width: 768px) {\n    height: auto;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  }\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 149px;\n  border-right: 1px solid #efefef;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    max-height: 60%;\n    max-width: 80%;\n  }\n'],['\n  width: 149px;\n  border-right: 1px solid #efefef;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    max-height: 60%;\n    max-width: 80%;\n  }\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-size: 16px;\n  color: #676767;\n  line-height: 24px;\n  font-weight: bold;\n  text-align: left;\n\n  @media (max-width: 1280px) {\n    font-size: 14px;\n  }\n'],['\n  font-size: 16px;\n  color: #676767;\n  line-height: 24px;\n  font-weight: bold;\n  text-align: left;\n\n  @media (max-width: 1280px) {\n    font-size: 14px;\n  }\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 300px;\n\n  @media screen and (max-width: 768px) {\n    width: auto;\n  }\n'],['\n  width: 300px;\n\n  @media screen and (max-width: 768px) {\n    width: auto;\n  }\n']);/* Result Header with icon and name
 * Created on Wed Aug 30 2017
 *
 * Copyright (c) 2017 Ubiwhere
 *
 * Authors:
 * - Hugo Fonseca <hfonseca@ubiwhere.com>
 */var CYCLES={s:'Simples',b:'Bi-horário',t:'Tri-horário',f:'Tetra-horário'};var MEDAL_TYPES={bronze:__WEBPACK_IMPORTED_MODULE_3__assets_medals_medal_bronze_v2_svg___default.a,silver:__WEBPACK_IMPORTED_MODULE_5__assets_medals_medal_silver_v2_svg___default.a,gold:__WEBPACK_IMPORTED_MODULE_4__assets_medals_medal_gold_v2_svg___default.a/* eslint-disable camelcase */};var ResultHeader=function ResultHeader(_ref){var designation=_ref.designation,absoluteLogoUrl=_ref.absoluteLogoUrl,timeCycle=_ref.timeCycle,medalText=_ref.medalText,medalType=_ref.medalType,shareUrl=_ref.shareUrl;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Header,null,absoluteLogoUrl&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Image,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:absoluteLogoUrl,alt:designation})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(NameContainer,{style:{padding:16}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Name,null,designation,' - ',CYCLES[timeCycle]),!!medalType&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(MedalContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(MedalIcon,{src:MEDAL_TYPES[medalType]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(MedalText,null,medalText))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ShareComponent,{shareContent:'Veja os detalhes acerca do tarifario '+designation,shareUrl:shareUrl,shareTitle:'Tarif\xE1rio '+designation}));};/* eslint-enable camelcase *//* harmony default export */ __webpack_exports__["a"] = (ResultHeader);var ShareComponent=function ShareComponent(_ref2){var shareUrl=_ref2.shareUrl,shareContent=_ref2.shareContent,shareTitle=_ref2.shareTitle;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ShareBoxContainer,{style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ShareBox,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'sharebox-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{width:24,height:26,viewBox:'0 0 24 26',xmlns:'http://www.w3.org/2000/svg'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M19.333 23.44c-1.142 0-2.077-.918-2.077-2.04 0-.097.006-.186.024-.276a2.017 2.017 0 01.8-1.345 2.07 2.07 0 011.253-.42c1.143 0 2.078.918 2.078 2.041 0 1.122-.935 2.04-2.078 2.04m-14.666-8.4c-1.143 0-2.078-.918-2.078-2.04 0-1.123.935-2.04 2.078-2.04.47 0 .904.155 1.252.42.428.318.728.797.801 1.344.018.09.024.18.024.276 0 .096-.006.186-.024.276a2.016 2.016 0 01-.8 1.344 2.07 2.07 0 01-1.253.42M17.256 4.6c0-1.123.935-2.04 2.077-2.04 1.143 0 2.078.917 2.078 2.04 0 1.122-.935 2.04-2.078 2.04-.47 0-.904-.156-1.252-.42a2.016 2.016 0 01-.801-1.344 1.365 1.365 0 01-.024-.276m2.077 13.2a3.667 3.667 0 00-2.689 1.157l-8.482-4.859a3.624 3.624 0 000-2.196l8.482-4.86a3.666 3.666 0 002.69 1.158C21.355 8.2 23 6.586 23 4.6S21.356 1 19.333 1c-2.022 0-3.666 1.614-3.666 3.6 0 .384.06.75.17 1.098l-8.481 4.86A3.666 3.666 0 004.666 9.4C2.645 9.4 1 11.014 1 13c0 1.985 1.644 3.6 3.667 3.6a3.668 3.668 0 002.689-1.158l8.482 4.86c-.11.348-.171.714-.171 1.098 0 1.985 1.644 3.6 3.666 3.6C21.356 25 23 23.385 23 21.4c0-1.986-1.644-3.6-3.667-3.6',fill:'#222',fillRule:'nonzero',stroke:'#222',strokeWidth:0.6})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'sharebox-dialog'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'resp-sharing-button__link',href:'https://facebook.com/sharer/sharer.php?u='+encodeURIComponent(shareUrl)+'&quote='+encodeURIComponent(shareContent),target:'_blank',rel:'noopener','aria-label':''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'resp-sharing-button resp-sharing-button--facebook resp-sharing-button--small'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{'aria-hidden':'true',className:'resp-sharing-button__icon resp-sharing-button__icon--solidcircle'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',viewBox:'0 0 24 24'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M12 0C5.38 0 0 5.38 0 12s5.38 12 12 12 12-5.38 12-12S18.62 0 12 0zm3.6 11.5h-2.1v7h-3v-7h-2v-2h2V8.34c0-1.1.35-2.82 2.65-2.82h2.35v2.3h-1.4c-.25 0-.6.13-.6.66V9.5h2.34l-.24 2z'}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'resp-sharing-button__link',href:'https://twitter.com/intent/tweet/?text='+encodeURIComponent(shareContent)+'&url='+encodeURIComponent(shareUrl),target:'_blank',rel:'noopener','aria-label':''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'resp-sharing-button resp-sharing-button--twitter resp-sharing-button--small'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{'aria-hidden':'true',className:'resp-sharing-button__icon resp-sharing-button__icon--solidcircle'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',viewBox:'0 0 24 24'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M12 0C5.38 0 0 5.38 0 12s5.38 12 12 12 12-5.38 12-12S18.62 0 12 0zm5.26 9.38v.34c0 3.48-2.64 7.5-7.48 7.5-1.48 0-2.87-.44-4.03-1.2 1.37.17 2.77-.2 3.9-1.08-1.16-.02-2.13-.78-2.46-1.83.38.1.8.07 1.17-.03-1.2-.24-2.1-1.3-2.1-2.58v-.05c.35.2.75.32 1.18.33-.7-.47-1.17-1.28-1.17-2.2 0-.47.13-.92.36-1.3C7.94 8.85 9.88 9.9 12.06 10c-.04-.2-.06-.4-.06-.6 0-1.46 1.18-2.63 2.63-2.63.76 0 1.44.3 1.92.82.6-.12 1.95-.27 1.95-.27-.35.53-.72 1.66-1.24 2.04z'}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'resp-sharing-button__link',href:'mailto:?subject='+encodeURIComponent(shareTitle)+'&body='+encodeURIComponent(shareContent+' '+shareUrl),target:'_self',rel:'noopener','aria-label':''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'resp-sharing-button resp-sharing-button--email resp-sharing-button--small'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{'aria-hidden':'true',className:'resp-sharing-button__icon resp-sharing-button__icon--solidcircle'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',viewBox:'0 0 24 24'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M12 0C5.38 0 0 5.38 0 12s5.38 12 12 12 12-5.38 12-12S18.62 0 12 0zm8 16c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v8z'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'M17.9 8.18c-.2-.2-.5-.24-.72-.07L12 12.38 6.82 8.1c-.22-.16-.53-.13-.7.08s-.15.53.06.7l3.62 2.97-3.57 2.23c-.23.14-.3.45-.15.7.1.14.25.22.42.22.1 0 .18-.02.27-.08l3.85-2.4 1.06.87c.1.04.2.1.32.1s.23-.06.32-.1l1.06-.9 3.86 2.4c.08.06.17.1.26.1.17 0 .33-.1.42-.25.15-.24.08-.55-.15-.7l-3.57-2.22 3.62-2.96c.2-.2.24-.5.07-.72z'}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'resp-sharing-button__link',href:'https://wa.me/?text='+encodeURIComponent(shareContent)+' '+encodeURIComponent(shareUrl),target:'_blank',rel:'noopener','aria-label':''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'resp-sharing-button resp-sharing-button--whatsapp resp-sharing-button--small'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{'aria-hidden':'true',className:'resp-sharing-button__icon resp-sharing-button__icon--solidcircle'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',height:'24',width:'24',viewBox:'0 0 24 24'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path',{d:'m12 0c-6.6 0-12 5.4-12 12s5.4 12 12 12 12-5.4 12-12-5.4-12-12-12zm0 3.8c2.2 0 4.2 0.9 5.7 2.4 1.6 1.5 2.4 3.6 2.5 5.7 0 4.5-3.6 8.1-8.1 8.1-1.4 0-2.7-0.4-3.9-1l-4.4 1.1 1.2-4.2c-0.8-1.2-1.1-2.6-1.1-4 0-4.5 3.6-8.1 8.1-8.1zm0.1 1.5c-3.7 0-6.7 3-6.7 6.7 0 1.3 0.3 2.5 1 3.6l0.1 0.3-0.7 2.4 2.5-0.7 0.3 0.099c1 0.7 2.2 1 3.4 1 3.7 0 6.8-3 6.9-6.6 0-1.8-0.7-3.5-2-4.8s-3-2-4.8-2zm-3 2.9h0.4c0.2 0 0.4-0.099 0.5 0.3s0.5 1.5 0.6 1.7 0.1 0.2 0 0.3-0.1 0.2-0.2 0.3l-0.3 0.3c-0.1 0.1-0.2 0.2-0.1 0.4 0.2 0.2 0.6 0.9 1.2 1.4 0.7 0.7 1.4 0.9 1.6 1 0.2 0 0.3 0.001 0.4-0.099s0.5-0.6 0.6-0.8c0.2-0.2 0.3-0.2 0.5-0.1l1.4 0.7c0.2 0.1 0.3 0.2 0.5 0.3 0 0.1 0.1 0.5-0.099 1s-1 0.9-1.4 1c-0.3 0-0.8 0.001-1.3-0.099-0.3-0.1-0.7-0.2-1.2-0.4-2.1-0.9-3.4-3-3.5-3.1s-0.8-1.1-0.8-2.1c0-1 0.5-1.5 0.7-1.7s0.4-0.3 0.5-0.3z'})))))));};var ShareBoxContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject);var ShareBox=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject2);var MedalContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject3);var MedalText=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject4);var MedalIcon=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].img(_templateObject5);var Header=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject6);var Image=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject7);var Name=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject8);var NameContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject9);

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResultTarifMobileV2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_ic_winner_component_svg__ = __webpack_require__(1646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_ic_winner_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_ic_winner_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_ic_add_component_svg__ = __webpack_require__(1645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_ic_add_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_ic_add_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_MyTarifSectionV2_images_ic_see_component_svg__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_MyTarifSectionV2_images_ic_see_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_MyTarifSectionV2_images_ic_see_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_MyTarifSectionV2_images_ic_whatsapp_component_svg__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_MyTarifSectionV2_images_ic_whatsapp_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_MyTarifSectionV2_images_ic_whatsapp_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_MyTarifSectionV2_images_ic_facebook_component_svg__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_MyTarifSectionV2_images_ic_facebook_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_MyTarifSectionV2_images_ic_facebook_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_MyTarifSectionV2_images_ic_x_component_svg__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_MyTarifSectionV2_images_ic_x_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_MyTarifSectionV2_images_ic_x_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_MyTarifSectionV2_images_ic_mail_component_svg__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_MyTarifSectionV2_images_ic_mail_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_MyTarifSectionV2_images_ic_mail_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DropdownGhostV2__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ShareButtonV2__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__InlineCheckV2__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ButtonGradientV2__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ButtonOutlineV2__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_utils__ = __webpack_require__(11);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  background: #fff;\n  width: 100%;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  background: #fff;\n  width: 100%;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 8px 20px;\n  align-items: center;\n  gap: 12px;\n  align-self: stretch;\n  border-bottom: 1px solid #ececec;\n\n  > img {\n    width: 48px;\n    height: 48px;\n    object-fit: contain;\n  }\n'],['\n  display: flex;\n  padding: 8px 20px;\n  align-items: center;\n  gap: 12px;\n  align-self: stretch;\n  border-bottom: 1px solid #ececec;\n\n  > img {\n    width: 48px;\n    height: 48px;\n    object-fit: contain;\n  }\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  height: 48px;\n  padding: 12px 20px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 4px;\n  align-self: stretch;\n  background: rgba(147, 193, 62, 0.2);\n\n  ','\n\n  ','\n\n  > p {\n    color: #006736;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    margin: 0;\n  }\n\n  > h4 {\n    color: #006736;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n    letter-spacing: 1px;\n    margin: 0;\n    text-transform: unset !important;\n  }\n'],['\n  display: flex;\n  height: 48px;\n  padding: 12px 20px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 4px;\n  align-self: stretch;\n  background: rgba(147, 193, 62, 0.2);\n\n  ','\n\n  ','\n\n  > p {\n    color: #006736;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    margin: 0;\n  }\n\n  > h4 {\n    color: #006736;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n    letter-spacing: 1px;\n    margin: 0;\n    text-transform: unset !important;\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 6px 0px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 4px;\n  flex: 1 0 0;\n  align-self: stretch;\n\n  > h2 {\n    overflow: hidden;\n    color: #1d1e22;\n    text-overflow: ellipsis;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n    align-self: stretch;\n    margin: 0 !important;\n    text-align: unset !important;\n    text-transform: unset !important;\n  }\n\n  .tagsWrapper {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n  }\n\n  .tag {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    align-self: stretch;\n\n    > p {\n      overflow: hidden;\n      color: #006736;\n      text-overflow: ellipsis;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 14px;\n      flex: 1 0 0;\n      margin: 0;\n    }\n  }\n'],['\n  display: flex;\n  padding: 6px 0px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 4px;\n  flex: 1 0 0;\n  align-self: stretch;\n\n  > h2 {\n    overflow: hidden;\n    color: #1d1e22;\n    text-overflow: ellipsis;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n    align-self: stretch;\n    margin: 0 !important;\n    text-align: unset !important;\n    text-transform: unset !important;\n  }\n\n  .tagsWrapper {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n  }\n\n  .tag {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    align-self: stretch;\n\n    > p {\n      overflow: hidden;\n      color: #006736;\n      text-overflow: ellipsis;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 14px;\n      flex: 1 0 0;\n      margin: 0;\n    }\n  }\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-self: stretch;\n  gap: 10px;\n  height: 40px;\n  padding: 10px;\n  border-bottom: ',';\n  background: #fff;\n  text-decoration: none;\n\n  cursor: pointer;\n\n  p {\n    flex: 1 0 0;\n    color: #3e3e3e;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n  }\n'],['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-self: stretch;\n  gap: 10px;\n  height: 40px;\n  padding: 10px;\n  border-bottom: ',';\n  background: #fff;\n  text-decoration: none;\n\n  cursor: pointer;\n\n  p {\n    flex: 1 0 0;\n    color: #3e3e3e;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n  }\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n  align-self: stretch;\n'],['\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n  align-self: stretch;\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-wrap: wrap;\n  padding: 16px 8px;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n  border-top: 1px solid #ececec;\n\n  @media screen and (min-width: 500px) {\n    padding-inline: 16px;\n  }\n'],['\n  display: flex;\n  flex-wrap: wrap;\n  padding: 16px 8px;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n  border-top: 1px solid #ececec;\n\n  @media screen and (min-width: 500px) {\n    padding-inline: 16px;\n  }\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  @media screen and (min-width: 500px) {\n    gap: 12px;\n  }\n'],['\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  @media screen and (min-width: 500px) {\n    gap: 12px;\n  }\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 120px;\n\n  @media screen and (min-width: 500px) {\n    width: 156px;\n  }\n'],['\n  width: 120px;\n\n  @media screen and (min-width: 500px) {\n    width: 156px;\n  }\n']);var ResultTarifMobileV2=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ResultTarifMobileV2,_Component);function ResultTarifMobileV2(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,ResultTarifMobileV2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=ResultTarifMobileV2.__proto__||Object.getPrototypeOf(ResultTarifMobileV2)).call.apply(_ref,[this].concat(args))),_this),_this.state={shareUrl:''+window.location.origin+window.location.pathname+'?code='+_this.simulationCode,shareContent:'Veja a minha simulação em'},_this.renderTag=function(text,icon){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span',{className:'tag'},icon,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('p',null,text));},_temp),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ResultTarifMobileV2,[{key:'render',/** Lonely boy */value:function render(){var _props=this.props,bestAnnualBilling=_props.bestAnnualBilling,setCompare=_props.setCompare,compareList=_props.compareList,index=_props.index,toggleJoinModal=_props.toggleJoinModal,toggleDetailsModal=_props.toggleDetailsModal,result=_props.result;// Calculate money saved
var moneySaved=bestAnnualBilling-result.annualBilling;// Calculate subscriptions
var subscriptions=void 0;var medalText=void 0;var icon=void 0;var title=void 0;// Get values depending if electricity or gas
if(result.electricityPriceList){subscriptions=result.electricityPriceList.subscriptions;icon=result.electricityPriceList.entity.hi_res_logo;title=result.electricityPriceList.designation;}if(result.gasPriceList){subscriptions=result.gasPriceList.subscriptions;icon=result.gasPriceList.entity.hi_res_logo;title=result.gasPriceList.designation;}if(subscriptions.count>=50){medalText='+50 '+subscriptions.period;}else if(subscriptions.count>=20){medalText='+20 '+subscriptions.period;}else if(subscriptions.count>=5){medalText='+5 '+subscriptions.period;}var moreInfoParams=Object.assign({},this.props,{moneySaved:moneySaved,priceListId:result.id});if(result.electricityPriceList){moreInfoParams.id=result.electricityPriceList.id;title=title+' ('+(result.priceListTimeCycle==='s'?'Simples':result.priceListTimeCycle==='b'?'Bi-Horário':'Tri-Horário')+')';}else if(result.gasPriceList){moreInfoParams.id=result.gasPriceList.id;}var savingsDesignation=Math.abs(Math.round(moneySaved))===0?'Idêntico ao atual':moneySaved<=0?'Sobrecusto':'Poupança';return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Header,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('img',{src:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_utils__["f" /* generateMediaUrl */])(icon),alt:title}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(TitleRow,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('h2',null,title),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span',{className:'tagsWrapper'},index===0&&this.renderTag('Mais Económico',__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__images_ic_winner_component_svg___default.a,null)),medalText&&this.renderTag(medalText,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__images_ic_winner_component_svg___default.a,null)))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ShareWrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__DropdownGhostV2__["a" /* default */],{titleArea:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ShareButtonV2__["a" /* default */],null)},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{style:{width:'186px',border:'1px solid #ECECEC'}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ShareBtn,{href:'https://wa.me/?text='+encodeURIComponent(this.state.shareContent)+' '+encodeURIComponent(this.state.shareUrl),target:'_blank',rel:'noopener','aria-label':''},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_MyTarifSectionV2_images_ic_whatsapp_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('p',null,'Whatsapp')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ShareBtn,{href:'https://facebook.com/sharer/sharer.php?u='+encodeURIComponent(this.state.shareUrl)+'&quote='+encodeURIComponent(this.state.shareContent),target:'_blank',rel:'noopener','aria-label':''},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_MyTarifSectionV2_images_ic_facebook_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('p',null,'Facebook')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ShareBtn,{href:'https://twitter.com/intent/tweet/?text='+encodeURIComponent(this.state.shareContent)+'&url='+encodeURIComponent(this.state.shareUrl),target:'_blank',rel:'noopener','aria-label':''},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_MyTarifSectionV2_images_ic_x_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('p',null,'X')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ShareBtn,{noBorder:true,href:'mailto:?subject='+encodeURIComponent('Simulação')+'&body='+encodeURIComponent(this.state.shareContent+' '+this.state.shareUrl),target:'_blank',rel:'noopener','aria-label':''},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_MyTarifSectionV2_images_ic_mail_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('p',null,'Mail')))))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Savings,{isMoneySaved:moneySaved},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('p',null,savingsDesignation),moneySaved&&Math.abs(Math.round(moneySaved))<0?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('h4',null,'+',Math.abs(Math.round(moneySaved)),' \u20AC/ano'):null,moneySaved&&Math.abs(Math.round(moneySaved))>0?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('h4',null,Math.abs(Math.round(moneySaved)),' \u20AC/ano'):null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Footer,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputWrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__InlineCheckV2__["a" /* default */],{noBackground:true,style:{width:'100%'},onClick:function onClick(){return setCompare(result);},name:'Comparar',disabled:compareList.length===2&&!compareList.some(function(item){return item.id===result.id;}),selected:compareList.some(function(item){return item.id===result.id;})})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(BtnsWrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ButtonOutlineV2__["a" /* default */],{style:{width:'48px',height:'48px'},onClick:function onClick(){return toggleDetailsModal(moreInfoParams);},setModalTriggerHeight:this.props.setModalTriggerHeight,icon:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_MyTarifSectionV2_images_ic_see_component_svg___default.a,null)}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ButtonGradientV2__["a" /* default */],{setModalTriggerHeight:this.props.setModalTriggerHeight,style:{width:'120px',height:'48px'},onClick:function onClick(){return toggleJoinModal(moreInfoParams);},icon:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__images_ic_add_component_svg___default.a,null)},'Aderir'))));}}]);return ResultTarifMobileV2;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);var Wrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject);var Header=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject2);var Savings=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject3,function(_ref2){var isMoneySaved=_ref2.isMoneySaved;return isMoneySaved<0&&'\n    background: linear-gradient(0deg, rgba(192, 0, 0, 0.10) 0%, rgba(192, 0, 0, 0.10) 100%), #FFF;\n  ';},function(_ref3){var isMoneySaved=_ref3.isMoneySaved;return isMoneySaved===0&&'\n    background: linear-gradient(0deg, rgba(117, 117, 117, 0.10) 0%, rgba(117, 117, 117, 0.10) 100%), #FFF;\n  ';});var TitleRow=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject4);var ShareBtn=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].a(_templateObject5,function(_ref4){var noBorder=_ref4.noBorder;return noBorder?'none':'1px solid #ECECEC';});var ShareWrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject6);var Footer=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject7);var BtnsWrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject8);var InputWrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject9);

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResultTarifV2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_ic_winner_component_svg__ = __webpack_require__(1648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_ic_winner_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_ic_winner_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_ic_add_component_svg__ = __webpack_require__(1647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_ic_add_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_ic_add_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_MyTarifSectionV2_images_ic_see_component_svg__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_MyTarifSectionV2_images_ic_see_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_MyTarifSectionV2_images_ic_see_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_MyTarifSectionV2_images_ic_whatsapp_component_svg__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_MyTarifSectionV2_images_ic_whatsapp_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_MyTarifSectionV2_images_ic_whatsapp_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_MyTarifSectionV2_images_ic_facebook_component_svg__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_MyTarifSectionV2_images_ic_facebook_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_MyTarifSectionV2_images_ic_facebook_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_MyTarifSectionV2_images_ic_x_component_svg__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_MyTarifSectionV2_images_ic_x_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_MyTarifSectionV2_images_ic_x_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_MyTarifSectionV2_images_ic_mail_component_svg__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_MyTarifSectionV2_images_ic_mail_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_MyTarifSectionV2_images_ic_mail_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DropdownGhostV2__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ShareButtonV2__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__InlineCheckV2__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ButtonGradientV2__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ButtonOutlineV2__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_utils__ = __webpack_require__(11);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: flex-start;\n  border: 1px solid #ececec;\n  background: #fff;\n'],['\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: flex-start;\n  border: 1px solid #ececec;\n  background: #fff;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  height: 72px;\n  padding: 2px 16px;\n  align-items: center;\n  gap: 16px;\n  align-self: stretch;\n\n  > img {\n    width: 86px;\n    height: 40px;\n    object-fit: contain;\n  }\n'],['\n  display: flex;\n  height: 72px;\n  padding: 2px 16px;\n  align-items: center;\n  gap: 16px;\n  align-self: stretch;\n\n  > img {\n    width: 86px;\n    height: 40px;\n    object-fit: contain;\n  }\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  height: 32px;\n  padding: 4px 8px;\n  justify-content: center;\n  align-items: flex-end;\n  gap: 4px;\n  border-radius: 4px;\n  background: linear-gradient(0deg, rgba(147, 193, 62, 0.20) 0%, rgba(147, 193, 62, 0.20) 100%), #FFF;\n\n  > p {\n    color: #006736;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */}\n    margin: 0;\n  }\n    \n  > h4 {\n    color: #006736;\n    font-size: 22px;\n    font-weight: 700;\n    line-height: 22px;\n    letter-spacing: 1px;\n    margin: 0;\n    text-transform: unset !important;\n  }\n\n  \n  ','\n\n  ','\n'],['\n  display: flex;\n  height: 32px;\n  padding: 4px 8px;\n  justify-content: center;\n  align-items: flex-end;\n  gap: 4px;\n  border-radius: 4px;\n  background: linear-gradient(0deg, rgba(147, 193, 62, 0.20) 0%, rgba(147, 193, 62, 0.20) 100%), #FFF;\n\n  > p {\n    color: #006736;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */}\n    margin: 0;\n  }\n    \n  > h4 {\n    color: #006736;\n    font-size: 22px;\n    font-weight: 700;\n    line-height: 22px;\n    letter-spacing: 1px;\n    margin: 0;\n    text-transform: unset !important;\n  }\n\n  \n  ','\n\n  ','\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  flex: 1 0 0;\n\n  > h2 {\n    color: #1d1e22;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px; /* 150% */\n    align-self: stretch;\n    margin: 0 !important;\n    text-align: unset !important;\n    text-transform: unset !important;\n  }\n\n  .tagsWrapper {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n  }\n\n  .tag {\n    display: flex;\n    height: 24px;\n    align-items: center;\n    gap: 4px;\n    align-self: stretch;\n\n    > p {\n      color: #006736;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 14px; /* 116.667% */\n      margin: 0;\n    }\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  flex: 1 0 0;\n\n  > h2 {\n    color: #1d1e22;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px; /* 150% */\n    align-self: stretch;\n    margin: 0 !important;\n    text-align: unset !important;\n    text-transform: unset !important;\n  }\n\n  .tagsWrapper {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n  }\n\n  .tag {\n    display: flex;\n    height: 24px;\n    align-items: center;\n    gap: 4px;\n    align-self: stretch;\n\n    > p {\n      color: #006736;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 14px; /* 116.667% */\n      margin: 0;\n    }\n  }\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-self: stretch;\n  gap: 10px;\n  height: 40px;\n  padding: 10px;\n  border-bottom: ',';\n  background: #fff;\n  text-decoration: none;\n\n  cursor: pointer;\n\n  p {\n    flex: 1 0 0;\n    color: #3e3e3e;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n  }\n'],['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-self: stretch;\n  gap: 10px;\n  height: 40px;\n  padding: 10px;\n  border-bottom: ',';\n  background: #fff;\n  text-decoration: none;\n\n  cursor: pointer;\n\n  p {\n    flex: 1 0 0;\n    color: #3e3e3e;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n  }\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n  align-self: stretch;\n'],['\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n  align-self: stretch;\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 16px;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n  border-top: 1px solid #ececec;\n'],['\n  display: flex;\n  padding: 16px;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n  border-top: 1px solid #ececec;\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 300px;\n'],['\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 300px;\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 156px;\n'],['\n  width: 156px;\n']);var ResultTarifV2=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ResultTarifV2,_Component);function ResultTarifV2(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,ResultTarifV2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=ResultTarifV2.__proto__||Object.getPrototypeOf(ResultTarifV2)).call.apply(_ref,[this].concat(args))),_this),_this.state={shareUrl:''+window.location.origin+window.location.pathname+'?code='+_this.simulationCode,shareContent:'Veja a minha simulação em'},_this.renderTag=function(text,icon){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span',{className:'tag'},icon,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('p',null,text));},_temp),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ResultTarifV2,[{key:'render',/** Lonely boy */value:function render(){var _props=this.props,bestAnnualBilling=_props.bestAnnualBilling,setCompare=_props.setCompare,compareList=_props.compareList,index=_props.index,toggleJoinModal=_props.toggleJoinModal,toggleDetailsModal=_props.toggleDetailsModal,result=_props.result;// Calculate money saved
var moneySaved=bestAnnualBilling-result.annualBilling;// Calculate subscriptions
var subscriptions=void 0;var medalText=void 0;var icon=void 0;var title=void 0;// Get values depending if electricity or gas
if(result.electricityPriceList){subscriptions=result.electricityPriceList.subscriptions;icon=result.electricityPriceList.entity.hi_res_logo;title=result.electricityPriceList.designation;}if(result.gasPriceList){subscriptions=result.gasPriceList.subscriptions;icon=result.gasPriceList.entity.hi_res_logo;title=result.gasPriceList.designation;}if(subscriptions.count>=50){medalText='+50 '+subscriptions.period;}else if(subscriptions.count>=20){medalText='+20 '+subscriptions.period;}else if(subscriptions.count>=5){medalText='+5 '+subscriptions.period;}var moreInfoParams=Object.assign({},this.props,{moneySaved:moneySaved,priceListId:result.id});if(result.electricityPriceList){moreInfoParams.id=result.electricityPriceList.id;title=title+' ('+(result.priceListTimeCycle==='s'?'Simples':result.priceListTimeCycle==='b'?'Bi-Horário':'Tri-Horário')+')';}else if(result.gasPriceList){moreInfoParams.id=result.gasPriceList.id;}var savingsDesignation=Math.abs(Math.round(moneySaved))===0?'Idêntico ao atual':moneySaved<=0?'Sobrecusto':'Poupança';return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Header,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('img',{src:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_utils__["f" /* generateMediaUrl */])(icon),alt:title}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(TitleRow,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('h2',null,title),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span',{className:'tagsWrapper'},index===0&&this.renderTag('Mais Económico',__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__images_ic_winner_component_svg___default.a,null)),medalText&&this.renderTag(medalText,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__images_ic_winner_component_svg___default.a,null)))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Savings,{isMoneySaved:moneySaved},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('p',null,savingsDesignation),moneySaved&&Math.abs(Math.round(moneySaved))<0?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('h4',null,'+',Math.abs(Math.round(moneySaved)),' \u20AC/ano'):null,moneySaved&&Math.abs(Math.round(moneySaved))>0?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('h4',null,Math.abs(Math.round(moneySaved)),' \u20AC/ano'):null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ShareWrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__DropdownGhostV2__["a" /* default */],{titleArea:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ShareButtonV2__["a" /* default */],null)},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{style:{width:'186px',border:'1px solid #ECECEC'}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ShareBtn,{href:'https://wa.me/?text='+encodeURIComponent(this.state.shareContent)+' '+encodeURIComponent(this.state.shareUrl),target:'_blank',rel:'noopener','aria-label':''},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_MyTarifSectionV2_images_ic_whatsapp_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('p',null,'Whatsapp')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ShareBtn,{href:'https://facebook.com/sharer/sharer.php?u='+encodeURIComponent(this.state.shareUrl)+'&quote='+encodeURIComponent(this.state.shareContent),target:'_blank',rel:'noopener','aria-label':''},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_MyTarifSectionV2_images_ic_facebook_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('p',null,'Facebook')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ShareBtn,{href:'https://twitter.com/intent/tweet/?text='+encodeURIComponent(this.state.shareContent)+'&url='+encodeURIComponent(this.state.shareUrl),target:'_blank',rel:'noopener','aria-label':''},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_MyTarifSectionV2_images_ic_x_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('p',null,'X')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ShareBtn,{noBorder:true,href:'mailto:?subject='+encodeURIComponent('Simulação')+'&body='+encodeURIComponent(this.state.shareContent+' '+this.state.shareUrl),target:'_blank',rel:'noopener','aria-label':''},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_MyTarifSectionV2_images_ic_mail_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('p',null,'Mail')))))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Content,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputWrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__InlineCheckV2__["a" /* default */],{noBackground:true,style:{width:'100%'},onClick:function onClick(){return setCompare(result);},name:'Comparar',disabled:compareList.length===2&&!compareList.some(function(item){return item.id===result.id;}),selected:compareList.some(function(item){return item.id===result.id;})})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(BtnsWrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ButtonOutlineV2__["a" /* default */],{setModalTriggerHeight:this.props.setModalTriggerHeight,onClick:function onClick(){return toggleDetailsModal(moreInfoParams);},icon:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_MyTarifSectionV2_images_ic_see_component_svg___default.a,null)},'Ver Detalhes'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ButtonGradientV2__["a" /* default */],{setModalTriggerHeight:this.props.setModalTriggerHeight,onClick:function onClick(){return toggleJoinModal(moreInfoParams);},icon:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__images_ic_add_component_svg___default.a,null)},'Aderir'))));}}]);return ResultTarifV2;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);var Wrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject);var Header=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject2);var Savings=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject3,function(_ref2){var isMoneySaved=_ref2.isMoneySaved;return isMoneySaved<0&&'\n    background: linear-gradient(0deg, rgba(192, 0, 0, 0.10) 0%, rgba(192, 0, 0, 0.10) 100%), #FFF;\n\n    > p,\n    > h4 {\n      color: #C00000;\n    }\n  ';},function(_ref3){var isMoneySaved=_ref3.isMoneySaved;return isMoneySaved===0&&'\n    background: linear-gradient(0deg, rgba(117, 117, 117, 0.10) 0%, rgba(117, 117, 117, 0.10) 100%), #FFF;\n\n    > p,\n    > h4 {\n      color:#3E3E3E;\n    }\n  ';});var TitleRow=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject4);var ShareBtn=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].a(_templateObject5,function(_ref4){var noBorder=_ref4.noBorder;return noBorder?'none':'1px solid #ECECEC';});var ShareWrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject6);var Content=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject7);var BtnsWrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject8);var InputWrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject9);

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResultsSectionV2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__logic__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ResultTarifV2__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ButtonOutlineV2__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DetailsModalV2__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__JoinTariffModalV2__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CompareModalV2__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SmallModalV2__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ButtonGradientV2__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_ic_alert_component_svg__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_ic_alert_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__images_ic_alert_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_utils__ = __webpack_require__(11);
var _class;var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: flex-start;\n'],['\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: flex-start;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 56px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 12px 0px;\n\n  h3 {\n    flex: 1 0 0;\n    color: #1d1e22;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n    letter-spacing: 1px;\n    margin: 0;\n    text-transform: unset;\n    text-align: left;\n  }\n'],['\n  height: 56px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 12px 0px;\n\n  h3 {\n    flex: 1 0 0;\n    color: #1d1e22;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n    letter-spacing: 1px;\n    margin: 0;\n    text-transform: unset;\n    text-align: left;\n  }\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n  padding-bottom: 24px;\n'],['\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n  padding-bottom: 24px;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding: 20px 0;\n'],['\n  padding: 20px 0;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  font-weight: bold;\n  margin-bottom: 10px;\n  color: #93c13e;\n  font-size: 16px;\n'],['\n  display: block;\n  font-weight: bold;\n  margin-bottom: 10px;\n  color: #93c13e;\n  font-size: 16px;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin-bottom: 10px;\n  font-size: 14px;\n\n  ','\n'],['\n  margin-bottom: 10px;\n  font-size: 14px;\n\n  ','\n']);var ResultsSectionV2=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__logic__["a" /* default */])(_class=function(_Component){__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ResultsSectionV2,_Component);function ResultsSectionV2(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this,ResultsSectionV2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=ResultsSectionV2.__proto__||Object.getPrototypeOf(ResultsSectionV2)).call.apply(_ref,[this].concat(args))),_this),_this.state={detailsModal:false,joinModal:false,adhesionTariff:null},_this.setCompareItem=function(id){var newList=[].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(_this.props.compareList));if(newList.includes(id)){var index=newList.indexOf(id);newList.splice(index,1);}else{if(newList.length===2){return;}newList.push(id);}_this.actions.setCompareList(newList);},_this.disableCompareModal=function(){return _this.props.compareList.length===0||_this.props.compareList.length>2;},_this.toggleCompareModal=function(){_this.actions.toggleCompareModal(!_this.props.compareModal);},_this.toggleDetailsModal=function(tariff){if(tariff){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_utils__["e" /* sendGevent */])('simulador','Saber mais','Saber mais sobre um tarifário');tariff&&_this.actions.fetchTariffInfo(tariff);}var tariffPriceListTimeCycle=tariff&&tariff.priceListTimeCycle;_this.setState({detailsModal:!_this.state.detailsModal,adhesionTariff:tariff,priceListTimeCycle:tariffPriceListTimeCycle||null});},_this.toggleJoinModal=function(tariff){if(tariff){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_utils__["e" /* sendGevent */])('simulador','Aderir','Aderir a um tarifário');tariff&&_this.actions.fetchTariffInfo(tariff);}else{_this.actions.setTariffInfo(null);}_this.setState({adhesionTariff:tariff,joinModal:!_this.state.joinModal});},_temp),__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}/**
   * Opens/Closes Compare modal
   *//**
   * Opens/Closes Details modal
   *//**
   * Opens/Closes join modal
   */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ResultsSectionV2,[{key:'renderCompareModalModal',value:function renderCompareModalModal(){var _this2=this;var _props=this.props,compareModal=_props.compareModal,compareList=_props.compareList;return compareModal?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__CompareModalV2__["a" /* default */],{modalTriggerHeight:this.props.modalTriggerHeight,setModalTriggerHeight:this.props.setModalTriggerHeight,onClose:function onClose(){return _this2.actions.toggleCompareModal(false);},compareList:compareList,simulation:this.props.simulation,onJoin:function onJoin(tariff){_this2.toggleCompareModal();_this2.toggleJoinModal(tariff);}}):null;}},{key:'renderJoinModal',value:function renderJoinModal(){var _this3=this;var _props2=this.props,simulation=_props2.simulation,tariffInfo=_props2.tariffInfo,translations=_props2.translations;var _state=this.state,joinModal=_state.joinModal,adhesionTariff=_state.adhesionTariff;if(joinModal&&adhesionTariff&&tariffInfo&&!tariffInfo.pricelistadditionalinfo.is_regulated){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__JoinTariffModalV2__["a" /* default */],Object.assign({},this.props,{tariff:adhesionTariff,tariffInfo:tariffInfo,changeTariff:this.toggleJoinModal,simulation:simulation,isHome:false,modalTriggerHeight:this.props.modalTriggerHeight,setModalTriggerHeight:this.props.setModalTriggerHeight}));}else if(joinModal&&adhesionTariff&&tariffInfo&&tariffInfo.pricelistadditionalinfo.is_regulated){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__SmallModalV2__["a" /* default */],{style:{width:'500px',height:'450px'},title:'Aderir a um tarif\xE1rio regulado?',icon:__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__images_ic_alert_component_svg___default.a,null),onClose:function onClose(){return _this3.toggleJoinModal();}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'column',gap:'16px',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Disclaimer,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(DisclaimerTitle,null,'Esclarecimentos'),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(DisclaimerText,null,'De acordo com a legisla\xE7\xE3o em vigor, os consumidores do mercado liberalizado que pretendam regressar ao mercado regulado devem contactar o comercializador de \xFAltimo recurso.'),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(DisclaimerTitle,null,translations.ESCLARECIMENTO_CONTACTE)),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{style:{display:'flex',placeItems:'center',width:'50%',flex:1}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__ButtonGradientV2__["a" /* default */],{onClick:function onClick(){_this3.setState({joinModal:false});}},'Fechar'))));}else{return null;}}},{key:'renderDetailsModal',value:function renderDetailsModal(){var _this4=this;var _state2=this.state,detailsModal=_state2.detailsModal,adhesionTariff=_state2.adhesionTariff,priceListTimeCycle=_state2.priceListTimeCycle;var loading=this.props.loading;return detailsModal&&adhesionTariff?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__DetailsModalV2__["a" /* default */],{hasBtns:true,modalTriggerHeight:this.props.modalTriggerHeight,setModalTriggerHeight:this.props.setModalTriggerHeight,tariff:adhesionTariff,tariffInfo:this.props.tariffInfo,priceListTimeCycle:priceListTimeCycle,onClose:function onClose(){_this4.actions.resetTariffInfo();_this4.setState({detailsModal:false,adhesionTariff:null});},loading:loading,onJoin:function onJoin(tariff){_this4.toggleDetailsModal(null);_this4.toggleJoinModal(tariff);}}):null;}/** Lonely boy */},{key:'render',value:function render(){var _this5=this;var _props3=this.props,results=_props3.results,bestAnnualBilling=_props3.bestAnnualBilling,count=_props3.count,restProps=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props3,['results','bestAnnualBilling','count']);return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Wrapper,restProps,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(TitleRow,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h3',null,'Resultados (',count,')'),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ButtonOutlineV2__["a" /* default */],{setModalTriggerHeight:this.props.setModalTriggerHeight,style:{maxWidth:'180px'},onClick:this.toggleCompareModal,disabled:this.disableCompareModal()},'Comparar Resultados')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(ResultsWrapper,null,results.map(function(result,index){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ResultTarifV2__["a" /* default */],{key:'result_tariff_card_'+index+'_'+result.id,index:index,bestAnnualBilling:bestAnnualBilling,setCompare:_this5.setCompareItem,compareList:_this5.props.compareList,toggleJoinModal:_this5.toggleJoinModal,toggleDetailsModal:_this5.toggleDetailsModal,result:result,setModalTriggerHeight:_this5.props.setModalTriggerHeight});})),this.renderJoinModal(),this.renderDetailsModal(),this.renderCompareModalModal());}}]);return ResultsSectionV2;}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]))||_class;var Wrapper=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject);var TitleRow=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject2);var ResultsWrapper=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject3);var Disclaimer=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject4);var DisclaimerTitle=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].span(_templateObject5);var DisclaimerText=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject6,function(_ref2){var red=_ref2.red;return red&&'\n  color: indianred;\n  ';});

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResultsSectionMobileV2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__logic__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ResultTarifMobileV2__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DetailsModalV2_mobile__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__JoinTariffModalV2_mobile__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CompareModalV2_mobile__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_containers_FiltersSectionV2__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ButtonCompareMobileV2__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ButtonFiltersMobileVe__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__SmallModalV2__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ButtonGradientV2__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_ic_alert_component_svg__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_ic_alert_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__images_ic_alert_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_ic_sort_component_svg__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_ic_sort_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__images_ic_sort_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_utils__ = __webpack_require__(11);
var _class;var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: flex-start;\n\n  @media screen and (min-width: 800px) {\n    padding-inline: 80px;\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: flex-start;\n\n  @media screen and (min-width: 800px) {\n    padding-inline: 80px;\n  }\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 56px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 12px 0px;\n\n  h3 {\n    flex: 1 0 0;\n    color: #1d1e22;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n    letter-spacing: 1px;\n    margin: 0;\n    text-transform: none;\n    text-align: start;\n  }\n\n  > .options {\n    display: flex;\n    padding: 12px;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 24px;\n    align-self: stretch;\n\n    > .iconWrapper {\n      cursor: pointer;\n      width: 20px;\n      height: 20px;\n    }\n  }\n'],['\n  height: 56px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 12px 0px;\n\n  h3 {\n    flex: 1 0 0;\n    color: #1d1e22;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n    letter-spacing: 1px;\n    margin: 0;\n    text-transform: none;\n    text-align: start;\n  }\n\n  > .options {\n    display: flex;\n    padding: 12px;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 24px;\n    align-self: stretch;\n\n    > .iconWrapper {\n      cursor: pointer;\n      width: 20px;\n      height: 20px;\n    }\n  }\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n  padding-bottom: 24px;\n'],['\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n  padding-bottom: 24px;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding: 20px 0;\n'],['\n  padding: 20px 0;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  font-weight: bold;\n  margin-bottom: 10px;\n  color: #93c13e;\n  font-size: 16px;\n'],['\n  display: block;\n  font-weight: bold;\n  margin-bottom: 10px;\n  color: #93c13e;\n  font-size: 16px;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin-bottom: 10px;\n  font-size: 14px;\n\n  ','\n'],['\n  margin-bottom: 10px;\n  font-size: 14px;\n\n  ','\n']);var ResultsSectionMobileV2=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__logic__["a" /* default */])(_class=function(_Component){__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ResultsSectionMobileV2,_Component);function ResultsSectionMobileV2(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this,ResultsSectionMobileV2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=ResultsSectionMobileV2.__proto__||Object.getPrototypeOf(ResultsSectionMobileV2)).call.apply(_ref,[this].concat(args))),_this),_this.state={detailsModal:false,joinModal:false,filtersModal:false,adhesionTariff:null},_this.setCompareItem=function(id){var newList=[].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(_this.props.compareList));if(newList.includes(id)){var index=newList.indexOf(id);newList.splice(index,1);}else{if(newList.length===2){return;}newList.push(id);}_this.actions.setCompareList(newList);},_this.disableCompareModal=function(){return _this.props.compareList.length===0||_this.props.compareList.length>2;},_this.toggleCompareModal=function(){_this.actions.toggleCompareModal(!_this.props.compareModal);},_this.toggleDetailsModal=function(tariff){if(tariff){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_utils__["e" /* sendGevent */])('simulador','Saber mais','Saber mais sobre um tarifário');tariff&&_this.actions.fetchTariffInfo(tariff);}var tariffPriceListTimeCycle=tariff&&tariff.priceListTimeCycle;_this.setState({detailsModal:!_this.state.detailsModal,adhesionTariff:tariff,priceListTimeCycle:tariffPriceListTimeCycle||null});},_this.toggleJoinModal=function(tariff){if(tariff){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_utils__["e" /* sendGevent */])('simulador','Aderir','Aderir a um tarifário');tariff&&_this.actions.fetchTariffInfo(tariff);}else{_this.actions.setTariffInfo(null);}_this.setState({adhesionTariff:tariff,joinModal:!_this.state.joinModal});},_temp),__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}/**
   * Opens/Closes Compare modal
   *//**
   * Opens/Closes Details modal
   *//**
   * Opens/Closes join modal
   */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ResultsSectionMobileV2,[{key:'renderMobileFiltersModal',value:function renderMobileFiltersModal(){var _this2=this;var filtersModal=this.state.filtersModal;return filtersModal?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_containers_FiltersSectionV2__["a" /* default */],{isMobile:true,simulation:this.props.simulation,setModalTriggerHeight:this.props.setModalTriggerHeight,modalTriggerHeight:this.props.modalTriggerHeight,changePage:this.props.changePage,onClose:function onClose(){return _this2.setState({filtersModal:false});}}):null;}},{key:'renderCompareModal',value:function renderCompareModal(){var _this3=this;var _props=this.props,compareModal=_props.compareModal,compareList=_props.compareList;return compareModal?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__CompareModalV2_mobile__["a" /* default */],{onClose:function onClose(){return _this3.actions.toggleCompareModal(false);},compareList:compareList,simulation:this.props.simulation,setModalTriggerHeight:this.props.setModalTriggerHeight,modalTriggerHeight:this.props.modalTriggerHeight,onJoin:function onJoin(tariff){_this3.toggleCompareModal();_this3.toggleJoinModal(tariff);}}):null;}},{key:'renderJoinModal',value:function renderJoinModal(){var _this4=this;var _props2=this.props,simulation=_props2.simulation,tariffInfo=_props2.tariffInfo,translations=_props2.translations;var _state=this.state,joinModal=_state.joinModal,adhesionTariff=_state.adhesionTariff;if(joinModal&&adhesionTariff&&tariffInfo&&!tariffInfo.pricelistadditionalinfo.is_regulated){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__JoinTariffModalV2_mobile__["a" /* default */],Object.assign({},this.props,{setModalTriggerHeight:this.props.setModalTriggerHeight,modalTriggerHeight:this.props.modalTriggerHeight,tariff:adhesionTariff,tariffInfo:tariffInfo,changeTariff:this.toggleJoinModal,simulation:simulation,isHome:false}));}else if(joinModal&&adhesionTariff&&tariffInfo&&tariffInfo.pricelistadditionalinfo.is_regulated){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__SmallModalV2__["a" /* default */],{style:{width:'500px',height:'450px'},title:'Aderir a um tarif\xE1rio regulado?',icon:__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__images_ic_alert_component_svg___default.a,null),onClose:function onClose(){return _this4.toggleJoinModal();}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'column',gap:'16px',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Disclaimer,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(DisclaimerTitle,null,'Esclarecimentos'),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(DisclaimerText,null,'De acordo com a legisla\xE7\xE3o em vigor, os consumidores do mercado liberalizado que pretendam regressar ao mercado regulado devem contactar o comercializador de \xFAltimo recurso.'),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(DisclaimerTitle,null,translations.ESCLARECIMENTO_CONTACTE)),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{style:{display:'flex',placeItems:'center',width:'50%',flex:1}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ButtonGradientV2__["a" /* default */],{onClick:function onClick(){_this4.setState({joinModal:false});}},'Fechar'))));}else{return null;}}},{key:'renderDetailsModal',value:function renderDetailsModal(){var _this5=this;var _state2=this.state,detailsModal=_state2.detailsModal,adhesionTariff=_state2.adhesionTariff,priceListTimeCycle=_state2.priceListTimeCycle;var loading=this.props.loading;return detailsModal&&adhesionTariff?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__DetailsModalV2_mobile__["a" /* default */],{hasBtns:true,setModalTriggerHeight:this.props.setModalTriggerHeight,modalTriggerHeight:this.props.modalTriggerHeight,tariff:adhesionTariff,tariffInfo:this.props.tariffInfo,priceListTimeCycle:priceListTimeCycle,loading:loading,onClose:function onClose(){_this5.actions.resetTariffInfo();_this5.setState({detailsModal:false,adhesionTariff:null});},onJoin:function onJoin(tariff){_this5.toggleDetailsModal(null);_this5.toggleJoinModal(tariff);}}):null;}/** Lonely boy */},{key:'render',value:function render(){var _this6=this;var _props3=this.props,results=_props3.results,bestAnnualBilling=_props3.bestAnnualBilling,count=_props3.count,restProps=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props3,['results','bestAnnualBilling','count']);return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Wrapper,restProps,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(TitleRow,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('h3',null,'Resultados (',count,')'),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'options'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ButtonCompareMobileV2__["a" /* default */],{setModalTriggerHeight:this.props.setModalTriggerHeight,onClick:this.toggleCompareModal,disabled:this.disableCompareModal()}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__ButtonFiltersMobileVe__["a" /* default */],{setModalTriggerHeight:this.props.setModalTriggerHeight,onClick:function onClick(){return _this6.setState({filtersModal:!_this6.state.filtersModal});}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__images_ic_sort_component_svg___default.a,null)))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(ResultsWrapper,null,results.map(function(result,index){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ResultTarifMobileV2__["a" /* default */],{key:'result_tariff_card_'+index+'_'+result.id,index:index,bestAnnualBilling:bestAnnualBilling,setCompare:_this6.setCompareItem,compareList:_this6.props.compareList,toggleJoinModal:_this6.toggleJoinModal,toggleDetailsModal:_this6.toggleDetailsModal,result:result,setModalTriggerHeight:_this6.props.setModalTriggerHeight});})),this.renderJoinModal(),this.renderDetailsModal(),this.renderCompareModal(),this.renderMobileFiltersModal());}}]);return ResultsSectionMobileV2;}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]))||_class;var Wrapper=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject);var TitleRow=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject2);var ResultsWrapper=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject3);var Disclaimer=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject4);var DisclaimerTitle=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].span(_templateObject5);var DisclaimerText=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject6,function(_ref2){var red=_ref2.red;return red&&'\n  color: indianred;\n  ';});

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(1);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: flex-start;\n  gap: 4px;\n  align-self: stretch;\n'],['\n  display: flex;\n  align-items: flex-start;\n  gap: 4px;\n  align-self: stretch;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  overflow: hidden;\n  color: #1d1e22;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  text-overflow: ellipsis;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px;\n  letter-spacing: 1px;\n  margin: 0;\n\n  @media screen and (min-width: 1000px) {\n    font-size: 18px;\n  }\n'],['\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  overflow: hidden;\n  color: #1d1e22;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  text-overflow: ellipsis;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px;\n  letter-spacing: 1px;\n  margin: 0;\n\n  @media screen and (min-width: 1000px) {\n    font-size: 18px;\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  overflow: hidden;\n  color: #f00;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  text-overflow: ellipsis;\n  font-family: Nunito;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px; /* 200% */\n  letter-spacing: 1px;\n  margin: 0;\n'],['\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  overflow: hidden;\n  color: #f00;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  text-overflow: ellipsis;\n  font-family: Nunito;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px; /* 200% */\n  letter-spacing: 1px;\n  margin: 0;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  overflow: hidden;\n  color: #3e3e3e;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  text-overflow: ellipsis;\n\n  /* Label 02/Regular */\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n  margin: 0;\n'],['\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  overflow: hidden;\n  color: #3e3e3e;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  text-overflow: ellipsis;\n\n  /* Label 02/Regular */\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n  margin: 0;\n']);var SectionHeader=function SectionHeader(_ref){var title=_ref.title,subTitle=_ref.subTitle,required=_ref.required,props=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref,['title','subTitle','required']);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Wrapper,{className:props.className},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(TitleRow,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Title,null,title),required&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Required,null,'*')),subTitle&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(SubTitle,null,subTitle));};SectionHeader.defaultProps={required:true};SectionHeader.propTypes={title:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,subTitle:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,required:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};var Wrapper=__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"].div(_templateObject);var TitleRow=__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"].div(_templateObject2);var Title=__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"].h1(_templateObject3);var Required=__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"].p(_templateObject4);var SubTitle=__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"].p(_templateObject5);/* harmony default export */ __webpack_exports__["a"] = (SectionHeader);

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  width: 100%;\n  padding: 20px;\n  flex-direction: column;\n  gap: 14px;\n  border-bottom: 1px solid #ececec;\n  background: #ffffff;\n\n  @media screen and (min-width: 750px) {\n    padding-inline: 100px;\n  }\n'],['\n  display: flex;\n  width: 100%;\n  padding: 20px;\n  flex-direction: column;\n  gap: 14px;\n  border-bottom: 1px solid #ececec;\n  background: #ffffff;\n\n  @media screen and (min-width: 750px) {\n    padding-inline: 100px;\n  }\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex: 1 0 0;\n'],['\n  display: flex;\n  flex: 1 0 0;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #1d1e22;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px; /* 150% */\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  margin: 0;\n'],['\n  color: #1d1e22;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px; /* 150% */\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  margin: 0;\n']);var SectionMobileV2=function SectionMobileV2(_ref){var style=_ref.style,className=_ref.className,id=_ref.id,title=_ref.title,children=_ref.children;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Wrapper,{style:style,className:className,id:id},title&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Title,null,title),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.map(children,function(child){if(__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(child)&&child.props['data-slot'])return;return child;})));};/* harmony default export */ __webpack_exports__["a"] = (SectionMobileV2);var Wrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject);var Container=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject2);var Title=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].h2(_templateObject3);

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  width: 100%;\n  padding: 32px 20px;\n  align-items: flex-start;\n  gap: 32px;\n  border-bottom: 1px solid #ececec;\n  background: #ffffff;\n  max-width: 1200px;\n  margin-inline: auto;\n\n  @media screen and (min-width: 1300px) {\n    padding-inline: 0px;\n  }\n'],['\n  display: flex;\n  width: 100%;\n  padding: 32px 20px;\n  align-items: flex-start;\n  gap: 32px;\n  border-bottom: 1px solid #ececec;\n  background: #ffffff;\n  max-width: 1200px;\n  margin-inline: auto;\n\n  @media screen and (min-width: 1300px) {\n    padding-inline: 0px;\n  }\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: flex-end;\n  gap: 12px;\n  flex-shrink: 0;\n  min-width: 576px;\n'],['\n  display: flex;\n  align-items: flex-end;\n  gap: 12px;\n  flex-shrink: 0;\n  min-width: 576px;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #1d1e22;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 42px; /* 210% */\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  min-width: 270px;\n  margin: 0;\n'],['\n  color: #1d1e22;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 42px; /* 210% */\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  min-width: 270px;\n  margin: 0;\n']);var SectionV2=function SectionV2(_ref){var style=_ref.style,className=_ref.className,id=_ref.id,title=_ref.title,subtitle=_ref.subtitle,grey=_ref.grey,children=_ref.children,noContainer=_ref.noContainer;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Wrapper,{style:style,className:className+' question',grey:grey,id:id},title&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Title,null,title),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.map(children,function(child,i){if(__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(child)&&child.props['data-slot'])return;return child;})));};/* harmony default export */ __webpack_exports__["a"] = (SectionV2);var Wrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject);var Container=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject2);var Title=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].h2(_templateObject3);

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Select__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_ic_arrow_more_svg__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_ic_arrow_more_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_ic_arrow_more_svg__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-size: 14px;\n  font-weight: bold;\n  text-align: left;\n  width: 100%;\n  display: block;\n  font-family: \'Nunito\';\n  color: #676767;\n  font-family: Nunito;\n  font-weight: 600;\n  line-height: 14px;\n  position: relative;\n'],['\n  font-size: 14px;\n  font-weight: bold;\n  text-align: left;\n  width: 100%;\n  display: block;\n  font-family: \'Nunito\';\n  color: #676767;\n  font-family: Nunito;\n  font-weight: 600;\n  line-height: 14px;\n  position: relative;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  max-width: 100%;\n  height: 40px;\n  box-sizing: border-box;\n  margin-top: 8px;\n\n  &:first-child > div:first-child {\n    height: 100%;\n    box-sizing: border-box;\n    border: 1px solid #dedede;\n  }\n'],['\n  width: 100%;\n  max-width: 100%;\n  height: 40px;\n  box-sizing: border-box;\n  margin-top: 8px;\n\n  &:first-child > div:first-child {\n    height: 100%;\n    box-sizing: border-box;\n    border: 1px solid #dedede;\n  }\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: absolute;\n  background: url(',') no-repeat;\n  background-size: contain;\n  width: 12px;\n  height: 12px;\n  top: 39px;\n  right: 10px;\n  transform: rotate(90deg);\n'],['\n  position: absolute;\n  background: url(',') no-repeat;\n  background-size: contain;\n  width: 12px;\n  height: 12px;\n  top: 39px;\n  right: 10px;\n  transform: rotate(90deg);\n']);var SelectInput=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SelectInput,_Component);function SelectInput(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,SelectInput);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=SelectInput.__proto__||Object.getPrototypeOf(SelectInput)).call.apply(_ref,[this].concat(args))),_this),_this.changeHandler=function(selected){_this.props.onChange(selected.value);},_temp),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SelectInput,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Label,null,this.props.label,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InnerSelect,{items:this.props.items,selected:this.props.selected,onChange:this.changeHandler,placeholder:this.props.placeholder,disabled:this.props.disabled}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ArrowIcon,null));}}]);return SelectInput;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);var Label=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].label(_templateObject);var InnerSelect=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_6_components_Select__["a" /* default */])(_templateObject2);var ArrowIcon=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject3,__WEBPACK_IMPORTED_MODULE_8__assets_ic_arrow_more_svg___default.a);/* harmony default export */ __webpack_exports__["a"] = (SelectInput);

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 32px;\n  gap: 16px;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 32px;\n  gap: 16px;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  overflow: hidden;\n  color: #1d1e22;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  text-overflow: ellipsis;\n  font-family: Nunito;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px; /* 133.333% */\n  letter-spacing: 1px;\n  margin: 0;\n  text-transform: unset;\n'],['\n  overflow: hidden;\n  color: #1d1e22;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  text-overflow: ellipsis;\n  font-family: Nunito;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px; /* 133.333% */\n  letter-spacing: 1px;\n  margin: 0;\n  text-transform: unset;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  overflow: hidden;\n  color: #3e3e3e;\n  text-align: center;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  text-overflow: ellipsis;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n  margin: 0;\n'],['\n  overflow: hidden;\n  color: #3e3e3e;\n  text-align: center;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  text-overflow: ellipsis;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n  margin: 0;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  align-self: stretch;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  align-self: stretch;\n']);var SimulationTimeouErrorV2=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SimulationTimeouErrorV2,_Component);function SimulationTimeouErrorV2(){__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,SimulationTimeouErrorV2);return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(SimulationTimeouErrorV2.__proto__||Object.getPrototypeOf(SimulationTimeouErrorV2)).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SimulationTimeouErrorV2,[{key:'render',value:function render(){var children=this.props.children;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Content,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Title,null,'Erro do Servidor'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Text,null,'O servidor encontrou um problema e n\xE3o conseguiu processar o seu pedido.'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Text,null,'Por favor tente novamente.')),children));}}]);return SimulationTimeouErrorV2;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SimulationTimeouErrorV2);var Wrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject);var Title=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].h3(_templateObject2);var Text=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].p(_templateObject3);var Content=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject4);

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StarRating; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  gap: 4px;\n'],['\n  display: flex;\n  align-items: center;\n  gap: 4px;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding: 0;\n  border: none;\n  background: none;\n  cursor: pointer;\n  line-height: 0;\n\n  svg path {\n    fill: ',';\n    transition: fill 0.15s ease;\n  }\n'],['\n  padding: 0;\n  border: none;\n  background: none;\n  cursor: pointer;\n  line-height: 0;\n\n  svg path {\n    fill: ',';\n    transition: fill 0.15s ease;\n  }\n']);/**
 * Avaliação por estrelas (1 a 5), fiel ao rating.php do WordPress antigo.
 *
 * Props:
 *  - value: número (1..5) atualmente selecionado (0/undefined = nenhuma).
 *  - onChange: (value) => void chamado ao clicar numa estrela.
 *  - name: string usada nos ids/acessibilidade (equivalente a rating_1/2/3).
 */var StarRating=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(StarRating,_Component);function StarRating(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,StarRating);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=StarRating.__proto__||Object.getPrototypeOf(StarRating)).call.apply(_ref,[this].concat(args))),_this),_this.state={hover:0},_this.handleEnter=function(value){return _this.setState({hover:value});},_this.handleLeave=function(){return _this.setState({hover:0});},_temp),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(StarRating,[{key:'render',value:function render(){var _this2=this;var _props=this.props,_props$value=_props.value,value=_props$value===undefined?0:_props$value,onChange=_props.onChange,name=_props.name;var hover=this.state.hover;var active=hover||value;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Stars,{onMouseLeave:this.handleLeave},[1,2,3,4,5].map(function(star){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Star,{key:star,type:'button','aria-label':star+' de 5','data-name':name,filled:star<=active,onMouseEnter:function onMouseEnter(){return _this2.handleEnter(star);},onClick:function onClick(){return onChange&&onChange(star);}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('svg',{width:'28',height:'28',viewBox:'0 0 24 24'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('path',{d:'M12 17.27l5.18 3.12-1.37-5.9 4.58-3.97-6.03-.52L12 4.5 9.64 10l-6.03.52 4.58 3.97-1.37 5.9L12 17.27z'})));}));}}]);return StarRating;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);var Stars=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject);var Star=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].button(_templateObject2,function(_ref2){var filled=_ref2.filled;return filled?'#93c13e':'#ececec';});

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n'],['\n  width: 100%;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  margin-top: 4px;\n'],['\n  display: flex;\n  margin-top: 4px;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #676767;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 19px;\n  text-align: left;\n  width: 100%;\n  display: block;\n'],['\n  color: #676767;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 19px;\n  text-align: left;\n  width: 100%;\n  display: block;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  visibility: hidden;\n  z-index: 6;\n\n  &:checked {\n    ~ div {\n      background: linear-gradient(270deg, #006736 0%, #93c13e 100%);\n      &::before {\n        background: #ffffff;\n      }\n    }\n  }\n'],['\n  display: block;\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  visibility: hidden;\n  z-index: 6;\n\n  &:checked {\n    ~ div {\n      background: linear-gradient(270deg, #006736 0%, #93c13e 100%);\n      &::before {\n        background: #ffffff;\n      }\n    }\n  }\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  position: relative;\n  float: left;\n  padding-left: 24px;\n  margin-right: 24px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 21px;\n\n  ','\n\n  &:before,\n  &:after {\n    content: \'\';\n    display: table;\n  }\n\n  &:after {\n    clear: both;\n  }\n\n  zoom: 1;\n\n  ',';\n'],['\n  display: block;\n  position: relative;\n  float: left;\n  padding-left: 24px;\n  margin-right: 24px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 21px;\n\n  ','\n\n  &:before,\n  &:after {\n    content: \'\';\n    display: table;\n  }\n\n  &:after {\n    clear: both;\n  }\n\n  zoom: 1;\n\n  ',';\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  border: 1px solid #9c9c9c;\n  background-color: #ffffff;\n  top: 3px;\n  left: 3px;\n  border-radius: 100%;\n  z-index: 5;\n  cursor: pointer;\n  box-sizing: initial !important;\n\n  ','\n\n  &::before {\n    display: block;\n    position: absolute;\n    content: \'\';\n    border-radius: 100%;\n    height: 8px;\n    width: 8px;\n    top: 3px;\n    left: 3px;\n    background: #ffffff;\n  }\n'],['\n  display: block;\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  border: 1px solid #9c9c9c;\n  background-color: #ffffff;\n  top: 3px;\n  left: 3px;\n  border-radius: 100%;\n  z-index: 5;\n  cursor: pointer;\n  box-sizing: initial !important;\n\n  ','\n\n  &::before {\n    display: block;\n    position: absolute;\n    content: \'\';\n    border-radius: 100%;\n    height: 8px;\n    width: 8px;\n    top: 3px;\n    left: 3px;\n    background: #ffffff;\n  }\n']);var RadioGroup=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(RadioGroup,_Component);function RadioGroup(){__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,RadioGroup);return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(RadioGroup.__proto__||Object.getPrototypeOf(RadioGroup)).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(RadioGroup,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Label,null,this.props.label),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Flexer,null,this.props.items.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(RadioLabel,{key:item.value,disabled:_this2.props.disabled},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Input,{type:'radio',defaultChecked:_this2.props.default===item.value,value:item.value,name:_this2.props.name,onClick:function onClick(e){return _this2.props.disabled?e.preventDefault():_this2.props.onClick(e.target.value);}}),item.label,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Check,{disabled:_this2.props.disabled}));})));}}]);return RadioGroup;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);RadioGroup.defaultProps={disabled:false};RadioGroup.propTypes={label:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,name:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,items:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object),onClick:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,default:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string};var Container=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject);var Flexer=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject2);var Label=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].label(_templateObject3);var Input=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].input(_templateObject4);var RadioLabel=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].label(_templateObject5,function(_ref){var disabled=_ref.disabled;return!disabled&&'\n    &:hover {\n      div {\n        background: linear-gradient(270deg, #006736 0%, #93C13E 100%);\n        &::before  {\n          background: #FFFFFF;\n        }\n      }\n    }\n  ';},function(_ref2){var disabled=_ref2.disabled;return disabled&&'opacity: 0.5';});var Check=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject6,function(_ref3){var disabled=_ref3.disabled;return disabled&&'\n    opacity: 0.5;';});/* harmony default export */ __webpack_exports__["a"] = (RadioGroup);

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Svg_remove_component_svg__ = __webpack_require__(1653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Svg_remove_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_Svg_remove_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_DatePicker__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_validations__ = __webpack_require__(48);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  border: 1px solid #9c9c9c;\n  margin: 20px auto;\n  display: flex;\n  align-items: flex-start;\n  max-width: 1024px;\n  padding: 20px 10px;\n\n  @media screen and (max-width: 768px) {\n    max-width: 90%;\n    flex-wrap: wrap;\n  }\n'],['\n  border: 1px solid #9c9c9c;\n  margin: 20px auto;\n  display: flex;\n  align-items: flex-start;\n  max-width: 1024px;\n  padding: 20px 10px;\n\n  @media screen and (max-width: 768px) {\n    max-width: 90%;\n    flex-wrap: wrap;\n  }\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  flex: ',';\n  padding: 0 10px;\n  position: relative;\n  box-sizing: border-box;\n\n  &.invalid {\n    .SingleDatePickerInput {\n      border-color: indianred;\n    }\n  }\n\n  @media (max-width: 767px) {\n    flex: 1;\n  }\n'],['\n  display: block;\n  flex: ',';\n  padding: 0 10px;\n  position: relative;\n  box-sizing: border-box;\n\n  &.invalid {\n    .SingleDatePickerInput {\n      border-color: indianred;\n    }\n  }\n\n  @media (max-width: 767px) {\n    flex: 1;\n  }\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  text-transform: uppercase;\n  font-size: 10px;\n  font-weight: bold;\n\n  display: block;\n  margin-bottom: 8px;\n  text-align: left;\n  box-sizing: border-box;\n  @media (min-width: 767px) {\n    ','\n  }\n'],['\n  text-transform: uppercase;\n  font-size: 10px;\n  font-weight: bold;\n\n  display: block;\n  margin-bottom: 8px;\n  text-align: left;\n  box-sizing: border-box;\n  @media (min-width: 767px) {\n    ','\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #bababa;\n  font-size: 16px;\n  line-height: 16px;\n  letter-spacing: 1px;\n  color: #3e3e3e;\n  box-sizing: border-box;\n\n  &.invalid {\n    border-color: indianred;\n  }\n'],['\n  display: block;\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #bababa;\n  font-size: 16px;\n  line-height: 16px;\n  letter-spacing: 1px;\n  color: #3e3e3e;\n  box-sizing: border-box;\n\n  &.invalid {\n    border-color: indianred;\n  }\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex: 0.5;\n  position: relative;\n\n  @media (max-width: 767px) {\n    flex: 1;\n    align-items: flex-end;\n  }\n\n  > div {\n    flex: 1;\n    width: 100%;\n  }\n'],['\n  display: flex;\n  flex: 0.5;\n  position: relative;\n\n  @media (max-width: 767px) {\n    flex: 1;\n    align-items: flex-end;\n  }\n\n  > div {\n    flex: 1;\n    width: 100%;\n  }\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  @media (max-width: 767px) {\n    flex-direction: column;\n    flex: 1;\n    margin-bottom: 8px;\n    min-width: 100%;\n  }\n'],['\n  @media (max-width: 767px) {\n    flex-direction: column;\n    flex: 1;\n    margin-bottom: 8px;\n    min-width: 100%;\n  }\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin-left: auto;\n  border: 0;\n  background: none;\n  outline: none;\n  padding: 20px;\n  cursor: pointer;\n\n  @media (max-width: 767px) {\n    align-self: center;\n  }\n'],['\n  margin-left: auto;\n  border: 0;\n  background: none;\n  outline: none;\n  padding: 20px;\n  cursor: pointer;\n\n  @media (max-width: 767px) {\n    align-self: center;\n  }\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-size: 10px;\n  text-transform: initial;\n'],['\n  font-size: 10px;\n  text-transform: initial;\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  font-size: 12px;\n  color: indianred;\n  margin: 10px auto;\n  margin-bottom: 0;\n  text-align: left;\n'],['\n  display: block;\n  font-size: 12px;\n  color: indianred;\n  margin: 10px auto;\n  margin-bottom: 0;\n  text-align: left;\n']);var _onChange=function _onChange(event,cb){var re=/^[0-9\b,]+$/;if(event.target.value&&!re.test(event.target.value)){return false;}cb();};var getMinHeight=function getMinHeight(consumptionDisaggregation){if(consumptionDisaggregation==='vcp'){return'30';}else if(consumptionDisaggregation==='vscp'){return'45';}return false;};var renderExtraInputs=function renderExtraInputs(_ref){var consumptionDisaggregation=_ref.consumptionDisaggregation,invalid=_ref.invalid,rest=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref,['consumptionDisaggregation','invalid']);switch(consumptionDisaggregation){case's':return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(InputWrapper,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Label,null,'Consumo Simples ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Lower,null,'(kWh)')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(InputDate,{type:'text',value:rest.simples,onChange:function onChange(e){return _onChange(e,function(){return rest.onChange({simples:e.target.value});});},className:invalid&&invalid.simples&&'invalid'}),invalid&&invalid.simples&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Error,null,__WEBPACK_IMPORTED_MODULE_7_validations__["b" /* Messages */][invalid.simples]&&__WEBPACK_IMPORTED_MODULE_7_validations__["b" /* Messages */][invalid.simples]('Simples')));case'vf':return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Multi,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(InputWrapper,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Label,null,'Consumo Vazio ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Lower,null,'(kWh)')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(InputDate,{type:'text',value:rest.simples,onChange:function onChange(e){return _onChange(e,function(){return rest.onChange({simples:e.target.value});});},className:invalid&&invalid.simples&&'invalid'}),invalid&&invalid.simples&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Error,null,__WEBPACK_IMPORTED_MODULE_7_validations__["b" /* Messages */][invalid.simples]&&__WEBPACK_IMPORTED_MODULE_7_validations__["b" /* Messages */][invalid.simples]('Vazio'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(InputWrapper,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Label,null,'Consumo Fora de Vazio ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Lower,null,'(kWh)')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(InputDate,{type:'text',value:rest.cheias,onChange:function onChange(e){return _onChange(e,function(){return rest.onChange({cheias:e.target.value});});},className:invalid&&invalid.cheias&&'invalid'}),invalid&&invalid.cheias&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Error,null,__WEBPACK_IMPORTED_MODULE_7_validations__["b" /* Messages */][invalid.cheias]&&__WEBPACK_IMPORTED_MODULE_7_validations__["b" /* Messages */][invalid.cheias]('Cheias'))));case'vcp':return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Multi,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(InputWrapper,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Label,{minHeight:'30'},'Consumo Vazio ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Lower,null,'(kWh)')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(InputDate,{type:'text',value:rest.simples,onChange:function onChange(e){return _onChange(e,function(){return rest.onChange({simples:e.target.value});});},className:invalid&&invalid.simples&&'invalid'}),invalid&&invalid.simples&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Error,null,__WEBPACK_IMPORTED_MODULE_7_validations__["b" /* Messages */][invalid.simples]&&__WEBPACK_IMPORTED_MODULE_7_validations__["b" /* Messages */][invalid.simples]('Vazio'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(InputWrapper,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Label,{minHeight:'30'},'Consumo Cheias ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Lower,null,'(kWh)')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(InputDate,{type:'text',value:rest.cheias,onChange:function onChange(e){return _onChange(e,function(){return rest.onChange({cheias:e.target.value});});},className:invalid&&invalid.cheias&&'invalid'}),invalid&&invalid.cheias&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Error,null,__WEBPACK_IMPORTED_MODULE_7_validations__["b" /* Messages */][invalid.cheias]&&__WEBPACK_IMPORTED_MODULE_7_validations__["b" /* Messages */][invalid.cheias]('Cheias'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(InputWrapper,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Label,{minHeight:'30'},'Consumo Ponta ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Lower,null,'(kWh)')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(InputDate,{type:'text',value:rest.ponta,onChange:function onChange(e){return _onChange(e,function(){return rest.onChange({ponta:e.target.value});});},className:invalid&&invalid.ponta&&'invalid'}),invalid&&invalid.ponta&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Error,null,__WEBPACK_IMPORTED_MODULE_7_validations__["b" /* Messages */][invalid.ponta]&&__WEBPACK_IMPORTED_MODULE_7_validations__["b" /* Messages */][invalid.ponta]('Cheias'))));case'vscp':return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Multi,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(InputWrapper,{flex:0.125},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Label,{minHeight:'45'},'Consumo Vazio ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Lower,null,'(kWh)')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(InputDate,{type:'text',value:rest.simples,onChange:function onChange(e){return _onChange(e,function(){return rest.onChange({simples:e.target.value});});},className:invalid&&invalid.simples&&'invalid'}),invalid&&invalid.simples&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Error,null,__WEBPACK_IMPORTED_MODULE_7_validations__["b" /* Messages */][invalid.simples]&&__WEBPACK_IMPORTED_MODULE_7_validations__["b" /* Messages */][invalid.simples]('Vazio'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(InputWrapper,{flex:0.125},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Label,{minHeight:'45'},'Consumo Super Vazio ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Lower,null,'(kWh)')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(InputDate,{type:'text',value:rest.svazio,onChange:function onChange(e){return _onChange(e,function(){return rest.onChange({svazio:e.target.value});});},className:invalid&&invalid.svazio&&'invalid'}),invalid&&invalid.svazio&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Error,null,__WEBPACK_IMPORTED_MODULE_7_validations__["b" /* Messages */][invalid.svazio]&&__WEBPACK_IMPORTED_MODULE_7_validations__["b" /* Messages */][invalid.svazio]('Super Vazio'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(InputWrapper,{flex:0.125},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Label,{minHeight:'45'},'Consumo Cheias ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Lower,null,'(kWh)')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(InputDate,{type:'text',value:rest.cheias,onChange:function onChange(e){return _onChange(e,function(){return rest.onChange({cheias:e.target.value});});},className:invalid&&invalid.cheias&&'invalid'}),invalid&&invalid.cheias&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Error,null,__WEBPACK_IMPORTED_MODULE_7_validations__["b" /* Messages */][invalid.cheias]&&__WEBPACK_IMPORTED_MODULE_7_validations__["b" /* Messages */][invalid.cheias]('Cheias'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(InputWrapper,{flex:0.125},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Label,{minHeight:'45'},'Consumo Ponta ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Lower,null,'(kWh)')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(InputDate,{type:'text',value:rest.ponta,onChange:function onChange(e){return _onChange(e,function(){return rest.onChange({ponta:e.target.value});});},className:invalid&&invalid.ponta&&'invalid'}),invalid&&invalid.ponta&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Error,null,__WEBPACK_IMPORTED_MODULE_7_validations__["b" /* Messages */][invalid.ponta]&&__WEBPACK_IMPORTED_MODULE_7_validations__["b" /* Messages */][invalid.ponta]('Cheias'))));default:return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(InputWrapper,{flex:0.5},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Label,null,'Consumo ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Lower,null,'(kWh)')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(InputDate,{type:'text',value:rest.consumption,onChange:function onChange(e){return _onChange(e,function(){return rest.onChange({consumption:e.target.value});});},className:invalid&&invalid.consumption&&'invalid'}),invalid&&invalid.consumption&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Error,null,__WEBPACK_IMPORTED_MODULE_7_validations__["b" /* Messages */][invalid.consumption]&&__WEBPACK_IMPORTED_MODULE_7_validations__["b" /* Messages */][invalid.consumption]('Consumo')));}};/* harmony default export */ __webpack_exports__["a"] = (function(_ref2){var children=_ref2.children,nextMonth=_ref2.nextMonth,all=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref2,['children','nextMonth']);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(DateMulti,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(InputWrapper,{className:all.invalid&&(all.invalid==='startDateVendDate'||all.invalid==='datesMustBeBiggerThanTheOthers')&&'invalid'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Label,{minHeight:getMinHeight(all.consumptionDisaggregation)},'Data de in\xEDcio'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_DatePicker__["a" /* default */],{value:all.startDate&&__WEBPACK_IMPORTED_MODULE_4_moment___default()(all.startDate),placeholder:'Data de in\xEDcio',onChange:function onChange(_ref3){var date=_ref3.date;return all.onChange({startDate:date&&date.format('YYYY-MM-DD')||date});},initialVisibleMonth:function initialVisibleMonth(){return all.startDate?__WEBPACK_IMPORTED_MODULE_4_moment___default()(all.startDate):nextMonth||__WEBPACK_IMPORTED_MODULE_4_moment___default()();}}),all.invalid&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Error,null,__WEBPACK_IMPORTED_MODULE_7_validations__["b" /* Messages */][all.invalid]&&__WEBPACK_IMPORTED_MODULE_7_validations__["b" /* Messages */][all.invalid]('Data de in\xEDcio'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(InputWrapper,{className:all.invalid&&(all.invalid==='startDateVendDate'||all.invalid==='datesMustBeBiggerThanTheOthers')&&'invalid'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Label,{minHeight:getMinHeight(all.consumptionDisaggregation)},'Data de fim'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_DatePicker__["a" /* default */],{value:all.endDate&&__WEBPACK_IMPORTED_MODULE_4_moment___default()(all.endDate),placeholder:'Data de fim',onChange:function onChange(_ref4){var date=_ref4.date;return all.onChange({endDate:date&&date.format('YYYY-MM-DD')||date});},initialVisibleMonth:function initialVisibleMonth(){return all.endDate?__WEBPACK_IMPORTED_MODULE_4_moment___default()(all.endDate):nextMonth||__WEBPACK_IMPORTED_MODULE_4_moment___default()();}}),all.invalid&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Error,null,__WEBPACK_IMPORTED_MODULE_7_validations__["b" /* Messages */][all.invalid]&&__WEBPACK_IMPORTED_MODULE_7_validations__["b" /* Messages */][all.invalid]('Data de fim')))),renderExtraInputs(all),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Remove,{onClick:function onClick(){return all.onRemove();}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Svg_remove_component_svg___default.a,null)),children);});var Wrapper=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject);var InputWrapper=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject2,function(_ref5){var flex=_ref5.flex;return flex||0.25;});var Label=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].label(_templateObject3,function(_ref6){var minHeight=_ref6.minHeight;return minHeight&&'min-height: '+minHeight+'px;';});var InputDate=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].input(_templateObject4);var Multi=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject5);var DateMulti=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"])(Multi)(_templateObject6);var Remove=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].button(_templateObject7);var Lower=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].span(_templateObject8);var Error=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].span(_templateObject9);

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TITLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MERCHANT_IDENTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SUPPORT_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BILLING_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONTRACT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PAYMENT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ADDITIONAL_RESTRICTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return COMERCIAL_CONDITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ADDITIONAL_SERVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return REFUNDS_ENTRIES; });
var TITLES={IDENTIFICATION:'Identificação',COMERCIAL_CONDITIONS:'Condições comerciais',ADDITIONAL_SERVICES:'Serviços adicionais (obrigatórios e opcionais)',REFUNDS:'Reembolsos'};var MERCHANT_IDENTIFICATION={designation:'Oferta comercial',commercial_offer_modality:'Modalidade da oferta comercial',description:'Descrição da oferta comercial',market_segment_type:'Segmento da oferta',commercial_offer_website:'Endereço web da oferta comercial',website_standardized_contract_form:'Endereço web da ficha contratual padronizada',website_contract_conditions:'Endereço web das condições gerais do contrato',contacts:'Contacto comercial telefónico',email_contact:'Contactos comercial eletrónico',website_contact:'Contactos comercial eletrónico'};var SUPPORT_OPTIONS=[{slug:'w',text:'Por escrito'},{slug:'p',text:'Presencial'},{slug:'t',text:'Telefónico'},{slug:'e',text:'Eletrónico'}];var BILLING_TYPE={electronic_billing:'Electrónica',paper_billing:'Papel'};var CONTRACT_TYPE={email_contract_contact:'Electrónica',location_contract_contact:'Presencial',phone_contract_contact:'Telefone'};var PAYMENT_TYPE={direct_debit:'Débito direto em conta',atm_ctt:'Multibanco / Transferência bancária',shop_payment:'Loja / Agente autorizado'};var ADDITIONAL_RESTRICTIONS={partnerships:'Obriga a parcerias com outras instituições',equipments:'Destina-se a algum tipo de equipamento específico',consumers:'Destina-se a um grupo de consumidores específico',consumptions:'Obriga a consumos de energia mínimos/máximos'};var COMERCIAL_CONDITIONS={offer_type:'Tipo de fornecimento',contract_duration:'Duração do contrato (meses)',offer_start_date:'Data de início da oferta comercial',offer_validity:'Data de validade da oferta comercial',contract_type:'Contratação',billing_type:'Faturação',payment_type:'Métodos de pagamento',direct_debit:'Débito direto em conta',atm_ctt:'Multibanco / Transferência bancária',shop_payment:'Loja / Agente autorizado',support_options:'Meios de atendimento',payment_periodicity:'Modalidades na faturação',has_loyalty:'Existe fidelização?',loyalty_clauses_description:'Descrição das cláusulas de fidelização, incluindo a penalização por rescisão antecipada',green_energy:'Energia elétrica com origem 100% renovável',has_additional_restrictions:'Restrições adicionais',additional_restrictions:'Restrições adicionais',offer_restrictions:'Detalhe as restrições anteriores e/ou outras aplicáveis.',discount_as_uploaded:'Descrição de descontos/benefícios relevantes (exeto reembolsos)',price_function_of_access:'A tabela de preços é atualizada em função das tarifas de acesso às redes?',price_revision_conditions:'Outras políticas de atualização da tabela de preços',indexed_prices:'Preços indexados - existem mecanismos de revisão de preços inferiores a um ano?',indexed_prices_description:'Descrição dos mecanismos de preços indexados'};var ADDITIONAL_SERVICES={required_subscription_additional_services:'Obrigatoriedade de contratação de serviços adicionais?',additional_services_cost:'Custo dos serviços adicionais obrigatórios (€/ano) sem IVA',additional_services_cost_with_vat:'Custo dos serviços adicionais obrigatórios (€/ano) após a aplicação da taxa de IVA aplicável',additional_services_description:'Descrição de todos os serviços adicionais obrigatórios',optional_services_description:'Descrição dos serviços adicionais opcionais relevantes'};var REFUNDS_ENTRIES={has_refunds:'A oferta tem reembolsos?',annual_refunds:'Reembolsos anuais',electricity_refund_fixed_term:'Eletricidade: reembolsos em % a aplicar no Termo Fixo',electricity_refund_energy_term:'Eletricidade: reembolsos em % a aplicar no Termo de Energia',electricity_refund_energy_function:'Eletricidade: reembolso em função da energia',gas_refund_fixed_term:'Gás Natural: reembolsos em % a aplicar no Termo Fixo',gas_refund_energy_term:'Gás Natural: reembolsos em % a aplicar no Termo de Energia',gas_refund_energy_function:'Gás Natural: reembolso em função da energia',refunds_description:'Descrição de todos os reembolsos da oferta comercial'};

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Input__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Util__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_SubscriptionRadioGroup__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_SelectInput__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_PostalInput__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_CheckInput__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_TariffSummary__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__data__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_find__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_containers_TariffSubscribeModal_validations__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_virtualized_select__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_virtualized_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_react_virtualized_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_ResultItem__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_components_AditionalServices__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_isEmpty__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash_merge__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_components_Toltip__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_components_Svg_informacao_svg__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_components_Svg_informacao_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_components_Svg_informacao_svg__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding: 32px 0;\n\n  label {\n    text-transform: initial !important;\n  }\n'],['\n  padding: 32px 0;\n\n  label {\n    text-transform: initial !important;\n  }\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #93c13e;\n  font-family: Nunito;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 16px;\n  margin: 0;\n'],['\n  color: #93c13e;\n  font-family: Nunito;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 16px;\n  margin: 0;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  border-bottom: 1px solid #dedede;\n  padding-bottom: 12px;\n'],['\n  border-bottom: 1px solid #dedede;\n  padding-bottom: 12px;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  margin-top: 12px;\n'],['\n  display: flex;\n  margin-top: 12px;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #9c9c9c;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 14px;\n  width: 45%;\n  min-width: 45%;\n'],['\n  color: #9c9c9c;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 14px;\n  width: 45%;\n  min-width: 45%;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #3e3e3e;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 14px;\n'],['\n  color: #3e3e3e;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 14px;\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  margin-top: 20px;\n\n  span {\n    margin-right: 10px;\n    color: #676767;\n    font-family: Nunito;\n    font-size: 14px;\n    line-height: 18px;\n  }\n'],['\n  display: flex;\n  margin-top: 20px;\n\n  span {\n    margin-right: 10px;\n    color: #676767;\n    font-family: Nunito;\n    font-size: 14px;\n    line-height: 18px;\n  }\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  font-size: 14px;\n  font-weight: bold;\n  text-align: left;\n  width: 100%;\n  color: #676767;\n  font-family: Nunito;\n  font-weight: 600;\n  line-height: 14px;\n'],['\n  display: block;\n  font-size: 14px;\n  font-weight: bold;\n  text-align: left;\n  width: 100%;\n  color: #676767;\n  font-family: Nunito;\n  font-weight: 600;\n  line-height: 14px;\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  max-height: 35px;\n  display: block;\n  margin-top: 10px;\n'],['\n  max-height: 35px;\n  display: block;\n  margin-top: 10px;\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  color: indianred;\n  font-size: 12px;\n  margin-top: 10px;\n'],['\n  display: block;\n  color: indianred;\n  font-size: 12px;\n  margin-top: 10px;\n']),_templateObject11=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-size: 12px;\n  color: #bcbbbb;\n'],['\n  font-size: 12px;\n  color: #bcbbbb;\n']),_templateObject12=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-size: 10px;\n'],['\n  font-size: 10px;\n']),_templateObject13=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  font-weight: bold;\n  margin-bottom: 20px;\n  color: #8abb3f;\n  font-size: 10px;\n'],['\n  display: block;\n  font-weight: bold;\n  margin-bottom: 20px;\n  color: #8abb3f;\n  font-size: 10px;\n']),_templateObject14=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin-bottom: 10px;\n  font-size: 10px;\n\n  ','\n'],['\n  margin-bottom: 10px;\n  font-size: 10px;\n\n  ','\n']),_templateObject15=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 10px;\n  height: 10px;\n  background: linear-gradient(270deg, #006736 0%, #93c13e 100%);\n  display: inline-block;\n  border-radius: 50%;\n  margin-right: 10px;\n'],['\n  width: 10px;\n  height: 10px;\n  background: linear-gradient(270deg, #006736 0%, #93c13e 100%);\n  display: inline-block;\n  border-radius: 50%;\n  margin-right: 10px;\n']),_templateObject16=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n\n  @media screen and (max-width: 768px) {\n    width: 320px;\n  }\n  .is-focused {\n    .Select-control {\n      border: 1px solid #bababa;\n    }\n  }\n  > .Select-control {\n    box-shadow: none !important;\n    border: 1px solid #bababa;\n    border-color: #bababa !important;\n    border-radius: 0px;\n    height: 50px;\n    font-size: 14px;\n    font-family: \'Nunito\', \'Helvetica Neue\', sans-serif;\n    text-rendering: optimizeLegibility;\n    -webkit-font-smoothing: antialiased;\n    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004);\n\n    .Select-placeholder {\n      line-height: 48px;\n    }\n    .Select-input {\n      height: 48px;\n      line-height: 48px;\n    }\n    .Select-value {\n      line-height: 48px !important;\n      outline: none;\n      text-align: left;\n      padding-left: 16px;\n      &:focus {\n        outline: none;\n      }\n      &:blur {\n        outline: none;\n      }\n    }\n  }\n  .VirtualizedSelectOption {\n    overflow: hidden;\n    text-align: left;\n    white-space: nowrap;\n    vertical-align: top;\n    font-size: 14px;\n    font-family: \'Nunito\', \'Helvetica Neue\', sans-serif;\n    text-rendering: optimizeLegibility;\n    -webkit-font-smoothing: antialiased;\n    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004);\n    padding: 16px 15px 15px 16px;\n\n    &:hover {\n      background-color: #efefef;\n    }\n  }\n  .VirtualizedSelectFocusedOption {\n    background-color: #efefef;\n  }\n  .VirtualizedSelectSelectedOption {\n    background-color: #efefef;\n\n    &:hover {\n      background-color: #efefef;\n    }\n  }\n'],['\n  width: 100%;\n\n  @media screen and (max-width: 768px) {\n    width: 320px;\n  }\n  .is-focused {\n    .Select-control {\n      border: 1px solid #bababa;\n    }\n  }\n  > .Select-control {\n    box-shadow: none !important;\n    border: 1px solid #bababa;\n    border-color: #bababa !important;\n    border-radius: 0px;\n    height: 50px;\n    font-size: 14px;\n    font-family: \'Nunito\', \'Helvetica Neue\', sans-serif;\n    text-rendering: optimizeLegibility;\n    -webkit-font-smoothing: antialiased;\n    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004);\n\n    .Select-placeholder {\n      line-height: 48px;\n    }\n    .Select-input {\n      height: 48px;\n      line-height: 48px;\n    }\n    .Select-value {\n      line-height: 48px !important;\n      outline: none;\n      text-align: left;\n      padding-left: 16px;\n      &:focus {\n        outline: none;\n      }\n      &:blur {\n        outline: none;\n      }\n    }\n  }\n  .VirtualizedSelectOption {\n    overflow: hidden;\n    text-align: left;\n    white-space: nowrap;\n    vertical-align: top;\n    font-size: 14px;\n    font-family: \'Nunito\', \'Helvetica Neue\', sans-serif;\n    text-rendering: optimizeLegibility;\n    -webkit-font-smoothing: antialiased;\n    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004);\n    padding: 16px 15px 15px 16px;\n\n    &:hover {\n      background-color: #efefef;\n    }\n  }\n  .VirtualizedSelectFocusedOption {\n    background-color: #efefef;\n  }\n  .VirtualizedSelectSelectedOption {\n    background-color: #efefef;\n\n    &:hover {\n      background-color: #efefef;\n    }\n  }\n']),_templateObject17=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-size: 14px;\n  font-weight: bold;\n  text-align: left;\n  width: 100%;\n  display: block;\n  font-family: \'Nunito\';\n  color: #676767;\n  font-family: Nunito;\n  font-weight: 600;\n  line-height: 14px;\n  margin-bottom: 10px;\n'],['\n  font-size: 14px;\n  font-weight: bold;\n  text-align: left;\n  width: 100%;\n  display: block;\n  font-family: \'Nunito\';\n  color: #676767;\n  font-family: Nunito;\n  font-weight: 600;\n  line-height: 14px;\n  margin-bottom: 10px;\n']),_templateObject18=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #8abb3f;\n\n  &:hover {\n    color: #6e9532;\n  }\n'],['\n  color: #8abb3f;\n\n  &:hover {\n    color: #6e9532;\n  }\n']),_templateObject19=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  margin-left: 30px;\n\n  @media (max-width: 980px) {\n    min-width: 195px;\n    min-height: 120px;\n  }\n\n  @media (max-width: 850px) {\n    margin-top: -5% !important;\n  }\n'],['\n  display: flex;\n  margin-left: 30px;\n\n  @media (max-width: 980px) {\n    min-width: 195px;\n    min-height: 120px;\n  }\n\n  @media (max-width: 850px) {\n    margin-top: -5% !important;\n  }\n']),_templateObject20=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()([''],['']);var SimplePersonalPanel=function SimplePersonalPanel(_ref){var name=_ref.name,surname=_ref.surname,nif=_ref.nif,email=_ref.email,phone=_ref.phone,_onChange=_ref.onChange,reqMail=_ref.reqMail,reqPhone=_ref.reqPhone;var key='personal';return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Title,null,'Dados pessoais'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'16',bottom:'0',right:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Input__["a" /* default */],{label:'Primeiro nome *',type:'text',value:name.value,className:name.valid?'invalid':'valid',onChange:function onChange(val){return _onChange(key,'name',val);}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,name.valid)),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Input__["a" /* default */],{label:'Apelido *',type:'text',value:surname.value,className:surname.valid&&'invalid',onChange:function onChange(val){return _onChange(key,'surname',val);}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,surname.valid)))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'32',bottom:'0',right:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Title,null,'Contactos')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'32',bottom:'0',right:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Input__["a" /* default */],{label:addRequiredIndicator(reqMail,'Email'),type:'email',value:email.value,className:email.valid&&'invalid',onChange:function onChange(val){return _onChange(key,'email',val);}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,email.valid)),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Input__["a" /* default */],{label:addRequiredIndicator(reqPhone,'Telefone / Telemóvel'),type:'text',value:phone.value,maxLength:9,onlyNumbers:true,className:phone.valid&&'invalid',onChange:function onChange(val){return _onChange(key,'phone',val);}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,phone.valid)))));};/* eslint-disable camelcase */var PersonalPanel=function PersonalPanel(_ref2){var name=_ref2.name,surname=_ref2.surname,nif=_ref2.nif,email=_ref2.email,phone=_ref2.phone,contact=_ref2.contact,contact_time=_ref2.contact_time,_onChange2=_ref2.onChange,reqMail=_ref2.reqMail,reqPhone=_ref2.reqPhone;var key='personal';return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Title,null,'Dados pessoais'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'16',bottom:'0',right:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Input__["a" /* default */],{label:'Primeiro nome *',type:'text',value:name.value,className:name.valid?'invalid':'valid',onChange:function onChange(val){return _onChange2(key,'name',val);}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,name.valid)),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Input__["a" /* default */],{label:'Apelido *',type:'text',value:surname.value,className:surname.valid&&'invalid',onChange:function onChange(val){return _onChange2(key,'surname',val);}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,surname.valid)))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'32',bottom:'0',right:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Input__["a" /* default */],{label:'NIF *',type:'text',value:nif.value,maxLength:9,onlyNumbers:true,className:nif.valid&&'invalid',onChange:function onChange(val){return _onChange2(key,'nif',val);}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,nif.valid)))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'32',bottom:'0',right:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Title,null,'Contactos')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'0',bottom:'0',right:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Input__["a" /* default */],{label:addRequiredIndicator(reqMail,'Email'),type:'email',value:email.value,className:email.valid&&'invalid',onChange:function onChange(val){return _onChange2(key,'email',val);}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,email.valid)),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Input__["a" /* default */],{label:addRequiredIndicator(reqPhone,'Telefone / Telemóvel'),type:'text',value:phone.value,maxLength:9,onlyNumbers:true,className:phone.valid&&'invalid',onChange:function onChange(val){return _onChange2(key,'phone',val);}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,phone.valid)))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'32',bottom:'0',right:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6,style:{minHeight:'62px'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_SubscriptionRadioGroup__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_19__data__["a" /* CONTACTS */].name,name:__WEBPACK_IMPORTED_MODULE_19__data__["a" /* CONTACTS */].fieldName,items:__WEBPACK_IMPORTED_MODULE_19__data__["a" /* CONTACTS */].values,'default':contact.value,onClick:function onClick(val){return _onChange2(key,'contact',val);}})),contact.value==='p'&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_SelectInput__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_19__data__["b" /* CONTACT_HOUR */].name,items:__WEBPACK_IMPORTED_MODULE_19__data__["b" /* CONTACT_HOUR */].values,placeholder:'Selecionar o ciclo hor\xE1rio...',selected:contact_time,className:contact_time.valid&&'invalid',onChange:function onChange(val){return _onChange2(key,'contact_time',val);}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,contact_time.valid)))));};var EnterprisePanel=function EnterprisePanel(_ref3){var name=_ref3.name,surname=_ref3.surname,nif=_ref3.nif,_onChange3=_ref3.onChange,companyName=_ref3.companyName,companyPhoneNumber=_ref3.companyPhoneNumber,contact_time=_ref3.contact_time,contact=_ref3.contact,companyEmail=_ref3.companyEmail,companyCae=_ref3.companyCae,caes=_ref3.caes,legalBi=_ref3.legalBi,email=_ref3.email,phone=_ref3.phone,reqMail=_ref3.reqMail,reqPhone=_ref3.reqPhone;var key='personal';return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Title,null,'Dados da empresa'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'16',bottom:'0',right:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Input__["a" /* default */],{label:'Nome da empresa *',type:'text',value:companyName.value,className:companyName.valid?'invalid':'valid',onChange:function onChange(val){return _onChange3(key,'companyName',val);}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,companyName.valid)),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Input__["a" /* default */],{label:'NIPC/NIF empresa *',type:'text',value:nif.value,maxLength:9,onlyNumbers:true,className:nif.valid&&'invalid',onChange:function onChange(val){return _onChange3(key,'nif',val);}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,nif.valid)))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'32',bottom:'0',right:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Input__["a" /* default */],{label:addRequiredIndicator(reqMail,'Email empresa'),type:'email',value:companyEmail.value,className:companyEmail.valid&&'invalid',onChange:function onChange(val){return _onChange3(key,'companyEmail',val);}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,companyEmail.valid)),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Input__["a" /* default */],{label:addRequiredIndicator(reqPhone,'Telefone empresa'),type:'text',value:companyPhoneNumber.value,maxLength:9,onlyNumbers:true,className:companyPhoneNumber.valid&&'invalid',onChange:function onChange(val){return _onChange3(key,'companyPhoneNumber',val);}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,companyPhoneNumber.valid)))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'16',bottom:'0',right:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:12},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CaeLabel,null,'CAE'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(StyledSelectCae,{options:caes,placeholder:'CAE',onChange:function onChange(val){return _onChange3(key,'companyCae',val);},value:companyCae.value,disabled:true}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,companyCae.valid)))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'32',bottom:'0',right:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Input__["a" /* default */],{label:'BI/CC do representante legal *',type:'text',value:legalBi.value,maxLength:9,onlyNumbers:true,className:legalBi.valid&&'invalid',onChange:function onChange(val){return _onChange3(key,'legalBi',val);}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,legalBi.valid)))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'16',bottom:'0',right:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Input__["a" /* default */],{label:'Primeiro nome do representante legal  *',type:'text',value:name.value,className:name.valid?'invalid':'valid',onChange:function onChange(val){return _onChange3(key,'name',val);}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,name.valid)),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Input__["a" /* default */],{label:'Apelido do representante legal *',type:'text',value:surname.value,className:surname.valid&&'invalid',onChange:function onChange(val){return _onChange3(key,'surname',val);}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,surname.valid)))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'32',bottom:'0',right:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Input__["a" /* default */],{label:'Email contacto *',type:'email',value:email.value,className:email.valid&&'invalid',onChange:function onChange(val){return _onChange3(key,'email',val);}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,email.valid)),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Input__["a" /* default */],{label:'Telefone / Telem\xF3vel Contacto *',type:'text',value:phone.value,maxLength:9,onlyNumbers:true,className:phone.valid&&'invalid',onChange:function onChange(val){return _onChange3(key,'phone',val);}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,phone.valid)))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'32',bottom:'0',right:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6,style:{minHeight:'62px'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_SubscriptionRadioGroup__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_19__data__["a" /* CONTACTS */].name,name:__WEBPACK_IMPORTED_MODULE_19__data__["a" /* CONTACTS */].fieldName,items:__WEBPACK_IMPORTED_MODULE_19__data__["a" /* CONTACTS */].values,'default':contact.value,onClick:function onClick(val){return _onChange3(key,'contact',val);}})),contact.value==='p'&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_SelectInput__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_19__data__["b" /* CONTACT_HOUR */].name,items:__WEBPACK_IMPORTED_MODULE_19__data__["b" /* CONTACT_HOUR */].values,placeholder:'Selecionar o ciclo hor\xE1rio...',selected:contact_time,className:contact_time.valid&&'invalid',onChange:function onChange(val){return _onChange3(key,'contact_time',val);}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,contact_time.valid)))));};var BillingPanel=function BillingPanel(_ref4){var tariffAditionalInfo=_ref4.tariffAditionalInfo,getPostal=_ref4.getPostal,districts=_ref4.districts,municipalities=_ref4.municipalities,postalCode=_ref4.postalCode,postalExtension=_ref4.postalExtension,street=_ref4.street,door=_ref4.door,floor=_ref4.floor,district=_ref4.district,municipality=_ref4.municipality,billingPostalCode=_ref4.billingPostalCode,billingPostalExtension=_ref4.billingPostalExtension,billingStreet=_ref4.billingStreet,billingDoor=_ref4.billingDoor,billingFloor=_ref4.billingFloor,billingDistrict=_ref4.billingDistrict,billingMunicipality=_ref4.billingMunicipality,billingAddress=_ref4.billingAddress,billingMunicipalities=_ref4.billingMunicipalities,electronicBilling=_ref4.electronicBilling,directDebit=_ref4.directDebit,_onChange4=_ref4.onChange,loadingAddress=_ref4.loadingAddress,addressNotFound=_ref4.addressNotFound;var key='billing';return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Title,null,'Morada do contrato'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'16',bottom:'0',right:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_PostalInput__["a" /* default */],{onClick:function onClick(postal){return getPostal(Object.assign({},postal,{type:'normal'}));},code:postalCode.value,ext:postalExtension.value,changeCode:function changeCode(val){return _onChange4(key,'postalCode',val);},changeExt:function changeExt(val){return _onChange4(key,'postalExtension',val);},loading:loadingAddress}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,addressNotFound&&'O Codigo-Postal n\xE3o foi encontrado'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,postalCode.valid||postalExtension.valid)))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'16',bottom:'0',right:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:12},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Input__["a" /* default */],{label:'Rua *',type:'text',value:street.value,onChange:function onChange(val){return _onChange4(key,'street',val);},className:street.valid?'invalid':'valid'}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,street.valid)))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'32',bottom:'0',right:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Input__["a" /* default */],{label:'N\xBA da porta *',type:'text',value:door.value,onChange:function onChange(val){return _onChange4(key,'door',val);},className:door.valid?'invalid':'valid'}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,door.valid)),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Input__["a" /* default */],{label:'Andar',type:'text',value:floor.value,onChange:function onChange(val){return _onChange4(key,'floor',val);}})))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'32',bottom:'0',right:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_SelectInput__["a" /* default */],{label:'Distrito *',items:districts&&districts.map(function(dis){return{label:dis.name,value:dis.id};}),placeholder:'Selecionar o distrito...',onChange:function onChange(val){return _onChange4(key,'district',val);},className:district.valid?'invalid':'valid',selected:district.value}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,district.valid)),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_SelectInput__["a" /* default */],{label:'Concelho *',items:municipalities&&municipalities.map(function(dis){return{label:dis.name,value:dis.id};}),placeholder:'Selecionar o distrito...',onChange:function onChange(val){return _onChange4(key,'municipality',val);},className:municipality.valid?'invalid':'valid',selected:municipality.value}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,municipality.valid)))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'32',bottom:'0',right:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Title,null,'Morada da fatura\xE7\xE3o')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'16',bottom:'0',right:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:12},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_SubscriptionRadioGroup__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_19__data__["c" /* BILLING_ADDRESS */].name,name:__WEBPACK_IMPORTED_MODULE_19__data__["c" /* BILLING_ADDRESS */].fieldName,items:__WEBPACK_IMPORTED_MODULE_19__data__["c" /* BILLING_ADDRESS */].values,'default':billingAddress.value,onClick:function onClick(val){return _onChange4(key,'billingAddress',val);}})))),billingAddress.value==='d'&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'16',bottom:'0',right:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_PostalInput__["a" /* default */],{onClick:function onClick(postal){return getPostal(Object.assign({},postal,{type:'billing'}));},code:billingPostalCode.value,ext:billingPostalExtension.value,changeCode:function changeCode(val){return _onChange4(key,'billingPostalCode',val);},changeExt:function changeExt(val){return _onChange4(key,'billingPostalExtension',val);}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,billingPostalCode.valid)))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'16',bottom:'0',right:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:12},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Input__["a" /* default */],{label:'Rua *',type:'text',value:billingStreet.value,onChange:function onChange(val){return _onChange4(key,'billingStreet',val);},className:billingStreet.valid?'invalid':'valid'}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,billingStreet.valid)))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'32',bottom:'0',right:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Input__["a" /* default */],{label:'N\xBA da porta  *',type:'text',value:billingDoor.value,onChange:function onChange(val){return _onChange4(key,'billingDoor',val);},className:billingDoor.valid?'invalid':'valid'}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,billingDoor.valid)),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Input__["a" /* default */],{label:'Andar',type:'text',value:billingFloor.value,onChange:function onChange(val){return _onChange4(key,'billingFloor',val);}})))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'32',bottom:'0',right:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_SelectInput__["a" /* default */],{label:'Distrito *',items:districts&&districts.map(function(dis){return{label:dis.name,value:dis.id};}),placeholder:'Selecionar o distrito...',onChange:function onChange(val){return _onChange4(key,'billingDistrict',val);},className:billingDistrict.valid?'invalid':'valid',selected:billingDistrict.value}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,billingDistrict.valid)),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_SelectInput__["a" /* default */],{label:'Concelho *',items:billingMunicipalities&&billingMunicipalities.map(function(mun){return{label:mun.name,value:mun.id};}),placeholder:'Selecionar o concelho...',onChange:function onChange(val){return _onChange4(key,'billingMunicipality',val);},className:billingMunicipality.valid?'invalid':'valid',selected:billingMunicipality.value}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,billingMunicipality.valid))))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'32',bottom:'0',right:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Title,null,'Detalhes da fatura\xE7\xE3o')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'16',bottom:'0',right:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_SubscriptionRadioGroup__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_19__data__["d" /* DIRECT_DEBIT */].name,name:__WEBPACK_IMPORTED_MODULE_19__data__["d" /* DIRECT_DEBIT */].fieldName,items:__WEBPACK_IMPORTED_MODULE_19__data__["d" /* DIRECT_DEBIT */].values,'default':directDebit.value,onClick:function onClick(val){return _onChange4(key,'directDebit',val);},disabled:tariffAditionalInfo&&tariffAditionalInfo.direct_debit&&!tariffAditionalInfo.atm_ctt})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_SubscriptionRadioGroup__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_19__data__["e" /* ELETRONIC_BILLING */].name,name:__WEBPACK_IMPORTED_MODULE_19__data__["e" /* ELETRONIC_BILLING */].fieldName,items:__WEBPACK_IMPORTED_MODULE_19__data__["e" /* ELETRONIC_BILLING */].values,'default':electronicBilling.value,onClick:function onClick(val){return _onChange4(key,'electronicBilling',val);},disabled:tariffAditionalInfo&&tariffAditionalInfo.electronic_billing&&!tariffAditionalInfo.paper_billing})))));};var ElectricityPanel=function ElectricityPanel(_ref5){var entity=_ref5.entity,userProfile=_ref5.userProfile,entities=_ref5.entities,currentEntity=_ref5.currentEntity,cpe=_ref5.cpe,potency=_ref5.potency,tariff=_ref5.tariff,cycle=_ref5.cycle,_onChange5=_ref5.onChange,isHome=_ref5.isHome;var key='electric';var userCPE=userProfile.cpe;if(userCPE&&!cpe.value){_onChange5(key,'cpe',userCPE);}return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Title,null,'Dados de fornecimento de eletricidade'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'16',right:'0',left:'0',bottom:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Label,null,'Fornecedor'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Logo,{src:''+__WEBPACK_IMPORTED_MODULE_20_config__["e" /* MEDIA_BASE_URL */]+entity.hi_res_logo})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Input__["a" /* default */],{label:'CPE',type:'text',placeholder:'Escreva o CPE...',value:cpe.value,maxLength:20,onChange:function onChange(val){return _onChange5(key,'cpe',val);}}),!cpe.valid&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(InfoLabel,null,'Verifique o c\xF3digo do ponto de entrega (CPE) na sua fatura. Tem o formato PT + 16 algarismos + 2 letras'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,cpe.valid)))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'32',right:'0',left:'0',bottom:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_SelectInput__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_19__data__["f" /* POTENCY */].name,items:__WEBPACK_IMPORTED_MODULE_19__data__["f" /* POTENCY */].values,placeholder:'Selecionar a pot\xEAncia...',onChange:function onChange(val){return _onChange5(key,'potency',val);},selected:potency.value,disabled:!isHome}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,potency.valid)))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'32',right:'0',left:'0',bottom:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_SelectInput__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_19__data__["g" /* TARIFF */].name,items:__WEBPACK_IMPORTED_MODULE_19__data__["g" /* TARIFF */].values,placeholder:'Selecionar a tarifa...',onChange:function onChange(val){return _onChange5(key,'tariff',val);},selected:tariff.value,disabled:!isHome}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,tariff.valid)),tariff.value!=='s'&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_SelectInput__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_19__data__["h" /* CYCLE */].name,items:__WEBPACK_IMPORTED_MODULE_19__data__["h" /* CYCLE */].values,placeholder:'Selecionar o ciclo hor\xE1rio...',onChange:function onChange(val){return _onChange5(key,'cycle',val);},selected:cycle.value}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,cycle.valid)))));};var GasPanel=function GasPanel(_ref6){var entity=_ref6.entity,userProfile=_ref6.userProfile,entities=_ref6.entities,cui=_ref6.cui,currentEntity=_ref6.currentEntity,tier=_ref6.tier,_onChange6=_ref6.onChange,isHome=_ref6.isHome;var key='gas';var userCUI=userProfile.cui;if(userCUI&&!cui.value){_onChange6(key,'cui',userCUI);}return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Title,null,'Dados de fornecimento de g\xE1s natural'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'16',right:'0',left:'0',bottom:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Label,null,'Fornecedor'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Logo,{src:''+__WEBPACK_IMPORTED_MODULE_20_config__["e" /* MEDIA_BASE_URL */]+entity.hi_res_logo})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Input__["a" /* default */],{label:'CUI',placeholder:'Escreva o CUI...',type:'text',value:cui.value,maxLength:20,onChange:function onChange(val){return _onChange6(key,'cui',val);}}),!cui.valid&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(InfoLabel,null,'Verifique o c\xF3digo universal da instala\xE7\xE3o (CUI) na sua fatura. Tem o formato PT + 16 algarismos + 2 letras'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,cui.valid)))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'32',right:'0',left:'0',bottom:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_SelectInput__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_19__data__["i" /* TIER */].name,items:__WEBPACK_IMPORTED_MODULE_19__data__["i" /* TIER */].values,placeholder:'Selecione o escal\xE3o...',onChange:function onChange(val){return _onChange6(key,'tier',val);},selected:tier.value,disabled:!isHome}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,tier.valid)))));};var ConfirmationPanel=function ConfirmationPanel(props){var filterPersonal=Object.assign({},props.labels.personal);if(props.entries.personal.contact.value!=='p'){delete filterPersonal.contact_time;}return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:12},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Title,null,'Resumo dos dados de ades\xE3o ao tarif\xE1rio')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:12},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Information,{labels:filterPersonal,entries:props.entries.personal,gasEntities:props.gasEntities,electricEntities:props.eletricEntities,caes:props.caes}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Information,{labels:props.labels.billing,entries:props.entries.billing,gasEntities:props.gasEntities,electricEntities:props.eletricEntities,municipalities:props.municipalities,billingMunicipalities:props.billingMunicipalities,districts:props.districts}),props.hasEletricity&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Information,{labels:props.labels.electric,entries:props.entries.electric,gasEntities:props.gasEntities,electricEntities:props.eletricEntities}),props.hasGas&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Information,{labels:props.labels.gas,entries:props.entries.gas,gasEntities:props.gasEntities,electricEntities:props.eletricEntities})))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:12},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:0,left:0,bottom:32,right:0},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Title,null,'Fornecedor'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Logo,{src:props.entity&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_utils__["f" /* generateMediaUrl */])(props.entity.hi_res_logo)})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Title,null,'Novo tarif\xE1rio:',' ',props.hasGas?props.tariff.gasPriceList?props.tariff.gasPriceList.designation:props.tariff.designation:props.tariff.electricityPriceList?props.tariff.electricityPriceList.designation:props.tariff.designation),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_TariffSummary__["a" /* default */],{tariff:props.tariff,entries:props.entries,tariffInfo:props.tariffInfo}))))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Disclaimer,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(DisclaimerTitle,null,'Esclarecimento'),props.tariffInfo&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_containers_TariffSubscribeModal_validations__["k" /* hasPaidServices */])(props.tariffInfo.additional_services)&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(DisclaimerText,{red:true},'Este tarif\xE1rio apresenta fideliza\xE7\xE3o e/ou servi\xE7os com custos adicionais'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(DisclaimerText,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(ListBall,null),'Os valores apresentados baseiam-se nos dados introduzidos e representam uma estimativa da sua fatura de energia para os pr\xF3ximos 12 meses e da poupan\xE7a expect\xE1vel face ao seu tarif\xE1rio atual.'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(DisclaimerText,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(ListBall,null),'Estes valores t\xEAm em considera\xE7\xE3o as condi\xE7\xF5es de consumo de eletricidade e/ou g\xE1s natural inseridos e que se assumem corretos e atuais.'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(DisclaimerText,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(ListBall,null),'O presente pedido de ades\xE3o n\xE3o constitui uma proposta contratual, sendo esta uma responsabilidade do comercializador, que entrar\xE1 em contacto consigo.'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(DisclaimerText,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(ListBall,null),'O OLMC n\xE3o pode ser responsabilizado por eventuais diferen\xE7as no valor de fatura\xE7\xE3o e/ou consumos de eletricidade e g\xE1s natural que venham a ocorrer durante este per\xEDodo, nem por eventuais diverg\xEAncias entre as partes que possam decorrer do contrato celebrado na sequ\xEAncia de informa\xE7\xE3o disponibilizada pelo Portal Poupa Energia.'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(DisclaimerTitle,null,'Em caso de d\xFAvida contacte-nos atrav\xE9s do 211 160 500.')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:12},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CheckboxWrapper,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_CheckInput__["a" /* default */],{value:props.entries.confirm.allowDataSharing.value,onClick:function onClick(){return props.changeAllowDataSharing();}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('span',null,'Concordo com os',' ',__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(TermsLink,{target:'_blank',href:__WEBPACK_IMPORTED_MODULE_20_config__["g" /* PAGE_URL */]+'/termos-e-condicoes/'},'termos e condi\xE7\xF5es'),' ','e autorizo o envio desta informa\xE7\xE3o para o comercializador.')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,props.entries.confirm.allowDataSharing.valid))));};var Information=function Information(props){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Summary,null,Object.keys(props.labels).map(function(key){if(key==='postal'){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(InfoEntry,{key:key},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(EntryLabel,null,props.labels[key]),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(EntryText,null,props.entries['postalCode'].value+'-'+props.entries['postalExtension'].value));}else if(key==='potency'){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(InfoEntry,{key:key},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(EntryLabel,null,props.labels[key]),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(EntryText,null,String(props.entries.potency.value).replace('.',',')+' kVA'));}else if(key==='cycle'&&props.entries.tariff&&props.entries.tariff.value==='s'){return null;}else if(key==='companyCae'){var cae=props.caes&&props.caes.find(function(_ref7){var value=_ref7.value;return props.entries.companyCae.value===value;});return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(InfoEntry,{key:key},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(EntryLabel,null,props.labels[key]),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(EntryText,null,cae&&cae.label));}else{var value=props.entries[key].value;var designations=props.entries[key].designation;var realValue=value;if(designations&&designations.values){realValue=__WEBPACK_IMPORTED_MODULE_21_lodash_find___default()(designations.values,{value:value});if(realValue){realValue=realValue.label;}}else{if(designations==='ee'&&props.electricEntities){realValue=__WEBPACK_IMPORTED_MODULE_21_lodash_find___default()(props.electricEntities,{id:value});if(realValue){realValue=realValue.designation;}}if(designations==='eg'&&props.gasEntities){realValue=__WEBPACK_IMPORTED_MODULE_21_lodash_find___default()(props.gasEntities,{id:value});if(realValue){realValue=realValue.designation;}}if(designations==='d'&&props.districts){realValue=__WEBPACK_IMPORTED_MODULE_21_lodash_find___default()(props.districts,{id:value});if(realValue){realValue=realValue.name;}}if(designations==='m'&&props.municipalities){realValue=__WEBPACK_IMPORTED_MODULE_21_lodash_find___default()(props.municipalities,{id:value});if(realValue){realValue=realValue.name;}}if(designations==='bm'&&props.billingMunicipalities){realValue=__WEBPACK_IMPORTED_MODULE_21_lodash_find___default()(props.billingMunicipalities,{id:value});if(realValue){realValue=realValue.name;}}}if(realValue){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(InfoEntry,{key:key},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(EntryLabel,null,props.labels[key]),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(EntryText,null,realValue));}else{return null;}}}));};var GeneralInformation=function GeneralInformation(_ref8){var tariff=_ref8.tariff,additionalServices=_ref8.additionalServices,isHome=_ref8.isHome,potency=_ref8.potency,potencies=_ref8.potencies,_onChange7=_ref8.onChange;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{style:{display:'flex'}},tariff&&tariff.prices.electricity&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_components_ResultItem__["a" /* EletricityItem */],Object.assign({},tariff,{entity:false,electricityConsumption:false})),tariff&&tariff.prices.gas&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_components_ResultItem__["b" /* GasItem */],Object.assign({},tariff,{entity:false,gasConsumption:false}))),additionalServices&&!__WEBPACK_IMPORTED_MODULE_26_lodash_isEmpty___default()(additionalServices)&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(AdditionalWrapper,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_components_AditionalServices__["a" /* default */],{list:additionalServices})),!!potencies.length&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Util__["a" /* Marginer */],{top:'32',right:'0',left:'0',bottom:'0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Row"],{style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_SelectInput__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_19__data__["f" /* POTENCY */].name,items:potencies,placeholder:'Selecionar a pot\xEAncia...',onChange:function onChange(val){_onChange7(val);},selected:potency.value}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Error,null,potency.valid)),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(AbsoluteToltip,{text:'Os pre\xE7os podem variar com a altera\xE7\xE3o da pot\xEAncia.',icon:__WEBPACK_IMPORTED_MODULE_29_components_Svg_informacao_svg___default.a}))));};function addRequiredIndicator(condition,string){return string+' '+(condition?'*':'');}var TariffAdhesion=function(_Component){__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(TariffAdhesion,_Component);function TariffAdhesion(props){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this,TariffAdhesion);var _this=__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this,(TariffAdhesion.__proto__||Object.getPrototypeOf(TariffAdhesion)).call(this,props));_this.checkAllFields=function(){Object.keys(_this.props.formData).forEach(function(key){if(_this.state[key].value===''){return{index:_this.keyToIndex(key),valid:false};}});return{valid:false};};var entreperiseLabels={companyName:'Nome da empresa',companyCae:'CAE',companyPhoneNumber:'Telefone da empresa',companyEmail:'Email da empresa',legalBi:'BI/CC do representante legal',name:'Primeiro nome',surname:'Apelido',nif:'NIPC/NIF empresa',contact:'Meio de contacto preferêncial',contact_time:'Em que período pretende ser contactado?',email:'Email contacto',phone:'Telefone / Telemóvel Contacto'};_this.labels={personal:__WEBPACK_IMPORTED_MODULE_20_config__["k" /* isEnterprise */]?entreperiseLabels:{name:'Primeiro nome',surname:'Apelido',nif:'NIF',email:'Email',phone:'Telefone / Telemóvel',contact:'Meio de contacto preferêncial',contact_time:'Em que período pretende ser contactado?'},billing:{street:'Rua',door:'Nº da porta',floor:'Andar',postal:'Código postal',district:'Distrito',municipality:'Concelho',billingAddress:'Morada de faturação',billingStreet:'Rua de faturação',billingDoor:'Nº da porta de faturação',billingFloor:'Andar de faturação',billingPostalCode:'Código postal de faturação',billingDistrict:'Distrito de faturação',billingMunicipality:'Concelho de faturação',directDebit:'Débito direto',electronicBilling:'Fatura eletrónica'},electric:{cpe:'CPE',potency:'Potência',tariff:'Tarifa',cycle:'Ciclo horário'},gas:{cui:'CUI',tier:'Escalão'}};_this.state={tariffObj:Object.assign({},props.tariff)};return _this;}__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(TariffAdhesion,[{key:'keyToIndex',value:function keyToIndex(key){switch(key){case'personal':return 0;case'billing':return 1;case'electric':return 2;case'gas':return 3;default:return 0;}}},{key:'onSubmit',value:function onSubmit(){this.props.onClick(this.checkAllFields());}},{key:'render',value:function render(){var _this2=this;var _props=this.props,numberOfTabs=_props.numberOfTabs,hasEletricity=_props.hasEletricity,hasGas=_props.hasGas,formData=_props.formData,districts=_props.districts,tariff=_props.tariff,municipalities=_props.municipalities,billingMunicipalities=_props.billingMunicipalities,electricEntities=_props.electricEntities,gasEntities=_props.gasEntities,tariffInfo=_props.tariffInfo,onChange=_props.onChange,getPostal=_props.getPostal,index=_props.index,caes=_props.caes,loadingAddress=_props.loadingAddress,addressNotFound=_props.addressNotFound,isSimple=_props.isSimple,userProfile=_props.userProfile,isHome=_props.isHome;var tariffObj=this.state.tariffObj;var _tariffInfo$entity=tariffInfo.entity,subscription_requires_email=_tariffInfo$entity.subscription_requires_email,subscription_requires_phone=_tariffInfo$entity.subscription_requires_phone;var gasTab=hasEletricity&&hasGas?3:2;var isEleContract=!!(tariffInfo&&tariffInfo.pricelistadditionalinfo.electronic_contract);var additionalServices=[];if(tariff.electricityPriceList){additionalServices=__WEBPACK_IMPORTED_MODULE_27_lodash_merge___default()(additionalServices,[].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(tariff.electricityPriceList.additional_services)));}if(tariff.gasPriceList){additionalServices=__WEBPACK_IMPORTED_MODULE_27_lodash_merge___default()(additionalServices,[].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(tariff.gasPriceList.additional_services)));}var onChangePontenty=function(){var _ref9=__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(val){var electricPrices,electricity;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:onChange('electric','potency',val);electricPrices=null;if(tariffInfo.electricity_set&&tariffInfo.electricity_set.length&&tariff.priceListTimeCycle==='s'){electricPrices=tariffInfo.electricity_set.find(function(_ref10){var potencia_contratada=_ref10.potencia_contratada,ciclo_horario=_ref10.ciclo_horario;return potencia_contratada===val&&ciclo_horario==='s';});}if(tariffInfo.electricity_set&&tariffInfo.electricity_set.length&&tariff.priceListTimeCycle==='b'){electricPrices=tariffInfo.electricity_set.find(function(_ref11){var potencia_contratada=_ref11.potencia_contratada,ciclo_horario=_ref11.ciclo_horario;return potencia_contratada===val&&ciclo_horario==='b';});}electricity=electricPrices?{cheia:parseFloat(electricPrices.cheias),ponta:parseFloat(electricPrices.ponta),super_vazio:parseFloat(electricPrices.super_vazio),termo_fixo:parseFloat(electricPrices.potencia_contratada_preco),vazio:parseFloat(electricPrices.vazio_normal)}:null;_this2.setState({tariffObj:Object.assign({},tariff,{prices:{electricity:electricity,gas:tariff.prices.gas}})});case 6:case'end':return _context.stop();}}},_callee,_this2);}));return function onChangePontenty(_x){return _ref9.apply(this,arguments);};}();var filteredPotencies=__WEBPACK_IMPORTED_MODULE_19__data__["f" /* POTENCY */].values.filter(function(_ref12){var value=_ref12.value;if(tariffInfo.electricity_set.length){return tariffInfo.electricity_set.find(function(_ref13){var potencia_contratada=_ref13.potencia_contratada;return potencia_contratada===value;});}return false;});return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Container,{auto:'off',onSubmit:function onSubmit(e){return e.preventDefault();}},index===0&&isHome&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(GeneralInformation,Object.assign({},formData.electric,{potencies:filteredPotencies,onChange:onChangePontenty,tariff:tariffObj,additionalServices:additionalServices})),index===0&&!isHome&&!__WEBPACK_IMPORTED_MODULE_20_config__["k" /* isEnterprise */]&&isEleContract&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(SimplePersonalPanel,Object.assign({},formData.personal,{onChange:onChange,reqMail:subscription_requires_email,reqPhone:subscription_requires_phone})),index===0&&!isHome&&!__WEBPACK_IMPORTED_MODULE_20_config__["k" /* isEnterprise */]&&!isEleContract&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(PersonalPanel,Object.assign({},formData.personal,{onChange:onChange,reqMail:subscription_requires_email,reqPhone:subscription_requires_phone})),index===0&&!isHome&&__WEBPACK_IMPORTED_MODULE_20_config__["k" /* isEnterprise */]&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(EnterprisePanel,Object.assign({},formData.personal,{onChange:onChange,caes:caes,reqMail:subscription_requires_email,reqPhone:subscription_requires_phone})),index===1&&isHome&&!__WEBPACK_IMPORTED_MODULE_20_config__["k" /* isEnterprise */]&&isEleContract&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(SimplePersonalPanel,Object.assign({},formData.personal,{onChange:onChange,reqMail:subscription_requires_email,reqPhone:subscription_requires_phone})),index===1&&isHome&&!__WEBPACK_IMPORTED_MODULE_20_config__["k" /* isEnterprise */]&&!isEleContract&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(PersonalPanel,Object.assign({},formData.personal,{onChange:onChange,reqMail:subscription_requires_email,reqPhone:subscription_requires_phone})),index===1&&isHome&&__WEBPACK_IMPORTED_MODULE_20_config__["k" /* isEnterprise */]&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(EnterprisePanel,Object.assign({},formData.personal,{onChange:onChange,caes:caes,reqMail:subscription_requires_email,reqPhone:subscription_requires_phone})),index===1&&!isHome&&tariffInfo&&!isEleContract&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(BillingPanel,Object.assign({},formData.billing,{getPostal:getPostal,tariffAditionalInfo:tariffInfo&&tariffInfo.pricelistadditionalinfo,districts:districts,municipalities:municipalities,billingMunicipalities:billingMunicipalities,onChange:onChange,loadingAddress:loadingAddress,addressNotFound:addressNotFound})),index===2&&isHome&&tariffInfo&&!isEleContract&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(BillingPanel,Object.assign({},formData.billing,{getPostal:getPostal,tariffAditionalInfo:tariffInfo&&tariffInfo.pricelistadditionalinfo,districts:districts,municipalities:municipalities,billingMunicipalities:billingMunicipalities,onChange:onChange,loadingAddress:loadingAddress,addressNotFound:addressNotFound})),index===2&&!isHome&&hasEletricity&&!isSimple&&!isEleContract&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(ElectricityPanel,Object.assign({},formData.electric,{userProfile:userProfile,entity:tariffObj.electricityPriceList.entity,entities:electricEntities,onChange:onChange,isHome:isHome})),index===gasTab&&!isHome&&hasGas&&!isSimple&&!isEleContract&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(GasPanel,Object.assign({},formData.gas,{userProfile:userProfile,entity:tariffObj.gasPriceList.entity,entities:gasEntities,onChange:onChange})),index===numberOfTabs-1&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(ConfirmationPanel,{tariff:tariffObj,entries:formData,labels:this.labels,getRef:this.props.finalRef,eletricEntities:electricEntities,gasEntities:gasEntities,entity:this.props.tariffInfo.entity,changeAllowDataSharing:function changeAllowDataSharing(){return onChange('confirm','allowDataSharing',!formData.confirm.allowDataSharing.value);},hasEletricity:hasEletricity,hasGas:hasGas,districts:districts,municipalities:municipalities,billingMunicipalities:billingMunicipalities,tariffInfo:this.props.tariffInfo,caes:caes}));}}]);return TariffAdhesion;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);var Container=__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].form(_templateObject);var Title=__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].h6(_templateObject2);var Summary=__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div(_templateObject3);var InfoEntry=__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div(_templateObject4);var EntryLabel=__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].span(_templateObject5);var EntryText=__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].span(_templateObject6);var CheckboxWrapper=__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div(_templateObject7);var Label=__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div(_templateObject8);var Logo=__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].img(_templateObject9);var Error=__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].span(_templateObject10);var InfoLabel=__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].span(_templateObject11);var Disclaimer=__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div(_templateObject12);var DisclaimerTitle=__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].span(_templateObject13);var DisclaimerText=__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div(_templateObject14,function(_ref14){var red=_ref14.red;return red&&'\ncolor: indianred;\n';});var ListBall=__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div(_templateObject15);var StyledSelectCae=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_23_react_virtualized_select___default.a)(_templateObject16);var CaeLabel=__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].label(_templateObject17);var TermsLink=__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].a(_templateObject18);/* harmony default export */ __webpack_exports__["a"] = (TariffAdhesion);var AdditionalWrapper=__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div(_templateObject19);var AbsoluteToltip=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_28_components_Toltip__["a" /* default */])(_templateObject20);

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_flexbox_grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_flexbox_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_flexbox_grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_AditionalServices__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Util__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils__ = __webpack_require__(11);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  color: #3e3e3e;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 14px;\n'],['\n  display: block;\n  color: #3e3e3e;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 14px;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #9c9c9c;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 14px;\n'],['\n  color: #9c9c9c;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 14px;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-weight: normal;\n'],['\n  font-weight: normal;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #676767;\n  font-family: Nunito;\n  font-size: 18px;\n  font-weight: bold;\n  line-height: 18px;\n'],['\n  color: #676767;\n  font-family: Nunito;\n  font-size: 18px;\n  font-weight: bold;\n  line-height: 18px;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #676767;\n  font-size: 18px;\n  font-weight: bold;\n  line-height: 18px;\n  display: flex;\n  justify-content: space-between;\n'],['\n  color: #676767;\n  font-size: 18px;\n  font-weight: bold;\n  line-height: 18px;\n  display: flex;\n  justify-content: space-between;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #676767;\n  font-size: 12px;\n  font-weight: 100;\n\n  margin-right: 10px;\n  display: inline-block;\n  vertical-align: middle;\n'],['\n  color: #676767;\n  font-size: 12px;\n  font-weight: 100;\n\n  margin-right: 10px;\n  display: inline-block;\n  vertical-align: middle;\n']);var Energy=function Energy(_ref){var filters=_ref.filters,ponta=_ref.ponta,cheia=_ref.cheia,vazio=_ref.vazio,super_vazio=_ref.super_vazio;if(filters.tariff.value==='s'){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Number,null,vazio&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_utils__["o" /* replaceDots */])(vazio)||'---');}else if(filters.tariff.value==='b'){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Number,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(NumberLabel,null,'Fora do vazio'),cheia&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_utils__["o" /* replaceDots */])(cheia)||'---'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Number,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(NumberLabel,null,'Vazio'),vazio&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_utils__["o" /* replaceDots */])(vazio)||'---'));}else{return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Number,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(NumberLabel,null,'Ponta'),ponta&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_utils__["o" /* replaceDots */])(ponta)||'---'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Number,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(NumberLabel,null,'Cheias'),cheia&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_utils__["o" /* replaceDots */])(cheia)||'---'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Number,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(NumberLabel,null,'Vazio'),vazio&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_utils__["o" /* replaceDots */])(vazio)||'---'));}};var EnergyGas=function EnergyGas(_ref2){var filters=_ref2.filters,gasData=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref2,['filters']);// Back end doens't filter by "escalão" this so we have to 😅
var field=gasData.escalao;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Number,null,field&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_utils__["o" /* replaceDots */])(field)||'---');};var TariffSummary=function TariffSummary(props){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,props.tariff.electricityPriceList&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Util__["a" /* Marginer */],{top:'24',right:'0',bottom:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Title,null,'Eletricidade'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Util__["a" /* Marginer */],{top:'12',right:'0',bottom:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Label,null,'Termo Pot\xEAncia ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Unit,null,'(\u20AC/dia)')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Value,null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_utils__["o" /* replaceDots */])(props.tariff.prices.electricity.termo_fixo))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Label,null,'Energia ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Unit,null,'(\u20AC/kWh)')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Energy,Object.assign({filters:props.entries.electric},props.tariff.prices.electricity)))))),props.tariff.gasPriceList&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Util__["a" /* Marginer */],{top:'48',right:'0',left:'0',bottom:'0'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Title,null,'G\xE1s Natural'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Util__["a" /* Marginer */],{top:'12',right:'0',bottom:'0',left:'0'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Label,null,'Termo Fixo ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Unit,null,'(\u20AC/dia)')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Value,null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_utils__["o" /* replaceDots */])(props.tariff.prices.gas.termo_fixo))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_flexbox_grid__["Col"],{xs:6},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Label,null,'Energia ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Unit,null,'(\u20AC/kWh)')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(EnergyGas,Object.assign({filters:props.entries.gas},props.tariff.prices.gas)))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Util__["a" /* Marginer */],{top:'48',right:'0',left:'0',bottom:'0'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_flexbox_grid__["Row"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_AditionalServices__["a" /* default */],{list:props.tariffInfo.additional_services}))));};var Title=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].span(_templateObject);var Label=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].span(_templateObject2);var Unit=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].span(_templateObject3);var Value=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject4);var Number=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].span(_templateObject5);var NumberLabel=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].span(_templateObject6);/* harmony default export */ __webpack_exports__["a"] = (TariffSummary);

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  border: 1px solid #bababa;\n  border-radius: 20px;\n  position: relative;\n  height: 14px;\n  width: 34px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n'],['\n  border: 1px solid #bababa;\n  border-radius: 20px;\n  position: relative;\n  height: 14px;\n  width: 34px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background: ',';\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  left: -5px;\n  border: 2px solid #ffffff;\n  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);\n\n  ','\n'],['\n  background: ',';\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  left: -5px;\n  border: 2px solid #ffffff;\n  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);\n\n  ','\n']);/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ToogleWrapper,props,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Circle,{selected:props.selected}));});var ToogleWrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject);var Circle=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject2,function(_ref){var selected=_ref.selected;return selected?'linear-gradient(270deg, #006736 0%, #93C13E 100%)':'#676767';},function(_ref2){var selected=_ref2.selected;return selected&&'\n        left: 16px\n    ';});

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Eletricity */
/* unused harmony export Gas */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TopResult; });
/* unused harmony export FaturaCol */
/* unused harmony export Numbery */
/* unused harmony export Label */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_flexbox_grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_flexbox_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_flexbox_grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ubiwherenpm_adene_ui_components__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_change_component_svg__ = __webpack_require__(1654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_change_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_change_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Svg_ic_editar_svg__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Svg_ic_editar_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Svg_ic_editar_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils__ = __webpack_require__(11);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 0.25 !important;\n'],['\n  flex: 0.25 !important;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #006736;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 14px;\n  cursor: pointer;\n  position: absolute;\n  top: -30px;\n  margin-left: 20px;\n  display: block;\n  width: 127%;\n'],['\n  color: #006736;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 14px;\n  cursor: pointer;\n  position: absolute;\n  top: -30px;\n  margin-left: 20px;\n  display: block;\n  width: 127%;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-size: 18px;\n'],['\n  font-size: 18px;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: row;\n\n  @media (max-width: 1200px) {\n    flex-direction: column !important;\n  }\n'],['\n  display: flex;\n  flex-direction: row;\n\n  @media (max-width: 1200px) {\n    flex-direction: column !important;\n  }\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 180px;\n  width: 100%;\n  width: 100%;\n  margin: 0 auto;\n  position: relative;\n  top: -100px;\n  display: flex;\n  margin-bottom: -100px;\n\n  ','\n\n  @media(max-width: 1200px) {\n    width: 100%;\n    flex-direction: column !important;\n    height: initial;\n  }\n'],['\n  height: 180px;\n  width: 100%;\n  width: 100%;\n  margin: 0 auto;\n  position: relative;\n  top: -100px;\n  display: flex;\n  margin-bottom: -100px;\n\n  ','\n\n  @media(max-width: 1200px) {\n    width: 100%;\n    flex-direction: column !important;\n    height: initial;\n  }\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin: 0 !important;\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: auto;\n  height: 100%;\n\n  @media (max-width: 1200px) {\n    display: flex;\n    flex-direction: column !important;\n  }\n\n  ','\n'],['\n  margin: 0 !important;\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: auto;\n  height: 100%;\n\n  @media (max-width: 1200px) {\n    display: flex;\n    flex-direction: column !important;\n  }\n\n  ','\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n  height: 100%;\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: auto;\n\n  @media (max-width: 1200px) {\n    margin-left: initial !important;\n    margin-right: initial !important;\n  }\n'],['\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n  height: 100%;\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: auto;\n\n  @media (max-width: 1200px) {\n    margin-left: initial !important;\n    margin-right: initial !important;\n  }\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex: 1;\n\n  @media (max-width: 1200px) {\n    max-width: 100%;\n    flex-direction: column;\n  }\n'],['\n  display: flex;\n  flex: 1;\n\n  @media (max-width: 1200px) {\n    max-width: 100%;\n    flex-direction: column;\n  }\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background-color: #676767;\n  flex: 0.2;\n  position: relative;\n\n  @media (max-width: 1200px) {\n    min-width: 150px;\n  }\n\n  ','\n'],['\n  background-color: #676767;\n  flex: 0.2;\n  position: relative;\n\n  @media (max-width: 1200px) {\n    min-width: 150px;\n  }\n\n  ','\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: row;\n  border-right: 1px solid #f9f9f9;\n\n  @media (max-width: 1200px) {\n    margin-right: 0;\n    min-width: 165px;\n    min-height: 170px;\n  }\n\n  @media (max-width: 1000px) {\n    border-right: none;\n  }\n\n  @media (max-width: 440px) {\n    flex-direction: column;\n  }\n'],['\n  display: flex;\n  flex-direction: row;\n  border-right: 1px solid #f9f9f9;\n\n  @media (max-width: 1200px) {\n    margin-right: 0;\n    min-width: 165px;\n    min-height: 170px;\n  }\n\n  @media (max-width: 1000px) {\n    border-right: none;\n  }\n\n  @media (max-width: 440px) {\n    flex-direction: column;\n  }\n']),_templateObject11=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 5%;\n\n  @media (max-width: 1200px) {\n    margin-right: 0;\n    min-width: 165px;\n    min-height: 170px;\n  }\n\n  @media (max-width: 440px) {\n    flex-direction: column;\n  }\n'],['\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 5%;\n\n  @media (max-width: 1200px) {\n    margin-right: 0;\n    min-width: 165px;\n    min-height: 170px;\n  }\n\n  @media (max-width: 440px) {\n    flex-direction: column;\n  }\n']),_templateObject12=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 56px;\n  width: 150px;\n  border: 1px solid #efefef;\n  background-color: #ffffff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n'],['\n  height: 56px;\n  width: 150px;\n  border: 1px solid #efefef;\n  background-color: #ffffff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n']),_templateObject13=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: row;\n  position: absolute;\n  top: -56px;\n'],['\n  display: flex;\n  flex-direction: row;\n  position: absolute;\n  top: -56px;\n']),_templateObject14=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  font-size: 12px;\n  color: #676767;\n  font-weight: 600;\n  line-height: 10px;\n  text-align: center;\n'],['\n  display: block;\n  font-size: 12px;\n  color: #676767;\n  font-weight: 600;\n  line-height: 10px;\n  text-align: center;\n']),_templateObject15=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #93c13e;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 16px;\n  text-align: center;\n  margin-top: 8px;\n'],['\n  color: #93c13e;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 16px;\n  text-align: center;\n  margin-top: 8px;\n']),_templateObject16=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #676767;\n  font-family: Nunito;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 24px;\n  text-align: center;\n'],['\n  color: #676767;\n  font-family: Nunito;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 24px;\n  text-align: center;\n']),_templateObject17=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  border: 1px solid #efefef;\n  background-color: rgba(255, 255, 255, 0.6);\n  width: 197px;\n  height: 56px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  @media (max-width: 426px) {\n    width: 172px;\n  }\n\n  @media (max-width: 340px) {\n    display: none;\n  }\n'],['\n  border: 1px solid #efefef;\n  background-color: rgba(255, 255, 255, 0.6);\n  width: 197px;\n  height: 56px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  @media (max-width: 426px) {\n    width: 172px;\n  }\n\n  @media (max-width: 340px) {\n    display: none;\n  }\n']),_templateObject18=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #010101;\n  font-size: 18px;\n  font-weight: bold;\n  line-height: 24px;\n  text-align: center;\n  position: relative;\n  top: -8px;\n  height: 90%;\n  display: flex;\n  align-items: center;\n  padding: 32px;\n\n  @media (max-width: 780px) {\n    font-size: 16px;\n  }\n'],['\n  color: #010101;\n  font-size: 18px;\n  font-weight: bold;\n  line-height: 24px;\n  text-align: center;\n  position: relative;\n  top: -8px;\n  height: 90%;\n  display: flex;\n  align-items: center;\n  padding: 32px;\n\n  @media (max-width: 780px) {\n    font-size: 16px;\n  }\n']),_templateObject19=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 0.3;\n  position: relative;\n  display: flex;\n  padding: 15% 20px 0 20px;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  max-width: 150px;\n\n  @media (max-width: 1200px) {\n    max-width: none;\n    justify-content: initial;\n    align-items: initial;\n    padding: 0;\n  }\n'],['\n  flex: 0.3;\n  position: relative;\n  display: flex;\n  padding: 15% 20px 0 20px;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  max-width: 150px;\n\n  @media (max-width: 1200px) {\n    max-width: none;\n    justify-content: initial;\n    align-items: initial;\n    padding: 0;\n  }\n']),_templateObject20=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: white;\n  font-size: 18px;\n  line-height: 18px;\n  font-weight: bold;\n  margin: 10px 0;\n  margin-top: 0;\n'],['\n  color: white;\n  font-size: 18px;\n  line-height: 18px;\n  font-weight: bold;\n  margin: 10px 0;\n  margin-top: 0;\n']),_templateObject21=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-size: 13px;\n'],['\n  font-size: 13px;\n']),_templateObject22=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-weight: normal;\n'],['\n  font-weight: normal;\n']),_templateObject23=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()([''],['']),_templateObject24=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #9c9c9c;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 14px;\n'],['\n  color: #9c9c9c;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 14px;\n']),_templateObject25=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 1;\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  box-shadow: inset 1px 0 0 0 #efefef;\n  cursor: pointer;\n  margin-left: auto;\n  max-width: 150px;\n\n  @media (max-width: 1200px) {\n    flex-direction: row;\n    max-width: none;\n    margin-left: initial;\n    align-items: initial;\n  }\n\n  ','\n'],['\n  flex: 1;\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  box-shadow: inset 1px 0 0 0 #efefef;\n  cursor: pointer;\n  margin-left: auto;\n  max-width: 150px;\n\n  @media (max-width: 1200px) {\n    flex-direction: row;\n    max-width: none;\n    margin-left: initial;\n    align-items: initial;\n  }\n\n  ','\n']),_templateObject26=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  border: 0;\n  background: none;\n  outline: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  background-color: #efefef;\n  border: 1px solid #dedede;\n  flex: 1;\n  width: 100%;\n  padding: 0 15px;\n  box-shadow: inset 1px -1px 0 0 #efefef;\n\n  &:last-child {\n    box-shadow: none;\n  }\n\n  @media (max-width: 1200px) {\n    padding: 16px;\n  }\n'],['\n  border: 0;\n  background: none;\n  outline: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  background-color: #efefef;\n  border: 1px solid #dedede;\n  flex: 1;\n  width: 100%;\n  padding: 0 15px;\n  box-shadow: inset 1px -1px 0 0 #efefef;\n\n  &:last-child {\n    box-shadow: none;\n  }\n\n  @media (max-width: 1200px) {\n    padding: 16px;\n  }\n']),_templateObject27=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  text-align: center;\n  font-weight: bold;\n  color: #3e3e3e;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 16px;\n  text-align: left;\n  margin-left: 10px;\n  flex: 1;\n\n  @media (max-width: 340px) {\n    font-size: 12px;\n  }\n'],['\n  display: block;\n  text-align: center;\n  font-weight: bold;\n  color: #3e3e3e;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 16px;\n  text-align: left;\n  margin-left: 10px;\n  flex: 1;\n\n  @media (max-width: 340px) {\n    font-size: 12px;\n  }\n']),_templateObject28=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #676767;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 18px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  margin: 2px 0;\n'],['\n  color: #676767;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 18px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  margin: 2px 0;\n']),_templateObject29=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-size: 12px;\n  line-height: 12px;\n  color: #676767;\n  font-weight: bold;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  margin: 2px 0;\n'],['\n  font-size: 12px;\n  line-height: 12px;\n  color: #676767;\n  font-weight: bold;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  margin: 2px 0;\n']),_templateObject30=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #676767;\n  font-size: 14px;\n  font-weight: 100;\n\n  margin-right: 10px;\n  display: inline-block;\n  vertical-align: middle;\n'],['\n  color: #676767;\n  font-size: 14px;\n  font-weight: 100;\n\n  margin-right: 10px;\n  display: inline-block;\n  vertical-align: middle;\n']),_templateObject31=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #676767;\n  font-size: 12px;\n  font-weight: 100;\n\n  margin-right: 10px;\n  display: inline-block;\n  vertical-align: middle;\n'],['\n  color: #676767;\n  font-size: 12px;\n  font-weight: 100;\n\n  margin-right: 10px;\n  display: inline-block;\n  vertical-align: middle;\n']),_templateObject32=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 0.25;\n  text-align: left;\n  margin-left: 35px;\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  margin-top: 20px;\n  min-width: 190px;\n  margin-right: 10px;\n\n  @media (max-width: 1200px) {\n    margin-right: 35px;\n    min-width: 290px;\n    margin-left: 20px;\n  }\n\n  @media (max-width: 1100px) {\n    min-width: 220px !important;\n  }\n'],['\n  flex: 0.25;\n  text-align: left;\n  margin-left: 35px;\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  margin-top: 20px;\n  min-width: 190px;\n  margin-right: 10px;\n\n  @media (max-width: 1200px) {\n    margin-right: 35px;\n    min-width: 290px;\n    margin-left: 20px;\n  }\n\n  @media (max-width: 1100px) {\n    min-width: 220px !important;\n  }\n']),_templateObject33=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 0.25;\n  text-align: left;\n  padding: 0 0 0 15px;\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  justify-content: flex-start;\n  min-width: 120px;\n  margin-top: 20px;\n  align-items: center;\n\n  @media (max-width: 1100px) {\n    text-align: center;\n  }\n'],['\n  flex: 0.25;\n  text-align: left;\n  padding: 0 0 0 15px;\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  justify-content: flex-start;\n  min-width: 120px;\n  margin-top: 20px;\n  align-items: center;\n\n  @media (max-width: 1100px) {\n    text-align: center;\n  }\n']),_templateObject34=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 0.25;\n  text-align: left;\n  margin-left: 15px;\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  justify-content: flex-start;\n  min-width: 95px;\n  margin-top: 20px;\n  align-items: center;\n\n  @media (max-width: 1100px) {\n    min-width: 75px !important;\n  }\n'],['\n  flex: 0.25;\n  text-align: left;\n  margin-left: 15px;\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  justify-content: flex-start;\n  min-width: 95px;\n  margin-top: 20px;\n  align-items: center;\n\n  @media (max-width: 1100px) {\n    min-width: 75px !important;\n  }\n']),_templateObject35=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  max-height: 50%;\n  max-width: 50%;\n  display: block;\n\n  @media (max-width: 440px) {\n    max-width: 30% !important;\n  }\n'],['\n  max-height: 50%;\n  max-width: 50%;\n  display: block;\n\n  @media (max-width: 440px) {\n    max-width: 30% !important;\n  }\n']),_templateObject36=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 14px;\n  margin: 20px 0;\n  color: #ccc;\n  white-space: nowrap;\n'],['\n  display: block;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 14px;\n  margin: 20px 0;\n  color: #ccc;\n  white-space: nowrap;\n']),_templateObject37=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 14px;\n  margin: 10px 0;\n  margin-top: 10px;\n  color: ',';\n\n  span {\n    color: #ccc;\n  }\n'],['\n  display: block;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 14px;\n  margin: 10px 0;\n  margin-top: 10px;\n  color: ',';\n\n  span {\n    color: #ccc;\n  }\n']),_templateObject38=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: absolute !important;\n  top: -75px;\n  right: 0;\n\n  @media screen and (max-width: 768px) {\n    position: relative;\n    top: initial;\n    width: 100%;\n  }\n\n  .resp-sharing-button__link,\n  .resp-sharing-button__icon {\n    display: inline-block;\n  }\n\n  .resp-sharing-button__link {\n    text-decoration: none;\n    color: #fff;\n    margin: 2px;\n  }\n\n  .resp-sharing-button {\n    border-radius: 5px;\n    transition: 25ms ease-out;\n    padding: 0.5em 0.75em;\n    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;\n  }\n\n  .resp-sharing-button__icon svg {\n    width: 1em;\n    height: 1em;\n    margin-right: 0.4em;\n    vertical-align: top;\n  }\n\n  .resp-sharing-button--small svg {\n    margin: 0;\n    vertical-align: middle;\n  }\n\n  /* Non solid icons get a stroke */\n  .resp-sharing-button__icon {\n    stroke: #fff;\n    fill: none;\n  }\n\n  /* Solid icons get a fill */\n  .resp-sharing-button__icon--solid,\n  .resp-sharing-button__icon--solidcircle {\n    fill: #fff;\n    stroke: none;\n  }\n\n  .resp-sharing-button--twitter {\n    background-color: #55acee;\n  }\n\n  .resp-sharing-button--twitter:hover {\n    background-color: #2795e9;\n  }\n\n  .resp-sharing-button--pinterest {\n    background-color: #bd081c;\n  }\n\n  .resp-sharing-button--pinterest:hover {\n    background-color: #8c0615;\n  }\n\n  .resp-sharing-button--facebook {\n    background-color: #3b5998;\n  }\n\n  .resp-sharing-button--facebook:hover {\n    background-color: #2d4373;\n  }\n\n  .resp-sharing-button--tumblr {\n    background-color: #35465c;\n  }\n\n  .resp-sharing-button--tumblr:hover {\n    background-color: #222d3c;\n  }\n\n  .resp-sharing-button--reddit {\n    background-color: #5f99cf;\n  }\n\n  .resp-sharing-button--reddit:hover {\n    background-color: #3a80c1;\n  }\n\n  .resp-sharing-button--google {\n    background-color: #dd4b39;\n  }\n\n  .resp-sharing-button--google:hover {\n    background-color: #c23321;\n  }\n\n  .resp-sharing-button--linkedin {\n    background-color: #0077b5;\n  }\n\n  .resp-sharing-button--linkedin:hover {\n    background-color: #046293;\n  }\n\n  .resp-sharing-button--email {\n    background-color: #777;\n  }\n\n  .resp-sharing-button--email:hover {\n    background-color: #5e5e5e;\n  }\n\n  .resp-sharing-button--xing {\n    background-color: #1a7576;\n  }\n\n  .resp-sharing-button--xing:hover {\n    background-color: #114c4c;\n  }\n\n  .resp-sharing-button--whatsapp {\n    background-color: #25d366;\n  }\n\n  .resp-sharing-button--whatsapp:hover {\n    background-color: #1da851;\n  }\n\n  .resp-sharing-button--hackernews {\n    background-color: #ff6600;\n  }\n  .resp-sharing-button--hackernews:hover,\n  .resp-sharing-button--hackernews:focus {\n    background-color: #fb6200;\n  }\n\n  .resp-sharing-button--vk {\n    background-color: #507299;\n  }\n\n  .resp-sharing-button--vk:hover {\n    background-color: #43648c;\n  }\n\n  .resp-sharing-button--facebook {\n    background-color: #3b5998;\n    border-color: #3b5998;\n  }\n\n  .resp-sharing-button--facebook:hover,\n  .resp-sharing-button--facebook:active {\n    background-color: #2d4373;\n    border-color: #2d4373;\n  }\n\n  .resp-sharing-button--twitter {\n    background-color: #55acee;\n    border-color: #55acee;\n  }\n\n  .resp-sharing-button--twitter:hover,\n  .resp-sharing-button--twitter:active {\n    background-color: #2795e9;\n    border-color: #2795e9;\n  }\n\n  .resp-sharing-button--email {\n    background-color: #777777;\n    border-color: #777777;\n  }\n\n  .resp-sharing-button--email:hover,\n  .resp-sharing-button--email:active {\n    background-color: #5e5e5e;\n    border-color: #5e5e5e;\n  }\n\n  .resp-sharing-button--whatsapp {\n    background-color: #25d366;\n    border-color: #25d366;\n  }\n\n  .resp-sharing-button--whatsapp:hover,\n  .resp-sharing-button--whatsapp:active {\n    background-color: #1da851;\n    border-color: #1da851;\n  }\n\n  .sharebox-dialog {\n    display: none;\n    position: absolute;\n    left: 65px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  &:hover {\n    .sharebox-dialog {\n      display: block;\n    }\n\n    .sharebox-text {\n      opacity: 0;\n    }\n  }\n'],['\n  position: absolute !important;\n  top: -75px;\n  right: 0;\n\n  @media screen and (max-width: 768px) {\n    position: relative;\n    top: initial;\n    width: 100%;\n  }\n\n  .resp-sharing-button__link,\n  .resp-sharing-button__icon {\n    display: inline-block;\n  }\n\n  .resp-sharing-button__link {\n    text-decoration: none;\n    color: #fff;\n    margin: 2px;\n  }\n\n  .resp-sharing-button {\n    border-radius: 5px;\n    transition: 25ms ease-out;\n    padding: 0.5em 0.75em;\n    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;\n  }\n\n  .resp-sharing-button__icon svg {\n    width: 1em;\n    height: 1em;\n    margin-right: 0.4em;\n    vertical-align: top;\n  }\n\n  .resp-sharing-button--small svg {\n    margin: 0;\n    vertical-align: middle;\n  }\n\n  /* Non solid icons get a stroke */\n  .resp-sharing-button__icon {\n    stroke: #fff;\n    fill: none;\n  }\n\n  /* Solid icons get a fill */\n  .resp-sharing-button__icon--solid,\n  .resp-sharing-button__icon--solidcircle {\n    fill: #fff;\n    stroke: none;\n  }\n\n  .resp-sharing-button--twitter {\n    background-color: #55acee;\n  }\n\n  .resp-sharing-button--twitter:hover {\n    background-color: #2795e9;\n  }\n\n  .resp-sharing-button--pinterest {\n    background-color: #bd081c;\n  }\n\n  .resp-sharing-button--pinterest:hover {\n    background-color: #8c0615;\n  }\n\n  .resp-sharing-button--facebook {\n    background-color: #3b5998;\n  }\n\n  .resp-sharing-button--facebook:hover {\n    background-color: #2d4373;\n  }\n\n  .resp-sharing-button--tumblr {\n    background-color: #35465c;\n  }\n\n  .resp-sharing-button--tumblr:hover {\n    background-color: #222d3c;\n  }\n\n  .resp-sharing-button--reddit {\n    background-color: #5f99cf;\n  }\n\n  .resp-sharing-button--reddit:hover {\n    background-color: #3a80c1;\n  }\n\n  .resp-sharing-button--google {\n    background-color: #dd4b39;\n  }\n\n  .resp-sharing-button--google:hover {\n    background-color: #c23321;\n  }\n\n  .resp-sharing-button--linkedin {\n    background-color: #0077b5;\n  }\n\n  .resp-sharing-button--linkedin:hover {\n    background-color: #046293;\n  }\n\n  .resp-sharing-button--email {\n    background-color: #777;\n  }\n\n  .resp-sharing-button--email:hover {\n    background-color: #5e5e5e;\n  }\n\n  .resp-sharing-button--xing {\n    background-color: #1a7576;\n  }\n\n  .resp-sharing-button--xing:hover {\n    background-color: #114c4c;\n  }\n\n  .resp-sharing-button--whatsapp {\n    background-color: #25d366;\n  }\n\n  .resp-sharing-button--whatsapp:hover {\n    background-color: #1da851;\n  }\n\n  .resp-sharing-button--hackernews {\n    background-color: #ff6600;\n  }\n  .resp-sharing-button--hackernews:hover,\n  .resp-sharing-button--hackernews:focus {\n    background-color: #fb6200;\n  }\n\n  .resp-sharing-button--vk {\n    background-color: #507299;\n  }\n\n  .resp-sharing-button--vk:hover {\n    background-color: #43648c;\n  }\n\n  .resp-sharing-button--facebook {\n    background-color: #3b5998;\n    border-color: #3b5998;\n  }\n\n  .resp-sharing-button--facebook:hover,\n  .resp-sharing-button--facebook:active {\n    background-color: #2d4373;\n    border-color: #2d4373;\n  }\n\n  .resp-sharing-button--twitter {\n    background-color: #55acee;\n    border-color: #55acee;\n  }\n\n  .resp-sharing-button--twitter:hover,\n  .resp-sharing-button--twitter:active {\n    background-color: #2795e9;\n    border-color: #2795e9;\n  }\n\n  .resp-sharing-button--email {\n    background-color: #777777;\n    border-color: #777777;\n  }\n\n  .resp-sharing-button--email:hover,\n  .resp-sharing-button--email:active {\n    background-color: #5e5e5e;\n    border-color: #5e5e5e;\n  }\n\n  .resp-sharing-button--whatsapp {\n    background-color: #25d366;\n    border-color: #25d366;\n  }\n\n  .resp-sharing-button--whatsapp:hover,\n  .resp-sharing-button--whatsapp:active {\n    background-color: #1da851;\n    border-color: #1da851;\n  }\n\n  .sharebox-dialog {\n    display: none;\n    position: absolute;\n    left: 65px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  &:hover {\n    .sharebox-dialog {\n      display: block;\n    }\n\n    .sharebox-text {\n      opacity: 0;\n    }\n  }\n']),_templateObject39=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  outline: none;\n  border: 1px solid #dedede;\n  background-color: #efefef;\n  color: #676767;\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 19px;\n  -webkit-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 14px;\n\n  .sharebox-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .sharebox-text {\n    padding: 0 24px;\n    flex: 1;\n    color: #010101;\n    font-family: Nunito;\n    font-size: 12px;\n    font-weight: bold;\n    letter-spacing: 0;\n    line-height: 16px;\n  }\n\n  .sharebox-carrot {\n    width: 60px;\n    height: 60px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n'],['\n  outline: none;\n  border: 1px solid #dedede;\n  background-color: #efefef;\n  color: #676767;\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 19px;\n  -webkit-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 14px;\n\n  .sharebox-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .sharebox-text {\n    padding: 0 24px;\n    flex: 1;\n    color: #010101;\n    font-family: Nunito;\n    font-size: 12px;\n    font-weight: bold;\n    letter-spacing: 0;\n    line-height: 16px;\n  }\n\n  .sharebox-carrot {\n    width: 60px;\n    height: 60px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n']);var Eletricity=function Eletricity(_ref){var electricityConsumption=_ref.electricityConsumption,prices=_ref.prices,timeCycle=_ref.timeCycle,entity=_ref.entity,className=_ref.className;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(EletricityRow,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(EletricityEntityCol,{className:className},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ResultLabel,{el:true},'Eletricidade'),entity&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Entity,{src:entity.logo,alt:entity.name})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(NumberysCol,null,electricityConsumption&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Numberyx,{style:{marginBottom:12}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(NumberyLabel,null,'Consumo'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Price,null,Number(electricityConsumption).toFixed(0)||'---',' ',__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Unit,null,'kWh/ano'))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Numberyx,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(NumberyLabel,null,'Termo Pot\xEAncia'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Price,null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["g" /* pricesCurrency */])(prices.electricity.termo_fixo)||'---',' ',__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Unit,null,'\u20AC/dia'))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Numberyx,{style:{marginTop:12}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(NumberyLabel,null,'Energia'),timeCycle==='s'&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Price,null,''+(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["g" /* pricesCurrency */])(prices.electricity.cheia)||'---'),' ',__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Unit,null,'\u20AC/kWh'))),timeCycle==='b'&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(NumberyxSmall,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(NumberyLabelSmall,null,'Fora do Vazio'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Price,null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["g" /* pricesCurrency */])(prices.electricity.cheia)||'---',' ',__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Unit,null,'\u20AC/kWh'))),timeCycle!=='s'&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(NumberyxSmall,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(NumberyLabelSmall,null,'Vazio'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Price,null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["g" /* pricesCurrency */])(prices.electricity.vazio)||'---',' ',__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Unit,null,'\u20AC/kWh'))),timeCycle!=='b'&&timeCycle!=='s'&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(NumberyxSmall,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(NumberyLabelSmall,null,'Ponta'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Price,null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["g" /* pricesCurrency */])(prices.electricity.ponta)||'---',' ',__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Unit,null,'\u20AC/kWh'))),timeCycle!=='b'&&timeCycle!=='s'&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(NumberyxSmall,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(NumberyLabelSmall,null,'Cheias'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Price,null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["g" /* pricesCurrency */])(prices.electricity.cheia)||'---',' ',__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Unit,null,'\u20AC/kWh')))));};var Gas=function Gas(_ref2){var gasConsumption=_ref2.gasConsumption,prices=_ref2.prices,entity=_ref2.entity,className=_ref2.className;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(GasRow,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(GasEntityCol,{className:className},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ResultLabel,{ga:true},'G\xE1s Natural'),entity&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Entity,{src:entity.logo,alt:entity.name})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(NumberysCol,null,gasConsumption&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Numberyx,{style:{marginBottom:12}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(NumberyLabel,null,'Consumo'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Price,null,Number(gasConsumption).toFixed(0)||'---',' ',__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Unit,null,'kWh/ano'))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Numberyx,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(NumberyLabel,null,'Termo Fixo'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Price,null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["g" /* pricesCurrency */])(prices.gas.termo_fixo)||'---',' ',__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Unit,null,'\u20AC/dia'))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Numberyx,{style:{marginTop:12}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(NumberyLabel,null,'Energia'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Price,null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["g" /* pricesCurrency */])(prices.gas.termo_energia)||'---',' ',__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Unit,null,'\u20AC/kWh')))));};var TopResult=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TopResult,_Component);function TopResult(){__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,TopResult);return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(TopResult.__proto__||Object.getPrototypeOf(TopResult)).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TopResult,[{key:'handleChangeSimulationData',value:function handleChangeSimulationData(){var _props=this.props,router=_props.router,changeSimulationData=_props.changeSimulationData;changeSimulationData();router.push('/');}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,annualBilling=_props2.annualBilling,electricityPriceList=_props2.electricityPriceList,gasPriceList=_props2.gasPriceList,simulationCode=_props2.simulationCode,hasSimulation=_props2.hasSimulation,error=_props2.error,onClickToSave=_props2.onClickToSave,onClickToChangePrices=_props2.onClickToChangePrices;var entity=void 0;if(electricityPriceList){entity=electricityPriceList.entity;if(entity){entity.logo=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["f" /* generateMediaUrl */])(entity.hi_res_logo);}}if(gasPriceList){entity=gasPriceList.entity;if(entity){entity.logo=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["f" /* generateMediaUrl */])(entity.hi_res_logo);}}return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Wrapper,{noSimulation:!hasSimulation},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Container,{fluid:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(FiltersList,{noSimulation:!hasSimulation},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Scrollable,{noSimulation:!hasSimulation},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Flexed,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(GreyCol,{noSimulation:!hasSimulation},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Simulation,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(SimulationNumber,{noSimulation:!hasSimulation},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ChangeData,{onClick:function onClick(){return _this2.handleChangeSimulationData();}},' ',__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(BackButton,null,'<'),' Alterar dados da simula\xE7\xE3o'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(SimulationLabel,null,'simula\xE7\xE3o'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(SimulationNumbery,null,'#',simulationCode)),hasSimulation&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(SimulationTitle,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Title,null,'O seu tarif\xE1rio atual'))),hasSimulation&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(FaturaCol,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(TitleLabel,null,'Fatura de Energia *'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Numbery,null,annualBilling&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["i" /* unitCurrency */])(annualBilling),' \u20AC/ano'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(SmallNumber,null,annualBilling&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["i" /* unitCurrency */])(annualBilling/12),' ','\u20AC/m\xEAs')),!hasSimulation&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(NoSimTitle,{grey:true,dangerouslySetInnerHTML:{__html:error}})),electricityPriceList&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(FlexedElectricity,Object.assign({},this.props,{entity:electricityPriceList.entity})),gasPriceList&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(FlexedGas,Object.assign({},this.props,{entity:gasPriceList.entity})))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ChangeCol,{noSimulation:!hasSimulation},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ChangeButton,{onClick:function onClick(){return onClickToChangePrices();}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('img',{style:{marginRight:12},src:__WEBPACK_IMPORTED_MODULE_10__Svg_ic_editar_svg___default.a,alt:'Ajustar Pre\xE7os'}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ButtonLabel,null,'Ajustar Pre\xE7os')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ChangeButton,{onClick:function onClick(){return onClickToSave&&onClickToSave();}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__images_change_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ButtonLabel,null,'Guardar Perfil de Simula\xE7\xE3o')))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ShareComponent,{shareContent:'Veja a minha simula\xE7\xE3o em',shareUrl:''+window.location.origin+window.location.pathname+'?code='+simulationCode,shareTitle:'Simula\xE7\xE3o'})));}}]);return TopResult;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);var FlexedElectricity=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(Eletricity)(_templateObject);var ChangeData=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject2);var BackButton=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject3);var FlexedGas=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(Gas)(_templateObject);var Flexed=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject4);var Wrapper=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_8__ubiwherenpm_adene_ui_components__["d" /* ShadowBox */])(_templateObject5,function(_ref3){var noSimulation=_ref3.noSimulation;return noSimulation&&'\n    height: 300px;\n  ';});var FiltersList=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_7_react_flexbox_grid__["Row"])(_templateObject6,function(_ref4){var noSimulation=_ref4.noSimulation;return noSimulation&&'\n    @media(max-width: 1200px) {\n      display: flex;\n      flex-direction: column;\n    }\n  ';});var Container=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_7_react_flexbox_grid__["Grid"])(_templateObject7);var Scrollable=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject8);var GreyCol=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject9,function(_ref5){var noSimulation=_ref5.noSimulation;return noSimulation&&'\n    background: #fff;\n    flex: 2;\n  ';});var EletricityRow=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject10);var GasRow=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject11);var SimulationNumber=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject12);var Simulation=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject13);var SimulationLabel=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject14);var SimulationNumbery=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject15);var Title=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject16);var SimulationTitle=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject17);var NoSimTitle=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject18);var FaturaCol=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject19);var Numbery=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject20);var SmallNumber=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(Numbery)(_templateObject21);var Unit=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject22);var Price=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject23);var Label=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject24);var ChangeCol=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject25,function(_ref6){var noSimulation=_ref6.noSimulation;return noSimulation&&'\n    @media(max-width: 1200px) {\n      flex-direction: row;\n      max-width: none;\n      margin-left: initial;\n      align-items: initial;\n    }\n  ';});var ChangeButton=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].button(_templateObject26);var ButtonLabel=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject27);var Numberyx=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject28);var NumberyxSmall=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject29);var NumberyLabel=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject30);var NumberyLabelSmall=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject31);var NumberysCol=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject32);var GasEntityCol=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject33);var EletricityEntityCol=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject34);var Entity=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].img(_templateObject35);var TitleLabel=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject36);var ResultLabel=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject37,function(_ref7){var el=_ref7.el;return el?'#FF8E2A':'#00BDED';});var ShareComponent=function ShareComponent(_ref8){var shareUrl=_ref8.shareUrl,shareContent=_ref8.shareContent,shareTitle=_ref8.shareTitle;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ShareBoxContainer,{style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ShareBox,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{className:'sharebox-icon'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('svg',{width:24,height:26,viewBox:'0 0 24 26',xmlns:'http://www.w3.org/2000/svg'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('path',{d:'M19.333 23.44c-1.142 0-2.077-.918-2.077-2.04 0-.097.006-.186.024-.276a2.017 2.017 0 01.8-1.345 2.07 2.07 0 011.253-.42c1.143 0 2.078.918 2.078 2.041 0 1.122-.935 2.04-2.078 2.04m-14.666-8.4c-1.143 0-2.078-.918-2.078-2.04 0-1.123.935-2.04 2.078-2.04.47 0 .904.155 1.252.42.428.318.728.797.801 1.344.018.09.024.18.024.276 0 .096-.006.186-.024.276a2.016 2.016 0 01-.8 1.344 2.07 2.07 0 01-1.253.42M17.256 4.6c0-1.123.935-2.04 2.077-2.04 1.143 0 2.078.917 2.078 2.04 0 1.122-.935 2.04-2.078 2.04-.47 0-.904-.156-1.252-.42a2.016 2.016 0 01-.801-1.344 1.365 1.365 0 01-.024-.276m2.077 13.2a3.667 3.667 0 00-2.689 1.157l-8.482-4.859a3.624 3.624 0 000-2.196l8.482-4.86a3.666 3.666 0 002.69 1.158C21.355 8.2 23 6.586 23 4.6S21.356 1 19.333 1c-2.022 0-3.666 1.614-3.666 3.6 0 .384.06.75.17 1.098l-8.481 4.86A3.666 3.666 0 004.666 9.4C2.645 9.4 1 11.014 1 13c0 1.985 1.644 3.6 3.667 3.6a3.668 3.668 0 002.689-1.158l8.482 4.86c-.11.348-.171.714-.171 1.098 0 1.985 1.644 3.6 3.666 3.6C21.356 25 23 23.385 23 21.4c0-1.986-1.644-3.6-3.667-3.6',fill:'#222',fillRule:'nonzero',stroke:'#222',strokeWidth:0.6}))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{className:'sharebox-text'},'PARTILHAR RESULTADOS')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{className:'sharebox-dialog'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('a',{className:'resp-sharing-button__link',href:'https://facebook.com/sharer/sharer.php?u='+encodeURIComponent(shareUrl)+'&quote='+encodeURIComponent(shareContent),target:'_blank',rel:'noopener','aria-label':''},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{className:'resp-sharing-button resp-sharing-button--facebook resp-sharing-button--small'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{'aria-hidden':'true',className:'resp-sharing-button__icon resp-sharing-button__icon--solidcircle'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',viewBox:'0 0 24 24'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('path',{d:'M12 0C5.38 0 0 5.38 0 12s5.38 12 12 12 12-5.38 12-12S18.62 0 12 0zm3.6 11.5h-2.1v7h-3v-7h-2v-2h2V8.34c0-1.1.35-2.82 2.65-2.82h2.35v2.3h-1.4c-.25 0-.6.13-.6.66V9.5h2.34l-.24 2z'}))))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('a',{className:'resp-sharing-button__link',href:'https://twitter.com/intent/tweet/?text='+encodeURIComponent(shareContent)+'&url='+encodeURIComponent(shareUrl),target:'_blank',rel:'noopener','aria-label':''},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{className:'resp-sharing-button resp-sharing-button--twitter resp-sharing-button--small'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{'aria-hidden':'true',className:'resp-sharing-button__icon resp-sharing-button__icon--solidcircle'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',viewBox:'0 0 24 24'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('path',{d:'M12 0C5.38 0 0 5.38 0 12s5.38 12 12 12 12-5.38 12-12S18.62 0 12 0zm5.26 9.38v.34c0 3.48-2.64 7.5-7.48 7.5-1.48 0-2.87-.44-4.03-1.2 1.37.17 2.77-.2 3.9-1.08-1.16-.02-2.13-.78-2.46-1.83.38.1.8.07 1.17-.03-1.2-.24-2.1-1.3-2.1-2.58v-.05c.35.2.75.32 1.18.33-.7-.47-1.17-1.28-1.17-2.2 0-.47.13-.92.36-1.3C7.94 8.85 9.88 9.9 12.06 10c-.04-.2-.06-.4-.06-.6 0-1.46 1.18-2.63 2.63-2.63.76 0 1.44.3 1.92.82.6-.12 1.95-.27 1.95-.27-.35.53-.72 1.66-1.24 2.04z'}))))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('a',{className:'resp-sharing-button__link',href:'mailto:?subject='+encodeURIComponent(shareTitle)+'&body='+encodeURIComponent(shareContent+' '+shareUrl),target:'_self',rel:'noopener','aria-label':''},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{className:'resp-sharing-button resp-sharing-button--email resp-sharing-button--small'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{'aria-hidden':'true',className:'resp-sharing-button__icon resp-sharing-button__icon--solidcircle'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',viewBox:'0 0 24 24'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('path',{d:'M12 0C5.38 0 0 5.38 0 12s5.38 12 12 12 12-5.38 12-12S18.62 0 12 0zm8 16c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v8z'}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('path',{d:'M17.9 8.18c-.2-.2-.5-.24-.72-.07L12 12.38 6.82 8.1c-.22-.16-.53-.13-.7.08s-.15.53.06.7l3.62 2.97-3.57 2.23c-.23.14-.3.45-.15.7.1.14.25.22.42.22.1 0 .18-.02.27-.08l3.85-2.4 1.06.87c.1.04.2.1.32.1s.23-.06.32-.1l1.06-.9 3.86 2.4c.08.06.17.1.26.1.17 0 .33-.1.42-.25.15-.24.08-.55-.15-.7l-3.57-2.22 3.62-2.96c.2-.2.24-.5.07-.72z'}))))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('a',{className:'resp-sharing-button__link',href:'https://wa.me/?text='+encodeURIComponent(shareContent)+' '+encodeURIComponent(shareUrl),target:'_blank',rel:'noopener','aria-label':''},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{className:'resp-sharing-button resp-sharing-button--whatsapp resp-sharing-button--small'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{'aria-hidden':'true',className:'resp-sharing-button__icon resp-sharing-button__icon--solidcircle'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',height:'24',width:'24',viewBox:'0 0 24 24'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('path',{d:'m12 0c-6.6 0-12 5.4-12 12s5.4 12 12 12 12-5.4 12-12-5.4-12-12-12zm0 3.8c2.2 0 4.2 0.9 5.7 2.4 1.6 1.5 2.4 3.6 2.5 5.7 0 4.5-3.6 8.1-8.1 8.1-1.4 0-2.7-0.4-3.9-1l-4.4 1.1 1.2-4.2c-0.8-1.2-1.1-2.6-1.1-4 0-4.5 3.6-8.1 8.1-8.1zm0.1 1.5c-3.7 0-6.7 3-6.7 6.7 0 1.3 0.3 2.5 1 3.6l0.1 0.3-0.7 2.4 2.5-0.7 0.3 0.099c1 0.7 2.2 1 3.4 1 3.7 0 6.8-3 6.9-6.6 0-1.8-0.7-3.5-2-4.8s-3-2-4.8-2zm-3 2.9h0.4c0.2 0 0.4-0.099 0.5 0.3s0.5 1.5 0.6 1.7 0.1 0.2 0 0.3-0.1 0.2-0.2 0.3l-0.3 0.3c-0.1 0.1-0.2 0.2-0.1 0.4 0.2 0.2 0.6 0.9 1.2 1.4 0.7 0.7 1.4 0.9 1.6 1 0.2 0 0.3 0.001 0.4-0.099s0.5-0.6 0.6-0.8c0.2-0.2 0.3-0.2 0.5-0.1l1.4 0.7c0.2 0.1 0.3 0.2 0.5 0.3 0 0.1 0.1 0.5-0.099 1s-1 0.9-1.4 1c-0.3 0-0.8 0.001-1.3-0.099-0.3-0.1-0.7-0.2-1.2-0.4-2.1-0.9-3.4-3-3.5-3.1s-0.8-1.1-0.8-2.1c0-1 0.5-1.5 0.7-1.7s0.4-0.3 0.5-0.3z'})))))));};var ShareBoxContainer=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject38);var ShareBox=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject39);

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Wrapper */
/* unused harmony export Container */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__logic__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_flexbox_grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_flexbox_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_flexbox_grid__);
var _class;var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  position: relative;\n'],['\n  width: 100%;\n  position: relative;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  max-width: 1200px;\n  margin: 0 auto;\n'],['\n  max-width: 1200px;\n  margin: 0 auto;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()([''],['']);var App=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__logic__["a" /* default */])(_class=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(App,_Component);function App(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,App);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref,[this].concat(args))),_this),_this.sendHeight=function(){var height=document.body.scrollHeight;window.parent.postMessage({type:'setHeight',height:height},'*');},_temp),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(App,[{key:'componentDidUpdate',value:function componentDidUpdate(){this.sendHeight();window.addEventListener('resize',this.sendHeight);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.sendHeight);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Anchor,{id:'anchor'}),!this.props.loading&&this.props.children);}}]);return App;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]))||_class;/* harmony default export */ __webpack_exports__["a"] = (App);var Wrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject);var Container=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_8_react_flexbox_grid__["Grid"])(_templateObject2);var Anchor=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject3);

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Wrapper */
/* unused harmony export Container */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__logic__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_flexbox_grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_flexbox_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_flexbox_grid__);
var _class;var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  position: relative;\n'],['\n  width: 100%;\n  position: relative;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  max-width: 1200px;\n  margin: 0 auto;\n'],['\n  max-width: 1200px;\n  margin: 0 auto;\n']);var AppV2=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__logic__["a" /* default */])(_class=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AppV2,_Component);function AppV2(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,AppV2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=AppV2.__proto__||Object.getPrototypeOf(AppV2)).call.apply(_ref,[this].concat(args))),_this),_this.sendHeight=function(){var height=document.body.scrollHeight;window.parent.postMessage({type:'setHeight',height:height},'*');},_temp),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AppV2,[{key:'componentDidUpdate',value:function componentDidUpdate(){this.sendHeight();window.addEventListener('resize',this.sendHeight);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.sendHeight);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{id:'anchor'}),!this.props.loading&&this.props.children);}}]);return AppV2;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]))||_class;/* harmony default export */ __webpack_exports__["a"] = (AppV2);var Wrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject);var Container=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_8_react_flexbox_grid__["Grid"])(_templateObject2);

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Loading__ = __webpack_require__(30);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  position: relative;\n'],['\n  width: 100%;\n  position: relative;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  border: 0;\n  width: 100%;\n  overflow: hidden;\n  height: ','!important;\n'],['\n  border: 0;\n  width: 100%;\n  overflow: hidden;\n  height: ','!important;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  background: rgba(0, 0, 0, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  min-height: 300px;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n'],['\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  background: rgba(0, 0, 0, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  min-height: 300px;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #fff;\n  text-align: center;\n'],['\n  color: #fff;\n  text-align: center;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  text-align: center;\n  color: #fff;\n  text-decoration: underline;\n  margin-top: 10px;\n  font-size: 14px;\n  cursor: pointer;\n'],['\n  text-align: center;\n  color: #fff;\n  text-decoration: underline;\n  margin-top: 10px;\n  font-size: 14px;\n  cursor: pointer;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  min-height: 300px;\n'],['\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  min-height: 300px;\n']);var checkingLogin=void 0;var AuthWrapper=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AuthWrapper,_Component);function AuthWrapper(){__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,AuthWrapper);var _this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(AuthWrapper.__proto__||Object.getPrototypeOf(AuthWrapper)).call(this));_this.state={iFrameHeight:'0px',loaded:false};return _this;}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AuthWrapper,[{key:'componentWillUnmount',value:function componentWillUnmount(){clearInterval(this.interval);clearInterval(checkingLogin);}},{key:'componentDidMount',value:function componentDidMount(){// Listen to simulator messages
window.addEventListener('message',this.onIframeMessage.bind(this));}/**
   * Iframe action listener
   * @param {*} e
   *//* eslint-disable camelcase */},{key:'onIframeMessage',value:function onIframeMessage(e){var _this2=this;var action=e.data;if(action==='userLoggedIn'){this.props.getCurrentUser();}if(action==='ccAuth'){this.setState({checkingLogin:true});checkingLogin=setInterval(function(){var token=window.localStorage.getItem('tokenauth');var saml_user_data=window.localStorage.getItem('saml_user_data');if(token){_this2.setState({checkingLogin:false});_this2.props.getCurrentUser();clearInterval(checkingLogin);}if(!token&&saml_user_data){_this2.setState({checkingLogin:false});clearInterval(checkingLogin);}},800);}}/* eslint-enable camelcase */},{key:'amaFailed',value:function amaFailed(){var _this3=this;this.props.toggler({opened:false});clearInterval(checkingLogin);setTimeout(function(){_this3.props.toggler({opened:true});},100);}},{key:'render',value:function render(){var _this4=this;var url=__WEBPACK_IMPORTED_MODULE_7_config__["g" /* PAGE_URL */]+'/authmodal/?iframed';if(this.props.isRegister){url=url+'&register';}return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(WrapperOutside,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Wrapper,{id:'auth-frame',src:url,onLoad:function onLoad(){_this4.setState({loaded:true});_this4.interval=setInterval(function(){var obj=document.getElementById('auth-frame');if(obj){var body=obj.contentWindow.document.body;if(body){var height=obj.contentWindow.document.body.scrollHeight+'px';if(height!==_this4.state.iFrameHeight){_this4.setState({iFrameHeight:obj.contentWindow.document.body.scrollHeight+'px'});}}}},100);},height:this.state.iFrameHeight,width:this.state.iframeWidth,scrolling:0}),this.state.checkingLogin&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CheckingLoginWrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Loading__["a" /* default */],{small:true,noHeight:true}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LoadingText,null,'A espera de resposta de autentica\xE7\xE3o. ',__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('br',null),'Complete a sua autentica\xE7\xE3o no site da ama.'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(FailedLink,{onClick:function onClick(){return _this4.amaFailed();}},'Em caso de falha no processo clique aqui para tentar novamente')),!this.state.loaded&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LoadingWrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Loading__["a" /* default */],{small:true,noHeight:true})));}}]);return AuthWrapper;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);var WrapperOutside=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject);var Wrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].iframe(_templateObject2,function(_ref){var height=_ref.height;return height&&height;});var CheckingLoginWrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject3);var LoadingText=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject4);var FailedLink=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject5);var LoadingWrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject6);

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SolarSistem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_ButtonConfirm__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Section__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_SubTitle__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Select__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Tip__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Label__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_ic_arrow_svg__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_ic_arrow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_ic_arrow_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_config__ = __webpack_require__(10);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  text-align: center;\n  margin-bottom: 81px;\n  ','\n'],['\n  display: block;\n  text-align: center;\n  margin-bottom: 81px;\n  ','\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  border-top: 1px solid #dedede;\n  overflow: visible;\n  padding-top: 80px;\n\n  ','\n'],['\n  display: block;\n  border-top: 1px solid #dedede;\n  overflow: visible;\n  padding-top: 80px;\n\n  ','\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: inline-block;\n  width: auto;\n  margin-top: 32px;\n'],['\n  display: inline-block;\n  width: auto;\n  margin-top: 32px;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 166px;\n  float: left;\n  max-width: 166px;\n\n  > div {\n    border: 1px solid #bababa;\n    color: #3e3e3e;\n  }\n  ','\n'],['\n  width: 166px;\n  float: left;\n  max-width: 166px;\n\n  > div {\n    border: 1px solid #bababa;\n    color: #3e3e3e;\n  }\n  ','\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  text-align: left;\n  padding-bottom: 5px;\n'],['\n  text-align: left;\n  padding-bottom: 5px;\n']);/* eslint-disable camelcase */var SolarSistem=function(_React$Component){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SolarSistem,_React$Component);function SolarSistem(props){__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,SolarSistem);var _this=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(SolarSistem.__proto__||Object.getPrototypeOf(SolarSistem)).call(this,props));_this.isLoading=true;_this.handleButtonSelection=_this.handleButtonSelection.bind(_this);_this.handleSelectSelection=_this.handleSelectSelection.bind(_this);_this.state={hasCentralAirConditioning:_this.props.option,open:_this.props.option,centralHeatingOfferType:_this.props.offerType,centralAirConditioningEquipment:_this.props.equipment,centralAirConditioningEnergyClass:_this.props.equipmentEnergyClass};return _this;}__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SolarSistem,[{key:'getFirstSelectedItem',value:function getFirstSelectedItem(prop,values){var items=values||this.props[prop];items&&items.forEach(function(item){if(item.status)return item;});return items&&items[0];}},{key:'handleButtonSelection',value:function handleButtonSelection(e){if(this.props.onSelectionChange&&!e.first){this.props.onSelectionChange({hasCentralAirConditioning:e.value,centralHeatingOfferType:this.state.centralHeatingOfferType,centralAirConditioningEquipment:this.state.centralAirConditioningEquipment,centralAirConditioningEnergyClass:this.state.centralAirConditioningEnergyClass});}this.setState({hasCentralAirConditioning:e.value,centralHeatingOfferType:this.state.centralHeatingOfferType,centralAirConditioningEquipment:this.state.centralAirConditioningEquipment,centralAirConditioningEnergyClass:this.state.centralAirConditioningEnergyClass,open:e.value});}// this is a mess refactor soon
},{key:'handleSelectSelection',value:function handleSelectSelection(prop,e){var objectProps=['centralAirConditioningEquipment','centralAirConditioningEnergyClass','centralHeatingOfferType'];objectProps.splice(objectProps.indexOf(prop),1);if(this.props.onSelectionChange&&!e.first){var changes={hasCentralAirConditioning:this.state.hasCentralAirConditioning,open:this.state.hasCentralAirConditioning};changes[prop]=e.value;if(prop==='centralHeatingOfferType'){changes.centralAirConditioningEnergyClass=null;changes.centralAirConditioningEquipment=null;}if(prop==='centralAirConditioningEquipment'){changes.centralAirConditioningEnergyClass=null;}this.props.onSelectionChange(Object.assign({},changes));this.setState(Object.assign({},changes));}var newState={};newState[prop]=e.value;this.setState(Object.assign({},newState));}},{key:'render',value:function render(){var _props=this.props,items=_props.items,equipments=_props.equipments,translations=_props.translations,iframed=_props.iframed;var _state=this.state,centralHeatingOfferType=_state.centralHeatingOfferType,hasCentralAirConditioning=_state.hasCentralAirConditioning,centralAirConditioningEquipment=_state.centralAirConditioningEquipment,centralAirConditioningEnergyClass=_state.centralAirConditioningEnergyClass;var _ref=translations||{},CENTRAL_HEATING=_ref.CENTRAL_HEATING;var filteredOfferTypes=this.props.offerTypes&&this.props.offerTypes.filter(function(_ref2){var slug=_ref2.slug;return slug!==__WEBPACK_IMPORTED_MODULE_16_config__["q" /* GAS_AND_ELECTRICITY_OFFER_TYPE */];});// Get all equipments for offerType
var filteredEquipments=centralHeatingOfferType&&[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(equipments.filter(function(_ref3){var offer_type=_ref3.offer_type;return offer_type===centralHeatingOfferType;})));// Format energyClasses
var classes=[];if(centralAirConditioningEquipment){var equipment=filteredEquipments&&filteredEquipments.find(function(_ref4){var id=_ref4.id;return id===centralAirConditioningEquipment;});if(equipment&&equipment.classes){classes=equipment&&equipment.classes.map(function(el){el.label=el.classe_energetica.name;el.value=el.id;return el;});}}classes=classes&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_utils__["u" /* sortByEnergyClass */])(classes);return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Section__["a" /* default */],{title:'Climatiza\xE7\xE3o Central',subtitle:'A sua habita\xE7\xE3o possui Climatiza\xE7\xE3o Central?',grey:true,compact:iframed},CENTRAL_HEATING&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Tip__["a" /* default */],{'data-slot':'tip',text:CENTRAL_HEATING}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ButtonWrapper,{status:this.state.open},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_ButtonConfirm__["a" /* default */],{onButtonClick:this.handleButtonSelection,value:hasCentralAirConditioning,items:items})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SelectorWrapper,{status:this.state.open},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_SubTitle__["a" /* default */],{text:'Indique a fonte de energia, sistema e classe/ano da Climatiza\xE7\xE3o Central'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WrapperSelect,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(LocationLabel,{fontSize:'12px'},'Fonte de energia'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledSelect,{margin:true,placeholder:'Selecione',items:filteredOfferTypes,onChange:this.handleSelectSelection.bind(this,'centralHeatingOfferType'),selected:centralHeatingOfferType,arrowIcon:__WEBPACK_IMPORTED_MODULE_14__images_ic_arrow_svg___default.a})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WrapperSelect,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(LocationLabel,{fontSize:'12px'},'Sistema'),centralAirConditioningEquipment&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledSelect,{margin:true,placeholder:'Selecione',items:filteredEquipments,onChange:this.handleSelectSelection.bind(this,'centralAirConditioningEquipment'),selected:centralAirConditioningEquipment,arrowIcon:__WEBPACK_IMPORTED_MODULE_14__images_ic_arrow_svg___default.a}),!centralAirConditioningEquipment&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledSelect,{margin:true,placeholder:'Selecione',items:filteredEquipments,onChange:this.handleSelectSelection.bind(this,'centralAirConditioningEquipment'),selected:centralAirConditioningEquipment,arrowIcon:__WEBPACK_IMPORTED_MODULE_14__images_ic_arrow_svg___default.a})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WrapperSelect,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(LocationLabel,{fontSize:'12px'},'Classe Energ\xE9tica / Ano'),centralAirConditioningEnergyClass&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledSelect,{margin:true,placeholder:'Selecione',items:classes,onChange:this.handleSelectSelection.bind(this,'centralAirConditioningEnergyClass'),selected:centralAirConditioningEnergyClass,arrowIcon:__WEBPACK_IMPORTED_MODULE_14__images_ic_arrow_svg___default.a}),!centralAirConditioningEnergyClass&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledSelect,{margin:true,placeholder:'Selecione',items:classes,onChange:this.handleSelectSelection.bind(this,'centralAirConditioningEnergyClass'),selected:centralAirConditioningEnergyClass,arrowIcon:__WEBPACK_IMPORTED_MODULE_14__images_ic_arrow_svg___default.a}))));}}]);return SolarSistem;}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);var ButtonWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject,function(_ref5){var status=_ref5.status;return!status&&'\n    margin-bottom: 0px;\n  ';});var SelectorWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject2,function(_ref6){var status=_ref6.status;return!status&&'\n    padding-top: 0px;\n    border-top: none;\n    overflow: hidden;\n    height: 0px;\n  ';});var WrapperSelect=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject3);var StyledSelect=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_11_components_Select__["a" /* default */])(_templateObject4,function(_ref7){var margin=_ref7.margin;return margin&&'margin-right: 30px;';});var LocationLabel=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_13_components_Label__["a" /* default */])(_templateObject5);

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompanyProfile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logic__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_uniqBy__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_ic_arrow_svg__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_ic_arrow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_ic_arrow_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_containers_Form__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Label__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Section__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_ButtonRadio__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_Loading__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_Select__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_UseType__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_Tip__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_virtualized_select__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_virtualized_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react_virtualized_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_select_dist_react_select_css__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_select_dist_react_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react_select_dist_react_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_virtualized_styles_css__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_virtualized_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react_virtualized_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_virtualized_select_styles_css__ = __webpack_require__(1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_virtualized_select_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_react_virtualized_select_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_validations__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_config__ = __webpack_require__(10);
var _class;var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background-image: url(',');\n  width: 12px;\n  height: 12px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  display: block;\n'],['\n  background-image: url(',');\n  width: 12px;\n  height: 12px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  display: block;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()([''],['']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  justify-content: center;\n  margin-top: 32px;\n\n  @media screen and (max-width: 768px) {\n    flex-direction: column;\n    align-items: center;\n\n    > div:first-child {\n      margin-bottom: 30px;\n    }\n  }\n'],['\n  display: flex;\n  justify-content: center;\n  margin-top: 32px;\n\n  @media screen and (max-width: 768px) {\n    flex-direction: column;\n    align-items: center;\n\n    > div:first-child {\n      margin-bottom: 30px;\n    }\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 270px;\n  margin: 10px;\n'],['\n  width: 270px;\n  margin: 10px;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 420px;\n  position: relative;\n\n  @media screen and (max-width: 768px) {\n    width: 320px;\n  }\n'],['\n  width: 420px;\n  position: relative;\n\n  @media screen and (max-width: 768px) {\n    width: 320px;\n  }\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 420px;\n\n  @media screen and (max-width: 768px) {\n    width: 320px;\n  }\n  .is-focused {\n    .Select-control {\n      border: 1px solid #bababa;\n    }\n  }\n  > .Select-control {\n    box-shadow: none !important;\n    border: 1px solid #bababa;\n    border-color: #bababa !important;\n    border-radius: 0px;\n    height: 50px;\n    font-size: 14px;\n    font-family: \'Nunito\', \'Helvetica Neue\', sans-serif;\n    text-rendering: optimizeLegibility;\n    -webkit-font-smoothing: antialiased;\n    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004);\n\n    .Select-placeholder {\n      line-height: 48px;\n    }\n    .Select-input {\n      height: 48px;\n      line-height: 48px;\n    }\n    .Select-value {\n      line-height: 48px !important;\n      outline: none;\n      text-align: left;\n      padding-left: 16px;\n      &:focus {\n        outline: none;\n      }\n      &:blur {\n        outline: none;\n      }\n    }\n  }\n  .VirtualizedSelectOption {\n    overflow: hidden;\n    text-align: left;\n    white-space: nowrap;\n    vertical-align: top;\n    font-size: 14px;\n    font-family: \'Nunito\', \'Helvetica Neue\', sans-serif;\n    text-rendering: optimizeLegibility;\n    -webkit-font-smoothing: antialiased;\n    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004);\n    padding: 16px 15px 15px 16px;\n\n    &:hover {\n      background-color: #efefef;\n    }\n  }\n  .VirtualizedSelectFocusedOption {\n    background-color: #efefef;\n  }\n  .VirtualizedSelectSelectedOption {\n    background-color: #efefef;\n\n    &:hover {\n      background-color: #efefef;\n    }\n  }\n'],['\n  width: 420px;\n\n  @media screen and (max-width: 768px) {\n    width: 320px;\n  }\n  .is-focused {\n    .Select-control {\n      border: 1px solid #bababa;\n    }\n  }\n  > .Select-control {\n    box-shadow: none !important;\n    border: 1px solid #bababa;\n    border-color: #bababa !important;\n    border-radius: 0px;\n    height: 50px;\n    font-size: 14px;\n    font-family: \'Nunito\', \'Helvetica Neue\', sans-serif;\n    text-rendering: optimizeLegibility;\n    -webkit-font-smoothing: antialiased;\n    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004);\n\n    .Select-placeholder {\n      line-height: 48px;\n    }\n    .Select-input {\n      height: 48px;\n      line-height: 48px;\n    }\n    .Select-value {\n      line-height: 48px !important;\n      outline: none;\n      text-align: left;\n      padding-left: 16px;\n      &:focus {\n        outline: none;\n      }\n      &:blur {\n        outline: none;\n      }\n    }\n  }\n  .VirtualizedSelectOption {\n    overflow: hidden;\n    text-align: left;\n    white-space: nowrap;\n    vertical-align: top;\n    font-size: 14px;\n    font-family: \'Nunito\', \'Helvetica Neue\', sans-serif;\n    text-rendering: optimizeLegibility;\n    -webkit-font-smoothing: antialiased;\n    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004);\n    padding: 16px 15px 15px 16px;\n\n    &:hover {\n      background-color: #efefef;\n    }\n  }\n  .VirtualizedSelectFocusedOption {\n    background-color: #efefef;\n  }\n  .VirtualizedSelectSelectedOption {\n    background-color: #efefef;\n\n    &:hover {\n      background-color: #efefef;\n    }\n  }\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  max-width: initial;\n\n  > div {\n    border: 1px solid #bababa;\n    color: #3e3e3e;\n    > div {\n      text-align: left;\n    }\n  }\n  ','\n'],['\n  width: 100%;\n  max-width: initial;\n\n  > div {\n    border: 1px solid #bababa;\n    color: #3e3e3e;\n    > div {\n      text-align: left;\n    }\n  }\n  ','\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  text-align: left;\n  padding-bottom: 5px;\n'],['\n  text-align: left;\n  padding-bottom: 5px;\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n\n  justify-content: center;\n  margin-top: 32px;\n'],['\n  display: flex;\n\n  justify-content: center;\n  margin-top: 32px;\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: inline-block;\n  font-size: 12px;\n  color: indianred;\n  margin: 10px auto;\n  text-align: left;\n'],['\n  display: inline-block;\n  font-size: 12px;\n  color: indianred;\n  margin: 10px auto;\n  text-align: left;\n']);var GEO_LOCATION_OPTIONS={maximumAge:0/* eslint-disable camelcase */};var CompanyProfile=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__logic__["a" /* default */])(_class=function(_Form){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CompanyProfile,_Form);function CompanyProfile(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,CompanyProfile);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=CompanyProfile.__proto__||Object.getPrototypeOf(CompanyProfile)).call.apply(_ref,[this].concat(args))),_this),_this.nextText='PR\xD3XIMO passo',_this.useFactors=[],_this.sendHeight=function(){var height=document.body.scrollHeight;window.parent.postMessage({type:'setHeight',height:height},'*');},_this.geoError=function(error){return true;},_this.geoSucess=function(position){var setCurrentLocation=_this.actions.setCurrentLocation;var lat=void 0;var long=void 0;lat=position.coords&&position.coords.latitude;long=position.coords&&position.coords.longitude;var GOOGLE_GEO_API='https://maps.googleapis.com/maps/api/geocode/json?latlng='+lat+','+long+'&sensor=true&key='+__WEBPACK_IMPORTED_MODULE_26_config__["n" /* GOOGLE_KEY */];try{var request=__WEBPACK_IMPORTED_MODULE_9_axios___default.a.get(GOOGLE_GEO_API);request.then(function(result){if(result.data.error_message||result.data.status==='OVER_QUERY_LIMIT'||result.data.status==='ZERO_RESULTS'){return false;}var newArr=[];result.data.results.forEach(function(component){newArr=[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(newArr),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(component.address_components));});newArr=__WEBPACK_IMPORTED_MODULE_10_lodash_uniqBy___default()(newArr,'long_name');setCurrentLocation(newArr);});}catch(error){}},_this.next=function(){var _this$isFormValid=_this.isFormValid(),valid=_this$isFormValid.valid,invalid=_this$isFormValid.invalid;var _this$actions=_this.actions,setInvalid=_this$actions.setInvalid,setFinished=_this$actions.setFinished;var router=_this.props.router;if(valid){setFinished({profileFinished:true});router.push('/faturacao');window.parent.postMessage({type:'scrollToTop'},'*');}else{setFinished({profileFinished:false});setInvalid(invalid);// Move to the places
var locationInvalid=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24_utils__["n" /* pickOrNot */])(invalid,['district','municipality']);if(locationInvalid){var location=document.getElementById('location');if(location){location.scrollIntoView({behavior:'smooth'});}return false;}var caesInvalid=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24_utils__["n" /* pickOrNot */])(invalid,['cae']);if(caesInvalid){var caes=document.getElementById('caes');if(caes){caes.scrollIntoView({behavior:'smooth'});}}var workingHoursInvalid=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24_utils__["n" /* pickOrNot */])(invalid,['work_hours']);if(workingHoursInvalid){var work_hours=document.getElementById('work_hours');if(work_hours){work_hours.scrollIntoView({behavior:'smooth'});}}}},_this.renderInvalidMessage=function(invalid,field,name){if(invalid){if(invalid[field]){var Message=__WEBPACK_IMPORTED_MODULE_25_validations__["b" /* Messages */][invalid[field]];if(Message){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Error,null,Message(name));}}}return null;},_temp),__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CompanyProfile,[{key:'componentDidMount',value:function componentDidMount(){var currentLocalization=this.props.currentLocalization;if(!currentLocalization){navigator.geolocation.getCurrentPosition(this.geoSucess,this.geoError,GEO_LOCATION_OPTIONS);}for(var i=0;i<100;i=i+5){this.useFactors.push({label:i+'%',value:i/100});}}},{key:'componentDidUpdate',value:function componentDidUpdate(lastProps){var data=this.props.data;var caes=data.caes;var setValues=this.actions.setValues;if(!(caes&&!lastProps.data.caes))return;var queryString=window.location.search;var urlParams=new URLSearchParams(queryString);// eslint-disable-next-line radix
var newCae=parseInt(urlParams.get('cae'));if(!newCae)return;// eslint-disable-next-line radix
var caeObject=caes.find(function(cae){return parseInt(cae.label)===newCae;});if(!caeObject)return;setValues({cae:caeObject.value});this.sendHeight();window.addEventListener('resize',this.sendHeight);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.sendHeight);}/**
   * Next Button actions
   *//**
   * Renders invalid messags
   */},{key:'render',value:function render(){var _props=this.props,districts=_props.districts,cities=_props.cities,loading=_props.loading,invalid=_props.invalid,translations=_props.translations,iframed=_props.iframed;var _actions=this.actions,setValues=_actions.setValues,fetchCities=_actions.fetchCities;var _props$data=this.props.data,caes=_props$data.caes,offerTypes=_props$data.offerTypes,enterpriseProfiles=_props$data.enterpriseProfiles;var _ref2=translations||{},CAE=_ref2.CAE,ENTERPRISE_SIMULATION_TARGET=_ref2.ENTERPRISE_SIMULATION_TARGET,ENTERPRISE_LOCATION=_ref2.ENTERPRISE_LOCATION,WORKING_HOURS=_ref2.WORKING_HOURS;var _props$values=this.props.values,offerType=_props$values.offerType,cae=_props$values.cae,municipality=_props$values.municipality,district=_props$values.district,enterprise_profile=_props$values.enterprise_profile;var citiesDisabled=!district||!cities;var locationInvalid=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24_utils__["n" /* pickOrNot */])(invalid,['district','municipality']);var caeInvalid=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24_utils__["n" /* pickOrNot */])(invalid,['cae']);if(loading){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Loading__["a" /* default */],null);}// All sections of this page
var SimulateQuestion=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Section__["a" /* default */],{title:'Simular',subtitle:'O que pretende simular',key:'simulate',compact:iframed},ENTERPRISE_SIMULATION_TARGET&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Tip__["a" /* default */],{'data-slot':'tip',text:ENTERPRISE_SIMULATION_TARGET}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ButtonContainer,null,offerTypes&&offerTypes.map(function(_ref3,index){var icon=_ref3.icon,text=_ref3.text,value=_ref3.value;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_ButtonRadio__["a" /* default */],{key:'ot-'+index,onClick:function onClick(){return setValues({offerType:value});},icon:icon,name:text,selected:offerType===value});})));var localizationQuestion=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Section__["a" /* default */],{title:'Localiza\xE7\xE3o',subtitle:'Selecione o distrito e concelho',className:locationInvalid&&'invalid',id:'location',key:'location',compact:iframed},ENTERPRISE_LOCATION&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Tip__["a" /* default */],{'data-slot':'tip',text:ENTERPRISE_LOCATION}),districts&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WrapperLocation,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WrapperSelect,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(LocationLabel,{fontSize:'12px'},'DISTRITO'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledSelect,{margin:true,placeholder:'Distrito',items:districts,onChange:function onChange(_ref4){var value=_ref4.value;setValues({district:value,municipality:undefined});fetchCities(value);},selected:district,arrowIcon:__WEBPACK_IMPORTED_MODULE_11__images_ic_arrow_svg___default.a}),this.renderInvalidMessage(locationInvalid,'district','Distrito')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WrapperSelect,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(LocationLabel,{fontSize:'12px'},'CONCELHO'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledSelect,{disabled:citiesDisabled,placeholder:'Concelho',items:cities,onChange:function onChange(_ref5){var value=_ref5.value;return setValues({municipality:value});},selected:municipality,arrowIcon:__WEBPACK_IMPORTED_MODULE_11__images_ic_arrow_svg___default.a}),this.renderInvalidMessage(locationInvalid,'municipality','Concelho'))));var caeQuestion=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Section__["a" /* default */],{title:'CAE',subtitle:'Selecione o c\xF3digo de actividade empresarial da sua empresa',className:caeInvalid&&'invalid',id:'cae',key:'cae',compact:iframed},CAE&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Tip__["a" /* default */],{'data-slot':'tip',text:CAE}),caes&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WrapperLocation,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WrapperSelectCAE,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(LocationLabel,{fontSize:'12px'},'CAE'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledSelectCae,{options:caes,onChange:function onChange(ele){if(ele!=null){setValues({cae:ele.value});}else{setValues({cae:null});}},placeholder:'CAE',arrowRenderer:arrowRenderer,value:cae}),this.renderInvalidMessage(caeInvalid,'cae','CAE'))));var enterpriseProfile=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Section__["a" /* default */],{title:'Per\xEDodo de Funcionamento',subtitle:'Selecione o perfil mais adequado ao hor\xE1rio de funcionamento da sua empresa',key:'enterpriseProfile',compact:iframed},WORKING_HOURS&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Tip__["a" /* default */],{'data-slot':'tip',text:WORKING_HOURS}),enterpriseProfiles&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_UseType__["a" /* default */],{items:enterpriseProfiles,value:enterprise_profile,name:'enterprise_profile',itemSize:'270px',onSelectionChange:function onSelectionChange(_ref6){var value=_ref6.value;return setValues({enterprise_profile:value});}}));return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Wrapper,null,this.renderNavbar(),[SimulateQuestion,localizationQuestion,caeQuestion,enterpriseProfile],this.renderButtons(loading));}}]);return CompanyProfile;}(__WEBPACK_IMPORTED_MODULE_12_containers_Form__["a" /* default */]))||_class;var SelectIcon=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject,function(_ref7){var arrowIcon=_ref7.arrowIcon;return arrowIcon;});var arrowRenderer=function arrowRenderer(){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SelectIcon,{arrowIcon:__WEBPACK_IMPORTED_MODULE_11__images_ic_arrow_svg___default.a});};var Wrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject2);var WrapperLocation=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject3);var WrapperSelect=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject4);var WrapperSelectCAE=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject5);var StyledSelectCae=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_20_react_virtualized_select___default.a)(_templateObject6);var StyledSelect=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_17_components_Select__["a" /* default */])(_templateObject7,function(_ref8){var margin=_ref8.margin;return margin&&'margin-right: 30px;';});var LocationLabel=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_13_components_Label__["a" /* default */])(_templateObject8);var ButtonContainer=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject9);var Error=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject10);

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Consume; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logic__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_containers_Form__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Section__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_RadioGroup__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_TableItem__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_PlusButton__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_FixedWrapper__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_Tip__ = __webpack_require__(109);
var _class;var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()([''],['']);var MAX_LIST_ITEMS=12;/* eslint-disable camelcase */var Consume=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__logic__["a" /* default */])(_class=function(_Form){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Consume,_Form);function Consume(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,Consume);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=Consume.__proto__||Object.getPrototypeOf(Consume)).call.apply(_ref,[this].concat(args))),_this),_this.nextText='Simular',_this.prevText='Passo Anterior',_this.sendHeight=function(){var height=document.body.scrollHeight;window.parent.postMessage({type:'setHeight',height:height},'*');},_this.next=function(){var _this$isFormValid=_this.isFormValid(),valid=_this$isFormValid.valid,invalid=_this$isFormValid.invalid;var _this$actions=_this.actions,setFinished=_this$actions.setFinished,setInvalid=_this$actions.setInvalid;var router=_this.props.router;if(valid){setFinished({consumeFinished:true});setInvalid(null);router.push('/resultados');window.parent.postMessage({type:'scrollToTop'},'*');}else{setFinished({consumeFinished:false});setInvalid(invalid);var electricityListInvalid=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_utils__["n" /* pickOrNot */])(invalid,['electricityConsumptionsRegistration']);var gasListInvalid=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_utils__["n" /* pickOrNot */])(invalid,['gasConsumptionsRegistration']);if(electricityListInvalid){var el=document.getElementById('electricityConsumptionsRegistration');if(el){el.IntoView({behavior:'smooth'});}return false;}if(gasListInvalid){var _el=document.getElementById('gasConsumptionsRegistration');if(_el){_el.scrollIntoView({behavior:'smooth'});}return false;}}},_this.prev=function(){var router=_this.props.router;window.parent.postMessage({type:'scrollToTop'},'*');router.push('/faturacao');},_this.consumptionDisaggregationLogic=function(values){var consumptionDisaggregation=_this.props.values.consumptionDisaggregation;var simples=values.simples,cheias=values.cheias;switch(consumptionDisaggregation){// Fill all fields with simples value
case's':if(simples){values.svazio=simples;values.cheias=simples;values.ponta=simples;}return values;case'vf':if(simples){values.svazio=simples;}if(cheias){values.ponta=cheias;}return values;case'vcp':if(simples){values.svazio=simples;}return values;case'vscp':return values;default:return values;}},_this.setTableElectricityValues=function(values,index){var setValues=_this.actions.setValues;var electricityConsumptionsRegistration=_this.props.values.electricityConsumptionsRegistration;values=_this.consumptionDisaggregationLogic(values);var item=electricityConsumptionsRegistration[index];electricityConsumptionsRegistration[index]=Object.assign({},item,values);setValues({electricityConsumptionsRegistration:electricityConsumptionsRegistration});},_this.onRemoveElectricityValue=function(index){var setValues=_this.actions.setValues;var electricityConsumptionsRegistration=_this.props.values.electricityConsumptionsRegistration;var clone=[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(electricityConsumptionsRegistration));if(clone.length>1){clone.splice(index,1);}setValues({electricityConsumptionsRegistration:clone});},_this.addNewElectricityTableValue=function(){var setValues=_this.actions.setValues;var electricityConsumptionsRegistration=_this.props.values.electricityConsumptionsRegistration;if(electricityConsumptionsRegistration.length>=MAX_LIST_ITEMS){return false;}electricityConsumptionsRegistration.push({startDate:null,endDate:null,simples:'',svazio:'',cheias:'',ponta:''});setValues({electricityConsumptionsRegistration:electricityConsumptionsRegistration});},_this.setTableGasValues=function(values,index){var setValues=_this.actions.setValues;var gasConsumptionsRegistration=_this.props.values.gasConsumptionsRegistration;var item=gasConsumptionsRegistration[index];gasConsumptionsRegistration[index]=Object.assign({},item,values);setValues({gasConsumptionsRegistration:gasConsumptionsRegistration});},_this.onRemoveGasValue=function(index){var setValues=_this.actions.setValues;var gasConsumptionsRegistration=_this.props.values.gasConsumptionsRegistration;if(gasConsumptionsRegistration.length>1){gasConsumptionsRegistration.splice(index,1);}setValues({gasConsumptionsRegistration:gasConsumptionsRegistration});},_this.addNewGasTableValue=function(){var setValues=_this.actions.setValues;var gasConsumptionsRegistration=_this.props.values.gasConsumptionsRegistration;if(gasConsumptionsRegistration.length>=MAX_LIST_ITEMS){return false;}gasConsumptionsRegistration.push({startDate:null,endDate:null,consumption:''});setValues({gasConsumptionsRegistration:gasConsumptionsRegistration});},_temp),__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Consume,[{key:'componentDidMount',value:function componentDidMount(){// Scrols to top on component mount
var element=document.getElementById('anchor');window.scroll({top:element.getBoundingClientRect().top});}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.sendHeight();window.addEventListener('resize',this.sendHeight);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.sendHeight);}/**
   * Logic to be applied to values based on
   * consumptionDisaggregation value
   *//**
   * Sets the value of the electricity element by index
   *//**
   * Removes an element from the table list of electricity
   *//**
   * Adds new eletricity table value to state
   *//**
   * Sets the value of the gas element by index
   *//**
   * Removes an element from the table list of gas
   *//**
   * Adds a new gas table value to state
   */},{key:'render',value:function render(){var _this2=this;var setValues=this.actions.setValues;var consumptionDisaggregations=this.props.filters.consumptionDisaggregations;var _props=this.props,offerType=_props.offerType,invalid=_props.invalid,translations=_props.translations,iframed=_props.iframed;var _props$values=this.props.values,consumptionDisaggregation=_props$values.consumptionDisaggregation,electricityConsumptionsRegistration=_props$values.electricityConsumptionsRegistration,gasConsumptionsRegistration=_props$values.gasConsumptionsRegistration,ciclo_horario=_props$values.ciclo_horario;var _ref2=translations||{},ELECTRICITY_SEGREGATION=_ref2.ELECTRICITY_SEGREGATION,ELECTRICITY_CONSUMPTION_REGISTRY=_ref2.ELECTRICITY_CONSUMPTION_REGISTRY,GAS_CONSUMPTION_REGISTRY=_ref2.GAS_CONSUMPTION_REGISTRY;// Check if gas or electricity or both
var isGas=offerType&&offerType.slug.indexOf(__WEBPACK_IMPORTED_MODULE_9_config__["l" /* GAS_OFFER_TYPE */])!==-1;var isElectricity=offerType&&offerType.slug.indexOf(__WEBPACK_IMPORTED_MODULE_9_config__["m" /* ELECTRICITY_OFFER_TYPE */])!==-1;// Check if MAX_ITEMS is not reached!
var canAddElectricityItems=electricityConsumptionsRegistration&&electricityConsumptionsRegistration.length<MAX_LIST_ITEMS;var canAddGasItems=gasConsumptionsRegistration&&gasConsumptionsRegistration.length<MAX_LIST_ITEMS;var electricityListInvalid=invalid&&invalid.electricityConsumptionsRegistration;var gasListInvalid=invalid&&invalid.gasConsumptionsRegistration;// If ciclo_horario selected in faturation is BI horario cannot let
// select a simple disaggregation
// https://gitlab.ubiwhere.com/adene-poupa-energia/adene-simulador-avancado/issues/25
var filteredConsumptionDisaggregations=void 0;var BI_HORARY='b';var SIMPLE_ID='s';var ENTERPRISE_ID='vscp';if(ciclo_horario===BI_HORARY){filteredConsumptionDisaggregations=consumptionDisaggregations.filter(function(item){return item.id!==SIMPLE_ID;});}if(!__WEBPACK_IMPORTED_MODULE_9_config__["k" /* isEnterprise */]){if(!filteredConsumptionDisaggregations){filteredConsumptionDisaggregations=consumptionDisaggregations.filter(function(item){return item.id!==ENTERPRISE_ID;});}else{filteredConsumptionDisaggregations=filteredConsumptionDisaggregations.filter(function(item){return item.id!==ENTERPRISE_ID;});}}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Wrapper,null,this.renderNavbar(),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_FixedWrapper__["a" /* default */],null,isElectricity&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Section__["a" /* default */],{title:'Desagrega\xE7\xE3o dos consumos de eletricidade',subtitle:'Como se encontram desagregados os seus consumos?',compact:iframed},ELECTRICITY_SEGREGATION&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_Tip__["a" /* default */],{'data-slot':'tip',text:ELECTRICITY_SEGREGATION}),consumptionDisaggregations&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_RadioGroup__["a" /* default */],{items:filteredConsumptionDisaggregations||consumptionDisaggregations,value:consumptionDisaggregation,name:'consumption_disaggregation',onSelectionChange:function onSelectionChange(_ref3){var value=_ref3.value;return setValues({consumptionDisaggregation:value});}})),isElectricity&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Section__["a" /* default */],{title:'Registo dos consumos de eletricidade',subtitle:'INTRODUZA AT\xC9 UM M\xC1XIMO DE 12 FATURAS',grey:true,id:'electricityConsumptionsRegistration',className:electricityListInvalid&&'invalid',compact:iframed},ELECTRICITY_CONSUMPTION_REGISTRY&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_Tip__["a" /* default */],{'data-slot':'tip',text:ELECTRICITY_CONSUMPTION_REGISTRY}),electricityConsumptionsRegistration&&electricityConsumptionsRegistration.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_TableItem__["a" /* default */],Object.assign({key:'ti-'+item.id+'-'+index},item,{consumptionDisaggregation:consumptionDisaggregation,onChange:function onChange(values){return _this2.setTableElectricityValues(values,index);},onRemove:function onRemove(){return _this2.onRemoveElectricityValue(index);},invalid:electricityListInvalid&&electricityListInvalid.errors&&electricityListInvalid.errors[index]}));}),canAddElectricityItems&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_PlusButton__["a" /* default */],{text:'Adicionar registo',onClick:function onClick(){return _this2.addNewElectricityTableValue();}})),isGas&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Section__["a" /* default */],{title:'Registo dos consumos de G\xE1s',subtitle:'INTRODUZA AT\xC9 UM M\xC1XIMO DE 12 FATURAS',id:'gasConsumptionsRegistration',className:gasListInvalid&&'invalid',compact:iframed},GAS_CONSUMPTION_REGISTRY&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_Tip__["a" /* default */],{'data-slot':'tip',text:GAS_CONSUMPTION_REGISTRY}),gasConsumptionsRegistration&&gasConsumptionsRegistration.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_TableItem__["a" /* default */],Object.assign({key:'tg-'+index},item,{onChange:function onChange(values){return _this2.setTableGasValues(values,index);},onRemove:function onRemove(){return _this2.onRemoveGasValue(index);},invalid:gasListInvalid&&gasListInvalid.errors&&gasListInvalid.errors[index]}));}),canAddGasItems&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_PlusButton__["a" /* default */],{text:'Adicionar registo',onClick:function onClick(){return _this2.addNewGasTableValue();}}))),this.renderButtons());}}]);return Consume;}(__WEBPACK_IMPORTED_MODULE_11_containers_Form__["a" /* default */]))||_class;var Wrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject);

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_kea__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_kea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_kea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_validations__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_containers_App_logic__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* eslint-disable camelcase */var defaultValues={consumptionDisaggregation:'s',electricityConsumptionsRegistration:[{startDate:__WEBPACK_IMPORTED_MODULE_7_moment___default()().date(1).month(0).format('YYYY-MM-DD'),endDate:__WEBPACK_IMPORTED_MODULE_7_moment___default()().date(31).month(0).format('YYYY-MM-DD'),simples:'',svazio:'',cheias:'',ponta:''}],gasConsumptionsRegistration:[{startDate:__WEBPACK_IMPORTED_MODULE_7_moment___default()().date(1).month(0).format('YYYY-MM-DD'),endDate:__WEBPACK_IMPORTED_MODULE_7_moment___default()().date(31).month(0).format('YYYY-MM-DD'),consumption:''}]};var fields={electricityConsumptionsRegistration:[__WEBPACK_IMPORTED_MODULE_4_validations__["a" /* Validations */].ignoreIf.isGas,__WEBPACK_IMPORTED_MODULE_4_validations__["a" /* Validations */].noDuplicateDates,__WEBPACK_IMPORTED_MODULE_4_validations__["a" /* Validations */].valuesGreaterThanZero],gasConsumptionsRegistration:[__WEBPACK_IMPORTED_MODULE_4_validations__["a" /* Validations */].ignoreIf.isElectricity,__WEBPACK_IMPORTED_MODULE_4_validations__["a" /* Validations */].noDuplicateDates,__WEBPACK_IMPORTED_MODULE_4_validations__["a" /* Validations */].valuesGreaterThanZero]};var consumptionDisaggregations=[{id:'s',name:'Simples',text:'Simples',value:'s'},{id:'vf',name:'Vazio / Fora de vazio',text:'Vazio / Fora de vazio',value:'vf'},{id:'vcp',name:'Vazio /  Cheias / Ponta',text:'Vazio /  Cheias / Ponta',value:'vcp'},{id:'vscp',name:'Vazio / Super Vazio /  Cheias / Ponta',text:'Vazio / Super Vazio /  Cheias / Ponta',value:'vscp'}];/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_kea__["kea"])({path:function path(){return['scenes','consume'];},connect:{actions:[__WEBPACK_IMPORTED_MODULE_6_containers_App_logic__["a" /* default */],['setValue','setValues','setFinished','iframed']],props:[__WEBPACK_IMPORTED_MODULE_6_containers_App_logic__["a" /* default */],['values','offerType','finished','translations']]},actions:function actions(){return{fetchFilters:function fetchFilters(){return{};},fetchError:function fetchError(error){return{error:error};},setFilters:function setFilters(filters){return{filters:filters};},setInvalid:function setInvalid(invalid){return{invalid:invalid};}};},start:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function start(){var setValues,_ref,ciclo_horario,consumptionDisaggregation,_ref2,profileFinished;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function start$(_context){while(1){switch(_context.prev=_context.next){case 0:setValues=this.actions.setValues;_context.next=3;return __WEBPACK_IMPORTED_MODULE_6_containers_App_logic__["a" /* default */].get('values');case 3:_ref=_context.sent;ciclo_horario=_ref.ciclo_horario;consumptionDisaggregation=_ref.consumptionDisaggregation;_context.next=8;return __WEBPACK_IMPORTED_MODULE_6_containers_App_logic__["a" /* default */].get('finished');case 8:_ref2=_context.sent;profileFinished=_ref2.profileFinished;// https://sentry2.ubiwhere.com/ubiwhere/simulador-avancado/issues/3364/
if(!profileFinished){this.props.router.push('/');}// Ao escolher Bi-horário, por defeito a
// DESAGREGAÇÃO DOS CONSUMOS DE ELETRICIDADE deve ser Vazio/Fora do Vazio
// https://gitlab.ubiwhere.com/adene-poupa-energia/adene-simulador-avancado/issues/14
if(ciclo_horario==='b'){defaultValues.consumptionDisaggregation='vf';}if(consumptionDisaggregation){_context.next=15;break;}_context.next=15;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["put"])(setValues(defaultValues));case 15:case'end':return _context.stop();}}},start,this);}),reducers:function reducers(_ref3){var _ref6;var actions=_ref3.actions;return{filters:[{consumptionDisaggregations:consumptionDisaggregations},__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({},actions.setFilters,function(_,payload){return Object.assign({},payload.filters);})],invalid:[{},__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({},actions.setInvalid,function(_,payload){return payload.invalid;})],fields:[fields,__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,{}],error:[false,__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array,(_ref6={},__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref6,actions.fetchFilters,function(){return false;}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref6,actions.setFilters,function(){return false;}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref6,actions.fetchError,function(_,payload){return payload.error;}),_ref6)]};}}));

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_DivisionNavbarItem__ = __webpack_require__(847);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  min-width: 100px;\n  margin: 0;\n  padding: 10px;\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  background-color: #ffffff;\n  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);\n  box-sizing: border-box;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  transform: translateX(-50%);\n'],['\n  display: flex;\n  min-width: 100px;\n  margin: 0;\n  padding: 10px;\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  background-color: #ffffff;\n  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);\n  box-sizing: border-box;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  transform: translateX(-50%);\n']);var DivisionNavbar=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DivisionNavbar,_Component);function DivisionNavbar(){__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,DivisionNavbar);return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(DivisionNavbar.__proto__||Object.getPrototypeOf(DivisionNavbar)).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DivisionNavbar,[{key:'render',value:function render(){var _props=this.props,className=_props.className,divisions=_props.divisions,selected=_props.selected,_onClick=_props.onClick;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Container,{className:className},divisions&&divisions.map(function(division,index){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_DivisionNavbarItem__["a" /* default */],{key:'division-'+index,onClick:function onClick(){return _onClick(division);},icon:division.icon,title:division.name,selected:selected.id===division.id});}));}}]);return DivisionNavbar;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DivisionNavbar);var Container=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject);

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Equipments; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__logic__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_EquipmentHeader__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Section__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_EquipmentListItem__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_PrimaryButton__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Tip__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_containers_DivisionNavbar__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_containers_EquipmentsModal__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_containers_EquipmentsEditModal__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_ic_eletricidade_svg__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_ic_eletricidade_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__images_ic_eletricidade_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_ic_gas_svg__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_ic_gas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__images_ic_gas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_plus_svg__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_plus_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__images_plus_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_findIndex__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_config__ = __webpack_require__(10);
var _class;var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding: 0;\n  padding-top: 80px;\n'],['\n  padding: 0;\n  padding-top: 80px;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  position: relative;\n  margin: 0;\n  padding: 0;\n  margin-top: 50px;\n  padding-bottom: 80px;\n  text-align: center;\n'],['\n  display: block;\n  position: relative;\n  margin: 0;\n  padding: 0;\n  margin-top: 50px;\n  padding-bottom: 80px;\n  text-align: center;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  max-width: 930px;\n  height: auto;\n  margin: 0 auto;\n  padding: 0;\n  margin-top: 50px;\n  padding-bottom: 140px;\n\n  @media (max-width: 600px) {\n    flex-direction: column;\n  }\n'],['\n  display: flex;\n  max-width: 930px;\n  height: auto;\n  margin: 0 auto;\n  padding: 0;\n  margin-top: 50px;\n  padding-bottom: 140px;\n\n  @media (max-width: 600px) {\n    flex-direction: column;\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 0.5;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n\n  @media (max-width: 600px) {\n    flex: 1;\n  }\n\n  &:first-child {\n    margin-right: 40px;\n\n    @media (max-width: 600px) {\n      margin-right: 0;\n    }\n  }\n\n  &:before,\n  &:after {\n    content: \'\';\n    display: table;\n  }\n\n  &:after {\n    clear: both;\n  }\n  zoom: 1;\n\n  ',';\n'],['\n  flex: 0.5;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n\n  @media (max-width: 600px) {\n    flex: 1;\n  }\n\n  &:first-child {\n    margin-right: 40px;\n\n    @media (max-width: 600px) {\n      margin-right: 0;\n    }\n  }\n\n  &:before,\n  &:after {\n    content: \'\';\n    display: table;\n  }\n\n  &:after {\n    clear: both;\n  }\n  zoom: 1;\n\n  ',';\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  text-align: left;\n  width: 100%;\n  margin-bottom: 20px;\n\n  > span {\n    line-height: 20px;\n    text-transform: uppercase;\n    font-size: 16px;\n  }\n\n  @media (max-width: 860px) {\n    display: flex;\n    padding: 0 8px;\n  }\n'],['\n  text-align: left;\n  width: 100%;\n  margin-bottom: 20px;\n\n  > span {\n    line-height: 20px;\n    text-transform: uppercase;\n    font-size: 16px;\n  }\n\n  @media (max-width: 860px) {\n    display: flex;\n    padding: 0 8px;\n  }\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: inline-flex;\n\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: flex-start;\n  align-content: flex-start;\n\n  /* width: 440px; */\n\n  > span {\n    display: inline-block;\n    text-align: left;\n    color: #676767;\n    font-family: Nunito;\n    font-size: 12px;\n    line-height: 12px;\n    flex: 1 1 auto;\n  }\n'],['\n  display: inline-flex;\n\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: flex-start;\n  align-content: flex-start;\n\n  /* width: 440px; */\n\n  > span {\n    display: inline-block;\n    text-align: left;\n    color: #676767;\n    font-family: Nunito;\n    font-size: 12px;\n    line-height: 12px;\n    flex: 1 1 auto;\n  }\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  list-style: none;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n'],['\n  list-style: none;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  border: 1px solid #dedede;\n  color: #3e3e3e;\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 12px;\n  padding: 10px;\n  margin: 10px 0;\n  margin-left: auto;\n  background: none;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background-image: url(',');\n  background-size: 20px 20px;\n  background-position: 95%;\n  padding-right: 35px;\n  background-repeat: no-repeat;\n\n  &:hover {\n    color: #93c13e;\n  }\n\n  ','\n'],['\n  border: 1px solid #dedede;\n  color: #3e3e3e;\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 12px;\n  padding: 10px;\n  margin: 10px 0;\n  margin-left: auto;\n  background: none;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background-image: url(',');\n  background-size: 20px 20px;\n  background-position: 95%;\n  padding-right: 35px;\n  background-repeat: no-repeat;\n\n  &:hover {\n    color: #93c13e;\n  }\n\n  ','\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  font-size: 18px;\n  color: #222;\n'],['\n  display: block;\n  font-size: 18px;\n  color: #222;\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  max-width: 250px;\n  margin: 20px auto;\n'],['\n  display: block;\n  max-width: 250px;\n  margin: 20px auto;\n']);// Needed components
// Needed containers
// Assets
// Utils
/* eslint-disable camelcase */var Equipments=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__logic__["a" /* default */])(_class=function(_Component){__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Equipments,_Component);function Equipments(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this,Equipments);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=Equipments.__proto__||Object.getPrototypeOf(Equipments)).call.apply(_ref,[this].concat(args))),_this),_this.onAddEquipments=function(equipments){var _this$actions=_this.actions,toggleEquipmentsModal=_this$actions.toggleEquipmentsModal,setValues=_this$actions.setValues;var merged=[].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(new Set([].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(_this.props.values.equipments),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(equipments)))));var _this$props$data=_this.props.data,defaultChargingDuration=_this$props$data.defaultChargingDuration,defaultChargingPower=_this$props$data.defaultChargingPower,defaultChargingFrequency=_this$props$data.defaultChargingFrequency;var carCharging=undefined;if(equipments.find(function(_ref2){var svg_key=_ref2.svg_key;return svg_key==='el-carro';})){carCharging={power:defaultChargingPower?defaultChargingPower.value:2300,frequency:defaultChargingFrequency?defaultChargingFrequency.id:1,duration:defaultChargingDuration?defaultChargingDuration.value:12};}setValues({equipments:merged,carCharging:carCharging});toggleEquipmentsModal(null);},_this.removeEquipment=function(idToRemove){var setValues=_this.actions.setValues;var _this$props=_this.props,currentDivision=_this$props.currentDivision,firstDivision=_this$props.firstDivision;var selectedDivision=currentDivision||firstDivision;var equipments=[].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(_this.props.values.equipments));var index=__WEBPACK_IMPORTED_MODULE_21_lodash_findIndex___default()(equipments,function(_ref3){var id=_ref3.id,house_divisions=_ref3.house_divisions;return house_divisions===selectedDivision.id&&idToRemove===id;});if(index!==-1){var eqi=equipments[index];if(eqi.svg_key==='el-carro'){setValues({carCharging:undefined});}equipments.splice(index,1);setValues({equipments:equipments});}},_this.editEquipment=function(equipment){var toggleEquipmentsEditModal=_this.actions.toggleEquipmentsEditModal;toggleEquipmentsEditModal(Object.assign(equipment));},_this.saveEquipment=function(equipment){var _this$actions2=_this.actions,toggleEquipmentsEditModal=_this$actions2.toggleEquipmentsEditModal,setValues=_this$actions2.setValues;var _this$props2=_this.props,currentDivision=_this$props2.currentDivision,firstDivision=_this$props2.firstDivision;var selectedDivision=currentDivision||firstDivision;// Create a independent object
var equipments=[].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(_this.props.values.equipments));var index=__WEBPACK_IMPORTED_MODULE_21_lodash_findIndex___default()(equipments,function(_ref4){var id=_ref4.id,house_divisions=_ref4.house_divisions;return equipment.id===id&&house_divisions===selectedDivision.id;});// Set selected class and quantity
equipments[index].selectedClass=equipment.selectedClass;equipments[index].quantity=equipment.quantity;setValues({equipments:equipments});toggleEquipmentsEditModal(false);},_temp),__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}/**
   * Adds a new equipment
   *//**
   * Removes an equipment by id
   *//**
   * Opens Edition Modal
   *//**
   * Saves edited equipment
   */__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Equipments,[{key:'render',value:function render(){var _this2=this;var _actions=this.actions,setDivision=_actions.setDivision,toggleEquipmentsModal=_actions.toggleEquipmentsModal,toggleEquipmentsEditModal=_actions.toggleEquipmentsEditModal,openEquipmentsList=_actions.openEquipmentsList;var _props=this.props,divisions=_props.divisions,firstDivision=_props.firstDivision,currentDivision=_props.currentDivision,offerType=_props.offerType,offerTypes=_props.offerTypes,equipments=_props.equipments,equipmentsOfferType=_props.equipmentsOfferType,equipmentsOpened=_props.equipmentsOpened,modalOpened=_props.modalOpened,showEquipmentsList=_props.showEquipmentsList,translations=_props.translations;var _ref5=translations||{},HOUSE_EQUIPMENTS=_ref5.HOUSE_EQUIPMENTS;var selectedDivision=currentDivision||firstDivision;var selectedEquipments=this.props.values.equipments&&this.props.values.equipments.filter(function(_ref6){var house_divisions=_ref6.house_divisions;return house_divisions===selectedDivision.id;});// Check if gas or electricity or both
var isGas=offerType&&offerType.slug.indexOf(__WEBPACK_IMPORTED_MODULE_23_config__["l" /* GAS_OFFER_TYPE */])!==-1;var isElectricity=offerType&&offerType.slug.indexOf(__WEBPACK_IMPORTED_MODULE_23_config__["m" /* ELECTRICITY_OFFER_TYPE */])!==-1;var isFullOne=!(isGas&&isElectricity);// Filters equipments by offer type
var gasEquipments=selectedEquipments&&selectedEquipments.filter(function(_ref7){var offer_type=_ref7.offer_type;var _findOfferType=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["t" /* findOfferType */])(offer_type,offerTypes),slug=_findOfferType.slug;return slug===__WEBPACK_IMPORTED_MODULE_23_config__["l" /* GAS_OFFER_TYPE */];}).filter(function(_ref8){var house_divisions=_ref8.house_divisions;return house_divisions===selectedDivision.id;});var electricEquipments=selectedEquipments&&selectedEquipments.filter(function(_ref9){var offer_type=_ref9.offer_type;var _findOfferType2=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["t" /* findOfferType */])(offer_type,offerTypes),slug=_findOfferType2.slug;return slug===__WEBPACK_IMPORTED_MODULE_23_config__["m" /* ELECTRICITY_OFFER_TYPE */];}).filter(function(_ref10){var house_divisions=_ref10.house_divisions;return house_divisions===selectedDivision.id;});// Configure edit modal props
// https://gitlab.ubiwhere.com/adene-poupa-energia/adene-simulador-avancado/issues/21
var equipmentsOfferTypeObject=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["t" /* findOfferType */])(equipmentsOfferType,offerTypes);// console.log(equipmentsOfferType)
var equipmentsModalProps={equipments:equipments,toggleEquipmentsModal:toggleEquipmentsModal,selectedEquipments:selectedEquipments,offerType:equipmentsOfferType,offerTypeName:equipmentsOfferTypeObject&&equipmentsOfferTypeObject.name,selectedDivision:selectedDivision// Map equipment classes to all classes
};var equipmentClasses=[];if(modalOpened){equipmentClasses=[].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(modalOpened.classes));equipmentClasses=equipmentClasses.map(function(item){item.label=item.classe_energetica.name;return item;});}return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(StyledSection,{title:'Equipamentos da Habita\xE7\xE3o',subtitle:'Caracterize os equipamentos da sua habita\xE7\xE3o'},HOUSE_EQUIPMENTS&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Tip__["a" /* default */],{'data-slot':'tip',text:HOUSE_EQUIPMENTS}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Container,null,!showEquipmentsList&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Disclaimer,null,'Definimos um conjunto de equipamentos para a sua casa. ',__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('br',null),'Se pretender alter\xE1-los selecione aqui',__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(DisclaimerButton,{text:'Alterar Equipamentos',onClick:openEquipmentsList})),showEquipmentsList&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_EquipmentHeader__["a" /* default */],{icon:selectedDivision&&selectedDivision.icon&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["f" /* generateMediaUrl */])(selectedDivision.icon),title:selectedDivision&&selectedDivision.name}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(ContentWrapper,null,isElectricity&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Column,{full:isFullOne},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(ColumnHeader,{icon:__WEBPACK_IMPORTED_MODULE_18__images_ic_eletricidade_svg___default.a,title:'Equipamentos de consumo de Eletricidade'}),electricEquipments&&!!electricEquipments.length&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(ColumnHeadings,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span',null,'Tipo de equipamento'),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span',null,'Classe Energ\xE9tica')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(ColumnContent,null,electricEquipments&&electricEquipments.map(function(_ref11,i){var house_divisions=_ref11.house_divisions,item=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref11,['house_divisions']);return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_EquipmentListItem__["a" /* default */],Object.assign({},item,{key:'eqe-'+i,onRemove:function onRemove(){return _this2.removeEquipment(item.id);},onEdit:function onEdit(){return _this2.editEquipment(item);},showEnergyClass:item.svg_key!=='el-carro'}));})),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(AddEquipment,{empty:electricEquipments&&!electricEquipments.length,onClick:function onClick(){return toggleEquipmentsModal(2);}},'Adicionar Equipamento')),isGas&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Column,{full:isFullOne},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(ColumnHeader,{icon:__WEBPACK_IMPORTED_MODULE_19__images_ic_gas_svg___default.a,title:'Equipamentos de consumo de G\xE1s Natural'}),gasEquipments&&!!gasEquipments.length&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(ColumnHeadings,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span',null,'Tipo de equipamento'),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span',null,'Classe Energ\xE9tica')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(ColumnContent,null,gasEquipments&&gasEquipments.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_EquipmentListItem__["a" /* default */],Object.assign({},item,{key:'eqg-'+i,onRemove:function onRemove(){return _this2.removeEquipment(item.id);},onEdit:function onEdit(){return _this2.editEquipment(item);},showEnergyClass:item.svg_key!=='el-carro'}));})),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(AddEquipment,{onClick:function onClick(){return toggleEquipmentsModal(3);},empty:gasEquipments&&!gasEquipments.length},'Adicionar Equipamento'))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_containers_DivisionNavbar__["a" /* default */],{divisions:divisions,selected:selectedDivision,onClick:function onClick(division){return setDivision(division);}}))),modalOpened&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_containers_EquipmentsEditModal__["a" /* default */],{toggle:toggleEquipmentsEditModal,energyClasses:equipmentClasses,equipment:modalOpened,saveEquipment:this.saveEquipment}),equipmentsOpened&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_containers_EquipmentsModal__["a" /* default */],Object.assign({},equipmentsModalProps,{onAddEquipments:this.onAddEquipments,toggle:toggleEquipmentsModal})));}}]);return Equipments;}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]))||_class;var StyledSection=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_11_components_Section__["a" /* default */])(_templateObject);var Container=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject2);var ContentWrapper=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject3);var Column=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject4,function(_ref12){var full=_ref12.full;return full?'margin: 0 auto!important;':'';});var ColumnHeader=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_10_components_EquipmentHeader__["a" /* default */])(_templateObject5);var ColumnHeadings=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject6);var ColumnContent=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].ul(_templateObject7);var AddEquipment=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].button(_templateObject8,__WEBPACK_IMPORTED_MODULE_20__images_plus_svg___default.a,function(_ref13){var empty=_ref13.empty;return empty&&'\n\n  margin: 40px auto;\n\n  ';});var Disclaimer=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject9);var DisclaimerButton=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_13_components_PrimaryButton__["a" /* default */])(_templateObject10);

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_kea__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_kea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_kea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_App_logic__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers_Habitation_logic__ = __webpack_require__(228);
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_kea__["kea"])({// Rename store
path:function path(){return['scenes','equipments'];},// Connect to app logic for the needed values
connect:{actions:[__WEBPACK_IMPORTED_MODULE_3_containers_App_logic__["a" /* default */],['setValue','setValues']],props:[__WEBPACK_IMPORTED_MODULE_3_containers_App_logic__["a" /* default */],['values','offerType','offerTypes','translations'],__WEBPACK_IMPORTED_MODULE_4_containers_Habitation_logic__["default"],['data']]},// All actions
actions:function actions(){return{// Toggles
toggleEquipmentsModal:function toggleEquipmentsModal(offerType){return{offerType:offerType};},toggleEquipmentsEditModal:function toggleEquipmentsEditModal(equipment){return{equipment:equipment};},// Sets
setDivision:function setDivision(division){return{division:division};},setStartDivisions:function setStartDivisions(divisions){return{divisions:divisions};},setNewClassId:function setNewClassId(id){return{id:id};},setEquipment:function setEquipment(division,equipment){return{division:division,equipment:equipment};},// Openers
openEquipmentsList:function openEquipmentsList(){return{};},closeEquipmentsList:function closeEquipmentsList(){return{};}};},reducers:function reducers(_ref){var _ref7;var actions=_ref.actions;return{// Current division of the user
currentDivision:[null,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({},actions.setDivision,function(state,payload){return payload.division;})],// If the right equipments modal is opened or not
equipmentsOpened:[false,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({},actions.toggleEquipmentsModal,function(state,payload){return!state;})],// If the edit modal is opened or not
modalOpened:[false,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({},actions.toggleEquipmentsEditModal,function(state,payload){return payload.equipment;})],// Unused i guess
newClassId:[null,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({},actions.setNewClassId,function(state,payload){return payload.id;})],// The current equipments offer type
equipmentsOfferType:[null,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({},actions.toggleEquipmentsModal,function(state,payload){return payload.offerType;})],// Determiner if the equipments list is shown or not
showEquipmentsList:[false,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,(_ref7={},__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref7,actions.openEquipmentsList,function(){return true;}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref7,actions.closeEquipmentsList,function(){return false;}),_ref7)]};}}));

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EquipmentsEditModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Modal__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Select__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Svg_arrow_svg__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Svg_arrow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_Svg_arrow_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ubiwherenpm_adene_ui_components__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_kea__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_kea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_kea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_containers_App_logic__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_containers_Habitation_logic__ = __webpack_require__(228);
var _dec,_class;var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  margin-bottom: 20px;\n'],['\n  display: block;\n  margin-bottom: 20px;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  width: 100%;\n  color: #010101;\n  border: 1px solid #bababa;\n'],['\n  display: block;\n  width: 100%;\n  color: #010101;\n  border: 1px solid #bababa;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  max-width: initial;\n  text-align: left;\n\n  > div {\n    border: 1px solid #bababa;\n    color: #3e3e3e;\n  }\n\n  img {\n    object-fit: scale-down;\n  }\n  ','\n'],['\n  width: 100%;\n  max-width: initial;\n  text-align: left;\n\n  > div {\n    border: 1px solid #bababa;\n    color: #3e3e3e;\n  }\n\n  img {\n    object-fit: scale-down;\n  }\n  ','\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  text-align: left;\n  padding-bottom: 5px;\n  display: block;\n  width: 100%;\n  font-weight: bold;\n  text-transform: uppercase;\n  font-size: 12px;\n'],['\n  text-align: left;\n  padding-bottom: 5px;\n  display: block;\n  width: 100%;\n  font-weight: bold;\n  text-transform: uppercase;\n  font-size: 12px;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding: 20px;\n  width: 100%;\n'],['\n  padding: 20px;\n  width: 100%;\n']);var EquipmentsEditModal=(_dec=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_kea__["connect"])({props:[__WEBPACK_IMPORTED_MODULE_12_containers_App_logic__["a" /* default */],['values'],__WEBPACK_IMPORTED_MODULE_13_containers_Habitation_logic__["default"],['data']],actions:[__WEBPACK_IMPORTED_MODULE_12_containers_App_logic__["a" /* default */],['setValues']]}),_dec(_class=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(EquipmentsEditModal,_Component);function EquipmentsEditModal(){__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,EquipmentsEditModal);var _this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(EquipmentsEditModal.__proto__||Object.getPrototypeOf(EquipmentsEditModal)).call(this));_this.renderEditButtons=[{label:'cancelar',primary:false,click:function click(){return _this.props.toggle(false);}},{label:'guardar',primary:true,click:function click(){return _this.props.saveEquipment(_this.state.equipment);}}];_this.setNewEquipmentClass=function(classe){var equipment=_this.state.equipment;equipment.selectedClass=Object.assign(classe);_this.setState({equipment:equipment});};_this.setNewEquipmentQuantity=function(quantity){var equipment=_this.state.equipment;equipment.quantity=Number(quantity);_this.setState({equipment:equipment});};_this.onChangeCarDetails=function(field,item){var setValues=_this.actions.setValues;var carChargingValues=_this.props.values.carCharging;carChargingValues[field]=item.value;setValues({carCharging:carChargingValues});};_this.state={equipment:null};return _this;}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(EquipmentsEditModal,[{key:'componentWillMount',value:function componentWillMount(){var equipment=this.props.equipment;this.setState({equipment:equipment});}/**
   * Renders Edit modal buttons
   */},{key:'render',value:function render(){var _this2=this;var _props=this.props,toggle=_props.toggle,energyClasses=_props.energyClasses;var equipment=this.state.equipment;var _props$data=this.props.data,carChargingDurations=_props$data.carChargingDurations,carChargingFrequencies=_props$data.carChargingFrequencies,carChargingPowers=_props$data.carChargingPowers;energyClasses=energyClasses.sort(function(a,b){var nameA=a.label.toUpperCase();var nameB=b.label.toUpperCase();if(nameA<nameB){return-1;}if(nameA>nameB){return 1;}return 0;}).sort(function(a,b){var plusA=a.label.substring(1,a.label.length);var plusB=b.label.substring(1,b.label.length);if(plusA>plusB){return-1;}if(plusA<plusB){return 1;}return 0;});if(equipment.svg_key==='el-carro'){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Modal__["a" /* default */],{title:equipment.name,toggle:true,buttons:this.renderEditButtons,onClick:function onClick(){return toggle(false);}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(EditForm,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputBox,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Label,null,'Quantas vezes carrega o seu veiculo eletrico?'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(StyledSelect,{margin:true,placeholder:'Selecionar..',items:carChargingFrequencies,arrowIcon:__WEBPACK_IMPORTED_MODULE_9_components_Svg_arrow_svg___default.a,onChange:function onChange(frequency){return _this2.onChangeCarDetails('frequency',frequency);},selected:this.props.values.carCharging&&this.props.values.carCharging.frequency})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputBox,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Label,null,'Pot\xEAncia'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(StyledSelect,{margin:true,placeholder:'Selecionar..',items:carChargingPowers,arrowIcon:__WEBPACK_IMPORTED_MODULE_9_components_Svg_arrow_svg___default.a,onChange:function onChange(power){return _this2.onChangeCarDetails('power',power);},selected:this.props.values.carCharging&&this.props.values.carCharging.power})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputBox,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Label,null,'Tempo de carregamento'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(StyledSelect,{margin:true,placeholder:'Selecionar..',items:carChargingDurations,arrowIcon:__WEBPACK_IMPORTED_MODULE_9_components_Svg_arrow_svg___default.a,onChange:function onChange(duration){return _this2.onChangeCarDetails('duration',duration);},selected:this.props.values.carCharging&&this.props.values.carCharging.duration}))));}return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Modal__["a" /* default */],{title:equipment.name,toggle:true,buttons:this.renderEditButtons,onClick:function onClick(){return toggle(false);}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(EditForm,null,energyClasses&&energyClasses.length>1&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputBox,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Label,null,'Classe energ\xE9tica'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(StyledSelect,{margin:true,placeholder:'Classe Energetica',items:energyClasses,onChange:function onChange(value){return _this2.setNewEquipmentClass(value);},selected:equipment.selectedClass&&equipment.selectedClass.id,arrowIcon:__WEBPACK_IMPORTED_MODULE_9_components_Svg_arrow_svg___default.a})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(InputBox,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Label,null,'Quantidade'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(NumberInput,{type:'number',value:equipment.quantity,onChange:function onChange(e){return _this2.setNewEquipmentQuantity(e.target.value);}}))));}}]);return EquipmentsEditModal;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]))||_class);var InputBox=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject);var NumberInput=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_10__ubiwherenpm_adene_ui_components__["a" /* Input */])(_templateObject2);var StyledSelect=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_8_components_Select__["a" /* default */])(_templateObject3,function(_ref){var margin=_ref.margin;return margin&&'margin-right: 30px;';});var Label=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].label(_templateObject4);var EditForm=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject5);

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EquipmentsList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Svg_arrow_svg__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Svg_arrow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_Svg_arrow_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Counter__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Counter_images_less_component_svg__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Counter_images_less_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_Counter_images_less_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Counter_images_more_component_svg__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Counter_images_more_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_Counter_images_more_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Select__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_findIndex__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_kea__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_kea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_kea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_containers_App_logic__ = __webpack_require__(42);
var _dec,_class;var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  text-align: left;\n  padding: 10px;\n\n  span {\n    color: #666;\n    text-align: left;\n    display: block;\n    margin-bottom: 10px;\n  }\n\n  a {\n    color: green;\n    text-decoration: underline;\n    cursor: pointer;\n  }\n'],['\n  text-align: left;\n  padding: 10px;\n\n  span {\n    color: #666;\n    text-align: left;\n    display: block;\n    margin-bottom: 10px;\n  }\n\n  a {\n    color: green;\n    text-decoration: underline;\n    cursor: pointer;\n  }\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 350px;\n  /*height: calc(100% - 6px);*/\n  overflow: auto;\n'],['\n  height: 350px;\n  /*height: calc(100% - 6px);*/\n  overflow: auto;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  box-shadow: inset 0 -1px 0 0 #efefef;\n  text-align: left;\n  cursor: pointer;\n  position: relative;\n  outline: none;\n'],['\n  box-shadow: inset 0 -1px 0 0 #efefef;\n  text-align: left;\n  cursor: pointer;\n  position: relative;\n  outline: none;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #3e3e3e;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 17px;\n  display: inline-block;\n  margin-right: 20px;\n'],['\n  color: #3e3e3e;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 17px;\n  display: inline-block;\n  margin-right: 20px;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  box-shadow: inset 0 -1px 0 0 #efefef;\n  text-align: left;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 10px;\n'],['\n  box-shadow: inset 0 -1px 0 0 #efefef;\n  text-align: left;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 10px;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 30px;\n  height: 30px;\n  display: inline-block;\n  vertical-align: middle;\n  float: none;\n  margin: 0;\n\n  svg {\n    margin: 0;\n    height: 12px;\n    width: 12px;\n  }\n'],['\n  width: 30px;\n  height: 30px;\n  display: inline-block;\n  vertical-align: middle;\n  float: none;\n  margin: 0;\n\n  svg {\n    margin: 0;\n    height: 12px;\n    width: 12px;\n  }\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin-right: 10px;\n'],['\n  margin-right: 10px;\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: inline-block;\n  vertical-align: middle;\n  margin: 0 10px;\n  font-weight: bold;\n'],['\n  display: inline-block;\n  vertical-align: middle;\n  margin: 0 10px;\n  font-weight: bold;\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding: 10px;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  ','\n  ','\n'],['\n  padding: 10px;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  ','\n  ','\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  flex: 1;\n  min-width: 160px;\n  > div {\n    padding: 0;\n    border: 0;\n    color: #3e3e3e;\n    font-size: 16px;\n    font-weight: bold;\n    line-height: 17px;\n  }\n  > div:last-child {\n    position: absolute;\n    max-width: auto;\n  }\n'],['\n  width: 100%;\n  flex: 1;\n  min-width: 160px;\n  > div {\n    padding: 0;\n    border: 0;\n    color: #3e3e3e;\n    font-size: 16px;\n    font-weight: bold;\n    line-height: 17px;\n  }\n  > div:last-child {\n    position: absolute;\n    max-width: auto;\n  }\n']);//import { filter } from "lodash-es";
var EquipmentsList=(_dec=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_kea__["connect"])({props:[__WEBPACK_IMPORTED_MODULE_15_containers_App_logic__["a" /* default */],['values']]}),_dec(_class=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(EquipmentsList,_Component);function EquipmentsList(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,EquipmentsList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=EquipmentsList.__proto__||Object.getPrototypeOf(EquipmentsList)).call.apply(_ref,[this].concat(args))),_this),_this.state={opened:[],editingCarInfo:false},_this.setOpened=function(item){var opened=_this.state.opened;var found=__WEBPACK_IMPORTED_MODULE_12_lodash_findIndex___default()(opened,function(_ref2){var id=_ref2.id;return id===item.id;});if(found!==-1){opened.splice(found,1);}else{opened.push(item);}_this.setState({opened:opened});},_this.setOpenedQuantity=function(item){var clone=Object.assign({},item);var opened=_this.state.opened;var found=__WEBPACK_IMPORTED_MODULE_12_lodash_findIndex___default()(opened,function(_ref3){var id=_ref3.id;return id===clone.id;});if(found!==-1){if(!clone.quantity){opened.splice(found,1);}else{opened[found]=Object.assign({},clone);}}_this.setState({opened:opened});_this.props.onChange&&_this.props.onChange(clone);},_this.renderListItem=function(item,index){var data=item.data;var _this$props=_this.props,allEquipments=_this$props.allEquipments,division=_this$props.division,onChangeEquipmentType=_this$props.onChangeEquipmentType,onChangeCarDetails=_this$props.onChangeCarDetails,carChargingDurations=_this$props.carChargingDurations,carChargingFrequencies=_this$props.carChargingFrequencies,carChargingPowers=_this$props.carChargingPowers;var types=void 0;var types2=void 0;var hasMultipleTypes=void 0;var hasMultipleTypes2=void 0;var et=data.equipment_type.name==='Iluminação';var cl=data.equipment_type.name==='Climatização Local';var cc=data.equipment_type.name==='Climatização Centralizada';var aqs=data.equipment_type.name==='AQS';var fv=data.equipment_type.name==='Funcionamento Variado';var isCar=item.svg_key==='el-carro';/* eslint-disable camelcase */types=allEquipments.filter(function(_ref4){var house_divisions=_ref4.house_divisions,svg_key=_ref4.svg_key,id=_ref4.id;return house_divisions.indexOf(division.id)!==-1&&item.svg_key&&svg_key===item.svg_key;}).map(__WEBPACK_IMPORTED_MODULE_13_utils__["s" /* selectMapper */]);types2=allEquipments.filter(function(equipment){return equipment.equipment_type.name==='Iluminação';}).map(__WEBPACK_IMPORTED_MODULE_13_utils__["s" /* selectMapper */]);hasMultipleTypes2=types2&&types2.length>1;/* eslint-enable camelcase */hasMultipleTypes=types&&types.length>1;if(isCar){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(EditItem,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Name,null,'Quantas vezes carrega o seu veiculo eletrico?'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(TypeSelect,{margin:true,placeholder:'Selecionar..',items:carChargingFrequencies,arrowIcon:__WEBPACK_IMPORTED_MODULE_7_components_Svg_arrow_svg___default.a,onChange:function onChange(frequency){return onChangeCarDetails('frequency',frequency);},selected:_this.props.values.carCharging&&_this.props.values.carCharging.frequency,style:{minWidth:'160px'}})),!_this.state.editingCarInfo&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CarCharginInfo,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span',null,'* Para efeitos de simula\xE7\xE3o ser\xE3o considerados carregamentos efetuados em tomada domestica de 2,3kW com uma dura\xE7\xE3o de 12h.'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('a',{onClick:function onClick(){return _this.setState({editingCarInfo:true});}},'Alterar dados de carregamento')),_this.state.editingCarInfo&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(EditItem,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Name,null,'Pot\xEAncia'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(TypeSelect,{margin:true,placeholder:'Selecionar..',items:carChargingPowers,arrowIcon:__WEBPACK_IMPORTED_MODULE_7_components_Svg_arrow_svg___default.a,onChange:function onChange(power){return onChangeCarDetails('power',power);},selected:_this.props.values.carCharging&&_this.props.values.carCharging.power})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(EditItem,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Name,null,'Tempo de carregamento'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(TypeSelect,{margin:true,placeholder:'Selecionar..',items:carChargingDurations,arrowIcon:__WEBPACK_IMPORTED_MODULE_7_components_Svg_arrow_svg___default.a,onChange:function onChange(duration){return onChangeCarDetails('duration',duration);},selected:_this.props.values.carCharging&&_this.props.values.carCharging.duration}))));}return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ListItem,{key:'li-'+index},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ListItemHeader,null,hasMultipleTypes2&&et&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(TypeSelect,{margin:true,placeholder:'Ilumina\xE7\xE3o',items:types2,selected:data.id,render:function render(selected,placeholder){return placeholder;},arrowIcon:__WEBPACK_IMPORTED_MODULE_7_components_Svg_arrow_svg___default.a,onChange:function onChange(newType){onChangeEquipmentType(data,newType,item.svg_key);}}),hasMultipleTypes&&cl&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(TypeSelect,{margin:true,placeholder:'Climatiza\xE7\xE3o Local',items:types,selected:data.id,arrowIcon:__WEBPACK_IMPORTED_MODULE_7_components_Svg_arrow_svg___default.a,onChange:function onChange(newType){return onChangeEquipmentType(data,newType,item.svg_key);}}),hasMultipleTypes&&cc&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(TypeSelect,{margin:true,placeholder:'Climatiza\xE7\xE3o Centralizada',items:types,selected:data.id,arrowIcon:__WEBPACK_IMPORTED_MODULE_7_components_Svg_arrow_svg___default.a,onChange:function onChange(newType){return onChangeEquipmentType(data,newType,item.svg_key);}}),hasMultipleTypes&&aqs&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(TypeSelect,{margin:true,placeholder:'AQS',items:types,selected:data.id,arrowIcon:__WEBPACK_IMPORTED_MODULE_7_components_Svg_arrow_svg___default.a,onChange:function onChange(newType){return onChangeEquipmentType(data,newType,item.svg_key);}}),hasMultipleTypes&&fv&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(TypeSelect,{margin:true,placeholder:'Funcionamento Variado',items:types,selected:data.id,arrowIcon:__WEBPACK_IMPORTED_MODULE_7_components_Svg_arrow_svg___default.a,onChange:function onChange(newType){return onChangeEquipmentType(data,newType,item.svg_key);}}),!hasMultipleTypes&&!et&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Name,null,data.name),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Selector,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CounterButton,{less:true,disabled:data.quantity===0,onClick:function onClick(){_this.props.onChange(Object.assign({},item,{data:Object.assign({},data,{quantity:!data.quantity?1:data.quantity-1})}));}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Counter_images_less_component_svg___default.a,null)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Quantity,null,data.quantity||1),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CounterButton,{plus:true,margin:true,onClick:function onClick(){_this.props.onChange(Object.assign({},item,{data:Object.assign({},data,{quantity:!data.quantity?1:data.quantity+1})}));}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Counter_images_more_component_svg___default.a,null)))));},_temp),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}/**
   * Sets the quantity of the opened
   */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(EquipmentsList,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){// Reset opened if division changed
if(nextProps.division&&this.props.division){if(nextProps.division.id!==this.props.division.id){this.setState({opened:[]});}}}},{key:'render',value:function render(){var equipments=this.props.equipments;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(List,null,equipments&&equipments.map(this.renderListItem));}}]);return EquipmentsList;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]))||_class);var CarCharginInfo=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject);var List=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject2);var ListItem=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject3);var Name=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject4);var EditItem=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject5);var CounterButton=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_8_components_Counter__["a" /* Button */])(_templateObject6);var Selector=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject7);var Quantity=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject8);var ListItemHeader=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject9,function(_ref5){var hasInside=_ref5.hasInside;return hasInside&&'\n    padding-right: 35px;\n    &:after {\n      content: "";\n      display: block;\n      background: url('+__WEBPACK_IMPORTED_MODULE_7_components_Svg_arrow_svg___default.a+');\n      background-repeat: no-repeat;\n      background-size: 100% 100%;\n      width: 12px;\n      height: 12px;\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      right: 10px;\n    }\n  ';},function(_ref6){var opened=_ref6.opened;return opened&&'\n  &:after {\n    transform: rotate(180deg)translateY(50%);\n  }\n';});var TypeSelect=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_11_components_Select__["a" /* default */])(_templateObject10);

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EquipmentsModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_EquipmentToggler__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_groupBy__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_groupBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_groupBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_findIndex__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_mapValues__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_toArray__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_toArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_toArray__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 280px;\n  background: linear-gradient(270deg, #006736 0%, #93c13e 100%);\n  text-transform: uppercase;\n  flex: 0.05;\n  text-align: center;\n  font-weight: bold;\n  font-size: 16px;\n  letter-spacing: 1px;\n  margin: 40px auto;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 0;\n  cursor: pointer;\n'],['\n  width: 280px;\n  background: linear-gradient(270deg, #006736 0%, #93c13e 100%);\n  text-transform: uppercase;\n  flex: 0.05;\n  text-align: center;\n  font-weight: bold;\n  font-size: 16px;\n  letter-spacing: 1px;\n  margin: 40px auto;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 0;\n  cursor: pointer;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background-color: rgba(239, 239, 239, 0.8);\n  z-index: 999;\n'],['\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background-color: rgba(239, 239, 239, 0.8);\n  z-index: 999;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 528px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background-color: #ffffff;\n  box-shadow: -2px 0 20px 0 rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n\n  @media (max-width: 600px) {\n    width: 100%;\n  }\n'],['\n  width: 528px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background-color: #ffffff;\n  box-shadow: -2px 0 20px 0 rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n\n  @media (max-width: 600px) {\n    width: 100%;\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #010101;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 32px;\n  text-align: left;\n  text-transform: uppercase;\n  flex: 0.8;\n\n  @media screen and (max-width: 768px) {\n    font-size: 16px;\n    line-height: 24px;\n  }\n\n  @media screen and (max-width: 320px) {\n    font-size: 14px;\n    line-height: 18px;\n  }\n'],['\n  color: #010101;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 32px;\n  text-align: left;\n  text-transform: uppercase;\n  flex: 0.8;\n\n  @media screen and (max-width: 768px) {\n    font-size: 16px;\n    line-height: 24px;\n  }\n\n  @media screen and (max-width: 320px) {\n    font-size: 14px;\n    line-height: 18px;\n  }\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.05);\n  padding: 40px;\n  flex: 0.15;\n'],['\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.05);\n  padding: 40px;\n  flex: 0.15;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 0.1;\n  display: block;\n  text-align: center;\n  position: relative;\n  cursor: pointer;\n\n  &:before {\n    content: \'\u2715\';\n    font-size: 20px;\n    line-height: 24px;\n    color: #bababa;\n    top: 0;\n    position: absolute;\n    left: 0;\n    width: 100%;\n    border: 1px solid #bababa;\n    width: 24px;\n    height: 24px;\n    display: block;\n    text-align: center;\n    position: relative;\n    cursor: pointer;\n  }\n'],['\n  flex: 0.1;\n  display: block;\n  text-align: center;\n  position: relative;\n  cursor: pointer;\n\n  &:before {\n    content: \'\u2715\';\n    font-size: 20px;\n    line-height: 24px;\n    color: #bababa;\n    top: 0;\n    position: absolute;\n    left: 0;\n    width: 100%;\n    border: 1px solid #bababa;\n    width: 24px;\n    height: 24px;\n    display: block;\n    text-align: center;\n    position: relative;\n    cursor: pointer;\n  }\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding: 10px 40px;\n  flex: 0.8;\n  display: flex;\n  overflow: auto;\n  flex-direction: column;\n'],['\n  padding: 10px 40px;\n  flex: 0.8;\n  display: flex;\n  overflow: auto;\n  flex-direction: column;\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  margin-bottom: 40px;\n  white-space: nowrap;\n'],['\n  width: 100%;\n  margin-bottom: 40px;\n  white-space: nowrap;\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: inline-block;\n  vertical-align: middle;\n  white-space: normal;\n  width: 25px;\n  margin-right: 20px;\n'],['\n  display: inline-block;\n  vertical-align: middle;\n  white-space: normal;\n  width: 25px;\n  margin-right: 20px;\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 1;\n  display: inline-block;\n  vertical-align: middle;\n  width: calc(100% - 25px);\n  white-space: normal;\n'],['\n  flex: 1;\n  display: inline-block;\n  vertical-align: middle;\n  width: calc(100% - 25px);\n  white-space: normal;\n']);var mapObjectToarray=function mapObjectToarray(object){return __WEBPACK_IMPORTED_MODULE_13_lodash_toArray___default()(__WEBPACK_IMPORTED_MODULE_12_lodash_mapValues___default()(object,function(value,key){return{key:key,id:key,value:value};}));};/* eslint-disable camelcase */var EquipmentsModal=function(_Component){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(EquipmentsModal,_Component);function EquipmentsModal(){__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,EquipmentsModal);var _this=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(EquipmentsModal.__proto__||Object.getPrototypeOf(EquipmentsModal)).call(this));_this.toggleEquipment=function(equipment){var clone=Object.assign({},equipment);var selectedDivision=_this.props.selectedDivision;var enabled=_this.state.enabled;var eqInArray=__WEBPACK_IMPORTED_MODULE_11_lodash_findIndex___default()(enabled,function(_ref){var id=_ref.id;return id===clone.id;});if(eqInArray!==-1){enabled.splice(eqInArray,1);}else{clone.house_divisions=selectedDivision.id;enabled.push(clone);}_this.setState({enabled:enabled});};_this.state={enabled:[]};return _this;}__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(EquipmentsModal,[{key:'componentWillMount',value:function componentWillMount(){document.body.style.overflow='hidden';var selectedEquipments=[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.props.selectedEquipments));this.setState({enabled:selectedEquipments});}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.body.style.overflow='initial';}},{key:'render',value:function render(){var _this2=this;var _props=this.props,selectedDivision=_props.selectedDivision,offerType=_props.offerType,onAddEquipments=_props.onAddEquipments,toggle=_props.toggle,offerTypeName=_props.offerTypeName;// Get equipments based on offertype and division
var equipments=[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.props.equipments));var groupEquipments=equipments&&equipments.filter(function(_ref2){var offer_type=_ref2.offer_type;return offer_type===offerType;}).filter(function(_ref3){var house_divisions=_ref3.house_divisions;return house_divisions.indexOf(selectedDivision.id)!==-1;});groupEquipments=__WEBPACK_IMPORTED_MODULE_10_lodash_groupBy___default()(groupEquipments,function(_ref4){var equipment_icon=_ref4.equipment_icon;return equipment_icon?equipment_icon.icon:null;});groupEquipments=mapObjectToarray(groupEquipments);return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Outside,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(RightContainer,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(RightHeader,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Title,null,'Adicionar equipamento de consumo de ',offerTypeName),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Close,{onClick:function onClick(){return toggle(null);}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(EquipmentsList,null,groupEquipments&&groupEquipments.map(function(item){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Item,{key:item.id},item.key&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Icon,{src:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_utils__["f" /* generateMediaUrl */])(item.key)}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(List,null,item.value&&item.value.map(function(equipment){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_EquipmentToggler__["a" /* default */],{key:equipment.id,equipment:equipment,onToggle:function onToggle(){return _this2.toggleEquipment(equipment);},selected:__WEBPACK_IMPORTED_MODULE_11_lodash_findIndex___default()(_this2.state.enabled,function(_ref5){var id=_ref5.id;return id===equipment.id;})!==-1});})));})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(EquipmentAddButton,{onClick:function onClick(){return onAddEquipments(_this2.state.enabled);}},'Adicionar Equipamentos')));}}]);return EquipmentsModal;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);var EquipmentAddButton=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject);var Outside=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject2);var RightContainer=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject3);var Title=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject4);var RightHeader=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject5);var Close=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject6);var EquipmentsList=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject7);var Item=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject8);var Icon=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].img(_templateObject9);var List=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject10);

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EquipmentsSvg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()([''],['']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin: 0 auto;\n\n  .clickable {\n    cursor: pointer;\n    pointer-events: bounding-box;\n  }\n\n  svg {\n    width: 100% !important;\n  }\n\n  .active {\n    fill: url(#gradient);\n  }\n'],['\n  margin: 0 auto;\n\n  .clickable {\n    cursor: pointer;\n    pointer-events: bounding-box;\n  }\n\n  svg {\n    width: 100% !important;\n  }\n\n  .active {\n    fill: url(#gradient);\n  }\n']);/* eslint-disable */window.NodeList.prototype.forEach=Array.prototype.forEach;window.Node.prototype.contains=function contains(node){if(!(0 in arguments)){throw new TypeError('1 argument is required');}while(node=node&&node.parentNode){if(this===node){return true;}}return false;};/* eslint-enable */var EquipmentsSvg=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(EquipmentsSvg,_Component);function EquipmentsSvg(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,EquipmentsSvg);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=EquipmentsSvg.__proto__||Object.getPrototypeOf(EquipmentsSvg)).call.apply(_ref,[this].concat(args))),_this),_this.onSvgClick=function(e){var onClickElement=_this.props.onClickElement;if(!onClickElement){return;}var interactiveBox=document.getElementsByClassName('elementos-interativos')[0];var element=e.target;// Check if elements exist
if(element&&interactiveBox){var parent=element.parentNode;var isInteractive=interactiveBox.contains(e.target);// Toggle equipment
if(isInteractive){// If is a group of equipments
if(!parent.classList.contains('elementos-interativos')){element=parent;}var item=element.classList.item(0);// Set gradient fill
element.classList.toggle('active');// Trigger
onClickElement(item);}}},_this.triggerSelected=function(){if(!_this.svgRef){return;}var interactiveBox=_this.svgRef.getElementsByClassName('elementos-interativos')[0];if(interactiveBox){var allInteractive=interactiveBox.querySelectorAll('path');allInteractive.forEach(function(ele){return ele.classList.add('clickable');});var _this$props=_this.props,currentEquipments=_this$props.currentEquipments,hiddenSvgItems=_this$props.hiddenSvgItems;currentEquipments&&currentEquipments.forEach(function(_ref2){var svg_key=_ref2.svg_key;var element=interactiveBox.getElementsByClassName(svg_key);if(element[0]){element[0].classList.add('active');}});hiddenSvgItems&&hiddenSvgItems.forEach(function(id){var element=_this.svgRef.getElementsByClassName(id);if(element[0]){element[0].style.cssText='fill: #DEDEDE';element[0].setAttribute('class','');if(element[0]&&element[0].tagName==='g'){element[0].querySelectorAll('path').forEach(function(ele){return ele.setAttribute('class','');});}}});}},_temp),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(EquipmentsSvg,[{key:'componentDidUpdate',value:function componentDidUpdate(){this.triggerSelected();}},{key:'componentDidMount',value:function componentDidMount(){this.triggerSelected();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,svg=_props.svg,className=_props.className,style=_props.style;var SvgComponent=function SvgComponent(props){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(SvgWrapper,Object.assign({},props,{dangerouslySetInnerHTML:{__html:svg}}));};return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Wrapper,{className:className,style:style},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(SvgComponent,{innerRef:function innerRef(ref){_this2.svgRef=ref;},onClick:this.onSvgClick}));}}]);return EquipmentsSvg;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);var Wrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject);var SvgWrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject2);

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Faturation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_containers_Form__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_ic_arrow_svg__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_ic_arrow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_ic_arrow_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Svg_informacao_svg__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Svg_informacao_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_Svg_informacao_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__logic__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Section__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_RadioGroup__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_ButtonConfirm__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_Toltip__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_Loading__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_Select__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_Tip__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_FixedWrapper__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_validations__ = __webpack_require__(48);
var _class;var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()([''],['']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 310px;\n  margin: 0 auto;\n  margin-top: 30px;\n  position: relative;\n\n  @media (max-width: 1280px) {\n    width: 320px;\n  }\n'],['\n  width: 310px;\n  margin: 0 auto;\n  margin-top: 30px;\n  position: relative;\n\n  @media (max-width: 1280px) {\n    width: 320px;\n  }\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  max-width: initial;\n  text-align: left;\n\n  > div {\n    border: 1px solid #bababa;\n    color: #3e3e3e;\n  }\n\n  img {\n    object-fit: scale-down;\n  }\n  ','\n'],['\n  width: 100%;\n  max-width: initial;\n  text-align: left;\n\n  > div {\n    border: 1px solid #bababa;\n    color: #3e3e3e;\n  }\n\n  img {\n    object-fit: scale-down;\n  }\n  ','\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  text-align: left;\n  padding-bottom: 5px;\n  display: block;\n  width: 100%;\n  font-weight: bold;\n  text-transform: uppercase;\n  font-size: 12px;\n'],['\n  text-align: left;\n  padding-bottom: 5px;\n  display: block;\n  width: 100%;\n  font-weight: bold;\n  text-transform: uppercase;\n  font-size: 12px;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: absolute;\n  right: -115%;\n  top: 42%;\n\n  @media (max-width: 1280px) {\n    right: 0;\n    top: 115%;\n  }\n'],['\n  position: absolute;\n  right: -115%;\n  top: 42%;\n\n  @media (max-width: 1280px) {\n    right: 0;\n    top: 115%;\n  }\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: inline-block;\n  font-size: 12px;\n  color: indianred;\n  margin: 10px auto;\n  text-align: left;\n'],['\n  display: inline-block;\n  font-size: 12px;\n  color: indianred;\n  margin: 10px auto;\n  text-align: left;\n']);var MAX_LIST_ITEMS=12;/* eslint-disable camelcase */var paymentMethods=[{text:'Multibanco / CTT / Payshop',value:'atm_ctt'},{text:'Débito Direto',value:'direct_debit'}];var Faturation=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__logic__["a" /* default */])(_class=function(_Form){__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Faturation,_Form);function Faturation(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this,Faturation);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=Faturation.__proto__||Object.getPrototypeOf(Faturation)).call.apply(_ref,[this].concat(args))),_this),_this.nextText='PR\xD3XIMO passo',_this.prevText='Passo Anterior',_this.sendHeight=function(){var height=document.body.scrollHeight;window.parent.postMessage({type:'setHeight',height:height},'*');},_this.next=function(){var _this$isFormValid=_this.isFormValid(),valid=_this$isFormValid.valid,invalid=_this$isFormValid.invalid;var _this$actions=_this.actions,setFinished=_this$actions.setFinished,setInvalid=_this$actions.setInvalid;var _this$props=_this.props,router=_this$props.router,values=_this$props.values;var has_consumes=values.has_consumes;if(valid){setFinished({faturationFinished:true});setInvalid({});window.parent.postMessage({type:'scrollToTop'},'*');if(__WEBPACK_IMPORTED_MODULE_21_config__["o" /* isSimple */]&&has_consumes!==true){router.push('/resultados');}else{router.push('/consumos');}}else{setFinished({faturationFinished:false});setInvalid(invalid);var gasEntityInvalid=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["n" /* pickOrNot */])(invalid,['gas_entity']);var electricityEntityInvalid=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["n" /* pickOrNot */])(invalid,['electricity_entity']);if(electricityEntityInvalid){var el=document.getElementById('comerel');var el2=document.getElementById('comerelg');if(el){el.scrollIntoView({behavior:'smooth'});}if(el2){el2.scrollIntoView({behavior:'smooth'});}return false;}if(gasEntityInvalid){var _el=document.getElementById('comerg');if(_el){_el.scrollIntoView({behavior:'smooth'});}return false;}}},_this.prev=function(){var router=_this.props.router;// If current simulador is empresarial prev must be the profile
if(__WEBPACK_IMPORTED_MODULE_21_config__["k" /* isEnterprise */]){router.push('/');}else{router.push('/habitacao');}window.parent.postMessage({type:'scrollToTop'},'*');},_this.renderInvalidMessage=function(invalid,field,name){if(invalid){if(invalid[field]){var Message=__WEBPACK_IMPORTED_MODULE_23_validations__["b" /* Messages */][invalid[field]];if(Message){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Error,null,Message(name));}}}return null;},_this.consumptionDisaggregationLogic=function(values){var consumptionDisaggregation=_this.props.values.consumptionDisaggregation;var simples=values.simples,cheias=values.cheias;switch(consumptionDisaggregation){// Fill all fields with simples value
case's':if(simples){values.svazio=simples;values.cheias=simples;values.ponta=simples;}return values;case'vf':if(simples){values.svazio=simples;}if(cheias){values.ponta=cheias;}return values;case'vcp':if(simples){values.svazio=simples;}return values;case'vscp':return values;default:return values;}},_this.setTableElectricityValues=function(values,index){var setValues=_this.actions.setValues;var electricityConsumptionsRegistration=_this.props.values.electricityConsumptionsRegistration;values=_this.consumptionDisaggregationLogic(values);var item=electricityConsumptionsRegistration[index];electricityConsumptionsRegistration[index]=Object.assign({},item,values);setValues({electricityConsumptionsRegistration:electricityConsumptionsRegistration});},_this.onRemoveElectricityValue=function(index){var setValues=_this.actions.setValues;var electricityConsumptionsRegistration=_this.props.values.electricityConsumptionsRegistration;var clone=[].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(electricityConsumptionsRegistration));if(clone.length>1){clone.splice(index,1);}setValues({electricityConsumptionsRegistration:clone});},_this.addNewElectricityTableValue=function(){var setValues=_this.actions.setValues;var electricityConsumptionsRegistration=_this.props.values.electricityConsumptionsRegistration;if(electricityConsumptionsRegistration.length>=MAX_LIST_ITEMS){return false;}electricityConsumptionsRegistration.push({startDate:null,endDate:null,simples:'',svazio:'',cheias:'',ponta:''});setValues({electricityConsumptionsRegistration:electricityConsumptionsRegistration});},_this.setTableGasValues=function(values,index){var setValues=_this.actions.setValues;var gasConsumptionsRegistration=_this.props.values.gasConsumptionsRegistration;var item=gasConsumptionsRegistration[index];gasConsumptionsRegistration[index]=Object.assign({},item,values);setValues({gasConsumptionsRegistration:gasConsumptionsRegistration});},_this.onRemoveGasValue=function(index){var setValues=_this.actions.setValues;var gasConsumptionsRegistration=_this.props.values.gasConsumptionsRegistration;if(gasConsumptionsRegistration.length>1){gasConsumptionsRegistration.splice(index,1);}setValues({gasConsumptionsRegistration:gasConsumptionsRegistration});},_this.addNewGasTableValue=function(){var setValues=_this.actions.setValues;var gasConsumptionsRegistration=_this.props.values.gasConsumptionsRegistration;if(gasConsumptionsRegistration.length>=MAX_LIST_ITEMS){return false;}gasConsumptionsRegistration.push({startDate:null,endDate:null,consumption:''});setValues({gasConsumptionsRegistration:gasConsumptionsRegistration});},_temp),__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Faturation,[{key:'componentWillMount',value:function componentWillMount(){if(__WEBPACK_IMPORTED_MODULE_21_config__["o" /* isSimple */]){this.nextText='Simular';}}},{key:'componentDidMount',value:function componentDidMount(){// Scrols to top on component mount
var element=document.getElementById('anchor');window.scroll({top:element.getBoundingClientRect().top});}},{key:'componentDidUpdate',value:function componentDidUpdate(oldProps){if(oldProps.loading&&!this.props.loading){var element=document.getElementById('anchor');window.scroll({top:element.getBoundingClientRect().top});}this.sendHeight();window.addEventListener('resize',this.sendHeight);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.sendHeight);}},{key:'pickTranslations',value:function pickTranslations(translations){var _ref2=translations||{},GAS_SCALE=_ref2.GAS_SCALE,GAS_SCALE_ENTERPRISE=_ref2.GAS_SCALE_ENTERPRISE,BILLING_TYPE=_ref2.BILLING_TYPE,ELECTRONIC_BILL=_ref2.ELECTRONIC_BILL,JOINT_BILLING=_ref2.JOINT_BILLING,ADDITIONAL_SERVICES=_ref2.ADDITIONAL_SERVICES,ELECTRICITY_SUPPLIER=_ref2.ELECTRICITY_SUPPLIER,ELECTRICITY_RATE=_ref2.ELECTRICITY_RATE,GAS_SUPPLIER=_ref2.GAS_SUPPLIER,ENTERPRISE_BILLING_TYPE=_ref2.ENTERPRISE_BILLING_TYPE,ENTERPRISE_ELECTRONIC_BILL=_ref2.ENTERPRISE_ELECTRONIC_BILL,ENTERPRISE_JOINT_BILLING=_ref2.ENTERPRISE_JOINT_BILLING,ENTERPRISE_ADDITIONAL_SERVICES=_ref2.ENTERPRISE_ADDITIONAL_SERVICES,ENTERPRISE_ELECTRICITY_SUPPLIER=_ref2.ENTERPRISE_ELECTRICITY_SUPPLIER,ENTERRPISE_ELECTRICITY_RATE=_ref2.ENTERRPISE_ELECTRICITY_RATE,ENTERPRISE_GAS_SUPPLIER=_ref2.ENTERPRISE_GAS_SUPPLIER;if(__WEBPACK_IMPORTED_MODULE_21_config__["k" /* isEnterprise */]){return{BILLING_TYPE:ENTERPRISE_BILLING_TYPE,ELECTRONIC_BILL:ENTERPRISE_ELECTRONIC_BILL,JOINT_BILLING:ENTERPRISE_JOINT_BILLING,ADDITIONAL_SERVICES:ENTERPRISE_ADDITIONAL_SERVICES,ELECTRICITY_SUPPLIER:ENTERPRISE_ELECTRICITY_SUPPLIER,ELECTRICITY_RATE:ENTERRPISE_ELECTRICITY_RATE,GAS_SUPPLIER:ENTERPRISE_GAS_SUPPLIER,GAS_SCALE:GAS_SCALE_ENTERPRISE};}else{return{BILLING_TYPE:BILLING_TYPE,ELECTRONIC_BILL:ELECTRONIC_BILL,JOINT_BILLING:JOINT_BILLING,ADDITIONAL_SERVICES:ADDITIONAL_SERVICES,ELECTRICITY_SUPPLIER:ELECTRICITY_SUPPLIER,ELECTRICITY_RATE:ELECTRICITY_RATE,GAS_SUPPLIER:GAS_SUPPLIER,GAS_SCALE:GAS_SCALE};}}/**
   * Logic to be applied to values based on
   * consumptionDisaggregation value
   *//**
   * Sets the value of the electricity element by index
   *//**
   * Removes an element from the table list of electricity
   *//**
   * Adds new eletricity table value to state
   *//**
   * Sets the value of the gas element by index
   *//**
   * Removes an element from the table list of gas
   *//**
   * Adds a new gas table value to state
   */},{key:'render',value:function render(){var _this2=this;var setValues=this.actions.setValues;var _props=this.props,loading=_props.loading,hiredPowerSugested=_props.hiredPowerSugested,offerType=_props.offerType,invalid=_props.invalid,translations=_props.translations,iframed=_props.iframed;var _pickTranslations=this.pickTranslations(translations),GAS_SCALE=_pickTranslations.GAS_SCALE,BILLING_TYPE=_pickTranslations.BILLING_TYPE,ELECTRONIC_BILL=_pickTranslations.ELECTRONIC_BILL,JOINT_BILLING=_pickTranslations.JOINT_BILLING,ADDITIONAL_SERVICES=_pickTranslations.ADDITIONAL_SERVICES,ELECTRICITY_SUPPLIER=_pickTranslations.ELECTRICITY_SUPPLIER,ELECTRICITY_RATE=_pickTranslations.ELECTRICITY_RATE,GAS_SUPPLIER=_pickTranslations.GAS_SUPPLIER;var _props$values=this.props.values,invoicing_type=_props$values.invoicing_type,has_electronic_billing=_props$values.has_electronic_billing,ciclo_horario=_props$values.ciclo_horario,ciclo_tarifa=_props$values.ciclo_tarifa,electricity_entity=_props$values.electricity_entity,gas_entity=_props$values.gas_entity,potencia_contratada=_props$values.potencia_contratada,gas_stage=_props$values.gas_stage,hide_additional=_props$values.hide_additional,has_consumes=_props$values.has_consumes;// We need to permit this value to change
var has_joint_billing=this.props.values.has_joint_billing;var _props$filters=this.props.filters,electricityEntities=_props$filters.electricityEntities,gasEntities=_props$filters.gasEntities,powerChoices=_props$filters.powerChoices,timeCycleChoices=_props$filters.timeCycleChoices,allEntities=_props$filters.allEntities;// Loading? Dont do anything
if(loading){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_Loading__["a" /* default */],null);}var gasScales=[{value:1,label:'Escalão 1'},{value:2,label:'Escalão 2'},{value:3,label:'Escalão 3'},{value:4,label:'Escalão 4'}];// Used to show determinated sections based on offertype chosen
var isGas=offerType&&offerType.slug===__WEBPACK_IMPORTED_MODULE_21_config__["l" /* GAS_OFFER_TYPE */];var isElectricity=offerType&&offerType.slug===__WEBPACK_IMPORTED_MODULE_21_config__["m" /* ELECTRICITY_OFFER_TYPE */];var isElectricityAndGas=offerType&&offerType.slug===__WEBPACK_IMPORTED_MODULE_21_config__["q" /* GAS_AND_ELECTRICITY_OFFER_TYPE */];// i think i did this in a hurry
// Remove tetra hórario from the list
// if (!isEnterprise) {
//   timeCycleChoices && delete timeCycleChoices['tetra-horário']
// }
// Convert object to array to use in selects and other mappers
timeCycleChoices=timeCycleChoices&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["k" /* mapObjectToarray */])(timeCycleChoices);/* priceCycleChoices = priceCycleChoices && mapObjectToarray(priceCycleChoices) */powerChoices=powerChoices&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["k" /* mapObjectToarray */])(powerChoices);electricityEntities=electricityEntities&&electricityEntities.map(function(_ref3){var hi_res_logo=_ref3.hi_res_logo,designation=_ref3.designation,id=_ref3.id,item=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref3,['hi_res_logo','designation','id']);return Object.assign({label:designation,value:id,icon:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["f" /* generateMediaUrl */])(hi_res_logo)},item);});gasEntities=gasEntities&&gasEntities.map(function(_ref4){var hi_res_logo=_ref4.hi_res_logo,designation=_ref4.designation,id=_ref4.id,item=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref4,['hi_res_logo','designation','id']);return Object.assign({label:designation,value:id,icon:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["f" /* generateMediaUrl */])(hi_res_logo)},item);});allEntities=allEntities&&allEntities.map(function(_ref5){var hi_res_logo=_ref5.hi_res_logo,designation=_ref5.designation,id=_ref5.id,item=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref5,['hi_res_logo','designation','id']);return Object.assign({label:designation,value:id,icon:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["f" /* generateMediaUrl */])(hi_res_logo)},item);});var showEletricSection=isElectricity||isElectricityAndGas&&!has_joint_billing;var showGasSection=isGas||isElectricityAndGas&&!has_joint_billing;var showBothSection=isElectricityAndGas&&has_joint_billing;// If is just one type has_joint_billing is false, because there's no set of invoices
if(isElectricity||isGas){if(has_joint_billing){setValues({has_joint_billing:false});}}// Pick needed invalids
var gasEntityInvalid=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["n" /* pickOrNot */])(invalid,['gas_entity']);var electricityEntityInvalid=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["n" /* pickOrNot */])(invalid,['electricity_entity']);var gasScaleInvalid=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["n" /* pickOrNot */])(invalid,['gas_stage']);var hiredPowerInvalid=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_utils__["n" /* pickOrNot */])(invalid,['potencia_contratada']);// Sets the value of ciclo de tarifa to diario if changed to Simple
// https://gitlab.ubiwhere.com/adene-poupa-energia/adene-simulador-avancado/issues/7
var SIMPLE_VALUE='s';var DAILY_VALUE='d';if(ciclo_horario===SIMPLE_VALUE&&ciclo_tarifa!==DAILY_VALUE){setValues({ciclo_tarifa:DAILY_VALUE});}var consumptionDisaggregations=this.props.filters.consumptionDisaggregations;// If ciclo_horario selected in faturation is BI horario cannot let
// select a simple disaggregation
// https://gitlab.ubiwhere.com/adene-poupa-energia/adene-simulador-avancado/issues/25
var filteredConsumptionDisaggregations=void 0;var BI_HORARY='b';var SIMPLE_ID='s';var ENTERPRISE_ID='vscp';if(ciclo_horario===BI_HORARY){filteredConsumptionDisaggregations=consumptionDisaggregations.filter(function(item){return item.id!==SIMPLE_ID;});}if(!__WEBPACK_IMPORTED_MODULE_21_config__["k" /* isEnterprise */]){if(!filteredConsumptionDisaggregations){filteredConsumptionDisaggregations=consumptionDisaggregations.filter(function(item){return item.id!==ENTERPRISE_ID;});}else{filteredConsumptionDisaggregations=filteredConsumptionDisaggregations.filter(function(item){return item.id!==ENTERPRISE_ID;});}}return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Wrapper,null,this.renderNavbar(),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_FixedWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Section__["a" /* default */],{title:'Fatura\xE7\xE3o',subtitle:'Selecione o m\xE9todo de pagamento',compact:iframed},BILLING_TYPE&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Tip__["a" /* default */],{'data-slot':'tip',text:BILLING_TYPE}),paymentMethods&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_RadioGroup__["a" /* default */],{items:paymentMethods,value:invoicing_type,name:'payment_method',onSelectionChange:function onSelectionChange(_ref6){var value=_ref6.value;return setValues({invoicing_type:value});}})),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Section__["a" /* default */],{title:'Fatura Eletr\xF3nica',subtitle:'Recebe a sua fatura por via eletr\xF3nica',grey:true,compact:iframed},ELECTRONIC_BILL&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Tip__["a" /* default */],{'data-slot':'tip',text:ELECTRONIC_BILL}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_ButtonConfirm__["a" /* default */],{onButtonClick:function onButtonClick(_ref7){var value=_ref7.value;return setValues({has_electronic_billing:value});},value:has_electronic_billing||false,items:__WEBPACK_IMPORTED_MODULE_21_config__["r" /* BOOLEAN_CHOICES */]})),isElectricityAndGas&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Section__["a" /* default */],{title:'Fatura Conjunta?',subtitle:'Possui os seus servi\xE7os agregados numa \xFAnica fatura?',compact:iframed},JOINT_BILLING&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Tip__["a" /* default */],{'data-slot':'tip',text:JOINT_BILLING}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_ButtonConfirm__["a" /* default */],{onButtonClick:function onButtonClick(_ref8){var value=_ref8.value;return setValues({has_joint_billing:value});},value:has_joint_billing||false,items:__WEBPACK_IMPORTED_MODULE_21_config__["r" /* BOOLEAN_CHOICES */],compact:iframed})),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Section__["a" /* default */],{title:'SERVI\xC7OS ADICIONAIS',subtitle:'Ver tarif\xE1rios com servi\xE7os adicionais?',compact:iframed},ADDITIONAL_SERVICES&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Tip__["a" /* default */],{'data-slot':'tip',text:ADDITIONAL_SERVICES}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_ButtonConfirm__["a" /* default */],{onButtonClick:function onButtonClick(_ref9){var value=_ref9.value;return setValues({hide_additional:value});},value:hide_additional||false,items:__WEBPACK_IMPORTED_MODULE_21_config__["r" /* BOOLEAN_CHOICES */]})),showEletricSection&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Section__["a" /* default */],{title:'Comercializador Eletricidade',subtitle:'Selecione o seu comercializador de Eletricidade',id:'comerel',className:electricityEntityInvalid&&'invalid',compact:iframed},ELECTRICITY_SUPPLIER&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Tip__["a" /* default */],{'data-slot':'tip',text:ELECTRICITY_SUPPLIER}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(WrapperSelect,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(LocationLabel,null,'Comercializador de eletricidade'),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(StyledSelect,{margin:true,placeholder:'Comercializador de eletricidade',items:electricityEntities,onChange:function onChange(_ref10){var value=_ref10.value;return setValues({electricity_entity:value});},selected:electricity_entity,arrowIcon:__WEBPACK_IMPORTED_MODULE_10__images_ic_arrow_svg___default.a})),this.renderInvalidMessage(electricityEntityInvalid,'electricity_entity','Comercializador')),showBothSection&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Section__["a" /* default */],{title:'Comercializador Eletricidade e G\xE1s',subtitle:'Selecione o seu comercializador de Eletricidade e G\xE1s',id:'comerelg',className:electricityEntityInvalid&&'invalid',compact:iframed},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(WrapperSelect,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(LocationLabel,null,'Comercializador de eletricidade e g\xE1s'),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(StyledSelect,{margin:true,placeholder:'Comercializador de eletricidade e g\xE1s',items:allEntities,onChange:function onChange(_ref11){var value=_ref11.value;return setValues({electricity_entity:value,gas_entity:value});},selected:electricity_entity,arrowIcon:__WEBPACK_IMPORTED_MODULE_10__images_ic_arrow_svg___default.a}),this.renderInvalidMessage(electricityEntityInvalid,'electricity_entity','Comercializador'))),(isElectricity||isElectricityAndGas)&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Section__["a" /* default */],{title:'Tarifa de Eletricidade',subtitle:'Selecione o seu tipo da tarifa de eletricidade',grey:true,compact:iframed},ELECTRICITY_RATE&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Tip__["a" /* default */],{'data-slot':'tip',text:ELECTRICITY_RATE}),timeCycleChoices&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_RadioGroup__["a" /* default */],{items:timeCycleChoices,value:ciclo_horario,name:'ciclo_horario',onSelectionChange:function onSelectionChange(_ref12){var value=_ref12.value;return setValues({ciclo_horario:value});}})),(isElectricity||isElectricityAndGas)&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Section__["a" /* default */],{title:'Pot\xEAncia Contratada',subtitle:'Selecione a pot\xEAncia contratada',grey:true,className:hiredPowerInvalid&&'invalid',compact:iframed},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(WrapperSelect,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(LocationLabel,null,'Pot\xEAncia Contratada'),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(StyledSelect,{margin:true,placeholder:'Pot\xEAncia Contratada',items:powerChoices,onChange:function onChange(_ref13){var value=_ref13.value;return setValues({potencia_contratada:value});},selected:potencia_contratada,arrowIcon:__WEBPACK_IMPORTED_MODULE_10__images_ic_arrow_svg___default.a}),hiredPowerSugested&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(AbsoluteToltip,{text:'Com base nas suas respostas anteriores,a pot\xEAncia contratada deveria ser '+hiredPowerSugested+' kVA',icon:__WEBPACK_IMPORTED_MODULE_11_components_Svg_informacao_svg___default.a}),this.renderInvalidMessage(hiredPowerInvalid,'potencia_contratada','Potência Contratada'))),showGasSection&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Section__["a" /* default */],{title:'Comercializador G\xE1s Natural',subtitle:'Selecione o seu comercializador de G\xE1s Natural',id:'comerg',className:gasEntityInvalid&&'invalid',compact:iframed},GAS_SUPPLIER&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Tip__["a" /* default */],{'data-slot':'tip',text:GAS_SUPPLIER}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(WrapperSelect,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(LocationLabel,null,'Comercializador G\xE1s Natural'),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(StyledSelect,{margin:true,placeholder:'Comercializador G\xE1s Natural',items:gasEntities,onChange:function onChange(_ref14){var value=_ref14.value;return setValues({gas_entity:value});},selected:gas_entity,arrowIcon:__WEBPACK_IMPORTED_MODULE_10__images_ic_arrow_svg___default.a}),this.renderInvalidMessage(gasEntityInvalid,'gas_entity','Comercializador'))),__WEBPACK_IMPORTED_MODULE_21_config__["o" /* isSimple */]&&(isGas||isElectricityAndGas)&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Section__["a" /* default */],{title:'Escal\xE3o G\xE1s Natural',subtitle:'Selecione o seu escal\xE3o',id:'comerg',className:gasScaleInvalid&&'invalid',compact:iframed},GAS_SCALE&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Tip__["a" /* default */],{'data-slot':'tip',text:GAS_SCALE}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(WrapperSelect,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(LocationLabel,null,'Escal\xE3o'),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(StyledSelect,{margin:true,placeholder:'Escal\xE3o',items:gasScales,onChange:function onChange(_ref15){var value=_ref15.value;return setValues({gas_stage:value});},selected:gas_stage,arrowIcon:__WEBPACK_IMPORTED_MODULE_10__images_ic_arrow_svg___default.a}),this.renderInvalidMessage(gasScaleInvalid,'gas_scale','Escalão'))),__WEBPACK_IMPORTED_MODULE_21_config__["o" /* isSimple */]&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Section__["a" /* default */],{title:'Deseja introduzir os seus consumos?',subtitle:'',grey:true,compact:iframed},timeCycleChoices&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_ButtonConfirm__["a" /* default */],{onButtonClick:function onButtonClick(_ref16){var value=_ref16.value;setValues({has_consumes:value});if(value===true){_this2.nextText='PRÓXIMO passo';}else{_this2.nextText='Simular';}},value:has_consumes||false,items:__WEBPACK_IMPORTED_MODULE_21_config__["r" /* BOOLEAN_CHOICES */],compact:iframed}))),this.renderButtons());}}]);return Faturation;}(__WEBPACK_IMPORTED_MODULE_9_containers_Form__["a" /* default */]))||_class;var Wrapper=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject);var WrapperSelect=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject2);var StyledSelect=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_18_components_Select__["a" /* default */])(_templateObject3,function(_ref17){var margin=_ref17.margin;return margin&&'margin-right: 30px;';});var LocationLabel=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].label(_templateObject4);var AbsoluteToltip=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_16_components_Toltip__["a" /* default */])(_templateObject5);var Error=__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].span(_templateObject6);

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_kea__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_kea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_kea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_validations__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_pick__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_omit__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_mapKeys__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_mapKeys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_mapKeys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_containers_App_logic__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_containers_SimpleHabitation_logic__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);
/** Redux and Kea */var INVOICING_ENDPOINT=__WEBPACK_IMPORTED_MODULE_2_config__["j" /* API_SIMULATION_URL */]+'/public/simulator/invoicing/';var HIRED_POWER_ENDPOINT=__WEBPACK_IMPORTED_MODULE_2_config__["j" /* API_SIMULATION_URL */]+'/public/simulator/advanced_hired_power_suggestion/';if(__WEBPACK_IMPORTED_MODULE_2_config__["o" /* isSimple */]){HIRED_POWER_ENDPOINT=__WEBPACK_IMPORTED_MODULE_2_config__["j" /* API_SIMULATION_URL */]+'/public/simulator/simple_hired_power_suggestion/';}var fields={invoicing_type:[__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].isUndefined],has_electronic_billing:[__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].isUndefined],has_joint_billing:[__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].isUndefined],ciclo_horario:[__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].ignoreIf.isGas,__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].isUndefined],electricity_entity:[__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].ignoreIf.isGas,__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].isUndefined,__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].isNull],gas_entity:[__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].ignoreIf.isElectricity,__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].ignoreIf.hasJointBilling,__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].isUndefined,__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].isNull],potencia_contratada:[__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].ignoreIf.isGas,__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].isUndefined,__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].isNull]};if(__WEBPACK_IMPORTED_MODULE_2_config__["o" /* isSimple */]){fields.gas_stage=[__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].ignoreIf.isElectricity,__WEBPACK_IMPORTED_MODULE_7_validations__["a" /* Validations */].isUndefined];}var consumeDefaultValues={consumptionDisaggregation:'s',electricityConsumptionsRegistration:[{startDate:__WEBPACK_IMPORTED_MODULE_14_moment___default()().date(1).month(0).format('YYYY-MM-DD'),endDate:__WEBPACK_IMPORTED_MODULE_14_moment___default()().date(31).month(0).format('YYYY-MM-DD'),simples:'',svazio:'',cheias:'',ponta:''}],gasConsumptionsRegistration:[{startDate:__WEBPACK_IMPORTED_MODULE_14_moment___default()().date(1).month(0).format('YYYY-MM-DD'),endDate:__WEBPACK_IMPORTED_MODULE_14_moment___default()().date(31).month(0).format('YYYY-MM-DD'),consumption:''}]};var consumptionDisaggregations=[{id:'s',name:'Simples',text:'Simples',value:'s'},{id:'vf',name:'Vazio / Fora de vazio',text:'Vazio / Fora de vazio',value:'vf'},{id:'vcp',name:'Vazio /  Cheias / Ponta',text:'Vazio /  Cheias / Ponta',value:'vcp'},{id:'vscp',name:'Vazio / Super Vazio /  Cheias / Ponta',text:'Vazio / Super Vazio /  Cheias / Ponta',value:'vscp'}];/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_kea__["kea"])({path:function path(){return['scenes','faturation'];},connect:{actions:[__WEBPACK_IMPORTED_MODULE_11_containers_App_logic__["a" /* default */],['setValue','setValues','setFinished']],props:[__WEBPACK_IMPORTED_MODULE_11_containers_App_logic__["a" /* default */],['values','offerType','translations','iframed'],__WEBPACK_IMPORTED_MODULE_12_containers_SimpleHabitation_logic__["default"],['currentEquipments']]},actions:function actions(){return{fetchFilters:function fetchFilters(){return{};},setHiredPower:function setHiredPower(value){return{value:value};},fetchError:function fetchError(error){return{error:error};},fetchHiredPower:function fetchHiredPower(){return{};},setFilters:function setFilters(filters){return{filters:filters};},setInvalid:function setInvalid(invalid){return{invalid:invalid};},toggleConsumes:function toggleConsumes(){return{};}};},reducers:function reducers(_ref){var _ref5,_ref6;var actions=_ref.actions;return{filters:[{consumptionDisaggregations:consumptionDisaggregations},__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.setFilters,function(_,payload){return Object.assign({},_,payload.filters);})],hiredPowerSugested:[null,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.setHiredPower,function(_,payload){return payload.value;})],invalid:[{},__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.setInvalid,function(_,payload){return payload.invalid;})],loading:[true,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,(_ref5={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref5,actions.fetchFilters,function(){return true;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref5,actions.setFilters,function(){return false;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref5,actions.fetchError,function(){return false;}),_ref5)],fields:[fields,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,{}],error:[false,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,(_ref6={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref6,actions.fetchFilters,function(){return false;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref6,actions.setFilters,function(){return false;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref6,actions.fetchError,function(_,payload){return payload.error;}),_ref6)]};},takeLatest:function takeLatest(_ref7){var _ref8;var actions=_ref7.actions,workers=_ref7.workers;return _ref8={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref8,actions.fetchFilters,workers.fetchInvoiceFilters),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref8,actions.fetchHiredPower,workers.fetchHiredPower),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref8,actions.toggleConsumes,workers.toggleConsumes),_ref8;},start:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function start(){var _actions,fetchFilters,fetchHiredPower,offerType,_ref9,profileFinished,settings;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function start$(_context){while(1){switch(_context.prev=_context.next){case 0:_actions=this.actions,fetchFilters=_actions.fetchFilters,fetchHiredPower=_actions.fetchHiredPower;_context.next=3;return __WEBPACK_IMPORTED_MODULE_11_containers_App_logic__["a" /* default */].get('offerType');case 3:offerType=_context.sent;_context.next=6;return __WEBPACK_IMPORTED_MODULE_11_containers_App_logic__["a" /* default */].get('finished');case 6:_ref9=_context.sent;profileFinished=_ref9.profileFinished;_context.next=10;return __WEBPACK_IMPORTED_MODULE_11_containers_App_logic__["a" /* default */].get('settings');case 10:settings=_context.sent;if(profileFinished){_context.next=15;break;}this.props.router.push('/');_context.next=21;break;case 15:_context.next=17;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(fetchFilters());case 17:if(settings.isFromProfile){_context.next=21;break;}if(!(offerType.slug!==__WEBPACK_IMPORTED_MODULE_2_config__["l" /* GAS_OFFER_TYPE */]&&!__WEBPACK_IMPORTED_MODULE_2_config__["k" /* isEnterprise */])){_context.next=21;break;}_context.next=21;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(fetchHiredPower());case 21:case'end':return _context.stop();}}},start,this);}),workers:{toggleConsumes:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function toggleConsumes(){var setValues,values,_ref10,has_consumes,ciclo_horario,cleanValues;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function toggleConsumes$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:setValues=this.actions.setValues;_context2.next=3;return __WEBPACK_IMPORTED_MODULE_11_containers_App_logic__["a" /* default */].get('values');case 3:values=_context2.sent;_context2.next=6;return __WEBPACK_IMPORTED_MODULE_11_containers_App_logic__["a" /* default */].get('values');case 6:_ref10=_context2.sent;has_consumes=_ref10.has_consumes;ciclo_horario=_ref10.ciclo_horario;if(!(has_consumes==='s')){_context2.next=15;break;}if(ciclo_horario==='b'){consumeDefaultValues.consumptionDisaggregation='vf';}_context2.next=13;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setValues(consumeDefaultValues));case 13:_context2.next=18;break;case 15:cleanValues=__WEBPACK_IMPORTED_MODULE_9_lodash_omit___default()(values,['consumptionDisaggregation','electricityConsumptionsRegistration','gasConsumptionsRegistration']);_context2.next=18;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setValues(cleanValues));case 18:case'end':return _context2.stop();}}},toggleConsumes,this);}),/**
     * Fetches the data needed for the faturation step
     */fetchInvoiceFilters:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchInvoiceFilters(){var _actions2,setFilters,setValues,fetchError,values,settings,params,cleanData,response,data,defaultValues;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchInvoiceFilters$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_actions2=this.actions,setFilters=_actions2.setFilters,setValues=_actions2.setValues,fetchError=_actions2.fetchError;_context3.next=3;return __WEBPACK_IMPORTED_MODULE_11_containers_App_logic__["a" /* default */].get('values');case 3:values=_context3.sent;_context3.next=6;return __WEBPACK_IMPORTED_MODULE_11_containers_App_logic__["a" /* default */].get('settings');case 6:settings=_context3.sent;// Needed params for the Invoicing endpoint
params=__WEBPACK_IMPORTED_MODULE_8_lodash_pick___default()(values,['offer_type','municipality']);if(__WEBPACK_IMPORTED_MODULE_2_config__["k" /* isEnterprise */]){params['type']='e';}// Clean response data for frontend use
cleanData=function cleanData(data){return{electricityEntities:data.electricity_entities_serializer,gasEntities:data.gas_entities_serializer,allEntities:data.all_entities_serializer,powerChoices:data.power_choices,priceCycleChoices:data.price_list_cycle_choices,timeCycleChoices:data.time_cycle_choices,defaultValues:Object.assign({},data.default_values,values)||{}};};_context3.prev=10;_context3.next=13;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get,INVOICING_ENDPOINT,{params:params});case 13:response=_context3.sent;data=cleanData(response.data);data.timeCycleChoices&&delete data.timeCycleChoices['tetra-horário'];// Only show entities with Eletricidade and gas
// https://gitlab.ubiwhere.com/adene-poupa-energia/adene-simulador-avancado/issues/6
data.allEntities=data.allEntities.filter(function(_ref11){var offer_types=_ref11.offer_types;return offer_types.find(function(_ref12){var slug=_ref12.slug;return slug===__WEBPACK_IMPORTED_MODULE_2_config__["q" /* GAS_AND_ELECTRICITY_OFFER_TYPE */];})!==undefined;});// Replace . with , in powerchoices 😑
data.powerChoices=__WEBPACK_IMPORTED_MODULE_10_lodash_mapKeys___default()(data.powerChoices,function(value,key){return key.replace('.',',');});// Default values for this form
if(settings.isFromProfile){_context3.next=22;break;}defaultValues={invoicing_type:'atm_ctt',has_electronic_billing:true,has_joint_billing:false,ciclo_horario:data.defaultValues.time_cycle||'s',ciclo_tarifa:'w',electricity_entity:null,gas_entity:null,gas_stage:1// Set the data to make the component
};_context3.next=22;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setValues(Object.assign({},defaultValues,values)));case 22:_context3.next=24;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setFilters(data));case 24:_context3.next=30;break;case 26:_context3.prev=26;_context3.t0=_context3['catch'](10);_context3.next=30;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(fetchError(_context3.t0));case 30:case'end':return _context3.stop();}}},fetchInvoiceFilters,this,[[10,26]]);}),/**
     * Fetches the Sugested hired power
     */fetchHiredPower:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchHiredPower(){var _actions3,setValues,setHiredPower,values,currentEquipments,params,adults,children,elderly,response,data,potencia_sugerida;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchHiredPower$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_actions3=this.actions,setValues=_actions3.setValues,setHiredPower=_actions3.setHiredPower;_context4.next=3;return __WEBPACK_IMPORTED_MODULE_11_containers_App_logic__["a" /* default */].get('values');case 3:values=_context4.sent;_context4.next=6;return __WEBPACK_IMPORTED_MODULE_12_containers_SimpleHabitation_logic__["default"].get('currentEquipments');case 6:currentEquipments=_context4.sent;// Required parameters to the Hired Power endooint
params=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_utils__["a" /* csObjectToUnderscore */])(__WEBPACK_IMPORTED_MODULE_8_lodash_pick___default()(values,['simulationCode','municipality','constructionYear','equipmentUtilizationType','equipmentUtilizationProfile']// "equipments",
));// Sum all the habitants
adults=values.adults,children=values.children,elderly=values.elderly;params.habitants=adults+children+elderly||0;// Map equipments for the request (it's very diferent)
// params.equipment =
//   params.equipments &&
//   params.equipments.map(
//     ({ id, quantity, selectedClass, house_divisions }) => ({
//       equipment: id,
//       equipment_profile_consumption: selectedClass && selectedClass.id,
//       division: house_divisions,
//       quantity,
//     })
//   );
params.equipment=currentEquipments&&currentEquipments.map(function(_ref13){var data=_ref13.data;var id=data.id,quantity=data.quantity,selectedClass=data.selectedClass,house_divisions=data.house_divisions;return{equipment:id,equipment_profile_consumption:selectedClass&&selectedClass.id,division:house_divisions,quantity:quantity};});// Omit equipments name since API uses single name.
// params = omit(params, "equipments");
// Request and set values
_context4.prev=11;_context4.next=14;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_3_axios___default.a.post,HIRED_POWER_ENDPOINT,Object.assign({},params));case 14:response=_context4.sent;// POTENCIA SUGERIDA DEFAULT 10,35kVA
data=response.data;potencia_sugerida=data.potencia_sugerida;_context4.next=19;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setHiredPower(potencia_sugerida));case 19:_context4.next=21;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setValues({potencia_contratada:potencia_sugerida}));case 21:_context4.next=25;break;case 23:_context4.prev=23;_context4.t0=_context4['catch'](11);case 25:case'end':return _context4.stop();}}},fetchHiredPower,this,[[11,23]]);})}}));

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FeedbackStandalone; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_FeedbackContent__ = __webpack_require__(856);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  box-sizing: border-box;\n'],['\n  width: 100%;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  box-sizing: border-box;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  max-width: 800px;\n  height: 560px;\n  background: #fff;\n\n  @media (max-width: 999px) {\n    height: auto;\n  }\n'],['\n  width: 100%;\n  max-width: 800px;\n  height: 560px;\n  background: #fff;\n\n  @media (max-width: 999px) {\n    height: auto;\n  }\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-family: Nunito;\n  font-size: 18px;\n  font-weight: 700;\n  color: #1d1e22;\n  text-align: center;\n'],['\n  font-family: Nunito;\n  font-size: 18px;\n  font-weight: 700;\n  color: #1d1e22;\n  text-align: center;\n']);/**
 * Página isolada do inquérito de satisfação.
 *
 * Renderiza APENAS o conteúdo (FeedbackContent) — formulário + painel verde —
 * sem a moldura de modal, porque a ideia é este conteúdo ser colocado dentro
 * de uma modal do projeto pai (ex.: embebido num iframe como micro-serviço).
 *
 * Aqui, para efeitos de visualização/teste isolado, envolvemos o conteúdo numa
 * caixa centrada com dimensões semelhantes às da modal original. No projeto
 * pai é a modal desse projeto que define o contentor/dimensões.
 *
 * Montada através do id `adene-simulador-feedback` (ver index.js / index.html).
 * A FeedbackModalV2 mantém-se intacta para uso dentro desta aplicação.
 */var FeedbackStandalone=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FeedbackStandalone,_Component);function FeedbackStandalone(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,FeedbackStandalone);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=FeedbackStandalone.__proto__||Object.getPrototypeOf(FeedbackStandalone)).call.apply(_ref,[this].concat(args))),_this),_this.state={width:window.innerWidth,submitted:false},_this.handleResize=function(){_this.setState({width:window.innerWidth});},_this.handleSubmitted=function(){window.parent.postMessage({type:'submitted'},'*');_this.setState({submitted:true});},_temp),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(FeedbackStandalone,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('resize',this.handleResize);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.handleResize);}// A lógica de submissão chama onClose apenas após o POST ter sucesso.
// Sem botão Cancelar, isto corresponde exclusivamente a "submetido com sucesso":
// avisamos o projeto pai (para poder esconder a modal/iframe) e mostramos
// a confirmação.
},{key:'render',value:function render(){var _state=this.state,width=_state.width,submitted=_state.submitted;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Page,null,submitted?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ThankYou,null,'Obrigado pelo seu feedback.'):__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Box,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_FeedbackContent__["a" /* default */],{width:width,onClose:this.handleSubmitted})));}}]);return FeedbackStandalone;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);var Page=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject);var Box=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject2);var ThankYou=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].p(_templateObject3);

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__images_ic_contrato_faturacao_svg__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__images_ic_contrato_faturacao_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__images_ic_contrato_faturacao_svg__);
/* harmony default export */ __webpack_exports__["a"] = ([{name:'Contrato e Faturação',icon:__WEBPACK_IMPORTED_MODULE_0__images_ic_contrato_faturacao_svg___default.a,size:12,type:'multifull',dependsOn:'offer_type',filters:[{name:'Fidelização',fieldName:'no_contract_duration',values:[{label:'Qualquer',value:'any'},{label:'Sem Fidelização',value:true},{label:'Com Fidelização',value:'false'}]},{name:'Faturação',fieldName:'billing',checkboxed:true,removedSelectOnSelected:['any'],excludeAllExceptOnSelect:['any'],values:[{label:'Qualquer',value:'any'},{label:'Débito Direto (DD)',value:'dd'},{label:'MB / CTT / PayShop',value:'mb'},{label:'Fatura eletrónica (FE)',value:'fe'},{label:'Fatura em papel',value:'fp'},{label:'Contratação eletrónica (CE)',value:'ce'}]},{name:'Mais filtros',fieldName:'extra',checkboxed:true,values:[{label:'Energia Verde',value:'ge'},{label:'Sem Reembolsos',value:'hr'},{label:'Sem serviços adicionais (€)',value:'as'},{label:'Tarifa Regulada',value:'rg'},{label:'Mobilidade Eléctrica',value:'me'}]}]}]);

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Filters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logic__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_flexbox_grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_flexbox_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_flexbox_grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ubiwherenpm_adene_ui_components__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_ic_arrow_svg__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_ic_arrow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_ic_arrow_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_DualSelect__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Select__ = __webpack_require__(68);
var _class;var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 150px;\n  width: 100%;\n  position: relative;\n  top: -75px;\n  display: flex;\n  margin-bottom: -75px;\n'],['\n  height: 150px;\n  width: 100%;\n  position: relative;\n  top: -75px;\n  display: flex;\n  margin-bottom: -75px;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin: 0 !important;\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: auto;\n  height: 100%;\n'],['\n  margin: 0 !important;\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: auto;\n  height: 100%;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n  height: 100%;\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: auto;\n'],['\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n  height: 100%;\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: auto;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  text-align: center;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-right: 1px solid #efefef;\n  text-transform: uppercase;\n  flex: 1;\n'],['\n  text-align: center;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-right: 1px solid #efefef;\n  text-transform: uppercase;\n  flex: 1;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding: 0 !important;\n  flex-direction: column;\n\n  ','\n'],['\n  padding: 0 !important;\n  flex-direction: column;\n\n  ','\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 1;\n  text-align: left;\n  max-width: initial;\n  > div:first-child {\n    height: 100%;\n    border-bottom: 0;\n    border-right: 0;\n  }\n'],['\n  flex: 1;\n  text-align: left;\n  max-width: initial;\n  > div:first-child {\n    height: 100%;\n    border-bottom: 0;\n    border-right: 0;\n  }\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: row;\n  height: calc(100% - 48px);\n'],['\n  display: flex;\n  flex-direction: row;\n  height: calc(100% - 48px);\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 8px;\n'],['\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 8px;\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  height: calc(100% - 48px);\n'],['\n  display: flex;\n  flex-direction: column;\n  height: calc(100% - 48px);\n']);/** UI */var gasFilters=['price_step','municipality'];var eletricityFilters=['potencia_contratada','ciclo_horario'];var GAS_OFFER_TYPE=3;var ELECTRICTY_OFFER_TYPE=2;var Filters=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__logic__["a" /* default */])(_class=function(_Component){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Filters,_Component);function Filters(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,Filters);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=Filters.__proto__||Object.getPrototypeOf(Filters)).call.apply(_ref,[this].concat(args))),_this),_this.isFilterDisabled=function(_ref2){var dependsOn=_ref2.dependsOn,dependsMostBe=_ref2.dependsMostBe;return false;},_this.checkIfFlowIsFinished=function(){// if (filters.offer_type === undefined) {
//   return false
// }
// let neededFilters = ['no_contract_duration', 'billing']
// if (filters.offer_type === EG_OFFER_TYPE) {
//   neededFilters = [...neededFilters, ...eletricityFilters, ...gasFilters]
// }
// if (filters.offer_type === ELECTRICTY_OFFER_TYPE) {
//   neededFilters = [...neededFilters, ...eletricityFilters]
// }
// if (filters.offer_type === GAS_OFFER_TYPE) {
//   neededFilters = [...neededFilters, ...gasFilters]
// }
// for (var index = 0; index < neededFilters.length; index++) {
//   var filter = neededFilters[index]
//   if (filters[filter] === undefined) {
//     return false
//   }
// }
return true;},_this.setFilterAndCheckIfFinishFlow=function(selected,item){// Remove filters if needed
var filtersToRemove=[];if(item.fieldName==='offer_type'){if(selected.value===ELECTRICTY_OFFER_TYPE){filtersToRemove=[].concat(gasFilters);}if(selected.value===GAS_OFFER_TYPE){filtersToRemove=[].concat(eletricityFilters);}if(filtersToRemove.length){_this.actions.removeFilters(filtersToRemove);}}_this.actions.setFilter(selected,item);// Wait for redux to finsh doing stuff
setTimeout(function(){var isFlowFinished=_this.checkIfFlowIsFinished();// Trigger fetching
if(isFlowFinished){_this.actions.triggerFilter();}},0);},_this.renderSelects=function(_ref3){var type=_ref3.type,filters=_ref3.filters,disabled=_ref3.disabled;var WrapperSelect=SelectsContainer;if(type==='multifull'){WrapperSelect=MultiFullSelect;}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WrapperSelect,null,filters&&filters.map(function(_ref4){var name=_ref4.name,values=_ref4.values,async=_ref4.async,checkboxed=_ref4.checkboxed,item=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref4,['name','values','async','checkboxed']);var items=values;var action=void 0;if(async){items=_this.props[async.prop];action=_this.actions[async.action];}// Easier fix for https://gitlab.ubiwhere.com/adene-poupa-energia/adene-simulador-avancado/issues/32 #3
var selected=_this.props.filters[item.fieldName];if(item.fieldName==='no_contract_duration'){if(selected==='any'){selected=undefined;}}return name==='Localização'?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_DualSelect__["a" /* default */],{key:name,placeholder:name,items:items,action:action,arrowIcon:__WEBPACK_IMPORTED_MODULE_12__images_ic_arrow_svg___default.a,onChange:function onChange(selected){return _this.setFilterAndCheckIfFinishFlow(selected,item);},selected:_this.props.filters[item.fieldName],disabled:disabled,checkboxed:checkboxed,removedSelectOnSelected:item.removedSelectOnSelected}):__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(FullSelect,{key:name,placeholder:name,items:items,action:action,arrowIcon:__WEBPACK_IMPORTED_MODULE_12__images_ic_arrow_svg___default.a,onChange:function onChange(selected){return _this.setFilterAndCheckIfFinishFlow(selected,item);},selected:selected,disabled:disabled,checkboxed:checkboxed,removedSelectOnSelected:item.removedSelectOnSelected,excludeAllExceptOnSelect:item.excludeAllExceptOnSelect});}));},_this.renderFilters=function(){return __WEBPACK_IMPORTED_MODULE_9__data__["a" /* default */]&&__WEBPACK_IMPORTED_MODULE_9__data__["a" /* default */].map(function(_ref5){var name=_ref5.name,size=_ref5.size,icon=_ref5.icon,hidden=_ref5.hidden,rest=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref5,['name','size','icon','hidden']);var disabled=_this.isFilterDisabled(Object.assign({},rest));if(hidden){return null;}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Column,{md:size,key:name,disabled:disabled},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Box,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Icon,{src:icon}),name),_this.renderSelects(Object.assign({},rest,{disabled:disabled})));});},_temp),__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}/**
   * Verifies if the filter is currently disabled
   * Based on the field it is dependent on.
   *//**
   * Checks if user selected all the needed filters
   * to procced with the fetching
   *//**
   * Adds the new filter to the state
   *//**
   * Renders all the selects based on they type
   *//**
   * Renders the filters boxes based on the json data
   */__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Filters,[{key:'render',/** Lonely boy */value:function render(){var renderClose=this.props.renderClose;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Container,{fluid:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(FiltersList,null,this.renderFilters(),renderClose())));}}]);return Filters;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]))||_class;var Wrapper=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_11__ubiwherenpm_adene_ui_components__["d" /* ShadowBox */])(_templateObject);var FiltersList=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_10_react_flexbox_grid__["Row"])(_templateObject2);var Container=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_10_react_flexbox_grid__["Grid"])(_templateObject3);var Box=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_10_react_flexbox_grid__["Col"])(_templateObject4);var Column=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_10_react_flexbox_grid__["Col"])(_templateObject5,function(props){return props.disabled&&'\n    opacity: .4;\n    pointer-events: none;\n  ';});var FullSelect=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_14_components_Select__["a" /* default */])(_templateObject6);var MultiFullSelect=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject7);var Icon=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].img(_templateObject8);var SelectsContainer=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject9);

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{name:'Tipo de Tarifário',hidden:false,filterSection:'tariff_type',type:'radio',filters:[{label:'Todos',fieldName:'price_list_time_cycle',value:'all'},{label:'Simples',fieldName:'price_list_time_cycle',value:'s'},{label:'Bi-horário',fieldName:'price_list_time_cycle',value:'b'},{label:'Tri-horário',fieldName:'price_list_time_cycle',value:'t'}]},{name:'Ofertas Comerciais',hidden:false,filterSection:'comercial_offer',type:'checkbox',filters:[{label:'Condicionadas',fieldName:'has_additional_restrictions',value:false},{label:'Com Fidelização',fieldName:'contract_duration',value:false},{label:'Preços Indexados',fieldName:'indexed_prices',value:false},{label:'Tarifários Regulados',fieldName:'is_regulated',value:false},{label:'Para Novos Clientes',fieldName:'has_refunds_nc',value:false},{label:'Outros Reembolsos/Descontos',fieldName:'has_refunds',value:false},{label:'Só Energia 100% renovável',fieldName:'green_energy',value:false}]},{name:'Tipo de Fatura',hidden:false,filterSection:'billing',type:'radio',removedSelectOnSelected:['any'],excludeAllExceptOnSelect:['any'],filters:[{label:'Todos',fieldName:'any_billing',value:false},{label:'Eletrónica',fieldName:'electronic_billing',value:false},{label:'Em papel',fieldName:'paper_billing',value:false}]},{name:'Método de Pagamento',hidden:false,filterSection:'payment_method',type:'radio',filters:[{label:'Todos',fieldName:'any_payment',value:false},{label:'Débito Direto',fieldName:'direct_debit',value:false},{label:'Multibanco, Payshop, CTT',fieldName:'atm_ctt',value:false}]},{name:'Comercializadores',hidden:false,filterSection:'entities',type:'checkbox',search:true,fillFromApi:true,filters:[]}]);

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormV2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Loading__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Error__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_validations__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_mapValues__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_isFunction__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_first__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_first___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_first__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_last__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_isEmpty__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_isObject__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_isEqual__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_config__ = __webpack_require__(10);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 24px 20px;\n  justify-content: flex-end;\n  align-items: flex-start;\n  gap: 10px;\n  align-self: stretch;\n  max-width: 1200px;\n  margin-inline: auto;\n\n  @media screen and (min-width: 1300px) {\n    padding-inline: 0px;\n  }\n'],['\n  display: flex;\n  padding: 24px 20px;\n  justify-content: flex-end;\n  align-items: flex-start;\n  gap: 10px;\n  align-self: stretch;\n  max-width: 1200px;\n  margin-inline: auto;\n\n  @media screen and (min-width: 1300px) {\n    padding-inline: 0px;\n  }\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 180px;\n  height: 48px;\n  padding: 12px;\n  gap: 8px;\n  background: ',';\n  border: none;\n  outline: none;\n\n  color: #fff;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: \'Nunito\', \'Helvetica Neue\', sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n\n  transition: all 0.3s ease-in-out;\n  border-radius: 0px;\n  cursor: pointer;\n\n  > strong {\n    margin: 0 10px;\n  }\n\n  &:hover {\n    color: #ffffff;\n    background: linear-gradient(\n        0deg,\n        rgba(0, 0, 0, 0.2) 0%,\n        rgba(0, 0, 0, 0.2) 100%\n      ),\n      linear-gradient(270deg, #006736 -58.87%, #93c13e 100%);\n  }\n'],['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 180px;\n  height: 48px;\n  padding: 12px;\n  gap: 8px;\n  background: ',';\n  border: none;\n  outline: none;\n\n  color: #fff;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: \'Nunito\', \'Helvetica Neue\', sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n\n  transition: all 0.3s ease-in-out;\n  border-radius: 0px;\n  cursor: pointer;\n\n  > strong {\n    margin: 0 10px;\n  }\n\n  &:hover {\n    color: #ffffff;\n    background: linear-gradient(\n        0deg,\n        rgba(0, 0, 0, 0.2) 0%,\n        rgba(0, 0, 0, 0.2) 100%\n      ),\n      linear-gradient(270deg, #006736 -58.87%, #93c13e 100%);\n  }\n']);var FormV2=function(_Component){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(FormV2,_Component);function FormV2(){__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,FormV2);return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(FormV2.__proto__||Object.getPrototypeOf(FormV2)).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(FormV2,[{key:'isFormValid',/**
   * Validates form fields based on flowfields sent
   * by props
   */value:function isFormValid(){var _props=this.props,values=_props.values,fields=_props.fields;var invalid={};__WEBPACK_IMPORTED_MODULE_11_lodash_mapValues___default()(fields,function(validations,key){var multiple=key.indexOf(',')!==-1;var fields=[values[key]];// Multiple params validation
if(multiple){var valueNames=key.split(',');fields=valueNames.map(function(name){return values[name];});}var validatorNameInAsValues=false;var shouldDoTheRest=true;var firstValidation=__WEBPACK_IMPORTED_MODULE_13_lodash_first___default()(validations);__WEBPACK_IMPORTED_MODULE_11_lodash_mapValues___default()(values,function(value,valKey){if(firstValidation===valKey){validatorNameInAsValues=__WEBPACK_IMPORTED_MODULE_10_validations__["c" /* default */][firstValidation];}});// Only passs if value in Values
if(validatorNameInAsValues!==false){if(!validatorNameInAsValues(values)){shouldDoTheRest=false;}else{validations.shift();}}// Ignore all if validation matches
if(firstValidation&&firstValidation.indexOf('ignoreIf')!==-1){var validation=__WEBPACK_IMPORTED_MODULE_14_lodash_last___default()(firstValidation.split('.'));if(__WEBPACK_IMPORTED_MODULE_10_validations__["c" /* default */][validation](values)){shouldDoTheRest=false;}}if(shouldDoTheRest){for(var index=0;index<validations.length;index++){var _validation=validations[index];var validator=__WEBPACK_IMPORTED_MODULE_10_validations__["c" /* default */][_validation];if(__WEBPACK_IMPORTED_MODULE_12_lodash_isFunction___default()(validator)){var validationResult=validator.apply(undefined,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(fields).concat([values]));if(__WEBPACK_IMPORTED_MODULE_16_lodash_isObject___default()(validationResult)){if(validationResult.flag){invalid[key]=validationResult;break;}}else{if(validationResult){invalid[key]=_validation;break;}}}}}});return{valid:__WEBPACK_IMPORTED_MODULE_15_lodash_isEmpty___default()(invalid),invalid:invalid};}/**
   * Stuff to do on first mount
   */},{key:'componentDidMount',value:function componentDidMount(){}// // Scrols to top on component mount
// setTimeout(() => {
//   const element = document.getElementById('anchor')
//   if (element) {
//     element.scroll({ top: 0, behavior: 'smooth' })
//   }
// }, 100)
/**
   * Refresh invalids
   */},{key:'componentDidUpdate',value:function componentDidUpdate(){var currentInvalid=this.props.invalid;var setInvalid=this.actions.setInvalid;// Update invalids on changes
if(!__WEBPACK_IMPORTED_MODULE_15_lodash_isEmpty___default()(currentInvalid)){var _isFormValid=this.isFormValid(),valid=_isFormValid.valid,invalid=_isFormValid.invalid;if(!__WEBPACK_IMPORTED_MODULE_17_lodash_isEqual___default()(currentInvalid,invalid)){if(valid){setInvalid({});}else{setInvalid(invalid);}}}}/**
   * Renders the top info
   */},{key:'renderTop',value:function renderTop(){var _props2=this.props,loading=_props2.loading,error=_props2.error;if(loading){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Loading__["a" /* default */],null);}if(error){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Error__["a" /* default */],null);}}/**
   * Renders the buttons
   */},{key:'renderSubmitButton',value:function renderSubmitButton(){var _this2=this;var isLoading=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ButtonWrapper,{id:'buttons-simulator'},this.submit&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledButton,{bgNormalColor:__WEBPACK_IMPORTED_MODULE_18_config__["c" /* backgroundColors */].normalLeft,arrowRight:true,disabled:isLoading,right:true,strokeColor:'#FFFFFF',onClick:function onClick(){if(!isLoading){_this2.submit();}}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('strong',null,this.state.nextText)));}}]);return FormV2;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);var ButtonWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject);var StyledButton=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].button(_templateObject2,function(_ref){var bgNormalColor=_ref.bgNormalColor;return bgNormalColor;});

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Habitation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__logic__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_containers_Form__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_containers_SolarSistem__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_containers_CentralHeating__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_containers_Equipments__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Loading__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Error__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_FixedWrapper__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_config__ = __webpack_require__(10);
var _class;var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  min-height: calc(100% - 60px);\n  flex-direction: column;\n  display: flex;\n  flex: 1;\n'],['\n  min-height: calc(100% - 60px);\n  flex-direction: column;\n  display: flex;\n  flex: 1;\n']);var Habitation=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__logic__["default"])(_class=function(_Form){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Habitation,_Form);function Habitation(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,Habitation);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=Habitation.__proto__||Object.getPrototypeOf(Habitation)).call.apply(_ref,[this].concat(args))),_this),_this.nextText='PR\xD3XIMO passo',_this.prevText='Passo Anterior',_this.sendHeight=function(){var height=document.body.scrollHeight;window.parent.postMessage({type:'setHeight',height:height},'*');},_this.next=function(){window.parent.postMessage({type:'scrollToTop'},'*');var _this$isFormValid=_this.isFormValid(),valid=_this$isFormValid.valid,invalid=_this$isFormValid.invalid;var _this$actions=_this.actions,setInvalid=_this$actions.setInvalid,setFinished=_this$actions.setFinished;var router=_this.props.router;if(valid){setFinished({habitationFinished:true});router.push('/faturacao');}else{setFinished({habitationFinished:false});setInvalid(invalid);}},_this.prev=function(){var router=_this.props.router;window.parent.postMessage({type:'scrollToTop'},'*');router.push('/');},_temp),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Habitation,[{key:'componentDidMount',value:function componentDidMount(){// Scrols to top on component mount
var element=document.getElementById('anchor');window.scroll({top:element.getBoundingClientRect().top});}},{key:'componentDidUpdate',value:function componentDidUpdate(oldProps){if(oldProps.loading&&!this.props.loading){var element=document.getElementById('anchor');window.scroll({top:element.getBoundingClientRect().top});}this.sendHeight();window.addEventListener('resize',this.sendHeight);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.sendHeight);}},{key:'render',value:function render(){var setValues=this.actions.setValues;var _props=this.props,loading=_props.loading,error=_props.error,firstDivision=_props.firstDivision,translations=_props.translations;var _props$data=this.props.data,solarSystemYears=_props$data.solarSystemYears,offerTypes=_props$data.offerTypes,centralHeatingEquipments=_props$data.centralHeatingEquipments,divisions=_props$data.divisions,equipments=_props$data.equipments,energyClasses=_props$data.energyClasses;var _props$values=this.props.values,hasSolarSystem=_props$values.hasSolarSystem,hasSolarSystemYear=_props$values.hasSolarSystemYear,hasCentralAirConditioning=_props$values.hasCentralAirConditioning,centralHeatingOfferType=_props$values.centralHeatingOfferType,centralAirConditioningEquipment=_props$values.centralAirConditioningEquipment,centralAirConditioningEnergyClass=_props$values.centralAirConditioningEnergyClass;var equipmentsProps={divisions:divisions,equipments:equipments,firstDivision:firstDivision,energyClasses:energyClasses};if(error){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Error__["a" /* default */],null);}if(loading){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Loading__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Wrapper,null,this.renderNavbar(),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_FixedWrapper__["a" /* default */],null,false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_containers_SolarSistem__["a" /* default */],{items:__WEBPACK_IMPORTED_MODULE_15_config__["r" /* BOOLEAN_CHOICES */],years:solarSystemYears,value:hasSolarSystem||false,year:hasSolarSystemYear,onSelectionChange:function onSelectionChange(v){return setValues(v);},translations:translations}),offerTypes&&centralHeatingEquipments&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_containers_CentralHeating__["a" /* default */],{items:__WEBPACK_IMPORTED_MODULE_15_config__["r" /* BOOLEAN_CHOICES */],option:hasCentralAirConditioning||false,offerTypes:offerTypes,offerType:centralHeatingOfferType,equipments:centralHeatingEquipments,equipment:centralAirConditioningEquipment,equipmentEnergyClass:centralAirConditioningEnergyClass,onSelectionChange:function onSelectionChange(v){return setValues(v);},translations:translations}),equipments&&divisions&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_containers_Equipments__["a" /* default */],equipmentsProps)),this.renderButtons());}}]);return Habitation;}(__WEBPACK_IMPORTED_MODULE_8_containers_Form__["a" /* default */]))||_class;var Wrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject);

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return HomeWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__logic__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_containers_TariffSubscribeModal__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_ModalExtended__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_TariffDetails__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Loading__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils__ = __webpack_require__(11);
var _class;var HomeWrapper=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__logic__["a" /* default */])(_class=function(_Component){__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(HomeWrapper,_Component);function HomeWrapper(){__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this,HomeWrapper);var _this=__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this,(HomeWrapper.__proto__||Object.getPrototypeOf(HomeWrapper)).call(this));_this.state={moreOpen:false,adhesionOpen:false,adhesionTariff:null,priceListTimeCycle:null/** Detail modal buttons */};_this.detailsButtons=[{label:'fechar',color:'#006736',primary:false,click:function click(){return _this.toggleMoreModal(null);}},{label:'aderir',primary:true,click:function click(){return _this.switchToAdhere();}}];_this.switchToAdhere=function(){_this.setState({moreOpen:false,detailsTariff:null,adhesionOpen:true});};_this.toggleMoreModal=function(tariff){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_utils__["e" /* sendGevent */])('home','Saber mais','Saber mais sobre um tarifário');tariff&&_this.actions.fetchTariffInfo(tariff.id);var tariffPriceListTimeCycle=tariff&&tariff.priceListTimeCycle;_this.setState({moreOpen:!_this.state.moreOpen,detailsTariff:tariff,adhesionTariff:tariff,priceListTimeCycle:tariffPriceListTimeCycle||null});};_this.toggleAdhereModal=function(tariff){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_utils__["e" /* sendGevent */])('home','Intenção Aderir','Intenção de aderir a um tarifário');_this.setState({adhesionTariff:tariff,adhesionOpen:!_this.state.adhesionOpen});};window.addEventListener('tarifadhere',function(e){_this.toggleAdhereModal(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_utils__["c" /* csObjectFromUnderscore */])(e.detail));});window.addEventListener('tarifinfo',function(e){_this.toggleMoreModal(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_utils__["c" /* csObjectFromUnderscore */])(e.detail));});return _this;}/**
   * Opens/Closes KnowMore modal
   *//**
   * Opens/Closes aderir modal
   */__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(HomeWrapper,[{key:'render',value:function render(){var _props=this.props,loading=_props.loading,simulation=_props.simulation,tariffInfo=_props.tariffInfo,userProfile=_props.userProfile;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,this.state.detailsTariff&&this.state.moreOpen&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_ModalExtended__["a" /* default */],{title:'detalhes do tarif\xE1rio',toggle:this.state.moreOpen,onClick:this.toggleMoreModal,custom:false,buttons:this.detailsButtons},!loading&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_TariffDetails__["a" /* default */],{tariff:tariffInfo,resultTariff:this.state.detailsTariff,priceListTimeCycle:this.state.priceListTimeCycle}),loading&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Loading__["a" /* default */],null)),this.state.adhesionTariff&&this.state.adhesionOpen&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_containers_TariffSubscribeModal__["a" /* default */],{userProfile:userProfile,tariff:this.state.adhesionTariff,changeTariff:this.toggleAdhereModal,simulation:simulation,isHome:true}));}}]);return HomeWrapper;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]))||_class;

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_kea__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_kea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_kea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_containers_App_logic__ = __webpack_require__(42);
// import TariffSubscribeModal from 'containers/TariffSubscribeModal/logic'
var PRICELIST_ENDPOINT=__WEBPACK_IMPORTED_MODULE_2_config__["b" /* API_BASE_URL */]+'/public/price-list';var MARKET_SEGMENT_ENDPOINT=__WEBPACK_IMPORTED_MODULE_2_config__["b" /* API_BASE_URL */]+'/public/market-segment';/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_kea__["kea"])({connect:{props:[__WEBPACK_IMPORTED_MODULE_7_containers_App_logic__["a" /* default */],['translations']]},actions:function actions(){return{fetchTariffInfo:function fetchTariffInfo(id){return{id:id};},setTariffInfo:function setTariffInfo(tariffInfo){return{tariffInfo:tariffInfo};},setFetchError:function setFetchError(message){return{message:message};}};},reducers:function reducers(_ref){var _ref3;var actions=_ref.actions;return{tariffInfo:[null,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.setTariffInfo,function(_,payload){return payload.tariffInfo;})],loading:[true,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,(_ref3={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3,actions.fetchTariffInfo,function(){return true;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3,actions.setTariffInfo,function(){return false;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3,actions.setFetchError,function(){return false;}),_ref3)]};},takeLatest:function takeLatest(_ref4){var actions=_ref4.actions,workers=_ref4.workers;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.fetchTariffInfo,workers.fetchTariffInfo);},workers:{fetchTariffInfo:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchTariffInfo(action){var id,_actions,setTariffInfo,setFetchError,info,data,marketSegmentsList,marketSegmentsData,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,_id,singleMs;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchTariffInfo$(_context){while(1){switch(_context.prev=_context.next){case 0:id=action.payload.id;_actions=this.actions,setTariffInfo=_actions.setTariffInfo,setFetchError=_actions.setFetchError;if(!id){_context.next=47;break;}_context.prev=3;_context.next=6;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get,PRICELIST_ENDPOINT+'/'+id+'/');case 6:info=_context.sent;data=info.data;marketSegmentsList=data.pricelistadditionalinfo.market_segment_type||[];marketSegmentsData=[];_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context.prev=13;_iterator=marketSegmentsList[Symbol.iterator]();case 15:if(_iteratorNormalCompletion=(_step=_iterator.next()).done){_context.next=24;break;}_id=_step.value;_context.next=19;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get,MARKET_SEGMENT_ENDPOINT+'/'+_id+'/');case 19:singleMs=_context.sent;marketSegmentsData.push(singleMs.data);case 21:_iteratorNormalCompletion=true;_context.next=15;break;case 24:_context.next=30;break;case 26:_context.prev=26;_context.t0=_context['catch'](13);_didIteratorError=true;_iteratorError=_context.t0;case 30:_context.prev=30;_context.prev=31;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 33:_context.prev=33;if(!_didIteratorError){_context.next=36;break;}throw _iteratorError;case 36:return _context.finish(33);case 37:return _context.finish(30);case 38:data.pricelistadditionalinfo.market_segment_type=marketSegmentsData.map(function(_ref6){var name=_ref6.name;return name;}).join(', ');_context.next=41;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setTariffInfo(info.data));case 41:_context.next=47;break;case 43:_context.prev=43;_context.t1=_context['catch'](3);_context.next=47;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setFetchError(_context.t1));case 47:case'end':return _context.stop();}}},fetchTariffInfo,this,[[3,43],[13,26,30,38],[31,,33,37]]);})}}));

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavBar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_kea__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_kea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_kea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_containers_App_logic__ = __webpack_require__(42);
var _dec,_class;var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  display: flex;\n  flex: 1;\n  margin: 0 auto;\n  background-color: #bababa;\n  max-height: 60px;\n  z-index: 55;\n'],['\n  width: 100%;\n  display: flex;\n  flex: 1;\n  margin: 0 auto;\n  background-color: #bababa;\n  max-height: 60px;\n  z-index: 55;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: inline-block;\n  text-align: center;\n  border-right: 1px solid #fff;\n  border-left: 1px solid #fff;\n  height: 60px;\n  font-size: 16px;\n  font-weight: bold;\n  color: #fff;\n  line-height: 60px;\n  text-decoration: none;\n  cursor: pointer;\n  flex: 1;\n  box-sizing: border-box;\n\n  &.finished {\n    background: #676767;\n  }\n\n  &.current {\n    background: ',';\n  }\n\n  &:first-child {\n    border-left: 0;\n  }\n\n  &:last-child {\n    border: 0;\n  }\n\n  @media screen and (max-width: 568px) {\n    line-height: initial;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    flex-direction: column;\n    padding-top: 10px;\n  }\n\n  ','\n'],['\n  display: inline-block;\n  text-align: center;\n  border-right: 1px solid #fff;\n  border-left: 1px solid #fff;\n  height: 60px;\n  font-size: 16px;\n  font-weight: bold;\n  color: #fff;\n  line-height: 60px;\n  text-decoration: none;\n  cursor: pointer;\n  flex: 1;\n  box-sizing: border-box;\n\n  &.finished {\n    background: #676767;\n  }\n\n  &.current {\n    background: ',';\n  }\n\n  &:first-child {\n    border-left: 0;\n  }\n\n  &:last-child {\n    border: 0;\n  }\n\n  @media screen and (max-width: 568px) {\n    line-height: initial;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    flex-direction: column;\n    padding-top: 10px;\n  }\n\n  ','\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: inline-block;\n  text-align: center;\n  border-right: 1px solid #fff;\n  border-left: 1px solid #fff;\n  height: 60px;\n  font-size: 16px;\n  font-weight: bold;\n  color: #fff;\n  line-height: 60px;\n  text-decoration: none;\n  cursor: pointer;\n  flex: 1;\n  box-sizing: border-box;\n\n  &.finished {\n    background: #676767;\n  }\n\n  &.current {\n    background: ',';\n  }\n\n  &:first-child {\n    border-left: 0;\n  }\n\n  &:last-child {\n    border: 0;\n  }\n\n  @media screen and (max-width: 568px) {\n    line-height: initial;\n    display: flex;\n    justify-content: flex-start;\n    flex-direction: column;\n    padding-top: 10px;\n  }\n'],['\n  display: inline-block;\n  text-align: center;\n  border-right: 1px solid #fff;\n  border-left: 1px solid #fff;\n  height: 60px;\n  font-size: 16px;\n  font-weight: bold;\n  color: #fff;\n  line-height: 60px;\n  text-decoration: none;\n  cursor: pointer;\n  flex: 1;\n  box-sizing: border-box;\n\n  &.finished {\n    background: #676767;\n  }\n\n  &.current {\n    background: ',';\n  }\n\n  &:first-child {\n    border-left: 0;\n  }\n\n  &:last-child {\n    border: 0;\n  }\n\n  @media screen and (max-width: 568px) {\n    line-height: initial;\n    display: flex;\n    justify-content: flex-start;\n    flex-direction: column;\n    padding-top: 10px;\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  @media screen and (max-width: 568px) {\n    display: block;\n    font-size: 8px;\n  }\n'],['\n  @media screen and (max-width: 568px) {\n    display: block;\n    font-size: 8px;\n  }\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()([''],['']);var NavBar=(_dec=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_kea__["kea"])({connect:{props:[__WEBPACK_IMPORTED_MODULE_10_containers_App_logic__["a" /* default */],['finished','values']]}}),_dec(_class=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavBar,_Component);function NavBar(){__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,NavBar);return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(NavBar.__proto__||Object.getPrototypeOf(NavBar)).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(NavBar,[{key:'render',value:function render(){var _props=this.props,router=_props.router,id=_props.id;var _props$router$getCurr=this.props.router.getCurrentLocation(),pathname=_props$router$getCurr.pathname;var pathContains=function pathContains(v){return pathname.indexOf(v)!==-1;};var _props$finished=this.props.finished,profileFinished=_props$finished.profileFinished,habitationFinished=_props$finished.habitationFinished,faturationFinished=_props$finished.faturationFinished,consumeFinished=_props$finished.consumeFinished;var has_consumes=this.props.values.has_consumes;var classNames=function classNames(current,finished){var classes='';if(current==='/'){if(pathname==='/'){classes+='current';}}else{if(pathContains(current)){classes+='current';}}if(finished){classes+=' finished';}return classes;};return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Wrapper,{id:id},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ItemNoLink,{onClick:function onClick(){return router.push('/#/');},className:classNames('/',profileFinished)},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Number,null,'1.\xA0'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Text,null,'Perfil ',__WEBPACK_IMPORTED_MODULE_5_config__["k" /* isEnterprise */]?'da Empresa':'do Consumidor')),(__WEBPACK_IMPORTED_MODULE_5_config__["p" /* isAdvanced */]||__WEBPACK_IMPORTED_MODULE_5_config__["o" /* isSimple */])&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Item,{to:'/habitacao',className:classNames('habitacao',habitationFinished),disabled:!profileFinished},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Number,null,'2.\xA0'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Text,null,'Minha Habita\xE7\xE3o')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Item,{to:'/faturacao',className:classNames('faturacao',faturationFinished),disabled:!habitationFinished&&!profileFinished},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Number,null,__WEBPACK_IMPORTED_MODULE_5_config__["k" /* isEnterprise */]?'2':'3','.\xA0'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Text,null,'Fatura\xE7\xE3o e Fornecedores')),(__WEBPACK_IMPORTED_MODULE_5_config__["p" /* isAdvanced */]||has_consumes===true)&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Item,{to:'/consumos',className:classNames('consumos',consumeFinished),disabled:!habitationFinished&&!profileFinished&&!faturationFinished},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Number,null,'4.\xA0'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Text,null,'Consumos')),__WEBPACK_IMPORTED_MODULE_5_config__["k" /* isEnterprise */]&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Item,{to:'/consumos',className:classNames('consumos',consumeFinished),disabled:!profileFinished&&!faturationFinished},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Number,null,'3.\xA0'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Text,null,'Consumos')));}}]);return NavBar;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]))||_class);var Wrapper=__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div(_templateObject);var Item=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_7_react_router__["Link"])(_templateObject2,__WEBPACK_IMPORTED_MODULE_5_config__["c" /* backgroundColors */].normalLeft,function(_ref){var disabled=_ref.disabled;return disabled&&'\n    pointer-events: none;\n    opacity: 0.7;\n  ';});var ItemNoLink=__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div(_templateObject3,__WEBPACK_IMPORTED_MODULE_5_config__["c" /* backgroundColors */].normalLeft);var Text=__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].span(_templateObject4);var Number=__WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].span(_templateObject5);

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Profile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logic__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_ic_arrow_svg__ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_ic_arrow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_ic_arrow_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_idoso_component_svg__ = __webpack_require__(1665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_idoso_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_idoso_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_adulto_component_svg__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_adulto_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_adulto_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_crianca_component_svg__ = __webpack_require__(1659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_crianca_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__images_crianca_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_ic_mobilidade_component_svg__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_ic_mobilidade_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_ic_mobilidade_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_ic_sem_acao_component_svg__ = __webpack_require__(1664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_ic_sem_acao_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__images_ic_sem_acao_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_containers_Form__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_Label__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_Counter__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_Section__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_ButtonRadio__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_RadioGroup__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_UseType__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_Loading__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_Select__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_components_FixedWrapper__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_Tip__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_validations__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_lodash_uniqBy__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_lodash_uniqBy__);
var _class;var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()([''],['']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  margin: 40px 0;\n  height: 1px;\n  background: #dedede;\n'],['\n  width: 100%;\n  margin: 40px 0;\n  height: 1px;\n  background: #dedede;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  line-height: 12px;\n  font-size: 12px;\n  -webkit-letter-spacing: 1px;\n  -moz-letter-spacing: 1px;\n  -ms-letter-spacing: 1px;\n  letter-spacing: 1px;\n  color: #010101;\n  text-transform: uppercase;\n  font-weight: normal;\n  text-align: center;\n  margin: 0;\n  font-size: 100;\n  position: relative;\n'],['\n  line-height: 12px;\n  font-size: 12px;\n  -webkit-letter-spacing: 1px;\n  -moz-letter-spacing: 1px;\n  -ms-letter-spacing: 1px;\n  letter-spacing: 1px;\n  color: #010101;\n  text-transform: uppercase;\n  font-weight: normal;\n  text-align: center;\n  margin: 0;\n  font-size: 100;\n  position: relative;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  justify-content: center;\n  margin-top: 32px;\n\n  @media screen and (max-width: 768px) {\n    flex-direction: column;\n    align-items: center;\n\n    > div:first-child {\n      margin-bottom: 30px;\n    }\n  }\n'],['\n  display: flex;\n  justify-content: center;\n  margin-top: 32px;\n\n  @media screen and (max-width: 768px) {\n    flex-direction: column;\n    align-items: center;\n\n    > div:first-child {\n      margin-bottom: 30px;\n    }\n  }\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  justify-content: center;\n  margin-top: 32px;\n\n  > div {\n    margin-left: 28px;\n    margin-right: 28px;\n    &:first-child {\n      margin-left: 0px;\n    }\n    &:last-child {\n      margin-right: 0px;\n    }\n  }\n\n  @media screen and (max-width: 568px) {\n    flex-direction: column;\n    align-items: center;\n\n    > div {\n      margin: 0;\n      margin-bottom: 30px;\n    }\n  }\n'],['\n  display: flex;\n  justify-content: center;\n  margin-top: 32px;\n\n  > div {\n    margin-left: 28px;\n    margin-right: 28px;\n    &:first-child {\n      margin-left: 0px;\n    }\n    &:last-child {\n      margin-right: 0px;\n    }\n  }\n\n  @media screen and (max-width: 568px) {\n    flex-direction: column;\n    align-items: center;\n\n    > div {\n      margin: 0;\n      margin-bottom: 30px;\n    }\n  }\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 270px;\n  margin: 10px;\n'],['\n  width: 270px;\n  margin: 10px;\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  max-width: initial;\n\n  > div {\n    border: 1px solid #bababa;\n    color: #3e3e3e;\n  }\n  ','\n'],['\n  width: 100%;\n  max-width: initial;\n\n  > div {\n    border: 1px solid #bababa;\n    color: #3e3e3e;\n  }\n  ','\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  text-align: left;\n  padding-bottom: 5px;\n'],['\n  text-align: left;\n  padding-bottom: 5px;\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n\n  justify-content: center;\n  margin-top: 32px;\n'],['\n  display: flex;\n\n  justify-content: center;\n  margin-top: 32px;\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: inline-block;\n  font-size: 12px;\n  color: indianred;\n  margin: 10px auto;\n  text-align: left;\n'],['\n  display: inline-block;\n  font-size: 12px;\n  color: indianred;\n  margin: 10px auto;\n  text-align: left;\n']);var GEO_LOCATION_OPTIONS={maximumAge:0/* eslint-disable camelcase */};var Profile=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__logic__["a" /* default */])(_class=function(_Form){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Profile,_Form);function Profile(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,Profile);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=Profile.__proto__||Object.getPrototypeOf(Profile)).call.apply(_ref,[this].concat(args))),_this),_this.nextText='PR\xD3XIMO passo',_this.sendHeight=function(){var height=document.body.scrollHeight;window.parent.postMessage({type:'setHeight',height:height},'*');},_this.geoError=function(error){return true;},_this.geoSucess=function(position){var setCurrentLocation=_this.actions.setCurrentLocation;var lat=void 0;var long=void 0;lat=position.coords&&position.coords.latitude;long=position.coords&&position.coords.longitude;var GOOGLE_GEO_API='https://maps.googleapis.com/maps/api/geocode/json?latlng='+lat+','+long+'&sensor=true&key='+__WEBPACK_IMPORTED_MODULE_29_config__["n" /* GOOGLE_KEY */];try{var request=__WEBPACK_IMPORTED_MODULE_9_axios___default.a.get(GOOGLE_GEO_API);request.then(function(result){if(result.data.error_message||result.data.status==='OVER_QUERY_LIMIT'||result.data.status==='ZERO_RESULTS'){return false;}var newArr=[];result.data.results.forEach(function(component){newArr=[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(newArr),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(component.address_components));});newArr=__WEBPACK_IMPORTED_MODULE_30_lodash_uniqBy___default()(newArr,'long_name');setCurrentLocation(newArr);});}catch(error){}},_this.next=function(){var _this$isFormValid=_this.isFormValid(),valid=_this$isFormValid.valid,invalid=_this$isFormValid.invalid;var _this$actions=_this.actions,setInvalid=_this$actions.setInvalid,setFinished=_this$actions.setFinished;var router=_this.props.router;if(valid){setFinished({profileFinished:true});// setCurrentEquipments([]);
router.push('/habitacao');window.parent.postMessage({type:'scrollToTop'},'*');}else{setFinished({profileFinished:false});setInvalid(invalid);// Move to the places
var locationInvalid=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_utils__["n" /* pickOrNot */])(invalid,['district','municipality']);if(locationInvalid){var location=document.getElementById('location');if(location){location.scrollIntoView({behavior:'smooth'});}return false;}var habitantsInvalid=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_utils__["n" /* pickOrNot */])(invalid,['adults,children,elderly']);if(habitantsInvalid){var habitants=document.getElementById('habitants');if(habitants){habitants.scrollIntoView({behavior:'smooth'});}}}},_this.renderInvalidMessage=function(invalid,field,name){if(invalid){if(invalid[field]){var Message=__WEBPACK_IMPORTED_MODULE_28_validations__["b" /* Messages */][invalid[field]];if(Message){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Error,null,Message(name));}}}return null;},_temp),__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Profile,[{key:'componentDidMount',value:function componentDidMount(){var currentLocalization=this.props.currentLocalization;if(!currentLocalization){navigator.geolocation.getCurrentPosition(this.geoSucess,this.geoError,GEO_LOCATION_OPTIONS);}// Scrols to top on component mount
var element=document.getElementById('anchor');window.scroll({top:element.getBoundingClientRect().top});}},{key:'componentDidUpdate',value:function componentDidUpdate(oldProps){if(oldProps.loading&&!this.props.loading){var element=document.getElementById('anchor');window.scroll({top:element.getBoundingClientRect().top});}this.sendHeight();window.addEventListener('resize',this.sendHeight);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.sendHeight);}/**
   * Next Button actions
   *//**
   * Renders invalid messags
   */},{key:'render',value:function render(){var _props=this.props,districts=_props.districts,cities=_props.cities,loading=_props.loading,totalPeople=_props.totalPeople,invalid=_props.invalid,translations=_props.translations,iframed=_props.iframed;var _actions=this.actions,setValues=_actions.setValues,fetchCities=_actions.fetchCities;var _props$data=this.props.data,constructionYears=_props$data.constructionYears,offerTypes=_props$data.offerTypes,equipmentUtilizationTypes=_props$data.equipmentUtilizationTypes,equipmentUtilizationProfiles=_props$data.equipmentUtilizationProfiles;var _props$values=this.props.values,offerType=_props$values.offerType,constructionYear=_props$values.constructionYear,equipmentUtilizationType=_props$values.equipmentUtilizationType,equipmentUtilizationProfile=_props$values.equipmentUtilizationProfile,adults=_props$values.adults,electricCar=_props$values.electricCar,municipality=_props$values.municipality,district=_props$values.district,children=_props$values.children,elderly=_props$values.elderly;var _ref2=translations||{},SIMULATION_TARGET=_ref2.SIMULATION_TARGET,HOUSEHOLD=_ref2.HOUSEHOLD,USAGE_TYPE=_ref2.USAGE_TYPE,CONSTRUCTION_YEAR=_ref2.CONSTRUCTION_YEAR,LOCATION=_ref2.LOCATION,EQUIPMENTS_PROFILE=_ref2.EQUIPMENTS_PROFILE;var citiesDisabled=!district||!cities;var locationInvalid=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_utils__["n" /* pickOrNot */])(invalid,['district','municipality']);var habitantsInvalid=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_utils__["n" /* pickOrNot */])(invalid,['adults,children,elderly']);if(loading){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_components_Loading__["a" /* default */],null);}// All sections of this page
var SimulateQuestion=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Section__["a" /* default */],{title:'Simular',subtitle:'O que pretende simular',key:'simulate',compact:iframed},SIMULATION_TARGET&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_components_Tip__["a" /* default */],{'data-slot':'tip',text:SIMULATION_TARGET}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ButtonContainer,null,offerTypes&&offerTypes.map(function(_ref3,index){var icon=_ref3.icon,text=_ref3.text,value=_ref3.value;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_ButtonRadio__["a" /* default */],{key:'ot-'+index,onClick:function onClick(){if(value===3){setValues({electricCar:false});}setValues({offerType:value});},icon:icon,name:text,selected:offerType===value});})),offerType&&offerType!==3&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Sep,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Subtitle,null,'Tem carro el\xE9ctrico e carrega-o em casa?'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ButtonContainer,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_ButtonRadio__["a" /* default */],{onClick:function onClick(){return setValues({electricCar:true});},icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__images_ic_mobilidade_component_svg___default.a,null),name:'Sim',selected:electricCar===true}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_ButtonRadio__["a" /* default */],{onClick:function onClick(){return setValues({electricCar:false});},icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__images_ic_sem_acao_component_svg___default.a,null),name:'N\xE3o',selected:electricCar===false}))));var constructionYearsQuestion=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Section__["a" /* default */],{title:'Ano de constru\xE7\xE3o / Reabilita\xE7\xE3o do Im\xF3vel',subtitle:'Selecione o intervalo adequado',key:'construction',compact:iframed},CONSTRUCTION_YEAR&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_components_Tip__["a" /* default */],{'data-slot':'tip',text:CONSTRUCTION_YEAR}),constructionYears&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_RadioGroup__["a" /* default */],{items:constructionYears,value:constructionYear,onSelectionChange:function onSelectionChange(_ref4){var value=_ref4.value;return setValues({constructionYear:value});}}));var localizationQuestion=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Section__["a" /* default */],{title:'Localiza\xE7\xE3o',subtitle:'Selecione o distrito e concelho',className:locationInvalid&&'invalid',id:'location',key:'location',compact:iframed},LOCATION&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_components_Tip__["a" /* default */],{'data-slot':'tip',text:LOCATION}),districts&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WrapperLocation,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WrapperSelect,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(LocationLabel,{fontSize:'12px'},'DISTRITO'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledSelect,{margin:true,placeholder:'Distrito',items:districts,onChange:function onChange(_ref5){var value=_ref5.value;setValues({district:value,municipality:undefined});fetchCities(value);},selected:district,arrowIcon:__WEBPACK_IMPORTED_MODULE_10__images_ic_arrow_svg___default.a}),this.renderInvalidMessage(locationInvalid,'district','Distrito')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WrapperSelect,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(LocationLabel,{fontSize:'12px'},'CONCELHO'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledSelect,{disabled:citiesDisabled,placeholder:'Concelho',items:cities,onChange:function onChange(_ref6){var value=_ref6.value;return setValues({municipality:value});},selected:municipality,arrowIcon:__WEBPACK_IMPORTED_MODULE_10__images_ic_arrow_svg___default.a}),this.renderInvalidMessage(locationInvalid,'municipality','Concelho'))));var utilizationQuestion=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Section__["a" /* default */],{title:'Tipo de utiliza\xE7\xE3o',subtitle:'Selecione o tipo de utiliza\xE7\xE3o mais adequado',key:'utilization',compact:iframed},USAGE_TYPE&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_components_Tip__["a" /* default */],{'data-slot':'tip',text:USAGE_TYPE}),equipmentUtilizationTypes&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_components_UseType__["a" /* default */],{items:equipmentUtilizationTypes,value:equipmentUtilizationType,onSelectionChange:function onSelectionChange(_ref7){var value=_ref7.value;return setValues({equipmentUtilizationType:value});}}));var habitantsQuestion=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Section__["a" /* default */],{title:'Agregado Familiar',subtitle:'Escolha um cen\xE1rio',className:habitantsInvalid&&'invalid',id:'habitants',key:'habitants',compact:iframed},HOUSEHOLD&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_components_Tip__["a" /* default */],{'data-slot':'tip',text:HOUSEHOLD}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WrapperHabitants,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Counter__["b" /* default */],{id:'adults',type:'adultos',value:adults,text:'Adultos',onChange:function onChange(_ref8){var value=_ref8.value;return setValues({adults:value});},disabled:totalPeople===__WEBPACK_IMPORTED_MODULE_8__logic__["b" /* MAX_PEOPLE */]},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__images_adulto_component_svg___default.a,null)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Counter__["b" /* default */],{id:'children',type:'criancas',value:children,text:'Crianças',onChange:function onChange(_ref9){var value=_ref9.value;return setValues({children:value});},disabled:totalPeople===__WEBPACK_IMPORTED_MODULE_8__logic__["b" /* MAX_PEOPLE */],subLabel:'<18 Anos'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__images_crianca_component_svg___default.a,null)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Counter__["b" /* default */],{id:'elderly',type:'idosos',value:elderly,text:'Idosos',onChange:function onChange(_ref10){var value=_ref10.value;return setValues({elderly:value});},disabled:totalPeople===__WEBPACK_IMPORTED_MODULE_8__logic__["b" /* MAX_PEOPLE */],subLabel:'>66 Anos'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__images_idoso_component_svg___default.a,null))),this.renderInvalidMessage(habitantsInvalid,'adults,children,elderly','Habitantes'));var equipmentProfileQuestion=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Section__["a" /* default */],{title:'Perfil de utiliza\xE7\xE3o dos equipamentos',subtitle:'Indique os seus h\xE1bitos de consumo de energia',key:'equipment',compact:iframed},EQUIPMENTS_PROFILE&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_components_Tip__["a" /* default */],{'data-slot':'tip',text:EQUIPMENTS_PROFILE}),equipmentUtilizationProfiles&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_components_UseType__["a" /* default */],{items:equipmentUtilizationProfiles,value:equipmentUtilizationProfile,name:'use_type',itemSize:'270px',onSelectionChange:function onSelectionChange(_ref11){var value=_ref11.value;return setValues({equipmentUtilizationProfile:value});}}));return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Wrapper,null,this.renderNavbar(),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_components_FixedWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_29_config__["p" /* isAdvanced */]&&[SimulateQuestion,constructionYearsQuestion,localizationQuestion,utilizationQuestion,habitantsQuestion,equipmentProfileQuestion],__WEBPACK_IMPORTED_MODULE_29_config__["o" /* isSimple */]&&[SimulateQuestion,habitantsQuestion,utilizationQuestion,constructionYearsQuestion,localizationQuestion,equipmentProfileQuestion]),this.renderButtons());}}]);return Profile;}(__WEBPACK_IMPORTED_MODULE_16_containers_Form__["a" /* default */]))||_class;var Wrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject);var Sep=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject2);var Subtitle=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject3);var WrapperLocation=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject4);var WrapperHabitants=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject5);var WrapperSelect=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject6);var StyledSelect=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_24_components_Select__["a" /* default */])(_templateObject7,function(_ref12){var margin=_ref12.margin;return margin&&'margin-right: 30px;';});var LocationLabel=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_17_components_Label__["a" /* default */])(_templateObject8);var ButtonContainer=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject9);var Error=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject10);

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MAX_PEOPLE; });
/* unused harmony export LOADING_COUNT */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_kea__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_kea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_kea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_saga__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_containers_App_logic__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_containers_SimpleHabitation_logic__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_validations__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_omit__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_find__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_first__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_first___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_first__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_forEach__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_electricityplusgas_component_svg__ = __webpack_require__(1661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_electricityplusgas_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__images_electricityplusgas_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_electricity_component_svg__ = __webpack_require__(1660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_electricity_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__images_electricity_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_gas_component_svg__ = __webpack_require__(1662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_gas_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__images_gas_component_svg__);
//import { isUndefined } from 'lodash-es'
var DISTRICTS_ENDPOINT=__WEBPACK_IMPORTED_MODULE_3_config__["b" /* API_BASE_URL */]+'/public/district/';var CITIES_ENDPOINT=__WEBPACK_IMPORTED_MODULE_3_config__["b" /* API_BASE_URL */]+'/public/municipality/';var CONSUMER_PROFILE=__WEBPACK_IMPORTED_MODULE_3_config__["b" /* API_BASE_URL */]+'/public/simulator/consumer_profile/';var MAX_PEOPLE=10;var LOADING_COUNT=2;var fields={offerType:[__WEBPACK_IMPORTED_MODULE_12_validations__["a" /* Validations */].isUndefined],constructionYear:[__WEBPACK_IMPORTED_MODULE_12_validations__["a" /* Validations */].isUndefined],district:[__WEBPACK_IMPORTED_MODULE_12_validations__["a" /* Validations */].isUndefined],municipality:[__WEBPACK_IMPORTED_MODULE_12_validations__["a" /* Validations */].isUndefined],equipmentUtilizationType:[__WEBPACK_IMPORTED_MODULE_12_validations__["a" /* Validations */].isUndefined],'adults,children,elderly':[__WEBPACK_IMPORTED_MODULE_12_validations__["a" /* Validations */].habitants],electricCar:[__WEBPACK_IMPORTED_MODULE_12_validations__["a" /* Validations */].isUndefined],equipmentUtilizationProfile:[__WEBPACK_IMPORTED_MODULE_12_validations__["a" /* Validations */].isUndefined]// This is needed for issue https://gitlab.ubiwhere.com/adene-poupa-energia/adene-simulador-avancado/issues/69
// We need to import the logic so the worker starts working immediately
// Please read the logic.js of Habitation for more info on this
};var connectArrayHabitation=[];if(__WEBPACK_IMPORTED_MODULE_3_config__["p" /* isAdvanced */]){var Habitation=__webpack_require__(228).default;connectArrayHabitation=[Habitation,[]];}if(__WEBPACK_IMPORTED_MODULE_3_config__["o" /* isSimple */]){var SimpleHabitation=__webpack_require__(138).default;connectArrayHabitation=[SimpleHabitation,[]];}/* eslint-disable camelcase *//* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_kea__["kea"])({path:function path(){return['scenes','profile'];},actions:function actions(){return{setDistricts:function setDistricts(districts){return{districts:districts};},setData:function setData(data){return{data:data};},setCities:function setCities(cities){return{cities:cities};},setInvalid:function setInvalid(invalid){return{invalid:invalid};},setCurrentLocation:function setCurrentLocation(currentLocation){return{currentLocation:currentLocation};},increment:function increment(){return{};},removeCities:function removeCities(cities){return{cities:cities};},fetchDistricts:function fetchDistricts(limit){return{limit:limit};},fetchCities:function fetchCities(district){return{district:district};},fetchData:function fetchData(){return{};},setDataFetchError:function setDataFetchError(fetchDataError){return{fetchDataError:fetchDataError};},setDistrictsFetchError:function setDistrictsFetchError(fetchDistrictError){return{fetchDistrictError:fetchDistrictError};},setCitiesFetchError:function setCitiesFetchError(fetchCitiesError){return{fetchCitiesError:fetchCitiesError};}};},reducers:function reducers(_ref){var _ref4,_ref7;var actions=_ref.actions;return{currentLocalization:[null,__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.setCurrentLocation,function(state,payload){return payload.currentLocation;})],districts:[[],__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.array,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.setDistricts,function(state,payload){return[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(payload.districts));})],cities:[[],__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.array,(_ref4={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref4,actions.setCities,function(state,payload){return[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(payload.cities));}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref4,actions.removeCities,function(state,payload){return __WEBPACK_IMPORTED_MODULE_13_lodash_omit___default()(state,payload.cities);}),_ref4)],data:[{},__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.setData,function(state,payload){return Object.assign({},payload.data);})],fields:[fields,__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,{}],invalid:[{},__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.array,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.setInvalid,function(_,payload){return payload.invalid;})],loading:[LOADING_COUNT,__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,(_ref7={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.setDistricts,function(state){return state&&state-1;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.setData,function(state){return state&&state-1;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.setDataFetchError,function(){return 0;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.setCities,function(state){return state&&state-1;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.increment,function(state){return state+1;}),_ref7)]};},takeLatest:function takeLatest(_ref8){var _ref9;var actions=_ref8.actions,workers=_ref8.workers;return _ref9={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref9,actions.fetchDistricts,workers.fetchDistricts),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref9,actions.setDistricts,workers.setFromLocation),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref9,actions.setCities,workers.setMunicipalityFromLocation),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref9,actions.setCurrentLocation,workers.setFromLocation),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref9,actions.setDistrict,workers.fetchCities),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref9,actions.fetchCities,workers.fetchCities),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref9,actions.fetchData,workers.fetchData),_ref9;},start:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function start(){var _actions,fetchDistricts,fetchData,fetchCities,increment,_ref10,simulationFinished,values,settings;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function start$(_context){while(1){switch(_context.prev=_context.next){case 0:_actions=this.actions,fetchDistricts=_actions.fetchDistricts,fetchData=_actions.fetchData,fetchCities=_actions.fetchCities,increment=_actions.increment;_context.next=3;return __WEBPACK_IMPORTED_MODULE_10_containers_App_logic__["a" /* default */].get('finished');case 3:_ref10=_context.sent;simulationFinished=_ref10.simulationFinished;_context.next=7;return __WEBPACK_IMPORTED_MODULE_10_containers_App_logic__["a" /* default */].get('values');case 7:values=_context.sent;_context.next=10;return __WEBPACK_IMPORTED_MODULE_10_containers_App_logic__["a" /* default */].get('settings');case 10:settings=_context.sent;_context.next=13;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga__["delay"])(800);case 13:if(!(simulationFinished||!values.simulationCode)){_context.next=23;break;}_context.next=16;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(fetchDistricts(100));case 16:if(!(settings.isFromProfile||settings.isFromUrl)){_context.next=21;break;}_context.next=19;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(increment());case 19:_context.next=21;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(fetchCities());case 21:_context.next=23;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(fetchData());case 23:case'end':return _context.stop();}}},start,this);}),workers:{/**
     * Fetches the needed data
     * @param {*} action
     */fetchData:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchData(action){var _actions2,setData,setDataFetchError,setValues,_ref11,simulationFinished,settings,params,data,constructionYears,equipmentUtilizationTypes,equipmentUtilizationProfiles,offerTypes,simulationCode,defaultValues,setFinished,goToResults,dataSimulationChanged;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchData$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_actions2=this.actions,setData=_actions2.setData,setDataFetchError=_actions2.setDataFetchError,setValues=_actions2.setValues;_context2.next=3;return __WEBPACK_IMPORTED_MODULE_10_containers_App_logic__["a" /* default */].get('finished');case 3:_ref11=_context2.sent;simulationFinished=_ref11.simulationFinished;_context2.next=7;return __WEBPACK_IMPORTED_MODULE_10_containers_App_logic__["a" /* default */].get('settings');case 7:settings=_context2.sent;params={format:'json',type:__WEBPACK_IMPORTED_MODULE_3_config__["o" /* isSimple */]?'s':__WEBPACK_IMPORTED_MODULE_3_config__["p" /* isAdvanced */]?'a':'b'};_context2.prev=9;_context2.next=12;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_9_axios___default.a.post,CONSUMER_PROFILE,params);case 12:data=_context2.sent;constructionYears=data.data&&data.data.construction_years.sort(function(a,b){return a.order-b.order;}).map(function(_ref12){var id=_ref12.id,name=_ref12.name;return{text:name,value:id};});equipmentUtilizationTypes=data.data&&data.data.equipment_utilization_type.sort(function(a,b){return a.order-b.order;}).map(function(_ref13){var id=_ref13.id,name=_ref13.name,sub_name=_ref13.sub_name,description=_ref13.description,defaultValue=_ref13.default;return{text:name,value:id,sub_name:sub_name,description:description,defaultValue:defaultValue};});equipmentUtilizationProfiles=data.data&&data.data.equipment_utilization_profile.sort(function(a,b){return a.order-b.order;}).map(function(_ref14){var id=_ref14.id,name=_ref14.name,description=_ref14.description,defaultValue=_ref14.default;return{text:name,value:id,description:description,defaultValue:defaultValue};});offerTypes=data.data&&data.data.offer_types.sort(function(a,b){return a.order-b.order;}).map(function(_ref15){var id=_ref15.id,slug=_ref15.slug,name=_ref15.name;var icon=void 0;switch(slug){case'e':icon=__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__images_electricity_component_svg___default.a,null);break;case'g':icon=__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__images_gas_component_svg___default.a,null);break;case'eg':icon=__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__images_electricityplusgas_component_svg___default.a,null);break;default:icon=__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__images_electricity_component_svg___default.a,null);}return{text:(name+'').replace(' + ','<br />+<br />'),value:id,icon:icon,id:id,slug:slug};});// Set the default values after getting the data
simulationCode=data.data.simulation_code;defaultValues={};if(!simulationFinished&&!settings.isFromProfile&&!settings.isFromUrl){defaultValues={simulationCode:simulationCode,adults:1,children:0,elderly:0,offerType:__WEBPACK_IMPORTED_MODULE_14_lodash_find___default()(offerTypes,function(_ref16){var slug=_ref16.slug;return slug==='eg';}).id,electricCar:false,constructionYear:__WEBPACK_IMPORTED_MODULE_15_lodash_first___default()(constructionYears).value,equipmentUtilizationType:__WEBPACK_IMPORTED_MODULE_14_lodash_find___default()(equipmentUtilizationTypes,function(_ref17){var defaultValue=_ref17.defaultValue;return defaultValue;}).value,equipmentUtilizationProfile:__WEBPACK_IMPORTED_MODULE_14_lodash_find___default()(equipmentUtilizationProfiles,function(_ref18){var defaultValue=_ref18.defaultValue;return defaultValue;}).value};}else{// Reset simulation code
defaultValues={simulationCode:simulationCode};}_context2.next=22;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setValues(defaultValues));case 22:_context2.next=24;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setData({constructionYears:constructionYears,equipmentUtilizationTypes:equipmentUtilizationTypes,equipmentUtilizationProfiles:equipmentUtilizationProfiles,offerTypes:offerTypes}));case 24:setFinished=this.actions.setFinished;_context2.next=27;return __WEBPACK_IMPORTED_MODULE_10_containers_App_logic__["a" /* default */].get('goToResults');case 27:goToResults=_context2.sent;_context2.next=30;return __WEBPACK_IMPORTED_MODULE_10_containers_App_logic__["a" /* default */].get('dataSimulationChanged');case 30:dataSimulationChanged=_context2.sent;if(goToResults&&!dataSimulationChanged){setFinished({profileFinished:true,habitationFinished:true,faturationFinished:true,consumeFinished:true});this.props.router.push('/resultados');}_context2.next=38;break;case 34:_context2.prev=34;_context2.t0=_context2['catch'](9);_context2.next=38;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setDataFetchError(_context2.t0));case 38:case'end':return _context2.stop();}}},fetchData,this,[[9,34]]);}),/**
     * Fetchs all Districts
     * @param {*} action
     */fetchDistricts:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchDistricts(action){var limit,_actions3,setDistricts,setDistrictsFetchError,params,districts,filteredDistricts;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchDistricts$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:limit=action.payload.limit;_actions3=this.actions,setDistricts=_actions3.setDistricts,setDistrictsFetchError=_actions3.setDistrictsFetchError;params={limit:limit,format:'json'};_context3.prev=3;_context3.next=6;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_9_axios___default.a.get,DISTRICTS_ENDPOINT,{params:params});case 6:districts=_context3.sent;filteredDistricts=districts.data.results.map(function(_ref19){var id=_ref19.id,name=_ref19.name;return{label:name,value:id};});_context3.next=10;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setDistricts(filteredDistricts));case 10:_context3.next=16;break;case 12:_context3.prev=12;_context3.t0=_context3['catch'](3);_context3.next=16;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setDistrictsFetchError(_context3.t0));case 16:case'end':return _context3.stop();}}},fetchDistricts,this,[[3,12]]);}),/**
     * Fetches all municipalities from a district
     * @param {*} action
     */fetchCities:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchCities(action){var district,_actions4,setCities,setCitiesFetchError,params,cities,results;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchCities$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:district=action.payload.district;_actions4=this.actions,setCities=_actions4.setCities,setCitiesFetchError=_actions4.setCitiesFetchError;params={limit:1000,format:'json',district:district};_context4.prev=3;_context4.next=6;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_9_axios___default.a.get,CITIES_ENDPOINT,{params:params});case 6:cities=_context4.sent;results=cities.data.results;results=results.map(function(_ref20){var id=_ref20.id,name=_ref20.name,district=_ref20.district;return{value:id,label:name,district:district.id};});_context4.next=11;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setCities(results));case 11:_context4.next=17;break;case 13:_context4.prev=13;_context4.t0=_context4['catch'](3);_context4.next=17;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setCitiesFetchError(_context4.t0));case 17:case'end':return _context4.stop();}}},fetchCities,this,[[3,13]]);}),setFromLocation:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function setFromLocation(){var setValues,districts,currentLocation,distrito;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setFromLocation$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:setValues=this.actions.setValues;_context5.next=3;return this.get('districts');case 3:districts=_context5.sent;_context5.next=6;return this.get('currentLocalization');case 6:currentLocation=_context5.sent;if(!(currentLocation&&!!currentLocation.length)){_context5.next=13;break;}distrito=null;__WEBPACK_IMPORTED_MODULE_16_lodash_forEach___default()(currentLocation,function(_ref21){var long_name=_ref21.long_name;var find=districts&&districts.find(function(_ref22){var label=_ref22.label;return label.toLowerCase()===long_name.toLowerCase();});if(find){distrito=find;return false;}});if(!distrito){_context5.next=13;break;}_context5.next=13;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setValues({district:distrito.value}));case 13:case'end':return _context5.stop();}}},setFromLocation,this);}),setMunicipalityFromLocation:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function setMunicipalityFromLocation(){var setValues,cities,currentLocation,cidade;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setMunicipalityFromLocation$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:setValues=this.actions.setValues;_context6.next=3;return this.get('cities');case 3:cities=_context6.sent;_context6.next=6;return this.get('currentLocalization');case 6:currentLocation=_context6.sent;cidade=null;if(!(currentLocation&&!!currentLocation.length)){_context6.next=14;break;}// Search First for administrative area level 2 and 3
__WEBPACK_IMPORTED_MODULE_16_lodash_forEach___default()(currentLocation,function(location){var find=cities&&cities.find(function(_ref23){var label=_ref23.label;return label.toLowerCase()===location.long_name.toLowerCase()&&(location.types[0]==='administrative_area_level_2'||location.types[0]==='administrative_area_level_3');});if(find){cidade=find;return false;}});// If search is empty search by the name
if(!cidade){__WEBPACK_IMPORTED_MODULE_16_lodash_forEach___default()(currentLocation,function(location){var find=cities&&cities.find(function(_ref24){var label=_ref24.label;return label.toLowerCase()===location.long_name.toLowerCase();});if(find){cidade=find;return false;}});}if(!cidade){_context6.next=14;break;}_context6.next=14;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setValues({municipality:cidade.value}));case 14:case'end':return _context6.stop();}}},setMunicipalityFromLocation,this);})},selectors:function selectors(_ref25){var _selectors=_ref25.selectors;return{totalPeople:[function(){return[__WEBPACK_IMPORTED_MODULE_10_containers_App_logic__["a" /* default */].selectors.values];},function(_ref26){var adults=_ref26.adults,children=_ref26.children,elderly=_ref26.elderly;return adults+children+elderly||0;}]};},connect:{actions:[__WEBPACK_IMPORTED_MODULE_10_containers_App_logic__["a" /* default */],['setValue','setValues','setFinished'],__WEBPACK_IMPORTED_MODULE_11_containers_SimpleHabitation_logic__["default"],['setCurrentEquipments']].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(connectArrayHabitation)),props:[__WEBPACK_IMPORTED_MODULE_10_containers_App_logic__["a" /* default */],['values','finished','translations','iframed','goToResults']]}}));

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProfileV2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logic__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_ic_arrow_component_svg__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_ic_arrow_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_ic_arrow_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_person_component_svg__ = __webpack_require__(1672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_person_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_person_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_ic_eletric_car_component_svg__ = __webpack_require__(1669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_ic_eletric_car_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_ic_eletric_car_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_ic_solar_component_svg__ = __webpack_require__(1671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_ic_solar_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__images_ic_solar_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_ic_gas_component_svg__ = __webpack_require__(1670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_ic_gas_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_ic_gas_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_containers_FormV2__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_SectionV2__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_SectionMobileV2__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_InlineRadioV2__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_InlineCheckV2__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_LeftAlignRadioV2__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_LeftAlignCheckV2__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_Loading__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_SelectV2__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_SectionHeader__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_components_FixedWrapper__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_validations__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lodash_uniqBy__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_lodash_uniqBy__);
var _class;var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 24px;\n  width: 100%;\n'],['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 24px;\n  width: 100%;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  gap: 16px;\n  align-self: stretch;\n  justify-content: unset;\n  background: #fff;\n'],['\n  gap: 16px;\n  align-self: stretch;\n  justify-content: unset;\n  background: #fff;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding-bottom: 24px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n'],['\n  display: flex;\n  padding-bottom: 24px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n'],['\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  align-self: stretch;\n'],['\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  align-self: stretch;\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  width: 26px;\n  height: 26px;\n  padding: 4px;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n\n  > svg {\n    width: 26px !important;\n    height: 26px !important;\n  }\n\n  > span {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    flex-shrink: 0;\n    position: absolute;\n    top: 26%;\n    right: 28%;\n    color: #3e3e3e;\n    text-align: center;\n    font-family: Nunito;\n    font-size: 8px;\n    font-style: normal;\n    font-weight: 800;\n    line-height: 14px;\n\n    font-size: 8px;\n  }\n\n  @media screen and (min-width: 1000px) {\n    width: 36px;\n    height: 36px;\n\n    > svg {\n      width: 36px !important;\n      height: 36px !important;\n    }\n\n    > span {\n      top: 33%;\n      right: 26%;\n    }\n  }\n'],['\n  display: flex;\n  width: 26px;\n  height: 26px;\n  padding: 4px;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n\n  > svg {\n    width: 26px !important;\n    height: 26px !important;\n  }\n\n  > span {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    flex-shrink: 0;\n    position: absolute;\n    top: 26%;\n    right: 28%;\n    color: #3e3e3e;\n    text-align: center;\n    font-family: Nunito;\n    font-size: 8px;\n    font-style: normal;\n    font-weight: 800;\n    line-height: 14px;\n\n    font-size: 8px;\n  }\n\n  @media screen and (min-width: 1000px) {\n    width: 36px;\n    height: 36px;\n\n    > svg {\n      width: 36px !important;\n      height: 36px !important;\n    }\n\n    > span {\n      top: 33%;\n      right: 26%;\n    }\n  }\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1 0 0;\n  min-width: 270px;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1 0 0;\n  min-width: 270px;\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  max-width: initial;\n\n  > div:first-child {\n    height: 40px;\n  }\n\n  > div {\n    padding: 10px;\n    border: 1px solid #bababa;\n\n    color: #616161;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n  }\n  ','\n'],['\n  width: 100%;\n  max-width: initial;\n\n  > div:first-child {\n    height: 40px;\n  }\n\n  > div {\n    padding: 10px;\n    border: 1px solid #bababa;\n\n    color: #616161;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n  }\n  ','\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 25px;\n  align-self: stretch;\n  color: #3e3e3e;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n\n  > b {\n    overflow: hidden;\n    color: #f00;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    text-overflow: ellipsis;\n    font-family: Nunito;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px; /* 200% */\n    letter-spacing: 1px;\n  }\n'],['\n  height: 25px;\n  align-self: stretch;\n  color: #3e3e3e;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n\n  > b {\n    overflow: hidden;\n    color: #f00;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    text-overflow: ellipsis;\n    font-family: Nunito;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px; /* 200% */\n    letter-spacing: 1px;\n  }\n']),_templateObject11=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: flex-end;\n  gap: 12px;\n  width: 100%;\n'],['\n  display: flex;\n  align-items: flex-end;\n  gap: 12px;\n  width: 100%;\n']),_templateObject12=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 16px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n\n  p,\n  b {\n    color: #3e3e3e;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n    margin: 0;\n  }\n\n  b {\n    font-weight: 700;\n  }\n\n  @media screen and (min-width: 750px) {\n    padding-inline: 130px;\n  }\n'],['\n  display: flex;\n  padding: 16px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n\n  p,\n  b {\n    color: #3e3e3e;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n    margin: 0;\n  }\n\n  b {\n    font-weight: 700;\n  }\n\n  @media screen and (min-width: 750px) {\n    padding-inline: 130px;\n  }\n']),_templateObject13=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: inline-block;\n  font-size: 12px;\n  color: indianred;\n  margin: 10px auto;\n  text-align: left;\n'],['\n  display: inline-block;\n  font-size: 12px;\n  color: indianred;\n  margin: 10px auto;\n  text-align: left;\n']);var GEO_LOCATION_OPTIONS={maximumAge:0/* eslint-disable camelcase */};var ProfileV2=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__logic__["a" /* default */])(_class=function(_FormV){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ProfileV2,_FormV);function ProfileV2(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,ProfileV2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=ProfileV2.__proto__||Object.getPrototypeOf(ProfileV2)).call.apply(_ref,[this].concat(args))),_this),_this.state={nextText:'Ver Resultados',width:0},_this.updateWindowDimensions=function(){_this.setState({width:window.innerWidth});},_this.sendHeight=function(){var height=document.body.scrollHeight;window.parent.postMessage({type:'setHeight',height:height},'*');},_this.handleResize=function(updateState){updateState&&_this.updateWindowDimensions();_this.sendHeight();},_this.geoError=function(error){return true;},_this.geoSucess=function(position){var setCurrentLocation=_this.actions.setCurrentLocation;var lat=void 0;var long=void 0;lat=position.coords&&position.coords.latitude;long=position.coords&&position.coords.longitude;var GOOGLE_GEO_API='https://maps.googleapis.com/maps/api/geocode/json?latlng='+lat+','+long+'&sensor=true&key='+__WEBPACK_IMPORTED_MODULE_28_config__["n" /* GOOGLE_KEY */];try{var request=__WEBPACK_IMPORTED_MODULE_9_axios___default.a.get(GOOGLE_GEO_API);request.then(function(result){if(result.data.error_message||result.data.status==='OVER_QUERY_LIMIT'||result.data.status==='ZERO_RESULTS'){return false;}var newArr=[];result.data.results.forEach(function(component){newArr=[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(newArr),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(component.address_components));});newArr=__WEBPACK_IMPORTED_MODULE_29_lodash_uniqBy___default()(newArr,'long_name');setCurrentLocation(newArr);});}catch(error){}},_this.renderInvalidMessage=function(invalid,field,name){if(invalid){if(invalid[field]){var _Message=__WEBPACK_IMPORTED_MODULE_27_validations__["b" /* Messages */][invalid[field]];if(_Message){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Error,{'data-error':true},_Message(name));}}}return null;},_this.submit=function(){var _this$isFormValid=_this.isFormValid(),valid=_this$isFormValid.valid,invalid=_this$isFormValid.invalid;var _this$actions=_this.actions,setFinished=_this$actions.setFinished,setInvalid=_this$actions.setInvalid,setCurrentLocation=_this$actions.setCurrentLocation;var router=_this.props.router;if(valid){setFinished({profileFinished:true});setInvalid({});window.parent.postMessage({type:'scrollToTop'},'*');setCurrentLocation([]);router.push('/resultados');}else{setFinished({profileFinished:false});setInvalid(invalid);}},_temp),__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ProfileV2,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,currentLocalization=_props.currentLocalization,values=_props.values;if(!currentLocalization&&!values.district&&!values.municipality){navigator.geolocation.getCurrentPosition(this.geoSucess,this.geoError,GEO_LOCATION_OPTIONS);}// Scrols to top on component mount
var element=document.getElementById('anchor');window.scroll({top:element.getBoundingClientRect().top});this.handleResize(true);window.addEventListener('resize',this.handleResize);}},{key:'componentDidUpdate',value:function componentDidUpdate(oldProps){if(oldProps.loading&&!this.props.loading){var element=document.getElementById('anchor');window.scroll({top:element.getBoundingClientRect().top});}var errorElement=document.querySelector('span[data-error]');if(errorElement){if(errorElement.parentElement){errorElement.parentElement.scrollIntoView({behavior:'smooth',block:'center'});}else{errorElement.scrollIntoView({behavior:'smooth',block:'center'});}}this.handleResize(false);window.addEventListener('resize',this.handleResize);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.handleResize);}/**
   * Renders invalid messags
   *//**
   * Submits the form
   */},{key:'render',value:function render(){var _props2=this.props,districts=_props2.districts,cities=_props2.cities,loading=_props2.loading,invalid=_props2.invalid,iframed=_props2.iframed,values=_props2.values;var _actions=this.actions,setValues=_actions.setValues,fetchCities=_actions.fetchCities;var offerTypes=this.props.data.offerTypes;var _props$values=this.props.values,offerType=_props$values.offerType,municipality=_props$values.municipality,district=_props$values.district,habitants=_props$values.habitants,hasSolarSystem=_props$values.hasSolarSystem,hasNaturalGasHeating=_props$values.hasNaturalGasHeating,hasElectricCar=_props$values.hasElectricCar;var citiesDisabled=!district||!cities;var locationInvalid=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_utils__["n" /* pickOrNot */])(invalid,['district','municipality']);var habitantsInvalid=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_utils__["n" /* pickOrNot */])(invalid,['habitants']);if(loading){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_components_Loading__["a" /* default */],null);}// All sections of this page
var SimulateSection=this.state.width>1000?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_SectionV2__["a" /* default */],{title:'Tipo de Simula\xE7\xE3o',key:'simulate',compact:iframed},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ButtonContainer,null,offerTypes&&offerTypes.map(function(_ref2,index){var icon=_ref2.icon,text=_ref2.text,value=_ref2.value;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_InlineRadioV2__["a" /* default */],{key:'ot-'+index,onClick:function onClick(){if(value===2){setValues({hasNaturalGasHeating:false});}setValues({offerType:value});},icon:icon,name:text,selected:offerType===value});}))):__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_SectionMobileV2__["a" /* default */],{title:'Tipo de Simula\xE7\xE3o',key:'simulate',compact:iframed},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledSelect,{items:offerTypes.map(function(item){return{value:item.value,label:item.text};}),onChange:function onChange(_ref3){var value=_ref3.value;if(value===2){setValues({hasNaturalGasHeating:false});}setValues({offerType:value});},selected:offerType,arrowIcon:__WEBPACK_IMPORTED_MODULE_10__images_ic_arrow_component_svg___default.a}));var GeneralSection=this.state.width>1000?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_SectionV2__["a" /* default */],{title:'Informa\xE7\xE3o Geral',key:'general',compact:iframed},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(GeneralWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InsideSection,{id:'location',key:'location'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_components_SectionHeader__["a" /* default */],{title:'Localiza\xE7\xE3o'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(LocationInputsWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WrapperSelect,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputLabel,null,'Distrito ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,'*')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledSelect,{placeholder:'Distrito',items:districts,onChange:function onChange(_ref4){var value=_ref4.value;setValues({district:value,municipality:undefined});fetchCities(value);},selected:district,arrowIcon:__WEBPACK_IMPORTED_MODULE_10__images_ic_arrow_component_svg___default.a}),this.renderInvalidMessage(locationInvalid,'district','Distrito')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WrapperSelect,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputLabel,null,'Concelho'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledSelect,{disabled:citiesDisabled,placeholder:'Concelho',items:cities,onChange:function onChange(_ref5){var value=_ref5.value;return setValues({municipality:value});},selected:municipality,arrowIcon:__WEBPACK_IMPORTED_MODULE_10__images_ic_arrow_component_svg___default.a}),this.renderInvalidMessage(locationInvalid,'municipality','Concelho')))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InsideSection,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_components_SectionHeader__["a" /* default */],{title:'Agregado Familiar',subTitle:'Por favor, selecione um cen\xE1rio.'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputsWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_LeftAlignRadioV2__["a" /* default */],{onClick:function onClick(){setValues({habitants:1});},icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(PersonIconWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__images_person_component_svg___default.a,null),' ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,'1'),' '),name:'1 Pessoa',selected:habitants===1}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_LeftAlignRadioV2__["a" /* default */],{onClick:function onClick(){setValues({habitants:2});},icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(PersonIconWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__images_person_component_svg___default.a,null),' ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,'2'),' '),name:'2 Pessoas',selected:habitants===2}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_LeftAlignRadioV2__["a" /* default */],{onClick:function onClick(){setValues({habitants:3});},icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(PersonIconWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__images_person_component_svg___default.a,null),' ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,'3'),' '),name:'3 Pessoas',selected:habitants===3}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_LeftAlignRadioV2__["a" /* default */],{onClick:function onClick(){setValues({habitants:4});},icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(PersonIconWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__images_person_component_svg___default.a,null),' ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,'4'),' '),name:'4 Pessoas',selected:habitants===4}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_LeftAlignRadioV2__["a" /* default */],{onClick:function onClick(){setValues({habitants:5});},icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(PersonIconWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__images_person_component_svg___default.a,null),' ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,'5'),' '),name:'5 ou mais pessoas',selected:habitants===5})),this.renderInvalidMessage(habitantsInvalid,'habitants','Agregado Familiar')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InsideSection,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_components_SectionHeader__["a" /* default */],{title:'Op\xE7\xF5es Adicionais',required:false,subTitle:'Por favor, selecione uma ou v\xE1rias op\xE7\xF5es.'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputsWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_LeftAlignCheckV2__["a" /* default */],{onClick:function onClick(){setValues({hasElectricCar:!hasElectricCar});},icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__images_ic_eletric_car_component_svg___default.a,null),name:'Carro El\xE9trico',selected:hasElectricCar}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_LeftAlignCheckV2__["a" /* default */],{onClick:function onClick(){setValues({hasSolarSystem:!hasSolarSystem});},icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__images_ic_solar_component_svg___default.a,null),name:'Energias Renov\xE1veis',selected:hasSolarSystem}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_LeftAlignCheckV2__["a" /* default */],{disabled:values.offerType===2,onClick:function onClick(){setValues({hasNaturalGasHeating:!hasNaturalGasHeating});},icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__images_ic_gas_component_svg___default.a,null),name:'Aquecimento centralizado a G\xE1s Natural',selected:hasNaturalGasHeating}))))):__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_SectionMobileV2__["a" /* default */],{title:'Informa\xE7\xE3o Geral',key:'general',compact:iframed},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(MobileGeneralWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(MobileSection,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_components_SectionHeader__["a" /* default */],{title:'Localiza\xE7\xE3o'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WrapperSelect,{style:{width:'100% '}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputLabel,null,'Distrito ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,'*')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledSelect,{placeholder:'Distrito',items:districts,onChange:function onChange(_ref6){var value=_ref6.value;setValues({district:value,municipality:undefined});fetchCities(value);},selected:district,arrowIcon:__WEBPACK_IMPORTED_MODULE_10__images_ic_arrow_component_svg___default.a}),this.renderInvalidMessage(locationInvalid,'district','Distrito')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WrapperSelect,{style:{width:'100% '}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(InputLabel,null,'Concelho'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledSelect,{disabled:citiesDisabled,placeholder:'Concelho',items:cities,onChange:function onChange(_ref7){var value=_ref7.value;return setValues({municipality:value});},selected:municipality,arrowIcon:__WEBPACK_IMPORTED_MODULE_10__images_ic_arrow_component_svg___default.a}),this.renderInvalidMessage(locationInvalid,'municipality','Concelho'))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(MobileSection,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_components_SectionHeader__["a" /* default */],{title:'Agregado Familiar',subTitle:'Por favor, selecione um cen\xE1rio.'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(MobileSection,{style:{gap:'8px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_InlineRadioV2__["a" /* default */],{style:{width:'100%'},onClick:function onClick(){setValues({habitants:1});},icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(PersonIconWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__images_person_component_svg___default.a,null),' ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,'1'),' '),name:'1 Pessoa',selected:habitants===1}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_InlineRadioV2__["a" /* default */],{style:{width:'100%'},onClick:function onClick(){setValues({habitants:2});},icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(PersonIconWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__images_person_component_svg___default.a,null),' ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,'2'),' '),name:'2 Pessoas',selected:habitants===2}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_InlineRadioV2__["a" /* default */],{style:{width:'100%'},onClick:function onClick(){setValues({habitants:3});},icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(PersonIconWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__images_person_component_svg___default.a,null),' ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,'3'),' '),name:'3 Pessoas',selected:habitants===3}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_InlineRadioV2__["a" /* default */],{style:{width:'100%'},onClick:function onClick(){setValues({habitants:4});},icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(PersonIconWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__images_person_component_svg___default.a,null),' ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,'4'),' '),name:'4 Pessoas',selected:habitants===4}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_InlineRadioV2__["a" /* default */],{style:{width:'100%'},onClick:function onClick(){setValues({habitants:5});},icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(PersonIconWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__images_person_component_svg___default.a,null),' ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,'5'),' '),name:'5 ou mais pessoas',selected:habitants===5})),this.renderInvalidMessage(habitantsInvalid,'habitants','Agregado Familiar')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(MobileSection,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_components_SectionHeader__["a" /* default */],{title:'Op\xE7\xF5es Adicionais',required:false,subTitle:'Por favor, selecione uma ou v\xE1rias op\xE7\xF5es.'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_InlineCheckV2__["a" /* default */],{style:{width:'100%'},onClick:function onClick(){setValues({hasElectricCar:!hasElectricCar});},icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__images_ic_eletric_car_component_svg___default.a,null),name:'Carro El\xE9trico',selected:hasElectricCar}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_InlineCheckV2__["a" /* default */],{style:{width:'100%'},onClick:function onClick(){setValues({hasSolarSystem:!hasSolarSystem});},icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__images_ic_solar_component_svg___default.a,null),name:'Energias Renov\xE1veis',selected:hasSolarSystem}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_InlineCheckV2__["a" /* default */],{disabled:values.offerType===2,style:{width:'100%'},onClick:function onClick(){setValues({hasNaturalGasHeating:!hasNaturalGasHeating});},icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__images_ic_gas_component_svg___default.a,null),name:'Aquecimento centralizado a G\xE1s Natural',selected:hasNaturalGasHeating}))));return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_components_FixedWrapper__["a" /* default */],null,SimulateSection,GeneralSection),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Message,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('p',null,'A simula\xE7\xE3o tem por base consumos t\xEDpicos para as op\xE7\xF5es selecionadas e pre\xE7os do mercado regulado. Para adaptar a simula\xE7\xE3o aos seus consumos introduza os seus dados na op\xE7\xE3o',' ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',null,'\u201CAjustar Valores\u201D'),' do menu seguinte.')),this.renderSubmitButton());}}]);return ProfileV2;}(__WEBPACK_IMPORTED_MODULE_15_containers_FormV2__["a" /* default */]))||_class;var GeneralWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject);var MobileGeneralWrapper=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(GeneralWrapper)(_templateObject2);var MobileSection=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject3);var InsideSection=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject4);var LocationInputsWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject5);var InputsWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject6);var PersonIconWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject7);var WrapperSelect=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject8);var StyledSelect=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_23_components_SelectV2__["a" /* default */])(_templateObject9,function(_ref8){var margin=_ref8.margin;return margin&&'margin-right: 30px;';});var InputLabel=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].label(_templateObject10);var ButtonContainer=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject11);var Message=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject12);var Error=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject13);

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LOADING_COUNT */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_kea__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_kea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_kea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_saga__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_containers_AppV2_logic__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_validations__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_omit__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_find__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_forEach__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_electricityplusgas_component_svg__ = __webpack_require__(1667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_electricityplusgas_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__images_electricityplusgas_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_electricity_component_svg__ = __webpack_require__(1666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_electricity_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__images_electricity_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_gas_component_svg__ = __webpack_require__(1668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_gas_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__images_gas_component_svg__);
var DISTRICTS_ENDPOINT=__WEBPACK_IMPORTED_MODULE_3_config__["b" /* API_BASE_URL */]+'/public/district/';var CITIES_ENDPOINT=__WEBPACK_IMPORTED_MODULE_3_config__["b" /* API_BASE_URL */]+'/public/municipality/';var CONSUMER_PROFILE=__WEBPACK_IMPORTED_MODULE_3_config__["b" /* API_BASE_URL */]+'/public/simulator/consumer_profile/';var LOADING_COUNT=2;var fields={offerType:[__WEBPACK_IMPORTED_MODULE_11_validations__["a" /* Validations */].isUndefined],district:[__WEBPACK_IMPORTED_MODULE_11_validations__["a" /* Validations */].isUndefined],municipality:[__WEBPACK_IMPORTED_MODULE_11_validations__["a" /* Validations */].isUndefined],habitants:[__WEBPACK_IMPORTED_MODULE_11_validations__["a" /* Validations */].isUndefined],hasSolarSystem:[__WEBPACK_IMPORTED_MODULE_11_validations__["a" /* Validations */].isUndefined],hasElectricCar:[__WEBPACK_IMPORTED_MODULE_11_validations__["a" /* Validations */].isUndefined],hasNaturalGasHeating:[__WEBPACK_IMPORTED_MODULE_11_validations__["a" /* Validations */].isUndefined]/* eslint-disable camelcase */};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_kea__["kea"])({path:function path(){return['scenes','profileV2'];},actions:function actions(){return{setDistricts:function setDistricts(districts){return{districts:districts};},setData:function setData(data){return{data:data};},setCities:function setCities(cities){return{cities:cities};},setInvalid:function setInvalid(invalid){return{invalid:invalid};},setCurrentLocation:function setCurrentLocation(currentLocation){return{currentLocation:currentLocation};},increment:function increment(){return{};},removeCities:function removeCities(cities){return{cities:cities};},fetchDistricts:function fetchDistricts(limit){return{limit:limit};},fetchCities:function fetchCities(district){return{district:district};},fetchData:function fetchData(){return{};},setDataFetchError:function setDataFetchError(fetchDataError){return{fetchDataError:fetchDataError};},setDistrictsFetchError:function setDistrictsFetchError(fetchDistrictError){return{fetchDistrictError:fetchDistrictError};},setCitiesFetchError:function setCitiesFetchError(fetchCitiesError){return{fetchCitiesError:fetchCitiesError};}};},reducers:function reducers(_ref){var _ref4,_ref7;var actions=_ref.actions;return{currentLocalization:[null,__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.setCurrentLocation,function(state,payload){return payload.currentLocation;})],districts:[[],__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.array,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.setDistricts,function(state,payload){return[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(payload.districts));})],cities:[[],__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.array,(_ref4={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref4,actions.setCities,function(state,payload){return[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(payload.cities));}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref4,actions.removeCities,function(state,payload){return __WEBPACK_IMPORTED_MODULE_12_lodash_omit___default()(state,payload.cities);}),_ref4)],data:[{},__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.setData,function(state,payload){return Object.assign({},payload.data);})],fields:[fields,__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,{}],invalid:[{},__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.array,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({},actions.setInvalid,function(_,payload){return payload.invalid;})],loading:[LOADING_COUNT,__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,(_ref7={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.setDistricts,function(state){return state&&state-1;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.setData,function(state){return state&&state-1;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.setDataFetchError,function(){return 0;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.setCities,function(state){return state&&state-1;}),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref7,actions.increment,function(state){return state+1;}),_ref7)]};},takeLatest:function takeLatest(_ref8){var _ref9;var actions=_ref8.actions,workers=_ref8.workers;return _ref9={},__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref9,actions.fetchDistricts,workers.fetchDistricts),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref9,actions.setDistricts,workers.setFromLocation),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref9,actions.setCities,workers.setMunicipalityFromLocation),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref9,actions.setCurrentLocation,workers.setFromLocation),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref9,actions.setDistrict,workers.fetchCities),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref9,actions.fetchCities,workers.fetchCities),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref9,actions.fetchData,workers.fetchData),_ref9;},start:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function start(){var _actions,fetchDistricts,fetchData,fetchCities,increment,_ref10,simulationFinished,values,settings;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function start$(_context){while(1){switch(_context.prev=_context.next){case 0:_actions=this.actions,fetchDistricts=_actions.fetchDistricts,fetchData=_actions.fetchData,fetchCities=_actions.fetchCities,increment=_actions.increment;_context.next=3;return __WEBPACK_IMPORTED_MODULE_10_containers_AppV2_logic__["a" /* default */].get('finished');case 3:_ref10=_context.sent;simulationFinished=_ref10.simulationFinished;_context.next=7;return __WEBPACK_IMPORTED_MODULE_10_containers_AppV2_logic__["a" /* default */].get('values');case 7:values=_context.sent;_context.next=10;return __WEBPACK_IMPORTED_MODULE_10_containers_AppV2_logic__["a" /* default */].get('settings');case 10:settings=_context.sent;_context.next=13;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_saga__["delay"])(800);case 13:if(!(simulationFinished||!values.simulationCode)){_context.next=25;break;}_context.next=16;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(fetchDistricts(100));case 16:_context.next=18;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["take"])();case 18:if(!(settings.isFromProfile||settings.isFromUrl)){_context.next=23;break;}_context.next=21;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(increment());case 21:_context.next=23;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(fetchCities());case 23:_context.next=25;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(fetchData());case 25:case'end':return _context.stop();}}},start,this);}),workers:{/**
     * Fetches the needed data
     * @param {*} action
     */fetchData:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchData(action){var _actions2,setData,setDataFetchError,setValues,_ref11,simulationFinished,settings,values,params,data,offerTypes,simulationCode,defaultValues,setFinished,goToResults,dataSimulationChanged;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchData$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_actions2=this.actions,setData=_actions2.setData,setDataFetchError=_actions2.setDataFetchError,setValues=_actions2.setValues;_context2.next=3;return __WEBPACK_IMPORTED_MODULE_10_containers_AppV2_logic__["a" /* default */].get('finished');case 3:_ref11=_context2.sent;simulationFinished=_ref11.simulationFinished;_context2.next=7;return __WEBPACK_IMPORTED_MODULE_10_containers_AppV2_logic__["a" /* default */].get('settings');case 7:settings=_context2.sent;_context2.next=10;return __WEBPACK_IMPORTED_MODULE_10_containers_AppV2_logic__["a" /* default */].get('values');case 10:values=_context2.sent;params={format:'json',type:__WEBPACK_IMPORTED_MODULE_3_config__["o" /* isSimple */]?'s':'b'};_context2.prev=12;_context2.next=15;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_9_axios___default.a.post,CONSUMER_PROFILE,params);case 15:data=_context2.sent;offerTypes=data.data&&data.data.offer_types.sort(function(a,b){return a.order-b.order;}).map(function(_ref12){var id=_ref12.id,slug=_ref12.slug,name=_ref12.name;var icon=void 0;switch(slug){case'e':icon=__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__images_electricity_component_svg___default.a,null);break;case'g':icon=__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__images_gas_component_svg___default.a,null);break;case'eg':icon=__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__images_electricityplusgas_component_svg___default.a,null);break;default:icon=__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__images_electricity_component_svg___default.a,null);}return{text:(name+'').replace(' + ','<br />+<br />'),value:id,icon:icon,id:id,slug:slug};});// Set the default values after getting the data
simulationCode=data.data.simulation_code;defaultValues={};if(!simulationFinished&&!settings.isFromProfile&&!settings.isFromUrl){defaultValues={simulationCode:simulationCode,habitants:undefined,district:undefined,municipality:undefined,offerType:__WEBPACK_IMPORTED_MODULE_13_lodash_find___default()(offerTypes,function(_ref13){var slug=_ref13.slug;return slug==='e';}).id,hasElectricCar:false,hasNaturalGasHeating:false,hasSolarSystem:false};}else{// Reset simulation code
defaultValues={simulationCode:simulationCode};}if(values.district){defaultValues=Object.assign({},defaultValues,{district:values.district});}_context2.next=23;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setValues(defaultValues));case 23:_context2.next=25;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setData({offerTypes:offerTypes}));case 25:setFinished=this.actions.setFinished;_context2.next=28;return __WEBPACK_IMPORTED_MODULE_10_containers_AppV2_logic__["a" /* default */].get('goToResults');case 28:goToResults=_context2.sent;_context2.next=31;return __WEBPACK_IMPORTED_MODULE_10_containers_AppV2_logic__["a" /* default */].get('dataSimulationChanged');case 31:dataSimulationChanged=_context2.sent;if(goToResults&&!dataSimulationChanged){setFinished({profileFinished:true});this.props.router.push('/resultados');}_context2.next=39;break;case 35:_context2.prev=35;_context2.t0=_context2['catch'](12);_context2.next=39;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setDataFetchError(_context2.t0));case 39:case'end':return _context2.stop();}}},fetchData,this,[[12,35]]);}),/**
     * Fetchs all Districts
     * @param {*} action
     */fetchDistricts:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchDistricts(action){var limit,_actions3,setDistricts,setDistrictsFetchError,params,districts,filteredDistricts;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchDistricts$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:limit=action.payload.limit;_actions3=this.actions,setDistricts=_actions3.setDistricts,setDistrictsFetchError=_actions3.setDistrictsFetchError;params={limit:limit,format:'json'};_context3.prev=3;_context3.next=6;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_9_axios___default.a.get,DISTRICTS_ENDPOINT,{params:params});case 6:districts=_context3.sent;filteredDistricts=districts.data.results.map(function(_ref14){var id=_ref14.id,name=_ref14.name;return{label:name,value:id};});_context3.next=10;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setDistricts(filteredDistricts));case 10:_context3.next=16;break;case 12:_context3.prev=12;_context3.t0=_context3['catch'](3);_context3.next=16;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setDistrictsFetchError(_context3.t0));case 16:case'end':return _context3.stop();}}},fetchDistricts,this,[[3,12]]);}),/**
     * Fetches all municipalities from a district
     * @param {*} action
     */fetchCities:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchCities(action){var district,_actions4,setCities,setCitiesFetchError,params,cities,results;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchCities$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:district=action.payload.district;_actions4=this.actions,setCities=_actions4.setCities,setCitiesFetchError=_actions4.setCitiesFetchError;params={limit:1000,format:'json',district:district};_context4.prev=3;_context4.next=6;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_9_axios___default.a.get,CITIES_ENDPOINT,{params:params});case 6:cities=_context4.sent;results=cities.data.results;results=results.map(function(_ref15){var id=_ref15.id,name=_ref15.name,district=_ref15.district;return{value:id,label:name,district:district.id};});_context4.next=11;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setCities(results));case 11:_context4.next=17;break;case 13:_context4.prev=13;_context4.t0=_context4['catch'](3);_context4.next=17;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setCitiesFetchError(_context4.t0));case 17:case'end':return _context4.stop();}}},fetchCities,this,[[3,13]]);}),setFromLocation:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function setFromLocation(){var setValues,districts,currentLocation,distrito;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setFromLocation$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:setValues=this.actions.setValues;_context5.next=3;return this.get('districts');case 3:districts=_context5.sent;_context5.next=6;return this.get('currentLocalization');case 6:currentLocation=_context5.sent;if(!(currentLocation&&!!currentLocation.length)){_context5.next=13;break;}distrito=null;__WEBPACK_IMPORTED_MODULE_14_lodash_forEach___default()(currentLocation,function(_ref16){var long_name=_ref16.long_name;var find=districts&&districts.find(function(_ref17){var label=_ref17.label;return label.toLowerCase()===long_name.toLowerCase();});if(find){distrito=find;return false;}});if(!distrito){_context5.next=13;break;}_context5.next=13;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setValues({district:distrito.value}));case 13:case'end':return _context5.stop();}}},setFromLocation,this);}),setMunicipalityFromLocation:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function setMunicipalityFromLocation(){var setValues,cities,currentLocation,cidade;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setMunicipalityFromLocation$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:setValues=this.actions.setValues;_context6.next=3;return this.get('cities');case 3:cities=_context6.sent;_context6.next=6;return this.get('currentLocalization');case 6:currentLocation=_context6.sent;cidade=null;if(!(currentLocation&&!!currentLocation.length)){_context6.next=14;break;}// Search First for administrative area level 2 and 3
__WEBPACK_IMPORTED_MODULE_14_lodash_forEach___default()(currentLocation,function(location){var find=cities&&cities.find(function(_ref18){var label=_ref18.label;return label.toLowerCase()===location.long_name.toLowerCase()&&(location.types[0]==='administrative_area_level_2'||location.types[0]==='administrative_area_level_3');});if(find){cidade=find;return false;}});// If search is empty search by the name
if(!cidade){__WEBPACK_IMPORTED_MODULE_14_lodash_forEach___default()(currentLocation,function(location){var find=cities&&cities.find(function(_ref19){var label=_ref19.label;return label.toLowerCase()===location.long_name.toLowerCase();});if(find){cidade=find;return false;}});}if(!cidade){_context6.next=14;break;}_context6.next=14;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setValues({municipality:cidade.value}));case 14:case'end':return _context6.stop();}}},setMunicipalityFromLocation,this);})},connect:{actions:[__WEBPACK_IMPORTED_MODULE_10_containers_AppV2_logic__["a" /* default */],['setValue','setValues','setFinished']],props:[__WEBPACK_IMPORTED_MODULE_10_containers_AppV2_logic__["a" /* default */],['values','finished','translations','iframed','goToResults']]}}));

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RatingStandalone; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_RatingContent__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_RatingHeader__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_RatingFooter__ = __webpack_require__(881);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n'],['\n  width: 100%;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 1 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 32px 16px;\n  background: #f2f4f3;\n'],['\n  flex: 1 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 32px 16px;\n  background: #f2f4f3;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  max-width: 640px;\n  background: #fff;\n  border: 1px solid #ececec;\n'],['\n  width: 100%;\n  max-width: 640px;\n  background: #fff;\n  border: 1px solid #ececec;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 40px 24px;\n  text-align: center;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 40px 24px;\n  text-align: center;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #1d1e22;\n  font-family: Nunito;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 28px;\n  margin: 0;\n'],['\n  color: #1d1e22;\n  font-family: Nunito;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 28px;\n  margin: 0;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #3e3e3e;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  margin: 0;\n'],['\n  color: #3e3e3e;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  margin: 0;\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin-top: 8px;\n  padding: 8px 24px;\n  border: none;\n  cursor: pointer;\n  color: #fff;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 500;\n  background: linear-gradient(270deg, #006736 -58.87%, #93c13e 100%);\n'],['\n  margin-top: 8px;\n  padding: 8px 24px;\n  border: none;\n  cursor: pointer;\n  color: #fff;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 500;\n  background: linear-gradient(270deg, #006736 -58.87%, #93c13e 100%);\n']);/**
 * Página autónoma da avaliação da adesão (rating).
 *
 * Réplica em React do template rating.php do WordPress. É uma página completa,
 * com header e footer próprios, para o utilizador ser direcionado diretamente
 * aqui (a partir do link do email) sem necessidade de iframe.
 *
 * O link do email aponta para `.../apps/simulador-rating/?subscription=X&token=Y`
 * e os parâmetros são lidos de window.location.search. Têm de vir na query
 * string real (antes de qualquer '#'), porque a app usa hash history.
 *
 * Montada através do id `adene-simulador-rating` (ver index.js / index.html).
 */var RatingStandalone=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(RatingStandalone,_Component);function RatingStandalone(props){__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,RatingStandalone);var _this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(RatingStandalone.__proto__||Object.getPrototypeOf(RatingStandalone)).call(this,props));_this.handleSuccess=function(){// Mantemos o aviso ao eventual pai (inócuo quando não há iframe) e mostramos
// a confirmação de agradecimento.
window.parent.postMessage({type:'submitted'},'*');_this.setState({submitted:true});};_this.handleClose=function(){// Sem iframe (window.parent === window), reencaminha para o site;
// dentro de um iframe, avisa o pai para fechar.
if(window.parent===window){window.location.href='https://poupaenergia.pt/';}else{window.parent.postMessage({type:'close'},'*');}};var params=new URLSearchParams(window.location.search);var subscription=params.get('subscription');var token=params.get('token');_this.state={subscription:subscription,token:token,// Sem token/subscription não dá para submeter: mostramos erro inline.
invalid:!subscription||!token,submitted:false};return _this;}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(RatingStandalone,[{key:'render',value:function render(){var _state=this.state,subscription=_state.subscription,token=_state.token,invalid=_state.invalid,submitted=_state.submitted;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Page,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_RatingHeader__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Main,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Box,null,invalid?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Message,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(MessageTitle,null,'Link inv\xE1lido ou expirado'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(MessageText,null,'N\xE3o foi poss\xEDvel abrir a avalia\xE7\xE3o. Por favor, utilize o link enviado no seu email.')):submitted?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Message,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(MessageTitle,null,'Obrigado!'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(MessageText,null,'O seu contributo \xE9 importante para melhorar o Poupa Energia'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CloseButton,{type:'button',onClick:this.handleClose},'Fechar')):__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_RatingContent__["a" /* default */],{subscription:subscription,token:token,onSuccess:this.handleSuccess}))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_RatingFooter__["a" /* default */],null));}}]);return RatingStandalone;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);var Page=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject);var Main=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].main(_templateObject2);var Box=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject3);var Message=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject4);var MessageTitle=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].h3(_templateObject5);var MessageText=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].p(_templateObject6);var CloseButton=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].button(_templateObject7);

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Orders */
/* unused harmony export SearchInputOptions */
/* unused harmony export OrderSelectOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Results; });
/* unused harmony export ResultsWrapper */
/* unused harmony export Container */
/* unused harmony export Header */
/* unused harmony export SearchInput */
/* unused harmony export OrderSelect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_flexbox_grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_flexbox_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_flexbox_grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ubiwherenpm_adene_ui_components__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Section__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__logic__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_containers_Profile_images_adulto_component_svg__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_containers_Profile_images_adulto_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_containers_Profile_images_adulto_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Svg_search_svg__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Svg_search_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_Svg_search_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Svg_arrow_svg__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Svg_arrow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_components_Svg_arrow_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Svg_order_svg__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Svg_order_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_components_Svg_order_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_TopResult__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_NoResults__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_Loading__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_Simulating__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_Pagination__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_Select__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_EditPricesModal__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_containers_ResultsList__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_containers_Filters__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_containers_SaveProfileModal__ = __webpack_require__(935);
var _class;var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n'],['\n  width: 100%;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  height: 100%;\n  background-color: #f9f9f9;\n  margin-top: 140px;\n  padding: 70px 0 20px 0;\n'],['\n  width: 100%;\n  height: 100%;\n  background-color: #f9f9f9;\n  margin-top: 140px;\n  padding: 70px 0 20px 0;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 1200px;\n  margin: 0 auto;\n\n  @media (max-width: 1280px) {\n    width: 100%;\n    box-sizing: border-box;\n  }\n'],['\n  width: 1200px;\n  margin: 0 auto;\n\n  @media (max-width: 1280px) {\n    width: 100%;\n    box-sizing: border-box;\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: 40px;\n  position: relative;\n  z-index: 11;\n  float: right;\n\n  @media (max-width: 1280px) {\n    width: 100%;\n    box-sizing: border-box;\n    margin-top: 70px;\n  }\n'],['\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: 40px;\n  position: relative;\n  z-index: 11;\n  float: right;\n\n  @media (max-width: 1280px) {\n    width: 100%;\n    box-sizing: border-box;\n    margin-top: 70px;\n  }\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 250px;\n\n  @media (max-width: 1280px) {\n    width: 100%;\n    box-sizing: border-box;\n  }\n'],['\n  width: 250px;\n\n  @media (max-width: 1280px) {\n    width: 100%;\n    box-sizing: border-box;\n  }\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  min-width: 280px;\n  margin-left: 10px;\n'],['\n  min-width: 280px;\n  margin-left: 10px;\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  width: 890px;\n  margin: 20px auto;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n'],['\n  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  width: 890px;\n  margin: 20px auto;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-weight: bold;\n  margin-left: 10px;\n'],['\n  font-weight: bold;\n  margin-left: 10px;\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  cursor: pointer;\n  color: #93c13e;\n'],['\n  cursor: pointer;\n  color: #93c13e;\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #bababa;\n  font-size: 14px;\n  line-height: 18px;\n  text-align: center;\n  display: block;\n  margin: 10px auto;\n  margin-top: 40px;\n'],['\n  color: #bababa;\n  font-size: 14px;\n  line-height: 18px;\n  text-align: center;\n  display: block;\n  margin: 10px auto;\n  margin-top: 40px;\n']),_templateObject11=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding: 14px;\n  margin-left: 10px;\n  width: 150px;\n\n  ','\n'],['\n  padding: 14px;\n  margin-left: 10px;\n  width: 150px;\n\n  ','\n']);var Orders=[{label:'Ordernar por preço ascendente',value:'asc'},{label:'Ordernar por preço descendente',value:'dec'}];var SearchInputOptions={type:'text',placeholder:'Nome do comercializador… ',icon:__WEBPACK_IMPORTED_MODULE_13_components_Svg_search_svg___default.a};var OrderSelectOptions={placeholder:'Ordernar..',items:Orders,icon:__WEBPACK_IMPORTED_MODULE_15_components_Svg_order_svg___default.a,arrowIcon:__WEBPACK_IMPORTED_MODULE_14_components_Svg_arrow_svg___default.a};var Results=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__logic__["a" /* default */])(_class=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Results,_Component);function Results(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,Results);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=Results.__proto__||Object.getPrototypeOf(Results)).call.apply(_ref,[this].concat(args))),_this),_this.state={showAll:false},_this.sendHeight=function(){var height=document.body.scrollHeight;window.parent.postMessage({type:'setHeight',height:height},'*');},_this.toggleFilters=function(){var filtering=_this.props.filtering;if(filtering){_this.actions.closeFiltering();}else{_this.actions.openFiltering();}},_temp),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Results,[{key:'componentWillUnmount',value:function componentWillUnmount(){if(__WEBPACK_IMPORTED_MODULE_5_config__["f" /* tipsWidget */]){__WEBPACK_IMPORTED_MODULE_5_config__["f" /* tipsWidget */].style.cssText='';}window.onpopstate=null;}},{key:'componentWillMount',value:function componentWillMount(){if(__WEBPACK_IMPORTED_MODULE_5_config__["f" /* tipsWidget */]){__WEBPACK_IMPORTED_MODULE_5_config__["f" /* tipsWidget */].style.cssText='';}window.removeEventListener('resize',this.sendHeight);}/**
   * Stuff to do on first mount
   */},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;window.onpopstate=function(e){e.preventDefault();_this2.props.router.push('/');};}},{key:'componentDidUpdate',value:function componentDidUpdate(oldProps){var _props=this.props,simulatingPatch=_props.simulatingPatch,simulating=_props.simulating;var oldSimulatingPatch=oldProps.simulatingPatch,oldSimulating=oldProps.simulating;if(!simulating&&!simulatingPatch&&(oldSimulatingPatch||oldSimulating)){var element=document.getElementById('anchor');window.scroll({top:element.getBoundingClientRect().top});}this.sendHeight();window.addEventListener('resize',this.sendHeight);}},{key:'render',value:function render(){var _this3=this;var _props2=this.props,simulation=_props2.simulation,loadingSugested=_props2.loadingSugested,sugestions=_props2.sugestions,simulating=_props2.simulating,router=_props2.router,currentPage=_props2.currentPage,filtering=_props2.filtering,ordering=_props2.ordering,finished=_props2.finished,translations=_props2.translations,showSaveProfileModal=_props2.showSaveProfileModal,showEditPricesModal=_props2.showEditPricesModal,pricesForm=_props2.pricesForm,settings=_props2.settings,startFilters=_props2.startFilters,simulatingPatch=_props2.simulatingPatch,iframed=_props2.iframed,userProfile=_props2.userProfile;var simulationCode=this.props.values.simulationCode;var showAll=this.state.showAll;var _actions=this.actions,changePage=_actions.changePage,search=_actions.search,saveProfile=_actions.saveProfile,toggleSaveProfileModal=_actions.toggleSaveProfileModal,toggleEditPricesModal=_actions.toggleEditPricesModal,editPrices=_actions.editPrices,changePrices=_actions.changePrices,updatePrices=_actions.updatePrices,updateProfile=_actions.updateProfile,getCurrentUser=_actions.getCurrentUser,changeSimulationData=_actions.changeSimulationData;var simulationError=finished&&finished.simulationError?translations['ERROR_'+(finished.simulationErrorCode+'').toUpperCase()]:null;var showResults=!loadingSugested&&sugestions.results&&sugestions.results.length;var isLoading=loadingSugested;var showNoResults=!loadingSugested&&(!sugestions.results||!sugestions.results.length);var bestAnnualBilling=simulation&&simulation.results&&simulation.results.annualBilling;var hasSimulation=simulation&&simulation.results;// this
var isFirstResultNegative=showAll||currentPage>1||isLoading?false// Showing all(ex clicked see more anchor)
:sugestions&&// Has simulation
sugestions.results&&sugestions.results.length&&// has results
ordering!=='dec'&&bestAnnualBilling-sugestions.results[0].annualBilling<=0;// First result anual billing <= 0
if(__WEBPACK_IMPORTED_MODULE_5_config__["f" /* tipsWidget */]&&!simulating){__WEBPACK_IMPORTED_MODULE_5_config__["f" /* tipsWidget */].style.cssText='display:block!important';}if(simulating){if(__WEBPACK_IMPORTED_MODULE_5_config__["f" /* tipsWidget */]){__WEBPACK_IMPORTED_MODULE_5_config__["f" /* tipsWidget */].style.cssText='';}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Simulating__["a" /* default */],null);}if(simulatingPatch){if(__WEBPACK_IMPORTED_MODULE_5_config__["f" /* tipsWidget */]){__WEBPACK_IMPORTED_MODULE_5_config__["f" /* tipsWidget */].style.cssText='';}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Simulating__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Section__["a" /* default */],{title:'Visualize os resultados da sua simula\xE7\xE3o',subtitle:'Escolha o tarif\xE1rio que mais se adequa a si e mude j\xE1',noContainer:true,style:{backgroundColor:'#F9F9F9'},id:'results',compact:iframed},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ResultsWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Container,{fluid:true},filtering&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_containers_Filters__["a" /* default */],{renderClose:function renderClose(){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(FilterButton,{close:true,onClick:_this3.toggleFilters},'Fechar');},startFilters:startFilters}),!filtering&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_TopResult__["a" /* default */],Object.assign({changeSimulationData:changeSimulationData,hasSimulation:hasSimulation,error:simulationError},simulation.results,{simulationCode:simulationCode,router:router,onClickToSave:saveProfile,onClickToChangePrices:editPrices})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{id:'changePage'}),(showAll||isFirstResultNegative)&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Best,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_containers_Profile_images_adulto_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Message,null,'O seu tarif\xE1rio \xE9 o melhor.',' ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Anchor,{onClick:function onClick(){return _this3.setState({showAll:!showAll});}},'Ver outras alternativas'))),sugestions.results&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Disclaimer,{dangerouslySetInnerHTML:{__html:translations.RESULTS_DISCLAIMER}}),hasSimulation&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Header,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SearchInput,Object.assign({},SearchInputOptions,{onChange:function onChange(e){return search(e.target.value);}})),!filtering&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(FilterButton,{onClick:this.toggleFilters},'Filtrar')),hasSimulation&&showResults&&!isFirstResultNegative&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_containers_ResultsList__["a" /* default */],{userProfile:userProfile,results:sugestions.results,simulation:simulation.results,bestAnnualBilling:bestAnnualBilling}),hasSimulation&&showNoResults&&!isFirstResultNegative&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_NoResults__["a" /* default */],null),isLoading&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Loading__["a" /* default */],null),hasSimulation&&showResults&&!isFirstResultNegative&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_Pagination__["a" /* default */],{count:sugestions.count,pageChange:function pageChange(params){setTimeout(function(){var element=document.getElementById('changePage');if(element){window.scrollTo({top:element.offsetTop,behavior:'smooth'});}},100);changePage(params);},currentPage:currentPage})))),showSaveProfileModal.opened&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_containers_SaveProfileModal__["a" /* default */],Object.assign({},showSaveProfileModal,{onClose:function onClose(){return toggleSaveProfileModal({opened:false});},toogler:toggleSaveProfileModal,updateProfile:updateProfile,saveProfile:saveProfile,settings:settings,getCurrentUser:getCurrentUser})),showEditPricesModal.opened&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_components_EditPricesModal__["a" /* default */],Object.assign({form:pricesForm,onChange:changePrices,updatePrices:updatePrices},simulation.results,{onClose:function onClose(){return toggleEditPricesModal({opened:false});},toogler:toggleEditPricesModal})));}}]);return Results;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]))||_class;var Wrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject);var ResultsWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject2);var Container=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_8_react_flexbox_grid__["Grid"])(_templateObject3);var Header=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject4);var SearchInput=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_9__ubiwherenpm_adene_ui_components__["a" /* Input */])(_templateObject5);var OrderSelect=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_21_components_Select__["a" /* default */])(_templateObject6);var Best=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject7);var Message=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject8);var Anchor=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject9);var Disclaimer=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject10);var FilterButton=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_9__ubiwherenpm_adene_ui_components__["b" /* SimpleButton */])(_templateObject11,function(_ref2){var close=_ref2.close;return close&&'\n  position: absolute;\n  right: 0px;\n  ';});

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Results; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_animate_css_styled_components__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_animate_css_styled_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_animate_css_styled_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logic__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_containers_TariffSubscribeModal__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_ResultItem__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_ModalExtended__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_TariffDetails__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Loading__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_utils__ = __webpack_require__(11);
var _class;var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  min-height: 500px;\n  width: 100%;\n  position: relative;\n  padding: 20px 0;\n  top: -70px;\n  z-index: 10;\n  display: flex;\n  flex-wrap: wrap;\n\n  @media (max-width: 1280px) {\n    top: 0;\n  }\n\n  > div {\n    width: 100%;\n  }\n'],['\n  min-height: 500px;\n  width: 100%;\n  position: relative;\n  padding: 20px 0;\n  top: -70px;\n  z-index: 10;\n  display: flex;\n  flex-wrap: wrap;\n\n  @media (max-width: 1280px) {\n    top: 0;\n  }\n\n  > div {\n    width: 100%;\n  }\n']);var Results=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__logic__["a" /* default */])(_class=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Results,_Component);function Results(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,Results);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=Results.__proto__||Object.getPrototypeOf(Results)).call.apply(_ref,[this].concat(args))),_this),_this.state={moreOpen:false,adhesionOpen:false,adhesionTariff:null,priceListTimeCycle:null/** Detail modal buttons */},_this.detailsButtons=[{label:'fechar',color:'#006736',primary:false,click:function click(){return _this.toggleMoreModal(null);}},{label:'aderir',primary:true,click:function click(){return _this.switchToAdhere();}}],_this.switchToAdhere=function(){_this.setState({moreOpen:false,detailsTariff:null,adhesionOpen:true});},_this.toggleMoreModal=function(tariff){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_utils__["e" /* sendGevent */])('simulador','Saber mais','Saber mais sobre um tarifário');tariff&&_this.actions.fetchTariffInfo(tariff.id);var tariffPriceListTimeCycle=tariff&&tariff.priceListTimeCycle;_this.setState({moreOpen:!_this.state.moreOpen,detailsTariff:tariff,adhesionTariff:tariff,priceListTimeCycle:tariffPriceListTimeCycle||null});},_this.toggleAdhereModal=function(tariff){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_utils__["e" /* sendGevent */])('simulador','Aderir','Aderir a um tarifário');_this.setState({adhesionTariff:tariff,adhesionOpen:!_this.state.adhesionOpen});},_temp),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}/**
   * Opens/Closes KnowMore modal
   *//**
   * Opens/Closes aderir modal
   */__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Results,[{key:'render',value:function render(){var _this2=this;var _props=this.props,results=_props.results,filters=_props.filters,bestAnnualBilling=_props.bestAnnualBilling,loading=_props.loading,simulation=_props.simulation,tariffInfo=_props.tariffInfo,userProfile=_props.userProfile,translations=_props.translations;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Wrapper,null,results&&results.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_animate_css_styled_components__["FadeIn"],{duration:'0.4s',key:'result-'+item.id+'-'+index,id:'result-'+index},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_animate_css_styled_components__["SlideInUp"],{duration:'0.4s',delay:index*0.08+'s'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_ResultItem__["c" /* default */],Object.assign({},item,{bestAnnualBilling:bestAnnualBilling,clickMore:_this2.toggleMoreModal,clickAdhere:_this2.toggleAdhereModal,filters:filters,translations:translations}))));}),this.state.detailsTariff&&this.state.moreOpen&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_ModalExtended__["a" /* default */],{title:'detalhes do tarif\xE1rio',toggle:this.state.moreOpen,onClick:this.toggleMoreModal,custom:false,buttons:this.detailsButtons},!loading&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_TariffDetails__["a" /* default */],{tariff:tariffInfo,resultTariff:this.state.detailsTariff,priceListTimeCycle:this.state.priceListTimeCycle}),loading&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Loading__["a" /* default */],null)),this.state.adhesionTariff&&this.state.adhesionOpen&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_containers_TariffSubscribeModal__["a" /* default */],{userProfile:userProfile,tariff:this.state.adhesionTariff,changeTariff:this.toggleAdhereModal,simulation:simulation,isHome:false}));}}]);return Results;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]))||_class;var Wrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject);

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_kea__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_kea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_kea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_containers_App_logic__ = __webpack_require__(42);
// import TariffSubscribeModal from 'containers/TariffSubscribeModal/logic'
var PRICELIST_ENDPOINT=__WEBPACK_IMPORTED_MODULE_2_config__["b" /* API_BASE_URL */]+'/public/price-list';var MARKET_SEGMENT_ENDPOINT=__WEBPACK_IMPORTED_MODULE_2_config__["b" /* API_BASE_URL */]+'/public/market-segment';/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_kea__["kea"])({connect:{props:[__WEBPACK_IMPORTED_MODULE_7_containers_App_logic__["a" /* default */],['translations']]},actions:function actions(){return{fetchTariffInfo:function fetchTariffInfo(id){return{id:id};},setTariffInfo:function setTariffInfo(tariffInfo){return{tariffInfo:tariffInfo};},setFetchError:function setFetchError(message){return{message:message};}};},reducers:function reducers(_ref){var _ref3;var actions=_ref.actions;return{tariffInfo:[null,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.setTariffInfo,function(_,payload){return payload.tariffInfo;})],loading:[true,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,(_ref3={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3,actions.fetchTariffInfo,function(){return true;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3,actions.setTariffInfo,function(){return false;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3,actions.setFetchError,function(){return false;}),_ref3)]};},takeLatest:function takeLatest(_ref4){var actions=_ref4.actions,workers=_ref4.workers;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.fetchTariffInfo,workers.fetchTariffInfo);},workers:{fetchTariffInfo:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchTariffInfo(action){var id,_actions,setTariffInfo,setFetchError,info,data,marketSegmentsList,marketSegmentsData,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,_id,singleMs;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchTariffInfo$(_context){while(1){switch(_context.prev=_context.next){case 0:id=action.payload.id;_actions=this.actions,setTariffInfo=_actions.setTariffInfo,setFetchError=_actions.setFetchError;if(!id){_context.next=47;break;}_context.prev=3;_context.next=6;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get,PRICELIST_ENDPOINT+'/'+id+'/');case 6:info=_context.sent;data=info.data;marketSegmentsList=data.pricelistadditionalinfo.market_segment_type||[];marketSegmentsData=[];_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context.prev=13;_iterator=marketSegmentsList[Symbol.iterator]();case 15:if(_iteratorNormalCompletion=(_step=_iterator.next()).done){_context.next=24;break;}_id=_step.value;_context.next=19;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get,MARKET_SEGMENT_ENDPOINT+'/'+_id+'/');case 19:singleMs=_context.sent;marketSegmentsData.push(singleMs.data);case 21:_iteratorNormalCompletion=true;_context.next=15;break;case 24:_context.next=30;break;case 26:_context.prev=26;_context.t0=_context['catch'](13);_didIteratorError=true;_iteratorError=_context.t0;case 30:_context.prev=30;_context.prev=31;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 33:_context.prev=33;if(!_didIteratorError){_context.next=36;break;}throw _iteratorError;case 36:return _context.finish(33);case 37:return _context.finish(30);case 38:data.pricelistadditionalinfo.market_segment_type=marketSegmentsData.map(function(_ref6){var name=_ref6.name;return name;}).join(', ');_context.next=41;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setTariffInfo(info.data));case 41:_context.next=47;break;case 43:_context.prev=43;_context.t1=_context['catch'](3);_context.next=47;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["put"])(setFetchError(_context.t1));case 47:case'end':return _context.stop();}}},fetchTariffInfo,this,[[3,43],[13,26,30,38],[31,,33,37]]);})}}));

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Orders */
/* unused harmony export SearchInputOptions */
/* unused harmony export OrderSelectOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Results; });
/* unused harmony export Container */
/* unused harmony export Header */
/* unused harmony export SearchInput */
/* unused harmony export OrderSelect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_flexbox_grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_flexbox_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_flexbox_grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ubiwherenpm_adene_ui_components__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__logic__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_MyTarifSectionV2__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_MyTarifMobileSectionV2__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_ResultsSectionV2__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_ResultsSectionV2_mobile__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_containers_FiltersSectionV2__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_FeedbackModalV2__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_MyTarifSectionV2_images_ic_edit_component_svg__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_MyTarifSectionV2_images_ic_edit_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_components_MyTarifSectionV2_images_ic_edit_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_Svg_search_svg__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_Svg_search_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_components_Svg_search_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_Svg_arrow_svg__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_Svg_arrow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_components_Svg_arrow_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_Svg_order_svg__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_Svg_order_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_components_Svg_order_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_NoResultsV2__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_SimulationTimeoutErrorV2__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_Loading__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_components_Simulating__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_PaginationV2__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_components_Select__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_components_ButtonGradientV2__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__images_success_component_svg__ = __webpack_require__(1673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__images_success_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__images_success_component_svg__);
var _class;var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n'],['\n  width: 100%;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  background: #f9f9f9;\n'],['\n  width: 100%;\n  background: #f9f9f9;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n'],['\n  width: 100%;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  overflow: hidden;\n  color: #1d1e22;\n  text-overflow: ellipsis;\n  font-family: Nunito;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px; /* 133.333% */\n  letter-spacing: 1px;\n'],['\n  overflow: hidden;\n  color: #1d1e22;\n  text-overflow: ellipsis;\n  font-family: Nunito;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px; /* 133.333% */\n  letter-spacing: 1px;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  overflow: hidden;\n  color: #3e3e3e;\n  text-align: center;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  text-overflow: ellipsis;\n  margin: 0;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n\n  > b {\n    cursor: pointer;\n    color: #1d1e22;\n    font-weight: 700;\n    text-decoration-line: underline;\n    text-decoration-style: solid;\n    text-decoration-skip-ink: none;\n    text-decoration-thickness: auto;\n    text-underline-offset: auto;\n    text-underline-position: from-font;\n  }\n'],['\n  overflow: hidden;\n  color: #3e3e3e;\n  text-align: center;\n  font-feature-settings: \'liga\' off, \'clig\' off;\n  text-overflow: ellipsis;\n  margin: 0;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n\n  > b {\n    cursor: pointer;\n    color: #1d1e22;\n    font-weight: 700;\n    text-decoration-line: underline;\n    text-decoration-style: solid;\n    text-decoration-skip-ink: none;\n    text-decoration-thickness: auto;\n    text-underline-offset: auto;\n    text-underline-position: from-font;\n  }\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #010101;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 24px;\n  text-align: center;\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin: 0;\n  padding-top: 16px;\n'],['\n  color: #010101;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 24px;\n  text-align: center;\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin: 0;\n  padding-top: 16px;\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 56px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 12px 0px;\n\n  h3 {\n    flex: 1 0 0;\n    color: #1d1e22;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n    letter-spacing: 1px;\n    margin: 0;\n    text-transform: none;\n    text-align: start;\n  }\n\n  button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    border: none;\n    outline: none;\n    background: transparent;\n\n    cursor: pointer;\n\n    color: #006736;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 20px;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n'],['\n  height: 56px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 12px 0px;\n\n  h3 {\n    flex: 1 0 0;\n    color: #1d1e22;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n    letter-spacing: 1px;\n    margin: 0;\n    text-transform: none;\n    text-align: start;\n  }\n\n  button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    border: none;\n    outline: none;\n    background: transparent;\n\n    cursor: pointer;\n\n    color: #006736;\n    font-feature-settings: \'liga\' off, \'clig\' off;\n    font-family: Nunito;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 20px;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  padding: 0px 20px 16px 20px;\n  align-items: flex-start;\n  gap: 32px;\n  flex-shrink: 0;\n  align-self: stretch;\n  max-width: 1200px;\n  margin-inline: auto;\n\n  @media screen and (min-width: 1300px) {\n    padding-inline: 0px;\n  }\n'],['\n  display: flex;\n  padding: 0px 20px 16px 20px;\n  align-items: flex-start;\n  gap: 32px;\n  flex-shrink: 0;\n  align-self: stretch;\n  max-width: 1200px;\n  margin-inline: auto;\n\n  @media screen and (min-width: 1300px) {\n    padding-inline: 0px;\n  }\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  min-width: 270px;\n'],['\n  min-width: 270px;\n']),_templateObject11=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 1 0 0;\n'],['\n  flex: 1 0 0;\n']),_templateObject12=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 11;\n  position: relative;\n'],['\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 11;\n  position: relative;\n']),_templateObject13=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  display: flex;\n  justify-content: center;\n'],['\n  width: 100%;\n  display: flex;\n  justify-content: center;\n']),_templateObject14=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 1200px;\n  margin: 0 auto;\n\n  @media (max-width: 1280px) {\n    width: 100%;\n    box-sizing: border-box;\n  }\n'],['\n  width: 1200px;\n  margin: 0 auto;\n\n  @media (max-width: 1280px) {\n    width: 100%;\n    box-sizing: border-box;\n  }\n']),_templateObject15=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: 40px;\n  position: relative;\n  z-index: 11;\n  float: right;\n\n  @media (max-width: 1280px) {\n    width: 100%;\n    box-sizing: border-box;\n    margin-top: 70px;\n  }\n'],['\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: 40px;\n  position: relative;\n  z-index: 11;\n  float: right;\n\n  @media (max-width: 1280px) {\n    width: 100%;\n    box-sizing: border-box;\n    margin-top: 70px;\n  }\n']),_templateObject16=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 250px;\n\n  @media (max-width: 1280px) {\n    width: 100%;\n    box-sizing: border-box;\n  }\n'],['\n  width: 250px;\n\n  @media (max-width: 1280px) {\n    width: 100%;\n    box-sizing: border-box;\n  }\n']),_templateObject17=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  min-width: 280px;\n  margin-left: 10px;\n'],['\n  min-width: 280px;\n  margin-left: 10px;\n']);var Orders=[{label:'Ordernar por preço ascendente',value:'asc'},{label:'Ordernar por preço descendente',value:'dec'}];var SearchInputOptions={type:'text',placeholder:'Nome do comercializador… ',icon:__WEBPACK_IMPORTED_MODULE_19_components_Svg_search_svg___default.a};var OrderSelectOptions={placeholder:'Ordernar..',items:Orders,icon:__WEBPACK_IMPORTED_MODULE_21_components_Svg_order_svg___default.a,arrowIcon:__WEBPACK_IMPORTED_MODULE_20_components_Svg_arrow_svg___default.a};var Results=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__logic__["a" /* default */])(_class=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Results,_Component);function Results(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,Results);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=Results.__proto__||Object.getPrototypeOf(Results)).call.apply(_ref,[this].concat(args))),_this),_this.state={showAll:false,width:0,feedbackModal:false,dataModal:false},_this.handleMessage=function(event){if(event.data.triggerFeedbackModal){_this.actions.setModalTriggerHeight(600);_this.setState({feedbackModal:true});}},_this.toggleDataModal=function(){_this.setState({dataModal:!_this.state.dataModal});},_this.sendHeight=function(){var height=document.body.scrollHeight;window.parent.postMessage({type:'setHeight',height:height},'*');},_this.updateWindowDimensions=function(){_this.setState({width:window.innerWidth});},_this.handleResize=function(updateState){updateState&&_this.updateWindowDimensions();_this.sendHeight();},_this.toggleFilters=function(){var filtering=_this.props.filtering;if(filtering){_this.actions.closeFiltering();}else{_this.actions.openFiltering();}},_this.renderCurrentTarfif=function(){var _this$props=_this.props,simulation=_this$props.simulation,router=_this$props.router,values=_this$props.values;var _this$actions=_this.actions,changeSimulationData=_this$actions.changeSimulationData,resetFilters=_this$actions.resetFilters,setSearchQuery=_this$actions.setSearchQuery;var hasSimulation=simulation&&simulation.results;var simulationCode=_this.props.values.simulationCode;return _this.state.width>=1000?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_MyTarifSectionV2__["a" /* default */],Object.assign({dataModal:_this.state.dataModal,toggleDataModal:_this.toggleDataModal,hasSimulation:hasSimulation,router:router,simulationCode:simulationCode,changeSimulationData:changeSimulationData,simulationValues:values,setModalTriggerHeight:_this.actions.setModalTriggerHeight,modalTriggerHeight:_this.props.modalTriggerHeight,resetFilters:resetFilters,setSearchQuery:setSearchQuery},simulation.results)):__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_MyTarifMobileSectionV2__["a" /* default */],Object.assign({dataModal:_this.state.dataModal,toggleDataModal:_this.toggleDataModal,hasSimulation:hasSimulation,router:router,simulationCode:simulationCode,changeSimulationData:changeSimulationData,simulationValues:values,setModalTriggerHeight:_this.actions.setModalTriggerHeight,modalTriggerHeight:_this.props.modalTriggerHeight,resetFilters:resetFilters,setSearchQuery:setSearchQuery},simulation.results));},_this.renderFeedbackModal=function(){var feedbackModal=_this.state.feedbackModal;var feedbackSubmitted=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils__["d" /* getCookie */])('feedbackSubmitted');return feedbackModal&&!feedbackSubmitted?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_FeedbackModalV2__["a" /* default */],{setModalTriggerHeight:_this.actions.setModalTriggerHeight,modalTriggerHeight:_this.props.modalTriggerHeight,width:_this.state.width,onClose:function onClose(){return _this.setState({feedbackModal:false});}}):null;},_this.renderResultSection=function(){var _this$props2=_this.props,simulation=_this$props2.simulation,sugestions=_this$props2.sugestions,ordering=_this$props2.ordering;var order=_this.actions.order;var bestAnnualBilling=simulation&&simulation.results&&simulation.results.annualBilling;return _this.state.width>=1000?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_ResultsSectionV2__["a" /* default */],{count:sugestions.count,ordering:ordering,order:order,results:sugestions.results,bestAnnualBilling:bestAnnualBilling,simulation:simulation,setModalTriggerHeight:_this.actions.setModalTriggerHeight,modalTriggerHeight:_this.props.modalTriggerHeight}):__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_ResultsSectionV2_mobile__["a" /* default */],{ordering:ordering,order:order,count:sugestions.count,results:sugestions.results,bestAnnualBilling:bestAnnualBilling,simulation:simulation,changePage:_this.actions.changePage,setModalTriggerHeight:_this.actions.setModalTriggerHeight,modalTriggerHeight:_this.props.modalTriggerHeight});},_this.renderDesktopFilters=function(){return _this.state.width>=1000?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(FiltersWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_containers_FiltersSectionV2__["a" /* default */],{changePage:_this.actions.changePage,simulation:_this.props.simulation})):null;},_temp),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Results,[{key:'componentWillMount',value:function componentWillMount(){if(__WEBPACK_IMPORTED_MODULE_5_config__["f" /* tipsWidget */]){__WEBPACK_IMPORTED_MODULE_5_config__["f" /* tipsWidget */].style.cssText='';}if(this.state.width<1000){this.actions.resetEntities();this.actions.setSearchQuery('');this.actions.setEntitiesCount(0);this.actions.setEntitiesOffset(0);}}/**
   * Stuff to do on first mount
   */},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;window.onpopstate=function(e){e.preventDefault();_this2.props.router.push('/');};this.handleResize(true);window.addEventListener('resize',this.handleResize);}},{key:'componentDidUpdate',value:function componentDidUpdate(oldProps){var _props=this.props,simulatingPatch=_props.simulatingPatch,simulating=_props.simulating;var oldSimulatingPatch=oldProps.simulatingPatch,oldSimulating=oldProps.simulating;if(!simulating&&!simulatingPatch&&(oldSimulatingPatch||oldSimulating)){var element=document.getElementById('anchor');window.scroll({top:element.getBoundingClientRect().top});}// Remove existing event listener to prevent multiple attachments
window.removeEventListener('message',this.handleMessage);// Add event listener with the bound method
window.addEventListener('message',this.handleMessage);var URLQuery=window.location.search;window.parent.postMessage({type:'setUrlParams',params:URLQuery},'*');this.handleResize(false);window.addEventListener('resize',this.handleResize);}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(__WEBPACK_IMPORTED_MODULE_5_config__["f" /* tipsWidget */]){__WEBPACK_IMPORTED_MODULE_5_config__["f" /* tipsWidget */].style.cssText='';}window.onpopstate=null;window.removeEventListener('resize',this.handleResize);}// Define handleMessage as a class method
},{key:'render',value:function render(){var _this3=this;var _props2=this.props,simulation=_props2.simulation,loadingSugested=_props2.loadingSugested,sugestions=_props2.sugestions,simulating=_props2.simulating,currentPage=_props2.currentPage,simulatingPatch=_props2.simulatingPatch,finished=_props2.finished,translations=_props2.translations;var showAll=this.state.showAll;var _actions=this.actions,changePage=_actions.changePage,resetFilters=_actions.resetFilters,makeSimulation=_actions.makeSimulation;var simulationError=finished&&finished.simulationError?translations['ERROR_'+(finished.simulationErrorCode+'').toUpperCase()]:null;var showResults=!loadingSugested&&sugestions.results&&sugestions.results.length;var isLoading=loadingSugested;var showNoResults=!loadingSugested&&(!sugestions.results||!sugestions.results.length);var bestAnnualBilling=simulation&&simulation.results&&simulation.results.annualBilling;var hasSimulation=simulation&&simulation.results;// this
var isFirstResultNegative=showAll||currentPage>1||isLoading?false// Showing all(ex clicked see more anchor)
:sugestions&&// Has simulation
sugestions.results&&sugestions.results.length&&// has results
bestAnnualBilling-sugestions.results[0].annualBilling<=0;// First result anual billing <= 0
if(__WEBPACK_IMPORTED_MODULE_5_config__["f" /* tipsWidget */]&&!simulating){__WEBPACK_IMPORTED_MODULE_5_config__["f" /* tipsWidget */].style.cssText='display:block!important';}if(simulating){if(__WEBPACK_IMPORTED_MODULE_5_config__["f" /* tipsWidget */]){__WEBPACK_IMPORTED_MODULE_5_config__["f" /* tipsWidget */].style.cssText='';}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_components_Simulating__["a" /* default */],null);}if(simulatingPatch){if(__WEBPACK_IMPORTED_MODULE_5_config__["f" /* tipsWidget */]){__WEBPACK_IMPORTED_MODULE_5_config__["f" /* tipsWidget */].style.cssText='';}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_components_Simulating__["a" /* default */],null);}var content=void 0;if(isLoading){content=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_components_Loading__["a" /* default */],null);}else if(isFirstResultNegative){//* First Result is Negative - Current tariff is the best already
content=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Best,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__images_success_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'column',alignItems:'center',gap:'4px',alignSelf:'stretch'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Message,null,'O seu Tarif\xE1rio atual \xE9 o mais barato.'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Description,null,'O seu tarif\xE1rio atual j\xE1 oferece as melhores condi\xE7\xF5es, por isso n\xE3o encontramos op\xE7\xF5es mais vantajosas. Se pretender visualizar as op\xE7\xF5es, pode v\xEA-las',' ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('b',{onClick:function onClick(){return _this3.setState({showAll:!showAll});}},'aqui.'))));}else if(hasSimulation&&showResults&&!isFirstResultNegative){//* Results exist and the first result is cheaper than the current tariff
content=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',null,this.renderResultSection(),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(PaginationWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_components_PaginationV2__["a" /* default */],{count:sugestions.count,pageChange:function pageChange(params){setTimeout(function(){var element=document.querySelector('div[data-results]');if(element){window.parent.postMessage({type:'scrollToTop'},'*');window.scrollTo({top:element.offsetTop,behavior:'smooth'});}},100);changePage(params);},currentPage:currentPage})));}else if(hasSimulation&&showNoResults&&!isFirstResultNegative||finished.simulationErrorCode==='no_items'){//* Results don't exist
content=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(NoResultsWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TitleRow,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h3',null,'Resultados (0)'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('button',{onClick:resetFilters},'Limpar Filtros')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_components_NoResultsV2__["a" /* default */],{title:true,text:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(NoResultsBtnWrapper,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_components_ButtonGradientV2__["a" /* default */],{onClick:function onClick(){return _this3.toggleDataModal();},style:{width:'200px'},icon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_MyTarifSectionV2_images_ic_edit_component_svg___default.a,null)},'Editar Dados'))));}else if(!hasSimulation&&finished.simulationErrorCode!=='timeout'&&finished.simulationErrorCode!=='no_items'){//* Error occured
content=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_components_NoResultsV2__["a" /* default */],{title:false,text:false},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(NoSimTitle,{grey:true,dangerouslySetInnerHTML:{__html:simulationError}}));}else if(!hasSimulation&&finished.simulationErrorCode==='timeout'){//* Timeout (504) Error occured
content=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_components_SimulationTimeoutErrorV2__["a" /* default */],{title:false,text:false},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_components_ButtonGradientV2__["a" /* default */],{onClick:function onClick(){return makeSimulation();},style:{width:'200px'}},'Tentar Novamente')));}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Wrapper,null,this.renderCurrentTarfif(),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Background,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Content,null,this.renderDesktopFilters(),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ResultsWrapper,{'data-results':true},content))),this.renderFeedbackModal());}}]);return Results;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]))||_class;var Wrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject);var Background=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject2);var Best=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject3);var Message=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject4);var Description=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].p(_templateObject5);var NoResultsWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject6);var NoSimTitle=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject7);var TitleRow=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject8);var Content=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject9);// const FeedbackBtnWrapper = styled.div`
//   overflow: hidden;
//   position: fixed;
//   width: 100%;
//   left: 0;
//   top: 90%;
//   > div {
//     max-width: 1200px;
//     margin-inline: auto;
//     display: flex;
//     justify-content: flex-end;
//     padding-inline: 20px;
//     @media screen and (min-width: 1300px) {
//       padding-inline: 0px;
//     }
//   }
// `
var FiltersWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject10);var ResultsWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject11);var PaginationWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject12);var NoResultsBtnWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject13);var Container=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_8_react_flexbox_grid__["Grid"])(_templateObject14);var Header=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject15);var SearchInput=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_9__ubiwherenpm_adene_ui_components__["a" /* Input */])(_templateObject16);var OrderSelect=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_27_components_Select__["a" /* default */])(_templateObject17);

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SaveProfileModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Modal__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Button__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_PrimaryButton__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Input__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__house_component_svg__ = __webpack_require__(1674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__house_component_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__house_component_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_containers_AuthWrapper__ = __webpack_require__(903);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: row;\n  padding: 32px;\n  align-items: center;\n'],['\n  display: flex;\n  flex-direction: row;\n  padding: 32px;\n  align-items: center;\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  > div:last-child > div {\n    max-width: 550px;\n    min-width: 550px;\n    transform: translateX(-50%);\n    left: 50%;\n  }\n\n  .show {\n    > div {\n      @media screen and (max-width: 468px) {\n        width: 100%;\n        min-width: initial !important;\n        transform: none;\n        left: 0;\n      }\n    }\n  }\n'],['\n  > div:last-child > div {\n    max-width: 550px;\n    min-width: 550px;\n    transform: translateX(-50%);\n    left: 50%;\n  }\n\n  .show {\n    > div {\n      @media screen and (max-width: 468px) {\n        width: 100%;\n        min-width: initial !important;\n        transform: none;\n        left: 0;\n      }\n    }\n  }\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background-color: #efefef;\n  box-shadow: inset 0 1px 0 0 #dedede;\n  padding: 12px;\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: end;\n\n  > * {\n    width: 180px;\n    margin-left: 12px;\n  }\n'],['\n  background-color: #efefef;\n  box-shadow: inset 0 1px 0 0 #dedede;\n  padding: 12px;\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: end;\n\n  > * {\n    width: 180px;\n    margin-left: 12px;\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin-left: 20px;\n'],['\n  margin-left: 20px;\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  color: #010101;\n  font-family: Nunito;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 28px;\n'],['\n  display: block;\n  color: #010101;\n  font-family: Nunito;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 28px;\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #010101;\n  font-family: Nunito;\n  font-size: 16px;\n  line-height: 24px;\n'],['\n  color: #010101;\n  font-family: Nunito;\n  font-size: 16px;\n  line-height: 24px;\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: absolute;\n  background: #fff;\n  border: 1px solid #93c13e;\n  border-top: 0;\n  width: 100%;\n'],['\n  position: absolute;\n  background: #fff;\n  border: 1px solid #93c13e;\n  border-top: 0;\n  width: 100%;\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding: 12px;\n  color: #3e3e3e;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 18px;\n  text-shadow: 0 1px 0 0 #ffffff;\n  cursor: pointer;\n\n  &:hover {\n    background-color: #efefef;\n  }\n'],['\n  padding: 12px;\n  color: #3e3e3e;\n  font-family: Nunito;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 18px;\n  text-shadow: 0 1px 0 0 #ffffff;\n  cursor: pointer;\n\n  &:hover {\n    background-color: #efefef;\n  }\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: relative;\n'],['\n  position: relative;\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  div:last-child > div > div > div {\n    padding: 0;\n  }\n\n  .show > div:nth-child(1) {\n    width: 680px;\n    left: 50%;\n    min-width: 680px;\n    transform: translateX(-50%);\n\n    @media screen and (max-width: 468px) {\n      width: 100%;\n      min-width: initial !important;\n      transform: none;\n      left: 0;\n    }\n  }\n\n  .show {\n    overflow: auto;\n    height: 100%;\n  }\n'],['\n  div:last-child > div > div > div {\n    padding: 0;\n  }\n\n  .show > div:nth-child(1) {\n    width: 680px;\n    left: 50%;\n    min-width: 680px;\n    transform: translateX(-50%);\n\n    @media screen and (max-width: 468px) {\n      width: 100%;\n      min-width: initial !important;\n      transform: none;\n      left: 0;\n    }\n  }\n\n  .show {\n    overflow: auto;\n    height: 100%;\n  }\n']);var SavedModal=function SavedModal(_ref){var onClose=_ref.onClose,manageProfiles=_ref.manageProfiles,showChangeName=_ref.showChangeName,saved=_ref.saved;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(SmallModal,{custom:true,onClick:onClose},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__house_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Info,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Title,null,'Perfil guardado'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Text,null,'O perfil de simula\xE7ao foi guardado com sucesso com o nome',' ',__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('strong',null,'\u201C',saved.name,'\u201D')))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ButtonWrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Button__["a" /* default */],{text:'Gerir Perfis',onClick:function onClick(){return manageProfiles();}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_PrimaryButton__["a" /* default */],{text:'Alterar nome',onClick:function onClick(){return showChangeName();}})));};var UpdateModal=function UpdateModal(_ref2){var onClose=_ref2.onClose,profiles=_ref2.profiles,state=_ref2.state,toggleProfiles=_ref2.toggleProfiles,updateProfile=_ref2.updateProfile,saveProfile=_ref2.saveProfile;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(SmallModal,{custom:true,onClick:onClose},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__house_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Info,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Title,null,'Atualizar / guardar perfil'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Text,null,'J\xE1 tem perfis de simula\xE7\xE3o guardados. Pretende atualizar um perfil existente ou guardar um novo perfil?'))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ButtonWrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_PrimaryButton__["a" /* default */],{text:'Guardar novo',onClick:function onClick(){return saveProfile(true);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(UpdateWrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Button__["a" /* default */],{text:'Atualizar',onClick:function onClick(){return toggleProfiles();}}),state.showingProfiles&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ProfileList,null,profiles&&profiles.map(function(_ref3){var id=_ref3.id,name=_ref3.name;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Item,{key:'profile'+id,onClick:function onClick(){return updateProfile(id);}},name);})))));};var UpdatedModal=function UpdatedModal(_ref4){var onClose=_ref4.onClose,saved=_ref4.saved,manageProfiles=_ref4.manageProfiles;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(SmallModal,{custom:true,onClick:onClose},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__house_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Info,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Title,null,'Perfil atualizado'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Text,null,'O perfil de simula\xE7\xE3o ',__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('strong',null,'\u201C',saved.name,'\u201D'),' foi atualizado com sucesso'))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ButtonWrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Button__["a" /* default */],{text:'Fechar',onClick:function onClick(){return onClose();}})));};var ChangeNameModal=function ChangeNameModal(_ref5){var onClose=_ref5.onClose,updateProfile=_ref5.updateProfile,state=_ref5.state,changeName=_ref5.changeName;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(SmallModal,{custom:true,onClick:onClose},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__house_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Info,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Title,null,'Alterar nome do perfil'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Input__["a" /* default */],{value:state.name,onChange:function onChange(value){return changeName(value);}}))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ButtonWrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Button__["a" /* default */],{text:'Cancelar',onClick:function onClick(){return onClose();}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Button__["a" /* default */],{text:'Guardar',onClick:function onClick(){return updateProfile(state.id,state.name);}})));};var LoginModal=function LoginModal(_ref6){var onClose=_ref6.onClose,showLogin=_ref6.showLogin,showRegister=_ref6.showRegister;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(SmallModal,{custom:true,onClick:onClose},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__house_component_svg___default.a,null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Info,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Title,null,'Para utilizar esta funcionalidade precisa de ter conta no portal Poupa Energia'))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ButtonWrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Button__["a" /* default */],{text:'Registar',onClick:showRegister}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_PrimaryButton__["a" /* default */],{text:'Entrar',onClick:showLogin})));};var LoginWrapper=function LoginWrapper(_ref7){var onClose=_ref7.onClose,toggler=_ref7.toggler,setWidth=_ref7.setWidth,state=_ref7.state,getCurrentUser=_ref7.getCurrentUser,isRegister=_ref7.isRegister;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ModalNoPadding,{custom:true,onClick:onClose,width:state.widthLoginModal},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_containers_AuthWrapper__["a" /* default */],{setWidth:setWidth,getCurrentUser:getCurrentUser,isRegister:isRegister,toggler:toggler})));};var SaveProfileModal=function(_Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SaveProfileModal,_Component);function SaveProfileModal(){var _ref8;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,SaveProfileModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref8=SaveProfileModal.__proto__||Object.getPrototypeOf(SaveProfileModal)).call.apply(_ref8,[this].concat(args))),_this),_this.state={name:'',showingProfiles:false,showingLogin:false,showingRegister:false},_temp),__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SaveProfileModal,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(props){var saved=props.saved;if(saved&&saved.name){this.setState({name:saved.name,id:saved.id});}}},{key:'showChangeName',value:function showChangeName(){var toogler=this.props.toogler;toogler({type:'change'});}},{key:'toggleProfiles',value:function toggleProfiles(){this.setState({showingProfiles:!this.state.showingProfiles});}},{key:'manageProfiles',value:function manageProfiles(){var settings=this.props.settings;if(settings.iframed&&window.top){window.top.postMessage('goToProfiles','*');return;}var url=__WEBPACK_IMPORTED_MODULE_12_config__["g" /* PAGE_URL */]+'/area-reservada/#/simuladores/?tipo='+(__WEBPACK_IMPORTED_MODULE_12_config__["k" /* isEnterprise */]?'e':'r');window.location.href=url;}},{key:'render',value:function render(){var _this2=this;var _props=this.props,type=_props.type,_getCurrentUser=_props.getCurrentUser;var modalProps=Object.assign({},this.props,{showChangeName:this.showChangeName.bind(this),toggleProfiles:this.toggleProfiles.bind(this),manageProfiles:this.manageProfiles.bind(this),state:this.state,changeName:function changeName(name){return _this2.setState({name:name});},showLogin:function showLogin(){return _this2.setState({showingLogin:true});},showRegister:function showRegister(){return _this2.setState({showingRegister:true});},setWidth:function setWidth(width){return _this2.setState({widthLoginModal:width});},getCurrentUser:function getCurrentUser(){_this2.props.onClose();_getCurrentUser({from:'iframe'});},toggler:this.props.toogler});if(this.state.showingLogin){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LoginWrapper,modalProps);}if(this.state.showingRegister){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LoginWrapper,Object.assign({},modalProps,{isRegister:true}));}switch(type){case'saved':return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(SavedModal,modalProps);case'update':return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(UpdateModal,modalProps);case'updated':return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(UpdatedModal,modalProps);case'change':return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ChangeNameModal,modalProps);case'notlogged':return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LoginModal,modalProps);default:break;}}}]);return SaveProfileModal;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);var Wrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject);var SmallModal=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_7_components_Modal__["a" /* default */])(_templateObject2);var ButtonWrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject3);var Info=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject4);var Title=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject5);var Text=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].span(_templateObject6);var ProfileList=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject7);var Item=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject8);var UpdateWrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject9);var ModalNoPadding=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_7_components_Modal__["a" /* default */])(_templateObject10);

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Habitation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logic__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_containers_Form__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_containers_EquipmentsSvg__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_containers_EquipmentsListSimple__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Section__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Loading__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Error__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Modal__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_FixedWrapper__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_findIndex__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_omit__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_isEmpty__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__house_svg__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__house_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__house_svg__);
var _class;var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  @media screen and (max-width: 765px) {\n    > div svg {\n      height: 250px;\n      padding: 0 20px;\n    }\n  }\n'],['\n  @media screen and (max-width: 765px) {\n    > div svg {\n      height: 250px;\n      padding: 0 20px;\n    }\n  }\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding: 20px 10px;\n  text-align: left;\n  color: #666;\n'],['\n  padding: 20px 10px;\n  text-align: left;\n  color: #666;\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  width: 100%;\n  @media screen and (max-width: 765px) {\n    flex-direction: column;\n  }\n'],['\n  display: flex;\n  width: 100%;\n  @media screen and (max-width: 765px) {\n    flex-direction: column;\n  }\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);\n  transition: all 0.2s ease-in-out;\n  border: 1px solid #efefef;\n\n  > div {\n    padding: 20px;\n  }\n\n  > div svg {\n    height: 250px;\n  }\n'],['\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);\n  transition: all 0.2s ease-in-out;\n  border: 1px solid #efefef;\n\n  > div {\n    padding: 20px;\n  }\n\n  > div svg {\n    height: 250px;\n  }\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);\n  transition: all 0.2s ease-in-out;\n  border: 2px solid #efefef;\n\n  > div {\n    padding: 5px;\n  }\n\n  > div svg {\n    height: 100px;\n  }\n'],['\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);\n  transition: all 0.2s ease-in-out;\n  border: 2px solid #efefef;\n\n  > div {\n    padding: 5px;\n  }\n\n  > div svg {\n    height: 100px;\n  }\n']),_templateObject6=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 50%;\n  padding: 40px 20px;\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n\n  ','\n\n  ','\n\n  @media screen and (max-width: 765px) {\n    width: 100%;\n  }\n'],['\n  width: 50%;\n  padding: 40px 20px;\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n\n  ','\n\n  ','\n\n  @media screen and (max-width: 765px) {\n    width: 100%;\n  }\n']),_templateObject7=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 50%;\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n  padding: 0 5px;\n\n  ',' {\n    ','\n  }\n\n  ','\n\n  ','\n\n  @media screen and (max-width: 765px) {\n    margin-bottom: 20px;\n  }\n'],['\n  width: 50%;\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n  padding: 0 5px;\n\n  ',' {\n    ','\n  }\n\n  ','\n\n  ','\n\n  @media screen and (max-width: 765px) {\n    margin-bottom: 20px;\n  }\n']),_templateObject8=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #3e3e3e;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 24px;\n  text-align: center;\n  margin: 0;\n  margin-bottom: 20px;\n'],['\n  color: #3e3e3e;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 24px;\n  text-align: center;\n  margin: 0;\n  margin-bottom: 20px;\n']),_templateObject9=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #3e3e3e;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 24px;\n  text-align: center;\n  margin: 0;\n  margin-top: 10px;\n  display: block;\n'],['\n  color: #3e3e3e;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 24px;\n  text-align: center;\n  margin: 0;\n  margin-top: 10px;\n  display: block;\n']),_templateObject10=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 10px;\n  height: 10px;\n  background: linear-gradient(270deg, #006736 0%, #93c13e 100%);\n  display: inline-block;\n  border-radius: 50%;\n  margin-right: 10px;\n'],['\n  width: 10px;\n  height: 10px;\n  background: linear-gradient(270deg, #006736 0%, #93c13e 100%);\n  display: inline-block;\n  border-radius: 50%;\n  margin-right: 10px;\n']),_templateObject11=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  margin-bottom: 20px;\n  color: #222;\n\n  @media (max-width: 860px) {\n    margin-bottom: 8px;\n    line-height: 16px;\n  }\n'],['\n  display: block;\n  margin-bottom: 20px;\n  color: #222;\n\n  @media (max-width: 860px) {\n    margin-bottom: 8px;\n    line-height: 16px;\n  }\n']),_templateObject12=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  min-height: calc(100% - 60px);\n  flex-direction: column;\n  display: flex;\n  flex: 1;\n  user-select: none;\n'],['\n  min-height: calc(100% - 60px);\n  flex-direction: column;\n  display: flex;\n  flex: 1;\n  user-select: none;\n']),_templateObject13=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n\n  @media screen and (max-width: 765px) {\n    flex-direction: column;\n  }\n'],['\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n\n  @media screen and (max-width: 765px) {\n    flex-direction: column;\n  }\n']),_templateObject14=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: row;\n  width: 80%;\n  margin: 0 auto;\n  margin-top: 40px;\n\n  @media screen and (max-width: 765px) {\n    width: 100%;\n    flex-wrap: wrap;\n    padding: 0 20px;\n    margin-top: 0;\n  }\n'],['\n  display: flex;\n  flex-direction: row;\n  width: 80%;\n  margin: 0 auto;\n  margin-top: 40px;\n\n  @media screen and (max-width: 765px) {\n    width: 100%;\n    flex-wrap: wrap;\n    padding: 0 20px;\n    margin-top: 0;\n  }\n']),_templateObject15=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  min-width: 280px;\n  flex: 0.6;\n  margin-left: 40px;\n  box-shadow: inset 1px 0 0 0 #efefef;\n  transition: right 0.2s ease-out;\n  @media screen and (max-width: 765px) {\n    margin-left: 0;\n    margin-bottom: 40px;\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);\n    min-height: 200px;\n  }\n'],['\n  min-width: 280px;\n  flex: 0.6;\n  margin-left: 40px;\n  box-shadow: inset 1px 0 0 0 #efefef;\n  transition: right 0.2s ease-out;\n  @media screen and (max-width: 765px) {\n    margin-left: 0;\n    margin-bottom: 40px;\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);\n    min-height: 200px;\n  }\n']),_templateObject16=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  position: relative;\n  margin-top: 40px;\n'],['\n  display: flex;\n  position: relative;\n  margin-top: 40px;\n']),_templateObject17=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 100%;\n  padding: 0 10px;\n'],['\n  width: 100%;\n  padding: 0 10px;\n']),_templateObject18=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  color: #010101;\n  font-size: 16px;\n  line-height: 24px;\n  width: 80%;\n  margin: 20px auto;\n  text-align: left;\n  margin-bottom: 60px;\n\n  @media (max-width: 800px) {\n    font-size: 13px;\n    margin: 8px 0 8px 0;\n    width: 100%;\n  }\n'],['\n  display: block;\n  color: #010101;\n  font-size: 16px;\n  line-height: 24px;\n  width: 80%;\n  margin: 20px auto;\n  text-align: left;\n  margin-bottom: 60px;\n\n  @media (max-width: 800px) {\n    font-size: 13px;\n    margin: 8px 0 8px 0;\n    width: 100%;\n  }\n']),_templateObject19=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: #010101;\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 28px;\n  text-align: center;\n'],['\n  color: #010101;\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 28px;\n  text-align: center;\n']),_templateObject20=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 64px;\n  display: block;\n  margin: 20px auto;\n  margin-top: 60px;\n  margin-bottom: 40px;\n\n  @media screen and (max-width: 800px) {\n    margin-top: 18px;\n    margin-bottom: 18px;\n    width: 42px;\n  }\n'],['\n  width: 64px;\n  display: block;\n  margin: 20px auto;\n  margin-top: 60px;\n  margin-bottom: 40px;\n\n  @media screen and (max-width: 800px) {\n    margin-top: 18px;\n    margin-bottom: 18px;\n    width: 42px;\n  }\n']),_templateObject21=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  font-weight: bold;\n  margin-bottom: 20px;\n  color: #93c13e;\n\n  @media (max-width: 860px) {\n    margin-bottom: 8px;\n  }\n'],['\n  display: block;\n  font-weight: bold;\n  margin-bottom: 20px;\n  color: #93c13e;\n\n  @media (max-width: 860px) {\n    margin-bottom: 8px;\n  }\n']),_templateObject22=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  @media screen and (max-width: 765px) {\n    width: 100vw;\n\n    > div:last-child > div {\n      min-width: auto;\n      left: auto;\n    }\n  }\n'],['\n  @media screen and (max-width: 765px) {\n    width: 100vw;\n\n    > div:last-child > div {\n      min-width: auto;\n      left: auto;\n    }\n  }\n']),_templateObject23=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 100%;\n  background-color: #fff !important;\n'],['\n  height: 100%;\n  background-color: #fff !important;\n']);//import { find } from 'lodash'
// import { find } from 'lodash-es'
/* eslint-disable camelcase */var Habitation=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__logic__["default"])(_class=function(_Form){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Habitation,_Form);function Habitation(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,Habitation);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=Habitation.__proto__||Object.getPrototypeOf(Habitation)).call.apply(_ref,[this].concat(args))),_this),_this.nextText='PR\xD3XIMO passo',_this.prevText='Passo Anterior',_this.state={opened:[],responsiveOpen:false},_this.next=function(){var _this$isFormValid=_this.isFormValid(),valid=_this$isFormValid.valid,invalid=_this$isFormValid.invalid;// Actions via KEA
var _this$actions=_this.actions,setInvalid=_this$actions.setInvalid,setFinished=_this$actions.setFinished;// Props via KEA
var router=_this.props.router;if(valid){setFinished({habitationFinished:true});router.push('/faturacao');}else{setFinished({habitationFinished:false});setInvalid(invalid);}},_this.prev=function(){var router=_this.props.router;router.push('/');},_this.onClickSvgElement=function(id){var _this$actions2=_this.actions,setValues=_this$actions2.setValues,setCurrentEquipments=_this$actions2.setCurrentEquipments;var _this$props$data=_this.props.data,equipments=_this$props$data.equipments,centralHeatingEquipments=_this$props$data.centralHeatingEquipments,sugestedEquipment=_this$props$data.sugestedEquipment,defaultChargingDuration=_this$props$data.defaultChargingDuration,defaultChargingPower=_this$props$data.defaultChargingPower,defaultChargingFrequency=_this$props$data.defaultChargingFrequency;var _this$props=_this.props,currentDivision=_this$props.currentDivision,currentEquipments=_this$props.currentEquipments;var newCurrentEquipments=[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(currentEquipments));var equipmentsClone=[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(equipments));var allEquipments=[];var carCharging={};if(centralHeatingEquipments){allEquipments.push.apply(allEquipments,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(centralHeatingEquipments));}if(equipments){allEquipments.push.apply(allEquipments,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(equipmentsClone));}// Found element in current? Remove it
var indexFound=__WEBPACK_IMPORTED_MODULE_17_lodash_findIndex___default()(newCurrentEquipments,function(_ref2){var svg_key=_ref2.svg_key,data=_ref2.data;var house_divisions=data.house_divisions;return svg_key===id&&house_divisions===currentDivision.id&&data.name;});var iluminationDefaultValue=function iluminationDefaultValue(findElement,currentDivisionId,svgKeyId){var findElementClone=Object.assign({},findElement);if(findElementClone.data.equipment_type.name==='Iluminação'){findElementClone.name='Iluminação';findElementClone.data=Object.assign({},findElementClone.data,{id:119,svg_key:svgKeyId,house_divisions:currentDivisionId});return Object.assign({},findElementClone);}else if(findElementClone.data.equipment_type.name==='Climatização Local'){findElementClone.data=Object.assign({},findElementClone.data,{name:'Climatização Local',id:null,svg_key:svgKeyId,house_divisions:currentDivisionId});return Object.assign({},findElementClone);}else if(findElementClone.data.equipment_type.name==='Climatização Centralizada'){findElementClone.data=Object.assign({},findElementClone.data,{name:'Climatização Centralizada',id:null,svg_key:svgKeyId,house_divisions:currentDivisionId});return Object.assign({},findElementClone);}else{findElementClone.data.house_divisions=currentDivisionId;return Object.assign({},findElementClone);}};if(indexFound!==-1){if(id==='el-carro'){carCharging=undefined;}newCurrentEquipments.splice(indexFound,1);}else{// Add new selected element
// This gets the reference for some reason
// Even using a clone it changed the referenced element
// using {...} solved the issue
var findElement={svg_key:id,data:Object.assign({},sugestedEquipment.find(function(_ref3){var svg_key=_ref3.svg_key;return svg_key===id;}))};if(!__WEBPACK_IMPORTED_MODULE_19_lodash_isEmpty___default()(findElement.data)){// findElement.data.house_divisions = currentDivision.id
// newCurrentEquipments.push({ ...findElement })
var sendIluminationValues=iluminationDefaultValue(findElement,currentDivision.id,id);newCurrentEquipments.push(sendIluminationValues);}else{findElement.data=Object.assign({},allEquipments.find(function(_ref4){var svg_key=_ref4.svg_key;return svg_key===id;}));var _sendIluminationValues=iluminationDefaultValue(findElement,currentDivision.id,id);newCurrentEquipments.push(_sendIluminationValues);}if(id==='el-carro'){carCharging={power:defaultChargingPower?defaultChargingPower.value:2300,frequency:defaultChargingFrequency?defaultChargingFrequency.id:1,duration:defaultChargingDuration?defaultChargingDuration.value:12};}}// Set new values
setValues({carCharging:carCharging});setCurrentEquipments(newCurrentEquipments);},_this.setNewValuesToEquipment=function(equipment){var setCurrentEquipments=_this.actions.setCurrentEquipments;var _this$props2=_this.props,currentDivision=_this$props2.currentDivision,currentEquipments=_this$props2.currentEquipments;var equipments=[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(currentEquipments));var found=__WEBPACK_IMPORTED_MODULE_17_lodash_findIndex___default()(equipments,function(_ref5){var data=_ref5.data,svg_key=_ref5.svg_key;var id=data.id,house_divisions=data.house_divisions;return equipment.data.id===id&&equipment.svg_key===svg_key&&house_divisions===currentDivision.id;});if(found!==-1){// Remove equipment if quantity is zero
if(!equipment.data.quantity){equipments.splice(found,1);}else{equipments[found].data=equipment.data;}setCurrentEquipments(equipments);}},_this.modalButtons=[{label:'Fechar',primary:true,click:function click(){return _this.actions.closeStartModal();}}],_this.onChangeEquipmentType=function(equipment,newType,svgKey){var _this$props3=_this.props,currentDivision=_this$props3.currentDivision,currentEquipments=_this$props3.currentEquipments;var setCurrentEquipments=_this.actions.setCurrentEquipments;// Reformat to equipment
newType.id=newType.value;newType.name=newType.label;// Delete keys
newType=__WEBPACK_IMPORTED_MODULE_18_lodash_omit___default()(newType,['label','value']);var newCurrentEquipments=[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(currentEquipments));var foundEquipmentIndex=__WEBPACK_IMPORTED_MODULE_17_lodash_findIndex___default()(newCurrentEquipments,function(_ref6){var data=_ref6.data,svg_key=_ref6.svg_key;var id=data.id,house_divisions=data.house_divisions;return equipment.id===id&&svg_key===svgKey&&house_divisions===currentDivision.id;});if(foundEquipmentIndex!==-1){var equipmentElement=newCurrentEquipments[foundEquipmentIndex];// Get the old quantity and division adn set it to the new object
newType.quantity=equipmentElement.data.quantity;newType.house_divisions=equipmentElement.data.house_divisions;if(newCurrentEquipments[foundEquipmentIndex].data.id!==newType.id){delete newCurrentEquipments[foundEquipmentIndex].name;}newCurrentEquipments[foundEquipmentIndex].data=newType;setCurrentEquipments(newCurrentEquipments);}},_this.onChangeCarDetails=function(field,item){var setValues=_this.actions.setValues;var carChargingValues=_this.props.values.carCharging;carChargingValues[field]=item.value;setValues({carCharging:carChargingValues});},_temp),__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Habitation,[{key:'componentDidMount',value:function componentDidMount(){// Scrols to top on component mount
var element=document.getElementById('anchor');window.scroll({top:element.getBoundingClientRect().top});}},{key:'componentDidUpdate',value:function componentDidUpdate(oldProps){var _this2=this;if(oldProps.loading&&!this.props.loading){var element=document.getElementById('anchor');window.scroll({top:element.getBoundingClientRect().top});}if(!oldProps.values.equipments&&this.props.values.equipments||oldProps.values.equipments&&this.props.currentEquipments&&!this.props.currentEquipments.length){var resolvedCurrentEquipments=[].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.props.values.equipments));var carObject=resolvedCurrentEquipments.find(function(el){return el['svg_key']==='el-carro';});var carIndex=resolvedCurrentEquipments.indexOf(carObject);if(!this.props.values.electricCar&&carIndex!==-1){resolvedCurrentEquipments.splice(carIndex,1);}else if(this.props.values.electricCar&&carIndex===-1){resolvedCurrentEquipments.push(carObject);}this.actions.setCurrentEquipments(resolvedCurrentEquipments.map(function(item){if(!item.data){var found=void 0;var name=null;if(item.equipment_type.name==='Iluminação'){name='Iluminação';found=__WEBPACK_IMPORTED_MODULE_17_lodash_findIndex___default()(_this2.props.data.equipments,function(_ref7){var id=_ref7.id;return id===119;});}else{found=__WEBPACK_IMPORTED_MODULE_17_lodash_findIndex___default()(_this2.props.data.equipments,function(_ref8){var id=_ref8.id;return item.id===id;});}var foundItem=_this2.props.data.equipments[found];return{svg_key:item.svg_key,data:Object.assign({},item,{id:foundItem.id,name:foundItem.name,selectedClass:foundItem.selectedClass}),name:name};}return item;}));}}/**
   * On click svg element select or de-select and element
   */},{key:'render',value:function render(){var _this3=this;var setDivision=this.actions.setDivision;var _props=this.props,loading=_props.loading,error=_props.error,currentDivision=_props.currentDivision,svg=_props.svg,showStartModal=_props.showStartModal,settings=_props.settings,divisions=_props.divisions,divisionsSvgs=_props.divisionsSvgs,currentEquipments=_props.currentEquipments;var _props$data=this.props.data,hiddenSvgItems=_props$data.hiddenSvgItems,equipments=_props$data.equipments,carChargingFrequencies=_props$data.carChargingFrequencies,carChargingDurations=_props$data.carChargingDurations,carChargingPowers=_props$data.carChargingPowers;if(error){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Error__["a" /* default */],null);}if(loading){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Loading__["a" /* default */],null);}var svgEquipments=currentEquipments&&currentDivision&&currentEquipments.filter(function(_ref9){var data=_ref9.data;var house_divisions=data.house_divisions;return house_divisions===currentDivision.id&&data.name;});//const iluminationType = 12
var showingEquipments=currentEquipments&&currentDivision&&currentEquipments.filter(function(_ref10){var data=_ref10.data;var house_divisions=data.house_divisions;var inDivision=house_divisions===currentDivision.id;return inDivision&&data.name;});return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Wrapper,null,this.renderNavbar(),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_FixedWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SimpleSection,{title:'Minha Habita\xE7\xE3o',subtitle:'Selecione e configure os equipamentos da sua habita\xE7\xE3o'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(HabitationWrapper,null,!currentDivision&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DivisionsOverview,null,divisions.map(function(division){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Division,{disabled:division.disabled,onClick:function onClick(){return setDivision(division);}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DivisionName,null,division.name),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DivisionEquipmentsOverview,{svg:divisionsSvgs[division.id],currentEquipments:currentEquipments&&currentEquipments.filter(function(_ref11){var data=_ref11.data;var house_divisions=data.house_divisions;return house_divisions===division.id;}),hiddenSvgItems:hiddenSvgItems}));})),currentDivision&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CurrentDivision,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{style:{flex:1}},currentEquipments&&svg&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CurrentDivisionSvg,{svg:svg,currentEquipments:svgEquipments,onClickElement:this.onClickSvgElement,hiddenSvgItems:hiddenSvgItems,style:{flex:1}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SecondCol,{className:this.state.responsiveOpen?'':'closed'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(EquipmentsList,null,currentDivision.name==='Garagem'&&!showingEquipments.find(function(item){return item.svg_key==='el-carro';})&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CarSelectInfo,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,'Clique no carro do cen\xE1rio para configurar o carregamento do carro el\xE9ctrico.')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_containers_EquipmentsListSimple__["a" /* default */],{allEquipments:equipments,equipments:showingEquipments,division:currentDivision,carChargingFrequencies:carChargingFrequencies,carChargingDurations:carChargingDurations,carChargingPowers:carChargingPowers,onChange:function onChange(opened){return _this3.setNewValuesToEquipment(opened);},onChangeCarDetails:this.onChangeCarDetails,onChangeEquipmentType:this.onChangeEquipmentType})))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DivisionsSmallOverview,null,divisions.map(function(division){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DivisionSmall,{disabled:division.disabled,onClick:function onClick(){setDivision(division);window.scrollTo(90,90);},selected:currentDivision.id===division.id},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DivisionEquipmentsSmallOverview,{svg:divisionsSvgs[division.id],currentEquipments:currentEquipments.filter(function(_ref12){var data=_ref12.data;var house_divisions=data.house_divisions;return house_divisions===division.id;}),hiddenSvgItems:hiddenSvgItems}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DivisionNameSmall,null,division.name));}))))),showStartModal&&!settings.isFromProfile&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(HabitationModal,{toggle:showStartModal,title:'Simulador Simples',buttons:this.modalButtons,onClick:this.actions.closeStartModal,iframed:this.props.iframed},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Image,{src:__WEBPACK_IMPORTED_MODULE_20__house_svg___default.a}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Title,null,'2. Minha Habita\xE7\xE3o'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Text,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerText,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ListBall,null),'Foram adicionados equipamentos padr\xE3o/ilumina\xE7\xE3o com base nas suas respostas.',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerText,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ListBall,null),'Pode adicionar ou remover equipamentos/ilumina\xE7\xE3o clicando na ilustra\xE7\xE3o \xE0 esquerda.',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerText,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ListBall,null),'Pode tamb\xE9m detalh\xE1-los na barra localizada \xE0 direita do seu ecr\xE3.',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DisclaimerTitle,null,'Se pretender pode saltar para o passo seguinte.')))),this.renderButtons());}}]);return Habitation;}(__WEBPACK_IMPORTED_MODULE_9_containers_Form__["a" /* default */]))||_class;var CurrentDivisionSvg=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_10_containers_EquipmentsSvg__["a" /* default */])(_templateObject);var CarSelectInfo=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject2);var CurrentDivision=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject3);var DivisionEquipmentsOverview=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_10_containers_EquipmentsSvg__["a" /* default */])(_templateObject4);var DivisionEquipmentsSmallOverview=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_10_containers_EquipmentsSvg__["a" /* default */])(_templateObject5);var Division=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject6,function(_ref13){var disabled=_ref13.disabled;return disabled&&'\n    pointer-events: none;\n    opacity: 0.2;\n  ';},function(_ref14){var disabled=_ref14.disabled;return!disabled&&'\n    &:hover {\n      transform: scale(1.0454544);\n\n      '+DivisionEquipmentsOverview+' > div {\n        box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);\n      }\n    }\n  ';});var DivisionSmall=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject7,DivisionEquipmentsSmallOverview,function(_ref15){var selected=_ref15.selected;return selected&&'\n        border: 2px solid transparent;\n        border-color: green;\n    ';},function(_ref16){var disabled=_ref16.disabled;return disabled&&'\n    pointer-events: none;\n    opacity: 0.2;\n  ';},function(_ref17){var disabled=_ref17.disabled;return!disabled&&'\n    &:hover {\n      transform: scale(1.0454544);\n\n      '+DivisionEquipmentsSmallOverview+' > div {\n        box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);\n      }\n    }\n  ';});var DivisionName=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].h2(_templateObject8);var DivisionNameSmall=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject9);var ListBall=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject10);var DisclaimerText=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject11);var Wrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject12);var DivisionsOverview=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject13);var DivisionsSmallOverview=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject14);var SecondCol=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject15);// const EquipmentTab = styled.div`
//   position: absolute;
//   left: -82px;
//   background: linear-gradient(270deg, #006736 0%, #93c13e 100%);
//   color: #fff;
//   padding: 10px;
//   border-top-left-radius: 10px;
//   border-top-right-radius: 10px;
//   font-weight: 600;
//   transform: rotate(-90deg);
//   top: 100px;
//   display: none;
//   @media (max-width: 1280px) {
//     display: block;
//   }
// `
var HabitationWrapper=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject16);var EquipmentsList=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject17);var Text=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject18);var Title=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject19);var Image=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].img(_templateObject20);var DisclaimerTitle=__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].span(_templateObject21);var HabitationModal=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_15_components_Modal__["a" /* default */])(_templateObject22);var SimpleSection=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_12_components_Section__["a" /* default */])(_templateObject23);

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SolarSistem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_ButtonConfirm__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Section__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_SubTitle__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Select__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Tip__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Label__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_ic_arrow_svg__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_ic_arrow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__images_ic_arrow_svg__);
var _templateObject=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  text-align: center;\n  margin-bottom: 81px;\n  ','\n'],['\n  display: block;\n  text-align: center;\n  margin-bottom: 81px;\n  ','\n']),_templateObject2=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  border-top: 1px solid #dedede;\n  overflow: visible;\n  padding-top: 80px;\n\n  ','\n'],['\n  display: block;\n  border-top: 1px solid #dedede;\n  overflow: visible;\n  padding-top: 80px;\n\n  ','\n']),_templateObject3=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: inline-block;\n  width: auto;\n  margin-top: 32px;\n'],['\n  display: inline-block;\n  width: auto;\n  margin-top: 32px;\n']),_templateObject4=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: 166px;\n  float: left;\n  max-width: 166px;\n\n  > div {\n    border: 1px solid #bababa;\n    color: #3e3e3e;\n  }\n  ','\n'],['\n  width: 166px;\n  float: left;\n  max-width: 166px;\n\n  > div {\n    border: 1px solid #bababa;\n    color: #3e3e3e;\n  }\n  ','\n']),_templateObject5=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  text-align: left;\n  padding-bottom: 5px;\n'],['\n  text-align: left;\n  padding-bottom: 5px;\n']);var SolarSistem=function(_React$Component){__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SolarSistem,_React$Component);function SolarSistem(props){__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,SolarSistem);var _this=__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this,(SolarSistem.__proto__||Object.getPrototypeOf(SolarSistem)).call(this,props));_this.isLoading=false;_this.handleButtonSelection=_this.handleButtonSelection.bind(_this);_this.handleSelectSelection=_this.handleSelectSelection.bind(_this);_this.state={hasSolarSystem:false,open:false,solarSystemYear:_this.props.year};return _this;}__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SolarSistem,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(){var value=this.isLoading;this.isLoading=true;return value;}},{key:'componentWillMount',value:function componentWillMount(){var props=Object.assign({},this.props);var optItem=props.value!==undefined&&props.value!==null?{value:props.value}:this.getFirstSelectedItem('items');this.isLoading=false;this.setState({hasSolarSystem:optItem.value,open:optItem.value,solarSystemYear:props.year});if(this.props.onSelectionChange){this.props.onSelectionChange({hasSolarSystem:optItem.value,solarSystemYear:props.year,first:true});}}},{key:'getFirstSelectedItem',value:function getFirstSelectedItem(prop){this.props[prop]&&this.props[prop].forEach(function(item){if(item.status)return item;});return this.props[prop]&&this.props[prop][0];}},{key:'handleButtonSelection',value:function handleButtonSelection(e){if(this.props.onSelectionChange&&!e.first){this.props.onSelectionChange({hasSolarSystem:e.value,solarSystemYear:this.state.solarSystemYear});}this.setState({hasSolarSystem:e.value,open:e.value});}},{key:'handleSelectSelection',value:function handleSelectSelection(e){if(this.props.onSelectionChange&&!e.first){this.props.onSelectionChange({solarSystemYear:e.value,hasSolarSystem:this.state.hasSolarSystem});}this.setState({solarSystemYear:e.value});}},{key:'render',value:function render(){var _props=this.props,items=_props.items,years=_props.years,translations=_props.translations,iframed=_props.iframed;var _ref=translations||{},CENTRAL_AIR_CONDITIONING=_ref.CENTRAL_AIR_CONDITIONING;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Section__["a" /* default */],{title:'Sistema Solar T\xE9rmico',subtitle:'A sua habita\xE7\xE3o possui Sistema Solar t\xE9rmico?',compact:iframed},CENTRAL_AIR_CONDITIONING&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Tip__["a" /* default */],{'data-slot':'tip',text:CENTRAL_AIR_CONDITIONING}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ButtonWrapper,{status:this.state.open},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_ButtonConfirm__["a" /* default */],{onButtonClick:this.handleButtonSelection,value:this.state&&this.state.hasSolarSystem,items:items})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(SelectorWrapper,{status:this.state.open},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_SubTitle__["a" /* default */],{text:'Indique o ano de instala\xE7\xE3o do Sistema Solar T\xE9rmico'}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(WrapperSelect,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LocationLabel,{fontSize:'12px'},'ANO DE INSTALA\xC7\xC3O'),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(StyledSelect,{margin:true,placeholder:'Selecione',items:years,onChange:this.handleSelectSelection,selected:this.state.solarSystemYear,arrowIcon:__WEBPACK_IMPORTED_MODULE_13__images_ic_arrow_svg___default.a}))));}}]);return SolarSistem;}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);var ButtonWrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject,function(_ref2){var status=_ref2.status;return!status&&'\n    margin-bottom: 0px;\n  ';});var SelectorWrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject2,function(_ref3){var status=_ref3.status;return!status&&'\n    padding-top: 0px;\n    border-top: none;\n    overflow: hidden;\n    height: 0px;\n  ';});var WrapperSelect=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject3);var StyledSelect=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_10_components_Select__["a" /* default */])(_templateObject4,function(_ref4){var margin=_ref4.margin;return margin&&'margin-right: 30px;';});var LocationLabel=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_12_components_Label__["a" /* default */])(_templateObject5);

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_kea__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_kea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_kea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_saga__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_containers_Results_logic__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_containers_Filters_logic__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_containers_CompanyProfile_logic__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_containers_App_logic__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_mapValues__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_omit__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_TariffSubscribeForm_data__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_utils__ = __webpack_require__(11);
/* eslint-disable camelcase */var ENTITIES_ENDPOINT=__WEBPACK_IMPORTED_MODULE_12_config__["b" /* API_BASE_URL */]+'/public/entity/';var POSTAL_ENDPOINT=__WEBPACK_IMPORTED_MODULE_12_config__["b" /* API_BASE_URL */]+'/public/postal-code/';var SUBSCRIBE_PRICE_LIST_ENDPOINT=__WEBPACK_IMPORTED_MODULE_12_config__["h" /* ADESION_URL */]+'/public/subscribe-price-list/';var DISTRICTS_ENDPOINT=__WEBPACK_IMPORTED_MODULE_12_config__["b" /* API_BASE_URL */]+'/public/district/';var MUNICIPALITIES_ENDPOINT=__WEBPACK_IMPORTED_MODULE_12_config__["b" /* API_BASE_URL */]+'/public/municipality/';var ENTREPRISE_PROPS={companyName:{value:'',valid:false},companyCae:{value:'',valid:false},companyPhoneNumber:{value:'',valid:false},companyEmail:{value:'',valid:false},phone:{value:'',valid:false},email:{value:'',valid:false},legalBi:{value:'',valid:false},nif:{value:'',valid:false},name:{value:'',valid:false},surname:{value:'',valid:false},contact:{value:'e',valid:false,designation:__WEBPACK_IMPORTED_MODULE_15_components_TariffSubscribeForm_data__["a" /* CONTACTS */]},contact_time:{value:'',valid:false,designation:__WEBPACK_IMPORTED_MODULE_15_components_TariffSubscribeForm_data__["b" /* CONTACT_HOUR */]}};var NORMAL_PROPS={name:{value:'',valid:false},surname:{value:'',valid:false},nif:{value:'',valid:false},email:{value:'',valid:false},phone:{value:'',valid:false},contact:{value:'e',valid:false,designation:__WEBPACK_IMPORTED_MODULE_15_components_TariffSubscribeForm_data__["a" /* CONTACTS */]},contact_time:{value:'',valid:false,designation:__WEBPACK_IMPORTED_MODULE_15_components_TariffSubscribeForm_data__["b" /* CONTACT_HOUR */]}};var DEFAULT_PROPS={personal:__WEBPACK_IMPORTED_MODULE_12_config__["k" /* isEnterprise */]?ENTREPRISE_PROPS:NORMAL_PROPS,billing:{postalCode:{value:'',valid:false},postalExtension:{value:'',valid:false},street:{value:'',valid:false},door:{value:'',valid:false},floor:{value:'',valid:false},district:{value:'',valid:false,designation:'d'},municipality:{value:'',valid:false,designation:'m'},billingAddress:{value:'e',valid:false,designation:__WEBPACK_IMPORTED_MODULE_15_components_TariffSubscribeForm_data__["c" /* BILLING_ADDRESS */]},directDebit:{value:'d',valid:false,designation:__WEBPACK_IMPORTED_MODULE_15_components_TariffSubscribeForm_data__["d" /* DIRECT_DEBIT */]},electronicBilling:{value:'e',valid:false,designation:__WEBPACK_IMPORTED_MODULE_15_components_TariffSubscribeForm_data__["e" /* ELETRONIC_BILLING */]},billingPostalCode:{value:'',valid:false},billingPostalExtension:{value:'',valid:false},billingStreet:{value:'',valid:false},billingDoor:{value:'',valid:false},billingFloor:{value:'',valid:false},billingDistrict:{value:'',valid:false,designation:'d'},billingMunicipality:{value:'',valid:false,designation:'bm'}},electric:{currentEntityElectric:{value:'',valid:false,designation:'ee'},cpe:{value:'',valid:false},potency:{value:'',valid:false},tariff:{value:'',valid:false,designation:__WEBPACK_IMPORTED_MODULE_15_components_TariffSubscribeForm_data__["g" /* TARIFF */]},cycle:{value:'',valid:false,designation:__WEBPACK_IMPORTED_MODULE_15_components_TariffSubscribeForm_data__["h" /* CYCLE */]}},gas:{currentEntityGas:{value:'',valid:false,designation:'eg'},cui:{value:'',valid:false},tier:{value:'',valid:false,designation:__WEBPACK_IMPORTED_MODULE_15_components_TariffSubscribeForm_data__["i" /* TIER */]}},confirm:{allowDataSharing:{value:false,valid:false}}};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_kea__["kea"])({connect:{actions:[__WEBPACK_IMPORTED_MODULE_8_containers_Results_logic__["a" /* default */],['fetchTariffInfo','setTariffInfo']],props:[__WEBPACK_IMPORTED_MODULE_8_containers_Results_logic__["a" /* default */],['tariffInfo','userProfile'],__WEBPACK_IMPORTED_MODULE_9_containers_Filters_logic__["a" /* default */],['filters'],__WEBPACK_IMPORTED_MODULE_11_containers_App_logic__["a" /* default */],['values','userLoggedIn','translations'],__WEBPACK_IMPORTED_MODULE_10_containers_CompanyProfile_logic__["a" /* default */],['data']]},actions:function actions(){return{fetchEntities:function fetchEntities(){return{};},fetchPostalInfo:function fetchPostalInfo(code,extension,type){return{code:code,extension:extension,type:type};},fetchMunicipality:function fetchMunicipality(id){return{id:id};},setMunicipality:function setMunicipality(municipality,type){return{fetched:{value:municipality,type:type}};},setPostalInfo:function setPostalInfo(postalInfo,type){return{postalInfo:postalInfo,type:type};},setEntities:function setEntities(entities){return{entities:entities};},setEntitiesError:function setEntitiesError(message){return{message:message};},setFetchError:function setFetchError(message){return{message:message};},setFormData:function setFormData(formData){return{formData:formData};},submitForm:function submitForm(form,omit){return{form:form,omit:omit};},setAdhesionResponse:function setAdhesionResponse(data){return{data:data};},setAdhesionError:function setAdhesionError(error){return{error:error};},reset:function reset(){return{};},setInvalid:function setInvalid(invalid){return{invalid:invalid};},recheckValids:function recheckValids(){return{};},setFirstSet:function setFirstSet(firstSet){return{firstSet:firstSet};},setConfirmationError:function setConfirmationError(error){return{error:error};},/* SETTING */setDistricts:function setDistricts(districts){return{districts:districts};},setMunicipalities:function setMunicipalities(municipalities){return{municipalities:municipalities};},setBillingMunicipalities:function setBillingMunicipalities(municipalities){return{municipalities:municipalities};},setError:function setError(error){return{error:error};},/* FETCHING */fetchDistrictsTrigger:function fetchDistrictsTrigger(){return{};},fetchMunicipalitiesTrigger:function fetchMunicipalitiesTrigger(id,type){return{id:id,type:type};}};},reducers:function reducers(_ref){var _ref3,_ref4,_ref8,_ref9,_ref10,_ref11,_ref12,_ref13,_ref14;var actions=_ref.actions;return{entities:[[],__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.setEntities,function(state,payload){return[].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(payload.entities));})],postalInfo:[null,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,(_ref3={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3,actions.setPostalInfo,function(state,payload){return[].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(payload.postalInfo),[payload.type]);}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3,actions.reset,function(){return null;}),_ref3)],municipality:[null,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,(_ref4={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref4,actions.setMunicipality,function(state,payload){return payload.fetched;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref4,actions.reset,function(){return null;}),_ref4)],districts:[[],__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.setDistricts,function(_,payload){return payload.districts;})],municipalities:[[],__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.setMunicipalities,function(_,payload){return payload.municipalities;})],billingMunicipalities:[[],__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.setBillingMunicipalities,function(_,payload){return payload.municipalities;})],formData:[DEFAULT_PROPS,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,(_ref8={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref8,actions.setFormData,function(state,payload){return Object.assign({},state,payload.formData);}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref8,actions.recheckValids,function(_,payload){var current=Object.assign({},_);current=__WEBPACK_IMPORTED_MODULE_13_lodash_mapValues___default()(current,function(list1,key1){return __WEBPACK_IMPORTED_MODULE_13_lodash_mapValues___default()(list1,function(item,key){return Object.assign({},item,{valid:false});});});return current;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref8,actions.reset,function(){return DEFAULT_PROPS;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref8,actions.setInvalid,function(_,payload){var current=Object.assign({},_);var key=Object.keys(payload.invalid)[0];var list=payload.invalid[key];current=__WEBPACK_IMPORTED_MODULE_13_lodash_mapValues___default()(current,function(list1,key1){return __WEBPACK_IMPORTED_MODULE_13_lodash_mapValues___default()(list1,function(item,key){return Object.assign({},item,{valid:false});});});__WEBPACK_IMPORTED_MODULE_13_lodash_mapValues___default()(list,function(valid,valueKey){current[key][valueKey].valid=valid;});return current;}),_ref8)],adhesionResponse:[null,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,(_ref9={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref9,actions.setAdhesionResponse,function(state,payload){return payload.data;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref9,actions.reset,function(){return null;}),_ref9)],confirmationError:[false,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,(_ref10={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref10,actions.setConfirmationError,function(state,payload){return payload.error;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref10,actions.reset,function(){return false;}),_ref10)],adhesionError:[null,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,(_ref11={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref11,actions.setAdhesionError,function(state,payload){return payload.error;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref11,actions.reset,function(){return null;}),_ref11)],loadingAddress:[false,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,(_ref12={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref12,actions.fetchPostalInfo,function(){return true;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref12,actions.setPostalInfo,function(){return false;}),_ref12)],addressNotFound:[false,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,(_ref13={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref13,actions.fetchPostalInfo,function(){return false;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref13,actions.setPostalInfo,function(){return false;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref13,actions.setFetchError,function(){return true;}),_ref13)],firstSet:[true,__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,(_ref14={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref14,actions.setFirstSet,function(_,payload){return payload.firstSet;}),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref14,actions.reset,function(){return true;}),_ref14)]};},selectors:function selectors(_ref15){var _selectors=_ref15.selectors;return{electricEntities:[function(){return[_selectors.entities];},function(entities){return entities.filter(function(entity){return entity.offer_types[0].order!==3;});},__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array],gasEntities:[function(){return[_selectors.entities];},function(entities){return entities.filter(function(entity){return entity.offer_types.length!==1&&entity.offer_types[0].order!==2;});},__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array]};},takeLatest:function takeLatest(_ref16){var _ref17;var actions=_ref16.actions,workers=_ref16.workers;return _ref17={},__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref17,actions.fetchEntities,workers.fetchEntities),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref17,actions.fetchPostalInfo,workers.fetchPostalInfo),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref17,actions.submitForm,workers.submitForm),__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref17,actions.fetchDistrictsTrigger,workers.fetchDistricts),_ref17;},takeEvery:function takeEvery(_ref18){var actions=_ref18.actions,workers=_ref18.workers;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({},actions.fetchMunicipalitiesTrigger,workers.fetchMunicipalities);},start:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function start(){var _actions,fetchEntities,fetchTariffInfo,fetchDistrictsTrigger,fetchMunicipalitiesTrigger,setFormData,user,formData,name,hasSurName,surname,phone,fillForm,post;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function start$(_context){while(1){switch(_context.prev=_context.next){case 0:_actions=this.actions,fetchEntities=_actions.fetchEntities,fetchTariffInfo=_actions.fetchTariffInfo,fetchDistrictsTrigger=_actions.fetchDistrictsTrigger,fetchMunicipalitiesTrigger=_actions.fetchMunicipalitiesTrigger,setFormData=_actions.setFormData;_context.next=3;return __WEBPACK_IMPORTED_MODULE_11_containers_App_logic__["a" /* default */].get('userLoggedIn');case 3:user=_context.sent;_context.next=6;return this.get('formData');case 6:formData=_context.sent;if(!user){_context.next=32;break;}name=user.user.name.split(' ');hasSurName=name.length>=2;surname=hasSurName&&name[name.length-1]||'';phone=user.phone_number&&user.phone_number.replace('+351','')||'';fillForm={personal:Object.assign({},formData.personal,{name:{value:name[0],valid:false},surname:{value:surname,valid:false},nif:{value:user.tax_id,valid:false},email:{value:user.user.email||'',valid:false},phone:{value:phone,valid:false},contact:{value:'e',valid:false,designation:__WEBPACK_IMPORTED_MODULE_15_components_TariffSubscribeForm_data__["a" /* CONTACTS */]},contact_time:{value:'',valid:false,designation:__WEBPACK_IMPORTED_MODULE_15_components_TariffSubscribeForm_data__["b" /* CONTACT_HOUR */]}}),billing:Object.assign({},formData.billing,{street:{value:user.address,valid:false},municipality:{value:user.municipality,valid:false,designation:'m'},district:{value:user.district,valid:false,designation:'d'},postal_code:{value:user.postal_code,valid:false},billingStreet:{value:user.address,valid:false},billingMunicipality:{value:user.municipality,valid:false,designation:'bm'},billingDistrict:{value:user.district,valid:false,designation:'d'},billing_postal_code:{value:user.postal_code,valid:false}})};_context.next=15;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["put"])(fetchMunicipalitiesTrigger(user.district,'district'));case 15:_context.next=17;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["put"])(fetchMunicipalitiesTrigger(user.district,''));case 17:_context.prev=17;_context.next=20;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_7_axios___default.a.get,__WEBPACK_IMPORTED_MODULE_12_config__["b" /* API_BASE_URL */]+'/public/postal-code/'+user.postal_code+'/');case 20:post=_context.sent;fillForm.billing.billingPostalCode={value:post.data.postal_code,valid:false};fillForm.billing.billingPostalExtension={value:post.data.postal_code_extension,valid:false};fillForm.billing.postalCode={value:post.data.postal_code,valid:false};fillForm.billing.postalExtension={value:post.data.postal_code_extension,valid:false};_context.next=30;break;case 27:_context.prev=27;_context.t0=_context['catch'](17);console.log(_context.t0);case 30:_context.next=32;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["put"])(setFormData(fillForm));case 32:_context.next=34;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["put"])(fetchEntities());case 34:_context.next=36;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["put"])(fetchTariffInfo(this.props.tariff));case 36:_context.next=38;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["put"])(fetchDistrictsTrigger());case 38:case'end':return _context.stop();}}},start,this,[[17,27]]);}),workers:{fetchEntities:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchEntities(action){var _actions2,setEntities,setEntitiesError,entities;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchEntities$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_actions2=this.actions,setEntities=_actions2.setEntities,setEntitiesError=_actions2.setEntitiesError;_context2.prev=1;_context2.next=4;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_7_axios___default.a.get,ENTITIES_ENDPOINT);case 4:entities=_context2.sent;_context2.next=7;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["put"])(setEntities(entities.data.results));case 7:_context2.next=13;break;case 9:_context2.prev=9;_context2.t0=_context2['catch'](1);_context2.next=13;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["put"])(setEntitiesError(_context2.t0));case 13:case'end':return _context2.stop();}}},fetchEntities,this,[[1,9]]);}),fetchPostalInfo:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchPostalInfo(_ref20){var payload=_ref20.payload;var _actions3,setPostalInfo,setFetchError,setFormData,postalInfo,_postalInfo$data$resu,artery_type,prep1,artery_name,prep2,artery_title,municipality,district,id,billing,street,mun,dist;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchPostalInfo$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_actions3=this.actions,setPostalInfo=_actions3.setPostalInfo,setFetchError=_actions3.setFetchError,setFormData=_actions3.setFormData;_context3.prev=1;_context3.next=4;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_7_axios___default.a.get,POSTAL_ENDPOINT,{params:{postal_code:payload.code,postal_code_extension:payload.extension}});case 4:postalInfo=_context3.sent;_context3.next=7;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["put"])(setPostalInfo(postalInfo.data.results,payload.type));case 7:_postalInfo$data$resu=postalInfo.data.results[0],artery_type=_postalInfo$data$resu.artery_type,prep1=_postalInfo$data$resu.prep1,artery_name=_postalInfo$data$resu.artery_name,prep2=_postalInfo$data$resu.prep2,artery_title=_postalInfo$data$resu.artery_title,municipality=_postalInfo$data$resu.municipality,district=_postalInfo$data$resu.district,id=_postalInfo$data$resu.id;billing=Object.assign({},this.props.formData.billing);street=[artery_type,prep1,artery_title,prep2,artery_name].filter(function(n){return n;}).join(' ');mun=municipality;dist=district;if(payload.type==='normal'){billing.street=Object.assign({},billing.street,{value:street});billing.municipality=Object.assign({},billing.municipality,{value:mun});billing.district=Object.assign({},billing.district,{value:dist});billing.postal_code=Object.assign({},billing.postal_code,{value:id});}else{billing.billingStreet=Object.assign({},billing.billingStreet,{value:street});billing.billingMunicipality=Object.assign({},billing.billingMunicipality,{value:mun});billing.billingDistrict=Object.assign({},billing.billingDistrict,{value:dist});billing.billing_postal_code=Object.assign({},billing.postal_code,{value:id});}_context3.next=15;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["put"])(setFormData(Object.assign({},this.props.formData,{billing:billing})));case 15:_context3.next=17;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_saga__["delay"])(800);case 17:_context3.next=19;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["put"])(setFormData(Object.assign({},this.props.formData,{billing:billing})));case 19:_context3.next=25;break;case 21:_context3.prev=21;_context3.t0=_context3['catch'](1);_context3.next=25;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["put"])(setFetchError(_context3.t0));case 25:case'end':return _context3.stop();}}},fetchPostalInfo,this,[[1,21]]);}),submitForm:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function submitForm(_ref21){var payload=_ref21.payload;var _actions4,setAdhesionResponse,setAdhesionError,setConfirmationError,_props$formData$billi,postalCode,postalExtension,billingPostalCode,billingPostalExtension,userCPEandCUI,form,arrayBillings,res,_res,result,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function submitForm$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_actions4=this.actions,setAdhesionResponse=_actions4.setAdhesionResponse,setAdhesionError=_actions4.setAdhesionError,setConfirmationError=_actions4.setConfirmationError;_props$formData$billi=this.props.formData.billing,postalCode=_props$formData$billi.postalCode,postalExtension=_props$formData$billi.postalExtension,billingPostalCode=_props$formData$billi.billingPostalCode,billingPostalExtension=_props$formData$billi.billingPostalExtension;_context4.next=4;return __WEBPACK_IMPORTED_MODULE_8_containers_Results_logic__["a" /* default */].get('userProfile');case 4:userCPEandCUI=_context4.sent;form={};Object.keys(payload.form).forEach(function(key){form[key]=payload.form[key];});arrayBillings=['billing_district','billing_door','billing_floor','billing_municipality','billing_street'];/** If billing_address is "e", thats means equal, billing values needs to be empty */if(form.billing_address==='e'){Object.keys(form).forEach(function(key){if(arrayBillings.find(function(value){return value===key;})){form[key]='';}});}/** If NIF is empty, send nif of user */if(!form.tax_id){if(this.props.formData.personal&&this.props.formData.personal.nif){form.tax_id=this.props.formData.personal.nif.value;}}/** If User has CPE added, send to API */if(!form.cpe){if(userCPEandCUI&&userCPEandCUI.cpe){form.cpe=userCPEandCUI.cpe;}}/** If User has CUI added, send to API */if(!form.cui){if(userCPEandCUI&&userCPEandCUI.cui){form.cui=userCPEandCUI.cui;}}if(form.phone_number){form.phone_number='+351'+form.phone_number;}else{delete form.phone_number;}if(form.company_phone_number){form.company_phone_number='+351'+form.company_phone_number;}else{delete form.company_phone_number;}// Set form type
form.type='p';if(__WEBPACK_IMPORTED_MODULE_12_config__["k" /* isEnterprise */]){form.type='e';}_context4.prev=16;if(!(!form.postal_code&&postalCode.value&&postalExtension.value)){_context4.next=22;break;}_context4.next=20;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_7_axios___default.a.get,POSTAL_ENDPOINT,{params:{postal_code:postalCode.value,postal_code_extension:postalExtension.value}});case 20:res=_context4.sent;form.postal_code=res.data.results.length&&res.data.results[0].id;case 22:if(!(form.billing_address==='d'&&!form.billing_postal_code&&billingPostalCode.value&&billingPostalExtension.value)){_context4.next=27;break;}_context4.next=25;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_7_axios___default.a.get,POSTAL_ENDPOINT,{params:{postal_code:billingPostalCode.value,postal_code_extension:billingPostalExtension.value}});case 25:_res=_context4.sent;form.billing_postal_code=_res.data.results.length&&_res.data.results[0].id;case 27:if(form.time_cycle==='s'){form=__WEBPACK_IMPORTED_MODULE_14_lodash_omit___default()(form,['price_list_cycle']);}form.requires_cui_cpe=__WEBPACK_IMPORTED_MODULE_12_config__["p" /* isAdvanced */];if(!payload.omit){// Enviar esta flag se for uma primeira adesao
form.test_repeated=true;}if(payload.omit&&payload.omit.omitRepeated){form.test_repeated=false;}_context4.next=33;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_7_axios___default.a.post,SUBSCRIBE_PRICE_LIST_ENDPOINT,form);case 33:result=_context4.sent;data=result.data;__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_utils__["e" /* sendGevent */])(this.props.isHome?'home':'simulador','Aderiu','Completou o processo de adesão');_context4.next=38;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["put"])(setAdhesionResponse(data));case 38:if(!(payload.omit&&payload.omit.omitRepeated)){_context4.next=41;break;}_context4.next=41;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["put"])(setConfirmationError(false));case 41:_context4.next=54;break;case 43:_context4.prev=43;_context4.t0=_context4['catch'](16);if(!(_context4.t0.response.data&&_context4.t0.response.status===400&&_context4.t0.response.data.test_repeated&&!!_context4.t0.response.data.test_repeated.length)){_context4.next=50;break;}_context4.next=48;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["put"])(setConfirmationError(true));case 48:_context4.next=54;break;case 50:if(_context4.t0.response.data&&_context4.t0.response.status===400&&_context4.t0.response.data.cui&&_context4.t0.response.data.cpe){_context4.t0.response.data.cuicpe='';delete _context4.t0.response.data.cui;delete _context4.t0.response.data.cpe;}if(_context4.t0.response.status!==400){_context4.t0.response.data='error';}_context4.next=54;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["put"])(setAdhesionError(_context4.t0));case 54:case'end':return _context4.stop();}}},submitForm,this,[[16,43]]);}),fetchMunicipalities:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchMunicipalities(_ref22){var payload=_ref22.payload;var _actions5,setMunicipalities,setBillingMunicipalities,setError,id,type,res,action;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchMunicipalities$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_actions5=this.actions,setMunicipalities=_actions5.setMunicipalities,setBillingMunicipalities=_actions5.setBillingMunicipalities,setError=_actions5.setError;id=payload.id,type=payload.type;_context5.prev=2;_context5.next=5;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_7_axios___default.a.get,MUNICIPALITIES_ENDPOINT,{params:{limit:100,district:id}});case 5:res=_context5.sent;action=type==='district'?setMunicipalities:setBillingMunicipalities;_context5.next=9;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["put"])(action(res.data.results));case 9:_context5.next=15;break;case 11:_context5.prev=11;_context5.t0=_context5['catch'](2);_context5.next=15;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["put"])(setError(_context5.t0));case 15:case'end':return _context5.stop();}}},fetchMunicipalities,this,[[2,11]]);}),fetchDistricts:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function fetchDistricts(){var _actions6,setDistricts,setError,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchDistricts$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_actions6=this.actions,setDistricts=_actions6.setDistricts,setError=_actions6.setError;_context6.prev=1;_context6.next=4;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["call"])(__WEBPACK_IMPORTED_MODULE_7_axios___default.a.get,DISTRICTS_ENDPOINT,{params:{limit:100}});case 4:res=_context6.sent;_context6.next=7;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["put"])(setDistricts(res.data.results));case 7:_context6.next=13;break;case 9:_context6.prev=9;_context6.t0=_context6['catch'](1);_context6.next=13;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["put"])(setError(_context6.t0));case 13:case'end':return _context6.stop();}}},fetchDistricts,this,[[1,9]]);})}}));

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export history */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdvancedRoutes; });
/* unused harmony export SimpleRoutes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EnterpriseRoutes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HomeRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_history__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_App___ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_containers_Profile__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_containers_CompanyProfile__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_containers_Faturation__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_containers_Consume__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_containers_Results__ = __webpack_require__(931);
var basedBrowserHistory=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history__["createHashHistory"])({});var history=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__["syncHistoryWithStore"])(basedBrowserHistory,__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */]);var AdvancedRoutes=function AdvancedRoutes(){var Habitation=__webpack_require__(922).default;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux__["Provider"],{store:__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Router"],{history:history},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Route"],{path:'/',component:__WEBPACK_IMPORTED_MODULE_6__containers_App___["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["IndexRoute"],{component:__WEBPACK_IMPORTED_MODULE_7_containers_Profile__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Route"],{path:'/habitacao',component:Habitation}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Route"],{path:'/faturacao',component:__WEBPACK_IMPORTED_MODULE_9_containers_Faturation__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Route"],{path:'/consumos',component:__WEBPACK_IMPORTED_MODULE_10_containers_Consume__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Route"],{path:'/resultados',component:__WEBPACK_IMPORTED_MODULE_11_containers_Results__["a" /* default */]}))));};var SimpleRoutes=function SimpleRoutes(){var SimpleHabitation=__webpack_require__(936).default;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux__["Provider"],{store:__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Router"],{history:history},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Route"],{path:'/',component:__WEBPACK_IMPORTED_MODULE_6__containers_App___["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["IndexRoute"],{component:__WEBPACK_IMPORTED_MODULE_7_containers_Profile__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Route"],{path:'/habitacao',component:SimpleHabitation}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Route"],{path:'/faturacao',component:__WEBPACK_IMPORTED_MODULE_9_containers_Faturation__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Route"],{path:'/resultados',component:__WEBPACK_IMPORTED_MODULE_11_containers_Results__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Route"],{path:'/consumos',component:__WEBPACK_IMPORTED_MODULE_10_containers_Consume__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Route"],{path:'/resultados/:id',component:__WEBPACK_IMPORTED_MODULE_11_containers_Results__["a" /* default */]}))));};var EnterpriseRoutes=function EnterpriseRoutes(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux__["Provider"],{store:__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Router"],{history:history},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Route"],{path:'/',component:__WEBPACK_IMPORTED_MODULE_6__containers_App___["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["IndexRoute"],{component:__WEBPACK_IMPORTED_MODULE_8_containers_CompanyProfile__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Route"],{path:'/faturacao',component:__WEBPACK_IMPORTED_MODULE_9_containers_Faturation__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Route"],{path:'/consumos',component:__WEBPACK_IMPORTED_MODULE_10_containers_Consume__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Route"],{path:'/resultados',component:__WEBPACK_IMPORTED_MODULE_11_containers_Results__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Route"],{path:'/resultados/:id',component:__WEBPACK_IMPORTED_MODULE_11_containers_Results__["a" /* default */]}))));};var HomeRoutes=function HomeRoutes(){var Wrapper=__webpack_require__(923).default;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux__["Provider"],{store:__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Router"],{history:history},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Route"],{path:'/',component:__WEBPACK_IMPORTED_MODULE_6__containers_App___["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["IndexRoute"],{component:Wrapper}))));};

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export history */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SimpleRoutesV2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FeedbackRoutes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RatingRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_history__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_containers_AppV2__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_containers_ProfileV2__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_containers_ResultsV2__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_containers_FeedbackStandalone__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_containers_RatingStandalone__ = __webpack_require__(930);
var basedBrowserHistory=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history__["createHashHistory"])({});var history=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__["syncHistoryWithStore"])(basedBrowserHistory,__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */]);var SimpleRoutesV2=function SimpleRoutesV2(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux__["Provider"],{store:__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Router"],{history:history},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Route"],{path:'/',component:__WEBPACK_IMPORTED_MODULE_6_containers_AppV2__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["IndexRoute"],{component:__WEBPACK_IMPORTED_MODULE_7_containers_ProfileV2__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Route"],{path:'/resultados',component:__WEBPACK_IMPORTED_MODULE_8_containers_ResultsV2__["a" /* default */]}))));};// Inquérito de satisfação isolado (sem AppV2/simulador à volta), para poder ser
// servido sozinho e embebido num iframe. Só precisa do store para a submissão.
var FeedbackRoutes=function FeedbackRoutes(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux__["Provider"],{store:__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_containers_FeedbackStandalone__["a" /* default */],null));};// Avaliação da adesão (rating) isolada, servida sozinha e embebida num iframe
// do site pai. É autónoma (não depende do store/AppV2), mas mantemos o Provider
// por paridade com os restantes módulos.
var RatingRoutes=function RatingRoutes(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux__["Provider"],{store:__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_containers_RatingStandalone__["a" /* default */],null));};

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(973), __esModule: true };

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(974), __esModule: true };

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(976), __esModule: true };

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(977), __esModule: true };

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(978), __esModule: true };

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(979), __esModule: true };

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(981), __esModule: true };

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(982), __esModule: true };

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(983), __esModule: true };

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(984), __esModule: true };

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(985), __esModule: true };

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(949);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(954);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 954 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__(462);
} catch (err) {
  var index = __webpack_require__(462);
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _eventOptionsKey = __webpack_require__(959);

var _eventOptionsKey2 = _interopRequireDefault(_eventOptionsKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ensureCanMutateNextEventHandlers(eventHandlers) {
  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
    // eslint-disable-next-line no-param-reassign
    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
  }
}

var TargetEventHandlers = function () {
  function TargetEventHandlers(target) {
    _classCallCheck(this, TargetEventHandlers);

    this.target = target;
    this.events = {};
  }

  _createClass(TargetEventHandlers, [{
    key: 'getEventHandlers',
    value: function () {
      function getEventHandlers(eventName, options) {
        var key = String(eventName) + ' ' + String((0, _eventOptionsKey2['default'])(options));

        if (!this.events[key]) {
          this.events[key] = {
            handlers: [],
            handleEvent: undefined
          };
          this.events[key].nextHandlers = this.events[key].handlers;
        }

        return this.events[key];
      }

      return getEventHandlers;
    }()
  }, {
    key: 'handleEvent',
    value: function () {
      function handleEvent(eventName, options, event) {
        var eventHandlers = this.getEventHandlers(eventName, options);
        eventHandlers.handlers = eventHandlers.nextHandlers;
        eventHandlers.handlers.forEach(function (handler) {
          if (handler) {
            // We need to check for presence here because a handler function may
            // cause later handlers to get removed. This can happen if you for
            // instance have a waypoint that unmounts another waypoint as part of an
            // onEnter/onLeave handler.
            handler(event);
          }
        });
      }

      return handleEvent;
    }()
  }, {
    key: 'add',
    value: function () {
      function add(eventName, listener, options) {
        var _this = this;

        // options has already been normalized at this point.
        var eventHandlers = this.getEventHandlers(eventName, options);

        ensureCanMutateNextEventHandlers(eventHandlers);

        if (eventHandlers.nextHandlers.length === 0) {
          eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);

          this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
        }

        eventHandlers.nextHandlers.push(listener);

        var isSubscribed = true;
        var unsubscribe = function () {
          function unsubscribe() {
            if (!isSubscribed) {
              return;
            }

            isSubscribed = false;

            ensureCanMutateNextEventHandlers(eventHandlers);
            var index = eventHandlers.nextHandlers.indexOf(listener);
            eventHandlers.nextHandlers.splice(index, 1);

            if (eventHandlers.nextHandlers.length === 0) {
              // All event handlers have been removed, so we want to remove the event
              // listener from the target node.

              if (_this.target) {
                // There can be a race condition where the target may no longer exist
                // when this function is called, e.g. when a React component is
                // unmounting. Guarding against this prevents the following error:
                //
                //   Cannot read property 'removeEventListener' of undefined
                _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
              }

              eventHandlers.handleEvent = undefined;
            }
          }

          return unsubscribe;
        }();
        return unsubscribe;
      }

      return add;
    }()
  }]);

  return TargetEventHandlers;
}();

exports['default'] = TargetEventHandlers;

/***/ }),
/* 957 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports['default'] = CAN_USE_DOM;

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = canUsePassiveEventListeners;

var _canUseDOM = __webpack_require__(957);

var _canUseDOM2 = _interopRequireDefault(_canUseDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Adapted from Modernizr
// https://github.com/Modernizr/Modernizr/blob/5eea7e2a/feature-detects/dom/passiveeventlisteners.js#L26-L35
function testPassiveEventListeners() {
  if (!_canUseDOM2['default']) {
    return false;
  }

  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
    return false;
  }

  var supportsPassiveOption = false;
  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function () {
        function get() {
          supportsPassiveOption = true;
        }

        return get;
      }()
    });
    window.addEventListener('test', null, opts);
  } catch (e) {
    // do nothing
  }

  return supportsPassiveOption;
}

var memoized = void 0;

function canUsePassiveEventListeners() {
  if (memoized === undefined) {
    memoized = testPassiveEventListeners();
  }
  return memoized;
}

/***/ }),
/* 959 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = eventOptionsKey;
/* eslint-disable no-bitwise */

/**
 * Generate a unique key for any set of event options
 */
function eventOptionsKey(normalizedEventOptions) {
  if (!normalizedEventOptions) {
    return 0;
  }

  // If the browser does not support passive event listeners, the normalized
  // event options will be a boolean.
  if (normalizedEventOptions === true) {
    return 100;
  }

  // At this point, the browser supports passive event listeners, so we expect
  // the event options to be an object with possible properties of capture,
  // passive, and once.
  //
  // We want to consistently return the same value, regardless of the order of
  // these properties, so let's use binary maths to assign each property to a
  // bit, and then add those together (with an offset to account for the
  // booleans at the beginning of this function).
  var capture = normalizedEventOptions.capture << 0;
  var passive = normalizedEventOptions.passive << 1;
  var once = normalizedEventOptions.once << 2;
  return capture + passive + once;
}

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = normalizeEventOptions;

var _canUsePassiveEventListeners = __webpack_require__(958);

var _canUsePassiveEventListeners2 = _interopRequireDefault(_canUsePassiveEventListeners);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function normalizeEventOptions(eventOptions) {
  if (!eventOptions) {
    return undefined;
  }

  if (!(0, _canUsePassiveEventListeners2['default'])()) {
    // If the browser does not support the passive option, then it is expecting
    // a boolean for the options argument to specify whether it should use
    // capture or not. In more modern browsers, this is passed via the `capture`
    // option, so let's just hoist that value up.
    return !!eventOptions.capture;
  }

  return eventOptions;
}

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1153);
__webpack_require__(1092);
__webpack_require__(1094);
__webpack_require__(1093);
__webpack_require__(1096);
__webpack_require__(1098);
__webpack_require__(1103);
__webpack_require__(1097);
__webpack_require__(1095);
__webpack_require__(1105);
__webpack_require__(1104);
__webpack_require__(1100);
__webpack_require__(1101);
__webpack_require__(1099);
__webpack_require__(1091);
__webpack_require__(1102);
__webpack_require__(1106);
__webpack_require__(1107);
__webpack_require__(1058);
__webpack_require__(1060);
__webpack_require__(1059);
__webpack_require__(1109);
__webpack_require__(1108);
__webpack_require__(1079);
__webpack_require__(1089);
__webpack_require__(1090);
__webpack_require__(1080);
__webpack_require__(1081);
__webpack_require__(1082);
__webpack_require__(1083);
__webpack_require__(1084);
__webpack_require__(1085);
__webpack_require__(1086);
__webpack_require__(1087);
__webpack_require__(1088);
__webpack_require__(1062);
__webpack_require__(1063);
__webpack_require__(1064);
__webpack_require__(1065);
__webpack_require__(1066);
__webpack_require__(1067);
__webpack_require__(1068);
__webpack_require__(1069);
__webpack_require__(1070);
__webpack_require__(1071);
__webpack_require__(1072);
__webpack_require__(1073);
__webpack_require__(1074);
__webpack_require__(1075);
__webpack_require__(1076);
__webpack_require__(1077);
__webpack_require__(1078);
__webpack_require__(1140);
__webpack_require__(1145);
__webpack_require__(1152);
__webpack_require__(1143);
__webpack_require__(1135);
__webpack_require__(1136);
__webpack_require__(1141);
__webpack_require__(1146);
__webpack_require__(1148);
__webpack_require__(1131);
__webpack_require__(1132);
__webpack_require__(1133);
__webpack_require__(1134);
__webpack_require__(1137);
__webpack_require__(1138);
__webpack_require__(1139);
__webpack_require__(1142);
__webpack_require__(1144);
__webpack_require__(1147);
__webpack_require__(1149);
__webpack_require__(1150);
__webpack_require__(1151);
__webpack_require__(1053);
__webpack_require__(1055);
__webpack_require__(1054);
__webpack_require__(1057);
__webpack_require__(1056);
__webpack_require__(1042);
__webpack_require__(1040);
__webpack_require__(1046);
__webpack_require__(1043);
__webpack_require__(1049);
__webpack_require__(1051);
__webpack_require__(1039);
__webpack_require__(1045);
__webpack_require__(1036);
__webpack_require__(1050);
__webpack_require__(1034);
__webpack_require__(1048);
__webpack_require__(1047);
__webpack_require__(1041);
__webpack_require__(1044);
__webpack_require__(1033);
__webpack_require__(1035);
__webpack_require__(1038);
__webpack_require__(1037);
__webpack_require__(1052);
__webpack_require__(347);
__webpack_require__(1124);
__webpack_require__(510);
__webpack_require__(1129);
__webpack_require__(511);
__webpack_require__(1125);
__webpack_require__(1126);
__webpack_require__(1127);
__webpack_require__(1128);
__webpack_require__(509);
__webpack_require__(1061);
__webpack_require__(1130);
__webpack_require__(1165);
__webpack_require__(1166);
__webpack_require__(1154);
__webpack_require__(1155);
__webpack_require__(1160);
__webpack_require__(1163);
__webpack_require__(1164);
__webpack_require__(1158);
__webpack_require__(1161);
__webpack_require__(1159);
__webpack_require__(1162);
__webpack_require__(1156);
__webpack_require__(1157);
__webpack_require__(1110);
__webpack_require__(1111);
__webpack_require__(1112);
__webpack_require__(1113);
__webpack_require__(1114);
__webpack_require__(1117);
__webpack_require__(1115);
__webpack_require__(1116);
__webpack_require__(1118);
__webpack_require__(1119);
__webpack_require__(1120);
__webpack_require__(1121);
__webpack_require__(1123);
__webpack_require__(1122);
module.exports = __webpack_require__(35);


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1167);
module.exports = __webpack_require__(35).Array.flatMap;


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1168);
module.exports = __webpack_require__(35).Array.includes;


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1169);
module.exports = __webpack_require__(35).Object.entries;


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1170);
module.exports = __webpack_require__(35).Object.getOwnPropertyDescriptors;


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1171);
module.exports = __webpack_require__(35).Object.values;


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(509);
__webpack_require__(1172);
module.exports = __webpack_require__(35).Promise['finally'];


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1173);
module.exports = __webpack_require__(35).String.padEnd;


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1174);
module.exports = __webpack_require__(35).String.padStart;


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1176);
module.exports = __webpack_require__(35).String.trimRight;


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1175);
module.exports = __webpack_require__(35).String.trimLeft;


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1177);
module.exports = __webpack_require__(345).f('asyncIterator');


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(191);
__webpack_require__(1009);
module.exports = __webpack_require__(34).Array.from;


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(236);
__webpack_require__(191);
module.exports = __webpack_require__(1007);


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1019);
module.exports = __webpack_require__(34).global;


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(236);
__webpack_require__(191);
module.exports = __webpack_require__(1008);


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1011);
module.exports = __webpack_require__(34).Object.assign;


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1012);
var $Object = __webpack_require__(34).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1013);
var $Object = __webpack_require__(34).Object;
module.exports = function defineProperties(T, D) {
  return $Object.defineProperties(T, D);
};


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1014);
var $Object = __webpack_require__(34).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1015);
module.exports = __webpack_require__(34).Object.freeze;


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1016);
module.exports = __webpack_require__(34).Object.setPrototypeOf;


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(480);
__webpack_require__(191);
__webpack_require__(236);
__webpack_require__(1017);
__webpack_require__(1020);
__webpack_require__(1021);
module.exports = __webpack_require__(34).Promise;


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1018);
__webpack_require__(480);
__webpack_require__(1022);
__webpack_require__(1023);
module.exports = __webpack_require__(34).Symbol;


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(191);
__webpack_require__(236);
module.exports = __webpack_require__(321).f('iterator');


/***/ }),
/* 986 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 987 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(142);
var toLength = __webpack_require__(318);
var toAbsoluteIndex = __webpack_require__(1005);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(88);
var createDesc = __webpack_require__(190);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(231);
var gOPS = __webpack_require__(314);
var pIE = __webpack_require__(232);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(139);
var call = __webpack_require__(467);
var isArrayIter = __webpack_require__(466);
var anObject = __webpack_require__(75);
var toLength = __webpack_require__(318);
var getIterFn = __webpack_require__(322);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 992 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(188);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(313);
var descriptor = __webpack_require__(190);
var setToStringTag = __webpack_require__(233);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(111)(IteratorPrototype, __webpack_require__(49)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 995 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(45);
var macrotask = __webpack_require__(479).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(188)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(76);
var getKeys = __webpack_require__(231);
var gOPS = __webpack_require__(314);
var pIE = __webpack_require__(232);
var toObject = __webpack_require__(234);
var IObject = __webpack_require__(465);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(140)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(142);
var gOPN = __webpack_require__(473).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(110);
var toObject = __webpack_require__(234);
var IE_PROTO = __webpack_require__(315)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(56);
var core = __webpack_require__(34);
var fails = __webpack_require__(140);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(111);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(87);
var anObject = __webpack_require__(75);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(139)(Function.call, __webpack_require__(472).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(45);
var core = __webpack_require__(34);
var dP = __webpack_require__(88);
var DESCRIPTORS = __webpack_require__(76);
var SPECIES = __webpack_require__(49)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(317);
var defined = __webpack_require__(309);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(317);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(45);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(75);
var get = __webpack_require__(322);
module.exports = __webpack_require__(34).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(308);
var ITERATOR = __webpack_require__(49)('iterator');
var Iterators = __webpack_require__(141);
module.exports = __webpack_require__(34).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(139);
var $export = __webpack_require__(56);
var toObject = __webpack_require__(234);
var call = __webpack_require__(467);
var isArrayIter = __webpack_require__(466);
var toLength = __webpack_require__(318);
var createProperty = __webpack_require__(989);
var getIterFn = __webpack_require__(322);

$export($export.S + $export.F * !__webpack_require__(469)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(986);
var step = __webpack_require__(995);
var Iterators = __webpack_require__(141);
var toIObject = __webpack_require__(142);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(468)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(56);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(997) });


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(56);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(313) });


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(56);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(76), 'Object', { defineProperties: __webpack_require__(471) });


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(56);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(76), 'Object', { defineProperty: __webpack_require__(88).f });


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(87);
var meta = __webpack_require__(470).onFreeze;

__webpack_require__(1000)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(56);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1002).set });


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(189);
var global = __webpack_require__(45);
var ctx = __webpack_require__(139);
var classof = __webpack_require__(308);
var $export = __webpack_require__(56);
var isObject = __webpack_require__(87);
var aFunction = __webpack_require__(230);
var anInstance = __webpack_require__(987);
var forOf = __webpack_require__(991);
var speciesConstructor = __webpack_require__(478);
var task = __webpack_require__(479).set;
var microtask = __webpack_require__(996)();
var newPromiseCapabilityModule = __webpack_require__(312);
var perform = __webpack_require__(475);
var userAgent = __webpack_require__(1006);
var promiseResolve = __webpack_require__(476);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(49)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(1001)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(233)($Promise, PROMISE);
__webpack_require__(1003)(PROMISE);
Wrapper = __webpack_require__(34)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(469)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(45);
var has = __webpack_require__(110);
var DESCRIPTORS = __webpack_require__(76);
var $export = __webpack_require__(56);
var redefine = __webpack_require__(477);
var META = __webpack_require__(470).KEY;
var $fails = __webpack_require__(140);
var shared = __webpack_require__(316);
var setToStringTag = __webpack_require__(233);
var uid = __webpack_require__(235);
var wks = __webpack_require__(49);
var wksExt = __webpack_require__(321);
var wksDefine = __webpack_require__(320);
var enumKeys = __webpack_require__(990);
var isArray = __webpack_require__(993);
var anObject = __webpack_require__(75);
var isObject = __webpack_require__(87);
var toObject = __webpack_require__(234);
var toIObject = __webpack_require__(142);
var toPrimitive = __webpack_require__(319);
var createDesc = __webpack_require__(190);
var _create = __webpack_require__(313);
var gOPNExt = __webpack_require__(998);
var $GOPD = __webpack_require__(472);
var $GOPS = __webpack_require__(314);
var $DP = __webpack_require__(88);
var $keys = __webpack_require__(231);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(473).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(232).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(189)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(111)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(56);

$export($export.G, { global: __webpack_require__(45) });


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(56);
var core = __webpack_require__(34);
var global = __webpack_require__(45);
var speciesConstructor = __webpack_require__(478);
var promiseResolve = __webpack_require__(476);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(56);
var newPromiseCapability = __webpack_require__(312);
var perform = __webpack_require__(475);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(320)('asyncIterator');


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(320)('observable');


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var isArray = __webpack_require__(242);
var SPECIES = __webpack_require__(28)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(18);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(17);
var toPrimitive = __webpack_require__(99);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(117);
var gOPS = __webpack_require__(244);
var pIE = __webpack_require__(194);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(242);
var isObject = __webpack_require__(20);
var toLength = __webpack_require__(31);
var ctx = __webpack_require__(79);
var IS_CONCAT_SPREADABLE = __webpack_require__(28)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(246)('native-function-to-string', Function.toString);


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(335);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(19);
var macrotask = __webpack_require__(343).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(89)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 1032 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(3);

$export($export.P, 'Array', { copyWithin: __webpack_require__(482) });

__webpack_require__(112)('copyWithin');


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $every = __webpack_require__(78)(4);

$export($export.P + $export.F * !__webpack_require__(69)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(3);

$export($export.P, 'Array', { fill: __webpack_require__(324) });

__webpack_require__(112)('fill');


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $filter = __webpack_require__(78)(2);

$export($export.P + $export.F * !__webpack_require__(69)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(3);
var $find = __webpack_require__(78)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(112)(KEY);


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(3);
var $find = __webpack_require__(78)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(112)(KEY);


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $forEach = __webpack_require__(78)(0);
var STRICT = __webpack_require__(69)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(79);
var $export = __webpack_require__(3);
var toObject = __webpack_require__(46);
var call = __webpack_require__(491);
var isArrayIter = __webpack_require__(331);
var toLength = __webpack_require__(31);
var createProperty = __webpack_require__(325);
var getIterFn = __webpack_require__(346);

$export($export.S + $export.F * !__webpack_require__(243)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $indexOf = __webpack_require__(237)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(69)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(3);

$export($export.S, 'Array', { isArray: __webpack_require__(242) });


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(3);
var toIObject = __webpack_require__(65);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(193) != Object || !__webpack_require__(69)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toIObject = __webpack_require__(65);
var toInteger = __webpack_require__(82);
var toLength = __webpack_require__(31);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(69)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $map = __webpack_require__(78)(1);

$export($export.P + $export.F * !__webpack_require__(69)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var createProperty = __webpack_require__(325);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(18)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $reduce = __webpack_require__(483);

$export($export.P + $export.F * !__webpack_require__(69)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $reduce = __webpack_require__(483);

$export($export.P + $export.F * !__webpack_require__(69)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var html = __webpack_require__(329);
var cof = __webpack_require__(89);
var toAbsoluteIndex = __webpack_require__(119);
var toLength = __webpack_require__(31);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(18)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $some = __webpack_require__(78)(3);

$export($export.P + $export.F * !__webpack_require__(69)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var aFunction = __webpack_require__(77);
var toObject = __webpack_require__(46);
var fails = __webpack_require__(18);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(69)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(146)('Array');


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(3);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(3);
var toISOString = __webpack_require__(1025);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toObject = __webpack_require__(46);
var toPrimitive = __webpack_require__(99);

$export($export.P + $export.F * __webpack_require__(18)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(28)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(64)(proto, TO_PRIMITIVE, __webpack_require__(1026));


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(57)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(3);

$export($export.P, 'Function', { bind: __webpack_require__(485) });


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(20);
var getPrototypeOf = __webpack_require__(116);
var HAS_INSTANCE = __webpack_require__(28)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(39).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(39).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(38) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(486);
var validate = __webpack_require__(121);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(238)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(3);
var log1p = __webpack_require__(494);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(3);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(3);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(3);
var sign = __webpack_require__(335);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(3);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(3);
var $expm1 = __webpack_require__(334);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', { fround: __webpack_require__(1030) });


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(3);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(3);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(18)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', { log1p: __webpack_require__(494) });


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', { sign: __webpack_require__(335) });


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(3);
var expm1 = __webpack_require__(334);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(18)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(3);
var expm1 = __webpack_require__(334);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(19);
var has = __webpack_require__(63);
var cof = __webpack_require__(89);
var inheritIfRequired = __webpack_require__(330);
var toPrimitive = __webpack_require__(99);
var fails = __webpack_require__(18);
var gOPN = __webpack_require__(115).f;
var gOPD = __webpack_require__(80).f;
var dP = __webpack_require__(39).f;
var $trim = __webpack_require__(148).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(114)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(38) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(57)(global, NUMBER, $Number);
}


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(3);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(3);
var _isFinite = __webpack_require__(19).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(3);

$export($export.S, 'Number', { isInteger: __webpack_require__(490) });


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(3);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(3);
var isInteger = __webpack_require__(490);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(3);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(3);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $parseFloat = __webpack_require__(502);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $parseInt = __webpack_require__(503);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toInteger = __webpack_require__(82);
var aNumberValue = __webpack_require__(481);
var repeat = __webpack_require__(341);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(18)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $fails = __webpack_require__(18);
var aNumberValue = __webpack_require__(481);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(3);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(496) });


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(114) });


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(38), 'Object', { defineProperties: __webpack_require__(497) });


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(38), 'Object', { defineProperty: __webpack_require__(39).f });


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(20);
var meta = __webpack_require__(98).onFreeze;

__webpack_require__(81)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(65);
var $getOwnPropertyDescriptor = __webpack_require__(80).f;

__webpack_require__(81)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(81)('getOwnPropertyNames', function () {
  return __webpack_require__(498).f;
});


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(46);
var $getPrototypeOf = __webpack_require__(116);

__webpack_require__(81)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(20);

__webpack_require__(81)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(20);

__webpack_require__(81)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(20);

__webpack_require__(81)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(3);
$export($export.S, 'Object', { is: __webpack_require__(505) });


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(46);
var $keys = __webpack_require__(117);

__webpack_require__(81)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(20);
var meta = __webpack_require__(98).onFreeze;

__webpack_require__(81)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(20);
var meta = __webpack_require__(98).onFreeze;

__webpack_require__(81)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(3);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(337).set });


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(192);
var test = {};
test[__webpack_require__(28)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(57)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $parseFloat = __webpack_require__(502);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $parseInt = __webpack_require__(503);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(3);
var aFunction = __webpack_require__(77);
var anObject = __webpack_require__(17);
var rApply = (__webpack_require__(19).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(18)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(3);
var create = __webpack_require__(114);
var aFunction = __webpack_require__(77);
var anObject = __webpack_require__(17);
var isObject = __webpack_require__(20);
var fails = __webpack_require__(18);
var bind = __webpack_require__(485);
var rConstruct = (__webpack_require__(19).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(39);
var $export = __webpack_require__(3);
var anObject = __webpack_require__(17);
var toPrimitive = __webpack_require__(99);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(18)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(3);
var gOPD = __webpack_require__(80).f;
var anObject = __webpack_require__(17);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(3);
var anObject = __webpack_require__(17);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(492)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(80);
var $export = __webpack_require__(3);
var anObject = __webpack_require__(17);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(3);
var getProto = __webpack_require__(116);
var anObject = __webpack_require__(17);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(80);
var getPrototypeOf = __webpack_require__(116);
var has = __webpack_require__(63);
var $export = __webpack_require__(3);
var isObject = __webpack_require__(20);
var anObject = __webpack_require__(17);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(3);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(3);
var anObject = __webpack_require__(17);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(3);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(501) });


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(3);
var anObject = __webpack_require__(17);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(3);
var setProto = __webpack_require__(337);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(39);
var gOPD = __webpack_require__(80);
var getPrototypeOf = __webpack_require__(116);
var has = __webpack_require__(63);
var $export = __webpack_require__(3);
var createDesc = __webpack_require__(118);
var anObject = __webpack_require__(17);
var isObject = __webpack_require__(20);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(19);
var inheritIfRequired = __webpack_require__(330);
var dP = __webpack_require__(39).f;
var gOPN = __webpack_require__(115).f;
var isRegExp = __webpack_require__(332);
var $flags = __webpack_require__(240);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(38) && (!CORRECT_NEW || __webpack_require__(18)(function () {
  re2[__webpack_require__(28)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(57)(global, 'RegExp', $RegExp);
}

__webpack_require__(146)('RegExp');


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(17);
var toLength = __webpack_require__(31);
var advanceStringIndex = __webpack_require__(323);
var regExpExec = __webpack_require__(245);

// @@match logic
__webpack_require__(239)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(17);
var toObject = __webpack_require__(46);
var toLength = __webpack_require__(31);
var toInteger = __webpack_require__(82);
var advanceStringIndex = __webpack_require__(323);
var regExpExec = __webpack_require__(245);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(239)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(17);
var sameValue = __webpack_require__(505);
var regExpExec = __webpack_require__(245);

// @@search logic
__webpack_require__(239)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(332);
var anObject = __webpack_require__(17);
var speciesConstructor = __webpack_require__(195);
var advanceStringIndex = __webpack_require__(323);
var toLength = __webpack_require__(31);
var callRegExpExec = __webpack_require__(245);
var regexpExec = __webpack_require__(336);
var fails = __webpack_require__(18);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(239)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(511);
var anObject = __webpack_require__(17);
var $flags = __webpack_require__(240);
var DESCRIPTORS = __webpack_require__(38);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(57)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(18)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(486);
var validate = __webpack_require__(121);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(238)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(58)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(58)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(58)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(58)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $at = __webpack_require__(339)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(3);
var toLength = __webpack_require__(31);
var context = __webpack_require__(340);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(328)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(58)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(58)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(58)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var toAbsoluteIndex = __webpack_require__(119);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(3);
var context = __webpack_require__(340);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(328)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(58)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(339)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(333)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(58)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var toIObject = __webpack_require__(65);
var toLength = __webpack_require__(31);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(341)
});


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(58)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(3);
var toLength = __webpack_require__(31);
var context = __webpack_require__(340);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(328)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(58)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(58)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(58)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(148)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(19);
var has = __webpack_require__(63);
var DESCRIPTORS = __webpack_require__(38);
var $export = __webpack_require__(3);
var redefine = __webpack_require__(57);
var META = __webpack_require__(98).KEY;
var $fails = __webpack_require__(18);
var shared = __webpack_require__(246);
var setToStringTag = __webpack_require__(147);
var uid = __webpack_require__(120);
var wks = __webpack_require__(28);
var wksExt = __webpack_require__(345);
var wksDefine = __webpack_require__(508);
var enumKeys = __webpack_require__(1027);
var isArray = __webpack_require__(242);
var anObject = __webpack_require__(17);
var isObject = __webpack_require__(20);
var toObject = __webpack_require__(46);
var toIObject = __webpack_require__(65);
var toPrimitive = __webpack_require__(99);
var createDesc = __webpack_require__(118);
var _create = __webpack_require__(114);
var gOPNExt = __webpack_require__(498);
var $GOPD = __webpack_require__(80);
var $GOPS = __webpack_require__(244);
var $DP = __webpack_require__(39);
var $keys = __webpack_require__(117);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(115).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(194).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(113)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(64)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $typed = __webpack_require__(247);
var buffer = __webpack_require__(344);
var anObject = __webpack_require__(17);
var toAbsoluteIndex = __webpack_require__(119);
var toLength = __webpack_require__(31);
var isObject = __webpack_require__(20);
var ArrayBuffer = __webpack_require__(19).ArrayBuffer;
var speciesConstructor = __webpack_require__(195);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(18)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(146)(ARRAY_BUFFER);


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
$export($export.G + $export.W + $export.F * !__webpack_require__(247).ABV, {
  DataView: __webpack_require__(344).DataView
});


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(91)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(91)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(91)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(91)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(91)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(91)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(91)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(91)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(91)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(19);
var each = __webpack_require__(78)(0);
var redefine = __webpack_require__(57);
var meta = __webpack_require__(98);
var assign = __webpack_require__(496);
var weak = __webpack_require__(487);
var isObject = __webpack_require__(20);
var validate = __webpack_require__(121);
var NATIVE_WEAK_MAP = __webpack_require__(121);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(238)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(487);
var validate = __webpack_require__(121);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(238)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(3);
var flattenIntoArray = __webpack_require__(1028);
var toObject = __webpack_require__(46);
var toLength = __webpack_require__(31);
var aFunction = __webpack_require__(77);
var arraySpeciesCreate = __webpack_require__(484);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(112)('flatMap');


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(3);
var $includes = __webpack_require__(237)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(112)('includes');


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(3);
var $entries = __webpack_require__(500)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(3);
var ownKeys = __webpack_require__(501);
var toIObject = __webpack_require__(65);
var gOPD = __webpack_require__(80);
var createProperty = __webpack_require__(325);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(3);
var $values = __webpack_require__(500)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(3);
var core = __webpack_require__(35);
var global = __webpack_require__(19);
var speciesConstructor = __webpack_require__(195);
var promiseResolve = __webpack_require__(504);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(3);
var $pad = __webpack_require__(506);
var userAgent = __webpack_require__(248);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(3);
var $pad = __webpack_require__(506);
var userAgent = __webpack_require__(248);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(148)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(148)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(508)('asyncIterator');


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(347);
var getKeys = __webpack_require__(117);
var redefine = __webpack_require__(57);
var global = __webpack_require__(19);
var hide = __webpack_require__(64);
var Iterators = __webpack_require__(144);
var wks = __webpack_require__(28);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $task = __webpack_require__(343);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(19);
var $export = __webpack_require__(3);
var userAgent = __webpack_require__(248);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1180);
__webpack_require__(1179);
__webpack_require__(1178);
module.exports = __webpack_require__(35);


/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TransitionEvents);

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isCssAnimationSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Event__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);




var isCssAnimationSupported = __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ __webpack_exports__["b"] = (cssAnimation);

/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return alignElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return alignPoint; });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var vendorPrefix;
var jsCssMap = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  // IE did it wrong again ...
  ms: '-ms-',
  O: '-o-'
};
function getVendorPrefix() {
  if (vendorPrefix !== undefined) {
    return vendorPrefix;
  }
  vendorPrefix = '';
  var style = document.createElement('p').style;
  var testProp = 'Transform';
  for (var key in jsCssMap) {
    if (key + testProp in style) {
      vendorPrefix = key;
    }
  }
  return vendorPrefix;
}
function getTransitionName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
}
function getTransformName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
}
function setTransitionProperty(node, value) {
  var name = getTransitionName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transitionProperty') {
      node.style.transitionProperty = value;
    }
  }
}
function setTransform(node, value) {
  var name = getTransformName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transform') {
      node.style.transform = value;
    }
  }
}
function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName()];
}
function getTransformXY(node) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
    return {
      x: parseFloat(matrix[12] || matrix[4], 0),
      y: parseFloat(matrix[13] || matrix[5], 0)
    };
  }
  return {
    x: 0,
    y: 0
  };
}
var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;
function setTransformXY(node, xy) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var arr;
    var match2d = transform.match(matrix2d);
    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, "matrix(".concat(arr.join(','), ")"));
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
    }
  } else {
    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
  }
}

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var getComputedStyleX;

// https://stackoverflow.com/a/3485654/3040605
function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = 'none';
  elem.offsetHeight; // eslint-disable-line
  elem.style.display = originalStyle;
}
function css(el, name, v) {
  var value = v;
  if (_typeof(name) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }
    return undefined;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = "".concat(value, "px");
    }
    el.style[name] = value;
    return undefined;
  }
  return getComputedStyleX(el, name);
}
function getClientPosition(elem) {
  var box;
  var x;
  var y;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  box = elem.getBoundingClientRect();

  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = Math.floor(box.left);
  y = Math.floor(box.top);

  // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.

  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.

  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x,
    top: y
  };
}
function getScroll(w, top) {
  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
  var method = "scroll".concat(top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}
function getScrollLeft(w) {
  return getScroll(w);
}
function getScrollTop(w) {
  return getScroll(w, true);
}
function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  // must use == for ie8
  /* eslint eqeqeq:0 */
  return obj !== null && obj !== undefined && obj == obj.window;
}
function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }
  if (node.nodeType === 9) {
    return node;
  }
  return node.ownerDocument;
}
function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = '';
  var d = getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);

  // https://github.com/kissyteam/kissy/issues/61
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }
  return val;
}
var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';
function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];

    // prevent flashing of content
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

    // Put in the new values to get a computed value out
    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX;

    // Revert the changed values
    style[LEFT] = left;
    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === '' ? 'auto' : ret;
}
if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}
function getOffsetDirection(dir, option) {
  if (dir === 'left') {
    return option.useCssRight ? 'right' : dir;
  }
  return option.useCssBottom ? 'bottom' : dir;
}
function oppositeOffsetDirection(dir) {
  if (dir === 'left') {
    return 'right';
  } else if (dir === 'right') {
    return 'left';
  } else if (dir === 'top') {
    return 'bottom';
  } else if (dir === 'bottom') {
    return 'top';
  }
}

// 设置 elem 相对 elem.ownerDocument 的坐标
function setLeftTop(elem, offset, option) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }
  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection('left', option);
  var verticalProperty = getOffsetDirection('top', option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
  if (horizontalProperty !== 'left') {
    presetH = 999;
  }
  if (verticalProperty !== 'top') {
    presetV = 999;
  }
  var originalTransition = '';
  var originalOffset = getOffset(elem);
  if ('left' in offset || 'top' in offset) {
    originalTransition = getTransitionProperty(elem) || '';
    setTransitionProperty(elem, 'none');
  }
  if ('left' in offset) {
    elem.style[oppositeHorizontalProperty] = '';
    elem.style[horizontalProperty] = "".concat(presetH, "px");
  }
  if ('top' in offset) {
    elem.style[oppositeVerticalProperty] = '';
    elem.style[verticalProperty] = "".concat(presetV, "px");
  }
  // force relayout
  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};
  for (var key in offset) {
    if (offset.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === 'left' ? presetH : presetV;
      var off = originalOffset[key] - old[key];
      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }
  css(elem, originalStyle);
  // force relayout
  forceRelayout(elem);
  if ('left' in offset || 'top' in offset) {
    setTransitionProperty(elem, originalTransition);
  }
  var ret = {};
  for (var _key in offset) {
    if (offset.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);
      var _off = offset[_key] - originalOffset[_key];
      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }
  css(elem, ret);
}
function setTransform$1(elem, offset) {
  var originalOffset = getOffset(elem);
  var originalXY = getTransformXY(elem);
  var resultXY = {
    x: originalXY.x,
    y: originalXY.y
  };
  if ('left' in offset) {
    resultXY.x = originalXY.x + offset.left - originalOffset.left;
  }
  if ('top' in offset) {
    resultXY.y = originalXY.y + offset.top - originalOffset.top;
  }
  setTransformXY(elem, resultXY);
}
function setOffset(elem, offset, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);
    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset.left.toFixed(0);
    var tTop = offset.top.toFixed(0);
    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }
  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset, option);
  } else if (option.useCssTransform && getTransformName() in document.body.style) {
    setTransform$1(elem, offset);
  } else {
    setLeftTop(elem, offset, option);
  }
}
function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}
function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}
var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;
function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name;

  // Remember the old values, and insert the new ones
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }
  callback.call(elem);

  // Revert the old values
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}
function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop;
  var j;
  var i;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;
        if (prop === 'border') {
          cssProp = "".concat(prop).concat(which[i], "Width");
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}
var domUtils = {
  getParent: function getParent(element) {
    var parent = element;
    do {
      if (parent.nodeType === 11 && parent.host) {
        parent = parent.host;
      } else {
        parent = parent.parentNode;
      }
    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
    return parent;
  }
};
each(['Width', 'Height'], function (name) {
  domUtils["doc".concat(name)] = function (refWin) {
    var d = refWin.document;
    return Math.max(
    // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement["scroll".concat(name)],
    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
  };
  domUtils["viewport".concat(name)] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = "client".concat(name);
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    // 标准模式取 documentElement
    // backcompat 取 body
    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});

/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, ex) {
  var extra = ex;
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
  var isBorderBox = isBorderBoxFn(elem);
  var cssBoxValue = 0;
  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    // Fall back to computed then un computed css if necessary
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    // Normalize '', auto, and prepare for extra
    cssBoxValue = Math.floor(parseFloat(cssBoxValue)) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which);
    }
    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }
    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
}
var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
};

// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var val;
  var elem = args[0];
  // in case elem is window
  // elem.offsetWidth === undefined
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}
each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils["outer".concat(first)] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  domUtils[name] = function (elem, v) {
    var val = v;
    if (val !== undefined) {
      if (elem) {
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which);
        }
        return css(elem, name, val);
      }
      return undefined;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});
function mix(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }
  return to;
}
var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  getDocument: getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== 'undefined') {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },
  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var i;
    var ret = {};
    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }
    return ret;
  },
  mix: mix,
  getWindowScrollLeft: function getWindowScrollLeft(w) {
    return getScrollLeft(w);
  },
  getWindowScrollTop: function getWindowScrollTop(w) {
    return getScrollTop(w);
  },
  merge: function merge() {
    var ret = {};
    for (var i = 0; i < arguments.length; i++) {
      utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
    }
    return ret;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
mix(utils, domUtils);

/**
 * 得到会导致元素显示不全的祖先元素
 */
var getParent = utils.getParent;
function getOffsetParent(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return null;
  }
  // ie 这个也不是完全可行
  /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */
  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
  //  In other browsers it only includes elements with position absolute, relative or
  // fixed, not elements with overflow set to auto or scroll.
  //        if (UA.ie && ieMode < 8) {
  //            return element.offsetParent;
  //        }
  // 统一的 offsetParent 方法
  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent;
  var positionStyle = utils.css(element, 'position');
  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
  if (!skipStatic) {
    return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
  }
  for (parent = getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent(parent)) {
    positionStyle = utils.css(parent, 'position');
    if (positionStyle !== 'static') {
      return parent;
    }
  }
  return null;
}

var getParent$1 = utils.getParent;
function isAncestorFixed(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return false;
  }
  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent = null;
  for (parent = getParent$1(element);
  // 修复元素位于 document.documentElement 下导致崩溃问题
  parent && parent !== body && parent !== doc; parent = getParent$1(parent)) {
    var positionStyle = utils.css(parent, 'position');
    if (positionStyle === 'fixed') {
      return true;
    }
  }
  return false;
}

/**
 * 获得元素的显示部分的区域
 */
function getVisibleRectForElement(element, alwaysByViewport) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = getOffsetParent(element);
  var doc = utils.getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement;

  // Determine the size of the visible rect by climbing the dom accounting for
  // all scrollable containers.
  while (el) {
    // clientWidth is zero for inline block elements in ie.
    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) &&
    // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
      var pos = utils.offset(el);
      // add border
      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right,
      // consider area without scrollBar
      pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }
    el = getOffsetParent(el);
  }

  // Set element position to fixed
  // make sure absolute element itself don't affect it's visible area
  // https://github.com/ant-design/ant-design/issues/7601
  var originalPosition = null;
  if (!utils.isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = utils.css(element, 'position');
    if (position === 'absolute') {
      element.style.position = 'fixed';
    }
  }
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight;

  // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
  // We should cut this ourself.
  var bodyStyle = window.getComputedStyle(body);
  if (bodyStyle.overflowX === 'hidden') {
    documentWidth = win.innerWidth;
  }
  if (bodyStyle.overflowY === 'hidden') {
    documentHeight = win.innerHeight;
  }

  // Reset element position after calculate the visible area
  if (element.style) {
    element.style.position = originalPosition;
  }
  if (alwaysByViewport || isAncestorFixed(element)) {
    // Clip by viewport's size.
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    // Clip by document's size.
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }
  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}

function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = utils.clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };
  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  }

  // Left edge inside and right edge outside viewport, try to resize it.
  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  }

  // Right edge outside viewport, try to move it.
  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  }

  // Top edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  }

  // Top edge inside and bottom edge outside viewport, try to resize it.
  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  }

  // Bottom edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }
  return utils.mix(pos, size);
}

function getRegion(node) {
  var offset;
  var w;
  var h;
  if (!utils.isWindow(node) && node.nodeType !== 9) {
    offset = utils.offset(node);
    w = utils.outerWidth(node);
    h = utils.outerHeight(node);
  } else {
    var win = utils.getWindow(node);
    offset = {
      left: utils.getWindowScrollLeft(win),
      top: utils.getWindowScrollTop(win)
    };
    w = utils.viewportWidth(win);
    h = utils.viewportHeight(win);
  }
  offset.width = w;
  offset.height = h;
  return offset;
}

/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */

function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;
  var x = region.left;
  var y = region.top;
  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }
  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }
  return {
    left: x,
    top: y
  };
}

function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
  var p1 = getAlignOffset(refNodeRegion, points[1]);
  var p2 = getAlignOffset(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];
  return {
    left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
    top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
  };
}

/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */

// http://yiminghe.iteye.com/blog/1124720

function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}
function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}
function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}
function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}
function flip(points, reg, map) {
  var ret = [];
  utils.each(points, function (p) {
    ret.push(p.replace(reg, function (m) {
      return map[m];
    }));
  });
  return ret;
}
function flipOffset(offset, index) {
  offset[index] = -offset[index];
  return offset;
}
function convertOffset(str, offsetLen) {
  var n;
  if (/%$/.test(str)) {
    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n = parseInt(str, 10);
  }
  return n || 0;
}
function normalizeOffset(offset, el) {
  offset[0] = convertOffset(offset[0], el.width);
  offset[1] = convertOffset(offset[1], el.height);
}

/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */
function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset = align.offset || [0, 0];
  var targetOffset = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset = [].concat(offset);
  targetOffset = [].concat(targetOffset);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  var alwaysByViewport = !!(overflow && overflow.alwaysByViewport);
  // 当前节点可以被放置的显示区域
  var visibleRect = getVisibleRectForElement(source, alwaysByViewport);
  // 当前节点所占的区域, left/top/width/height
  var elRegion = getRegion(source);
  // 将 offset 转换成数值，支持百分比
  normalizeOffset(offset, elRegion);
  normalizeOffset(targetOffset, tgtRegion);
  // 当前节点将要被放置的位置
  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
  // 当前节点将要所处的区域
  var newElRegion = utils.merge(elRegion, elFuturePos);

  // 如果可视区域不能完全放置当前节点时允许调整
  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      // 如果横向不能放下
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var newPoints = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        });
        // 偏移量也反下
        var newOffset = flipOffset(offset, 0);
        var newTargetOffset = flipOffset(targetOffset, 0);
        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset = newOffset;
          targetOffset = newTargetOffset;
        }
      }
    }
    if (overflow.adjustY) {
      // 如果纵向不能放下
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var _newPoints = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        });
        // 偏移量也反下
        var _newOffset = flipOffset(offset, 1);
        var _newTargetOffset = flipOffset(targetOffset, 1);
        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset = _newOffset;
          targetOffset = _newTargetOffset;
        }
      }
    }

    // 如果失败，重新计算当前节点将要被放置的位置
    if (fail) {
      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
      utils.mix(newElRegion, elFuturePos);
    }
    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect);
    // 检查反下后的位置是否可以放下了，如果仍然放不下：
    // 1. 复原修改过的定位参数
    if (isStillFailX || isStillFailY) {
      var _newPoints2 = points;

      // 重置对应部分的翻转逻辑
      if (isStillFailX) {
        _newPoints2 = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        });
      }
      if (isStillFailY) {
        _newPoints2 = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        });
      }
      points = _newPoints2;
      offset = align.offset || [0, 0];
      targetOffset = align.targetOffset || [0, 0];
    }
    // 2. 只有指定了可以调整当前方向才调整
    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;

    // 确实要调整，甚至可能会调整高度宽度
    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  }

  // need judge to in case set fixed with in css on height auto element
  if (newElRegion.width !== elRegion.width) {
    utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
  }
  if (newElRegion.height !== elRegion.height) {
    utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
  }

  // https://github.com/kissyteam/kissy/issues/190
  // 相对于屏幕位置没变，而 left/top 变了
  // 例如 <div 'relative'><el absolute></div>
  utils.offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });
  return {
    points: points,
    offset: offset,
    targetOffset: targetOffset,
    overflow: newOverflowCfg
  };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/

function isOutOfVisibleRect(target, alwaysByViewport) {
  var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
  var targetRegion = getRegion(target);
  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}
function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = getRegion(target);
  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}
alignElement.__getOffsetParent = getOffsetParent;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;

/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */

function alignPoint(el, tgtPoint, align) {
  var pageX;
  var pageY;
  var doc = utils.getDocument(el);
  var win = doc.defaultView || doc.parentWindow;
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  if ('pageX' in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }
  if ('pageY' in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }
  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };
  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;

  // Provide default target point
  var points = [align.points[0], 'cc'];
  return doAlign(el, tgtRegion, _objectSpread2(_objectSpread2({}, align), {}, {
    points: points
  }), pointInView);
}

/* unused harmony default export */ var _unused_webpack_default_export = (alignElement);

//# sourceMappingURL=index.js.map


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./eval')} */
module.exports = EvalError;


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
module.exports = Error;


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./range')} */
module.exports = RangeError;


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./ref')} */
module.exports = ReferenceError;


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./uri')} */
module.exports = URIError;


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $TypeError = __webpack_require__(149);

/** @type {import('./RequireObjectCoercible')} */
module.exports = function RequireObjectCoercible(value) {
	if (value == null) {
		throw new $TypeError((arguments.length > 0 && arguments[1]) || ('Cannot call method on ' + value));
	}
	return value;
};


/***/ }),
/* 1191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var camelize = __webpack_require__(1200);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(1210);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var invariant = __webpack_require__(12);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(50);

var createArrayFromMixed = __webpack_require__(1203);
var getMarkupWrap = __webpack_require__(1205);
var invariant = __webpack_require__(12);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(50);

var invariant = __webpack_require__(12);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(1207);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(1209);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/calendar.5d820edd.svg";

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/grayscale.c9e0932d.svg";

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ic-arrow-more.75ea5c38.svg";

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ic-edit.00e4192f.svg";

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ic-remove.43d86f75.svg";

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ic-search.9b51ec00.svg";

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ic-navigation-left.043be889.svg";

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ic-navigation-right.091bf8d1.svg";

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/medal-bronze-v2.3bf20984.svg";

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/medal-gold-v2.3d8d6b20.svg";

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/medal-silver-v2.1d05e2f1.svg";

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ic-saber-mais.b3f2bc0f.svg";

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ic-arrow-more.75ea5c38.svg";

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ic-contrato-faturacao.dee4b09b.svg";

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ic-editar.ea61ee74.svg";

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ic-arrow.ecaebf72.svg";

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ic-arrow.ecaebf72.svg";

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ic-eletricidade.daf2f299.svg";

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ic-gas.3e4d6d0f.svg";

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/plus.56c6406d.svg";

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ic-arrow.ecaebf72.svg";

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ic-arrow.ecaebf72.svg";

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ic-contrato-faturacao.55931140.svg";

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ic-arrow.ecaebf72.svg";

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/house.eb3a51f6.svg";

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ic-arrow.ecaebf72.svg";

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ic-aceitar.114a4e80.svg";

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ic-informacao.f6d5daf4.svg";

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var test = {
	__proto__: null,
	foo: {}
};

var $Object = Object;

/** @type {import('.')} */
module.exports = function hasProto() {
	// @ts-expect-error: TS errors on an inherited property for some reason
	return { __proto__: test }.foo === test.foo
		&& !(test instanceof $Object);
};


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(524);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(351);

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var isSync = false,
      hasNext = false,
      doneArgs = void 0;

  var done = function done() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    isDone = true;

    if (isSync) {
      // Iterate instead of recursing if possible.
      doneArgs = args;
      return;
    }

    callback.apply(undefined, args);
  };

  var next = function next() {
    if (isDone) return;

    hasNext = true;

    if (isSync) return; // Iterate instead of recursing if possible.

    isSync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work(currentTurn++, next, done);
    }

    isSync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(undefined, _toConsumableArray(doneArgs));
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  };

  next();
};

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(352);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _warning = __webpack_require__(151);

var _warning2 = _interopRequireDefault(_warning);

var _LocationUtils = __webpack_require__(122);

var _DOMUtils = __webpack_require__(196);

var _DOMStateStorage = __webpack_require__(525);

var _PathUtils = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.substring(index + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var i = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, i >= 0 ? i : 0) + '#' + path);
};

var ensureSlash = function ensureSlash() {
  var path = getHashPath();

  if ((0, _PathUtils.isAbsolutePath)(path)) return true;

  replaceHashPath('/' + path);

  return false;
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(queryKey) {
  var path = getHashPath();
  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);

  var state = void 0;
  if (key) {
    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
    state = (0, _DOMStateStorage.readState)(key);
  }

  var init = (0, _PathUtils.parsePath)(path);
  init.state = state;

  return (0, _LocationUtils.createLocation)(init, undefined, key);
};

var prevLocation = void 0;

var startListener = exports.startListener = function startListener(listener, queryKey) {
  var handleHashChange = function handleHashChange() {
    if (!ensureSlash()) return; // Hash path must always begin with a /

    var currentLocation = getCurrentLocation(queryKey);

    if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events

    prevLocation = currentLocation;

    listener(currentLocation);
  };

  ensureSlash();
  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
  };
};

var updateLocation = function updateLocation(location, queryKey, updateHash) {
  var state = location.state;
  var key = location.key;

  var path = (0, _PathUtils.createPath)(location);

  if (state !== undefined) {
    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
    (0, _DOMStateStorage.saveState)(key, state);
  }

  prevLocation = location;

  updateHash(path);
};

var pushLocation = exports.pushLocation = function pushLocation(location, queryKey) {
  return updateLocation(location, queryKey, function (path) {
    if (getHashPath() !== path) {
      pushHashPath(path);
    } else {
       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
    }
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location, queryKey) {
  return updateLocation(location, queryKey, function (path) {
    if (getHashPath() !== path) replaceHashPath(path);
  });
};

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(352);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _LocationUtils = __webpack_require__(122);

var _PathUtils = __webpack_require__(100);

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  return (0, _LocationUtils.createLocation)(window.location);
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  window.location.href = (0, _PathUtils.createPath)(location);
  return false; // Don't update location
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  window.location.replace((0, _PathUtils.createPath)(location));
  return false; // Don't update location
};

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(36);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(353);

var _BrowserProtocol = __webpack_require__(352);

var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);

var _RefreshProtocol = __webpack_require__(1246);

var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);

var _DOMUtils = __webpack_require__(196);

var _createHistory = __webpack_require__(354);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve clean URLs. You can force this
 * behavior using { forceRefresh: true } in options.
 */
var createBrowserHistory = function createBrowserHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;

  var getUserConfirmation = Protocol.getUserConfirmation;
  var getCurrentLocation = Protocol.getCurrentLocation;
  var pushLocation = Protocol.pushLocation;
  var replaceLocation = Protocol.replaceLocation;
  var go = Protocol.go;


  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen
  });
};

exports.default = createBrowserHistory;

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(151);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(36);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(353);

var _DOMUtils = __webpack_require__(196);

var _HashProtocol = __webpack_require__(1245);

var HashProtocol = _interopRequireWildcard(_HashProtocol);

var _createHistory = __webpack_require__(354);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultQueryKey = '_k';

var createHashHistory = function createHashHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var queryKey = options.queryKey;


   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;

  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;

  var getUserConfirmation = HashProtocol.getUserConfirmation;


  var getCurrentLocation = function getCurrentLocation() {
    return HashProtocol.getCurrentLocation(queryKey);
  };

  var pushLocation = function pushLocation(location) {
    return HashProtocol.pushLocation(location, queryKey);
  };

  var replaceLocation = function replaceLocation(location) {
    return HashProtocol.replaceLocation(location, queryKey);
  };

  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: HashProtocol.go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, queryKey);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var go = function go(n) {
     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;

    history.go(n);
  };

  var createHref = function createHref(path) {
    return '#' + history.createHref(path);
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    go: go,
    createHref: createHref
  });
};

exports.default = createHashHistory;

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(151);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(36);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(122);

var _PathUtils = __webpack_require__(100);

var _createHistory = __webpack_require__(354);

var _createHistory2 = _interopRequireDefault(_createHistory);

var _Actions = __webpack_require__(252);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createStateStorage = function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
};

var createMemoryHistory = function createMemoryHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var getCurrentLocation = function getCurrentLocation() {
    var entry = entries[current];
    var path = (0, _PathUtils.createPath)(entry);

    var key = void 0,
        state = void 0;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    }

    var init = (0, _PathUtils.parsePath)(path);

    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
  };

  var canGo = function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  };

  var go = function go(n) {
    if (!n) return;

    if (!canGo(n)) {
       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;

      return;
    }

    current += n;
    var currentLocation = getCurrentLocation();

    // Change action to POP
    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
  };

  var pushLocation = function pushLocation(location) {
    current += 1;

    if (current < entries.length) entries.splice(current);

    entries.push(location);

    saveState(location.key, location.state);
  };

  var replaceLocation = function replaceLocation(location) {
    entries[current] = location;
    saveState(location.key, location.state);
  };

  var history = (0, _createHistory2.default)(_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var _options = options;
  var entries = _options.entries;
  var current = _options.current;


  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    return (0, _LocationUtils.createLocation)(entry);
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
  }

  var storage = createStateStorage(entries);

  var saveState = function saveState(key, state) {
    return storage[key] = state;
  };

  var readState = function readState(key) {
    return storage[key];
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _runTransitionHook = __webpack_require__(355);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useBasename = function useBasename(createHistory) {
  return function () {
    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var history = createHistory(options);
    var basename = options.basename;


    var addBasename = function addBasename(location) {
      if (!location) return location;

      if (basename && location.basename == null) {
        if (location.pathname.indexOf(basename) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    };

    var prependBasename = function prependBasename(location) {
      if (!basename) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var pname = object.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, location, {
        pathname: pathname
      });
    };

    // Override all read methods with basename-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return addBasename(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(addBasename(location));
      });
    };

    // Override all write methods with basename-aware versions.
    var push = function push(location) {
      return history.push(prependBasename(location));
    };

    var replace = function replace(location) {
      return history.replace(prependBasename(location));
    };

    var createPath = function createPath(location) {
      return history.createPath(prependBasename(location));
    };

    var createHref = function createHref(location) {
      return history.createHref(prependBasename(location));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useBasename;

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(36);

var _invariant2 = _interopRequireDefault(_invariant);

var _DOMUtils = __webpack_require__(196);

var _ExecutionEnvironment = __webpack_require__(353);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var startListener = function startListener(getPromptMessage) {
  var handleBeforeUnload = function handleBeforeUnload(event) {
    var message = getPromptMessage();

    if (typeof message === 'string') {
      (event || window.event).returnValue = message;
      return message;
    }

    return undefined;
  };

  (0, _DOMUtils.addEventListener)(window, 'beforeunload', handleBeforeUnload);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, 'beforeunload', handleBeforeUnload);
  };
};

/**
 * Returns a new createHistory function that can be used to create
 * history objects that know how to use the beforeunload event in web
 * browsers to cancel navigation.
 */
var useBeforeUnload = function useBeforeUnload(createHistory) {
  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'useBeforeUnload only works in DOM environments') : (0, _invariant2.default)(false) : void 0;

  return function (options) {
    var history = createHistory(options);

    var listeners = [];
    var stopListener = void 0;

    var getPromptMessage = function getPromptMessage() {
      var message = void 0;
      for (var i = 0, len = listeners.length; message == null && i < len; ++i) {
        message = listeners[i].call();
      }return message;
    };

    var listenBeforeUnload = function listenBeforeUnload(listener) {
      if (listeners.push(listener) === 1) stopListener = startListener(getPromptMessage);

      return function () {
        listeners = listeners.filter(function (item) {
          return item !== listener;
        });

        if (listeners.length === 0 && stopListener) {
          stopListener();
          stopListener = null;
        }
      };
    };

    return _extends({}, history, {
      listenBeforeUnload: listenBeforeUnload
    });
  };
};

exports.default = useBeforeUnload;

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = __webpack_require__(599);

var _runTransitionHook = __webpack_require__(355);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _LocationUtils = __webpack_require__(122);

var _PathUtils = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStringifyQuery = function defaultStringifyQuery(query) {
  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
};

var defaultParseQueryString = _queryString.parse;

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
var useQueries = function useQueries(createHistory) {
  return function () {
    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var history = createHistory(options);
    var stringifyQuery = options.stringifyQuery;
    var parseQueryString = options.parseQueryString;


    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    var decodeQuery = function decodeQuery(location) {
      if (!location) return location;

      if (location.query == null) location.query = parseQueryString(location.search.substring(1));

      return location;
    };

    var encodeQuery = function encodeQuery(location, query) {
      if (query == null) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var queryString = stringifyQuery(query);
      var search = queryString ? '?' + queryString : '';

      return _extends({}, object, {
        search: search
      });
    };

    // Override all read methods with query-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return decodeQuery(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(decodeQuery(location));
      });
    };

    // Override all write methods with query-aware versions.
    var push = function push(location) {
      return history.push(encodeQuery(location, location.query));
    };

    var replace = function replace(location) {
      return history.replace(encodeQuery(location, location.query));
    };

    var createPath = function createPath(location) {
      return history.createPath(encodeQuery(location, location.query));
    };

    var createHref = function createHref(location) {
      return history.createHref(encodeQuery(location, location.query));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));

      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);

      return decodeQuery(newLocation);
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useQueries;

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.idempotentBabelPolyfill = idempotentBabelPolyfill;
exports.default = void 0;

function idempotentBabelPolyfill() {
  if (!global._babelPolyfill && ( // eslint-disable-next-line no-undef
  typeof window === 'undefined' || !window._babelPolyfill)) {
    return __webpack_require__(716);
  }

  return null;
}

var _default = idempotentBabelPolyfill();

exports.default = _default;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 1254 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



var isObject = __webpack_require__(1256);

function isObjectObject(o) {
  return isObject(o) === true
    && Object.prototype.toString.call(o) === '[object Object]';
}

module.exports = function isPlainObject(o) {
  var ctor,prot;

  if (isObjectObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (typeof ctor !== 'function') return false;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
};


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



module.exports = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.convertConstants = convertConstants;
exports.createLogic = createLogic;

var _effects = __webpack_require__(26);

var _reselect = __webpack_require__(281);

var _reducer = __webpack_require__(527);

var _selectors = __webpack_require__(357);

var _actions = __webpack_require__(253);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var gaveAddSelectorWarning = false;
var gaveStructureWarning = false;

// convert ['A', 'B'] ==> { 'A': 'A', 'B': 'B' }
function convertConstants(c) {
  if (Array.isArray(c)) {
    var a = {};
    for (var i = 0; i < c.length; i++) {
      a[c[i]] = c[i];
    }
    return a;
  }
  return c;
}

function createLogic(_this) {
  var object = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  object.key = _this.key ? _this.key(object.props || {}) : undefined;
  object.path = _this.path(object.key);
  object.selector = function (state) {
    return (0, _selectors.pathSelector)(object.path, state);
  };
  object.constants = _this.constants ? convertConstants(_this.constants(object)) : {};
  object.actions = _this.actions ? (0, _actions.createActions)(_this.actions(object), object.path) : {};

  // reducers
  if (_this.structure) {
    // DEPRECATED
    if (!gaveStructureWarning) {
      console.warn('[KEA-LOGIC] structure = () => ({}) is deprecated. Please rename it to reducers = () => ({}).');
      gaveStructureWarning = true;
    }
    object.reducers = (0, _reducer.convertReducerArrays)(_this.structure(object));
  } else if (_this.reducers) {
    object.reducers = (0, _reducer.convertReducerArrays)(_this.reducers(object));
  } else {
    object.reducers = {};
  }

  object.reducer = _this.reducer ? _this.reducer(object) : (0, _reducer.combineReducerObjects)(object.path, object.reducers);

  object.selectors = (0, _selectors.createSelectors)(object.path, Object.keys(object.reducers));

  // selectors
  // TODO: remove addSelector deprecation
  var response = _this.selectors ? _this.selectors(Object.assign({}, object, { addSelector: _addSelector.bind(object) })) : {};

  if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object') {
    var keys = Object.keys(response);
    for (var i = 0; i < keys.length; i++) {
      var s = response[keys[i]];
      // s == [() => args, selectorFunction, propType]

      var args = s[0]();
      if (s[2]) {
        object.reducers[keys[i]] = { type: s[2] };
      }
      object.selectors[keys[i]] = _reselect.createSelector.apply(undefined, _toConsumableArray(args).concat([s[1]]));
    }
  }

  Object.assign(_this, object);

  _this.get = regeneratorRuntime.mark(function _callee(key) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _effects.select)(key ? _this.selectors[key] : _this.selector);

          case 2:
            return _context.abrupt('return', _context.sent);

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  });

  _this.fetch = regeneratorRuntime.mark(function _callee2() {
    var results,
        keys,
        _i,
        _args2 = arguments;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            results = {};
            keys = Array.isArray(_args2[0]) ? _args2[0] : _args2;
            _i = 0;

          case 3:
            if (!(_i < keys.length)) {
              _context2.next = 10;
              break;
            }

            _context2.next = 6;
            return _this.get(keys[_i]);

          case 6:
            results[keys[_i]] = _context2.sent;

          case 7:
            _i++;
            _context2.next = 3;
            break;

          case 10:
            return _context2.abrupt('return', results);

          case 11:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  });

  return _this;
}

// DEPRECATED
// bound to object
function _addSelector(name, type, args, func) {
  if (!gaveAddSelectorWarning) {
    console.warn('[KEA-LOGIC] addSelector is deprecated. Please use the new compact Array format.');
    gaveAddSelectorWarning = true;
  }

  this.reducers[name] = { type: type };
  this.selectors[name] = _reselect.createSelector.apply(undefined, _toConsumableArray(args).concat([func]));
}

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cachedSelectors = cachedSelectors;
exports.kea = kea;

var _props = __webpack_require__(1259);

var _actions = __webpack_require__(253);

var _reducer = __webpack_require__(527);

var _create = __webpack_require__(1257);

var _selectors = __webpack_require__(357);

var _create2 = __webpack_require__(1261);

var _connected = __webpack_require__(1260);

var _store = __webpack_require__(254);

var _saga = __webpack_require__(1262);

var _shallowEqual = __webpack_require__(1263);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _reselect = __webpack_require__(281);

var _effects = __webpack_require__(26);

var _reactRedux = __webpack_require__(401);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var inlineCache = {};
var actionCache = {};

function cachedSelectors(path) {
  return inlineCache[path.join('.')] || {};
}

var DEBUG = false;

var nonameCounter = 0;

function kea(_this) {
  var hasConnect = !!_this.connect;
  var hasLogic = !!(_this.path || _this.actions || _this.reducers || _this.selectors);
  var hasSaga = !!(_this.sagas || _this.start || _this.stop || _this.takeEvery || _this.takeLatest || _this.connect && _this.connect.sagas);
  var isSingleton = !_this.key;

  var object = {};

  if (!_this.path) {
    var reducerRoot = (0, _store.firstReducerRoot)();
    if (!reducerRoot) {
      console.error('[KEA] Could not find the root of the keaReducer! Make sure you call keaReducer() before any call to kea() is made. See: https://kea.js.org/api/reducer');
    }
    var inlinePath = [reducerRoot, '_kea', 'inline-' + nonameCounter++];
    _this.path = function () {
      return inlinePath;
    };
  }

  var propTypes = {};
  var connect = {};
  var connectedActions = {};
  var connectedSelectors = {};

  if (hasConnect) {
    // the { connect: { props, actions } } part
    connect = _this.connect || {};

    // get default proptypes and add connected ones
    propTypes = Object.assign({}, connect.props ? (0, _props.propTypesFromMapping)(connect) : {});

    // connected actions and props/selectors
    connectedActions = (0, _actions.createActionTransforms)(connect.actions).actions;
    connectedSelectors = (0, _props.createPropTransforms)(connect.props).selectorFunctions;

    if (isSingleton) {
      object.actions = Object.assign({}, connectedActions);
      object.selectors = Object.assign({}, connectedSelectors);
    }

    var connectedSagas = (0, _connected.getConnectedSagas)(connect);

    // sagas we automatically connect from actions && props
    if (connectedSagas.length > 0) {
      hasSaga = true;
      _this.sagas = _this.sagas ? _this.sagas.concat(connectedSagas) : connectedSagas;
    }

    // we have _this: { connect: { sagas: [] } }, add to _this: { sagas: [] }
    if (connect.sagas) {
      _this.sagas = _this.sagas ? _this.sagas.concat(connect.sagas) : connect.sagas;
    }
  }

  // pregenerate as many things as we can
  object.constants = _this.constants ? (0, _create.convertConstants)(_this.constants(object)) : {};

  if (hasLogic) {
    // we don't know yet if it's going to be a singleton (no key) or inline (key)
    // however the actions and constants are common for all, so get a path without the dynamic
    // component and initialize them
    object.path = _this.path('').filter(function (p) {
      return p;
    });
    object.actions = Object.assign({}, object.actions, _this.actions ? (0, _actions.createActions)(_this.actions(object), object.path) : {});
    object.props = {};
  }

  if (hasLogic && isSingleton) {
    object.selector = function (state) {
      return (0, _selectors.pathSelector)(object.path, state);
    };
    object.reducers = _this.reducers ? (0, _reducer.convertReducerArrays)(_this.reducers(object)) : {};
    object.reducer = _this.reducer ? _this.reducer(object) : (0, _reducer.combineReducerObjects)(object.path, object.reducers);
    object.selectors = Object.assign({}, object.selectors, (0, _selectors.createSelectors)(object.path, Object.keys(object.reducers || {})));

    var selectorResponse = _this.selectors ? _this.selectors(object) : {};
    Object.keys(selectorResponse).forEach(function (selectorKey) {
      // s == [() => args, selectorFunction, propType]
      var s = selectorResponse[selectorKey];
      var args = s[0]();
      if (s[2]) {
        object.reducers[selectorKey] = { type: s[2] };
      }
      object.selectors[selectorKey] = _reselect.createSelector.apply(undefined, _toConsumableArray(args).concat([s[1]]));
    });

    object.get = regeneratorRuntime.mark(function _callee(key) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _effects.select)(key ? object.selectors[key] : object.selector);

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    });

    object.fetch = regeneratorRuntime.mark(function _callee2() {
      var results,
          keys,
          i,
          _args2 = arguments;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              results = {};
              keys = Array.isArray(_args2[0]) ? _args2[0] : _args2;
              i = 0;

            case 3:
              if (!(i < keys.length)) {
                _context2.next = 10;
                break;
              }

              _context2.next = 6;
              return object.get(keys[i]);

            case 6:
              results[keys[i]] = _context2.sent;

            case 7:
              i++;
              _context2.next = 3;
              break;

            case 10:
              return _context2.abrupt('return', results);

            case 11:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    });
  }

  if (hasSaga && isSingleton) {
    object.saga = regeneratorRuntime.mark(function _callee5() {
      var sagas, hasSelectors, _singletonSagaBase, sagaActions, sagaPath;

      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              sagas = (_this.sagas || []).map(function (saga) {
                return saga && saga._hasKeaSaga && saga.saga ? saga.saga : saga;
              });


              if (_this.start || _this.stop || _this.takeEvery || _this.takeLatest) {
                if (!object._createdSaga) {
                  hasSelectors = !!(object.selectors && Object.keys(object.selectors).length > 0);
                  _singletonSagaBase = {
                    start: _this.start,
                    stop: _this.stop,
                    takeEvery: _this.takeEvery,
                    takeLatest: _this.takeLatest,
                    workers: _this.workers ? Object.assign({}, _this.workers) : {},
                    key: object.key,
                    path: object.path,
                    get: hasSelectors ? regeneratorRuntime.mark(function _callee3(key) {
                      return regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              _context3.next = 2;
                              return (0, _effects.select)(key ? object.selectors[key] : object.selector);

                            case 2:
                              return _context3.abrupt('return', _context3.sent);

                            case 3:
                            case 'end':
                              return _context3.stop();
                          }
                        }
                      }, _callee3, this);
                    }) : undefined,
                    fetch: hasSelectors ? regeneratorRuntime.mark(function _callee4() {
                      var results,
                          keys,
                          i,
                          _args4 = arguments;
                      return regeneratorRuntime.wrap(function _callee4$(_context4) {
                        while (1) {
                          switch (_context4.prev = _context4.next) {
                            case 0:
                              results = {};
                              keys = Array.isArray(_args4[0]) ? _args4[0] : _args4;
                              i = 0;

                            case 3:
                              if (!(i < keys.length)) {
                                _context4.next = 10;
                                break;
                              }

                              _context4.next = 6;
                              return this.get(keys[i]);

                            case 6:
                              results[keys[i]] = _context4.sent;

                            case 7:
                              i++;
                              _context4.next = 3;
                              break;

                            case 10:
                              return _context4.abrupt('return', results);

                            case 11:
                            case 'end':
                              return _context4.stop();
                          }
                        }
                      }, _callee4, this);
                    }) : undefined
                  };
                  sagaActions = Object.assign({}, connectedActions, object.actions);


                  object._createdSaga = (0, _create2.createSaga)(_singletonSagaBase, { actions: sagaActions });
                }

                sagas.push(object._createdSaga);
              }

              sagaPath = object.path ? object.path.join('.') : _this.path('').filter(function (p) {
                return p;
              }).join('.');
              _context5.next = 5;
              return (0, _effects.call)((0, _saga.createCombinedSaga)(sagas, sagaPath));

            case 5:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, this);
    });
  }

  var response = function response(Klass) {
    // initializing as a singleton
    if (Klass === false) {
      if (!isSingleton) {
        console.error('[KEA-LOGIC] Standalone "export default kea({})" functions must have no "key"!', object.path, Klass);
      }

      return Object.assign(_this, object);
    }

    if (Klass && Klass.propTypes) {
      propTypes = Object.assign({}, propTypes, Klass.propTypes);
    }

    if (hasLogic) {
      // add proptypes from reducer
      var reducers = _this.reducers ? (0, _reducer.convertReducerArrays)(_this.reducers(object)) : {};
      Object.keys(reducers).forEach(function (reducerKey) {
        if (reducers[reducerKey].type) {
          propTypes[reducerKey] = reducers[reducerKey].type;
        }
      });

      // add proptypes from selectors
      var selectorsThatDontWork = _this.selectors ? _this.selectors({}) : {};
      Object.keys(selectorsThatDontWork).forEach(function (selectorKey) {
        if (selectorsThatDontWork[selectorKey][2]) {
          propTypes[selectorKey] = selectorsThatDontWork[selectorKey][2];
        }
      });
    }

    if (Klass && hasLogic) {
      // add kea metadata to component
      Klass.kea = {
        path: _this.path,
        constants: object.constants,
        actions: object.actions,
        select: function select(key) {
          return cachedSelectors(_this.path(key));
        }
      };
    }

    if (Klass && (hasLogic || hasConnect)) {
      // convert this.props.actions to this.actions in the component
      var originalComponentWillMount = Klass.prototype.componentWillMount;
      Klass.prototype.componentWillMount = function () {
        this.actions = this.props.actions;
        originalComponentWillMount && originalComponentWillMount.bind(this)();
      };
    }

    // check for sagas
    if (Klass && hasSaga) {
      var originalComponentDidMount = Klass.prototype.componentDidMount;
      Klass.prototype.componentDidMount = function () {
        if (DEBUG) {
          console.log('component did mount');
        }

        // this === component instance
        this._keaSagaBase = {};
        this._keaRunningSaga = null;

        var key = _this.key ? _this.key(this.props) : 'index';
        var path = _this.path(key);

        var sagas = (_this.sagas || []).map(function (saga) {
          return saga && saga._hasKeaSaga && saga.saga ? saga.saga : saga;
        });

        if (_this.start || _this.stop || _this.takeEvery || _this.takeLatest) {
          var _component = this;
          _component._keaSagaBase = {
            start: _this.start,
            stop: _this.stop,
            takeEvery: _this.takeEvery,
            takeLatest: _this.takeLatest,
            workers: _this.workers ? Object.assign({}, _this.workers) : {},
            key: key,
            path: path,
            props: this.props,
            get: regeneratorRuntime.mark(function get(key) {
              var _cachedSelectors, selectors, selector;

              return regeneratorRuntime.wrap(function get$(_context6) {
                while (1) {
                  switch (_context6.prev = _context6.next) {
                    case 0:
                      _cachedSelectors = cachedSelectors(path), selectors = _cachedSelectors.selectors, selector = _cachedSelectors.selector;
                      _context6.next = 3;
                      return (0, _effects.select)(key ? selectors[key] : selector);

                    case 3:
                      return _context6.abrupt('return', _context6.sent);

                    case 4:
                    case 'end':
                      return _context6.stop();
                  }
                }
              }, get, this);
            }),
            fetch: regeneratorRuntime.mark(function fetch() {
              var results,
                  keys,
                  i,
                  _args7 = arguments;
              return regeneratorRuntime.wrap(function fetch$(_context7) {
                while (1) {
                  switch (_context7.prev = _context7.next) {
                    case 0:
                      results = {};
                      keys = Array.isArray(_args7[0]) ? _args7[0] : _args7;
                      i = 0;

                    case 3:
                      if (!(i < keys.length)) {
                        _context7.next = 10;
                        break;
                      }

                      _context7.next = 6;
                      return _component._keaSagaBase.get(keys[i]);

                    case 6:
                      results[keys[i]] = _context7.sent;

                    case 7:
                      i++;
                      _context7.next = 3;
                      break;

                    case 10:
                      return _context7.abrupt('return', results);

                    case 11:
                    case 'end':
                      return _context7.stop();
                  }
                }
              }, fetch, this);
            })
          };

          var sagaActions = Object.assign({}, connectedActions);

          // inject key to the payload of inline actions
          Object.keys(object.actions || {}).forEach(function (actionKey) {
            sagaActions[actionKey] = function () {
              var _object$actions;

              var createdAction = (_object$actions = object.actions)[actionKey].apply(_object$actions, arguments);
              return Object.assign({}, createdAction, { payload: Object.assign({ key: key }, createdAction.payload) });
            };
            sagaActions[actionKey].toString = object.actions[actionKey].toString;
          });

          var saga = (0, _create2.createSaga)(this._keaSagaBase, { actions: sagaActions });
          sagas.push(saga);
        }

        if (sagas.length > 0) {
          this._keaRunningSaga = (0, _store.startSaga)((0, _saga.createCombinedSaga)(sagas, path.join('.')));
        }

        originalComponentDidMount && originalComponentDidMount.bind(this)();
      };

      var originalComponentWillReceiveProps = Klass.prototype.componentWillReceiveProps;
      Klass.prototype.componentWillReceiveProps = function (nextProps) {
        this._keaSagaBase.props = nextProps;

        originalComponentWillReceiveProps && originalComponentWillReceiveProps.bind(this)(nextProps);
      };

      var originalComponentWillUnmount = Klass.prototype.componentWillUnmount;
      Klass.prototype.componentWillUnmount = function () {
        if (DEBUG) {
          console.log('component will unmount');
        }
        if (this._keaRunningSaga) {
          (0, _store.cancelSaga)(this._keaRunningSaga);
        }

        originalComponentWillUnmount && originalComponentWillUnmount.bind(this)();
      };
    }

    var selectorFactory = function selectorFactory(dispatch, options) {
      var lastProps = {};
      var result = null;

      if (!(0, _store.isSyncedWithStore)()) {
        dispatch({ type: 'hydrate kea store' });
      }

      return function (nextState, nextOwnProps) {
        var key = void 0;
        var path = void 0;
        var joinedPath = void 0;

        var nextProps = Object.assign({}, nextOwnProps);

        if (hasConnect) {
          // TODO: this will fail if the redux tree is not initialized yet.
          // see comment in logic-component.js

          // connected props
          Object.keys(connectedSelectors).forEach(function (propKey) {
            nextProps[propKey] = connectedSelectors[propKey](nextState, nextOwnProps);
          });
        }

        if (hasLogic) {
          key = _this.key ? _this.key(nextOwnProps) : 'index';

          if (typeof key === 'undefined') {
            console.error('"key" can\'t be undefined in path: ' + _this.path('undefined').join('.'));
          }

          path = _this.path(key);
          joinedPath = path.join('.');

          if (DEBUG) {
            console.log('Inline selectorFactory for ' + joinedPath);
            console.log({ nextOwnProps: nextOwnProps, nextState: nextState, key: key, path: path });
          }

          var selector = void 0;
          var selectors = void 0;

          // now we must check if the reducer is already in redux, or we need to add it
          // if we need to add it, create "dummy" selectors for the default values until then

          // is the reducer created? if we have "true" in the cache, it's definitely created
          var reducerCreated = inlineCache[joinedPath] && inlineCache[joinedPath].reducerCreated;

          // if it's not let's double check. maybe it is now?
          if (!reducerCreated) {
            try {
              selector = function selector(state) {
                return (0, _selectors.pathSelector)(path, state);
              };
              reducerCreated = typeof selector(nextState) !== 'undefined';
            } catch (e) {
              reducerCreated = false;
            }
          }

          // we have the selectors cached! with the current reducerCreated state!
          if (inlineCache[joinedPath] && inlineCache[joinedPath].reducerCreated === reducerCreated) {
            if (DEBUG) {
              console.log('cache hit!');
            }
            selector = inlineCache[joinedPath].selector;
            selectors = inlineCache[joinedPath].selectors;

            // either we have nothing cached or the cache is invalid. regenerate the selectors!
          } else {
            if (!selector) {
              selector = function selector(state) {
                return (0, _selectors.pathSelector)(path, state);
              };
            }

            // add { path } and { key } to the reducer creator function
            var localObject = Object.assign({}, object, { path: path, key: key, props: nextOwnProps });
            localObject.reducers = _this.reducers ? (0, _reducer.convertReducerArrays)(_this.reducers(localObject)) : {};
            localObject.reducer = _this.reducer ? _this.reducer(localObject) : (0, _reducer.combineReducerObjects)(path, localObject.reducers);

            // if the reducer is in redux, get real reducer selectors. otherwise add dummies that return defaults
            if (reducerCreated) {
              selectors = (0, _selectors.createSelectors)(path, Object.keys(localObject.reducers));
            } else {
              (0, _store.addReducer)(path, localObject.reducer, true);

              var realSelectors = (0, _selectors.createSelectors)(path, Object.keys(localObject.reducers));

              // if we don't know for sure that the reducer is in the current store object,
              // then fallback to giving the default value
              selectors = {};
              Object.keys(localObject.reducers).forEach(function (key) {
                selectors[key] = function (state) {
                  try {
                    return realSelectors[key](state);
                  } catch (error) {
                    return localObject.reducers[key].value;
                  }
                };
              });
            }

            // create
            var _selectorResponse = _this.selectors ? _this.selectors(Object.assign({}, localObject, { selectors: selectors })) : {};

            Object.keys(_selectorResponse).forEach(function (selectorKey) {
              // s == [() => args, selectorFunction, propType]
              var s = _selectorResponse[selectorKey];

              var args = s[0]();
              selectors[selectorKey] = _reselect.createSelector.apply(undefined, _toConsumableArray(args).concat([s[1]]));
            });

            // store in the cache
            inlineCache[joinedPath] = {
              reducerCreated: reducerCreated,
              selector: selector,
              selectors: selectors
            };
          }

          if (DEBUG) {
            console.log({ selector: selector, selectors: selectors });
          }

          Object.keys(selectors).forEach(function (selectorKey) {
            nextProps[selectorKey] = selectors[selectorKey](nextState, nextOwnProps);
          });
        }

        if (DEBUG) {
          console.log({ nextProps: nextProps });
        }

        // TODO: cache these even if no path present
        var actions = joinedPath ? actionCache[joinedPath] : null;

        if (!actions) {
          actions = {};

          if (hasConnect) {
            // pass conneted actions as they are
            Object.keys(connectedActions).forEach(function (actionKey) {
              actions[actionKey] = function () {
                var _connectedActions;

                return dispatch((_connectedActions = connectedActions)[actionKey].apply(_connectedActions, arguments));
              };
            });
          }

          if (hasLogic) {
            // inject key to the payload of inline actions
            Object.keys(object.actions).forEach(function (actionKey) {
              actions[actionKey] = function () {
                var _object$actions2;

                var createdAction = (_object$actions2 = object.actions)[actionKey].apply(_object$actions2, arguments);
                return dispatch(Object.assign({}, createdAction, { payload: Object.assign({ key: key }, createdAction.payload) }));
              };
            });
          }

          if (DEBUG) {
            console.log({ actions: actions });
          }

          if (joinedPath) {
            actionCache[joinedPath] = actions;
          }
        }

        // if the props did not change, return the old cached object
        if (!result || !(0, _shallowEqual2.default)(lastProps, nextProps)) {
          lastProps = nextProps;
          result = Object.assign({}, nextProps, { actions: actions, dispatch: dispatch });
        }

        return result;
      };
    };

    return (0, _reactRedux.connectAdvanced)(selectorFactory, { methodName: 'kea' })(Klass);
  };

  response.path = object.path;
  response.constants = object.constants;
  response.actions = object.actions;
  response.reducer = object.reducer;
  response.reducers = object.reducers;
  response.selector = object.selector;
  response.selectors = object.selectors;
  response.saga = object.saga;
  response.get = object.get;
  response.fetch = object.fetch;

  response._isKeaFunction = true;
  response._isKeaSingleton = isSingleton;
  response._hasKeaConnect = hasConnect;
  response._hasKeaLogic = hasLogic;
  response._hasKeaSaga = hasSaga;

  if (object.path) {
    if (isSingleton) {
      (0, _store.addReducer)(object.path, object.reducer, true);
      response._keaReducerConnected = true;
    } else {
      response._keaReducerConnected = false;
    }
  }

  return response;
}

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.createPropTransforms = createPropTransforms;
exports.selectPropsFromLogic = selectPropsFromLogic;
exports.propTypesFromMapping = propTypesFromMapping;
exports.havePropsChanged = havePropsChanged;

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reselect = __webpack_require__(281);

var _selectors = __webpack_require__(357);

var _store = __webpack_require__(254);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createPropTransforms() {
  var mapping = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (mapping.length % 2 === 1) {
    console.error('[KEA-LOGIC] uneven mapping given to selectPropsFromLogic:', mapping);
    console.trace();
    return;
  }

  var hash = {};
  var transforms = {};

  var _loop = function _loop(i) {
    var logic = mapping[i];
    var props = mapping[i + 1];

    // we were given a function (state) => state.something as logic input
    var isFunction = typeof logic === 'function' && !logic._isKeaFunction;

    // path selector array
    if (Array.isArray(logic)) {
      logic = function logic(state) {
        return (0, _selectors.safePathSelector)(mapping[i], state);
      };
      isFunction = true;
    }

    if (logic._isKeaSingleton) {
      if (!logic._keaReducerConnected) {
        (0, _store.addReducer)(logic.path, logic.reducer, true);
        logic._keaReducerConnected = true;
      }
    }

    var selectors = isFunction ? null : logic.selectors ? logic.selectors : logic;

    props.forEach(function (query) {
      var from = query;
      var to = query;

      if (query.includes(' as ')) {
        var _query$split = query.split(' as ');

        var _query$split2 = _slicedToArray(_query$split, 2);

        from = _query$split2[0];
        to = _query$split2[1];
      }

      var matches = from.match(/^(.*)\[(.*)\]$/);

      if (matches) {
        if (from === to) {
          to = matches[1];
        }
        from = matches[1];
        transforms[to] = function (value, props) {
          return value[props[matches[2]]];
        };
      }

      if (from === '*') {
        hash[to] = isFunction ? logic : logic.selector ? logic.selector : selectors;
      } else if (isFunction) {
        hash[to] = function (state) {
          return (logic(state) || {})[from];
        };
      } else if (typeof selectors[from] !== 'undefined') {
        hash[to] = selectors[from];
      } else {
        console.error('[KEA-LOGIC] selector "' + query + '" missing for logic:', logic);
        console.trace();
      }
    });
  };

  for (var i = 0; i < mapping.length; i += 2) {
    _loop(i);
  }

  return {
    selectorFunctions: hash,
    selectors: (0, _reselect.createStructuredSelector)(hash),
    transforms: transforms
  };
}

function selectPropsFromLogic() {
  var mapping = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return createPropTransforms(mapping).selectors;
}

function propTypesFromMapping(mapping) {
  var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var propTypes = Object.assign({}, mapping.propTypes || mapping.passedProps || {});

  if (mapping.props) {
    if (mapping.props.length % 2 === 1) {
      console.error('[KEA-LOGIC] uneven props mapping given to propTypesFromLogic:', mapping);
      console.trace();
      return;
    }

    var _loop2 = function _loop2(i) {
      var logic = mapping.props[i];
      var props = mapping.props[i + 1];

      if (logic._isKeaSingleton) {
        if (!logic._keaReducerConnected) {
          (0, _store.addReducer)(logic.path, logic.reducer, true);
          logic._keaReducerConnected = true;
        }
      }

      if (logic && logic.reducers) {
        props.forEach(function (query) {
          var from = query;
          var to = query;

          if (query.includes(' as ')) {
            var _query$split3 = query.split(' as ');

            var _query$split4 = _slicedToArray(_query$split3, 2);

            from = _query$split4[0];
            to = _query$split4[1];
          }

          var matches = from.match(/^(.*)\[(.*)]$/);

          if (matches) {
            if (from === to) {
              to = matches[1];
            }
            from = matches[1];
          }

          var reducer = logic.reducers[from];

          if (reducer && reducer.type) {
            propTypes[to] = reducer.type;
          } else if (from !== '*') {
            console.error('[KEA-LOGIC] prop type for "' + from + '" missing for logic:', logic);
            console.trace();
          }
        });
      }
    };

    for (var i = 0; i < mapping.props.length; i += 2) {
      _loop2(i);
    }
  }

  if (mapping.actions) {
    if (mapping.actions.length % 2 === 1) {
      console.error('[KEA-LOGIC] uneven actions mapping given to propTypesFromLogic:', mapping);
      console.trace();
      return;
    }

    var actions = {};

    var _loop3 = function _loop3(i) {
      var logic = mapping.actions[i];
      var actionsArray = mapping.actions[i + 1];

      if (logic._isKeaSingleton) {
        if (!logic._keaReducerConnected) {
          (0, _store.addReducer)(logic.path, logic.reducer, true);
          logic._keaReducerConnected = true;
        }
      }

      var actions = logic && logic.actions ? logic.actions : logic;

      actionsArray.forEach(function (query) {
        var from = query;
        var to = query;

        if (query.includes(' as ')) {
          var _query$split5 = query.split(' as ');

          var _query$split6 = _slicedToArray(_query$split5, 2);

          from = _query$split6[0];
          to = _query$split6[1];
        }

        var matches = from.match(/^(.*)\((.*)\)$/);

        if (matches) {
          if (from === to) {
            to = matches[1];
          }
          from = matches[1];
        }

        if (actions[from]) {
          propTypes[to] = _propTypes2.default.func;
        } else {
          console.error('[KEA-LOGIC] action "' + query + '" missing for logic:', logic);
          console.trace();
        }
      });
    };

    for (var i = 0; i < mapping.actions.length; i += 2) {
      _loop3(i);
    }

    propTypes.actions = _propTypes2.default.shape(actions);
  }

  if (extra) {
    Object.assign(propTypes, extra);
  }

  return propTypes;
}

function havePropsChangedDebug(nextProps) {
  var _this = this;

  var changedProps = Object.keys(nextProps).filter(function (key) {
    return key !== 'actions' && nextProps[key] !== _this.props[key];
  });
  if (changedProps.length > 0) {
    changedProps.forEach(function (key) {
      console.log('prop \'' + key + '\' changed', _this.props[key], nextProps[key]);
    });
    return true;
  }
  return false;
}

function havePropsChangedProduction(nextProps) {
  for (var key in nextProps) {
    if (key === 'actions') {
      continue;
    }
    if (nextProps[key] !== this.props[key]) {
      return true;
    }
  }
  return false;
}

function havePropsChanged() {
  var debug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (debug) {
    return havePropsChangedDebug;
  } else {
    return havePropsChangedProduction;
  }
}

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConnectedSagas = getConnectedSagas;
function getConnectedSagas(mapping) {
  var sagas = [];
  var uniqueSagaKeys = {};

  var props = mapping.props || [];
  for (var i = 0; i < props.length; i += 2) {
    var logic = props[i];
    if (logic && logic._hasKeaSaga && logic.path) {
      var sagaPath = logic.path.join('.');
      if (!uniqueSagaKeys[sagaPath]) {
        sagas.push(logic.saga);
        uniqueSagaKeys[sagaPath] = true;
      }
    }
  }

  var actions = mapping.actions || [];
  for (var _i = 0; _i < actions.length; _i += 2) {
    var _logic = actions[_i];
    if (_logic && _logic._hasKeaSaga && _logic.path) {
      var _sagaPath = _logic.path.join('.');
      if (!uniqueSagaKeys[_sagaPath]) {
        sagas.push(_logic.saga);
        uniqueSagaKeys[_sagaPath] = true;
      }
    }
  }

  return sagas;
}

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSaga = createSaga;

var _effects = __webpack_require__(26);

var _actions = __webpack_require__(253);

var _gaveRunWarning = false;
var _gaveCancelledWarning = false;

// this = object with keys { takeEvery, takeLatest, start, stop }
// object = what is merged into _this after actions are created
function createSaga(_this) {
  var object = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // bind all functions to _this
  var keys = Object.keys(_this);
  for (var i = 0; i < keys.length; i++) {
    if (typeof _this[keys[i]] === 'function') {
      _this[keys[i]] = _this[keys[i]].bind(_this);
    }
  }

  if (_this.workers) {
    var _keys = Object.keys(_this.workers);
    for (var _i = 0; _i < _keys.length; _i++) {
      if (typeof _this.workers[_keys[_i]] === 'function') {
        _this.workers[_keys[_i]] = _this.workers[_keys[_i]].bind(_this);
      }
    }
  }

  object.actions = _this.actions ? (0, _actions.selectActionsFromLogic)(_this.actions(object)) : object.actions || {};
  Object.assign(_this, object);

  // generate the saga
  return regeneratorRuntime.mark(function _callee() {
    var ops, opKeys, k, op, list, _keys2, _i2, fn, j;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            // start takeEvery and takeLatest watchers
            ops = { takeEvery: _effects.takeEvery, takeLatest: _effects.takeLatest };
            opKeys = Object.keys(ops);
            k = 0;

          case 4:
            if (!(k < opKeys.length)) {
              _context.next = 30;
              break;
            }

            op = opKeys[k];

            if (!_this[op]) {
              _context.next = 27;
              break;
            }

            list = _this[op](_this);
            _keys2 = Object.keys(list);
            _i2 = 0;

          case 10:
            if (!(_i2 < _keys2.length)) {
              _context.next = 27;
              break;
            }

            fn = list[_keys2[_i2]];

            if (!Array.isArray(fn)) {
              _context.next = 22;
              break;
            }

            j = 0;

          case 14:
            if (!(j < fn.length)) {
              _context.next = 20;
              break;
            }

            _context.next = 17;
            return ops[op](_keys2[_i2], fn[j].bind(_this));

          case 17:
            j++;
            _context.next = 14;
            break;

          case 20:
            _context.next = 24;
            break;

          case 22:
            _context.next = 24;
            return ops[op](_keys2[_i2], fn.bind(_this));

          case 24:
            _i2++;
            _context.next = 10;
            break;

          case 27:
            k++;
            _context.next = 4;
            break;

          case 30:
            if (!_this.run) {
              _context.next = 34;
              break;
            }

            if (!_gaveRunWarning) {
              console.warn('[KEA-LOGIC] run() is deprecated in sagas. Use start() instead.');
              _gaveRunWarning = true;
            }
            _context.next = 34;
            return (0, _effects.call)(_this.run);

          case 34:
            if (!_this.start) {
              _context.next = 37;
              break;
            }

            _context.next = 37;
            return (0, _effects.call)(_this.start);

          case 37:
            _context.prev = 37;
            _context.next = 40;
            return (0, _effects.cancelled)();

          case 40:
            if (!_context.sent) {
              _context.next = 48;
              break;
            }

            if (!_this.cancelled) {
              _context.next = 45;
              break;
            }

            if (!_gaveCancelledWarning) {
              console.warn('[KEA-LOGIC] cancelled() is deprecated in sagas. Use stop() instead.');
              _gaveCancelledWarning = true;
            }
            _context.next = 45;
            return (0, _effects.call)(_this.cancelled);

          case 45:
            if (!_this.stop) {
              _context.next = 48;
              break;
            }

            _context.next = 48;
            return (0, _effects.call)(_this.stop);

          case 48:
            return _context.finish(37);

          case 49:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[0,, 37, 49]]);
  });
}

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearRunningSagas = clearRunningSagas;
exports.createCombinedSaga = createCombinedSaga;

var _effects = __webpack_require__(26);

var DEBUG = false;

var runningSagas = {};

function clearRunningSagas() {
  runningSagas = {};
}

function createCombinedSaga(sagas) {
  var sagaPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  return regeneratorRuntime.mark(function _callee() {
    var workers, i, worker, _i;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (DEBUG) {
              console.log('Starting ' + sagaPath);
            }

            if (!(sagaPath && runningSagas[sagaPath])) {
              _context.next = 6;
              break;
            }

            if (DEBUG) {
              console.log('Already running ' + sagaPath);
            }
            return _context.abrupt('return');

          case 6:
            runningSagas[sagaPath] = true;

          case 7:
            workers = [];
            _context.prev = 8;
            i = 0;

          case 10:
            if (!(i < sagas.length)) {
              _context.next = 18;
              break;
            }

            _context.next = 13;
            return (0, _effects.fork)(sagas[i]);

          case 13:
            worker = _context.sent;

            workers.push(worker);

          case 15:
            i++;
            _context.next = 10;
            break;

          case 18:
            if (false) {
              _context.next = 23;
              break;
            }

            _context.next = 21;
            return (0, _effects.take)('wait until worker cancellation');

          case 21:
            _context.next = 18;
            break;

          case 23:
            _context.prev = 23;
            _context.next = 26;
            return (0, _effects.cancelled)();

          case 26:
            if (!_context.sent) {
              _context.next = 34;
              break;
            }

            _i = 0;

          case 28:
            if (!(_i < workers.length)) {
              _context.next = 34;
              break;
            }

            _context.next = 31;
            return (0, _effects.cancel)(workers[_i]);

          case 31:
            _i++;
            _context.next = 28;
            break;

          case 34:
            delete runningSagas[sagaPath];
            if (DEBUG) {
              console.log('Stopped ' + sagaPath);
            }
            return _context.finish(23);

          case 37:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[8,, 23, 37]]);
  });
}

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return false;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(1268);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(60)))

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(1269);


/** Built-in value references. */
var getPrototype = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(528);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(1265);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(1271);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(125),
    root = __webpack_require__(66);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1342),
    hashDelete = __webpack_require__(1343),
    hashGet = __webpack_require__(1344),
    hashHas = __webpack_require__(1345),
    hashSet = __webpack_require__(1346);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(125),
    root = __webpack_require__(66);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(125),
    root = __webpack_require__(66);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 1277 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 1278 */
/***/ (function(module, exports) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),
/* 1279 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(1292);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 1281 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 1282 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 1283 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(362);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(155),
    keys = __webpack_require__(102);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(155),
    keysIn = __webpack_require__(204);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 1287 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.conformsTo` which accepts `props` to check.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property predicates to conform to.
 * @returns {boolean} Returns `true` if `object` conforms, else `false`.
 */
function baseConformsTo(object, source, props) {
  var length = props.length;
  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (length--) {
    var key = props[length],
        predicate = source[key],
        value = object[key];

    if ((value === undefined && !(key in object)) || !predicate(value)) {
      return false;
    }
  }
  return true;
}

module.exports = baseConformsTo;


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(43);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 1289 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */
function baseGt(value, other) {
  return value > other;
}

module.exports = baseGt;


/***/ }),
/* 1290 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 1291 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(536),
    baseIsNaN = __webpack_require__(1298),
    strictIndexOf = __webpack_require__(1377);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(51),
    isObjectLike = __webpack_require__(37);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(51),
    isObjectLike = __webpack_require__(37);

var arrayBufferTag = '[object ArrayBuffer]';

/**
 * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
 */
function baseIsArrayBuffer(value) {
  return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
}

module.exports = baseIsArrayBuffer;


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(51),
    isObjectLike = __webpack_require__(37);

/** `Object#toString` result references. */
var dateTag = '[object Date]';

/**
 * The base implementation of `_.isDate` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 */
function baseIsDate(value) {
  return isObjectLike(value) && baseGetTag(value) == dateTag;
}

module.exports = baseIsDate;


/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(256),
    equalArrays = __webpack_require__(551),
    equalByTag = __webpack_require__(1337),
    equalObjects = __webpack_require__(1338),
    getTag = __webpack_require__(126),
    isArray = __webpack_require__(23),
    isBuffer = __webpack_require__(161),
    isTypedArray = __webpack_require__(203);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(126),
    isObjectLike = __webpack_require__(37);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 1298 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(51),
    isObjectLike = __webpack_require__(37);

/** `Object#toString` result references. */
var regexpTag = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return isObjectLike(value) && baseGetTag(value) == regexpTag;
}

module.exports = baseIsRegExp;


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(126),
    isObjectLike = __webpack_require__(37);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(51),
    isLength = __webpack_require__(264),
    isObjectLike = __webpack_require__(37);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(43),
    isPrototype = __webpack_require__(261),
    nativeKeysIn = __webpack_require__(1366);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 1303 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */
function baseLt(value, other) {
  return value < other;
}

module.exports = baseLt;


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(364),
    getMatchData = __webpack_require__(367),
    matchesStrictComparable = __webpack_require__(562);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(258),
    get = __webpack_require__(1390),
    hasIn = __webpack_require__(569),
    isKey = __webpack_require__(370),
    isStrictComparable = __webpack_require__(560),
    matchesStrictComparable = __webpack_require__(562),
    toKey = __webpack_require__(157);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(256),
    assignMergeValue = __webpack_require__(534),
    baseFor = __webpack_require__(538),
    baseMergeDeep = __webpack_require__(1307),
    isObject = __webpack_require__(43),
    keysIn = __webpack_require__(204),
    safeGet = __webpack_require__(565);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(534),
    cloneBuffer = __webpack_require__(547),
    cloneTypedArray = __webpack_require__(548),
    copyArray = __webpack_require__(366),
    initCloneObject = __webpack_require__(558),
    isArguments = __webpack_require__(160),
    isArray = __webpack_require__(23),
    isArrayLikeObject = __webpack_require__(570),
    isBuffer = __webpack_require__(161),
    isFunction = __webpack_require__(101),
    isObject = __webpack_require__(43),
    isPlainObject = __webpack_require__(202),
    isTypedArray = __webpack_require__(203),
    safeGet = __webpack_require__(565),
    toPlainObject = __webpack_require__(584);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(197),
    baseGet = __webpack_require__(199),
    baseIteratee = __webpack_require__(92),
    baseMap = __webpack_require__(542),
    baseSortBy = __webpack_require__(1317),
    baseUnary = __webpack_require__(124),
    compareMultiple = __webpack_require__(1327),
    identity = __webpack_require__(201),
    isArray = __webpack_require__(23);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(1310),
    hasIn = __webpack_require__(569);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(199),
    baseSet = __webpack_require__(1314),
    castPath = __webpack_require__(154);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 1311 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(199);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

var baseUnset = __webpack_require__(545),
    isIndex = __webpack_require__(200);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * The base implementation of `_.pullAt` without support for individual
 * indexes or capturing the removed elements.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {number[]} indexes The indexes of elements to remove.
 * @returns {Array} Returns `array`.
 */
function basePullAt(array, indexes) {
  var length = array ? indexes.length : 0,
      lastIndex = length - 1;

  while (length--) {
    var index = indexes[length];
    if (length == lastIndex || index !== previous) {
      var previous = index;
      if (isIndex(index)) {
        splice.call(array, index, 1);
      } else {
        baseUnset(array, index);
      }
    }
  }
  return array;
}

module.exports = basePullAt;


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(361),
    castPath = __webpack_require__(154),
    isIndex = __webpack_require__(200),
    isObject = __webpack_require__(43),
    toKey = __webpack_require__(157);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(1387),
    defineProperty = __webpack_require__(550),
    identity = __webpack_require__(201);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 1316 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 1317 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),
/* 1318 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(123),
    arrayMap = __webpack_require__(197),
    isArray = __webpack_require__(23),
    isSymbol = __webpack_require__(162);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(1380);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(197);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(201);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(365);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 1324 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(123);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(162);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(1326);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(155),
    getSymbols = __webpack_require__(369);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(155),
    getSymbolsIn = __webpack_require__(556);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(1278),
    baseAggregator = __webpack_require__(1284),
    baseIteratee = __webpack_require__(92),
    isArray = __webpack_require__(23);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(543),
    isIterateeCall = __webpack_require__(559);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(83);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 1333 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(92),
    isArrayLike = __webpack_require__(83),
    keys = __webpack_require__(102);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(529),
    noop = __webpack_require__(1417),
    setToArray = __webpack_require__(263);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(202);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(123),
    Uint8Array = __webpack_require__(531),
    eq = __webpack_require__(158),
    equalArrays = __webpack_require__(551),
    mapToArray = __webpack_require__(561),
    setToArray = __webpack_require__(263);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(554);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(123);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1340 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1341 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(262);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1343 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(262);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(262);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(262);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1347 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(365),
    cloneDataView = __webpack_require__(1323),
    cloneRegExp = __webpack_require__(1324),
    cloneSymbol = __webpack_require__(1325),
    cloneTypedArray = __webpack_require__(548);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(123),
    isArguments = __webpack_require__(160),
    isArray = __webpack_require__(23);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 1350 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(549),
    isFunction = __webpack_require__(101),
    stubFalse = __webpack_require__(581);

/**
 * Checks if `func` is capable of being masked.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
 */
var isMaskable = coreJsData ? isFunction : stubFalse;

module.exports = isMaskable;


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(549);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1353 */
/***/ (function(module, exports) {

/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

module.exports = iteratorToArray;


/***/ }),
/* 1354 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(257);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(257);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(257);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(257);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1274),
    ListCache = __webpack_require__(255),
    Map = __webpack_require__(358);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(260);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(260);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(260);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(260);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1416);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(563);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1366 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 1367 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(199),
    baseSlice = __webpack_require__(1316);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 1369 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 1370 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 1371 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(255);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1373 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1374 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1375 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(255),
    Map = __webpack_require__(358),
    MapCache = __webpack_require__(359);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1377 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(1283),
    hasUnicode = __webpack_require__(1341),
    unicodeToArray = __webpack_require__(1381);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1364);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1380 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 1381 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(23);

/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */
function castArray() {
  if (!arguments.length) {
    return [];
  }
  var value = arguments[0];
  return isArray(value) ? value : [value];
}

module.exports = castArray;


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(198);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(198);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.cloneWith` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the deep cloned value.
 * @see _.cloneWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(true);
 *   }
 * }
 *
 * var el = _.cloneDeepWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 20
 */
function cloneDeepWith(value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
}

module.exports = cloneDeepWith;


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(198);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it accepts `customizer` which
 * is invoked to produce the cloned value. If `customizer` returns `undefined`,
 * cloning is handled by the method instead. The `customizer` is invoked with
 * up to four arguments; (value [, index|key, object, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeepWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(false);
 *   }
 * }
 *
 * var el = _.cloneWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 0
 */
function cloneWith(value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
}

module.exports = cloneWith;


/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

var baseConformsTo = __webpack_require__(1287),
    keys = __webpack_require__(102);

/**
 * Checks if `object` conforms to `source` by invoking the predicate
 * properties of `source` with the corresponding property values of `object`.
 *
 * **Note:** This method is equivalent to `_.conforms` when `source` is
 * partially applied.
 *
 * @static
 * @memberOf _
 * @since 4.14.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property predicates to conform to.
 * @returns {boolean} Returns `true` if `object` conforms, else `false`.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 *
 * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
 * // => true
 *
 * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
 * // => false
 */
function conformsTo(object, source) {
  return source == null || baseConformsTo(object, source, keys(source));
}

module.exports = conformsTo;


/***/ }),
/* 1387 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(43),
    now = __webpack_require__(1418),
    toNumber = __webpack_require__(266);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(537);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(199);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(153),
    createAggregator = __webpack_require__(1330);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy = createAggregator(function(result, value, key) {
  if (hasOwnProperty.call(result, key)) {
    result[key].push(value);
  } else {
    baseAssignValue(result, key, [value]);
  }
});

module.exports = groupBy;


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

var baseGt = __webpack_require__(1289),
    createRelationalOperation = __webpack_require__(259);

/**
 * Checks if `value` is greater than `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 * @see _.lt
 * @example
 *
 * _.gt(3, 1);
 * // => true
 *
 * _.gt(3, 3);
 * // => false
 *
 * _.gt(1, 3);
 * // => false
 */
var gt = createRelationalOperation(baseGt);

module.exports = gt;


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

var createRelationalOperation = __webpack_require__(259);

/**
 * Checks if `value` is greater than or equal to `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than or equal to
 *  `other`, else `false`.
 * @see _.lte
 * @example
 *
 * _.gte(3, 1);
 * // => true
 *
 * _.gte(3, 3);
 * // => true
 *
 * _.gte(1, 3);
 * // => false
 */
var gte = createRelationalOperation(function(value, other) {
  return value >= other;
});

module.exports = gte;


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(1290),
    hasPath = __webpack_require__(557);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 1395 */
/***/ (function(module, exports) {

/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return (array && array.length) ? array[0] : undefined;
}

module.exports = head;


/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArrayBuffer = __webpack_require__(1294),
    baseUnary = __webpack_require__(124),
    nodeUtil = __webpack_require__(156);

/* Node.js helper references. */
var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer;

/**
 * Checks if `value` is classified as an `ArrayBuffer` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
 * @example
 *
 * _.isArrayBuffer(new ArrayBuffer(2));
 * // => true
 *
 * _.isArrayBuffer(new Array(2));
 * // => false
 */
var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

module.exports = isArrayBuffer;


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(51),
    isObjectLike = __webpack_require__(37);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike(value) && baseGetTag(value) == boolTag);
}

module.exports = isBoolean;


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsDate = __webpack_require__(1295),
    baseUnary = __webpack_require__(124),
    nodeUtil = __webpack_require__(156);

/* Node.js helper references. */
var nodeIsDate = nodeUtil && nodeUtil.isDate;

/**
 * Checks if `value` is classified as a `Date` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 * @example
 *
 * _.isDate(new Date);
 * // => true
 *
 * _.isDate('Mon April 23 2012');
 * // => false
 */
var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

module.exports = isDate;


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

var isObjectLike = __webpack_require__(37),
    isPlainObject = __webpack_require__(202);

/**
 * Checks if `value` is likely a DOM element.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
 * @example
 *
 * _.isElement(document.body);
 * // => true
 *
 * _.isElement('<body>');
 * // => false
 */
function isElement(value) {
  return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
}

module.exports = isElement;


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(258);

/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */
function isEqualWith(value, other, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  var result = customizer ? customizer(value, other) : undefined;
  return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
}

module.exports = isEqualWith;


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(51),
    isObjectLike = __webpack_require__(37),
    isPlainObject = __webpack_require__(202);

/** `Object#toString` result references. */
var domExcTag = '[object DOMException]',
    errorTag = '[object Error]';

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == errorTag || tag == domExcTag ||
    (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
}

module.exports = isError;


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(66);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsFinite = root.isFinite;

/**
 * Checks if `value` is a finite primitive number.
 *
 * **Note:** This method is based on
 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
 * @example
 *
 * _.isFinite(3);
 * // => true
 *
 * _.isFinite(Number.MIN_VALUE);
 * // => true
 *
 * _.isFinite(Infinity);
 * // => false
 *
 * _.isFinite('3');
 * // => false
 */
function isFinite(value) {
  return typeof value == 'number' && nativeIsFinite(value);
}

module.exports = isFinite;


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(364),
    getMatchData = __webpack_require__(367);

/**
 * Performs a partial deep comparison between `object` and `source` to
 * determine if `object` contains equivalent property values.
 *
 * **Note:** This method is equivalent to `_.matches` when `source` is
 * partially applied.
 *
 * Partial comparisons will match empty array and empty object `source`
 * values against any array or object value, respectively. See `_.isEqual`
 * for a list of supported value comparisons.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 *
 * _.isMatch(object, { 'b': 2 });
 * // => true
 *
 * _.isMatch(object, { 'b': 1 });
 * // => false
 */
function isMatch(object, source) {
  return object === source || baseIsMatch(object, source, getMatchData(source));
}

module.exports = isMatch;


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(364),
    getMatchData = __webpack_require__(367);

/**
 * This method is like `_.isMatch` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with five
 * arguments: (objValue, srcValue, index|key, object, source).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, srcValue) {
 *   if (isGreeting(objValue) && isGreeting(srcValue)) {
 *     return true;
 *   }
 * }
 *
 * var object = { 'greeting': 'hello' };
 * var source = { 'greeting': 'hi' };
 *
 * _.isMatchWith(object, source, customizer);
 * // => true
 */
function isMatchWith(object, source, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return baseIsMatch(object, source, getMatchData(source), customizer);
}

module.exports = isMatchWith;


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(540),
    isMaskable = __webpack_require__(1351);

/** Error message constants. */
var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.';

/**
 * Checks if `value` is a pristine native function.
 *
 * **Note:** This method can't reliably detect native functions in the presence
 * of the core-js package because core-js circumvents this kind of detection.
 * Despite multiple requests, the core-js maintainer has made it clear: any
 * attempt to fix the detection will be obstructed. As a result, we're left
 * with little choice but to throw an error. Unfortunately, this also affects
 * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
 * which rely on core-js.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (isMaskable(value)) {
    throw new Error(CORE_ERROR_TEXT);
  }
  return baseIsNative(value);
}

module.exports = isNative;


/***/ }),
/* 1406 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),
/* 1407 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */
function isNull(value) {
  return value === null;
}

module.exports = isNull;


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsRegExp = __webpack_require__(1299),
    baseUnary = __webpack_require__(124),
    nodeUtil = __webpack_require__(156);

/* Node.js helper references. */
var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

module.exports = isRegExp;


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

var isInteger = __webpack_require__(571);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
 * double precision number which isn't the result of a rounded unsafe integer.
 *
 * **Note:** This method is based on
 * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
 * @example
 *
 * _.isSafeInteger(3);
 * // => true
 *
 * _.isSafeInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isSafeInteger(Infinity);
 * // => false
 *
 * _.isSafeInteger('3');
 * // => false
 */
function isSafeInteger(value) {
  return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
}

module.exports = isSafeInteger;


/***/ }),
/* 1410 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(126),
    isObjectLike = __webpack_require__(37);

/** `Object#toString` result references. */
var weakMapTag = '[object WeakMap]';

/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */
function isWeakMap(value) {
  return isObjectLike(value) && getTag(value) == weakMapTag;
}

module.exports = isWeakMap;


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(51),
    isObjectLike = __webpack_require__(37);

/** `Object#toString` result references. */
var weakSetTag = '[object WeakSet]';

/**
 * Checks if `value` is classified as a `WeakSet` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
 * @example
 *
 * _.isWeakSet(new WeakSet);
 * // => true
 *
 * _.isWeakSet(new Set);
 * // => false
 */
function isWeakSet(value) {
  return isObjectLike(value) && baseGetTag(value) == weakSetTag;
}

module.exports = isWeakSet;


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  'castArray': __webpack_require__(1382),
  'clone': __webpack_require__(1383),
  'cloneDeep': __webpack_require__(568),
  'cloneDeepWith': __webpack_require__(1384),
  'cloneWith': __webpack_require__(1385),
  'conformsTo': __webpack_require__(1386),
  'eq': __webpack_require__(158),
  'gt': __webpack_require__(1392),
  'gte': __webpack_require__(1393),
  'isArguments': __webpack_require__(160),
  'isArray': __webpack_require__(23),
  'isArrayBuffer': __webpack_require__(1396),
  'isArrayLike': __webpack_require__(83),
  'isArrayLikeObject': __webpack_require__(570),
  'isBoolean': __webpack_require__(1397),
  'isBuffer': __webpack_require__(161),
  'isDate': __webpack_require__(1398),
  'isElement': __webpack_require__(1399),
  'isEmpty': __webpack_require__(72),
  'isEqual': __webpack_require__(127),
  'isEqualWith': __webpack_require__(1400),
  'isError': __webpack_require__(1401),
  'isFinite': __webpack_require__(1402),
  'isFunction': __webpack_require__(101),
  'isInteger': __webpack_require__(571),
  'isLength': __webpack_require__(264),
  'isMap': __webpack_require__(572),
  'isMatch': __webpack_require__(1403),
  'isMatchWith': __webpack_require__(1404),
  'isNaN': __webpack_require__(573),
  'isNative': __webpack_require__(1405),
  'isNil': __webpack_require__(1406),
  'isNull': __webpack_require__(1407),
  'isNumber': __webpack_require__(574),
  'isObject': __webpack_require__(43),
  'isObjectLike': __webpack_require__(37),
  'isPlainObject': __webpack_require__(202),
  'isRegExp': __webpack_require__(1408),
  'isSafeInteger': __webpack_require__(1409),
  'isSet': __webpack_require__(575),
  'isString': __webpack_require__(576),
  'isSymbol': __webpack_require__(162),
  'isTypedArray': __webpack_require__(203),
  'isUndefined': __webpack_require__(1410),
  'isWeakMap': __webpack_require__(1411),
  'isWeakSet': __webpack_require__(1412),
  'lt': __webpack_require__(1414),
  'lte': __webpack_require__(1415),
  'toArray': __webpack_require__(374),
  'toFinite': __webpack_require__(583),
  'toInteger': __webpack_require__(206),
  'toLength': __webpack_require__(1420),
  'toNumber': __webpack_require__(266),
  'toPlainObject': __webpack_require__(584),
  'toSafeInteger': __webpack_require__(1421),
  'toString': __webpack_require__(585)
};


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

var baseLt = __webpack_require__(1303),
    createRelationalOperation = __webpack_require__(259);

/**
 * Checks if `value` is less than `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 * @see _.gt
 * @example
 *
 * _.lt(1, 3);
 * // => true
 *
 * _.lt(3, 3);
 * // => false
 *
 * _.lt(3, 1);
 * // => false
 */
var lt = createRelationalOperation(baseLt);

module.exports = lt;


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

var createRelationalOperation = __webpack_require__(259);

/**
 * Checks if `value` is less than or equal to `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than or equal to
 *  `other`, else `false`.
 * @see _.gte
 * @example
 *
 * _.lte(1, 3);
 * // => true
 *
 * _.lte(3, 3);
 * // => true
 *
 * _.lte(3, 1);
 * // => false
 */
var lte = createRelationalOperation(function(value, other) {
  return value <= other;
});

module.exports = lte;


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(359);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1417 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(66);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1311),
    basePropertyDeep = __webpack_require__(1312),
    isKey = __webpack_require__(370),
    toKey = __webpack_require__(157);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(535),
    toInteger = __webpack_require__(206);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Converts `value` to an integer suitable for use as the length of an
 * array-like object.
 *
 * **Note:** This method is based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toLength(3.2);
 * // => 3
 *
 * _.toLength(Number.MIN_VALUE);
 * // => 0
 *
 * _.toLength(Infinity);
 * // => 4294967295
 *
 * _.toLength('3.2');
 * // => 3
 */
function toLength(value) {
  return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
}

module.exports = toLength;


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(535),
    toInteger = __webpack_require__(206);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Converts `value` to a safe integer. A safe integer can be compared and
 * represented correctly.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toSafeInteger(3.2);
 * // => 3
 *
 * _.toSafeInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toSafeInteger(Infinity);
 * // => 9007199254740991
 *
 * _.toSafeInteger('3.2');
 * // => 3
 */
function toSafeInteger(value) {
  return value
    ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
    : (value === 0 ? value : 0);
}

module.exports = toSafeInteger;


/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(544);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(1321),
    keys = __webpack_require__(102);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(13)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pt = moment.defineLocale('pt', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
                '_'
            ),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            w: 'uma semana',
            ww: '%d semanas',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pt;

})));


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(1680);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
    }
    if (
        (typeof globalThis !== 'undefined' && obj === globalThis)
        || (typeof global !== 'undefined' && obj === global)
    ) {
        return '{ [object globalThis] }';
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(588); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(249);
var getPolyfill = __webpack_require__(590);

module.exports = function shimAssign() {
	var polyfill = getPolyfill();
	define(
		Object,
		{ assign: polyfill },
		{ assign: function () { return Object.assign !== polyfill; } }
	);
	return polyfill;
};


/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(593);
var define = __webpack_require__(249);

module.exports = function shimValues() {
	var polyfill = getPolyfill();
	define(Object, { values: polyfill }, {
		values: function testValues() {
			return Object.values !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(595);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._61);
  p._81 = 1;
  p._65 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._81 === 3) {
            val = val._65;
          }
          if (val._81 === 1) return res(i, val._65);
          if (val._81 === 2) reject(val._65);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(595);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._10 = null;
  Promise._97 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._10 = function (promise) {
    if (
      promise._81 === 2 && // IS REJECTED
      rejections[promise._72]
    ) {
      if (rejections[promise._72].logged) {
        onHandled(promise._72);
      } else {
        clearTimeout(rejections[promise._72].timeout);
      }
      delete rejections[promise._72];
    }
  };
  Promise._97 = function (promise, err) {
    if (promise._45 === 0) { // not yet handled
      promise._72 = id++;
      rejections[promise._72] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._72),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (false) {
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
  var has = require('./lib/has');

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (false) {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(596);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactIs = __webpack_require__(1538);
var assign = __webpack_require__(21);

var ReactPropTypesSecret = __webpack_require__(596);
var has = __webpack_require__(1434);
var checkPropTypes = __webpack_require__(1431);

var printWarning = function() {};

if (false) {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (false) {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1434 */
/***/ (function(module, exports) {

module.exports = Function.call.bind(Object.prototype.hasOwnProperty);


/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(598);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        var existing = has.call(obj, key);
        if (existing && options.duplicates === 'combine') {
            obj[key] = utils.combine(obj[key], val);
        } else if (!existing || options.duplicates === 'last') {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = options.allowEmptyArrays && (leaf === '' || (options.strictNullHandling && leaf === null))
                ? []
                : [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== decodedRoot
                && String(index) === decodedRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') {
                obj[decodedRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, check strictDepth option for throw, else just add whatever is left

    if (segment) {
        if (options.strictDepth === true) {
            throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        }
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
        throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;

    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
        throw new TypeError('The duplicates option must be either combine, first, or last');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getSideChannel = __webpack_require__(1617);
var utils = __webpack_require__(598);
var formats = __webpack_require__(378);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    allowEmptyArrays,
    strictNullHandling,
    skipNulls,
    encodeDotInKeys,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, '%2E') : prefix;

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;

    if (allowEmptyArrays && isArray(obj) && obj.length === 0) {
        return adjustedPrefix + '[]';
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, '%2E') : key;
        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            allowEmptyArrays,
            strictNullHandling,
            skipNulls,
            encodeDotInKeys,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
        throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    var arrayFormat;
    if (opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if ('indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = defaults.arrayFormat;
    }

    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.allowEmptyArrays,
            options.strictNullHandling,
            options.skipNulls,
            options.encodeDotInKeys,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 1439 */
/***/ (function(module, exports) {

function RavenConfigError(message) {
  this.name = 'RavenConfigError';
  this.message = message;
}
RavenConfigError.prototype = new Error();
RavenConfigError.prototype.constructor = RavenConfigError;

module.exports = RavenConfigError;


/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

var utils = __webpack_require__(379);

var wrapMethod = function(console, level, callback) {
  var originalConsoleLevel = console[level];
  var originalConsole = console;

  if (!(level in console)) {
    return;
  }

  var sentryLevel = level === 'warn' ? 'warning' : level;

  console[level] = function() {
    var args = [].slice.call(arguments);

    var msg = utils.safeJoin(args, ' ');
    var data = {level: sentryLevel, logger: 'console', extra: {arguments: args}};

    if (level === 'assert') {
      if (args[0] === false) {
        // Default browsers message
        msg =
          'Assertion failed: ' + (utils.safeJoin(args.slice(1), ' ') || 'console.assert');
        data.extra.arguments = args.slice(1);
        callback && callback(msg, data);
      }
    } else {
      callback && callback(msg, data);
    }

    // this fails for some browsers. :(
    if (originalConsoleLevel) {
      // IE9 doesn't allow calling apply on console functions directly
      // See: https://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function#answer-5473193
      Function.prototype.apply.call(originalConsoleLevel, originalConsole, args);
    }
  };
};

module.exports = {
  wrapMethod: wrapMethod
};


/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*global XDomainRequest:false */

var TraceKit = __webpack_require__(1442);
var stringify = __webpack_require__(602);
var md5 = __webpack_require__(1443);
var RavenConfigError = __webpack_require__(1439);

var utils = __webpack_require__(379);
var isErrorEvent = utils.isErrorEvent;
var isDOMError = utils.isDOMError;
var isDOMException = utils.isDOMException;
var isError = utils.isError;
var isObject = utils.isObject;
var isPlainObject = utils.isPlainObject;
var isUndefined = utils.isUndefined;
var isFunction = utils.isFunction;
var isString = utils.isString;
var isArray = utils.isArray;
var isEmptyObject = utils.isEmptyObject;
var each = utils.each;
var objectMerge = utils.objectMerge;
var truncate = utils.truncate;
var objectFrozen = utils.objectFrozen;
var hasKey = utils.hasKey;
var joinRegExp = utils.joinRegExp;
var urlencode = utils.urlencode;
var uuid4 = utils.uuid4;
var htmlTreeAsString = utils.htmlTreeAsString;
var isSameException = utils.isSameException;
var isSameStacktrace = utils.isSameStacktrace;
var parseUrl = utils.parseUrl;
var fill = utils.fill;
var supportsFetch = utils.supportsFetch;
var supportsReferrerPolicy = utils.supportsReferrerPolicy;
var serializeKeysForMessage = utils.serializeKeysForMessage;
var serializeException = utils.serializeException;
var sanitize = utils.sanitize;

var wrapConsoleMethod = __webpack_require__(1440).wrapMethod;

var dsnKeys = 'source protocol user pass host port path'.split(' '),
  dsnPattern = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/;

function now() {
  return +new Date();
}

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var _document = _window.document;
var _navigator = _window.navigator;

function keepOriginalCallback(original, callback) {
  return isFunction(callback)
    ? function(data) {
        return callback(data, original);
      }
    : callback;
}

// First, check for JSON support
// If there is no JSON, we no-op the core features of Raven
// since JSON is required to encode the payload
function Raven() {
  this._hasJSON = !!(typeof JSON === 'object' && JSON.stringify);
  // Raven can run in contexts where there's no document (react-native)
  this._hasDocument = !isUndefined(_document);
  this._hasNavigator = !isUndefined(_navigator);
  this._lastCapturedException = null;
  this._lastData = null;
  this._lastEventId = null;
  this._globalServer = null;
  this._globalKey = null;
  this._globalProject = null;
  this._globalContext = {};
  this._globalOptions = {
    // SENTRY_RELEASE can be injected by https://github.com/getsentry/sentry-webpack-plugin
    release: _window.SENTRY_RELEASE && _window.SENTRY_RELEASE.id,
    logger: 'javascript',
    ignoreErrors: [],
    ignoreUrls: [],
    whitelistUrls: [],
    includePaths: [],
    headers: null,
    collectWindowErrors: true,
    captureUnhandledRejections: true,
    maxMessageLength: 0,
    // By default, truncates URL values to 250 chars
    maxUrlLength: 250,
    stackTraceLimit: 50,
    autoBreadcrumbs: true,
    instrument: true,
    sampleRate: 1,
    sanitizeKeys: []
  };
  this._fetchDefaults = {
    method: 'POST',
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
    // https://caniuse.com/#feat=referrer-policy
    // It doesn't. And it throw exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    referrerPolicy: supportsReferrerPolicy() ? 'origin' : ''
  };
  this._ignoreOnError = 0;
  this._isRavenInstalled = false;
  this._originalErrorStackTraceLimit = Error.stackTraceLimit;
  // capture references to window.console *and* all its methods first
  // before the console plugin has a chance to monkey patch
  this._originalConsole = _window.console || {};
  this._originalConsoleMethods = {};
  this._plugins = [];
  this._startTime = now();
  this._wrappedBuiltIns = [];
  this._breadcrumbs = [];
  this._lastCapturedEvent = null;
  this._keypressTimeout;
  this._location = _window.location;
  this._lastHref = this._location && this._location.href;
  this._resetBackoff();

  // eslint-disable-next-line guard-for-in
  for (var method in this._originalConsole) {
    this._originalConsoleMethods[method] = this._originalConsole[method];
  }
}

/*
 * The core Raven singleton
 *
 * @this {Raven}
 */

Raven.prototype = {
  // Hardcode version string so that raven source can be loaded directly via
  // webpack (using a build step causes webpack #1617). Grunt verifies that
  // this value matches package.json during build.
  //   See: https://github.com/getsentry/raven-js/issues/465
  VERSION: '3.27.2',

  debug: false,

  TraceKit: TraceKit, // alias to TraceKit

  /*
     * Configure Raven with a DSN and extra options
     *
     * @param {string} dsn The public Sentry DSN
     * @param {object} options Set of global options [optional]
     * @return {Raven}
     */
  config: function(dsn, options) {
    var self = this;

    if (self._globalServer) {
      this._logDebug('error', 'Error: Raven has already been configured');
      return self;
    }
    if (!dsn) return self;

    var globalOptions = self._globalOptions;

    // merge in options
    if (options) {
      each(options, function(key, value) {
        // tags and extra are special and need to be put into context
        if (key === 'tags' || key === 'extra' || key === 'user') {
          self._globalContext[key] = value;
        } else {
          globalOptions[key] = value;
        }
      });
    }

    self.setDSN(dsn);

    // "Script error." is hard coded into browsers for errors that it can't read.
    // this is the result of a script being pulled in from an external domain and CORS.
    globalOptions.ignoreErrors.push(/^Script error\.?$/);
    globalOptions.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/);

    // join regexp rules into one big rule
    globalOptions.ignoreErrors = joinRegExp(globalOptions.ignoreErrors);
    globalOptions.ignoreUrls = globalOptions.ignoreUrls.length
      ? joinRegExp(globalOptions.ignoreUrls)
      : false;
    globalOptions.whitelistUrls = globalOptions.whitelistUrls.length
      ? joinRegExp(globalOptions.whitelistUrls)
      : false;
    globalOptions.includePaths = joinRegExp(globalOptions.includePaths);
    globalOptions.maxBreadcrumbs = Math.max(
      0,
      Math.min(globalOptions.maxBreadcrumbs || 100, 100)
    ); // default and hard limit is 100

    var autoBreadcrumbDefaults = {
      xhr: true,
      console: true,
      dom: true,
      location: true,
      sentry: true
    };

    var autoBreadcrumbs = globalOptions.autoBreadcrumbs;
    if ({}.toString.call(autoBreadcrumbs) === '[object Object]') {
      autoBreadcrumbs = objectMerge(autoBreadcrumbDefaults, autoBreadcrumbs);
    } else if (autoBreadcrumbs !== false) {
      autoBreadcrumbs = autoBreadcrumbDefaults;
    }
    globalOptions.autoBreadcrumbs = autoBreadcrumbs;

    var instrumentDefaults = {
      tryCatch: true
    };

    var instrument = globalOptions.instrument;
    if ({}.toString.call(instrument) === '[object Object]') {
      instrument = objectMerge(instrumentDefaults, instrument);
    } else if (instrument !== false) {
      instrument = instrumentDefaults;
    }
    globalOptions.instrument = instrument;

    TraceKit.collectWindowErrors = !!globalOptions.collectWindowErrors;

    // return for chaining
    return self;
  },

  /*
     * Installs a global window.onerror error handler
     * to capture and report uncaught exceptions.
     * At this point, install() is required to be called due
     * to the way TraceKit is set up.
     *
     * @return {Raven}
     */
  install: function() {
    var self = this;
    if (self.isSetup() && !self._isRavenInstalled) {
      TraceKit.report.subscribe(function() {
        self._handleOnErrorStackInfo.apply(self, arguments);
      });

      if (self._globalOptions.captureUnhandledRejections) {
        self._attachPromiseRejectionHandler();
      }

      self._patchFunctionToString();

      if (self._globalOptions.instrument && self._globalOptions.instrument.tryCatch) {
        self._instrumentTryCatch();
      }

      if (self._globalOptions.autoBreadcrumbs) self._instrumentBreadcrumbs();

      // Install all of the plugins
      self._drainPlugins();

      self._isRavenInstalled = true;
    }

    Error.stackTraceLimit = self._globalOptions.stackTraceLimit;
    return this;
  },

  /*
     * Set the DSN (can be called multiple time unlike config)
     *
     * @param {string} dsn The public Sentry DSN
     */
  setDSN: function(dsn) {
    var self = this,
      uri = self._parseDSN(dsn),
      lastSlash = uri.path.lastIndexOf('/'),
      path = uri.path.substr(1, lastSlash);

    self._dsn = dsn;
    self._globalKey = uri.user;
    self._globalSecret = uri.pass && uri.pass.substr(1);
    self._globalProject = uri.path.substr(lastSlash + 1);

    self._globalServer = self._getGlobalServer(uri);

    self._globalEndpoint =
      self._globalServer + '/' + path + 'api/' + self._globalProject + '/store/';

    // Reset backoff state since we may be pointing at a
    // new project/server
    this._resetBackoff();
  },

  /*
     * Wrap code within a context so Raven can capture errors
     * reliably across domains that is executed immediately.
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The callback to be immediately executed within the context
     * @param {array} args An array of arguments to be called with the callback [optional]
     */
  context: function(options, func, args) {
    if (isFunction(options)) {
      args = func || [];
      func = options;
      options = {};
    }

    return this.wrap(options, func).apply(this, args);
  },

  /*
     * Wrap code within a context and returns back a new function to be executed
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The function to be wrapped in a new context
     * @param {function} _before A function to call before the try/catch wrapper [optional, private]
     * @return {function} The newly wrapped functions with a context
     */
  wrap: function(options, func, _before) {
    var self = this;
    // 1 argument has been passed, and it's not a function
    // so just return it
    if (isUndefined(func) && !isFunction(options)) {
      return options;
    }

    // options is optional
    if (isFunction(options)) {
      func = options;
      options = undefined;
    }

    // At this point, we've passed along 2 arguments, and the second one
    // is not a function either, so we'll just return the second argument.
    if (!isFunction(func)) {
      return func;
    }

    // We don't wanna wrap it twice!
    try {
      if (func.__raven__) {
        return func;
      }

      // If this has already been wrapped in the past, return that
      if (func.__raven_wrapper__) {
        return func.__raven_wrapper__;
      }
    } catch (e) {
      // Just accessing custom props in some Selenium environments
      // can cause a "Permission denied" exception (see raven-js#495).
      // Bail on wrapping and return the function as-is (defers to window.onerror).
      return func;
    }

    function wrapped() {
      var args = [],
        i = arguments.length,
        deep = !options || (options && options.deep !== false);

      if (_before && isFunction(_before)) {
        _before.apply(this, arguments);
      }

      // Recursively wrap all of a function's arguments that are
      // functions themselves.
      while (i--) args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];

      try {
        // Attempt to invoke user-land function
        // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
        //       means Raven caught an error invoking your application code. This is
        //       expected behavior and NOT indicative of a bug with Raven.js.
        return func.apply(this, args);
      } catch (e) {
        self._ignoreNextOnError();
        self.captureException(e, options);
        throw e;
      }
    }

    // copy over properties of the old function
    for (var property in func) {
      if (hasKey(func, property)) {
        wrapped[property] = func[property];
      }
    }
    wrapped.prototype = func.prototype;

    func.__raven_wrapper__ = wrapped;
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    wrapped.__raven__ = true;
    wrapped.__orig__ = func;

    return wrapped;
  },

  /**
   * Uninstalls the global error handler.
   *
   * @return {Raven}
   */
  uninstall: function() {
    TraceKit.report.uninstall();

    this._detachPromiseRejectionHandler();
    this._unpatchFunctionToString();
    this._restoreBuiltIns();
    this._restoreConsole();

    Error.stackTraceLimit = this._originalErrorStackTraceLimit;
    this._isRavenInstalled = false;

    return this;
  },

  /**
   * Callback used for `unhandledrejection` event
   *
   * @param {PromiseRejectionEvent} event An object containing
   *   promise: the Promise that was rejected
   *   reason: the value with which the Promise was rejected
   * @return void
   */
  _promiseRejectionHandler: function(event) {
    this._logDebug('debug', 'Raven caught unhandled promise rejection:', event);
    this.captureException(event.reason, {
      mechanism: {
        type: 'onunhandledrejection',
        handled: false
      }
    });
  },

  /**
   * Installs the global promise rejection handler.
   *
   * @return {raven}
   */
  _attachPromiseRejectionHandler: function() {
    this._promiseRejectionHandler = this._promiseRejectionHandler.bind(this);
    _window.addEventListener &&
      _window.addEventListener('unhandledrejection', this._promiseRejectionHandler);
    return this;
  },

  /**
   * Uninstalls the global promise rejection handler.
   *
   * @return {raven}
   */
  _detachPromiseRejectionHandler: function() {
    _window.removeEventListener &&
      _window.removeEventListener('unhandledrejection', this._promiseRejectionHandler);
    return this;
  },

  /**
   * Manually capture an exception and send it over to Sentry
   *
   * @param {error} ex An exception to be logged
   * @param {object} options A specific set of options for this error [optional]
   * @return {Raven}
   */
  captureException: function(ex, options) {
    options = objectMerge({trimHeadFrames: 0}, options ? options : {});

    if (isErrorEvent(ex) && ex.error) {
      // If it is an ErrorEvent with `error` property, extract it to get actual Error
      ex = ex.error;
    } else if (isDOMError(ex) || isDOMException(ex)) {
      // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
      // then we just extract the name and message, as they don't provide anything else
      // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
      // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
      var name = ex.name || (isDOMError(ex) ? 'DOMError' : 'DOMException');
      var message = ex.message ? name + ': ' + ex.message : name;

      return this.captureMessage(
        message,
        objectMerge(options, {
          // neither DOMError or DOMException provide stack trace and we most likely wont get it this way as well
          // but it's barely any overhead so we may at least try
          stacktrace: true,
          trimHeadFrames: options.trimHeadFrames + 1
        })
      );
    } else if (isError(ex)) {
      // we have a real Error object
      ex = ex;
    } else if (isPlainObject(ex)) {
      // If it is plain Object, serialize it manually and extract options
      // This will allow us to group events based on top-level keys
      // which is much better than creating new group when any key/value change
      options = this._getCaptureExceptionOptionsFromPlainObject(options, ex);
      ex = new Error(options.message);
    } else {
      // If none of previous checks were valid, then it means that
      // it's not a DOMError/DOMException
      // it's not a plain Object
      // it's not a valid ErrorEvent (one with an error property)
      // it's not an Error
      // So bail out and capture it as a simple message:
      return this.captureMessage(
        ex,
        objectMerge(options, {
          stacktrace: true, // if we fall back to captureMessage, default to attempting a new trace
          trimHeadFrames: options.trimHeadFrames + 1
        })
      );
    }

    // Store the raw exception object for potential debugging and introspection
    this._lastCapturedException = ex;

    // TraceKit.report will re-raise any exception passed to it,
    // which means you have to wrap it in try/catch. Instead, we
    // can wrap it here and only re-raise if TraceKit.report
    // raises an exception different from the one we asked to
    // report on.
    try {
      var stack = TraceKit.computeStackTrace(ex);
      this._handleStackInfo(stack, options);
    } catch (ex1) {
      if (ex !== ex1) {
        throw ex1;
      }
    }

    return this;
  },

  _getCaptureExceptionOptionsFromPlainObject: function(currentOptions, ex) {
    var exKeys = Object.keys(ex).sort();
    var options = objectMerge(currentOptions, {
      message:
        'Non-Error exception captured with keys: ' + serializeKeysForMessage(exKeys),
      fingerprint: [md5(exKeys)],
      extra: currentOptions.extra || {}
    });
    options.extra.__serialized__ = serializeException(ex);

    return options;
  },

  /*
     * Manually send a message to Sentry
     *
     * @param {string} msg A plain message to be captured in Sentry
     * @param {object} options A specific set of options for this message [optional]
     * @return {Raven}
     */
  captureMessage: function(msg, options) {
    // config() automagically converts ignoreErrors from a list to a RegExp so we need to test for an
    // early call; we'll error on the side of logging anything called before configuration since it's
    // probably something you should see:
    if (
      !!this._globalOptions.ignoreErrors.test &&
      this._globalOptions.ignoreErrors.test(msg)
    ) {
      return;
    }

    options = options || {};
    msg = msg + ''; // Make sure it's actually a string

    var data = objectMerge(
      {
        message: msg
      },
      options
    );

    var ex;
    // Generate a "synthetic" stack trace from this point.
    // NOTE: If you are a Sentry user, and you are seeing this stack frame, it is NOT indicative
    //       of a bug with Raven.js. Sentry generates synthetic traces either by configuration,
    //       or if it catches a thrown object without a "stack" property.
    try {
      throw new Error(msg);
    } catch (ex1) {
      ex = ex1;
    }

    // null exception name so `Error` isn't prefixed to msg
    ex.name = null;
    var stack = TraceKit.computeStackTrace(ex);

    // stack[0] is `throw new Error(msg)` call itself, we are interested in the frame that was just before that, stack[1]
    var initialCall = isArray(stack.stack) && stack.stack[1];

    // if stack[1] is `Raven.captureException`, it means that someone passed a string to it and we redirected that call
    // to be handled by `captureMessage`, thus `initialCall` is the 3rd one, not 2nd
    // initialCall => captureException(string) => captureMessage(string)
    if (initialCall && initialCall.func === 'Raven.captureException') {
      initialCall = stack.stack[2];
    }

    var fileurl = (initialCall && initialCall.url) || '';

    if (
      !!this._globalOptions.ignoreUrls.test &&
      this._globalOptions.ignoreUrls.test(fileurl)
    ) {
      return;
    }

    if (
      !!this._globalOptions.whitelistUrls.test &&
      !this._globalOptions.whitelistUrls.test(fileurl)
    ) {
      return;
    }

    // Always attempt to get stacktrace if message is empty.
    // It's the only way to provide any helpful information to the user.
    if (this._globalOptions.stacktrace || options.stacktrace || data.message === '') {
      // fingerprint on msg, not stack trace (legacy behavior, could be revisited)
      data.fingerprint = data.fingerprint == null ? msg : data.fingerprint;

      options = objectMerge(
        {
          trimHeadFrames: 0
        },
        options
      );
      // Since we know this is a synthetic trace, the top frame (this function call)
      // MUST be from Raven.js, so mark it for trimming
      // We add to the trim counter so that callers can choose to trim extra frames, such
      // as utility functions.
      options.trimHeadFrames += 1;

      var frames = this._prepareFrames(stack, options);
      data.stacktrace = {
        // Sentry expects frames oldest to newest
        frames: frames.reverse()
      };
    }

    // Make sure that fingerprint is always wrapped in an array
    if (data.fingerprint) {
      data.fingerprint = isArray(data.fingerprint)
        ? data.fingerprint
        : [data.fingerprint];
    }

    // Fire away!
    this._send(data);

    return this;
  },

  captureBreadcrumb: function(obj) {
    var crumb = objectMerge(
      {
        timestamp: now() / 1000
      },
      obj
    );

    if (isFunction(this._globalOptions.breadcrumbCallback)) {
      var result = this._globalOptions.breadcrumbCallback(crumb);

      if (isObject(result) && !isEmptyObject(result)) {
        crumb = result;
      } else if (result === false) {
        return this;
      }
    }

    this._breadcrumbs.push(crumb);
    if (this._breadcrumbs.length > this._globalOptions.maxBreadcrumbs) {
      this._breadcrumbs.shift();
    }
    return this;
  },

  addPlugin: function(plugin /*arg1, arg2, ... argN*/) {
    var pluginArgs = [].slice.call(arguments, 1);

    this._plugins.push([plugin, pluginArgs]);
    if (this._isRavenInstalled) {
      this._drainPlugins();
    }

    return this;
  },

  /*
     * Set/clear a user to be sent along with the payload.
     *
     * @param {object} user An object representing user data [optional]
     * @return {Raven}
     */
  setUserContext: function(user) {
    // Intentionally do not merge here since that's an unexpected behavior.
    this._globalContext.user = user;

    return this;
  },

  /*
     * Merge extra attributes to be sent along with the payload.
     *
     * @param {object} extra An object representing extra data [optional]
     * @return {Raven}
     */
  setExtraContext: function(extra) {
    this._mergeContext('extra', extra);

    return this;
  },

  /*
     * Merge tags to be sent along with the payload.
     *
     * @param {object} tags An object representing tags [optional]
     * @return {Raven}
     */
  setTagsContext: function(tags) {
    this._mergeContext('tags', tags);

    return this;
  },

  /*
     * Clear all of the context.
     *
     * @return {Raven}
     */
  clearContext: function() {
    this._globalContext = {};

    return this;
  },

  /*
     * Get a copy of the current context. This cannot be mutated.
     *
     * @return {object} copy of context
     */
  getContext: function() {
    // lol javascript
    return JSON.parse(stringify(this._globalContext));
  },

  /*
     * Set environment of application
     *
     * @param {string} environment Typically something like 'production'.
     * @return {Raven}
     */
  setEnvironment: function(environment) {
    this._globalOptions.environment = environment;

    return this;
  },

  /*
     * Set release version of application
     *
     * @param {string} release Typically something like a git SHA to identify version
     * @return {Raven}
     */
  setRelease: function(release) {
    this._globalOptions.release = release;

    return this;
  },

  /*
     * Set the dataCallback option
     *
     * @param {function} callback The callback to run which allows the
     *                            data blob to be mutated before sending
     * @return {Raven}
     */
  setDataCallback: function(callback) {
    var original = this._globalOptions.dataCallback;
    this._globalOptions.dataCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /*
     * Set the breadcrumbCallback option
     *
     * @param {function} callback The callback to run which allows filtering
     *                            or mutating breadcrumbs
     * @return {Raven}
     */
  setBreadcrumbCallback: function(callback) {
    var original = this._globalOptions.breadcrumbCallback;
    this._globalOptions.breadcrumbCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /*
     * Set the shouldSendCallback option
     *
     * @param {function} callback The callback to run which allows
     *                            introspecting the blob before sending
     * @return {Raven}
     */
  setShouldSendCallback: function(callback) {
    var original = this._globalOptions.shouldSendCallback;
    this._globalOptions.shouldSendCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /**
   * Override the default HTTP transport mechanism that transmits data
   * to the Sentry server.
   *
   * @param {function} transport Function invoked instead of the default
   *                             `makeRequest` handler.
   *
   * @return {Raven}
   */
  setTransport: function(transport) {
    this._globalOptions.transport = transport;

    return this;
  },

  /*
     * Get the latest raw exception that was captured by Raven.
     *
     * @return {error}
     */
  lastException: function() {
    return this._lastCapturedException;
  },

  /*
     * Get the last event id
     *
     * @return {string}
     */
  lastEventId: function() {
    return this._lastEventId;
  },

  /*
     * Determine if Raven is setup and ready to go.
     *
     * @return {boolean}
     */
  isSetup: function() {
    if (!this._hasJSON) return false; // needs JSON support
    if (!this._globalServer) {
      if (!this.ravenNotConfiguredError) {
        this.ravenNotConfiguredError = true;
        this._logDebug('error', 'Error: Raven has not been configured.');
      }
      return false;
    }
    return true;
  },

  afterLoad: function() {
    // TODO: remove window dependence?

    // Attempt to initialize Raven on load
    var RavenConfig = _window.RavenConfig;
    if (RavenConfig) {
      this.config(RavenConfig.dsn, RavenConfig.config).install();
    }
  },

  showReportDialog: function(options) {
    if (
      !_document // doesn't work without a document (React native)
    )
      return;

    options = objectMerge(
      {
        eventId: this.lastEventId(),
        dsn: this._dsn,
        user: this._globalContext.user || {}
      },
      options
    );

    if (!options.eventId) {
      throw new RavenConfigError('Missing eventId');
    }

    if (!options.dsn) {
      throw new RavenConfigError('Missing DSN');
    }

    var encode = encodeURIComponent;
    var encodedOptions = [];

    for (var key in options) {
      if (key === 'user') {
        var user = options.user;
        if (user.name) encodedOptions.push('name=' + encode(user.name));
        if (user.email) encodedOptions.push('email=' + encode(user.email));
      } else {
        encodedOptions.push(encode(key) + '=' + encode(options[key]));
      }
    }
    var globalServer = this._getGlobalServer(this._parseDSN(options.dsn));

    var script = _document.createElement('script');
    script.async = true;
    script.src = globalServer + '/api/embed/error-page/?' + encodedOptions.join('&');
    (_document.head || _document.body).appendChild(script);
  },

  /**** Private functions ****/
  _ignoreNextOnError: function() {
    var self = this;
    this._ignoreOnError += 1;
    setTimeout(function() {
      // onerror should trigger before setTimeout
      self._ignoreOnError -= 1;
    });
  },

  _triggerEvent: function(eventType, options) {
    // NOTE: `event` is a native browser thing, so let's avoid conflicting wiht it
    var evt, key;

    if (!this._hasDocument) return;

    options = options || {};

    eventType = 'raven' + eventType.substr(0, 1).toUpperCase() + eventType.substr(1);

    if (_document.createEvent) {
      evt = _document.createEvent('HTMLEvents');
      evt.initEvent(eventType, true, true);
    } else {
      evt = _document.createEventObject();
      evt.eventType = eventType;
    }

    for (key in options)
      if (hasKey(options, key)) {
        evt[key] = options[key];
      }

    if (_document.createEvent) {
      // IE9 if standards
      _document.dispatchEvent(evt);
    } else {
      // IE8 regardless of Quirks or Standards
      // IE9 if quirks
      try {
        _document.fireEvent('on' + evt.eventType.toLowerCase(), evt);
      } catch (e) {
        // Do nothing
      }
    }
  },

  /**
   * Wraps addEventListener to capture UI breadcrumbs
   * @param evtName the event name (e.g. "click")
   * @returns {Function}
   * @private
   */
  _breadcrumbEventHandler: function(evtName) {
    var self = this;
    return function(evt) {
      // reset keypress timeout; e.g. triggering a 'click' after
      // a 'keypress' will reset the keypress debounce so that a new
      // set of keypresses can be recorded
      self._keypressTimeout = null;

      // It's possible this handler might trigger multiple times for the same
      // event (e.g. event propagation through node ancestors). Ignore if we've
      // already captured the event.
      if (self._lastCapturedEvent === evt) return;

      self._lastCapturedEvent = evt;

      // try/catch both:
      // - accessing evt.target (see getsentry/raven-js#838, #768)
      // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
      //   can throw an exception in some circumstances.
      var target;
      try {
        target = htmlTreeAsString(evt.target);
      } catch (e) {
        target = '<unknown>';
      }

      self.captureBreadcrumb({
        category: 'ui.' + evtName, // e.g. ui.click, ui.input
        message: target
      });
    };
  },

  /**
   * Wraps addEventListener to capture keypress UI events
   * @returns {Function}
   * @private
   */
  _keypressEventHandler: function() {
    var self = this,
      debounceDuration = 1000; // milliseconds

    // TODO: if somehow user switches keypress target before
    //       debounce timeout is triggered, we will only capture
    //       a single breadcrumb from the FIRST target (acceptable?)
    return function(evt) {
      var target;
      try {
        target = evt.target;
      } catch (e) {
        // just accessing event properties can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/raven-js/issues/838
        return;
      }
      var tagName = target && target.tagName;

      // only consider keypress events on actual input elements
      // this will disregard keypresses targeting body (e.g. tabbing
      // through elements, hotkeys, etc)
      if (
        !tagName ||
        (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)
      )
        return;

      // record first keypress in a series, but ignore subsequent
      // keypresses until debounce clears
      var timeout = self._keypressTimeout;
      if (!timeout) {
        self._breadcrumbEventHandler('input')(evt);
      }
      clearTimeout(timeout);
      self._keypressTimeout = setTimeout(function() {
        self._keypressTimeout = null;
      }, debounceDuration);
    };
  },

  /**
   * Captures a breadcrumb of type "navigation", normalizing input URLs
   * @param to the originating URL
   * @param from the target URL
   * @private
   */
  _captureUrlChange: function(from, to) {
    var parsedLoc = parseUrl(this._location.href);
    var parsedTo = parseUrl(to);
    var parsedFrom = parseUrl(from);

    // because onpopstate only tells you the "new" (to) value of location.href, and
    // not the previous (from) value, we need to track the value of the current URL
    // state ourselves
    this._lastHref = to;

    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host)
      to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host)
      from = parsedFrom.relative;

    this.captureBreadcrumb({
      category: 'navigation',
      data: {
        to: to,
        from: from
      }
    });
  },

  _patchFunctionToString: function() {
    var self = this;
    self._originalFunctionToString = Function.prototype.toString;
    // eslint-disable-next-line no-extend-native
    Function.prototype.toString = function() {
      if (typeof this === 'function' && this.__raven__) {
        return self._originalFunctionToString.apply(this.__orig__, arguments);
      }
      return self._originalFunctionToString.apply(this, arguments);
    };
  },

  _unpatchFunctionToString: function() {
    if (this._originalFunctionToString) {
      // eslint-disable-next-line no-extend-native
      Function.prototype.toString = this._originalFunctionToString;
    }
  },

  /**
   * Wrap timer functions and event targets to catch errors and provide
   * better metadata.
   */
  _instrumentTryCatch: function() {
    var self = this;

    var wrappedBuiltIns = self._wrappedBuiltIns;

    function wrapTimeFn(orig) {
      return function(fn, t) {
        // preserve arity
        // Make a copy of the arguments to prevent deoptimization
        // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; ++i) {
          args[i] = arguments[i];
        }
        var originalCallback = args[0];
        if (isFunction(originalCallback)) {
          args[0] = self.wrap(
            {
              mechanism: {
                type: 'instrument',
                data: {function: orig.name || '<anonymous>'}
              }
            },
            originalCallback
          );
        }

        // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
        // also supports only two arguments and doesn't care what this is, so we
        // can just call the original function directly.
        if (orig.apply) {
          return orig.apply(this, args);
        } else {
          return orig(args[0], args[1]);
        }
      };
    }

    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

    function wrapEventTarget(global) {
      var proto = _window[global] && _window[global].prototype;
      if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
        fill(
          proto,
          'addEventListener',
          function(orig) {
            return function(evtName, fn, capture, secure) {
              // preserve arity
              try {
                if (fn && fn.handleEvent) {
                  fn.handleEvent = self.wrap(
                    {
                      mechanism: {
                        type: 'instrument',
                        data: {
                          target: global,
                          function: 'handleEvent',
                          handler: (fn && fn.name) || '<anonymous>'
                        }
                      }
                    },
                    fn.handleEvent
                  );
                }
              } catch (err) {
                // can sometimes get 'Permission denied to access property "handle Event'
              }

              // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
              // so that we don't have more than one wrapper function
              var before, clickHandler, keypressHandler;

              if (
                autoBreadcrumbs &&
                autoBreadcrumbs.dom &&
                (global === 'EventTarget' || global === 'Node')
              ) {
                // NOTE: generating multiple handlers per addEventListener invocation, should
                //       revisit and verify we can just use one (almost certainly)
                clickHandler = self._breadcrumbEventHandler('click');
                keypressHandler = self._keypressEventHandler();
                before = function(evt) {
                  // need to intercept every DOM event in `before` argument, in case that
                  // same wrapped method is re-used for different events (e.g. mousemove THEN click)
                  // see #724
                  if (!evt) return;

                  var eventType;
                  try {
                    eventType = evt.type;
                  } catch (e) {
                    // just accessing event properties can throw an exception in some rare circumstances
                    // see: https://github.com/getsentry/raven-js/issues/838
                    return;
                  }
                  if (eventType === 'click') return clickHandler(evt);
                  else if (eventType === 'keypress') return keypressHandler(evt);
                };
              }
              return orig.call(
                this,
                evtName,
                self.wrap(
                  {
                    mechanism: {
                      type: 'instrument',
                      data: {
                        target: global,
                        function: 'addEventListener',
                        handler: (fn && fn.name) || '<anonymous>'
                      }
                    }
                  },
                  fn,
                  before
                ),
                capture,
                secure
              );
            };
          },
          wrappedBuiltIns
        );
        fill(
          proto,
          'removeEventListener',
          function(orig) {
            return function(evt, fn, capture, secure) {
              try {
                fn = fn && (fn.__raven_wrapper__ ? fn.__raven_wrapper__ : fn);
              } catch (e) {
                // ignore, accessing __raven_wrapper__ will throw in some Selenium environments
              }
              return orig.call(this, evt, fn, capture, secure);
            };
          },
          wrappedBuiltIns
        );
      }
    }

    fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
    fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
    if (_window.requestAnimationFrame) {
      fill(
        _window,
        'requestAnimationFrame',
        function(orig) {
          return function(cb) {
            return orig(
              self.wrap(
                {
                  mechanism: {
                    type: 'instrument',
                    data: {
                      function: 'requestAnimationFrame',
                      handler: (orig && orig.name) || '<anonymous>'
                    }
                  }
                },
                cb
              )
            );
          };
        },
        wrappedBuiltIns
      );
    }

    // event targets borrowed from bugsnag-js:
    // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
    var eventTargets = [
      'EventTarget',
      'Window',
      'Node',
      'ApplicationCache',
      'AudioTrackList',
      'ChannelMergerNode',
      'CryptoOperation',
      'EventSource',
      'FileReader',
      'HTMLUnknownElement',
      'IDBDatabase',
      'IDBRequest',
      'IDBTransaction',
      'KeyOperation',
      'MediaController',
      'MessagePort',
      'ModalWindow',
      'Notification',
      'SVGElementInstance',
      'Screen',
      'TextTrack',
      'TextTrackCue',
      'TextTrackList',
      'WebSocket',
      'WebSocketWorker',
      'Worker',
      'XMLHttpRequest',
      'XMLHttpRequestEventTarget',
      'XMLHttpRequestUpload'
    ];
    for (var i = 0; i < eventTargets.length; i++) {
      wrapEventTarget(eventTargets[i]);
    }
  },

  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - XMLHttpRequests
   *  - DOM interactions (click/typing)
   *  - window.location changes
   *  - console
   *
   * Can be disabled or individually configured via the `autoBreadcrumbs` config option
   */
  _instrumentBreadcrumbs: function() {
    var self = this;
    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

    var wrappedBuiltIns = self._wrappedBuiltIns;

    function wrapProp(prop, xhr) {
      if (prop in xhr && isFunction(xhr[prop])) {
        fill(xhr, prop, function(orig) {
          return self.wrap(
            {
              mechanism: {
                type: 'instrument',
                data: {function: prop, handler: (orig && orig.name) || '<anonymous>'}
              }
            },
            orig
          );
        }); // intentionally don't track filled methods on XHR instances
      }
    }

    if (autoBreadcrumbs.xhr && 'XMLHttpRequest' in _window) {
      var xhrproto = _window.XMLHttpRequest && _window.XMLHttpRequest.prototype;
      fill(
        xhrproto,
        'open',
        function(origOpen) {
          return function(method, url) {
            // preserve arity

            // if Sentry key appears in URL, don't capture
            if (isString(url) && url.indexOf(self._globalKey) === -1) {
              this.__raven_xhr = {
                method: method,
                url: url,
                status_code: null
              };
            }

            return origOpen.apply(this, arguments);
          };
        },
        wrappedBuiltIns
      );

      fill(
        xhrproto,
        'send',
        function(origSend) {
          return function() {
            // preserve arity
            var xhr = this;

            function onreadystatechangeHandler() {
              if (xhr.__raven_xhr && xhr.readyState === 4) {
                try {
                  // touching statusCode in some platforms throws
                  // an exception
                  xhr.__raven_xhr.status_code = xhr.status;
                } catch (e) {
                  /* do nothing */
                }

                self.captureBreadcrumb({
                  type: 'http',
                  category: 'xhr',
                  data: xhr.__raven_xhr
                });
              }
            }

            var props = ['onload', 'onerror', 'onprogress'];
            for (var j = 0; j < props.length; j++) {
              wrapProp(props[j], xhr);
            }

            if ('onreadystatechange' in xhr && isFunction(xhr.onreadystatechange)) {
              fill(
                xhr,
                'onreadystatechange',
                function(orig) {
                  return self.wrap(
                    {
                      mechanism: {
                        type: 'instrument',
                        data: {
                          function: 'onreadystatechange',
                          handler: (orig && orig.name) || '<anonymous>'
                        }
                      }
                    },
                    orig,
                    onreadystatechangeHandler
                  );
                } /* intentionally don't track this instrumentation */
              );
            } else {
              // if onreadystatechange wasn't actually set by the page on this xhr, we
              // are free to set our own and capture the breadcrumb
              xhr.onreadystatechange = onreadystatechangeHandler;
            }

            return origSend.apply(this, arguments);
          };
        },
        wrappedBuiltIns
      );
    }

    if (autoBreadcrumbs.xhr && supportsFetch()) {
      fill(
        _window,
        'fetch',
        function(origFetch) {
          return function() {
            // preserve arity
            // Make a copy of the arguments to prevent deoptimization
            // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
            var args = new Array(arguments.length);
            for (var i = 0; i < args.length; ++i) {
              args[i] = arguments[i];
            }

            var fetchInput = args[0];
            var method = 'GET';
            var url;

            if (typeof fetchInput === 'string') {
              url = fetchInput;
            } else if ('Request' in _window && fetchInput instanceof _window.Request) {
              url = fetchInput.url;
              if (fetchInput.method) {
                method = fetchInput.method;
              }
            } else {
              url = '' + fetchInput;
            }

            // if Sentry key appears in URL, don't capture, as it's our own request
            if (url.indexOf(self._globalKey) !== -1) {
              return origFetch.apply(this, args);
            }

            if (args[1] && args[1].method) {
              method = args[1].method;
            }

            var fetchData = {
              method: method,
              url: url,
              status_code: null
            };

            return origFetch
              .apply(this, args)
              .then(function(response) {
                fetchData.status_code = response.status;

                self.captureBreadcrumb({
                  type: 'http',
                  category: 'fetch',
                  data: fetchData
                });

                return response;
              })
              ['catch'](function(err) {
                // if there is an error performing the request
                self.captureBreadcrumb({
                  type: 'http',
                  category: 'fetch',
                  data: fetchData,
                  level: 'error'
                });

                throw err;
              });
          };
        },
        wrappedBuiltIns
      );
    }

    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
    // to the document. Do this before we instrument addEventListener.
    if (autoBreadcrumbs.dom && this._hasDocument) {
      if (_document.addEventListener) {
        _document.addEventListener('click', self._breadcrumbEventHandler('click'), false);
        _document.addEventListener('keypress', self._keypressEventHandler(), false);
      } else if (_document.attachEvent) {
        // IE8 Compatibility
        _document.attachEvent('onclick', self._breadcrumbEventHandler('click'));
        _document.attachEvent('onkeypress', self._keypressEventHandler());
      }
    }

    // record navigation (URL) changes
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var chrome = _window.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    var hasPushAndReplaceState =
      !isChromePackagedApp &&
      _window.history &&
      _window.history.pushState &&
      _window.history.replaceState;
    if (autoBreadcrumbs.location && hasPushAndReplaceState) {
      // TODO: remove onpopstate handler on uninstall()
      var oldOnPopState = _window.onpopstate;
      _window.onpopstate = function() {
        var currentHref = self._location.href;
        self._captureUrlChange(self._lastHref, currentHref);

        if (oldOnPopState) {
          return oldOnPopState.apply(this, arguments);
        }
      };

      var historyReplacementFunction = function(origHistFunction) {
        // note history.pushState.length is 0; intentionally not declaring
        // params to preserve 0 arity
        return function(/* state, title, url */) {
          var url = arguments.length > 2 ? arguments[2] : undefined;

          // url argument is optional
          if (url) {
            // coerce to string (this is what pushState does)
            self._captureUrlChange(self._lastHref, url + '');
          }

          return origHistFunction.apply(this, arguments);
        };
      };

      fill(_window.history, 'pushState', historyReplacementFunction, wrappedBuiltIns);
      fill(_window.history, 'replaceState', historyReplacementFunction, wrappedBuiltIns);
    }

    if (autoBreadcrumbs.console && 'console' in _window && console.log) {
      // console
      var consoleMethodCallback = function(msg, data) {
        self.captureBreadcrumb({
          message: msg,
          level: data.level,
          category: 'console'
        });
      };

      each(['debug', 'info', 'warn', 'error', 'log'], function(_, level) {
        wrapConsoleMethod(console, level, consoleMethodCallback);
      });
    }
  },

  _restoreBuiltIns: function() {
    // restore any wrapped builtins
    var builtin;
    while (this._wrappedBuiltIns.length) {
      builtin = this._wrappedBuiltIns.shift();

      var obj = builtin[0],
        name = builtin[1],
        orig = builtin[2];

      obj[name] = orig;
    }
  },

  _restoreConsole: function() {
    // eslint-disable-next-line guard-for-in
    for (var method in this._originalConsoleMethods) {
      this._originalConsole[method] = this._originalConsoleMethods[method];
    }
  },

  _drainPlugins: function() {
    var self = this;

    // FIX ME TODO
    each(this._plugins, function(_, plugin) {
      var installer = plugin[0];
      var args = plugin[1];
      installer.apply(self, [self].concat(args));
    });
  },

  _parseDSN: function(str) {
    var m = dsnPattern.exec(str),
      dsn = {},
      i = 7;

    try {
      while (i--) dsn[dsnKeys[i]] = m[i] || '';
    } catch (e) {
      throw new RavenConfigError('Invalid DSN: ' + str);
    }

    if (dsn.pass && !this._globalOptions.allowSecretKey) {
      throw new RavenConfigError(
        'Do not specify your secret key in the DSN. See: http://bit.ly/raven-secret-key'
      );
    }

    return dsn;
  },

  _getGlobalServer: function(uri) {
    // assemble the endpoint from the uri pieces
    var globalServer = '//' + uri.host + (uri.port ? ':' + uri.port : '');

    if (uri.protocol) {
      globalServer = uri.protocol + ':' + globalServer;
    }
    return globalServer;
  },

  _handleOnErrorStackInfo: function(stackInfo, options) {
    options = options || {};
    options.mechanism = options.mechanism || {
      type: 'onerror',
      handled: false
    };

    // if we are intentionally ignoring errors via onerror, bail out
    if (!this._ignoreOnError) {
      this._handleStackInfo(stackInfo, options);
    }
  },

  _handleStackInfo: function(stackInfo, options) {
    var frames = this._prepareFrames(stackInfo, options);

    this._triggerEvent('handle', {
      stackInfo: stackInfo,
      options: options
    });

    this._processException(
      stackInfo.name,
      stackInfo.message,
      stackInfo.url,
      stackInfo.lineno,
      frames,
      options
    );
  },

  _prepareFrames: function(stackInfo, options) {
    var self = this;
    var frames = [];
    if (stackInfo.stack && stackInfo.stack.length) {
      each(stackInfo.stack, function(i, stack) {
        var frame = self._normalizeFrame(stack, stackInfo.url);
        if (frame) {
          frames.push(frame);
        }
      });

      // e.g. frames captured via captureMessage throw
      if (options && options.trimHeadFrames) {
        for (var j = 0; j < options.trimHeadFrames && j < frames.length; j++) {
          frames[j].in_app = false;
        }
      }
    }
    frames = frames.slice(0, this._globalOptions.stackTraceLimit);
    return frames;
  },

  _normalizeFrame: function(frame, stackInfoUrl) {
    // normalize the frames data
    var normalized = {
      filename: frame.url,
      lineno: frame.line,
      colno: frame.column,
      function: frame.func || '?'
    };

    // Case when we don't have any information about the error
    // E.g. throwing a string or raw object, instead of an `Error` in Firefox
    // Generating synthetic error doesn't add any value here
    //
    // We should probably somehow let a user know that they should fix their code
    if (!frame.url) {
      normalized.filename = stackInfoUrl; // fallback to whole stacks url from onerror handler
    }

    normalized.in_app = !// determine if an exception came from outside of our app
    // first we check the global includePaths list.
    (
      (!!this._globalOptions.includePaths.test &&
        !this._globalOptions.includePaths.test(normalized.filename)) ||
      // Now we check for fun, if the function name is Raven or TraceKit
      /(Raven|TraceKit)\./.test(normalized['function']) ||
      // finally, we do a last ditch effort and check for raven.min.js
      /raven\.(min\.)?js$/.test(normalized.filename)
    );

    return normalized;
  },

  _processException: function(type, message, fileurl, lineno, frames, options) {
    var prefixedMessage = (type ? type + ': ' : '') + (message || '');
    if (
      !!this._globalOptions.ignoreErrors.test &&
      (this._globalOptions.ignoreErrors.test(message) ||
        this._globalOptions.ignoreErrors.test(prefixedMessage))
    ) {
      return;
    }

    var stacktrace;

    if (frames && frames.length) {
      fileurl = frames[0].filename || fileurl;
      // Sentry expects frames oldest to newest
      // and JS sends them as newest to oldest
      frames.reverse();
      stacktrace = {frames: frames};
    } else if (fileurl) {
      stacktrace = {
        frames: [
          {
            filename: fileurl,
            lineno: lineno,
            in_app: true
          }
        ]
      };
    }

    if (
      !!this._globalOptions.ignoreUrls.test &&
      this._globalOptions.ignoreUrls.test(fileurl)
    ) {
      return;
    }

    if (
      !!this._globalOptions.whitelistUrls.test &&
      !this._globalOptions.whitelistUrls.test(fileurl)
    ) {
      return;
    }

    var data = objectMerge(
      {
        // sentry.interfaces.Exception
        exception: {
          values: [
            {
              type: type,
              value: message,
              stacktrace: stacktrace
            }
          ]
        },
        transaction: fileurl
      },
      options
    );

    var ex = data.exception.values[0];
    if (ex.type == null && ex.value === '') {
      ex.value = 'Unrecoverable error caught';
    }

    // Move mechanism from options to exception interface
    // We do this, as requiring user to pass `{exception:{mechanism:{ ... }}}` would be
    // too much
    if (!data.exception.mechanism && data.mechanism) {
      data.exception.mechanism = data.mechanism;
      delete data.mechanism;
    }

    data.exception.mechanism = objectMerge(
      {
        type: 'generic',
        handled: true
      },
      data.exception.mechanism || {}
    );

    // Fire away!
    this._send(data);
  },

  _trimPacket: function(data) {
    // For now, we only want to truncate the two different messages
    // but this could/should be expanded to just trim everything
    var max = this._globalOptions.maxMessageLength;
    if (data.message) {
      data.message = truncate(data.message, max);
    }
    if (data.exception) {
      var exception = data.exception.values[0];
      exception.value = truncate(exception.value, max);
    }

    var request = data.request;
    if (request) {
      if (request.url) {
        request.url = truncate(request.url, this._globalOptions.maxUrlLength);
      }
      if (request.Referer) {
        request.Referer = truncate(request.Referer, this._globalOptions.maxUrlLength);
      }
    }

    if (data.breadcrumbs && data.breadcrumbs.values)
      this._trimBreadcrumbs(data.breadcrumbs);

    return data;
  },

  /**
   * Truncate breadcrumb values (right now just URLs)
   */
  _trimBreadcrumbs: function(breadcrumbs) {
    // known breadcrumb properties with urls
    // TODO: also consider arbitrary prop values that start with (https?)?://
    var urlProps = ['to', 'from', 'url'],
      urlProp,
      crumb,
      data;

    for (var i = 0; i < breadcrumbs.values.length; ++i) {
      crumb = breadcrumbs.values[i];
      if (
        !crumb.hasOwnProperty('data') ||
        !isObject(crumb.data) ||
        objectFrozen(crumb.data)
      )
        continue;

      data = objectMerge({}, crumb.data);
      for (var j = 0; j < urlProps.length; ++j) {
        urlProp = urlProps[j];
        if (data.hasOwnProperty(urlProp) && data[urlProp]) {
          data[urlProp] = truncate(data[urlProp], this._globalOptions.maxUrlLength);
        }
      }
      breadcrumbs.values[i].data = data;
    }
  },

  _getHttpData: function() {
    if (!this._hasNavigator && !this._hasDocument) return;
    var httpData = {};

    if (this._hasNavigator && _navigator.userAgent) {
      httpData.headers = {
        'User-Agent': _navigator.userAgent
      };
    }

    // Check in `window` instead of `document`, as we may be in ServiceWorker environment
    if (_window.location && _window.location.href) {
      httpData.url = _window.location.href;
    }

    if (this._hasDocument && _document.referrer) {
      if (!httpData.headers) httpData.headers = {};
      httpData.headers.Referer = _document.referrer;
    }

    return httpData;
  },

  _resetBackoff: function() {
    this._backoffDuration = 0;
    this._backoffStart = null;
  },

  _shouldBackoff: function() {
    return this._backoffDuration && now() - this._backoffStart < this._backoffDuration;
  },

  /**
   * Returns true if the in-process data payload matches the signature
   * of the previously-sent data
   *
   * NOTE: This has to be done at this level because TraceKit can generate
   *       data from window.onerror WITHOUT an exception object (IE8, IE9,
   *       other old browsers). This can take the form of an "exception"
   *       data object with a single frame (derived from the onerror args).
   */
  _isRepeatData: function(current) {
    var last = this._lastData;

    if (
      !last ||
      current.message !== last.message || // defined for captureMessage
      current.transaction !== last.transaction // defined for captureException/onerror
    )
      return false;

    // Stacktrace interface (i.e. from captureMessage)
    if (current.stacktrace || last.stacktrace) {
      return isSameStacktrace(current.stacktrace, last.stacktrace);
    } else if (current.exception || last.exception) {
      // Exception interface (i.e. from captureException/onerror)
      return isSameException(current.exception, last.exception);
    } else if (current.fingerprint || last.fingerprint) {
      return Boolean(current.fingerprint && last.fingerprint) &&
        JSON.stringify(current.fingerprint) === JSON.stringify(last.fingerprint)
    }

    return true;
  },

  _setBackoffState: function(request) {
    // If we are already in a backoff state, don't change anything
    if (this._shouldBackoff()) {
      return;
    }

    var status = request.status;

    // 400 - project_id doesn't exist or some other fatal
    // 401 - invalid/revoked dsn
    // 429 - too many requests
    if (!(status === 400 || status === 401 || status === 429)) return;

    var retry;
    try {
      // If Retry-After is not in Access-Control-Expose-Headers, most
      // browsers will throw an exception trying to access it
      if (supportsFetch()) {
        retry = request.headers.get('Retry-After');
      } else {
        retry = request.getResponseHeader('Retry-After');
      }

      // Retry-After is returned in seconds
      retry = parseInt(retry, 10) * 1000;
    } catch (e) {
      /* eslint no-empty:0 */
    }

    this._backoffDuration = retry
      ? // If Sentry server returned a Retry-After value, use it
        retry
      : // Otherwise, double the last backoff duration (starts at 1 sec)
        this._backoffDuration * 2 || 1000;

    this._backoffStart = now();
  },

  _send: function(data) {
    var globalOptions = this._globalOptions;

    var baseData = {
        project: this._globalProject,
        logger: globalOptions.logger,
        platform: 'javascript'
      },
      httpData = this._getHttpData();

    if (httpData) {
      baseData.request = httpData;
    }

    // HACK: delete `trimHeadFrames` to prevent from appearing in outbound payload
    if (data.trimHeadFrames) delete data.trimHeadFrames;

    data = objectMerge(baseData, data);

    // Merge in the tags and extra separately since objectMerge doesn't handle a deep merge
    data.tags = objectMerge(objectMerge({}, this._globalContext.tags), data.tags);
    data.extra = objectMerge(objectMerge({}, this._globalContext.extra), data.extra);

    // Send along our own collected metadata with extra
    data.extra['session:duration'] = now() - this._startTime;

    if (this._breadcrumbs && this._breadcrumbs.length > 0) {
      // intentionally make shallow copy so that additions
      // to breadcrumbs aren't accidentally sent in this request
      data.breadcrumbs = {
        values: [].slice.call(this._breadcrumbs, 0)
      };
    }

    if (this._globalContext.user) {
      // sentry.interfaces.User
      data.user = this._globalContext.user;
    }

    // Include the environment if it's defined in globalOptions
    if (globalOptions.environment) data.environment = globalOptions.environment;

    // Include the release if it's defined in globalOptions
    if (globalOptions.release) data.release = globalOptions.release;

    // Include server_name if it's defined in globalOptions
    if (globalOptions.serverName) data.server_name = globalOptions.serverName;

    data = this._sanitizeData(data);

    // Cleanup empty properties before sending them to the server
    Object.keys(data).forEach(function(key) {
      if (data[key] == null || data[key] === '' || isEmptyObject(data[key])) {
        delete data[key];
      }
    });

    if (isFunction(globalOptions.dataCallback)) {
      data = globalOptions.dataCallback(data) || data;
    }

    // Why??????????
    if (!data || isEmptyObject(data)) {
      return;
    }

    // Check if the request should be filtered or not
    if (
      isFunction(globalOptions.shouldSendCallback) &&
      !globalOptions.shouldSendCallback(data)
    ) {
      return;
    }

    // Backoff state: Sentry server previously responded w/ an error (e.g. 429 - too many requests),
    // so drop requests until "cool-off" period has elapsed.
    if (this._shouldBackoff()) {
      this._logDebug('warn', 'Raven dropped error due to backoff: ', data);
      return;
    }

    if (typeof globalOptions.sampleRate === 'number') {
      if (Math.random() < globalOptions.sampleRate) {
        this._sendProcessedPayload(data);
      }
    } else {
      this._sendProcessedPayload(data);
    }
  },

  _sanitizeData: function(data) {
    return sanitize(data, this._globalOptions.sanitizeKeys);
  },

  _getUuid: function() {
    return uuid4();
  },

  _sendProcessedPayload: function(data, callback) {
    var self = this;
    var globalOptions = this._globalOptions;

    if (!this.isSetup()) return;

    // Try and clean up the packet before sending by truncating long values
    data = this._trimPacket(data);

    // ideally duplicate error testing should occur *before* dataCallback/shouldSendCallback,
    // but this would require copying an un-truncated copy of the data packet, which can be
    // arbitrarily deep (extra_data) -- could be worthwhile? will revisit
    if (!this._globalOptions.allowDuplicates && this._isRepeatData(data)) {
      this._logDebug('warn', 'Raven dropped repeat event: ', data);
      return;
    }

    // Send along an event_id if not explicitly passed.
    // This event_id can be used to reference the error within Sentry itself.
    // Set lastEventId after we know the error should actually be sent
    this._lastEventId = data.event_id || (data.event_id = this._getUuid());

    // Store outbound payload after trim
    this._lastData = data;

    this._logDebug('debug', 'Raven about to send:', data);

    var auth = {
      sentry_version: '7',
      sentry_client: 'raven-js/' + this.VERSION,
      sentry_key: this._globalKey
    };

    if (this._globalSecret) {
      auth.sentry_secret = this._globalSecret;
    }

    var exception = data.exception && data.exception.values[0];

    // only capture 'sentry' breadcrumb is autoBreadcrumbs is truthy
    if (
      this._globalOptions.autoBreadcrumbs &&
      this._globalOptions.autoBreadcrumbs.sentry
    ) {
      this.captureBreadcrumb({
        category: 'sentry',
        message: exception
          ? (exception.type ? exception.type + ': ' : '') + exception.value
          : data.message,
        event_id: data.event_id,
        level: data.level || 'error' // presume error unless specified
      });
    }

    var url = this._globalEndpoint;
    (globalOptions.transport || this._makeRequest).call(this, {
      url: url,
      auth: auth,
      data: data,
      options: globalOptions,
      onSuccess: function success() {
        self._resetBackoff();

        self._triggerEvent('success', {
          data: data,
          src: url
        });
        callback && callback();
      },
      onError: function failure(error) {
        self._logDebug('error', 'Raven transport failed to send: ', error);

        if (error.request) {
          self._setBackoffState(error.request);
        }

        self._triggerEvent('failure', {
          data: data,
          src: url
        });
        error = error || new Error('Raven send failed (no additional details provided)');
        callback && callback(error);
      }
    });
  },

  _makeRequest: function(opts) {
    // Auth is intentionally sent as part of query string (NOT as custom HTTP header) to avoid preflight CORS requests
    var url = opts.url + '?' + urlencode(opts.auth);

    var evaluatedHeaders = null;
    var evaluatedFetchParameters = {};

    if (opts.options.headers) {
      evaluatedHeaders = this._evaluateHash(opts.options.headers);
    }

    if (opts.options.fetchParameters) {
      evaluatedFetchParameters = this._evaluateHash(opts.options.fetchParameters);
    }

    if (supportsFetch()) {
      evaluatedFetchParameters.body = stringify(opts.data);

      var defaultFetchOptions = objectMerge({}, this._fetchDefaults);
      var fetchOptions = objectMerge(defaultFetchOptions, evaluatedFetchParameters);

      if (evaluatedHeaders) {
        fetchOptions.headers = evaluatedHeaders;
      }

      return _window
        .fetch(url, fetchOptions)
        .then(function(response) {
          if (response.ok) {
            opts.onSuccess && opts.onSuccess();
          } else {
            var error = new Error('Sentry error code: ' + response.status);
            // It's called request only to keep compatibility with XHR interface
            // and not add more redundant checks in setBackoffState method
            error.request = response;
            opts.onError && opts.onError(error);
          }
        })
        ['catch'](function() {
          opts.onError &&
            opts.onError(new Error('Sentry error code: network unavailable'));
        });
    }

    var request = _window.XMLHttpRequest && new _window.XMLHttpRequest();
    if (!request) return;

    // if browser doesn't support CORS (e.g. IE7), we are out of luck
    var hasCORS = 'withCredentials' in request || typeof XDomainRequest !== 'undefined';

    if (!hasCORS) return;

    if ('withCredentials' in request) {
      request.onreadystatechange = function() {
        if (request.readyState !== 4) {
          return;
        } else if (request.status === 200) {
          opts.onSuccess && opts.onSuccess();
        } else if (opts.onError) {
          var err = new Error('Sentry error code: ' + request.status);
          err.request = request;
          opts.onError(err);
        }
      };
    } else {
      request = new XDomainRequest();
      // xdomainrequest cannot go http -> https (or vice versa),
      // so always use protocol relative
      url = url.replace(/^https?:/, '');

      // onreadystatechange not supported by XDomainRequest
      if (opts.onSuccess) {
        request.onload = opts.onSuccess;
      }
      if (opts.onError) {
        request.onerror = function() {
          var err = new Error('Sentry error code: XDomainRequest');
          err.request = request;
          opts.onError(err);
        };
      }
    }

    request.open('POST', url);

    if (evaluatedHeaders) {
      each(evaluatedHeaders, function(key, value) {
        request.setRequestHeader(key, value);
      });
    }

    request.send(stringify(opts.data));
  },

  _evaluateHash: function(hash) {
    var evaluated = {};

    for (var key in hash) {
      if (hash.hasOwnProperty(key)) {
        var value = hash[key];
        evaluated[key] = typeof value === 'function' ? value() : value;
      }
    }

    return evaluated;
  },

  _logDebug: function(level) {
    // We allow `Raven.debug` and `Raven.config(DSN, { debug: true })` to not make backward incompatible API change
    if (
      this._originalConsoleMethods[level] &&
      (this.debug || this._globalOptions.debug)
    ) {
      // In IE<10 console methods do not have their own 'apply' method
      Function.prototype.apply.call(
        this._originalConsoleMethods[level],
        this._originalConsole,
        [].slice.call(arguments, 1)
      );
    }
  },

  _mergeContext: function(key, context) {
    if (isUndefined(context)) {
      delete this._globalContext[key];
    } else {
      this._globalContext[key] = objectMerge(this._globalContext[key] || {}, context);
    }
  }
};

// Deprecations
Raven.prototype.setUser = Raven.prototype.setUserContext;
Raven.prototype.setReleaseContext = Raven.prototype.setRelease;

module.exports = Raven;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var utils = __webpack_require__(379);

/*
 TraceKit - Cross brower stack traces

 This was originally forked from github.com/occ/TraceKit, but has since been
 largely re-written and is now maintained as part of raven-js.  Tests for
 this are in test/vendor.

 MIT license
*/

var TraceKit = {
  collectWindowErrors: true,
  debug: false
};

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined'
    ? global
    : typeof self !== 'undefined'
    ? self
    : {};

// global reference to slice
var _slice = [].slice;
var UNKNOWN_FUNCTION = '?';

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;

function getLocationHref() {
  if (typeof document === 'undefined' || document.location == null) return '';
  return document.location.href;
}

function getLocationOrigin() {
  if (typeof document === 'undefined' || document.location == null) return '';

  // Oh dear IE10...
  if (!document.location.origin) {
    return (
      document.location.protocol +
      '//' +
      document.location.hostname +
      (document.location.port ? ':' + document.location.port : '')
    );
  }

  return document.location.origin;
}

/**
 * TraceKit.report: cross-browser processing of unhandled exceptions
 *
 * Syntax:
 *   TraceKit.report.subscribe(function(stackInfo) { ... })
 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
 *   TraceKit.report(exception)
 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *              on top frame; column number is not guaranteed
 *   - Opera:   full stack trace with line and column numbers
 *   - Chrome:  full stack trace with line and column numbers
 *   - Safari:  line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *   - IE:      line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires TraceKit.computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that TraceKit.report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where TraceKit.report was called.
 *
 * Handlers receive a stackInfo object as described in the
 * TraceKit.computeStackTrace docs.
 */
TraceKit.report = (function reportModuleWrapper() {
  var handlers = [],
    lastArgs = null,
    lastException = null,
    lastExceptionStack = null;

  /**
   * Add a crash handler.
   * @param {Function} handler
   */
  function subscribe(handler) {
    installGlobalHandler();
    handlers.push(handler);
  }

  /**
   * Remove a crash handler.
   * @param {Function} handler
   */
  function unsubscribe(handler) {
    for (var i = handlers.length - 1; i >= 0; --i) {
      if (handlers[i] === handler) {
        handlers.splice(i, 1);
      }
    }
  }

  /**
   * Remove all crash handlers.
   */
  function unsubscribeAll() {
    uninstallGlobalHandler();
    handlers = [];
  }

  /**
   * Dispatch stack information to all handlers.
   * @param {Object.<string, *>} stack
   */
  function notifyHandlers(stack, isWindowError) {
    var exception = null;
    if (isWindowError && !TraceKit.collectWindowErrors) {
      return;
    }
    for (var i in handlers) {
      if (handlers.hasOwnProperty(i)) {
        try {
          handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
        } catch (inner) {
          exception = inner;
        }
      }
    }

    if (exception) {
      throw exception;
    }
  }

  var _oldOnerrorHandler, _onErrorHandlerInstalled;

  /**
   * Ensures all global unhandled exceptions are recorded.
   * Supported by Gecko and IE.
   * @param {string} msg Error message.
   * @param {string} url URL of script that generated the exception.
   * @param {(number|string)} lineNo The line number at which the error
   * occurred.
   * @param {?(number|string)} colNo The column number at which the error
   * occurred.
   * @param {?Error} ex The actual Error object.
   */
  function traceKitWindowOnError(msg, url, lineNo, colNo, ex) {
    var stack = null;
    // If 'ex' is ErrorEvent, get real Error from inside
    var exception = utils.isErrorEvent(ex) ? ex.error : ex;
    // If 'msg' is ErrorEvent, get real message from inside
    var message = utils.isErrorEvent(msg) ? msg.message : msg;

    if (lastExceptionStack) {
      TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(
        lastExceptionStack,
        url,
        lineNo,
        message
      );
      processLastException();
    } else if (exception && utils.isError(exception)) {
      // non-string `exception` arg; attempt to extract stack trace

      // New chrome and blink send along a real error object
      // Let's just report that like a normal error.
      // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
      stack = TraceKit.computeStackTrace(exception);
      notifyHandlers(stack, true);
    } else {
      var location = {
        url: url,
        line: lineNo,
        column: colNo
      };

      var name = undefined;
      var groups;

      if ({}.toString.call(message) === '[object String]') {
        var groups = message.match(ERROR_TYPES_RE);
        if (groups) {
          name = groups[1];
          message = groups[2];
        }
      }

      location.func = UNKNOWN_FUNCTION;

      stack = {
        name: name,
        message: message,
        url: getLocationHref(),
        stack: [location]
      };
      notifyHandlers(stack, true);
    }

    if (_oldOnerrorHandler) {
      return _oldOnerrorHandler.apply(this, arguments);
    }

    return false;
  }

  function installGlobalHandler() {
    if (_onErrorHandlerInstalled) {
      return;
    }
    _oldOnerrorHandler = _window.onerror;
    _window.onerror = traceKitWindowOnError;
    _onErrorHandlerInstalled = true;
  }

  function uninstallGlobalHandler() {
    if (!_onErrorHandlerInstalled) {
      return;
    }
    _window.onerror = _oldOnerrorHandler;
    _onErrorHandlerInstalled = false;
    _oldOnerrorHandler = undefined;
  }

  function processLastException() {
    var _lastExceptionStack = lastExceptionStack,
      _lastArgs = lastArgs;
    lastArgs = null;
    lastExceptionStack = null;
    lastException = null;
    notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
  }

  /**
   * Reports an unhandled Error to TraceKit.
   * @param {Error} ex
   * @param {?boolean} rethrow If false, do not re-throw the exception.
   * Only used for window.onerror to not cause an infinite loop of
   * rethrowing.
   */
  function report(ex, rethrow) {
    var args = _slice.call(arguments, 1);
    if (lastExceptionStack) {
      if (lastException === ex) {
        return; // already caught by an inner catch block, ignore
      } else {
        processLastException();
      }
    }

    var stack = TraceKit.computeStackTrace(ex);
    lastExceptionStack = stack;
    lastException = ex;
    lastArgs = args;

    // If the stack trace is incomplete, wait for 2 seconds for
    // slow slow IE to see if onerror occurs or not before reporting
    // this exception; otherwise, we will end up with an incomplete
    // stack trace
    setTimeout(
      function() {
        if (lastException === ex) {
          processLastException();
        }
      },
      stack.incomplete ? 2000 : 0
    );

    if (rethrow !== false) {
      throw ex; // re-throw to propagate to the top level (and cause window.onerror)
    }
  }

  report.subscribe = subscribe;
  report.unsubscribe = unsubscribe;
  report.uninstall = unsubscribeAll;
  return report;
})();

/**
 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
 * Returns:
 *   s.name              - exception name
 *   s.message           - exception message
 *   s.stack[i].url      - JavaScript or HTML file URL
 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
 *   s.stack[i].args     - arguments passed to the function, if known
 *   s.stack[i].line     - line number, if known
 *   s.stack[i].column   - column number, if known
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * TraceKit.computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with TraceKit.report,
 * which builds on top of TraceKit.computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 */
TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
  // Contents of Exception in various browsers.
  //
  // SAFARI:
  // ex.message = Can't find variable: qq
  // ex.line = 59
  // ex.sourceId = 580238192
  // ex.sourceURL = http://...
  // ex.expressionBeginOffset = 96
  // ex.expressionCaretOffset = 98
  // ex.expressionEndOffset = 98
  // ex.name = ReferenceError
  //
  // FIREFOX:
  // ex.message = qq is not defined
  // ex.fileName = http://...
  // ex.lineNumber = 59
  // ex.columnNumber = 69
  // ex.stack = ...stack trace... (see the example below)
  // ex.name = ReferenceError
  //
  // CHROME:
  // ex.message = qq is not defined
  // ex.name = ReferenceError
  // ex.type = not_defined
  // ex.arguments = ['aa']
  // ex.stack = ...stack trace...
  //
  // INTERNET EXPLORER:
  // ex.message = ...
  // ex.name = ReferenceError
  //
  // OPERA:
  // ex.message = ...message... (see the example below)
  // ex.name = ReferenceError
  // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
  // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'

  /**
   * Computes stack trace information from the stack property.
   * Chrome and Gecko use this property.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */
  function computeStackTraceFromStackProp(ex) {
    if (typeof ex.stack === 'undefined' || !ex.stack) return;

    var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|[a-z]:|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
    var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx(?:-web)|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
    // NOTE: blob urls are now supposed to always have an origin, therefore it's format
    // which is `blob:http://url/path/with-some-uuid`, is matched by `blob.*?:\/` as well
    var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i;
    // Used to additionally parse URL/line/column from eval frames
    var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
    var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
    var lines = ex.stack.split('\n');
    var stack = [];
    var submatch;
    var parts;
    var element;
    var reference = /^(.*) is undefined$/.exec(ex.message);

    for (var i = 0, j = lines.length; i < j; ++i) {
      if ((parts = chrome.exec(lines[i]))) {
        var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval && (submatch = chromeEval.exec(parts[2]))) {
          // throw out eval line/column and use top-most line/column number
          parts[2] = submatch[1]; // url
          parts[3] = submatch[2]; // line
          parts[4] = submatch[3]; // column
        }
        element = {
          url: !isNative ? parts[2] : null,
          func: parts[1] || UNKNOWN_FUNCTION,
          args: isNative ? [parts[2]] : [],
          line: parts[3] ? +parts[3] : null,
          column: parts[4] ? +parts[4] : null
        };
      } else if ((parts = winjs.exec(lines[i]))) {
        element = {
          url: parts[2],
          func: parts[1] || UNKNOWN_FUNCTION,
          args: [],
          line: +parts[3],
          column: parts[4] ? +parts[4] : null
        };
      } else if ((parts = gecko.exec(lines[i]))) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval && (submatch = geckoEval.exec(parts[3]))) {
          // throw out eval line/column and use top-most line number
          parts[3] = submatch[1];
          parts[4] = submatch[2];
          parts[5] = null; // no column when eval
        } else if (i === 0 && !parts[5] && typeof ex.columnNumber !== 'undefined') {
          // FireFox uses this awesome columnNumber property for its top frame
          // Also note, Firefox's column number is 0-based and everything else expects 1-based,
          // so adding 1
          // NOTE: this hack doesn't work if top-most frame is eval
          stack[0].column = ex.columnNumber + 1;
        }
        element = {
          url: parts[3],
          func: parts[1] || UNKNOWN_FUNCTION,
          args: parts[2] ? parts[2].split(',') : [],
          line: parts[4] ? +parts[4] : null,
          column: parts[5] ? +parts[5] : null
        };
      } else {
        continue;
      }

      if (!element.func && element.line) {
        element.func = UNKNOWN_FUNCTION;
      }

      if (element.url && element.url.substr(0, 5) === 'blob:') {
        // Special case for handling JavaScript loaded into a blob.
        // We use a synchronous AJAX request here as a blob is already in
        // memory - it's not making a network request.  This will generate a warning
        // in the browser console, but there has already been an error so that's not
        // that much of an issue.
        var xhr = new XMLHttpRequest();
        xhr.open('GET', element.url, false);
        xhr.send(null);

        // If we failed to download the source, skip this patch
        if (xhr.status === 200) {
          var source = xhr.responseText || '';

          // We trim the source down to the last 300 characters as sourceMappingURL is always at the end of the file.
          // Why 300? To be in line with: https://github.com/getsentry/sentry/blob/4af29e8f2350e20c28a6933354e4f42437b4ba42/src/sentry/lang/javascript/processor.py#L164-L175
          source = source.slice(-300);

          // Now we dig out the source map URL
          var sourceMaps = source.match(/\/\/# sourceMappingURL=(.*)$/);

          // If we don't find a source map comment or we find more than one, continue on to the next element.
          if (sourceMaps) {
            var sourceMapAddress = sourceMaps[1];

            // Now we check to see if it's a relative URL.
            // If it is, convert it to an absolute one.
            if (sourceMapAddress.charAt(0) === '~') {
              sourceMapAddress = getLocationOrigin() + sourceMapAddress.slice(1);
            }

            // Now we strip the '.map' off of the end of the URL and update the
            // element so that Sentry can match the map to the blob.
            element.url = sourceMapAddress.slice(0, -4);
          }
        }
      }

      stack.push(element);
    }

    if (!stack.length) {
      return null;
    }

    return {
      name: ex.name,
      message: ex.message,
      url: getLocationHref(),
      stack: stack
    };
  }

  /**
   * Adds information about the first frame to incomplete stack traces.
   * Safari and IE require this to get complete data on the first frame.
   * @param {Object.<string, *>} stackInfo Stack trace information from
   * one of the compute* methods.
   * @param {string} url The URL of the script that caused an error.
   * @param {(number|string)} lineNo The line number of the script that
   * caused an error.
   * @param {string=} message The error generated by the browser, which
   * hopefully contains the name of the object that caused the error.
   * @return {boolean} Whether or not the stack information was
   * augmented.
   */
  function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
    var initial = {
      url: url,
      line: lineNo
    };

    if (initial.url && initial.line) {
      stackInfo.incomplete = false;

      if (!initial.func) {
        initial.func = UNKNOWN_FUNCTION;
      }

      if (stackInfo.stack.length > 0) {
        if (stackInfo.stack[0].url === initial.url) {
          if (stackInfo.stack[0].line === initial.line) {
            return false; // already in stack trace
          } else if (
            !stackInfo.stack[0].line &&
            stackInfo.stack[0].func === initial.func
          ) {
            stackInfo.stack[0].line = initial.line;
            return false;
          }
        }
      }

      stackInfo.stack.unshift(initial);
      stackInfo.partial = true;
      return true;
    } else {
      stackInfo.incomplete = true;
    }

    return false;
  }

  /**
   * Computes stack trace information by walking the arguments.caller
   * chain at the time the exception occurred. This will cause earlier
   * frames to be missed but is the only way to get any stack trace in
   * Safari and IE. The top frame is restored by
   * {@link augmentStackTraceWithInitialElement}.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */
  function computeStackTraceByWalkingCallerChain(ex, depth) {
    var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
      stack = [],
      funcs = {},
      recursion = false,
      parts,
      item,
      source;

    for (
      var curr = computeStackTraceByWalkingCallerChain.caller;
      curr && !recursion;
      curr = curr.caller
    ) {
      if (curr === computeStackTrace || curr === TraceKit.report) {
        // console.log('skipping internal function');
        continue;
      }

      item = {
        url: null,
        func: UNKNOWN_FUNCTION,
        line: null,
        column: null
      };

      if (curr.name) {
        item.func = curr.name;
      } else if ((parts = functionName.exec(curr.toString()))) {
        item.func = parts[1];
      }

      if (typeof item.func === 'undefined') {
        try {
          item.func = parts.input.substring(0, parts.input.indexOf('{'));
        } catch (e) {}
      }

      if (funcs['' + curr]) {
        recursion = true;
      } else {
        funcs['' + curr] = true;
      }

      stack.push(item);
    }

    if (depth) {
      // console.log('depth is ' + depth);
      // console.log('stack is ' + stack.length);
      stack.splice(0, depth);
    }

    var result = {
      name: ex.name,
      message: ex.message,
      url: getLocationHref(),
      stack: stack
    };
    augmentStackTraceWithInitialElement(
      result,
      ex.sourceURL || ex.fileName,
      ex.line || ex.lineNumber,
      ex.message || ex.description
    );
    return result;
  }

  /**
   * Computes a stack trace for an exception.
   * @param {Error} ex
   * @param {(string|number)=} depth
   */
  function computeStackTrace(ex, depth) {
    var stack = null;
    depth = depth == null ? 0 : +depth;

    try {
      stack = computeStackTraceFromStackProp(ex);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }

    try {
      stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }
    return {
      name: ex.name,
      message: ex.message,
      url: getLocationHref()
    };
  }

  computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
  computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;

  return computeStackTrace;
})();

module.exports = TraceKit;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 1443 */
/***/ (function(module, exports) {

/*
 * JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

/*
* Add integers, wrapping at 2^32. This uses 16-bit operations internally
* to work around bugs in some JS interpreters.
*/
function safeAdd(x, y) {
  var lsw = (x & 0xffff) + (y & 0xffff);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return (msw << 16) | (lsw & 0xffff);
}

/*
* Bitwise rotate a 32-bit number to the left.
*/
function bitRotateLeft(num, cnt) {
  return (num << cnt) | (num >>> (32 - cnt));
}

/*
* These functions implement the four basic operations the algorithm uses.
*/
function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}
function md5ff(a, b, c, d, x, s, t) {
  return md5cmn((b & c) | (~b & d), a, b, x, s, t);
}
function md5gg(a, b, c, d, x, s, t) {
  return md5cmn((b & d) | (c & ~d), a, b, x, s, t);
}
function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

/*
* Calculate the MD5 of an array of little-endian words, and a bit length.
*/
function binlMD5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << (len % 32);
  x[(((len + 64) >>> 9) << 4) + 14] = len;

  var i;
  var olda;
  var oldb;
  var oldc;
  var oldd;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (i = 0; i < x.length; i += 16) {
    olda = a;
    oldb = b;
    oldc = c;
    oldd = d;

    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);

    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);

    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);

    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);

    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }
  return [a, b, c, d];
}

/*
* Convert an array of little-endian words to a string
*/
function binl2rstr(input) {
  var i;
  var output = '';
  var length32 = input.length * 32;
  for (i = 0; i < length32; i += 8) {
    output += String.fromCharCode((input[i >> 5] >>> (i % 32)) & 0xff);
  }
  return output;
}

/*
* Convert a raw string to an array of little-endian words
* Characters >255 have their high-byte silently ignored.
*/
function rstr2binl(input) {
  var i;
  var output = [];
  output[(input.length >> 2) - 1] = undefined;
  for (i = 0; i < output.length; i += 1) {
    output[i] = 0;
  }
  var length8 = input.length * 8;
  for (i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << (i % 32);
  }
  return output;
}

/*
* Calculate the MD5 of a raw string
*/
function rstrMD5(s) {
  return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
}

/*
* Calculate the HMAC-MD5, of a key and some data (raw strings)
*/
function rstrHMACMD5(key, data) {
  var i;
  var bkey = rstr2binl(key);
  var ipad = [];
  var opad = [];
  var hash;
  ipad[15] = opad[15] = undefined;
  if (bkey.length > 16) {
    bkey = binlMD5(bkey, key.length * 8);
  }
  for (i = 0; i < 16; i += 1) {
    ipad[i] = bkey[i] ^ 0x36363636;
    opad[i] = bkey[i] ^ 0x5c5c5c5c;
  }
  hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
  return binl2rstr(binlMD5(opad.concat(hash), 512 + 128));
}

/*
* Convert a raw string to a hex string
*/
function rstr2hex(input) {
  var hexTab = '0123456789abcdef';
  var output = '';
  var x;
  var i;
  for (i = 0; i < input.length; i += 1) {
    x = input.charCodeAt(i);
    output += hexTab.charAt((x >>> 4) & 0x0f) + hexTab.charAt(x & 0x0f);
  }
  return output;
}

/*
* Encode a string as utf-8
*/
function str2rstrUTF8(input) {
  return unescape(encodeURIComponent(input));
}

/*
* Take string arguments and return either raw or hex encoded strings
*/
function rawMD5(s) {
  return rstrMD5(str2rstrUTF8(s));
}
function hexMD5(s) {
  return rstr2hex(rawMD5(s));
}
function rawHMACMD5(k, d) {
  return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
}
function hexHMACMD5(k, d) {
  return rstr2hex(rawHMACMD5(k, d));
}

function md5(string, key, raw) {
  if (!key) {
    if (!raw) {
      return hexMD5(string);
    }
    return rawMD5(string);
  }
  if (!raw) {
    return hexHMACMD5(key, string);
  }
  return rawHMACMD5(key, string);
}

module.exports = md5;


/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_align__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(1446);












function getElement(func) {
  if (typeof func !== 'function' || !func) return null;
  return func();
}

function getPoint(point) {
  if (typeof point !== 'object' || !point) return null;
  return point;
}

var Align = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Align, _Component);

  function Align() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Align);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Align.__proto__ || Object.getPrototypeOf(Align)).call.apply(_ref, [this].concat(args))), _this), _this.forceAlign = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          target = _this$props.target,
          align = _this$props.align,
          onAlign = _this$props.onAlign;

      if (!disabled && target) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(_this);

        var result = void 0;
        var element = getElement(target);
        var point = getPoint(target);

        // IE lose focus after element realign
        // We should record activeElement and restore later
        var activeElement = document.activeElement;

        if (element) {
          result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_dom_align__["a" /* alignElement */])(source, element, align);
        } else if (point) {
          result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_dom_align__["b" /* alignPoint */])(source, point, align);
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* restoreFocus */])(activeElement, source);

        if (onAlign) {
          onAlign(source, result);
        }
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Align, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;
      // if parent ref not attached .... use document.getElementById
      this.forceAlign();
      if (!props.disabled && props.monitorWindowResize) {
        this.startMonitorWindowResize();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var reAlign = false;
      var props = this.props;

      if (!props.disabled) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
        var sourceRect = source ? source.getBoundingClientRect() : null;

        if (prevProps.disabled) {
          reAlign = true;
        } else {
          var lastElement = getElement(prevProps.target);
          var currentElement = getElement(props.target);
          var lastPoint = getPoint(prevProps.target);
          var currentPoint = getPoint(props.target);

          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util__["b" /* isWindow */])(lastElement) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util__["b" /* isWindow */])(currentElement)) {
            // Skip if is window
            reAlign = false;
          } else if (lastElement !== currentElement || // Element change
          lastElement && !currentElement && currentPoint || // Change from element to point
          lastPoint && currentPoint && currentElement || // Change from point to element
          currentPoint && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* isSamePoint */])(lastPoint, currentPoint)) {
            reAlign = true;
          }

          // If source element size changed
          var preRect = this.sourceRect || {};
          if (!reAlign && source && (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isSimilarValue */])(preRect.width, sourceRect.width) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isSimilarValue */])(preRect.height, sourceRect.height))) {
            reAlign = true;
          }
        }

        this.sourceRect = sourceRect;
      }

      if (reAlign) {
        this.forceAlign();
      }

      if (props.monitorWindowResize && !props.disabled) {
        this.startMonitorWindowResize();
      } else {
        this.stopMonitorWindowResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopMonitorWindowResize();
    }
  }, {
    key: 'startMonitorWindowResize',
    value: function startMonitorWindowResize() {
      if (!this.resizeHandler) {
        this.bufferMonitor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util__["e" /* buffer */])(this.forceAlign, this.props.monitorBufferTime);
        this.resizeHandler = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', this.bufferMonitor);
      }
    }
  }, {
    key: 'stopMonitorWindowResize',
    value: function stopMonitorWindowResize() {
      if (this.resizeHandler) {
        this.bufferMonitor.clear();
        this.resizeHandler.remove();
        this.resizeHandler = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          childrenProps = _props.childrenProps,
          children = _props.children;

      var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
      if (childrenProps) {
        var newProps = {};
        var propList = Object.keys(childrenProps);
        propList.forEach(function (prop) {
          newProps[prop] = _this2.props[childrenProps[prop]];
        });

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newProps);
      }
      return child;
    }
  }]);

  return Align;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Align.propTypes = {
  childrenProps: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    clientX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    clientY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })]),
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  monitorBufferTime: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  monitorWindowResize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
};
Align.defaultProps = {
  target: function target() {
    return window;
  },
  monitorBufferTime: 50,
  monitorWindowResize: false,
  disabled: false
};


/* harmony default export */ __webpack_exports__["a"] = (Align);

/***/ }),
/* 1445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Align__ = __webpack_require__(1444);
// export this package's api


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Align__["a" /* default */]);

/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = buffer;
/* harmony export (immutable) */ __webpack_exports__["c"] = isSamePoint;
/* harmony export (immutable) */ __webpack_exports__["b"] = isWindow;
/* harmony export (immutable) */ __webpack_exports__["d"] = isSimilarValue;
/* harmony export (immutable) */ __webpack_exports__["a"] = restoreFocus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__ = __webpack_require__(607);


function buffer(fn, ms) {
  var timer = void 0;

  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function bufferFn() {
    clear();
    timer = setTimeout(fn, ms);
  }

  bufferFn.clear = clear;

  return bufferFn;
}

function isSamePoint(prev, next) {
  if (prev === next) return true;
  if (!prev || !next) return false;

  if ('pageX' in next && 'pageY' in next) {
    return prev.pageX === next.pageX && prev.pageY === next.pageY;
  }

  if ('clientX' in next && 'clientY' in next) {
    return prev.clientX === next.clientX && prev.clientY === next.clientY;
  }

  return false;
}

function isWindow(obj) {
  return obj && typeof obj === 'object' && obj.window === obj;
}

function isSimilarValue(val1, val2) {
  var int1 = Math.floor(val1);
  var int2 = Math.floor(val2);
  return Math.abs(int1 - int2) <= 1;
}

function restoreFocus(activeElement, container) {
  // Focus back if is in the container
  if (activeElement !== document.activeElement && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__["a" /* default */])(container, activeElement)) {
    activeElement.focus();
  }
}

/***/ }),
/* 1447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__ = __webpack_require__(1459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AnimateChild__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_animate__ = __webpack_require__(603);













var defaultKey = 'rc_animate_' + Date.now();

function getChildrenFromProps(props) {
  var children = props.children;
  if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
    if (!children.key) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Animate);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* toArrayChildren */])(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* toArrayChildren */])(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* toArrayChildren */])(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findChildInChildrenByKey */])(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(nextChild || currentChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findChildInChildrenByKey */])(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["c" /* mergeChildren */])(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findChildInChildrenByKey */])(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["d" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findChildInChildrenByKey */])(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["d" /* findShownChildInChildrenByKey */])(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["d" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findChildInChildrenByKey */])(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__AnimateChild__["a" /* default */],
            {
              key: child.key,
              ref: function ref(node) {
                _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Animate.isAnimate = true;
Animate.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  componentProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* toArrayChildren */])(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else if (type === 'appear') {
      if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowAppearCallback(props)) {
        props.onAppear(key);
        props.onEnd(key, true);
      }
    } else if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowEnterCallback(props)) {
      props.onEnter(key);
      props.onEnd(key, true);
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* toArrayChildren */])(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* isSameChildren */])(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__["a" /* default */])(Animate));

/***/ }),
/* 1448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_css_animation__ = __webpack_require__(1183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_animate__ = __webpack_require__(603);










var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);

  function AnimateChild() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = typeof transitionName === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((__WEBPACK_IMPORTED_MODULE_7_css_animation__["a" /* isCssAnimationSupported */] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_css_animation__["b" /* default */])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

AnimateChild.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateChild);

/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toArrayChildren;
/* harmony export (immutable) */ __webpack_exports__["b"] = findChildInChildrenByKey;
/* harmony export (immutable) */ __webpack_exports__["d"] = findShownChildInChildrenByKey;
/* unused harmony export findHiddenChildInChildrenByKey */
/* harmony export (immutable) */ __webpack_exports__["e"] = isSameChildren;
/* harmony export (immutable) */ __webpack_exports__["c"] = mergeChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArrayChildren(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}

/***/ }),
/* 1450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);






var Content = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Content, _React$Component);

  function Content() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Content);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Content.prototype.componentDidUpdate = function componentDidUpdate() {
    var trigger = this.props.trigger;

    if (trigger) {
      trigger.forcePopupAlign();
    }
  };

  Content.prototype.render = function render() {
    var _props = this.props,
        overlay = _props.overlay,
        prefixCls = _props.prefixCls,
        id = _props.id;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: prefixCls + '-inner', id: id, role: 'tooltip' },
      typeof overlay === 'function' ? overlay() : overlay
    );
  };

  return Content;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Content.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  overlay: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]).isRequired,
  id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  trigger: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (Content);

/***/ }),
/* 1451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_trigger__ = __webpack_require__(1456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__placements__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Content__ = __webpack_require__(1450);











var Tooltip = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tooltip, _Component);

  function Tooltip() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPopupElement = function () {
      var _this$props = _this.props,
          arrowContent = _this$props.arrowContent,
          overlay = _this$props.overlay,
          prefixCls = _this$props.prefixCls,
          id = _this$props.id;

      return [__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-arrow', key: 'arrow' },
        arrowContent
      ), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Content__["a" /* default */], {
        key: 'content',
        trigger: _this.trigger,
        prefixCls: prefixCls,
        id: id,
        overlay: overlay
      })];
    }, _this.saveTrigger = function (node) {
      _this.trigger = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Tooltip.prototype.getPopupDomNode = function getPopupDomNode() {
    return this.trigger.getPopupDomNode();
  };

  Tooltip.prototype.render = function render() {
    var _props = this.props,
        overlayClassName = _props.overlayClassName,
        trigger = _props.trigger,
        mouseEnterDelay = _props.mouseEnterDelay,
        mouseLeaveDelay = _props.mouseLeaveDelay,
        overlayStyle = _props.overlayStyle,
        prefixCls = _props.prefixCls,
        children = _props.children,
        onVisibleChange = _props.onVisibleChange,
        afterVisibleChange = _props.afterVisibleChange,
        transitionName = _props.transitionName,
        animation = _props.animation,
        placement = _props.placement,
        align = _props.align,
        destroyTooltipOnHide = _props.destroyTooltipOnHide,
        defaultVisible = _props.defaultVisible,
        getTooltipContainer = _props.getTooltipContainer,
        restProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['overlayClassName', 'trigger', 'mouseEnterDelay', 'mouseLeaveDelay', 'overlayStyle', 'prefixCls', 'children', 'onVisibleChange', 'afterVisibleChange', 'transitionName', 'animation', 'placement', 'align', 'destroyTooltipOnHide', 'defaultVisible', 'getTooltipContainer']);

    var extraProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, restProps);
    if ('visible' in this.props) {
      extraProps.popupVisible = this.props.visible;
    }
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_rc_trigger__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        popupClassName: overlayClassName,
        ref: this.saveTrigger,
        prefixCls: prefixCls,
        popup: this.getPopupElement,
        action: trigger,
        builtinPlacements: __WEBPACK_IMPORTED_MODULE_8__placements__["a" /* placements */],
        popupPlacement: placement,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        defaultPopupVisible: defaultVisible,
        destroyPopupOnHide: destroyTooltipOnHide,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay
      }, extraProps),
      children
    );
  };

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Tooltip.propTypes = {
  trigger: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  defaultVisible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  placement: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  onVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  afterVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  overlay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]).isRequired,
  overlayStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  overlayClassName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  getTooltipContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  destroyTooltipOnHide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  align: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  arrowContent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
Tooltip.defaultProps = {
  prefixCls: 'rc-tooltip',
  mouseEnterDelay: 0,
  destroyTooltipOnHide: false,
  mouseLeaveDelay: 0.1,
  align: {},
  placement: 'right',
  trigger: ['hover'],
  arrowContent: null
};


/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tooltip__ = __webpack_require__(1451);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Tooltip__["a" /* default */]);

/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return placements; });
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = {
  left: {
    points: ['cr', 'cl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  right: {
    points: ['cl', 'cr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  rightBottom: {
    points: ['bl', 'br'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  leftBottom: {
    points: ['br', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (placements);

/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_align__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_animate__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PopupInner__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(605);













var Popup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Popup, _Component);

  function Popup(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Popup);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      // Used for stretch
      stretchChecked: false,
      targetWidth: undefined,
      targetHeight: undefined
    };

    _this.savePopupRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'popupInstance');
    _this.saveAlignRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'alignInstance');
    return _this;
  }

  Popup.prototype.componentDidMount = function componentDidMount() {
    this.rootNode = this.getPopupDomNode();
    this.setStretchSize();
  };

  Popup.prototype.componentDidUpdate = function componentDidUpdate() {
    this.setStretchSize();
  };

  // Record size if stretch needed


  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
    return __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.popupInstance);
  };

  // `target` on `rc-align` can accept as a function to get the bind element or a point.
  // ref: https://www.npmjs.com/package/rc-align


  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
    var props = this.props;
    var transitionName = props.maskTransitionName;
    var animation = props.maskAnimation;
    if (!transitionName && animation) {
      transitionName = props.prefixCls + '-' + animation;
    }
    return transitionName;
  };

  Popup.prototype.getTransitionName = function getTransitionName() {
    var props = this.props;
    var transitionName = props.transitionName;
    if (!transitionName && props.animation) {
      transitionName = props.prefixCls + '-' + props.animation;
    }
    return transitionName;
  };

  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
  };

  Popup.prototype.getPopupElement = function getPopupElement() {
    var _this2 = this;

    var savePopupRef = this.savePopupRef;
    var _state = this.state,
        stretchChecked = _state.stretchChecked,
        targetHeight = _state.targetHeight,
        targetWidth = _state.targetWidth;
    var _props = this.props,
        align = _props.align,
        visible = _props.visible,
        prefixCls = _props.prefixCls,
        style = _props.style,
        getClassNameFromAlign = _props.getClassNameFromAlign,
        destroyPopupOnHide = _props.destroyPopupOnHide,
        stretch = _props.stretch,
        children = _props.children,
        onMouseEnter = _props.onMouseEnter,
        onMouseLeave = _props.onMouseLeave,
        onMouseDown = _props.onMouseDown,
        onTouchStart = _props.onTouchStart;

    var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
    var hiddenClassName = prefixCls + '-hidden';

    if (!visible) {
      this.currentAlignClassName = null;
    }

    var sizeStyle = {};
    if (stretch) {
      // Stretch with target
      if (stretch.indexOf('height') !== -1) {
        sizeStyle.height = targetHeight;
      } else if (stretch.indexOf('minHeight') !== -1) {
        sizeStyle.minHeight = targetHeight;
      }
      if (stretch.indexOf('width') !== -1) {
        sizeStyle.width = targetWidth;
      } else if (stretch.indexOf('minWidth') !== -1) {
        sizeStyle.minWidth = targetWidth;
      }

      // Delay force align to makes ui smooth
      if (!stretchChecked) {
        sizeStyle.visibility = 'hidden';
        setTimeout(function () {
          if (_this2.alignInstance) {
            _this2.alignInstance.forceAlign();
          }
        }, 0);
      }
    }

    var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, sizeStyle, style, this.getZIndexStyle());

    var popupInnerProps = {
      className: className,
      prefixCls: prefixCls,
      ref: savePopupRef,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onMouseDown: onMouseDown,
      onTouchStart: onTouchStart,
      style: newStyle
    };
    if (destroyPopupOnHide) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
        {
          component: '',
          exclusive: true,
          transitionAppear: true,
          transitionName: this.getTransitionName()
        },
        visible ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
          {
            target: this.getAlignTarget(),
            key: 'popup',
            ref: this.saveAlignRef,
            monitorWindowResize: true,
            align: align,
            onAlign: this.onAlign
          },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              visible: true
            }, popupInnerProps),
            children
          )
        ) : null
      );
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
      {
        component: '',
        exclusive: true,
        transitionAppear: true,
        transitionName: this.getTransitionName(),
        showProp: 'xVisible'
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
        {
          target: this.getAlignTarget(),
          key: 'popup',
          ref: this.saveAlignRef,
          monitorWindowResize: true,
          xVisible: visible,
          childrenProps: { visible: 'xVisible' },
          disabled: !visible,
          align: align,
          onAlign: this.onAlign
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            hiddenClassName: hiddenClassName
          }, popupInnerProps),
          children
        )
      )
    );
  };

  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
    var style = {};
    var props = this.props;
    if (props.zIndex !== undefined) {
      style.zIndex = props.zIndex;
    }
    return style;
  };

  Popup.prototype.getMaskElement = function getMaskElement() {
    var props = this.props;
    var maskElement = void 0;
    if (props.mask) {
      var maskTransition = this.getMaskTransitionName();
      maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__["a" /* default */], {
        style: this.getZIndexStyle(),
        key: 'mask',
        className: props.prefixCls + '-mask',
        hiddenClassName: props.prefixCls + '-mask-hidden',
        visible: props.visible
      });
      if (maskTransition) {
        maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
          {
            key: 'mask',
            showProp: 'visible',
            transitionAppear: true,
            component: '',
            transitionName: maskTransition
          },
          maskElement
        );
      }
    }
    return maskElement;
  };

  Popup.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      null,
      this.getMaskElement(),
      this.getPopupElement()
    );
  };

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Popup.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  getClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getRootDomNode: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  point: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onAlign = function (popupDomNode, align) {
    var props = _this3.props;
    var currentAlignClassName = props.getClassNameFromAlign(align);
    // FIX: https://github.com/react-component/trigger/issues/56
    // FIX: https://github.com/react-component/tooltip/issues/79
    if (_this3.currentAlignClassName !== currentAlignClassName) {
      _this3.currentAlignClassName = currentAlignClassName;
      popupDomNode.className = _this3.getClassName(currentAlignClassName);
    }
    props.onAlign(popupDomNode, align);
  };

  this.setStretchSize = function () {
    var _props2 = _this3.props,
        stretch = _props2.stretch,
        getRootDomNode = _props2.getRootDomNode,
        visible = _props2.visible;
    var _state2 = _this3.state,
        stretchChecked = _state2.stretchChecked,
        targetHeight = _state2.targetHeight,
        targetWidth = _state2.targetWidth;


    if (!stretch || !visible) {
      if (stretchChecked) {
        _this3.setState({ stretchChecked: false });
      }
      return;
    }

    var $ele = getRootDomNode();
    if (!$ele) return;

    var height = $ele.offsetHeight;
    var width = $ele.offsetWidth;

    if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
      _this3.setState({
        stretchChecked: true,
        targetHeight: height,
        targetWidth: width
      });
    }
  };

  this.getTargetElement = function () {
    return _this3.props.getRootDomNode();
  };

  this.getAlignTarget = function () {
    var point = _this3.props.point;

    if (point) {
      return point;
    }
    return _this3.getTargetElement;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Popup);

/***/ }),
/* 1455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__ = __webpack_require__(604);







var PopupInner = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(PopupInner, _Component);

  function PopupInner() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PopupInner);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  PopupInner.prototype.render = function render() {
    var props = this.props;
    var className = props.className;
    if (!props.visible) {
      className += ' ' + props.hiddenClassName;
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      {
        className: className,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onMouseDown: props.onMouseDown,
        onTouchStart: props.onTouchStart,
        style: props.style
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__["a" /* default */],
        { className: props.prefixCls + '-content', visible: props.visible },
        props.children
      )
    );
  };

  return PopupInner;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

PopupInner.propTypes = {
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};


/* harmony default export */ __webpack_exports__["a"] = (PopupInner);

/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_ContainerRender__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_Portal__ = __webpack_require__(1458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Popup__ = __webpack_require__(1454);

















function noop() {}

function returnEmptyString() {
  return '';
}

function returnDocument() {
  return window.document;
}

var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];

var IS_REACT_16 = !!__WEBPACK_IMPORTED_MODULE_6_react_dom__["createPortal"];

var contextTypes = {
  rcTrigger: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    onPopupMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
  })
};

var Trigger = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Trigger, _React$Component);

  function Trigger(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Trigger);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var popupVisible = void 0;
    if ('popupVisible' in props) {
      popupVisible = !!props.popupVisible;
    } else {
      popupVisible = !!props.defaultPopupVisible;
    }

    _this.state = {
      prevPopupVisible: popupVisible,
      popupVisible: popupVisible
    };

    ALL_HANDLERS.forEach(function (h) {
      _this['fire' + h] = function (e) {
        _this.fireEvents(h, e);
      };
    });
    return _this;
  }

  Trigger.prototype.getChildContext = function getChildContext() {
    return {
      rcTrigger: {
        onPopupMouseDown: this.onPopupMouseDown
      }
    };
  };

  Trigger.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate({}, {
      popupVisible: this.state.popupVisible
    });
  };

  Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
    var props = this.props;
    var state = this.state;
    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
      if (prevState.popupVisible !== state.popupVisible) {
        props.afterPopupVisibleChange(state.popupVisible);
      }
    };
    if (!IS_REACT_16) {
      this.renderComponent(null, triggerAfterPopupVisibleChange);
    }

    // We must listen to `mousedown` or `touchstart`, edge case:
    // https://github.com/ant-design/ant-design/issues/5804
    // https://github.com/react-component/calendar/issues/250
    // https://github.com/react-component/trigger/issues/50
    if (state.popupVisible) {
      var currentDocument = void 0;
      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
        currentDocument = props.getDocument();
        this.clickOutsideHandler = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'mousedown', this.onDocumentClick);
      }
      // always hide on mobile
      if (!this.touchOutsideHandler) {
        currentDocument = currentDocument || props.getDocument();
        this.touchOutsideHandler = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'touchstart', this.onDocumentClick);
      }
      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
        currentDocument = currentDocument || props.getDocument();
        this.contextMenuOutsideHandler1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'scroll', this.onContextMenuClose);
      }
      // close popup when trigger type contains 'onContextMenu' and window is blur.
      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
        this.contextMenuOutsideHandler2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'blur', this.onContextMenuClose);
      }
      return;
    }

    this.clearOutsideHandler();
  };

  Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearDelayTimer();
    this.clearOutsideHandler();
    clearTimeout(this.mouseDownTimeout);
  };

  Trigger.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var popupVisible = _ref.popupVisible;

    var newState = {};

    if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
      newState.popupVisible = popupVisible;
      newState.prevPopupVisible = prevState.popupVisible;
    }

    return newState;
  };

  Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
    // for test
    if (this._component && this._component.getPopupDomNode) {
      return this._component.getPopupDomNode();
    }
    return null;
  };

  Trigger.prototype.getPopupAlign = function getPopupAlign() {
    var props = this.props;
    var popupPlacement = props.popupPlacement,
        popupAlign = props.popupAlign,
        builtinPlacements = props.builtinPlacements;

    if (popupPlacement && builtinPlacements) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils__["a" /* getAlignFromPlacement */])(builtinPlacements, popupPlacement, popupAlign);
    }
    return popupAlign;
  };

  /**
   * @param popupVisible    Show or not the popup element
   * @param event           SyntheticEvent, used for `pointAlign`
   */
  Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
    var alignPoint = this.props.alignPoint;
    var prevPopupVisible = this.state.popupVisible;


    this.clearDelayTimer();

    if (prevPopupVisible !== popupVisible) {
      if (!('popupVisible' in this.props)) {
        this.setState({ popupVisible: popupVisible, prevPopupVisible: prevPopupVisible });
      }
      this.props.onPopupVisibleChange(popupVisible);
    }

    // Always record the point position since mouseEnterDelay will delay the show
    if (alignPoint && event) {
      this.setPoint(event);
    }
  };

  Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
    var _this2 = this;

    var delay = delayS * 1000;
    this.clearDelayTimer();
    if (delay) {
      var point = event ? { pageX: event.pageX, pageY: event.pageY } : null;
      this.delayTimer = setTimeout(function () {
        _this2.setPopupVisible(visible, point);
        _this2.clearDelayTimer();
      }, delay);
    } else {
      this.setPopupVisible(visible, event);
    }
  };

  Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
  };

  Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
    if (this.clickOutsideHandler) {
      this.clickOutsideHandler.remove();
      this.clickOutsideHandler = null;
    }

    if (this.contextMenuOutsideHandler1) {
      this.contextMenuOutsideHandler1.remove();
      this.contextMenuOutsideHandler1 = null;
    }

    if (this.contextMenuOutsideHandler2) {
      this.contextMenuOutsideHandler2.remove();
      this.contextMenuOutsideHandler2 = null;
    }

    if (this.touchOutsideHandler) {
      this.touchOutsideHandler.remove();
      this.touchOutsideHandler = null;
    }
  };

  Trigger.prototype.createTwoChains = function createTwoChains(event) {
    var childPros = this.props.children.props;
    var props = this.props;
    if (childPros[event] && props[event]) {
      return this['fire' + event];
    }
    return childPros[event] || props[event];
  };

  Trigger.prototype.isClickToShow = function isClickToShow() {
    var _props = this.props,
        action = _props.action,
        showAction = _props.showAction;

    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
    var _props2 = this.props,
        action = _props2.action,
        showAction = _props2.showAction;

    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
  };

  Trigger.prototype.isClickToHide = function isClickToHide() {
    var _props3 = this.props,
        action = _props3.action,
        hideAction = _props3.hideAction;

    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
    var _props4 = this.props,
        action = _props4.action,
        showAction = _props4.showAction;

    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
  };

  Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
    var _props5 = this.props,
        action = _props5.action,
        hideAction = _props5.hideAction;

    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
  };

  Trigger.prototype.isFocusToShow = function isFocusToShow() {
    var _props6 = this.props,
        action = _props6.action,
        showAction = _props6.showAction;

    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
  };

  Trigger.prototype.isBlurToHide = function isBlurToHide() {
    var _props7 = this.props,
        action = _props7.action,
        hideAction = _props7.hideAction;

    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
  };

  Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
    if (this.state.popupVisible && this._component && this._component.alignInstance) {
      this._component.alignInstance.forceAlign();
    }
  };

  Trigger.prototype.fireEvents = function fireEvents(type, e) {
    var childCallback = this.props.children.props[type];
    if (childCallback) {
      childCallback(e);
    }
    var callback = this.props[type];
    if (callback) {
      callback(e);
    }
  };

  Trigger.prototype.close = function close() {
    this.setPopupVisible(false);
  };

  Trigger.prototype.render = function render() {
    var _this3 = this;

    var popupVisible = this.state.popupVisible;
    var _props8 = this.props,
        children = _props8.children,
        forceRender = _props8.forceRender,
        alignPoint = _props8.alignPoint,
        className = _props8.className;

    var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
    var newChildProps = { key: 'trigger' };

    if (this.isContextMenuToShow()) {
      newChildProps.onContextMenu = this.onContextMenu;
    } else {
      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
    }

    if (this.isClickToHide() || this.isClickToShow()) {
      newChildProps.onClick = this.onClick;
      newChildProps.onMouseDown = this.onMouseDown;
      newChildProps.onTouchStart = this.onTouchStart;
    } else {
      newChildProps.onClick = this.createTwoChains('onClick');
      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
    }
    if (this.isMouseEnterToShow()) {
      newChildProps.onMouseEnter = this.onMouseEnter;
      if (alignPoint) {
        newChildProps.onMouseMove = this.onMouseMove;
      }
    } else {
      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
    }
    if (this.isMouseLeaveToHide()) {
      newChildProps.onMouseLeave = this.onMouseLeave;
    } else {
      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
    }
    if (this.isFocusToShow() || this.isBlurToHide()) {
      newChildProps.onFocus = this.onFocus;
      newChildProps.onBlur = this.onBlur;
    } else {
      newChildProps.onFocus = this.createTwoChains('onFocus');
      newChildProps.onBlur = this.createTwoChains('onBlur');
    }

    var childrenClassName = __WEBPACK_IMPORTED_MODULE_12_classnames___default()(child && child.props && child.props.className, className);
    if (childrenClassName) {
      newChildProps.className = childrenClassName;
    }
    var trigger = __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newChildProps);

    if (!IS_REACT_16) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_rc_util_es_ContainerRender__["a" /* default */],
        {
          parent: this,
          visible: popupVisible,
          autoMount: false,
          forceRender: forceRender,
          getComponent: this.getComponent,
          getContainer: this.getContainer
        },
        function (_ref2) {
          var renderComponent = _ref2.renderComponent;

          _this3.renderComponent = renderComponent;
          return trigger;
        }
      );
    }

    var portal = void 0;
    // prevent unmounting after it's rendered
    if (popupVisible || this._component || forceRender) {
      portal = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_rc_util_es_Portal__["a" /* default */],
        { key: 'portal', getContainer: this.getContainer, didUpdate: this.handlePortalUpdate },
        this.getComponent()
      );
    }

    return [trigger, portal];
  };

  return Trigger;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Trigger.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  action: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string)]),
  showAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  hideAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  getPopupClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  onPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  afterPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]).isRequired,
  popupStyle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupPlacement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  builtinPlacements: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  popupAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  zIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  focusDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  blurDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  getPopupContainer: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getDocument: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  forceRender: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  mask: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskClosable: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onPopupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  defaultPopupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  maskAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  alignPoint: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool // Maybe we can support user pass position in the future
};
Trigger.contextTypes = contextTypes;
Trigger.childContextTypes = contextTypes;
Trigger.defaultProps = {
  prefixCls: 'rc-trigger-popup',
  getPopupClassNameFromAlign: returnEmptyString,
  getDocument: returnDocument,
  onPopupVisibleChange: noop,
  afterPopupVisibleChange: noop,
  onPopupAlign: noop,
  popupClassName: '',
  mouseEnterDelay: 0,
  mouseLeaveDelay: 0.1,
  focusDelay: 0,
  blurDelay: 0.15,
  popupStyle: {},
  destroyPopupOnHide: false,
  popupAlign: {},
  defaultPopupVisible: false,
  mask: false,
  maskClosable: true,
  action: [],
  showAction: [],
  hideAction: []
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onMouseEnter = function (e) {
    var mouseEnterDelay = _this4.props.mouseEnterDelay;

    _this4.fireEvents('onMouseEnter', e);
    _this4.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
  };

  this.onMouseMove = function (e) {
    _this4.fireEvents('onMouseMove', e);
    _this4.setPoint(e);
  };

  this.onMouseLeave = function (e) {
    _this4.fireEvents('onMouseLeave', e);
    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
  };

  this.onPopupMouseEnter = function () {
    _this4.clearDelayTimer();
  };

  this.onPopupMouseLeave = function (e) {
    // https://github.com/react-component/trigger/pull/13
    // react bug?
    if (e.relatedTarget && !e.relatedTarget.setTimeout && _this4._component && _this4._component.getPopupDomNode && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__["a" /* default */])(_this4._component.getPopupDomNode(), e.relatedTarget)) {
      return;
    }
    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
  };

  this.onFocus = function (e) {
    _this4.fireEvents('onFocus', e);
    // incase focusin and focusout
    _this4.clearDelayTimer();
    if (_this4.isFocusToShow()) {
      _this4.focusTime = Date.now();
      _this4.delaySetPopupVisible(true, _this4.props.focusDelay);
    }
  };

  this.onMouseDown = function (e) {
    _this4.fireEvents('onMouseDown', e);
    _this4.preClickTime = Date.now();
  };

  this.onTouchStart = function (e) {
    _this4.fireEvents('onTouchStart', e);
    _this4.preTouchTime = Date.now();
  };

  this.onBlur = function (e) {
    _this4.fireEvents('onBlur', e);
    _this4.clearDelayTimer();
    if (_this4.isBlurToHide()) {
      _this4.delaySetPopupVisible(false, _this4.props.blurDelay);
    }
  };

  this.onContextMenu = function (e) {
    e.preventDefault();
    _this4.fireEvents('onContextMenu', e);
    _this4.setPopupVisible(true, e);
  };

  this.onContextMenuClose = function () {
    if (_this4.isContextMenuToShow()) {
      _this4.close();
    }
  };

  this.onClick = function (event) {
    _this4.fireEvents('onClick', event);
    // focus will trigger click
    if (_this4.focusTime) {
      var preTime = void 0;
      if (_this4.preClickTime && _this4.preTouchTime) {
        preTime = Math.min(_this4.preClickTime, _this4.preTouchTime);
      } else if (_this4.preClickTime) {
        preTime = _this4.preClickTime;
      } else if (_this4.preTouchTime) {
        preTime = _this4.preTouchTime;
      }
      if (Math.abs(preTime - _this4.focusTime) < 20) {
        return;
      }
      _this4.focusTime = 0;
    }
    _this4.preClickTime = 0;
    _this4.preTouchTime = 0;

    // Only prevent default when all the action is click.
    // https://github.com/ant-design/ant-design/issues/17043
    // https://github.com/ant-design/ant-design/issues/17291
    if (_this4.isClickToShow() && (_this4.isClickToHide() || _this4.isBlurToHide()) && event && event.preventDefault) {
      event.preventDefault();
    }
    var nextVisible = !_this4.state.popupVisible;
    if (_this4.isClickToHide() && !nextVisible || nextVisible && _this4.isClickToShow()) {
      _this4.setPopupVisible(!_this4.state.popupVisible, event);
    }
  };

  this.onPopupMouseDown = function () {
    var _context$rcTrigger = _this4.context.rcTrigger,
        rcTrigger = _context$rcTrigger === undefined ? {} : _context$rcTrigger;

    _this4.hasPopupMouseDown = true;

    clearTimeout(_this4.mouseDownTimeout);
    _this4.mouseDownTimeout = setTimeout(function () {
      _this4.hasPopupMouseDown = false;
    }, 0);

    if (rcTrigger.onPopupMouseDown) {
      rcTrigger.onPopupMouseDown.apply(rcTrigger, arguments);
    }
  };

  this.onDocumentClick = function (event) {
    if (_this4.props.mask && !_this4.props.maskClosable) {
      return;
    }

    var target = event.target;
    var root = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4);
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__["a" /* default */])(root, target) && !_this4.hasPopupMouseDown) {
      _this4.close();
    }
  };

  this.getRootDomNode = function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4);
  };

  this.getPopupClassNameFromAlign = function (align) {
    var className = [];
    var _props9 = _this4.props,
        popupPlacement = _props9.popupPlacement,
        builtinPlacements = _props9.builtinPlacements,
        prefixCls = _props9.prefixCls,
        alignPoint = _props9.alignPoint,
        getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;

    if (popupPlacement && builtinPlacements) {
      className.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils__["b" /* getAlignPopupClassName */])(builtinPlacements, prefixCls, align, alignPoint));
    }
    if (getPopupClassNameFromAlign) {
      className.push(getPopupClassNameFromAlign(align));
    }
    return className.join(' ');
  };

  this.getComponent = function () {
    var _props10 = _this4.props,
        prefixCls = _props10.prefixCls,
        destroyPopupOnHide = _props10.destroyPopupOnHide,
        popupClassName = _props10.popupClassName,
        action = _props10.action,
        onPopupAlign = _props10.onPopupAlign,
        popupAnimation = _props10.popupAnimation,
        popupTransitionName = _props10.popupTransitionName,
        popupStyle = _props10.popupStyle,
        mask = _props10.mask,
        maskAnimation = _props10.maskAnimation,
        maskTransitionName = _props10.maskTransitionName,
        zIndex = _props10.zIndex,
        popup = _props10.popup,
        stretch = _props10.stretch,
        alignPoint = _props10.alignPoint;
    var _state = _this4.state,
        popupVisible = _state.popupVisible,
        point = _state.point;


    var align = _this4.getPopupAlign();

    var mouseProps = {};
    if (_this4.isMouseEnterToShow()) {
      mouseProps.onMouseEnter = _this4.onPopupMouseEnter;
    }
    if (_this4.isMouseLeaveToHide()) {
      mouseProps.onMouseLeave = _this4.onPopupMouseLeave;
    }

    mouseProps.onMouseDown = _this4.onPopupMouseDown;
    mouseProps.onTouchStart = _this4.onPopupMouseDown;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_14__Popup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        prefixCls: prefixCls,
        destroyPopupOnHide: destroyPopupOnHide,
        visible: popupVisible,
        point: alignPoint && point,
        className: popupClassName,
        action: action,
        align: align,
        onAlign: onPopupAlign,
        animation: popupAnimation,
        getClassNameFromAlign: _this4.getPopupClassNameFromAlign
      }, mouseProps, {
        stretch: stretch,
        getRootDomNode: _this4.getRootDomNode,
        style: popupStyle,
        mask: mask,
        zIndex: zIndex,
        transitionName: popupTransitionName,
        maskAnimation: maskAnimation,
        maskTransitionName: maskTransitionName,
        ref: _this4.savePopup
      }),
      typeof popup === 'function' ? popup() : popup
    );
  };

  this.getContainer = function () {
    var props = _this4.props;

    var popupContainer = document.createElement('div');
    // Make sure default popup container will never cause scrollbar appearing
    // https://github.com/react-component/trigger/issues/41
    popupContainer.style.position = 'absolute';
    popupContainer.style.top = '0';
    popupContainer.style.left = '0';
    popupContainer.style.width = '100%';
    var mountNode = props.getPopupContainer ? props.getPopupContainer(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4)) : props.getDocument().body;
    mountNode.appendChild(popupContainer);
    return popupContainer;
  };

  this.setPoint = function (point) {
    var alignPoint = _this4.props.alignPoint;

    if (!alignPoint || !point) return;

    _this4.setState({
      point: {
        pageX: point.pageX,
        pageY: point.pageY
      }
    });
  };

  this.handlePortalUpdate = function () {
    if (_this4.state.prevPopupVisible !== _this4.state.popupVisible) {
      _this4.props.afterPopupVisibleChange(_this4.state.popupVisible);
    }
  };

  this.savePopup = function (node) {
    _this4._component = node;
  };
};

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__["polyfill"])(Trigger);

/* harmony default export */ __webpack_exports__["a"] = (Trigger);

/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContainerRender; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }





var ContainerRender = /*#__PURE__*/function (_React$Component) {
  _inherits(ContainerRender, _React$Component);

  var _super = _createSuper(ContainerRender);

  function ContainerRender() {
    var _this;

    _classCallCheck(this, ContainerRender);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.removeContainer = function () {
      if (_this.container) {
        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unmountComponentAtNode(_this.container);

        _this.container.parentNode.removeChild(_this.container);

        _this.container = null;
      }
    };

    _this.renderComponent = function (props, ready) {
      var _this$props = _this.props,
          visible = _this$props.visible,
          getComponent = _this$props.getComponent,
          forceRender = _this$props.forceRender,
          getContainer = _this$props.getContainer,
          parent = _this$props.parent;

      if (visible || parent._component || forceRender) {
        if (!_this.container) {
          _this.container = getContainer();
        }

        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
          if (ready) {
            ready.call(this);
          }
        });
      }
    };

    return _this;
  }

  _createClass(ContainerRender, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.autoDestroy) {
        this.removeContainer();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        renderComponent: this.renderComponent,
        removeContainer: this.removeContainer
      });
    }
  }]);

  return ContainerRender;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContainerRender.propTypes = {
  autoMount: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  autoDestroy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  forceRender: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  parent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
  getComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  getContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
ContainerRender.defaultProps = {
  autoMount: true,
  autoDestroy: true,
  forceRender: false
};


/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Portal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }





var Portal = /*#__PURE__*/function (_React$Component) {
  _inherits(Portal, _React$Component);

  var _super = _createSuper(Portal);

  function Portal() {
    _classCallCheck(this, Portal);

    return _super.apply(this, arguments);
  }

  _createClass(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createContainer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var didUpdate = this.props.didUpdate;

      if (didUpdate) {
        didUpdate(prevProps);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeContainer();
    }
  }, {
    key: "createContainer",
    value: function createContainer() {
      this._container = this.props.getContainer();
      this.forceUpdate();
    }
  }, {
    key: "removeContainer",
    value: function removeContainer() {
      if (this._container) {
        this._container.parentNode.removeChild(this._container);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this._container) {
        return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(this.props.children, this._container);
      }

      return null;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Portal.propTypes = {
  getContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,
  didUpdate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};


/***/ }),
/* 1459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  } // only handle componentWillReceiveProps


  if (typeof prototype.componentWillReceiveProps !== 'function') {
    return Component;
  } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
  // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler


  if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.Profiler) {
    return Component;
  } // Here polyfill get started


  prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
  delete prototype.componentWillReceiveProps;
  return Component;
};

/* harmony default export */ __webpack_exports__["a"] = (unsafeLifecyclesPolyfill);

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

var DateRangePicker = __webpack_require__(1461).default;
var DateRangePickerInput = __webpack_require__(612).default;
var DateRangePickerInputController = __webpack_require__(613).default;
var SingleDatePicker = __webpack_require__(1464).default;
var SingleDatePickerInput = __webpack_require__(616).default;
var DayPicker = __webpack_require__(380).default;
var DayPickerRangeController = __webpack_require__(614).default;
var DayPickerSingleDateController = __webpack_require__(615).default;
var CalendarMonthGrid = __webpack_require__(610).default;
var CalendarMonth = __webpack_require__(609).default;
var CalendarDay = __webpack_require__(608).default;

var DateRangePickerShape = __webpack_require__(618).default;
var SingleDatePickerShape = __webpack_require__(621).default;

var isInclusivelyAfterDay = __webpack_require__(211).default;
var isInclusivelyBeforeDay = __webpack_require__(1468).default;
var isNextDay = __webpack_require__(626).default;
var isSameDay = __webpack_require__(166).default;

var toISODateString = __webpack_require__(167).default;
var toLocalizedDateString = __webpack_require__(382).default;
var toMomentObject = __webpack_require__(168).default;


module.exports = {
  DateRangePicker: DateRangePicker,
  SingleDatePicker: SingleDatePicker,

  DateRangePickerInputController: DateRangePickerInputController,
  DateRangePickerInput: DateRangePickerInput,
  SingleDatePickerInput: SingleDatePickerInput,
  DayPicker: DayPicker,
  DayPickerRangeController: DayPickerRangeController,
  DayPickerSingleDateController: DayPickerSingleDateController,
  CalendarMonthGrid: CalendarMonthGrid,
  CalendarMonth: CalendarMonth,
  CalendarDay: CalendarDay,

  DateRangePickerShape: DateRangePickerShape,
  SingleDatePickerShape: SingleDatePickerShape,

  isInclusivelyAfterDay: isInclusivelyAfterDay,
  isInclusivelyBeforeDay: isInclusivelyBeforeDay,
  isNextDay: isNextDay,
  isSameDay: isSameDay,

  toISODateString: toISODateString,
  toLocalizedDateString: toLocalizedDateString,
  toMomentObject: toMomentObject,
};


/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 65);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(41);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(25);

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(47);

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(55);

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(13);

/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(152);

/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function () {
      function render() {
        return _react2["default"].createElement(
          "svg",
          _extends({ viewBox: "0 0 12 12" }, this.props),
          _react2["default"].createElement("path", { fillRule: "evenodd", d: "M11.53.47a.75.75 0 0 0-1.061 0l-4.47 4.47L1.529.47A.75.75 0 1 0 .468 1.531l4.47 4.47-4.47 4.47a.75.75 0 1 0 1.061 1.061l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.061-1.061l-4.47-4.47 4.47-4.47a.75.75 0 0 0 0-1.061z" })
        );
      }

      return render;
    }()
  }]);

  return SVG;
}(_react2["default"].Component);

exports["default"] = SVG;

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(207);

/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(211);

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(268);

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(229);

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(623);

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(54);

/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(650);

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(618);

/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(613);

/***/ }),
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(614);

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(39);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactAddonsShallowCompare = __webpack_require__(14);

var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);

var _moment = __webpack_require__(7);

var _moment2 = _interopRequireDefault(_moment);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactPortal = __webpack_require__(40);

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _airbnbPropTypes = __webpack_require__(1);

var _consolidatedEvents = __webpack_require__(18);

var _isTouchDevice = __webpack_require__(9);

var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);

var _defaultPhrases = __webpack_require__(3);

var _OutsideClickHandler = __webpack_require__(17);

var _OutsideClickHandler2 = _interopRequireDefault(_OutsideClickHandler);

var _getResponsiveContainerStyles = __webpack_require__(29);

var _getResponsiveContainerStyles2 = _interopRequireDefault(_getResponsiveContainerStyles);

var _isInclusivelyAfterDay = __webpack_require__(16);

var _isInclusivelyAfterDay2 = _interopRequireDefault(_isInclusivelyAfterDay);

var _DateRangePickerInputController = __webpack_require__(55);

var _DateRangePickerInputController2 = _interopRequireDefault(_DateRangePickerInputController);

var _DayPickerRangeController = __webpack_require__(58);

var _DayPickerRangeController2 = _interopRequireDefault(_DayPickerRangeController);

var _close = __webpack_require__(11);

var _close2 = _interopRequireDefault(_close);

var _DateRangePickerShape = __webpack_require__(43);

var _DateRangePickerShape2 = _interopRequireDefault(_DateRangePickerShape);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(_DateRangePickerShape2['default']);

var defaultProps = {
  // required props for a functional interactive DateRangePicker
  startDate: null,
  endDate: null,
  focusedInput: null,

  // input related props
  startDateId: _constants.START_DATE,
  startDatePlaceholderText: 'Start Date',
  endDateId: _constants.END_DATE,
  endDatePlaceholderText: 'End Date',
  disabled: false,
  required: false,
  readOnly: false,
  screenReaderInputMessage: '',
  showClearDates: false,
  showDefaultInputIcon: false,
  inputIconPosition: _constants.ICON_BEFORE_POSITION,
  customInputIcon: null,
  customArrowIcon: null,
  customCloseIcon: null,

  // calendar presentation and interaction related props
  renderMonth: null,
  orientation: _constants.HORIZONTAL_ORIENTATION,
  anchorDirection: _constants.ANCHOR_LEFT,
  openDirection: _constants.OPEN_DOWN,
  horizontalMargin: 0,
  withPortal: false,
  withFullScreenPortal: false,
  initialVisibleMonth: null,
  numberOfMonths: 2,
  keepOpenOnDateSelect: false,
  reopenPickerOnClearDates: false,
  renderCalendarInfo: null,
  hideKeyboardShortcutsPanel: false,
  daySize: _constants.DAY_SIZE,
  isRTL: false,
  firstDayOfWeek: null,

  // navigation related props
  navPrev: null,
  navNext: null,

  onPrevMonthClick: function () {
    function onPrevMonthClick() {}

    return onPrevMonthClick;
  }(),
  onNextMonthClick: function () {
    function onNextMonthClick() {}

    return onNextMonthClick;
  }(),
  onClose: function () {
    function onClose() {}

    return onClose;
  }(),

  // day presentation and interaction related props
  renderDay: null,
  minimumNights: 1,
  enableOutsideDays: false,
  isDayBlocked: function () {
    function isDayBlocked() {
      return false;
    }

    return isDayBlocked;
  }(),
  isOutsideRange: function () {
    function isOutsideRange(day) {
      return !(0, _isInclusivelyAfterDay2['default'])(day, (0, _moment2['default'])());
    }

    return isOutsideRange;
  }(),
  isDayHighlighted: function () {
    function isDayHighlighted() {
      return false;
    }

    return isDayHighlighted;
  }(),

  // internationalization
  displayFormat: function () {
    function displayFormat() {
      return _moment2['default'].localeData().longDateFormat('L');
    }

    return displayFormat;
  }(),
  monthFormat: 'MMMM YYYY',
  weekDayFormat: 'dd',
  phrases: _defaultPhrases.DateRangePickerPhrases
};

var DateRangePicker = function (_React$Component) {
  _inherits(DateRangePicker, _React$Component);

  function DateRangePicker(props) {
    _classCallCheck(this, DateRangePicker);

    var _this = _possibleConstructorReturn(this, (DateRangePicker.__proto__ || Object.getPrototypeOf(DateRangePicker)).call(this, props));

    _this.state = {
      dayPickerContainerStyles: {},
      isDateRangePickerInputFocused: false,
      isDayPickerFocused: false,
      showKeyboardShortcuts: false
    };

    _this.isTouchDevice = false;

    _this.onOutsideClick = _this.onOutsideClick.bind(_this);
    _this.onDateRangePickerInputFocus = _this.onDateRangePickerInputFocus.bind(_this);
    _this.onDayPickerFocus = _this.onDayPickerFocus.bind(_this);
    _this.onDayPickerBlur = _this.onDayPickerBlur.bind(_this);
    _this.showKeyboardShortcutsPanel = _this.showKeyboardShortcutsPanel.bind(_this);

    _this.responsivizePickerPosition = _this.responsivizePickerPosition.bind(_this);

    _this.setDayPickerContainerRef = _this.setDayPickerContainerRef.bind(_this);
    _this.setDayPickerRef = _this.setDayPickerRef.bind(_this);
    return _this;
  }

  _createClass(DateRangePicker, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        this.resizeHandle = (0, _consolidatedEvents.addEventListener)(window, 'resize', this.responsivizePickerPosition, { passive: true });
        this.responsivizePickerPosition();

        if (this.props.focusedInput) {
          this.setState({
            isDateRangePickerInputFocused: true
          });
        }

        this.isTouchDevice = (0, _isTouchDevice2['default'])();
      }

      return componentDidMount;
    }()
  }, {
    key: 'shouldComponentUpdate',
    value: function () {
      function shouldComponentUpdate(nextProps, nextState) {
        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
      }

      return shouldComponentUpdate;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps) {
        if (!prevProps.focusedInput && this.props.focusedInput && this.isOpened()) {
          // The date picker just changed from being closed to being open.
          this.responsivizePickerPosition();
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        if (this.resizeHandle) (0, _consolidatedEvents.removeEventListener)(this.resizeHandle);
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'onOutsideClick',
    value: function () {
      function onOutsideClick() {
        var _props = this.props,
            onFocusChange = _props.onFocusChange,
            onClose = _props.onClose,
            startDate = _props.startDate,
            endDate = _props.endDate;

        if (!this.isOpened()) return;

        this.setState({
          isDateRangePickerInputFocused: false,
          isDayPickerFocused: false,
          showKeyboardShortcuts: false
        });

        onFocusChange(null);
        onClose({ startDate: startDate, endDate: endDate });
      }

      return onOutsideClick;
    }()
  }, {
    key: 'onDateRangePickerInputFocus',
    value: function () {
      function onDateRangePickerInputFocus(focusedInput) {
        var _props2 = this.props,
            onFocusChange = _props2.onFocusChange,
            withPortal = _props2.withPortal,
            withFullScreenPortal = _props2.withFullScreenPortal;

        if (focusedInput) {
          var moveFocusToDayPicker = withPortal || withFullScreenPortal || this.isTouchDevice;
          if (moveFocusToDayPicker) {
            this.onDayPickerFocus();
          } else {
            this.onDayPickerBlur();
          }
        }

        onFocusChange(focusedInput);
      }

      return onDateRangePickerInputFocus;
    }()
  }, {
    key: 'onDayPickerFocus',
    value: function () {
      function onDayPickerFocus() {
        var _props3 = this.props,
            focusedInput = _props3.focusedInput,
            onFocusChange = _props3.onFocusChange;

        if (!focusedInput) onFocusChange(_constants.START_DATE);

        this.setState({
          isDateRangePickerInputFocused: false,
          isDayPickerFocused: true,
          showKeyboardShortcuts: false
        });
      }

      return onDayPickerFocus;
    }()
  }, {
    key: 'onDayPickerBlur',
    value: function () {
      function onDayPickerBlur() {
        this.setState({
          isDateRangePickerInputFocused: true,
          isDayPickerFocused: false,
          showKeyboardShortcuts: false
        });
      }

      return onDayPickerBlur;
    }()
  }, {
    key: 'getDayPickerContainerClasses',
    value: function () {
      function getDayPickerContainerClasses() {
        var _props4 = this.props,
            orientation = _props4.orientation,
            withPortal = _props4.withPortal,
            withFullScreenPortal = _props4.withFullScreenPortal,
            anchorDirection = _props4.anchorDirection,
            openDirection = _props4.openDirection,
            isRTL = _props4.isRTL;

        var dayPickerClassName = (0, _classnames2['default'])('DateRangePicker__picker', {
          'DateRangePicker__picker--direction-left': anchorDirection === _constants.ANCHOR_LEFT,
          'DateRangePicker__picker--direction-right': anchorDirection === _constants.ANCHOR_RIGHT,
          'DateRangePicker__picker--open-down': openDirection === _constants.OPEN_DOWN,
          'DateRangePicker__picker--open-up': openDirection === _constants.OPEN_UP,
          'DateRangePicker__picker--horizontal': orientation === _constants.HORIZONTAL_ORIENTATION,
          'DateRangePicker__picker--vertical': orientation === _constants.VERTICAL_ORIENTATION,
          'DateRangePicker__picker--portal': withPortal || withFullScreenPortal,
          'DateRangePicker__picker--full-screen-portal': withFullScreenPortal,
          'DateRangePicker__picker--rtl': isRTL
        });

        return dayPickerClassName;
      }

      return getDayPickerContainerClasses;
    }()
  }, {
    key: 'getDayPickerDOMNode',
    value: function () {
      function getDayPickerDOMNode() {
        return _reactDom2['default'].findDOMNode(this.dayPicker); // eslint-disable-line react/no-find-dom-node
      }

      return getDayPickerDOMNode;
    }()
  }, {
    key: 'setDayPickerContainerRef',
    value: function () {
      function setDayPickerContainerRef(ref) {
        this.dayPickerContainer = ref;
      }

      return setDayPickerContainerRef;
    }()
  }, {
    key: 'setDayPickerRef',
    value: function () {
      function setDayPickerRef(ref) {
        this.dayPicker = ref;
      }

      return setDayPickerRef;
    }()
  }, {
    key: 'isOpened',
    value: function () {
      function isOpened() {
        var focusedInput = this.props.focusedInput;

        return focusedInput === _constants.START_DATE || focusedInput === _constants.END_DATE;
      }

      return isOpened;
    }()
  }, {
    key: 'responsivizePickerPosition',
    value: function () {
      function responsivizePickerPosition() {
        // It's possible the portal props have been changed in response to window resizes
        // So let's ensure we reset this back to the base state each time
        this.setState({ dayPickerContainerStyles: {} });

        if (!this.isOpened()) {
          return;
        }

        var _props5 = this.props,
            anchorDirection = _props5.anchorDirection,
            horizontalMargin = _props5.horizontalMargin,
            withPortal = _props5.withPortal,
            withFullScreenPortal = _props5.withFullScreenPortal;
        var dayPickerContainerStyles = this.state.dayPickerContainerStyles;

        var isAnchoredLeft = anchorDirection === _constants.ANCHOR_LEFT;
        if (!withPortal && !withFullScreenPortal) {
          var containerRect = this.dayPickerContainer.getBoundingClientRect();
          var currentOffset = dayPickerContainerStyles[anchorDirection] || 0;
          var containerEdge = isAnchoredLeft ? containerRect[_constants.ANCHOR_RIGHT] : containerRect[_constants.ANCHOR_LEFT];

          this.setState({
            dayPickerContainerStyles: (0, _getResponsiveContainerStyles2['default'])(anchorDirection, currentOffset, containerEdge, horizontalMargin)
          });
        }
      }

      return responsivizePickerPosition;
    }()
  }, {
    key: 'showKeyboardShortcutsPanel',
    value: function () {
      function showKeyboardShortcutsPanel() {
        this.setState({
          isDateRangePickerInputFocused: false,
          isDayPickerFocused: true,
          showKeyboardShortcuts: true
        });
      }

      return showKeyboardShortcutsPanel;
    }()
  }, {
    key: 'maybeRenderDayPickerWithPortal',
    value: function () {
      function maybeRenderDayPickerWithPortal() {
        var _props6 = this.props,
            withPortal = _props6.withPortal,
            withFullScreenPortal = _props6.withFullScreenPortal;

        if (!this.isOpened()) {
          return null;
        }

        if (withPortal || withFullScreenPortal) {
          return _react2['default'].createElement(_reactPortal2['default'], { isOpened: true }, this.renderDayPicker());
        }

        return this.renderDayPicker();
      }

      return maybeRenderDayPickerWithPortal;
    }()
  }, {
    key: 'renderDayPicker',
    value: function () {
      function renderDayPicker() {
        var _props7 = this.props,
            isDayBlocked = _props7.isDayBlocked,
            isDayHighlighted = _props7.isDayHighlighted,
            isOutsideRange = _props7.isOutsideRange,
            numberOfMonths = _props7.numberOfMonths,
            orientation = _props7.orientation,
            monthFormat = _props7.monthFormat,
            renderMonth = _props7.renderMonth,
            navPrev = _props7.navPrev,
            navNext = _props7.navNext,
            onPrevMonthClick = _props7.onPrevMonthClick,
            onNextMonthClick = _props7.onNextMonthClick,
            onDatesChange = _props7.onDatesChange,
            onFocusChange = _props7.onFocusChange,
            withPortal = _props7.withPortal,
            withFullScreenPortal = _props7.withFullScreenPortal,
            daySize = _props7.daySize,
            enableOutsideDays = _props7.enableOutsideDays,
            focusedInput = _props7.focusedInput,
            startDate = _props7.startDate,
            endDate = _props7.endDate,
            minimumNights = _props7.minimumNights,
            keepOpenOnDateSelect = _props7.keepOpenOnDateSelect,
            renderDay = _props7.renderDay,
            renderCalendarInfo = _props7.renderCalendarInfo,
            firstDayOfWeek = _props7.firstDayOfWeek,
            initialVisibleMonth = _props7.initialVisibleMonth,
            hideKeyboardShortcutsPanel = _props7.hideKeyboardShortcutsPanel,
            customCloseIcon = _props7.customCloseIcon,
            onClose = _props7.onClose,
            phrases = _props7.phrases,
            isRTL = _props7.isRTL,
            weekDayFormat = _props7.weekDayFormat;
        var _state = this.state,
            dayPickerContainerStyles = _state.dayPickerContainerStyles,
            isDayPickerFocused = _state.isDayPickerFocused,
            showKeyboardShortcuts = _state.showKeyboardShortcuts;

        var onOutsideClick = !withFullScreenPortal && withPortal ? this.onOutsideClick : undefined;
        var initialVisibleMonthThunk = initialVisibleMonth || function () {
          return startDate || endDate || (0, _moment2['default'])();
        };

        var closeIcon = customCloseIcon || _react2['default'].createElement(_close2['default'], null);

        return _react2['default'].createElement('div', { // eslint-disable-line jsx-a11y/no-static-element-interactions
          ref: this.setDayPickerContainerRef,
          className: this.getDayPickerContainerClasses(),
          style: dayPickerContainerStyles,
          onClick: onOutsideClick
        }, _react2['default'].createElement(_DayPickerRangeController2['default'], {
          ref: this.setDayPickerRef,
          orientation: orientation,
          enableOutsideDays: enableOutsideDays,
          numberOfMonths: numberOfMonths,
          onPrevMonthClick: onPrevMonthClick,
          onNextMonthClick: onNextMonthClick,
          onDatesChange: onDatesChange,
          onFocusChange: onFocusChange,
          onClose: onClose,
          focusedInput: focusedInput,
          startDate: startDate,
          endDate: endDate,
          monthFormat: monthFormat,
          renderMonth: renderMonth,
          withPortal: withPortal || withFullScreenPortal,
          daySize: daySize,
          initialVisibleMonth: initialVisibleMonthThunk,
          hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
          navPrev: navPrev,
          navNext: navNext,
          minimumNights: minimumNights,
          isOutsideRange: isOutsideRange,
          isDayHighlighted: isDayHighlighted,
          isDayBlocked: isDayBlocked,
          keepOpenOnDateSelect: keepOpenOnDateSelect,
          renderDay: renderDay,
          renderCalendarInfo: renderCalendarInfo,
          isFocused: isDayPickerFocused,
          showKeyboardShortcuts: showKeyboardShortcuts,
          onBlur: this.onDayPickerBlur,
          phrases: phrases,
          isRTL: isRTL,
          firstDayOfWeek: firstDayOfWeek,
          weekDayFormat: weekDayFormat
        }), withFullScreenPortal && _react2['default'].createElement('button', {
          className: 'DateRangePicker__close',
          type: 'button',
          onClick: this.onOutsideClick,
          'aria-label': phrases.closeDatePicker
        }, _react2['default'].createElement('div', { className: 'DateRangePicker__close' }, closeIcon)));
      }

      return renderDayPicker;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props8 = this.props,
            startDate = _props8.startDate,
            startDateId = _props8.startDateId,
            startDatePlaceholderText = _props8.startDatePlaceholderText,
            endDate = _props8.endDate,
            endDateId = _props8.endDateId,
            endDatePlaceholderText = _props8.endDatePlaceholderText,
            focusedInput = _props8.focusedInput,
            screenReaderInputMessage = _props8.screenReaderInputMessage,
            showClearDates = _props8.showClearDates,
            showDefaultInputIcon = _props8.showDefaultInputIcon,
            inputIconPosition = _props8.inputIconPosition,
            customInputIcon = _props8.customInputIcon,
            customArrowIcon = _props8.customArrowIcon,
            customCloseIcon = _props8.customCloseIcon,
            disabled = _props8.disabled,
            required = _props8.required,
            readOnly = _props8.readOnly,
            openDirection = _props8.openDirection,
            phrases = _props8.phrases,
            isOutsideRange = _props8.isOutsideRange,
            minimumNights = _props8.minimumNights,
            withPortal = _props8.withPortal,
            withFullScreenPortal = _props8.withFullScreenPortal,
            displayFormat = _props8.displayFormat,
            reopenPickerOnClearDates = _props8.reopenPickerOnClearDates,
            keepOpenOnDateSelect = _props8.keepOpenOnDateSelect,
            onDatesChange = _props8.onDatesChange,
            onClose = _props8.onClose,
            isRTL = _props8.isRTL;
        var isDateRangePickerInputFocused = this.state.isDateRangePickerInputFocused;

        var onOutsideClick = !withPortal && !withFullScreenPortal ? this.onOutsideClick : undefined;

        return _react2['default'].createElement('div', { className: 'DateRangePicker' }, _react2['default'].createElement(_OutsideClickHandler2['default'], { onOutsideClick: onOutsideClick }, _react2['default'].createElement(_DateRangePickerInputController2['default'], {
          startDate: startDate,
          startDateId: startDateId,
          startDatePlaceholderText: startDatePlaceholderText,
          isStartDateFocused: focusedInput === _constants.START_DATE,
          endDate: endDate,
          endDateId: endDateId,
          endDatePlaceholderText: endDatePlaceholderText,
          isEndDateFocused: focusedInput === _constants.END_DATE,
          displayFormat: displayFormat,
          showClearDates: showClearDates,
          showCaret: !withPortal && !withFullScreenPortal,
          showDefaultInputIcon: showDefaultInputIcon,
          inputIconPosition: inputIconPosition,
          customInputIcon: customInputIcon,
          customArrowIcon: customArrowIcon,
          customCloseIcon: customCloseIcon,
          disabled: disabled,
          required: required,
          readOnly: readOnly,
          openDirection: openDirection,
          reopenPickerOnClearDates: reopenPickerOnClearDates,
          keepOpenOnDateSelect: keepOpenOnDateSelect,
          isOutsideRange: isOutsideRange,
          minimumNights: minimumNights,
          withFullScreenPortal: withFullScreenPortal,
          onDatesChange: onDatesChange,
          onFocusChange: this.onDateRangePickerInputFocus,
          onArrowDown: this.onDayPickerFocus,
          onQuestionMark: this.showKeyboardShortcutsPanel,
          onClose: onClose,
          phrases: phrases,
          screenReaderMessage: screenReaderInputMessage,
          isFocused: isDateRangePickerInputFocused,
          isRTL: isRTL
        }), this.maybeRenderDayPickerWithPortal()));
      }

      return render;
    }()
  }]);

  return DateRangePicker;
}(_react2['default'].Component);

exports['default'] = DateRangePicker;

DateRangePicker.propTypes = propTypes;
DateRangePicker.defaultProps = defaultProps;

/***/ })
/******/ ]);

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 69);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __webpack_require__(41);

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function () {
      function render() {
        return _react2["default"].createElement(
          "svg",
          _extends({ viewBox: "0 0 12 12" }, this.props),
          _react2["default"].createElement("path", { fillRule: "evenodd", d: "M11.53.47a.75.75 0 0 0-1.061 0l-4.47 4.47L1.529.47A.75.75 0 1 0 .468 1.531l4.47 4.47-4.47 4.47a.75.75 0 1 0 1.061 1.061l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.061-1.061l-4.47-4.47 4.47-4.47a.75.75 0 0 0 0-1.061z" })
        );
      }

      return render;
    }()
  }]);

  return SVG;
}(_react2["default"].Component);

exports["default"] = SVG;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __webpack_require__(47);

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __webpack_require__(8);

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __webpack_require__(59);

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = __webpack_require__(55);

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BOTTOM_RIGHT = exports.TOP_RIGHT = exports.TOP_LEFT = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

exports.KeyboardShortcutRow = KeyboardShortcutRow;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _airbnbPropTypes = __webpack_require__(1);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _defaultPhrases = __webpack_require__(3);

var _getPhrasePropTypes = __webpack_require__(5);

var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);

var _close = __webpack_require__(11);

var _close2 = _interopRequireDefault(_close);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var TOP_LEFT = exports.TOP_LEFT = 'top-left';
var TOP_RIGHT = exports.TOP_RIGHT = 'top-right';
var BOTTOM_RIGHT = exports.BOTTOM_RIGHT = 'bottom-right';

var propTypes = {
  block: _propTypes2['default'].bool,
  buttonLocation: _propTypes2['default'].oneOf([TOP_LEFT, TOP_RIGHT, BOTTOM_RIGHT]),
  showKeyboardShortcutsPanel: _propTypes2['default'].bool,
  openKeyboardShortcutsPanel: _propTypes2['default'].func,
  closeKeyboardShortcutsPanel: _propTypes2['default'].func,
  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DayPickerKeyboardShortcutsPhrases))
};

var defaultProps = {
  block: false,
  buttonLocation: BOTTOM_RIGHT,
  showKeyboardShortcutsPanel: false,
  openKeyboardShortcutsPanel: function () {
    function openKeyboardShortcutsPanel() {}

    return openKeyboardShortcutsPanel;
  }(),
  closeKeyboardShortcutsPanel: function () {
    function closeKeyboardShortcutsPanel() {}

    return closeKeyboardShortcutsPanel;
  }(),

  phrases: _defaultPhrases.DayPickerKeyboardShortcutsPhrases
};

function KeyboardShortcutRow(_ref) {
  var unicode = _ref.unicode,
      label = _ref.label,
      action = _ref.action;

  return _react2['default'].createElement('li', { className: 'KeyboardShortcutRow' }, _react2['default'].createElement('div', {
    className: 'KeyboardShortcutRow__key-container'
  }, _react2['default'].createElement('span', {
    className: 'KeyboardShortcutRow__key',
    role: 'img',
    'aria-label': label
  }, unicode)), _react2['default'].createElement('div', { className: 'KeyboardShortcutRow__action' }, action));
}

KeyboardShortcutRow.propTypes = {
  unicode: _propTypes2['default'].string.isRequired,
  label: _propTypes2['default'].string.isRequired,
  action: _propTypes2['default'].string.isRequired
};

var DayPickerKeyboardShortcuts = function (_React$Component) {
  _inherits(DayPickerKeyboardShortcuts, _React$Component);

  function DayPickerKeyboardShortcuts() {
    var _ref2;

    _classCallCheck(this, DayPickerKeyboardShortcuts);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref2 = DayPickerKeyboardShortcuts.__proto__ || Object.getPrototypeOf(DayPickerKeyboardShortcuts)).call.apply(_ref2, [this].concat(args)));

    _this.onClick = _this.onClick.bind(_this);
    _this.setShowKeyboardShortcutsButtonRef = _this.setShowKeyboardShortcutsButtonRef.bind(_this);
    return _this;
  }

  _createClass(DayPickerKeyboardShortcuts, [{
    key: 'onClick',
    value: function () {
      function onClick() {
        var _this2 = this;

        var openKeyboardShortcutsPanel = this.props.openKeyboardShortcutsPanel;

        // we want to return focus to this button after closing the keyboard shortcuts panel

        openKeyboardShortcutsPanel(function () {
          _this2.showKeyboardShortcutsButton.focus();
        });
      }

      return onClick;
    }()
  }, {
    key: 'setShowKeyboardShortcutsButtonRef',
    value: function () {
      function setShowKeyboardShortcutsButtonRef(ref) {
        this.showKeyboardShortcutsButton = ref;
      }

      return setShowKeyboardShortcutsButtonRef;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            block = _props.block,
            buttonLocation = _props.buttonLocation,
            showKeyboardShortcutsPanel = _props.showKeyboardShortcutsPanel,
            closeKeyboardShortcutsPanel = _props.closeKeyboardShortcutsPanel,
            phrases = _props.phrases;

        var keyboardShortcuts = [{
          unicode: '↵',
          label: phrases.enterKey,
          action: phrases.selectFocusedDate
        }, {
          unicode: '←/→',
          label: phrases.leftArrowRightArrow,
          action: phrases.moveFocusByOneDay
        }, {
          unicode: '↑/↓',
          label: phrases.upArrowDownArrow,
          action: phrases.moveFocusByOneWeek
        }, {
          unicode: 'PgUp/PgDn',
          label: phrases.pageUpPageDown,
          action: phrases.moveFocusByOneMonth
        }, {
          unicode: 'Home/End',
          label: phrases.homeEnd,
          action: phrases.moveFocustoStartAndEndOfWeek
        }, {
          unicode: 'Esc',
          label: phrases.escape,
          action: phrases.returnFocusToInput
        }, {
          unicode: '?',
          label: phrases.questionMark,
          action: phrases.openThisPanel
        }];

        var toggleButtonText = showKeyboardShortcutsPanel ? phrases.hideKeyboardShortcutsPanel : phrases.showKeyboardShortcutsPanel;

        return _react2['default'].createElement('div', null, _react2['default'].createElement('button', {
          ref: this.setShowKeyboardShortcutsButtonRef,
          className: (0, _classnames2['default'])('DayPickerKeyboardShortcuts__show', {
            'DayPickerKeyboardShortcuts__show--bottom-right': buttonLocation === BOTTOM_RIGHT,
            'DayPickerKeyboardShortcuts__show--top-right': buttonLocation === TOP_RIGHT,
            'DayPickerKeyboardShortcuts__show--top-left': buttonLocation === TOP_LEFT
          }),
          type: 'button',
          'aria-label': toggleButtonText,
          onClick: this.onClick,
          onMouseUp: function () {
            function onMouseUp(e) {
              e.currentTarget.blur();
            }

            return onMouseUp;
          }()
        }, _react2['default'].createElement('span', { className: 'DayPickerKeyboardShortcuts__show_span' }, '?')), showKeyboardShortcutsPanel && _react2['default'].createElement('div', {
          className: (0, _classnames2['default'])('DayPickerKeyboardShortcuts__panel', {
            'DayPickerKeyboardShortcuts__panel--block': block
          }),
          role: 'dialog',
          'aria-labelledby': 'DayPickerKeyboardShortcuts__title'
        }, _react2['default'].createElement('div', {
          id: 'DayPickerKeyboardShortcuts__title',
          className: 'DayPickerKeyboardShortcuts__title'
        }, phrases.keyboardShortcuts), _react2['default'].createElement('button', {
          className: 'DayPickerKeyboardShortcuts__close',
          type: 'button',
          'aria-label': phrases.hideKeyboardShortcutsPanel,
          onClick: closeKeyboardShortcutsPanel,
          onKeyDown: function () {
            function onKeyDown(e) {
              // Because the close button is the only focusable element inside of the panel, this
              // amount to a very basic focus trap. The user can exit the panel by "pressing" the
              // close button or hitting escape
              if (e.key === 'Tab') {
                e.preventDefault();
              }
            }

            return onKeyDown;
          }()
        }, _react2['default'].createElement(_close2['default'], null)), _react2['default'].createElement('ul', { className: 'DayPickerKeyboardShortcuts__list' }, keyboardShortcuts.map(function (_ref3) {
          var unicode = _ref3.unicode,
              label = _ref3.label,
              action = _ref3.action;
          return _react2['default'].createElement(KeyboardShortcutRow, { key: label, unicode: unicode, label: label, action: action });
        }))));
      }

      return render;
    }()
  }]);

  return DayPickerKeyboardShortcuts;
}(_react2['default'].Component);

exports['default'] = DayPickerKeyboardShortcuts;

DayPickerKeyboardShortcuts.propTypes = (0, _airbnbPropTypes.forbidExtraProps)(propTypes);
DayPickerKeyboardShortcuts.defaultProps = defaultProps;

/***/ })

/******/ });

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 70);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __webpack_require__(41);

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __webpack_require__(25);

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function () {
      function render() {
        return _react2["default"].createElement(
          "svg",
          _extends({ viewBox: "0 0 1000 1000" }, this.props),
          _react2["default"].createElement("path", { d: "M336.2 274.5l-210.1 210h805.4c13 0 23 10 23 23s-10 23-23 23H126.1l210.1 210.1c11 11 11 21 0 32-5 5-10 7-16 7s-11-2-16-7l-249.1-249c-11-11-11-21 0-32l249.1-249.1c21-21.1 53 10.9 32 32z" })
        );
      }

      return render;
    }()
  }]);

  return SVG;
}(_react2["default"].Component);

exports["default"] = SVG;

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function () {
      function render() {
        return _react2["default"].createElement(
          "svg",
          _extends({ viewBox: "0 0 1000 1000" }, this.props),
          _react2["default"].createElement("path", { d: "M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z" })
        );
      }

      return render;
    }()
  }]);

  return SVG;
}(_react2["default"].Component);

exports["default"] = SVG;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __webpack_require__(47);

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __webpack_require__(8);

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function () {
      function render() {
        return _react2["default"].createElement(
          "svg",
          _extends({ viewBox: "0 0 1000 1000" }, this.props),
          _react2["default"].createElement("path", { d: "M967.5 288.5L514.3 740.7c-11 11-21 11-32 0L29.1 288.5c-4-5-6-11-6-16 0-13 10-23 23-23 6 0 11 2 15 7l437.2 436.2 437.2-436.2c4-5 9-7 16-7 6 0 11 2 16 7 9 10.9 9 21 0 32z" })
        );
      }

      return render;
    }()
  }]);

  return SVG;
}(_react2["default"].Component);

exports["default"] = SVG;

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function () {
      function render() {
        return _react2["default"].createElement(
          "svg",
          _extends({ viewBox: "0 0 1000 1000" }, this.props),
          _react2["default"].createElement("path", { d: "M32.1 712.6l453.2-452.2c11-11 21-11 32 0l453.2 452.2c4 5 6 10 6 16 0 13-10 23-22 23-7 0-12-2-16-7L501.3 308.5 64.1 744.7c-4 5-9 7-15 7-7 0-12-2-17-7-9-11-9-21 0-32.1z" })
        );
      }

      return render;
    }()
  }]);

  return SVG;
}(_react2["default"].Component);

exports["default"] = SVG;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __webpack_require__(59);

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = __webpack_require__(55);

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = DayPickerNavigation;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _airbnbPropTypes = __webpack_require__(1);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _defaultPhrases = __webpack_require__(3);

var _getPhrasePropTypes = __webpack_require__(5);

var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);

var _arrowLeft = __webpack_require__(25);

var _arrowLeft2 = _interopRequireDefault(_arrowLeft);

var _arrowRight = __webpack_require__(26);

var _arrowRight2 = _interopRequireDefault(_arrowRight);

var _chevronUp = __webpack_require__(42);

var _chevronUp2 = _interopRequireDefault(_chevronUp);

var _chevronDown = __webpack_require__(41);

var _chevronDown2 = _interopRequireDefault(_chevronDown);

var _ScrollableOrientationShape = __webpack_require__(8);

var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
  navPrev: _propTypes2['default'].node,
  navNext: _propTypes2['default'].node,
  orientation: _ScrollableOrientationShape2['default'],

  onPrevMonthClick: _propTypes2['default'].func,
  onNextMonthClick: _propTypes2['default'].func,

  // internationalization
  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DayPickerNavigationPhrases)),

  isRTL: _propTypes2['default'].bool
});

var defaultProps = {
  navPrev: null,
  navNext: null,
  orientation: _constants.HORIZONTAL_ORIENTATION,

  onPrevMonthClick: function () {
    function onPrevMonthClick() {}

    return onPrevMonthClick;
  }(),
  onNextMonthClick: function () {
    function onNextMonthClick() {}

    return onNextMonthClick;
  }(),

  // internationalization
  phrases: _defaultPhrases.DayPickerNavigationPhrases,
  isRTL: false
};

function DayPickerNavigation(props) {
  var navPrev = props.navPrev,
      navNext = props.navNext,
      onPrevMonthClick = props.onPrevMonthClick,
      onNextMonthClick = props.onNextMonthClick,
      orientation = props.orientation,
      phrases = props.phrases,
      isRTL = props.isRTL;

  var isVertical = orientation !== _constants.HORIZONTAL_ORIENTATION;
  var isVerticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;

  var navPrevIcon = navPrev;
  var navNextIcon = navNext;
  var isDefaultNavPrev = false;
  var isDefaultNavNext = false;
  if (!navPrevIcon) {
    isDefaultNavPrev = true;
    navPrevIcon = isVertical ? _react2['default'].createElement(_chevronUp2['default'], null) : _react2['default'].createElement(_arrowLeft2['default'], null);
    if (isRTL && !isVertical) {
      navPrevIcon = _react2['default'].createElement(_arrowRight2['default'], null);
    }
  }
  if (!navNextIcon) {
    isDefaultNavNext = true;
    navNextIcon = isVertical ? _react2['default'].createElement(_chevronDown2['default'], null) : _react2['default'].createElement(_arrowRight2['default'], null);
    if (isRTL && !isVertical) {
      navNextIcon = _react2['default'].createElement(_arrowLeft2['default'], null);
    }
  }

  var navClassNames = (0, _classnames2['default'])('DayPickerNavigation', {
    'DayPickerNavigation--horizontal': !isVertical,
    'DayPickerNavigation--vertical': isVertical,
    'DayPickerNavigation--vertical-scrollable': isVerticalScrollable
  });
  var prevClassNames = (0, _classnames2['default'])('DayPickerNavigation__prev', {
    'DayPickerNavigation__prev--default': isDefaultNavPrev,
    'DayPickerNavigation__prev--rtl': isRTL
  });
  var nextClassNames = (0, _classnames2['default'])('DayPickerNavigation__next', {
    'DayPickerNavigation__next--default': isDefaultNavNext,
    'DayPickerNavigation__next--rtl': isRTL
  });

  return _react2['default'].createElement('div', { className: navClassNames }, !isVerticalScrollable && _react2['default'].createElement('button', {
    type: 'button',
    'aria-label': phrases.jumpToPrevMonth,
    className: prevClassNames,
    onClick: onPrevMonthClick,
    onMouseUp: function () {
      function onMouseUp(e) {
        e.currentTarget.blur();
      }

      return onMouseUp;
    }()
  }, navPrevIcon), _react2['default'].createElement('button', {
    type: 'button',
    'aria-label': phrases.jumpToNextMonth,
    className: nextClassNames,
    onClick: onNextMonthClick,
    onMouseUp: function () {
      function onMouseUp(e) {
        e.currentTarget.blur();
      }

      return onMouseUp;
    }()
  }, navNextIcon));
}

DayPickerNavigation.propTypes = propTypes;
DayPickerNavigation.defaultProps = defaultProps;

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = __webpack_require__(165);

/***/ })

/******/ });

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 74);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __webpack_require__(41);

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function () {
      function render() {
        return _react2["default"].createElement(
          "svg",
          _extends({ viewBox: "0 0 12 12" }, this.props),
          _react2["default"].createElement("path", { fillRule: "evenodd", d: "M11.53.47a.75.75 0 0 0-1.061 0l-4.47 4.47L1.529.47A.75.75 0 1 0 .468 1.531l4.47 4.47-4.47 4.47a.75.75 0 1 0 1.061 1.061l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.061-1.061l-4.47-4.47 4.47-4.47a.75.75 0 0 0 0-1.061z" })
        );
      }

      return render;
    }()
  }]);

  return SVG;
}(_react2["default"].Component);

exports["default"] = SVG;

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __webpack_require__(167);

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = __webpack_require__(211);

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = __webpack_require__(268);

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = __webpack_require__(229);

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __webpack_require__(25);

/***/ }),

/***/ 29:
/***/ (function(module, exports) {

module.exports = __webpack_require__(623);

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __webpack_require__(47);

/***/ }),

/***/ 33:
/***/ (function(module, exports) {

module.exports = __webpack_require__(382);

/***/ }),

/***/ 34:
/***/ (function(module, exports) {

module.exports = __webpack_require__(168);

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

module.exports = __webpack_require__(650);

/***/ }),

/***/ 45:
/***/ (function(module, exports) {

module.exports = __webpack_require__(621);

/***/ }),

/***/ 59:
/***/ (function(module, exports) {

module.exports = __webpack_require__(615);

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = __webpack_require__(55);

/***/ }),

/***/ 60:
/***/ (function(module, exports) {

module.exports = __webpack_require__(616);

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __webpack_require__(13);

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(7);

var _moment2 = _interopRequireDefault(_moment);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactPortal = __webpack_require__(40);

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _airbnbPropTypes = __webpack_require__(1);

var _consolidatedEvents = __webpack_require__(18);

var _isTouchDevice = __webpack_require__(9);

var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);

var _SingleDatePickerShape = __webpack_require__(45);

var _SingleDatePickerShape2 = _interopRequireDefault(_SingleDatePickerShape);

var _defaultPhrases = __webpack_require__(3);

var _OutsideClickHandler = __webpack_require__(17);

var _OutsideClickHandler2 = _interopRequireDefault(_OutsideClickHandler);

var _toMomentObject = __webpack_require__(34);

var _toMomentObject2 = _interopRequireDefault(_toMomentObject);

var _toLocalizedDateString = __webpack_require__(33);

var _toLocalizedDateString2 = _interopRequireDefault(_toLocalizedDateString);

var _getResponsiveContainerStyles = __webpack_require__(29);

var _getResponsiveContainerStyles2 = _interopRequireDefault(_getResponsiveContainerStyles);

var _toISODateString = __webpack_require__(13);

var _toISODateString2 = _interopRequireDefault(_toISODateString);

var _SingleDatePickerInput = __webpack_require__(60);

var _SingleDatePickerInput2 = _interopRequireDefault(_SingleDatePickerInput);

var _DayPickerSingleDateController = __webpack_require__(59);

var _DayPickerSingleDateController2 = _interopRequireDefault(_DayPickerSingleDateController);

var _close = __webpack_require__(11);

var _close2 = _interopRequireDefault(_close);

var _isInclusivelyAfterDay = __webpack_require__(16);

var _isInclusivelyAfterDay2 = _interopRequireDefault(_isInclusivelyAfterDay);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(_SingleDatePickerShape2['default']);

var defaultProps = {
  // required props for a functional interactive SingleDatePicker
  date: null,
  focused: false,

  // input related props
  id: 'date',
  placeholder: 'Date',
  disabled: false,
  required: false,
  readOnly: false,
  screenReaderInputMessage: '',
  showClearDate: false,
  showDefaultInputIcon: false,
  inputIconPosition: _constants.ICON_BEFORE_POSITION,
  customInputIcon: null,
  customCloseIcon: null,

  // calendar presentation and interaction related props
  orientation: _constants.HORIZONTAL_ORIENTATION,
  anchorDirection: _constants.ANCHOR_LEFT,
  openDirection: _constants.OPEN_DOWN,
  horizontalMargin: 0,
  withPortal: false,
  withFullScreenPortal: false,
  initialVisibleMonth: null,
  firstDayOfWeek: null,
  numberOfMonths: 2,
  keepOpenOnDateSelect: false,
  reopenPickerOnClearDate: false,
  renderCalendarInfo: null,
  hideKeyboardShortcutsPanel: false,
  daySize: _constants.DAY_SIZE,
  isRTL: false,

  // navigation related props
  navPrev: null,
  navNext: null,

  onPrevMonthClick: function () {
    function onPrevMonthClick() {}

    return onPrevMonthClick;
  }(),
  onNextMonthClick: function () {
    function onNextMonthClick() {}

    return onNextMonthClick;
  }(),
  onClose: function () {
    function onClose() {}

    return onClose;
  }(),

  // month presentation and interaction related props
  renderMonth: null,

  // day presentation and interaction related props
  renderDay: null,
  enableOutsideDays: false,
  isDayBlocked: function () {
    function isDayBlocked() {
      return false;
    }

    return isDayBlocked;
  }(),
  isOutsideRange: function () {
    function isOutsideRange(day) {
      return !(0, _isInclusivelyAfterDay2['default'])(day, (0, _moment2['default'])());
    }

    return isOutsideRange;
  }(),
  isDayHighlighted: function () {
    function isDayHighlighted() {}

    return isDayHighlighted;
  }(),

  // internationalization props
  displayFormat: function () {
    function displayFormat() {
      return _moment2['default'].localeData().longDateFormat('L');
    }

    return displayFormat;
  }(),
  monthFormat: 'MMMM YYYY',
  weekDayFormat: 'dd',
  phrases: _defaultPhrases.SingleDatePickerPhrases
};

var SingleDatePicker = function (_React$Component) {
  _inherits(SingleDatePicker, _React$Component);

  function SingleDatePicker(props) {
    _classCallCheck(this, SingleDatePicker);

    var _this = _possibleConstructorReturn(this, (SingleDatePicker.__proto__ || Object.getPrototypeOf(SingleDatePicker)).call(this, props));

    _this.isTouchDevice = false;

    _this.state = {
      dayPickerContainerStyles: {},
      isDayPickerFocused: false,
      isInputFocused: false
    };

    _this.onDayPickerFocus = _this.onDayPickerFocus.bind(_this);
    _this.onDayPickerBlur = _this.onDayPickerBlur.bind(_this);

    _this.onChange = _this.onChange.bind(_this);
    _this.onFocus = _this.onFocus.bind(_this);
    _this.onClearFocus = _this.onClearFocus.bind(_this);
    _this.clearDate = _this.clearDate.bind(_this);

    _this.responsivizePickerPosition = _this.responsivizePickerPosition.bind(_this);

    _this.setDayPickerContainerRef = _this.setDayPickerContainerRef.bind(_this);
    return _this;
  }

  /* istanbul ignore next */

  _createClass(SingleDatePicker, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        this.resizeHandle = (0, _consolidatedEvents.addEventListener)(window, 'resize', this.responsivizePickerPosition, { passive: true });
        this.responsivizePickerPosition();

        if (this.props.focused) {
          this.setState({
            isInputFocused: true
          });
        }

        this.isTouchDevice = (0, _isTouchDevice2['default'])();
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps) {
        if (!prevProps.focused && this.props.focused) {
          this.responsivizePickerPosition();
        }
      }

      return componentDidUpdate;
    }()

    /* istanbul ignore next */

  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        (0, _consolidatedEvents.removeEventListener)(this.resizeHandle);
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'onChange',
    value: function () {
      function onChange(dateString) {
        var _props = this.props,
            isOutsideRange = _props.isOutsideRange,
            keepOpenOnDateSelect = _props.keepOpenOnDateSelect,
            onDateChange = _props.onDateChange,
            onFocusChange = _props.onFocusChange,
            onClose = _props.onClose;

        var newDate = (0, _toMomentObject2['default'])(dateString, this.getDisplayFormat());

        var isValid = newDate && !isOutsideRange(newDate);
        if (isValid) {
          onDateChange(newDate);
          if (!keepOpenOnDateSelect) {
            onFocusChange({ focused: false });
            onClose({ date: newDate });
          }
        } else {
          onDateChange(null);
        }
      }

      return onChange;
    }()
  }, {
    key: 'onFocus',
    value: function () {
      function onFocus() {
        var _props2 = this.props,
            disabled = _props2.disabled,
            onFocusChange = _props2.onFocusChange,
            withPortal = _props2.withPortal,
            withFullScreenPortal = _props2.withFullScreenPortal;

        var moveFocusToDayPicker = withPortal || withFullScreenPortal || this.isTouchDevice;
        if (moveFocusToDayPicker) {
          this.onDayPickerFocus();
        } else {
          this.onDayPickerBlur();
        }

        if (!disabled) {
          onFocusChange({ focused: true });
        }
      }

      return onFocus;
    }()
  }, {
    key: 'onClearFocus',
    value: function () {
      function onClearFocus() {
        var _props3 = this.props,
            startDate = _props3.startDate,
            endDate = _props3.endDate,
            focused = _props3.focused,
            onFocusChange = _props3.onFocusChange,
            onClose = _props3.onClose;

        if (!focused) return;

        this.setState({
          isInputFocused: false,
          isDayPickerFocused: false
        });

        onFocusChange({ focused: false });
        onClose({ startDate: startDate, endDate: endDate });
      }

      return onClearFocus;
    }()
  }, {
    key: 'onDayPickerFocus',
    value: function () {
      function onDayPickerFocus() {
        this.setState({
          isInputFocused: false,
          isDayPickerFocused: true
        });
      }

      return onDayPickerFocus;
    }()
  }, {
    key: 'onDayPickerBlur',
    value: function () {
      function onDayPickerBlur() {
        this.setState({
          isInputFocused: true,
          isDayPickerFocused: false
        });
      }

      return onDayPickerBlur;
    }()
  }, {
    key: 'getDateString',
    value: function () {
      function getDateString(date) {
        var displayFormat = this.getDisplayFormat();
        if (date && displayFormat) {
          return date && date.format(displayFormat);
        }
        return (0, _toLocalizedDateString2['default'])(date);
      }

      return getDateString;
    }()
  }, {
    key: 'getDayPickerContainerClasses',
    value: function () {
      function getDayPickerContainerClasses() {
        var _props4 = this.props,
            orientation = _props4.orientation,
            withPortal = _props4.withPortal,
            withFullScreenPortal = _props4.withFullScreenPortal,
            anchorDirection = _props4.anchorDirection,
            openDirection = _props4.openDirection,
            isRTL = _props4.isRTL;

        var dayPickerClassName = (0, _classnames2['default'])('SingleDatePicker__picker', {
          'SingleDatePicker__picker--direction-left': anchorDirection === _constants.ANCHOR_LEFT,
          'SingleDatePicker__picker--direction-right': anchorDirection === _constants.ANCHOR_RIGHT,
          'SingleDatePicker__picker--open-down': openDirection === _constants.OPEN_DOWN,
          'SingleDatePicker__picker--open-up': openDirection === _constants.OPEN_UP,
          'SingleDatePicker__picker--horizontal': orientation === _constants.HORIZONTAL_ORIENTATION,
          'SingleDatePicker__picker--vertical': orientation === _constants.VERTICAL_ORIENTATION,
          'SingleDatePicker__picker--portal': withPortal || withFullScreenPortal,
          'SingleDatePicker__picker--full-screen-portal': withFullScreenPortal,
          'SingleDatePicker__picker--rtl': isRTL
        });

        return dayPickerClassName;
      }

      return getDayPickerContainerClasses;
    }()
  }, {
    key: 'getDisplayFormat',
    value: function () {
      function getDisplayFormat() {
        var displayFormat = this.props.displayFormat;

        return typeof displayFormat === 'string' ? displayFormat : displayFormat();
      }

      return getDisplayFormat;
    }()
  }, {
    key: 'setDayPickerContainerRef',
    value: function () {
      function setDayPickerContainerRef(ref) {
        this.dayPickerContainer = ref;
      }

      return setDayPickerContainerRef;
    }()
  }, {
    key: 'clearDate',
    value: function () {
      function clearDate() {
        var _props5 = this.props,
            onDateChange = _props5.onDateChange,
            reopenPickerOnClearDate = _props5.reopenPickerOnClearDate,
            onFocusChange = _props5.onFocusChange;

        onDateChange(null);
        if (reopenPickerOnClearDate) {
          onFocusChange({ focused: true });
        }
      }

      return clearDate;
    }()

    /* istanbul ignore next */

  }, {
    key: 'responsivizePickerPosition',
    value: function () {
      function responsivizePickerPosition() {
        // It's possible the portal props have been changed in response to window resizes
        // So let's ensure we reset this back to the base state each time
        this.setState({ dayPickerContainerStyles: {} });

        var _props6 = this.props,
            anchorDirection = _props6.anchorDirection,
            horizontalMargin = _props6.horizontalMargin,
            withPortal = _props6.withPortal,
            withFullScreenPortal = _props6.withFullScreenPortal,
            focused = _props6.focused;
        var dayPickerContainerStyles = this.state.dayPickerContainerStyles;

        if (!focused) {
          return;
        }

        var isAnchoredLeft = anchorDirection === _constants.ANCHOR_LEFT;

        if (!withPortal && !withFullScreenPortal) {
          var containerRect = this.dayPickerContainer.getBoundingClientRect();
          var currentOffset = dayPickerContainerStyles[anchorDirection] || 0;
          var containerEdge = isAnchoredLeft ? containerRect[_constants.ANCHOR_RIGHT] : containerRect[_constants.ANCHOR_LEFT];

          this.setState({
            dayPickerContainerStyles: (0, _getResponsiveContainerStyles2['default'])(anchorDirection, currentOffset, containerEdge, horizontalMargin)
          });
        }
      }

      return responsivizePickerPosition;
    }()
  }, {
    key: 'maybeRenderDayPickerWithPortal',
    value: function () {
      function maybeRenderDayPickerWithPortal() {
        var _props7 = this.props,
            focused = _props7.focused,
            withPortal = _props7.withPortal,
            withFullScreenPortal = _props7.withFullScreenPortal;

        if (!focused) {
          return null;
        }

        if (withPortal || withFullScreenPortal) {
          return _react2['default'].createElement(_reactPortal2['default'], { isOpened: true }, this.renderDayPicker());
        }

        return this.renderDayPicker();
      }

      return maybeRenderDayPickerWithPortal;
    }()
  }, {
    key: 'renderDayPicker',
    value: function () {
      function renderDayPicker() {
        var _props8 = this.props,
            onDateChange = _props8.onDateChange,
            date = _props8.date,
            onFocusChange = _props8.onFocusChange,
            focused = _props8.focused,
            enableOutsideDays = _props8.enableOutsideDays,
            numberOfMonths = _props8.numberOfMonths,
            orientation = _props8.orientation,
            monthFormat = _props8.monthFormat,
            navPrev = _props8.navPrev,
            navNext = _props8.navNext,
            onPrevMonthClick = _props8.onPrevMonthClick,
            onNextMonthClick = _props8.onNextMonthClick,
            withPortal = _props8.withPortal,
            withFullScreenPortal = _props8.withFullScreenPortal,
            keepOpenOnDateSelect = _props8.keepOpenOnDateSelect,
            initialVisibleMonth = _props8.initialVisibleMonth,
            renderMonth = _props8.renderMonth,
            renderDay = _props8.renderDay,
            renderCalendarInfo = _props8.renderCalendarInfo,
            hideKeyboardShortcutsPanel = _props8.hideKeyboardShortcutsPanel,
            firstDayOfWeek = _props8.firstDayOfWeek,
            customCloseIcon = _props8.customCloseIcon,
            phrases = _props8.phrases,
            daySize = _props8.daySize,
            isRTL = _props8.isRTL,
            isOutsideRange = _props8.isOutsideRange,
            isDayBlocked = _props8.isDayBlocked,
            isDayHighlighted = _props8.isDayHighlighted,
            weekDayFormat = _props8.weekDayFormat;
        var _state = this.state,
            dayPickerContainerStyles = _state.dayPickerContainerStyles,
            isDayPickerFocused = _state.isDayPickerFocused;

        var onOutsideClick = !withFullScreenPortal && withPortal ? this.onClearFocus : undefined;
        var closeIcon = customCloseIcon || _react2['default'].createElement(_close2['default'], null);

        return _react2['default'].createElement('div', { // eslint-disable-line jsx-a11y/no-static-element-interactions
          ref: this.setDayPickerContainerRef,
          className: this.getDayPickerContainerClasses(),
          style: dayPickerContainerStyles,
          onClick: onOutsideClick
        }, _react2['default'].createElement(_DayPickerSingleDateController2['default'], {
          date: date,
          onDateChange: onDateChange,
          onFocusChange: onFocusChange,
          orientation: orientation,
          enableOutsideDays: enableOutsideDays,
          numberOfMonths: numberOfMonths,
          monthFormat: monthFormat,
          withPortal: withPortal || withFullScreenPortal,
          focused: focused,
          keepOpenOnDateSelect: keepOpenOnDateSelect,
          hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
          initialVisibleMonth: initialVisibleMonth,
          navPrev: navPrev,
          navNext: navNext,
          onPrevMonthClick: onPrevMonthClick,
          onNextMonthClick: onNextMonthClick,
          renderMonth: renderMonth,
          renderDay: renderDay,
          renderCalendarInfo: renderCalendarInfo,
          isFocused: isDayPickerFocused,
          phrases: phrases,
          daySize: daySize,
          isRTL: isRTL,
          isOutsideRange: isOutsideRange,
          isDayBlocked: isDayBlocked,
          isDayHighlighted: isDayHighlighted,
          firstDayOfWeek: firstDayOfWeek,
          weekDayFormat: weekDayFormat
        }), withFullScreenPortal && _react2['default'].createElement('button', {
          'aria-label': phrases.closeDatePicker,
          className: 'SingleDatePicker__close',
          type: 'button',
          onClick: this.onClearFocus
        }, _react2['default'].createElement('div', { className: 'SingleDatePicker__close-icon' }, closeIcon)));
      }

      return renderDayPicker;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props9 = this.props,
            id = _props9.id,
            placeholder = _props9.placeholder,
            disabled = _props9.disabled,
            focused = _props9.focused,
            required = _props9.required,
            readOnly = _props9.readOnly,
            openDirection = _props9.openDirection,
            showClearDate = _props9.showClearDate,
            showDefaultInputIcon = _props9.showDefaultInputIcon,
            inputIconPosition = _props9.inputIconPosition,
            customInputIcon = _props9.customInputIcon,
            date = _props9.date,
            phrases = _props9.phrases,
            withPortal = _props9.withPortal,
            withFullScreenPortal = _props9.withFullScreenPortal,
            screenReaderInputMessage = _props9.screenReaderInputMessage,
            isRTL = _props9.isRTL;
        var isInputFocused = this.state.isInputFocused;

        var displayValue = this.getDateString(date);
        var inputValue = (0, _toISODateString2['default'])(date);

        var onOutsideClick = !withPortal && !withFullScreenPortal ? this.onClearFocus : undefined;

        return _react2['default'].createElement('div', { className: 'SingleDatePicker' }, _react2['default'].createElement(_OutsideClickHandler2['default'], { onOutsideClick: onOutsideClick }, _react2['default'].createElement(_SingleDatePickerInput2['default'], {
          id: id,
          placeholder: placeholder,
          focused: focused,
          isFocused: isInputFocused,
          disabled: disabled,
          required: required,
          readOnly: readOnly,
          openDirection: openDirection,
          showCaret: !withPortal && !withFullScreenPortal,
          onClearDate: this.clearDate,
          showClearDate: showClearDate,
          showDefaultInputIcon: showDefaultInputIcon,
          inputIconPosition: inputIconPosition,
          customInputIcon: customInputIcon,
          displayValue: displayValue,
          inputValue: inputValue,
          onChange: this.onChange,
          onFocus: this.onFocus,
          onKeyDownShiftTab: this.onClearFocus,
          onKeyDownTab: this.onClearFocus,
          onKeyDownArrowDown: this.onDayPickerFocus,
          screenReaderMessage: screenReaderInputMessage,
          phrases: phrases,
          isRTL: isRTL
        }), this.maybeRenderDayPickerWithPortal()));
      }

      return render;
    }()
  }]);

  return SingleDatePicker;
}(_react2['default'].Component);

exports['default'] = SingleDatePicker;

SingleDatePicker.propTypes = propTypes;
SingleDatePicker.defaultProps = defaultProps;

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = __webpack_require__(152);

/***/ })

/******/ });

/***/ }),
/* 1465 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = getActiveElement;
function getActiveElement() {
  return typeof document !== 'undefined' && document.activeElement;
}

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = getCalendarMonthWeeks;

var _moment = __webpack_require__(13);

var _moment2 = _interopRequireDefault(_moment);

var _constants = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getCalendarMonthWeeks(month, enableOutsideDays) {
  var firstDayOfWeek = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _moment2['default'].localeData().firstDayOfWeek();

  if (!_moment2['default'].isMoment(month) || !month.isValid()) {
    throw new TypeError('`month` must be a valid moment object');
  }
  if (_constants.WEEKDAYS.indexOf(firstDayOfWeek) === -1) {
    throw new TypeError('`firstDayOfWeek` must be an integer between 0 and 6');
  }

  // set utc offset to get correct dates in future (when timezone changes)
  var firstOfMonth = month.clone().startOf('month').hour(12);
  var lastOfMonth = month.clone().endOf('month').hour(12);

  // calculate the exact first and last days to fill the entire matrix
  // (considering days outside month)
  var prevDays = (firstOfMonth.day() + 7 - firstDayOfWeek) % 7;
  var nextDays = (firstDayOfWeek + 6 - lastOfMonth.day()) % 7;
  var firstDay = firstOfMonth.clone().subtract(prevDays, 'day');
  var lastDay = lastOfMonth.clone().add(nextDays, 'day');

  var totalDays = lastDay.diff(firstDay, 'days') + 1;

  var currentDay = firstDay.clone();
  var weeksInMonth = [];

  for (var i = 0; i < totalDays; i += 1) {
    if (i % 7 === 0) {
      weeksInMonth.push([]);
    }

    var day = null;
    if (i >= prevDays && i < totalDays - nextDays || enableOutsideDays) {
      day = currentDay.clone();
    }

    weeksInMonth[weeksInMonth.length - 1].push(day);

    currentDay.add(1, 'day');
  }

  return weeksInMonth;
}

/***/ }),
/* 1467 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = getPhrase;
function getPhrase(phrase, args) {
  if (typeof phrase === 'string') return phrase;

  if (typeof phrase === 'function') {
    return phrase(args);
  }

  return '';
}

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = isInclusivelyBeforeDay;

var _moment = __webpack_require__(13);

var _moment2 = _interopRequireDefault(_moment);

var _isAfterDay = __webpack_require__(209);

var _isAfterDay2 = _interopRequireDefault(_isAfterDay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function isInclusivelyBeforeDay(a, b) {
  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
  return !(0, _isAfterDay2['default'])(a, b);
}

/***/ }),
/* 1469 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = isTransitionEndSupported;
function isTransitionEndSupported() {
  return !!(typeof window !== 'undefined' && 'TransitionEvent' in window);
}

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(33);

var focusNode = __webpack_require__(516);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(213);
var ExecutionEnvironment = __webpack_require__(50);
var FallbackCompositionState = __webpack_require__(1478);
var SyntheticCompositionEvent = __webpack_require__(1515);
var SyntheticInputEvent = __webpack_require__(1518);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(627);
var ExecutionEnvironment = __webpack_require__(50);
var ReactInstrumentation = __webpack_require__(73);

var camelizeStyleName = __webpack_require__(1201);
var dangerousStyleValue = __webpack_require__(1524);
var hyphenateStyleName = __webpack_require__(1208);
var memoizeStringOnly = __webpack_require__(1211);
var warning = __webpack_require__(14);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(212);
var EventPropagators = __webpack_require__(213);
var ExecutionEnvironment = __webpack_require__(50);
var ReactDOMComponentTree = __webpack_require__(33);
var ReactUpdates = __webpack_require__(84);
var SyntheticEvent = __webpack_require__(94);

var inputValueTracking = __webpack_require__(643);
var getEventTarget = __webpack_require__(395);
var isEventSupported = __webpack_require__(396);
var isTextInputElement = __webpack_require__(645);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(22);

var DOMLazyTree = __webpack_require__(169);
var ExecutionEnvironment = __webpack_require__(50);

var createNodesFromMarkup = __webpack_require__(1204);
var emptyFunction = __webpack_require__(70);
var invariant = __webpack_require__(12);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(213);
var ReactDOMComponentTree = __webpack_require__(33);
var SyntheticMouseEvent = __webpack_require__(271);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(21);

var PooledClass = __webpack_require__(129);

var getTextContentAccessor = __webpack_require__(642);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(170);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactReconciler = __webpack_require__(171);

var instantiateReactComponent = __webpack_require__(644);
var KeyEscapeUtils = __webpack_require__(387);
var shouldUpdateReactComponent = __webpack_require__(397);
var traverseAllChildren = __webpack_require__(647);
var warning = __webpack_require__(14);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":"/apps/simulador/app/plugins/adene-simulador-wrapper/build","ADENE_ENV":"production"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(674);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(376)))

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(383);
var ReactDOMIDOperations = __webpack_require__(1488);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(22),
    _assign = __webpack_require__(21);

var React = __webpack_require__(175);
var ReactComponentEnvironment = __webpack_require__(389);
var ReactCurrentOwner = __webpack_require__(95);
var ReactErrorUtils = __webpack_require__(390);
var ReactInstanceMap = __webpack_require__(214);
var ReactInstrumentation = __webpack_require__(73);
var ReactNodeTypes = __webpack_require__(637);
var ReactReconciler = __webpack_require__(171);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(250);
var invariant = __webpack_require__(12);
var shallowEqual = __webpack_require__(349);
var shouldUpdateReactComponent = __webpack_require__(397);
var warning = __webpack_require__(14);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(33);
var ReactDefaultInjection = __webpack_require__(1496);
var ReactMount = __webpack_require__(636);
var ReactReconciler = __webpack_require__(171);
var ReactUpdates = __webpack_require__(84);
var ReactVersion = __webpack_require__(1509);

var findDOMNode = __webpack_require__(1525);
var getHostComponentFromComposite = __webpack_require__(641);
var renderSubtreeIntoContainer = __webpack_require__(1532);
var warning = __webpack_require__(14);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(22),
    _assign = __webpack_require__(21);

var AutoFocusUtils = __webpack_require__(1471);
var CSSPropertyOperations = __webpack_require__(1473);
var DOMLazyTree = __webpack_require__(169);
var DOMNamespaces = __webpack_require__(384);
var DOMProperty = __webpack_require__(170);
var DOMPropertyOperations = __webpack_require__(629);
var EventPluginHub = __webpack_require__(212);
var EventPluginRegistry = __webpack_require__(385);
var ReactBrowserEventEmitter = __webpack_require__(270);
var ReactDOMComponentFlags = __webpack_require__(630);
var ReactDOMComponentTree = __webpack_require__(33);
var ReactDOMInput = __webpack_require__(1489);
var ReactDOMOption = __webpack_require__(1490);
var ReactDOMSelect = __webpack_require__(631);
var ReactDOMTextarea = __webpack_require__(1493);
var ReactInstrumentation = __webpack_require__(73);
var ReactMultiChild = __webpack_require__(1502);
var ReactServerRenderingTransaction = __webpack_require__(1507);

var emptyFunction = __webpack_require__(70);
var escapeTextContentForBrowser = __webpack_require__(273);
var invariant = __webpack_require__(12);
var isEventSupported = __webpack_require__(396);
var shallowEqual = __webpack_require__(349);
var inputValueTracking = __webpack_require__(643);
var validateDOMNesting = __webpack_require__(398);
var warning = __webpack_require__(14);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var validateDOMNesting = __webpack_require__(398);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(21);

var DOMLazyTree = __webpack_require__(169);
var ReactDOMComponentTree = __webpack_require__(33);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(383);
var ReactDOMComponentTree = __webpack_require__(33);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(22),
    _assign = __webpack_require__(21);

var DOMPropertyOperations = __webpack_require__(629);
var LinkedValueUtils = __webpack_require__(388);
var ReactDOMComponentTree = __webpack_require__(33);
var ReactUpdates = __webpack_require__(84);

var invariant = __webpack_require__(12);
var warning = __webpack_require__(14);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(21);

var React = __webpack_require__(175);
var ReactDOMComponentTree = __webpack_require__(33);
var ReactDOMSelect = __webpack_require__(631);

var warning = __webpack_require__(14);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(50);

var getNodeForCharacterOffset = __webpack_require__(1529);
var getTextContentAccessor = __webpack_require__(642);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(22),
    _assign = __webpack_require__(21);

var DOMChildrenOperations = __webpack_require__(383);
var DOMLazyTree = __webpack_require__(169);
var ReactDOMComponentTree = __webpack_require__(33);

var escapeTextContentForBrowser = __webpack_require__(273);
var invariant = __webpack_require__(12);
var validateDOMNesting = __webpack_require__(398);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(22),
    _assign = __webpack_require__(21);

var LinkedValueUtils = __webpack_require__(388);
var ReactDOMComponentTree = __webpack_require__(33);
var ReactUpdates = __webpack_require__(84);

var invariant = __webpack_require__(12);
var warning = __webpack_require__(14);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(22);

var invariant = __webpack_require__(12);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(21);

var ReactUpdates = __webpack_require__(84);
var Transaction = __webpack_require__(272);

var emptyFunction = __webpack_require__(70);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(1470);
var BeforeInputEventPlugin = __webpack_require__(1472);
var ChangeEventPlugin = __webpack_require__(1474);
var DefaultEventPluginOrder = __webpack_require__(1476);
var EnterLeaveEventPlugin = __webpack_require__(1477);
var HTMLDOMPropertyConfig = __webpack_require__(1479);
var ReactComponentBrowserEnvironment = __webpack_require__(1481);
var ReactDOMComponent = __webpack_require__(1484);
var ReactDOMComponentTree = __webpack_require__(33);
var ReactDOMEmptyComponent = __webpack_require__(1486);
var ReactDOMTreeTraversal = __webpack_require__(1494);
var ReactDOMTextComponent = __webpack_require__(1492);
var ReactDefaultBatchingStrategy = __webpack_require__(1495);
var ReactEventListener = __webpack_require__(1499);
var ReactInjection = __webpack_require__(1500);
var ReactReconcileTransaction = __webpack_require__(1505);
var SVGDOMPropertyConfig = __webpack_require__(1510);
var SelectEventPlugin = __webpack_require__(1511);
var SimpleEventPlugin = __webpack_require__(1512);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(212);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(21);

var EventListener = __webpack_require__(515);
var ExecutionEnvironment = __webpack_require__(50);
var PooledClass = __webpack_require__(129);
var ReactDOMComponentTree = __webpack_require__(33);
var ReactUpdates = __webpack_require__(84);

var getEventTarget = __webpack_require__(395);
var getUnboundedScrollPosition = __webpack_require__(1206);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(170);
var EventPluginHub = __webpack_require__(212);
var EventPluginUtils = __webpack_require__(386);
var ReactComponentEnvironment = __webpack_require__(389);
var ReactEmptyComponent = __webpack_require__(632);
var ReactBrowserEventEmitter = __webpack_require__(270);
var ReactHostComponent = __webpack_require__(634);
var ReactUpdates = __webpack_require__(84);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var adler32 = __webpack_require__(1523);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(22);

var ReactComponentEnvironment = __webpack_require__(389);
var ReactInstanceMap = __webpack_require__(214);
var ReactInstrumentation = __webpack_require__(73);

var ReactCurrentOwner = __webpack_require__(95);
var ReactReconciler = __webpack_require__(171);
var ReactChildReconciler = __webpack_require__(1480);

var emptyFunction = __webpack_require__(70);
var flattenChildren = __webpack_require__(1526);
var invariant = __webpack_require__(12);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(22);

var invariant = __webpack_require__(12);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(21);

var CallbackQueue = __webpack_require__(628);
var PooledClass = __webpack_require__(129);
var ReactBrowserEventEmitter = __webpack_require__(270);
var ReactInputSelection = __webpack_require__(635);
var ReactInstrumentation = __webpack_require__(73);
var Transaction = __webpack_require__(272);
var ReactUpdateQueue = __webpack_require__(391);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactOwner = __webpack_require__(1503);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(21);

var PooledClass = __webpack_require__(129);
var Transaction = __webpack_require__(272);
var ReactInstrumentation = __webpack_require__(73);
var ReactServerUpdateQueue = __webpack_require__(1508);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(391);

var warning = __webpack_require__(14);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(213);
var ExecutionEnvironment = __webpack_require__(50);
var ReactDOMComponentTree = __webpack_require__(33);
var ReactInputSelection = __webpack_require__(635);
var SyntheticEvent = __webpack_require__(94);

var getActiveElement = __webpack_require__(517);
var isTextInputElement = __webpack_require__(645);
var shallowEqual = __webpack_require__(349);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(22);

var EventListener = __webpack_require__(515);
var EventPropagators = __webpack_require__(213);
var ReactDOMComponentTree = __webpack_require__(33);
var SyntheticAnimationEvent = __webpack_require__(1513);
var SyntheticClipboardEvent = __webpack_require__(1514);
var SyntheticEvent = __webpack_require__(94);
var SyntheticFocusEvent = __webpack_require__(1517);
var SyntheticKeyboardEvent = __webpack_require__(1519);
var SyntheticMouseEvent = __webpack_require__(271);
var SyntheticDragEvent = __webpack_require__(1516);
var SyntheticTouchEvent = __webpack_require__(1520);
var SyntheticTransitionEvent = __webpack_require__(1521);
var SyntheticUIEvent = __webpack_require__(215);
var SyntheticWheelEvent = __webpack_require__(1522);

var emptyFunction = __webpack_require__(70);
var getEventCharCode = __webpack_require__(393);
var invariant = __webpack_require__(12);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(94);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(94);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(94);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(271);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(215);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(94);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(215);

var getEventCharCode = __webpack_require__(393);
var getEventKey = __webpack_require__(1527);
var getEventModifierState = __webpack_require__(394);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(215);

var getEventModifierState = __webpack_require__(394);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(94);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(271);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(627);
var warning = __webpack_require__(14);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(22);

var ReactCurrentOwner = __webpack_require__(95);
var ReactDOMComponentTree = __webpack_require__(33);
var ReactInstanceMap = __webpack_require__(214);

var getHostComponentFromComposite = __webpack_require__(641);
var invariant = __webpack_require__(12);
var warning = __webpack_require__(14);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(387);
var traverseAllChildren = __webpack_require__(647);
var warning = __webpack_require__(14);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":"/apps/simulador/app/plugins/adene-simulador-wrapper/build","ADENE_ENV":"production"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(674);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(376)))

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var getEventCharCode = __webpack_require__(393);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(50);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(273);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactMount = __webpack_require__(636);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColumnProps = getColumnProps;
exports.default = Col;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createProps = __webpack_require__(400);

var _createProps2 = _interopRequireDefault(_createProps);

var _classNames = __webpack_require__(399);

var _classNames2 = _interopRequireDefault(_classNames);

var _types = __webpack_require__(648);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  xs: _types.ColumnSizeType,
  sm: _types.ColumnSizeType,
  md: _types.ColumnSizeType,
  lg: _types.ColumnSizeType,
  xsOffset: _propTypes2.default.number,
  smOffset: _propTypes2.default.number,
  mdOffset: _propTypes2.default.number,
  lgOffset: _propTypes2.default.number,
  first: _types.ViewportSizeType,
  last: _types.ViewportSizeType,
  className: _propTypes2.default.string,
  tagName: _propTypes2.default.string,
  children: _propTypes2.default.node
};

var classMap = {
  xs: 'col-xs',
  sm: 'col-sm',
  md: 'col-md',
  lg: 'col-lg',
  xsOffset: 'col-xs-offset',
  smOffset: 'col-sm-offset',
  mdOffset: 'col-md-offset',
  lgOffset: 'col-lg-offset'
};

function isInteger(value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}

function getColClassNames(props) {
  var extraClasses = [];

  if (props.className) {
    extraClasses.push(props.className);
  }

  if (props.first) {
    extraClasses.push((0, _classNames2.default)('first-' + props.first));
  }

  if (props.last) {
    extraClasses.push((0, _classNames2.default)('last-' + props.last));
  }

  return Object.keys(props).filter(function (key) {
    return classMap[key];
  }).map(function (key) {
    return (0, _classNames2.default)(isInteger(props[key]) ? classMap[key] + '-' + props[key] : classMap[key]);
  }).concat(extraClasses);
}

function getColumnProps(props) {
  return (0, _createProps2.default)(propTypes, props, getColClassNames(props));
}

function Col(props) {
  var tagName = props.tagName,
      columnProps = _objectWithoutProperties(props, ['tagName']);

  return _react2.default.createElement(tagName || 'div', getColumnProps(columnProps));
}

Col.propTypes = propTypes;

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Grid;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createProps = __webpack_require__(400);

var _createProps2 = _interopRequireDefault(_createProps);

var _classNames = __webpack_require__(399);

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  fluid: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  tagName: _propTypes2.default.string,
  children: _propTypes2.default.node
};

function Grid(props) {
  var containerClass = (0, _classNames2.default)(props.fluid ? 'container-fluid' : 'container');
  var classNames = [props.className, containerClass];

  return _react2.default.createElement(props.tagName || 'div', (0, _createProps2.default)(propTypes, props, classNames));
}

Grid.propTypes = propTypes;

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRowProps = getRowProps;
exports.default = Row;

var _classNames = __webpack_require__(399);

var _classNames2 = _interopRequireDefault(_classNames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createProps = __webpack_require__(400);

var _createProps2 = _interopRequireDefault(_createProps);

var _types = __webpack_require__(648);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rowKeys = ['start', 'center', 'end', 'top', 'middle', 'bottom', 'around', 'between'];

var propTypes = {
  reverse: _propTypes2.default.bool,
  start: _types.ViewportSizeType,
  center: _types.ViewportSizeType,
  end: _types.ViewportSizeType,
  top: _types.ViewportSizeType,
  middle: _types.ViewportSizeType,
  bottom: _types.ViewportSizeType,
  around: _types.ViewportSizeType,
  between: _types.ViewportSizeType,
  className: _propTypes2.default.string,
  tagName: _propTypes2.default.string,
  children: _propTypes2.default.node
};

function getRowClassNames(props) {
  var modificators = [props.className, (0, _classNames2.default)('row')];

  for (var i = 0; i < rowKeys.length; ++i) {
    var key = rowKeys[i];
    var value = props[key];
    if (value) {
      modificators.push((0, _classNames2.default)(key + '-' + value));
    }
  }

  if (props.reverse) {
    modificators.push((0, _classNames2.default)('reverse'));
  }

  return modificators;
}

function getRowProps(props) {
  return (0, _createProps2.default)(propTypes, props, getRowClassNames(props));
}

function Row(props) {
  return _react2.default.createElement(props.tagName || 'div', getRowProps(props));
}

Row.propTypes = propTypes;

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'UNSAFE_componentWillReceiveProps',
		value: function UNSAFE_componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1537);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 1539 */
/***/ (function(module, exports) {

var messages = {
  invalidPredicate: '`predicate` must be a function',
  invalidPropValidator: '`propValidator` must be a function',
  requiredCore: 'is marked as required',
  invalidTypeCore: 'Invalid input type',
  predicateFailureCore: 'Failed to succeed with predicate',
  anonymousMessage: '<<anonymous>>',
  baseInvalidMessage: 'Invalid ',
};

function constructPropValidatorVariations(propValidator) {
  if (typeof propValidator !== 'function') {
    throw new Error(messages.invalidPropValidator);
  }

  var requiredPropValidator = propValidator.bind(null, false, null);
  requiredPropValidator.isRequired = propValidator.bind(null, true, null);

  requiredPropValidator.withPredicate = function predicateApplication(predicate) {
    if (typeof predicate !== 'function') {
      throw new Error(messages.invalidPredicate);
    }
    var basePropValidator = propValidator.bind(null, false, predicate);
    basePropValidator.isRequired = propValidator.bind(null, true, predicate);
    return basePropValidator;
  };

  return requiredPropValidator;
}

function createInvalidRequiredErrorMessage(propName, componentName, value) {
  return new Error(
    'The prop `' + propName + '` ' + messages.requiredCore +
    ' in `' + componentName + '`, but its value is `' + value + '`.'
  );
}

var independentGuardianValue = -1;

function preValidationRequireCheck(isRequired, componentName, propFullName, propValue) {
  var isPropValueUndefined = typeof propValue === 'undefined';
  var isPropValueNull = propValue === null;

  if (isRequired) {
    if (isPropValueUndefined) {
      return createInvalidRequiredErrorMessage(propFullName, componentName, 'undefined');
    } else if (isPropValueNull) {
      return createInvalidRequiredErrorMessage(propFullName, componentName, 'null');
    }
  }

  if (isPropValueUndefined || isPropValueNull) {
    return null;
  }

  return independentGuardianValue;
}

function createMomentChecker(type, typeValidator, validator, momentType) {

  function propValidator(
    isRequired, // Bound parameter to indicate with the propType is required
    predicate, // Bound parameter to allow user to add dynamic validation
    props,
    propName,
    componentName,
    location,
    propFullName
  ) {
    var propValue = props[ propName ];
    var propType = typeof propValue;

    componentName = componentName || messages.anonymousMessage;
    propFullName = propFullName || propName;

    var preValidationRequireCheckValue = preValidationRequireCheck(
      isRequired, componentName, propFullName, propValue
    );

    if (preValidationRequireCheckValue !== independentGuardianValue) {
      return preValidationRequireCheckValue;
    }

    if (typeValidator && !typeValidator(propValue)) {
      return new Error(
        messages.invalidTypeCore + ': `' + propName + '` of type `' + propType + '` ' +
        'supplied to `' + componentName + '`, expected `' + type + '`.'
      );
    }

    if (!validator(propValue)) {
      return new Error(
        messages.baseInvalidMessage + location + ' `' + propName + '` of type `' + propType + '` ' +
        'supplied to `' + componentName + '`, expected `' + momentType + '`.'
      );
    }

    if (predicate && !predicate(propValue)) {
      var predicateName = predicate.name || messages.anonymousMessage;
      return new Error(
        messages.baseInvalidMessage + location + ' `' + propName + '` of type `' + propType + '` ' +
        'supplied to `' + componentName + '`. ' + messages.predicateFailureCore + ' `' +
        predicateName + '`.'
      );
    }

    return null;

  }

  return constructPropValidatorVariations(propValidator);

}

module.exports = {
  constructPropValidatorVariations: constructPropValidatorVariations,
  createMomentChecker: createMomentChecker,
  messages: messages,
};


/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

var moment = __webpack_require__(13);

function isValidMoment(testMoment) {
  if (typeof moment.isMoment === 'function' && !moment.isMoment(testMoment)) {
    return false;
  }

  /* istanbul ignore else  */
  if (typeof testMoment.isValid === 'function') {
    // moment 1.7.0+
    return testMoment.isValid();
  }

  /* istanbul ignore next */
  return !isNaN(testMoment);
}

module.exports = {
  isValidMoment : isValidMoment,
};


/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(0), __webpack_require__(8)) :
  typeof define === 'function' && define.amd ? define(['exports', 'react', 'prop-types'], factory) :
  (factory((global.ReactOutsideClickHandler = {}),global.React,global.PropTypes));
}(this, (function (exports,React,PropTypes) { 'use strict';

  React = React && React.hasOwnProperty('default') ? React['default'] : React;
  PropTypes = PropTypes && PropTypes.hasOwnProperty('default') ? PropTypes['default'] : PropTypes;

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

  var propTypes = {
    children: PropTypes.node,
    useCapture: PropTypes.bool,
    onOutsideClick: PropTypes.func
  };

  var defaultProps = {
    children: React.createElement('span', null),
    useCapture: true,
    onOutsideClick: function onOutsideClick() {}
  };

  var OutsideClickHandler = function (_React$Component) {
    _inherits(OutsideClickHandler, _React$Component);

    function OutsideClickHandler(props) {
      _classCallCheck(this, OutsideClickHandler);

      var _this = _possibleConstructorReturn(this, (OutsideClickHandler.__proto__ || Object.getPrototypeOf(OutsideClickHandler)).call(this, props));

      _this.handleOutsideClick = _this.handleOutsideClick.bind(_this);
      _this.setChildNode = _this.setChildNode.bind(_this);
      return _this;
    }

    _createClass(OutsideClickHandler, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        document.addEventListener('click', this.handleOutsideClick, this.props.useCapture);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        document.removeEventListener('click', this.handleOutsideClick, this.props.useCapture);
      }
    }, {
      key: 'setChildNode',
      value: function setChildNode(ref) {
        this.childNode = ref;
      }
    }, {
      key: 'handleOutsideClick',
      value: function handleOutsideClick(e) {
        var isDescendantOfRoot = this.childNode.contains(e.target);
        if (!isDescendantOfRoot) {
          this.props.onOutsideClick(e);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return React.createElement(
          'div',
          { ref: this.setChildNode },
          this.props.children
        );
      }
    }]);

    return OutsideClickHandler;
  }(React.Component);

  OutsideClickHandler.propTypes = propTypes;
  OutsideClickHandler.defaultProps = defaultProps;

  exports.default = OutsideClickHandler;

  Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),
/* 1542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Provider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_Subscription__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_storeShape__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(402);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

var Provider = function (_Component) {
  _inherits(Provider, _Component);

  Provider.prototype.getChildContext = function getChildContext() {
    return { store: this.store, storeSubscription: null };
  };

  function Provider(props, context) {
    _classCallCheck(this, Provider);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

    _this.store = props.store;
    return _this;
  }

  Provider.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
  };

  return Provider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);




if (false) {
  Provider.prototype.componentWillReceiveProps = function (nextProps) {
    var store = this.store;
    var nextStore = nextProps.store;


    if (store !== nextStore) {
      warnAboutReceivingStore();
    }
  };
}

Provider.propTypes = {
  store: __WEBPACK_IMPORTED_MODULE_2__utils_storeShape__["a" /* default */].isRequired,
  children: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].element.isRequired
};
Provider.childContextTypes = {
  store: __WEBPACK_IMPORTED_MODULE_2__utils_storeShape__["a" /* default */].isRequired,
  storeSubscription: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].instanceOf(__WEBPACK_IMPORTED_MODULE_1__utils_Subscription__["a" /* default */])
};
Provider.displayName = 'Provider';

/***/ }),
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(1545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(1547);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 1544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(652);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 1545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(652);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 1546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(655);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(1548);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 1548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(402);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 1549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function shallowEqual(a, b) {
  if (a === b) return true;

  var countA = 0;
  var countB = 0;

  for (var key in a) {
    if (hasOwn.call(a, key) && a[key] !== b[key]) return false;
    countA++;
  }

  for (var _key in b) {
    if (hasOwn.call(b, _key)) countB++;
  }

  return countA === countB;
}

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = routerMiddleware;

var _actions = __webpack_require__(656);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== _actions.CALL_HISTORY_METHOD) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
}

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = syncHistoryWithStore;

var _reducer = __webpack_require__(657);

var defaultSelectLocationState = function defaultSelectLocationState(state) {
  return state.routing;
};

/**
 * This function synchronizes your history state with the Redux store.
 * Location changes flow from history to the store. An enhanced history is
 * returned with a listen method that responds to store updates for location.
 *
 * When this history is provided to the router, this means the location data
 * will flow like this:
 * history.push -> store.dispatch -> enhancedHistory.listen -> router
 * This ensures that when the store state changes due to a replay or other
 * event, the router will be updated appropriately and can transition to the
 * correct router state.
 */
function syncHistoryWithStore(history, store) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$selectLocationSt = _ref.selectLocationState,
      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;

  // Ensure that the reducer is mounted on the store and functioning properly.
  if (typeof selectLocationState(store.getState()) === 'undefined') {
    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
  }

  var initialLocation = void 0;
  var isTimeTraveling = void 0;
  var unsubscribeFromStore = void 0;
  var unsubscribeFromHistory = void 0;
  var currentLocation = void 0;

  // What does the store say about current location?
  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
    var locationState = selectLocationState(store.getState());
    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
  };

  // Init initialLocation with potential location in store
  initialLocation = getLocationInStore();

  // If the store is replayed, update the URL in the browser to match.
  if (adjustUrlOnReplay) {
    var handleStoreChange = function handleStoreChange() {
      var locationInStore = getLocationInStore(true);
      if (currentLocation === locationInStore || initialLocation === locationInStore) {
        return;
      }

      // Update address bar to reflect store state
      isTimeTraveling = true;
      currentLocation = locationInStore;
      history.transitionTo(_extends({}, locationInStore, {
        action: 'PUSH'
      }));
      isTimeTraveling = false;
    };

    unsubscribeFromStore = store.subscribe(handleStoreChange);
    handleStoreChange();
  }

  // Whenever location changes, dispatch an action to get it in the store
  var handleLocationChange = function handleLocationChange(location) {
    // ... unless we just caused that location change
    if (isTimeTraveling) {
      return;
    }

    // Remember where we are
    currentLocation = location;

    // Are we being called for the first time?
    if (!initialLocation) {
      // Remember as a fallback in case state is reset
      initialLocation = location;

      // Respect persisted location, if any
      if (getLocationInStore()) {
        return;
      }
    }

    // Tell the store to update by dispatching an action
    store.dispatch({
      type: _reducer.LOCATION_CHANGE,
      payload: location
    });
  };
  unsubscribeFromHistory = history.listen(handleLocationChange);

  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
  if (history.getCurrentLocation) {
    handleLocationChange(history.getCurrentLocation());
  }

  // The enhanced history uses store as source of truth
  return _extends({}, history, {
    // The listeners are subscribed to the store instead of history
    listen: function listen(listener) {
      // Copy of last location.
      var lastPublishedLocation = getLocationInStore(true);

      // Keep track of whether we unsubscribed, as Redux store
      // only applies changes in subscriptions on next dispatch
      var unsubscribed = false;
      var unsubscribeFromStore = store.subscribe(function () {
        var currentLocation = getLocationInStore(true);
        if (currentLocation === lastPublishedLocation) {
          return;
        }
        lastPublishedLocation = currentLocation;
        if (!unsubscribed) {
          listener(lastPublishedLocation);
        }
      });

      // History 2.x listeners expect a synchronous call. Make the first call to the
      // listener after subscribing to the store, in case the listener causes a
      // location change (e.g. when it redirects)
      if (!history.getCurrentLocation) {
        listener(lastPublishedLocation);
      }

      // Let user unsubscribe later
      return function () {
        unsubscribed = true;
        unsubscribeFromStore();
      };
    },


    // It also provides a way to destroy internal listeners
    unsubscribe: function unsubscribe() {
      if (adjustUrlOnReplay) {
        unsubscribeFromStore();
      }
      unsubscribeFromHistory();
    }
  });
}

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Link = __webpack_require__(658);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */
var IndexLink = _react2.default.createClass({
  displayName: 'IndexLink',
  render: function render() {
    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
  }
});

exports.default = IndexLink;
module.exports = exports['default'];

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _routerWarning = __webpack_require__(173);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _invariant = __webpack_require__(36);

var _invariant2 = _interopRequireDefault(_invariant);

var _Redirect = __webpack_require__(660);

var _Redirect2 = _interopRequireDefault(_Redirect);

var _InternalPropTypes = __webpack_require__(216);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _React$PropTypes = _react2.default.PropTypes,
    string = _React$PropTypes.string,
    object = _React$PropTypes.object;

/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */
/* eslint-disable react/require-render-return */

var IndexRedirect = _react2.default.createClass({
  displayName: 'IndexRedirect',


  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
      } else {
         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    to: string.isRequired,
    query: object,
    state: object,
    onEnter: _InternalPropTypes.falsy,
    children: _InternalPropTypes.falsy
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
  }
});

exports.default = IndexRedirect;
module.exports = exports['default'];

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _routerWarning = __webpack_require__(173);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _invariant = __webpack_require__(36);

var _invariant2 = _interopRequireDefault(_invariant);

var _RouteUtils = __webpack_require__(104);

var _InternalPropTypes = __webpack_require__(216);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var func = _react2.default.PropTypes.func;

/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */
/* eslint-disable react/require-render-return */

var IndexRoute = _react2.default.createClass({
  displayName: 'IndexRoute',


  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
      } else {
         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    path: _InternalPropTypes.falsy,
    component: _InternalPropTypes.component,
    components: _InternalPropTypes.components,
    getComponent: func,
    getComponents: func
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
  }
});

exports.default = IndexRoute;
module.exports = exports['default'];

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(36);

var _invariant2 = _interopRequireDefault(_invariant);

var _RouteUtils = __webpack_require__(104);

var _InternalPropTypes = __webpack_require__(216);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _React$PropTypes = _react2.default.PropTypes,
    string = _React$PropTypes.string,
    func = _React$PropTypes.func;

/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */
/* eslint-disable react/require-render-return */

var Route = _react2.default.createClass({
  displayName: 'Route',


  statics: {
    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
  },

  propTypes: {
    path: string,
    component: _InternalPropTypes.component,
    components: _InternalPropTypes.components,
    getComponent: func,
    getComponents: func
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
  }
});

exports.default = Route;
module.exports = exports['default'];

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(36);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createTransitionManager2 = __webpack_require__(664);

var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);

var _InternalPropTypes = __webpack_require__(216);

var _RouterContext = __webpack_require__(407);

var _RouterContext2 = _interopRequireDefault(_RouterContext);

var _RouteUtils = __webpack_require__(104);

var _RouterUtils = __webpack_require__(661);

var _routerWarning = __webpack_require__(173);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _React$PropTypes = _react2.default.PropTypes,
    func = _React$PropTypes.func,
    object = _React$PropTypes.object;

/**
 * A <Router> is a high-level API for automatically setting up
 * a router that renders a <RouterContext> with all the props
 * it needs each time the URL changes.
 */

var Router = _react2.default.createClass({
  displayName: 'Router',


  propTypes: {
    history: object,
    children: _InternalPropTypes.routes,
    routes: _InternalPropTypes.routes, // alias for children
    render: func,
    createElement: func,
    onError: func,
    onUpdate: func,

    // PRIVATE: For client-side rehydration of server match.
    matchContext: object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return _react2.default.createElement(_RouterContext2.default, props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  createRouterObject: function createRouterObject(state) {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.router;
    }

    var history = this.props.history;

    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
  },
  createTransitionManager: function createTransitionManager() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.transitionManager;
    }

    var history = this.props.history;
    var _props = this.props,
        routes = _props.routes,
        children = _props.children;


    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v2.x or ' + 'earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please upgrade to history v3.x.') : (0, _invariant2.default)(false) : void 0;

    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    this.transitionManager = this.createTransitionManager();
    this.router = this.createRouterObject(this.state);

    this._unlisten = this.transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        // Keep the identity of this.router because of a caveat in ContextUtils:
        // they only work if the object identity is preserved.
        (0, _RouterUtils.assignRouterState)(_this.router, state);
        _this.setState(state, _this.props.onUpdate);
      }
    });
  },


  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state,
        location = _state.location,
        routes = _state.routes,
        params = _state.params,
        components = _state.components;

    var _props2 = this.props,
        createElement = _props2.createElement,
        render = _props2.render,
        props = _objectWithoutProperties(_props2, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(Router.propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

exports.default = Router;
module.exports = exports['default'];

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.runEnterHooks = runEnterHooks;
exports.runChangeHooks = runChangeHooks;
exports.runLeaveHooks = runLeaveHooks;

var _AsyncUtils = __webpack_require__(404);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PendingHooks = function PendingHooks() {
  var _this = this;

  _classCallCheck(this, PendingHooks);

  this.hooks = [];

  this.add = function (hook) {
    return _this.hooks.push(hook);
  };

  this.remove = function (hook) {
    return _this.hooks = _this.hooks.filter(function (h) {
      return h !== hook;
    });
  };

  this.has = function (hook) {
    return _this.hooks.indexOf(hook) !== -1;
  };

  this.clear = function () {
    return _this.hooks = [];
  };
};

var enterHooks = new PendingHooks();
var changeHooks = new PendingHooks();

function createTransitionHook(hook, route, asyncArity, pendingHooks) {
  var isSync = hook.length < asyncArity;

  var transitionHook = function transitionHook() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    hook.apply(route, args);

    if (isSync) {
      var callback = args[args.length - 1];
      // Assume hook executes synchronously and
      // automatically call the callback.
      callback();
    }
  };

  pendingHooks.add(transitionHook);

  return transitionHook;
}

function getEnterHooks(routes) {
  return routes.reduce(function (hooks, route) {
    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
    return hooks;
  }, []);
}

function getChangeHooks(routes) {
  return routes.reduce(function (hooks, route) {
    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
    return hooks;
  }, []);
}

function runTransitionHooks(length, iter, callback) {
  if (!length) {
    callback();
    return;
  }

  var redirectInfo = void 0;
  function replace(location) {
    redirectInfo = location;
  }

  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
    iter(index, replace, function (error) {
      if (error || redirectInfo) {
        done(error, redirectInfo); // No need to continue.
      } else {
        next();
      }
    });
  }, callback);
}

/**
 * Runs all onEnter hooks in the given array of routes in order
 * with onEnter(nextState, replace, callback) and calls
 * callback(error, redirectInfo) when finished. The first hook
 * to use replace short-circuits the loop.
 *
 * If a hook needs to run asynchronously, it may use the callback
 * function. However, doing so will cause the transition to pause,
 * which could lead to a non-responsive UI if the hook is slow.
 */
function runEnterHooks(routes, nextState, callback) {
  enterHooks.clear();
  var hooks = getEnterHooks(routes);
  return runTransitionHooks(hooks.length, function (index, replace, next) {
    var wrappedNext = function wrappedNext() {
      if (enterHooks.has(hooks[index])) {
        next();
        enterHooks.remove(hooks[index]);
      }
    };
    hooks[index](nextState, replace, wrappedNext);
  }, callback);
}

/**
 * Runs all onChange hooks in the given array of routes in order
 * with onChange(prevState, nextState, replace, callback) and calls
 * callback(error, redirectInfo) when finished. The first hook
 * to use replace short-circuits the loop.
 *
 * If a hook needs to run asynchronously, it may use the callback
 * function. However, doing so will cause the transition to pause,
 * which could lead to a non-responsive UI if the hook is slow.
 */
function runChangeHooks(routes, state, nextState, callback) {
  changeHooks.clear();
  var hooks = getChangeHooks(routes);
  return runTransitionHooks(hooks.length, function (index, replace, next) {
    var wrappedNext = function wrappedNext() {
      if (changeHooks.has(hooks[index])) {
        next();
        changeHooks.remove(hooks[index]);
      }
    };
    hooks[index](state, nextState, replace, wrappedNext);
  }, callback);
}

/**
 * Runs all onLeave hooks in the given array of routes in order.
 */
function runLeaveHooks(routes, prevState) {
  for (var i = 0, len = routes.length; i < len; ++i) {
    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
  }
}

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _RouterContext = __webpack_require__(407);

var _RouterContext2 = _interopRequireDefault(_RouterContext);

var _routerWarning = __webpack_require__(173);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  if (false) {
    middlewares.forEach(function (middleware, index) {
      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
    });
  }

  var withContext = middlewares.map(function (middleware) {
    return middleware.renderRouterContext;
  }).filter(Boolean);
  var withComponent = middlewares.map(function (middleware) {
    return middleware.renderRouteComponent;
  }).filter(Boolean);

  var makeCreateElement = function makeCreateElement() {
    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
    return function (Component, props) {
      return withComponent.reduceRight(function (previous, renderRouteComponent) {
        return renderRouteComponent(previous, props);
      }, baseCreateElement(Component, props));
    };
  };

  return function (renderProps) {
    return withContext.reduceRight(function (previous, renderRouterContext) {
      return renderRouterContext(previous, renderProps);
    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
      createElement: makeCreateElement(renderProps.createElement)
    })));
  };
};

module.exports = exports['default'];

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createBrowserHistory = __webpack_require__(1571);

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

var _createRouterHistory = __webpack_require__(663);

var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
module.exports = exports['default'];

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _PatternUtils = __webpack_require__(172);

function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = (0, _PatternUtils.getParamNames)(route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    (function () {
      var parentIsLeaving = false;
      leaveRoutes = prevRoutes.filter(function (route) {
        if (parentIsLeaving) {
          return true;
        } else {
          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
          if (isLeaving) parentIsLeaving = true;
          return isLeaving;
        }
      });

      // onLeave hooks start at the leaf route.
      leaveRoutes.reverse();

      enterRoutes = [];
      changeRoutes = [];

      nextRoutes.forEach(function (route) {
        var isNew = prevRoutes.indexOf(route) === -1;
        var paramsChanged = leaveRoutes.indexOf(route) !== -1;

        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
      });
    })();
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

exports.default = computeChangedRoutes;
module.exports = exports['default'];

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AsyncUtils = __webpack_require__(404);

var _PromiseUtils = __webpack_require__(659);

function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (getComponent) {
    var componentReturn = getComponent.call(route, nextState, callback);
    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
      return callback(null, component);
    }, callback);
  } else {
    callback();
  }
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

exports.default = getComponents;
module.exports = exports['default'];

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _PatternUtils = __webpack_require__(172);

/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

exports.default = getRouteParams;
module.exports = exports['default'];

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createHashHistory = __webpack_require__(1572);

var _createHashHistory2 = _interopRequireDefault(_createHashHistory);

var _createRouterHistory = __webpack_require__(663);

var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
module.exports = exports['default'];

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isActive;

var _PatternUtils = __webpack_require__(172);

function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname,
      query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}
module.exports = exports['default'];

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Actions = __webpack_require__(277);

var _invariant = __webpack_require__(36);

var _invariant2 = _interopRequireDefault(_invariant);

var _createMemoryHistory = __webpack_require__(662);

var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);

var _createTransitionManager = __webpack_require__(664);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _RouteUtils = __webpack_require__(104);

var _RouterUtils = __webpack_require__(661);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history,
      routes = _ref.routes,
      location = _ref.location,
      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;

  history = history ? history : (0, _createMemoryHistory2.default)(options);
  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    location = history.getCurrentLocation();
  }

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    var renderProps = void 0;

    if (nextState) {
      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
      renderProps = _extends({}, nextState, {
        router: router,
        matchContext: { transitionManager: transitionManager, router: router }
      });
    }

    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
  });
}

exports.default = match;
module.exports = exports['default'];

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = matchRoutes;

var _AsyncUtils = __webpack_require__(404);

var _PromiseUtils = __webpack_require__(659);

var _PatternUtils = __webpack_require__(172);

var _routerWarning = __webpack_require__(173);

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _RouteUtils = __webpack_require__(104);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
  }, callback);

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
    });

    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
    }, callback);
  } else if (route.childRoutes) {
    (function () {
      var pathless = route.childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    })();
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var _ret2 = function () {
        var match = {
          routes: [route],
          params: createParams(paramNames, paramValues)
        };

        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
          if (error) {
            callback(error);
          } else {
            if (Array.isArray(indexRoute)) {
              var _match$routes;

               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
                return !route.path;
              }), 'Index routes should not have paths') : void 0;
              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
            } else if (indexRoute) {
               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
              match.routes.push(indexRoute);
            }

            callback(null, match);
          }
        });

        return {
          v: void 0
        };
      }();

      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}
module.exports = exports['default'];

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = withRouter;

var _invariant = __webpack_require__(36);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = __webpack_require__(356);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _ContextUtils = __webpack_require__(405);

var _PropTypes = __webpack_require__(406);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withRouter(WrappedComponent, options) {
  var withRef = options && options.withRef;

  var WithRouter = _react2.default.createClass({
    displayName: 'WithRouter',

    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],

    contextTypes: { router: _PropTypes.routerShape },
    propTypes: { router: _PropTypes.routerShape },

    getWrappedInstance: function getWrappedInstance() {
      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;

      return this.wrappedInstance;
    },
    render: function render() {
      var _this = this;

      var router = this.props.router || this.context.router;
      var params = router.params,
          location = router.location,
          routes = router.routes;

      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });

      if (withRef) {
        props.ref = function (c) {
          _this.wrappedInstance = c;
        };
      }

      return _react2.default.createElement(WrappedComponent, props);
    }
  });

  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
  WithRouter.WrappedComponent = WrappedComponent;

  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
}
module.exports = exports['default'];

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var isSync = false,
      hasNext = false,
      doneArgs = void 0;

  var done = function done() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    isDone = true;

    if (isSync) {
      // Iterate instead of recursing if possible.
      doneArgs = args;
      return;
    }

    callback.apply(undefined, args);
  };

  var next = function next() {
    if (isDone) return;

    hasNext = true;

    if (isSync) return; // Iterate instead of recursing if possible.

    isSync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work(currentTurn++, next, done);
    }

    isSync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(undefined, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  };

  next();
};

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(408);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _warning = __webpack_require__(107);

var _warning2 = _interopRequireDefault(_warning);

var _LocationUtils = __webpack_require__(174);

var _DOMUtils = __webpack_require__(278);

var _DOMStateStorage = __webpack_require__(666);

var _PathUtils = __webpack_require__(105);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
  var path = pathCoder.decodePath(getHashPath());
  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);

  var state = void 0;
  if (key) {
    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
    state = (0, _DOMStateStorage.readState)(key);
  }

  var init = (0, _PathUtils.parsePath)(path);
  init.state = state;

  return (0, _LocationUtils.createLocation)(init, undefined, key);
};

var prevLocation = void 0;

var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = pathCoder.encodePath(path);

    if (path !== encodedPath) {
      // Always be sure we have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var currentLocation = getCurrentLocation(pathCoder, queryKey);

      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events

      prevLocation = currentLocation;

      listener(currentLocation);
    }
  };

  // Ensure the hash is encoded properly.
  var path = getHashPath();
  var encodedPath = pathCoder.encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
  };
};

var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
  var state = location.state,
      key = location.key;


  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));

  if (state !== undefined) {
    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
    (0, _DOMStateStorage.saveState)(key, state);
  }

  prevLocation = location;

  updateHash(path);
};

var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) {
      pushHashPath(path);
    } else {
       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
    }
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) replaceHashPath(path);
  });
};

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(408);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _LocationUtils = __webpack_require__(174);

var _PathUtils = __webpack_require__(105);

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  return (0, _LocationUtils.createLocation)(window.location);
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  window.location.href = (0, _PathUtils.createPath)(location);
  return false; // Don't update location
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  window.location.replace((0, _PathUtils.createPath)(location));
  return false; // Don't update location
};

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(36);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(409);

var _BrowserProtocol = __webpack_require__(408);

var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);

var _RefreshProtocol = __webpack_require__(1570);

var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);

var _DOMUtils = __webpack_require__(278);

var _createHistory = __webpack_require__(410);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve clean URLs. You can force this
 * behavior using { forceRefresh: true } in options.
 */
var createBrowserHistory = function createBrowserHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;

  var getUserConfirmation = Protocol.getUserConfirmation,
      getCurrentLocation = Protocol.getCurrentLocation,
      pushLocation = Protocol.pushLocation,
      replaceLocation = Protocol.replaceLocation,
      go = Protocol.go;


  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen
  });
};

exports.default = createBrowserHistory;

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(107);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(36);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(409);

var _DOMUtils = __webpack_require__(278);

var _HashProtocol = __webpack_require__(1569);

var HashProtocol = _interopRequireWildcard(_HashProtocol);

var _createHistory = __webpack_require__(410);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultQueryKey = '_k';

var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!' + path;
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substring(1) : path;
    }
  },
  noslash: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '/' ? path.substring(1) : path;
    },
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

var createHashHistory = function createHashHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var queryKey = options.queryKey,
      hashType = options.hashType;


   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;

  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;

  if (hashType == null) hashType = 'slash';

  if (!(hashType in HashPathCoders)) {
     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;

    hashType = 'slash';
  }

  var pathCoder = HashPathCoders[hashType];

  var getUserConfirmation = HashProtocol.getUserConfirmation;


  var getCurrentLocation = function getCurrentLocation() {
    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
  };

  var pushLocation = function pushLocation(location) {
    return HashProtocol.pushLocation(location, pathCoder, queryKey);
  };

  var replaceLocation = function replaceLocation(location) {
    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
  };

  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: HashProtocol.go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var go = function go(n) {
     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;

    history.go(n);
  };

  var createHref = function createHref(path) {
    return '#' + pathCoder.encodePath(history.createHref(path));
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    go: go,
    createHref: createHref
  });
};

exports.default = createHashHistory;

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(107);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(36);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(174);

var _PathUtils = __webpack_require__(105);

var _createHistory = __webpack_require__(410);

var _createHistory2 = _interopRequireDefault(_createHistory);

var _Actions = __webpack_require__(277);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createStateStorage = function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
};

var createMemoryHistory = function createMemoryHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var getCurrentLocation = function getCurrentLocation() {
    var entry = entries[current];
    var path = (0, _PathUtils.createPath)(entry);

    var key = void 0,
        state = void 0;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    }

    var init = (0, _PathUtils.parsePath)(path);

    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
  };

  var canGo = function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  };

  var go = function go(n) {
    if (!n) return;

    if (!canGo(n)) {
       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;

      return;
    }

    current += n;
    var currentLocation = getCurrentLocation();

    // Change action to POP
    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
  };

  var pushLocation = function pushLocation(location) {
    current += 1;

    if (current < entries.length) entries.splice(current);

    entries.push(location);

    saveState(location.key, location.state);
  };

  var replaceLocation = function replaceLocation(location) {
    entries[current] = location;
    saveState(location.key, location.state);
  };

  var history = (0, _createHistory2.default)(_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var _options = options,
      entries = _options.entries,
      current = _options.current;


  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    return (0, _LocationUtils.createLocation)(entry);
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
  }

  var storage = createStateStorage(entries);

  var saveState = function saveState(key, state) {
    return storage[key] = state;
  };

  var readState = function readState(key) {
    return storage[key];
  };

  return _extends({}, history, {
    canGo: canGo
  });
};

exports.default = createMemoryHistory;

/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Async", function() { return Async; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AsyncCreatable", function() { return AsyncCreatableSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Creatable", function() { return CreatableSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Value", function() { return Value; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Option", function() { return Option; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultMenuRenderer", function() { return menuRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultArrowRenderer", function() { return arrowRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultClearRenderer", function() { return clearRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultFilterOptions", function() { return filterOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize__ = __webpack_require__(1536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);






var arrowRenderer = function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-arrow',
		onMouseDown: onMouseDown
	});
};

arrowRenderer.propTypes = {
	onMouseDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

var clearRenderer = function clearRenderer() {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
};

var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

var stripDiacritics = function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
};

var trim = function trim(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var isValid = function isValid(value) {
	return typeof value !== 'undefined' && value !== null && value !== '';
};

var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
	if (props.ignoreAccents) {
		filterValue = stripDiacritics(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (props.trimFilter) {
		filterValue = trim(filterValue);
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
		if (!filterValue) return true;

		var value = option[props.valueKey];
		var label = option[props.labelKey];
		var hasValue = isValid(value);
		var hasLabel = isValid(label);

		if (!hasValue && !hasLabel) {
			return false;
		}

		var valueTest = hasValue ? String(value) : null;
		var labelTest = hasLabel ? String(label) : null;

		if (props.ignoreAccents) {
			if (valueTest && props.matchProp !== 'label') valueTest = stripDiacritics(valueTest);
			if (labelTest && props.matchProp !== 'value') labelTest = stripDiacritics(labelTest);
		}

		if (props.ignoreCase) {
			if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}

		return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
};

var menuRenderer = function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption,
	    focusOption = _ref.focusOption,
	    inputValue = _ref.inputValue,
	    instancePrefix = _ref.instancePrefix,
	    onFocus = _ref.onFocus,
	    onOptionRef = _ref.onOptionRef,
	    onSelect = _ref.onSelect,
	    optionClassName = _ref.optionClassName,
	    optionComponent = _ref.optionComponent,
	    optionRenderer = _ref.optionRenderer,
	    options = _ref.options,
	    removeValue = _ref.removeValue,
	    selectValue = _ref.selectValue,
	    valueArray = _ref.valueArray,
	    valueKey = _ref.valueKey;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.some(function (x) {
			return x[valueKey] === option[valueKey];
		});
		var isFocused = option === focusedOption;
		var optionClass = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
			Option,
			{
				className: optionClass,
				focusOption: focusOption,
				inputValue: inputValue,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function ref(_ref2) {
					onOptionRef(_ref2, isFocused);
				},
				removeValue: removeValue,
				selectValue: selectValue
			},
			optionRenderer(option, i, inputValue)
		);
	});
};

menuRenderer.propTypes = {
	focusOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	focusedOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
	inputValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onOptionRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	removeValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	selectValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	valueArray: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

var blockEvent = (function (event) {
	event.preventDefault();
	event.stopPropagation();
	if (event.target.tagName !== 'A' || !('href' in event.target)) {
		return;
	}
	if (event.target.target) {
		window.open(event.target.href, event.target.target);
	} else {
		window.location.href = event.target.href;
	}
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Option = function (_React$Component) {
	inherits(Option, _React$Component);

	function Option(props) {
		classCallCheck(this, Option);

		var _this = possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
		_this.handleMouseMove = _this.handleMouseMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.onFocus = _this.onFocus.bind(_this);
		return _this;
	}

	createClass(Option, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		}
	}, {
		key: 'handleMouseEnter',
		value: function handleMouseEnter(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleMouseMove',
		value: function handleMouseMove(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'onFocus',
		value: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    option = _props.option,
			    instancePrefix = _props.instancePrefix,
			    optionIndex = _props.optionIndex;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(this.props.className, option.className);

			return option.disabled ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					onMouseDown: blockEvent,
					onClick: blockEvent },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					style: option.style,
					role: 'option',
					'aria-label': option.label,
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					id: instancePrefix + '-option-' + optionIndex,
					title: option.title },
				this.props.children
			);
		}
	}]);
	return Option;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Option.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className (based on mouse position)
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired, // unique prefix for the ids (used for aria)
	isDisabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is disabled
	isFocused: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is focused
	isSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is selected
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseEnter on option element
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on option element
	onUnfocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseLeave on option element
	option: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, // object that is base for that option
	optionIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number // index of the option, used to generate unique ids for aria
};

var Value = function (_React$Component) {
	inherits(Value, _React$Component);

	function Value(props) {
		classCallCheck(this, Value);

		var _this = possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.onRemove = _this.onRemove.bind(_this);
		_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		return _this;
	}

	createClass(Value, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		}
	}, {
		key: 'onRemove',
		value: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		}
	}, {
		key: 'handleTouchEndRemove',
		value: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.onRemove(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'renderRemoveIcon',
		value: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-value-icon',
					'aria-hidden': 'true',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'\xD7'
			);
		}
	}, {
		key: 'renderLabel',
		value: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
				this.props.children
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-value', this.props.value.disabled ? 'Select-value-disabled' : '', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	}]);
	return Value;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Value.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // disabled prop passed to ReactSelect
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // Unique id for the value - used for aria
	onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on value label
	onRemove: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle removal of the value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired // the option object for this value
};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/react-select
*/
var stringifyValue = function stringifyValue(value) {
	return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
};

var stringOrNode = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]);
var stringOrNumber = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]);

var instanceId = 1;

var shouldShowValue = function shouldShowValue(state, props) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	if (!inputValue) return true;

	if (!onSelectResetsInput) {
		return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
	}

	return false;
};

var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
};

/**
 * Retrieve a value from the given options and valueKey
 * @param {String|Number|Array} value	- the selected value(s)
 * @param {Object}		 props	- the Select component's props (or nextProps)
 */
var expandValue = function expandValue(value, props) {
	var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
	var options = props.options,
	    valueKey = props.valueKey;

	if (!options) return;
	for (var i = 0; i < options.length; i++) {
		if (String(options[i][valueKey]) === String(value)) return options[i];
	}
};

var handleRequired = function handleRequired(value, multi) {
	if (!value) return true;
	return multi ? value.length === 0 : Object.keys(value).length === 0;
};

var Select$1 = function (_React$Component) {
	inherits(Select, _React$Component);

	function Select(props) {
		classCallCheck(this, Select);

		var _this = possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

		['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
			return _this[fn] = _this[fn].bind(_this);
		});

		_this.state = {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
		return _this;
	}

	createClass(Select, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
			var valueArray = this.getValueArray(this.props.value);

			if (this.props.required) {
				this.setState({
					required: handleRequired(valueArray[0], this.props.multi)
				});
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
				console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
			}
			if (this.props.autoFocus || this.props.autofocus) {
				this.focus();
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var valueArray = this.getValueArray(nextProps.value, nextProps);

			if (nextProps.required) {
				this.setState({
					required: handleRequired(valueArray[0], nextProps.multi)
				});
			} else if (this.props.required) {
				// Used to be required but it's not any more
				this.setState({ required: false });
			}

			if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
				this.setState({ inputValue: this.handleInputValueChange('') });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);

				var scrollTop = menuNode.scrollTop;
				var scrollBottom = scrollTop + menuNode.offsetHeight;
				var optionTop = focusedOptionNode.offsetTop;
				var optionBottom = optionTop + focusedOptionNode.offsetHeight;

				if (scrollTop > optionTop || scrollBottom < optionBottom) {
					menuNode.scrollTop = focusedOptionNode.offsetTop;
				}

				// We still set hasScrolledToOption to true even if we didn't
				// actually need to scroll, as we've still confirmed that the
				// option is in view.
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}

			if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuDOM = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				} else if (focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop;
				}
			}
			if (this.props.scrollMenuIntoView && this.menuContainer) {
				var menuContainerRect = this.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
				this.closeMenu();
			}
			if (prevState.isOpen !== this.state.isOpen) {
				this.toggleTouchOutsideEvent(this.state.isOpen);
				var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
				handler && handler();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.toggleTouchOutsideEvent(false);
		}
	}, {
		key: 'toggleTouchOutsideEvent',
		value: function toggleTouchOutsideEvent(enabled) {
			var eventTogglerName = enabled ? document.addEventListener ? 'addEventListener' : 'attachEvent' : document.removeEventListener ? 'removeEventListener' : 'detachEvent';
			var pref = document.addEventListener ? '' : 'on';

			document[eventTogglerName](pref + 'touchstart', this.handleTouchOutside);
			document[eventTogglerName](pref + 'mousedown', this.handleTouchOutside);
		}
	}, {
		key: 'handleTouchOutside',
		value: function handleTouchOutside(event) {
			// handle touch outside on ios to dismiss menu
			if (this.wrapper && !this.wrapper.contains(event.target)) {
				this.closeMenu();
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			if (!this.input) return;
			this.input.focus();
		}
	}, {
		key: 'blurInput',
		value: function blurInput() {
			if (!this.input) return;
			this.input.blur();
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchEndClearValue',
		value: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Clear the value
			this.clearValue(event);
		}
	}, {
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (event.target.tagName === 'INPUT') {
				if (!this.state.isFocused) {
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
				} else if (!this.state.isOpen) {
					this.setState({
						isOpen: true,
						isPseudoFocused: false,
						focusedOption: null
					});
				}

				return;
			}

			// prevent default event handlers
			event.preventDefault();

			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen,
					focusedOption: null
				});
			}

			if (this.state.isFocused) {
				// On iOS, we can get into a state where we think the input is focused but it isn't really,
				// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
				// Call focus() again here to be safe.
				this.focus();

				var input = this.input;
				var toOpen = true;

				if (typeof input.getInput === 'function') {
					// Get the actual DOM input if the ref is an <AutosizeInput /> component
					input = input.getInput();
				}

				// clears the value so that the cursor will be at the end of input when the component re-renders
				input.value = '';

				if (this._focusAfterClear) {
					toOpen = false;
					this._focusAfterClear = false;
				}

				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: toOpen,
					isPseudoFocused: false,
					focusedOption: null
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = this.props.openOnClick;
				this.focus();
				this.setState({ focusedOption: null });
			}
		}
	}, {
		key: 'handleMouseDownOnArrow',
		value: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (this.state.isOpen) {
				// prevent default event handlers
				event.stopPropagation();
				event.preventDefault();
				// close the menu
				this.closeMenu();
			} else {
				// If the menu isn't open, let the event bubble to the main handleMouseDown
				this.setState({
					isOpen: true
				});
			}
		}
	}, {
		key: 'handleMouseDownOnMenu',
		value: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.stopPropagation();
			event.preventDefault();

			this._openAfterFocus = true;
			this.focus();
		}
	}, {
		key: 'closeMenu',
		value: function closeMenu() {
			if (this.props.onCloseResetsInput) {
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			} else {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			}
			this.hasScrolledToOption = false;
		}
	}, {
		key: 'handleInputFocus',
		value: function handleInputFocus(event) {
			if (this.props.disabled) return;

			var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
			toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.

			if (this.props.onFocus) {
				this.props.onFocus(event);
			}

			this.setState({
				isFocused: true,
				isOpen: !!toOpen
			});

			this._focusAfterClear = false;
			this._openAfterFocus = false;
		}
	}, {
		key: 'handleInputBlur',
		value: function handleInputBlur(event) {
			// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
			if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
				this.focus();
				return;
			}

			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = this.handleInputValueChange('');
			}
			this.setState(onBlurredState);
		}
	}, {
		key: 'handleInputChange',
		value: function handleInputChange(event) {
			var newInputValue = event.target.value;

			if (this.state.inputValue !== event.target.value) {
				newInputValue = this.handleInputValueChange(newInputValue);
			}

			this.setState({
				inputValue: newInputValue,
				isOpen: true,
				isPseudoFocused: false
			});
		}
	}, {
		key: 'setInputValue',
		value: function setInputValue(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			this.setState({
				inputValue: newValue
			});
		}
	}, {
		key: 'handleInputValueChange',
		value: function handleInputValueChange(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				// Note: != used deliberately here to catch undefined and null
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			return newValue;
		}
	}, {
		key: 'handleKeyDown',
		value: function handleKeyDown(event) {
			if (this.props.disabled) return;

			if (typeof this.props.onInputKeyDown === 'function') {
				this.props.onInputKeyDown(event);
				if (event.defaultPrevented) {
					return;
				}
			}

			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
						break;
					}
					event.preventDefault();
					this.selectFocusedOption();
					break;
				case 13:
					// enter
					event.preventDefault();
					event.stopPropagation();
					if (this.state.isOpen) {
						this.selectFocusedOption();
					} else {
						this.focusNextOption();
					}
					break;
				case 27:
					// escape
					event.preventDefault();
					if (this.state.isOpen) {
						this.closeMenu();
						event.stopPropagation();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
						event.stopPropagation();
					}
					break;
				case 32:
					// space
					if (this.props.searchable) {
						break;
					}
					event.preventDefault();
					if (!this.state.isOpen) {
						this.focusNextOption();
						break;
					}
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 38:
					// up
					event.preventDefault();
					this.focusPreviousOption();
					break;
				case 40:
					// down
					event.preventDefault();
					this.focusNextOption();
					break;
				case 33:
					// page up
					event.preventDefault();
					this.focusPageUpOption();
					break;
				case 34:
					// page down
					event.preventDefault();
					this.focusPageDownOption();
					break;
				case 35:
					// end key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusEndOption();
					break;
				case 36:
					// home key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusStartOption();
					break;
				case 46:
					// delete
					if (!this.state.inputValue && this.props.deleteRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
			}
		}
	}, {
		key: 'handleValueClick',
		value: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		}
	}, {
		key: 'handleMenuScroll',
		value: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;

			if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
				this.props.onMenuScrollToBottom();
			}
		}
	}, {
		key: 'getOptionLabel',
		value: function getOptionLabel(op) {
			return op[this.props.labelKey];
		}

		/**
   * Turns a value into an array from the given options
   * @param {String|Number|Array} value		- the value of the select input
   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
   * @returns	{Array}	the value of the select represented in an array
   */

	}, {
		key: 'getValueArray',
		value: function getValueArray(value) {
			var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

			/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
			var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
			if (props.multi) {
				if (typeof value === 'string') {
					value = value.split(props.delimiter);
				}
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(function (value) {
					return expandValue(value, props);
				}).filter(function (i) {
					return i;
				});
			}
			var expandedValue = expandValue(value, props);
			return expandedValue ? [expandedValue] : [];
		}
	}, {
		key: 'setValue',
		value: function setValue(value) {
			var _this2 = this;

			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (this.props.required) {
				var required = handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.simpleValue && value) {
				value = this.props.multi ? value.map(function (i) {
					return i[_this2.props.valueKey];
				}).join(this.props.delimiter) : value[this.props.valueKey];
			}
			if (this.props.onChange) {
				this.props.onChange(value);
			}
		}
	}, {
		key: 'selectValue',
		value: function selectValue(value) {
			var _this3 = this;

			// NOTE: we actually add/set the value in a callback to make sure the
			// input value is empty to avoid styling issues in Chrome
			if (this.props.closeOnSelect) {
				this.hasScrolledToOption = false;
			}
			var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
			if (this.props.multi) {
				this.setState({
					focusedIndex: null,
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect
				}, function () {
					var valueArray = _this3.getValueArray(_this3.props.value);
					if (valueArray.some(function (i) {
						return i[_this3.props.valueKey] === value[_this3.props.valueKey];
					})) {
						_this3.removeValue(value);
					} else {
						_this3.addValue(value);
					}
				});
			} else {
				this.setState({
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect,
					isPseudoFocused: this.state.isFocused
				}, function () {
					_this3.setValue(value);
				});
			}
		}
	}, {
		key: 'addValue',
		value: function addValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			var visibleOptions = this._visibleOptions.filter(function (val) {
				return !val.disabled;
			});
			var lastValueIndex = visibleOptions.indexOf(value);
			this.setValue(valueArray.concat(value));
			if (!this.props.closeOnSelect) {
				return;
			}
			if (visibleOptions.length - 1 === lastValueIndex) {
				// the last option was selected; focus the second-last one
				this.focusOption(visibleOptions[lastValueIndex - 1]);
			} else if (visibleOptions.length > lastValueIndex) {
				// focus the option below the selected one
				this.focusOption(visibleOptions[lastValueIndex + 1]);
			}
		}
	}, {
		key: 'popValue',
		value: function popValue() {
			var valueArray = this.getValueArray(this.props.value);
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
		}
	}, {
		key: 'removeValue',
		value: function removeValue(value) {
			var _this4 = this;

			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.filter(function (i) {
				return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
			}));
			this.focus();
		}
	}, {
		key: 'clearValue',
		value: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.preventDefault();

			this.setValue(this.getResetValue());
			this.setState({
				inputValue: this.handleInputValueChange(''),
				isOpen: false
			}, this.focus);

			this._focusAfterClear = true;
		}
	}, {
		key: 'getResetValue',
		value: function getResetValue() {
			if (this.props.resetValue !== undefined) {
				return this.props.resetValue;
			} else if (this.props.multi) {
				return [];
			} else {
				return null;
			}
		}
	}, {
		key: 'focusOption',
		value: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		}
	}, {
		key: 'focusNextOption',
		value: function focusNextOption() {
			this.focusAdjacentOption('next');
		}
	}, {
		key: 'focusPreviousOption',
		value: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		}
	}, {
		key: 'focusPageUpOption',
		value: function focusPageUpOption() {
			this.focusAdjacentOption('page_up');
		}
	}, {
		key: 'focusPageDownOption',
		value: function focusPageDownOption() {
			this.focusAdjacentOption('page_down');
		}
	}, {
		key: 'focusStartOption',
		value: function focusStartOption() {
			this.focusAdjacentOption('start');
		}
	}, {
		key: 'focusEndOption',
		value: function focusEndOption() {
			this.focusAdjacentOption('end');
		}
	}, {
		key: 'focusAdjacentOption',
		value: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.map(function (option, index) {
				return { option: option, index: index };
			}).filter(function (option) {
				return !option.option.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				var newState = {
					focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
					isOpen: true
				};
				if (this.props.onSelectResetsInput) {
					newState.inputValue = '';
				}
				this.setState(newState);
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i].option) {
					focusedIndex = i;
					break;
				}
			}
			if (dir === 'next' && focusedIndex !== -1) {
				focusedIndex = (focusedIndex + 1) % options.length;
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedIndex = focusedIndex - 1;
				} else {
					focusedIndex = options.length - 1;
				}
			} else if (dir === 'start') {
				focusedIndex = 0;
			} else if (dir === 'end') {
				focusedIndex = options.length - 1;
			} else if (dir === 'page_up') {
				var potentialIndex = focusedIndex - this.props.pageSize;
				if (potentialIndex < 0) {
					focusedIndex = 0;
				} else {
					focusedIndex = potentialIndex;
				}
			} else if (dir === 'page_down') {
				var _potentialIndex = focusedIndex + this.props.pageSize;
				if (_potentialIndex > options.length - 1) {
					focusedIndex = options.length - 1;
				} else {
					focusedIndex = _potentialIndex;
				}
			}

			if (focusedIndex === -1) {
				focusedIndex = 0;
			}

			this.setState({
				focusedIndex: options[focusedIndex].index,
				focusedOption: options[focusedIndex].option
			});
		}
	}, {
		key: 'getFocusedOption',
		value: function getFocusedOption() {
			return this._focusedOption;
		}
	}, {
		key: 'selectFocusedOption',
		value: function selectFocusedOption() {
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		}
	}, {
		key: 'renderLoading',
		value: function renderLoading() {
			if (!this.props.isLoading) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: 'Select-loading' })
			);
		}
	}, {
		key: 'renderValue',
		value: function renderValue(valueArray, isOpen) {
			var _this5 = this;

			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
				return showPlaceholder ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						ValueComponent,
						{
							disabled: _this5.props.disabled || value.clearableValue === false,
							id: _this5._instancePrefix + '-value-' + i,
							instancePrefix: _this5._instancePrefix,
							key: 'value-' + i + '-' + value[_this5.props.valueKey],
							onClick: onClick,
							onRemove: _this5.removeValue,
							placeholder: _this5.props.placeholder,
							value: value,
							values: valueArray
						},
						renderLabel(value, i),
						__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
							'span',
							{ className: 'Select-aria-only' },
							'\xA0'
						)
					);
				});
			} else if (shouldShowValue(this.state, this.props)) {
				if (isOpen) onClick = null;
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					ValueComponent,
					{
						disabled: this.props.disabled,
						id: this._instancePrefix + '-value-item',
						instancePrefix: this._instancePrefix,
						onClick: onClick,
						placeholder: this.props.placeholder,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		}
	}, {
		key: 'renderInput',
		value: function renderInput(valueArray, focusedOptionIndex) {
			var _classNames,
			    _this6 = this;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-input', this.props.inputProps.className);
			var isOpen = this.state.isOpen;

			var ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames = {}, defineProperty(_classNames, this._instancePrefix + '-list', isOpen), defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

			var value = this.state.inputValue;
			if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
				// it hides input value when it is not focused and was not reset on select
				value = '';
			}

			var inputProps = _extends({}, this.props.inputProps, {
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				'aria-describedby': this.props['aria-describedby'],
				'aria-expanded': '' + isOpen,
				'aria-haspopup': '' + isOpen,
				'aria-label': this.props['aria-label'],
				'aria-labelledby': this.props['aria-labelledby'],
				'aria-owns': ariaOwns,
				onBlur: this.handleInputBlur,
				onChange: this.handleInputChange,
				onFocus: this.handleInputFocus,
				ref: function ref(_ref) {
					return _this6.input = _ref;
				},
				role: 'combobox',
				required: this.state.required,
				tabIndex: this.props.tabIndex,
				value: value
			});

			if (this.props.inputRenderer) {
				return this.props.inputRenderer(inputProps);
			}

			if (this.props.disabled || !this.props.searchable) {
				var divProps = objectWithoutProperties(this.props.inputProps, []);


				var _ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(defineProperty({}, this._instancePrefix + '-list', isOpen));
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', _extends({}, divProps, {
					'aria-expanded': isOpen,
					'aria-owns': _ariaOwns,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-disabled': '' + this.props.disabled,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					className: className,
					onBlur: this.handleInputBlur,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref2) {
						return _this6.input = _ref2;
					},
					role: 'combobox',
					style: { border: 0, width: 1, display: 'inline-block' },
					tabIndex: this.props.tabIndex || 0
				}));
			}

			if (this.props.autosize) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default.a, _extends({ id: this.props.id }, inputProps, { className: className, minWidth: '5' }));
			}
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', _extends({ id: this.props.id }, inputProps))
			);
		}
	}, {
		key: 'renderClear',
		value: function renderClear() {
			var valueArray = this.getValueArray(this.props.value);
			if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
			var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
			var clear = this.props.clearRenderer();

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					'aria-label': ariaLabel,
					className: 'Select-clear-zone',
					onMouseDown: this.clearValue,
					onTouchEnd: this.handleTouchEndClearValue,
					onTouchMove: this.handleTouchMove,
					onTouchStart: this.handleTouchStart,
					title: ariaLabel
				},
				clear
			);
		}
	}, {
		key: 'renderArrow',
		value: function renderArrow() {
			if (!this.props.arrowRenderer) return;

			var onMouseDown = this.handleMouseDownOnArrow;
			var isOpen = this.state.isOpen;
			var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

			if (!arrow) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					className: 'Select-arrow-zone',
					onMouseDown: onMouseDown
				},
				arrow
			);
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1(excludeOptions) {
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (this.props.filterOptions) {
				// Maintain backwards compatibility with boolean attribute
				var filterOptions$$1 = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : filterOptions;

				return filterOptions$$1(options, filterValue, excludeOptions, {
					filterOption: this.props.filterOption,
					ignoreAccents: this.props.ignoreAccents,
					ignoreCase: this.props.ignoreCase,
					labelKey: this.props.labelKey,
					matchPos: this.props.matchPos,
					matchProp: this.props.matchProp,
					trimFilter: this.props.trimFilter,
					valueKey: this.props.valueKey
				});
			} else {
				return options;
			}
		}
	}, {
		key: 'onOptionRef',
		value: function onOptionRef(ref, isFocused) {
			if (isFocused) {
				this.focused = ref;
			}
		}
	}, {
		key: 'renderMenu',
		value: function renderMenu(options, valueArray, focusedOption) {
			if (options && options.length) {
				return this.props.menuRenderer({
					focusedOption: focusedOption,
					focusOption: this.focusOption,
					inputValue: this.state.inputValue,
					instancePrefix: this._instancePrefix,
					labelKey: this.props.labelKey,
					onFocus: this.focusOption,
					onOptionRef: this.onOptionRef,
					onSelect: this.selectValue,
					optionClassName: this.props.optionClassName,
					optionComponent: this.props.optionComponent,
					optionRenderer: this.props.optionRenderer || this.getOptionLabel,
					options: options,
					removeValue: this.removeValue,
					selectValue: this.selectValue,
					valueArray: valueArray,
					valueKey: this.props.valueKey
				});
			} else if (this.props.noResultsText) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		}
	}, {
		key: 'renderHiddenField',
		value: function renderHiddenField(valueArray) {
			var _this7 = this;

			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this7.props.valueKey]);
				}).join(this.props.delimiter);
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: this.props.disabled,
					name: this.props.name,
					ref: function ref(_ref3) {
						return _this7.value = _ref3;
					},
					type: 'hidden',
					value: value
				});
			}
			return valueArray.map(function (item, index) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: _this7.props.disabled,
					key: 'hidden.' + index,
					name: _this7.props.name,
					ref: 'value' + index,
					type: 'hidden',
					value: stringifyValue(item[_this7.props.valueKey])
				});
			});
		}
	}, {
		key: 'getFocusableOptionIndex',
		value: function getFocusableOptionIndex(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return null;

			var valueKey = this.props.valueKey;
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && !focusedOption.disabled) {
				var focusedOptionIndex = -1;
				options.some(function (option, index) {
					var isOptionEqual = option[valueKey] === focusedOption[valueKey];
					if (isOptionEqual) {
						focusedOptionIndex = index;
					}
					return isOptionEqual;
				});
				if (focusedOptionIndex !== -1) {
					return focusedOptionIndex;
				}
			}

			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return i;
			}
			return null;
		}
	}, {
		key: 'renderOuter',
		value: function renderOuter(options, valueArray, focusedOption) {
			var _this8 = this;

			var menu = this.renderMenu(options, valueArray, focusedOption);
			if (!menu) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref5) {
						return _this8.menuContainer = _ref5;
					}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{
						className: 'Select-menu',
						id: this._instancePrefix + '-list',
						onMouseDown: this.handleMouseDownOnMenu,
						onScroll: this.handleMenuScroll,
						ref: function ref(_ref4) {
							return _this8.menu = _ref4;
						},
						role: 'listbox',
						style: this.props.menuStyle,
						tabIndex: -1
					},
					menu
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this9 = this;

			var valueArray = this.getValueArray(this.props.value);
			var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

			var focusedOption = null;
			if (focusedOptionIndex !== null) {
				focusedOption = this._focusedOption = options[focusedOptionIndex];
			} else {
				focusedOption = this._focusedOption = null;
			}
			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select', this.props.className, {
				'has-value': valueArray.length,
				'is-clearable': this.props.clearable,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'Select--multi': this.props.multi,
				'Select--rtl': this.props.rtl,
				'Select--single': !this.props.multi
			});

			var removeMessage = null;
			if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
				removeMessage = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'span',
					{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
					this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
				);
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref7) {
						return _this9.wrapper = _ref7;
					},
					className: className,
					style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ ref: function ref(_ref6) {
							return _this9.control = _ref6;
						},
						className: 'Select-control',
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						style: this.props.style
					},
					__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						'div',
						{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
						this.renderValue(valueArray, isOpen),
						this.renderInput(valueArray, focusedOptionIndex)
					),
					removeMessage,
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
			);
		}
	}]);
	return Select;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Select$1.propTypes = {
	'aria-describedby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
	'aria-label': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // aria label (for assistive tech)
	'aria-labelledby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id of an element that should be used as the label (for assistive tech)
	arrowRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create the drop-down caret element
	autoBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // automatically blur the component when an option is selected
	autoFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // autofocus the component on mount
	autofocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // deprecated; use autoFocus instead
	autosize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable autosizing or not
	backspaceRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether backspace removes an item if there is no text input
	backspaceToRemoveMessage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className for the outer element
	clearAllText: stringOrNode, // title for the "clear" control when multi: true
	clearRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create clearable x element
	clearValueText: stringOrNode, // title for the "clear" control
	clearable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // should it be possible to reset value
	closeOnSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to close the menu when a value is selected
	deleteRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether delete removes an item if there is no text input
	delimiter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // delimiter to use to join multiple values for the hidden field value
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is disabled or not
	escapeClearsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether escape clears the value when the menu is closed
	filterOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to filter a single option (option, filterString)
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id to set on the input element for accessibility or tests
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to strip diacritics when filtering
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to perform case-insensitive filtering
	inputProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // custom attributes for the Input
	inputRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // returns a custom input component
	instanceId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // set the components instanceId
	isLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is loading externally or not (such as options being loaded)
	joinValues: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
	labelKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	matchPos: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|start) match the start or entire string when filtering
	matchProp: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|label|value) which option property to filter on
	menuBuffer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
	menuContainerStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu container
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // renders a custom menu with options
	menuStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // generates a hidden <input /> tag with this field name for html forms
	noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
	onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onBlur handler: function (event) {}
	onBlurResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on blur
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is closed
	onCloseResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared when menu is closed through the arrow
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onFocus handler: function (event) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onInputChange handler: function (inputValue) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // input keyDown handler: function (event) {}
	onMenuScrollToBottom: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
	onOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is opened
	onSelectResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on select (works only for multiselect)
	onValueClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onClick handler for value labels: function (value, event) {}
	openOnClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to control opening the menu when the control is clicked
	openOnFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // always open options menu on focus
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // additional class(es) to apply to the <Option /> elements
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // option component to render in dropdown
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optionRenderer: function (option) {}
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, // array of options
	pageSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // number of entries to page when using page up/down keys
	placeholder: stringOrNode, // field placeholder, displayed when there's no value
	removeSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the selected option is removed from the dropdown on multi selects
	required: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // applies HTML5 required attribute when needed
	resetValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // value to use when you clear the control
	rtl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // set to true in order to use react-select in right-to-left direction
	scrollMenuIntoView: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
	searchable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable searching feature or not
	simpleValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
	style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the control
	tabIndex: stringOrNumber, // optional tab index of the control
	tabSelectsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to treat tabbing out while focused to be value selection
	trimFilter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to trim whitespace around filter value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // initial field value
	valueComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // value component to render
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	valueRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // valueRenderer: function (option) {}
	wrapperStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object // optional style to apply to the component wrapper
};

Select$1.defaultProps = {
	arrowRenderer: arrowRenderer,
	autosize: true,
	backspaceRemoves: true,
	backspaceToRemoveMessage: 'Press backspace to remove {label}',
	clearable: true,
	clearAllText: 'Clear all',
	clearRenderer: clearRenderer,
	clearValueText: 'Clear value',
	closeOnSelect: true,
	deleteRemoves: true,
	delimiter: ',',
	disabled: false,
	escapeClearsValue: true,
	filterOptions: filterOptions,
	ignoreAccents: true,
	ignoreCase: true,
	inputProps: {},
	isLoading: false,
	joinValues: false,
	labelKey: 'label',
	matchPos: 'any',
	matchProp: 'any',
	menuBuffer: 0,
	menuRenderer: menuRenderer,
	multi: false,
	noResultsText: 'No results found',
	onBlurResetsInput: true,
	onCloseResetsInput: true,
	onSelectResetsInput: true,
	openOnClick: true,
	optionComponent: Option,
	pageSize: 5,
	placeholder: 'Select...',
	removeSelected: true,
	required: false,
	rtl: false,
	scrollMenuIntoView: true,
	searchable: true,
	simpleValue: false,
	tabSelectsValue: true,
	trimFilter: true,
	valueComponent: Value,
	valueKey: 'value'
};

var propTypes = {
	autoload: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // object to use to cache results; set to null/false to disable caching
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // strip diacritics when filtering; defaults to true
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // perform case-insensitive filtering; defaults to true
	loadOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	loadingPlaceholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// replaces the placeholder while options are loading
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	noResultsText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field noResultsText, displayed when no options come back from the server
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optional for keeping track of what is being typed
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired, // array of options
	placeholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	searchPromptText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// label to prompt for search input
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any // initial field value
};

var defaultCache = {};

var defaultChildren = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = function (_Component) {
	inherits(Async, _Component);

	function Async(props, context) {
		classCallCheck(this, Async);

		var _this = possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));

		_this._cache = props.cache === defaultCache ? {} : props.cache;

		_this.state = {
			inputValue: '',
			isLoading: false,
			options: props.options
		};

		_this.onInputChange = _this.onInputChange.bind(_this);
		return _this;
	}

	createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;


			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.options !== this.props.options) {
				this.setState({
					options: nextProps.options
				});
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this._callback = null;
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
				this._callback = null;

				this.setState({
					isLoading: false,
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				var options = data && data.options || [];

				if (cache) {
					cache[inputValue] = options;
				}

				if (callback === _this2._callback) {
					_this2._callback = null;

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(inputValue) {
			var _props = this.props,
			    ignoreAccents = _props.ignoreAccents,
			    ignoreCase = _props.ignoreCase,
			    onInputChange = _props.onInputChange;

			var newInputValue = inputValue;

			if (onInputChange) {
				var value = onInputChange(newInputValue);
				// Note: != used deliberately here to catch undefined and null
				if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
					newInputValue = '' + value;
				}
			}

			var transformedInputValue = newInputValue;

			if (ignoreAccents) {
				transformedInputValue = stripDiacritics(transformedInputValue);
			}

			if (ignoreCase) {
				transformedInputValue = transformedInputValue.toLowerCase();
			}

			this.setState({ inputValue: newInputValue });
			this.loadOptions(transformedInputValue);

			// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
			return newInputValue;
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props,
			    loadingPlaceholder = _props2.loadingPlaceholder,
			    noResultsText = _props2.noResultsText,
			    searchPromptText = _props2.searchPromptText;
			var _state = this.state,
			    inputValue = _state.inputValue,
			    isLoading = _state.isLoading;


			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props,
			    children = _props3.children,
			    loadingPlaceholder = _props3.loadingPlaceholder,
			    placeholder = _props3.placeholder;
			var _state2 = this.state,
			    isLoading = _state2.isLoading,
			    options = _state2.options;


			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this.onInputChange
			}));
		}
	}]);
	return Async;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

var CreatableSelect = function (_React$Component) {
	inherits(CreatableSelect, _React$Component);

	function CreatableSelect(props, context) {
		classCallCheck(this, CreatableSelect);

		var _this = possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));

		_this.filterOptions = _this.filterOptions.bind(_this);
		_this.menuRenderer = _this.menuRenderer.bind(_this);
		_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
		_this.onInputChange = _this.onInputChange.bind(_this);
		_this.onOptionSelect = _this.onOptionSelect.bind(_this);
		return _this;
	}

	createClass(CreatableSelect, [{
		key: 'createNewOption',
		value: function createNewOption() {
			var _props = this.props,
			    isValidNewOption = _props.isValidNewOption,
			    newOptionCreator = _props.newOptionCreator,
			    onNewOptionClick = _props.onNewOptionClick,
			    _props$options = _props.options,
			    options = _props$options === undefined ? [] : _props$options;


			if (isValidNewOption({ label: this.inputValue })) {
				var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
				var _isOptionUnique = this.isOptionUnique({ option: option, options: options });

				// Don't add the same option twice.
				if (_isOptionUnique) {
					if (onNewOptionClick) {
						onNewOptionClick(option);
					} else {
						options.unshift(option);

						this.select.selectValue(option);
					}
				}
			}
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1() {
			var _props2 = this.props,
			    filterOptions$$1 = _props2.filterOptions,
			    isValidNewOption = _props2.isValidNewOption,
			    promptTextCreator = _props2.promptTextCreator,
			    showNewOptionAtTop = _props2.showNewOptionAtTop;

			// TRICKY Check currently selected options as well.
			// Don't display a create-prompt for a value that's selected.
			// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.

			var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];

			var filteredOptions = filterOptions$$1.apply(undefined, arguments) || [];

			if (isValidNewOption({ label: this.inputValue })) {
				var _newOptionCreator = this.props.newOptionCreator;


				var option = _newOptionCreator({
					label: this.inputValue,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
				// For multi-selects, this would remove it from the filtered list.
				var _isOptionUnique2 = this.isOptionUnique({
					option: option,
					options: excludeOptions.concat(filteredOptions)
				});

				if (_isOptionUnique2) {
					var prompt = promptTextCreator(this.inputValue);

					this._createPlaceholderOption = _newOptionCreator({
						label: prompt,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});

					if (showNewOptionAtTop) {
						filteredOptions.unshift(this._createPlaceholderOption);
					} else {
						filteredOptions.push(this._createPlaceholderOption);
					}
				}
			}

			return filteredOptions;
		}
	}, {
		key: 'isOptionUnique',
		value: function isOptionUnique(_ref) {
			var option = _ref.option,
			    options = _ref.options;
			var isOptionUnique = this.props.isOptionUnique;


			options = options || this.props.options;

			return isOptionUnique({
				labelKey: this.labelKey,
				option: option,
				options: options,
				valueKey: this.valueKey
			});
		}
	}, {
		key: 'menuRenderer',
		value: function menuRenderer$$1(params) {
			var menuRenderer$$1 = this.props.menuRenderer;


			return menuRenderer$$1(_extends({}, params, {
				onSelect: this.onOptionSelect,
				selectValue: this.onOptionSelect
			}));
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(input) {
			var onInputChange = this.props.onInputChange;

			// This value may be needed in between Select mounts (when this.select is null)

			this.inputValue = input;

			if (onInputChange) {
				this.inputValue = onInputChange(input);
			}

			return this.inputValue;
		}
	}, {
		key: 'onInputKeyDown',
		value: function onInputKeyDown(event) {
			var _props3 = this.props,
			    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
			    onInputKeyDown = _props3.onInputKeyDown;

			var focusedOption = this.select.getFocusedOption();

			if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption(event)) {
				this.createNewOption();

				// Prevent decorated Select from doing anything additional with this keyDown event
				event.preventDefault();
			} else if (onInputKeyDown) {
				onInputKeyDown(event);
			}
		}
	}, {
		key: 'onOptionSelect',
		value: function onOptionSelect(option) {
			if (option === this._createPlaceholderOption) {
				this.createNewOption();
			} else {
				this.select.selectValue(option);
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props4 = this.props,
			    refProp = _props4.ref,
			    restProps = objectWithoutProperties(_props4, ['ref']);
			var children = this.props.children;

			// We can't use destructuring default values to set the children,
			// because it won't apply work if `children` is null. A falsy check is
			// more reliable in real world use-cases.

			if (!children) {
				children = defaultChildren$2;
			}

			var props = _extends({}, restProps, {
				allowCreate: true,
				filterOptions: this.filterOptions,
				menuRenderer: this.menuRenderer,
				onInputChange: this.onInputChange,
				onInputKeyDown: this.onInputKeyDown,
				ref: function ref(_ref2) {
					_this2.select = _ref2;

					// These values may be needed in between Select mounts (when this.select is null)
					if (_ref2) {
						_this2.labelKey = _ref2.props.labelKey;
						_this2.valueKey = _ref2.props.valueKey;
					}
					if (refProp) {
						refProp(_ref2);
					}
				}
			});

			return children(props);
		}
	}]);
	return CreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$2 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var isOptionUnique = function isOptionUnique(_ref3) {
	var option = _ref3.option,
	    options = _ref3.options,
	    labelKey = _ref3.labelKey,
	    valueKey = _ref3.valueKey;

	if (!options || !options.length) {
		return true;
	}

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
};

var isValidNewOption = function isValidNewOption(_ref4) {
	var label = _ref4.label;
	return !!label;
};

var newOptionCreator = function newOptionCreator(_ref5) {
	var label = _ref5.label,
	    labelKey = _ref5.labelKey,
	    valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';

	return option;
};

var promptTextCreator = function promptTextCreator(label) {
	return 'Create option "' + label + '"';
};

var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
		default:
			return false;
	}
};

// Default prop methods
CreatableSelect.isOptionUnique = isOptionUnique;
CreatableSelect.isValidNewOption = isValidNewOption;
CreatableSelect.newOptionCreator = newOptionCreator;
CreatableSelect.promptTextCreator = promptTextCreator;
CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;

CreatableSelect.defaultProps = {
	filterOptions: filterOptions,
	isOptionUnique: isOptionUnique,
	isValidNewOption: isValidNewOption,
	menuRenderer: menuRenderer,
	newOptionCreator: newOptionCreator,
	promptTextCreator: promptTextCreator,
	shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
	showNewOptionAtTop: true
};

CreatableSelect.propTypes = {
	// Child function responsible for creating the inner Select component
	// This component can be used to compose HOCs (eg Creatable and Async)
	// (props: Object): PropTypes.element
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.filterOptions
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Searches for any matching option within the set of options.
	// This function prevents duplicate options from being created.
	// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
	isOptionUnique: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Determines if the current input text represents a valid option.
	// ({ label: string }): boolean
	isValidNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.menuRenderer
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Factory to create new option.
	// ({ label: string, labelKey: string, valueKey: string }): Object
	newOptionCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input change handler: function (inputValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input keyDown handler: function (event) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// new option click handler: function (option) {}
	onNewOptionClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.options
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,

	// Creates prompt/placeholder option text.
	// (filterText: string): string
	promptTextCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	ref: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
	shouldKeyDownEventCreateNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Where to show prompt/placeholder option text.
	// true: new option prompt at top of list (default)
	// false: new option prompt at bottom of list
	showNewOptionAtTop: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};

var AsyncCreatableSelect = function (_React$Component) {
	inherits(AsyncCreatableSelect, _React$Component);

	function AsyncCreatableSelect() {
		classCallCheck(this, AsyncCreatableSelect);
		return possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
	}

	createClass(AsyncCreatableSelect, [{
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				Async,
				this.props,
				function (_ref) {
					var ref = _ref.ref,
					    asyncProps = objectWithoutProperties(_ref, ['ref']);

					var asyncRef = ref;
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						CreatableSelect,
						asyncProps,
						function (_ref2) {
							var ref = _ref2.ref,
							    creatableProps = objectWithoutProperties(_ref2, ['ref']);

							var creatableRef = ref;
							return _this2.props.children(_extends({}, creatableProps, {
								ref: function ref(select) {
									creatableRef(select);
									asyncRef(select);
									_this2.select = select;
								}
							}));
						}
					);
				}
			);
		}
	}]);
	return AsyncCreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$1 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

AsyncCreatableSelect.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
};

AsyncCreatableSelect.defaultProps = {
	children: defaultChildren$1
};

Select$1.Async = Async;
Select$1.AsyncCreatable = AsyncCreatableSelect;
Select$1.Creatable = CreatableSelect;
Select$1.Value = Value;
Select$1.Option = Option;


/* harmony default export */ __webpack_exports__["default"] = (Select$1);


/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSelect = __webpack_require__(1574);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _AutoSizer = __webpack_require__(1578);

var _AutoSizer2 = _interopRequireDefault(_AutoSizer);

var _List = __webpack_require__(1587);

var _List2 = _interopRequireDefault(_List);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Import directly to avoid Webpack bundling the parts of react-virtualized that we are not using


var VirtualizedSelect = function (_Component) {
  _inherits(VirtualizedSelect, _Component);

  function VirtualizedSelect(props, context) {
    _classCallCheck(this, VirtualizedSelect);

    var _this = _possibleConstructorReturn(this, (VirtualizedSelect.__proto__ || Object.getPrototypeOf(VirtualizedSelect)).call(this, props, context));

    _this._renderMenu = _this._renderMenu.bind(_this);
    _this._optionRenderer = _this._optionRenderer.bind(_this);
    _this._setListRef = _this._setListRef.bind(_this);
    _this._setSelectRef = _this._setSelectRef.bind(_this);
    return _this;
  }

  /** See List#recomputeRowHeights */


  _createClass(VirtualizedSelect, [{
    key: 'recomputeOptionHeights',
    value: function recomputeOptionHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this._listRef) {
        this._listRef.recomputeRowHeights(index);
      }
    }

    /** See Select#focus (in react-select) */

  }, {
    key: 'focus',
    value: function focus() {
      if (this._selectRef) {
        return this._selectRef.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var SelectComponent = this._getSelectComponent();

      return _react2.default.createElement(SelectComponent, _extends({}, this.props, {
        ref: this._setSelectRef,
        menuRenderer: this._renderMenu,
        menuStyle: { overflow: 'hidden' }
      }));
    }

    // See https://github.com/JedWatson/react-select/#effeciently-rendering-large-lists-with-windowing

  }, {
    key: '_renderMenu',
    value: function _renderMenu(_ref) {
      var _this2 = this;

      var focusedOption = _ref.focusedOption,
          focusOption = _ref.focusOption,
          labelKey = _ref.labelKey,
          onSelect = _ref.onSelect,
          options = _ref.options,
          selectValue = _ref.selectValue,
          valueArray = _ref.valueArray,
          valueKey = _ref.valueKey;
      var _props = this.props,
          listProps = _props.listProps,
          optionRenderer = _props.optionRenderer;

      var focusedOptionIndex = options.indexOf(focusedOption);
      var height = this._calculateListHeight({ options: options });
      var innerRowRenderer = optionRenderer || this._optionRenderer;

      // react-select 1.0.0-rc2 passes duplicate `onSelect` and `selectValue` props to `menuRenderer`
      // The `Creatable` HOC only overrides `onSelect` which breaks an edge-case
      // In order to support creating items via clicking on the placeholder option,
      // We need to ensure that the specified `onSelect` handle is the one we use.
      // See issue #33

      function wrappedRowRenderer(_ref2) {
        var index = _ref2.index,
            key = _ref2.key,
            style = _ref2.style;

        var option = options[index];

        return innerRowRenderer({
          focusedOption: focusedOption,
          focusedOptionIndex: focusedOptionIndex,
          focusOption: focusOption,
          key: key,
          labelKey: labelKey,
          onSelect: onSelect,
          option: option,
          optionIndex: index,
          options: options,
          selectValue: onSelect,
          style: style,
          valueArray: valueArray,
          valueKey: valueKey
        });
      }

      return _react2.default.createElement(
        _AutoSizer2.default,
        { disableHeight: true },
        function (_ref3) {
          var width = _ref3.width;
          return _react2.default.createElement(_List2.default, _extends({
            className: 'VirtualSelectGrid',
            height: height,
            ref: _this2._setListRef,
            rowCount: options.length,
            rowHeight: function rowHeight(_ref4) {
              var index = _ref4.index;
              return _this2._getOptionHeight({
                option: options[index]
              });
            },
            rowRenderer: wrappedRowRenderer,
            scrollToIndex: focusedOptionIndex,
            width: width
          }, listProps));
        }
      );
    }
  }, {
    key: '_calculateListHeight',
    value: function _calculateListHeight(_ref5) {
      var options = _ref5.options;
      var maxHeight = this.props.maxHeight;


      var height = 0;

      for (var optionIndex = 0; optionIndex < options.length; optionIndex++) {
        var option = options[optionIndex];

        height += this._getOptionHeight({ option: option });

        if (height > maxHeight) {
          return maxHeight;
        }
      }

      return height;
    }
  }, {
    key: '_getOptionHeight',
    value: function _getOptionHeight(_ref6) {
      var option = _ref6.option;
      var optionHeight = this.props.optionHeight;


      return optionHeight instanceof Function ? optionHeight({ option: option }) : optionHeight;
    }
  }, {
    key: '_getSelectComponent',
    value: function _getSelectComponent() {
      var _props2 = this.props,
          async = _props2.async,
          selectComponent = _props2.selectComponent;


      if (selectComponent) {
        return selectComponent;
      } else if (async) {
        return _reactSelect2.default.Async;
      } else {
        return _reactSelect2.default;
      }
    }
  }, {
    key: '_optionRenderer',
    value: function _optionRenderer(_ref7) {
      var focusedOption = _ref7.focusedOption,
          focusOption = _ref7.focusOption,
          key = _ref7.key,
          labelKey = _ref7.labelKey,
          option = _ref7.option,
          selectValue = _ref7.selectValue,
          style = _ref7.style,
          valueArray = _ref7.valueArray;

      var className = ['VirtualizedSelectOption'];

      if (option === focusedOption) {
        className.push('VirtualizedSelectFocusedOption');
      }

      if (option.disabled) {
        className.push('VirtualizedSelectDisabledOption');
      }

      if (valueArray && valueArray.indexOf(option) >= 0) {
        className.push('VirtualizedSelectSelectedOption');
      }

      if (option.className) {
        className.push(option.className);
      }

      var events = option.disabled ? {} : {
        onClick: function onClick() {
          return selectValue(option);
        },
        onMouseEnter: function onMouseEnter() {
          return focusOption(option);
        }
      };

      return _react2.default.createElement(
        'div',
        _extends({
          className: className.join(' '),
          key: key,
          style: style,
          title: option.title
        }, events),
        option[labelKey]
      );
    }
  }, {
    key: '_setListRef',
    value: function _setListRef(ref) {
      this._listRef = ref;
    }
  }, {
    key: '_setSelectRef',
    value: function _setSelectRef(ref) {
      this._selectRef = ref;
    }
  }]);

  return VirtualizedSelect;
}(_react.Component);

VirtualizedSelect.propTypes = {
  async: _propTypes2.default.bool,
  listProps: _propTypes2.default.object,
  maxHeight: _propTypes2.default.number,
  optionHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
  optionRenderer: _propTypes2.default.func,
  selectComponent: _propTypes2.default.func
};
VirtualizedSelect.defaultProps = {
  async: false,
  maxHeight: 200,
  optionHeight: 35
};
exports.default = VirtualizedSelect;

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _VirtualizedSelect = __webpack_require__(1575);

var _VirtualizedSelect2 = _interopRequireDefault(_VirtualizedSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _VirtualizedSelect2.default;

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(61);

var _interopRequireWildcard = __webpack_require__(182);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(179));

var _createClass2 = _interopRequireDefault(__webpack_require__(180));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(290));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(288));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(219));

var _inherits2 = _interopRequireDefault(__webpack_require__(289));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(181));

var React = _interopRequireWildcard(__webpack_require__(0));

var _detectElementResize = _interopRequireDefault(__webpack_require__(1591));

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _class, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var AutoSizer = (_temp = _class =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(AutoSizer, _React$Component);

  function AutoSizer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, AutoSizer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(AutoSizer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      height: _this.props.defaultHeight || 0,
      width: _this.props.defaultWidth || 0
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_parentNode", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_autoSizer", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_window", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_detectElementResize", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onResize", function () {
      var _this$props = _this.props,
          disableHeight = _this$props.disableHeight,
          disableWidth = _this$props.disableWidth,
          onResize = _this$props.onResize;

      if (_this._parentNode) {
        // Guard against AutoSizer component being removed from the DOM immediately after being added.
        // This can result in invalid style values which can result in NaN values if we don't handle them.
        // See issue #150 for more context.
        var height = _this._parentNode.offsetHeight || 0;
        var width = _this._parentNode.offsetWidth || 0;
        var win = _this._window || window;
        var style = win.getComputedStyle(_this._parentNode) || {};
        var paddingLeft = parseInt(style.paddingLeft, 10) || 0;
        var paddingRight = parseInt(style.paddingRight, 10) || 0;
        var paddingTop = parseInt(style.paddingTop, 10) || 0;
        var paddingBottom = parseInt(style.paddingBottom, 10) || 0;
        var newHeight = height - paddingTop - paddingBottom;
        var newWidth = width - paddingLeft - paddingRight;

        if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
          _this.setState({
            height: height - paddingTop - paddingBottom,
            width: width - paddingLeft - paddingRight
          });

          onResize({
            height: height,
            width: width
          });
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setRef", function (autoSizer) {
      _this._autoSizer = autoSizer;
    });
    return _this;
  }

  (0, _createClass2["default"])(AutoSizer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var nonce = this.props.nonce;

      if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
        // Delay access of parentNode until mount.
        // This handles edge-cases where the component has already been unmounted before its ref has been set,
        // As well as libraries like react-lite which have a slightly different lifecycle.
        this._parentNode = this._autoSizer.parentNode;
        this._window = this._autoSizer.parentNode.ownerDocument.defaultView; // Defer requiring resize handler in order to support server-side rendering.
        // See issue #41

        this._detectElementResize = (0, _detectElementResize["default"])(nonce, this._window);

        this._detectElementResize.addResizeListener(this._parentNode, this._onResize);

        this._onResize();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._detectElementResize && this._parentNode) {
        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          disableHeight = _this$props2.disableHeight,
          disableWidth = _this$props2.disableWidth,
          style = _this$props2.style;
      var _this$state = this.state,
          height = _this$state.height,
          width = _this$state.width; // Outer div should not force width/height since that may prevent containers from shrinking.
      // Inner component should overflow and use calculated width/height.
      // See issue #68 for more information.

      var outerStyle = {
        overflow: 'visible'
      };
      var childParams = {};

      if (!disableHeight) {
        outerStyle.height = 0;
        childParams.height = height;
      }

      if (!disableWidth) {
        outerStyle.width = 0;
        childParams.width = width;
      }
      /**
       * TODO: Avoid rendering children before the initial measurements have been collected.
       * At best this would just be wasting cycles.
       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
       * Note that if default width/height props were provided this would still work with SSR.
      if (
        height !== 0 &&
        width !== 0
      ) {
        child = children({ height, width })
      }
      */


      return React.createElement("div", {
        className: className,
        ref: this._setRef,
        style: _objectSpread({}, outerStyle, {}, style)
      }, children(childParams));
    }
  }]);
  return AutoSizer;
}(React.Component), (0, _defineProperty2["default"])(_class, "propTypes",  true ? null : {
  /** Function responsible for rendering children.*/
  "children": _propTypes["default"].func.isRequired,

  /** Optional custom CSS class name to attach to root AutoSizer element.  */
  "className": _propTypes["default"].string,

  /** Default height to use for initial render; useful for SSR */
  "defaultHeight": _propTypes["default"].number,

  /** Default width to use for initial render; useful for SSR */
  "defaultWidth": _propTypes["default"].number,

  /** Disable dynamic :height property */
  "disableHeight": _propTypes["default"].bool.isRequired,

  /** Disable dynamic :width property */
  "disableWidth": _propTypes["default"].bool.isRequired,

  /** Nonce of the inlined stylesheet for Content Security Policy */
  "nonce": _propTypes["default"].string,

  /** Callback to be invoked on-resize */
  "onResize": _propTypes["default"].func.isRequired,

  /** Optional inline style */
  "style": _propTypes["default"].object
}), _temp);
exports["default"] = AutoSizer;
(0, _defineProperty2["default"])(AutoSizer, "defaultProps", {
  onResize: function onResize() {},
  disableHeight: false,
  disableWidth: false,
  style: {}
});

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(61);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _AutoSizer["default"];
  }
});
Object.defineProperty(exports, "AutoSizer", {
  enumerable: true,
  get: function get() {
    return _AutoSizer["default"];
  }
});

var _AutoSizer = _interopRequireDefault(__webpack_require__(1577));

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(61);

var _interopRequireWildcard = __webpack_require__(182);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(419));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(179));

var _createClass2 = _interopRequireDefault(__webpack_require__(180));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(290));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(288));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(219));

var _inherits2 = _interopRequireDefault(__webpack_require__(289));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(181));

var React = _interopRequireWildcard(__webpack_require__(0));

var _clsx = _interopRequireDefault(__webpack_require__(461));

var _calculateSizeAndPositionDataAndUpdateScrollOffset = _interopRequireDefault(__webpack_require__(1583));

var _ScalingCellSizeAndPositionManager = _interopRequireDefault(__webpack_require__(412));

var _createCallbackMemoizer = _interopRequireDefault(__webpack_require__(1589));

var _defaultOverscanIndicesGetter = _interopRequireWildcard(__webpack_require__(671));

var _updateScrollIndexHelper = _interopRequireDefault(__webpack_require__(1585));

var _defaultCellRangeRenderer = _interopRequireDefault(__webpack_require__(670));

var _scrollbarSize = _interopRequireDefault(__webpack_require__(1593));

var _reactLifecyclesCompat = __webpack_require__(649);

var _requestAnimationTimeout = __webpack_require__(1590);

var _types = __webpack_require__(106);

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _class, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */

exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = DEFAULT_SCROLLING_RESET_TIME_INTERVAL;
var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

var renderNull = function renderNull() {
  return null;
};

/**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */
var Grid = (_temp = _class =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2["default"])(Grid, _React$PureComponent);

  // Invokes onSectionRendered callback only when start/stop row or column indices change
  function Grid(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Grid);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Grid).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onGridRenderedMemoizer", (0, _createCallbackMemoizer["default"])());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onScrollMemoizer", (0, _createCallbackMemoizer["default"])(false));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_deferredInvalidateColumnIndex", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_deferredInvalidateRowIndex", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_recomputeScrollLeftFlag", false);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_recomputeScrollTopFlag", false);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_horizontalScrollBarSize", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_verticalScrollBarSize", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_scrollbarPresenceChanged", false);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_scrollingContainer", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_childrenToDisplay", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_columnStartIndex", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_columnStopIndex", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_rowStartIndex", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_rowStopIndex", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderedColumnStartIndex", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderedColumnStopIndex", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderedRowStartIndex", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderedRowStopIndex", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_initialScrollTop", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_initialScrollLeft", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_disablePointerEventsTimeoutId", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_styleCache", {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_cellCache", {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_debounceScrollEndedCallback", function () {
      _this._disablePointerEventsTimeoutId = null; // isScrolling is used to determine if we reset styleCache

      _this.setState({
        isScrolling: false,
        needToResetStyleCache: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_invokeOnGridRenderedHelper", function () {
      var onSectionRendered = _this.props.onSectionRendered;

      _this._onGridRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          columnOverscanStartIndex: _this._columnStartIndex,
          columnOverscanStopIndex: _this._columnStopIndex,
          columnStartIndex: _this._renderedColumnStartIndex,
          columnStopIndex: _this._renderedColumnStopIndex,
          rowOverscanStartIndex: _this._rowStartIndex,
          rowOverscanStopIndex: _this._rowStopIndex,
          rowStartIndex: _this._renderedRowStartIndex,
          rowStopIndex: _this._renderedRowStopIndex
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setScrollingContainerRef", function (ref) {
      _this._scrollingContainer = ref;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onScroll", function (event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target === _this._scrollingContainer) {
        _this.handleScrollEvent(event.target);
      }
    });
    var columnSizeAndPositionManager = new _ScalingCellSizeAndPositionManager["default"]({
      cellCount: props.columnCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.columnWidth)(params);
      },
      estimatedCellSize: Grid._getEstimatedColumnSize(props)
    });
    var rowSizeAndPositionManager = new _ScalingCellSizeAndPositionManager["default"]({
      cellCount: props.rowCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.rowHeight)(params);
      },
      estimatedCellSize: Grid._getEstimatedRowSize(props)
    });
    _this.state = {
      instanceProps: {
        columnSizeAndPositionManager: columnSizeAndPositionManager,
        rowSizeAndPositionManager: rowSizeAndPositionManager,
        prevColumnWidth: props.columnWidth,
        prevRowHeight: props.rowHeight,
        prevColumnCount: props.columnCount,
        prevRowCount: props.rowCount,
        prevIsScrolling: props.isScrolling === true,
        prevScrollToColumn: props.scrollToColumn,
        prevScrollToRow: props.scrollToRow,
        scrollbarSize: 0,
        scrollbarSizeMeasured: false
      },
      isScrolling: false,
      scrollDirectionHorizontal: _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
      scrollDirectionVertical: _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
      scrollLeft: 0,
      scrollTop: 0,
      scrollPositionChangeReason: null,
      needToResetStyleCache: false
    };

    if (props.scrollToRow > 0) {
      _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
    }

    if (props.scrollToColumn > 0) {
      _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
    }

    return _this;
  }
  /**
   * Gets offsets for a given cell and alignment.
   */


  (0, _createClass2["default"])(Grid, [{
    key: "getOffsetForCell",
    value: function getOffsetForCell() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$alignment = _ref.alignment,
          alignment = _ref$alignment === void 0 ? this.props.scrollToAlignment : _ref$alignment,
          _ref$columnIndex = _ref.columnIndex,
          columnIndex = _ref$columnIndex === void 0 ? this.props.scrollToColumn : _ref$columnIndex,
          _ref$rowIndex = _ref.rowIndex,
          rowIndex = _ref$rowIndex === void 0 ? this.props.scrollToRow : _ref$rowIndex;

      var offsetProps = _objectSpread({}, this.props, {
        scrollToAlignment: alignment,
        scrollToColumn: columnIndex,
        scrollToRow: rowIndex
      });

      return {
        scrollLeft: this._getCalculatedScrollLeft(offsetProps),
        scrollTop: this._getCalculatedScrollTop(offsetProps)
      };
    }
    /**
     * Gets estimated total rows' height.
     */

  }, {
    key: "getTotalRowsHeight",
    value: function getTotalRowsHeight() {
      return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
    }
    /**
     * Gets estimated total columns' width.
     */

  }, {
    key: "getTotalColumnsWidth",
    value: function getTotalColumnsWidth() {
      return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
    }
    /**
     * This method handles a scroll event originating from an external scroll control.
     * It's an advanced method and should probably not be used unless you're implementing a custom scroll-bar solution.
     */

  }, {
    key: "handleScrollEvent",
    value: function handleScrollEvent(_ref2) {
      var _ref2$scrollLeft = _ref2.scrollLeft,
          scrollLeftParam = _ref2$scrollLeft === void 0 ? 0 : _ref2$scrollLeft,
          _ref2$scrollTop = _ref2.scrollTop,
          scrollTopParam = _ref2$scrollTop === void 0 ? 0 : _ref2$scrollTop;

      // On iOS, we can arrive at negative offsets by swiping past the start.
      // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
      if (scrollTopParam < 0) {
        return;
      } // Prevent pointer events from interrupting a smooth scroll


      this._debounceScrollEnded();

      var _this$props = this.props,
          autoHeight = _this$props.autoHeight,
          autoWidth = _this$props.autoWidth,
          height = _this$props.height,
          width = _this$props.width;
      var instanceProps = this.state.instanceProps; // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.

      var scrollbarSize = instanceProps.scrollbarSize;
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam); // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.

      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
        // Don't change direction for an axis unless scroll offset has changed.
        var scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionHorizontal;
        var scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionVertical;
        var newState = {
          isScrolling: true,
          scrollDirectionHorizontal: scrollDirectionHorizontal,
          scrollDirectionVertical: scrollDirectionVertical,
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED
        };

        if (!autoHeight) {
          newState.scrollTop = scrollTop;
        }

        if (!autoWidth) {
          newState.scrollLeft = scrollLeft;
        }

        newState.needToResetStyleCache = false;
        this.setState(newState);
      }

      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalColumnsWidth: totalColumnsWidth,
        totalRowsHeight: totalRowsHeight
      });
    }
    /**
     * Invalidate Grid size and recompute visible cells.
     * This is a deferred wrapper for recomputeGridSize().
     * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
     * This method is intended for advanced use-cases like CellMeasurer.
     */
    // @TODO (bvaughn) Add automated test coverage for this.

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref3) {
      var columnIndex = _ref3.columnIndex,
          rowIndex = _ref3.rowIndex;
      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }
    /**
     * Pre-measure all columns and rows in a Grid.
     * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
     * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
     */

  }, {
    key: "measureAllCells",
    value: function measureAllCells() {
      var _this$props2 = this.props,
          columnCount = _this$props2.columnCount,
          rowCount = _this$props2.rowCount;
      var instanceProps = this.state.instanceProps;
      instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
      instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
    }
    /**
     * Forced recompute of row heights and column widths.
     * This function should be called if dynamic column or row sizes have changed but nothing else has.
     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
     */

  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$columnIndex = _ref4.columnIndex,
          columnIndex = _ref4$columnIndex === void 0 ? 0 : _ref4$columnIndex,
          _ref4$rowIndex = _ref4.rowIndex,
          rowIndex = _ref4$rowIndex === void 0 ? 0 : _ref4$rowIndex;

      var _this$props3 = this.props,
          scrollToColumn = _this$props3.scrollToColumn,
          scrollToRow = _this$props3.scrollToRow;
      var instanceProps = this.state.instanceProps;
      instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
      instanceProps.rowSizeAndPositionManager.resetCell(rowIndex); // Cell sizes may be determined by a function property.
      // In this case the cDU handler can't know if they changed.
      // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.

      this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
      this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD ? rowIndex <= scrollToRow : rowIndex >= scrollToRow); // Clear cell cache in case we are scrolling;
      // Invalid row heights likely mean invalid cached content as well.

      this._styleCache = {};
      this._cellCache = {};
      this.forceUpdate();
    }
    /**
     * Ensure column and row are visible.
     */

  }, {
    key: "scrollToCell",
    value: function scrollToCell(_ref5) {
      var columnIndex = _ref5.columnIndex,
          rowIndex = _ref5.rowIndex;
      var columnCount = this.props.columnCount;
      var props = this.props; // Don't adjust scroll offset for single-column grids (eg List, Table).
      // This can cause a funky scroll offset because of the vertical scrollbar width.

      if (columnCount > 1 && columnIndex !== undefined) {
        this._updateScrollLeftForScrollToColumn(_objectSpread({}, props, {
          scrollToColumn: columnIndex
        }));
      }

      if (rowIndex !== undefined) {
        this._updateScrollTopForScrollToRow(_objectSpread({}, props, {
          scrollToRow: rowIndex
        }));
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props,
          getScrollbarSize = _this$props4.getScrollbarSize,
          height = _this$props4.height,
          scrollLeft = _this$props4.scrollLeft,
          scrollToColumn = _this$props4.scrollToColumn,
          scrollTop = _this$props4.scrollTop,
          scrollToRow = _this$props4.scrollToRow,
          width = _this$props4.width;
      var instanceProps = this.state.instanceProps; // Reset initial offsets to be ignored in browser

      this._initialScrollTop = 0;
      this._initialScrollLeft = 0; // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize(); // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.


      if (!instanceProps.scrollbarSizeMeasured) {
        this.setState(function (prevState) {
          var stateUpdate = _objectSpread({}, prevState, {
            needToResetStyleCache: false
          });

          stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
          stateUpdate.instanceProps.scrollbarSizeMeasured = true;
          return stateUpdate;
        });
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
        var stateUpdate = Grid._getScrollToPositionStateUpdate({
          prevState: this.state,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });

        if (stateUpdate) {
          stateUpdate.needToResetStyleCache = false;
          this.setState(stateUpdate);
        }
      } // refs don't work in `react-test-renderer`


      if (this._scrollingContainer) {
        // setting the ref's scrollLeft and scrollTop.
        // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
        if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) {
          this._scrollingContainer.scrollLeft = this.state.scrollLeft;
        }

        if (this._scrollingContainer.scrollTop !== this.state.scrollTop) {
          this._scrollingContainer.scrollTop = this.state.scrollTop;
        }
      } // Don't update scroll offset if the size is 0; we don't render any cells in this case.
      // Setting a state may cause us to later thing we've updated the offce when we haven't.


      var sizeIsBiggerThanZero = height > 0 && width > 0;

      if (scrollToColumn >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollLeftForScrollToColumn();
      }

      if (scrollToRow >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollTopForScrollToRow();
      } // Update onRowsRendered callback


      this._invokeOnGridRenderedHelper(); // Initialize onScroll callback


      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
        totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
      });

      this._maybeCallOnScrollbarPresenceChange();
    }
    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) New scroll-to-cell props have been set
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _this$props5 = this.props,
          autoHeight = _this$props5.autoHeight,
          autoWidth = _this$props5.autoWidth,
          columnCount = _this$props5.columnCount,
          height = _this$props5.height,
          rowCount = _this$props5.rowCount,
          scrollToAlignment = _this$props5.scrollToAlignment,
          scrollToColumn = _this$props5.scrollToColumn,
          scrollToRow = _this$props5.scrollToRow,
          width = _this$props5.width;
      var _this$state = this.state,
          scrollLeft = _this$state.scrollLeft,
          scrollPositionChangeReason = _this$state.scrollPositionChangeReason,
          scrollTop = _this$state.scrollTop,
          instanceProps = _this$state.instanceProps; // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize(); // Handle edge case where column or row count has only just increased over 0.
      // In this case we may have to restore a previously-specified scroll offset.
      // For more info see bvaughn/react-virtualized/issues/218


      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0; // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.

      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
        // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
        if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }

        if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      } // Special case where the previous size was 0:
      // In this case we don't show any windowed cells at all.
      // So we should always recalculate offset afterwards.


      var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0; // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?

      if (this._recomputeScrollLeftFlag) {
        this._recomputeScrollLeftFlag = false;

        this._updateScrollLeftForScrollToColumn(this.props);
      } else {
        (0, _updateScrollIndexHelper["default"])({
          cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          previousCellsCount: prevProps.columnCount,
          previousCellSize: prevProps.columnWidth,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToColumn,
          previousSize: prevProps.width,
          scrollOffset: scrollLeft,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToColumn,
          size: width,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollLeftForScrollToColumn(_this2.props);
          }
        });
      }

      if (this._recomputeScrollTopFlag) {
        this._recomputeScrollTopFlag = false;

        this._updateScrollTopForScrollToRow(this.props);
      } else {
        (0, _updateScrollIndexHelper["default"])({
          cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          previousCellsCount: prevProps.rowCount,
          previousCellSize: prevProps.rowHeight,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToRow,
          previousSize: prevProps.height,
          scrollOffset: scrollTop,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToRow,
          size: height,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollTopForScrollToRow(_this2.props);
          }
        });
      } // Update onRowsRendered callback if start/stop indices have changed


      this._invokeOnGridRenderedHelper(); // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners


      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();

        this._invokeOnScrollMemoizer({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          totalColumnsWidth: totalColumnsWidth,
          totalRowsHeight: totalRowsHeight
        });
      }

      this._maybeCallOnScrollbarPresenceChange();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        (0, _requestAnimationTimeout.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
      }
    }
    /**
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          autoContainerWidth = _this$props6.autoContainerWidth,
          autoHeight = _this$props6.autoHeight,
          autoWidth = _this$props6.autoWidth,
          className = _this$props6.className,
          containerProps = _this$props6.containerProps,
          containerRole = _this$props6.containerRole,
          containerStyle = _this$props6.containerStyle,
          height = _this$props6.height,
          id = _this$props6.id,
          noContentRenderer = _this$props6.noContentRenderer,
          role = _this$props6.role,
          style = _this$props6.style,
          tabIndex = _this$props6.tabIndex,
          width = _this$props6.width;
      var _this$state2 = this.state,
          instanceProps = _this$state2.instanceProps,
          needToResetStyleCache = _this$state2.needToResetStyleCache;

      var isScrolling = this._isScrolling();

      var gridStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        width: autoWidth ? 'auto' : width,
        WebkitOverflowScrolling: 'touch',
        willChange: 'transform'
      };

      if (needToResetStyleCache) {
        this._styleCache = {};
      } // calculate _styleCache here
      // if state.isScrolling (not from _isScrolling) then reset


      if (!this.state.isScrolling) {
        this._resetStyleCache();
      } // calculate children to render here


      this._calculateChildrenToRender(this.props, this.state);

      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize(); // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116

      var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
      var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;

      if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
        this._horizontalScrollBarSize = horizontalScrollBarSize;
        this._verticalScrollBarSize = verticalScrollBarSize;
        this._scrollbarPresenceChanged = true;
      } // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23


      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
      var childrenToDisplay = this._childrenToDisplay;
      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
      return React.createElement("div", (0, _extends2["default"])({
        ref: this._setScrollingContainerRef
      }, containerProps, {
        "aria-label": this.props['aria-label'],
        "aria-readonly": this.props['aria-readonly'],
        className: (0, _clsx["default"])('ReactVirtualized__Grid', className),
        id: id,
        onScroll: this._onScroll,
        role: role,
        style: _objectSpread({}, gridStyle, {}, style),
        tabIndex: tabIndex
      }), childrenToDisplay.length > 0 && React.createElement("div", {
        className: "ReactVirtualized__Grid__innerScrollContainer",
        role: containerRole,
        style: _objectSpread({
          width: autoContainerWidth ? 'auto' : totalColumnsWidth,
          height: totalRowsHeight,
          maxWidth: totalColumnsWidth,
          maxHeight: totalRowsHeight,
          overflow: 'hidden',
          pointerEvents: isScrolling ? 'none' : '',
          position: 'relative'
        }, containerStyle)
      }, childrenToDisplay), showNoContentRenderer && noContentRenderer());
    }
    /* ---------------------------- Helper methods ---------------------------- */

  }, {
    key: "_calculateChildrenToRender",
    value: function _calculateChildrenToRender() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var cellRenderer = props.cellRenderer,
          cellRangeRenderer = props.cellRangeRenderer,
          columnCount = props.columnCount,
          deferredMeasurementCache = props.deferredMeasurementCache,
          height = props.height,
          overscanColumnCount = props.overscanColumnCount,
          overscanIndicesGetter = props.overscanIndicesGetter,
          overscanRowCount = props.overscanRowCount,
          rowCount = props.rowCount,
          width = props.width,
          isScrollingOptOut = props.isScrollingOptOut;
      var scrollDirectionHorizontal = state.scrollDirectionHorizontal,
          scrollDirectionVertical = state.scrollDirectionVertical,
          instanceProps = state.instanceProps;
      var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
      var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;

      var isScrolling = this._isScrolling(props, state);

      this._childrenToDisplay = []; // Render only enough columns and rows to cover the visible area of the grid.

      if (height > 0 && width > 0) {
        var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
          containerSize: width,
          offset: scrollLeft
        });
        var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
          containerSize: height,
          offset: scrollTop
        });
        var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
          containerSize: width,
          offset: scrollLeft
        });
        var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
          containerSize: height,
          offset: scrollTop
        }); // Store for _invokeOnGridRenderedHelper()

        this._renderedColumnStartIndex = visibleColumnIndices.start;
        this._renderedColumnStopIndex = visibleColumnIndices.stop;
        this._renderedRowStartIndex = visibleRowIndices.start;
        this._renderedRowStopIndex = visibleRowIndices.stop;
        var overscanColumnIndices = overscanIndicesGetter({
          direction: 'horizontal',
          cellCount: columnCount,
          overscanCellsCount: overscanColumnCount,
          scrollDirection: scrollDirectionHorizontal,
          startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
          stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
        });
        var overscanRowIndices = overscanIndicesGetter({
          direction: 'vertical',
          cellCount: rowCount,
          overscanCellsCount: overscanRowCount,
          scrollDirection: scrollDirectionVertical,
          startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
          stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
        }); // Store for _invokeOnGridRenderedHelper()

        var columnStartIndex = overscanColumnIndices.overscanStartIndex;
        var columnStopIndex = overscanColumnIndices.overscanStopIndex;
        var rowStartIndex = overscanRowIndices.overscanStartIndex;
        var rowStopIndex = overscanRowIndices.overscanStopIndex; // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.

        if (deferredMeasurementCache) {
          // If rows have a dynamic height, scan the rows we are about to render.
          // If any have not yet been measured, then we need to render all columns initially,
          // Because the height of the row is equal to the tallest cell within that row,
          // (And so we can't know the height without measuring all column-cells first).
          if (!deferredMeasurementCache.hasFixedHeight()) {
            for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
              if (!deferredMeasurementCache.has(rowIndex, 0)) {
                columnStartIndex = 0;
                columnStopIndex = columnCount - 1;
                break;
              }
            }
          } // If columns have a dynamic width, scan the columns we are about to render.
          // If any have not yet been measured, then we need to render all rows initially,
          // Because the width of the column is equal to the widest cell within that column,
          // (And so we can't know the width without measuring all row-cells first).


          if (!deferredMeasurementCache.hasFixedWidth()) {
            for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
              if (!deferredMeasurementCache.has(0, columnIndex)) {
                rowStartIndex = 0;
                rowStopIndex = rowCount - 1;
                break;
              }
            }
          }
        }

        this._childrenToDisplay = cellRangeRenderer({
          cellCache: this._cellCache,
          cellRenderer: cellRenderer,
          columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          columnStartIndex: columnStartIndex,
          columnStopIndex: columnStopIndex,
          deferredMeasurementCache: deferredMeasurementCache,
          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
          isScrolling: isScrolling,
          isScrollingOptOut: isScrollingOptOut,
          parent: this,
          rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          rowStartIndex: rowStartIndex,
          rowStopIndex: rowStopIndex,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          styleCache: this._styleCache,
          verticalOffsetAdjustment: verticalOffsetAdjustment,
          visibleColumnIndices: visibleColumnIndices,
          visibleRowIndices: visibleRowIndices
        }); // update the indices

        this._columnStartIndex = columnStartIndex;
        this._columnStopIndex = columnStopIndex;
        this._rowStartIndex = rowStartIndex;
        this._rowStopIndex = rowStopIndex;
      }
    }
    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Grid.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: "_debounceScrollEnded",
    value: function _debounceScrollEnded() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;

      if (this._disablePointerEventsTimeoutId) {
        (0, _requestAnimationTimeout.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = (0, _requestAnimationTimeout.requestAnimationTimeout)(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
    }
  }, {
    key: "_handleInvalidatedGridSize",

    /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;
        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;
        this.recomputeGridSize({
          columnIndex: columnIndex,
          rowIndex: rowIndex
        });
      }
    }
  }, {
    key: "_invokeOnScrollMemoizer",
    value: function _invokeOnScrollMemoizer(_ref6) {
      var _this3 = this;

      var scrollLeft = _ref6.scrollLeft,
          scrollTop = _ref6.scrollTop,
          totalColumnsWidth = _ref6.totalColumnsWidth,
          totalRowsHeight = _ref6.totalRowsHeight;

      this._onScrollMemoizer({
        callback: function callback(_ref7) {
          var scrollLeft = _ref7.scrollLeft,
              scrollTop = _ref7.scrollTop;
          var _this3$props = _this3.props,
              height = _this3$props.height,
              onScroll = _this3$props.onScroll,
              width = _this3$props.width;
          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalRowsHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalColumnsWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: "_isScrolling",
    value: function _isScrolling() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      // If isScrolling is defined in props, use it to override the value in state
      // This is a performance optimization for WindowScroller + Grid
      return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
    }
  }, {
    key: "_maybeCallOnScrollbarPresenceChange",
    value: function _maybeCallOnScrollbarPresenceChange() {
      if (this._scrollbarPresenceChanged) {
        var onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
        this._scrollbarPresenceChanged = false;
        onScrollbarPresenceChange({
          horizontal: this._horizontalScrollBarSize > 0,
          size: this.state.instanceProps.scrollbarSize,
          vertical: this._verticalScrollBarSize > 0
        });
      }
    }
  }, {
    key: "scrollToPosition",

    /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */
    value: function scrollToPosition(_ref8) {
      var scrollLeft = _ref8.scrollLeft,
          scrollTop = _ref8.scrollTop;

      var stateUpdate = Grid._getScrollToPositionStateUpdate({
        prevState: this.state,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      });

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: "_getCalculatedScrollLeft",
    value: function _getCalculatedScrollLeft() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      return Grid._getCalculatedScrollLeft(props, state);
    }
  }, {
    key: "_updateScrollLeftForScrollToColumn",
    value: function _updateScrollLeftForScrollToColumn() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: "_getCalculatedScrollTop",
    value: function _getCalculatedScrollTop() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      return Grid._getCalculatedScrollTop(props, state);
    }
  }, {
    key: "_resetStyleCache",
    value: function _resetStyleCache() {
      var styleCache = this._styleCache;
      var cellCache = this._cellCache;
      var isScrollingOptOut = this.props.isScrollingOptOut; // Reset cell and style caches once scrolling stops.
      // This makes Grid simpler to use (since cells commonly change).
      // And it keeps the caches from growing too large.
      // Performance is most sensitive when a user is scrolling.
      // Don't clear visible cells from cellCache if isScrollingOptOut is specified.
      // This keeps the cellCache to a resonable size.

      this._cellCache = {};
      this._styleCache = {}; // Copy over the visible cell styles so avoid unnecessary re-render.

      for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
        for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
          var key = "".concat(rowIndex, "-").concat(columnIndex);
          this._styleCache[key] = styleCache[key];

          if (isScrollingOptOut) {
            this._cellCache[key] = cellCache[key];
          }
        }
      }
    }
  }, {
    key: "_updateScrollTopForScrollToRow",
    value: function _updateScrollTopForScrollToRow() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var newState = {};

      if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
        newState.scrollLeft = 0;
        newState.scrollTop = 0; // only use scroll{Left,Top} from props if scrollTo{Column,Row} isn't specified
        // scrollTo{Column,Row} should override scroll{Left,Top}
      } else if (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0) {
        Object.assign(newState, Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: nextProps.scrollLeft,
          scrollTop: nextProps.scrollTop
        }));
      }

      var instanceProps = prevState.instanceProps; // Initially we should not clearStyleCache

      newState.needToResetStyleCache = false;

      if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) {
        // Reset cache. set it to {} in render
        newState.needToResetStyleCache = true;
      }

      instanceProps.columnSizeAndPositionManager.configure({
        cellCount: nextProps.columnCount,
        estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
      });
      instanceProps.rowSizeAndPositionManager.configure({
        cellCount: nextProps.rowCount,
        estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
      });

      if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
        instanceProps.prevColumnCount = 0;
        instanceProps.prevRowCount = 0;
      } // If scrolling is controlled outside this component, clear cache when scrolling stops


      if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) {
        Object.assign(newState, {
          isScrolling: false
        });
      }

      var maybeStateA;
      var maybeStateB;
      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset["default"])({
        cellCount: instanceProps.prevColumnCount,
        cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.columnSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.columnCount,
        nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
        nextScrollToIndex: nextProps.scrollToColumn,
        scrollToIndex: instanceProps.prevScrollToColumn,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
        }
      });
      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset["default"])({
        cellCount: instanceProps.prevRowCount,
        cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.rowSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.rowCount,
        nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
        nextScrollToIndex: nextProps.scrollToRow,
        scrollToIndex: instanceProps.prevScrollToRow,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
        }
      });
      instanceProps.prevColumnCount = nextProps.columnCount;
      instanceProps.prevColumnWidth = nextProps.columnWidth;
      instanceProps.prevIsScrolling = nextProps.isScrolling === true;
      instanceProps.prevRowCount = nextProps.rowCount;
      instanceProps.prevRowHeight = nextProps.rowHeight;
      instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
      instanceProps.prevScrollToRow = nextProps.scrollToRow; // getting scrollBarSize (moved from componentWillMount)

      instanceProps.scrollbarSize = nextProps.getScrollbarSize();

      if (instanceProps.scrollbarSize === undefined) {
        instanceProps.scrollbarSizeMeasured = false;
        instanceProps.scrollbarSize = 0;
      } else {
        instanceProps.scrollbarSizeMeasured = true;
      }

      newState.instanceProps = instanceProps;
      return _objectSpread({}, newState, {}, maybeStateA, {}, maybeStateB);
    }
  }, {
    key: "_getEstimatedColumnSize",
    value: function _getEstimatedColumnSize(props) {
      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
    }
  }, {
    key: "_getEstimatedRowSize",
    value: function _getEstimatedRowSize(props) {
      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
    }
  }, {
    key: "_getScrollToPositionStateUpdate",

    /**
     * Get the updated state after scrolling to
     * scrollLeft and scrollTop
     */
    value: function _getScrollToPositionStateUpdate(_ref9) {
      var prevState = _ref9.prevState,
          scrollLeft = _ref9.scrollLeft,
          scrollTop = _ref9.scrollTop;
      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
        newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
        newState.scrollLeft = scrollLeft;
      }

      if (typeof scrollTop === 'number' && scrollTop >= 0) {
        newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
        newState.scrollTop = scrollTop;
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) {
        return newState;
      }

      return {};
    }
  }, {
    key: "_wrapSizeGetter",
    value: function _wrapSizeGetter(value) {
      return typeof value === 'function' ? value : function () {
        return value;
      };
    }
  }, {
    key: "_getCalculatedScrollLeft",
    value: function _getCalculatedScrollLeft(nextProps, prevState) {
      var columnCount = nextProps.columnCount,
          height = nextProps.height,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToColumn = nextProps.scrollToColumn,
          width = nextProps.width;
      var scrollLeft = prevState.scrollLeft,
          instanceProps = prevState.instanceProps;

      if (columnCount > 0) {
        var finalColumn = columnCount - 1;
        var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
        return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: width - scrollBarSize,
          currentOffset: scrollLeft,
          targetIndex: targetIndex
        });
      }

      return 0;
    }
  }, {
    key: "_getScrollLeftForScrollToColumnStateUpdate",
    value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState) {
      var scrollLeft = prevState.scrollLeft;

      var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);

      if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: calculatedScrollLeft,
          scrollTop: -1
        });
      }

      return {};
    }
  }, {
    key: "_getCalculatedScrollTop",
    value: function _getCalculatedScrollTop(nextProps, prevState) {
      var height = nextProps.height,
          rowCount = nextProps.rowCount,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToRow = nextProps.scrollToRow,
          width = nextProps.width;
      var scrollTop = prevState.scrollTop,
          instanceProps = prevState.instanceProps;

      if (rowCount > 0) {
        var finalRow = rowCount - 1;
        var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
        return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: height - scrollBarSize,
          currentOffset: scrollTop,
          targetIndex: targetIndex
        });
      }

      return 0;
    }
  }, {
    key: "_getScrollTopForScrollToRowStateUpdate",
    value: function _getScrollTopForScrollToRowStateUpdate(nextProps, prevState) {
      var scrollTop = prevState.scrollTop;

      var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);

      if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: -1,
          scrollTop: calculatedScrollTop
        });
      }

      return {};
    }
  }]);
  return Grid;
}(React.PureComponent), (0, _defineProperty2["default"])(_class, "propTypes",  true ? null : {
  "aria-label": _propTypes["default"].string.isRequired,
  "aria-readonly": _propTypes["default"].bool,

  /**
   * Set the width of the inner scrollable container to 'auto'.
   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
   */
  "autoContainerWidth": _propTypes["default"].bool.isRequired,

  /**
   * Removes fixed height from the scrollingContainer so that the total height of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  "autoHeight": _propTypes["default"].bool.isRequired,

  /**
   * Removes fixed width from the scrollingContainer so that the total width of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  "autoWidth": _propTypes["default"].bool.isRequired,

  /** Responsible for rendering a cell given an row and column index.  */
  "cellRenderer": function cellRenderer() {
    return (typeof _types.bpfrpt_proptype_CellRenderer === "function" ? _types.bpfrpt_proptype_CellRenderer.isRequired ? _types.bpfrpt_proptype_CellRenderer.isRequired : _types.bpfrpt_proptype_CellRenderer : _propTypes["default"].shape(_types.bpfrpt_proptype_CellRenderer).isRequired).apply(this, arguments);
  },

  /** Responsible for rendering a group of cells given their index ranges.  */
  "cellRangeRenderer": function cellRangeRenderer() {
    return (typeof _types.bpfrpt_proptype_CellRangeRenderer === "function" ? _types.bpfrpt_proptype_CellRangeRenderer.isRequired ? _types.bpfrpt_proptype_CellRangeRenderer.isRequired : _types.bpfrpt_proptype_CellRangeRenderer : _propTypes["default"].shape(_types.bpfrpt_proptype_CellRangeRenderer).isRequired).apply(this, arguments);
  },

  /** Optional custom CSS class name to attach to root Grid element.  */
  "className": _propTypes["default"].string,

  /** Number of columns in grid.  */
  "columnCount": _propTypes["default"].number.isRequired,

  /** Either a fixed column width (number) or a function that returns the width of a column given its index.  */
  "columnWidth": function columnWidth() {
    return (typeof _types.bpfrpt_proptype_CellSize === "function" ? _types.bpfrpt_proptype_CellSize.isRequired ? _types.bpfrpt_proptype_CellSize.isRequired : _types.bpfrpt_proptype_CellSize : _propTypes["default"].shape(_types.bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },

  /** Unfiltered props for the Grid container. */
  "containerProps": _propTypes["default"].object,

  /** ARIA role for the cell-container.  */
  "containerRole": _propTypes["default"].string.isRequired,

  /** Optional inline style applied to inner cell-container */
  "containerStyle": _propTypes["default"].object.isRequired,

  /**
   * If CellMeasurer is used to measure this Grid's children, this should be a pointer to its CellMeasurerCache.
   * A shared CellMeasurerCache reference enables Grid and CellMeasurer to share measurement data.
   */
  "deferredMeasurementCache": _propTypes["default"].object,

  /**
   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
   * The estimated total width is adjusted as columns are rendered.
   */
  "estimatedColumnSize": _propTypes["default"].number.isRequired,

  /**
   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  "estimatedRowSize": _propTypes["default"].number.isRequired,

  /** Exposed for testing purposes only.  */
  "getScrollbarSize": _propTypes["default"].func.isRequired,

  /** Height of Grid; this property determines the number of visible (vs virtualized) rows.  */
  "height": _propTypes["default"].number.isRequired,

  /** Optional custom id to attach to root Grid element.  */
  "id": _propTypes["default"].string,

  /**
   * Override internal is-scrolling state tracking.
   * This property is primarily intended for use with the WindowScroller component.
   */
  "isScrolling": _propTypes["default"].bool,

  /**
   * Opt-out of isScrolling param passed to cellRangeRenderer.
   * To avoid the extra render when scroll stops.
   */
  "isScrollingOptOut": _propTypes["default"].bool.isRequired,

  /** Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.  */
  "noContentRenderer": function noContentRenderer() {
    return (typeof _types.bpfrpt_proptype_NoContentRenderer === "function" ? _types.bpfrpt_proptype_NoContentRenderer.isRequired ? _types.bpfrpt_proptype_NoContentRenderer.isRequired : _types.bpfrpt_proptype_NoContentRenderer : _propTypes["default"].shape(_types.bpfrpt_proptype_NoContentRenderer).isRequired).apply(this, arguments);
  },

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   */
  "onScroll": _propTypes["default"].func.isRequired,

  /**
   * Called whenever a horizontal or vertical scrollbar is added or removed.
   * This prop is not intended for end-user use;
   * It is used by MultiGrid to support fixed-row/fixed-column scroll syncing.
   */
  "onScrollbarPresenceChange": _propTypes["default"].func.isRequired,

  /** Callback invoked with information about the section of the Grid that was just rendered.  */
  "onSectionRendered": _propTypes["default"].func.isRequired,

  /**
   * Number of columns to render before/after the visible section of the grid.
   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  "overscanColumnCount": _propTypes["default"].number.isRequired,

  /**
   * Calculates the number of cells to overscan before and after a specified range.
   * This function ensures that overscanning doesn't exceed the available cells.
   */
  "overscanIndicesGetter": function overscanIndicesGetter() {
    return (typeof _types.bpfrpt_proptype_OverscanIndicesGetter === "function" ? _types.bpfrpt_proptype_OverscanIndicesGetter.isRequired ? _types.bpfrpt_proptype_OverscanIndicesGetter.isRequired : _types.bpfrpt_proptype_OverscanIndicesGetter : _propTypes["default"].shape(_types.bpfrpt_proptype_OverscanIndicesGetter).isRequired).apply(this, arguments);
  },

  /**
   * Number of rows to render above/below the visible section of the grid.
   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  "overscanRowCount": _propTypes["default"].number.isRequired,

  /** ARIA role for the grid element.  */
  "role": _propTypes["default"].string.isRequired,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * Should implement the following interface: ({ index: number }): number
   */
  "rowHeight": function rowHeight() {
    return (typeof _types.bpfrpt_proptype_CellSize === "function" ? _types.bpfrpt_proptype_CellSize.isRequired ? _types.bpfrpt_proptype_CellSize.isRequired : _types.bpfrpt_proptype_CellSize : _propTypes["default"].shape(_types.bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },

  /** Number of rows in grid.  */
  "rowCount": _propTypes["default"].number.isRequired,

  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. */
  "scrollingResetTimeInterval": _propTypes["default"].number.isRequired,

  /** Horizontal offset. */
  "scrollLeft": _propTypes["default"].number,

  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   */
  "scrollToAlignment": function scrollToAlignment() {
    return (typeof _types.bpfrpt_proptype_Alignment === "function" ? _types.bpfrpt_proptype_Alignment.isRequired ? _types.bpfrpt_proptype_Alignment.isRequired : _types.bpfrpt_proptype_Alignment : _propTypes["default"].shape(_types.bpfrpt_proptype_Alignment).isRequired).apply(this, arguments);
  },

  /** Column index to ensure visible (by forcefully scrolling if necessary) */
  "scrollToColumn": _propTypes["default"].number.isRequired,

  /** Vertical offset. */
  "scrollTop": _propTypes["default"].number,

  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  "scrollToRow": _propTypes["default"].number.isRequired,

  /** Optional inline style */
  "style": _propTypes["default"].object.isRequired,

  /** Tab index for focus */
  "tabIndex": _propTypes["default"].number,

  /** Width of Grid; this property determines the number of visible (vs virtualized) columns.  */
  "width": _propTypes["default"].number.isRequired
}), _temp);
(0, _defineProperty2["default"])(Grid, "defaultProps", {
  'aria-label': 'grid',
  'aria-readonly': true,
  autoContainerWidth: false,
  autoHeight: false,
  autoWidth: false,
  cellRangeRenderer: _defaultCellRangeRenderer["default"],
  containerRole: 'rowgroup',
  containerStyle: {},
  estimatedColumnSize: 100,
  estimatedRowSize: 30,
  getScrollbarSize: _scrollbarSize["default"],
  noContentRenderer: renderNull,
  onScroll: function onScroll() {},
  onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
  onSectionRendered: function onSectionRendered() {},
  overscanColumnCount: 0,
  overscanIndicesGetter: _defaultOverscanIndicesGetter["default"],
  overscanRowCount: 10,
  role: 'grid',
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  scrollToAlignment: 'auto',
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  tabIndex: 0,
  isScrollingOptOut: false
});
(0, _reactLifecyclesCompat.polyfill)(Grid);
var _default = Grid;
exports["default"] = _default;

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = defaultOverscanIndicesGetter;
exports.SCROLL_DIRECTION_VERTICAL = exports.SCROLL_DIRECTION_HORIZONTAL = exports.SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_BACKWARD = void 0;

var _types = __webpack_require__(106);

var SCROLL_DIRECTION_BACKWARD = -1;
exports.SCROLL_DIRECTION_BACKWARD = SCROLL_DIRECTION_BACKWARD;
var SCROLL_DIRECTION_FORWARD = 1;
exports.SCROLL_DIRECTION_FORWARD = SCROLL_DIRECTION_FORWARD;
var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
exports.SCROLL_DIRECTION_HORIZONTAL = SCROLL_DIRECTION_HORIZONTAL;
var SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

exports.SCROLL_DIRECTION_VERTICAL = SCROLL_DIRECTION_VERTICAL;

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;
  // Make sure we render at least 1 cell extra before and after (except near boundaries)
  // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
  // For more info see issues #625
  overscanCellsCount = Math.max(1, overscanCellsCount);

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex - 1),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
  }
}

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(61);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Grid["default"];
  }
});
Object.defineProperty(exports, "Grid", {
  enumerable: true,
  get: function get() {
    return _Grid["default"];
  }
});
Object.defineProperty(exports, "accessibilityOverscanIndicesGetter", {
  enumerable: true,
  get: function get() {
    return _accessibilityOverscanIndicesGetter["default"];
  }
});
Object.defineProperty(exports, "defaultCellRangeRenderer", {
  enumerable: true,
  get: function get() {
    return _defaultCellRangeRenderer["default"];
  }
});
Object.defineProperty(exports, "defaultOverscanIndicesGetter", {
  enumerable: true,
  get: function get() {
    return _defaultOverscanIndicesGetter["default"];
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_NoContentRenderer", {
  enumerable: true,
  get: function get() {
    return _types.bpfrpt_proptype_NoContentRenderer;
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_Alignment", {
  enumerable: true,
  get: function get() {
    return _types.bpfrpt_proptype_Alignment;
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_CellPosition", {
  enumerable: true,
  get: function get() {
    return _types.bpfrpt_proptype_CellPosition;
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_CellSize", {
  enumerable: true,
  get: function get() {
    return _types.bpfrpt_proptype_CellSize;
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_OverscanIndicesGetter", {
  enumerable: true,
  get: function get() {
    return _types.bpfrpt_proptype_OverscanIndicesGetter;
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_RenderedSection", {
  enumerable: true,
  get: function get() {
    return _types.bpfrpt_proptype_RenderedSection;
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_CellRendererParams", {
  enumerable: true,
  get: function get() {
    return _types.bpfrpt_proptype_CellRendererParams;
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_Scroll", {
  enumerable: true,
  get: function get() {
    return _types.bpfrpt_proptype_Scroll;
  }
});

var _Grid = _interopRequireDefault(__webpack_require__(1579));

var _accessibilityOverscanIndicesGetter = _interopRequireDefault(__webpack_require__(1580));

var _defaultCellRangeRenderer = _interopRequireDefault(__webpack_require__(670));

var _defaultOverscanIndicesGetter = _interopRequireDefault(__webpack_require__(671));

var _types = __webpack_require__(106);

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(61);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(179));

var _createClass2 = _interopRequireDefault(__webpack_require__(180));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(181));

var _types = __webpack_require__(106);

/**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */
var CellSizeAndPositionManager =
/*#__PURE__*/
function () {
  // Cache of size and position data for cells, mapped by cell index.
  // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
  // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
  // Used in deferred mode to track which cells have been queued for measurement.
  function CellSizeAndPositionManager(_ref) {
    var cellCount = _ref.cellCount,
        cellSizeGetter = _ref.cellSizeGetter,
        estimatedCellSize = _ref.estimatedCellSize;
    (0, _classCallCheck2["default"])(this, CellSizeAndPositionManager);
    (0, _defineProperty2["default"])(this, "_cellSizeAndPositionData", {});
    (0, _defineProperty2["default"])(this, "_lastMeasuredIndex", -1);
    (0, _defineProperty2["default"])(this, "_lastBatchedIndex", -1);
    (0, _defineProperty2["default"])(this, "_cellCount", void 0);
    (0, _defineProperty2["default"])(this, "_cellSizeGetter", void 0);
    (0, _defineProperty2["default"])(this, "_estimatedCellSize", void 0);
    this._cellSizeGetter = cellSizeGetter;
    this._cellCount = cellCount;
    this._estimatedCellSize = estimatedCellSize;
  }

  (0, _createClass2["default"])(CellSizeAndPositionManager, [{
    key: "areOffsetsAdjusted",
    value: function areOffsetsAdjusted() {
      return false;
    }
  }, {
    key: "configure",
    value: function configure(_ref2) {
      var cellCount = _ref2.cellCount,
          estimatedCellSize = _ref2.estimatedCellSize,
          cellSizeGetter = _ref2.cellSizeGetter;
      this._cellCount = cellCount;
      this._estimatedCellSize = estimatedCellSize;
      this._cellSizeGetter = cellSizeGetter;
    }
  }, {
    key: "getCellCount",
    value: function getCellCount() {
      return this._cellCount;
    }
  }, {
    key: "getEstimatedCellSize",
    value: function getEstimatedCellSize() {
      return this._estimatedCellSize;
    }
  }, {
    key: "getLastMeasuredIndex",
    value: function getLastMeasuredIndex() {
      return this._lastMeasuredIndex;
    }
  }, {
    key: "getOffsetAdjustment",
    value: function getOffsetAdjustment() {
      return 0;
    }
    /**
     * This method returns the size and position for the cell at the specified index.
     * It just-in-time calculates (or used cached values) for cells leading up to the index.
     */

  }, {
    key: "getSizeAndPositionOfCell",
    value: function getSizeAndPositionOfCell(index) {
      if (index < 0 || index >= this._cellCount) {
        throw Error("Requested index ".concat(index, " is outside of range 0..").concat(this._cellCount));
      }

      if (index > this._lastMeasuredIndex) {
        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
        var offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;

        for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
          var size = this._cellSizeGetter({
            index: i
          }); // undefined or NaN probably means a logic error in the size getter.
          // null means we're using CellMeasurer and haven't yet measured a given index.


          if (size === undefined || isNaN(size)) {
            throw Error("Invalid size returned for cell ".concat(i, " of value ").concat(size));
          } else if (size === null) {
            this._cellSizeAndPositionData[i] = {
              offset: offset,
              size: 0
            };
            this._lastBatchedIndex = index;
          } else {
            this._cellSizeAndPositionData[i] = {
              offset: offset,
              size: size
            };
            offset += size;
            this._lastMeasuredIndex = index;
          }
        }
      }

      return this._cellSizeAndPositionData[index];
    }
  }, {
    key: "getSizeAndPositionOfLastMeasuredCell",
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
        offset: 0,
        size: 0
      };
    }
    /**
     * Total size of all cells being measured.
     * This value will be completely estimated initially.
     * As cells are measured, the estimate will be updated.
     */

  }, {
    key: "getTotalSize",
    value: function getTotalSize() {
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
      var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
      var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
      return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
    }
    /**
     * Determines a new offset that ensures a certain cell is visible, given the current offset.
     * If the cell is already visible then the current offset will be returned.
     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
     *
     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
     * @param containerSize Size (width or height) of the container viewport
     * @param currentOffset Container's current (x or y) offset
     * @param totalSize Total size (width or height) of all cells
     * @return Offset to use to ensure the specified cell is visible
     */

  }, {
    key: "getUpdatedOffsetForIndex",
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === void 0 ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;

      if (containerSize <= 0) {
        return 0;
      }

      var datum = this.getSizeAndPositionOfCell(targetIndex);
      var maxOffset = datum.offset;
      var minOffset = maxOffset - containerSize + datum.size;
      var idealOffset;

      switch (align) {
        case 'start':
          idealOffset = maxOffset;
          break;

        case 'end':
          idealOffset = minOffset;
          break;

        case 'center':
          idealOffset = maxOffset - (containerSize - datum.size) / 2;
          break;

        default:
          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
          break;
      }

      var totalSize = this.getTotalSize();
      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
    }
  }, {
    key: "getVisibleCellRange",
    value: function getVisibleCellRange(params) {
      var containerSize = params.containerSize,
          offset = params.offset;
      var totalSize = this.getTotalSize();

      if (totalSize === 0) {
        return {};
      }

      var maxOffset = offset + containerSize;

      var start = this._findNearestCell(offset);

      var datum = this.getSizeAndPositionOfCell(start);
      offset = datum.offset + datum.size;
      var stop = start;

      while (offset < maxOffset && stop < this._cellCount - 1) {
        stop++;
        offset += this.getSizeAndPositionOfCell(stop).size;
      }

      return {
        start: start,
        stop: stop
      };
    }
    /**
     * Clear all cached values for cells after the specified index.
     * This method should be called for any cell that has changed its size.
     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
     */

  }, {
    key: "resetCell",
    value: function resetCell(index) {
      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
    }
  }, {
    key: "_binarySearch",
    value: function _binarySearch(high, low, offset) {
      while (low <= high) {
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = this.getSizeAndPositionOfCell(middle).offset;

        if (currentOffset === offset) {
          return middle;
        } else if (currentOffset < offset) {
          low = middle + 1;
        } else if (currentOffset > offset) {
          high = middle - 1;
        }
      }

      if (low > 0) {
        return low - 1;
      } else {
        return 0;
      }
    }
  }, {
    key: "_exponentialSearch",
    value: function _exponentialSearch(index, offset) {
      var interval = 1;

      while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
        index += interval;
        interval *= 2;
      }

      return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
    }
    /**
     * Searches for the cell (index) nearest the specified offset.
     *
     * If no exact match is found the next lowest cell index will be returned.
     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
     */

  }, {
    key: "_findNearestCell",
    value: function _findNearestCell(offset) {
      if (isNaN(offset)) {
        throw Error("Invalid offset ".concat(offset, " specified"));
      } // Our search algorithms find the nearest match at or below the specified offset.
      // So make sure the offset is at least 0 or no match will be found.


      offset = Math.max(0, offset);
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);

      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
        // If we've already measured cells within this range just use a binary search as it's faster.
        return this._binarySearch(lastMeasuredIndex, 0, offset);
      } else {
        // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
        // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
        // The overall complexity for this approach is O(log n).
        return this._exponentialSearch(lastMeasuredIndex, offset);
      }
    }
  }]);
  return CellSizeAndPositionManager;
}();

exports["default"] = CellSizeAndPositionManager;

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = calculateSizeAndPositionDataAndUpdateScrollOffset;

/**
 * Helper method that determines when to recalculate row or column metadata.
 */
function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
  var cellCount = _ref.cellCount,
      cellSize = _ref.cellSize,
      computeMetadataCallback = _ref.computeMetadataCallback,
      computeMetadataCallbackProps = _ref.computeMetadataCallbackProps,
      nextCellsCount = _ref.nextCellsCount,
      nextCellSize = _ref.nextCellSize,
      nextScrollToIndex = _ref.nextScrollToIndex,
      scrollToIndex = _ref.scrollToIndex,
      updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;

  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
  // In that event users should use the manual recompute methods to inform of changes.
  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
    computeMetadataCallback(computeMetadataCallbackProps); // Updated cell metadata may have hidden the previous scrolled-to item.
    // In this case we should also update the scrollTop to ensure it stays visible.

    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
      updateScrollOffsetForScrollToIndex();
    }
  }
}

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMaxElementSize = void 0;
var DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var CHROME_MAX_ELEMENT_SIZE = 1.67771e7;

var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};

var isChrome = function isChrome() {
  return !!window.chrome;
};

var getMaxElementSize = function getMaxElementSize() {
  if (isBrowser()) {
    if (isChrome()) {
      return CHROME_MAX_ELEMENT_SIZE;
    }
  }

  return DEFAULT_MAX_ELEMENT_SIZE;
};

exports.getMaxElementSize = getMaxElementSize;

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(61);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = updateScrollIndexHelper;

var _ScalingCellSizeAndPositionManager = _interopRequireDefault(__webpack_require__(412));

var _types = __webpack_require__(106);

function updateScrollIndexHelper(_ref) {
  var cellSize = _ref.cellSize,
      cellSizeAndPositionManager = _ref.cellSizeAndPositionManager,
      previousCellsCount = _ref.previousCellsCount,
      previousCellSize = _ref.previousCellSize,
      previousScrollToAlignment = _ref.previousScrollToAlignment,
      previousScrollToIndex = _ref.previousScrollToIndex,
      previousSize = _ref.previousSize,
      scrollOffset = _ref.scrollOffset,
      scrollToAlignment = _ref.scrollToAlignment,
      scrollToIndex = _ref.scrollToIndex,
      size = _ref.size,
      sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero,
      updateScrollIndexCallback = _ref.updateScrollIndexCallback;
  var cellCount = cellSizeAndPositionManager.getCellCount();
  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
  var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize; // If we have a new scroll target OR if height/row-height has changed,
  // We should ensure that the scroll target is visible.

  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
    updateScrollIndexCallback(scrollToIndex); // If we don't have a selected item but list size or number of children have decreased,
    // Make sure we aren't scrolled too far past the current content.
  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
    // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
      updateScrollIndexCallback(cellCount - 1);
    }
  }
}

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(61);

var _interopRequireWildcard = __webpack_require__(182);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(419));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(179));

var _createClass2 = _interopRequireDefault(__webpack_require__(180));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(290));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(288));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(219));

var _inherits2 = _interopRequireDefault(__webpack_require__(289));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(181));

var _Grid = _interopRequireWildcard(__webpack_require__(1581));

var React = _interopRequireWildcard(__webpack_require__(0));

var _clsx = _interopRequireDefault(__webpack_require__(461));

var _types = __webpack_require__(672);

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var _class, _temp;

var List = (_temp = _class =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2["default"])(List, _React$PureComponent);

  function List() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, List);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(List)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "Grid", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_cellRenderer", function (_ref) {
      var parent = _ref.parent,
          rowIndex = _ref.rowIndex,
          style = _ref.style,
          isScrolling = _ref.isScrolling,
          isVisible = _ref.isVisible,
          key = _ref.key;
      var rowRenderer = _this.props.rowRenderer; // TRICKY The style object is sometimes cached by Grid.
      // This prevents new style objects from bypassing shallowCompare().
      // However as of React 16, style props are auto-frozen (at least in dev mode)
      // Check to make sure we can still modify the style before proceeding.
      // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713

      var widthDescriptor = Object.getOwnPropertyDescriptor(style, 'width');

      if (widthDescriptor && widthDescriptor.writable) {
        // By default, List cells should be 100% width.
        // This prevents them from flowing under a scrollbar (if present).
        style.width = '100%';
      }

      return rowRenderer({
        index: rowIndex,
        style: style,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setRef", function (ref) {
      _this.Grid = ref;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onScroll", function (_ref2) {
      var clientHeight = _ref2.clientHeight,
          scrollHeight = _ref2.scrollHeight,
          scrollTop = _ref2.scrollTop;
      var onScroll = _this.props.onScroll;
      onScroll({
        clientHeight: clientHeight,
        scrollHeight: scrollHeight,
        scrollTop: scrollTop
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onSectionRendered", function (_ref3) {
      var rowOverscanStartIndex = _ref3.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref3.rowOverscanStopIndex,
          rowStartIndex = _ref3.rowStartIndex,
          rowStopIndex = _ref3.rowStopIndex;
      var onRowsRendered = _this.props.onRowsRendered;
      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(List, [{
    key: "forceUpdateGrid",
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }
    /** See Grid#getOffsetForCell */

  }, {
    key: "getOffsetForRow",
    value: function getOffsetForRow(_ref4) {
      var alignment = _ref4.alignment,
          index = _ref4.index;

      if (this.Grid) {
        var _this$Grid$getOffsetF = this.Grid.getOffsetForCell({
          alignment: alignment,
          rowIndex: index,
          columnIndex: 0
        }),
            scrollTop = _this$Grid$getOffsetF.scrollTop;

        return scrollTop;
      }

      return 0;
    }
    /** CellMeasurer compatibility */

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref5) {
      var columnIndex = _ref5.columnIndex,
          rowIndex = _ref5.rowIndex;

      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }
    /** See Grid#measureAllCells */

  }, {
    key: "measureAllRows",
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }
    /** CellMeasurer compatibility */

  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref6$columnIndex = _ref6.columnIndex,
          columnIndex = _ref6$columnIndex === void 0 ? 0 : _ref6$columnIndex,
          _ref6$rowIndex = _ref6.rowIndex,
          rowIndex = _ref6$rowIndex === void 0 ? 0 : _ref6$rowIndex;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }
    /** See Grid#recomputeGridSize */

  }, {
    key: "recomputeRowHeights",
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index,
          columnIndex: 0
        });
      }
    }
    /** See Grid#scrollToPosition */

  }, {
    key: "scrollToPosition",
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToPosition({
          scrollTop: scrollTop
        });
      }
    }
    /** See Grid#scrollToCell */

  }, {
    key: "scrollToRow",
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          noRowsRenderer = _this$props.noRowsRenderer,
          scrollToIndex = _this$props.scrollToIndex,
          width = _this$props.width;
      var classNames = (0, _clsx["default"])('ReactVirtualized__List', className);
      return React.createElement(_Grid["default"], (0, _extends2["default"])({}, this.props, {
        autoContainerWidth: true,
        cellRenderer: this._cellRenderer,
        className: classNames,
        columnWidth: width,
        columnCount: 1,
        noContentRenderer: noRowsRenderer,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        scrollToRow: scrollToIndex
      }));
    }
  }]);
  return List;
}(React.PureComponent), (0, _defineProperty2["default"])(_class, "propTypes",  true ? null : {
  "aria-label": _propTypes["default"].string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  "autoHeight": _propTypes["default"].bool.isRequired,

  /** Optional CSS class name */
  "className": _propTypes["default"].string,

  /**
   * Used to estimate the total height of a List before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  "estimatedRowSize": _propTypes["default"].number.isRequired,

  /** Height constraint for list (determines how many actual rows are rendered) */
  "height": _propTypes["default"].number.isRequired,

  /** Optional renderer to be used in place of rows when rowCount is 0 */
  "noRowsRenderer": function noRowsRenderer() {
    return (typeof _Grid.bpfrpt_proptype_NoContentRenderer === "function" ? _Grid.bpfrpt_proptype_NoContentRenderer.isRequired ? _Grid.bpfrpt_proptype_NoContentRenderer.isRequired : _Grid.bpfrpt_proptype_NoContentRenderer : _propTypes["default"].shape(_Grid.bpfrpt_proptype_NoContentRenderer).isRequired).apply(this, arguments);
  },

  /** Callback invoked with information about the slice of rows that were just rendered.  */
  "onRowsRendered": _propTypes["default"].func.isRequired,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   */
  "onScroll": _propTypes["default"].func.isRequired,

  /** See Grid#overscanIndicesGetter */
  "overscanIndicesGetter": function overscanIndicesGetter() {
    return (typeof _Grid.bpfrpt_proptype_OverscanIndicesGetter === "function" ? _Grid.bpfrpt_proptype_OverscanIndicesGetter.isRequired ? _Grid.bpfrpt_proptype_OverscanIndicesGetter.isRequired : _Grid.bpfrpt_proptype_OverscanIndicesGetter : _propTypes["default"].shape(_Grid.bpfrpt_proptype_OverscanIndicesGetter).isRequired).apply(this, arguments);
  },

  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  "overscanRowCount": _propTypes["default"].number.isRequired,

  /** Either a fixed row height (number) or a function that returns the height of a row given its index.  */
  "rowHeight": function rowHeight() {
    return (typeof _Grid.bpfrpt_proptype_CellSize === "function" ? _Grid.bpfrpt_proptype_CellSize.isRequired ? _Grid.bpfrpt_proptype_CellSize.isRequired : _Grid.bpfrpt_proptype_CellSize : _propTypes["default"].shape(_Grid.bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },

  /** Responsible for rendering a row given an index; ({ index: number }): node */
  "rowRenderer": function rowRenderer() {
    return (typeof _types.bpfrpt_proptype_RowRenderer === "function" ? _types.bpfrpt_proptype_RowRenderer.isRequired ? _types.bpfrpt_proptype_RowRenderer.isRequired : _types.bpfrpt_proptype_RowRenderer : _propTypes["default"].shape(_types.bpfrpt_proptype_RowRenderer).isRequired).apply(this, arguments);
  },

  /** Number of rows in list. */
  "rowCount": _propTypes["default"].number.isRequired,

  /** See Grid#scrollToAlignment */
  "scrollToAlignment": function scrollToAlignment() {
    return (typeof _Grid.bpfrpt_proptype_Alignment === "function" ? _Grid.bpfrpt_proptype_Alignment.isRequired ? _Grid.bpfrpt_proptype_Alignment.isRequired : _Grid.bpfrpt_proptype_Alignment : _propTypes["default"].shape(_Grid.bpfrpt_proptype_Alignment).isRequired).apply(this, arguments);
  },

  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  "scrollToIndex": _propTypes["default"].number.isRequired,

  /** Vertical offset. */
  "scrollTop": _propTypes["default"].number,

  /** Optional inline style */
  "style": _propTypes["default"].object.isRequired,

  /** Tab index for focus */
  "tabIndex": _propTypes["default"].number,

  /** Width of list */
  "width": _propTypes["default"].number.isRequired
}), _temp);
exports["default"] = List;
(0, _defineProperty2["default"])(List, "defaultProps", {
  autoHeight: false,
  estimatedRowSize: 30,
  onScroll: function onScroll() {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {},
  overscanIndicesGetter: _Grid.accessibilityOverscanIndicesGetter,
  overscanRowCount: 10,
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
});

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(61);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _List["default"];
  }
});
Object.defineProperty(exports, "List", {
  enumerable: true,
  get: function get() {
    return _List["default"];
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_RowRendererParams", {
  enumerable: true,
  get: function get() {
    return _types.bpfrpt_proptype_RowRendererParams;
  }
});

var _List = _interopRequireDefault(__webpack_require__(1586));

var _types = __webpack_require__(672);

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.caf = exports.raf = void 0;
// Properly handle server-side rendering.
var win;

if (typeof window !== 'undefined') {
  win = window;
} else if (typeof self !== 'undefined') {
  win = self;
} else {
  win = {};
} // requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/


var request = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.oRequestAnimationFrame || win.msRequestAnimationFrame || function (callback) {
  return win.setTimeout(callback, 1000 / 60);
};

var cancel = win.cancelAnimationFrame || win.webkitCancelAnimationFrame || win.mozCancelAnimationFrame || win.oCancelAnimationFrame || win.msCancelAnimationFrame || function (id) {
  win.clearTimeout(id);
};

var raf = request;
exports.raf = raf;
var caf = cancel;
exports.caf = caf;

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createCallbackMemoizer;

/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */
function createCallbackMemoizer() {
  var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var cachedIndices = {};
  return function (_ref) {
    var callback = _ref.callback,
        indices = _ref.indices;
    var keys = Object.keys(indices);
    var allInitialized = !requireAllKeys || keys.every(function (key) {
      var value = indices[key];
      return Array.isArray(value) ? value.length > 0 : value >= 0;
    });
    var indexChanged = keys.length !== Object.keys(cachedIndices).length || keys.some(function (key) {
      var cachedValue = cachedIndices[key];
      var value = indices[key];
      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
    });
    cachedIndices = indices;

    if (allInitialized && indexChanged) {
      callback(indices);
    }
  };
}

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(61);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bpfrpt_proptype_AnimationTimeoutId = exports.requestAnimationTimeout = exports.cancelAnimationTimeout = void 0;

var _animationFrame = __webpack_require__(1588);

var _propTypes = _interopRequireDefault(__webpack_require__(8));

var bpfrpt_proptype_AnimationTimeoutId =  true ? null : {
  "id": _propTypes["default"].number.isRequired
};
exports.bpfrpt_proptype_AnimationTimeoutId = bpfrpt_proptype_AnimationTimeoutId;

var cancelAnimationTimeout = function cancelAnimationTimeout(frame) {
  return (0, _animationFrame.caf)(frame.id);
};
/**
 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
 * When the delay time has been reached the function you're timing out will be called.
 *
 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
 */


exports.cancelAnimationTimeout = cancelAnimationTimeout;

var requestAnimationTimeout = function requestAnimationTimeout(callback, delay) {
  var start; // wait for end of processing current event handler, because event handler may be long

  Promise.resolve().then(function () {
    start = Date.now();
  });

  var timeout = function timeout() {
    if (Date.now() - start >= delay) {
      callback.call();
    } else {
      frame.id = (0, _animationFrame.raf)(timeout);
    }
  };

  var frame = {
    id: (0, _animationFrame.raf)(timeout)
  };
  return frame;
};

exports.requestAnimationTimeout = requestAnimationTimeout;

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createDetectElementResize;

/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 * 5) Added support for injecting custom window object
 **/
function createDetectElementResize(nonce, hostWindow) {
  // Check `document` and `window` in case of server-side rendering
  var _window;

  if (typeof hostWindow !== 'undefined') {
    _window = hostWindow;
  } else if (typeof window !== 'undefined') {
    _window = window;
  } else if (typeof self !== 'undefined') {
    _window = self;
  } else {
    _window = global;
  }

  var attachEvent = typeof _window.document !== 'undefined' && _window.document.attachEvent;

  if (!attachEvent) {
    var requestFrame = function () {
      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
        return _window.setTimeout(fn, 20);
      };

      return function (fn) {
        return raf(fn);
      };
    }();

    var cancelFrame = function () {
      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
      return function (id) {
        return cancel(id);
      };
    }();

    var resetTriggers = function resetTriggers(element) {
      var triggers = element.__resizeTriggers__,
          expand = triggers.firstElementChild,
          contract = triggers.lastElementChild,
          expandChild = expand.firstElementChild;
      contract.scrollLeft = contract.scrollWidth;
      contract.scrollTop = contract.scrollHeight;
      expandChild.style.width = expand.offsetWidth + 1 + 'px';
      expandChild.style.height = expand.offsetHeight + 1 + 'px';
      expand.scrollLeft = expand.scrollWidth;
      expand.scrollTop = expand.scrollHeight;
    };

    var checkTriggers = function checkTriggers(element) {
      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
    };

    var scrollListener = function scrollListener(e) {
      // Don't measure (which forces) reflow for scrolls that happen inside of children!
      if (e.target.className && typeof e.target.className.indexOf === 'function' && e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
        return;
      }

      var element = this;
      resetTriggers(this);

      if (this.__resizeRAF__) {
        cancelFrame(this.__resizeRAF__);
      }

      this.__resizeRAF__ = requestFrame(function () {
        if (checkTriggers(element)) {
          element.__resizeLast__.width = element.offsetWidth;
          element.__resizeLast__.height = element.offsetHeight;

          element.__resizeListeners__.forEach(function (fn) {
            fn.call(element, e);
          });
        }
      });
    };
    /* Detect CSS Animations support to detect element display/re-attach */


    var animation = false,
        keyframeprefix = '',
        animationstartevent = 'animationstart',
        domPrefixes = 'Webkit Moz O ms'.split(' '),
        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
        pfx = '';
    {
      var elm = _window.document.createElement('fakeelement');

      if (elm.style.animationName !== undefined) {
        animation = true;
      }

      if (animation === false) {
        for (var i = 0; i < domPrefixes.length; i++) {
          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            pfx = domPrefixes[i];
            keyframeprefix = '-' + pfx.toLowerCase() + '-';
            animationstartevent = startEvents[i];
            animation = true;
            break;
          }
        }
      }
    }
    var animationName = 'resizeanim';
    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
  }

  var createStyles = function createStyles(doc) {
    if (!doc.getElementById('detectElementResize')) {
      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
          head = doc.head || doc.getElementsByTagName('head')[0],
          style = doc.createElement('style');
      style.id = 'detectElementResize';
      style.type = 'text/css';

      if (nonce != null) {
        style.setAttribute('nonce', nonce);
      }

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(doc.createTextNode(css));
      }

      head.appendChild(style);
    }
  };

  var addResizeListener = function addResizeListener(element, fn) {
    if (attachEvent) {
      element.attachEvent('onresize', fn);
    } else {
      if (!element.__resizeTriggers__) {
        var doc = element.ownerDocument;

        var elementStyle = _window.getComputedStyle(element);

        if (elementStyle && elementStyle.position == 'static') {
          element.style.position = 'relative';
        }

        createStyles(doc);
        element.__resizeLast__ = {};
        element.__resizeListeners__ = [];
        (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
        var resizeTriggersHtml = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';

        if (window.trustedTypes) {
          var staticPolicy = trustedTypes.createPolicy('react-virtualized-auto-sizer', {
            createHTML: function createHTML() {
              return resizeTriggersHtml;
            }
          });
          element.__resizeTriggers__.innerHTML = staticPolicy.createHTML('');
        } else {
          element.__resizeTriggers__.innerHTML = resizeTriggersHtml;
        }

        element.appendChild(element.__resizeTriggers__);
        resetTriggers(element);
        element.addEventListener('scroll', scrollListener, true);
        /* Listen for a css animation to detect element display/re-attach */

        if (animationstartevent) {
          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
            if (e.animationName == animationName) {
              resetTriggers(element);
            }
          };

          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
        }
      }

      element.__resizeListeners__.push(fn);
    }
  };

  var removeResizeListener = function removeResizeListener(element, fn) {
    if (attachEvent) {
      element.detachEvent('onresize', fn);
    } else {
      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);

      if (!element.__resizeListeners__.length) {
        element.removeEventListener('scroll', scrollListener, true);

        if (element.__resizeTriggers__.__animationListener__) {
          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);

          element.__resizeTriggers__.__animationListener__ = null;
        }

        try {
          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
        } catch (e) {// Preact compat; see developit/preact-compat/issues/228
        }
      }
    }
  };

  return {
    addResizeListener: addResizeListener,
    removeResizeListener: removeResizeListener
  };
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 1592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (!!(typeof window !== 'undefined' && window.document && window.document.createElement));

/***/ }),
/* 1593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = scrollbarSize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__canUseDOM__ = __webpack_require__(1592);

var size;
function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (__WEBPACK_IMPORTED_MODULE_0__canUseDOM__["a" /* default */]) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(217);

var invariant = __webpack_require__(12);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var PooledClass = __webpack_require__(1595);
var ReactElement = __webpack_require__(176);

var emptyFunction = __webpack_require__(70);
var traverseAllChildren = __webpack_require__(1605);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactElement = __webpack_require__(176);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(176),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(377);

module.exports = factory(isValidElement);

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(673),
    Component = _require.Component;

var _require2 = __webpack_require__(176),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(676);
var factory = __webpack_require__(512);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */


var _prodInvariant = __webpack_require__(217);

var ReactElement = __webpack_require__(176);

var invariant = __webpack_require__(12);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(217);

var ReactCurrentOwner = __webpack_require__(95);
var REACT_ELEMENT_TYPE = __webpack_require__(675);

var getIteratorFn = __webpack_require__(1601);
var invariant = __webpack_require__(12);
var KeyEscapeUtils = __webpack_require__(1594);
var warning = __webpack_require__(14);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 1606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sagaMiddlewareFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channel__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__runSaga__ = __webpack_require__(679);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






function sagaMiddlewareFactory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref$context = _ref.context,
      context = _ref$context === undefined ? {} : _ref$context,
      options = _objectWithoutProperties(_ref, ['context']);

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;


  if (__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func(options)) {
    if (true) {
      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
    } else {
      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
    }
  }

  if (logger && !__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func(logger)) {
    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
  }

  if (false) {
    throw new Error('`options.onerror` was removed. Use `options.onError` instead.');
  }

  if (onError && !__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func(onError)) {
    throw new Error('`options.onError` passed to the Saga middleware is not a function!');
  }

  if (options.emitter && !__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func(options.emitter)) {
    throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
  }

  function sagaMiddleware(_ref2) {
    var getState = _ref2.getState,
        dispatch = _ref2.dispatch;

    var sagaEmitter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__channel__["f" /* emitter */])();
    sagaEmitter.emit = (options.emitter || __WEBPACK_IMPORTED_MODULE_0__utils__["g" /* ident */])(sagaEmitter.emit);

    sagaMiddleware.run = __WEBPACK_IMPORTED_MODULE_2__runSaga__["a" /* runSaga */].bind(null, {
      context: context,
      subscribe: sagaEmitter.subscribe,
      dispatch: dispatch,
      getState: getState,
      sagaMonitor: sagaMonitor,
      logger: logger,
      onError: onError
    });

    return function (next) {
      return function (action) {
        if (sagaMonitor && sagaMonitor.actionDispatched) {
          sagaMonitor.actionDispatched(action);
        }
        var result = next(action); // hit reducers
        sagaEmitter.emit(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function () {
    throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
  };

  sagaMiddleware.setContext = function (props) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].object, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])('sagaMiddleware', props));
    __WEBPACK_IMPORTED_MODULE_0__utils__["z" /* object */].assign(context, props);
  };

  return sagaMiddleware;
}

/***/ }),
/* 1607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeEvery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(177);




function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__io__["d" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["e" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };

  var action = void 0,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q1', yFork(action)];
    }
  }, 'q1', 'takeEvery(' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 1608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeLatest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(177);




function takeLatest(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__io__["d" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["e" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yCancel = function yCancel(task) {
    return { done: false, value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__io__["f" /* cancel */])(task) };
  };

  var task = void 0,
      action = void 0;
  var setTask = function setTask(t) {
    return task = t;
  };
  var setAction = function setAction(ac) {
    return action = ac;
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
    },
    q3: function q3() {
      return ['q1', yFork(action), setTask];
    }
  }, 'q1', 'takeLatest(' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 1609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buffers__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(67);






function throttle(delayLength, pattern, worker) {
  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action = void 0,
      channel = void 0;

  var yActionChannel = { done: false, value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__io__["c" /* actionChannel */])(pattern, __WEBPACK_IMPORTED_MODULE_3__buffers__["a" /* buffers */].sliding(1)) };
  var yTake = function yTake() {
    return { done: false, value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__io__["d" /* take */])(channel) };
  };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["e" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yDelay = { done: false, value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__io__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_4__utils__["i" /* delay */], delayLength) };

  var setAction = function setAction(ac) {
    return action = ac;
  };
  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yActionChannel, setChannel];
    },
    q2: function q2() {
      return ['q3', yTake(), setAction];
    },
    q3: function q3() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q4', yFork(action)];
    },
    q4: function q4() {
      return ['q2', yDelay];
    }
  }, 'q1', 'throttle(' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(pattern) + ', ' + worker.name + ')');
}

/***/ }),
/* 1610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_utils__ = __webpack_require__(67);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TASK", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["r"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SAGA_ACTION", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "noop", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["p"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "is", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "deferred", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["s"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "arrayOfDeffered", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["t"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createMockTask", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["u"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cloneableGenerator", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["v"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_io__ = __webpack_require__(178);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "asEffect", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_io__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_proc__ = __webpack_require__(678);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CHANNEL_END", function() { return __WEBPACK_IMPORTED_MODULE_2__internal_proc__["a"]; });




/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = applyMiddleware;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _compose = __webpack_require__(683);

var _compose2 = _interopRequireDefault(_compose);

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (next) {
    return function (reducer, initialState) {
      var store = next(reducer, initialState);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

module.exports = exports['default'];

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = bindActionCreators;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utilsMapValues = __webpack_require__(685);

var _utilsMapValues2 = _interopRequireDefault(_utilsMapValues);

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */

function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null || actionCreators === undefined) {
    // eslint-disable-line no-eq-null
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  return _utilsMapValues2['default'](actionCreators, function (actionCreator) {
    return bindActionCreator(actionCreator, dispatch);
  });
}

module.exports = exports['default'];

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = combineReducers;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _createStore = __webpack_require__(682);

var _utilsIsPlainObject = __webpack_require__(684);

var _utilsIsPlainObject2 = _interopRequireDefault(_utilsIsPlainObject);

var _utilsMapValues = __webpack_require__(685);

var _utilsMapValues2 = _interopRequireDefault(_utilsMapValues);

var _utilsPick = __webpack_require__(1614);

var _utilsPick2 = _interopRequireDefault(_utilsPick);

/* eslint-disable no-console */

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Reducer "' + key + '" returned undefined handling ' + actionName + '. ' + 'To ignore an action, you must explicitly return the previous state.';
}

function getUnexpectedStateKeyWarningMessage(inputState, outputState, action) {
  var reducerKeys = Object.keys(outputState);
  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'initialState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!_utilsIsPlainObject2['default'](inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + ({}).toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return reducerKeys.indexOf(key) < 0;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerSanity(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */

function combineReducers(reducers) {
  var finalReducers = _utilsPick2['default'](reducers, function (val) {
    return typeof val === 'function';
  });
  var sanityError;

  try {
    assertReducerSanity(finalReducers);
  } catch (e) {
    sanityError = e;
  }

  var defaultState = _utilsMapValues2['default'](finalReducers, function () {
    return undefined;
  });

  return function combination(state, action) {
    if (state === undefined) state = defaultState;

    if (sanityError) {
      throw sanityError;
    }

    var hasChanged = false;
    var finalState = _utilsMapValues2['default'](finalReducers, function (reducer, key) {
      var previousStateForKey = state[key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(key, action);
        throw new Error(errorMessage);
      }
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
      return nextStateForKey;
    });

    if (false) {
      var warningMessage = getUnexpectedStateKeyWarningMessage(state, finalState, action);
      if (warningMessage) {
        console.error(warningMessage);
      }
    }

    return hasChanged ? finalState : state;
  };
}

module.exports = exports['default'];

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Picks key-value pairs from an object where values satisfy a predicate.
 *
 * @param {Object} obj The object to pick from.
 * @param {Function} fn The predicate the values must satisfy to be copied.
 * @returns {Object} The object with the values that satisfied the predicate.
 */


exports.__esModule = true;
exports["default"] = pick;

function pick(obj, fn) {
  return Object.keys(obj).reduce(function (result, key) {
    if (fn(obj[key])) {
      result[key] = obj[key];
    }
    return result;
  }, {});
}

module.exports = exports["default"];

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(150);
var define = __webpack_require__(513);
var hasDescriptors = __webpack_require__(523)();
var gOPD = __webpack_require__(522);

var $TypeError = __webpack_require__(149);
var $floor = GetIntrinsic('%Math.floor%');

/** @type {import('.')} */
module.exports = function setFunctionLength(fn, length) {
	if (typeof fn !== 'function') {
		throw new $TypeError('`fn` is not a function');
	}
	if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
		throw new $TypeError('`length` must be a positive 32-bit integer');
	}

	var loose = arguments.length > 2 && !!arguments[2];

	var functionLengthIsConfigurable = true;
	var functionLengthIsWritable = true;
	if ('length' in fn && gOPD) {
		var desc = gOPD(fn, 'length');
		if (desc && !desc.configurable) {
			functionLengthIsConfigurable = false;
		}
		if (desc && !desc.writable) {
			functionLengthIsWritable = false;
		}
	}

	if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
		if (hasDescriptors) {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length, true, true);
		} else {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length);
		}
	}
	return fn;
};


/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(150);
var callBound = __webpack_require__(306);
var inspect = __webpack_require__(1425);

var $TypeError = __webpack_require__(149);
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/
/** @type {import('.').listGetNode} */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	/** @type {typeof list | NonNullable<(typeof list)['next']>} */
	var prev = list;
	/** @type {(typeof list)['next']} */
	var curr;
	for (; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			// eslint-disable-next-line no-extra-parens
			curr.next = /** @type {NonNullable<typeof list.next>} */ (list.next);
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

/** @type {import('.').listGet} */
var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
/** @type {import('.').listSet} */
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = /** @type {import('.').ListNode<typeof value>} */ ({ // eslint-disable-line no-param-reassign, no-extra-parens
			key: key,
			next: objects.next,
			value: value
		});
	}
};
/** @type {import('.').listHas} */
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

/** @type {import('.')} */
module.exports = function getSideChannel() {
	/** @type {WeakMap<object, unknown>} */ var $wm;
	/** @type {Map<object, unknown>} */ var $m;
	/** @type {import('.').RootNode<unknown>} */ var $o;

	/** @type {import('.').Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					// Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};


/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

/* smoothscroll v0.4.4 - 2019 - Dustan Kasten, Jeremias Menichelli - MIT License */
(function () {
  'use strict';

  // polyfill
  function polyfill() {
    // aliases
    var w = window;
    var d = document;

    // return if scroll behavior is supported and polyfill is not forced
    if (
      'scrollBehavior' in d.documentElement.style &&
      w.__forceSmoothScrollPolyfill__ !== true
    ) {
      return;
    }

    // globals
    var Element = w.HTMLElement || w.Element;
    var SCROLL_TIME = 468;

    // object gathering original scroll methods
    var original = {
      scroll: w.scroll || w.scrollTo,
      scrollBy: w.scrollBy,
      elementScroll: Element.prototype.scroll || scrollElement,
      scrollIntoView: Element.prototype.scrollIntoView
    };

    // define timing method
    var now =
      w.performance && w.performance.now
        ? w.performance.now.bind(w.performance)
        : Date.now;

    /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */
    function isMicrosoftBrowser(userAgent) {
      var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];

      return new RegExp(userAgentPatterns.join('|')).test(userAgent);
    }

    /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */
    var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;

    /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function scrollElement(x, y) {
      this.scrollLeft = x;
      this.scrollTop = y;
    }

    /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */
    function ease(k) {
      return 0.5 * (1 - Math.cos(Math.PI * k));
    }

    /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */
    function shouldBailOut(firstArg) {
      if (
        firstArg === null ||
        typeof firstArg !== 'object' ||
        firstArg.behavior === undefined ||
        firstArg.behavior === 'auto' ||
        firstArg.behavior === 'instant'
      ) {
        // first argument is not an object/null
        // or behavior is auto, instant or undefined
        return true;
      }

      if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') {
        // first argument is an object and behavior is smooth
        return false;
      }

      // throw error when behavior is not supported
      throw new TypeError(
        'behavior member of ScrollOptions ' +
          firstArg.behavior +
          ' is not a valid value for enumeration ScrollBehavior.'
      );
    }

    /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function hasScrollableSpace(el, axis) {
      if (axis === 'Y') {
        return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
      }

      if (axis === 'X') {
        return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
      }
    }

    /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function canOverflow(el, axis) {
      var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];

      return overflowValue === 'auto' || overflowValue === 'scroll';
    }

    /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function isScrollable(el) {
      var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
      var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');

      return isScrollableY || isScrollableX;
    }

    /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */
    function findScrollableParent(el) {
      while (el !== d.body && isScrollable(el) === false) {
        el = el.parentNode || el.host;
      }

      return el;
    }

    /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */
    function step(context) {
      var time = now();
      var value;
      var currentX;
      var currentY;
      var elapsed = (time - context.startTime) / SCROLL_TIME;

      // avoid elapsed times higher than one
      elapsed = elapsed > 1 ? 1 : elapsed;

      // apply easing to elapsed time
      value = ease(elapsed);

      currentX = context.startX + (context.x - context.startX) * value;
      currentY = context.startY + (context.y - context.startY) * value;

      context.method.call(context.scrollable, currentX, currentY);

      // scroll more if we have not reached our destination
      if (currentX !== context.x || currentY !== context.y) {
        w.requestAnimationFrame(step.bind(w, context));
      }
    }

    /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function smoothScroll(el, x, y) {
      var scrollable;
      var startX;
      var startY;
      var method;
      var startTime = now();

      // define scroll context
      if (el === d.body) {
        scrollable = w;
        startX = w.scrollX || w.pageXOffset;
        startY = w.scrollY || w.pageYOffset;
        method = original.scroll;
      } else {
        scrollable = el;
        startX = el.scrollLeft;
        startY = el.scrollTop;
        method = scrollElement;
      }

      // scroll looping over a frame
      step({
        scrollable: scrollable,
        method: method,
        startTime: startTime,
        startX: startX,
        startY: startY,
        x: x,
        y: y
      });
    }

    // ORIGINAL METHODS OVERRIDES
    // w.scroll and w.scrollTo
    w.scroll = w.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scroll.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object'
              ? arguments[0]
              : w.scrollX || w.pageXOffset,
          // use top prop, second argument if present or fallback to scrollY
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined
              ? arguments[1]
              : w.scrollY || w.pageYOffset
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        arguments[0].left !== undefined
          ? ~~arguments[0].left
          : w.scrollX || w.pageXOffset,
        arguments[0].top !== undefined
          ? ~~arguments[0].top
          : w.scrollY || w.pageYOffset
      );
    };

    // w.scrollBy
    w.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.scrollBy.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object' ? arguments[0] : 0,
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined ? arguments[1] : 0
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        ~~arguments[0].left + (w.scrollX || w.pageXOffset),
        ~~arguments[0].top + (w.scrollY || w.pageYOffset)
      );
    };

    // Element.prototype.scroll and Element.prototype.scrollTo
    Element.prototype.scroll = Element.prototype.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        // if one number is passed, throw error to match Firefox implementation
        if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
          throw new SyntaxError('Value could not be converted');
        }

        original.elementScroll.call(
          this,
          // use left prop, first number argument or fallback to scrollLeft
          arguments[0].left !== undefined
            ? ~~arguments[0].left
            : typeof arguments[0] !== 'object' ? ~~arguments[0] : this.scrollLeft,
          // use top prop, second argument or fallback to scrollTop
          arguments[0].top !== undefined
            ? ~~arguments[0].top
            : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop
        );

        return;
      }

      var left = arguments[0].left;
      var top = arguments[0].top;

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        this,
        this,
        typeof left === 'undefined' ? this.scrollLeft : ~~left,
        typeof top === 'undefined' ? this.scrollTop : ~~top
      );
    };

    // Element.prototype.scrollBy
    Element.prototype.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.elementScroll.call(
          this,
          arguments[0].left !== undefined
            ? ~~arguments[0].left + this.scrollLeft
            : ~~arguments[0] + this.scrollLeft,
          arguments[0].top !== undefined
            ? ~~arguments[0].top + this.scrollTop
            : ~~arguments[1] + this.scrollTop
        );

        return;
      }

      this.scroll({
        left: ~~arguments[0].left + this.scrollLeft,
        top: ~~arguments[0].top + this.scrollTop,
        behavior: arguments[0].behavior
      });
    };

    // Element.prototype.scrollIntoView
    Element.prototype.scrollIntoView = function() {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scrollIntoView.call(
          this,
          arguments[0] === undefined ? true : arguments[0]
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      var scrollableParent = findScrollableParent(this);
      var parentRects = scrollableParent.getBoundingClientRect();
      var clientRects = this.getBoundingClientRect();

      if (scrollableParent !== d.body) {
        // reveal element inside parent
        smoothScroll.call(
          this,
          scrollableParent,
          scrollableParent.scrollLeft + clientRects.left - parentRects.left,
          scrollableParent.scrollTop + clientRects.top - parentRects.top
        );

        // reveal parent in viewport unless is fixed
        if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
          w.scrollBy({
            left: parentRects.left,
            top: parentRects.top,
            behavior: 'smooth'
          });
        }
      } else {
        // reveal element in viewport
        w.scrollBy({
          left: clientRects.left,
          top: clientRects.top,
          behavior: 'smooth'
        });
      }
    };
  }

  if (true) {
    // commonjs
    module.exports = { polyfill: polyfill };
  } else {
    // global
    polyfill();
  }

}());


/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */
(function (factory) {/* eslint-disable */
	 true ? (module['exports'] = factory(null)) :
		typeof define === 'function' && define['amd'] ? define(factory(null)) :
			(window['stylis'] = factory(null))
}(/** @param {*=} options */function factory (options) {/* eslint-disable */

	'use strict'

	/**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */

	var nullptn = /^\0+/g /* matches leading null characters */
	var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
	var colonptn = /: */g /* splits animation rules */
	var cursorptn = /zoo|gra/ /* assert cursor varient */
	var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
	var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
	var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
	var elementptn = / *[\0] */g /* selector elements */
	var selectorptn = /,\r+?/g /* splits selectors */
	var andptn = /([\t\r\n ])*\f?&/g /* match & */
	var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
	var invalidptn = /\W+/g /* removes invalid characters from keyframes */
	var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
	var plcholdrptn = /::(place)/g /* match ::placeholder varient */
	var readonlyptn = /:(read-only)/g /* match :read-only varient */
	var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
	var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
	var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
	var whiteptn = /\s{2,}/g /* matches repeating whitespace */
	var pseudoptn = /([^\(])(:+) */g /* pseudo element */
	var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
	var gradientptn = /([\w-]+t\()/g /* match *gradient property */
	var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
	var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
	var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
	var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
	var trimptn = /[ \t]+$/ /* match tail whitspace */
	var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */
	var imgsrcptn = /([^-])(image-set\()/

	/* vendors */
	var webkit = '-webkit-'
	var moz = '-moz-'
	var ms = '-ms-'

	/* character codes */
	var SEMICOLON = 59 /* ; */
	var CLOSEBRACES = 125 /* } */
	var OPENBRACES = 123 /* { */
	var OPENPARENTHESES = 40 /* ( */
	var CLOSEPARENTHESES = 41 /* ) */
	var OPENBRACKET = 91 /* [ */
	var CLOSEBRACKET = 93 /* ] */
	var NEWLINE = 10 /* \n */
	var CARRIAGE = 13 /* \r */
	var TAB = 9 /* \t */
	var AT = 64 /* @ */
	var SPACE = 32 /*   */
	var AND = 38 /* & */
	var DASH = 45 /* - */
	var UNDERSCORE = 95 /* _ */
	var STAR = 42 /* * */
	var COMMA = 44 /* , */
	var COLON = 58 /* : */
	var SINGLEQUOTE = 39 /* ' */
	var DOUBLEQUOTE = 34 /* " */
	var FOWARDSLASH = 47 /* / */
	var GREATERTHAN = 62 /* > */
	var PLUS = 43 /* + */
	var TILDE = 126 /* ~ */
	var NULL = 0 /* \0 */
	var FORMFEED = 12 /* \f */
	var VERTICALTAB = 11 /* \v */

	/* special identifiers */
	var KEYFRAME = 107 /* k */
	var MEDIA = 109 /* m */
	var SUPPORTS = 115 /* s */
	var PLACEHOLDER = 112 /* p */
	var READONLY = 111 /* o */
	var IMPORT = 105 /* <at>i */
	var CHARSET = 99 /* <at>c */
	var DOCUMENT = 100 /* <at>d */
	var PAGE = 112 /* <at>p */

	var column = 1 /* current column */
	var line = 1 /* current line numebr */
	var pattern = 0 /* :pattern */

	var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
	var prefix = 1 /* vendor prefix */
	var escape = 1 /* escape :global() pattern */
	var compress = 0 /* compress output */
	var semicolon = 0 /* no/semicolon option */
	var preserve = 0 /* preserve empty selectors */

	/* empty reference */
	var array = []

	/* plugins */
	var plugins = []
	var plugged = 0
	var should = null

	/* plugin context */
	var POSTS = -2
	var PREPS = -1
	var UNKWN = 0
	var PROPS = 1
	var BLCKS = 2
	var ATRUL = 3

	/* plugin newline context */
	var unkwn = 0

	/* keyframe animation */
	var keyed = 1
	var key = ''

	/* selector namespace */
	var nscopealt = ''
	var nscope = ''

	/**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */
	function compile (parent, current, body, id, depth) {
		var bracket = 0 /* brackets [] */
		var comment = 0 /* comments /* // or /* */
		var parentheses = 0 /* functions () */
		var quote = 0 /* quotes '', "" */

		var first = 0 /* first character code */
		var second = 0 /* second character code */
		var code = 0 /* current character code */
		var tail = 0 /* previous character code */
		var trail = 0 /* character before previous code */
		var peak = 0 /* previous non-whitespace code */

		var counter = 0 /* count sequence termination */
		var context = 0 /* track current context */
		var atrule = 0 /* track @at-rule context */
		var pseudo = 0 /* track pseudo token index */
		var caret = 0 /* current character index */
		var format = 0 /* control character formating context */
		var insert = 0 /* auto semicolon insertion */
		var invert = 0 /* inverted selector pattern */
		var length = 0 /* generic length address */
		var eof = body.length /* end of file(length) */
		var eol = eof - 1 /* end of file(characters) */

		var char = '' /* current character */
		var chars = '' /* current buffer of characters */
		var child = '' /* next buffer of characters */
		var out = '' /* compiled body */
		var children = '' /* compiled children */
		var flat = '' /* compiled leafs */
		var selector /* generic selector address */
		var result /* generic address */

		// ...build body
		while (caret < eof) {
			code = body.charCodeAt(caret)

			// eof varient
			if (caret === eol) {
				// last character + noop context, add synthetic padding for noop context to terminate
				if (comment + quote + parentheses + bracket !== 0) {
					if (comment !== 0) {
						code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
					}

					quote = parentheses = bracket = 0
					eof++
					eol++
				}
			}

			if (comment + quote + parentheses + bracket === 0) {
				// eof varient
				if (caret === eol) {
					if (format > 0) {
						chars = chars.replace(formatptn, '')
					}

					if (chars.trim().length > 0) {
						switch (code) {
							case SPACE:
							case TAB:
							case SEMICOLON:
							case CARRIAGE:
							case NEWLINE: {
								break
							}
							default: {
								chars += body.charAt(caret)
							}
						}

						code = SEMICOLON
					}
				}

				// auto semicolon insertion
				if (insert === 1) {
					switch (code) {
						// false flags
						case OPENBRACES:
						case CLOSEBRACES:
						case SEMICOLON:
						case DOUBLEQUOTE:
						case SINGLEQUOTE:
						case OPENPARENTHESES:
						case CLOSEPARENTHESES:
						case COMMA: {
							insert = 0
						}
						// ignore
						case TAB:
						case CARRIAGE:
						case NEWLINE:
						case SPACE: {
							break
						}
						// valid
						default: {
							insert = 0
							length = caret
							first = code
							caret--
							code = SEMICOLON

							while (length < eof) {
								switch (body.charCodeAt(length++)) {
									case NEWLINE:
									case CARRIAGE:
									case SEMICOLON: {
										++caret
										code = first
										length = eof
										break
									}
									case COLON: {
										if (format > 0) {
											++caret
											code = first
										}
									}
									case OPENBRACES: {
										length = eof
									}
								}
							}
						}
					}
				}

				// token varient
				switch (code) {
					case OPENBRACES: {
						chars = chars.trim()
						first = chars.charCodeAt(0)
						counter = 1
						length = ++caret

						while (caret < eof) {
							switch (code = body.charCodeAt(caret)) {
								case OPENBRACES: {
									counter++
									break
								}
								case CLOSEBRACES: {
									counter--
									break
								}
								case FOWARDSLASH: {
									switch (second = body.charCodeAt(caret + 1)) {
										// /*, //
										case STAR:
										case FOWARDSLASH: {
											caret = delimited(second, caret, eol, body)
										}
									}
									break
								}
								// given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
								case OPENBRACKET: {
									code++
								}
								// given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
								case OPENPARENTHESES: {
									code++
								}
								// quote tail delimiter is identical to the head delimiter hence noop,
								// fallthrough clauses have been shifted to the correct tail delimiter
								case DOUBLEQUOTE:
								case SINGLEQUOTE: {
									while (caret++ < eol) {
										if (body.charCodeAt(caret) === code) {
											break
										}
									}
								}
							}

							if (counter === 0) {
								break
							}

							caret++
						}

						child = body.substring(length, caret)

						if (first === NULL) {
							first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
						}

						switch (first) {
							// @at-rule
							case AT: {
								if (format > 0) {
									chars = chars.replace(formatptn, '')
								}

								second = chars.charCodeAt(1)

								switch (second) {
									case DOCUMENT:
									case MEDIA:
									case SUPPORTS:
									case DASH: {
										selector = current
										break
									}
									default: {
										selector = array
									}
								}

								child = compile(current, selector, child, second, depth+1)
								length = child.length

								// preserve empty @at-rule
								if (preserve > 0 && length === 0) {
									length = chars.length
								}

								// execute plugins, @at-rule context
								if (plugged > 0) {
									selector = select(array, chars, invert)
									result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id)
									chars = selector.join('')

									if (result !== void 0) {
										if ((length = (child = result.trim()).length) === 0) {
											second = 0
											child = ''
										}
									}
								}

								if (length > 0) {
									switch (second) {
										case SUPPORTS: {
											chars = chars.replace(supportsptn, supports)
										}
										case DOCUMENT:
										case MEDIA:
										case DASH: {
											child = chars + '{' + child + '}'
											break
										}
										case KEYFRAME: {
											chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
											child = chars + '{' + child + '}'

											if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
												child = '@' + webkit + child + '@' + child
											} else {
												child = '@' + child
											}
											break
										}
										default: {
											child = chars + child

											if (id === PAGE) {
												child = (out += child, '')
											}
										}
									}
								} else {
									child = ''
								}

								break
							}
							// selector
							default: {
								child = compile(current, select(current, chars, invert), child, id, depth+1)
							}
						}

						children += child

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						atrule = 0
						chars = ''
						child = ''
						code = body.charCodeAt(++caret)
						break
					}
					case CLOSEBRACES:
					case SEMICOLON: {
						chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()

						if ((length = chars.length) > 1) {
							// monkey-patch missing colon
							if (pseudo === 0) {
								first = chars.charCodeAt(0)

								// first character is a letter or dash, buffer has a space character
								if ((first === DASH || first > 96 && first < 123)) {
									length = (chars = chars.replace(' ', ':')).length
								}
							}

							// execute plugins, property context
							if (plugged > 0) {
								if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
									if ((length = (chars = result.trim()).length) === 0) {
										chars = '\0\0'
									}
								}
							}

							first = chars.charCodeAt(0)
							second = chars.charCodeAt(1)

							switch (first) {
								case NULL: {
									break
								}
								case AT: {
									if (second === IMPORT || second === CHARSET) {
										flat += chars + body.charAt(caret)
										break
									}
								}
								default: {
									if (chars.charCodeAt(length-1) === COLON) {
										break
									}

									out += property(chars, first, second, chars.charCodeAt(2))
								}
							}
						}

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						chars = ''
						code = body.charCodeAt(++caret)
						break
					}
				}
			}

			// parse characters
			switch (code) {
				case CARRIAGE:
				case NEWLINE: {
					// auto insert semicolon
					if (comment + quote + parentheses + bracket + semicolon === 0) {
						// valid non-whitespace characters that
						// may precede a newline
						switch (peak) {
							case CLOSEPARENTHESES:
							case SINGLEQUOTE:
							case DOUBLEQUOTE:
							case AT:
							case TILDE:
							case GREATERTHAN:
							case STAR:
							case PLUS:
							case FOWARDSLASH:
							case DASH:
							case COLON:
							case COMMA:
							case SEMICOLON:
							case OPENBRACES:
							case CLOSEBRACES: {
								break
							}
							default: {
								// current buffer has a colon
								if (pseudo > 0) {
									insert = 1
								}
							}
						}
					}

					// terminate line comment
					if (comment === FOWARDSLASH) {
						comment = 0
					} else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
						format = 1
						chars += '\0'
					}

					// execute plugins, newline context
					if (plugged * unkwn > 0) {
						proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id)
					}

					// next line, reset column position
					column = 1
					line++
					break
				}
				case SEMICOLON:
				case CLOSEBRACES: {
					if (comment + quote + parentheses + bracket === 0) {
						column++
						break
					}
				}
				default: {
					// increment column position
					column++

					// current character
					char = body.charAt(caret)

					// remove comments, escape functions, strings, attributes and prepare selectors
					switch (code) {
						case TAB:
						case SPACE: {
							if (quote + bracket + comment === 0) {
								switch (tail) {
									case COMMA:
									case COLON:
									case TAB:
									case SPACE: {
										char = ''
										break
									}
									default: {
										if (code !== SPACE) {
											char = ' '
										}
									}
								}
							}
							break
						}
						// escape breaking control characters
						case NULL: {
							char = '\\0'
							break
						}
						case FORMFEED: {
							char = '\\f'
							break
						}
						case VERTICALTAB: {
							char = '\\v'
							break
						}
						// &
						case AND: {
							// inverted selector pattern i.e html &
							if (quote + comment + bracket === 0 && cascade > 0) {
								invert = 1
								format = 1
								char = '\f' + char
							}
							break
						}
						// ::p<l>aceholder, l
						// :read-on<l>y, l
						case 108: {
							if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
								switch (caret - pseudo) {
									// ::placeholder
									case 2: {
										if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
											pattern = tail
										}
									}
									// :read-only
									case 8: {
										if (trail === READONLY) {
											pattern = trail
										}
									}
								}
							}
							break
						}
						// :<pattern>
						case COLON: {
							if (quote + comment + bracket === 0) {
								pseudo = caret
							}
							break
						}
						// selectors
						case COMMA: {
							if (comment + parentheses + quote + bracket === 0) {
								format = 1
								char += '\r'
							}
							break
						}
						// quotes
						case DOUBLEQUOTE:
						case SINGLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						// attributes
						case OPENBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket++
							}
							break
						}
						case CLOSEBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket--
							}
							break
						}
						// functions
						case CLOSEPARENTHESES: {
							if (quote + comment + bracket === 0) {
								parentheses--
							}
							break
						}
						case OPENPARENTHESES: {
							if (quote + comment + bracket === 0) {
								if (context === 0) {
									switch (tail*2 + trail*3) {
										// :matches
										case 533: {
											break
										}
										// :global, :not, :nth-child etc...
										default: {
											counter = 0
											context = 1
										}
									}
								}

								parentheses++
							}
							break
						}
						case AT: {
							if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
								atrule = 1
							}
							break
						}
						// block/line comments
						case STAR:
						case FOWARDSLASH: {
							if (quote + bracket + parentheses > 0) {
								break
							}

							switch (comment) {
								// initialize line/block comment context
								case 0: {
									switch (code*2 + body.charCodeAt(caret+1)*3) {
										// //
										case 235: {
											comment = FOWARDSLASH
											break
										}
										// /*
										case 220: {
											length = caret
											comment = STAR
											break
										}
									}
									break
								}
								// end block comment context
								case STAR: {
									if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
										// /*<!> ... */, !
										if (body.charCodeAt(length+2) === 33) {
											out += body.substring(length, caret+1)
										}
										char = ''
										comment = 0
									}
								}
							}
						}
					}

					// ignore comment blocks
					if (comment === 0) {
						// aggressive isolation mode, divide each individual selector
						// including selectors in :not function but excluding selectors in :global function
						if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
							switch (code) {
								case COMMA:
								case TILDE:
								case GREATERTHAN:
								case PLUS:
								case CLOSEPARENTHESES:
								case OPENPARENTHESES: {
									if (context === 0) {
										// outside of an isolated context i.e nth-child(<...>)
										switch (tail) {
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												char = char + '\0'
												break
											}
											default: {
												char = '\0' + char + (code === COMMA ? '' : '\0')
											}
										}
										format = 1
									} else {
										// within an isolated context, sleep untill it's terminated
										switch (code) {
											case OPENPARENTHESES: {
												// :globa<l>(
												if (pseudo + 7 === caret && tail === 108) {
													pseudo = 0
												}
												context = ++counter
												break
											}
											case CLOSEPARENTHESES: {
												if ((context = --counter) === 0) {
													format = 1
													char += '\0'
												}
												break
											}
										}
									}
									break
								}
								case TAB:
								case SPACE: {
									switch (tail) {
										case NULL:
										case OPENBRACES:
										case CLOSEBRACES:
										case SEMICOLON:
										case COMMA:
										case FORMFEED:
										case TAB:
										case SPACE:
										case NEWLINE:
										case CARRIAGE: {
											break
										}
										default: {
											// ignore in isolated contexts
											if (context === 0) {
												format = 1
												char += '\0'
											}
										}
									}
								}
							}
						}

						// concat buffer of characters
						chars += char

						// previous non-whitespace character code
						if (code !== SPACE && code !== TAB) {
							peak = code
						}
					}
				}
			}

			// tail character codes
			trail = tail
			tail = code

			// visit every character
			caret++
		}

		length = out.length

		// preserve empty selector
 		if (preserve > 0) {
 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
					length = current.join(',').length + 2
 				}
 			}
		}

		if (length > 0) {
			// cascade isolation mode?
			selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current

			// execute plugins, block context
			if (plugged > 0) {
				result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id)

				if (result !== void 0 && (out = result).length === 0) {
					return flat + out + children
				}
			}

			out = selector.join(',') + '{' + out + '}'

			if (prefix*pattern !== 0) {
				if (prefix === 2 && !vendor(out, 2))
					pattern = 0

				switch (pattern) {
					// ::read-only
					case READONLY: {
						out = out.replace(readonlyptn, ':'+moz+'$1')+out
						break
					}
					// ::placeholder
					case PLACEHOLDER: {
						out = (
							out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
							out.replace(plcholdrptn, '::' + moz + '$1') +
							out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
						)
						break
					}
				}

				pattern = 0
			}
		}

		return flat + out + children
	}

	/**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */
	function select (parent, current, invert) {
		var selectors = current.trim().split(selectorptn)
		var out = selectors

		var length = selectors.length
		var l = parent.length

		switch (l) {
			// 0-1 parent selectors
			case 0:
			case 1: {
				for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
					out[i] = scope(selector, out[i], invert, l).trim()
				}
				break
			}
			// >2 parent selectors, nested
			default: {
				for (var i = 0, j = 0, out = []; i < length; ++i) {
					for (var k = 0; k < l; ++k) {
						out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
					}
				}
			}
		}

		return out
	}

	/**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */
	function scope (parent, current, invert, level) {
		var selector = current
		var code = selector.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (selector = selector.trim()).charCodeAt(0)
		}

		switch (code) {
			// &
			case AND: {
				switch (cascade + level) {
					case 0:
					case 1: {
						if (parent.trim().length === 0) {
							break
						}
					}
					default: {
						return selector.replace(andptn, '$1'+parent.trim())
					}
				}
				break
			}
			// :
			case COLON: {
				switch (selector.charCodeAt(1)) {
					// g in :global
					case 103: {
						if (escape > 0 && cascade > 0) {
							return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
						}
						break
					}
					default: {
						// :hover
						return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
					}
				}
			}
			default: {
				// html &
				if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
					return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
				}
			}
		}

		return parent + selector
	}

	/**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */
	function property (input, first, second, third) {
		var index = 0
		var out = input + ';'
		var hash = (first*2) + (second*3) + (third*4)
		var cache

		// animation: a, n, i characters
		if (hash === 944) {
			return animation(out)
		} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
			return out
		}

		// vendor prefix
		switch (hash) {
			// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
			case 1015: {
				// text-shadow/text-align/text-transform, a
				return out.charCodeAt(10) === 97 ? webkit + out + out : out
			}
			// filter/fill f, i, l
			case 951: {
				// filter, t
				return out.charCodeAt(3) === 116 ? webkit + out + out : out
			}
			// color/column, c, o, l
			case 963: {
				// column, n
				return out.charCodeAt(5) === 110 ? webkit + out + out : out
			}
			// box-decoration-break, b, o, x
			case 1009: {
				if (out.charCodeAt(4) !== 100) {
					break
				}
			}
			// mask, m, a, s
			// clip-path, c, l, i
			case 969:
			case 942: {
				return webkit + out + out
			}
			// appearance: a, p, p
			case 978: {
				return webkit + out + moz + out + out
			}
			// hyphens: h, y, p
			// user-select: u, s, e
			case 1019:
			case 983: {
				return webkit + out + moz + out + ms + out + out
			}
			// background/backface-visibility, b, a, c
			case 883: {
				// backface-visibility, -
				if (out.charCodeAt(8) === DASH) {
					return webkit + out + out
				}

				// image-set(...)
				if (out.indexOf('image-set(', 11) > 0) {
					return out.replace(imgsrcptn, '$1'+webkit+'$2') + out
				}

				return out
			}
			// flex: f, l, e
			case 932: {
				if (out.charCodeAt(4) === DASH) {
					switch (out.charCodeAt(5)) {
						// flex-grow, g
						case 103: {
							return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
						}
						// flex-shrink, s
						case 115: {
							return webkit + out + ms + out.replace('shrink', 'negative') + out
						}
						// flex-basis, b
						case 98: {
							return webkit + out + ms + out.replace('basis', 'preferred-size') + out
						}
					}
				}

				return webkit + out + ms + out + out
			}
			// order: o, r, d
			case 964: {
				return webkit + out + ms + 'flex' + '-' + out + out
			}
			// justify-items/justify-content, j, u, s
			case 1023: {
				// justify-content, c
				if (out.charCodeAt(8) !== 99) {
					break
				}

				cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
				return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
			}
			// cursor, c, u, r
			case 1005: {
				return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
			}
			// writing-mode, w, r, i
			case 1000: {
				cache = out.substring(13).trim()
				index = cache.indexOf('-') + 1

				switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
					// vertical-lr
					case 226: {
						cache = out.replace(writingptn, 'tb')
						break
					}
					// vertical-rl
					case 232: {
						cache = out.replace(writingptn, 'tb-rl')
						break
					}
					// horizontal-tb
					case 220: {
						cache = out.replace(writingptn, 'lr')
						break
					}
					default: {
						return out
					}
				}

				return webkit + out + ms + cache + out
			}
			// position: sticky
			case 1017: {
				if (out.indexOf('sticky', 9) === -1) {
					return out
				}
			}
			// display(flex/inline-flex/inline-box): d, i, s
			case 975: {
				index = (out = input).length - 10
				cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()

				switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
					// inline-
					case 203: {
						// inline-box
						if (cache.charCodeAt(8) < 111) {
							break
						}
					}
					// inline-box/sticky
					case 115: {
						out = out.replace(cache, webkit+cache)+';'+out
						break
					}
					// inline-flex
					// flex
					case 207:
					case 102: {
						out = (
							out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
							out.replace(cache, webkit+cache)+';'+
							out.replace(cache, ms+cache+'box')+';'+
							out
						)
					}
				}

				return out + ';'
			}
			// align-items, align-center, align-self: a, l, i, -
			case 938: {
				if (out.charCodeAt(5) === DASH) {
					switch (out.charCodeAt(6)) {
						// align-items, i
						case 105: {
							cache = out.replace('-items', '')
							return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
						}
						// align-self, s
						case 115: {
							return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
						}
						// align-content
						default: {
							return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
						}
					}
				}
				break
			}
			// min/max
			case 973:
			case 989: {
				// min-/max- height/width/block-size/inline-size
				if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
					break
				}
			}
			// height/width: min-content / width: max-content
			case 931:
			case 953: {
				if (dimensionptn.test(input) === true) {
					// stretch
					if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115)
						return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch')
					else
						return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out
				}
				break
			}
			// transform, transition: t, r, a
			case 962: {
				out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out

				// transitions
				if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
					return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
				}

				break
			}
		}

		return out
	}

	/**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */
	function vendor (content, context) {
		var index = content.indexOf(context === 1 ? ':' : '{')
		var key = content.substring(0, context !== 3 ? index : 10)
		var value = content.substring(index + 1, content.length - 1)

		return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
	}

	/**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */
	function supports (match, group) {
		var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))

		return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
	}

	/**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */
	function animation (input) {
		var length = input.length
		var index = input.indexOf(':', 9) + 1
		var declare = input.substring(0, index).trim()
		var out = input.substring(index, length-1).trim()

		switch (input.charCodeAt(9)*keyed) {
			case 0: {
				break
			}
			// animation-*, -
			case DASH: {
				// animation-name, n
				if (input.charCodeAt(10) !== 110) {
					break
				}
			}
			// animation/animation-name
			default: {
				// split in case of multiple animations
				var list = out.split((out = '', animationptn))

				for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
					var value = list[i]
					var items = value.split(propertiesptn)

					while (value = items[index]) {
						var peak = value.charCodeAt(0)

						if (keyed === 1 && (
							// letters
							(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
							// dash but not in sequence i.e --
							(peak === DASH && value.charCodeAt(1) !== DASH)
						)) {
							// not a number/function
							switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
								case 1: {
									switch (value) {
										// not a valid reserved keyword
										case 'infinite': case 'alternate': case 'backwards': case 'running':
										case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
										case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
										case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
										case 'initial': case 'unset': case 'step-start': case 'step-end': {
											break
										}
										default: {
											value += key
										}
									}
								}
							}
						}

						items[index++] = value
					}

					out += (i === 0 ? '' : ',') + items.join(' ')
				}
			}
		}

		out = declare + out + ';'

		if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
			return webkit + out + out

		return out
	}

	/**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */
	function isolate (current) {
		for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
			// split individual elements in a selector i.e h1 h2 === [h1, h2]
			var elements = current[i].split(elementptn)
			var out = ''

			for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
				// empty element
				if ((size = (element = elements[j]).length) === 0 && l > 1) {
					continue
				}

				tail = out.charCodeAt(out.length-1)
				code = element.charCodeAt(0)
				padding = ''

				if (j !== 0) {
					// determine if we need padding
					switch (tail) {
						case STAR:
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case OPENPARENTHESES:  {
							break
						}
						default: {
							padding = ' '
						}
					}
				}

				switch (code) {
					case AND: {
						element = padding + nscopealt
					}
					case TILDE:
					case GREATERTHAN:
					case PLUS:
					case SPACE:
					case CLOSEPARENTHESES:
					case OPENPARENTHESES: {
						break
					}
					case OPENBRACKET: {
						element = padding + element + nscopealt
						break
					}
					case COLON: {
						switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
							// :global
							case 530: {
								if (escape > 0) {
									element = padding + element.substring(8, size - 1)
									break
								}
							}
							// :hover, :nth-child(), ...
							default: {
								if (j < 1 || elements[j-1].length < 1) {
									element = padding + nscopealt + element
								}
							}
						}
						break
					}
					case COMMA: {
						padding = ''
					}
					default: {
						if (size > 1 && element.indexOf(':') > 0) {
							element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
						} else {
							element = padding + element + nscopealt
						}
					}
				}

				out += element
			}

			selector[i] = out.replace(formatptn, '').trim()
		}

		return selector
	}

	/**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */
	function proxy (context, content, selectors, parents, line, column, length, id, depth, at) {
		for (var i = 0, out = content, next; i < plugged; ++i) {
			switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
				case void 0:
				case false:
				case true:
				case null: {
					break
				}
				default: {
					out = next
				}
			}
		}
		if (out !== content) {
		  return out
		}
	}

	/**
	 * @param {number} code
	 * @param {number} index
	 * @param {number} length
	 * @param {string} body
	 * @return {number}
	 */
	function delimited (code, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				// /*
				case FOWARDSLASH: {
					if (code === STAR) {
						if (body.charCodeAt(i - 1) === STAR &&  index + 2 !== i) {
							return i + 1
						}
					}
					break
				}
				// //
				case NEWLINE: {
					if (code === FOWARDSLASH) {
						return i + 1
					}
				}
			}
		}

		return i
	}

	/**
	 * @param {number} type
	 * @param {number} index
	 * @param {number} length
	 * @param {number} find
	 * @param {string} body
	 * @return {number}
	 */
	function match (type, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				case type: {
					return i
				}
			}
		}

		return i
	}

	/**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */
	function minify (output) {
		return output
			.replace(formatptn, '')
			.replace(beforeptn, '')
			.replace(afterptn, '$1')
			.replace(tailptn, '$1')
			.replace(whiteptn, ' ')
	}

	/**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */
	function use (plugin) {
		switch (plugin) {
			case void 0:
			case null: {
				plugged = plugins.length = 0
				break
			}
			default: {
				if (typeof plugin === 'function') {
					plugins[plugged++] = plugin
				}	else if (typeof plugin === 'object') {
					for (var i = 0, length = plugin.length; i < length; ++i) {
						use(plugin[i])
					}
				} else {
					unkwn = !!plugin|0
				}
			}
 		}

 		return use
	}

	/**
	 * Set
	 *
	 * @param {*} options
	 */
	function set (options) {
		for (var name in options) {
			var value = options[name]
			switch (name) {
				case 'keyframe': keyed = value|0; break
				case 'global': escape = value|0; break
				case 'cascade': cascade = value|0; break
				case 'compress': compress = value|0; break
				case 'semicolon': semicolon = value|0; break
				case 'preserve': preserve = value|0; break
				case 'prefix':
					should = null

					if (!value) {
						prefix = 0
					} else if (typeof value !== 'function') {
						prefix = 1
					} else {
						prefix = 2
						should = value
					}
			}
		}

		return set
	}

	/**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */
	function stylis (selector, input) {
		if (this !== void 0 && this.constructor === stylis) {
			return factory(selector)
		}

		// setup
		var ns = selector
		var code = ns.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (ns = ns.trim()).charCodeAt(0)
		}

		// keyframe/animation namespace
		if (keyed > 0) {
			key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
		}

		// reset, used to assert if a plugin is moneky-patching the return value
		code = 1

		// cascade/isolate
		if (cascade === 1) {
			nscope = ns
		} else {
			nscopealt = ns
		}

		var selectors = [nscope]
		var result

		// execute plugins, pre-process context
		if (plugged > 0) {
			result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0)

			if (result !== void 0 && typeof result === 'string') {
				input = result
			}
		}

		// build
		var output = compile(array, selectors, input, 0, 0)

		// execute plugins, post-process context
		if (plugged > 0) {
			result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0)

			// bypass minification
			if (result !== void 0 && typeof(output = result) !== 'string') {
				code = 0
			}
		}

		// reset
		key = ''
		nscope = ''
		nscopealt = ''
		pattern = 0
		line = 1
		column = 1

		return compress*code === 0 ? output : minify(output)
	}

	stylis['use'] = use
	stylis['set'] = set

	if (options !== void 0) {
		set(options)
	}

	return stylis
}));


/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcArrowComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-arrow up"},React.createElement("path",{"id":"icons/ic-arrow-language","d":"M14.3356 14.7474C14.7484 15.1143 15.3805 15.0771 15.7474 14.6644C16.1143 14.2516 16.0771 13.6195 15.6644 13.2526L12.1644 9.25258C11.7855 8.91579 11.2145 8.91579 10.8356 9.25258L7.33563 13.2526C6.92284 13.6195 6.88566 14.2516 7.25258 14.6644C7.6195 15.0771 8.25157 15.1143 8.66435 14.7474L11.5 11.3379L14.3356 14.7474Z","fill":"#3E3E3E"})));
}

IcArrowComponent.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IcArrowComponent;

IcArrowComponent.default = IcArrowComponent;


/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcEletricityComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-eletricity"},React.createElement("path",{"id":"icons/ic-eletricidade","fillRule":"evenodd","clipRule":"evenodd","d":"M4.37866 9.14103C4.37866 9.08025 4.39178 9.01923 4.41835 8.96216L7.93668 1.39939C8.008 1.24643 8.16425 1.14795 8.33594 1.14795H13.1947C13.359 1.14795 13.509 1.23742 13.5848 1.38027C13.6177 1.44269 13.634 1.51069 13.634 1.57845C13.634 1.66579 13.6069 1.75274 13.5535 1.82688L10.0208 6.73742H12.5245C12.6954 6.73742 12.8509 6.83482 12.923 6.98742C12.9947 7.13929 12.9701 7.31858 12.8598 7.44629L5.48782 15.9954C5.40216 16.0953 5.27789 16.1479 5.15253 16.1479C5.07827 16.1479 5.0029 16.1299 4.93488 16.091C4.7507 15.9878 4.66834 15.771 4.7382 15.5751L6.87971 9.57147H4.81761C4.66834 9.57147 4.52938 9.49716 4.44849 9.37378C4.40219 9.30336 4.37866 9.22241 4.37866 9.14103ZM8.6183 2.00906L5.50069 8.71072H7.49809C7.64074 8.71072 7.77419 8.77782 7.85617 8.89182C7.93853 9.00582 7.95985 9.15192 7.91279 9.28323L6.35142 13.6602L11.5782 7.59889H9.1738C9.00983 7.59889 8.85947 7.50942 8.7841 7.36656C8.70837 7.22371 8.72087 7.05127 8.81498 6.91959L12.3477 2.00906H8.6183Z","fill":"#FF8E2A"})));
}

IcEletricityComponent.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = IcEletricityComponent;

IcEletricityComponent.default = IcEletricityComponent;


/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcGasComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-gas"},React.createElement("path",{"id":"icons/ic-gas","fillRule":"evenodd","clipRule":"evenodd","d":"M7.72475 2.0518C7.74156 1.82926 7.8249 1.64824 7.97931 1.5H8.46602C9.46639 2.21608 10.4983 2.95762 11.4181 3.81601C12.5004 4.82578 13.8544 6.21608 14.7242 8.01692C15.2491 9.10481 15.5033 10.0588 15.5089 10.9817V11.0469C15.5082 11.1707 15.5029 11.2942 15.4931 11.417C15.3054 13.8007 14.2928 15.4344 12.3982 16.4104C12.283 16.47 12.1723 16.5 12.0694 16.5C11.937 16.5 11.826 16.4501 11.7392 16.3514C11.6278 16.2258 11.5841 16.087 11.6128 15.9503C11.6461 15.7902 11.7739 15.651 11.9727 15.5576C12.5263 15.2991 12.998 14.9234 13.374 14.4421C14.5918 12.883 14.8629 11.1209 14.1797 9.20352C13.7778 8.07621 13.1072 7.00471 12.0694 5.83101C11.2374 4.88961 10.2567 4.0082 8.98283 3.05738L8.95237 3.03436L8.95058 3.03298C8.8894 2.98588 8.82053 2.93286 8.72968 2.93286C8.60818 2.93286 8.52099 3.01971 8.47162 3.19201C8.07875 4.56243 7.22124 5.69358 6.35288 6.71277C6.23914 6.84608 6.12408 6.97906 6.0093 7.11171L5.99958 7.12295C5.43059 7.77904 4.84234 8.45745 4.40081 9.23736C3.55135 10.7382 3.45401 12.1006 4.10248 13.4027C4.7471 14.695 5.83536 15.4236 7.33644 15.5687C7.64107 15.5977 7.8375 15.7944 7.82595 16.057C7.81474 16.3137 7.61971 16.486 7.34134 16.4864C5.88368 16.4574 4.68863 15.8237 3.6732 14.5488C3.04504 13.7602 2.73201 12.7815 2.74321 11.6392C2.75442 10.4271 3.14868 9.28514 3.94877 8.14737C4.34829 7.57883 4.80943 7.04029 5.25517 6.52023C5.61757 6.09714 5.99188 5.6601 6.33432 5.20631C7.07173 4.22829 7.49541 3.35316 7.66663 2.45187C7.69044 2.3249 7.7146 2.18957 7.72475 2.0518ZM8.86694 6.4285C8.82703 6.18434 8.97619 6.04412 9.10855 5.96913C9.19223 5.92204 9.27416 5.89798 9.35295 5.89798C9.44889 5.89798 9.54098 5.9339 9.62711 6.00436C10.6888 6.8774 11.3901 7.72148 11.8351 8.66114C12.6611 10.4058 12.5179 12.0637 11.3978 13.7288L11.3754 13.7623C11.3727 13.7664 11.3699 13.7705 11.3672 13.7746C11.3519 13.7976 11.3366 13.8205 11.3194 13.8422C11.2056 13.9855 11.0505 14.0682 10.8939 14.0682C10.8012 14.0682 10.7133 14.0403 10.6324 13.9855C10.4135 13.8362 10.3698 13.5879 10.5158 13.3214C10.5624 13.2363 10.6163 13.1554 10.6702 13.0748C10.7091 13.0169 10.7476 12.959 10.784 12.8997C11.6394 11.5038 11.6096 10.0487 10.6954 8.57429C10.6219 8.45535 10.5396 8.34165 10.4573 8.22829L10.3502 8.079L10.0602 8.15853C10.014 8.78252 9.97166 9.34723 9.81199 9.89937C9.71185 10.2468 9.58089 10.5045 9.40127 10.71C9.15862 10.9869 8.84699 11.1338 8.49964 11.1338C8.15825 11.1338 7.8074 10.9922 7.48526 10.7246C7.31531 10.5832 7.22959 10.5119 7.11936 10.5119C6.94284 10.5119 6.88915 10.6679 6.80814 10.9034L6.80773 10.9046C6.48909 11.8324 6.72334 12.5628 7.52343 13.1369C7.7006 13.2642 7.96426 13.5283 7.74297 13.8659C7.65999 13.9935 7.53428 14.0602 7.37917 14.0602C7.25276 14.0602 7.11481 14.0152 6.97965 13.9301C5.84797 13.2147 5.41134 11.815 5.918 10.5272C6.09238 10.0825 6.32312 9.66533 6.60324 9.28723C6.73105 9.11423 6.89001 9.01936 7.05073 9.01936C7.2111 9.01936 7.36761 9.11493 7.49156 9.28758C7.702 9.58057 7.88408 9.78985 8.08191 9.96599C8.18696 10.0595 8.31301 10.1554 8.45062 10.1554C8.67926 10.1554 8.78396 9.906 8.83403 9.78566C9.03221 9.31304 9.04692 8.81671 9.04447 8.34862C9.04202 7.76857 8.98529 7.15853 8.86694 6.4285Z","fill":"#10C1EE"})));
}

IcGasComponent.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = IcGasComponent;

IcGasComponent.default = IcGasComponent;


/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcBrandColorComponent (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icons/ic-brand-color"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2},[React.createElement("linearGradient",{"x1":"158.87207%","y1":"50%","x2":"-2.22044605e-14%","y2":"50%","id":"linearGradient-1","key":0},[React.createElement("stop",{"stopColor":"#006736","offset":"0%","key":0}),React.createElement("stop",{"stopColor":"#93C13E","offset":"100%","key":1})]),React.createElement("path",{"d":"M40.0211403,18.8096986 L27.3886995,18.8096986 L27.3886995,4.81391779 C27.3886995,2.15531837 25.2338121,0 22.5752126,0 C19.9166132,0 17.7617257,2.15531837 17.7617257,4.81391779 L17.7617257,11.0278015 C17.7617257,11.7922027 18.0650732,12.5251488 18.6054109,13.0654865 L28.4038795,22.8635242 C29.0312572,23.4913328 29.0312572,24.5090981 28.4038795,25.1364758 L18.6054109,34.9349444 C18.0650732,35.4752821 17.7617257,36.2077973 17.7617257,36.9717676 L17.7617257,43.1860822 C17.7617257,45.8446816 19.9166132,48 22.5752126,48 C25.2338121,48 27.3886995,45.8446816 27.3886995,43.1860822 L27.3886995,28.4371033 L40.181001,28.4371033 C42.8693319,28.4371033 45.0431786,26.2335251 44.9936261,23.5335601 C44.9453662,20.8835786 42.6715528,18.8096986 40.0211403,18.8096986 M19.021652,30.9711752 L24.9601961,25.0322001 C25.5302653,24.4621309 25.5302653,23.5378691 24.9601961,22.967369 L19.021652,17.0288248 C18.5567202,16.5638931 17.7617257,16.8930941 17.7617257,17.5506342 L17.7617257,18.8096986 L4.97373325,18.8096986 C2.32288987,18.8096986 0.0495072867,20.8835786 0.000816567945,23.5335601 C-0.0483050422,26.2335251 2.12511076,28.4371033 4.81387257,28.4371033 L17.7617257,28.4371033 L17.7617257,30.4493658 C17.7617257,31.1069059 18.5567202,31.4361069 19.021652,30.9711752","id":"path-2","key":1})]),React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","opacity":"0.800000012","key":3},React.createElement("g",{"id":"buttons/btn-view-more/gray","transform":"translate(-11.000000, 0.000000)"},React.createElement("g",{"id":"buttons/btn-view-more"},React.createElement("g",{"id":"icons/ic-brand-color","transform":"translate(11.000000, 0.000000)"},[React.createElement("mask",{"id":"mask-3","fill":"white","key":0},React.createElement("use",{"xlinkHref":"#path-2"})),React.createElement("use",{"fill":"url(#linearGradient-1)","xlinkHref":"#path-2","key":1})]))))]);
}

IcBrandColorComponent.defaultProps = {"width":"45px","height":"48px","viewBox":"0 0 45 48","version":"1.1"};

module.exports = IcBrandColorComponent;

IcBrandColorComponent.default = IcBrandColorComponent;


/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcCloseComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-close"},React.createElement("path",{"id":"Vector","d":"M17.8741 7.33366L16.6993 6.16699L12 10.8337L7.30071 6.16699L6.12589 7.33366L10.8252 12.0003L6.12589 16.667L7.30071 17.8337L12 13.167L16.6993 17.8337L17.8741 16.667L13.1748 12.0003L17.8741 7.33366Z","fill":"#3E3E3E"})));
}

IcCloseComponent.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IcCloseComponent;

IcCloseComponent.default = IcCloseComponent;


/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcEditComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-edit"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M13.8567 7.68437L13.0726 6.92737L12.3156 6.14332L3.91667 14.5423V16.0833H5.45772L13.8567 7.68437ZM15.9217 5.24495L14.7551 4.07828L14.5783 4.25505L15.7449 5.42172L15.9217 5.24495ZM16.8441 6.34406L5.93811 17.25H2.75V14.062L13.6727 3.15999C13.8176 3.0279 13.9758 2.92713 14.1477 2.856C14.3181 2.78546 14.4974 2.75 14.6875 2.75C14.8776 2.75 15.0614 2.78548 15.2405 2.85712C15.4137 2.92641 15.563 3.0298 15.6906 3.16903L16.8471 4.34652L16.8519 4.35096C16.9897 4.47725 17.0883 4.62433 17.1507 4.7944C17.2176 4.97697 17.25 5.15623 17.25 5.33333C17.25 5.52624 17.217 5.70792 17.1517 5.88009C17.089 6.04539 16.9881 6.20002 16.8441 6.34406Z","fill":"white"})));
}

IcEditComponent.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IcEditComponent;

IcEditComponent.default = IcEditComponent;


/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcFacebookComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icons/ic-facebook"},React.createElement("g",{"id":"Vector"},[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.5583 1.49984H1.44173V16.4998H16.5583V1.49984ZM0.608398 0.666504V17.3332H17.3916V0.666504H0.608398Z","fill":"#3E3E3E","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.917 13.9998V9.49984H11.2928L11.5175 7.49984H9.917V6.52584C9.917 6.01084 9.93025 5.49984 10.6549 5.49984H11.3889V4.06984C11.3889 4.04834 10.7584 3.99984 10.1206 3.99984C8.78853 3.99984 7.95444 4.82834 7.95444 6.34984V7.49984H6.48252V9.49984H7.95444V13.9998H9.917Z","fill":"#3E3E3E","key":1})])));
}

IcFacebookComponent.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = IcFacebookComponent;

IcFacebookComponent.default = IcFacebookComponent;


/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcHouseComponent (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"House","key":0},[React.createElement("g",{"id":"Group","key":0},[React.createElement("g",{"id":"Group_2","key":0},[React.createElement("path",{"id":"Vector","d":"M11.9488 25.0617C13.3567 25.1677 15.3472 17.752 16.1192 12.4214C16.7532 8.04346 16.7341 3.90634 15.9388 3.75861C15.33 3.64543 14.4901 5.91137 13.9842 5.74779C13.3062 5.52853 14.6426 1.40529 13.4768 0.664363C12.7585 0.207885 11.1751 1.08945 10.2286 2.29848C8.52059 4.47992 9.19055 7.33754 10.1537 14.2093C11.3878 23.0153 11.2243 25.0072 11.9488 25.0617Z","fill":"url(#paint0_linear_1437_15329)","key":0}),React.createElement("g",{"id":"Vector_2","style":{"mixBlendMode":"soft-light"},"opacity":"0.3","key":1},React.createElement("path",{"d":"M13.1051 20.1673C13.7849 18.1681 14.5956 17.1883 14.4246 15.4169C14.2753 13.8696 13.5709 13.7254 13.3789 11.9217C13.1617 9.8788 14.0125 9.56613 13.7744 7.92915C13.4437 5.65627 11.677 5.38962 11.4451 3.39787C11.3719 2.76846 11.4466 1.91994 11.9942 0.828613C11.3735 1.13932 10.7164 1.67502 10.2283 2.29825C8.52035 4.47968 9.19031 7.33731 10.1534 14.2091C11.3875 23.0151 11.2242 25.007 11.9487 25.0615C12.0588 25.0698 12.1725 25.0321 12.289 24.9528C12.3325 22.9163 12.7093 21.3309 13.105 20.167L13.1051 20.1673Z","fill":"white"}))]),React.createElement("g",{"id":"Group_3","key":1},[React.createElement("path",{"id":"Vector_3","d":"M11.5604 28.2543C14.3878 22.2766 11.6122 16.0809 11.513 12.6296C11.29 4.86451 9.54385 3.25515 8.68002 2.6787C7.52894 1.91031 5.65507 1.4481 4.6391 2.34159C2.73829 4.01343 4.68069 9.69217 3.68751 10.1074C3.17354 10.3223 2.57595 8.83399 1.75622 9.00013C0.635034 9.22724 0.129049 12.3396 0.0393662 13.1152C-0.654272 19.1104 8.92287 26.3341 11.5605 28.2543H11.5604Z","fill":"url(#paint1_linear_1437_15329)","key":0}),React.createElement("g",{"id":"Vector_4","style":{"mixBlendMode":"soft-light"},"opacity":"0.5","key":1},React.createElement("path",{"d":"M8.75851 20.7271C7.85088 18.1511 7.22724 17.8485 7.08295 16.0108C6.81701 12.6219 8.76221 11.4139 8.0847 8.84435C7.60166 7.0124 6.46819 7.07729 5.55182 4.82236C5.17888 3.90458 4.99819 2.98664 4.92922 2.13525C4.82652 2.19395 4.72914 2.26216 4.63886 2.34154C2.73805 4.01338 4.68045 9.69212 3.68727 10.1074C3.1733 10.3223 2.57571 8.83394 1.75598 8.99993C0.634942 9.22704 0.12881 12.3394 0.0391271 13.115C-0.654511 19.1102 8.06976 25.9704 10.7073 27.8906C10.7335 27.7791 10.0354 27.0031 10.0608 26.8924C9.82095 24.1906 9.25887 22.1476 8.75851 20.7271Z","fill":"white"}))])]),React.createElement("g",{"id":"Group_4","key":1},[React.createElement("g",{"id":"Group_5","key":0},[React.createElement("path",{"id":"Vector_5","d":"M33.5888 33.889V30.0499L2.13904 30.0059V33.8121L8.96724 35.4575L33.5888 33.889Z","fill":"white","key":0}),React.createElement("path",{"id":"Vector_6","d":"M33.5187 21.2627V21.7426L35.6131 21.7622L35.1497 21.2692L33.5187 21.2627Z","fill":"#D8DEE8","key":1}),React.createElement("path",{"id":"Vector_7","d":"M8.89975 31.5787L2.13904 30.0956V21.2739L8.89975 21.3405V31.5787Z","fill":"url(#paint2_linear_1437_15329)","key":2}),React.createElement("path",{"id":"Vector_8","d":"M35.1497 21.2454L33.589 21.2762V30.1418L17.9196 31.0539L11.4287 31.4317L8.89966 31.5789V21.3406L19.7787 18.1803L26.2638 11.7964L35.1496 21.2454H35.1497ZM30.7037 29.362V20.5786L21.1529 20.562V29.8621L30.7037 29.362Z","fill":"url(#paint3_linear_1437_15329)","key":3}),React.createElement("g",{"id":"Group_6","opacity":"0.2","key":4},React.createElement("path",{"id":"Vector_9","d":"M35.306 21.2798L26.5119 11.8833L26.2423 11.5952L25.9748 11.8572L19.5276 18.1768L8.72934 21.278L7.24854 21.7032V21.9358H8.89968V21.7855L19.7411 18.6713L26.2639 12.2882L34.6892 21.2798H35.306Z","fill":"#D8DEE8"})),React.createElement("path",{"id":"Vector_10","d":"M26.2423 11.1035L26.5119 11.3914L35.4126 20.8922L35.6424 21.1371V21.7598L35.613 21.7625L35.1523 21.272L26.2639 11.7963L19.7411 18.1796L8.99292 21.4287L7.24854 21.9221V21.2115L8.72934 20.7863L19.5276 17.6849L25.9748 11.3655L26.2423 11.1035Z","fill":"white","key":5}),React.createElement("g",{"id":"Group_7","key":6},[React.createElement("path",{"id":"Vector_11","d":"M30.6073 20.7V29.244L21.261 29.7265V20.6909L30.6073 20.7001V20.7ZM30.1112 28.4298V21.2571L27.865 21.2625V28.534L30.1112 28.4296V28.4298ZM27.2548 28.5624V21.264L24.929 21.2698V28.6706L27.2548 28.5626V28.5624ZM24.2967 28.6999V21.2713L21.8865 21.2772V28.8118L24.2967 28.6999Z","fill":"white","key":0}),React.createElement("path",{"id":"Vector_12","d":"M21.1106 29.8881V20.5376L30.7576 20.5471V29.3901L21.1106 29.8881ZM21.4115 20.8448V29.5656L30.4569 29.0987V20.8537L21.4115 20.8448ZM21.7362 28.9729V21.1246L24.4471 21.118V28.8469L21.7362 28.9729ZM22.037 21.4306V28.6519L24.1464 28.5538V21.4255L22.037 21.4306ZM24.7786 28.8315V21.1172L27.4051 21.1109V28.7095L24.7786 28.8316V28.8315ZM25.0794 21.4232V28.5105L27.1044 28.4163V21.4183L25.0794 21.4232ZM27.7144 28.695V21.11L30.2615 21.1038V28.5767L27.7144 28.695ZM28.0153 21.416V28.3741L29.9607 28.2837V21.4113L28.0153 21.4161V21.416Z","fill":"white","key":1})]),React.createElement("path",{"id":"Vector_13","d":"M26.2425 11.1035L25.9751 11.3656L19.5277 17.6849L11.7091 18.1023L17.59 12.5725L17.8354 12.3424L26.2425 11.1035Z","fill":"url(#paint4_linear_1437_15329)","key":7}),React.createElement("path",{"id":"Vector_14","d":"M13.8943 25.8503L17.2049 25.8066L17.2028 33.2742L13.8943 33.4658V25.8503Z","fill":"#F4F7FA","key":8}),React.createElement("path",{"id":"Vector_15","d":"M13.2834 33.1028V26.1194L16.9615 26.0747V32.8181L13.2834 33.1028Z","fill":"#93C13E","key":9}),React.createElement("path",{"id":"Vector_16","d":"M11.4288 33.6597V24.9619L17.9082 24.895V33.2334L17.2029 33.2743V25.822L13.8944 25.8735V33.5169L11.4288 33.6597Z","fill":"white","key":10}),React.createElement("path",{"id":"Vector_17","d":"M19.5276 17.6851L8.72923 20.7865L7.24842 21.2115L0.665894 21.1626L1.98672 20.7967L11.709 18.1025L19.5276 17.6851Z","fill":"url(#paint5_linear_1437_15329)","key":11}),React.createElement("path",{"id":"Vector_18","d":"M7.24857 21.9222L0.665894 21.7741V21.1626L7.24857 21.2116V21.9222Z","fill":"white","key":12}),React.createElement("path",{"id":"Vector_19","d":"M30.0678 21.3125V28.3777L27.9097 28.4773V21.3185L30.0678 21.3125Z","fill":"url(#paint6_linear_1437_15329)","key":13}),React.createElement("path",{"id":"Vector_20","d":"M24.2503 21.3281V28.6455L21.9343 28.7523V21.3346L24.2503 21.3281Z","fill":"url(#paint7_linear_1437_15329)","key":14}),React.createElement("path",{"id":"Vector_21","d":"M27.2101 21.3203V28.5094L24.9751 28.6125V21.3265L27.2101 21.3203Z","fill":"url(#paint8_linear_1437_15329)","key":15}),React.createElement("path",{"id":"Vector_22","d":"M11.4288 33.6516L17.9082 33.187L19.4214 34.9147L11.4288 35.287V33.6516Z","fill":"#E8E8E8","key":16})]),React.createElement("path",{"id":"Vector_23","d":"M25.096 11.8453C25.096 11.9168 25.0392 11.9747 24.969 11.9747C24.8989 11.9747 24.842 11.9168 24.842 11.8453V11.379C24.842 11.3075 24.8989 11.2495 24.969 11.2495C25.0392 11.2495 25.096 11.3075 25.096 11.379V11.8453Z","fill":"url(#paint9_linear_1437_15329)","key":1}),React.createElement("path",{"id":"Vector_24","d":"M22.5552 14.3838C22.5552 14.4554 22.4984 14.5133 22.4282 14.5133C22.3581 14.5133 22.3013 14.4554 22.3013 14.3838V13.9176C22.3013 13.846 22.3581 13.7881 22.4282 13.7881C22.4984 13.7881 22.5552 13.846 22.5552 13.9176V14.3838Z","fill":"url(#paint10_linear_1437_15329)","key":2}),React.createElement("path",{"id":"Vector_25","d":"M16.1526 18.5119C16.1526 18.5643 16.0958 18.6067 16.0257 18.6067C15.9555 18.6067 15.8987 18.5643 15.8987 18.5119V18.1705C15.8987 18.1181 15.9555 18.0757 16.0257 18.0757C16.0958 18.0757 16.1526 18.1181 16.1526 18.1705V18.5119Z","fill":"url(#paint11_linear_1437_15329)","key":3}),React.createElement("path",{"id":"Vector_26","d":"M11.9347 19.7203C11.9347 19.7918 11.8779 19.8497 11.8078 19.8497C11.7376 19.8497 11.6808 19.7918 11.6808 19.7203V19.254C11.6808 19.1825 11.7376 19.1245 11.8078 19.1245C11.8779 19.1245 11.9347 19.1825 11.9347 19.254V19.7203Z","fill":"url(#paint12_linear_1437_15329)","key":4}),React.createElement("path",{"id":"Vector_27","d":"M19.7604 17.2335C19.7604 17.305 19.7036 17.3629 19.6334 17.3629C19.5633 17.3629 19.5065 17.305 19.5065 17.2335V16.7672C19.5065 16.6956 19.5633 16.6377 19.6334 16.6377C19.7036 16.6377 19.7604 16.6956 19.7604 16.7672V17.2335Z","fill":"url(#paint13_linear_1437_15329)","key":5}),React.createElement("path",{"id":"Vector_28","d":"M12.3921 17.6998C12.3921 17.7713 12.3353 17.8292 12.2652 17.8292C12.195 17.8292 12.1382 17.7713 12.1382 17.6998V17.2335C12.1382 17.162 12.195 17.104 12.2652 17.104C12.3353 17.104 12.3921 17.162 12.3921 17.2335V17.6998Z","fill":"url(#paint14_linear_1437_15329)","key":6}),React.createElement("g",{"id":"Group_8","key":7},[React.createElement("path",{"id":"Vector_29","d":"M17.4007 18.0083L10.3381 18.0364C10.2429 18.0367 10.0439 18.0694 9.9052 18.1091L0.826635 20.6474C0.715493 20.6793 0.658368 20.7357 0.720229 20.8087L6.42028 21.0339C6.55481 21.0392 6.68771 21.0236 6.81764 20.988C8.26841 20.5907 17.3594 18.15 17.3594 18.15C17.5247 18.1065 17.5139 18.0078 17.4007 18.0083Z","fill":"url(#paint15_linear_1437_15329)","key":0}),React.createElement("path",{"id":"Vector_30","d":"M17.3581 18.0098L10.0803 18.0375C9.98574 18.0378 9.7972 18.0704 9.65928 18.11L0.826676 20.6475C0.716126 20.6794 0.687119 20.707 0.761707 20.7094L6.45584 20.8953C6.54286 20.8982 6.72711 20.8731 6.85631 20.839L17.2755 18.0875C17.4398 18.044 17.4706 18.0093 17.3581 18.0098Z","fill":"url(#paint16_linear_1437_15329)","key":1}),React.createElement("g",{"id":"Group_9","key":2},[React.createElement("g",{"id":"Group_10","key":0},[React.createElement("path",{"id":"Vector_31","d":"M10.4703 18.2153L9.46516 18.5002C9.36216 18.5294 9.23325 18.5528 9.16355 18.5526L8.49833 18.5509C8.42995 18.5508 8.44697 18.5274 8.54761 18.4986L9.53057 18.217C9.63387 18.1874 9.78364 18.1633 9.85423 18.1631L10.5417 18.1616C10.6137 18.1615 10.5758 18.1856 10.4702 18.2155L10.4703 18.2153Z","fill":"url(#paint17_linear_1437_15329)","key":0}),React.createElement("path",{"id":"Vector_32","d":"M11.6375 18.2133L10.6043 18.5021C10.4985 18.5317 10.34 18.5554 10.2684 18.5553L9.58481 18.5536C9.51451 18.5535 9.55743 18.5298 9.66087 18.5005L10.6708 18.215C10.7769 18.185 10.9046 18.1607 10.9773 18.1604L11.6839 18.1587C11.7579 18.1585 11.7459 18.1828 11.6373 18.2133H11.6375Z","fill":"url(#paint18_linear_1437_15329)","key":1}),React.createElement("path",{"id":"Vector_33","d":"M12.8588 18.1558L12.1321 18.1574C12.0576 18.1576 11.9011 18.1825 11.7924 18.2128L10.7555 18.5022C10.6496 18.5318 10.6297 18.556 10.7018 18.5561L11.4043 18.5579C11.4777 18.5581 11.6162 18.5341 11.7247 18.504L12.7855 18.2111C12.8968 18.1804 12.9347 18.1556 12.8588 18.1558Z","fill":"url(#paint19_linear_1437_15329)","key":2}),React.createElement("path",{"id":"Vector_34","d":"M14.0668 18.1533L13.3193 18.155C13.2427 18.1551 13.1095 18.1803 12.9976 18.2111L11.9316 18.5046C11.8227 18.5347 11.7755 18.5589 11.8496 18.5592L12.572 18.5611C12.6474 18.5612 12.8173 18.5369 12.9288 18.5066L14.0199 18.2095C14.1345 18.1782 14.145 18.1532 14.0668 18.1533Z","fill":"url(#paint20_linear_1437_15329)","key":3}),React.createElement("path",{"id":"Vector_35","d":"M15.3101 18.1504L14.5408 18.1522C14.4619 18.1524 14.2985 18.178 14.1835 18.2092L13.0882 18.507C12.9764 18.5375 12.9534 18.5622 13.0296 18.5624L13.7727 18.5642C13.8504 18.5643 13.9988 18.5396 14.1134 18.5088L15.2349 18.2074C15.3525 18.1757 15.3904 18.1502 15.3101 18.1504Z","fill":"url(#paint21_linear_1437_15329)","key":4}),React.createElement("path",{"id":"Vector_36","d":"M16.5901 18.1475L15.7981 18.1493C15.7168 18.1494 15.578 18.1754 15.4598 18.2071L14.3327 18.5092C14.2175 18.54 14.1656 18.5652 14.244 18.5653L15.0087 18.5673C15.0886 18.5674 15.2705 18.5424 15.3884 18.5111L16.5429 18.2053C16.6641 18.1731 16.673 18.1473 16.5901 18.1475Z","fill":"url(#paint22_linear_1437_15329)","key":5})]),React.createElement("g",{"id":"Group_11","key":1},[React.createElement("path",{"id":"Vector_37","d":"M8.84876 18.6724L7.88074 18.948C7.78159 18.976 7.65727 18.999 7.59023 18.9984L6.94987 18.9934C6.88402 18.9928 6.90059 18.9702 6.99753 18.9422L7.94453 18.6687C8.04398 18.6401 8.18812 18.6151 8.2562 18.6152L8.91757 18.6173C8.98683 18.6176 8.95043 18.6435 8.84861 18.6723L8.84876 18.6724Z","fill":"url(#paint23_linear_1437_15329)","key":0}),React.createElement("path",{"id":"Vector_38","d":"M9.97109 18.6792L8.97673 18.9573C8.87491 18.9859 8.72234 19.0082 8.65352 19.0076L7.99584 19.0021C7.92821 19.0015 7.9695 18.9786 8.06925 18.9504L9.04185 18.6754C9.14411 18.6466 9.26695 18.6234 9.3368 18.6235L10.0162 18.6258C10.0874 18.6261 10.0757 18.6499 9.97124 18.6792H9.97109Z","fill":"url(#paint24_linear_1437_15329)","key":1}),React.createElement("path",{"id":"Vector_39","d":"M11.1448 18.6299L10.4464 18.6274C10.3748 18.6271 10.2243 18.6507 10.1197 18.68L9.12176 18.9585C9.01979 18.987 9.00055 19.0106 9.06981 19.0112L9.7454 19.0168C9.81599 19.0174 9.94918 18.9944 10.0535 18.9656L11.0741 18.6839C11.1811 18.6543 11.2176 18.6302 11.1447 18.6299H11.1448Z","fill":"url(#paint25_linear_1437_15329)","key":2}),React.createElement("path",{"id":"Vector_40","d":"M12.3053 18.6338L11.5874 18.6314C11.5137 18.631 11.3857 18.655 11.2781 18.6846L10.2527 18.967C10.1479 18.9958 10.1023 19.0195 10.1737 19.0201L10.8679 19.0258C10.9404 19.0264 11.1038 19.0035 11.2109 18.9742L12.26 18.6885C12.3702 18.6585 12.3804 18.6339 12.3053 18.6336V18.6338Z","fill":"url(#paint26_linear_1437_15329)","key":3}),React.createElement("path",{"id":"Vector_41","d":"M13.4989 18.6378L12.7605 18.6353C12.6847 18.635 12.5278 18.6592 12.4173 18.6893L11.3643 18.9755C11.2567 19.0048 11.2345 19.029 11.3078 19.0296L12.0215 19.0354C12.0961 19.0361 12.2388 19.0125 12.3489 18.9829L13.4266 18.6934C13.5396 18.663 13.576 18.6381 13.4989 18.6378Z","fill":"url(#paint27_linear_1437_15329)","key":4}),React.createElement("path",{"id":"Vector_42","d":"M14.7268 18.6417L13.967 18.6392C13.8891 18.6389 13.7558 18.6635 13.6421 18.6939L12.5591 18.9841C12.4484 19.0139 12.3986 19.0381 12.4737 19.0388L13.2078 19.0448C13.2846 19.0454 13.4592 19.0218 13.5724 18.9918L14.6812 18.6982C14.7975 18.6674 14.8061 18.642 14.7268 18.6417Z","fill":"url(#paint28_linear_1437_15329)","key":5})]),React.createElement("g",{"id":"Group_12","key":2},[React.createElement("path",{"id":"Vector_43","d":"M7.28684 19.1171L6.3539 19.3815C6.2583 19.4087 6.13858 19.4298 6.07405 19.4289L5.45722 19.4203C5.39373 19.4194 5.40972 19.397 5.5034 19.3702L6.4165 19.1087C6.5124 19.0812 6.65137 19.0595 6.71678 19.0601L7.35344 19.0658C7.42004 19.0664 7.38496 19.0893 7.28684 19.1171Z","fill":"url(#paint29_linear_1437_15329)","key":0}),React.createElement("path",{"id":"Vector_44","d":"M8.3667 19.1278L7.40889 19.3956C7.31077 19.4231 7.16382 19.4442 7.09752 19.4433L6.46441 19.4346C6.39929 19.4337 6.43925 19.4113 6.53515 19.3842L7.47238 19.1192C7.5708 19.0914 7.68919 19.0692 7.75638 19.0698L8.41006 19.0757C8.47858 19.0763 8.46733 19.0996 8.3667 19.1278Z","fill":"url(#paint30_linear_1437_15329)","key":1}),React.createElement("path",{"id":"Vector_45","d":"M9.42786 19.138L8.44519 19.4091C8.34456 19.4369 8.21655 19.4586 8.14862 19.4577L7.49849 19.4487C7.4316 19.4478 7.4501 19.4247 7.54866 19.3972L8.50987 19.1289C8.6108 19.1007 8.75538 19.0785 8.82435 19.0791L9.49594 19.0852C9.56623 19.0858 9.53116 19.1093 9.42786 19.1378V19.138Z","fill":"url(#paint31_linear_1437_15329)","key":2}),React.createElement("path",{"id":"Vector_46","d":"M10.6115 19.0957L9.92143 19.0894C9.85069 19.0888 9.72741 19.1115 9.62381 19.1401L8.63656 19.412C8.53563 19.4398 8.49182 19.4629 8.56035 19.4638L9.22808 19.4731C9.29779 19.474 9.45496 19.4524 9.55811 19.4242L10.5677 19.1493C10.6737 19.1205 10.6836 19.0963 10.6114 19.0957H10.6115Z","fill":"url(#paint32_linear_1437_15329)","key":3}),React.createElement("path",{"id":"Vector_47","d":"M11.7582 19.1061L11.0487 19.0996C10.9759 19.099 10.8251 19.1218 10.7188 19.1508L9.70568 19.4262C9.60209 19.4544 9.58078 19.4779 9.65122 19.479L10.3373 19.4885C10.4091 19.4895 10.5463 19.4672 10.6522 19.4387L11.6886 19.1603C11.7974 19.131 11.8325 19.1069 11.7583 19.1061H11.7582Z","fill":"url(#paint33_linear_1437_15329)","key":4}),React.createElement("path",{"id":"Vector_48","d":"M12.9373 19.1165L12.2077 19.1099C12.1329 19.1091 12.0048 19.1327 11.8956 19.1619L10.8542 19.4411C10.7478 19.4696 10.6997 19.4932 10.7721 19.4942L11.4774 19.504C11.5511 19.5051 11.7189 19.4829 11.8278 19.4539L12.8935 19.1716C13.0054 19.142 13.0136 19.1171 12.9373 19.1165Z","fill":"url(#paint34_linear_1437_15329)","key":5})]),React.createElement("g",{"id":"Group_13","key":3},[React.createElement("path",{"id":"Vector_49","d":"M5.78125 19.5444L4.8816 19.7994C4.7894 19.8255 4.67397 19.8457 4.61167 19.8445L4.01718 19.8329C3.95606 19.8317 3.97145 19.8097 4.06188 19.7839L4.94287 19.5316C5.03537 19.505 5.1693 19.4845 5.23234 19.4854L5.84562 19.4944C5.90985 19.4953 5.87581 19.5177 5.78139 19.5444H5.78125Z","fill":"url(#paint35_linear_1437_15329)","key":0}),React.createElement("path",{"id":"Vector_50","d":"M6.8212 19.5602L5.89788 19.8184C5.80331 19.8448 5.66169 19.8649 5.5979 19.8637L4.98803 19.8518C4.92528 19.8506 4.96376 19.8287 5.0564 19.8026L5.96019 19.5471C6.05505 19.5202 6.16915 19.4991 6.23382 19.5L6.86323 19.5094C6.92909 19.5103 6.91814 19.5332 6.8212 19.5604V19.5602Z","fill":"url(#paint36_linear_1437_15329)","key":1}),React.createElement("path",{"id":"Vector_51","d":"M7.8425 19.576L6.8958 19.8374C6.79887 19.8641 6.67559 19.8847 6.61003 19.8835L5.98402 19.8713C5.91965 19.8701 5.93755 19.8476 6.03242 19.8211L6.95885 19.5624C7.05622 19.5352 7.19534 19.5141 7.26178 19.5152L7.90807 19.5247C7.9757 19.5257 7.94181 19.5485 7.84236 19.576H7.8425Z","fill":"url(#paint37_linear_1437_15329)","key":2}),React.createElement("path",{"id":"Vector_52","d":"M8.93882 19.5931L7.96666 19.8578C7.86706 19.885 7.71611 19.9053 7.64892 19.904L7.00634 19.8913C6.94018 19.8899 6.98251 19.8676 7.07989 19.8409L8.03089 19.5789C8.13078 19.5515 8.24903 19.5297 8.3174 19.5308L8.98114 19.5406C9.0507 19.5417 9.04093 19.5654 8.93882 19.5931Z","fill":"url(#paint38_linear_1437_15329)","key":3}),React.createElement("path",{"id":"Vector_53","d":"M10.0164 19.6093L9.01893 19.8774C8.91681 19.9048 8.7851 19.9259 8.71599 19.9246L8.05595 19.9116C7.98802 19.9102 8.00874 19.8872 8.10863 19.86L9.08419 19.5949C9.18675 19.5669 9.33149 19.5454 9.40164 19.5464L10.0836 19.5565C10.1551 19.5576 10.1213 19.5811 10.0164 19.6093Z","fill":"url(#paint39_linear_1437_15329)","key":4}),React.createElement("path",{"id":"Vector_54","d":"M11.2167 19.5734L10.5156 19.563C10.4437 19.562 10.3206 19.5843 10.2154 19.6125L9.21316 19.8811C9.11075 19.9086 9.06443 19.9315 9.13398 19.9329L9.81208 19.9462C9.88297 19.9475 10.0444 19.9265 10.1492 19.8988L11.1743 19.6272C11.2819 19.5986 11.2899 19.5745 11.2167 19.5734Z","fill":"url(#paint40_linear_1437_15329)","key":5})]),React.createElement("g",{"id":"Group_14","key":4},[React.createElement("path",{"id":"Vector_55","d":"M4.32935 19.9555L3.46108 20.2015C3.37214 20.2267 3.2607 20.246 3.20076 20.2445L2.62744 20.23C2.56839 20.2285 2.58349 20.207 2.67066 20.1821L3.52102 19.9385C3.61026 19.9128 3.73945 19.8934 3.80028 19.8946L4.39136 19.9067C4.45322 19.9079 4.42036 19.9296 4.3292 19.9555H4.32935Z","fill":"url(#paint41_linear_1437_15329)","key":0}),React.createElement("path",{"id":"Vector_56","d":"M5.33132 19.9766L4.44085 20.2256C4.34954 20.2511 4.21309 20.2701 4.15152 20.2684L3.56355 20.2535C3.50302 20.252 3.54032 20.2307 3.6297 20.2055L4.50167 19.9589C4.59328 19.933 4.70324 19.9129 4.76554 19.9141L5.37201 19.9265C5.4355 19.9278 5.42485 19.9503 5.33132 19.9764V19.9766Z","fill":"url(#paint42_linear_1437_15329)","key":1}),React.createElement("path",{"id":"Vector_57","d":"M6.31499 19.9979L5.40232 20.2499C5.30879 20.2757 5.18996 20.2955 5.12691 20.2938L4.52384 20.2786C4.46184 20.2771 4.47915 20.255 4.57076 20.2294L5.46418 19.9799C5.55801 19.9537 5.69209 19.9338 5.75617 19.9351L6.37848 19.948C6.44359 19.9493 6.41089 19.9716 6.31499 19.9981V19.9979Z","fill":"url(#paint43_linear_1437_15329)","key":2}),React.createElement("path",{"id":"Vector_58","d":"M7.37042 20.0196L6.43363 20.2746C6.33758 20.3007 6.19226 20.32 6.12744 20.3184L5.50853 20.3027C5.4449 20.301 5.48559 20.2793 5.57957 20.2535L6.49638 20.001C6.59272 19.9745 6.70668 19.9538 6.77238 19.9551L7.41127 19.9683C7.47816 19.9696 7.46883 19.9927 7.37042 20.0196Z","fill":"url(#paint44_linear_1437_15329)","key":3}),React.createElement("path",{"id":"Vector_59","d":"M8.4073 20.042L7.44653 20.3002C7.34812 20.3266 7.22129 20.3467 7.15469 20.345L6.51936 20.3289C6.4541 20.3272 6.47393 20.3047 6.57027 20.2785L7.51032 20.023C7.60903 19.9961 7.74858 19.9756 7.81592 19.9771L8.47197 19.9906C8.54064 19.9919 8.50823 20.0149 8.4073 20.042Z","fill":"url(#paint45_linear_1437_15329)","key":4}),React.createElement("path",{"id":"Vector_60","d":"M9.5208 20.0656L8.53399 20.327C8.52911 20.3284 8.51505 20.3294 8.50927 20.3306C8.41042 20.3555 8.27456 20.3733 8.20959 20.3718L7.55724 20.3552C7.4902 20.3536 7.53475 20.3312 7.63361 20.3048L8.59881 20.0462C8.60799 20.0437 8.6071 20.0412 8.6176 20.0388C8.71454 20.0152 8.82479 19.9979 8.88784 19.9991L9.56194 20.013C9.63253 20.0145 9.62454 20.0382 9.5208 20.0656Z","fill":"url(#paint46_linear_1437_15329)","key":5})]),React.createElement("g",{"id":"Group_15","key":5},[React.createElement("path",{"id":"Vector_61","d":"M2.92786 20.3528L2.08949 20.5903C2.0035 20.6146 1.89591 20.6331 1.83805 20.6313L1.28486 20.6141C1.22788 20.6123 1.24253 20.5912 1.32674 20.5672L2.14824 20.3318C2.23452 20.307 2.35913 20.2885 2.41788 20.2901L2.98809 20.3051C3.04773 20.3066 3.01606 20.3279 2.92801 20.3528H2.92786Z","fill":"url(#paint47_linear_1437_15329)","key":0}),React.createElement("path",{"id":"Vector_62","d":"M3.89408 20.3788L3.03455 20.6192C2.94649 20.6438 2.81463 20.6618 2.75529 20.66L2.18818 20.6423C2.12987 20.6405 2.16584 20.6198 2.25211 20.5954L3.09404 20.3573C3.18239 20.3322 3.2885 20.3129 3.34873 20.3146L3.93345 20.3299C3.99457 20.3316 3.98436 20.3536 3.89408 20.3788Z","fill":"url(#paint48_linear_1437_15329)","key":1}),React.createElement("path",{"id":"Vector_63","d":"M4.84197 20.404L3.96141 20.6471C3.87114 20.672 3.75659 20.6908 3.69577 20.6889L3.11431 20.6708C3.05452 20.669 3.07124 20.6474 3.15974 20.6227L4.02209 20.382C4.11266 20.3567 4.24201 20.3378 4.30372 20.3395L4.90338 20.3552C4.96613 20.3568 4.93461 20.3785 4.84211 20.404H4.84197Z","fill":"url(#paint49_linear_1437_15329)","key":2}),React.createElement("path",{"id":"Vector_64","d":"M5.85883 20.4317L4.95548 20.6777C4.86284 20.7029 4.72269 20.7212 4.66024 20.7192L4.06383 20.7006C4.00242 20.6987 4.04178 20.6775 4.1325 20.6526L5.0169 20.4091C5.10984 20.3834 5.21965 20.3637 5.28299 20.3653L5.89834 20.3815C5.96272 20.3831 5.95369 20.4058 5.85883 20.4317Z","fill":"url(#paint50_linear_1437_15329)","key":3}),React.createElement("path",{"id":"Vector_65","d":"M6.85708 20.4589L5.93109 20.7077C5.83623 20.7332 5.71399 20.7524 5.64991 20.7503L5.03796 20.7313C4.97507 20.7293 4.99431 20.7073 5.0871 20.6821L5.9934 20.4358C6.08856 20.41 6.22293 20.3905 6.2879 20.3922L6.91953 20.4088C6.98568 20.4104 6.95431 20.4329 6.85693 20.459L6.85708 20.4589Z","fill":"url(#paint51_linear_1437_15329)","key":4}),React.createElement("path",{"id":"Vector_66","d":"M7.92866 20.4874L6.97796 20.7393C6.88058 20.7651 6.73126 20.7836 6.66555 20.7817L6.03747 20.7622C5.97295 20.7602 6.01586 20.7385 6.11117 20.713L7.04145 20.4637C7.13912 20.4375 7.25308 20.4172 7.31967 20.4191L7.96832 20.4361C8.03625 20.4379 8.02855 20.4612 7.92881 20.4877L7.92866 20.4874Z","fill":"url(#paint52_linear_1437_15329)","key":5})])]),React.createElement("path",{"id":"Vector_67","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M9.66112 18.5L10.5747 18.2417C10.5026 18.3185 10.3401 18.4204 10.0366 18.5542L9.58505 18.553C9.51475 18.5529 9.55767 18.5293 9.66112 18.5Z","fill":"url(#paint53_linear_1437_15329)","key":3}),React.createElement("path",{"id":"Vector_68","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M9.87037 18.6205C9.63684 18.7113 9.33804 18.8287 8.96185 18.9547C8.86003 18.9832 8.7224 19.0069 8.65358 19.0063L7.99605 19.0015C7.92842 19.0009 7.96986 18.9783 8.06946 18.95L9.04206 18.6728C9.14432 18.644 9.26716 18.6185 9.33701 18.6187L9.87037 18.6205Z","fill":"url(#paint54_linear_1437_15329)","key":4}),React.createElement("path",{"id":"Vector_69","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M7.54863 19.3973L8.40181 19.1592C8.13039 19.2761 7.95472 19.3724 7.86904 19.4539L7.49861 19.4488C7.43172 19.4479 7.45007 19.4248 7.54863 19.3973Z","fill":"url(#paint55_linear_1437_15329)","key":5}),React.createElement("path",{"id":"Vector_70","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M7.81291 19.5228C7.79959 19.5468 7.81394 19.5698 7.78745 19.5907L6.8958 19.8369C6.79887 19.8636 6.67559 19.8842 6.61003 19.883L5.98402 19.8708C5.91965 19.8696 5.93755 19.8471 6.03242 19.8206L6.95885 19.5619C7.05622 19.5348 7.19534 19.5136 7.26178 19.5147L7.81291 19.5228Z","fill":"url(#paint56_linear_1437_15329)","key":6}),React.createElement("path",{"id":"Vector_71","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M4.84197 20.4036L3.96141 20.6467C3.87114 20.6716 3.75659 20.6903 3.69577 20.6885L3.11431 20.6704C3.05452 20.6685 3.07124 20.647 3.15974 20.6222L4.02209 20.3815C4.11266 20.3562 4.24201 20.3373 4.30372 20.339L4.90338 20.3547C4.96613 20.3563 4.93461 20.3781 4.84211 20.4036H4.84197Z","fill":"url(#paint57_linear_1437_15329)","key":7}),React.createElement("path",{"id":"Vector_72","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M7.82471 19.6353C7.86097 19.7075 7.94813 19.7661 8.10219 19.8203L7.96678 19.8571C7.86718 19.8842 7.71623 19.9046 7.64904 19.9033L7.00646 19.8906C6.94031 19.8892 6.98263 19.8669 7.08001 19.8402L7.82471 19.6353Z","fill":"url(#paint58_linear_1437_15329)","key":8}),React.createElement("path",{"id":"Vector_73","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M8.10863 19.8598L8.1514 19.8481C8.2177 19.8715 8.28193 19.8942 8.34246 19.917L8.05595 19.9114C7.98802 19.91 8.00874 19.8869 8.10863 19.8598Z","fill":"url(#paint59_linear_1437_15329)","key":9}),React.createElement("path",{"id":"Vector_74","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M7.63336 20.3041L8.59857 20.0455C8.60774 20.0431 8.60685 20.0405 8.61736 20.0381C8.73427 20.1163 8.74197 20.2065 8.50474 20.3299C8.40588 20.3548 8.27432 20.3728 8.20935 20.3711L7.557 20.3545C7.48996 20.3529 7.5345 20.3305 7.63336 20.3041Z","fill":"url(#paint60_linear_1437_15329)","key":10})]),React.createElement("g",{"id":"Group_16","key":8},[React.createElement("path",{"id":"Vector_75","d":"M25.4446 10.7309L18.383 11.4528C18.2909 11.4622 18.1413 11.532 18.0598 11.6078L11.5955 17.6022C11.4954 17.695 11.4993 17.7679 11.5933 17.7653L18.8674 17.5574C18.9803 17.5542 19.1522 17.4688 19.2499 17.3671L25.5008 10.858C25.5791 10.7765 25.5535 10.7197 25.4448 10.7309H25.4446Z","fill":"url(#paint61_linear_1437_15329)","key":0}),React.createElement("path",{"id":"Vector_76","d":"M25.1508 10.7607L18.1333 11.4782C18.0418 11.4876 17.9017 11.5562 17.8199 11.6318L11.351 17.6097C11.2509 17.7022 11.245 17.7752 11.3383 17.7725L18.5616 17.5659C18.6738 17.5627 18.8561 17.4773 18.9539 17.3759L25.2158 10.8864C25.2942 10.8052 25.2585 10.7497 25.1506 10.7607H25.1508Z","fill":"url(#paint62_linear_1437_15329)","key":1}),React.createElement("g",{"id":"Group_17","key":2},[React.createElement("g",{"id":"Group_18","key":0},[React.createElement("path",{"id":"Vector_77","d":"M18.7613 11.7235L18.1612 12.2875C18.0983 12.3467 18.0006 12.3988 17.9299 12.4052L17.2546 12.467C17.1852 12.4733 17.1713 12.4318 17.2343 12.3733L17.8367 11.8146C17.8985 11.7573 18.0131 11.7046 18.0823 11.6977L18.7554 11.6307C18.8258 11.6236 18.8229 11.6657 18.7613 11.7235Z","fill":"url(#paint63_linear_1437_15329)","key":0}),React.createElement("path",{"id":"Vector_78","d":"M19.9087 11.6109L19.3118 12.1816C19.2492 12.2415 19.1242 12.2967 19.0515 12.3034L18.3577 12.3668C18.2864 12.3732 18.2962 12.329 18.3591 12.2697L18.9586 11.7046C19.0202 11.6467 19.1106 11.5958 19.1816 11.5887L19.8727 11.5199C19.9451 11.5127 19.97 11.5523 19.9087 11.6109Z","fill":"url(#paint64_linear_1437_15329)","key":1}),React.createElement("path",{"id":"Vector_79","d":"M21.0204 11.4051L20.3105 11.4759C20.2377 11.4831 20.1216 11.5372 20.0605 11.5957L19.4641 12.1673C19.4017 12.2272 19.4178 12.2696 19.4909 12.263L20.2038 12.198C20.2782 12.1912 20.3803 12.1373 20.4425 12.0769L21.0359 11.4996C21.0968 11.4404 21.0945 11.3977 21.0204 11.4051Z","fill":"url(#paint65_linear_1437_15329)","key":2}),React.createElement("path",{"id":"Vector_80","d":"M22.1997 11.2875L21.4703 11.3603C21.3954 11.3677 21.305 11.4197 21.2443 11.479L20.6514 12.0576C20.5894 12.1181 20.5804 12.1635 20.6556 12.1567L21.3884 12.0899C21.4651 12.0829 21.5961 12.0257 21.6578 11.9646L22.2472 11.3803C22.3076 11.3206 22.2759 11.28 22.1997 11.2875Z","fill":"url(#paint66_linear_1437_15329)","key":3}),React.createElement("path",{"id":"Vector_81","d":"M23.4119 11.1666L22.662 11.2413C22.5851 11.249 22.4682 11.3042 22.4078 11.3641L21.8189 11.9493C21.7572 12.0106 21.7757 12.0542 21.853 12.0471L22.6065 11.9783C22.6853 11.971 22.7917 11.9156 22.8531 11.8536L23.4382 11.2625C23.4982 11.202 23.4903 11.1587 23.4119 11.1664V11.1666Z","fill":"url(#paint67_linear_1437_15329)","key":4}),React.createElement("path",{"id":"Vector_82","d":"M24.6581 11.0425L23.8869 11.1193C23.8079 11.1272 23.7179 11.1804 23.6581 11.2411L23.0737 11.8335C23.0125 11.8956 23.0046 11.9422 23.0841 11.9349L23.8594 11.8642C23.9405 11.8568 24.0776 11.7978 24.1384 11.7351L24.7187 11.1367C24.778 11.0754 24.7388 11.0345 24.6583 11.0425H24.6581Z","fill":"url(#paint68_linear_1437_15329)","key":5})]),React.createElement("g",{"id":"Group_19","key":1},[React.createElement("path",{"id":"Vector_83","d":"M17.7803 12.6455L17.1605 13.2279C17.0955 13.289 16.9959 13.3423 16.9249 13.3481L16.2469 13.4028C16.1772 13.4084 16.1648 13.3648 16.2299 13.3043L16.8518 12.7275C16.9156 12.6684 17.032 12.6148 17.1016 12.6086L17.7773 12.548C17.848 12.5416 17.8436 12.5855 17.7801 12.6453L17.7803 12.6455Z","fill":"url(#paint69_linear_1437_15329)","key":0}),React.createElement("path",{"id":"Vector_84","d":"M18.9326 12.5436L18.316 13.1333C18.2513 13.1952 18.1242 13.2513 18.0512 13.2572L17.3545 13.3135C17.2828 13.3192 17.2942 13.273 17.3592 13.2118L17.9784 12.6281C18.0419 12.5682 18.1342 12.5162 18.2056 12.5098L18.8998 12.4474C18.9724 12.4409 18.996 12.4832 18.9326 12.5436Z","fill":"url(#paint70_linear_1437_15329)","key":1}),React.createElement("path",{"id":"Vector_85","d":"M20.053 12.3439L19.3395 12.4079C19.2663 12.4146 19.1485 12.4695 19.0853 12.5299L18.4689 13.1205C18.4044 13.1824 18.419 13.2272 18.4926 13.2211L19.2089 13.1632C19.2838 13.1572 19.3878 13.1022 19.452 13.0398L20.0654 12.4431C20.1282 12.382 20.1276 12.3372 20.053 12.3439Z","fill":"url(#paint71_linear_1437_15329)","key":2}),React.createElement("path",{"id":"Vector_86","d":"M21.2384 12.2377L20.505 12.3035C20.4298 12.3103 20.3375 12.3635 20.2747 12.4246L19.6619 13.0227C19.5976 13.0853 19.5873 13.1328 19.6628 13.1266L20.3995 13.067C20.4764 13.0608 20.6096 13.0027 20.6735 12.9395L21.2831 12.3353C21.3456 12.2734 21.3151 12.2307 21.2384 12.2375V12.2377Z","fill":"url(#paint72_linear_1437_15329)","key":3}),React.createElement("path",{"id":"Vector_87","d":"M22.4575 12.1287L21.7032 12.1963C21.6258 12.2032 21.5068 12.2595 21.4444 12.3215L20.8352 12.9268C20.7714 12.9902 20.7885 13.0362 20.8663 13.0298L21.6242 12.9686C21.7034 12.9622 21.812 12.9055 21.8753 12.8414L22.4808 12.2298C22.5428 12.1671 22.5363 12.1216 22.4574 12.1287H22.4575Z","fill":"url(#paint73_linear_1437_15329)","key":4}),React.createElement("path",{"id":"Vector_88","d":"M23.7118 12.0157L22.9357 12.0853C22.8561 12.0924 22.7642 12.147 22.7023 12.2096L22.0976 12.8226C22.0343 12.8869 22.0248 12.9356 22.1049 12.9291L22.885 12.8661C22.9665 12.8594 23.1059 12.7995 23.169 12.7346L23.7697 12.115C23.8311 12.0517 23.793 12.0082 23.7119 12.0154L23.7118 12.0157Z","fill":"url(#paint74_linear_1437_15329)","key":5})]),React.createElement("g",{"id":"Group_20","key":2},[React.createElement("path",{"id":"Vector_89","d":"M16.7669 13.5981L16.1265 14.2C16.0593 14.2631 15.9578 14.3176 15.8866 14.3226L15.2063 14.3701C15.1363 14.3749 15.1253 14.329 15.1928 14.2666L15.8352 13.6708C15.9011 13.6097 16.0195 13.5552 16.0893 13.5498L16.7677 13.4961C16.8388 13.4905 16.8329 13.5365 16.7671 13.5982L16.7669 13.5981Z","fill":"url(#paint75_linear_1437_15329)","key":0}),React.createElement("path",{"id":"Vector_90","d":"M17.9239 13.5075L17.2864 14.1172C17.2195 14.1811 17.0903 14.2382 17.017 14.2432L16.3176 14.2921C16.2457 14.297 16.2587 14.2487 16.3258 14.1855L16.9657 13.5822C17.0314 13.5203 17.1255 13.4672 17.1971 13.4615L17.8943 13.4063C17.9673 13.4005 17.9893 13.4449 17.9239 13.5075Z","fill":"url(#paint76_linear_1437_15329)","key":1}),React.createElement("path",{"id":"Vector_91","d":"M19.0621 13.4192L18.4277 14.0364C18.3611 14.1012 18.2553 14.1571 18.1799 14.1624L17.4606 14.2127C17.3866 14.2178 17.3734 14.1707 17.4403 14.1066L18.0774 13.4959C18.1428 13.4333 18.2624 13.3774 18.3361 13.3717L19.0528 13.315C19.1278 13.3091 19.1271 13.3558 19.0621 13.4192Z","fill":"url(#paint77_linear_1437_15329)","key":2}),React.createElement("path",{"id":"Vector_92","d":"M20.2444 13.2206L19.5072 13.279C19.4316 13.2851 19.3373 13.3395 19.2725 13.4029L18.6386 14.0215C18.5722 14.0862 18.5602 14.136 18.6361 14.1307L19.3764 14.0791C19.4538 14.0737 19.5892 14.0148 19.6552 13.9493L20.2859 13.324C20.3505 13.26 20.3215 13.2146 20.2444 13.2208V13.2206Z","fill":"url(#paint78_linear_1437_15329)","key":3}),React.createElement("path",{"id":"Vector_93","d":"M21.4701 13.1238L20.7115 13.1839C20.6337 13.19 20.5126 13.2474 20.4481 13.3115L19.8178 13.9379C19.7518 14.0036 19.7673 14.052 19.8455 14.0466L20.6075 13.9934C20.6871 13.9879 20.7978 13.9299 20.8635 13.8637L21.4904 13.2305C21.5545 13.1657 21.5494 13.1178 21.4701 13.1241V13.1238Z","fill":"url(#paint79_linear_1437_15329)","key":4}),React.createElement("path",{"id":"Vector_94","d":"M22.732 13.0236L21.9512 13.0854C21.8711 13.0918 21.7773 13.1476 21.7132 13.2126L21.0872 13.8473C21.0216 13.9139 21.0105 13.9649 21.091 13.9593L21.8758 13.9045C21.958 13.8988 22.0997 13.838 22.1649 13.7707L22.787 13.1289C22.8507 13.0632 22.8138 13.0171 22.7321 13.0236H22.732Z","fill":"url(#paint80_linear_1437_15329)","key":5})]),React.createElement("g",{"id":"Group_21","key":3},[React.createElement("path",{"id":"Vector_95","d":"M15.7195 14.5827L15.0573 15.205C14.9879 15.2704 14.8843 15.3259 14.8129 15.33L14.1303 15.3697C14.0602 15.3738 14.0509 15.3253 14.1206 15.2607L14.7845 14.645C14.8525 14.5818 14.973 14.5266 15.0428 14.5218L15.7235 14.4754C15.7948 14.4706 15.7872 14.5187 15.7193 14.5826L15.7195 14.5827Z","fill":"url(#paint81_linear_1437_15329)","key":0}),React.createElement("path",{"id":"Vector_96","d":"M16.8812 14.5055L16.2217 15.1361C16.1525 15.2024 16.0212 15.2601 15.9477 15.2645L15.2456 15.3053C15.1735 15.3095 15.188 15.2589 15.2576 15.1934L15.9192 14.5698C15.9872 14.5058 16.0832 14.4515 16.1551 14.4465L16.855 14.3988C16.9282 14.3938 16.949 14.4407 16.8813 14.5055H16.8812Z","fill":"url(#paint82_linear_1437_15329)","key":1}),React.createElement("path",{"id":"Vector_97","d":"M18.0241 14.4289L17.3674 15.0675C17.2985 15.1345 17.1906 15.1919 17.115 15.1963L16.3925 15.2382C16.3182 15.2426 16.3066 15.1928 16.3759 15.1265L17.035 14.4949C17.1027 14.4301 17.2243 14.3734 17.2983 14.3683L18.0183 14.3192C18.0938 14.3141 18.0914 14.3633 18.0241 14.4288V14.4289Z","fill":"url(#paint83_linear_1437_15329)","key":2}),React.createElement("path",{"id":"Vector_98","d":"M19.2539 14.3473L18.6008 14.9947C18.5323 15.0626 18.3948 15.1223 18.317 15.1269L17.5733 15.17C17.497 15.1744 17.5107 15.1225 17.5795 15.0553L18.2356 14.4152C18.3029 14.3496 18.3988 14.2939 18.4749 14.2886L19.2157 14.2382C19.2934 14.2329 19.3208 14.281 19.2539 14.3473Z","fill":"url(#paint84_linear_1437_15329)","key":3}),React.createElement("path",{"id":"Vector_99","d":"M20.4649 14.2662L19.8155 14.9222C19.7473 14.991 19.6348 15.0501 19.5545 15.0548L18.7885 15.0993C18.7097 15.1038 18.6957 15.0528 18.7644 14.9848L19.417 14.3362C19.4839 14.2697 19.607 14.2114 19.6853 14.2061L20.4479 14.1542C20.5278 14.1488 20.5314 14.199 20.4648 14.2663L20.4649 14.2662Z","fill":"url(#paint85_linear_1437_15329)","key":4}),React.createElement("path",{"id":"Vector_100","d":"M21.7172 14.068L20.9318 14.1214C20.8513 14.1268 20.7552 14.1842 20.6889 14.2515L20.0403 14.909C19.9724 14.9779 19.9596 15.0313 20.0404 15.0267L20.8297 14.9808C20.9123 14.976 21.0566 14.9141 21.124 14.8444L21.7688 14.1792C21.8348 14.1111 21.7992 14.0621 21.717 14.0678L21.7172 14.068Z","fill":"url(#paint86_linear_1437_15329)","key":5})]),React.createElement("g",{"id":"Group_22","key":4},[React.createElement("path",{"id":"Vector_101","d":"M14.6367 15.6004L13.9518 16.2442C13.8798 16.3118 13.7743 16.3685 13.7025 16.3719L13.0181 16.4031C12.9478 16.4063 12.9402 16.3553 13.0122 16.2884L13.6987 15.6519C13.7691 15.5866 13.8915 15.5303 13.9617 15.5264L14.6445 15.488C14.716 15.4839 14.7068 15.5345 14.6365 15.6006L14.6367 15.6004Z","fill":"url(#paint87_linear_1437_15329)","key":0}),React.createElement("path",{"id":"Vector_102","d":"M15.8023 15.537L15.1198 16.1896C15.0482 16.2581 14.9145 16.317 14.8408 16.3203L14.1364 16.3524C14.064 16.3558 14.0805 16.3028 14.1524 16.2352L14.8368 15.5899C14.907 15.5237 15.0051 15.4682 15.0773 15.4641L15.7797 15.4246C15.8532 15.4205 15.8723 15.4701 15.8023 15.537Z","fill":"url(#paint88_linear_1437_15329)","key":1}),React.createElement("path",{"id":"Vector_103","d":"M16.9501 15.4739L16.2702 16.1353C16.1989 16.2047 16.0888 16.2633 16.0127 16.2668L15.2875 16.2998C15.2131 16.3033 15.2032 16.2508 15.2748 16.1821L15.9571 15.5283C16.0271 15.4613 16.1509 15.4035 16.2252 15.3992L16.9482 15.3586C17.0239 15.3544 17.0199 15.406 16.9502 15.4739H16.9501Z","fill":"url(#paint89_linear_1437_15329)","key":2}),React.createElement("path",{"id":"Vector_104","d":"M18.1854 15.4058L17.5088 16.0765C17.4377 16.147 17.2979 16.2077 17.2196 16.2113L16.4727 16.2454C16.396 16.2489 16.4116 16.1945 16.4829 16.1248L17.1623 15.4619C17.232 15.394 17.33 15.3368 17.4065 15.3326L18.1508 15.2908C18.2288 15.2864 18.2548 15.3371 18.1855 15.4059L18.1854 15.4058Z","fill":"url(#paint90_linear_1437_15329)","key":3}),React.createElement("path",{"id":"Vector_105","d":"M19.4025 15.3398L18.7294 16.0198C18.6587 16.0911 18.5439 16.1517 18.4632 16.1553L17.6935 16.1904C17.6145 16.1941 17.602 16.1402 17.6731 16.0696L18.3493 15.3976C18.4185 15.3288 18.5439 15.2693 18.6226 15.265L19.3892 15.2219C19.4696 15.2174 19.4715 15.2704 19.4025 15.34V15.3398Z","fill":"url(#paint91_linear_1437_15329)","key":4}),React.createElement("path",{"id":"Vector_106","d":"M20.7138 15.2676L20.045 15.9573C20.0416 15.9608 20.0271 15.9649 20.0227 15.9683C19.9515 16.0363 19.8242 16.0927 19.7451 16.0963L18.9515 16.1325C18.87 16.1363 18.8846 16.0803 18.9552 16.0086L19.6276 15.327C19.6338 15.3207 19.6286 15.3154 19.6363 15.3091C19.7063 15.2475 19.8017 15.1981 19.8754 15.1941L20.6653 15.1497C20.7481 15.145 20.7822 15.1969 20.7137 15.2677L20.7138 15.2676Z","fill":"url(#paint92_linear_1437_15329)","key":5})]),React.createElement("g",{"id":"Group_23","key":5},[React.createElement("path",{"id":"Vector_107","d":"M13.5163 16.6536L12.8074 17.3198C12.733 17.3898 12.6253 17.4479 12.5533 17.4502L11.8672 17.4724C11.7968 17.4747 11.791 17.4209 11.8656 17.3518L12.5758 16.6931C12.6486 16.6255 12.7733 16.5683 12.8435 16.5652L13.5283 16.5353C13.6001 16.5321 13.589 16.5851 13.5163 16.6534V16.6536Z","fill":"url(#paint93_linear_1437_15329)","key":0}),React.createElement("path",{"id":"Vector_108","d":"M14.6859 16.6039L13.979 17.2798C13.9049 17.3508 13.7689 17.4107 13.6949 17.4131L12.9885 17.4359C12.916 17.4383 12.9344 17.3829 13.0088 17.3127L13.7174 16.6448C13.7901 16.5763 13.8903 16.5194 13.9626 16.5163L14.6674 16.4855C14.7412 16.4823 14.7584 16.5347 14.6859 16.6039Z","fill":"url(#paint94_linear_1437_15329)","key":1}),React.createElement("path",{"id":"Vector_109","d":"M15.8379 16.5556L15.1334 17.2408C15.0594 17.3128 14.9471 17.3727 14.8707 17.3751L14.1431 17.3986C14.0683 17.4011 14.0603 17.3457 14.1345 17.2746L14.841 16.5975C14.9134 16.5281 15.0396 16.4692 15.114 16.4659L15.8396 16.4342C15.9157 16.4309 15.9099 16.4852 15.8377 16.5554L15.8379 16.5556Z","fill":"url(#paint95_linear_1437_15329)","key":2}),React.createElement("path",{"id":"Vector_110","d":"M17.0782 16.5035L16.3767 17.1988C16.303 17.2719 16.1608 17.3336 16.0822 17.3361L15.3323 17.3604C15.2554 17.3629 15.2728 17.306 15.3468 17.2338L16.0508 16.5469C16.1231 16.4765 16.2232 16.4179 16.3001 16.4146L17.0474 16.382C17.1257 16.3785 17.1503 16.4324 17.0783 16.5036L17.0782 16.5035Z","fill":"url(#paint96_linear_1437_15329)","key":3}),React.createElement("path",{"id":"Vector_111","d":"M18.3011 16.4523L17.603 17.1574C17.5296 17.2315 17.4124 17.2934 17.3313 17.296L16.5582 17.321C16.4788 17.3236 16.4682 17.2667 16.5419 17.1935L17.2429 16.4968C17.3147 16.4254 17.4424 16.3649 17.5216 16.3614L18.2919 16.3278C18.3727 16.3243 18.3728 16.38 18.3012 16.4523H18.3011Z","fill":"url(#paint97_linear_1437_15329)","key":4}),React.createElement("path",{"id":"Vector_112","d":"M19.6193 16.3966L18.9252 17.1125C18.8522 17.1878 18.7031 17.2515 18.6194 17.2542L17.8219 17.28C17.7401 17.2827 17.7565 17.2238 17.8299 17.1496L18.5274 16.4425C18.5989 16.37 18.6989 16.3098 18.7805 16.3062L19.5746 16.2717C19.6579 16.268 19.6903 16.3231 19.6193 16.3964V16.3966Z","fill":"url(#paint98_linear_1437_15329)","key":5})])]),React.createElement("path",{"id":"Vector_113","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M18.359 12.2687L18.9024 11.7563C18.9413 11.8876 18.9265 12.0705 18.8158 12.3237L18.3575 12.3655C18.2862 12.372 18.2959 12.3278 18.3588 12.2685L18.359 12.2687Z","fill":"url(#paint99_linear_1437_15329)","key":3}),React.createElement("path",{"id":"Vector_114","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M18.7508 12.4609C18.6527 12.6491 18.5063 12.8717 18.3001 13.1346C18.2355 13.1964 18.1242 13.2512 18.0511 13.2571L17.3543 13.3134C17.2827 13.3191 17.2941 13.2729 17.3591 13.2117L17.9783 12.628C18.0418 12.5681 18.1341 12.5162 18.2054 12.5097L18.7508 12.4609Z","fill":"url(#paint100_linear_1437_15329)","key":4}),React.createElement("path",{"id":"Vector_115","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M17.4402 14.1062L18.0071 13.563C17.8895 13.812 17.8423 14.0154 17.8704 14.1838L17.4604 14.2125C17.3864 14.2176 17.3733 14.1705 17.4402 14.1064V14.1062Z","fill":"url(#paint101_linear_1437_15329)","key":5}),React.createElement("path",{"id":"Vector_116","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M18.0956 14.5508C18.247 14.6944 18.4354 14.8057 18.6935 14.9019L18.6008 14.9938C18.5323 15.0617 18.3948 15.1215 18.317 15.126L17.5733 15.1692C17.497 15.1736 17.5107 15.1216 17.5795 15.0545L18.0956 14.5508Z","fill":"url(#paint102_linear_1437_15329)","key":6}),React.createElement("path",{"id":"Vector_117","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M18.7644 14.9842L18.7937 14.9551C18.9061 14.997 19.0154 15.0378 19.1211 15.0794L18.7887 15.0987C18.71 15.1033 18.6959 15.0523 18.7646 14.9842H18.7644Z","fill":"url(#paint103_linear_1437_15329)","key":7}),React.createElement("path",{"id":"Vector_118","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M18.9552 16.0087L19.6276 15.327C19.6338 15.3207 19.6286 15.3154 19.6363 15.3091C19.9052 15.4662 20.0729 15.6643 20.0174 15.9687C19.9462 16.0366 19.8242 16.0927 19.7451 16.0963L18.9515 16.1326C18.87 16.1363 18.8846 16.0803 18.9552 16.0087Z","fill":"url(#paint104_linear_1437_15329)","key":8}),React.createElement("path",{"id":"Vector_119","style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M19.6192 16.3966L18.9251 17.1125C18.8521 17.1878 18.7029 17.2515 18.6193 17.2542L17.8218 17.28C17.74 17.2827 17.7564 17.2238 17.8298 17.1496L18.5273 16.4425C18.5987 16.37 18.6988 16.3098 18.7803 16.3062L19.5745 16.2717C19.6578 16.268 19.6902 16.3233 19.6192 16.3966Z","fill":"url(#paint105_linear_1437_15329)","key":9})])])]),React.createElement("defs",{"key":1},[React.createElement("linearGradient",{"id":"paint0_linear_1437_15329","x1":"12.8092","y1":"11.0732","x2":"0.477176","y2":"38.8032","gradientUnits":"userSpaceOnUse","key":0},[React.createElement("stop",{"stopColor":"#006736","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint1_linear_1437_15329","x1":"6.70655","y1":"16.8166","x2":"2.48892","y2":"-8.35525","gradientUnits":"userSpaceOnUse","key":1},[React.createElement("stop",{"stopColor":"#93C13E","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#93C13E","key":1})]),React.createElement("linearGradient",{"id":"paint2_linear_1437_15329","x1":"-5.79214","y1":"24.9333","x2":"12.7804","y2":"26.789","gradientUnits":"userSpaceOnUse","key":2},[React.createElement("stop",{"stopColor":"#93C13E","key":0}),React.createElement("stop",{"offset":"1","stopColor":"white","key":1})]),React.createElement("linearGradient",{"id":"paint3_linear_1437_15329","x1":"-2.46271","y1":"23.0333","x2":"36.7756","y2":"20.6281","gradientUnits":"userSpaceOnUse","key":3},[React.createElement("stop",{"stopColor":"#C7DF9A","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#7BBE00","key":1})]),React.createElement("linearGradient",{"id":"paint4_linear_1437_15329","x1":"29.0188","y1":"10.2886","x2":"6.01535","y2":"20.4016","gradientUnits":"userSpaceOnUse","key":4},[React.createElement("stop",{"stopColor":"#05683C","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint5_linear_1437_15329","x1":"16.5951","y1":"17.0457","x2":"-0.608862","y2":"23.1011","gradientUnits":"userSpaceOnUse","key":5},[React.createElement("stop",{"stopColor":"#05683C","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#F5F9F5","key":1})]),React.createElement("linearGradient",{"id":"paint6_linear_1437_15329","x1":"28.9888","y1":"19.617","x2":"28.9888","y2":"35.1055","gradientUnits":"userSpaceOnUse","key":6},[React.createElement("stop",{"stopColor":"#93C13E","stopOpacity":"0.1","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint7_linear_1437_15329","x1":"23.0924","y1":"19.6164","x2":"23.0924","y2":"35.105","gradientUnits":"userSpaceOnUse","key":7},[React.createElement("stop",{"stopColor":"#93C13E","stopOpacity":"0.1","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint8_linear_1437_15329","x1":"26.0926","y1":"19.6168","x2":"26.0926","y2":"35.1053","gradientUnits":"userSpaceOnUse","key":8},[React.createElement("stop",{"stopColor":"#93C13E","stopOpacity":"0.1","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint9_linear_1437_15329","x1":"25.1772","y1":"11.4816","x2":"24.8167","y2":"11.6988","gradientUnits":"userSpaceOnUse","key":9},[React.createElement("stop",{"stopColor":"#EBEFF2","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint10_linear_1437_15329","x1":"22.6365","y1":"14.0202","x2":"22.2759","y2":"14.2374","gradientUnits":"userSpaceOnUse","key":10},[React.createElement("stop",{"stopColor":"#EBEFF2","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint11_linear_1437_15329","x1":"16.1997","y1":"18.232","x2":"15.8982","y2":"18.4137","gradientUnits":"userSpaceOnUse","key":11},[React.createElement("stop",{"stopColor":"#EBEFF2","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint12_linear_1437_15329","x1":"12.0161","y1":"19.3566","x2":"11.6556","y2":"19.574","gradientUnits":"userSpaceOnUse","key":12},[React.createElement("stop",{"stopColor":"#EBEFF2","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint13_linear_1437_15329","x1":"19.8417","y1":"16.8698","x2":"19.4811","y2":"17.087","gradientUnits":"userSpaceOnUse","key":13},[React.createElement("stop",{"stopColor":"#EBEFF2","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint14_linear_1437_15329","x1":"12.4734","y1":"17.3361","x2":"12.1128","y2":"17.5533","gradientUnits":"userSpaceOnUse","key":14},[React.createElement("stop",{"stopColor":"#EBEFF2","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint15_linear_1437_15329","x1":"-2.78599","y1":"19.5215","x2":"14.004","y2":"19.5215","gradientUnits":"userSpaceOnUse","key":15},[React.createElement("stop",{"stopColor":"#EBEFF2","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint16_linear_1437_15329","x1":"15.66","y1":"15.2339","x2":"4.25838","y2":"22.1044","gradientUnits":"userSpaceOnUse","key":16},[React.createElement("stop",{"stopColor":"#EBEFF2","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint17_linear_1437_15329","x1":"9.49505","y1":"17.5583","x2":"9.59568","y2":"20.9208","gradientUnits":"userSpaceOnUse","key":17},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint18_linear_1437_15329","x1":"10.617","y1":"17.5349","x2":"10.7189","y2":"20.9414","gradientUnits":"userSpaceOnUse","key":18},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint19_linear_1437_15329","x1":"11.7545","y1":"17.5111","x2":"11.8576","y2":"20.9627","gradientUnits":"userSpaceOnUse","key":19},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint20_linear_1437_15329","x1":"12.9403","y1":"17.4871","x2":"13.045","y2":"20.9849","gradientUnits":"userSpaceOnUse","key":20},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint21_linear_1437_15329","x1":"14.1433","y1":"17.4623","x2":"14.2493","y2":"21.0078","gradientUnits":"userSpaceOnUse","key":21},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint22_linear_1437_15329","x1":"15.3989","y1":"17.4363","x2":"15.5065","y2":"21.0306","gradientUnits":"userSpaceOnUse","key":22},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint23_linear_1437_15329","x1":"7.89717","y1":"17.5995","x2":"7.9961","y2":"20.9099","gradientUnits":"userSpaceOnUse","key":23},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint24_linear_1437_15329","x1":"8.97673","y1":"17.5939","x2":"9.07582","y2":"20.9093","gradientUnits":"userSpaceOnUse","key":24},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint25_linear_1437_15329","x1":"10.0701","y1":"17.5725","x2":"10.1704","y2":"20.9304","gradientUnits":"userSpaceOnUse","key":25},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint26_linear_1437_15329","x1":"11.2096","y1":"17.5497","x2":"11.3112","y2":"20.9515","gradientUnits":"userSpaceOnUse","key":26},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint27_linear_1437_15329","x1":"12.3649","y1":"17.5269","x2":"12.4678","y2":"20.9737","gradientUnits":"userSpaceOnUse","key":27},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint28_linear_1437_15329","x1":"13.5699","y1":"17.5027","x2":"13.6742","y2":"20.9957","gradientUnits":"userSpaceOnUse","key":28},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint29_linear_1437_15329","x1":"6.35834","y1":"17.6767","x2":"6.45374","y2":"20.8658","gradientUnits":"userSpaceOnUse","key":29},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint30_linear_1437_15329","x1":"7.39705","y1":"17.6569","x2":"7.49353","y2":"20.8855","gradientUnits":"userSpaceOnUse","key":30},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint31_linear_1437_15329","x1":"8.44889","y1":"17.6369","x2":"8.54675","y2":"20.906","gradientUnits":"userSpaceOnUse","key":31},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint32_linear_1437_15329","x1":"9.54464","y1":"17.6164","x2":"9.64373","y2":"20.9269","gradientUnits":"userSpaceOnUse","key":32},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint33_linear_1437_15329","x1":"10.6551","y1":"17.5956","x2":"10.7552","y2":"20.9487","gradientUnits":"userSpaceOnUse","key":33},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint34_linear_1437_15329","x1":"11.8125","y1":"17.5735","x2":"11.914","y2":"20.9702","gradientUnits":"userSpaceOnUse","key":34},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint35_linear_1437_15329","x1":"4.8742","y1":"17.742","x2":"4.96714","y2":"20.8506","gradientUnits":"userSpaceOnUse","key":35},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint36_linear_1437_15329","x1":"5.87479","y1":"17.7238","x2":"5.96881","y2":"20.87","gradientUnits":"userSpaceOnUse","key":36},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint37_linear_1437_15329","x1":"6.88751","y1":"17.7057","x2":"6.9826","y2":"20.8902","gradientUnits":"userSpaceOnUse","key":37},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint38_linear_1437_15329","x1":"7.94165","y1":"17.6871","x2":"8.03796","y2":"20.911","gradientUnits":"userSpaceOnUse","key":38},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint39_linear_1437_15329","x1":"9.00946","y1":"17.6679","x2":"9.10701","y2":"20.932","gradientUnits":"userSpaceOnUse","key":39},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint40_linear_1437_15329","x1":"10.1223","y1":"17.6482","x2":"10.2211","y2":"20.9536","gradientUnits":"userSpaceOnUse","key":40},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint41_linear_1437_15329","x1":"3.44258","y1":"17.8094","x2":"3.53321","y2":"20.8414","gradientUnits":"userSpaceOnUse","key":41},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint42_linear_1437_15329","x1":"4.40696","y1":"17.7929","x2":"4.49866","y2":"20.8605","gradientUnits":"userSpaceOnUse","key":42},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint43_linear_1437_15329","x1":"5.38249","y1":"17.7772","x2":"5.47527","y2":"20.8813","gradientUnits":"userSpaceOnUse","key":43},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint44_linear_1437_15329","x1":"6.39767","y1":"17.7597","x2":"6.49152","y2":"20.901","gradientUnits":"userSpaceOnUse","key":44},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint45_linear_1437_15329","x1":"7.42537","y1":"17.7432","x2":"7.52046","y2":"20.9229","gradientUnits":"userSpaceOnUse","key":45},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint46_linear_1437_15329","x1":"8.49581","y1":"17.7256","x2":"8.59197","y2":"20.9445","gradientUnits":"userSpaceOnUse","key":46},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint47_linear_1437_15329","x1":"2.06048","y1":"17.8793","x2":"2.14895","y2":"20.8383","gradientUnits":"userSpaceOnUse","key":47},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint48_linear_1437_15329","x1":"2.99045","y1":"17.865","x2":"3.07984","y2":"20.8578","gradientUnits":"userSpaceOnUse","key":48},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint49_linear_1437_15329","x1":"3.93093","y1":"17.8505","x2":"4.0214","y2":"20.8779","gradientUnits":"userSpaceOnUse","key":49},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint50_linear_1437_15329","x1":"4.90901","y1":"17.8356","x2":"5.00056","y2":"20.8987","gradientUnits":"userSpaceOnUse","key":50},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint51_linear_1437_15329","x1":"5.89898","y1":"17.8211","x2":"5.9916","y2":"20.9204","gradientUnits":"userSpaceOnUse","key":51},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint52_linear_1437_15329","x1":"6.92912","y1":"17.8051","x2":"7.02298","y2":"20.9417","gradientUnits":"userSpaceOnUse","key":52},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint53_linear_1437_15329","x1":"9.55057","y1":"18.398","x2":"10.5747","y2":"18.398","gradientUnits":"userSpaceOnUse","key":53},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint54_linear_1437_15329","x1":"7.96261","y1":"18.8124","x2":"9.87037","y2":"18.8124","gradientUnits":"userSpaceOnUse","key":54},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint55_linear_1437_15329","x1":"7.45895","y1":"19.3066","x2":"8.40181","y2":"19.3066","gradientUnits":"userSpaceOnUse","key":55},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint56_linear_1437_15329","x1":"5.94599","y1":"19.6989","x2":"7.81291","y2":"19.6989","gradientUnits":"userSpaceOnUse","key":56},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint57_linear_1437_15329","x1":"3.07894","y1":"20.5137","x2":"4.93594","y2":"20.5137","gradientUnits":"userSpaceOnUse","key":57},[React.createElement("stop",{"stopColor":"#AA80F9","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#6165D7","key":1})]),React.createElement("linearGradient",{"id":"paint58_linear_1437_15329","x1":"6.97435","y1":"19.7694","x2":"8.10219","y2":"19.7694","gradientUnits":"userSpaceOnUse","key":58},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint59_linear_1437_15329","x1":"8.01628","y1":"19.8825","x2":"8.34246","y2":"19.8825","gradientUnits":"userSpaceOnUse","key":59},[React.createElement("stop",{"stopColor":"#AA80F9","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#6165D7","key":1})]),React.createElement("linearGradient",{"id":"paint60_linear_1437_15329","x1":"7.52503","y1":"20.2045","x2":"8.69683","y2":"20.2045","gradientUnits":"userSpaceOnUse","key":60},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint61_linear_1437_15329","x1":"8.61388","y1":"14.2474","x2":"22.6385","y2":"14.2474","gradientUnits":"userSpaceOnUse","key":61},[React.createElement("stop",{"stopColor":"#EBEFF2","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint62_linear_1437_15329","x1":"24.9375","y1":"10.4036","x2":"13.6268","y2":"17.2193","gradientUnits":"userSpaceOnUse","key":62},[React.createElement("stop",{"stopColor":"white","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint63_linear_1437_15329","x1":"17.9518","y1":"10.334","x2":"18.1674","y2":"17.5479","gradientUnits":"userSpaceOnUse","key":63},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint64_linear_1437_15329","x1":"19.0748","y1":"10.1787","x2":"19.2932","y2":"17.486","gradientUnits":"userSpaceOnUse","key":64},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint65_linear_1437_15329","x1":"20.2002","y1":"10.0192","x2":"20.4215","y2":"17.4224","gradientUnits":"userSpaceOnUse","key":65},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint66_linear_1437_15329","x1":"21.3865","y1":"9.85471","x2":"21.6107","y2":"17.3564","gradientUnits":"userSpaceOnUse","key":66},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint67_linear_1437_15329","x1":"22.5747","y1":"9.68652","x2":"22.802","y2":"17.2894","gradientUnits":"userSpaceOnUse","key":67},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint68_linear_1437_15329","x1":"23.8297","y1":"9.51296","x2":"24.06","y2":"17.2197","gradientUnits":"userSpaceOnUse","key":68},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint69_linear_1437_15329","x1":"16.9311","y1":"10.2873","x2":"17.1514","y2":"17.6598","gradientUnits":"userSpaceOnUse","key":69},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint70_linear_1437_15329","x1":"18.0582","y1":"10.1285","x2":"18.2814","y2":"17.5987","gradientUnits":"userSpaceOnUse","key":70},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint71_linear_1437_15329","x1":"19.1886","y1":"9.96603","x2":"19.4149","y2":"17.5364","gradientUnits":"userSpaceOnUse","key":71},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0.5","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint72_linear_1437_15329","x1":"20.3801","y1":"9.79805","x2":"20.6095","y2":"17.4716","gradientUnits":"userSpaceOnUse","key":72},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0.5","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint73_linear_1437_15329","x1":"21.5746","y1":"9.62685","x2":"21.8072","y2":"17.4062","gradientUnits":"userSpaceOnUse","key":73},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"0.263695","stopColor":"#05683C","stopOpacity":"0.263695","key":1}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":2})]),React.createElement("linearGradient",{"id":"paint74_linear_1437_15329","x1":"22.8366","y1":"9.44905","x2":"23.0723","y2":"17.3372","gradientUnits":"userSpaceOnUse","key":74},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint75_linear_1437_15329","x1":"15.8765","y1":"10.2275","x2":"16.1018","y2":"17.7656","gradientUnits":"userSpaceOnUse","key":75},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint76_linear_1437_15329","x1":"17.007","y1":"10.0648","x2":"17.2355","y2":"17.705","gradientUnits":"userSpaceOnUse","key":76},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint77_linear_1437_15329","x1":"18.1425","y1":"9.89914","x2":"18.3741","y2":"17.6442","gradientUnits":"userSpaceOnUse","key":77},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint78_linear_1437_15329","x1":"19.3389","y1":"9.7274","x2":"19.5736","y2":"17.5804","gradientUnits":"userSpaceOnUse","key":78},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint79_linear_1437_15329","x1":"20.5395","y1":"9.5518","x2":"20.7777","y2":"17.5158","gradientUnits":"userSpaceOnUse","key":79},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint80_linear_1437_15329","x1":"21.8079","y1":"9.36977","x2":"22.0495","y2":"17.4477","gradientUnits":"userSpaceOnUse","key":80},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint81_linear_1437_15329","x1":"14.7864","y1":"10.1535","x2":"15.0169","y2":"17.8646","gradientUnits":"userSpaceOnUse","key":81},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint82_linear_1437_15329","x1":"15.9201","y1":"9.98704","x2":"16.1537","y2":"17.8051","gradientUnits":"userSpaceOnUse","key":82},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint83_linear_1437_15329","x1":"17.0598","y1":"9.81645","x2":"17.2969","y2":"17.7444","gradientUnits":"userSpaceOnUse","key":83},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint84_linear_1437_15329","x1":"18.2609","y1":"9.64066","x2":"18.5012","y2":"17.6818","gradientUnits":"userSpaceOnUse","key":84},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint85_linear_1437_15329","x1":"19.4675","y1":"9.46011","x2":"19.7113","y2":"17.6174","gradientUnits":"userSpaceOnUse","key":85},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint86_linear_1437_15329","x1":"20.7421","y1":"9.27353","x2":"20.9895","y2":"17.5507","gradientUnits":"userSpaceOnUse","key":86},[React.createElement("stop",{"stopColor":"#006736","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint87_linear_1437_15329","x1":"13.6589","y1":"10.0625","x2":"13.8948","y2":"17.9547","gradientUnits":"userSpaceOnUse","key":87},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint88_linear_1437_15329","x1":"14.7953","y1":"9.89188","x2":"15.0345","y2":"17.896","gradientUnits":"userSpaceOnUse","key":88},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint89_linear_1437_15329","x1":"15.9391","y1":"9.71642","x2":"16.1819","y2":"17.836","gradientUnits":"userSpaceOnUse","key":89},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint90_linear_1437_15329","x1":"17.1443","y1":"9.53464","x2":"17.3906","y2":"17.7728","gradientUnits":"userSpaceOnUse","key":90},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint91_linear_1437_15329","x1":"18.3565","y1":"9.34961","x2":"18.6064","y2":"17.7099","gradientUnits":"userSpaceOnUse","key":91},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0.5","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint92_linear_1437_15329","x1":"19.6366","y1":"9.15694","x2":"19.8903","y2":"17.6431","gradientUnits":"userSpaceOnUse","key":92},[React.createElement("stop",{"stopColor":"#006736","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint93_linear_1437_15329","x1":"12.4918","y1":"9.95401","x2":"12.7333","y2":"18.0357","gradientUnits":"userSpaceOnUse","key":93},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint94_linear_1437_15329","x1":"13.6307","y1":"9.77715","x2":"13.8758","y2":"17.9764","gradientUnits":"userSpaceOnUse","key":94},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint95_linear_1437_15329","x1":"14.7782","y1":"9.59641","x2":"15.0269","y2":"17.9166","gradientUnits":"userSpaceOnUse","key":95},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint96_linear_1437_15329","x1":"15.9869","y1":"9.40942","x2":"16.2392","y2":"17.8544","gradientUnits":"userSpaceOnUse","key":96},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"0.728491","stopColor":"#006736","stopOpacity":"0.728491","key":1}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":2})]),React.createElement("linearGradient",{"id":"paint97_linear_1437_15329","x1":"17.2041","y1":"9.21789","x2":"17.4605","y2":"17.7912","gradientUnits":"userSpaceOnUse","key":97},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint98_linear_1437_15329","x1":"18.4897","y1":"9.01902","x2":"18.7498","y2":"17.7247","gradientUnits":"userSpaceOnUse","key":98},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint99_linear_1437_15329","x1":"18.3079","y1":"12.0613","x2":"18.9219","y2":"12.0613","gradientUnits":"userSpaceOnUse","key":99},[React.createElement("stop",{"stopColor":"#006736","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint100_linear_1437_15329","x1":"17.3053","y1":"12.8875","x2":"18.7508","y2":"12.8875","gradientUnits":"userSpaceOnUse","key":100},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint101_linear_1437_15329","x1":"17.3968","y1":"13.8877","x2":"18.0071","y2":"13.8877","gradientUnits":"userSpaceOnUse","key":101},[React.createElement("stop",{"stopColor":"#006736","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint102_linear_1437_15329","x1":"17.5215","y1":"14.8601","x2":"18.6935","y2":"14.8601","gradientUnits":"userSpaceOnUse","key":102},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0.5","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint103_linear_1437_15329","x1":"18.7205","y1":"15.0272","x2":"19.1211","y2":"15.0272","gradientUnits":"userSpaceOnUse","key":103},[React.createElement("stop",{"stopColor":"#AA80F9","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#6165D7","key":1})]),React.createElement("linearGradient",{"id":"paint104_linear_1437_15329","x1":"18.896","y1":"15.7209","x2":"20.0279","y2":"15.7209","gradientUnits":"userSpaceOnUse","key":104},[React.createElement("stop",{"stopColor":"#AA80F9","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#6165D7","key":1})]),React.createElement("linearGradient",{"id":"paint105_linear_1437_15329","x1":"17.7673","y1":"16.7758","x2":"19.6582","y2":"16.7758","gradientUnits":"userSpaceOnUse","key":105},[React.createElement("stop",{"stopColor":"#AA80F9","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#AA80F9","key":1})])])]);
}

IcHouseComponent.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = IcHouseComponent;

IcHouseComponent.default = IcHouseComponent;


/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcInfoComponent (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.5918 9.74167V6.59167H7.40846V9.74167H6.5918ZM7.29201 4.95856C7.21464 5.03592 7.12134 5.07501 7.00013 5.07501C6.87892 5.07501 6.78562 5.03592 6.70825 4.95856C6.63088 4.88119 6.5918 4.78788 6.5918 4.66667C6.5918 4.54547 6.63088 4.45216 6.70825 4.37479C6.78562 4.29743 6.87892 4.25834 7.00013 4.25834C7.12134 4.25834 7.21464 4.29743 7.29201 4.37479C7.36938 4.45216 7.40846 4.54547 7.40846 4.66667C7.40846 4.78788 7.36938 4.88119 7.29201 4.95856ZM7.00013 12.6583C6.21596 12.6583 5.48133 12.5097 4.79446 12.2133C4.1042 11.9154 3.50551 11.5121 2.99679 11.0033C2.48807 10.4946 2.0847 9.89594 1.78685 9.20567C1.49046 8.51881 1.3418 7.78418 1.3418 7.00001C1.3418 6.21584 1.49046 5.48121 1.78685 4.79434C2.0847 4.10408 2.48807 3.50539 2.99679 2.99667C3.50551 2.48795 4.1042 2.08458 4.79446 1.78673C5.48133 1.49034 6.21596 1.34167 7.00013 1.34167C7.7843 1.34167 8.51893 1.49034 9.2058 1.78673C9.89606 2.08458 10.4948 2.48795 11.0035 2.99667C11.5122 3.50539 11.9156 4.10408 12.2134 4.79434C12.5098 5.48121 12.6585 6.21584 12.6585 7.00001C12.6585 7.78418 12.5098 8.51881 12.2134 9.20567C11.9156 9.89594 11.5122 10.4946 11.0035 11.0033C10.4948 11.5121 9.89606 11.9154 9.2058 12.2133C8.51893 12.5097 7.7843 12.6583 7.00013 12.6583ZM7.00013 11.8417C8.34834 11.8417 9.49662 11.3718 10.4343 10.4342C11.372 9.4965 11.8418 8.34822 11.8418 7.00001C11.8418 5.6518 11.372 4.50352 10.4343 3.56585C9.49662 2.62817 8.34834 2.15834 7.00013 2.15834C5.65192 2.15834 4.50364 2.62817 3.56597 3.56585C2.6283 4.50352 2.15846 5.6518 2.15846 7.00001C2.15846 8.34822 2.6283 9.4965 3.56597 10.4342C4.50364 11.3718 5.65192 11.8417 7.00013 11.8417Z","fill":"#3E3E3E"}));
}

IcInfoComponent.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = IcInfoComponent;

IcInfoComponent.default = IcInfoComponent;


/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcMailComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icons/ic-search"},[React.createElement("rect",{"id":"background","x":"1.34729","y":"1.1665","width":"15.7832","height":"15.6667","stroke":"#3E3E3E","key":0}),React.createElement("path",{"id":"Vector","d":"M4.5 4.5H13.5C13.7761 4.5 14 4.72386 14 5V13C14 13.2761 13.7761 13.5 13.5 13.5H4.5C4.22386 13.5 4 13.2761 4 13V5C4 4.72386 4.22386 4.5 4.5 4.5ZM13 6.61896L9.0359 10.169L5 6.60797V12.5H13V6.61896ZM5.25573 5.5L9.03095 8.831L12.7505 5.5H5.25573Z","fill":"#3E3E3E","key":1})]));
}

IcMailComponent.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = IcMailComponent;

IcMailComponent.default = IcMailComponent;


/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcResultComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-result"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M3.3751 2.94336L4.5001 1.81836L5.6251 2.94336L6.7501 1.81836L7.8751 2.94336L9.0001 1.81836L10.1251 2.94336L11.2501 1.81836L12.3751 2.94336L13.5001 1.81836L14.6251 2.94336L15.5251 2.04336V15.957L14.6251 15.057L13.5001 16.182L12.3751 15.057L11.2501 16.182L10.1251 15.057L9.0001 16.182L7.8751 15.057L6.7501 16.182L5.6251 15.057L4.5001 16.182L3.3751 15.057L2.4751 15.957V2.04336L3.3751 2.94336ZM3.5251 3.45016V14.5502H14.4751V3.45016H3.5251ZM4.7251 12.5252V11.4752H13.2751V12.5252H4.7251ZM4.7251 9.52516V8.47516H13.2751V9.52516H4.7251ZM4.7251 6.52516V5.47516H13.2751V6.52516H4.7251Z","fill":"#3E3E3E"})));
}

IcResultComponent.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = IcResultComponent;

IcResultComponent.default = IcResultComponent;


/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcSeeComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-see"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M17.0782 10.1038L17.1297 9.99993L17.0782 9.89604C16.4089 8.54393 15.4397 7.46725 14.1736 6.67005C12.9065 5.87224 11.5136 5.47306 10 5.47306C8.48652 5.47306 7.09358 5.87224 5.82648 6.67005C4.56034 7.46725 3.59122 8.54393 2.92186 9.89604L2.87043 9.99993L2.92186 10.1038C3.59122 11.4559 4.56034 12.5326 5.82648 13.3298C7.09358 14.1276 8.48652 14.5268 10 14.5268C11.5136 14.5268 12.9065 14.1276 14.1736 13.3298C15.4397 12.5326 16.4089 11.4559 17.0782 10.1038ZM12.3223 12.3222C11.6838 12.9607 10.9143 13.278 10 13.278C9.08582 13.278 8.31631 12.9607 7.67779 12.3222C7.03927 11.6837 6.72197 10.9142 6.72197 9.99993C6.72197 9.0857 7.03927 8.31619 7.67779 7.67767C8.31631 7.03915 9.08582 6.72185 10 6.72185C10.9143 6.72185 11.6838 7.03915 12.3223 7.67767C12.9608 8.31619 13.2781 9.0857 13.2781 9.99993C13.2781 10.9142 12.9608 11.6837 12.3223 12.3222ZM8.34178 11.6582C8.79595 12.1124 9.35328 12.3414 10 12.3414C10.6468 12.3414 11.2041 12.1124 11.6583 11.6582C12.1125 11.204 12.3415 10.6467 12.3415 9.99993C12.3415 9.35316 12.1125 8.79583 11.6583 8.34166C11.2041 7.8875 10.6468 7.65844 10 7.65844C9.35328 7.65844 8.79595 7.8875 8.34178 8.34166C7.88761 8.79583 7.65856 9.35316 7.65856 9.99993C7.65856 10.6467 7.88761 11.204 8.34178 11.6582ZM10 15.6195C8.14743 15.6195 6.46322 15.1033 4.94131 14.0697C3.44502 13.0534 2.35442 11.6987 1.66675 9.99993C2.35442 8.30117 3.44502 6.94641 4.94131 5.93018C6.46322 4.89655 8.14743 4.38037 10 4.38037C11.8527 4.38037 13.5369 4.89655 15.0588 5.93018C16.5551 6.94641 17.6457 8.30116 18.3333 9.99992C17.6457 11.6987 16.5551 13.0534 15.0588 14.0697C13.5369 15.1033 11.8527 15.6195 10 15.6195Z","fill":"#3E3E3E"})));
}

IcSeeComponent.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IcSeeComponent;

IcSeeComponent.default = IcSeeComponent;


/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcWhatsappComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icons/ic-search"},[React.createElement("rect",{"id":"background","x":"1.34729","y":"1.1665","width":"15.7832","height":"15.6667","stroke":"#3E3E3E","key":0}),React.createElement("path",{"id":"Vector","d":"M6.62631 12.2472L6.98868 12.4585C7.59405 12.8115 8.28206 13 9.00001 13C11.2092 13 13 11.2092 13 9C13 6.79086 11.2092 5 9.00001 5C6.79086 5 5 6.79086 5 9C5 9.71815 5.18861 10.4064 5.54184 11.0119L5.75303 11.3739L5.42628 12.5747L6.62631 12.2472ZM4.00209 14L4.67807 11.5157C4.24698 10.7768 4 9.91725 4 9C4 6.23857 6.23857 4 9.00001 4C11.7614 4 14 6.23857 14 9C14 11.7614 11.7614 14 9.00001 14C8.08306 14 7.22376 13.7532 6.48494 13.3223L4.00209 14ZM7.19567 6.65417C7.26261 6.64946 7.32977 6.64874 7.3968 6.65201C7.42388 6.65379 7.45083 6.65692 7.4778 6.66003C7.55743 6.66923 7.645 6.71773 7.67444 6.78447C7.8236 7.12268 7.96833 7.46282 8.10861 7.80481C8.13956 7.88031 8.12091 7.97817 8.06201 8.07285C8.03211 8.1214 7.98515 8.1895 7.93075 8.25915C7.8742 8.3315 7.7525 8.46455 7.7525 8.46455C7.7525 8.46455 7.7032 8.52365 7.72178 8.5972C7.72902 8.625 7.75211 8.6655 7.77305 8.69955C7.78464 8.7184 7.79541 8.73525 7.80239 8.7469C7.93035 8.96055 8.10236 9.17715 8.31246 9.3808C8.37266 9.43915 8.43106 9.4987 8.49386 9.554C8.72801 9.76045 8.99291 9.92915 9.279 10.0541L9.28155 10.0553C9.3238 10.0735 9.3455 10.0834 9.40735 10.1097C9.43855 10.1228 9.47045 10.1343 9.5032 10.1429C9.51505 10.146 9.5272 10.1477 9.5394 10.1486C9.62025 10.1535 9.667 10.1016 9.68695 10.0778C10.0487 9.6395 10.0818 9.6109 10.0843 9.6111V9.6119C10.1319 9.5618 10.2066 9.5444 10.2733 9.5485C10.3038 9.55035 10.3341 9.5562 10.3618 9.56885C10.6277 9.69015 11.0624 9.87935 11.0624 9.87935L11.3532 10.01C11.4019 10.0335 11.4463 10.0889 11.4485 10.1427C11.4498 10.1762 11.4534 10.2301 11.4414 10.3289C11.4258 10.4583 11.3864 10.614 11.3473 10.6957C11.3198 10.7529 11.2842 10.8037 11.2428 10.8467C11.1867 10.905 11.145 10.9404 11.0775 10.9907C11.0364 11.0213 11.0151 11.0357 11.0151 11.0357C10.9456 11.0795 10.9065 11.1014 10.8237 11.1454C10.695 11.214 10.5528 11.2534 10.4072 11.2609C10.3143 11.2656 10.2217 11.2724 10.129 11.2674C10.1249 11.2671 9.84485 11.2241 9.84485 11.2241C9.1339 11.0371 8.47641 10.6868 7.92468 10.201C7.81187 10.1017 7.70726 9.99425 7.60048 9.88795C7.15595 9.4454 6.81942 8.9682 6.61535 8.5168C6.51472 8.2942 6.451 8.0558 6.45 7.81049C6.44815 7.50703 6.5475 7.2116 6.73235 6.97093C6.76879 6.92349 6.80338 6.87427 6.86305 6.81793C6.92625 6.75826 6.96647 6.72622 7.00979 6.70406C7.06754 6.67451 7.13097 6.65871 7.19567 6.65417Z","fill":"#3E3E3E","key":1})]));
}

IcWhatsappComponent.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = IcWhatsappComponent;

IcWhatsappComponent.default = IcWhatsappComponent;


/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcXComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icons/ic-search"},[React.createElement("rect",{"id":"background","x":"1.1084","y":"1.1665","width":"15.7832","height":"15.6667","stroke":"#3E3E3E","key":0}),React.createElement("path",{"id":"Vector","d":"M12.0572 3.58301H13.7536L10.0474 7.81891L14.4074 13.583H10.9936L8.31973 10.0871L5.26026 13.583H3.56282L7.52693 9.05224L3.34436 3.58301H6.84487L9.26178 6.77839L12.0572 3.58301Z","fill":"#3E3E3E","key":1})]));
}

IcXComponent.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = IcXComponent;

IcXComponent.default = IcXComponent;


/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function CarLineComponent (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"Car","key":0},[React.createElement("path",{"id":"Vector","d":"M61.6093 60.6095C33.5367 60.1613 55.6075 69.9602 48.9859 60.6095C25.9168 28.0322 15 81.016 15 9.08203","stroke":"url(#paint0_linear_1633_10313)","strokeLinecap":"round","key":0}),React.createElement("path",{"id":"Vector_2","d":"M28.0977 14.7612C28.0977 7.30539 22.0535 1.26123 14.5977 1.26123C7.14181 1.26123 1.09766 7.30539 1.09766 14.7612C1.09766 22.2171 7.14181 28.2612 14.5977 28.2612C22.0535 28.2612 28.0977 22.2171 28.0977 14.7612Z","fill":"url(#paint1_linear_1633_10313)","key":1}),React.createElement("path",{"id":"Vector_3","fillRule":"evenodd","clipRule":"evenodd","d":"M20.6244 16.3917L20.711 16.4245C21.5864 16.764 22.164 17.5985 22.1683 18.5299V20.8373C22.1683 21.0646 21.9823 21.2488 21.753 21.2488H20.5403V22.6802C20.5403 22.9089 20.3533 23.0943 20.1225 23.0943H18.2602C18.1496 23.0943 18.0436 23.0506 17.9656 22.9728C17.8877 22.8951 17.8442 22.7898 17.8449 22.6802V21.2488H11.7025V22.6802C11.7025 22.9089 11.5155 23.0943 11.2847 23.0943H9.41731C9.30131 23.0973 9.18931 23.052 9.10851 22.9696C9.02771 22.8871 8.9854 22.7748 8.9918 22.66V21.2286H7.7893C7.5596 21.2287 7.3729 21.0448 7.3715 20.8171V18.5097C7.3766 17.577 7.9565 16.7421 8.8339 16.4043L8.92051 16.3715L8.5944 16.1569H7.7893C7.5586 16.1569 7.3715 15.9715 7.3715 15.7429C7.3715 15.5142 7.5586 15.3289 7.7893 15.3289H8.7192C8.802 15.3286 8.8828 15.3532 8.9511 15.3995L9.8937 16.0206L10.4185 14.4604C10.7038 13.5941 11.5243 13.0122 12.4439 13.024H14.4463V12.0142C14.3983 12.011 14.351 12.0071 14.3041 12.0032C14.202 11.9947 14.1018 11.9864 14.0005 11.9864C13.1189 11.9608 12.2441 11.8251 11.3968 11.5825C11.3233 11.5559 11.2416 11.5643 11.1752 11.6052C10.5077 12.2388 9.7307 12.2792 8.918 11.9864C8.5317 11.8371 8.15711 11.6599 7.79701 11.4562C7.69941 11.4097 7.6285 11.3217 7.6042 11.2171C7.58 11.1125 7.6049 11.0027 7.6722 10.9185C7.7343 10.822 7.79871 10.7277 7.86601 10.629C7.90081 10.578 7.93631 10.5259 7.97281 10.4717L7.25691 9.94146C7.02251 9.78246 6.9588 9.61336 7.0862 9.41636C7.2136 9.21946 7.4225 9.19426 7.6569 9.35076L8.39311 9.85566C8.43771 9.79046 8.4814 9.72596 8.5248 9.66206C8.6575 9.46646 8.7868 9.27586 8.923 9.08566L8.8689 9.04976C8.6121 8.87946 8.374 8.72156 8.1358 8.53286C8.0404 8.44826 7.9872 8.32646 7.9906 8.19956C8.0286 8.08046 8.11431 7.98186 8.22751 7.92696C8.33581 7.89506 8.4527 7.91076 8.5485 7.96986C8.7438 8.08816 8.932 8.21776 9.1289 8.35326C9.1966 8.39986 9.2654 8.44716 9.3358 8.49496L9.5905 8.12636C9.6436 8.00446 9.75501 7.91726 9.88691 7.89436C10.0189 7.87146 10.1536 7.91596 10.2453 8.01276C10.6933 8.31706 11.0811 8.70046 11.3892 9.14376C11.7169 9.59146 11.8253 10.1611 11.6847 10.6964L11.6337 10.8958C12.5438 11.1605 13.4877 11.294 14.4362 11.2922V11.0649C14.4377 10.8932 14.4365 10.721 14.4352 10.5488C14.4324 10.1464 14.4295 9.74336 14.4616 9.34576C14.6 7.63166 16.0918 6.33936 17.8245 6.43246C19.0628 6.50736 20.0346 7.51326 20.0563 8.74236C20.1462 9.84086 19.4759 10.861 18.4258 11.224C17.4344 11.62 16.3914 11.875 15.3278 11.9813C15.2667 11.9864 15.1648 12.0495 15.1648 12.0899V13.0442H17.0857C18.0099 13.0268 18.8371 13.6098 19.1238 14.4806L19.6486 16.0408L20.5887 15.4197C20.6572 15.3738 20.7379 15.3492 20.8206 15.349H21.7555C21.9863 15.349 22.1734 15.5344 22.1734 15.7631C22.1734 15.9917 21.9863 16.1771 21.7555 16.1771H20.9505L20.6244 16.3917ZM17.7023 7.13926C16.3403 7.13316 15.2215 8.20376 15.1801 9.55276C15.1738 9.97096 15.1762 10.3893 15.1787 10.809L15.1801 11.0624C15.1801 11.0934 15.1834 11.1243 15.1867 11.1546C15.1898 11.1836 15.1929 11.212 15.1929 11.2391C15.2102 11.2453 15.2281 11.2495 15.2464 11.2518C16.3176 11.1483 17.3652 10.8755 18.3494 10.4439C19.095 10.0915 19.4918 9.27156 19.3022 8.47476C19.149 7.71406 18.4849 7.15966 17.7023 7.13926ZM10.9714 10.5297C10.7829 11.0952 10.3141 11.5219 9.6644 11.4436C9.2427 11.3913 8.8384 11.2445 8.4823 11.0145C8.9918 10.2571 9.5014 9.49966 10.0109 8.75746C10.5689 9.11846 11.1777 9.90616 10.9714 10.5297ZM12.4439 13.8697C11.8845 13.8601 11.3842 14.2135 11.2108 14.7406L10.6886 16.273H18.8411L18.3315 14.7406C18.1581 14.2135 17.6579 13.8601 17.0985 13.8697H15.6539V13.9177C15.6539 14.1463 15.4669 14.3317 15.2361 14.3317H14.3062C14.1952 14.3324 14.0886 14.289 14.01 14.2112C13.9315 14.1334 13.8877 14.0277 13.8884 13.9177V13.8697H12.4439ZM10.8643 22.2687H9.8453V21.2589H10.8643V22.2687ZM18.6729 22.2687H19.7072L19.6919 21.2589H18.6729V22.2687ZM21.3351 20.4233H8.2071V18.5299C8.2071 17.7394 8.8538 17.0985 9.6516 17.0985H19.8906C20.6878 17.0999 21.3337 17.74 21.3351 18.5299V20.4233ZM18.5328 18.7622C18.5328 18.4067 18.8236 18.1185 19.1824 18.1185C19.5412 18.1185 19.8321 18.4067 19.8321 18.7622C19.8321 19.1177 19.5412 19.406 19.1824 19.406C18.8236 19.406 18.5328 19.1177 18.5328 18.7622ZM10.3497 18.1185C9.99091 18.1185 9.7001 18.4067 9.7001 18.7622C9.7001 19.1177 9.99091 19.406 10.3497 19.406C10.7085 19.406 10.9994 19.1177 10.9994 18.7622C10.9994 18.5915 10.9309 18.4277 10.8091 18.307C10.6873 18.1863 10.522 18.1185 10.3497 18.1185ZM13.142 18.3481H16.4004C16.6179 18.365 16.7856 18.5448 16.7856 18.7609C16.7856 18.977 16.6179 19.1568 16.4004 19.1737H13.142C12.9854 19.1858 12.8352 19.1099 12.7531 18.9772C12.6711 18.8445 12.6711 18.6774 12.7531 18.5446C12.8352 18.4119 12.9854 18.336 13.142 18.3481Z","fill":"white","key":2}),React.createElement("path",{"id":"Vector_4","d":"M28.0977 14.7612C28.0977 7.30539 22.0535 1.26123 14.5977 1.26123C7.14181 1.26123 1.09766 7.30539 1.09766 14.7612C1.09766 22.2171 7.14181 28.2612 14.5977 28.2612C22.0535 28.2612 28.0977 22.2171 28.0977 14.7612Z","stroke":"url(#paint2_linear_1633_10313)","key":3})]),React.createElement("defs",{"key":1},[React.createElement("linearGradient",{"id":"paint0_linear_1633_10313","x1":"-12.4398","y1":"-7.28007","x2":"61.6093","y2":"-7.28007","gradientUnits":"userSpaceOnUse","key":0},[React.createElement("stop",{"stopColor":"#006736","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#93C13E","key":1})]),React.createElement("linearGradient",{"id":"paint1_linear_1633_10313","x1":"45.0818","y1":"-7.48087","x2":"0.597657","y2":"-7.48087","gradientUnits":"userSpaceOnUse","key":1},[React.createElement("stop",{"stopColor":"#006736","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#93C13E","key":1})]),React.createElement("linearGradient",{"id":"paint2_linear_1633_10313","x1":"45.0818","y1":"-7.48087","x2":"0.597657","y2":"-7.48087","gradientUnits":"userSpaceOnUse","key":2},[React.createElement("stop",{"stopColor":"#006736","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#93C13E","key":1})])])]);
}

CarLineComponent.defaultProps = {"width":"63","height":"66","viewBox":"0 0 63 66","fill":"none"};

module.exports = CarLineComponent;

CarLineComponent.default = CarLineComponent;


/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function EnergyLineComponent (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"Energias Renovaveis","key":0},[React.createElement("path",{"id":"Vector","d":"M51.2991 14.5698C51.2991 7.11398 45.2549 1.06982 37.7991 1.06982C30.3432 1.06982 24.2991 7.11398 24.2991 14.5698C24.2991 22.0257 30.3432 28.0698 37.7991 28.0698C45.2549 28.0698 51.2991 22.0257 51.2991 14.5698Z","fill":"url(#paint0_linear_1633_10308)","key":0}),React.createElement("path",{"id":"Vector_2","d":"M24.5 16.9999C8.5 23.4999 3.5 14.4999 1.00012 31.0819","stroke":"url(#paint1_linear_1633_10308)","strokeLinecap":"round","key":1}),React.createElement("path",{"id":"Vector_3","d":"M51.2991 14.5698C51.2991 7.11398 45.2549 1.06982 37.7991 1.06982C30.3432 1.06982 24.2991 7.11398 24.2991 14.5698C24.2991 22.0257 30.3432 28.0698 37.7991 28.0698C45.2549 28.0698 51.2991 22.0257 51.2991 14.5698Z","stroke":"url(#paint2_linear_1633_10308)","key":2}),React.createElement("path",{"id":"Vector_4","fillRule":"evenodd","clipRule":"evenodd","d":"M31.636 19.3197L31.203 21.4864H37.216V19.3197H31.636ZM32.303 15.9864L31.869 18.1531H37.216V15.9864H32.303ZM38.382 19.3197V21.4864H44.396L43.962 19.3197H38.382ZM38.382 15.9864V18.1531H43.729L43.296 15.9864H38.382ZM31.337 14.8197L29.771 22.6531H45.828L44.261 14.8197H31.337ZM30.549 7.65308V6.48641H32.549V7.65308H30.549ZM32.071 11.1723L32.902 11.9886L34.319 10.5713L33.488 9.7551L32.071 11.1723ZM37.799 10.1531C36.712 10.1531 35.793 9.773 35.028 9.0076C34.322 8.30151 33.944 7.46485 33.889 6.48641H35.059C35.112 7.14062 35.377 7.70992 35.852 8.18402C36.385 8.71755 37.039 8.98641 37.799 8.98641C38.559 8.98641 39.213 8.71755 39.747 8.18402C40.221 7.70992 40.486 7.14062 40.539 6.48641H41.709C41.654 7.46485 41.276 8.30151 40.57 9.0076C39.805 9.773 38.886 10.1531 37.799 10.1531ZM37.216 13.4864V11.4864H38.382V13.4864H37.216ZM43.528 11.1541L42.696 11.986L41.297 10.5708L42.113 9.7556L43.528 11.1541ZM43.049 7.65308V6.48641H45.049V7.65308H43.049Z","fill":"white","key":3})]),React.createElement("defs",{"key":1},[React.createElement("linearGradient",{"id":"paint0_linear_1633_10308","x1":"68.2831","y1":"-7.67227","x2":"23.7991","y2":"-7.67227","gradientUnits":"userSpaceOnUse","key":0},[React.createElement("stop",{"stopColor":"#006736","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#93C13E","key":1})]),React.createElement("linearGradient",{"id":"paint1_linear_1633_10308","x1":"-27.259","y1":"36.4027","x2":"49","y2":"36.4027","gradientUnits":"userSpaceOnUse","key":1},[React.createElement("stop",{"stopColor":"#006736","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#93C13E","key":1})]),React.createElement("linearGradient",{"id":"paint2_linear_1633_10308","x1":"68.2831","y1":"-7.67227","x2":"23.7991","y2":"-7.67227","gradientUnits":"userSpaceOnUse","key":2},[React.createElement("stop",{"stopColor":"#006736","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#93C13E","key":1})])])]);
}

EnergyLineComponent.defaultProps = {"width":"52","height":"32","viewBox":"0 0 52 32","fill":"none"};

module.exports = EnergyLineComponent;

EnergyLineComponent.default = EnergyLineComponent;


/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function GasLineComponent (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"Gas","key":0},[React.createElement("path",{"id":"Vector","d":"M0.919922 55.1311C10.5469 54.8007 9.64892 42.3377 11.9199 35.4434C14.4949 27.6259 18.7359 20.7184 27.4199 18.7974","stroke":"url(#paint0_linear_1633_10440)","strokeLinecap":"round","key":0}),React.createElement("path",{"id":"Vector_2","d":"M52 14.5C52 7.04416 45.9558 1 38.5 1C31.0442 1 25 7.04416 25 14.5C25 21.9558 31.0442 28 38.5 28C45.9558 28 52 21.9558 52 14.5Z","fill":"url(#paint1_linear_1633_10440)","key":1}),React.createElement("path",{"id":"Vector_3","d":"M52.427 14.7456C52.427 7.28976 46.3828 1.24561 38.927 1.24561C31.4712 1.24561 25.427 7.28976 25.427 14.7456C25.427 22.2015 31.4712 28.2456 38.927 28.2456C46.3828 28.2456 52.427 22.2015 52.427 14.7456Z","stroke":"url(#paint2_linear_1633_10440)","key":2}),React.createElement("path",{"id":"Vector_4","fillRule":"evenodd","clipRule":"evenodd","d":"M42.3304 14.1092V11.9704C42.3304 11.3657 42.3304 10.761 42.3304 10.1564C42.3304 10.0279 42.3295 10.0277 42.1985 10.0275C42.0895 10.0274 41.9814 10.0286 41.8734 10.0275C41.8164 10.0269 41.7885 10.0501 41.7905 10.1079C41.7915 10.138 41.7905 10.168 41.7905 10.1982C41.7905 12.8127 41.7905 15.4273 41.7905 18.0419C41.7905 18.066 41.7925 18.0901 41.7905 18.114C41.7855 18.1789 41.8115 18.2071 41.8785 18.2048C41.9845 18.2012 42.0895 18.204 42.1955 18.2039C42.3295 18.2038 42.3304 18.2036 42.3304 18.0717V14.1092ZM35.0824 14.1235V12.4359C35.0824 11.6745 35.0824 10.9132 35.0824 10.1518C35.0824 10.0285 35.0814 10.0278 34.9554 10.0275C34.8494 10.0274 34.7445 10.0298 34.6395 10.0269C34.5715 10.0249 34.5384 10.0489 34.5414 10.1206C34.5454 10.2137 34.5425 10.3069 34.5425 10.4002V13.5866V16.71C34.5425 17.1732 34.5434 17.6366 34.5414 18.1C34.5404 18.1765 34.5624 18.2098 34.6434 18.2054C34.7454 18.1997 34.8485 18.204 34.9505 18.2039C35.0825 18.2038 35.0824 18.2036 35.0824 18.0685C35.0824 16.7536 35.0824 15.4385 35.0824 14.1235ZM37.5024 14.1244V10.5492C37.5024 10.4077 37.4995 10.2663 37.5045 10.1249C37.5065 10.0488 37.4764 10.0239 37.4034 10.0265C37.2894 10.0303 37.1745 10.031 37.0605 10.0263C36.9805 10.023 36.9435 10.0474 36.9505 10.1335C36.9625 10.2767 36.9685 10.4234 36.9625 10.5638C36.9504 10.8249 36.9534 11.0857 36.9534 11.3465C36.9504 13.5193 36.9514 15.6921 36.9514 17.865C36.9514 17.9417 36.9644 18.018 36.9514 18.0952C36.9354 18.184 36.9794 18.21 37.0634 18.2058C37.1654 18.2004 37.2675 18.2042 37.3705 18.204C37.5025 18.2038 37.5024 18.2038 37.5024 18.0698V14.1244ZM39.3714 14.1192V16.5294C39.3714 17.0499 39.3724 17.5705 39.3694 18.0909C39.3694 18.1752 39.3905 18.2118 39.4805 18.2056C39.5795 18.1987 39.6794 18.204 39.7784 18.204C39.9224 18.2039 39.9225 18.2039 39.9225 18.064V10.1836C39.9225 10.1564 39.9215 10.1293 39.9225 10.1023C39.9255 10.0477 39.8985 10.027 39.8465 10.0275C39.7355 10.0285 39.6235 10.0275 39.5125 10.0275C39.3715 10.0277 39.3714 10.0278 39.3714 10.1653V14.1192ZM32.6864 19.2806V20.3871C32.6864 20.6228 32.6864 20.6229 32.9254 20.6228C34.6994 20.6225 36.4745 20.6218 38.2475 20.6218C40.1845 20.622 42.1214 20.6225 44.0584 20.6226C44.1704 20.6228 44.1765 20.6168 44.1765 20.5057C44.1765 20.1325 44.1764 19.7593 44.1754 19.3861C44.1754 19.3678 44.1854 19.3456 44.1644 19.3281C43.9864 19.7716 43.6664 19.9895 43.1834 19.967C42.8594 19.952 42.5185 19.7134 42.4025 19.4099C42.3355 19.2371 42.3215 19.059 42.3315 18.8774C42.3355 18.8014 42.3085 18.7669 42.2285 18.7702C42.1105 18.7748 41.9935 18.7744 41.8765 18.7714C41.8065 18.7694 41.7795 18.803 41.7925 18.8644C41.8065 18.928 41.7945 18.9891 41.7905 19.0511C41.7785 19.2411 41.7395 19.4199 41.6205 19.5789C41.4145 19.8546 41.1464 19.9779 40.8024 19.9678C40.3854 19.9557 40.0165 19.6541 39.9375 19.2442C39.9125 19.1156 39.9244 18.9861 39.9234 18.8571C39.9234 18.7958 39.9035 18.7687 39.8405 18.7715C39.7625 18.7747 39.6835 18.7722 39.6055 18.7722C39.3715 18.7722 39.3635 18.7724 39.3725 19.0045C39.3945 19.5658 38.9174 19.9954 38.4084 19.9707C37.9034 19.9462 37.5044 19.565 37.5024 19.0594C37.5024 18.9871 37.5014 18.9149 37.5024 18.8427C37.5034 18.7931 37.4825 18.7718 37.4325 18.7722C37.2975 18.7732 37.1614 18.7736 37.0264 18.7719C36.9724 18.7712 36.9494 18.793 36.9514 18.8469C36.9534 18.9312 36.9535 19.0156 36.9505 19.0998C36.9415 19.3395 36.8505 19.5463 36.6785 19.7109C36.4015 19.9756 36.0655 20.0355 35.7135 19.9226C35.3575 19.8084 35.1525 19.5438 35.0925 19.1711C35.0755 19.066 35.0845 18.961 35.0835 18.8559C35.0825 18.8018 35.0684 18.7706 35.0074 18.7718C34.8774 18.774 34.7485 18.7735 34.6185 18.772C34.5645 18.7714 34.5425 18.7951 34.5425 18.8479C34.5415 18.9411 34.5405 19.034 34.5325 19.1273C34.4765 19.8138 33.7645 20.157 33.1725 19.8716C32.9225 19.7515 32.7704 19.544 32.6864 19.2806ZM38.4464 22.094H31.1904C31.1574 22.094 31.1244 22.092 31.0914 22.094C31.0244 22.0982 30.9994 22.0655 31.0004 22.0021C31.0014 21.8514 31.0004 21.701 31.0004 21.5505C31.0004 21.2857 30.9994 21.0209 31.0004 20.7559C31.0004 20.6232 31.0005 20.623 31.1375 20.6229C31.3575 20.6226 31.5764 20.6229 31.7964 20.6225C31.9174 20.6222 31.9175 20.6218 31.9175 20.5042C31.9175 19.7578 31.9264 19.0112 31.9144 18.2649C31.9084 17.8501 32.1935 17.4974 32.5835 17.4562C32.6505 17.4492 32.6734 17.424 32.6734 17.3538C32.6704 16.6043 32.6704 15.855 32.6714 15.1058C32.6724 13.4864 32.6795 11.8672 32.6705 10.248C32.6685 9.80277 32.6785 9.35777 32.6705 8.91257C32.6615 8.30957 33.2784 7.86446 33.8674 8.03936C34.2814 8.16216 34.5365 8.50497 34.5425 8.94947C34.5435 9.08497 34.5444 9.22047 34.5414 9.35577C34.5394 9.42667 34.5684 9.45226 34.6384 9.45026C34.7554 9.44706 34.8734 9.44666 34.9904 9.45026C35.0624 9.45256 35.0834 9.42246 35.0844 9.35406C35.0874 9.16156 35.0664 8.96856 35.0974 8.77716C35.1664 8.35806 35.4814 8.06217 35.9164 8.00727C36.3164 7.95687 36.7155 8.18157 36.8785 8.55357C36.9255 8.66147 36.9504 8.77657 36.9514 8.89547C36.9514 9.05217 36.9535 9.20857 36.9505 9.36507C36.9495 9.42757 36.9745 9.45126 37.0365 9.45016C37.1625 9.44786 37.2895 9.44736 37.4155 9.45026C37.4835 9.45186 37.5045 9.42347 37.5035 9.35857C37.5005 9.20217 37.5015 9.04556 37.5035 8.88906C37.5095 8.36046 38.0094 7.93467 38.5354 8.00867C39.0544 8.08147 39.3714 8.44697 39.3714 8.97237C39.3714 9.10177 39.3735 9.23126 39.3705 9.36066C39.3685 9.42756 39.3964 9.45166 39.4614 9.45016C39.5844 9.44746 39.7085 9.44656 39.8315 9.45056C39.9045 9.45296 39.9254 9.42186 39.9234 9.35356C39.9204 9.20016 39.9224 9.04666 39.9234 8.89326C39.9274 8.35396 40.4315 7.92736 40.9655 8.01036C41.4725 8.08926 41.7875 8.45526 41.7905 8.96936C41.7905 9.09566 41.7934 9.22206 41.7894 9.34856C41.7874 9.42066 41.8115 9.45336 41.8875 9.45056C42.0025 9.44636 42.1164 9.44636 42.2314 9.45056C42.3054 9.45326 42.3305 9.42667 42.3315 9.35157C42.3335 9.16227 42.3135 8.97216 42.3445 8.78376C42.4195 8.31476 42.8005 7.99887 43.2825 8.00317C43.7445 8.00717 44.1274 8.34126 44.1924 8.79896C44.2004 8.85227 44.1985 8.90707 44.1985 8.96117C44.1985 11.7393 44.1985 14.5173 44.1985 17.2953C44.1985 17.438 44.1995 17.438 44.3385 17.4643C44.6975 17.5319 44.9544 17.8428 44.9554 18.2174C44.9564 18.9758 44.9554 19.7343 44.9554 20.4929C44.9554 20.6226 44.9565 20.6228 45.0835 20.6228C45.3155 20.6229 45.5475 20.6225 45.7795 20.623C45.8975 20.6232 45.8985 20.6237 45.8985 20.7456C45.8985 21.155 45.8985 21.5644 45.8985 21.9736C45.8985 22.0912 45.8955 22.0939 45.7755 22.0939C44.8605 22.0942 43.9444 22.094 43.0284 22.094H38.4464ZM44.5725 13.9825C44.6115 13.9151 44.6595 13.8676 44.7065 13.8185C44.8945 13.6232 45.0924 13.4392 45.2704 13.2344C45.5594 12.9032 45.7384 12.5163 45.8864 12.1099C45.9834 11.8438 46.0984 11.5876 46.2744 11.3599C46.5494 11.0011 46.9225 10.8256 47.3595 10.7641C47.4455 10.752 47.5325 10.7441 47.6205 10.7466C47.6705 10.748 47.6804 10.7693 47.6474 10.8063C47.5984 10.86 47.5484 10.9122 47.4984 10.9641C47.2984 11.1719 47.0965 11.3783 46.8965 11.5873C46.7795 11.7101 46.7205 11.8645 46.6705 12.0235C46.5785 12.3159 46.4924 12.6103 46.3414 12.8809C46.0854 13.34 45.6984 13.6445 45.2184 13.8402C45.0594 13.905 44.8944 13.9512 44.7244 13.9785C44.6774 13.9859 44.6315 13.9964 44.5725 13.9825ZM44.6695 12.3815C44.7645 12.2923 44.8464 12.2144 44.9294 12.137C45.1864 11.8969 45.3864 11.6215 45.5024 11.2851C45.5814 11.0545 45.6814 10.8307 45.8654 10.659C46.0715 10.4664 46.3235 10.3906 46.6005 10.3845C46.6175 10.3841 46.6404 10.3798 46.6494 10.3969C46.6634 10.4211 46.6384 10.4348 46.6254 10.4487C46.5094 10.5673 46.3974 10.6893 46.2764 10.8019C46.1424 10.9266 46.0565 11.0751 46.0045 11.2497C45.9425 11.4574 45.8725 11.6636 45.7385 11.8383C45.4865 12.1648 45.1494 12.3422 44.7444 12.3991C44.7354 12.4004 44.7265 12.4002 44.7175 12.3991C44.7115 12.3985 44.7065 12.3953 44.6695 12.3815Z","fill":"white","key":3})]),React.createElement("defs",{"key":1},[React.createElement("linearGradient",{"id":"paint0_linear_1633_10440","x1":"43.0209","y1":"8.10206","x2":"0.919922","y2":"8.10206","gradientUnits":"userSpaceOnUse","key":0},[React.createElement("stop",{"stopColor":"#006736","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#93C13E","key":1})]),React.createElement("linearGradient",{"id":"paint1_linear_1633_10440","x1":"68.984","y1":"-7.7421","x2":"24.5","y2":"-7.7421","gradientUnits":"userSpaceOnUse","key":1},[React.createElement("stop",{"stopColor":"#006736","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#93C13E","key":1})]),React.createElement("linearGradient",{"id":"paint2_linear_1633_10440","x1":"69.411","y1":"-7.49649","x2":"24.927","y2":"-7.49649","gradientUnits":"userSpaceOnUse","key":2},[React.createElement("stop",{"stopColor":"#006736","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#93C13E","key":1})])])]);
}

GasLineComponent.defaultProps = {"width":"53","height":"56","viewBox":"0 0 53 56","fill":"none"};

module.exports = GasLineComponent;

GasLineComponent.default = GasLineComponent;


/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function HomeIllustrationComponent (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1649_7004)","key":0},[React.createElement("path",{"d":"M270.782 27.5665C270.782 -12.6519 201.979 13.0727 155.167 20.1258C107.976 27.2362 108.08 -0.0844404 41.7225 3.28312C0.786015 5.36061 -2.15627 23.6027 1.79476 37.5417C4.98313 48.7901 9.29912 60.0575 11.1967 71.594C13.3898 84.9264 18.7785 101.196 32.0014 103.542C71.4089 110.531 154.39 119.715 183.724 119.207C212.89 118.703 249.029 114.356 274.404 95.6845C299.733 77.0467 263.329 55.0212 270.782 27.5665Z","fill":"white","fillOpacity":"0.2","key":0}),React.createElement("path",{"d":"M270.782 27.5665C270.782 -12.6519 201.979 13.0727 155.167 20.1258C107.976 27.2362 108.08 -0.0844404 41.7225 3.28312C0.786015 5.36061 -2.15627 23.6027 1.79476 37.5417C4.98313 48.7901 9.29912 60.0575 11.1967 71.594C13.3898 84.9264 18.7785 101.196 32.0014 103.542C71.4089 110.531 154.39 119.715 183.724 119.207C212.89 118.703 249.029 114.356 274.404 95.6845C299.733 77.0467 263.329 55.0212 270.782 27.5665Z","fill":"#93C13E","fillOpacity":"0.2","key":1}),React.createElement("path",{"d":"M119.103 80.4074C123.766 80.7538 130.36 56.5046 132.917 39.0735C135.017 24.7575 134.954 11.229 132.319 10.7459C130.303 10.3758 127.521 17.7855 125.845 17.2506C123.599 16.5336 128.026 3.05054 124.164 0.627693C121.785 -0.864998 116.54 2.01774 113.405 5.97128C107.748 13.1046 109.967 22.4491 113.157 44.9199C117.245 73.7157 116.703 80.2293 119.103 80.4074Z","fill":"url(#paint0_linear_1649_7004)","key":2}),React.createElement("g",{"style":{"mixBlendMode":"soft-light"},"opacity":"0.3","key":3},React.createElement("path",{"d":"M122.933 64.4028C125.185 57.8655 127.87 54.6616 127.304 48.8689C126.809 43.8091 124.476 43.3378 123.84 37.4396C123.12 30.7593 125.938 29.7369 125.15 24.3839C124.055 16.9515 118.203 16.0796 117.434 9.56654C117.192 7.50836 117.439 4.73368 119.253 1.16504C117.197 2.18106 115.021 3.93281 113.404 5.97076C107.747 13.1041 109.966 22.4486 113.156 44.9194C117.244 73.7152 116.703 80.2288 119.103 80.4069C119.467 80.434 119.844 80.3107 120.23 80.0516C120.374 73.392 121.622 68.2088 122.933 64.4028Z","fill":"white"})),React.createElement("path",{"d":"M117.816 90.8478C127.182 71.3007 117.988 51.0406 117.659 39.7549C116.921 14.3629 111.137 9.10022 108.275 7.21523C104.463 4.70258 98.2557 3.19114 94.8905 6.11286C88.5944 11.5798 95.0282 30.1494 91.7385 31.5073C90.036 32.21 88.0566 27.3431 85.3414 27.8864C81.6276 28.629 79.9516 38.8065 79.6546 41.3428C77.357 60.9471 109.079 84.5687 117.816 90.8478Z","fill":"url(#paint1_linear_1649_7004)","key":4}),React.createElement("g",{"style":{"mixBlendMode":"soft-light"},"opacity":"0.5","key":5},React.createElement("path",{"d":"M108.535 66.2337C105.529 57.8099 103.463 56.8206 102.985 50.8113C102.105 39.7294 108.548 35.7793 106.304 27.3768C104.704 21.3863 100.949 21.5985 97.9138 14.2249C96.6785 11.2237 96.0799 8.22204 95.8515 5.43799C95.5113 5.62994 95.1887 5.85298 94.8897 6.11254C88.5936 11.5795 95.0275 30.149 91.7377 31.507C90.0353 32.2097 88.0558 27.3428 85.3406 27.8856C81.6273 28.6282 79.9508 38.8057 79.6538 41.342C77.4791 59.9097 106.254 83.3791 114.99 89.6583C115.077 89.2936 112.765 86.7563 112.849 86.3941C112.055 77.5593 110.193 70.8785 108.535 66.2337Z","fill":"white"})),React.createElement("path",{"d":"M190.782 107.283V94.7295L86.6091 94.5854V107.032L109.227 112.412L190.782 107.283Z","fill":"white","key":6}),React.createElement("path",{"d":"M190.55 65.9956V67.5648L197.487 67.6289L195.952 66.0168L190.55 65.9956Z","fill":"#D8DEE8","key":7}),React.createElement("path",{"d":"M109.003 99.7281L86.6091 94.8785V66.0312L109.003 66.249V99.7281Z","fill":"url(#paint2_linear_1649_7004)","key":8}),React.createElement("path",{"d":"M195.952 65.938L190.782 66.0386V95.0294L138.88 98.0118L117.38 99.2473L109.003 99.7285V66.2493L145.038 55.915L166.519 35.0396L195.952 65.938ZM181.225 92.4792V63.7574L149.59 63.703V94.1145L181.225 92.4792Z","fill":"url(#paint3_linear_1649_7004)","key":9}),React.createElement("g",{"opacity":"0.2","key":10},React.createElement("path",{"d":"M196.47 66.0501L167.341 35.3233L166.448 34.3813L165.562 35.238L144.206 55.9032L108.439 66.0441L103.534 67.4347V68.1951H109.003V67.7036L144.914 57.5203L166.519 36.6473L194.427 66.0501H196.47Z","fill":"#D8DEE8"})),React.createElement("path",{"d":"M166.448 32.7739L167.341 33.7154L196.823 64.7831L197.584 65.584V67.62L197.487 67.6289L195.961 66.0251L166.519 35.0394L144.914 55.9128L109.312 66.5373L103.534 68.1509V65.8273L108.439 64.4367L144.206 54.2953L165.562 33.6306L166.448 32.7739Z","fill":"white","key":11}),React.createElement("path",{"d":"M180.906 64.1561V92.0953L149.948 93.6728V64.1265L180.906 64.1561ZM179.263 89.4326V65.9779L171.822 65.9957V89.7736L179.263 89.4326ZM169.801 89.8664V66.0006L162.097 66.0193V90.2202L169.801 89.8664ZM160.003 90.3159V66.0243L152.02 66.0435V90.682L160.003 90.3159Z","fill":"white","key":12}),React.createElement("path",{"d":"M149.45 94.2007V63.6245L181.404 63.6556V92.5723L149.45 94.2007ZM150.446 64.6292V93.1462L180.408 91.6195V64.6583L150.446 64.6292ZM151.522 91.208V65.544L160.501 65.5223V90.7959L151.522 91.208ZM152.518 66.5448V90.1584L159.505 89.8376V66.528L152.518 66.5448ZM161.599 90.7456V65.5199L170.299 65.4991V90.3469L161.599 90.7456ZM162.596 66.5206V89.696L169.303 89.3881V66.5043L162.596 66.5206ZM171.324 90.2995V65.4962L179.761 65.4759V89.9126L171.324 90.2995ZM172.321 66.4969V89.2499L178.764 88.9544V66.4816L172.321 66.4969Z","fill":"white","key":13}),React.createElement("path",{"d":"M166.448 32.7739L165.563 33.6311L144.206 54.2953L118.309 55.6602L137.788 37.5777L138.601 36.8252L166.448 32.7739Z","fill":"url(#paint4_linear_1649_7004)","key":14}),React.createElement("path",{"d":"M125.547 80.9956L136.513 80.853L136.506 105.272L125.547 105.899V80.9956Z","fill":"#F4F7FA","key":15}),React.createElement("path",{"d":"M123.523 104.711V81.8751L135.706 81.729V103.78L123.523 104.711Z","fill":"#93C13E","key":16}),React.createElement("path",{"d":"M117.38 106.533V78.0907L138.842 77.8721V105.139L136.506 105.272V80.9033L125.547 81.0716V106.066L117.38 106.533Z","fill":"white","key":17}),React.createElement("path",{"d":"M144.206 54.2949L108.438 64.4368L103.533 65.8264L81.7297 65.6665L86.1048 64.4699L118.309 55.6598L144.206 54.2949Z","fill":"url(#paint5_linear_1649_7004)","key":18}),React.createElement("path",{"d":"M103.534 68.151L81.7297 67.6665V65.667L103.534 65.8274V68.151Z","fill":"white","key":19}),React.createElement("path",{"d":"M179.119 66.1572V89.2606L171.97 89.5863V66.177L179.119 66.1572Z","fill":"url(#paint6_linear_1649_7004)","key":20}),React.createElement("path",{"d":"M159.849 66.21V90.1379L152.178 90.4873V66.2312L159.849 66.21Z","fill":"url(#paint7_linear_1649_7004)","key":21}),React.createElement("path",{"d":"M169.653 66.1836V89.6921L162.25 90.0291V66.2038L169.653 66.1836Z","fill":"url(#paint8_linear_1649_7004)","key":22}),React.createElement("path",{"d":"M117.38 106.507L138.842 104.988L143.855 110.637L117.38 111.855V106.507Z","fill":"#E8E8E8","key":23}),React.createElement("path",{"d":"M162.651 35.1986C162.651 35.4325 162.463 35.622 162.23 35.622C161.998 35.622 161.81 35.4325 161.81 35.1986V33.6739C161.81 33.44 161.998 33.2505 162.23 33.2505C162.463 33.2505 162.651 33.44 162.651 33.6739V35.1986Z","fill":"url(#paint9_linear_1649_7004)","key":24}),React.createElement("path",{"d":"M154.235 43.5009C154.235 43.7348 154.047 43.9243 153.814 43.9243C153.582 43.9243 153.394 43.7348 153.394 43.5009V41.9761C153.394 41.7422 153.582 41.5527 153.814 41.5527C154.047 41.5527 154.235 41.7422 154.235 41.9761V43.5009Z","fill":"url(#paint10_linear_1649_7004)","key":25}),React.createElement("path",{"d":"M133.027 56.9993C133.027 57.1706 132.839 57.3092 132.606 57.3092C132.374 57.3092 132.186 57.1706 132.186 56.9993V55.8826C132.186 55.7114 132.374 55.5728 132.606 55.5728C132.839 55.5728 133.027 55.7114 133.027 55.8826V56.9993Z","fill":"url(#paint11_linear_1649_7004)","key":26}),React.createElement("path",{"d":"M119.056 60.9516C119.056 61.1855 118.868 61.3749 118.635 61.3749C118.403 61.3749 118.215 61.1855 118.215 60.9516V59.4268C118.215 59.1929 118.403 59.0034 118.635 59.0034C118.868 59.0034 119.056 59.1929 119.056 59.4268V60.9516Z","fill":"url(#paint12_linear_1649_7004)","key":27}),React.createElement("path",{"d":"M144.977 52.8192C144.977 53.0531 144.789 53.2426 144.557 53.2426C144.324 53.2426 144.136 53.0531 144.136 52.8192V51.2945C144.136 51.0606 144.324 50.8711 144.557 50.8711C144.789 50.8711 144.977 51.0606 144.977 51.2945V52.8192Z","fill":"url(#paint13_linear_1649_7004)","key":28}),React.createElement("path",{"d":"M120.571 54.3441C120.571 54.578 120.383 54.7675 120.151 54.7675C119.918 54.7675 119.73 54.578 119.73 54.3441V52.8194C119.73 52.5855 119.918 52.396 120.151 52.396C120.383 52.396 120.571 52.5855 120.571 52.8194V54.3441Z","fill":"url(#paint14_linear_1649_7004)","key":29}),React.createElement("path",{"d":"M137.161 55.3525L113.767 55.4443C113.452 55.4453 112.793 55.5524 112.333 55.6822L82.262 63.9825C81.8939 64.0866 81.7047 64.2712 81.9096 64.51L100.79 65.2462C101.236 65.2635 101.676 65.2127 102.106 65.0962C106.912 63.797 137.024 55.8159 137.024 55.8159C137.572 55.6738 137.536 55.3511 137.161 55.3525Z","fill":"url(#paint15_linear_1649_7004)","key":30}),React.createElement("path",{"d":"M137.02 55.3569L112.913 55.4477C112.6 55.4487 111.976 55.5553 111.519 55.6846L82.2621 63.9825C81.896 64.0866 81.7999 64.1769 82.0469 64.1848L100.908 64.7927C101.196 64.8021 101.806 64.7203 102.234 64.6088L136.747 55.6111C137.291 55.469 137.393 55.3555 137.02 55.3569Z","fill":"url(#paint16_linear_1649_7004)","key":31}),React.createElement("path",{"d":"M114.205 56.0287L110.876 56.9603C110.535 57.0556 110.108 57.1321 109.877 57.1316L107.673 57.1261C107.447 57.1256 107.503 57.0492 107.836 56.9549L111.092 56.0341C111.435 55.9374 111.931 55.8585 112.164 55.858L114.441 55.853C114.68 55.8525 114.555 55.931 114.205 56.0287Z","fill":"url(#paint17_linear_1649_7004)","key":32}),React.createElement("path",{"d":"M118.071 56.0219L114.649 56.9664C114.299 57.0631 113.774 57.1405 113.537 57.1401L111.272 57.1346C111.039 57.1341 111.182 57.0567 111.524 56.9609L114.869 56.0273C115.221 55.9291 115.644 55.8497 115.885 55.8487L118.225 55.8433C118.47 55.8428 118.431 55.9222 118.071 56.0219Z","fill":"url(#paint18_linear_1649_7004)","key":33}),React.createElement("path",{"d":"M122.117 55.835L119.71 55.8404C119.463 55.8409 118.944 55.9223 118.584 56.0215L115.15 56.9679C114.799 57.0646 114.733 57.1436 114.972 57.1441L117.299 57.15C117.542 57.1505 118.001 57.072 118.36 56.9738L121.874 56.0161C122.243 55.9154 122.368 55.8345 122.117 55.835Z","fill":"url(#paint19_linear_1649_7004)","key":34}),React.createElement("path",{"d":"M126.118 55.8257L123.642 55.8311C123.388 55.8316 122.947 55.914 122.576 56.0147L119.046 56.9744C118.685 57.0726 118.528 57.1521 118.774 57.1531L121.167 57.159C121.417 57.1595 121.979 57.08 122.348 56.9809L125.963 56.0093C126.342 55.9071 126.377 55.8252 126.118 55.8257Z","fill":"url(#paint20_linear_1649_7004)","key":35}),React.createElement("path",{"d":"M130.236 55.8159L127.688 55.8218C127.427 55.8223 126.886 55.9062 126.505 56.0084L122.877 56.9819C122.506 57.0816 122.43 57.1625 122.683 57.163L125.144 57.169C125.401 57.1695 125.893 57.0885 126.272 56.9879L129.987 56.0024C130.377 55.8988 130.502 55.8154 130.236 55.8159Z","fill":"url(#paint21_linear_1649_7004)","key":36}),React.createElement("path",{"d":"M134.476 55.8066L131.853 55.8126C131.583 55.8131 131.124 55.8979 130.732 56.0016L126.999 56.9895C126.617 57.0901 126.445 57.1725 126.705 57.173L129.238 57.1794C129.503 57.1799 130.105 57.098 130.496 56.9959L134.32 55.9956C134.721 55.8905 134.751 55.8061 134.476 55.8066Z","fill":"url(#paint22_linear_1649_7004)","key":37}),React.createElement("path",{"d":"M108.834 57.5234L105.628 58.4245C105.299 58.5163 104.887 58.5913 104.665 58.5893L102.544 58.573C102.326 58.571 102.381 58.497 102.702 58.4057L105.839 57.5111C106.168 57.4178 106.646 57.3359 106.871 57.3364L109.062 57.3433C109.291 57.3443 109.171 57.4291 108.834 57.5234Z","fill":"url(#paint23_linear_1649_7004)","key":38}),React.createElement("path",{"d":"M112.552 57.5459L109.258 58.4553C108.921 58.5485 108.415 58.6216 108.187 58.6196L106.009 58.6018C105.785 58.5999 105.922 58.5249 106.252 58.4326L109.474 57.5335C109.812 57.4393 110.219 57.3633 110.451 57.3638L112.701 57.3712C112.937 57.3722 112.898 57.4501 112.552 57.5459Z","fill":"url(#paint24_linear_1649_7004)","key":39}),React.createElement("path",{"d":"M116.439 57.3839L114.126 57.376C113.889 57.375 113.39 57.452 113.044 57.5477L109.738 58.4586C109.401 58.5519 109.337 58.6289 109.566 58.6308L111.804 58.6491C112.038 58.6511 112.479 58.5761 112.825 58.4818L116.205 57.5605C116.559 57.4638 116.681 57.3849 116.439 57.3839Z","fill":"url(#paint25_linear_1649_7004)","key":40}),React.createElement("path",{"d":"M120.284 57.3966L117.906 57.3887C117.661 57.3877 117.237 57.4662 116.881 57.5629L113.484 58.4861C113.137 58.5804 112.986 58.6578 113.223 58.6598L115.522 58.6786C115.762 58.6805 116.304 58.6055 116.658 58.5098L120.134 57.5757C120.498 57.4775 120.532 57.3976 120.284 57.3966Z","fill":"url(#paint26_linear_1649_7004)","key":41}),React.createElement("path",{"d":"M124.237 57.4098L121.791 57.4014C121.54 57.4004 121.02 57.4798 120.654 57.578L117.166 58.5141C116.81 58.6098 116.736 58.6888 116.979 58.6908L119.343 58.71C119.59 58.712 120.063 58.635 120.428 58.5383L123.997 57.5914C124.372 57.4922 124.492 57.4107 124.237 57.4098Z","fill":"url(#paint27_linear_1649_7004)","key":42}),React.createElement("path",{"d":"M128.304 57.4239L125.787 57.4155C125.53 57.4145 125.088 57.495 124.711 57.5947L121.124 58.5436C120.757 58.6408 120.592 58.7202 120.841 58.7222L123.273 58.7419C123.527 58.7439 124.106 58.6669 124.481 58.5687L128.153 57.6085C128.538 57.5078 128.567 57.4249 128.304 57.4239Z","fill":"url(#paint28_linear_1649_7004)","key":43}),React.createElement("path",{"d":"M103.66 58.9781L100.57 59.8426C100.253 59.9314 99.8569 60.0005 99.6432 59.9975L97.6 59.9694C97.3897 59.9665 97.4427 59.8934 97.753 59.8056L100.777 58.9504C101.095 58.8606 101.555 58.7896 101.772 58.7915L103.881 58.8103C104.102 58.8123 103.985 58.8873 103.66 58.9781Z","fill":"url(#paint29_linear_1649_7004)","key":44}),React.createElement("path",{"d":"M107.237 59.0128L104.065 59.8886C103.74 59.9785 103.253 60.0475 103.033 60.0446L100.936 60.016C100.721 60.013 100.853 59.94 101.171 59.8511L104.275 58.9846C104.601 58.8938 104.993 58.8213 105.216 58.8233L107.381 58.8425C107.608 58.8445 107.571 58.9205 107.237 59.0128Z","fill":"url(#paint30_linear_1649_7004)","key":45}),React.createElement("path",{"d":"M110.752 59.047L107.497 59.9337C107.164 60.0245 106.74 60.0956 106.515 60.0926L104.361 60.063C104.14 60.06 104.201 59.9845 104.528 59.8947L107.712 59.0174C108.046 58.9251 108.525 58.8526 108.753 58.8545L110.978 58.8743C111.211 58.8762 111.094 58.9537 110.752 59.047Z","fill":"url(#paint31_linear_1649_7004)","key":46}),React.createElement("path",{"d":"M114.673 58.9075L112.387 58.8868C112.153 58.8848 111.744 58.9593 111.401 59.0526L108.131 59.9418C107.797 60.0326 107.652 60.1081 107.879 60.111L110.09 60.1416C110.321 60.1446 110.842 60.074 111.183 59.9817L114.528 59.0827C114.879 58.9884 114.912 58.9095 114.673 58.9075Z","fill":"url(#paint32_linear_1649_7004)","key":47}),React.createElement("path",{"d":"M118.471 58.9417L116.121 58.9204C115.88 58.9185 115.38 58.993 115.028 59.0877L111.672 59.9883C111.329 60.0805 111.259 60.1575 111.492 60.161L113.764 60.1921C114.002 60.1955 114.457 60.1225 114.808 60.0292L118.24 59.1188C118.601 59.0231 118.717 58.9441 118.471 58.9417Z","fill":"url(#paint33_linear_1649_7004)","key":48}),React.createElement("path",{"d":"M122.377 58.9768L119.96 58.9551C119.712 58.9527 119.288 59.0296 118.926 59.1254L115.477 60.0383C115.124 60.1315 114.965 60.2085 115.205 60.212L117.541 60.244C117.785 60.2475 118.341 60.1749 118.702 60.0802L122.232 59.157C122.602 59.0602 122.629 58.9788 122.377 58.9768Z","fill":"url(#paint34_linear_1649_7004)","key":49}),React.createElement("path",{"d":"M98.6735 60.3737L95.6936 61.2076C95.3882 61.293 95.0059 61.3591 94.7995 61.3552L92.8303 61.3172C92.6279 61.3132 92.6789 61.2412 92.9784 61.1568L95.8966 60.3318C96.2029 60.2449 96.6466 60.1778 96.8554 60.1808L98.8868 60.2104C99.0995 60.2133 98.9863 60.2864 98.6735 60.3737Z","fill":"url(#paint35_linear_1649_7004)","key":50}),React.createElement("path",{"d":"M102.118 60.426L99.0597 61.2703C98.7465 61.3566 98.2773 61.4223 98.0661 61.4183L96.046 61.3793C95.8381 61.3754 95.9656 61.3038 96.2724 61.2185L99.2661 60.3831C99.5803 60.2952 99.9582 60.2261 100.172 60.2291L102.257 60.2597C102.475 60.2627 102.439 60.3372 102.118 60.426Z","fill":"url(#paint36_linear_1649_7004)","key":51}),React.createElement("path",{"d":"M105.501 60.4783L102.365 61.3329C102.044 61.4203 101.636 61.4879 101.419 61.4839L99.3452 61.444C99.132 61.44 99.1913 61.3665 99.5055 61.2796L102.574 60.4339C102.897 60.3451 103.357 60.276 103.578 60.2794L105.718 60.3105C105.942 60.314 105.83 60.3885 105.501 60.4783Z","fill":"url(#paint37_linear_1649_7004)","key":52}),React.createElement("path",{"d":"M109.133 60.533L105.913 61.3985C105.583 61.4874 105.083 61.554 104.86 61.5495L102.732 61.5081C102.513 61.5036 102.653 61.4306 102.976 61.3433L106.126 60.4866C106.456 60.3968 106.848 60.3258 107.075 60.3292L109.273 60.3613C109.504 60.3648 109.471 60.4422 109.133 60.533Z","fill":"url(#paint38_linear_1649_7004)","key":53}),React.createElement("path",{"d":"M112.702 60.5872L109.398 61.4636C109.06 61.5534 108.624 61.6225 108.395 61.6181L106.209 61.5756C105.984 61.5712 106.052 61.4957 106.383 61.4069L109.614 60.5399C109.954 60.4486 110.434 60.378 110.666 60.3815L112.925 60.4145C113.162 60.418 113.05 60.495 112.702 60.5872Z","fill":"url(#paint39_linear_1649_7004)","key":54}),React.createElement("path",{"d":"M116.678 60.4702L114.356 60.4362C114.117 60.4327 113.709 60.5057 113.361 60.598L110.041 61.4763C109.702 61.5662 109.549 61.6412 109.779 61.6456L112.025 61.689C112.26 61.6935 112.795 61.6249 113.142 61.5341L116.537 60.6459C116.894 60.5526 116.92 60.4737 116.678 60.4702Z","fill":"url(#paint40_linear_1649_7004)","key":55}),React.createElement("path",{"d":"M93.8642 61.7191L90.9882 62.5234C90.6936 62.6058 90.3245 62.669 90.1259 62.664L88.2269 62.6166C88.0313 62.6117 88.0813 62.5412 88.37 62.4597L91.1867 61.6633C91.4823 61.5794 91.9103 61.5158 92.1117 61.5197L94.0696 61.5592C94.2745 61.5631 94.1662 61.6342 93.8642 61.7191Z","fill":"url(#paint41_linear_1649_7004)","key":56}),React.createElement("path",{"d":"M97.1828 61.788L94.2333 62.6021C93.9308 62.6855 93.4788 62.7477 93.2749 62.7423L91.3273 62.6934C91.1269 62.6885 91.2504 62.6189 91.5465 62.5365L94.4347 61.7302C94.7382 61.6453 95.1024 61.5797 95.3088 61.5837L97.3176 61.6241C97.5279 61.6286 97.4926 61.7026 97.1828 61.788Z","fill":"url(#paint42_linear_1649_7004)","key":57}),React.createElement("path",{"d":"M100.441 61.8564L97.4182 62.6804C97.1084 62.7648 96.7148 62.8295 96.506 62.824L94.5084 62.7742C94.303 62.7693 94.3604 62.6972 94.6638 62.6133L97.6231 61.7976C97.9339 61.7118 98.378 61.6467 98.5903 61.6511L100.652 61.693C100.867 61.6975 100.759 61.77 100.441 61.8564Z","fill":"url(#paint43_linear_1649_7004)","key":58}),React.createElement("path",{"d":"M103.937 61.9292L100.834 62.7631C100.516 62.8485 100.035 62.9116 99.8201 62.9062L97.7701 62.8549C97.5593 62.8495 97.6941 62.7784 98.0054 62.694L101.042 61.8685C101.361 61.7816 101.739 61.714 101.956 61.7185L104.073 61.7614C104.294 61.7658 104.263 61.8413 103.937 61.9292Z","fill":"url(#paint44_linear_1649_7004)","key":59}),React.createElement("path",{"d":"M107.372 62.0015L104.189 62.8458C103.863 62.9322 103.443 62.9978 103.223 62.9924L101.118 62.9396C100.902 62.9341 100.968 62.8606 101.287 62.7747L104.401 61.9393C104.728 61.8515 105.19 61.7844 105.413 61.7893L107.586 61.8332C107.813 61.8377 107.706 61.9127 107.372 62.0015Z","fill":"url(#paint45_linear_1649_7004)","key":60}),React.createElement("path",{"d":"M111.06 62.0782L107.791 62.9328C107.775 62.9373 107.729 62.9407 107.71 62.9447C107.382 63.0261 106.932 63.0843 106.717 63.0794L104.556 63.0251C104.334 63.0197 104.482 62.9466 104.809 62.8603L108.006 62.0145C108.037 62.0066 108.034 61.9982 108.068 61.9903C108.389 61.9133 108.755 61.8566 108.964 61.8605L111.196 61.9059C111.43 61.9109 111.404 61.9884 111.06 62.0782Z","fill":"url(#paint46_linear_1649_7004)","key":61}),React.createElement("path",{"d":"M89.222 63.0181L86.445 63.7948C86.1602 63.8742 85.8038 63.9349 85.6121 63.929L83.7798 63.8728C83.591 63.8668 83.6396 63.7978 83.9185 63.7193L86.6396 62.9495C86.9254 62.8686 87.3381 62.8079 87.5328 62.8133L89.4215 62.8622C89.6191 62.8671 89.5136 62.9367 89.222 63.0181Z","fill":"url(#paint47_linear_1649_7004)","key":62}),React.createElement("path",{"d":"M92.4227 63.1026L89.5756 63.8887C89.284 63.9691 88.8472 64.0278 88.6506 64.0219L86.7722 63.9642C86.579 63.9583 86.6982 63.8907 86.984 63.8107L89.7727 63.0321C90.0654 62.9501 90.4168 62.887 90.6163 62.8924L92.5531 62.9427C92.7556 62.9482 92.7218 63.0202 92.4227 63.1026Z","fill":"url(#paint48_linear_1649_7004)","key":63}),React.createElement("path",{"d":"M95.5623 63.1857L92.6456 63.9806C92.3466 64.062 91.9671 64.1232 91.7657 64.1173L89.8397 64.0581C89.6416 64.0522 89.697 63.9816 89.9902 63.9007L92.8466 63.1136C93.1466 63.0307 93.575 62.969 93.7794 62.9745L95.7657 63.0258C95.9736 63.0312 95.8686 63.1023 95.5623 63.1857Z","fill":"url(#paint49_linear_1649_7004)","key":64}),React.createElement("path",{"d":"M98.9303 63.2755L95.9382 64.0799C95.6313 64.1623 95.1671 64.222 94.9602 64.2156L92.9847 64.1549C92.7813 64.1485 92.9117 64.0794 93.2122 63.998L96.1416 63.2015C96.4494 63.1176 96.8132 63.053 97.023 63.0584L99.0612 63.1112C99.2745 63.1166 99.2446 63.1907 98.9303 63.2755Z","fill":"url(#paint50_linear_1649_7004)","key":65}),React.createElement("path",{"d":"M102.237 63.3634L99.1697 64.1771C98.8555 64.2605 98.4506 64.3232 98.2384 64.3163L96.2114 64.2541C96.0031 64.2477 96.0668 64.1757 96.3741 64.0933L99.3761 63.288C99.6913 63.2036 100.136 63.1399 100.352 63.1453L102.444 63.1996C102.663 63.205 102.559 63.2786 102.236 63.3639L102.237 63.3634Z","fill":"url(#paint51_linear_1649_7004)","key":66}),React.createElement("path",{"d":"M105.786 63.4583L102.637 64.2818C102.315 64.3662 101.82 64.4269 101.602 64.4205L99.522 64.3569C99.3083 64.3504 99.4505 64.2794 99.7662 64.196L102.848 63.3808C103.171 63.2949 103.549 63.2288 103.769 63.2347L105.918 63.2905C106.143 63.2964 106.117 63.3724 105.787 63.4593L105.786 63.4583Z","fill":"url(#paint52_linear_1649_7004)","key":67}),React.createElement("path",{"style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M111.525 56.961L114.551 56.1162C114.312 56.3674 113.774 56.7005 112.768 57.1382L111.273 57.1342C111.04 57.1337 111.182 57.0567 111.525 56.961Z","fill":"url(#paint53_linear_1649_7004)","key":68}),React.createElement("path",{"style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M112.218 57.3541C111.444 57.6511 110.455 58.035 109.209 58.4471C108.871 58.5403 108.415 58.6178 108.187 58.6158L106.01 58.6C105.785 58.5981 105.923 58.524 106.253 58.4318L109.474 57.5253C109.813 57.4311 110.22 57.3477 110.451 57.3481L112.218 57.3541Z","fill":"url(#paint54_linear_1649_7004)","key":69}),React.createElement("path",{"style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M104.527 59.8944L107.353 59.1157C106.454 59.4981 105.873 59.813 105.589 60.0794L104.362 60.0627C104.14 60.0597 104.201 59.9842 104.527 59.8944Z","fill":"url(#paint55_linear_1649_7004)","key":70}),React.createElement("path",{"style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M105.403 60.3051C105.359 60.3836 105.407 60.4586 105.319 60.5271L102.365 61.332C102.044 61.4193 101.636 61.4869 101.419 61.483L99.3452 61.443C99.132 61.439 99.1913 61.3655 99.5055 61.2787L102.574 60.4329C102.897 60.3441 103.357 60.275 103.578 60.2784L105.403 60.3051Z","fill":"url(#paint56_linear_1649_7004)","key":71}),React.createElement("path",{"style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M95.5623 63.1857L92.6456 63.9806C92.3466 64.062 91.9671 64.1232 91.7657 64.1173L89.8397 64.0581C89.6416 64.0522 89.697 63.9816 89.9902 63.9007L92.8466 63.1136C93.1466 63.0307 93.575 62.969 93.7794 62.9745L95.7657 63.0258C95.9736 63.0312 95.8686 63.1023 95.5623 63.1857Z","fill":"url(#paint57_linear_1649_7004)","key":72}),React.createElement("path",{"style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M105.442 60.6729C105.562 60.9092 105.851 61.1007 106.361 61.2778L105.913 61.3982C105.583 61.487 105.083 61.5536 104.86 61.5491L102.732 61.5078C102.513 61.5033 102.653 61.4302 102.976 61.3429L105.442 60.6729Z","fill":"url(#paint58_linear_1649_7004)","key":73}),React.createElement("path",{"style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M106.383 61.4071L106.525 61.3691C106.744 61.4456 106.957 61.5196 107.158 61.5942L106.209 61.5759C105.984 61.5715 106.052 61.496 106.383 61.4071Z","fill":"url(#paint59_linear_1649_7004)","key":74}),React.createElement("path",{"style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M104.809 62.8607L108.006 62.0149C108.036 62.007 108.033 61.9986 108.068 61.9907C108.455 62.2463 108.481 62.5414 107.695 62.9451C107.367 63.0265 106.932 63.0852 106.716 63.0798L104.556 63.0255C104.334 63.0201 104.481 62.947 104.809 62.8607Z","fill":"url(#paint60_linear_1649_7004)","key":75}),React.createElement("path",{"d":"M163.805 31.5544L140.415 33.9151C140.11 33.9457 139.614 34.1741 139.344 34.4218L117.932 54.0237C117.601 54.3272 117.614 54.5655 117.925 54.5571L142.019 53.8771C142.393 53.8668 142.963 53.5875 143.286 53.2549L163.991 31.9699C164.251 31.7034 164.166 31.5179 163.806 31.5544H163.805Z","fill":"url(#paint61_linear_1649_7004)","key":76}),React.createElement("path",{"d":"M162.832 31.6535L139.588 33.9998C139.285 34.0304 138.821 34.255 138.549 34.5022L117.122 54.0497C116.791 54.3522 116.771 54.5911 117.08 54.5822L141.006 53.9066C141.378 53.8963 141.982 53.617 142.306 53.2854L163.047 32.0645C163.307 31.799 163.189 31.6175 162.832 31.6535Z","fill":"url(#paint62_linear_1649_7004)","key":77}),React.createElement("path",{"d":"M141.668 34.8007L139.68 36.6452C139.472 36.8386 139.148 37.0088 138.914 37.0301L136.677 37.2319C136.447 37.2526 136.401 37.1169 136.61 36.9255L138.605 35.0987C138.81 34.9112 139.189 34.739 139.419 34.7163L141.648 34.4972C141.882 34.474 141.872 34.6117 141.668 34.8007Z","fill":"url(#paint63_linear_1649_7004)","key":78}),React.createElement("path",{"d":"M145.468 34.4312L143.491 36.2974C143.284 36.4933 142.87 36.6739 142.629 36.6956L140.331 36.9029C140.095 36.9241 140.127 36.7795 140.335 36.5856L142.321 34.7376C142.525 34.5481 142.825 34.3819 143.06 34.3587L145.349 34.1336C145.589 34.11 145.671 34.2397 145.468 34.4312Z","fill":"url(#paint64_linear_1649_7004)","key":79}),React.createElement("path",{"d":"M149.151 33.7591L146.799 33.9905C146.558 34.0142 146.174 34.1908 145.971 34.3823L143.996 36.2515C143.789 36.4474 143.842 36.5861 144.085 36.5643L146.446 36.3517C146.692 36.3295 147.031 36.1533 147.237 35.9559L149.202 34.068C149.404 33.8745 149.396 33.7349 149.151 33.7591Z","fill":"url(#paint65_linear_1649_7004)","key":80}),React.createElement("path",{"d":"M153.057 33.3745L150.641 33.6124C150.393 33.6366 150.093 33.8068 149.892 34.0007L147.929 35.8926C147.723 36.0905 147.693 36.239 147.942 36.2168L150.37 35.9982C150.624 35.9755 151.058 35.7885 151.262 35.5886L153.215 33.678C153.415 33.4826 153.31 33.3499 153.057 33.3745Z","fill":"url(#paint66_linear_1649_7004)","key":81}),React.createElement("path",{"d":"M157.072 32.9795L154.588 33.2237C154.333 33.2489 153.946 33.4295 153.746 33.6254L151.795 35.539C151.591 35.7393 151.652 35.8819 151.908 35.8588L154.404 35.6337C154.665 35.6101 155.018 35.429 155.221 35.2261L157.159 33.2933C157.358 33.0954 157.332 32.9543 157.072 32.9795Z","fill":"url(#paint67_linear_1649_7004)","key":82}),React.createElement("path",{"d":"M161.2 32.5731L158.646 32.8243C158.384 32.8499 158.086 33.0241 157.888 33.2225L155.952 35.1598C155.749 35.3626 155.723 35.515 155.987 35.4914L158.555 35.2599C158.823 35.2357 159.277 35.0428 159.479 34.838L161.401 32.881C161.598 32.6807 161.468 32.5469 161.201 32.5731H161.2Z","fill":"url(#paint68_linear_1649_7004)","key":83}),React.createElement("path",{"d":"M138.418 37.8159L136.365 39.7206C136.15 39.9204 135.82 40.0946 135.585 40.1134L133.339 40.2925C133.108 40.3108 133.067 40.1682 133.283 39.9703L135.343 38.0843C135.554 37.8909 135.94 37.7157 136.17 37.6955L138.408 37.4971C138.643 37.4764 138.628 37.6205 138.418 37.8159Z","fill":"url(#paint69_linear_1649_7004)","key":84}),React.createElement("path",{"d":"M142.235 37.4825L140.192 39.4109C139.978 39.6132 139.557 39.7968 139.315 39.816L137.007 40.0001C136.77 40.0188 136.808 39.8678 137.023 39.6675L139.074 37.7588C139.284 37.5629 139.59 37.3932 139.827 37.372L142.126 37.1682C142.367 37.147 142.445 37.2851 142.235 37.4825Z","fill":"url(#paint70_linear_1649_7004)","key":85}),React.createElement("path",{"d":"M145.946 36.8304L143.583 37.0396C143.34 37.0613 142.95 37.2409 142.741 37.4383L140.699 39.3696C140.485 39.572 140.534 39.7185 140.777 39.6988L143.15 39.5093C143.398 39.4896 143.743 39.3099 143.955 39.1057L145.987 37.1545C146.195 36.9547 146.193 36.8081 145.946 36.8304Z","fill":"url(#paint71_linear_1649_7004)","key":86}),React.createElement("path",{"d":"M149.873 36.4823L147.443 36.6974C147.194 36.7197 146.888 36.8938 146.68 37.0937L144.651 39.0492C144.438 39.254 144.403 39.4095 144.653 39.3892L147.094 39.1943C147.349 39.1741 147.79 38.9841 148.002 38.7773L150.021 36.8016C150.228 36.5993 150.127 36.4601 149.873 36.4823Z","fill":"url(#paint72_linear_1649_7004)","key":87}),React.createElement("path",{"d":"M153.911 36.1254L151.412 36.3465C151.156 36.3692 150.762 36.5532 150.555 36.7561L148.537 38.7353C148.326 38.9425 148.383 39.093 148.64 39.0723L151.151 38.872C151.413 38.8512 151.773 38.6657 151.983 38.456L153.988 36.456C154.193 36.2513 154.172 36.1022 153.911 36.1254Z","fill":"url(#paint73_linear_1649_7004)","key":88}),React.createElement("path",{"d":"M158.065 35.757L155.495 35.9845C155.231 36.0077 154.927 36.1863 154.722 36.3911L152.719 38.3955C152.509 38.6057 152.478 38.7651 152.743 38.7438L155.327 38.5376C155.597 38.5159 156.059 38.32 156.267 38.1078L158.257 36.0817C158.461 35.8744 158.335 35.7323 158.066 35.756L158.065 35.757Z","fill":"url(#paint74_linear_1649_7004)","key":89}),React.createElement("path",{"d":"M135.061 40.9313L132.94 42.8996C132.718 43.1059 132.381 43.284 132.146 43.3003L129.892 43.4558C129.66 43.4716 129.624 43.3215 129.848 43.1173L131.976 41.1691C132.194 40.9693 132.586 40.7911 132.817 40.7734L135.064 40.5977C135.3 40.5794 135.28 40.7299 135.062 40.9318L135.061 40.9313Z","fill":"url(#paint75_linear_1649_7004)","key":90}),React.createElement("path",{"d":"M138.894 40.636L136.783 42.6295C136.561 42.8387 136.133 43.0252 135.89 43.0415L133.574 43.2014C133.335 43.2177 133.379 43.0598 133.601 42.853L135.72 40.8802C135.938 40.6779 136.25 40.5042 136.487 40.4855L138.796 40.3049C139.038 40.2861 139.111 40.4312 138.894 40.636Z","fill":"url(#paint76_linear_1649_7004)","key":91}),React.createElement("path",{"d":"M142.664 40.346L140.562 42.3642C140.342 42.5759 139.991 42.759 139.742 42.7763L137.359 42.9406C137.114 42.9574 137.07 42.8034 137.292 42.5937L139.402 40.5967C139.619 40.3919 140.015 40.2093 140.259 40.1906L142.633 40.0051C142.882 39.9858 142.879 40.1388 142.664 40.346Z","fill":"url(#paint77_linear_1649_7004)","key":92}),React.createElement("path",{"d":"M146.58 39.6967L144.138 39.8876C143.888 39.9074 143.576 40.0855 143.361 40.2928L141.261 42.3154C141.041 42.5271 141.001 42.6899 141.253 42.6727L143.705 42.5039C143.961 42.4861 144.41 42.2937 144.628 42.0795L146.718 40.0347C146.931 39.8255 146.835 39.6764 146.58 39.6967Z","fill":"url(#paint78_linear_1649_7004)","key":93}),React.createElement("path",{"d":"M150.64 39.3798L148.128 39.5761C147.87 39.5964 147.469 39.7839 147.255 39.9936L145.167 42.0419C144.949 42.2566 145 42.415 145.259 42.3972L147.783 42.2235C148.047 42.2053 148.413 42.0158 148.631 41.7991L150.707 39.7286C150.92 39.5169 150.903 39.3591 150.64 39.3798Z","fill":"url(#paint79_linear_1649_7004)","key":94}),React.createElement("path",{"d":"M154.82 39.0528L152.234 39.2551C151.968 39.2758 151.658 39.4584 151.445 39.6711L149.372 41.7465C149.155 41.9641 149.118 42.1309 149.384 42.1127L151.984 41.9335C152.256 41.9148 152.726 41.7159 152.941 41.4958L155.002 39.3972C155.213 39.1825 155.091 39.0315 154.82 39.0528Z","fill":"url(#paint80_linear_1649_7004)","key":95}),React.createElement("path",{"d":"M131.592 44.1498L129.399 46.1848C129.169 46.3984 128.826 46.58 128.589 46.5934L126.328 46.7231C126.096 46.7365 126.065 46.5781 126.296 46.3669L128.495 44.3536C128.721 44.1468 129.12 43.9662 129.351 43.9504L131.605 43.7989C131.842 43.7832 131.817 43.9411 131.592 44.1498Z","fill":"url(#paint81_linear_1649_7004)","key":96}),React.createElement("path",{"d":"M135.44 43.8969L133.256 45.9591C133.027 46.1757 132.592 46.3647 132.348 46.379L130.023 46.5122C129.784 46.526 129.832 46.3607 130.062 46.1466L132.254 44.1071C132.479 43.8979 132.797 43.7203 133.035 43.704L135.354 43.5481C135.596 43.5318 135.664 43.6852 135.44 43.8969Z","fill":"url(#paint82_linear_1649_7004)","key":97}),React.createElement("path",{"d":"M139.226 43.6475L137.051 45.7358C136.822 45.9549 136.465 46.1424 136.215 46.1567L133.821 46.2939C133.575 46.3082 133.537 46.1454 133.767 45.9288L135.95 43.8632C136.174 43.6515 136.577 43.4659 136.822 43.4492L139.207 43.2888C139.457 43.272 139.449 43.4334 139.226 43.6475Z","fill":"url(#paint83_linear_1649_7004)","key":98}),React.createElement("path",{"d":"M143.3 43.3791L141.136 45.496C140.909 45.718 140.454 45.9134 140.196 45.9282L137.733 46.0694C137.48 46.0837 137.526 45.9139 137.753 45.6943L139.927 43.6011C140.15 43.3865 140.467 43.2044 140.719 43.1871L143.173 43.0223C143.431 43.005 143.521 43.1624 143.3 43.3791Z","fill":"url(#paint84_linear_1649_7004)","key":99}),React.createElement("path",{"d":"M147.311 43.115L145.16 45.26C144.934 45.4851 144.562 45.6785 144.295 45.6938L141.758 45.8394C141.497 45.8542 141.451 45.6874 141.678 45.4648L143.84 43.344C144.062 43.1264 144.469 42.9359 144.729 42.9186L147.255 42.7489C147.519 42.7311 147.531 42.8949 147.311 43.115Z","fill":"url(#paint85_linear_1649_7004)","key":100}),React.createElement("path",{"d":"M151.459 42.4663L148.857 42.641C148.59 42.6588 148.272 42.8463 148.053 43.0664L145.904 45.2163C145.679 45.4418 145.637 45.6165 145.905 45.6012L148.519 45.4512C148.792 45.4354 149.27 45.2331 149.494 45.0051L151.63 42.83C151.848 42.6075 151.73 42.4471 151.458 42.4658L151.459 42.4663Z","fill":"url(#paint86_linear_1649_7004)","key":101}),React.createElement("path",{"d":"M128.005 47.4787L125.737 49.5838C125.499 49.8049 125.149 49.9904 124.911 50.0013L122.644 50.1034C122.411 50.1138 122.386 49.947 122.625 49.7284L124.899 47.647C125.132 47.4333 125.537 47.2493 125.77 47.2364L128.031 47.1111C128.268 47.0978 128.238 47.2626 128.005 47.4787Z","fill":"url(#paint87_linear_1649_7004)","key":102}),React.createElement("path",{"d":"M131.867 47.2698L129.606 49.4039C129.369 49.628 128.926 49.8204 128.682 49.8313L126.349 49.9364C126.109 49.9472 126.163 49.774 126.402 49.553L128.669 47.443C128.901 47.2263 129.226 47.0447 129.465 47.0314L131.792 46.9021C132.035 46.8888 132.099 47.0512 131.867 47.2698Z","fill":"url(#paint88_linear_1649_7004)","key":103}),React.createElement("path",{"d":"M135.668 47.0643L133.416 49.2271C133.18 49.4541 132.815 49.6456 132.563 49.6569L130.161 49.765C129.915 49.7763 129.882 49.6046 130.119 49.3801L132.379 47.242C132.611 47.0229 133.021 46.8339 133.267 46.8201L135.662 46.6873C135.913 46.6735 135.899 46.8423 135.669 47.0643H135.668Z","fill":"url(#paint89_linear_1649_7004)","key":104}),React.createElement("path",{"d":"M139.76 46.8427L137.519 49.0361C137.283 49.2665 136.82 49.4649 136.561 49.4767L134.087 49.5883C133.833 49.5996 133.884 49.422 134.121 49.194L136.371 47.0263C136.602 46.8042 136.926 46.6172 137.18 46.6034L139.645 46.4667C139.903 46.4524 139.99 46.6177 139.76 46.8427Z","fill":"url(#paint90_linear_1649_7004)","key":105}),React.createElement("path",{"d":"M143.792 46.625L141.562 48.8485C141.328 49.0819 140.948 49.2798 140.68 49.2916L138.131 49.4066C137.869 49.4185 137.828 49.2423 138.063 49.0114L140.303 46.814C140.532 46.589 140.948 46.3946 141.208 46.3803L143.748 46.2397C144.014 46.2248 144.02 46.3975 143.792 46.625Z","fill":"url(#paint91_linear_1649_7004)","key":106}),React.createElement("path",{"d":"M148.135 46.3893L145.92 48.6448C145.908 48.6562 145.86 48.6695 145.846 48.6809C145.61 48.9029 145.188 49.0875 144.926 49.0993L142.298 49.2177C142.027 49.2301 142.076 49.047 142.31 48.8126L144.537 46.5837C144.557 46.563 144.54 46.5457 144.566 46.525C144.798 46.3236 145.114 46.1623 145.358 46.149L147.974 46.0039C148.249 45.9886 148.361 46.1583 148.134 46.3898L148.135 46.3893Z","fill":"url(#paint92_linear_1649_7004)","key":107}),React.createElement("path",{"d":"M124.295 50.9215L121.947 53.1001C121.7 53.329 121.343 53.519 121.105 53.5264L118.832 53.599C118.599 53.6064 118.58 53.4307 118.827 53.2047L121.179 51.0508C121.421 50.8297 121.833 50.6427 122.066 50.6323L124.334 50.5346C124.572 50.5243 124.535 50.698 124.295 50.9215Z","fill":"url(#paint93_linear_1649_7004)","key":108}),React.createElement("path",{"d":"M128.168 50.7604L125.827 52.9705C125.581 53.2025 125.131 53.3984 124.886 53.4063L122.546 53.4808C122.306 53.4887 122.367 53.3076 122.613 53.0781L124.96 50.8941C125.201 50.6701 125.533 50.484 125.773 50.4737L128.107 50.373C128.352 50.3626 128.408 50.5339 128.168 50.7604Z","fill":"url(#paint94_linear_1649_7004)","key":109}),React.createElement("path",{"d":"M131.984 50.6023L129.651 52.8431C129.405 53.0784 129.033 53.2743 128.78 53.2822L126.37 53.3592C126.123 53.3671 126.096 53.186 126.342 52.9536L128.682 50.7395C128.922 50.5125 129.34 50.32 129.586 50.3092L131.99 50.2056C132.242 50.1947 132.223 50.3723 131.983 50.6018L131.984 50.6023Z","fill":"url(#paint95_linear_1649_7004)","key":110}),React.createElement("path",{"d":"M136.093 50.4314L133.769 52.7053C133.525 52.9441 133.054 53.1459 132.794 53.1543L130.31 53.2338C130.055 53.2416 130.113 53.0556 130.358 52.8197L132.69 50.5736C132.929 50.3431 133.261 50.1517 133.515 50.1408L135.991 50.0342C136.25 50.0229 136.331 50.1985 136.093 50.4314Z","fill":"url(#paint96_linear_1649_7004)","key":111}),React.createElement("path",{"d":"M140.143 50.2631L137.831 52.569C137.588 52.8113 137.2 53.0136 136.931 53.022L134.37 53.1039C134.107 53.1123 134.072 52.9262 134.316 52.6869L136.638 50.4086C136.876 50.1752 137.299 49.9774 137.561 49.966L140.113 49.856C140.38 49.8446 140.38 50.0267 140.143 50.2631Z","fill":"url(#paint97_linear_1649_7004)","key":112}),React.createElement("path",{"d":"M144.51 50.082L142.21 52.4229C141.969 52.6691 141.475 52.8774 141.198 52.8863L138.556 52.9706C138.285 52.9795 138.339 52.7871 138.582 52.5443L140.893 50.232C141.13 49.9951 141.461 49.7982 141.731 49.7864L144.361 49.6734C144.637 49.6616 144.745 49.8422 144.51 50.082Z","fill":"url(#paint98_linear_1649_7004)","key":113}),React.createElement("path",{"style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M140.335 36.5844L142.136 34.9092C142.264 35.3385 142.215 35.9365 141.849 36.7646L140.331 36.9012C140.094 36.9225 140.127 36.7783 140.335 36.5844Z","fill":"url(#paint99_linear_1649_7004)","key":114}),React.createElement("path",{"style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M141.633 37.2119C141.308 37.8272 140.823 38.5551 140.14 39.4147C139.926 39.617 139.557 39.7961 139.315 39.8154L137.007 39.9994C136.77 40.0182 136.808 39.8672 137.023 39.6668L139.074 37.7582C139.284 37.5623 139.59 37.3925 139.827 37.3713L141.633 37.2119Z","fill":"url(#paint100_linear_1649_7004)","key":115}),React.createElement("path",{"style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M137.292 42.5938L139.17 40.8174C138.78 41.6316 138.624 42.2968 138.717 42.8474L137.359 42.9412C137.114 42.958 137.07 42.8035 137.292 42.5938Z","fill":"url(#paint101_linear_1649_7004)","key":116}),React.createElement("path",{"style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M139.463 44.0469C139.964 44.5166 140.588 44.8803 141.443 45.1951L141.136 45.4956C140.909 45.7177 140.454 45.9131 140.196 45.9279L137.733 46.069C137.48 46.0833 137.526 45.9136 137.753 45.694L139.463 44.0469Z","fill":"url(#paint102_linear_1649_7004)","key":117}),React.createElement("path",{"style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M141.678 45.4639L141.775 45.3687C142.147 45.5058 142.51 45.6391 142.86 45.7753L141.759 45.8384C141.498 45.8532 141.451 45.6864 141.679 45.4639H141.678Z","fill":"url(#paint103_linear_1649_7004)","key":118}),React.createElement("path",{"style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M142.31 48.813L144.537 46.5841C144.558 46.5634 144.541 46.5461 144.566 46.5254C145.457 47.0391 146.012 47.687 145.828 48.6823C145.593 48.9043 145.189 49.0879 144.926 49.0997L142.298 49.2182C142.028 49.2305 142.076 49.0474 142.31 48.813Z","fill":"url(#paint104_linear_1649_7004)","key":119}),React.createElement("path",{"style":{"mixBlendMode":"multiply"},"opacity":"0.3","d":"M144.51 50.082L142.21 52.4229C141.969 52.6691 141.475 52.8774 141.198 52.8863L138.556 52.9706C138.285 52.9795 138.339 52.7871 138.582 52.5443L140.893 50.232C141.13 49.9951 141.461 49.7982 141.731 49.7864L144.361 49.6734C144.637 49.6616 144.745 49.8422 144.51 50.082Z","fill":"url(#paint105_linear_1649_7004)","key":120})]),React.createElement("defs",{"key":1},[React.createElement("linearGradient",{"id":"paint0_linear_1649_7004","x1":"121.953","y1":"34.6648","x2":"81.9749","y2":"125.724","gradientUnits":"userSpaceOnUse","key":0},[React.createElement("stop",{"stopColor":"#006736","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint1_linear_1649_7004","x1":"101.739","y1":"53.4465","x2":"88.1137","y2":"-28.9231","gradientUnits":"userSpaceOnUse","key":1},[React.createElement("stop",{"stopColor":"#93C13E","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#93C13E","key":1})]),React.createElement("linearGradient",{"id":"paint2_linear_1649_7004","x1":"60.3383","y1":"77.9975","x2":"121.841","y2":"84.2223","gradientUnits":"userSpaceOnUse","key":2},[React.createElement("stop",{"stopColor":"#93C13E","key":0}),React.createElement("stop",{"offset":"1","stopColor":"white","key":1})]),React.createElement("linearGradient",{"id":"paint3_linear_1649_7004","x1":"71.3666","y1":"71.7844","x2":"201.325","y2":"63.7153","gradientUnits":"userSpaceOnUse","key":3},[React.createElement("stop",{"stopColor":"#C7DF9A","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#7BBE00","key":1})]),React.createElement("linearGradient",{"id":"paint4_linear_1649_7004","x1":"175.644","y1":"30.1093","x2":"99.7692","y2":"63.8981","gradientUnits":"userSpaceOnUse","key":4},[React.createElement("stop",{"stopColor":"#05683C","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint5_linear_1649_7004","x1":"134.493","y1":"52.2042","x2":"77.6705","y2":"72.4633","gradientUnits":"userSpaceOnUse","key":5},[React.createElement("stop",{"stopColor":"#05683C","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#F5F9F5","key":1})]),React.createElement("linearGradient",{"id":"paint6_linear_1649_7004","x1":"175.545","y1":"60.6128","x2":"175.545","y2":"111.261","gradientUnits":"userSpaceOnUse","key":6},[React.createElement("stop",{"stopColor":"#93C13E","stopOpacity":"0.1","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint7_linear_1649_7004","x1":"156.014","y1":"60.6127","x2":"156.014","y2":"111.261","gradientUnits":"userSpaceOnUse","key":7},[React.createElement("stop",{"stopColor":"#93C13E","stopOpacity":"0.1","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint8_linear_1649_7004","x1":"165.952","y1":"60.613","x2":"165.952","y2":"111.261","gradientUnits":"userSpaceOnUse","key":8},[React.createElement("stop",{"stopColor":"#93C13E","stopOpacity":"0.1","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint9_linear_1649_7004","x1":"162.92","y1":"34.0094","x2":"161.734","y2":"34.7332","gradientUnits":"userSpaceOnUse","key":9},[React.createElement("stop",{"stopColor":"#EBEFF2","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint10_linear_1649_7004","x1":"154.504","y1":"42.3117","x2":"153.318","y2":"43.0355","gradientUnits":"userSpaceOnUse","key":10},[React.createElement("stop",{"stopColor":"#EBEFF2","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint11_linear_1649_7004","x1":"133.183","y1":"56.084","x2":"132.191","y2":"56.6894","gradientUnits":"userSpaceOnUse","key":11},[React.createElement("stop",{"stopColor":"#EBEFF2","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint12_linear_1649_7004","x1":"119.326","y1":"59.7623","x2":"118.139","y2":"60.4866","gradientUnits":"userSpaceOnUse","key":12},[React.createElement("stop",{"stopColor":"#EBEFF2","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint13_linear_1649_7004","x1":"145.247","y1":"51.63","x2":"144.06","y2":"52.3538","gradientUnits":"userSpaceOnUse","key":13},[React.createElement("stop",{"stopColor":"#EBEFF2","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint14_linear_1649_7004","x1":"120.841","y1":"53.1549","x2":"119.654","y2":"53.8787","gradientUnits":"userSpaceOnUse","key":14},[React.createElement("stop",{"stopColor":"#EBEFF2","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint15_linear_1649_7004","x1":"70.2957","y1":"60.3009","x2":"125.91","y2":"60.3009","gradientUnits":"userSpaceOnUse","key":15},[React.createElement("stop",{"stopColor":"#EBEFF2","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint16_linear_1649_7004","x1":"131.395","y1":"46.2799","x2":"93.8895","y2":"69.1731","gradientUnits":"userSpaceOnUse","key":16},[React.createElement("stop",{"stopColor":"#EBEFF2","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint17_linear_1649_7004","x1":"110.975","y1":"53.8802","x2":"111.3","y2":"64.8757","gradientUnits":"userSpaceOnUse","key":17},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint18_linear_1649_7004","x1":"114.691","y1":"53.8033","x2":"115.02","y2":"64.9429","gradientUnits":"userSpaceOnUse","key":18},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint19_linear_1649_7004","x1":"118.459","y1":"53.7269","x2":"118.792","y2":"65.014","gradientUnits":"userSpaceOnUse","key":19},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint20_linear_1649_7004","x1":"122.387","y1":"53.6471","x2":"122.725","y2":"65.0852","gradientUnits":"userSpaceOnUse","key":20},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint21_linear_1649_7004","x1":"126.371","y1":"53.5658","x2":"126.714","y2":"65.1598","gradientUnits":"userSpaceOnUse","key":21},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint22_linear_1649_7004","x1":"130.53","y1":"53.481","x2":"130.878","y2":"65.235","gradientUnits":"userSpaceOnUse","key":22},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint23_linear_1649_7004","x1":"105.682","y1":"54.015","x2":"106.001","y2":"64.8402","gradientUnits":"userSpaceOnUse","key":23},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint24_linear_1649_7004","x1":"109.258","y1":"53.997","x2":"109.578","y2":"64.8384","gradientUnits":"userSpaceOnUse","key":24},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint25_linear_1649_7004","x1":"112.88","y1":"53.9263","x2":"113.203","y2":"64.9069","gradientUnits":"userSpaceOnUse","key":25},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint26_linear_1649_7004","x1":"116.654","y1":"53.8516","x2":"116.982","y2":"64.9759","gradientUnits":"userSpaceOnUse","key":26},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint27_linear_1649_7004","x1":"120.481","y1":"53.777","x2":"120.813","y2":"65.0483","gradientUnits":"userSpaceOnUse","key":27},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint28_linear_1649_7004","x1":"124.472","y1":"53.6994","x2":"124.809","y2":"65.1216","gradientUnits":"userSpaceOnUse","key":28},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint29_linear_1649_7004","x1":"100.585","y1":"54.2681","x2":"100.893","y2":"64.6966","gradientUnits":"userSpaceOnUse","key":29},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint30_linear_1649_7004","x1":"104.026","y1":"54.2031","x2":"104.337","y2":"64.7609","gradientUnits":"userSpaceOnUse","key":30},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint31_linear_1649_7004","x1":"107.51","y1":"54.1386","x2":"107.825","y2":"64.8286","gradientUnits":"userSpaceOnUse","key":31},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint32_linear_1649_7004","x1":"111.139","y1":"54.0701","x2":"111.459","y2":"64.8959","gradientUnits":"userSpaceOnUse","key":32},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint33_linear_1649_7004","x1":"114.817","y1":"54.0022","x2":"115.14","y2":"64.9672","gradientUnits":"userSpaceOnUse","key":33},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint34_linear_1649_7004","x1":"118.651","y1":"53.9313","x2":"118.979","y2":"65.0388","gradientUnits":"userSpaceOnUse","key":34},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint35_linear_1649_7004","x1":"95.6691","y1":"54.4799","x2":"95.9691","y2":"64.6454","gradientUnits":"userSpaceOnUse","key":35},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint36_linear_1649_7004","x1":"98.9832","y1":"54.4207","x2":"99.2867","y2":"64.709","gradientUnits":"userSpaceOnUse","key":36},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint37_linear_1649_7004","x1":"102.338","y1":"54.3624","x2":"102.645","y2":"64.7761","gradientUnits":"userSpaceOnUse","key":37},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint38_linear_1649_7004","x1":"105.83","y1":"54.3002","x2":"106.141","y2":"64.8427","gradientUnits":"userSpaceOnUse","key":38},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint39_linear_1649_7004","x1":"109.367","y1":"54.2385","x2":"109.682","y2":"64.9127","gradientUnits":"userSpaceOnUse","key":39},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint40_linear_1649_7004","x1":"113.053","y1":"54.1747","x2":"113.371","y2":"64.9837","gradientUnits":"userSpaceOnUse","key":40},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint41_linear_1649_7004","x1":"90.9269","y1":"54.7012","x2":"91.2195","y2":"64.616","gradientUnits":"userSpaceOnUse","key":41},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint42_linear_1649_7004","x1":"94.121","y1":"54.6472","x2":"94.417","y2":"64.6785","gradientUnits":"userSpaceOnUse","key":42},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint43_linear_1649_7004","x1":"97.3525","y1":"54.5947","x2":"97.6521","y2":"64.7454","gradientUnits":"userSpaceOnUse","key":43},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint44_linear_1649_7004","x1":"100.715","y1":"54.5393","x2":"101.018","y2":"64.8118","gradientUnits":"userSpaceOnUse","key":44},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint45_linear_1649_7004","x1":"104.119","y1":"54.4843","x2":"104.426","y2":"64.8822","gradientUnits":"userSpaceOnUse","key":45},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint46_linear_1649_7004","x1":"107.665","y1":"54.4262","x2":"107.975","y2":"64.9524","gradientUnits":"userSpaceOnUse","key":46},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint47_linear_1649_7004","x1":"86.3489","y1":"54.93","x2":"86.6345","y2":"64.6059","gradientUnits":"userSpaceOnUse","key":47},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint48_linear_1649_7004","x1":"89.4296","y1":"54.8822","x2":"89.7182","y2":"64.6692","gradientUnits":"userSpaceOnUse","key":48},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint49_linear_1649_7004","x1":"92.5446","y1":"54.8354","x2":"92.8367","y2":"64.7355","gradientUnits":"userSpaceOnUse","key":49},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint50_linear_1649_7004","x1":"95.7842","y1":"54.7862","x2":"96.0798","y2":"64.8027","gradientUnits":"userSpaceOnUse","key":50},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint51_linear_1649_7004","x1":"99.0634","y1":"54.738","x2":"99.3624","y2":"64.8728","gradientUnits":"userSpaceOnUse","key":51},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint52_linear_1649_7004","x1":"102.476","y1":"54.6872","x2":"102.779","y2":"64.9439","gradientUnits":"userSpaceOnUse","key":52},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint53_linear_1649_7004","x1":"111.159","y1":"56.6274","x2":"114.551","y2":"56.6274","gradientUnits":"userSpaceOnUse","key":53},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint54_linear_1649_7004","x1":"105.899","y1":"57.9817","x2":"112.218","y2":"57.9817","gradientUnits":"userSpaceOnUse","key":54},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint55_linear_1649_7004","x1":"104.23","y1":"59.5978","x2":"107.353","y2":"59.5978","gradientUnits":"userSpaceOnUse","key":55},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint56_linear_1649_7004","x1":"99.2192","y1":"60.8809","x2":"105.403","y2":"60.8809","gradientUnits":"userSpaceOnUse","key":56},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint57_linear_1649_7004","x1":"89.7225","y1":"63.5459","x2":"95.8736","y2":"63.5459","gradientUnits":"userSpaceOnUse","key":57},[React.createElement("stop",{"stopColor":"#AA80F9","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#6165D7","key":1})]),React.createElement("linearGradient",{"id":"paint58_linear_1649_7004","x1":"102.626","y1":"61.1115","x2":"106.361","y2":"61.1115","gradientUnits":"userSpaceOnUse","key":58},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint59_linear_1649_7004","x1":"106.077","y1":"61.4816","x2":"107.158","y2":"61.4816","gradientUnits":"userSpaceOnUse","key":59},[React.createElement("stop",{"stopColor":"#AA80F9","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#6165D7","key":1})]),React.createElement("linearGradient",{"id":"paint60_linear_1649_7004","x1":"104.45","y1":"62.535","x2":"108.331","y2":"62.535","gradientUnits":"userSpaceOnUse","key":60},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint61_linear_1649_7004","x1":"108.056","y1":"43.0533","x2":"154.51","y2":"43.0533","gradientUnits":"userSpaceOnUse","key":61},[React.createElement("stop",{"stopColor":"#EBEFF2","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint62_linear_1649_7004","x1":"162.126","y1":"30.486","x2":"124.919","y2":"53.1963","gradientUnits":"userSpaceOnUse","key":62},[React.createElement("stop",{"stopColor":"white","key":0}),React.createElement("stop",{"offset":"0.47","stopColor":"#D2D9E1","key":1}),React.createElement("stop",{"offset":"0.99","stopColor":"#B7C0CE","key":2})]),React.createElement("linearGradient",{"id":"paint63_linear_1649_7004","x1":"138.986","y1":"30.2569","x2":"139.682","y2":"53.8471","gradientUnits":"userSpaceOnUse","key":63},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint64_linear_1649_7004","x1":"142.706","y1":"29.7478","x2":"143.411","y2":"53.6434","gradientUnits":"userSpaceOnUse","key":64},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint65_linear_1649_7004","x1":"146.434","y1":"29.2272","x2":"147.148","y2":"53.4361","gradientUnits":"userSpaceOnUse","key":65},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint66_linear_1649_7004","x1":"150.364","y1":"28.6892","x2":"151.087","y2":"53.2204","gradientUnits":"userSpaceOnUse","key":66},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint67_linear_1649_7004","x1":"154.299","y1":"28.1397","x2":"155.033","y2":"53.0019","gradientUnits":"userSpaceOnUse","key":67},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint68_linear_1649_7004","x1":"158.456","y1":"27.5715","x2":"159.2","y2":"52.7732","gradientUnits":"userSpaceOnUse","key":68},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint69_linear_1649_7004","x1":"135.605","y1":"30.1047","x2":"136.317","y2":"54.2135","gradientUnits":"userSpaceOnUse","key":69},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint70_linear_1649_7004","x1":"139.338","y1":"29.5853","x2":"140.059","y2":"54.0132","gradientUnits":"userSpaceOnUse","key":70},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint71_linear_1649_7004","x1":"143.083","y1":"29.0545","x2":"143.814","y2":"53.8102","gradientUnits":"userSpaceOnUse","key":71},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0.5","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint72_linear_1649_7004","x1":"147.029","y1":"28.5047","x2":"147.77","y2":"53.5979","gradientUnits":"userSpaceOnUse","key":72},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0.5","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint73_linear_1649_7004","x1":"150.986","y1":"27.9445","x2":"151.738","y2":"53.3836","gradientUnits":"userSpaceOnUse","key":73},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"0.263695","stopColor":"#05683C","stopOpacity":"0.263695","key":1}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":2})]),React.createElement("linearGradient",{"id":"paint74_linear_1649_7004","x1":"155.166","y1":"27.3639","x2":"155.927","y2":"53.1588","gradientUnits":"userSpaceOnUse","key":74},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint75_linear_1649_7004","x1":"132.112","y1":"29.9095","x2":"132.839","y2":"54.5596","gradientUnits":"userSpaceOnUse","key":75},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint76_linear_1649_7004","x1":"135.857","y1":"29.3784","x2":"136.595","y2":"54.3625","gradientUnits":"userSpaceOnUse","key":76},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint77_linear_1649_7004","x1":"139.618","y1":"28.8353","x2":"140.365","y2":"54.1624","gradientUnits":"userSpaceOnUse","key":77},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint78_linear_1649_7004","x1":"143.581","y1":"28.2737","x2":"144.338","y2":"53.9537","gradientUnits":"userSpaceOnUse","key":78},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint79_linear_1649_7004","x1":"147.558","y1":"27.6993","x2":"148.327","y2":"53.7424","gradientUnits":"userSpaceOnUse","key":79},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint80_linear_1649_7004","x1":"151.759","y1":"27.1048","x2":"152.539","y2":"53.5205","gradientUnits":"userSpaceOnUse","key":80},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint81_linear_1649_7004","x1":"128.501","y1":"29.666","x2":"129.246","y2":"54.8821","gradientUnits":"userSpaceOnUse","key":81},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint82_linear_1649_7004","x1":"132.257","y1":"29.1215","x2":"133.011","y2":"54.6874","gradientUnits":"userSpaceOnUse","key":82},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint83_linear_1649_7004","x1":"136.032","y1":"28.5647","x2":"136.797","y2":"54.4898","gradientUnits":"userSpaceOnUse","key":83},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint84_linear_1649_7004","x1":"140.01","y1":"27.9883","x2":"140.786","y2":"54.2835","gradientUnits":"userSpaceOnUse","key":84},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint85_linear_1649_7004","x1":"144.007","y1":"27.3991","x2":"144.794","y2":"54.0743","gradientUnits":"userSpaceOnUse","key":85},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint86_linear_1649_7004","x1":"148.229","y1":"26.7884","x2":"149.027","y2":"53.8554","gradientUnits":"userSpaceOnUse","key":86},[React.createElement("stop",{"stopColor":"#006736","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint87_linear_1649_7004","x1":"124.767","y1":"29.3696","x2":"125.528","y2":"55.1778","gradientUnits":"userSpaceOnUse","key":87},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint88_linear_1649_7004","x1":"128.531","y1":"28.8102","x2":"129.303","y2":"54.9846","gradientUnits":"userSpaceOnUse","key":88},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint89_linear_1649_7004","x1":"132.319","y1":"28.2372","x2":"133.103","y2":"54.789","gradientUnits":"userSpaceOnUse","key":89},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint90_linear_1649_7004","x1":"136.311","y1":"27.644","x2":"137.107","y2":"54.5836","gradientUnits":"userSpaceOnUse","key":90},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint91_linear_1649_7004","x1":"140.327","y1":"27.037","x2":"141.134","y2":"54.3758","gradientUnits":"userSpaceOnUse","key":91},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0.5","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint92_linear_1649_7004","x1":"144.567","y1":"26.4075","x2":"145.386","y2":"54.1579","gradientUnits":"userSpaceOnUse","key":92},[React.createElement("stop",{"stopColor":"#006736","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint93_linear_1649_7004","x1":"120.901","y1":"29.0137","x2":"121.681","y2":"55.4417","gradientUnits":"userSpaceOnUse","key":93},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint94_linear_1649_7004","x1":"124.673","y1":"28.4366","x2":"125.464","y2":"55.249","gradientUnits":"userSpaceOnUse","key":94},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint95_linear_1649_7004","x1":"128.474","y1":"27.8458","x2":"129.277","y2":"55.0534","gradientUnits":"userSpaceOnUse","key":95},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint96_linear_1649_7004","x1":"132.478","y1":"27.2338","x2":"133.293","y2":"54.8495","gradientUnits":"userSpaceOnUse","key":96},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"0.728491","stopColor":"#006736","stopOpacity":"0.728491","key":1}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":2})]),React.createElement("linearGradient",{"id":"paint97_linear_1649_7004","x1":"136.51","y1":"26.6065","x2":"137.337","y2":"54.6421","gradientUnits":"userSpaceOnUse","key":97},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint98_linear_1649_7004","x1":"140.768","y1":"25.9572","x2":"141.608","y2":"54.4255","gradientUnits":"userSpaceOnUse","key":98},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint99_linear_1649_7004","x1":"140.166","y1":"35.9064","x2":"142.2","y2":"35.9064","gradientUnits":"userSpaceOnUse","key":99},[React.createElement("stop",{"stopColor":"#006736","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint100_linear_1649_7004","x1":"136.845","y1":"38.6069","x2":"141.633","y2":"38.6069","gradientUnits":"userSpaceOnUse","key":100},[React.createElement("stop",{"stopColor":"#006736","stopOpacity":"0","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint101_linear_1649_7004","x1":"137.148","y1":"41.8793","x2":"139.17","y2":"41.8793","gradientUnits":"userSpaceOnUse","key":101},[React.createElement("stop",{"stopColor":"#006736","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#006736","key":1})]),React.createElement("linearGradient",{"id":"paint102_linear_1649_7004","x1":"137.561","y1":"45.0584","x2":"141.443","y2":"45.0584","gradientUnits":"userSpaceOnUse","key":102},[React.createElement("stop",{"stopColor":"#05683C","stopOpacity":"0.5","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#05683C","key":1})]),React.createElement("linearGradient",{"id":"paint103_linear_1649_7004","x1":"141.533","y1":"45.6045","x2":"142.86","y2":"45.6045","gradientUnits":"userSpaceOnUse","key":103},[React.createElement("stop",{"stopColor":"#AA80F9","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#6165D7","key":1})]),React.createElement("linearGradient",{"id":"paint104_linear_1649_7004","x1":"142.114","y1":"47.872","x2":"145.863","y2":"47.872","gradientUnits":"userSpaceOnUse","key":104},[React.createElement("stop",{"stopColor":"#AA80F9","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#6165D7","key":1})]),React.createElement("linearGradient",{"id":"paint105_linear_1649_7004","x1":"138.376","y1":"51.322","x2":"144.639","y2":"51.322","gradientUnits":"userSpaceOnUse","key":105},[React.createElement("stop",{"stopColor":"#AA80F9","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#AA80F9","key":1})]),React.createElement("clipPath",{"id":"clip0_1649_7004","key":106},React.createElement("rect",{"width":"284","height":"120","fill":"white"}))])]);
}

HomeIllustrationComponent.defaultProps = {"width":"284","height":"120","viewBox":"0 0 284 120","fill":"none"};

module.exports = HomeIllustrationComponent;

HomeIllustrationComponent.default = HomeIllustrationComponent;


/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcArrowBackComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-arrow back"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M16.3132 10.8331L16.3132 10.8331L6.1674 10.8331L16.3132 10.8331ZM10.8341 4.49976L6.1674 9.16645L10.8341 4.49978L10.8341 4.49976ZM10.4789 4.50134L5.56385 9.41644L16.0632 9.41644L16.0632 10.5831L5.56385 10.5831L10.4789 15.4982L9.64812 16.3145L3.33345 9.99978L9.64812 3.6851L10.4789 4.50134Z","fill":"#3E3E3E"})));
}

IcArrowBackComponent.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IcArrowBackComponent;

IcArrowBackComponent.default = IcArrowBackComponent;


/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcInfoComponent (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.5918 9.74167V6.59167H7.40846V9.74167H6.5918ZM7.29201 4.95856C7.21464 5.03592 7.12134 5.07501 7.00013 5.07501C6.87892 5.07501 6.78562 5.03592 6.70825 4.95856C6.63088 4.88119 6.5918 4.78788 6.5918 4.66667C6.5918 4.54547 6.63088 4.45216 6.70825 4.37479C6.78562 4.29743 6.87892 4.25834 7.00013 4.25834C7.12134 4.25834 7.21464 4.29743 7.29201 4.37479C7.36938 4.45216 7.40846 4.54547 7.40846 4.66667C7.40846 4.78788 7.36938 4.88119 7.29201 4.95856ZM7.00013 12.6583C6.21596 12.6583 5.48133 12.5097 4.79446 12.2133C4.1042 11.9154 3.50551 11.5121 2.99679 11.0033C2.48807 10.4946 2.0847 9.89594 1.78685 9.20567C1.49046 8.51881 1.3418 7.78418 1.3418 7.00001C1.3418 6.21584 1.49046 5.48121 1.78685 4.79434C2.0847 4.10408 2.48807 3.50539 2.99679 2.99667C3.50551 2.48795 4.1042 2.08458 4.79446 1.78673C5.48133 1.49034 6.21596 1.34167 7.00013 1.34167C7.7843 1.34167 8.51893 1.49034 9.2058 1.78673C9.89606 2.08458 10.4948 2.48795 11.0035 2.99667C11.5122 3.50539 11.9156 4.10408 12.2134 4.79434C12.5098 5.48121 12.6585 6.21584 12.6585 7.00001C12.6585 7.78418 12.5098 8.51881 12.2134 9.20567C11.9156 9.89594 11.5122 10.4946 11.0035 11.0033C10.4948 11.5121 9.89606 11.9154 9.2058 12.2133C8.51893 12.5097 7.7843 12.6583 7.00013 12.6583ZM7.00013 11.8417C8.34834 11.8417 9.49662 11.3718 10.4343 10.4342C11.372 9.4965 11.8418 8.34822 11.8418 7.00001C11.8418 5.6518 11.372 4.50352 10.4343 3.56585C9.49662 2.62817 8.34834 2.15834 7.00013 2.15834C5.65192 2.15834 4.50364 2.62817 3.56597 3.56585C2.6283 4.50352 2.15846 5.6518 2.15846 7.00001C2.15846 8.34822 2.6283 9.4965 3.56597 10.4342C4.50364 11.3718 5.65192 11.8417 7.00013 11.8417Z","fill":"#3E3E3E"}));
}

IcInfoComponent.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = IcInfoComponent;

IcInfoComponent.default = IcInfoComponent;


/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcResultComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-result"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M3.3751 2.94336L4.5001 1.81836L5.6251 2.94336L6.7501 1.81836L7.8751 2.94336L9.0001 1.81836L10.1251 2.94336L11.2501 1.81836L12.3751 2.94336L13.5001 1.81836L14.6251 2.94336L15.5251 2.04336V15.957L14.6251 15.057L13.5001 16.182L12.3751 15.057L11.2501 16.182L10.1251 15.057L9.0001 16.182L7.8751 15.057L6.7501 16.182L5.6251 15.057L4.5001 16.182L3.3751 15.057L2.4751 15.957V2.04336L3.3751 2.94336ZM3.5251 3.45016V14.5502H14.4751V3.45016H3.5251ZM4.7251 12.5252V11.4752H13.2751V12.5252H4.7251ZM4.7251 9.52516V8.47516H13.2751V9.52516H4.7251ZM4.7251 6.52516V5.47516H13.2751V6.52516H4.7251Z","fill":"#3E3E3E"})));
}

IcResultComponent.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = IcResultComponent;

IcResultComponent.default = IcResultComponent;


/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcSearchComponent (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.6041 50.7726C12.6041 50.7726 32.3968 49.98 36.674 17.445C40.4723 -11.4492 73.848 1.70238 83.4957 13.2203C95.9933 28.1408 89.3312 53.8071 105.498 57.0495C121.666 60.2919 111.108 96.3418 86.5672 92.8912C56.039 88.5988 63.4251 106.438 54.2607 113.988C47.6836 119.407 20.7151 114.191 19.8163 94.5193C19.0599 77.966 12.0774 78.0185 7.12815 76.1415C-0.00982624 73.4344 -4.50754 53.8294 12.6041 50.7726Z","fill":"#93C13E","fillOpacity":"0.2","key":0}),React.createElement("path",{"d":"M79.8881 86.9046L60.4424 67.6896L56.5918 71.5864L76.0376 90.8013L79.8881 86.9046Z","fill":"#006736","key":1}),React.createElement("path",{"d":"M87.3163 92.0679L72.1874 77.1186C72.1032 77.0354 71.9674 77.0362 71.8842 77.1204L66.1581 82.9153C66.0748 82.9996 66.0756 83.1353 66.1599 83.2186L81.2887 98.1679C81.3729 98.2511 81.5087 98.2503 81.5919 98.1661L87.3181 92.3711C87.4013 92.2869 87.4005 92.1511 87.3163 92.0679Z","fill":"url(#paint0_linear_1594_32853)","key":2}),React.createElement("path",{"d":"M43.2075 77.3532C56.5856 77.3532 67.4307 66.5081 67.4307 53.13C67.4307 39.7519 56.5856 28.9069 43.2075 28.9069C29.8294 28.9069 18.9844 39.7519 18.9844 53.13C18.9844 66.5081 29.8294 77.3532 43.2075 77.3532Z","fill":"url(#paint1_linear_1594_32853)","key":3}),React.createElement("path",{"d":"M43.2075 73.401C54.4026 73.401 63.4781 64.3255 63.4781 53.1303C63.4781 41.9351 54.4026 32.8596 43.2075 32.8596C32.0123 32.8596 22.9368 41.9351 22.9368 53.1303C22.9368 64.3255 32.0123 73.401 43.2075 73.401Z","fill":"#E9F3D8","key":4}),React.createElement("path",{"d":"M70.453 49.39L75.6294 30.0715L85.2887 32.6597L89.5313 40.0082L85.9078 53.5312L70.453 49.39ZM82.511 39.1624L83.8051 34.3328L77.0436 32.521L72.9025 47.9758L84.4936 51.0817L87.3406 40.4565L82.511 39.1624Z","fill":"#93C13E","key":5}),React.createElement("path",{"d":"M37.8406 97.4615L30.5601 84.8513L36.8652 81.2111L42.8324 82.81L47.9287 91.6371L37.8406 97.4615ZM38.7828 85.9887L36.9627 82.8361L32.5491 85.3843L38.3735 95.4724L45.9397 91.1041L41.9354 84.1685L38.7828 85.9887Z","fill":"#93C13E","key":6}),React.createElement("defs",{"key":7},[React.createElement("linearGradient",{"id":"paint0_linear_1594_32853","x1":"98.3293","y1":"99.4014","x2":"73.8092","y2":"75.1723","gradientUnits":"userSpaceOnUse","key":0},[React.createElement("stop",{"stopColor":"#006736","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#93C13E","key":1})]),React.createElement("linearGradient",{"id":"paint1_linear_1594_32853","x1":"95.952","y1":"14.6462","x2":"18.9844","y2":"14.6462","gradientUnits":"userSpaceOnUse","key":1},[React.createElement("stop",{"stopColor":"#006736","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#93C13E","key":1})])])]);
}

IcSearchComponent.defaultProps = {"width":"114","height":"116","viewBox":"0 0 114 116","fill":"none"};

module.exports = IcSearchComponent;

IcSearchComponent.default = IcSearchComponent;


/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcLeftComponent (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"<","fillRule":"evenodd","clipRule":"evenodd","d":"M0.49999 8C0.49999 8.26562 0.609365 8.51562 0.796865 8.70312L7.79687 15.7031C7.98437 15.8906 8.23437 16 8.5 16C9.04687 16 9.5 15.5469 9.5 15L9.5 1C9.5 0.453125 9.04687 0 8.5 0C8.23437 0 7.98437 0.109375 7.79687 0.296875L0.796865 7.29687C0.609365 7.48437 0.49999 7.73437 0.49999 8Z","fill":"#9C9C9C"}));
}

IcLeftComponent.defaultProps = {"width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"};

module.exports = IcLeftComponent;

IcLeftComponent.default = IcLeftComponent;


/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcRightComponent (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"<","fillRule":"evenodd","clipRule":"evenodd","d":"M9.50001 8C9.50001 7.73438 9.39064 7.48438 9.20314 7.29688L2.20313 0.296875C2.01563 0.109375 1.76563 0 1.5 0C0.953126 0 0.5 0.453125 0.5 1V15C0.5 15.5469 0.953126 16 1.5 16C1.76563 16 2.01563 15.8906 2.20313 15.7031L9.20314 8.70312C9.39064 8.51562 9.50001 8.26562 9.50001 8Z","fill":"#9C9C9C"}));
}

IcRightComponent.defaultProps = {"width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"};

module.exports = IcRightComponent;

IcRightComponent.default = IcRightComponent;


/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcAddComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-add"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M9.4165 15.8991V10.8991H4.4165V9.73242H9.4165V4.73242H10.5832V9.73242H15.5832V10.8991H10.5832V15.8991H9.4165Z","fill":"white"})));
}

IcAddComponent.defaultProps = {"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none"};

module.exports = IcAddComponent;

IcAddComponent.default = IcAddComponent;


/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcWinnerComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-winner_1"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M4.93934 10.9207L2.65723 7.21668L5.82207 2.08447H12.178L15.3429 7.21668L13.0608 10.9207V16.5473L9.00005 15.1938L4.93934 16.5473V10.9207ZM5.91791 12.3488V15.1889L9.00005 14.1679L12.0822 15.1889V12.3488H5.91791ZM11.6255 3.06305H6.37462L3.80697 7.21663L6.37462 11.3702H11.6255L14.1931 7.21663L11.6255 3.06305ZM8.25052 8.42815L6.73219 6.90982L6.0331 7.60892L8.24913 9.80936L11.9665 6.07553L11.2698 5.39102L8.25052 8.42815Z","fill":"#006736"})));
}

IcWinnerComponent.defaultProps = {"width":"18","height":"19","viewBox":"0 0 18 19","fill":"none"};

module.exports = IcWinnerComponent;

IcWinnerComponent.default = IcWinnerComponent;


/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcAddComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-add"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M9.4165 15.8991V10.8991H4.4165V9.73242H9.4165V4.73242H10.5832V9.73242H15.5832V10.8991H10.5832V15.8991H9.4165Z","fill":"white"})));
}

IcAddComponent.defaultProps = {"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none"};

module.exports = IcAddComponent;

IcAddComponent.default = IcAddComponent;


/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcWinnerComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-winner_1"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M4.93934 10.9207L2.65723 7.21668L5.82207 2.08447H12.178L15.3429 7.21668L13.0608 10.9207V16.5473L9.00005 15.1938L4.93934 16.5473V10.9207ZM5.91791 12.3488V15.1889L9.00005 14.1679L12.0822 15.1889V12.3488H5.91791ZM11.6255 3.06305H6.37462L3.80697 7.21663L6.37462 11.3702H11.6255L14.1931 7.21663L11.6255 3.06305ZM8.25052 8.42815L6.73219 6.90982L6.0331 7.60892L8.24913 9.80936L11.9665 6.07553L11.2698 5.39102L8.25052 8.42815Z","fill":"#006736"})));
}

IcWinnerComponent.defaultProps = {"width":"18","height":"19","viewBox":"0 0 18 19","fill":"none"};

module.exports = IcWinnerComponent;

IcWinnerComponent.default = IcWinnerComponent;


/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcSortComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-sort"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M2.75 14.75V13.5833H7.25V14.75H2.75ZM2.75 10.5833V9.41667H12.25V10.5833H2.75ZM2.75 6.41667V5.25H17.25V6.41667H2.75Z","fill":"#006736"})));
}

IcSortComponent.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IcSortComponent;

IcSortComponent.default = IcSortComponent;


/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcShareComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-share"},React.createElement("path",{"id":"ic-partilhar-gray","fillRule":"evenodd","clipRule":"evenodd","d":"M13.1667 14.1369C13.6208 13.6415 14.275 13.3332 15 13.3332C16.3792 13.3332 17.5 14.454 17.5 15.8332C17.5 17.2119 16.3792 18.3332 15 18.3332C13.6208 18.3332 12.5 17.2119 12.5 15.8332C12.5 15.5665 12.5417 15.3123 12.6167 15.0707L6.83333 11.6957C6.37917 12.1911 5.725 12.4998 5 12.4998C3.62083 12.4998 2.5 11.3786 2.5 9.99984C2.5 8.62067 3.62083 7.49984 5 7.49984C5.725 7.49984 6.37917 7.80817 6.83333 8.304L12.6167 4.929C12.5417 4.68734 12.5 4.43317 12.5 4.1665C12.5 2.78734 13.6208 1.6665 15 1.6665C16.3792 1.6665 17.5 2.78734 17.5 4.1665C17.5 5.54567 16.3792 6.6665 15 6.6665C14.275 6.6665 13.6208 6.35775 13.1667 5.86192L7.38333 9.23734C7.45833 9.479 7.5 9.73275 7.5 9.99984C7.5 10.2665 7.45833 10.5207 7.38333 10.7623L13.1667 14.1369ZM13.5833 4.1665C13.5833 3.38692 14.2208 2.74984 15 2.74984C15.7792 2.74984 16.4167 3.38692 16.4167 4.1665C16.4167 4.94567 15.7792 5.58317 15 5.58317C14.6792 5.58317 14.3833 5.47484 14.1458 5.2915C13.8542 5.07067 13.65 4.73734 13.6 4.35817C13.5875 4.29567 13.5833 4.23317 13.5833 4.1665ZM3.58333 9.99984C3.58333 10.779 4.22083 11.4165 5 11.4165C5.32083 11.4165 5.61667 11.3078 5.85417 11.1248C6.14583 10.904 6.35 10.5707 6.4 10.1915C6.4125 10.129 6.41667 10.0665 6.41667 9.99984C6.41667 9.93275 6.4125 9.87067 6.4 9.80817C6.35 9.42859 6.14583 9.09567 5.85417 8.87442C5.61667 8.69109 5.32083 8.58317 5 8.58317C4.22083 8.58317 3.58333 9.22025 3.58333 9.99984ZM13.5833 15.8332C13.5833 16.6123 14.2208 17.2498 15 17.2498C15.7792 17.2498 16.4167 16.6123 16.4167 15.8332C16.4167 15.0536 15.7792 14.4161 15 14.4161C14.6792 14.4161 14.3833 14.5248 14.1458 14.7078C13.8542 14.929 13.65 15.2619 13.6 15.6415C13.5875 15.704 13.5833 15.7661 13.5833 15.8332Z","fill":"#3E3E3E"})));
}

IcShareComponent.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IcShareComponent;

IcShareComponent.default = IcShareComponent;


/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcBrandColorComponent (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icons/ic-brand-color"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2},[React.createElement("linearGradient",{"x1":"158.87207%","y1":"50%","x2":"-2.22044605e-14%","y2":"50%","id":"linearGradient-1","key":0},[React.createElement("stop",{"stopColor":"#006736","offset":"0%","key":0}),React.createElement("stop",{"stopColor":"#93C13E","offset":"100%","key":1})]),React.createElement("path",{"d":"M40.0211403,18.8096986 L27.3886995,18.8096986 L27.3886995,4.81391779 C27.3886995,2.15531837 25.2338121,0 22.5752126,0 C19.9166132,0 17.7617257,2.15531837 17.7617257,4.81391779 L17.7617257,11.0278015 C17.7617257,11.7922027 18.0650732,12.5251488 18.6054109,13.0654865 L28.4038795,22.8635242 C29.0312572,23.4913328 29.0312572,24.5090981 28.4038795,25.1364758 L18.6054109,34.9349444 C18.0650732,35.4752821 17.7617257,36.2077973 17.7617257,36.9717676 L17.7617257,43.1860822 C17.7617257,45.8446816 19.9166132,48 22.5752126,48 C25.2338121,48 27.3886995,45.8446816 27.3886995,43.1860822 L27.3886995,28.4371033 L40.181001,28.4371033 C42.8693319,28.4371033 45.0431786,26.2335251 44.9936261,23.5335601 C44.9453662,20.8835786 42.6715528,18.8096986 40.0211403,18.8096986 M19.021652,30.9711752 L24.9601961,25.0322001 C25.5302653,24.4621309 25.5302653,23.5378691 24.9601961,22.967369 L19.021652,17.0288248 C18.5567202,16.5638931 17.7617257,16.8930941 17.7617257,17.5506342 L17.7617257,18.8096986 L4.97373325,18.8096986 C2.32288987,18.8096986 0.0495072867,20.8835786 0.000816567945,23.5335601 C-0.0483050422,26.2335251 2.12511076,28.4371033 4.81387257,28.4371033 L17.7617257,28.4371033 L17.7617257,30.4493658 C17.7617257,31.1069059 18.5567202,31.4361069 19.021652,30.9711752","id":"path-2","key":1})]),React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","opacity":"0.800000012","key":3},React.createElement("g",{"id":"buttons/btn-view-more/gray","transform":"translate(-11.000000, 0.000000)"},React.createElement("g",{"id":"buttons/btn-view-more"},React.createElement("g",{"id":"icons/ic-brand-color","transform":"translate(11.000000, 0.000000)"},[React.createElement("mask",{"id":"mask-3","fill":"white","key":0},React.createElement("use",{"xlinkHref":"#path-2"})),React.createElement("use",{"fill":"url(#linearGradient-1)","xlinkHref":"#path-2","key":1})]))))]);
}

IcBrandColorComponent.defaultProps = {"width":"65px","height":"65px","viewBox":"0 0 45 48","version":"1.1"};

module.exports = IcBrandColorComponent;

IcBrandColorComponent.default = IcBrandColorComponent;


/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function LogoComponent (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icons/ic-brand-color"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2},[React.createElement("linearGradient",{"x1":"158.87207%","y1":"50%","x2":"-2.22044605e-14%","y2":"50%","id":"linearGradient-1","key":0},[React.createElement("stop",{"stopColor":"#006736","offset":"0%","key":0}),React.createElement("stop",{"stopColor":"#93C13E","offset":"100%","key":1})]),React.createElement("path",{"d":"M40.0211403,18.8096986 L27.3886995,18.8096986 L27.3886995,4.81391779 C27.3886995,2.15531837 25.2338121,0 22.5752126,0 C19.9166132,0 17.7617257,2.15531837 17.7617257,4.81391779 L17.7617257,11.0278015 C17.7617257,11.7922027 18.0650732,12.5251488 18.6054109,13.0654865 L28.4038795,22.8635242 C29.0312572,23.4913328 29.0312572,24.5090981 28.4038795,25.1364758 L18.6054109,34.9349444 C18.0650732,35.4752821 17.7617257,36.2077973 17.7617257,36.9717676 L17.7617257,43.1860822 C17.7617257,45.8446816 19.9166132,48 22.5752126,48 C25.2338121,48 27.3886995,45.8446816 27.3886995,43.1860822 L27.3886995,28.4371033 L40.181001,28.4371033 C42.8693319,28.4371033 45.0431786,26.2335251 44.9936261,23.5335601 C44.9453662,20.8835786 42.6715528,18.8096986 40.0211403,18.8096986 M19.021652,30.9711752 L24.9601961,25.0322001 C25.5302653,24.4621309 25.5302653,23.5378691 24.9601961,22.967369 L19.021652,17.0288248 C18.5567202,16.5638931 17.7617257,16.8930941 17.7617257,17.5506342 L17.7617257,18.8096986 L4.97373325,18.8096986 C2.32288987,18.8096986 0.0495072867,20.8835786 0.000816567945,23.5335601 C-0.0483050422,26.2335251 2.12511076,28.4371033 4.81387257,28.4371033 L17.7617257,28.4371033 L17.7617257,30.4493658 C17.7617257,31.1069059 18.5567202,31.4361069 19.021652,30.9711752","id":"path-2","key":1})]),React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","opacity":"0.800000012","key":3},React.createElement("g",{"id":"buttons/btn-view-more/gray","transform":"translate(-11.000000, 0.000000)"},React.createElement("g",{"id":"buttons/btn-view-more"},React.createElement("g",{"id":"icons/ic-brand-color","transform":"translate(11.000000, 0.000000)"},[React.createElement("mask",{"id":"mask-3","fill":"white","key":0},React.createElement("use",{"xlinkHref":"#path-2"})),React.createElement("use",{"fill":"url(#linearGradient-1)","xlinkHref":"#path-2","key":1})]))))]);
}

LogoComponent.defaultProps = {"width":"45px","height":"48px","viewBox":"0 0 45 48","version":"1.1"};

module.exports = LogoComponent;

LogoComponent.default = LogoComponent;


/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function RemoveComponent (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"simuladores/icons/ic-remove"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Simulador-Avancado---Desktop","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"simul_avancado_etapa4_desktop","transform":"translate(-1166.000000, -1112.000000)","fillRule":"nonzero","fill":"#BABABA"},React.createElement("g",{"id":"consumo-eletricidade","transform":"translate(0.000000, 878.000000)"},React.createElement("g",{"id":"content","transform":"translate(226.000000, 80.000000)"},React.createElement("g",{"id":"box","transform":"translate(0.000000, 100.000000)"},React.createElement("g",{"id":"content","transform":"translate(24.000000, 24.000000)"},React.createElement("path",{"d":"M928.063097,46 C924.590956,45.9530792 921.118815,45.9061584 917.646674,45.8592375 C917.083625,45.6715543 916.849021,45.3431085 916.849021,44.7331378 C916.849021,43.888563 916.895941,42.9970674 916.895941,42.1524927 C916.942862,39.8064516 916.942862,37.4604106 916.989783,35.1143695 C916.989783,34.973607 916.989783,34.9266862 916.8021,34.8797654 C916.285971,34.7859238 915.957525,34.3636364 916.004446,33.8475073 C916.004446,33.5190616 916.004446,33.2375367 916.004446,32.9090909 C916.004446,32.2991202 916.426733,31.8768328 917.083625,31.8768328 C917.97512,31.8768328 918.913537,31.9237537 919.805032,31.9237537 C919.992716,31.9237537 919.992716,31.9237537 920.039636,31.7360704 C920.039636,31.5014663 920.039636,31.2668622 920.039636,31.0791789 C920.039636,30.4692082 920.27424,30.1876833 920.83729,30 C922.338757,30 923.793302,30.0469208 925.294768,30.0469208 C925.341689,30.0469208 925.341689,30.0938416 925.38861,30.0938416 C925.857818,30.2815249 926.045501,30.6099707 926.045501,31.1260997 C926.045501,31.3607038 926.045501,31.5953079 926.045501,31.829912 C926.045501,32.0645161 926.045501,32.0645161 926.280106,32.0645161 C927.218522,32.0645161 928.156938,32.111437 929.048434,32.111437 C929.564563,32.111437 930.033771,32.5806452 929.98685,33.0967742 C929.98685,33.4252199 929.98685,33.8005865 929.98685,34.1290323 C929.98685,34.5982405 929.658405,34.973607 929.189196,35.1143695 C928.954592,35.1612903 928.954592,35.1143695 928.954592,35.3958944 C928.907672,38.6334311 928.860751,41.8709677 928.81383,45.0615836 C928.81383,45.1554252 928.81383,45.2492669 928.766909,45.2961877 C928.766909,45.6715543 928.485384,45.9061584 928.063097,46 Z M927.922334,40.0410557 C927.922334,38.4457478 927.969255,36.8504399 927.969255,35.255132 C927.969255,35.0205279 927.969255,35.0205279 927.734651,35.0205279 C927.218522,35.0205279 926.702393,35.0205279 926.186264,35.0205279 C925.95166,35.0205279 925.95166,35.0205279 925.95166,35.255132 C925.904739,37.6480938 925.857818,40.0410557 925.857818,42.4809384 C925.857818,42.8093842 925.670135,43.0439883 925.341689,42.9970674 C925.060164,42.9970674 924.82556,42.7624633 924.82556,42.4340176 C924.82556,41.5894428 924.872481,40.744868 924.872481,39.9002933 C924.872481,38.3519062 924.919402,36.7565982 924.919402,35.2082111 C924.919402,35.0205279 924.919402,35.0205279 924.731718,35.0205279 C924.356352,35.0205279 924.027906,35.0205279 923.65254,35.0205279 C923.511777,35.0205279 923.464856,35.0674487 923.464856,35.2082111 C923.464856,35.6304985 923.464856,36.0058651 923.464856,36.4281525 C923.417935,38.4457478 923.417935,40.4633431 923.371015,42.4809384 C923.371015,42.8093842 923.136411,42.9970674 922.854886,42.9970674 C922.573361,42.9970674 922.338757,42.7624633 922.338757,42.4809384 C922.338757,42.2463343 922.338757,42.0117302 922.338757,41.8240469 C922.385677,39.6187683 922.385677,37.4604106 922.432598,35.255132 C922.432598,35.0674487 922.432598,35.0674487 922.197994,35.0674487 C921.869548,35.0674487 921.494182,35.0674487 921.165736,35.0674487 C920.931132,35.0674487 920.931132,35.0674487 920.931132,35.3020528 C920.884211,37.6950147 920.83729,40.0410557 920.83729,42.4340176 C920.83729,42.5278592 920.83729,42.6217009 920.83729,42.6686217 C920.79037,42.9032258 920.555765,43.0439883 920.27424,43.0439883 C920.039636,42.9970674 919.851953,42.8093842 919.851953,42.4809384 C919.898874,40.1348974 919.898874,37.8357771 919.945795,35.4897361 C919.945795,35.0205279 919.945795,35.0205279 919.523507,35.0205279 C919.054299,35.0205279 918.632012,35.0205279 918.162804,35.0205279 C918.022041,35.0205279 917.97512,35.0674487 917.97512,35.1612903 C917.97512,35.2082111 917.97512,35.3020528 917.97512,35.3489736 C917.928199,37.601173 917.928199,39.8533724 917.881279,42.1055718 C917.881279,42.9970674 917.881279,43.8416422 917.834358,44.7331378 C917.834358,44.8739003 917.881279,44.9208211 918.022041,44.9208211 C918.068962,44.9208211 918.115883,44.9208211 918.162804,44.9208211 C921.306499,44.9677419 924.450194,45.0146628 927.546968,45.0615836 C927.781572,45.0615836 927.781572,45.0615836 927.781572,44.8269795 C927.875413,43.1847507 927.922334,41.6363636 927.922334,40.0410557 Z M923.042569,33.941349 C923.042569,33.941349 923.042569,33.941349 923.042569,33.941349 C923.65254,33.941349 924.26251,33.941349 924.872481,33.9882698 C926.186264,33.9882698 927.500047,34.0351906 928.81383,34.0351906 C928.954592,34.0351906 929.048434,33.9882698 929.001513,33.8475073 C929.001513,33.7067449 929.001513,33.5659824 929.001513,33.4252199 C929.001513,33.0498534 929.048434,33.0967742 928.673067,33.0967742 C926.420868,33.0498534 924.121748,33.0498534 921.869548,33.0029326 C920.321161,33.0029326 918.819695,32.9560117 917.271308,32.9560117 C917.083625,32.9560117 917.083625,32.9560117 917.083625,33.143695 C917.083625,33.3313783 917.083625,33.5190616 917.083625,33.7067449 C917.083625,33.941349 917.083625,33.941349 917.318229,33.941349 C919.241982,33.8944282 921.118815,33.941349 923.042569,33.941349 Z M923.136411,30.9853372 C922.52644,30.9853372 921.916469,30.9853372 921.353419,30.9384164 C921.212657,30.9384164 921.165736,30.9853372 921.165736,31.1260997 C921.165736,31.313783 921.165736,31.5483871 921.165736,31.7360704 C921.165736,31.8768328 921.212657,31.9237537 921.306499,31.9237537 C922.52644,31.9237537 923.746381,31.9706745 924.966323,31.9706745 C925.107085,31.9706745 925.154006,31.9237537 925.154006,31.7829912 C925.154006,31.5953079 925.154006,31.4076246 925.154006,31.2199413 C925.154006,30.9853372 925.154006,30.9853372 924.919402,30.9853372 C924.26251,31.0322581 923.69946,30.9853372 923.136411,30.9853372 Z","id":"simuladores/icons/ic-remove"})))))))]);
}

RemoveComponent.defaultProps = {"width":"14px","height":"16px","viewBox":"0 0 14 16","version":"1.1"};

module.exports = RemoveComponent;

RemoveComponent.default = RemoveComponent;


/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function ChangeComponent (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"ic-simulador-avancado"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2},React.createElement("linearGradient",{"x1":"158.87207%","y1":"50%","x2":"-2.22044605e-14%","y2":"50%","id":"linearGradient-1"},[React.createElement("stop",{"stopColor":"#006736","offset":"0%","key":0}),React.createElement("stop",{"stopColor":"#93C13E","offset":"100%","key":1})])),React.createElement("g",{"id":"ICONES-ADENE","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"icons","transform":"translate(-216.000000, -1205.000000)","fillRule":"nonzero","fill":"url(#linearGradient-1)"},React.createElement("g",{"id":"simuladores","transform":"translate(11.000000, 1204.000000)"},React.createElement("path",{"d":"M240.3,32.9 L240.3,4.4 C240.3,2.6 238.8,1.1 237,1.1 L208.5,1.1 C206.7,1.1 205.2,2.6 205.2,4.4 L205.2,32.9 C205.2,34.7 206.7,36.2 208.5,36.2 L237,36.2 C238.8,36.2 240.3,34.7 240.3,32.9 Z M208.5,34 C207.9,34 207.4,33.5 207.4,32.9 L207.4,4.4 C207.4,3.8 207.9,3.3 208.5,3.3 L237,3.3 C237.6,3.3 238.1,3.8 238.1,4.4 L238.1,32.9 C238.1,33.5 237.6,34 237,34 L208.5,34 Z M225.8,20.3 L225.8,19.7 L227.4,19.7 L227.4,19.7 C228,19.7 228.5,19.2 228.5,18.6 C228.5,18 228,17.5 227.4,17.5 L225.8,17.5 L225.8,17 C225.8,16.4 225.3,15.9 224.7,15.9 C224.1,15.9 223.6,16.4 223.6,17 C223.6,17 223.6,17 223.6,17 L223.6,17.5 L213.2,17.5 C212.6,17.5 212.1,18 212.1,18.6 C212.1,19.2 212.6,19.7 213.2,19.7 L213.2,19.7 L223.6,19.7 L223.6,20.2 C223.6,20.2 223.6,20.2 223.6,20.2 C223.6,20.8 224.1,21.3 224.7,21.3 C225.3,21.4 225.8,20.9 225.8,20.3 Z M216.5,12.1 L216.5,11.6 L227.4,11.6 L227.4,11.6 C228,11.6 228.5,11.1 228.5,10.5 C228.5,9.9 228,9.4 227.4,9.4 L216.5,9.4 L216.5,8.8 C216.5,8.2 216,7.7 215.4,7.7 C214.8,7.7 214.3,8.2 214.3,8.8 C214.3,8.8 214.3,8.8 214.3,8.8 L214.3,9.4 L213.2,9.4 C212.6,9.4 212.1,9.9 212.1,10.5 C212.1,11.1 212.6,11.6 213.2,11.6 L213.2,11.6 L214.3,11.6 L214.3,12.1 C214.3,12.1 214.3,12.1 214.3,12.1 C214.3,12.7 214.8,13.2 215.4,13.2 C216,13.2 216.5,12.7 216.5,12.1 Z M220.9,28.5 L220.9,27.9 L227.5,27.9 L227.5,27.9 C228.1,27.9 228.6,27.4 228.6,26.8 C228.6,26.2 228.1,25.7 227.5,25.7 L220.9,25.7 L220.9,25.2 C220.9,24.6 220.4,24.1 219.8,24.1 C219.2,24.1 218.7,24.6 218.7,25.2 C218.7,25.2 218.7,25.2 218.7,25.2 L218.7,25.7 L213.2,25.7 C212.6,25.7 212.1,26.2 212.1,26.8 C212.1,27.4 212.6,27.9 213.2,27.9 L213.2,27.9 L218.7,27.9 L218.7,28.4 C218.7,28.4 218.7,28.4 218.7,28.4 C218.7,29 219.2,29.5 219.8,29.5 C220.4,29.6 220.9,29.1 220.9,28.5 Z M231.9,19.7 C232.507513,19.7 233,19.2075132 233,18.6 C233,17.9924868 232.507513,17.5 231.9,17.5 C231.292487,17.5 230.8,17.9924868 230.8,18.6 C230.8,19.2075132 231.292487,19.7 231.9,19.7 Z M231.9,28 C232.507513,28 233,27.5075132 233,26.9 C233,26.2924868 232.507513,25.8 231.9,25.8 C231.292487,25.8 230.8,26.2924868 230.8,26.9 C230.8,27.5075132 231.292487,28 231.9,28 Z M231.9,11.5 C232.507513,11.5 233,11.0075132 233,10.4 C233,9.79248678 232.507513,9.3 231.9,9.3 C231.292487,9.3 230.8,9.79248678 230.8,10.4 C230.8,11.0075132 231.292487,11.5 231.9,11.5 Z","id":"ic-simulador-avancado"}))))]);
}

ChangeComponent.defaultProps = {"width":"36px","height":"36px","viewBox":"0 0 36 36","version":"1.1"};

module.exports = ChangeComponent;

ChangeComponent.default = ChangeComponent;


/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function ElectricityComponent (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"d":"M28,41.3148834 C27.9999986,41.1528071 28.0349943,40.9900798 28.10583,40.8379028 L37.4880435,20.6705147 C37.6782367,20.2626263 38.0948972,20 38.5527335,20 L51.5094037,20 C51.9476325,20 52.3476266,20.2385762 52.5495844,20.6195286 C52.6373967,20.7859767 52.6808524,20.9673005 52.6808511,21.1480134 L52.6808511,21.1480134 C52.6808493,21.3809009 52.6086746,21.6127736 52.4662523,21.8104858 L43.045804,34.9052429 L49.7221754,34.9052429 C50.178051,34.9052429 50.5927507,35.1649832 50.7849047,35.5719096 C50.9760783,35.976912 50.910393,36.4550265 50.6162798,36.7955748 L30.9577484,59.5930736 C30.7293204,59.8595479 30.3979528,60 30.063644,60 C29.8656077,60 29.6646303,59.9519 29.4832605,59.8480038 C28.9920913,59.5728716 28.7724867,58.994709 28.9587585,58.4723425 L34.6694579,42.4627225 L29.17052,42.4627225 C28.7724867,42.4627225 28.401904,42.2645503 28.1862209,41.9355459 C28.0627499,41.7477532 28.0000019,41.5319019 28,41.3148834 L28,41.3148834 L28,41.3148834 Z M39.3056635,22.2962963 L30.9920616,40.1673882 L36.318453,40.1673882 C36.6988395,40.1673882 37.0547166,40.3463203 37.2733408,40.6503127 C37.4929454,40.954305 37.5498073,41.3439153 37.4243189,41.6940837 L33.2606553,53.3660414 L47.1986835,37.2025012 L40.7870141,37.2025012 C40.3497657,37.2025012 39.9487912,36.963925 39.7478138,36.5829726 C39.545856,36.2020202 39.5791889,35.7421837 39.8301655,35.3910534 L49.2506138,22.2962963 L39.3056635,22.2962963 Z","id":"path-1"})),React.createElement("g",{"id":"UI---Desktop","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"comercializadores_desktop","transform":"translate(-558.000000, -412.000000)"},React.createElement("g",{"id":"section---comercializadores","transform":"translate(0.000000, 96.000000)"},React.createElement("g",{"id":"content","transform":"translate(130.000000, 120.000000)"},React.createElement("g",{"id":"selector","transform":"translate(397.000000, 176.000000)"},React.createElement("g",{"id":"eletricidade"},React.createElement("g",{"id":"box","transform":"translate(3.000000, 0.000000)"},[React.createElement("mask",{"id":"mask-2","fill":"white","key":0},React.createElement("use",{"xlinkHref":"#path-1"})),React.createElement("use",{"id":"icons/ic-eletricidade","fill":"#3E3E3E","xlinkHref":"#path-1","key":1})])))))))]);
}

ElectricityComponent.defaultProps = {"width":"25px","height":"40px","preserveAspectRatio":"xMidYMin slice","viewBox":"0 0 25 40","version":"1.1"};

module.exports = ElectricityComponent;

ElectricityComponent.default = ElectricityComponent;


/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function ElectricityplusgasComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"UI---Desktop","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","width":"48px","height":"40px"},React.createElement("g",{"id":"comercializadores_desktop","transform":"translate(-818.000000, -412.000000)","fill":"#3E3E3E"},React.createElement("g",{"id":"section---comercializadores","transform":"translate(0.000000, 96.000000)"},React.createElement("g",{"id":"content","transform":"translate(130.000000, 120.000000)"},React.createElement("g",{"id":"selector","transform":"translate(397.000000, 176.000000)"},React.createElement("g",{"id":"eletricidade+gas","transform":"translate(253.000000, 0.000000)"},React.createElement("g",{"id":"box","transform":"translate(22.000000, 0.000000)"},React.createElement("path",{"d":"M26.2500869,20 C25.8042612,20 25.400419,20.2570082 25.2154913,20.6588936 L25.2154913,20.6588936 L16.103053,40.4753163 C15.9421159,40.8246093 15.9711046,41.2314562 16.1800229,41.5539568 L16.1800229,41.5539568 C16.3899409,41.8774498 16.7507998,42.0719424 17.1376486,42.0719424 L17.1376486,42.0719424 L22.4775615,42.0719424 L16.9317291,57.8020342 C16.7507998,58.3160506 16.9647162,58.884644 17.4405302,59.1545522 L17.4405302,59.1545522 C17.6174611,59.2557678 17.8123849,59.3033987 18.0033103,59.3033987 L18.0033103,59.3033987 C18.3301825,59.3033987 18.6500575,59.1654676 18.8729704,58.9044902 L18.8729704,58.9044902 L30.0975831,45.7355495 C30.0416049,46.2287274 30.0026202,46.7248822 29.9976221,47.2259985 L29.9976221,47.2259985 C29.9696331,50.2277351 30.7943107,52.8007938 32.4506633,54.8727363 L32.4506633,54.8727363 C35.1286166,58.2237658 38.2793851,59.887869 42.1228828,59.9642769 L42.1228828,59.9642769 C42.8575956,59.9632845 43.3713948,59.5107914 43.4003835,58.8360208 L43.4003835,58.8360208 C43.4313714,58.1463657 42.9135738,57.6293724 42.1108875,57.5529645 L42.1108875,57.5529645 C38.1524347,57.1719176 35.2825564,55.2567601 33.5832207,51.8600843 L33.5832207,51.8600843 C31.8728892,48.4395932 32.1297887,44.8593401 34.3689136,40.9159018 L34.3689136,40.9159018 C34.5138569,40.6618705 34.6787924,40.4247085 34.8337319,40.1786157 L34.8337319,40.1786157 C34.8337319,40.1786157 39.2080221,34.6415282 39.5169014,34.2813198 L39.5169014,34.2813198 C41.8060067,31.6040685 44.0671229,28.6301166 45.1037177,25.0310097 L45.1037177,25.0310097 C45.2336669,24.5775242 45.463577,24.3483007 45.7844516,24.3483007 L45.7844516,24.3483007 C46.0263571,24.3483007 46.208286,24.4902009 46.3702227,24.615232 L46.3702227,24.615232 L46.451191,24.6767551 C49.8098782,27.1743984 52.3958675,29.490449 54.5900099,31.9642769 L54.5900099,31.9642769 C57.3269401,35.0483751 59.0962485,37.8645497 60.1548348,40.8265939 L60.1548348,40.8265939 C61.9561307,45.8645497 61.2414101,50.4956586 58.030665,54.5919127 L58.030665,54.5919127 C57.0390526,55.8571074 55.7955387,56.8424709 54.3351095,57.5241875 L54.3351095,57.5241875 C53.8113142,57.769288 53.4744459,58.1354503 53.3864803,58.5551972 L53.3864803,58.5551972 C53.3115096,58.9144133 53.4264646,59.2795832 53.7193502,59.6100223 L53.7193502,59.6100223 C53.9482607,59.8690151 54.2411462,60 54.5900099,60 L54.5900099,60 C54.860904,60 55.1527899,59.9206152 55.4576707,59.7638303 L55.4576707,59.7638303 C60.4537179,57.1997023 63.1226747,52.906971 63.6174813,46.6435128 L63.6174813,46.6435128 C63.838395,43.8571074 63.193647,41.0181097 61.5912733,37.7097494 L61.5912733,37.7097494 C59.2961704,32.9764326 55.7265656,29.3227487 52.8726811,26.6683205 L52.8726811,26.6683205 C50.4486286,24.4147854 48.1715186,20.5844704 44.7168689,20.5844704 L44.7168689,20.5844704 C44.1510901,20.5844704 43.1774706,21.4497643 43.1344874,22.0332424 L43.1344874,22.0332424 C43.1084976,22.3954354 43.043523,22.7516745 42.979548,23.0840982 L42.979548,23.0840982 C42.5287242,25.4527413 41.4121606,27.7529149 39.4679205,30.3229968 L39.4679205,30.3229968 C38.5652733,31.5157529 37.5776594,32.6638551 36.6220329,33.7752419 L36.6220329,33.7752419 C36.3741298,34.0630117 36.1252271,34.3547507 35.8763244,34.6464897 L35.8763244,34.6464897 L30.6143811,34.6464897 L39.7638049,21.7802034 C40.0077095,21.4348797 40.039697,20.9833788 39.8447732,20.6092781 L39.8447732,20.6092781 C39.6478502,20.2351774 39.2590022,20 38.8351679,20 L38.8351679,20 L26.2500869,20 Z M26.9798017,22.256512 L36.6400259,22.256512 L27.490602,35.1227983 C27.2456978,35.4691144 27.2147099,35.9196229 27.4106333,36.2937236 C27.6055571,36.6688167 27.9944051,36.9030017 28.4192391,36.9030017 L34.0280468,36.9030017 C33.7361609,37.2810717 21.1090963,52.7859092 21.1090963,52.7859092 L25.1535155,41.3167948 C25.2744682,40.9724634 25.2204893,40.5894319 25.0075726,40.291739 C24.7946558,39.9920615 24.448791,39.8154304 24.0799351,39.8154304 L18.9059575,39.8154304 L26.9798017,22.256512 Z M46.7830613,32.3274622 C47.0029754,32.2034235 47.2198906,32.1399157 47.4278093,32.1399157 C47.6797108,32.1399157 47.9236155,32.2341851 48.1495272,32.419747 C50.9494328,34.7139668 52.7997096,36.932771 53.9722513,39.4016373 C56.1504,43.9861077 55.7735473,48.3423468 52.8187022,52.7174398 L52.7597252,52.8057554 C52.7127436,52.8772017 52.665762,52.9496403 52.6127827,53.0151327 C52.3128999,53.3922104 51.9020605,53.6105185 51.4892218,53.6105185 C51.2453172,53.6105185 51.0134078,53.5360953 50.8014907,53.3922104 C50.2237165,53.0002481 50.1087614,52.3473084 50.493611,51.6467378 C50.6155633,51.4234681 50.7585075,51.2121062 50.9014516,50.9997519 C51.0034117,50.8479286 51.1053719,50.6961052 51.2013344,50.5393203 C53.4564529,46.871744 53.3774838,43.0463905 50.9664262,39.1724138 C50.7735016,38.8608286 50.5565864,38.5611511 50.3396712,38.2644505 L50.0567817,37.8714959 L49.2920806,38.0798809 C49.1701283,39.7201687 49.0591717,41.2046639 48.6373365,42.6544282 C48.3734397,43.5683453 48.0285745,44.2441082 47.5547597,44.7849169 C46.9150097,45.5132721 46.0923313,45.8982883 45.1776888,45.8982883 C44.2770408,45.8982883 43.3514026,45.5261722 42.5027343,44.8226247 C42.0539098,44.4515009 41.8289977,44.2649467 41.5381114,44.2649467 C41.0722934,44.2649467 40.9303489,44.6757628 40.7164325,45.2969486 C39.8757611,47.734061 40.4935197,49.6541801 42.6036949,51.1624907 C43.0705124,51.4978913 43.7662405,52.1905234 43.1824687,53.0786405 C42.9625546,53.4130489 42.6306843,53.58968 42.2228437,53.58968 C41.8899738,53.58968 41.5261161,53.4706028 41.1692555,53.2463409 C38.1854218,51.3669065 37.0338719,47.6894071 38.3693499,44.3036467 C38.8291702,43.1366906 39.4379323,42.0401885 40.1776431,41.0458943 C40.5135118,40.5924088 40.9333478,40.3423468 41.3571821,40.3423468 C41.7800168,40.3423468 42.1928555,40.5934011 42.5187281,41.0478789 C43.0745108,41.8179112 43.5543233,42.3676507 44.0751197,42.830067 C44.3520115,43.0751675 44.6848814,43.3282064 45.0477396,43.3282064 C45.650504,43.3282064 45.9273958,42.6712974 46.0593442,42.3567353 C46.5821398,41.115356 46.620125,39.8104689 46.6141273,38.5790127 C46.6071301,37.0558174 46.4571887,35.4532374 46.1453106,33.5341106 C46.0413512,32.8920863 46.4341977,32.5239395 46.7830613,32.3274622 Z","id":"icons/ic-eletricidade-gas"})))))))));
}

ElectricityplusgasComponent.defaultProps = {"width":"48px","height":"40px","viewBox":"0 0 48 40","version":"1.1"};

module.exports = ElectricityplusgasComponent;

ElectricityplusgasComponent.default = ElectricityplusgasComponent;


/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function GasComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"UI---Desktop","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"comercializadores_desktop","transform":"translate(-689.000000, -412.000000)","fill":"#3E3E3E"},React.createElement("g",{"id":"section---comercializadores","transform":"translate(0.000000, 96.000000)"},React.createElement("g",{"id":"content","transform":"translate(130.000000, 120.000000)"},React.createElement("g",{"id":"selector","transform":"translate(397.000000, 176.000000)"},React.createElement("g",{"id":"gas","transform":"translate(139.000000, 0.000000)"},React.createElement("g",{"id":"box"},React.createElement("path",{"d":"M36.9637116,20 L38.2615906,20 C40.9292454,21.9095454 43.6809356,23.8869899 46.1338336,26.176026 C49.0199803,28.8687362 52.6306983,32.5762121 54.9500735,37.3784444 C56.3497286,40.2795024 57.0276136,42.8233926 57.0425532,45.2845018 L57.0425532,45.4584351 C57.0406857,45.7886292 57.0266799,46.1178933 57.0005355,46.4452971 C56.5000584,52.8017672 53.7997232,57.1584699 48.7473323,59.760958 C48.4401365,59.9200093 48.1450791,60 47.8705637,60 C47.5176153,60 47.2216242,59.8669922 46.9900602,59.603767 C46.6931354,59.2689222 46.5764196,58.8987327 46.6529852,58.5341239 C46.7416891,58.1071968 47.0824991,57.7360772 47.6128554,57.4868039 C49.089076,56.7975817 50.3468048,55.7958377 51.3496264,54.512266 C54.5971251,50.3546099 55.3198289,45.6556214 53.4981297,40.5427276 C52.4262124,37.5365655 50.6381273,34.6792233 47.8705637,31.5493547 C45.652031,29.038949 43.0366648,26.6885246 39.63977,24.1530055 L39.5585358,24.0916173 C39.3942001,23.9651203 39.2093223,23.8209511 38.9646861,23.8209511 C38.6406833,23.8209511 38.4081855,24.052552 38.2765302,24.5120335 C37.2288897,28.1664923 34.942195,31.1828857 32.6265548,33.9007092 C32.3146903,34.2662481 31.999091,34.6308569 31.6844254,34.9945355 C30.1671208,36.7440995 28.5984613,38.5531915 27.4210329,40.6329497 C25.1558139,44.635275 24.8962381,48.2683409 26.6254985,51.7404953 C28.3444878,55.1866062 31.2465079,57.1296361 35.2493908,57.5165678 C36.0617323,57.5937682 36.5855526,58.1183583 36.5547396,58.818742 C36.5248604,59.5033136 36.0047751,59.962795 35.262463,59.9637251 C31.3753621,59.8865248 28.1885556,58.1964888 25.4807505,54.7968841 C23.8056463,52.6938728 22.9708953,50.0839437 23.0007745,47.0377863 C23.0306538,43.805604 24.0820291,40.7603767 26.2155928,37.7263109 C27.280974,36.2102081 28.510691,34.774096 29.6993241,33.3872805 C30.6657304,32.2590396 31.6638834,31.0935938 32.5770673,29.8835019 C34.543494,27.2754331 35.6733024,24.941751 36.1298943,22.5383095 C36.1933877,22.1997442 36.2578148,21.8388559 36.2848928,21.4714568 C36.3297117,20.8780374 36.5519384,20.3953029 36.9637116,20 Z M39.9749776,31.917684 C40.1981381,31.7921172 40.4166299,31.7279386 40.6267182,31.7279386 C40.8825591,31.7279386 41.128129,31.8237414 41.3578256,32.0116266 C44.1888825,34.3397279 46.0591355,36.590629 47.2459011,39.0963841 C49.4485605,43.7488664 49.0666666,48.1697477 46.0796775,52.6101616 L46.019919,52.6994536 C45.9713653,52.7720033 45.924679,52.844553 45.8705229,52.912452 C45.5670619,53.2947332 45.1534214,53.5151727 44.7360459,53.5151727 C44.4886085,53.5151727 44.2542433,53.4407627 44.0385527,53.2947332 C43.454974,52.8966399 43.3382582,52.2343913 43.7276219,51.5237763 C43.8518075,51.296826 43.9956013,51.0810371 44.1393951,50.8661784 C44.2430386,50.7117777 44.3457485,50.557377 44.442856,50.3992559 C46.7239483,46.676898 46.6445816,42.796419 44.2066233,38.8647832 C44.0105409,38.5476107 43.7911153,38.2443902 43.5716897,37.9420998 L43.2859696,37.5440065 L42.5128445,37.7560749 C42.3895927,39.4200674 42.2766119,40.9259388 41.8508329,42.3983258 C41.5837873,43.3247297 41.2345738,44.0120916 40.7555724,44.5599349 C40.1085004,45.2984537 39.2774843,45.690036 38.3512282,45.690036 C37.4408455,45.690036 36.5052521,45.3124055 35.6462243,44.5990001 C35.1924335,44.2213696 34.9646044,44.0316242 34.6704808,44.0316242 C34.1989492,44.0316242 34.0560891,44.4492501 33.8394647,45.0789443 C32.9897742,47.5530752 33.6144368,49.5007557 35.7480004,51.0317405 C36.2204657,51.3712359 36.9235613,52.0753401 36.3334466,52.9757005 C36.1121535,53.316126 35.7769459,53.4937798 35.3633054,53.4937798 C35.0262303,53.4937798 34.6583423,53.3737937 34.2979241,53.1468434 C31.280122,51.2391582 30.1157658,47.506569 31.4668672,44.0725497 C31.9318627,42.8866411 32.5471881,41.7742123 33.2941688,40.7659574 C33.6349787,40.3046157 34.0588903,40.0516219 34.4874705,40.0516219 C34.9151169,40.0516219 35.3324924,40.306476 35.6630314,40.7668876 C36.2242006,41.5481921 36.7097381,42.1062667 37.2372932,42.5759795 C37.517411,42.8252529 37.8535523,43.0810371 38.2205066,43.0810371 C38.8302296,43.0810371 39.1094137,42.4159981 39.2429365,42.0951052 C39.7714253,40.8347867 39.8106418,39.5112196 39.8041057,38.2629927 C39.7975696,36.7161958 39.6463061,35.0894082 39.3307067,33.1426578 C39.2242619,32.4915707 39.6220292,32.1176607 39.9749776,31.917684 Z","id":"icons/ic-gas"})))))))));
}

GasComponent.defaultProps = {"width":"35px","height":"40px","viewBox":"0 0 35 40","version":"1.1"};

module.exports = GasComponent;

GasComponent.default = GasComponent;


/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function SearchComponent (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"simuladores/icons/ic-search"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Simulador-Avancado---Desktop","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"simul_avancado_resultados_desktop","transform":"translate(-673.000000, -970.000000)","stroke":"#676767","strokeWidth":"0.5","fill":"#676767","fillRule":"nonzero"},React.createElement("g",{"id":"section-tarifarios","transform":"translate(0.000000, 544.000000)"},React.createElement("g",{"id":"content","transform":"translate(130.000000, 80.000000)"},React.createElement("g",{"transform":"translate(0.000000, 330.000000)","id":"search"},React.createElement("g",{"transform":"translate(528.000000, 0.000000)"},React.createElement("g",{"id":"content","transform":"translate(16.000000, 15.000000)"},React.createElement("path",{"d":"M15.8411648,17.1211118 L11.436135,12.7160821 C13.6386499,10.1747187 13.5115817,6.32031767 11.0972866,3.9060225 C8.55592323,1.36465917 4.44738584,1.36465917 1.9060225,3.9060225 C-0.635340834,6.44738584 -0.635340834,10.5559232 1.9060225,13.0972866 C4.32031767,15.5115817 8.17471873,15.6386499 10.7160821,13.436135 L15.1211118,17.8411648 L15.1211118,17.8411648 C15.3328921,18.0529451 15.6293845,18.0529451 15.8411648,17.8411648 C16.0529451,17.6293845 16.0529451,17.2905361 15.8411648,17.1211118 Z M10.3772336,12.3772336 C8.21707478,14.5373925 4.74387823,14.5373925 2.58371939,12.3772336 C0.423560556,10.2170748 0.423560556,6.74387823 2.58371939,4.58371939 C4.74387823,2.42356056 8.21707478,2.42356056 10.3772336,4.58371939 C12.5373925,6.74387823 12.5373925,10.2170748 10.3772336,12.3772336 Z","id":"simuladores/icons/ic-search"}))))))))]);
}

SearchComponent.defaultProps = {"width":"18px","height":"18px","viewBox":"0 0 18 18","version":"1.1"};

module.exports = SearchComponent;

SearchComponent.default = SearchComponent;


/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function CriancaComponent (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"simuladores/icons/ic-crianca"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2},React.createElement("linearGradient",{"x1":"158.87207%","y1":"50%","x2":"-2.22044605e-14%","y2":"50%","id":"linearGradient-1"},[React.createElement("stop",{"stopColor":"#006736","offset":"0%","key":0}),React.createElement("stop",{"stopColor":"#93C13E","offset":"100%","key":1})])),React.createElement("g",{"id":"Simulador-Avancado---Desktop","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"simul_avancado_etapa1_desktop","transform":"translate(-692.000000, -2326.000000)","fillRule":"nonzero","fill":"url(#linearGradient-1)"},React.createElement("g",{"id":"agregado","transform":"translate(0.000000, 2122.000000)"},React.createElement("g",{"id":"content","transform":"translate(479.000000, 80.000000)"},React.createElement("g",{"id":"boxes","transform":"translate(0.000000, 100.000000)"},React.createElement("g",{"id":"option","transform":"translate(176.000000, 0.000000)"},React.createElement("g",{"id":"box"},React.createElement("path",{"d":"M78,42.8 C75.7,35.6 69.3,30.5 61.8,29.8 C62.4,28.1 64,26.8 65.9,26.8 C66.7,26.8 67.3,26.2 67.3,25.4 C67.3,24.6 66.7,24 65.9,24 C62.4,24 59.5,26.5 58.8,29.8 C51.1,30.3 44.6,35.5 42.2,42.8 C39.3,43.1 37,45.6 37,48.6 C37,51.6 39.3,54.1 42.2,54.4 C44.7,62.1 51.9,67.4 60.1,67.4 C68.3,67.4 75.5,62.1 78,54.4 C80.9,54.1 83.2,51.6 83.2,48.6 C83.2,45.5 80.9,43.1 78,42.8 Z M77.4,51.4 L76.9,51.4 C76.2,51.4 75.7,51.8 75.5,52.5 C73.7,59.5 67.4,64.4 60.1,64.4 C52.8,64.4 46.5,59.5 44.7,52.5 C44.5,51.9 44,51.4 43.3,51.4 L42.8,51.4 C41.2,51.4 39.9,50.1 39.9,48.5 C39.9,46.9 41.2,45.6 42.8,45.6 L43.3,45.6 C44,45.6 44.5,45.2 44.7,44.5 C46.5,37.5 52.8,32.6 60.1,32.6 C67.4,32.6 73.7,37.5 75.5,44.5 C75.7,45.1 76.2,45.6 76.9,45.6 L77.4,45.6 C79,45.6 80.3,46.9 80.3,48.5 C80.3,50.1 79,51.4 77.4,51.4 Z M65.2,47.1 C67.6,47.1 69.5,45.2 69.5,42.8 C69.5,40.4 67.6,38.5 65.2,38.5 C62.8,38.5 60.9,40.4 60.9,42.8 C60.8,45.2 62.8,47.1 65.2,47.1 Z M65.2,41.3 C66,41.3 66.6,41.9 66.6,42.7 C66.6,43.5 66,44.1 65.2,44.1 C64.4,44.1 63.8,43.5 63.8,42.7 C63.8,41.9 64.4,41.3 65.2,41.3 Z M55,47.1 C57.4,47.1 59.3,45.2 59.3,42.8 C59.3,40.4 57.4,38.5 55,38.5 C52.6,38.5 50.7,40.4 50.7,42.8 C50.7,45.2 52.7,47.1 55,47.1 Z M55,41.3 C55.8,41.3 56.4,41.9 56.4,42.7 C56.4,43.5 55.8,44.1 55,44.1 C54.2,44.1 53.6,43.5 53.6,42.7 C53.6,41.9 54.2,41.3 55,41.3 Z M70.2,51.6 C69.5,51.2 68.6,51.4 68.2,52.1 C66.4,55.3 63.3,57.2 60.1,57.2 C56.8,57.2 53.8,55.3 52,52.1 C51.6,51.4 50.7,51.2 50,51.6 C49.3,52 49.1,52.9 49.5,53.6 C51.9,57.7 55.8,60.1 60.1,60.1 C64.4,60.1 68.4,57.7 70.7,53.6 C71.2,52.9 70.9,52 70.2,51.6 Z","id":"simuladores/icons/ic-crianca"}))))))))]);
}

CriancaComponent.defaultProps = {"width":"47px","height":"44px","viewBox":"0 0 47 44","version":"1.1"};

module.exports = CriancaComponent;

CriancaComponent.default = CriancaComponent;


/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function ElectricityComponent (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"d":"M28,41.3148834 C27.9999986,41.1528071 28.0349943,40.9900798 28.10583,40.8379028 L37.4880435,20.6705147 C37.6782367,20.2626263 38.0948972,20 38.5527335,20 L51.5094037,20 C51.9476325,20 52.3476266,20.2385762 52.5495844,20.6195286 C52.6373967,20.7859767 52.6808524,20.9673005 52.6808511,21.1480134 L52.6808511,21.1480134 C52.6808493,21.3809009 52.6086746,21.6127736 52.4662523,21.8104858 L43.045804,34.9052429 L49.7221754,34.9052429 C50.178051,34.9052429 50.5927507,35.1649832 50.7849047,35.5719096 C50.9760783,35.976912 50.910393,36.4550265 50.6162798,36.7955748 L30.9577484,59.5930736 C30.7293204,59.8595479 30.3979528,60 30.063644,60 C29.8656077,60 29.6646303,59.9519 29.4832605,59.8480038 C28.9920913,59.5728716 28.7724867,58.994709 28.9587585,58.4723425 L34.6694579,42.4627225 L29.17052,42.4627225 C28.7724867,42.4627225 28.401904,42.2645503 28.1862209,41.9355459 C28.0627499,41.7477532 28.0000019,41.5319019 28,41.3148834 L28,41.3148834 L28,41.3148834 Z M39.3056635,22.2962963 L30.9920616,40.1673882 L36.318453,40.1673882 C36.6988395,40.1673882 37.0547166,40.3463203 37.2733408,40.6503127 C37.4929454,40.954305 37.5498073,41.3439153 37.4243189,41.6940837 L33.2606553,53.3660414 L47.1986835,37.2025012 L40.7870141,37.2025012 C40.3497657,37.2025012 39.9487912,36.963925 39.7478138,36.5829726 C39.545856,36.2020202 39.5791889,35.7421837 39.8301655,35.3910534 L49.2506138,22.2962963 L39.3056635,22.2962963 Z","id":"path-1"})),React.createElement("g",{"id":"UI---Desktop","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"comercializadores_desktop","transform":"translate(-558.000000, -412.000000)"},React.createElement("g",{"id":"section---comercializadores","transform":"translate(0.000000, 96.000000)"},React.createElement("g",{"id":"content","transform":"translate(130.000000, 120.000000)"},React.createElement("g",{"id":"selector","transform":"translate(397.000000, 176.000000)"},React.createElement("g",{"id":"eletricidade"},React.createElement("g",{"id":"box","transform":"translate(3.000000, 0.000000)"},[React.createElement("mask",{"id":"mask-2","fill":"white","key":0},React.createElement("use",{"xlinkHref":"#path-1"})),React.createElement("use",{"id":"icons/ic-eletricidade","fill":"#3E3E3E","xlinkHref":"#path-1","key":1})])))))))]);
}

ElectricityComponent.defaultProps = {"width":"25px","height":"40px","preserveAspectRatio":"xMidYMin slice","viewBox":"0 0 25 40","version":"1.1"};

module.exports = ElectricityComponent;

ElectricityComponent.default = ElectricityComponent;


/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function ElectricityplusgasComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"UI---Desktop","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","width":"48px","height":"40px"},React.createElement("g",{"id":"comercializadores_desktop","transform":"translate(-818.000000, -412.000000)","fill":"#3E3E3E"},React.createElement("g",{"id":"section---comercializadores","transform":"translate(0.000000, 96.000000)"},React.createElement("g",{"id":"content","transform":"translate(130.000000, 120.000000)"},React.createElement("g",{"id":"selector","transform":"translate(397.000000, 176.000000)"},React.createElement("g",{"id":"eletricidade+gas","transform":"translate(253.000000, 0.000000)"},React.createElement("g",{"id":"box","transform":"translate(22.000000, 0.000000)"},React.createElement("path",{"d":"M26.2500869,20 C25.8042612,20 25.400419,20.2570082 25.2154913,20.6588936 L25.2154913,20.6588936 L16.103053,40.4753163 C15.9421159,40.8246093 15.9711046,41.2314562 16.1800229,41.5539568 L16.1800229,41.5539568 C16.3899409,41.8774498 16.7507998,42.0719424 17.1376486,42.0719424 L17.1376486,42.0719424 L22.4775615,42.0719424 L16.9317291,57.8020342 C16.7507998,58.3160506 16.9647162,58.884644 17.4405302,59.1545522 L17.4405302,59.1545522 C17.6174611,59.2557678 17.8123849,59.3033987 18.0033103,59.3033987 L18.0033103,59.3033987 C18.3301825,59.3033987 18.6500575,59.1654676 18.8729704,58.9044902 L18.8729704,58.9044902 L30.0975831,45.7355495 C30.0416049,46.2287274 30.0026202,46.7248822 29.9976221,47.2259985 L29.9976221,47.2259985 C29.9696331,50.2277351 30.7943107,52.8007938 32.4506633,54.8727363 L32.4506633,54.8727363 C35.1286166,58.2237658 38.2793851,59.887869 42.1228828,59.9642769 L42.1228828,59.9642769 C42.8575956,59.9632845 43.3713948,59.5107914 43.4003835,58.8360208 L43.4003835,58.8360208 C43.4313714,58.1463657 42.9135738,57.6293724 42.1108875,57.5529645 L42.1108875,57.5529645 C38.1524347,57.1719176 35.2825564,55.2567601 33.5832207,51.8600843 L33.5832207,51.8600843 C31.8728892,48.4395932 32.1297887,44.8593401 34.3689136,40.9159018 L34.3689136,40.9159018 C34.5138569,40.6618705 34.6787924,40.4247085 34.8337319,40.1786157 L34.8337319,40.1786157 C34.8337319,40.1786157 39.2080221,34.6415282 39.5169014,34.2813198 L39.5169014,34.2813198 C41.8060067,31.6040685 44.0671229,28.6301166 45.1037177,25.0310097 L45.1037177,25.0310097 C45.2336669,24.5775242 45.463577,24.3483007 45.7844516,24.3483007 L45.7844516,24.3483007 C46.0263571,24.3483007 46.208286,24.4902009 46.3702227,24.615232 L46.3702227,24.615232 L46.451191,24.6767551 C49.8098782,27.1743984 52.3958675,29.490449 54.5900099,31.9642769 L54.5900099,31.9642769 C57.3269401,35.0483751 59.0962485,37.8645497 60.1548348,40.8265939 L60.1548348,40.8265939 C61.9561307,45.8645497 61.2414101,50.4956586 58.030665,54.5919127 L58.030665,54.5919127 C57.0390526,55.8571074 55.7955387,56.8424709 54.3351095,57.5241875 L54.3351095,57.5241875 C53.8113142,57.769288 53.4744459,58.1354503 53.3864803,58.5551972 L53.3864803,58.5551972 C53.3115096,58.9144133 53.4264646,59.2795832 53.7193502,59.6100223 L53.7193502,59.6100223 C53.9482607,59.8690151 54.2411462,60 54.5900099,60 L54.5900099,60 C54.860904,60 55.1527899,59.9206152 55.4576707,59.7638303 L55.4576707,59.7638303 C60.4537179,57.1997023 63.1226747,52.906971 63.6174813,46.6435128 L63.6174813,46.6435128 C63.838395,43.8571074 63.193647,41.0181097 61.5912733,37.7097494 L61.5912733,37.7097494 C59.2961704,32.9764326 55.7265656,29.3227487 52.8726811,26.6683205 L52.8726811,26.6683205 C50.4486286,24.4147854 48.1715186,20.5844704 44.7168689,20.5844704 L44.7168689,20.5844704 C44.1510901,20.5844704 43.1774706,21.4497643 43.1344874,22.0332424 L43.1344874,22.0332424 C43.1084976,22.3954354 43.043523,22.7516745 42.979548,23.0840982 L42.979548,23.0840982 C42.5287242,25.4527413 41.4121606,27.7529149 39.4679205,30.3229968 L39.4679205,30.3229968 C38.5652733,31.5157529 37.5776594,32.6638551 36.6220329,33.7752419 L36.6220329,33.7752419 C36.3741298,34.0630117 36.1252271,34.3547507 35.8763244,34.6464897 L35.8763244,34.6464897 L30.6143811,34.6464897 L39.7638049,21.7802034 C40.0077095,21.4348797 40.039697,20.9833788 39.8447732,20.6092781 L39.8447732,20.6092781 C39.6478502,20.2351774 39.2590022,20 38.8351679,20 L38.8351679,20 L26.2500869,20 Z M26.9798017,22.256512 L36.6400259,22.256512 L27.490602,35.1227983 C27.2456978,35.4691144 27.2147099,35.9196229 27.4106333,36.2937236 C27.6055571,36.6688167 27.9944051,36.9030017 28.4192391,36.9030017 L34.0280468,36.9030017 C33.7361609,37.2810717 21.1090963,52.7859092 21.1090963,52.7859092 L25.1535155,41.3167948 C25.2744682,40.9724634 25.2204893,40.5894319 25.0075726,40.291739 C24.7946558,39.9920615 24.448791,39.8154304 24.0799351,39.8154304 L18.9059575,39.8154304 L26.9798017,22.256512 Z M46.7830613,32.3274622 C47.0029754,32.2034235 47.2198906,32.1399157 47.4278093,32.1399157 C47.6797108,32.1399157 47.9236155,32.2341851 48.1495272,32.419747 C50.9494328,34.7139668 52.7997096,36.932771 53.9722513,39.4016373 C56.1504,43.9861077 55.7735473,48.3423468 52.8187022,52.7174398 L52.7597252,52.8057554 C52.7127436,52.8772017 52.665762,52.9496403 52.6127827,53.0151327 C52.3128999,53.3922104 51.9020605,53.6105185 51.4892218,53.6105185 C51.2453172,53.6105185 51.0134078,53.5360953 50.8014907,53.3922104 C50.2237165,53.0002481 50.1087614,52.3473084 50.493611,51.6467378 C50.6155633,51.4234681 50.7585075,51.2121062 50.9014516,50.9997519 C51.0034117,50.8479286 51.1053719,50.6961052 51.2013344,50.5393203 C53.4564529,46.871744 53.3774838,43.0463905 50.9664262,39.1724138 C50.7735016,38.8608286 50.5565864,38.5611511 50.3396712,38.2644505 L50.0567817,37.8714959 L49.2920806,38.0798809 C49.1701283,39.7201687 49.0591717,41.2046639 48.6373365,42.6544282 C48.3734397,43.5683453 48.0285745,44.2441082 47.5547597,44.7849169 C46.9150097,45.5132721 46.0923313,45.8982883 45.1776888,45.8982883 C44.2770408,45.8982883 43.3514026,45.5261722 42.5027343,44.8226247 C42.0539098,44.4515009 41.8289977,44.2649467 41.5381114,44.2649467 C41.0722934,44.2649467 40.9303489,44.6757628 40.7164325,45.2969486 C39.8757611,47.734061 40.4935197,49.6541801 42.6036949,51.1624907 C43.0705124,51.4978913 43.7662405,52.1905234 43.1824687,53.0786405 C42.9625546,53.4130489 42.6306843,53.58968 42.2228437,53.58968 C41.8899738,53.58968 41.5261161,53.4706028 41.1692555,53.2463409 C38.1854218,51.3669065 37.0338719,47.6894071 38.3693499,44.3036467 C38.8291702,43.1366906 39.4379323,42.0401885 40.1776431,41.0458943 C40.5135118,40.5924088 40.9333478,40.3423468 41.3571821,40.3423468 C41.7800168,40.3423468 42.1928555,40.5934011 42.5187281,41.0478789 C43.0745108,41.8179112 43.5543233,42.3676507 44.0751197,42.830067 C44.3520115,43.0751675 44.6848814,43.3282064 45.0477396,43.3282064 C45.650504,43.3282064 45.9273958,42.6712974 46.0593442,42.3567353 C46.5821398,41.115356 46.620125,39.8104689 46.6141273,38.5790127 C46.6071301,37.0558174 46.4571887,35.4532374 46.1453106,33.5341106 C46.0413512,32.8920863 46.4341977,32.5239395 46.7830613,32.3274622 Z","id":"icons/ic-eletricidade-gas"})))))))));
}

ElectricityplusgasComponent.defaultProps = {"width":"48px","height":"40px","viewBox":"0 0 48 40","version":"1.1"};

module.exports = ElectricityplusgasComponent;

ElectricityplusgasComponent.default = ElectricityplusgasComponent;


/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function GasComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"UI---Desktop","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"comercializadores_desktop","transform":"translate(-689.000000, -412.000000)","fill":"#3E3E3E"},React.createElement("g",{"id":"section---comercializadores","transform":"translate(0.000000, 96.000000)"},React.createElement("g",{"id":"content","transform":"translate(130.000000, 120.000000)"},React.createElement("g",{"id":"selector","transform":"translate(397.000000, 176.000000)"},React.createElement("g",{"id":"gas","transform":"translate(139.000000, 0.000000)"},React.createElement("g",{"id":"box"},React.createElement("path",{"d":"M36.9637116,20 L38.2615906,20 C40.9292454,21.9095454 43.6809356,23.8869899 46.1338336,26.176026 C49.0199803,28.8687362 52.6306983,32.5762121 54.9500735,37.3784444 C56.3497286,40.2795024 57.0276136,42.8233926 57.0425532,45.2845018 L57.0425532,45.4584351 C57.0406857,45.7886292 57.0266799,46.1178933 57.0005355,46.4452971 C56.5000584,52.8017672 53.7997232,57.1584699 48.7473323,59.760958 C48.4401365,59.9200093 48.1450791,60 47.8705637,60 C47.5176153,60 47.2216242,59.8669922 46.9900602,59.603767 C46.6931354,59.2689222 46.5764196,58.8987327 46.6529852,58.5341239 C46.7416891,58.1071968 47.0824991,57.7360772 47.6128554,57.4868039 C49.089076,56.7975817 50.3468048,55.7958377 51.3496264,54.512266 C54.5971251,50.3546099 55.3198289,45.6556214 53.4981297,40.5427276 C52.4262124,37.5365655 50.6381273,34.6792233 47.8705637,31.5493547 C45.652031,29.038949 43.0366648,26.6885246 39.63977,24.1530055 L39.5585358,24.0916173 C39.3942001,23.9651203 39.2093223,23.8209511 38.9646861,23.8209511 C38.6406833,23.8209511 38.4081855,24.052552 38.2765302,24.5120335 C37.2288897,28.1664923 34.942195,31.1828857 32.6265548,33.9007092 C32.3146903,34.2662481 31.999091,34.6308569 31.6844254,34.9945355 C30.1671208,36.7440995 28.5984613,38.5531915 27.4210329,40.6329497 C25.1558139,44.635275 24.8962381,48.2683409 26.6254985,51.7404953 C28.3444878,55.1866062 31.2465079,57.1296361 35.2493908,57.5165678 C36.0617323,57.5937682 36.5855526,58.1183583 36.5547396,58.818742 C36.5248604,59.5033136 36.0047751,59.962795 35.262463,59.9637251 C31.3753621,59.8865248 28.1885556,58.1964888 25.4807505,54.7968841 C23.8056463,52.6938728 22.9708953,50.0839437 23.0007745,47.0377863 C23.0306538,43.805604 24.0820291,40.7603767 26.2155928,37.7263109 C27.280974,36.2102081 28.510691,34.774096 29.6993241,33.3872805 C30.6657304,32.2590396 31.6638834,31.0935938 32.5770673,29.8835019 C34.543494,27.2754331 35.6733024,24.941751 36.1298943,22.5383095 C36.1933877,22.1997442 36.2578148,21.8388559 36.2848928,21.4714568 C36.3297117,20.8780374 36.5519384,20.3953029 36.9637116,20 Z M39.9749776,31.917684 C40.1981381,31.7921172 40.4166299,31.7279386 40.6267182,31.7279386 C40.8825591,31.7279386 41.128129,31.8237414 41.3578256,32.0116266 C44.1888825,34.3397279 46.0591355,36.590629 47.2459011,39.0963841 C49.4485605,43.7488664 49.0666666,48.1697477 46.0796775,52.6101616 L46.019919,52.6994536 C45.9713653,52.7720033 45.924679,52.844553 45.8705229,52.912452 C45.5670619,53.2947332 45.1534214,53.5151727 44.7360459,53.5151727 C44.4886085,53.5151727 44.2542433,53.4407627 44.0385527,53.2947332 C43.454974,52.8966399 43.3382582,52.2343913 43.7276219,51.5237763 C43.8518075,51.296826 43.9956013,51.0810371 44.1393951,50.8661784 C44.2430386,50.7117777 44.3457485,50.557377 44.442856,50.3992559 C46.7239483,46.676898 46.6445816,42.796419 44.2066233,38.8647832 C44.0105409,38.5476107 43.7911153,38.2443902 43.5716897,37.9420998 L43.2859696,37.5440065 L42.5128445,37.7560749 C42.3895927,39.4200674 42.2766119,40.9259388 41.8508329,42.3983258 C41.5837873,43.3247297 41.2345738,44.0120916 40.7555724,44.5599349 C40.1085004,45.2984537 39.2774843,45.690036 38.3512282,45.690036 C37.4408455,45.690036 36.5052521,45.3124055 35.6462243,44.5990001 C35.1924335,44.2213696 34.9646044,44.0316242 34.6704808,44.0316242 C34.1989492,44.0316242 34.0560891,44.4492501 33.8394647,45.0789443 C32.9897742,47.5530752 33.6144368,49.5007557 35.7480004,51.0317405 C36.2204657,51.3712359 36.9235613,52.0753401 36.3334466,52.9757005 C36.1121535,53.316126 35.7769459,53.4937798 35.3633054,53.4937798 C35.0262303,53.4937798 34.6583423,53.3737937 34.2979241,53.1468434 C31.280122,51.2391582 30.1157658,47.506569 31.4668672,44.0725497 C31.9318627,42.8866411 32.5471881,41.7742123 33.2941688,40.7659574 C33.6349787,40.3046157 34.0588903,40.0516219 34.4874705,40.0516219 C34.9151169,40.0516219 35.3324924,40.306476 35.6630314,40.7668876 C36.2242006,41.5481921 36.7097381,42.1062667 37.2372932,42.5759795 C37.517411,42.8252529 37.8535523,43.0810371 38.2205066,43.0810371 C38.8302296,43.0810371 39.1094137,42.4159981 39.2429365,42.0951052 C39.7714253,40.8347867 39.8106418,39.5112196 39.8041057,38.2629927 C39.7975696,36.7161958 39.6463061,35.0894082 39.3307067,33.1426578 C39.2242619,32.4915707 39.6220292,32.1176607 39.9749776,31.917684 Z","id":"icons/ic-gas"})))))))));
}

GasComponent.defaultProps = {"width":"35px","height":"40px","viewBox":"0 0 35 40","version":"1.1"};

module.exports = GasComponent;

GasComponent.default = GasComponent;


/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcMobilidadeComponent (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icons/ic-mobilidade"),React.createElement("g",{"id":"⚠️-Agosto-2021","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"[2021]-Homepage-nova-versao-V3-eletricidade","transform":"translate(-1135.000000, -555.000000)","fill":"#3E3E3E","fillRule":"nonzero"},React.createElement("g",{"id":"simulador","transform":"translate(866.500000, 201.000000)"},React.createElement("g",{"id":"content","transform":"translate(40.000000, 32.000000)"},React.createElement("g",{"id":"simular","transform":"translate(18.500000, 276.000000)"},React.createElement("g",{"id":"selector","transform":"translate(54.000000, 28.000000)"},React.createElement("g",{"id":"box","transform":"translate(136.000000, 0.000000)"},React.createElement("path",{"d":"M56.1394275,44.3912395 L55.9107525,44.3045988 L56.7716467,43.738102 L58.8969793,43.738102 C59.5061608,43.738102 60,43.2487468 60,42.6450965 C60,42.0414462 59.5061608,41.5520909 58.8969793,41.5520909 L56.4286342,41.5520909 C56.2104247,41.55255 55.9973177,41.617526 55.8165922,41.7387016 L53.3347956,43.37821 L51.949294,39.2594451 C51.1924749,36.9604427 49.008652,35.4213017 46.5687052,35.467249 L41.4975002,35.467249 C41.4975002,34.5741835 41.4975002,33.761094 41.4975002,32.9480045 C41.4975002,32.8413698 41.7665297,32.6747531 41.9279473,32.6614237 C44.7356479,32.380614 47.4891149,31.7074727 50.1064423,30.6620233 C52.8788857,29.7036915 54.6482352,27.0107564 54.4109134,24.1106546 C54.3538169,20.8658719 51.7880938,18.2102546 48.5191686,18.0124833 C43.9448826,17.7667197 40.0065026,21.1785561 39.6411971,25.7035103 C39.5201338,27.2030606 39.5873912,28.7292696 39.5739397,30.2421492 L39.5739397,30.8419694 C37.0699347,30.8469017 34.5782609,30.4945009 32.1756301,29.7956165 L32.3101448,29.2691077 C32.6813423,27.8559717 32.3951407,26.3523871 31.5299595,25.1703368 C30.7165674,24.0000492 29.6929255,22.9879609 28.510104,22.1845656 C28.2680861,21.9290527 27.912456,21.8115413 27.5641154,21.871981 C27.2157748,21.9324206 26.9215961,22.1626788 26.7815898,22.4844756 L26.1090162,23.4575171 C25.3826367,22.9643317 24.7235146,22.4911403 24.0307638,22.0712662 C23.7776307,21.915152 23.4691551,21.8739102 23.1833211,21.9579668 C22.8842576,22.1030323 22.6582116,22.3631539 22.5578276,22.677751 C22.5489498,23.0125719 22.6891559,23.3343117 22.9411946,23.5574872 C23.6137682,24.0906606 24.2863418,24.5305287 25.019447,25.0170495 C24.5419197,25.6835163 24.0980212,26.3499831 23.6204939,27.0497732 L21.6767562,25.7168396 C21.0579885,25.3036302 20.5064781,25.3702769 20.1701913,25.890121 C19.8339045,26.4099651 20.0020479,26.8564979 20.6208156,27.2763719 L22.5107475,28.6759522 C22.2282665,29.0958263 21.9659628,29.4690477 21.7171106,29.8555985 C21.5396901,30.0777434 21.4737302,30.3677323 21.5378249,30.6438183 C21.6019196,30.9199044 21.7891262,31.152182 22.0466717,31.2751728 C22.9972429,31.8127893 23.9863393,32.2805718 25.0059955,32.6747531 C27.1515053,33.4478546 29.2028548,33.3412199 30.9649976,31.6683882 C31.1404115,31.5604496 31.3561393,31.5383356 31.5501367,31.6084062 C33.7869829,32.2489521 36.0964604,32.6072312 38.4238389,32.6747531 C38.8139316,32.6747531 39.1972985,32.7214057 39.6008427,32.7480644 L39.6008427,35.4139316 L34.3144142,35.4139316 C31.8867989,35.3827258 29.7206095,36.9190408 28.967454,39.2061278 L27.5819524,43.3248926 L25.0934301,41.6853843 C24.9132527,41.5630787 24.6997852,41.4979928 24.4813881,41.4987736 L22.0264945,41.4987736 C21.4173129,41.4987736 20.9234738,41.9881288 20.9234738,42.5917791 C20.9234738,43.1954294 21.4173129,43.6847847 22.0264945,43.6847847 L24.151827,43.6847847 L25.0127213,44.2512815 L24.7840462,44.3379222 C22.4678106,45.2298249 20.9369692,47.4338831 20.9234738,49.8962553 L20.9234738,55.9877619 C20.9271723,56.5888079 21.4199299,57.074114 22.0264945,57.0741028 L25.2010419,57.0741028 L25.2010419,60.8529696 C25.1840253,61.1560203 25.2957286,61.4523057 25.5090981,61.6700682 C25.7224676,61.8878307 26.0180434,62.0072096 26.3242398,61.9996627 L31.2542043,61.9996627 C31.8633858,61.9996627 32.357225,61.5099373 32.357225,60.906287 L32.357225,57.1274202 L48.5729745,57.1274202 L48.5729745,60.906287 C48.5711836,61.1955555 48.6858946,61.4735858 48.8916842,61.678758 C49.0974739,61.8839301 49.3773449,61.9996627 49.6692695,61.9996627 L54.5857825,61.9996627 C55.194964,61.9996627 55.6888032,61.5099373 55.6888032,60.906287 L55.6888032,57.1274202 L58.8902536,57.1274202 C59.4957206,57.1274202 59.9865485,56.6410488 59.9865485,56.0410793 L59.9865485,49.9495727 C59.9752261,47.49052 58.4503759,45.2874113 56.1394275,44.3912395 Z M41.5378546,26.2500131 C41.6472181,22.6886903 44.6007515,19.8624877 48.1963333,19.8785219 C50.2622995,19.9323599 52.0156385,21.3958865 52.4200955,23.4041998 C52.9205865,25.507668 51.8731748,27.6722753 49.9046702,28.6026409 C47.3063451,29.7421002 44.5407152,30.4621052 41.7127238,30.7353347 C41.6645681,30.7293096 41.6172121,30.7181368 41.5714833,30.7020113 C41.5714833,30.5553886 41.5378546,30.3954366 41.5378546,30.2354846 C41.5311289,28.902551 41.5176774,27.576282 41.5378546,26.2500131 Z M30.4269387,28.8292396 C29.9292343,30.3221252 28.6916989,31.4484542 26.9766362,31.2418494 C25.863136,31.103607 24.795963,30.716167 23.8558947,30.1088559 C25.2010419,28.1094555 26.5461891,26.110055 27.8913363,24.1506426 C29.3642725,25.1036902 30.9717234,27.1830666 30.4269387,28.8292396 Z M31.0591579,39.9459059 C31.5168579,38.554199 32.8374755,37.6213969 34.3144142,37.6465954 L38.1279065,37.6465954 L38.1279065,37.7732241 C38.1261028,38.0636515 38.2417343,38.3427014 38.4489831,38.5480684 C38.6562319,38.7534354 38.9378387,38.868017 39.2309272,38.8662297 L41.6858208,38.8662297 C42.2950023,38.8662297 42.7888415,38.3768744 42.7888415,37.7732241 L42.7888415,37.6465954 L46.6023339,37.6465954 C48.0792725,37.6213969 49.3998902,38.554199 49.8575901,39.9459059 L51.2027373,43.9913594 L29.680382,43.9913594 L31.0591579,39.9459059 Z M30.1444578,59.8199461 L27.4541634,59.8199461 L27.4541634,57.1540788 L30.1444578,57.1540788 L30.1444578,59.8199461 Z M53.4894875,59.8199461 L50.7588387,59.8199461 L50.7588387,57.1540788 L53.4491331,57.1540788 L53.4894875,59.8199461 Z M57.7872329,54.9480737 L23.1295152,54.9480737 L23.1295152,49.9495727 C23.1295152,47.8625622 24.8368738,46.1707059 26.9430075,46.1707059 L53.9737405,46.1707059 C56.0783388,46.1743743 57.7835308,47.8640836 57.7872329,49.9495727 L57.7872329,54.9480737 Z M52.1039859,48.8632318 C51.156783,48.8632318 50.3889232,49.6241195 50.3889232,50.5627221 C50.3889232,51.5013247 51.156783,52.2622125 52.1039859,52.2622125 C53.0511889,52.2622125 53.8190486,51.5013247 53.8190486,50.5627221 C53.8190486,49.6241195 53.0511889,48.8632318 52.1039859,48.8632318 L52.1039859,48.8632318 Z M28.7858592,48.8632318 C27.8386562,48.8632318 27.0707965,49.6241195 27.0707965,50.5627221 C27.0707965,51.5013247 27.8386562,52.2622125 28.7858592,52.2622125 C29.7330621,52.2622125 30.5009218,51.5013247 30.5009218,50.5627221 C30.5009218,50.1119893 30.3202283,49.6797173 29.9985916,49.361001 C29.676955,49.0422847 29.2407221,48.8632318 28.7858592,48.8632318 L28.7858592,48.8632318 Z M44.7594822,49.4697166 L36.1572658,49.4697166 C35.743866,49.4376552 35.3472475,49.6380505 35.1306371,49.9884305 C34.9140268,50.3388105 34.9140268,50.7799691 35.1306371,51.1303491 C35.3472475,51.4807291 35.743866,51.6811244 36.1572658,51.649063 L44.7594822,51.649063 C45.333529,51.6045426 45.7764371,51.1299639 45.7764371,50.5593898 C45.7764371,49.9888157 45.333529,49.514237 44.7594822,49.4697166 L44.7594822,49.4697166 Z","id":"icons/ic-mobilidade"}))))))))]);
}

IcMobilidadeComponent.defaultProps = {"width":"40px","height":"44px","viewBox":"0 0 40 44","version":"1.1"};

module.exports = IcMobilidadeComponent;

IcMobilidadeComponent.default = IcMobilidadeComponent;


/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcSemAcaoComponent (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icons/ic-sem-acao"),React.createElement("g",{"id":"⚠️-Agosto-2021","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"[2021]-Homepage-nova-versao-V3-eletricidade","transform":"translate(-999.000000, -557.000000)","fill":"#3E3E3E","fillRule":"nonzero"},React.createElement("g",{"id":"simulador","transform":"translate(866.500000, 201.000000)"},React.createElement("g",{"id":"content","transform":"translate(40.000000, 32.000000)"},React.createElement("g",{"id":"simular","transform":"translate(18.500000, 276.000000)"},React.createElement("g",{"id":"selector","transform":"translate(54.000000, 28.000000)"},React.createElement("g",{"id":"box","transform":"translate(0.000000, 0.000000)"},React.createElement("path",{"d":"M54.1406155,25.8594726 C50.362297,22.0809778 45.3387216,20 39.9953752,20 C34.6518527,20 29.6281892,22.0809778 25.8499587,25.8594726 C18.0500138,33.6591532 18.0500138,46.3504487 25.8499587,54.1501294 C29.7498431,58.0501899 34.8725211,60 39.995199,60 C45.1181413,60 50.2408192,58.0501899 54.1406155,54.1501294 C57.9191103,50.3718108 60.0000881,45.3482354 60.0000881,40.0047129 C60.0000881,34.6613665 57.9191103,29.6377911 54.1406155,25.8594726 Z M27.4620272,27.471541 C30.8099323,24.1239002 35.260827,22.2800639 39.9954633,22.2800639 C44.3476078,22.2800639 48.4577658,23.8419204 51.6941474,26.6940483 L26.6846226,51.703397 C20.5656334,44.7498321 20.8221549,34.1113252 27.4620272,27.471541 Z M52.528547,52.538149 C45.8889391,59.1780213 35.2505203,59.4344547 28.2966911,53.3154655 L53.3061278,28.3060287 C56.1582558,31.5424104 57.7201123,35.6525684 57.7201123,40.0047129 C57.7201123,44.7393492 55.8762759,49.1902439 52.528547,52.538149 Z","id":"icons/ic-sem-acao"}))))))))]);
}

IcSemAcaoComponent.defaultProps = {"width":"40px","height":"40px","viewBox":"0 0 40 40","version":"1.1"};

module.exports = IcSemAcaoComponent;

IcSemAcaoComponent.default = IcSemAcaoComponent;


/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IdosoComponent (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"simuladores/icons/ic-idoso"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2},React.createElement("linearGradient",{"x1":"158.87207%","y1":"50%","x2":"-2.22044605e-14%","y2":"50%","id":"linearGradient-1"},[React.createElement("stop",{"stopColor":"#006736","offset":"0%","key":0}),React.createElement("stop",{"stopColor":"#93C13E","offset":"100%","key":1})])),React.createElement("g",{"id":"Simulador-Avancado---Desktop","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"simul_avancado_etapa1_desktop","transform":"translate(-871.000000, -2324.000000)","fillRule":"nonzero","fill":"url(#linearGradient-1)"},React.createElement("g",{"id":"agregado","transform":"translate(0.000000, 2122.000000)"},React.createElement("g",{"id":"content","transform":"translate(479.000000, 80.000000)"},React.createElement("g",{"id":"boxes","transform":"translate(0.000000, 100.000000)"},React.createElement("g",{"id":"option","transform":"translate(352.000000, 0.000000)"},React.createElement("g",{"id":"box"},React.createElement("path",{"d":"M70.9,32.8 C70.9,26.8 66,22 60,22 C54,22 49.1,26.9 49.1,32.9 L49.4,32.9 C43.8,36.5 40,42.8 40,50 C40,61.2 49.1,70.2 60.2,70.2 C71.4,70.2 80.4,61.1 80.4,50 C80.4,42.8 76.6,36.4 70.9,32.8 Z M60,24.8 C63.9,24.8 67.1,27.6 67.9,31.2 C65.5,30.2 62.9,29.7 60.2,29.7 C57.3,29.7 54.6,30.3 52.1,31.4 C52.7,27.7 56,24.8 60,24.8 Z M60.2,32.3 C65.3,32.3 69.9,34.5 73.1,37.9 C71.9,37.1 70.5,36.7 69,36.7 C65.2,36.7 62.1,39.4 61.5,43 L58.7,43 C58.1,39.4 55,36.7 51.2,36.7 C49.7,36.7 48.3,37.1 47.1,37.9 C50.5,34.4 55.1,32.3 60.2,32.3 Z M74.1,44.3 C74.1,47.1 71.8,49.4 69,49.4 C66.2,49.4 63.9,47.1 63.9,44.3 C63.9,41.5 66.2,39.2 69,39.2 C71.8,39.2 74.1,41.5 74.1,44.3 Z M51.3,39.2 C54.1,39.2 56.4,41.5 56.4,44.3 C56.4,47.1 54.1,49.4 51.3,49.4 C48.5,49.4 46.2,47.1 46.2,44.3 C46.3,41.5 48.5,39.2 51.3,39.2 Z M60.2,67.7 C50.4,67.7 42.5,59.8 42.5,50 C42.5,47.6 43,45.3 43.9,43.2 C43.8,43.6 43.8,43.9 43.8,44.3 C43.8,48.5 47.2,51.9 51.4,51.9 C55.2,51.9 58.3,49.2 58.9,45.6 L61.7,45.6 C62.3,49.2 65.4,51.9 69.2,51.9 C73.4,51.9 76.8,48.5 76.8,44.3 C76.8,43.9 76.8,43.6 76.7,43.2 C77.6,45.3 78.1,47.6 78.1,50 C77.9,59.7 69.9,67.7 60.2,67.7 Z M69.6,55 L50.7,55 C50.2,55 49.8,55.3 49.6,55.7 C49.4,56.1 49.4,56.6 49.7,57 C52.1,60.5 56,62.6 60.2,62.6 C64.4,62.6 68.4,60.5 70.7,57 C71,56.6 71,56.1 70.8,55.7 C70.5,55.3 70.1,55 69.6,55 Z M60.2,60.1 C57.7,60.1 55.3,59.2 53.5,57.6 L66.9,57.6 C65,59.2 62.7,60.1 60.2,60.1 Z M69,46.8 C70.3807119,46.8 71.5,45.6807119 71.5,44.3 C71.5,42.9192881 70.3807119,41.8 69,41.8 C67.6192881,41.8 66.5,42.9192881 66.5,44.3 C66.5,45.6807119 67.6192881,46.8 69,46.8 Z M51.3,46.8 C52.6807119,46.8 53.8,45.6807119 53.8,44.3 C53.8,42.9192881 52.6807119,41.8 51.3,41.8 C49.9192881,41.8 48.8,42.9192881 48.8,44.3 C48.8,45.6807119 49.9192881,46.8 51.3,46.8 Z","id":"simuladores/icons/ic-idoso"}))))))))]);
}

IdosoComponent.defaultProps = {"width":"41px","height":"49px","viewBox":"0 0 41 49","version":"1.1"};

module.exports = IdosoComponent;

IdosoComponent.default = IdosoComponent;


/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function ElectricityComponent (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.86523 10.1566C4.86523 10.0891 4.87982 10.0213 4.90933 9.95785L8.81859 1.55477C8.89783 1.38482 9.07144 1.27539 9.26221 1.27539H14.6608C14.8434 1.27539 15.0101 1.3748 15.0942 1.53353C15.1308 1.60288 15.1489 1.67843 15.1489 1.75373C15.1489 1.85077 15.1188 1.94738 15.0595 2.02976L11.1343 7.48591H13.9161C14.1061 7.48591 14.2789 7.59413 14.3589 7.76369C14.4386 7.93244 14.4112 8.13165 14.2887 8.27355L6.09763 17.7725C6.00245 17.8835 5.86438 17.9421 5.72509 17.9421C5.64257 17.9421 5.55883 17.922 5.48326 17.8787C5.27861 17.7641 5.1871 17.5232 5.26472 17.3055L7.64418 10.6349H5.35295C5.1871 10.6349 5.03269 10.5523 4.94283 10.4152C4.89138 10.337 4.86524 10.247 4.86523 10.1566ZM9.57594 2.23218L6.11194 9.67847H8.33127C8.48976 9.67847 8.63804 9.75303 8.72914 9.87969C8.82064 10.0064 8.84433 10.1687 8.79204 10.3146L7.05718 15.1779L12.8647 8.4431H10.1932C10.011 8.4431 9.84391 8.34369 9.76017 8.18496C9.67602 8.02623 9.68991 7.83463 9.79448 7.68833L13.7197 2.23218H9.57594Z","fill":"#3E3E3E"}));
}

ElectricityComponent.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = ElectricityComponent;

ElectricityComponent.default = ElectricityComponent;


/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function ElectricityplusgasComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"UI---Desktop","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","width":"48px","height":"40px"},React.createElement("g",{"id":"comercializadores_desktop","transform":"translate(-818.000000, -412.000000)","fill":"#3E3E3E"},React.createElement("g",{"id":"section---comercializadores","transform":"translate(0.000000, 96.000000)"},React.createElement("g",{"id":"content","transform":"translate(130.000000, 120.000000)"},React.createElement("g",{"id":"selector","transform":"translate(397.000000, 176.000000)"},React.createElement("g",{"id":"eletricidade+gas","transform":"translate(253.000000, 0.000000)"},React.createElement("g",{"id":"box","transform":"translate(22.000000, 0.000000)"},React.createElement("path",{"d":"M26.2500869,20 C25.8042612,20 25.400419,20.2570082 25.2154913,20.6588936 L25.2154913,20.6588936 L16.103053,40.4753163 C15.9421159,40.8246093 15.9711046,41.2314562 16.1800229,41.5539568 L16.1800229,41.5539568 C16.3899409,41.8774498 16.7507998,42.0719424 17.1376486,42.0719424 L17.1376486,42.0719424 L22.4775615,42.0719424 L16.9317291,57.8020342 C16.7507998,58.3160506 16.9647162,58.884644 17.4405302,59.1545522 L17.4405302,59.1545522 C17.6174611,59.2557678 17.8123849,59.3033987 18.0033103,59.3033987 L18.0033103,59.3033987 C18.3301825,59.3033987 18.6500575,59.1654676 18.8729704,58.9044902 L18.8729704,58.9044902 L30.0975831,45.7355495 C30.0416049,46.2287274 30.0026202,46.7248822 29.9976221,47.2259985 L29.9976221,47.2259985 C29.9696331,50.2277351 30.7943107,52.8007938 32.4506633,54.8727363 L32.4506633,54.8727363 C35.1286166,58.2237658 38.2793851,59.887869 42.1228828,59.9642769 L42.1228828,59.9642769 C42.8575956,59.9632845 43.3713948,59.5107914 43.4003835,58.8360208 L43.4003835,58.8360208 C43.4313714,58.1463657 42.9135738,57.6293724 42.1108875,57.5529645 L42.1108875,57.5529645 C38.1524347,57.1719176 35.2825564,55.2567601 33.5832207,51.8600843 L33.5832207,51.8600843 C31.8728892,48.4395932 32.1297887,44.8593401 34.3689136,40.9159018 L34.3689136,40.9159018 C34.5138569,40.6618705 34.6787924,40.4247085 34.8337319,40.1786157 L34.8337319,40.1786157 C34.8337319,40.1786157 39.2080221,34.6415282 39.5169014,34.2813198 L39.5169014,34.2813198 C41.8060067,31.6040685 44.0671229,28.6301166 45.1037177,25.0310097 L45.1037177,25.0310097 C45.2336669,24.5775242 45.463577,24.3483007 45.7844516,24.3483007 L45.7844516,24.3483007 C46.0263571,24.3483007 46.208286,24.4902009 46.3702227,24.615232 L46.3702227,24.615232 L46.451191,24.6767551 C49.8098782,27.1743984 52.3958675,29.490449 54.5900099,31.9642769 L54.5900099,31.9642769 C57.3269401,35.0483751 59.0962485,37.8645497 60.1548348,40.8265939 L60.1548348,40.8265939 C61.9561307,45.8645497 61.2414101,50.4956586 58.030665,54.5919127 L58.030665,54.5919127 C57.0390526,55.8571074 55.7955387,56.8424709 54.3351095,57.5241875 L54.3351095,57.5241875 C53.8113142,57.769288 53.4744459,58.1354503 53.3864803,58.5551972 L53.3864803,58.5551972 C53.3115096,58.9144133 53.4264646,59.2795832 53.7193502,59.6100223 L53.7193502,59.6100223 C53.9482607,59.8690151 54.2411462,60 54.5900099,60 L54.5900099,60 C54.860904,60 55.1527899,59.9206152 55.4576707,59.7638303 L55.4576707,59.7638303 C60.4537179,57.1997023 63.1226747,52.906971 63.6174813,46.6435128 L63.6174813,46.6435128 C63.838395,43.8571074 63.193647,41.0181097 61.5912733,37.7097494 L61.5912733,37.7097494 C59.2961704,32.9764326 55.7265656,29.3227487 52.8726811,26.6683205 L52.8726811,26.6683205 C50.4486286,24.4147854 48.1715186,20.5844704 44.7168689,20.5844704 L44.7168689,20.5844704 C44.1510901,20.5844704 43.1774706,21.4497643 43.1344874,22.0332424 L43.1344874,22.0332424 C43.1084976,22.3954354 43.043523,22.7516745 42.979548,23.0840982 L42.979548,23.0840982 C42.5287242,25.4527413 41.4121606,27.7529149 39.4679205,30.3229968 L39.4679205,30.3229968 C38.5652733,31.5157529 37.5776594,32.6638551 36.6220329,33.7752419 L36.6220329,33.7752419 C36.3741298,34.0630117 36.1252271,34.3547507 35.8763244,34.6464897 L35.8763244,34.6464897 L30.6143811,34.6464897 L39.7638049,21.7802034 C40.0077095,21.4348797 40.039697,20.9833788 39.8447732,20.6092781 L39.8447732,20.6092781 C39.6478502,20.2351774 39.2590022,20 38.8351679,20 L38.8351679,20 L26.2500869,20 Z M26.9798017,22.256512 L36.6400259,22.256512 L27.490602,35.1227983 C27.2456978,35.4691144 27.2147099,35.9196229 27.4106333,36.2937236 C27.6055571,36.6688167 27.9944051,36.9030017 28.4192391,36.9030017 L34.0280468,36.9030017 C33.7361609,37.2810717 21.1090963,52.7859092 21.1090963,52.7859092 L25.1535155,41.3167948 C25.2744682,40.9724634 25.2204893,40.5894319 25.0075726,40.291739 C24.7946558,39.9920615 24.448791,39.8154304 24.0799351,39.8154304 L18.9059575,39.8154304 L26.9798017,22.256512 Z M46.7830613,32.3274622 C47.0029754,32.2034235 47.2198906,32.1399157 47.4278093,32.1399157 C47.6797108,32.1399157 47.9236155,32.2341851 48.1495272,32.419747 C50.9494328,34.7139668 52.7997096,36.932771 53.9722513,39.4016373 C56.1504,43.9861077 55.7735473,48.3423468 52.8187022,52.7174398 L52.7597252,52.8057554 C52.7127436,52.8772017 52.665762,52.9496403 52.6127827,53.0151327 C52.3128999,53.3922104 51.9020605,53.6105185 51.4892218,53.6105185 C51.2453172,53.6105185 51.0134078,53.5360953 50.8014907,53.3922104 C50.2237165,53.0002481 50.1087614,52.3473084 50.493611,51.6467378 C50.6155633,51.4234681 50.7585075,51.2121062 50.9014516,50.9997519 C51.0034117,50.8479286 51.1053719,50.6961052 51.2013344,50.5393203 C53.4564529,46.871744 53.3774838,43.0463905 50.9664262,39.1724138 C50.7735016,38.8608286 50.5565864,38.5611511 50.3396712,38.2644505 L50.0567817,37.8714959 L49.2920806,38.0798809 C49.1701283,39.7201687 49.0591717,41.2046639 48.6373365,42.6544282 C48.3734397,43.5683453 48.0285745,44.2441082 47.5547597,44.7849169 C46.9150097,45.5132721 46.0923313,45.8982883 45.1776888,45.8982883 C44.2770408,45.8982883 43.3514026,45.5261722 42.5027343,44.8226247 C42.0539098,44.4515009 41.8289977,44.2649467 41.5381114,44.2649467 C41.0722934,44.2649467 40.9303489,44.6757628 40.7164325,45.2969486 C39.8757611,47.734061 40.4935197,49.6541801 42.6036949,51.1624907 C43.0705124,51.4978913 43.7662405,52.1905234 43.1824687,53.0786405 C42.9625546,53.4130489 42.6306843,53.58968 42.2228437,53.58968 C41.8899738,53.58968 41.5261161,53.4706028 41.1692555,53.2463409 C38.1854218,51.3669065 37.0338719,47.6894071 38.3693499,44.3036467 C38.8291702,43.1366906 39.4379323,42.0401885 40.1776431,41.0458943 C40.5135118,40.5924088 40.9333478,40.3423468 41.3571821,40.3423468 C41.7800168,40.3423468 42.1928555,40.5934011 42.5187281,41.0478789 C43.0745108,41.8179112 43.5543233,42.3676507 44.0751197,42.830067 C44.3520115,43.0751675 44.6848814,43.3282064 45.0477396,43.3282064 C45.650504,43.3282064 45.9273958,42.6712974 46.0593442,42.3567353 C46.5821398,41.115356 46.620125,39.8104689 46.6141273,38.5790127 C46.6071301,37.0558174 46.4571887,35.4532374 46.1453106,33.5341106 C46.0413512,32.8920863 46.4341977,32.5239395 46.7830613,32.3274622 Z","id":"icons/ic-eletricidade-gas"})))))))));
}

ElectricityplusgasComponent.defaultProps = {"width":"48px","height":"40px","viewBox":"0 0 48 40","version":"1.1"};

module.exports = ElectricityplusgasComponent;

ElectricityplusgasComponent.default = ElectricityplusgasComponent;


/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function GasComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"UI---Desktop","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"comercializadores_desktop","transform":"translate(-689.000000, -412.000000)","fill":"#3E3E3E"},React.createElement("g",{"id":"section---comercializadores","transform":"translate(0.000000, 96.000000)"},React.createElement("g",{"id":"content","transform":"translate(130.000000, 120.000000)"},React.createElement("g",{"id":"selector","transform":"translate(397.000000, 176.000000)"},React.createElement("g",{"id":"gas","transform":"translate(139.000000, 0.000000)"},React.createElement("g",{"id":"box"},React.createElement("path",{"d":"M36.9637116,20 L38.2615906,20 C40.9292454,21.9095454 43.6809356,23.8869899 46.1338336,26.176026 C49.0199803,28.8687362 52.6306983,32.5762121 54.9500735,37.3784444 C56.3497286,40.2795024 57.0276136,42.8233926 57.0425532,45.2845018 L57.0425532,45.4584351 C57.0406857,45.7886292 57.0266799,46.1178933 57.0005355,46.4452971 C56.5000584,52.8017672 53.7997232,57.1584699 48.7473323,59.760958 C48.4401365,59.9200093 48.1450791,60 47.8705637,60 C47.5176153,60 47.2216242,59.8669922 46.9900602,59.603767 C46.6931354,59.2689222 46.5764196,58.8987327 46.6529852,58.5341239 C46.7416891,58.1071968 47.0824991,57.7360772 47.6128554,57.4868039 C49.089076,56.7975817 50.3468048,55.7958377 51.3496264,54.512266 C54.5971251,50.3546099 55.3198289,45.6556214 53.4981297,40.5427276 C52.4262124,37.5365655 50.6381273,34.6792233 47.8705637,31.5493547 C45.652031,29.038949 43.0366648,26.6885246 39.63977,24.1530055 L39.5585358,24.0916173 C39.3942001,23.9651203 39.2093223,23.8209511 38.9646861,23.8209511 C38.6406833,23.8209511 38.4081855,24.052552 38.2765302,24.5120335 C37.2288897,28.1664923 34.942195,31.1828857 32.6265548,33.9007092 C32.3146903,34.2662481 31.999091,34.6308569 31.6844254,34.9945355 C30.1671208,36.7440995 28.5984613,38.5531915 27.4210329,40.6329497 C25.1558139,44.635275 24.8962381,48.2683409 26.6254985,51.7404953 C28.3444878,55.1866062 31.2465079,57.1296361 35.2493908,57.5165678 C36.0617323,57.5937682 36.5855526,58.1183583 36.5547396,58.818742 C36.5248604,59.5033136 36.0047751,59.962795 35.262463,59.9637251 C31.3753621,59.8865248 28.1885556,58.1964888 25.4807505,54.7968841 C23.8056463,52.6938728 22.9708953,50.0839437 23.0007745,47.0377863 C23.0306538,43.805604 24.0820291,40.7603767 26.2155928,37.7263109 C27.280974,36.2102081 28.510691,34.774096 29.6993241,33.3872805 C30.6657304,32.2590396 31.6638834,31.0935938 32.5770673,29.8835019 C34.543494,27.2754331 35.6733024,24.941751 36.1298943,22.5383095 C36.1933877,22.1997442 36.2578148,21.8388559 36.2848928,21.4714568 C36.3297117,20.8780374 36.5519384,20.3953029 36.9637116,20 Z M39.9749776,31.917684 C40.1981381,31.7921172 40.4166299,31.7279386 40.6267182,31.7279386 C40.8825591,31.7279386 41.128129,31.8237414 41.3578256,32.0116266 C44.1888825,34.3397279 46.0591355,36.590629 47.2459011,39.0963841 C49.4485605,43.7488664 49.0666666,48.1697477 46.0796775,52.6101616 L46.019919,52.6994536 C45.9713653,52.7720033 45.924679,52.844553 45.8705229,52.912452 C45.5670619,53.2947332 45.1534214,53.5151727 44.7360459,53.5151727 C44.4886085,53.5151727 44.2542433,53.4407627 44.0385527,53.2947332 C43.454974,52.8966399 43.3382582,52.2343913 43.7276219,51.5237763 C43.8518075,51.296826 43.9956013,51.0810371 44.1393951,50.8661784 C44.2430386,50.7117777 44.3457485,50.557377 44.442856,50.3992559 C46.7239483,46.676898 46.6445816,42.796419 44.2066233,38.8647832 C44.0105409,38.5476107 43.7911153,38.2443902 43.5716897,37.9420998 L43.2859696,37.5440065 L42.5128445,37.7560749 C42.3895927,39.4200674 42.2766119,40.9259388 41.8508329,42.3983258 C41.5837873,43.3247297 41.2345738,44.0120916 40.7555724,44.5599349 C40.1085004,45.2984537 39.2774843,45.690036 38.3512282,45.690036 C37.4408455,45.690036 36.5052521,45.3124055 35.6462243,44.5990001 C35.1924335,44.2213696 34.9646044,44.0316242 34.6704808,44.0316242 C34.1989492,44.0316242 34.0560891,44.4492501 33.8394647,45.0789443 C32.9897742,47.5530752 33.6144368,49.5007557 35.7480004,51.0317405 C36.2204657,51.3712359 36.9235613,52.0753401 36.3334466,52.9757005 C36.1121535,53.316126 35.7769459,53.4937798 35.3633054,53.4937798 C35.0262303,53.4937798 34.6583423,53.3737937 34.2979241,53.1468434 C31.280122,51.2391582 30.1157658,47.506569 31.4668672,44.0725497 C31.9318627,42.8866411 32.5471881,41.7742123 33.2941688,40.7659574 C33.6349787,40.3046157 34.0588903,40.0516219 34.4874705,40.0516219 C34.9151169,40.0516219 35.3324924,40.306476 35.6630314,40.7668876 C36.2242006,41.5481921 36.7097381,42.1062667 37.2372932,42.5759795 C37.517411,42.8252529 37.8535523,43.0810371 38.2205066,43.0810371 C38.8302296,43.0810371 39.1094137,42.4159981 39.2429365,42.0951052 C39.7714253,40.8347867 39.8106418,39.5112196 39.8041057,38.2629927 C39.7975696,36.7161958 39.6463061,35.0894082 39.3307067,33.1426578 C39.2242619,32.4915707 39.6220292,32.1176607 39.9749776,31.917684 Z","id":"icons/ic-gas"})))))))));
}

GasComponent.defaultProps = {"width":"35px","height":"40px","viewBox":"0 0 35 40","version":"1.1"};

module.exports = GasComponent;

GasComponent.default = GasComponent;


/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcEletricCarComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-eletric car"},React.createElement("path",{"id":"Shape","fillRule":"evenodd","clipRule":"evenodd","d":"M28.8486 20.9351L29.0045 20.9942C30.5801 21.6052 31.6198 23.1073 31.6275 24.784V28.9373C31.6275 29.3464 31.2929 29.678 30.8801 29.678H28.6972V32.2545C28.6972 32.6661 28.3605 32.9997 27.9452 32.9997H24.593C24.3939 32.9998 24.2031 32.9211 24.0628 32.7812C23.9225 32.6413 23.8443 32.4517 23.8455 32.2545V29.678H12.7892V32.2545C12.7892 32.6661 12.4525 32.9997 12.0371 32.9997H8.67578C8.46701 33.0051 8.26548 32.9237 8.12 32.7753C7.97452 32.6268 7.89836 32.4248 7.90996 32.2182V29.6416H5.74548C5.33191 29.6416 4.99594 29.3108 4.99342 28.9009V24.7476C5.00262 23.0687 6.04638 21.5659 7.62564 20.9578L7.78156 20.8987L7.19458 20.5125H5.74548C5.33013 20.5125 4.99342 20.1788 4.99342 19.7673C4.99342 19.3557 5.33013 19.022 5.74548 19.022H7.41928C7.56819 19.0215 7.71374 19.0659 7.83659 19.1492L9.53332 20.2671L10.478 17.4588C10.9915 15.8994 12.4685 14.8519 14.1237 14.8732H17.7281V13.0556C17.6415 13.0499 17.5563 13.0428 17.4719 13.0358C17.288 13.0205 17.1079 13.0056 16.9256 13.0056C15.3387 12.9596 13.7641 12.7153 12.2389 12.2785C12.1067 12.2308 11.9596 12.2458 11.84 12.3194C10.6385 13.46 9.23983 13.5327 7.77697 13.0056C7.08175 12.7368 6.40736 12.4179 5.75924 12.0513C5.58364 11.9675 5.456 11.8091 5.41229 11.6209C5.36859 11.4326 5.41357 11.2349 5.53454 11.0834C5.6464 10.9097 5.76226 10.7398 5.88341 10.5623L5.88342 10.5622C5.94603 10.4705 6.01004 10.3766 6.07566 10.2791L4.78706 9.32485C4.36517 9.03857 4.25052 8.73411 4.47981 8.37967C4.7091 8.02523 5.08513 7.97979 5.50702 8.26152L6.83231 9.17035C6.91264 9.05262 6.99158 8.93627 7.06982 8.82097L7.06987 8.8209C7.30868 8.46892 7.54091 8.12666 7.78615 7.78439L7.68878 7.71981C7.22643 7.41325 6.79779 7.12903 6.36914 6.78922C6.1973 6.63706 6.1017 6.41769 6.10776 6.1894C6.1762 5.9749 6.33032 5.79754 6.53423 5.69863C6.72912 5.64132 6.93945 5.66944 7.11204 5.77588C7.46351 5.98891 7.80228 6.22206 8.1567 6.46598C8.27858 6.54986 8.40231 6.63502 8.52904 6.72106L8.98762 6.05762C9.08308 5.83821 9.28365 5.68122 9.52116 5.64001C9.75867 5.5988 10.0011 5.67892 10.1662 5.85313C10.9726 6.40091 11.6706 7.09097 12.2252 7.8889C12.8151 8.69485 13.0102 9.72003 12.7571 10.6835L12.6654 11.0425C14.3036 11.519 16.0024 11.7593 17.7097 11.756V11.347C17.7125 11.0376 17.7103 10.7273 17.7081 10.417V10.417C17.703 9.6928 17.6978 8.96816 17.7556 8.25243C18.0047 5.16721 20.69 2.84094 23.8088 3.00851C26.0376 3.14336 27.787 4.95402 27.8259 7.16639C27.9877 9.14374 26.7814 10.9799 24.891 11.6333C23.1065 12.3461 21.2291 12.805 19.3148 12.9965C19.2047 13.0056 19.0213 13.1192 19.0213 13.1919V14.9096H22.4789C24.1425 14.8783 25.6315 15.9277 26.1475 17.4952L27.0922 20.3035L28.7844 19.1856C28.9076 19.103 29.0529 19.0587 29.2017 19.0584H30.8846C31.3 19.0584 31.6367 19.392 31.6367 19.8036C31.6367 20.2152 31.3 20.5488 30.8846 20.5488H29.4355L28.8486 20.9351ZM23.5888 4.28088C21.1372 4.2699 19.1234 6.19687 19.0489 8.62506C19.0374 9.37783 19.0419 10.1306 19.0463 10.886V10.886V10.8861V10.8861V10.8861V10.8861V10.8862V10.8862V10.8862L19.0489 11.3425C19.0489 11.3982 19.0549 11.4539 19.0607 11.5084C19.0663 11.5606 19.0718 11.6116 19.0718 11.6605C19.103 11.6715 19.1353 11.6792 19.1681 11.6833C21.0963 11.497 22.982 11.0061 24.7536 10.2291C26.0957 9.5948 26.8099 8.11892 26.4686 6.68472C26.1929 5.31541 24.9974 4.31754 23.5888 4.28088ZM11.4731 10.3836C11.1338 11.4015 10.29 12.1695 9.12065 12.0286C8.36144 11.9343 7.63381 11.6702 6.99285 11.2561L6.9929 11.256C7.91004 9.89281 8.82717 8.5296 9.74431 7.19365C10.7486 7.84346 11.8446 9.26122 11.4731 10.3836ZM14.1237 16.3955C13.1167 16.3783 12.2163 17.0143 11.9042 17.9632L10.9641 20.7215H25.6386L24.7214 17.9632C24.4093 17.0143 23.5089 16.3783 22.5019 16.3955H19.9018V16.4819C19.9018 16.8934 19.5651 17.2271 19.1497 17.2271H17.4759C17.2761 17.2283 17.0841 17.1502 16.9427 17.0102C16.8014 16.8701 16.7226 16.6799 16.7238 16.4819V16.3955H14.1237ZM11.2805 31.5138H9.44615V29.6961H11.2805V31.5138ZM25.3358 31.5138H27.1977L27.1701 29.6961H25.3358V31.5138ZM30.1279 28.192H6.49746V24.7839C6.49746 23.361 7.66158 22.2074 9.09759 22.2074H27.5278C28.9627 22.2099 30.1254 23.362 30.1279 24.7839V28.192ZM25.0836 25.2021C25.0836 24.5621 25.6072 24.0433 26.253 24.0433C26.8988 24.0433 27.4224 24.5621 27.4224 25.2021C27.4224 25.842 26.8988 26.3608 26.253 26.3608C25.6072 26.3608 25.0836 25.842 25.0836 25.2021ZM10.3542 24.0433C9.70835 24.0433 9.18481 24.5621 9.18481 25.2021C9.18481 25.842 9.70835 26.3608 10.3542 26.3608C11 26.3608 11.5235 25.842 11.5235 25.2021C11.5235 24.8947 11.4003 24.6 11.181 24.3827C10.9617 24.1654 10.6643 24.0433 10.3542 24.0433ZM15.3802 24.4567H21.2454C21.6368 24.4871 21.9388 24.8107 21.9388 25.1997C21.9388 25.5887 21.6368 25.9123 21.2454 25.9427H15.3802C15.0984 25.9645 14.8279 25.8279 14.6802 25.589C14.5326 25.3501 14.5326 25.0493 14.6802 24.8104C14.8279 24.5715 15.0984 24.4349 15.3802 24.4567Z","fill":"#3E3E3E"})));
}

IcEletricCarComponent.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = IcEletricCarComponent;

IcEletricCarComponent.default = IcEletricCarComponent;


/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcGasComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-gas"},React.createElement("path",{"id":"Vector","fillRule":"evenodd","clipRule":"evenodd","d":"M23.3943 16.3119V12.4621C23.3943 11.3736 23.3946 10.2851 23.3943 9.19684C23.3941 8.96564 23.3936 8.96515 23.1569 8.96491C22.9616 8.96467 22.7665 8.96683 22.5715 8.96491C22.47 8.96371 22.4192 9.00553 22.4233 9.1096C22.4255 9.16367 22.4231 9.21775 22.4231 9.27207C22.4228 13.9782 22.4228 18.6845 22.4228 23.3908C22.4228 23.4341 22.4262 23.4776 22.4226 23.5206C22.4132 23.6374 22.4603 23.6881 22.5821 23.684C22.7716 23.6775 22.9614 23.6826 23.1512 23.6824C23.3939 23.6821 23.3943 23.6819 23.3943 23.4444V16.3119ZM10.3488 16.3376V13.2999C10.3488 11.9295 10.3493 10.5591 10.349 9.18867C10.3488 8.9666 10.3469 8.96539 10.1196 8.96491C9.92979 8.96467 9.73977 8.969 9.55023 8.96371C9.4278 8.96011 9.37007 9.00337 9.37488 9.13243C9.38113 9.29995 9.37632 9.4677 9.37632 9.6357V15.3712V20.9934C9.37632 21.8272 9.37849 22.6611 9.37416 23.4954C9.3732 23.6331 9.41264 23.6929 9.55865 23.685C9.74241 23.6749 9.92738 23.6826 10.1114 23.6824C10.3488 23.6821 10.349 23.6819 10.349 23.4386C10.349 21.0718 10.349 18.7047 10.3488 16.3376ZM14.7051 16.3393V9.90392C14.7051 9.64916 14.6993 9.39464 14.7075 9.14012C14.7116 9.00313 14.6579 8.95842 14.5264 8.96299C14.3205 8.96996 14.1141 8.97116 13.9084 8.96275C13.7641 8.95674 13.698 9.00072 13.7107 9.15574C13.7317 9.41339 13.7439 9.67752 13.7321 9.93011C13.7102 10.4002 13.716 10.8696 13.7155 11.339C13.7117 15.25 13.7129 19.1611 13.7122 23.0724C13.7122 23.2103 13.7369 23.3478 13.7119 23.4867C13.6833 23.6465 13.7636 23.6934 13.9137 23.6857C14.0977 23.6761 14.2822 23.6828 14.4665 23.6826C14.7048 23.6821 14.7051 23.6821 14.7051 23.441V16.3393ZM18.0682 16.3299V20.6682C18.0682 21.6051 18.0711 22.5422 18.0656 23.479C18.0646 23.6307 18.1031 23.6965 18.2652 23.6855C18.4432 23.673 18.6226 23.6826 18.8016 23.6826C19.0609 23.6824 19.0611 23.6824 19.0611 23.4305V9.24587C19.0611 9.19684 19.0585 9.14805 19.0609 9.09951C19.0662 9.00121 19.0181 8.96395 18.9238 8.96491C18.7232 8.96659 18.5226 8.96491 18.322 8.96491C18.0687 8.96515 18.0682 8.96539 18.0682 9.21294V16.3299ZM6.03604 25.6204V27.6121C6.03604 28.0363 6.03604 28.0366 6.4666 28.0363C9.65991 28.0359 12.8532 28.0347 16.0463 28.0347C19.5323 28.0349 23.0186 28.0359 26.5047 28.0361C26.706 28.0363 26.7168 28.0255 26.7168 27.8256C26.7173 27.1538 26.7173 26.4821 26.7159 25.8103C26.7159 25.7774 26.7332 25.7375 26.6954 25.706C26.3755 26.5042 25.7992 26.8964 24.9301 26.856C24.3471 26.8289 23.733 26.3994 23.5237 25.8531C23.4044 25.5421 23.3794 25.2215 23.3972 24.8946C23.4044 24.7579 23.3554 24.6959 23.2106 24.7016C22.9996 24.71 22.7882 24.7093 22.5772 24.7038C22.4514 24.7002 22.4024 24.7607 22.4267 24.8713C22.4517 24.9857 22.4308 25.0958 22.4235 25.2073C22.4009 25.5493 22.3312 25.8711 22.1176 26.1574C21.7469 26.6537 21.2637 26.8755 20.645 26.8575C19.8943 26.8356 19.2302 26.2927 19.0876 25.5548C19.0429 25.3234 19.0647 25.0903 19.0631 24.8581C19.0623 24.7478 19.027 24.699 18.9125 24.704C18.7718 24.7098 18.6306 24.7052 18.4896 24.7052C18.0687 24.7052 18.055 24.7057 18.0711 25.1234C18.1103 26.1338 17.2509 26.907 16.3347 26.8625C15.4257 26.8185 14.7089 26.1324 14.7051 25.2222C14.7046 25.0922 14.7027 24.9622 14.7051 24.8321C14.707 24.743 14.6683 24.7045 14.579 24.7052C14.3349 24.7072 14.0908 24.7079 13.8471 24.7048C13.7502 24.7036 13.7095 24.7427 13.7119 24.8398C13.7155 24.9915 13.7167 25.1434 13.711 25.295C13.6946 25.7264 13.5306 26.0987 13.2208 26.3951C12.7233 26.8714 12.1184 26.9793 11.4846 26.776C10.8436 26.5705 10.4744 26.0942 10.3671 25.4234C10.3368 25.2342 10.3526 25.0451 10.3502 24.8559C10.349 24.7586 10.3235 24.7024 10.2127 24.7045C9.97958 24.7086 9.7465 24.7076 9.51319 24.705C9.41673 24.7038 9.3768 24.7466 9.37632 24.8415C9.37536 25.0093 9.3732 25.1765 9.35925 25.3445C9.25774 26.5801 7.97618 27.198 6.9099 26.6842C6.46106 26.4681 6.18662 26.0946 6.03604 25.6204ZM16.4045 30.6846H3.34304C3.28338 30.6846 3.22349 30.681 3.16408 30.6846C3.0443 30.6921 2.99908 30.6332 3.00004 30.519C3.0022 30.2479 3.00028 29.9771 3.00028 29.7062C3.00004 29.2296 2.9998 28.753 3.00028 28.276C3.00052 28.0371 3.00124 28.0368 3.24682 28.0366C3.64274 28.0361 4.03842 28.0366 4.43433 28.0359C4.65105 28.0354 4.65202 28.0347 4.65202 27.8229C4.65226 26.4794 4.66717 25.1354 4.64624 23.7922C4.6347 23.0454 5.14751 22.4107 5.85059 22.3364C5.97038 22.3239 6.01271 22.2785 6.01223 22.1521C6.00718 20.8031 6.00742 19.4543 6.00814 18.1058C6.00982 15.1909 6.02378 12.2763 6.00718 9.36171C6.00261 8.56042 6.02065 7.75937 6.00766 6.95808C5.99034 5.87271 7.1004 5.07142 8.16187 5.38626C8.90728 5.60737 9.36526 6.22432 9.3756 7.02441C9.37873 7.26835 9.38041 7.51231 9.37488 7.75577C9.37175 7.88339 9.42371 7.92953 9.54854 7.92593C9.75949 7.92016 9.9714 7.91944 10.1826 7.92593C10.3118 7.93001 10.3495 7.87594 10.3512 7.75264C10.357 7.40631 10.319 7.05878 10.3753 6.71438C10.4991 5.95995 11.0675 5.42736 11.8502 5.32858C12.5701 5.23773 13.2874 5.64222 13.5808 6.3118C13.6662 6.506 13.7114 6.71317 13.7122 6.92731C13.7129 7.20923 13.7158 7.49091 13.7112 7.77259C13.7095 7.88507 13.7543 7.92761 13.8649 7.92569C14.0927 7.9216 14.3205 7.92064 14.5483 7.92593C14.6697 7.92881 14.7089 7.87762 14.7068 7.76082C14.7015 7.47938 14.7027 7.19745 14.706 6.91578C14.7178 5.96427 15.6172 5.19783 16.5637 5.33098C17.4979 5.46197 18.0685 6.12001 18.0682 7.06575C18.0682 7.29864 18.0725 7.53177 18.067 7.76466C18.0641 7.88507 18.1134 7.92833 18.2306 7.92569C18.4528 7.92088 18.6753 7.9192 18.8976 7.92641C19.0289 7.93074 19.0657 7.87473 19.0631 7.75192C19.057 7.47577 19.0597 7.19938 19.0619 6.92323C19.0696 5.9525 19.9768 5.18461 20.9383 5.33411C21.8513 5.47615 22.4183 6.13491 22.4228 7.06022C22.4238 7.28758 22.4276 7.51518 22.4211 7.74278C22.4175 7.87257 22.4603 7.93146 22.5979 7.92641C22.8038 7.91896 23.0102 7.91896 23.2161 7.92641C23.3491 7.93122 23.3958 7.88338 23.3972 7.74831C23.4004 7.40751 23.3648 7.06527 23.4194 6.72615C23.5555 5.88208 24.241 5.31344 25.1091 5.32113C25.9406 5.32834 26.63 5.92966 26.7471 6.75355C26.7608 6.84944 26.7572 6.94822 26.7575 7.04556C26.7577 12.0461 26.7577 17.0466 26.7577 22.0468C26.7577 22.3038 26.7582 22.3038 27.0095 22.3511C27.6561 22.4727 28.1184 23.0325 28.1198 23.7066C28.1223 25.0718 28.1203 26.4371 28.1206 27.8025C28.1206 28.0361 28.121 28.0363 28.351 28.0363C28.7686 28.0366 29.1861 28.0359 29.6035 28.0368C29.8156 28.0371 29.8166 28.038 29.8166 28.2575C29.817 28.9943 29.817 29.7312 29.8168 30.4679C29.8168 30.6796 29.8127 30.6844 29.5962 30.6844C27.9481 30.6849 26.2997 30.6846 24.6516 30.6846H16.4045ZM27.4306 16.0839C27.5003 15.9626 27.5876 15.877 27.6723 15.7886C28.0093 15.4372 28.3665 15.106 28.6876 14.7373C29.2071 14.141 29.529 13.4448 29.7957 12.7132C29.9703 12.2342 30.1782 11.773 30.4933 11.3632C30.99 10.7174 31.6596 10.4014 32.4466 10.2908C32.6022 10.2689 32.7584 10.2547 32.9161 10.2593C33.0075 10.2617 33.0249 10.3002 32.965 10.3667C32.8781 10.4634 32.7882 10.5573 32.698 10.6508C32.3369 11.0248 31.9735 11.3964 31.6144 11.7725C31.403 11.9936 31.2969 12.2714 31.2067 12.5577C31.041 13.084 30.8868 13.614 30.6147 14.1009C30.1531 14.9274 29.457 15.4754 28.5935 15.8277C28.3075 15.9443 28.0095 16.0275 27.7036 16.0767C27.6201 16.09 27.5364 16.1089 27.4306 16.0839ZM27.6055 13.202C27.7763 13.0414 27.9245 12.9013 28.0736 12.7619C28.535 12.3298 28.8953 11.834 29.1041 11.2286C29.2472 10.8135 29.4269 10.4107 29.7578 10.1016C30.1292 9.75479 30.5819 9.61852 31.08 9.60746C31.1115 9.60674 31.1522 9.59905 31.1693 9.62982C31.1938 9.67332 31.1498 9.69807 31.1253 9.72306C30.9174 9.93648 30.7156 10.1562 30.4975 10.3588C30.2557 10.5832 30.1015 10.8505 30.008 11.1649C29.8971 11.5386 29.7711 11.9099 29.5288 12.2243C29.0757 12.8119 28.4683 13.1313 27.7398 13.2337C27.7236 13.2361 27.707 13.2356 27.6909 13.2337C27.6808 13.2327 27.6712 13.227 27.6055 13.202Z","fill":"#3E3E3E"})));
}

IcGasComponent.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = IcGasComponent;

IcGasComponent.default = IcGasComponent;


/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function IcSolarComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-solar panel"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M25.4882 3.45098C25.4885 3.44504 25.4888 3.4391 25.4891 3.43315C25.4963 3.29028 25.4999 3.1459 25.4999 3H22.4999C22.4999 4.25 22.0624 5.3125 21.1874 6.1875C20.3124 7.0625 19.2499 7.5 17.9999 7.5C16.7499 7.5 15.6874 7.0625 14.8124 6.1875C13.9374 5.3125 13.4999 4.25 13.4999 3M23.6624 10.8L26.8124 13.9875L26.8125 13.9874L23.6624 10.8ZM6.90601 26.55L6.12601 30.45H16.9499V26.55H6.90601ZM8.10601 20.55L7.32601 24.45H16.9499V20.55H8.10601ZM19.0499 26.55V30.45H29.8738L29.0938 26.55H19.0499ZM19.0499 20.55V24.45H28.6738L27.8938 20.55H19.0499ZM6.36883 18.45L3.54883 32.55H32.451L29.631 18.45H6.36883ZM4.94992 5.55V3.45H8.54992V5.55H4.94992ZM7.68914 11.8847L9.18461 13.3539L11.7357 10.8028L10.2402 9.33359L7.68914 11.8847ZM17.9999 10.05C16.0438 10.05 14.3897 9.36585 13.0119 7.98805C11.741 6.71718 11.0603 5.21119 10.9623 3.45H13.0679C13.1636 4.62758 13.6408 5.65232 14.4942 6.5057C15.4546 7.46605 16.6319 7.95 17.9999 7.95C19.3679 7.95 20.5453 7.46605 21.5056 6.5057C22.359 5.65232 22.8362 4.62758 22.9319 3.45H25.0376C24.9395 5.21119 24.2588 6.71718 22.988 7.98805C21.6102 9.36585 19.956 10.05 17.9999 10.05ZM16.9499 16.05V12.45H19.0499V16.05H16.9499ZM28.3116 11.8519L26.8143 13.3492L24.2969 10.8019L25.7643 9.33452L28.3116 11.8519ZM27.4499 5.55V3.45H31.0499V5.55H27.4499Z","fill":"#3E3E3E"})));
}

IcSolarComponent.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = IcSolarComponent;

IcSolarComponent.default = IcSolarComponent;


/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function PersonComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"person"},React.createElement("path",{"id":"Shape","fillRule":"evenodd","clipRule":"evenodd","d":"M29.7858 14.0002C29.7858 9.56444 26.1566 5.93522 21.7209 5.93522H21.0488C20.0407 2.77645 17.0835 0.558594 13.6559 0.558594C9.35462 0.558594 5.85981 4.0534 5.85981 8.3547C5.85981 11.043 7.20397 13.3281 9.2202 14.7394C7.33838 15.4115 5.59098 16.4868 4.11241 17.9654C1.62572 20.4521 0.214355 23.8797 0.214355 27.4417H2.2978C2.2978 21.1914 7.40559 16.0836 13.6559 16.0836H13.9247C14.8657 19.5112 17.9572 22.0651 21.7209 22.0651C22.3257 22.0651 22.9306 21.9979 23.5355 21.8635C24.4764 23.5437 25.014 25.4255 25.014 27.4417H27.0975C27.0975 25.2239 26.5598 23.0732 25.5517 21.1242C28.0384 19.78 29.7858 17.0917 29.7858 14.0002ZM13.6559 14.0002C10.4971 14.0002 8.01046 11.4463 8.01046 8.3547C8.01046 5.19593 10.5644 2.70924 13.6559 2.70924C16.1426 2.70924 18.226 4.25502 19.0325 6.47288C15.8738 7.5482 13.6559 10.5053 13.6559 14.0002ZM22.4601 20.3177C23.1994 20.1833 23.9387 19.9816 24.6108 19.6456C26.627 18.5703 28.0384 16.4196 27.9712 14.0674C27.9712 10.5726 25.1485 7.74983 21.6536 7.74983H21.3176C20.5783 7.81704 19.9062 7.95145 19.2342 8.22028C17.0163 9.16119 15.4705 11.3118 15.3361 13.7985V14.0674C15.3361 14.8739 15.5377 15.6131 15.8066 16.3524C16.7475 18.7047 19.0325 20.3849 21.7209 20.3849C21.8553 20.3849 21.9729 20.3681 22.0905 20.3513C22.2081 20.3345 22.3257 20.3177 22.4601 20.3177Z","fill":"#3E3E3E"})));
}

PersonComponent.defaultProps = {"width":"30","height":"28","viewBox":"0 0 30 28","fill":"none"};

module.exports = PersonComponent;

PersonComponent.default = PersonComponent;


/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function SuccessComponent (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11.8353 50.7726C11.8353 50.7726 31.628 49.98 35.9052 17.445C39.7035 -11.4492 73.0792 1.70238 82.7269 13.2203C95.2246 28.1408 88.5624 53.8071 104.73 57.0495C120.897 60.2919 110.339 96.3418 85.7984 92.8912C55.2702 88.5988 62.6563 106.438 53.4919 113.988C46.9148 119.407 19.9463 114.191 19.0475 94.5193C18.2911 77.966 11.3086 78.0185 6.35935 76.1415C-0.778625 73.4344 -5.27634 53.8294 11.8353 50.7726Z","fill":"#93C13E","fillOpacity":"0.2","key":0}),React.createElement("path",{"d":"M67.6845 48.39L72.8608 29.0715L82.5201 31.6597L86.7627 39.0082L83.1393 52.5312L67.6845 48.39ZM79.7424 38.1624L81.0365 33.3328L74.2751 31.521L70.1339 46.9758L81.7251 50.0817L84.5721 39.4565L79.7424 38.1624Z","fill":"#93C13E","key":1}),React.createElement("path",{"d":"M43.072 97.4615L35.7915 84.8513L42.0966 81.2111L48.0638 82.81L53.1602 91.6371L43.072 97.4615ZM44.0143 85.9887L42.1941 82.8361L37.7806 85.3843L43.605 95.4724L51.1711 91.1041L47.1668 84.1685L44.0143 85.9887Z","fill":"#93C13E","key":2}),React.createElement("path",{"d":"M79.1195 86.9046L59.6738 67.6896L55.8233 71.5864L75.269 90.8014L79.1195 86.9046Z","fill":"#006736","key":3}),React.createElement("path",{"d":"M86.548 92.0679L71.4191 77.1186C71.3349 77.0354 71.1991 77.0362 71.1159 77.1204L65.3897 82.9153C65.3065 82.9996 65.3073 83.1353 65.3916 83.2186L80.5204 98.1679C80.6046 98.2511 80.7404 98.2503 80.8236 98.1661L86.5498 92.3711C86.633 92.2869 86.6322 92.1511 86.548 92.0679Z","fill":"url(#paint0_linear_1761_20189)","key":4}),React.createElement("path",{"d":"M42.5 77C56.031 77 67 66.2548 67 53C67 39.7452 56.031 29 42.5 29C28.969 29 18 39.7452 18 53C18 66.2548 28.969 77 42.5 77Z","fill":"url(#paint1_linear_1761_20189)","key":5}),React.createElement("path",{"d":"M31.1996 57.4374L31.2425 57.5058C31.2243 57.5358 31.1031 57.4395 31.1339 57.5124C31.1854 57.6343 31.2709 57.5868 31.3417 57.6246C31.4151 57.7003 31.4848 57.7763 31.5197 57.8575C31.5542 57.9932 31.712 58.0616 31.8175 58.1588C31.7657 58.1772 31.656 58.0513 31.6008 58.1349C31.807 58.208 31.8378 58.396 32.0114 58.5024L32.3128 58.8915C32.4557 59.0508 32.5877 59.2083 32.7634 59.3621C33.3506 59.8771 33.9684 60.3572 34.5635 60.8685L34.8962 61.1514C35.0001 61.2171 35.0632 61.3686 35.2027 61.3775C35.1506 61.3034 35.0233 61.2266 35.0782 61.1667L35.4163 61.4388L35.7309 61.7156L35.693 61.7708C35.6967 61.7861 35.7011 61.8005 35.7064 61.8147C35.7077 61.8181 35.7093 61.8218 35.7106 61.8252C35.7146 61.8307 35.7182 61.836 35.7222 61.8415C35.7301 61.8523 35.7385 61.8633 35.7469 61.8739C35.7808 61.917 35.819 61.959 35.86 62.0003C35.9424 62.0834 36.0368 62.1633 36.1367 62.2427C36.3372 62.4031 36.5579 62.5582 36.7649 62.7525C36.5747 62.4875 36.4392 62.2661 36.8428 62.5892C36.9809 62.6999 37.1384 62.8277 37.2865 62.9523C37.4346 63.0753 37.5732 63.1941 37.6737 63.2912C37.8821 63.4917 38.0899 63.6674 38.2945 63.833C38.4997 63.9989 38.702 64.1556 38.9079 64.3262C39.1528 64.5207 39.398 64.7153 39.6432 64.9098C39.6729 64.9295 39.7039 64.9532 39.7363 64.9798C39.7444 64.9866 39.7523 64.9932 39.7605 65C39.7655 64.9929 39.7702 64.9832 39.7752 64.975C39.7849 64.9587 39.7949 64.9419 39.8049 64.9251C39.8452 64.8593 39.8873 64.7968 39.9278 64.7303C40.0085 64.5978 40.0838 64.4495 40.1187 64.2478C40.3144 63.9463 40.517 63.6229 40.6998 63.2144L40.9523 62.7278C41.0512 62.5521 41.1486 62.3702 41.2446 62.1838C41.3401 61.9922 41.4361 61.8002 41.5316 61.6089C41.5797 61.5137 41.6278 61.4183 41.6773 61.3252C41.7281 61.234 41.7794 61.1438 41.8317 61.0547C41.884 60.9655 41.9374 60.8775 41.9924 60.7905C42.0198 60.7471 42.0477 60.7037 42.0761 60.6608C42.0903 60.6395 42.1045 60.6183 42.1187 60.5967L42.1403 60.5649L42.1531 60.5499C42.21 60.4395 42.2941 60.3209 42.3175 60.2202C42.3315 60.1603 42.3583 60.1017 42.3899 60.0441C42.4057 60.0152 42.4228 59.9865 42.4399 59.9578C42.4578 59.9297 42.4759 59.9013 42.4935 59.8737C42.5632 59.7615 42.6201 59.6492 42.6003 59.5291C42.8002 59.36 42.8899 59.0716 43.0646 58.8644C43.1156 58.804 43.1648 58.7425 43.2124 58.6799C43.2598 58.6163 43.3063 58.5532 43.3529 58.4906C43.445 58.3634 43.5307 58.2319 43.6102 58.0968C43.769 57.8265 43.9037 57.5415 44.0179 57.2453C44.065 57.1643 44.1173 57.0862 44.167 57.0068L44.3827 56.7555C44.5011 56.5972 44.5976 56.4329 44.6481 56.2549L44.8049 56.022L44.8715 55.9807C44.9564 55.9528 44.9917 55.8932 45.0188 55.828C45.0453 55.7628 45.0606 55.6899 45.1006 55.6332L45.1874 55.4415C45.2637 55.2517 45.5514 55.1129 45.4846 54.8889L45.5001 54.8592L45.5217 54.8331C45.6346 54.8055 45.7185 54.6828 45.7779 54.5647C45.8276 54.4627 45.8918 54.3697 45.955 54.2758C46.0186 54.1825 46.0838 54.0902 46.1441 53.995L46.5058 53.4908C46.5731 53.3969 46.6405 53.3033 46.7088 53.2082C46.7425 53.1601 46.7788 53.1135 46.8149 53.0657C46.8512 53.0181 46.8877 52.9697 46.9251 52.9208C46.8191 52.9284 46.7444 53.0728 46.6631 53.0885L46.7183 52.9558L46.8035 52.8448C46.924 52.6766 47.0492 52.5089 47.054 52.3372L47.1797 52.1737C47.2516 52.1747 47.2255 52.2773 47.1013 52.4815C47.1808 52.5404 47.3199 52.4573 47.3922 52.3464C47.5006 52.1802 47.6085 52.0141 47.7211 51.8508C47.8371 51.6902 47.9567 51.5317 48.0838 51.3768L48.2027 51.212C48.2777 51.0713 48.4131 50.943 48.4518 50.7942C48.4844 50.7295 48.5407 50.6825 48.5938 50.6333C48.6204 50.6089 48.6459 50.5834 48.6678 50.5552C48.6901 50.5274 48.7083 50.4964 48.7188 50.4598C48.8314 50.388 48.9237 50.285 49.0105 50.1719L49.207 49.8709L49.186 49.8662L49.0952 49.9614C49.086 49.955 49.0771 49.9482 49.0684 49.9411C49.0657 49.8993 49.0944 49.8557 49.131 49.8115L49.3556 49.546L49.3782 49.5194L49.4006 49.4929L49.4877 49.5213C49.4995 49.4077 49.5729 49.3485 49.6529 49.2933C49.7341 49.2394 49.8228 49.19 49.8636 49.0922C49.8967 49.0133 50.0722 48.9589 50.048 48.8235C49.9712 48.9011 49.9017 48.9715 49.8228 49.0517C49.8312 48.961 49.9756 48.884 49.9417 48.7951C49.8094 48.9305 49.7565 48.8335 49.6492 48.8774C49.7131 48.655 49.8793 48.4673 50.0703 48.2896L50.2837 48.0509C50.3528 47.978 50.4152 47.9023 50.4712 47.8245C50.5291 47.7483 50.5801 47.6697 50.6246 47.5882C50.6277 47.585 50.6298 47.5826 50.6314 47.5803L50.7145 47.4854L51.0047 47.182C51.1251 47.1446 51.5952 46.7642 51.5947 46.6909C51.5947 46.5663 51.6349 46.4385 51.6999 46.2957C51.8461 46.1493 51.9579 45.9971 52.0545 45.8288C52.1502 45.6614 52.2623 45.4787 52.4651 45.3738C52.4967 45.3409 52.5167 45.312 52.5245 45.2867C52.533 45.262 52.5295 45.241 52.514 45.2234L52.5645 45.1755C52.5735 45.1834 52.5819 45.1913 52.5903 45.1997C52.8557 45.0493 53.1001 44.8453 53.3087 44.6095C53.4271 44.4757 53.537 44.339 53.6575 44.2112C53.7169 44.1463 53.783 44.0882 53.8521 44.0311C53.9216 43.9749 53.996 43.922 54.0778 43.8747C54.2225 43.7906 54.208 43.6586 54.2496 43.5508C54.2641 43.5135 54.243 43.5001 54.1967 43.5161C54.1149 43.5445 53.9545 43.6804 53.8082 43.8297C53.7351 43.9044 53.6654 43.9822 53.6109 44.0519C53.5578 44.1229 53.5199 44.1857 53.5075 44.2273L53.2534 44.4699C53.2356 44.4836 53.2177 44.4988 53.1995 44.5107C53.1929 44.5149 53.1785 44.513 53.1793 44.5112C53.2398 44.3655 53.3631 44.2094 53.3986 44.0548C53.1388 44.2046 52.8644 44.2625 52.6795 44.6056C52.6463 44.6668 52.5277 44.7628 52.4567 44.7951C52.3562 44.8406 52.2802 44.8971 52.221 44.9634C52.1629 45.0309 52.1218 45.1085 52.0882 45.1939L51.7367 45.5391L51.6865 45.5849C51.5728 45.6138 51.4963 45.7216 51.4121 45.8131L51.3374 45.8462C51.3427 45.7797 51.4092 45.7237 51.4621 45.6651C51.6602 45.4716 51.8364 45.2654 52.0092 45.0567L52.1384 44.8997L52.2718 44.7467C52.3612 44.645 52.4519 44.544 52.5464 44.4455C52.5485 44.5362 52.6056 44.5383 52.7082 44.4334C52.8021 44.3374 52.7739 44.3009 52.7013 44.2974L52.7897 44.1707C52.9225 44.0106 53.1214 43.8947 53.219 43.7104C53.3455 43.5724 53.4755 43.438 53.6038 43.3013C53.7182 43.2012 53.8387 43.1055 53.9455 42.9995C54.05 42.8962 54.2312 42.8042 54.2067 42.6659C54.2638 42.6049 54.3569 42.5557 54.3632 42.4824C54.2912 42.4332 54.2386 42.6078 54.1494 42.6002C54.0702 42.5933 54.0205 42.6525 53.9916 42.7626L53.4639 43.2409L53.1427 43.5158C52.9509 43.5729 52.862 43.7858 52.7058 43.8963C52.634 43.9641 52.5508 44.0332 52.6032 44.0884L52.6282 44.1176C52.6198 44.1344 52.6071 44.1489 52.59 44.1613L52.3665 44.3527C52.1973 44.3853 52.1676 44.3395 52.3659 44.1599C52.3872 44.1408 52.398 44.1082 52.4138 44.0816C52.5214 43.9583 52.6484 43.8492 52.7705 43.7364C52.8315 43.6802 52.8915 43.6228 52.947 43.5626C53.0028 43.5022 53.0538 43.4383 53.1004 43.3715C53.3153 43.121 53.5915 42.9083 53.793 42.6483C53.8656 42.5852 53.9566 42.5263 53.9726 42.4101C53.8161 42.5276 53.6919 42.6246 53.5844 42.7474C53.593 42.7453 53.6017 42.7419 53.6107 42.7374C53.6015 42.7429 53.5928 42.7466 53.5844 42.7474L53.3637 42.9185C53.2374 42.9577 53.1482 43.117 53.0167 43.167C53.1445 43.0119 53.3474 42.9062 53.4486 42.7037C53.2245 42.8394 53.0793 43.0224 52.9007 43.1504L52.8762 43.132C52.8357 43.1262 52.7926 43.1391 52.7497 43.1646C52.7071 43.1901 52.6634 43.2267 52.6198 43.2658L52.5982 43.2501C52.6563 43.1935 52.7129 43.1354 52.7726 43.0805L52.9507 42.9146C53.2992 42.6062 53.6685 42.3194 53.9687 41.9637C54.1257 41.8257 54.283 41.6876 54.4403 41.5494C54.5974 41.4311 54.7144 41.2736 54.888 41.1621C54.9775 41.1048 55.0706 40.9883 54.9214 41.0009L54.6013 41.277C54.5137 41.338 54.4556 41.4132 54.4011 41.4899C54.2954 41.5567 54.248 41.6556 54.1639 41.7344C54.0507 41.7565 53.9447 41.8222 53.8435 41.9016C53.743 41.9821 53.6446 42.0733 53.5415 42.1411C53.3871 42.1843 53.2755 42.3872 53.1214 42.4332L53.2053 42.3444C53.3392 42.1958 53.4989 42.0586 53.602 41.8959C53.7603 41.7494 53.9263 41.6119 54.1394 41.4289C53.9881 41.4918 53.8658 41.5759 53.7553 41.6648C53.6456 41.7544 53.5512 41.8522 53.4492 41.9366L53.4555 41.8351C53.476 41.8091 53.5144 41.7605 53.5149 41.7599C53.4105 41.7308 53.4107 41.6834 53.456 41.6277C53.4786 41.5998 53.5125 41.5699 53.5504 41.5391C53.5883 41.5083 53.6314 41.4784 53.6701 41.4481C53.7125 41.4153 53.764 41.3687 53.7214 41.3267C53.6407 41.3866 53.557 41.445 53.4762 41.5078C53.3952 41.5704 53.3137 41.6332 53.2321 41.6963L52.5845 42.2763C52.6816 42.1359 52.7366 41.9897 52.8912 41.8564C52.9641 41.777 53.0833 41.7179 53.1117 41.609C53.0009 41.6261 52.9294 41.7389 52.8428 41.8033C52.7526 41.8756 52.6592 42.001 52.5761 41.9455L52.534 41.8935L52.524 41.8961L52.5277 41.8914L52.534 41.8935L52.7452 41.6963C52.7829 41.6474 52.9091 41.5822 52.8297 41.5546C52.7618 41.531 52.6824 41.5804 52.6424 41.6913L52.5046 41.864C52.4612 41.8651 52.4164 41.8977 52.3715 41.9363L52.2925 41.959C52.1629 41.9931 52.1287 42.0565 52.1463 42.1351C52.0971 42.1774 52.0474 42.2195 51.9982 42.2618C51.9487 42.3039 51.9019 42.3488 51.8559 42.3941C51.7746 42.4745 51.6578 42.6254 51.6141 42.6109C51.4863 42.5691 51.3892 42.72 51.2798 42.8063C51.1488 42.8144 51.0249 42.9051 50.9802 43.0439C50.951 43.1344 50.8789 43.2033 50.8324 43.2813C50.7774 43.3329 50.7219 43.3849 50.6672 43.4365C50.6122 43.4872 50.5551 43.5332 50.4909 43.565C50.3123 43.6565 50.1837 43.8014 50.0806 43.9725C50.0314 43.9746 49.989 44.0154 49.9483 44.0664C49.9296 44.0766 49.912 44.0903 49.8954 44.1076C49.7568 44.1597 49.6552 44.2783 49.5576 44.4029C49.5398 44.4165 49.5221 44.431 49.505 44.4462C49.4345 44.4523 49.3875 44.5485 49.3262 44.5835C49.0786 44.7349 48.915 45.001 48.698 45.1945C48.6885 45.1908 48.6812 45.1847 48.6759 45.1761L48.719 45.1253C48.8203 45.0241 48.8898 44.9195 48.9229 44.8106L48.9458 44.7851L48.9708 44.762C49.0205 44.7833 49.0947 44.7486 49.1402 44.6723C49.2851 44.4231 49.5582 44.2712 49.7128 44.0393C49.7841 43.9333 49.9675 43.8842 49.9572 43.7461C50.1782 43.6732 50.2789 43.5375 50.2595 43.3389C49.9798 43.62 49.7039 43.8971 49.4282 44.1741C49.3596 44.2457 49.2904 44.2969 49.2094 44.3392C49.0458 44.4294 49.1107 44.4689 49.1404 44.5122L49.0489 44.624L48.2945 45.4234L48.1648 45.5586C48.1217 45.6035 48.078 45.6482 48.0364 45.6948C47.9062 45.8394 47.7768 45.985 47.645 46.1283C47.6061 46.1706 47.5261 46.2429 47.5225 46.2392C47.4104 46.1249 47.3139 46.3686 47.2176 46.4503C47.1389 46.5174 47.0647 46.6465 46.9961 46.6846C46.9272 46.723 46.8738 46.7634 46.8314 46.8055C46.7896 46.8481 46.7599 46.8931 46.7365 46.9385C46.6896 47.0298 46.6702 47.1249 46.6436 47.2209L46.5471 47.3297C46.4826 47.3276 46.415 47.3689 46.3443 47.4541C46.2504 47.4725 46.1943 47.575 46.1288 47.6563L45.7958 48.0469C45.7682 48.0795 45.74 48.1119 45.713 48.1447L45.6322 48.2446L45.471 48.4442C45.1995 48.6939 44.9714 48.9892 44.7523 49.2917L44.7052 49.3483C44.6718 49.3746 44.6402 49.4027 44.6103 49.4321C44.5808 49.4618 44.5537 49.4937 44.5274 49.526C44.4748 49.5909 44.4269 49.6598 44.3804 49.7295C44.2872 49.8693 44.1991 50.0131 44.0884 50.138C44.0797 50.1446 44.0718 50.1514 44.065 50.1588C43.955 50.2561 43.8598 50.3694 43.7698 50.4877C43.7248 50.5468 43.6812 50.6073 43.6375 50.6678C43.5941 50.7285 43.5494 50.7882 43.5068 50.8492C43.4905 50.8581 43.4805 50.872 43.4771 50.8904C43.4373 50.9296 43.4018 50.9727 43.3682 51.0177C43.1951 51.2238 43.0315 51.4394 42.8776 51.6644C42.8505 51.6854 42.8286 51.7088 42.8131 51.7346C42.7082 51.8511 42.6116 51.9754 42.5185 52.1027C42.4264 52.231 42.342 52.365 42.2547 52.497L42.0408 52.8004C42.0245 52.8075 42.015 52.8207 42.0124 52.8398C41.8122 53.0665 41.6418 53.3212 41.4732 53.5767C41.2725 53.8467 41.0568 54.107 40.8729 54.3896L40.6459 54.7401C40.5704 54.8571 40.4941 54.9735 40.4231 55.0932L39.9914 55.8082L39.7763 56.1663L39.6687 56.3453L39.615 56.435L39.5634 56.526L39.152 57.2531C39.0771 57.3733 39.0074 57.4966 38.94 57.6209C38.9069 57.6832 38.8737 57.7458 38.8406 57.8084C38.808 57.8712 38.7743 57.9333 38.7438 57.9974C38.6815 58.1246 38.6186 58.2514 38.552 58.3765C38.5189 58.4391 38.4847 58.5011 38.4492 58.5624L38.4426 58.5739L38.4392 58.5797L38.4376 58.5826L38.436 58.5829L38.4334 58.5824C38.4313 58.5818 38.4292 58.5813 38.4266 58.5803C38.4213 58.5776 38.4539 58.6008 38.4784 58.6189C38.4844 58.6339 38.4905 58.6486 38.4947 58.667C38.4989 58.6852 38.5021 58.7062 38.5039 58.7301L38.4978 58.7359C38.4952 58.7472 38.4907 58.7546 38.4879 58.7666C38.485 58.7787 38.4839 58.7956 38.486 58.8305C38.4823 58.8213 38.4823 58.8245 38.4857 58.8403C38.4829 58.8429 38.4802 58.8468 38.4779 58.8518C38.4765 58.8539 38.4758 58.8579 38.4744 58.8592C38.4726 58.8581 38.4705 58.8571 38.4686 58.8563C38.461 58.8531 38.4531 58.851 38.4444 58.8455C38.4281 58.835 38.4071 58.8098 38.3984 58.7501C38.3934 58.7422 38.3876 58.7396 38.3829 58.7312C38.3784 58.723 38.3753 58.7091 38.3797 58.682C38.3811 58.6657 38.385 58.6483 38.3845 58.6431C38.3837 58.6378 38.3787 58.6447 38.3566 58.6725C38.3416 58.692 38.3256 58.7104 38.3082 58.728C38.3085 58.7204 38.3082 58.7141 38.3077 58.7085V58.7075C38.3077 58.7072 38.3056 58.7049 38.3048 58.7041L38.2911 58.6909L38.2635 58.6649L38.2077 58.6131C38.1325 58.5445 38.0567 58.4759 37.9815 58.4073C37.8316 58.269 37.6882 58.1278 37.5761 57.9677C37.0077 57.3772 36.3701 56.8556 35.7161 56.3474C35.6519 56.2943 35.5864 56.2428 35.5183 56.1942C35.4836 56.1487 35.4436 56.1119 35.391 56.0956C35.174 55.9145 34.9475 55.7727 34.7129 55.665L34.4235 55.4901C34.2162 55.3332 33.9419 55.0876 33.8046 55.095C33.6486 55.1034 33.4595 55.0687 33.3208 55.1026L33.1375 55.1691C32.8784 55.0193 32.6411 54.8994 32.6551 55.1633C32.6595 55.2496 32.5435 55.1925 32.4717 55.1873L32.4007 55.1686C32.1587 55.1045 32.0598 55.1691 32.1248 55.3818C32.1282 55.4786 31.9764 55.416 31.9143 55.4525C32.0251 55.5569 32.1158 55.6429 32.2058 55.7296C32.2657 55.9775 32.0414 55.7756 31.9351 55.7026C31.757 55.5806 31.7112 55.6671 31.6292 55.6752C31.5408 55.6842 31.6876 55.804 31.7291 55.8713C31.7928 55.9736 31.883 56.0788 31.9619 56.1826C31.9832 56.2368 32.0048 56.2912 32.0272 56.348C31.953 56.3125 31.8801 56.2775 31.8073 56.2426C31.702 56.1768 31.6044 56.0359 31.489 56.0625C31.2614 55.9975 31.3106 56.1135 31.4216 56.2696C31.378 56.2893 31.4214 56.3538 31.4195 56.395C31.3803 56.4626 31.4395 56.5436 31.5453 56.6306C31.4821 56.623 31.3893 56.5404 31.3088 56.4897C31.228 56.4389 31.1599 56.4187 31.1465 56.5328C31.1491 56.5467 31.1544 56.557 31.1615 56.5646C31.233 56.6971 31.3832 56.7768 31.5087 56.873L31.6573 56.9921L31.7504 57.1214C31.7326 57.1149 31.7162 57.1038 31.7015 57.088C31.5984 57.0073 31.504 56.9114 31.4035 56.8257C31.3033 56.7402 31.197 56.6656 31.071 56.633L31.0926 56.7126C31.1062 56.7636 31.1346 56.8099 31.1736 56.853C31.2496 56.976 31.3327 57.1001 31.3567 57.2137C31.3477 57.2255 31.3482 57.2431 31.3638 57.2702C31.3893 57.3115 31.445 57.378 31.435 57.3906C31.4074 57.4256 31.3585 57.3504 31.3193 57.3262C31.2701 57.2955 31.2251 57.2684 31.1825 57.2684C31.1191 57.245 31.0129 57.1582 31.0015 57.21C30.9831 57.2941 31.1339 57.3607 31.2028 57.4382L31.1996 57.4374ZM52.5316 45.0309L52.5101 45.0601L52.5048 45.0614C52.513 45.0509 52.5219 45.0409 52.5316 45.0309ZM53.5959 43.2695L53.5965 43.2719C53.5965 43.2719 53.5954 43.2708 53.5946 43.2703L53.5959 43.2695ZM52.9025 43.9959L52.9041 43.9977L52.901 44.0006C52.9015 43.9991 52.902 43.9975 52.9025 43.9959ZM52.5832 44.1996L52.5858 44.1768C52.5858 44.1839 52.5877 44.1891 52.5911 44.1923L52.5832 44.1996ZM52.9533 42.8762C52.952 42.883 52.9515 42.8896 52.9507 42.8965C52.9504 42.8904 52.9486 42.8862 52.9452 42.8833L52.9533 42.8762ZM52.9454 42.2437L52.9433 42.2455V42.2442L52.9454 42.2437ZM52.5806 43.8542H52.5824L52.5758 43.86L52.5806 43.8542ZM52.0958 43.5971L52.0974 43.596C52.0953 43.6005 52.0929 43.605 52.0908 43.6097L52.0887 43.6118L52.08 43.6068L52.0958 43.5971ZM51.7501 44.0401H51.7512L51.7493 44.0414L51.7501 44.0401ZM51.5652 45.2515C51.5686 45.2533 51.5721 45.2549 51.5755 45.2562C51.5692 45.2583 51.5628 45.2599 51.5565 45.2612L51.5652 45.2515ZM51.5452 44.1055L51.5465 44.105L51.5515 44.1034L51.5421 44.1087L51.5452 44.1055ZM51.5376 44.1092L51.541 44.1076L51.5386 44.1097L51.5376 44.1092ZM51.471 45.0885L51.4663 45.0896L51.4697 45.0856C51.4697 45.0856 51.4705 45.0875 51.471 45.0885ZM51.1343 44.553L51.1457 44.5461L51.1186 44.5732L51.1343 44.553ZM51.0644 43.3423C51.0644 43.3423 51.067 43.3442 51.0683 43.345L51.0636 43.3492C51.0638 43.3468 51.0644 43.3447 51.0644 43.3423ZM50.9268 43.9034C50.9268 43.9034 50.9294 43.9052 50.9307 43.9063C50.9276 43.9073 50.9247 43.9084 50.9215 43.9094L50.9268 43.9034ZM50.9165 46.3181L50.9123 46.3223L50.9136 46.3207L50.9092 46.3236C50.9086 46.3223 50.9079 46.321 50.9071 46.3197C50.9102 46.3194 50.9134 46.3186 50.9165 46.3181ZM50.8713 46.1977L50.8687 46.205L50.8639 46.2064L50.8713 46.1977ZM50.8337 46.042V46.0439L50.8313 46.0449L50.8337 46.042ZM50.5033 45.9187L50.5004 45.9219L50.4991 45.9209L50.4875 45.9332C50.4875 45.9308 50.4867 45.9293 50.4865 45.9272C50.4907 45.9251 50.4949 45.923 50.4991 45.9209L50.5033 45.9187ZM50.417 44.686C50.4407 44.6616 50.4625 44.6253 50.4912 44.6345C50.4591 44.6358 50.436 44.6679 50.4107 44.6936L50.417 44.686ZM50.1158 47.7136L50.1079 47.7117L50.1048 47.7154C50.0811 47.7183 50.1361 47.6765 50.1158 47.7136ZM50.1 44.7254L50.0969 44.7283L50.0958 44.7273L50.1 44.7254ZM49.727 46.5013C49.7291 46.5003 49.7315 46.4992 49.7336 46.4984L49.7181 46.5163L49.727 46.5013ZM49.5663 45.8044C49.5668 45.8081 49.5674 45.811 49.5682 45.8141C49.564 45.8149 49.5597 45.8157 49.5555 45.816L49.5663 45.8044ZM49.3832 46.7364L49.394 46.7248C49.3964 46.7277 49.3988 46.7301 49.4011 46.7324C49.3953 46.7343 49.3893 46.7356 49.3832 46.7364ZM49.2588 44.9184L49.2522 44.9253C49.2507 44.9237 49.2541 44.9208 49.2588 44.9184ZM49.1849 46.8468C49.1839 46.8555 49.182 46.8639 49.1796 46.872C49.1783 46.8676 49.1768 46.8628 49.1746 46.8584L49.1849 46.8468ZM49.1002 45.0867L49.1055 45.0777C49.107 45.0772 49.1086 45.0767 49.1102 45.0764L49.1002 45.0867ZM49.0771 48.2688C49.0781 48.2709 49.0789 48.2725 49.0799 48.2743C49.0768 48.2749 49.0736 48.2756 49.0705 48.2759L49.0771 48.2688ZM48.9674 47.1983L48.9684 47.1972C48.9703 47.198 48.9732 47.1983 48.9766 47.1978C49.0052 47.1933 48.9576 47.2212 48.9674 47.1983ZM48.758 46.9443L48.7656 46.9359C48.7656 46.9359 48.7664 46.938 48.7667 46.9391L48.758 46.9443ZM48.5786 50.0728L48.5754 50.0807C48.5746 50.0799 48.5738 50.0794 48.5731 50.0786L48.5717 50.0797L48.5786 50.0728ZM48.5694 45.593H48.5712L48.5704 45.5951V45.5975L48.5691 45.5996L48.5694 45.593ZM48.2913 50.0137C48.2913 50.0137 48.2929 50.0142 48.2937 50.0145L48.29 50.0192C48.2905 50.0174 48.2908 50.0152 48.2913 50.0137ZM48.1467 49.0683C48.1432 49.0641 48.1422 49.0567 48.1425 49.0475C48.1461 49.052 48.1496 49.0567 48.1538 49.0601L48.1467 49.0683ZM48.1411 46.8712L48.1438 46.8718L48.1396 46.8765C48.1401 46.8747 48.1406 46.8731 48.1411 46.8712ZM48.1364 50.0841C48.139 50.0826 48.1414 50.0812 48.144 50.0797L48.1335 50.0939C48.1346 50.0907 48.1353 50.0873 48.1364 50.0841ZM48.0741 45.9269V45.9285L48.072 45.9295L48.0741 45.9269ZM48.0672 49.8346L48.0583 49.8452C48.0578 49.8399 48.0572 49.8354 48.0564 49.832C48.0604 49.832 48.0641 49.8325 48.0672 49.8346ZM47.9178 50.1556L47.9215 50.1583C47.9128 50.169 47.9044 50.1793 47.8955 50.1893C47.9023 50.178 47.9099 50.1669 47.9178 50.1556ZM47.6308 49.0086C47.6303 49.0104 47.6298 49.012 47.6292 49.0136C47.6277 49.0141 47.6261 49.0149 47.6248 49.0154L47.6308 49.0086ZM47.5987 47.1502H47.6035L47.5893 47.1665C47.5924 47.1609 47.5958 47.1557 47.5987 47.1502ZM47.5601 49.0278L47.5585 49.0346C47.5561 49.0338 47.5569 49.0317 47.5601 49.0278ZM47.5167 47.8592L47.5175 47.8637C47.5148 47.8653 47.5119 47.8668 47.5093 47.8684L47.5167 47.8592ZM47.3828 49.8964L47.3862 49.8988C47.3783 49.9077 47.3701 49.9164 47.3623 49.9248C47.3688 49.9153 47.3757 49.9059 47.3828 49.8964ZM47.3317 51.1731L47.3054 51.207C47.3099 51.1986 47.3178 51.1873 47.3317 51.1731ZM47.2741 49.8625C47.2791 49.8643 47.2852 49.8659 47.2923 49.867L47.2623 49.9061C47.2647 49.8912 47.2689 49.8767 47.2741 49.8625ZM46.9282 52.2704L46.9319 52.2646L46.9327 52.2693L46.9282 52.2704ZM46.9295 50.7251C46.9303 50.7293 46.9306 50.7338 46.9306 50.738C46.9259 50.7395 46.9211 50.7409 46.9164 50.7419L46.9295 50.7251ZM46.6468 51.2856C46.696 51.2204 46.7441 51.1544 46.7957 51.0913L46.9361 50.9259C46.8927 50.9835 46.8485 51.0403 46.803 51.096C46.757 51.1515 46.7133 51.2085 46.6657 51.2627C46.651 51.2798 46.6483 51.29 46.6549 51.29C46.6836 51.2893 46.617 51.3224 46.6468 51.2856ZM46.4405 50.0907L46.4384 50.0946C46.4321 50.1017 46.4255 50.1091 46.4192 50.1162C46.4263 50.1078 46.4334 50.0991 46.4405 50.0907ZM46.3764 52.7486C46.3808 52.7547 46.3853 52.7591 46.3898 52.7628C46.379 52.7691 46.3682 52.7739 46.3566 52.7757L46.3764 52.7486ZM45.7432 53.8751L45.7377 53.8796L45.7348 53.8778C45.7377 53.877 45.7403 53.8759 45.7432 53.8751ZM45.7132 50.0463L45.7156 50.0431L45.7166 50.046L45.7132 50.0463ZM45.6298 51.5203L45.6275 51.5235L45.6238 51.5209C45.6256 51.5209 45.6277 51.5209 45.6298 51.5203ZM45.5514 53.3964L45.5491 53.4009C45.5454 53.3993 45.5436 53.3985 45.5417 53.398C45.5449 53.3972 45.5483 53.3967 45.5514 53.3964ZM45.0259 51.0613C45.0259 51.0629 45.0261 51.0645 45.0264 51.0661C45.0248 51.0663 45.0232 51.0666 45.0217 51.0668L45.0259 51.0613ZM44.7463 49.9929L44.7284 50.0187C44.7242 50.0087 44.7207 49.9984 44.7178 49.9882C44.7263 49.9908 44.7357 49.9924 44.7463 49.9929ZM44.4411 51.5372L44.4401 51.5364L44.4435 51.5324L44.4411 51.5372ZM44.4361 51.3308C44.4401 51.3337 44.4438 51.3384 44.4472 51.345L44.4385 51.3558C44.434 51.3534 44.4343 51.3432 44.4361 51.3308ZM44.1912 54.8502C44.191 54.8537 44.1904 54.8568 44.1902 54.8602L44.1857 54.8584L44.1912 54.8502ZM44.1736 50.1478L44.1683 50.1548C44.1683 50.1548 44.1676 50.1525 44.1673 50.1512L44.1736 50.1478ZM44.0558 52.7512C44.0634 52.7526 44.0573 52.7562 44.0558 52.7512ZM44.0734 52.7097C44.0831 52.7002 44.0926 52.691 44.1023 52.6818L44.0558 52.7455C44.0568 52.7392 44.0613 52.7278 44.0734 52.7097ZM43.9642 56.3874C43.9655 56.3822 43.9668 56.3772 43.9679 56.3719C43.9697 56.3724 43.9713 56.3727 43.9732 56.3732L43.9642 56.3874ZM44.0095 54.2201C44.0081 54.2209 44.0068 54.2214 44.0055 54.2222L44.0084 54.2174L44.0095 54.2201ZM43.9861 51.6731C43.995 51.6713 44.0016 51.6726 44.0066 51.6757C43.9913 51.687 43.9737 51.7015 43.9526 51.7207L43.9861 51.6731ZM43.9808 54.7361L43.991 54.7212C43.9821 54.7364 43.9732 54.7516 43.964 54.7672L43.9519 54.7811C43.9616 54.7658 43.9713 54.7509 43.9808 54.7361ZM43.8193 55.5427V55.5446L43.8224 55.5398C43.8232 55.5419 43.824 55.5438 43.8245 55.5456C43.8227 55.5453 43.8211 55.5451 43.8193 55.5446L43.8177 55.5456L43.8193 55.5427ZM43.7127 50.8195L43.7122 50.8223H43.7101L43.7127 50.8195ZM43.6462 55.0077L43.6475 55.0072L43.6459 55.0127C43.6462 55.0111 43.6459 55.0093 43.6462 55.0077ZM43.4747 57.1661C43.4744 57.164 43.4739 57.1619 43.4736 57.1595C43.4763 57.158 43.4789 57.1564 43.4815 57.1545L43.4747 57.1661ZM43.4671 52.7652C43.475 52.7641 43.4828 52.7628 43.4905 52.761C43.4773 52.7715 43.4636 52.7812 43.4492 52.7904L43.4671 52.7652ZM43.2779 58.0726C43.2724 58.076 43.2669 58.0792 43.2614 58.0815L43.2795 58.0516C43.2785 58.06 43.2779 58.0668 43.2779 58.0726ZM43.2929 55.1902L43.2945 55.191C43.2861 55.2033 43.2777 55.2154 43.2695 55.2275C43.2771 55.2151 43.285 55.2028 43.2929 55.1902ZM43.2658 57.022L43.2593 57.0347C43.259 57.032 43.2585 57.0294 43.2582 57.0268C43.2608 57.0252 43.2632 57.0236 43.2658 57.022ZM42.8831 56.5386L42.8849 56.5352C42.8852 56.537 42.8855 56.5388 42.886 56.5404L42.8831 56.5386ZM42.9055 53.7834L42.891 53.8047L42.8852 53.8126C42.8773 53.8144 42.8694 53.8178 42.8618 53.822C42.8757 53.8055 42.8899 53.7921 42.9055 53.7834ZM42.6287 54.8552C42.6272 54.8526 42.6261 54.8494 42.6256 54.8458C42.6279 54.8466 42.6306 54.8473 42.6332 54.8481L42.6287 54.8552ZM42.6198 52.2099L42.6211 52.2091L42.6195 52.2115L42.6198 52.2099ZM42.6358 54.6433C42.634 54.6523 42.6319 54.6617 42.6293 54.6712C42.625 54.6723 42.6206 54.6733 42.6156 54.6749L42.6358 54.6433ZM42.4798 53.0144L42.4748 53.022C42.4748 53.0194 42.4735 53.0181 42.4709 53.0183C42.4488 53.0205 42.4767 53.0042 42.4798 53.0144ZM42.4638 53.852L42.4627 53.8549L42.4604 53.857L42.4638 53.852ZM42.3281 55.2572C42.3281 55.2588 42.3281 55.2604 42.3281 55.2619L42.3262 55.2609L42.3281 55.2572ZM42.2778 53.3559C42.2773 53.3596 42.277 53.3635 42.277 53.3672C42.2699 53.3743 42.2626 53.3817 42.2555 53.389L42.2778 53.3559ZM42.2581 54.0978C42.2576 54.1015 42.2568 54.1049 42.2563 54.1086L42.2526 54.1062L42.2581 54.0978ZM42.23 53.8131C42.23 53.8155 42.23 53.8178 42.23 53.8202C42.2278 53.8207 42.2257 53.8215 42.2236 53.822L42.23 53.8131ZM42.2255 56.7205L42.2205 56.7352C42.2205 56.7352 42.2181 56.7347 42.2168 56.7347L42.2255 56.7205ZM42.1613 53.5915L42.1442 53.6167C42.1368 53.6175 42.1308 53.618 42.1255 53.6178C42.1379 53.6088 42.1495 53.6001 42.1613 53.5915ZM41.9132 55.5054L41.9148 55.507L41.9101 55.5101L41.9132 55.5054ZM41.8604 57.9614L41.8472 57.9843C41.8441 57.979 41.8409 57.9745 41.8378 57.9706C41.8451 57.9661 41.8527 57.963 41.8604 57.9614ZM41.6526 54.3505C41.656 54.3515 41.6597 54.3523 41.6631 54.3528C41.6549 54.3654 41.6468 54.3783 41.6384 54.3915C41.6428 54.3775 41.6476 54.3639 41.6526 54.3505ZM41.6434 56.562L41.6184 56.6032C41.6171 56.5898 41.6165 56.5762 41.6168 56.5622C41.6247 56.5628 41.6334 56.5625 41.6434 56.562ZM41.6199 59.7207C41.6194 59.7244 41.6189 59.7281 41.6184 59.7318L41.6171 59.7262L41.6199 59.7207ZM41.5823 57.0838L41.5818 57.087H41.5805L41.5823 57.0838ZM41.3298 60.6422L41.3303 60.6443C41.3303 60.6443 41.328 60.6466 41.3269 60.6477L41.3298 60.6422ZM41.309 61.2261L41.3003 61.2434C41.3009 61.2379 41.3017 61.2321 41.3025 61.2263C41.3046 61.2263 41.3067 61.2263 41.309 61.2261ZM41.2943 59.5546C41.2935 59.5517 41.2927 59.549 41.2919 59.5461C41.2948 59.544 41.2977 59.5419 41.3006 59.5398L41.2943 59.5546ZM41.2953 54.3594C41.2727 54.3973 41.248 54.4343 41.2227 54.4717L41.1817 54.5277C41.2164 54.4682 41.2533 54.4115 41.2953 54.3594ZM41.147 56.8236L41.1449 56.827C41.1444 56.8251 41.1438 56.8233 41.1433 56.8217L41.147 56.8236ZM41.0973 56.1679L41.0994 56.1645L41.097 56.1724L41.0973 56.1679ZM41.0918 57.1283L41.0941 57.1296L41.0899 57.1306L41.0918 57.1283ZM41.0626 62.2811L41.0591 62.2916L41.0568 62.2921L41.0626 62.2811ZM41.0412 58.8876C41.0357 58.8826 41.0268 58.8902 41.0412 58.8876ZM41.0291 62.025L41.0391 62.0056C41.0391 62.0069 41.0391 62.0087 41.0391 62.01L41.0291 62.025ZM40.8532 57.6399C40.8298 57.6806 40.8071 57.7222 40.7864 57.7653C40.8056 57.7219 40.8284 57.6803 40.8532 57.6399ZM40.7403 55.1092C40.7416 55.1121 40.743 55.115 40.7445 55.1176L40.7395 55.1242C40.7395 55.1192 40.7398 55.1142 40.7403 55.1092ZM40.723 58.0616L40.7185 58.0692C40.7148 58.0697 40.7177 58.0658 40.723 58.0616ZM40.6811 56.5465L40.6832 56.5451L40.6814 56.5491L40.6811 56.5465L40.6767 56.5536C40.6753 56.5486 40.6735 56.5441 40.6711 56.5407L40.6811 56.5465ZM40.5946 59.9037L40.5985 59.9058C40.5909 59.9195 40.583 59.9329 40.5749 59.946C40.5809 59.9321 40.5878 59.9176 40.5946 59.9037ZM40.4631 60.5891L40.4599 60.5822L40.4652 60.5728L40.4631 60.5891C40.4618 60.5998 40.4599 60.6104 40.4581 60.6209C40.4568 60.6167 40.4549 60.6122 40.4531 60.608L40.4631 60.5891ZM40.0343 62.4517L40.0333 62.4541L40.0325 62.453L40.0343 62.4517ZM39.9667 60.5063L39.9578 60.5231C39.9554 60.5202 39.953 60.5178 39.9507 60.5155C39.9559 60.512 39.9612 60.5089 39.9667 60.5063ZM39.9333 58.1333L39.9251 58.1502C39.9249 58.148 39.9243 58.1459 39.9241 58.1438L39.9333 58.1333ZM39.8147 61.928L39.8154 61.9301L39.8144 61.9325L39.8147 61.928ZM39.8091 58.7319C39.8089 58.7351 39.8083 58.7377 39.8081 58.7409L39.8049 58.7398L39.8091 58.7319ZM39.7584 56.684L39.7547 56.6905C39.7542 56.6869 39.7531 56.6834 39.7518 56.6805L39.7584 56.684ZM39.6597 64.2013C39.6592 64.2076 39.6584 64.2131 39.6579 64.2192C39.6539 64.2229 39.6503 64.226 39.6463 64.2294L39.6597 64.2013ZM39.5545 56.7521C39.5537 56.7557 39.5529 56.7591 39.5521 56.7628C39.5508 56.7628 39.5495 56.7628 39.5485 56.7628C39.5506 56.7591 39.5524 56.7557 39.5545 56.7521ZM39.4953 62.6399L39.494 62.6452L39.4924 62.6457L39.4953 62.6399ZM39.4517 61.056C39.4517 61.056 39.4517 61.0573 39.4514 61.0589H39.4501L39.4517 61.056ZM39.4553 62.483C39.4545 62.4864 39.4538 62.4896 39.453 62.4927C39.4517 62.4927 39.4503 62.493 39.449 62.4935L39.4553 62.483ZM39.3556 61.0933V61.0975L39.3549 61.0949L39.3556 61.0933ZM39.2851 60.3538L39.2836 60.3569V60.3551L39.2851 60.3538ZM39.237 58.4191L39.2354 58.4223L39.2349 58.4209L39.237 58.4191ZM39.1541 57.3005L39.1531 57.302V57.3002L39.1541 57.3005ZM38.9703 60.6645L38.9692 60.6664L38.9703 60.6674L38.9687 60.6708L38.9692 60.6664L38.9682 60.6635L38.9703 60.6645ZM38.96 59.8858L38.9629 59.8932C38.9616 59.8916 38.96 59.89 38.9587 59.8887L38.96 59.8858ZM38.9137 60.6982L38.91 60.7055C38.91 60.7037 38.9098 60.7019 38.9095 60.7L38.9137 60.6982ZM38.9592 64.3514L38.9079 64.3262C38.9187 64.3262 38.9369 64.3364 38.9592 64.3514ZM38.632 60.067L38.6341 60.0706L38.6325 60.0712L38.6304 60.0656L38.632 60.067ZM38.5057 58.9927C38.5057 58.9927 38.5078 58.9938 38.5097 58.9972C38.5081 58.998 38.5063 58.998 38.5044 58.9977L38.5057 58.9927ZM38.4526 62.9021V62.9042L38.4505 62.9005L38.4526 62.9021ZM38.4271 60.089C38.4255 60.0909 38.4237 60.0919 38.4218 60.0932C38.42 60.089 38.4184 60.0848 38.4166 60.0806L38.4271 60.089ZM38.2743 58.7475L38.2756 58.7482C38.2737 58.7496 38.2722 58.7506 38.2706 58.7517C38.2719 58.7504 38.2732 58.749 38.2743 58.7475ZM38.2298 59.6463L38.2327 59.6468V59.6495C38.2327 59.6495 38.2309 59.6474 38.2298 59.6463ZM38.1298 61.5289L38.1312 61.531L38.1288 61.5289H38.1298ZM38.0109 59.533L38.0236 59.5443C38.0188 59.5419 38.0144 59.5396 38.0096 59.5367L38.0109 59.533ZM37.9494 60.3979L37.9512 60.4021L37.9486 60.4L37.9494 60.3979ZM37.8521 58.5306C37.8521 58.5329 37.8521 58.535 37.8521 58.5377L37.8402 58.5261L37.8521 58.5306ZM37.7158 62.5834L37.7261 62.5932L37.7255 62.5958L37.709 62.5826C37.7113 62.5832 37.7137 62.5834 37.7158 62.5834ZM37.4962 60.796L37.4901 60.812L37.497 60.8267L37.4856 60.8173L37.4901 60.812L37.4833 60.8065C37.4888 60.8044 37.493 60.801 37.4962 60.796ZM37.3094 58.9273L37.3131 58.9331L37.3076 58.9283L37.3094 58.9273ZM37.0598 57.6775L37.0553 57.6825L37.0558 57.6835L37.05 57.6782C37.0535 57.6782 37.0566 57.678 37.0598 57.6775ZM36.762 61.4787L36.761 61.4813L36.7552 61.4771C36.7573 61.4777 36.7596 61.4782 36.762 61.4787ZM36.6991 59.8666C36.7018 59.8727 36.7039 59.8787 36.7057 59.8848L36.6965 59.8769C36.6976 59.8735 36.6986 59.87 36.6991 59.8666ZM36.6881 58.4549L36.6862 58.4572L36.6839 58.4554L36.6881 58.4549ZM36.6221 60.1006L36.6113 60.0946C36.6108 60.0925 36.61 60.0901 36.6094 60.088L36.6221 60.1006ZM36.4279 58.8547L36.4377 58.8629C36.4335 58.8621 36.4292 58.8613 36.4253 58.8602C36.4261 58.8584 36.4271 58.8566 36.4279 58.8547ZM36.359 58.5135L36.3564 58.5114L36.3635 58.5145C36.3619 58.5143 36.3606 58.514 36.359 58.5135C36.3538 58.5111 36.3485 58.5093 36.343 58.5069L36.3406 58.5053C36.3467 58.5082 36.353 58.5106 36.359 58.5135ZM36.2898 61.8896C36.2856 61.8936 36.2817 61.8973 36.2777 61.9004C36.2688 61.886 36.2598 61.8718 36.2512 61.8576L36.2898 61.8896ZM36.1741 57.8394L36.1751 57.8412L36.173 57.8397L36.1741 57.8394ZM36.0876 61.6706C36.0828 61.668 36.0783 61.6656 36.0736 61.663L36.0697 61.6588C36.0657 61.6538 36.0618 61.6491 36.0578 61.6441L36.0876 61.6706ZM35.8111 57.1614L35.8029 57.1743C35.8043 57.1695 35.8066 57.1653 35.8111 57.1614ZM35.6509 61.3165C35.6462 61.3147 35.642 61.3086 35.6406 61.3036L35.6625 61.3218C35.6588 61.3199 35.6546 61.3184 35.6509 61.3165ZM35.6809 61.3136C35.6959 61.3276 35.7119 61.3412 35.7285 61.3549C35.699 61.3375 35.6698 61.321 35.6406 61.3036C35.6383 61.2942 35.6462 61.2873 35.6809 61.3136ZM35.1819 58.1299C35.1811 58.1325 35.1803 58.1352 35.179 58.1378L35.1708 58.1299C35.1748 58.1299 35.1787 58.1302 35.1819 58.1299ZM35.1548 60.2702L35.1616 60.2781L35.1543 60.2723C35.1543 60.2723 35.1545 60.271 35.1548 60.2702ZM35.0932 60.4655C35.0935 60.4673 35.0943 60.4692 35.0946 60.471L35.0867 60.4645C35.0888 60.4647 35.0911 60.4652 35.0932 60.4655ZM34.8767 59.7226L34.8778 59.7244L34.8757 59.7226H34.8767ZM34.741 55.7486L34.7484 55.7517L34.7494 55.7557L34.741 55.7486L34.7418 55.7507L34.7376 55.747L34.741 55.7486ZM34.5664 59.4147L34.5714 59.4207L34.5635 59.4147C34.5635 59.4147 34.5656 59.4147 34.5664 59.4147ZM33.9037 58.9565C33.9037 58.9565 33.9056 58.9549 33.9061 58.9544L33.9206 58.9707L33.9037 58.9565ZM34.4246 58.4825C34.4238 58.4867 34.4235 58.4914 34.4246 58.4967L34.4172 58.4903L34.4246 58.4825ZM34.2883 55.9313C34.2915 55.9357 34.2949 55.9402 34.298 55.9447L34.2815 55.9318C34.2836 55.9318 34.2859 55.9313 34.2883 55.9313ZM34.2523 58.6809L34.2544 58.6844L34.2502 58.6809H34.2523ZM34.2275 55.4631L34.2281 55.4652L34.2239 55.4628L34.2275 55.4631ZM34.2189 57.7098L34.2236 57.7164L34.2178 57.7114L34.2189 57.7098ZM33.9929 55.4065L33.9963 55.406C33.9963 55.406 33.9963 55.4078 33.9961 55.4089L33.9987 55.4165L33.9908 55.4099L33.9961 55.4089L33.9929 55.4065ZM33.9713 59.8606C33.9761 59.8779 33.9629 59.8614 33.9587 59.8501L33.9713 59.8606ZM33.9208 57.8972L33.9224 57.9004L33.9208 57.8986C33.9193 57.8957 33.9177 57.893 33.9161 57.8904L33.9208 57.8972ZM33.9108 57.8796L33.9077 57.877L33.9024 57.8688L33.8998 57.8631C33.9037 57.8683 33.9074 57.8738 33.9108 57.8796ZM33.8793 59.6897L33.8714 59.686L33.8693 59.6831L33.8793 59.6897ZM33.7856 56.226H33.7846L33.7819 56.2231L33.7856 56.226ZM33.7054 59.8632C33.7091 59.8693 33.7125 59.8753 33.7159 59.8816L33.7138 59.8808L33.6891 59.8601C33.6946 59.8614 33.6999 59.8627 33.7054 59.8632ZM33.5518 58.5208L33.572 58.5345C33.5718 58.5361 33.5715 58.5377 33.571 58.5392C33.5647 58.5332 33.5584 58.5269 33.5518 58.5208ZM33.5034 56.8838C33.5042 56.8814 33.5052 56.879 33.506 56.8767C33.5084 56.8811 33.511 56.8856 33.5131 56.8903L33.5034 56.8838ZM33.5039 55.4323L33.5055 55.4276L33.5123 55.4341L33.5039 55.4323L33.5015 55.4318L33.501 55.4299L33.5039 55.4323ZM33.4255 57.7566L33.4366 57.7658C33.4326 57.7653 33.4289 57.7647 33.425 57.7642C33.425 57.7618 33.4253 57.7592 33.4255 57.7566ZM33.3834 58.8371C33.3871 58.8442 33.39 58.8513 33.3921 58.8584L33.3769 58.8455L33.3758 58.8445C33.3787 58.8421 33.3808 58.8397 33.3834 58.8371ZM33.3776 59.6324C33.389 59.6374 33.4 59.6437 33.4111 59.6505L33.4279 59.6694C33.4089 59.6571 33.3892 59.6468 33.3687 59.639C33.3629 59.6368 33.3395 59.6042 33.3776 59.6324ZM33.2098 58.0484L33.2069 58.0516C33.2059 58.0489 33.2048 58.046 33.2038 58.0434L33.2098 58.0484ZM33.1772 56.0546L33.1809 56.0575L33.1772 56.0609C33.1775 56.059 33.1772 56.0567 33.1772 56.0546ZM33.1588 56.0793L33.1572 56.0811L33.1559 56.0801L33.1588 56.0793ZM33.1456 58.559L33.1417 58.5574L33.1399 58.554L33.1456 58.559ZM33.0644 57.082L33.0707 57.0872C33.0675 57.0865 33.0646 57.0857 33.0617 57.0849L33.0644 57.082ZM32.8739 57.7613C32.875 57.7642 32.876 57.7668 32.8771 57.77L32.8723 57.7661C32.8729 57.7645 32.8731 57.7629 32.8739 57.7613ZM32.8926 58.8263C32.8768 58.8187 32.8618 58.81 32.8471 58.8006L32.8184 58.7735C32.8429 58.7911 32.8676 58.8087 32.8926 58.8263ZM32.795 57.9819L32.7937 57.9837L32.7918 57.9822C32.7918 57.9822 32.7939 57.9819 32.795 57.9819ZM32.7484 58.3691C32.7455 58.3681 32.7429 58.3673 32.74 58.3663C32.74 58.3647 32.74 58.3628 32.7395 58.361L32.7484 58.3691ZM32.7303 57.9259C32.7327 57.9296 32.735 57.933 32.7374 57.9367L32.7261 57.928C32.7274 57.9275 32.729 57.9267 32.7303 57.9259ZM32.6098 55.7244C32.6072 55.7246 32.6046 55.7244 32.6019 55.7244C32.6019 55.722 32.6014 55.7196 32.6009 55.717L32.6098 55.7244ZM32.4333 58.8713L32.4654 58.906L32.4265 58.8644L32.4333 58.8713ZM32.2376 57.7584L32.235 57.7576L32.2344 57.7561L32.2376 57.7584ZM32.1695 57.6801C32.1555 57.6688 32.1416 57.6575 32.1292 57.6459C32.1282 57.6449 32.1274 57.6443 32.1263 57.6433C32.1411 57.6554 32.1555 57.6677 32.1695 57.6801ZM32.1258 55.9379C32.1284 55.9557 32.1203 55.9428 32.1192 55.9326L32.1258 55.9379ZM32.0766 57.6038C32.0882 57.6128 32.0992 57.6215 32.1106 57.6301C32.1061 57.6272 32.1034 57.6267 32.1027 57.6288C32.1013 57.632 32.0998 57.6336 32.0982 57.6341L32.0842 57.6246C32.0761 57.6136 32.07 57.5981 32.0766 57.6038ZM31.9819 56.7994C31.9819 56.7994 31.9819 56.8004 31.9819 56.8012C31.9835 56.8259 31.9635 56.792 31.9651 56.7854L31.9819 56.7994ZM31.964 56.8546C31.9706 56.8625 31.9772 56.8704 31.9843 56.878C31.9632 56.8614 31.943 56.8441 31.9246 56.8249C31.938 56.8349 31.9509 56.8446 31.964 56.8546ZM31.8041 57.4232C31.8054 57.4303 31.8057 57.438 31.8049 57.4458C31.7949 57.4385 31.7852 57.4311 31.7749 57.4243C31.777 57.4182 31.7891 57.4198 31.8041 57.4232Z","fill":"white","key":6}),React.createElement("defs",{"key":7},[React.createElement("linearGradient",{"id":"paint0_linear_1761_20189","x1":"97.561","y1":"99.4014","x2":"73.0409","y2":"75.1723","gradientUnits":"userSpaceOnUse","key":0},[React.createElement("stop",{"stopColor":"#006736","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#93C13E","key":1})]),React.createElement("linearGradient",{"id":"paint1_linear_1761_20189","x1":"95.8473","y1":"14.8707","x2":"18","y2":"14.8707","gradientUnits":"userSpaceOnUse","key":1},[React.createElement("stop",{"stopColor":"#006736","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#93C13E","key":1})])])]);
}

SuccessComponent.defaultProps = {"width":"113","height":"116","viewBox":"0 0 113 116","fill":"none"};

module.exports = SuccessComponent;

SuccessComponent.default = SuccessComponent;


/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function HouseComponent (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("linearGradient",{"x1":"158.87207%","y1":"50%","x2":"-2.22044605e-14%","y2":"50%","id":"linearGradient-1"},[React.createElement("stop",{"stopColor":"#006736","offset":"0%","key":0}),React.createElement("stop",{"stopColor":"#93C13E","offset":"100%","key":1})])),React.createElement("g",{"id":"simul_resultados_modals","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","transform":"translate(-96.000000, -214.000000)","key":1},React.createElement("g",{"id":"flow-1","transform":"translate(64.000000, 64.000000)","fill":"url(#linearGradient-1)","fillRule":"nonzero"},React.createElement("g",{"id":"modal","transform":"translate(0.000000, 72.000000)"},React.createElement("g",{"id":"content","transform":"translate(32.000000, 58.000000)"},React.createElement("path",{"d":"M38.3952802,38.4778761 L20.2713864,20.3539823 C19.79941,19.8820059 18.9498525,19.8820059 18.4778761,20.3539823 L0.353982301,38.4778761 C-0.1179941,38.9498525 -0.1179941,39.79941 0.353982301,40.2713864 C0.825958702,40.7433628 1.67551622,40.7433628 2.14749263,40.2713864 L4.41297935,38.0058997 L4.41297935,56.2241888 C4.41297935,58.300885 6.1120944,60 8.18879056,60 L30.6548673,60 C32.7315634,60 34.4306785,58.300885 34.4306785,56.2241888 L34.4306785,38.0058997 L36.6961652,40.2713864 C37.1681416,40.7433628 38.0176991,40.7433628 38.4896755,40.2713864 C38.9616519,39.7050147 38.9616519,38.9498525 38.3952802,38.4778761 Z M15.740413,57.4513274 L15.740413,43.7640118 L23.1976401,43.7640118 L23.1976401,57.4513274 L15.740413,57.4513274 Z M31.9764012,56.1297935 C31.9764012,56.7905605 31.4100295,57.3569322 30.7492625,57.3569322 L25.7463127,57.3569322 L25.7463127,42.4424779 C25.7463127,41.7817109 25.179941,41.2153392 24.519174,41.2153392 L14.5132743,41.2153392 C13.8525074,41.2153392 13.2861357,41.7817109 13.2861357,42.4424779 L13.2861357,57.4513274 L8.28318584,57.4513274 C7.62241888,57.4513274 7.0560472,56.8849558 7.0560472,56.2241888 L7.0560472,35.5516224 L19.5162242,23.0914454 L31.9764012,35.5516224 L31.9764012,56.1297935 Z","id":"ic-residencial-copy-5"})))))]);
}

HouseComponent.defaultProps = {"width":"39px","height":"40px","viewBox":"0 0 39 40","version":"1.1"};

module.exports = HouseComponent;

HouseComponent.default = HouseComponent;


/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo-poupa-energia-footer.ad1c2be2.png";

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo-adene.e8db3c06.png";

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo-poupa-energia.ed1acefe.png";

/***/ }),
/* 1678 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 1679 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 1680 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(714);
module.exports = __webpack_require__(715);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.30553f0c.js